/**
 * music21j 0.9.43 built on 2020-05-05.
 * Copyright (c) 2013-2020 Michael Scott Cuthbert and cuthbertLab
 * BSD License, see LICENSE
 *
 * http://github.com/cuthbertLab/music21j
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("music21", [], factory);
	else if(typeof exports === 'object')
		exports["music21"] = factory();
	else
		root["music21"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/music21_modules.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./css/midiPlayer.css":
/*!****************************!*\
  !*** ./css/midiPlayer.css ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../node_modules/css-loader/dist/cjs.js!./midiPlayer.css */ "./node_modules/css-loader/dist/cjs.js!./css/midiPlayer.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./node_modules/core-js/internals/a-function.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/a-function.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/a-possible-prototype.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/a-possible-prototype.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/add-to-unscopables.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/add-to-unscopables.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  createNonEnumerableProperty(ArrayPrototype, UNSCOPABLES, create(null));
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "./node_modules/core-js/internals/advance-string-index.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/advance-string-index.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "./node_modules/core-js/internals/an-instance.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/an-instance.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/an-object.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/an-object.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-buffer-view-core.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/array-buffer-view-core.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");

var DataView = global.DataView;
var DataViewPrototype = DataView && DataView.prototype;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var isPrototypeOf = ObjectPrototype.isPrototypeOf;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var NATIVE_ARRAY_BUFFER = !!(global.ArrayBuffer && DataView);
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQIRED = false;
var NAME;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var isView = function isView(it) {
  var klass = classof(it);
  return klass === 'DataView' || has(TypedArrayConstructorsList, klass);
};

var isTypedArray = function (it) {
  return isObject(it) && has(TypedArrayConstructorsList, classof(it));
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (setPrototypeOf) {
    if (isPrototypeOf.call(TypedArray, C)) return C;
  } else for (var ARRAY in TypedArrayConstructorsList) if (has(TypedArrayConstructorsList, NAME)) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (C === TypedArrayConstructor || isPrototypeOf.call(TypedArrayConstructor, C))) {
      return C;
    }
  } throw TypeError('Target is not a typed array constructor');
};

var exportProto = function (KEY, property, forced) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && has(TypedArrayConstructor.prototype, KEY)) {
      delete TypedArrayConstructor.prototype[KEY];
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    redefine(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property);
  }
};

var exportStatic = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && has(TypedArrayConstructor, KEY)) {
        delete TypedArrayConstructor[KEY];
      }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return redefine(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8Array[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      redefine(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  if (!global[NAME]) NATIVE_ARRAY_BUFFER_VIEWS = false;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || typeof TypedArray != 'function' || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !has(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQIRED = true;
  defineProperty(TypedArrayPrototype, TO_STRING_TAG, { get: function () {
    return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
  } });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

// WebKit bug - the same parent prototype for typed arrays and data view
if (NATIVE_ARRAY_BUFFER && setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
  setPrototypeOf(DataViewPrototype, ObjectPrototype);
}

module.exports = {
  NATIVE_ARRAY_BUFFER: NATIVE_ARRAY_BUFFER,
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportProto: exportProto,
  exportStatic: exportStatic,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-buffer.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/array-buffer.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var NATIVE_ARRAY_BUFFER = __webpack_require__(/*! ../internals/array-buffer-view-core */ "./node_modules/core-js/internals/array-buffer-view-core.js").NATIVE_ARRAY_BUFFER;
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js/internals/redefine-all.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toIndex = __webpack_require__(/*! ../internals/to-index */ "./node_modules/core-js/internals/to-index.js");
var getOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js").f;
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var arrayFill = __webpack_require__(/*! ../internals/array-fill */ "./node_modules/core-js/internals/array-fill.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = 1 / 0;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

// IEEE754 conversions based on https://github.com/feross/ieee754
var packIEEE754 = function (number, mantissaLength, bytes) {
  var buffer = new Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    if (number * (c = pow(2, -exponent)) < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  for (; mantissaLength >= 8; buffer[index++] = mantissa & 255, mantissa /= 256, mantissaLength -= 8);
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  for (; exponentLength > 0; buffer[index++] = exponent & 255, exponent /= 256, exponentLength -= 8);
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpackIEEE754 = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  for (; nBits > 0; exponent = exponent * 256 + buffer[index], index--, nBits -= 8);
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  for (; nBits > 0; mantissa = mantissa * 256 + buffer[index], index--, nBits -= 8);
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key) {
  defineProperty(Constructor[PROTOTYPE], key, { get: function () { return getInternalState(this)[key]; } });
};

var get = function (view, count, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = bytes.slice(start, start + count);
  return isLittleEndian ? pack : pack.reverse();
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    setInternalState(this, {
      bytes: arrayFill.call(new Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) this.byteLength = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = getInternalState(buffer).byteLength;
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    setInternalState(this, {
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength');
    addGetter($DataView, 'buffer');
    addGetter($DataView, 'byteLength');
    addGetter($DataView, 'byteOffset');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new NativeArrayBuffer(); // eslint-disable-line no-new
    new NativeArrayBuffer(1.5); // eslint-disable-line no-new
    new NativeArrayBuffer(NaN); // eslint-disable-line no-new
    return NativeArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new NativeArrayBuffer(toIndex(length));
    };
    var ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE] = NativeArrayBuffer[PROTOTYPE];
    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }
    ArrayBufferPrototype.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var nativeSetInt8 = $DataView[PROTOTYPE].setInt8;
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      nativeSetInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      nativeSetInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-fill.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/array-fill.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");

// `Array.prototype.fill` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-for-each.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-for-each.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").forEach;
var sloppyArrayMethod = __webpack_require__(/*! ../internals/sloppy-array-method */ "./node_modules/core-js/internals/sloppy-array-method.js");

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = sloppyArrayMethod('forEach') ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "./node_modules/core-js/internals/array-from.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/array-from.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/core-js/internals/bind-context.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var callWithSafeIterationClosing = __webpack_require__(/*! ../internals/call-with-safe-iteration-closing */ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js");
var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var index = 0;
  var iteratorMethod = getIteratorMethod(O);
  var length, result, step, iterator, next;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      createProperty(result, index, mapping
        ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true)
        : step.value
      );
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-includes.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-includes.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-iteration.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/array-iteration.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/core-js/internals/bind-context.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-last-index-of.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/array-last-index-of.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var sloppyArrayMethod = __webpack_require__(/*! ../internals/sloppy-array-method */ "./node_modules/core-js/internals/sloppy-array-method.js");

var min = Math.min;
var nativeLastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!nativeLastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var SLOPPY_METHOD = sloppyArrayMethod('lastIndexOf');

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
module.exports = (NEGATIVE_ZERO || SLOPPY_METHOD) ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return nativeLastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : nativeLastIndexOf;


/***/ }),

/***/ "./node_modules/core-js/internals/array-method-has-species-support.js":
/*!****************************************************************************!*\
  !*** ./node_modules/core-js/internals/array-method-has-species-support.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__(/*! ../internals/v8-version */ "./node_modules/core-js/internals/v8-version.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-species-create.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/array-species-create.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "./node_modules/core-js/internals/bind-context.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/bind-context.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js":
/*!****************************************************************************!*\
  !*** ./node_modules/core-js/internals/call-with-safe-iteration-closing.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/check-correctness-of-iteration.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/check-correctness-of-iteration.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "./node_modules/core-js/internals/classof-raw.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/classof-raw.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js/internals/classof.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/internals/classof.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/collection-strong.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/collection-strong.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js/internals/redefine-all.js");
var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/core-js/internals/bind-context.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js/internals/define-iterator.js");
var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/core-js/internals/set-species.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var fastKey = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js").fastKey;
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/collection-weak.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/collection-weak.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js/internals/redefine-all.js");
var getWeakData = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js").getWeakData;
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
var ArrayIterationModule = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js");
var $has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.3.3.3 WeakMap.prototype.get(key)
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // 23.3.3.5 WeakMap.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // 23.4.3.1 WeakSet.prototype.add(value)
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/collection.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/collection.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var InternalMetadataModule = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var inheritIfRequired = __webpack_require__(/*! ../internals/inherit-if-required */ "./node_modules/core-js/internals/inherit-if-required.js");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common, IS_MAP, IS_WEAK) {
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var ADDER = IS_MAP ? 'set' : 'add';
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  // eslint-disable-next-line max-len
  if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
    new NativeConstructor().entries().next();
  })))) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "./node_modules/core-js/internals/copy-constructor-properties.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/copy-constructor-properties.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var ownKeys = __webpack_require__(/*! ../internals/own-keys */ "./node_modules/core-js/internals/own-keys.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/correct-is-regexp-logic.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/correct-is-regexp-logic.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "./node_modules/core-js/internals/correct-prototype-getter.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/correct-prototype-getter.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "./node_modules/core-js/internals/create-iterator-constructor.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-iterator-constructor.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js").IteratorPrototype;
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-non-enumerable-property.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/create-non-enumerable-property.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-property-descriptor.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-property-descriptor.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-property.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/create-property.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "./node_modules/core-js/internals/define-iterator.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/define-iterator.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var createIteratorConstructor = __webpack_require__(/*! ../internals/create-iterator-constructor */ "./node_modules/core-js/internals/create-iterator-constructor.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
var IteratorsCore = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "./node_modules/core-js/internals/descriptors.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/descriptors.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/internals/document-create-element.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/document-create-element.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/internals/dom-iterables.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/dom-iterables.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "./node_modules/core-js/internals/enum-bug-keys.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/enum-bug-keys.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "./node_modules/core-js/internals/export.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/internals/export.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");
var copyConstructorProperties = __webpack_require__(/*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/fails.js":
/*!*************************************************!*\
  !*** ./node_modules/core-js/internals/fails.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js":
/*!******************************************************************************!*\
  !*** ./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var regexpExec = __webpack_require__(/*! ../internals/regexp-exec */ "./node_modules/core-js/internals/regexp-exec.js");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
    if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/flatten-into-array.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/flatten-into-array.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/core-js/internals/bind-context.js");

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ "./node_modules/core-js/internals/forced-string-trim-method.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/forced-string-trim-method.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js/internals/whitespaces.js");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/freezing.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/freezing.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "./node_modules/core-js/internals/function-to-string.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/function-to-string.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");

module.exports = shared('native-function-to-string', Function.toString);


/***/ }),

/***/ "./node_modules/core-js/internals/get-built-in.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/get-built-in.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js/internals/path.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "./node_modules/core-js/internals/get-iterator-method.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator-method.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "./node_modules/core-js/internals/get-iterator.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");

module.exports = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};


/***/ }),

/***/ "./node_modules/core-js/internals/global.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/internals/global.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/core-js/internals/has.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/internals/has.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/internals/hidden-keys.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/hidden-keys.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/internals/html.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/internals/html.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "./node_modules/core-js/internals/ie8-dom-define.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/ie8-dom-define.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var createElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/internals/indexed-object.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/indexed-object.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "./node_modules/core-js/internals/inherit-if-required.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/inherit-if-required.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "./node_modules/core-js/internals/internal-metadata.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/internal-metadata.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
var FREEZING = __webpack_require__(/*! ../internals/freezing */ "./node_modules/core-js/internals/freezing.js");

var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "./node_modules/core-js/internals/internal-state.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/internal-state.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(/*! ../internals/native-weak-map */ "./node_modules/core-js/internals/native-weak-map.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var objectHas = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-array-iterator-method.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/is-array-iterator-method.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-array.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/is-array.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-forced.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-forced.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "./node_modules/core-js/internals/is-object.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-object.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-pure.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/internals/is-pure.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "./node_modules/core-js/internals/is-regexp.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-regexp.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "./node_modules/core-js/internals/iterate.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/internals/iterate.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/core-js/internals/bind-context.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");
var callWithSafeIterationClosing = __webpack_require__(/*! ../internals/call-with-safe-iteration-closing */ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};


/***/ }),

/***/ "./node_modules/core-js/internals/iterators-core.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/iterators-core.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "./node_modules/core-js/internals/iterators.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/iterators.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/internals/native-symbol.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/native-symbol.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "./node_modules/core-js/internals/native-url.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/native-url.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ "./node_modules/core-js/internals/native-weak-map.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/native-weak-map.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var nativeFunctionToString = __webpack_require__(/*! ../internals/function-to-string */ "./node_modules/core-js/internals/function-to-string.js");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));


/***/ }),

/***/ "./node_modules/core-js/internals/not-a-regexp.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/not-a-regexp.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__(/*! ../internals/is-regexp */ "./node_modules/core-js/internals/is-regexp.js");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-assign.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-assign.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");

var nativeAssign = Object.assign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !nativeAssign || fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "./node_modules/core-js/internals/object-create.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-create.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var defineProperties = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/core-js/internals/object-define-properties.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
var html = __webpack_require__(/*! ../internals/html */ "./node_modules/core-js/internals/html.js");
var documentCreateElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
var IE_PROTO = sharedKey('IE_PROTO');

var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

hiddenKeys[IE_PROTO] = true;


/***/ }),

/***/ "./node_modules/core-js/internals/object-define-properties.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-properties.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-define-property.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-property.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-descriptor.js":
/*!******************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-descriptor.js ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-names.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-symbols.js":
/*!***************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-symbols.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-prototype-of.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-prototype-of.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(/*! ../internals/correct-prototype-getter */ "./node_modules/core-js/internals/correct-prototype-getter.js");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-keys-internal.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys-internal.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var indexOf = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js").indexOf;
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-keys.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-property-is-enumerable.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-property-is-enumerable.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/internals/object-set-prototype-of.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-set-prototype-of.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aPossiblePrototype = __webpack_require__(/*! ../internals/a-possible-prototype */ "./node_modules/core-js/internals/a-possible-prototype.js");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "./node_modules/core-js/internals/own-keys.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/own-keys.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "./node_modules/core-js/internals/path.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/internals/path.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");


/***/ }),

/***/ "./node_modules/core-js/internals/punycode-to-ascii.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/punycode-to-ascii.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line  max-statements
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

module.exports = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};


/***/ }),

/***/ "./node_modules/core-js/internals/redefine-all.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/redefine-all.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "./node_modules/core-js/internals/redefine.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/redefine.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");
var nativeFunctionToString = __webpack_require__(/*! ../internals/function-to-string */ "./node_modules/core-js/internals/function-to-string.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(nativeFunctionToString).split('toString');

shared('inspectSource', function (it) {
  return nativeFunctionToString.call(it);
});

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || nativeFunctionToString.call(this);
});


/***/ }),

/***/ "./node_modules/core-js/internals/regexp-exec-abstract.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-exec-abstract.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(/*! ./classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var regexpExec = __webpack_require__(/*! ./regexp-exec */ "./node_modules/core-js/internals/regexp-exec.js");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "./node_modules/core-js/internals/regexp-exec.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-exec.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__(/*! ./regexp-flags */ "./node_modules/core-js/internals/regexp-flags.js");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "./node_modules/core-js/internals/regexp-flags.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-flags.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/require-object-coercible.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/require-object-coercible.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/same-value.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/same-value.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// `SameValue` abstract operation
// https://tc39.github.io/ecma262/#sec-samevalue
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "./node_modules/core-js/internals/set-global.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/set-global.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "./node_modules/core-js/internals/set-species.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/set-species.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/set-to-string-tag.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/set-to-string-tag.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/shared-key.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/shared-key.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/internals/shared-store.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/shared-store.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "./node_modules/core-js/internals/shared.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/internals/shared.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var store = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.4.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "./node_modules/core-js/internals/sloppy-array-method.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/sloppy-array-method.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !method || !fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/species-constructor.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/species-constructor.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-multibyte.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/internals/string-multibyte.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-trim.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/string-trim.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js/internals/whitespaces.js");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-absolute-index.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-absolute-index.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-index.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/to-index.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");

// `ToIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length or index');
  return length;
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-indexed-object.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-indexed-object.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-integer.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/to-integer.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-length.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-length.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-object.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-object.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-offset.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-offset.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toPositiveInteger = __webpack_require__(/*! ../internals/to-positive-integer */ "./node_modules/core-js/internals/to-positive-integer.js");

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-positive-integer.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/to-positive-integer.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");

module.exports = function (it) {
  var result = toInteger(it);
  if (result < 0) throw RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-primitive.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/to-primitive.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/internals/typed-array-constructor.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/typed-array-constructor.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(/*! ../internals/typed-arrays-constructors-requires-wrappers */ "./node_modules/core-js/internals/typed-arrays-constructors-requires-wrappers.js");
var ArrayBufferViewCore = __webpack_require__(/*! ../internals/array-buffer-view-core */ "./node_modules/core-js/internals/array-buffer-view-core.js");
var ArrayBufferModule = __webpack_require__(/*! ../internals/array-buffer */ "./node_modules/core-js/internals/array-buffer.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toIndex = __webpack_require__(/*! ../internals/to-index */ "./node_modules/core-js/internals/to-index.js");
var toOffset = __webpack_require__(/*! ../internals/to-offset */ "./node_modules/core-js/internals/to-offset.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");
var getOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js").f;
var typedArrayFrom = __webpack_require__(/*! ../internals/typed-array-from */ "./node_modules/core-js/internals/typed-array-from.js");
var forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").forEach;
var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/core-js/internals/set-species.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var inheritIfRequired = __webpack_require__(/*! ../internals/inherit-if-required */ "./node_modules/core-js/internals/inherit-if-required.js");

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round = Math.round;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor(C))(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  nativeDefineProperty(it, key, { get: function () {
    return getInternalState(this)[key];
  } });
};

var isArrayBuffer = function (it) {
  var klass;
  return it instanceof ArrayBuffer || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && typeof key != 'symbol'
    && key in target
    && String(+key) == String(key);
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  return isTypedArrayIndex(target, key = toPrimitive(key, true))
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  if (isTypedArrayIndex(target, key = toPrimitive(key, true))
    && isObject(descriptor)
    && has(descriptor, 'value')
    && !has(descriptor, 'get')
    && !has(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!has(descriptor, 'writable') || descriptor.writable)
    && (!has(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, BYTES, wrapper, CLAMPED) {
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructor, CONSTRUCTOR_NAME);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructor, CONSTRUCTOR_NAME);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({
      global: true, forced: TypedArrayConstructor != NativeTypedArrayConstructor, sham: !NATIVE_ARRAY_BUFFER_VIEWS
    }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ "./node_modules/core-js/internals/typed-array-from.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/internals/typed-array-from.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");
var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js");
var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/core-js/internals/bind-context.js");
var aTypedArrayConstructor = __webpack_require__(/*! ../internals/array-buffer-view-core */ "./node_modules/core-js/internals/array-buffer-view-core.js").aTypedArrayConstructor;

module.exports = function from(source /* , mapfn, thisArg */) {
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, step, iterator, next;
  if (iteratorMethod != undefined && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    O = [];
    while (!(step = next.call(iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2], 2);
  }
  length = toLength(O.length);
  result = new (aTypedArrayConstructor(this))(length);
  for (i = 0; length > i; i++) {
    result[i] = mapping ? mapfn(O[i], i) : O[i];
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/typed-arrays-constructors-requires-wrappers.js":
/*!***************************************************************************************!*\
  !*** ./node_modules/core-js/internals/typed-arrays-constructors-requires-wrappers.js ***!
  \***************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-new */
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js");
var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(/*! ../internals/array-buffer-view-core */ "./node_modules/core-js/internals/array-buffer-view-core.js").NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});


/***/ }),

/***/ "./node_modules/core-js/internals/uid.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/internals/uid.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "./node_modules/core-js/internals/user-agent.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/user-agent.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "./node_modules/core-js/internals/v8-version.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/v8-version.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var userAgent = __webpack_require__(/*! ../internals/user-agent */ "./node_modules/core-js/internals/user-agent.js");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "./node_modules/core-js/internals/well-known-symbol.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js/internals/native-symbol.js");

var Symbol = global.Symbol;
var store = shared('wks');

module.exports = function (name) {
  return store[name] || (store[name] = NATIVE_SYMBOL && Symbol[name]
    || (NATIVE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};


/***/ }),

/***/ "./node_modules/core-js/internals/whitespaces.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/whitespaces.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "./node_modules/core-js/modules/es.array-buffer.slice.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.array-buffer.slice.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var ArrayBufferModule = __webpack_require__(/*! ../internals/array-buffer */ "./node_modules/core-js/internals/array-buffer.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");

var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var nativeArrayBufferSlice = ArrayBuffer.prototype.slice;

var INCORRECT_SLICE = fails(function () {
  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-arraybuffer.prototype.slice
$({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice !== undefined && end === undefined) {
      return nativeArrayBufferSlice.call(anObject(this), start); // FF fix
    }
    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer))(toLength(fin - first));
    var viewSource = new DataView(this);
    var viewTarget = new DataView(result);
    var index = 0;
    while (first < fin) {
      viewTarget.setUint8(index++, viewSource.getUint8(first++));
    } return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.concat.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.concat.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js");
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__(/*! ../internals/v8-version */ "./node_modules/core-js/internals/v8-version.js");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.flat.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.flat.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var flattenIntoArray = __webpack_require__(/*! ../internals/flatten-into-array */ "./node_modules/core-js/internals/flatten-into-array.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js");

// `Array.prototype.flat` method
// https://github.com/tc39/proposal-flatMap
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.from.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.from.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var from = __webpack_require__(/*! ../internals/array-from */ "./node_modules/core-js/internals/array-from.js");
var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.includes.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.includes.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $includes = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js").includes;
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js");

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.index-of.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.index-of.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $indexOf = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js").indexOf;
var sloppyArrayMethod = __webpack_require__(/*! ../internals/sloppy-array-method */ "./node_modules/core-js/internals/sloppy-array-method.js");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var SLOPPY_METHOD = sloppyArrayMethod('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || SLOPPY_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.iterator.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.iterator.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js/internals/define-iterator.js");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.last-index-of.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.last-index-of.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var lastIndexOf = __webpack_require__(/*! ../internals/array-last-index-of */ "./node_modules/core-js/internals/array-last-index-of.js");

// `Array.prototype.lastIndexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.reverse.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.reverse.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.slice.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.slice.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('slice') }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.sort.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.sort.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var sloppyArrayMethod = __webpack_require__(/*! ../internals/sloppy-array-method */ "./node_modules/core-js/internals/sloppy-array-method.js");

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var SLOPPY_METHOD = sloppyArrayMethod('sort');

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || SLOPPY_METHOD;

// `Array.prototype.sort` method
// https://tc39.github.io/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? nativeSort.call(toObject(this))
      : nativeSort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.unscopables.flat.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.unscopables.flat.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js");

addToUnscopables('flat');


/***/ }),

/***/ "./node_modules/core-js/modules/es.map.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/modules/es.map.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/core-js/internals/collection.js");
var collectionStrong = __webpack_require__(/*! ../internals/collection-strong */ "./node_modules/core-js/internals/collection-strong.js");

// `Map` constructor
// https://tc39.github.io/ecma262/#sec-map-objects
module.exports = collection('Map', function (get) {
  return function Map() { return get(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong, true);


/***/ }),

/***/ "./node_modules/core-js/modules/es.regexp.constructor.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.regexp.constructor.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
var inheritIfRequired = __webpack_require__(/*! ../internals/inherit-if-required */ "./node_modules/core-js/internals/inherit-if-required.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var getOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js").f;
var isRegExp = __webpack_require__(/*! ../internals/is-regexp */ "./node_modules/core-js/internals/is-regexp.js");
var getFlags = __webpack_require__(/*! ../internals/regexp-flags */ "./node_modules/core-js/internals/regexp-flags.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/core-js/internals/set-species.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var FORCED = DESCRIPTORS && isForced('RegExp', (!CORRECT_NEW || fails(function () {
  re2[MATCH] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    return !thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined ? pattern
      : inheritIfRequired(CORRECT_NEW
        ? new NativeRegExp(patternIsRegExp && !flagsAreUndefined ? pattern.source : pattern, flags)
        : NativeRegExp((patternIsRegExp = pattern instanceof RegExpWrapper)
          ? pattern.source
          : pattern, patternIsRegExp && flagsAreUndefined ? getFlags.call(pattern) : flags)
      , thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys.length > index) proxy(keys[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "./node_modules/core-js/modules/es.regexp.to-string.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.regexp.to-string.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var flags = __webpack_require__(/*! ../internals/regexp-flags */ "./node_modules/core-js/internals/regexp-flags.js");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.set.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/modules/es.set.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/core-js/internals/collection.js");
var collectionStrong = __webpack_require__(/*! ../internals/collection-strong */ "./node_modules/core-js/internals/collection-strong.js");

// `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects
module.exports = collection('Set', function (get) {
  return function Set() { return get(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.ends-with.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.ends-with.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js/internals/correct-is-regexp-logic.js");

var nativeEndsWith = ''.endsWith;
var min = Math.min;

// `String.prototype.endsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('endsWith') }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = String(searchString);
    return nativeEndsWith
      ? nativeEndsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.includes.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.includes.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js/internals/correct-is-regexp-logic.js");

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.iterator.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.iterator.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js").charAt;
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js/internals/define-iterator.js");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.match.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.match.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var advanceStringIndex = __webpack_require__(/*! ../internals/advance-string-index */ "./node_modules/core-js/internals/advance-string-index.js");
var regExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.replace.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.replace.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var advanceStringIndex = __webpack_require__(/*! ../internals/advance-string-index */ "./node_modules/core-js/internals/advance-string-index.js");
var regExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.search.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.search.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var sameValue = __webpack_require__(/*! ../internals/same-value */ "./node_modules/core-js/internals/same-value.js");
var regExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");

// @@search logic
fixRegExpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.split.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.split.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
var isRegExp = __webpack_require__(/*! ../internals/is-regexp */ "./node_modules/core-js/internals/is-regexp.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var advanceStringIndex = __webpack_require__(/*! ../internals/advance-string-index */ "./node_modules/core-js/internals/advance-string-index.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var callRegExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");
var regexpExec = __webpack_require__(/*! ../internals/regexp-exec */ "./node_modules/core-js/internals/regexp-exec.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.starts-with.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.starts-with.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js/internals/correct-is-regexp-logic.js");

var nativeStartsWith = ''.startsWith;
var min = Math.min;

// `String.prototype.startsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('startsWith') }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.trim.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.trim.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $trim = __webpack_require__(/*! ../internals/string-trim */ "./node_modules/core-js/internals/string-trim.js").trim;
var forcedStringTrimMethod = __webpack_require__(/*! ../internals/forced-string-trim-method */ "./node_modules/core-js/internals/forced-string-trim-method.js");

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.symbol.description.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.description.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var copyConstructorProperties = __webpack_require__(/*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.typed-array.float32-array.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/modules/es.typed-array.float32-array.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var typedArrayConstructor = __webpack_require__(/*! ../internals/typed-array-constructor */ "./node_modules/core-js/internals/typed-array-constructor.js");

// `Float32Array` constructor
// https://tc39.github.io/ecma262/#sec-typedarray-objects
typedArrayConstructor('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.typed-array.to-locale-string.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js/modules/es.typed-array.to-locale-string.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var ArrayBufferViewCore = __webpack_require__(/*! ../internals/array-buffer-view-core */ "./node_modules/core-js/internals/array-buffer-view-core.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var $toLocaleString = [].toLocaleString;
var $slice = [].slice;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.tolocalestring
ArrayBufferViewCore.exportProto('toLocaleString', function toLocaleString() {
  return $toLocaleString.apply(TO_LOCALE_STRING_BUG ? $slice.call(aTypedArray(this)) : aTypedArray(this), arguments);
}, FORCED);


/***/ }),

/***/ "./node_modules/core-js/modules/es.typed-array.uint8-array.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/modules/es.typed-array.uint8-array.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var typedArrayConstructor = __webpack_require__(/*! ../internals/typed-array-constructor */ "./node_modules/core-js/internals/typed-array-constructor.js");

// `Uint8Array` constructor
// https://tc39.github.io/ecma262/#sec-typedarray-objects
typedArrayConstructor('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.weak-map.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/es.weak-map.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js/internals/redefine-all.js");
var InternalMetadataModule = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js");
var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/core-js/internals/collection.js");
var collectionWeak = __webpack_require__(/*! ../internals/collection-weak */ "./node_modules/core-js/internals/collection-weak.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var enforceIternalState = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js").enforce;
var NATIVE_WEAK_MAP = __webpack_require__(/*! ../internals/native-weak-map */ "./node_modules/core-js/internals/native-weak-map.js");

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.github.io/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak, true, true);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.REQUIRED = true;
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/web.dom-collections.for-each.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/modules/web.dom-collections.for-each.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var DOMIterables = __webpack_require__(/*! ../internals/dom-iterables */ "./node_modules/core-js/internals/dom-iterables.js");
var forEach = __webpack_require__(/*! ../internals/array-for-each */ "./node_modules/core-js/internals/array-for-each.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "./node_modules/core-js/modules/web.dom-collections.iterator.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/modules/web.dom-collections.iterator.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var DOMIterables = __webpack_require__(/*! ../internals/dom-iterables */ "./node_modules/core-js/internals/dom-iterables.js");
var ArrayIteratorMethods = __webpack_require__(/*! ../modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "./node_modules/core-js/modules/web.url-search-params.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/web.url-search-params.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(/*! ../modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var USE_NATIVE_URL = __webpack_require__(/*! ../internals/native-url */ "./node_modules/core-js/internals/native-url.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js/internals/redefine-all.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var createIteratorConstructor = __webpack_require__(/*! ../internals/create-iterator-constructor */ "./node_modules/core-js/internals/create-iterator-constructor.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var hasOwn = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/core-js/internals/bind-context.js");
var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var getIterator = __webpack_require__(/*! ../internals/get-iterator */ "./node_modules/core-js/internals/get-iterator.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var $fetch = getBuiltIn('fetch');
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.appent` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!USE_NATIVE_URL && typeof $fetch == 'function' && typeof Headers == 'function') {
  $({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject(init)) {
          body = init.body;
          if (classof(body) === URL_SEARCH_PARAMS) {
            headers = init.headers ? new Headers(init.headers) : new Headers();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = create(init, {
              body: createPropertyDescriptor(0, String(body)),
              headers: createPropertyDescriptor(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch.apply(this, args);
    }
  });
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ "./node_modules/core-js/modules/web.url.js":
/*!*************************************************!*\
  !*** ./node_modules/core-js/modules/web.url.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(/*! ../modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var USE_NATIVE_URL = __webpack_require__(/*! ../internals/native-url */ "./node_modules/core-js/internals/native-url.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var defineProperties = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/core-js/internals/object-define-properties.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var assign = __webpack_require__(/*! ../internals/object-assign */ "./node_modules/core-js/internals/object-assign.js");
var arrayFrom = __webpack_require__(/*! ../internals/array-from */ "./node_modules/core-js/internals/array-from.js");
var codeAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js").codeAt;
var toASCII = __webpack_require__(/*! ../internals/punycode-to-ascii */ "./node_modules/core-js/internals/punycode-to-ascii.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var URLSearchParamsModule = __webpack_require__(/*! ../modules/web.url-search-params */ "./node_modules/core-js/modules/web.url-search-params.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");

var NativeURL = global.URL;
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor = Math.floor;
var pow = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
var ALPHANUMERIC = /[\d+\-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^(0x|0X)/;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
// eslint-disable-next-line no-control-regex
var TAB_AND_NEW_LINE = /[\u0009\u000A\u000D]/g;
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var char = function () {
    return input.charAt(pointer);
  };

  if (char() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (char()) {
    if (pieceIndex == 8) return;
    if (char() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(char())) {
      value = value * 16 + parseInt(char(), 16);
      pointer++;
      length++;
    }
    if (char() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (char()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (char() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(char())) return;
        while (DIGIT.test(char())) {
          number = parseInt(char(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (char() == ':') {
      pointer++;
      if (!char()) return;
    } else if (char()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (char, set) {
  var code = codeAt(char, 0);
  return code > 0x20 && code < 0x7F && !has(set, char) ? char : encodeURIComponent(char);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, char, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    char = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (char && ALPHA.test(char)) {
          buffer += char.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
          buffer += char.toLowerCase();
        } else if (char == ':') {
          if (stateOverride && (
            (isSpecial(url) != has(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && char != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && char == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (char == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (char == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (char == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (char == '/' || (char == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (char == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (char == '/' || char == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (char == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (char != '/' && char != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (char == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += char;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (char == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (char == '[') seenBracket = true;
          else if (char == ']') seenBracket = false;
          buffer += char;
        } break;

      case PORT:
        if (DIGIT.test(char)) {
          buffer += char;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (char == '/' || char == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (char == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (char == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (char == '/' || char == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += char;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (char != '/' && char != '\\') continue;
        } else if (!stateOverride && char == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          state = PATH;
          if (char != '/') continue;
        } break;

      case PATH:
        if (
          char == EOF || char == '/' ||
          (char == '\\' && isSpecial(url)) ||
          (!stateOverride && (char == '?' || char == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (char == '?') {
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(char, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (char == '?') {
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          if (char == "'" && isSpecial(url)) url.query += '%27';
          else if (char == '#') url.query += '%23';
          else url.query += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (char != EOF) url.fragment += percentEncode(char, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = String(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, String(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URL(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = String(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, String(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = String(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, pathname + '', PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = String(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = String(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./css/midiPlayer.css":
/*!******************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js!./css/midiPlayer.css ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../node_modules/css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.i, "/* midi player */\n/* adapted from MIDI.js css MIT License*/\n\n.midiPlayer {\n    background-image: linear-gradient(\n        to bottom,\n        rgba(66, 66, 66, 1),\n        rgba(22, 22, 22, 1)\n    );\n    padding: 15px 20px;\n    border: 1px solid #000;\n    box-shadow: 0 0 10px #fff;\n    border-radius: 10px;\n    color: #ffffff;\n    color: rgba(255, 255, 255, 0.8);\n    text-shadow: 1px 1px 2px #000;\n    margin-bottom: 15px;\n    height: 42px;\n    max-width: 700px;\n    min-height: 70px;\n}\n\n.midiPlayer .capsule {\n    border: 1px solid #000;\n    box-shadow: 0 0 10px #555;\n    background: #000;\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), #333 0);\n    overflow: hidden;\n    border-radius: 5px;\n    -moz-border-radius: 5px;\n    -webkit-border-radius: 5px;\n    width: 420px;\n    display: inline-block;\n    height: 30px;\n}\n\n.midiPlayer .capsule .cursor {\n    border-radius: 5px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    background: #003b96;\n    background: linear-gradient(to bottom, #0088e9, #003b96 100%);\n    width: 0;\n    display: inline-block;\n    height: 100%;\n}\n\n.midiPlayer .timePlayed,\n.midiPlayer .timeRemaining {\n    position: relative;\n    top: -9px;\n    padding: 0 10px;\n    width: 40px;\n    display: inline-block;\n    text-align: right;\n}\n\n.midiPlayer .timeRemaining {\n    text-align: left;\n}\n\n.midiPlayer .timeControls {\n    width: 560px;\n    margin: 0;\n    float: left;\n    position: relative;\n    top: 5px;\n}\n\n.midiPlayer .positionControls {\n    position: relative;\n    top: 5px;\n    margin: 0 auto;\n    width: 80px;\n    float: right;\n}\n\n.midiPlayer .positionControls input[type='image']:hover {\n    opacity: 1;\n}\n\n.midiPlayer .positionControls input[type='image']:active {\n    opacity: 0.85;\n}\n\n.midiPlayer .positionControls input[type='image'] {\n    opacity: 0.7;\n    outline: none;\n    vertical-align: middle;\n}\n", ""]);


/***/ }),

/***/ "./node_modules/css-loader/dist/runtime/api.js":
/*!*****************************************************!*\
  !*** ./node_modules/css-loader/dist/runtime/api.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], "{").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    for (var i = 0; i < this.length; i++) {
      // eslint-disable-next-line prefer-destructuring
      var id = this[i][0];

      if (id != null) {
        alreadyImportedModules[id] = true;
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = modules[_i]; // skip already imported module
      // this implementation is not 100% perfect for weird media query combinations
      // when a module is imported multiple times with different media queries.
      // I hope this will never occur (Hey this way we have smaller bundles)

      if (item[0] == null || !alreadyImportedModules[item[0]]) {
        if (mediaQuery && !item[2]) {
          item[2] = mediaQuery;
        } else if (mediaQuery) {
          item[2] = "(".concat(item[2], ") and (").concat(mediaQuery, ")");
        }

        list.push(item);
      }
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot).concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "./node_modules/jquery-ui-bundle/jquery-ui.js":
/*!****************************************************!*\
  !*** ./node_modules/jquery-ui-bundle/jquery-ui.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery UI - v1.12.1 - 2017-03-19
* http://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/draggable.js, widgets/droppable.js, widgets/resizable.js, widgets/selectable.js, widgets/sortable.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/selectmenu.js, widgets/slider.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js") ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}(function( $ ) {

$.ui = $.ui || {};

var version = $.ui.version = "1.12.1";


/*!
 * jQuery UI Widget 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/



var widgetUuid = 0;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// Http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( $.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr.pseudos[ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					current = $( $.uniqueSort( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		this._on( options.element, {
			"remove": "_untrackClassesElement"
		} );

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName ).off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

var widget = $.widget;


/*!
 * jQuery UI Position 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */

//>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: http://api.jqueryui.com/position/
//>>demos: http://jqueryui.com/position/


( function() {
var cachedScrollbarWidth,
	max = Math.max,
	abs = Math.abs,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[ 0 ];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div " +
				"style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'>" +
				"<div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[ 0 ];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[ 0 ].clientWidth;
		}

		div.remove();

		return ( cachedScrollbarWidth = w1 - w2 );
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[ 0 ] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
			hasOffset = !isWindow && !isDocument;
		return {
			element: withinElement,
			isWindow: isWindow,
			isDocument: isDocument,
			offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),
			width: withinElement.outerWidth(),
			height: withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// Make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[ 0 ].preventDefault ) {

		// Force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;

	// Clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// Force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1 ) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// Calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// Reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	} );

	// Normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each( function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
				scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
				scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				} );
			}
		} );

		if ( options.using ) {

			// Adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	} );
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// Element is wider than within
			if ( data.collisionWidth > outerWidth ) {

				// Element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
						withinOffset;
					position.left += overLeft - newOverRight;

				// Element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;

				// Element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}

			// Too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;

			// Too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;

			// Adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// Element is taller than within
			if ( data.collisionHeight > outerHeight ) {

				// Element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
						withinOffset;
					position.top += overTop - newOverBottom;

				// Element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;

				// Element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}

			// Too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;

			// Too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;

			// Adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
					outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
					atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
					outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
					offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

} )();

var position = $.ui.position;


/*!
 * jQuery UI :data 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :data Selector
//>>group: Core
//>>description: Selects elements which have data stored under the specified key.
//>>docs: http://api.jqueryui.com/data-selector/


var data = $.extend( $.expr.pseudos, {
	data: $.expr.createPseudo ?
		$.expr.createPseudo( function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		} ) :

		// Support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		}
} );

/*!
 * jQuery UI Disable Selection 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: disableSelection
//>>group: Core
//>>description: Disable selection of text content within the set of matched elements.
//>>docs: http://api.jqueryui.com/disableSelection/

// This file is deprecated


var disableSelection = $.fn.extend( {
	disableSelection: ( function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.on( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			} );
		};
	} )(),

	enableSelection: function() {
		return this.off( ".ui-disableSelection" );
	}
} );


/*!
 * jQuery UI Focusable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :focusable Selector
//>>group: Core
//>>description: Selects elements which can be focused.
//>>docs: http://api.jqueryui.com/focusable-selector/



// Selectors
$.ui.focusable = function( element, hasTabindex ) {
	var map, mapName, img, focusableIfVisible, fieldset,
		nodeName = element.nodeName.toLowerCase();

	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" );
		return img.length > 0 && img.is( ":visible" );
	}

	if ( /^(input|select|textarea|button|object)$/.test( nodeName ) ) {
		focusableIfVisible = !element.disabled;

		if ( focusableIfVisible ) {

			// Form controls within a disabled fieldset are disabled.
			// However, controls within the fieldset's legend do not get disabled.
			// Since controls generally aren't placed inside legends, we skip
			// this portion of the check.
			fieldset = $( element ).closest( "fieldset" )[ 0 ];
			if ( fieldset ) {
				focusableIfVisible = !fieldset.disabled;
			}
		}
	} else if ( "a" === nodeName ) {
		focusableIfVisible = element.href || hasTabindex;
	} else {
		focusableIfVisible = hasTabindex;
	}

	return focusableIfVisible && $( element ).is( ":visible" ) && visible( $( element ) );
};

// Support: IE 8 only
// IE 8 doesn't resolve inherit to visible/hidden for computed values
function visible( element ) {
	var visibility = element.css( "visibility" );
	while ( visibility === "inherit" ) {
		element = element.parent();
		visibility = element.css( "visibility" );
	}
	return visibility !== "hidden";
}

$.extend( $.expr.pseudos, {
	focusable: function( element ) {
		return $.ui.focusable( element, $.attr( element, "tabindex" ) != null );
	}
} );

var focusable = $.ui.focusable;




// Support: IE8 Only
// IE8 does not support the form attribute and when it is supplied. It overwrites the form prop
// with a string, so we need to find the proper form.
var form = $.fn.form = function() {
	return typeof this[ 0 ].form === "string" ? this.closest( "form" ) : $( this[ 0 ].form );
};


/*!
 * jQuery UI Form Reset Mixin 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Form Reset Mixin
//>>group: Core
//>>description: Refresh input widgets when their form is reset
//>>docs: http://api.jqueryui.com/form-reset-mixin/



var formResetMixin = $.ui.formResetMixin = {
	_formResetHandler: function() {
		var form = $( this );

		// Wait for the form reset to actually happen before refreshing
		setTimeout( function() {
			var instances = form.data( "ui-form-reset-instances" );
			$.each( instances, function() {
				this.refresh();
			} );
		} );
	},

	_bindFormResetHandler: function() {
		this.form = this.element.form();
		if ( !this.form.length ) {
			return;
		}

		var instances = this.form.data( "ui-form-reset-instances" ) || [];
		if ( !instances.length ) {

			// We don't use _on() here because we use a single event handler per form
			this.form.on( "reset.ui-form-reset", this._formResetHandler );
		}
		instances.push( this );
		this.form.data( "ui-form-reset-instances", instances );
	},

	_unbindFormResetHandler: function() {
		if ( !this.form.length ) {
			return;
		}

		var instances = this.form.data( "ui-form-reset-instances" );
		instances.splice( $.inArray( this, instances ), 1 );
		if ( instances.length ) {
			this.form.data( "ui-form-reset-instances", instances );
		} else {
			this.form
				.removeData( "ui-form-reset-instances" )
				.off( "reset.ui-form-reset" );
		}
	}
};


/*!
 * jQuery UI Support for jQuery core 1.7.x 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 */

//>>label: jQuery 1.7 Support
//>>group: Core
//>>description: Support version 1.7.x of jQuery core



// Support: jQuery 1.7 only
// Not a great way to check versions, but since we only support 1.7+ and only
// need to detect <1.8, this is a simple check that should suffice. Checking
// for "1.7." would be a bit safer, but the version string is 1.7, not 1.7.0
// and we'll never reach 1.70.0 (if we do, we certainly won't be supporting
// 1.7 anymore). See #11197 for why we're not using feature detection.
if ( $.fn.jquery.substring( 0, 3 ) === "1.7" ) {

	// Setters for .innerWidth(), .innerHeight(), .outerWidth(), .outerHeight()
	// Unlike jQuery Core 1.8+, these only support numeric values to set the
	// dimensions in pixels
	$.each( [ "Width", "Height" ], function( i, name ) {
		var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
			type = name.toLowerCase(),
			orig = {
				innerWidth: $.fn.innerWidth,
				innerHeight: $.fn.innerHeight,
				outerWidth: $.fn.outerWidth,
				outerHeight: $.fn.outerHeight
			};

		function reduce( elem, size, border, margin ) {
			$.each( side, function() {
				size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
				if ( border ) {
					size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
				}
				if ( margin ) {
					size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
				}
			} );
			return size;
		}

		$.fn[ "inner" + name ] = function( size ) {
			if ( size === undefined ) {
				return orig[ "inner" + name ].call( this );
			}

			return this.each( function() {
				$( this ).css( type, reduce( this, size ) + "px" );
			} );
		};

		$.fn[ "outer" + name ] = function( size, margin ) {
			if ( typeof size !== "number" ) {
				return orig[ "outer" + name ].call( this, size );
			}

			return this.each( function() {
				$( this ).css( type, reduce( this, size, true, margin ) + "px" );
			} );
		};
	} );

	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

;
/*!
 * jQuery UI Keycode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Keycode
//>>group: Core
//>>description: Provide keycodes as keynames
//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/


var keycode = $.ui.keyCode = {
	BACKSPACE: 8,
	COMMA: 188,
	DELETE: 46,
	DOWN: 40,
	END: 35,
	ENTER: 13,
	ESCAPE: 27,
	HOME: 36,
	LEFT: 37,
	PAGE_DOWN: 34,
	PAGE_UP: 33,
	PERIOD: 190,
	RIGHT: 39,
	SPACE: 32,
	TAB: 9,
	UP: 38
};




// Internal use only
var escapeSelector = $.ui.escapeSelector = ( function() {
	var selectorEscape = /([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;
	return function( selector ) {
		return selector.replace( selectorEscape, "\\$1" );
	};
} )();


/*!
 * jQuery UI Labels 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: labels
//>>group: Core
//>>description: Find all the labels associated with a given input
//>>docs: http://api.jqueryui.com/labels/



var labels = $.fn.labels = function() {
	var ancestor, selector, id, labels, ancestors;

	// Check control.labels first
	if ( this[ 0 ].labels && this[ 0 ].labels.length ) {
		return this.pushStack( this[ 0 ].labels );
	}

	// Support: IE <= 11, FF <= 37, Android <= 2.3 only
	// Above browsers do not support control.labels. Everything below is to support them
	// as well as document fragments. control.labels does not work on document fragments
	labels = this.eq( 0 ).parents( "label" );

	// Look for the label based on the id
	id = this.attr( "id" );
	if ( id ) {

		// We don't search against the document in case the element
		// is disconnected from the DOM
		ancestor = this.eq( 0 ).parents().last();

		// Get a full set of top level ancestors
		ancestors = ancestor.add( ancestor.length ? ancestor.siblings() : this.siblings() );

		// Create a selector for the label based on the id
		selector = "label[for='" + $.ui.escapeSelector( id ) + "']";

		labels = labels.add( ancestors.find( selector ).addBack( selector ) );

	}

	// Return whatever we have found for labels
	return this.pushStack( labels );
};


/*!
 * jQuery UI Scroll Parent 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: scrollParent
//>>group: Core
//>>description: Get the closest ancestor element that is scrollable.
//>>docs: http://api.jqueryui.com/scrollParent/



var scrollParent = $.fn.scrollParent = function( includeHidden ) {
	var position = this.css( "position" ),
		excludeStaticParent = position === "absolute",
		overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
		scrollParent = this.parents().filter( function() {
			var parent = $( this );
			if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
				return false;
			}
			return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
				parent.css( "overflow-x" ) );
		} ).eq( 0 );

	return position === "fixed" || !scrollParent.length ?
		$( this[ 0 ].ownerDocument || document ) :
		scrollParent;
};


/*!
 * jQuery UI Tabbable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :tabbable Selector
//>>group: Core
//>>description: Selects elements which can be tabbed to.
//>>docs: http://api.jqueryui.com/tabbable-selector/



var tabbable = $.extend( $.expr.pseudos, {
	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			hasTabindex = tabIndex != null;
		return ( !hasTabindex || tabIndex >= 0 ) && $.ui.focusable( element, hasTabindex );
	}
} );


/*!
 * jQuery UI Unique ID 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: http://api.jqueryui.com/uniqueId/



var uniqueId = $.fn.extend( {
	uniqueId: ( function() {
		var uuid = 0;

		return function() {
			return this.each( function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			} );
		};
	} )(),

	removeUniqueId: function() {
		return this.each( function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		} );
	}
} );




// This file is deprecated
var ie = $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

/*!
 * jQuery UI Mouse 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: http://api.jqueryui.com/mouse/



var mouseHandled = false;
$( document ).on( "mouseup", function() {
	mouseHandled = false;
} );

var widgetsMouse = $.widget( "ui.mouse", {
	version: "1.12.1",
	options: {
		cancel: "input, textarea, button, select, option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.on( "mousedown." + this.widgetName, function( event ) {
				return that._mouseDown( event );
			} )
			.on( "click." + this.widgetName, function( event ) {
				if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
					$.removeData( event.target, that.widgetName + ".preventClickEvent" );
					event.stopImmediatePropagation();
					return false;
				}
			} );

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.off( "." + this.widgetName );
		if ( this._mouseMoveDelegate ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
		}
	},

	_mouseDown: function( event ) {

		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// We may have missed mouseup (out of window)
		( this._mouseStarted && this._mouseUp( event ) );

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = ( event.which === 1 ),

			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
				$( event.target ).closest( this.options.cancel ).length : false );
		if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if ( !this.mouseDelayMet ) {
			this._mouseDelayTimer = setTimeout( function() {
				that.mouseDelayMet = true;
			}, this.options.delay );
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted = ( this._mouseStart( event ) !== false );
			if ( !this._mouseStarted ) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
			$.removeData( event.target, this.widgetName + ".preventClickEvent" );
		}

		// These delegates are required to keep context
		this._mouseMoveDelegate = function( event ) {
			return that._mouseMove( event );
		};
		this._mouseUpDelegate = function( event ) {
			return that._mouseUp( event );
		};

		this.document
			.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.on( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function( event ) {

		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {

			// IE mouseup check - mouseup happened when mouse was out of window
			if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
					!event.button ) {
				return this._mouseUp( event );

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {

				// Support: Safari <=8 - 9
				// Safari sets which to 0 if you press any of the following keys
				// during a drag (#14461)
				if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
						event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
					this.ignoreMissingWhich = true;
				} else if ( !this.ignoreMissingWhich ) {
					return this._mouseUp( event );
				}
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if ( this._mouseStarted ) {
			this._mouseDrag( event );
			return event.preventDefault();
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted =
				( this._mouseStart( this._mouseDownEvent, event ) !== false );
			( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
		}

		return !this._mouseStarted;
	},

	_mouseUp: function( event ) {
		this.document
			.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.off( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if ( this._mouseStarted ) {
			this._mouseStarted = false;

			if ( event.target === this._mouseDownEvent.target ) {
				$.data( event.target, this.widgetName + ".preventClickEvent", true );
			}

			this._mouseStop( event );
		}

		if ( this._mouseDelayTimer ) {
			clearTimeout( this._mouseDelayTimer );
			delete this._mouseDelayTimer;
		}

		this.ignoreMissingWhich = false;
		mouseHandled = false;
		event.preventDefault();
	},

	_mouseDistanceMet: function( event ) {
		return ( Math.max(
				Math.abs( this._mouseDownEvent.pageX - event.pageX ),
				Math.abs( this._mouseDownEvent.pageY - event.pageY )
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function( /* event */ ) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function( /* event */ ) {},
	_mouseDrag: function( /* event */ ) {},
	_mouseStop: function( /* event */ ) {},
	_mouseCapture: function( /* event */ ) { return true; }
} );




// $.ui.plugin is deprecated. Use $.widget() extensions instead.
var plugin = $.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
				instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};



var safeActiveElement = $.ui.safeActiveElement = function( document ) {
	var activeElement;

	// Support: IE 9 only
	// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
	try {
		activeElement = document.activeElement;
	} catch ( error ) {
		activeElement = document.body;
	}

	// Support: IE 9 - 11 only
	// IE may return null instead of an element
	// Interestingly, this only seems to occur when NOT in an iframe
	if ( !activeElement ) {
		activeElement = document.body;
	}

	// Support: IE 11 only
	// IE11 returns a seemingly empty object in some cases when accessing
	// document.activeElement from an <iframe>
	if ( !activeElement.nodeName ) {
		activeElement = document.body;
	}

	return activeElement;
};



var safeBlur = $.ui.safeBlur = function( element ) {

	// Support: IE9 - 10 only
	// If the <body> is blurred, IE will switch windows, see #9420
	if ( element && element.nodeName.toLowerCase() !== "body" ) {
		$( element ).trigger( "blur" );
	}
};


/*!
 * jQuery UI Draggable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Draggable
//>>group: Interactions
//>>description: Enables dragging functionality for any element.
//>>docs: http://api.jqueryui.com/draggable/
//>>demos: http://jqueryui.com/draggable/
//>>css.structure: ../../themes/base/draggable.css



$.widget( "ui.draggable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false,

		// Callbacks
		drag: null,
		start: null,
		stop: null
	},
	_create: function() {

		if ( this.options.helper === "original" ) {
			this._setPositionRelative();
		}
		if ( this.options.addClasses ) {
			this._addClass( "ui-draggable" );
		}
		this._setHandleClassName();

		this._mouseInit();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "handle" ) {
			this._removeHandleClassName();
			this._setHandleClassName();
		}
	},

	_destroy: function() {
		if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
			this.destroyOnClear = true;
			return;
		}
		this._removeHandleClassName();
		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var o = this.options;

		// Among others, prevent a drag on a resizable-handle
		if ( this.helper || o.disabled ||
				$( event.target ).closest( ".ui-resizable-handle" ).length > 0 ) {
			return false;
		}

		//Quit if we're not on a valid handle
		this.handle = this._getHandle( event );
		if ( !this.handle ) {
			return false;
		}

		this._blurActiveElement( event );

		this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

		return true;

	},

	_blockFrames: function( selector ) {
		this.iframeBlocks = this.document.find( selector ).map( function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( "position", "absolute" )
				.appendTo( iframe.parent() )
				.outerWidth( iframe.outerWidth() )
				.outerHeight( iframe.outerHeight() )
				.offset( iframe.offset() )[ 0 ];
		} );
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_blurActiveElement: function( event ) {
		var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
			target = $( event.target );

		// Don't blur if the event occurred on an element that is within
		// the currently focused element
		// See #10527, #12472
		if ( target.closest( activeElement ).length ) {
			return;
		}

		// Blur any element that currently has focus, see #4261
		$.ui.safeBlur( activeElement );
	},

	_mouseStart: function( event ) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		this._addClass( this.helper, "ui-draggable-dragging" );

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css( "position" );
		this.scrollParent = this.helper.scrollParent( true );
		this.offsetParent = this.helper.offsetParent();
		this.hasFixedAncestor = this.helper.parents().filter( function() {
				return $( this ).css( "position" ) === "fixed";
			} ).length > 0;

		//The element's absolute position on the page minus margins
		this.positionAbs = this.element.offset();
		this._refreshOffsets( event );

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition( event, false );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );

		//Set a containment if given in the options
		this._setContainment();

		//Trigger event + callbacks
		if ( this._trigger( "start", event ) === false ) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		// Execute the drag once - this causes the helper not to be visible before getting its
		// correct position
		this._mouseDrag( event, true );

		// If the ddmanager is used for droppables, inform the manager that dragging has started
		// (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStart( this, event );
		}

		return true;
	},

	_refreshOffsets: function( event ) {
		this.offset = {
			top: this.positionAbs.top - this.margins.top,
			left: this.positionAbs.left - this.margins.left,
			scroll: false,
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset()
		};

		this.offset.click = {
			left: event.pageX - this.offset.left,
			top: event.pageY - this.offset.top
		};
	},

	_mouseDrag: function( event, noPropagation ) {

		// reset any necessary cached properties (see #5009)
		if ( this.hasFixedAncestor ) {
			this.offset.parent = this._getParentOffset();
		}

		//Compute the helpers position
		this.position = this._generatePosition( event, true );
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Call plugins and callbacks and use the resulting position if something is returned
		if ( !noPropagation ) {
			var ui = this._uiHash();
			if ( this._trigger( "drag", event, ui ) === false ) {
				this._mouseUp( new $.Event( "mouseup", event ) );
				return false;
			}
			this.position = ui.position;
		}

		this.helper[ 0 ].style.left = this.position.left + "px";
		this.helper[ 0 ].style.top = this.position.top + "px";

		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		return false;
	},

	_mouseStop: function( event ) {

		//If we are using droppables, inform the manager about the drop
		var that = this,
			dropped = false;
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			dropped = $.ui.ddmanager.drop( this, event );
		}

		//if a drop comes from outside (a sortable)
		if ( this.dropped ) {
			dropped = this.dropped;
			this.dropped = false;
		}

		if ( ( this.options.revert === "invalid" && !dropped ) ||
				( this.options.revert === "valid" && dropped ) ||
				this.options.revert === true || ( $.isFunction( this.options.revert ) &&
				this.options.revert.call( this.element, dropped ) )
		) {
			$( this.helper ).animate(
				this.originalPosition,
				parseInt( this.options.revertDuration, 10 ),
				function() {
					if ( that._trigger( "stop", event ) !== false ) {
						that._clear();
					}
				}
			);
		} else {
			if ( this._trigger( "stop", event ) !== false ) {
				this._clear();
			}
		}

		return false;
	},

	_mouseUp: function( event ) {
		this._unblockFrames();

		// If the ddmanager is used for droppables, inform the manager that dragging has stopped
		// (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStop( this, event );
		}

		// Only need to focus if the event occurred on the draggable itself, see #10527
		if ( this.handleElement.is( event.target ) ) {

			// The interaction is over; whether or not the click resulted in a drag,
			// focus the element
			this.element.trigger( "focus" );
		}

		return $.ui.mouse.prototype._mouseUp.call( this, event );
	},

	cancel: function() {

		if ( this.helper.is( ".ui-draggable-dragging" ) ) {
			this._mouseUp( new $.Event( "mouseup", { target: this.element[ 0 ] } ) );
		} else {
			this._clear();
		}

		return this;

	},

	_getHandle: function( event ) {
		return this.options.handle ?
			!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
			true;
	},

	_setHandleClassName: function() {
		this.handleElement = this.options.handle ?
			this.element.find( this.options.handle ) : this.element;
		this._addClass( this.handleElement, "ui-draggable-handle" );
	},

	_removeHandleClassName: function() {
		this._removeClass( this.handleElement, "ui-draggable-handle" );
	},

	_createHelper: function( event ) {

		var o = this.options,
			helperIsFunction = $.isFunction( o.helper ),
			helper = helperIsFunction ?
				$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
				( o.helper === "clone" ?
					this.element.clone().removeAttr( "id" ) :
					this.element );

		if ( !helper.parents( "body" ).length ) {
			helper.appendTo( ( o.appendTo === "parent" ?
				this.element[ 0 ].parentNode :
				o.appendTo ) );
		}

		// Http://bugs.jqueryui.com/ticket/9446
		// a helper function can return the original element
		// which wouldn't have been set to relative in _create
		if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
			this._setPositionRelative();
		}

		if ( helper[ 0 ] !== this.element[ 0 ] &&
				!( /(fixed|absolute)/ ).test( helper.css( "position" ) ) ) {
			helper.css( "position", "absolute" );
		}

		return helper;

	},

	_setPositionRelative: function() {
		if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
			this.element[ 0 ].style.position = "relative";
		}
	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( $.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_isRootNode: function( element ) {
		return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		var po = this.offsetParent.offset(),
			document = this.document[ 0 ];

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== document &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {
		if ( this.cssPosition !== "relative" ) {
			return { top: 0, left: 0 };
		}

		var p = this.element.position(),
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
			left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
		};

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.element.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.element.css( "marginTop" ), 10 ) || 0 ),
			right: ( parseInt( this.element.css( "marginRight" ), 10 ) || 0 ),
			bottom: ( parseInt( this.element.css( "marginBottom" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var isUserScrollable, c, ce,
			o = this.options,
			document = this.document[ 0 ];

		this.relativeContainer = null;

		if ( !o.containment ) {
			this.containment = null;
			return;
		}

		if ( o.containment === "window" ) {
			this.containment = [
				$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
				$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
				$( window ).scrollLeft() + $( window ).width() -
					this.helperProportions.width - this.margins.left,
				$( window ).scrollTop() +
					( $( window ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment === "document" ) {
			this.containment = [
				0,
				0,
				$( document ).width() - this.helperProportions.width - this.margins.left,
				( $( document ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment.constructor === Array ) {
			this.containment = o.containment;
			return;
		}

		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}

		c = $( o.containment );
		ce = c[ 0 ];

		if ( !ce ) {
			return;
		}

		isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

		this.containment = [
			( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
			( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
			( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
			( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
		];
		this.relativeContainer = c;
	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}

		var mod = d === "absolute" ? 1 : -1,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.offset.scroll.top :
					( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.offset.scroll.left :
					( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod )
			)
		};

	},

	_generatePosition: function( event, constrainPosition ) {

		var containment, co, top, left,
			o = this.options,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
			pageX = event.pageX,
			pageY = event.pageY;

		// Cache the scroll
		if ( !scrollIsRootNode || !this.offset.scroll ) {
			this.offset.scroll = {
				top: this.scrollParent.scrollTop(),
				left: this.scrollParent.scrollLeft()
			};
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		// If we are not dragging yet, we won't check for options
		if ( constrainPosition ) {
			if ( this.containment ) {
				if ( this.relativeContainer ) {
					co = this.relativeContainer.offset();
					containment = [
						this.containment[ 0 ] + co.left,
						this.containment[ 1 ] + co.top,
						this.containment[ 2 ] + co.left,
						this.containment[ 3 ] + co.top
					];
				} else {
					containment = this.containment;
				}

				if ( event.pageX - this.offset.click.left < containment[ 0 ] ) {
					pageX = containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < containment[ 1 ] ) {
					pageY = containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > containment[ 2 ] ) {
					pageX = containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > containment[ 3 ] ) {
					pageY = containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {

				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid
				// argument errors in IE (see ticket #6950)
				top = o.grid[ 1 ] ? this.originalPageY + Math.round( ( pageY -
					this.originalPageY ) / o.grid[ 1 ] ) * o.grid[ 1 ] : this.originalPageY;
				pageY = containment ? ( ( top - this.offset.click.top >= containment[ 1 ] ||
					top - this.offset.click.top > containment[ 3 ] ) ?
						top :
						( ( top - this.offset.click.top >= containment[ 1 ] ) ?
							top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) : top;

				left = o.grid[ 0 ] ? this.originalPageX +
					Math.round( ( pageX - this.originalPageX ) / o.grid[ 0 ] ) * o.grid[ 0 ] :
					this.originalPageX;
				pageX = containment ? ( ( left - this.offset.click.left >= containment[ 0 ] ||
					left - this.offset.click.left > containment[ 2 ] ) ?
						left :
						( ( left - this.offset.click.left >= containment[ 0 ] ) ?
							left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) : left;
			}

			if ( o.axis === "y" ) {
				pageX = this.originalPageX;
			}

			if ( o.axis === "x" ) {
				pageY = this.originalPageY;
			}
		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( this.cssPosition === "fixed" ?
					-this.offset.scroll.top :
					( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( this.cssPosition === "fixed" ?
					-this.offset.scroll.left :
					( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
			)
		};

	},

	_clear: function() {
		this._removeClass( this.helper, "ui-draggable-dragging" );
		if ( this.helper[ 0 ] !== this.element[ 0 ] && !this.cancelHelperRemoval ) {
			this.helper.remove();
		}
		this.helper = null;
		this.cancelHelperRemoval = false;
		if ( this.destroyOnClear ) {
			this.destroy();
		}
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function( type, event, ui ) {
		ui = ui || this._uiHash();
		$.ui.plugin.call( this, type, [ event, ui, this ], true );

		// Absolute position and offset (see #6884 ) have to be recalculated after plugins
		if ( /^(drag|start|stop)/.test( type ) ) {
			this.positionAbs = this._convertPositionTo( "absolute" );
			ui.offset = this.positionAbs;
		}
		return $.Widget.prototype._trigger.call( this, type, event, ui );
	},

	plugins: {},

	_uiHash: function() {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

} );

$.ui.plugin.add( "draggable", "connectToSortable", {
	start: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		} );

		draggable.sortables = [];
		$( draggable.options.connectToSortable ).each( function() {
			var sortable = $( this ).sortable( "instance" );

			if ( sortable && !sortable.options.disabled ) {
				draggable.sortables.push( sortable );

				// RefreshPositions is called at drag start to refresh the containerCache
				// which is used in drag. This ensures it's initialized and synchronized
				// with any changes that might have happened on the page since initialization.
				sortable.refreshPositions();
				sortable._trigger( "activate", event, uiSortable );
			}
		} );
	},
	stop: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		} );

		draggable.cancelHelperRemoval = false;

		$.each( draggable.sortables, function() {
			var sortable = this;

			if ( sortable.isOver ) {
				sortable.isOver = 0;

				// Allow this sortable to handle removing the helper
				draggable.cancelHelperRemoval = true;
				sortable.cancelHelperRemoval = false;

				// Use _storedCSS To restore properties in the sortable,
				// as this also handles revert (#9675) since the draggable
				// may have modified them in unexpected ways (#8809)
				sortable._storedCSS = {
					position: sortable.placeholder.css( "position" ),
					top: sortable.placeholder.css( "top" ),
					left: sortable.placeholder.css( "left" )
				};

				sortable._mouseStop( event );

				// Once drag has ended, the sortable should return to using
				// its original helper, not the shared helper from draggable
				sortable.options.helper = sortable.options._helper;
			} else {

				// Prevent this Sortable from removing the helper.
				// However, don't set the draggable to remove the helper
				// either as another connected Sortable may yet handle the removal.
				sortable.cancelHelperRemoval = true;

				sortable._trigger( "deactivate", event, uiSortable );
			}
		} );
	},
	drag: function( event, ui, draggable ) {
		$.each( draggable.sortables, function() {
			var innermostIntersecting = false,
				sortable = this;

			// Copy over variables that sortable's _intersectsWith uses
			sortable.positionAbs = draggable.positionAbs;
			sortable.helperProportions = draggable.helperProportions;
			sortable.offset.click = draggable.offset.click;

			if ( sortable._intersectsWith( sortable.containerCache ) ) {
				innermostIntersecting = true;

				$.each( draggable.sortables, function() {

					// Copy over variables that sortable's _intersectsWith uses
					this.positionAbs = draggable.positionAbs;
					this.helperProportions = draggable.helperProportions;
					this.offset.click = draggable.offset.click;

					if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
						innermostIntersecting = false;
					}

					return innermostIntersecting;
				} );
			}

			if ( innermostIntersecting ) {

				// If it intersects, we use a little isOver variable and set it once,
				// so that the move-in stuff gets fired only once.
				if ( !sortable.isOver ) {
					sortable.isOver = 1;

					// Store draggable's parent in case we need to reappend to it later.
					draggable._parent = ui.helper.parent();

					sortable.currentItem = ui.helper
						.appendTo( sortable.element )
						.data( "ui-sortable-item", true );

					// Store helper option to later restore it
					sortable.options._helper = sortable.options.helper;

					sortable.options.helper = function() {
						return ui.helper[ 0 ];
					};

					// Fire the start events of the sortable with our passed browser event,
					// and our own helper (so it doesn't create a new one)
					event.target = sortable.currentItem[ 0 ];
					sortable._mouseCapture( event, true );
					sortable._mouseStart( event, true, true );

					// Because the browser event is way off the new appended portlet,
					// modify necessary variables to reflect the changes
					sortable.offset.click.top = draggable.offset.click.top;
					sortable.offset.click.left = draggable.offset.click.left;
					sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
					sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

					draggable._trigger( "toSortable", event );

					// Inform draggable that the helper is in a valid drop zone,
					// used solely in the revert option to handle "valid/invalid".
					draggable.dropped = sortable.element;

					// Need to refreshPositions of all sortables in the case that
					// adding to one sortable changes the location of the other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					} );

					// Hack so receive/update callbacks work (mostly)
					draggable.currentItem = draggable.element;
					sortable.fromOutside = draggable;
				}

				if ( sortable.currentItem ) {
					sortable._mouseDrag( event );

					// Copy the sortable's position because the draggable's can potentially reflect
					// a relative position, while sortable is always absolute, which the dragged
					// element has now become. (#8809)
					ui.position = sortable.position;
				}
			} else {

				// If it doesn't intersect with the sortable, and it intersected before,
				// we fake the drag stop of the sortable, but make sure it doesn't remove
				// the helper by using cancelHelperRemoval.
				if ( sortable.isOver ) {

					sortable.isOver = 0;
					sortable.cancelHelperRemoval = true;

					// Calling sortable's mouseStop would trigger a revert,
					// so revert must be temporarily false until after mouseStop is called.
					sortable.options._revert = sortable.options.revert;
					sortable.options.revert = false;

					sortable._trigger( "out", event, sortable._uiHash( sortable ) );
					sortable._mouseStop( event, true );

					// Restore sortable behaviors that were modfied
					// when the draggable entered the sortable area (#9481)
					sortable.options.revert = sortable.options._revert;
					sortable.options.helper = sortable.options._helper;

					if ( sortable.placeholder ) {
						sortable.placeholder.remove();
					}

					// Restore and recalculate the draggable's offset considering the sortable
					// may have modified them in unexpected ways. (#8809, #10669)
					ui.helper.appendTo( draggable._parent );
					draggable._refreshOffsets( event );
					ui.position = draggable._generatePosition( event, true );

					draggable._trigger( "fromSortable", event );

					// Inform draggable that the helper is no longer in a valid drop zone
					draggable.dropped = false;

					// Need to refreshPositions of all sortables just in case removing
					// from one sortable changes the location of other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					} );
				}
			}
		} );
	}
} );

$.ui.plugin.add( "draggable", "cursor", {
	start: function( event, ui, instance ) {
		var t = $( "body" ),
			o = instance.options;

		if ( t.css( "cursor" ) ) {
			o._cursor = t.css( "cursor" );
		}
		t.css( "cursor", o.cursor );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if ( o._cursor ) {
			$( "body" ).css( "cursor", o._cursor );
		}
	}
} );

$.ui.plugin.add( "draggable", "opacity", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;
		if ( t.css( "opacity" ) ) {
			o._opacity = t.css( "opacity" );
		}
		t.css( "opacity", o.opacity );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if ( o._opacity ) {
			$( ui.helper ).css( "opacity", o._opacity );
		}
	}
} );

$.ui.plugin.add( "draggable", "scroll", {
	start: function( event, ui, i ) {
		if ( !i.scrollParentNotHidden ) {
			i.scrollParentNotHidden = i.helper.scrollParent( false );
		}

		if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] &&
				i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
			i.overflowOffset = i.scrollParentNotHidden.offset();
		}
	},
	drag: function( event, ui, i  ) {

		var o = i.options,
			scrolled = false,
			scrollParent = i.scrollParentNotHidden[ 0 ],
			document = i.document[ 0 ];

		if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
			if ( !o.axis || o.axis !== "x" ) {
				if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY <
						o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
				} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX <
						o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
				}
			}

		} else {

			if ( !o.axis || o.axis !== "x" ) {
				if ( event.pageY - $( document ).scrollTop() < o.scrollSensitivity ) {
					scrolled = $( document ).scrollTop( $( document ).scrollTop() - o.scrollSpeed );
				} else if ( $( window ).height() - ( event.pageY - $( document ).scrollTop() ) <
						o.scrollSensitivity ) {
					scrolled = $( document ).scrollTop( $( document ).scrollTop() + o.scrollSpeed );
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( event.pageX - $( document ).scrollLeft() < o.scrollSensitivity ) {
					scrolled = $( document ).scrollLeft(
						$( document ).scrollLeft() - o.scrollSpeed
					);
				} else if ( $( window ).width() - ( event.pageX - $( document ).scrollLeft() ) <
						o.scrollSensitivity ) {
					scrolled = $( document ).scrollLeft(
						$( document ).scrollLeft() + o.scrollSpeed
					);
				}
			}

		}

		if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( i, event );
		}

	}
} );

$.ui.plugin.add( "draggable", "snap", {
	start: function( event, ui, i ) {

		var o = i.options;

		i.snapElements = [];

		$( o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap )
			.each( function() {
				var $t = $( this ),
					$o = $t.offset();
				if ( this !== i.element[ 0 ] ) {
					i.snapElements.push( {
						item: this,
						width: $t.outerWidth(), height: $t.outerHeight(),
						top: $o.top, left: $o.left
					} );
				}
			} );

	},
	drag: function( event, ui, inst ) {

		var ts, bs, ls, rs, l, r, t, b, i, first,
			o = inst.options,
			d = o.snapTolerance,
			x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for ( i = inst.snapElements.length - 1; i >= 0; i-- ) {

			l = inst.snapElements[ i ].left - inst.margins.left;
			r = l + inst.snapElements[ i ].width;
			t = inst.snapElements[ i ].top - inst.margins.top;
			b = t + inst.snapElements[ i ].height;

			if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d ||
					!$.contains( inst.snapElements[ i ].item.ownerDocument,
					inst.snapElements[ i ].item ) ) {
				if ( inst.snapElements[ i ].snapping ) {
					( inst.options.snap.release &&
						inst.options.snap.release.call(
							inst.element,
							event,
							$.extend( inst._uiHash(), { snapItem: inst.snapElements[ i ].item } )
						) );
				}
				inst.snapElements[ i ].snapping = false;
				continue;
			}

			if ( o.snapMode !== "inner" ) {
				ts = Math.abs( t - y2 ) <= d;
				bs = Math.abs( b - y1 ) <= d;
				ls = Math.abs( l - x2 ) <= d;
				rs = Math.abs( r - x1 ) <= d;
				if ( ts ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: t - inst.helperProportions.height,
						left: 0
					} ).top;
				}
				if ( bs ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: b,
						left: 0
					} ).top;
				}
				if ( ls ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: l - inst.helperProportions.width
					} ).left;
				}
				if ( rs ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: r
					} ).left;
				}
			}

			first = ( ts || bs || ls || rs );

			if ( o.snapMode !== "outer" ) {
				ts = Math.abs( t - y1 ) <= d;
				bs = Math.abs( b - y2 ) <= d;
				ls = Math.abs( l - x1 ) <= d;
				rs = Math.abs( r - x2 ) <= d;
				if ( ts ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: t,
						left: 0
					} ).top;
				}
				if ( bs ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: b - inst.helperProportions.height,
						left: 0
					} ).top;
				}
				if ( ls ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: l
					} ).left;
				}
				if ( rs ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: r - inst.helperProportions.width
					} ).left;
				}
			}

			if ( !inst.snapElements[ i ].snapping && ( ts || bs || ls || rs || first ) ) {
				( inst.options.snap.snap &&
					inst.options.snap.snap.call(
						inst.element,
						event,
						$.extend( inst._uiHash(), {
							snapItem: inst.snapElements[ i ].item
						} ) ) );
			}
			inst.snapElements[ i ].snapping = ( ts || bs || ls || rs || first );

		}

	}
} );

$.ui.plugin.add( "draggable", "stack", {
	start: function( event, ui, instance ) {
		var min,
			o = instance.options,
			group = $.makeArray( $( o.stack ) ).sort( function( a, b ) {
				return ( parseInt( $( a ).css( "zIndex" ), 10 ) || 0 ) -
					( parseInt( $( b ).css( "zIndex" ), 10 ) || 0 );
			} );

		if ( !group.length ) { return; }

		min = parseInt( $( group[ 0 ] ).css( "zIndex" ), 10 ) || 0;
		$( group ).each( function( i ) {
			$( this ).css( "zIndex", min + i );
		} );
		this.css( "zIndex", ( min + group.length ) );
	}
} );

$.ui.plugin.add( "draggable", "zIndex", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;

		if ( t.css( "zIndex" ) ) {
			o._zIndex = t.css( "zIndex" );
		}
		t.css( "zIndex", o.zIndex );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;

		if ( o._zIndex ) {
			$( ui.helper ).css( "zIndex", o._zIndex );
		}
	}
} );

var widgetsDraggable = $.ui.draggable;


/*!
 * jQuery UI Droppable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Droppable
//>>group: Interactions
//>>description: Enables drop targets for draggable elements.
//>>docs: http://api.jqueryui.com/droppable/
//>>demos: http://jqueryui.com/droppable/



$.widget( "ui.droppable", {
	version: "1.12.1",
	widgetEventPrefix: "drop",
	options: {
		accept: "*",
		addClasses: true,
		greedy: false,
		scope: "default",
		tolerance: "intersect",

		// Callbacks
		activate: null,
		deactivate: null,
		drop: null,
		out: null,
		over: null
	},
	_create: function() {

		var proportions,
			o = this.options,
			accept = o.accept;

		this.isover = false;
		this.isout = true;

		this.accept = $.isFunction( accept ) ? accept : function( d ) {
			return d.is( accept );
		};

		this.proportions = function( /* valueToWrite */ ) {
			if ( arguments.length ) {

				// Store the droppable's proportions
				proportions = arguments[ 0 ];
			} else {

				// Retrieve or derive the droppable's proportions
				return proportions ?
					proportions :
					proportions = {
						width: this.element[ 0 ].offsetWidth,
						height: this.element[ 0 ].offsetHeight
					};
			}
		};

		this._addToManager( o.scope );

		o.addClasses && this._addClass( "ui-droppable" );

	},

	_addToManager: function( scope ) {

		// Add the reference and positions to the manager
		$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
		$.ui.ddmanager.droppables[ scope ].push( this );
	},

	_splice: function( drop ) {
		var i = 0;
		for ( ; i < drop.length; i++ ) {
			if ( drop[ i ] === this ) {
				drop.splice( i, 1 );
			}
		}
	},

	_destroy: function() {
		var drop = $.ui.ddmanager.droppables[ this.options.scope ];

		this._splice( drop );
	},

	_setOption: function( key, value ) {

		if ( key === "accept" ) {
			this.accept = $.isFunction( value ) ? value : function( d ) {
				return d.is( value );
			};
		} else if ( key === "scope" ) {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];

			this._splice( drop );
			this._addToManager( value );
		}

		this._super( key, value );
	},

	_activate: function( event ) {
		var draggable = $.ui.ddmanager.current;

		this._addActiveClass();
		if ( draggable ) {
			this._trigger( "activate", event, this.ui( draggable ) );
		}
	},

	_deactivate: function( event ) {
		var draggable = $.ui.ddmanager.current;

		this._removeActiveClass();
		if ( draggable ) {
			this._trigger( "deactivate", event, this.ui( draggable ) );
		}
	},

	_over: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
			this._addHoverClass();
			this._trigger( "over", event, this.ui( draggable ) );
		}

	},

	_out: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
			this._removeHoverClass();
			this._trigger( "out", event, this.ui( draggable ) );
		}

	},

	_drop: function( event, custom ) {

		var draggable = custom || $.ui.ddmanager.current,
			childrenIntersection = false;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return false;
		}

		this.element
			.find( ":data(ui-droppable)" )
			.not( ".ui-draggable-dragging" )
			.each( function() {
				var inst = $( this ).droppable( "instance" );
				if (
					inst.options.greedy &&
					!inst.options.disabled &&
					inst.options.scope === draggable.options.scope &&
					inst.accept.call(
						inst.element[ 0 ], ( draggable.currentItem || draggable.element )
					) &&
					intersect(
						draggable,
						$.extend( inst, { offset: inst.element.offset() } ),
						inst.options.tolerance, event
					)
				) {
					childrenIntersection = true;
					return false; }
			} );
		if ( childrenIntersection ) {
			return false;
		}

		if ( this.accept.call( this.element[ 0 ],
				( draggable.currentItem || draggable.element ) ) ) {
			this._removeActiveClass();
			this._removeHoverClass();

			this._trigger( "drop", event, this.ui( draggable ) );
			return this.element;
		}

		return false;

	},

	ui: function( c ) {
		return {
			draggable: ( c.currentItem || c.element ),
			helper: c.helper,
			position: c.position,
			offset: c.positionAbs
		};
	},

	// Extension points just to make backcompat sane and avoid duplicating logic
	// TODO: Remove in 1.13 along with call to it below
	_addHoverClass: function() {
		this._addClass( "ui-droppable-hover" );
	},

	_removeHoverClass: function() {
		this._removeClass( "ui-droppable-hover" );
	},

	_addActiveClass: function() {
		this._addClass( "ui-droppable-active" );
	},

	_removeActiveClass: function() {
		this._removeClass( "ui-droppable-active" );
	}
} );

var intersect = $.ui.intersect = ( function() {
	function isOverAxis( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	}

	return function( draggable, droppable, toleranceMode, event ) {

		if ( !droppable.offset ) {
			return false;
		}

		var x1 = ( draggable.positionAbs ||
				draggable.position.absolute ).left + draggable.margins.left,
			y1 = ( draggable.positionAbs ||
				draggable.position.absolute ).top + draggable.margins.top,
			x2 = x1 + draggable.helperProportions.width,
			y2 = y1 + draggable.helperProportions.height,
			l = droppable.offset.left,
			t = droppable.offset.top,
			r = l + droppable.proportions().width,
			b = t + droppable.proportions().height;

		switch ( toleranceMode ) {
		case "fit":
			return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
		case "intersect":
			return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
				x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
		case "pointer":
			return isOverAxis( event.pageY, t, droppable.proportions().height ) &&
				isOverAxis( event.pageX, l, droppable.proportions().width );
		case "touch":
			return (
				( y1 >= t && y1 <= b ) || // Top edge touching
				( y2 >= t && y2 <= b ) || // Bottom edge touching
				( y1 < t && y2 > b ) // Surrounded vertically
			) && (
				( x1 >= l && x1 <= r ) || // Left edge touching
				( x2 >= l && x2 <= r ) || // Right edge touching
				( x1 < l && x2 > r ) // Surrounded horizontally
			);
		default:
			return false;
		}
	};
} )();

/*
	This manager tracks offsets of draggables and droppables
*/
$.ui.ddmanager = {
	current: null,
	droppables: { "default": [] },
	prepareOffsets: function( t, event ) {

		var i, j,
			m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
			type = event ? event.type : null, // workaround for #2317
			list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();

		droppablesLoop: for ( i = 0; i < m.length; i++ ) {

			// No disabled and non-accepted
			if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ],
					( t.currentItem || t.element ) ) ) ) {
				continue;
			}

			// Filter out elements in the current dragged item
			for ( j = 0; j < list.length; j++ ) {
				if ( list[ j ] === m[ i ].element[ 0 ] ) {
					m[ i ].proportions().height = 0;
					continue droppablesLoop;
				}
			}

			m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
			if ( !m[ i ].visible ) {
				continue;
			}

			// Activate the droppable if used directly from draggables
			if ( type === "mousedown" ) {
				m[ i ]._activate.call( m[ i ], event );
			}

			m[ i ].offset = m[ i ].element.offset();
			m[ i ].proportions( {
				width: m[ i ].element[ 0 ].offsetWidth,
				height: m[ i ].element[ 0 ].offsetHeight
			} );

		}

	},
	drop: function( draggable, event ) {

		var dropped = false;

		// Create a copy of the droppables in case the list changes during the drop (#9116)
		$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {

			if ( !this.options ) {
				return;
			}
			if ( !this.options.disabled && this.visible &&
					intersect( draggable, this, this.options.tolerance, event ) ) {
				dropped = this._drop.call( this, event ) || dropped;
			}

			if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ],
					( draggable.currentItem || draggable.element ) ) ) {
				this.isout = true;
				this.isover = false;
				this._deactivate.call( this, event );
			}

		} );
		return dropped;

	},
	dragStart: function( draggable, event ) {

		// Listen for scrolling so that if the dragging causes scrolling the position of the
		// droppables can be recalculated (see #5003)
		draggable.element.parentsUntil( "body" ).on( "scroll.droppable", function() {
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		} );
	},
	drag: function( draggable, event ) {

		// If you have a highly dynamic page, you might try this option. It renders positions
		// every time you move the mouse.
		if ( draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}

		// Run through all droppables and check their positions based on specific tolerance options
		$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {

			if ( this.options.disabled || this.greedyChild || !this.visible ) {
				return;
			}

			var parentInstance, scope, parent,
				intersects = intersect( draggable, this, this.options.tolerance, event ),
				c = !intersects && this.isover ?
					"isout" :
					( intersects && !this.isover ? "isover" : null );
			if ( !c ) {
				return;
			}

			if ( this.options.greedy ) {

				// find droppable parents with same scope
				scope = this.options.scope;
				parent = this.element.parents( ":data(ui-droppable)" ).filter( function() {
					return $( this ).droppable( "instance" ).options.scope === scope;
				} );

				if ( parent.length ) {
					parentInstance = $( parent[ 0 ] ).droppable( "instance" );
					parentInstance.greedyChild = ( c === "isover" );
				}
			}

			// We just moved into a greedy child
			if ( parentInstance && c === "isover" ) {
				parentInstance.isover = false;
				parentInstance.isout = true;
				parentInstance._out.call( parentInstance, event );
			}

			this[ c ] = true;
			this[ c === "isout" ? "isover" : "isout" ] = false;
			this[ c === "isover" ? "_over" : "_out" ].call( this, event );

			// We just moved out of a greedy child
			if ( parentInstance && c === "isout" ) {
				parentInstance.isout = false;
				parentInstance.isover = true;
				parentInstance._over.call( parentInstance, event );
			}
		} );

	},
	dragStop: function( draggable, event ) {
		draggable.element.parentsUntil( "body" ).off( "scroll.droppable" );

		// Call prepareOffsets one final time since IE does not fire return scroll events when
		// overflow was caused by drag (see #5003)
		if ( !draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}
	}
};

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for activeClass and hoverClass options
	$.widget( "ui.droppable", $.ui.droppable, {
		options: {
			hoverClass: false,
			activeClass: false
		},
		_addActiveClass: function() {
			this._super();
			if ( this.options.activeClass ) {
				this.element.addClass( this.options.activeClass );
			}
		},
		_removeActiveClass: function() {
			this._super();
			if ( this.options.activeClass ) {
				this.element.removeClass( this.options.activeClass );
			}
		},
		_addHoverClass: function() {
			this._super();
			if ( this.options.hoverClass ) {
				this.element.addClass( this.options.hoverClass );
			}
		},
		_removeHoverClass: function() {
			this._super();
			if ( this.options.hoverClass ) {
				this.element.removeClass( this.options.hoverClass );
			}
		}
	} );
}

var widgetsDroppable = $.ui.droppable;


/*!
 * jQuery UI Resizable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Resizable
//>>group: Interactions
//>>description: Enables resize functionality for any element.
//>>docs: http://api.jqueryui.com/resizable/
//>>demos: http://jqueryui.com/resizable/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/resizable.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.resizable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "resize",
	options: {
		alsoResize: false,
		animate: false,
		animateDuration: "slow",
		animateEasing: "swing",
		aspectRatio: false,
		autoHide: false,
		classes: {
			"ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"
		},
		containment: false,
		ghost: false,
		grid: false,
		handles: "e,s,se",
		helper: false,
		maxHeight: null,
		maxWidth: null,
		minHeight: 10,
		minWidth: 10,

		// See #7960
		zIndex: 90,

		// Callbacks
		resize: null,
		start: null,
		stop: null
	},

	_num: function( value ) {
		return parseFloat( value ) || 0;
	},

	_isNumber: function( value ) {
		return !isNaN( parseFloat( value ) );
	},

	_hasScroll: function( el, a ) {

		if ( $( el ).css( "overflow" ) === "hidden" ) {
			return false;
		}

		var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
			has = false;

		if ( el[ scroll ] > 0 ) {
			return true;
		}

		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		el[ scroll ] = 1;
		has = ( el[ scroll ] > 0 );
		el[ scroll ] = 0;
		return has;
	},

	_create: function() {

		var margins,
			o = this.options,
			that = this;
		this._addClass( "ui-resizable" );

		$.extend( this, {
			_aspectRatio: !!( o.aspectRatio ),
			aspectRatio: o.aspectRatio,
			originalElement: this.element,
			_proportionallyResizeElements: [],
			_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
		} );

		// Wrap the element if it cannot hold child nodes
		if ( this.element[ 0 ].nodeName.match( /^(canvas|textarea|input|select|button|img)$/i ) ) {

			this.element.wrap(
				$( "<div class='ui-wrapper' style='overflow: hidden;'></div>" ).css( {
					position: this.element.css( "position" ),
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					top: this.element.css( "top" ),
					left: this.element.css( "left" )
				} )
			);

			this.element = this.element.parent().data(
				"ui-resizable", this.element.resizable( "instance" )
			);

			this.elementIsWrapper = true;

			margins = {
				marginTop: this.originalElement.css( "marginTop" ),
				marginRight: this.originalElement.css( "marginRight" ),
				marginBottom: this.originalElement.css( "marginBottom" ),
				marginLeft: this.originalElement.css( "marginLeft" )
			};

			this.element.css( margins );
			this.originalElement.css( "margin", 0 );

			// support: Safari
			// Prevent Safari textarea resize
			this.originalResizeStyle = this.originalElement.css( "resize" );
			this.originalElement.css( "resize", "none" );

			this._proportionallyResizeElements.push( this.originalElement.css( {
				position: "static",
				zoom: 1,
				display: "block"
			} ) );

			// Support: IE9
			// avoid IE jump (hard set the margin)
			this.originalElement.css( margins );

			this._proportionallyResize();
		}

		this._setupHandles();

		if ( o.autoHide ) {
			$( this.element )
				.on( "mouseenter", function() {
					if ( o.disabled ) {
						return;
					}
					that._removeClass( "ui-resizable-autohide" );
					that._handles.show();
				} )
				.on( "mouseleave", function() {
					if ( o.disabled ) {
						return;
					}
					if ( !that.resizing ) {
						that._addClass( "ui-resizable-autohide" );
						that._handles.hide();
					}
				} );
		}

		this._mouseInit();
	},

	_destroy: function() {

		this._mouseDestroy();

		var wrapper,
			_destroy = function( exp ) {
				$( exp )
					.removeData( "resizable" )
					.removeData( "ui-resizable" )
					.off( ".resizable" )
					.find( ".ui-resizable-handle" )
						.remove();
			};

		// TODO: Unwrap at same DOM position
		if ( this.elementIsWrapper ) {
			_destroy( this.element );
			wrapper = this.element;
			this.originalElement.css( {
				position: wrapper.css( "position" ),
				width: wrapper.outerWidth(),
				height: wrapper.outerHeight(),
				top: wrapper.css( "top" ),
				left: wrapper.css( "left" )
			} ).insertAfter( wrapper );
			wrapper.remove();
		}

		this.originalElement.css( "resize", this.originalResizeStyle );
		_destroy( this.originalElement );

		return this;
	},

	_setOption: function( key, value ) {
		this._super( key, value );

		switch ( key ) {
		case "handles":
			this._removeHandles();
			this._setupHandles();
			break;
		default:
			break;
		}
	},

	_setupHandles: function() {
		var o = this.options, handle, i, n, hname, axis, that = this;
		this.handles = o.handles ||
			( !$( ".ui-resizable-handle", this.element ).length ?
				"e,s,se" : {
					n: ".ui-resizable-n",
					e: ".ui-resizable-e",
					s: ".ui-resizable-s",
					w: ".ui-resizable-w",
					se: ".ui-resizable-se",
					sw: ".ui-resizable-sw",
					ne: ".ui-resizable-ne",
					nw: ".ui-resizable-nw"
				} );

		this._handles = $();
		if ( this.handles.constructor === String ) {

			if ( this.handles === "all" ) {
				this.handles = "n,e,s,w,se,sw,ne,nw";
			}

			n = this.handles.split( "," );
			this.handles = {};

			for ( i = 0; i < n.length; i++ ) {

				handle = $.trim( n[ i ] );
				hname = "ui-resizable-" + handle;
				axis = $( "<div>" );
				this._addClass( axis, "ui-resizable-handle " + hname );

				axis.css( { zIndex: o.zIndex } );

				this.handles[ handle ] = ".ui-resizable-" + handle;
				this.element.append( axis );
			}

		}

		this._renderAxis = function( target ) {

			var i, axis, padPos, padWrapper;

			target = target || this.element;

			for ( i in this.handles ) {

				if ( this.handles[ i ].constructor === String ) {
					this.handles[ i ] = this.element.children( this.handles[ i ] ).first().show();
				} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
					this.handles[ i ] = $( this.handles[ i ] );
					this._on( this.handles[ i ], { "mousedown": that._mouseDown } );
				}

				if ( this.elementIsWrapper &&
						this.originalElement[ 0 ]
							.nodeName
							.match( /^(textarea|input|select|button)$/i ) ) {
					axis = $( this.handles[ i ], this.element );

					padWrapper = /sw|ne|nw|se|n|s/.test( i ) ?
						axis.outerHeight() :
						axis.outerWidth();

					padPos = [ "padding",
						/ne|nw|n/.test( i ) ? "Top" :
						/se|sw|s/.test( i ) ? "Bottom" :
						/^e$/.test( i ) ? "Right" : "Left" ].join( "" );

					target.css( padPos, padWrapper );

					this._proportionallyResize();
				}

				this._handles = this._handles.add( this.handles[ i ] );
			}
		};

		// TODO: make renderAxis a prototype function
		this._renderAxis( this.element );

		this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
		this._handles.disableSelection();

		this._handles.on( "mouseover", function() {
			if ( !that.resizing ) {
				if ( this.className ) {
					axis = this.className.match( /ui-resizable-(se|sw|ne|nw|n|e|s|w)/i );
				}
				that.axis = axis && axis[ 1 ] ? axis[ 1 ] : "se";
			}
		} );

		if ( o.autoHide ) {
			this._handles.hide();
			this._addClass( "ui-resizable-autohide" );
		}
	},

	_removeHandles: function() {
		this._handles.remove();
	},

	_mouseCapture: function( event ) {
		var i, handle,
			capture = false;

		for ( i in this.handles ) {
			handle = $( this.handles[ i ] )[ 0 ];
			if ( handle === event.target || $.contains( handle, event.target ) ) {
				capture = true;
			}
		}

		return !this.options.disabled && capture;
	},

	_mouseStart: function( event ) {

		var curleft, curtop, cursor,
			o = this.options,
			el = this.element;

		this.resizing = true;

		this._renderProxy();

		curleft = this._num( this.helper.css( "left" ) );
		curtop = this._num( this.helper.css( "top" ) );

		if ( o.containment ) {
			curleft += $( o.containment ).scrollLeft() || 0;
			curtop += $( o.containment ).scrollTop() || 0;
		}

		this.offset = this.helper.offset();
		this.position = { left: curleft, top: curtop };

		this.size = this._helper ? {
				width: this.helper.width(),
				height: this.helper.height()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.originalSize = this._helper ? {
				width: el.outerWidth(),
				height: el.outerHeight()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.sizeDiff = {
			width: el.outerWidth() - el.width(),
			height: el.outerHeight() - el.height()
		};

		this.originalPosition = { left: curleft, top: curtop };
		this.originalMousePosition = { left: event.pageX, top: event.pageY };

		this.aspectRatio = ( typeof o.aspectRatio === "number" ) ?
			o.aspectRatio :
			( ( this.originalSize.width / this.originalSize.height ) || 1 );

		cursor = $( ".ui-resizable-" + this.axis ).css( "cursor" );
		$( "body" ).css( "cursor", cursor === "auto" ? this.axis + "-resize" : cursor );

		this._addClass( "ui-resizable-resizing" );
		this._propagate( "start", event );
		return true;
	},

	_mouseDrag: function( event ) {

		var data, props,
			smp = this.originalMousePosition,
			a = this.axis,
			dx = ( event.pageX - smp.left ) || 0,
			dy = ( event.pageY - smp.top ) || 0,
			trigger = this._change[ a ];

		this._updatePrevProperties();

		if ( !trigger ) {
			return false;
		}

		data = trigger.apply( this, [ event, dx, dy ] );

		this._updateVirtualBoundaries( event.shiftKey );
		if ( this._aspectRatio || event.shiftKey ) {
			data = this._updateRatio( data, event );
		}

		data = this._respectSize( data, event );

		this._updateCache( data );

		this._propagate( "resize", event );

		props = this._applyChanges();

		if ( !this._helper && this._proportionallyResizeElements.length ) {
			this._proportionallyResize();
		}

		if ( !$.isEmptyObject( props ) ) {
			this._updatePrevProperties();
			this._trigger( "resize", event, this.ui() );
			this._applyChanges();
		}

		return false;
	},

	_mouseStop: function( event ) {

		this.resizing = false;
		var pr, ista, soffseth, soffsetw, s, left, top,
			o = this.options, that = this;

		if ( this._helper ) {

			pr = this._proportionallyResizeElements;
			ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName );
			soffseth = ista && this._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height;
			soffsetw = ista ? 0 : that.sizeDiff.width;

			s = {
				width: ( that.helper.width()  - soffsetw ),
				height: ( that.helper.height() - soffseth )
			};
			left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null;
			top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

			if ( !o.animate ) {
				this.element.css( $.extend( s, { top: top, left: left } ) );
			}

			that.helper.height( that.size.height );
			that.helper.width( that.size.width );

			if ( this._helper && !o.animate ) {
				this._proportionallyResize();
			}
		}

		$( "body" ).css( "cursor", "auto" );

		this._removeClass( "ui-resizable-resizing" );

		this._propagate( "stop", event );

		if ( this._helper ) {
			this.helper.remove();
		}

		return false;

	},

	_updatePrevProperties: function() {
		this.prevPosition = {
			top: this.position.top,
			left: this.position.left
		};
		this.prevSize = {
			width: this.size.width,
			height: this.size.height
		};
	},

	_applyChanges: function() {
		var props = {};

		if ( this.position.top !== this.prevPosition.top ) {
			props.top = this.position.top + "px";
		}
		if ( this.position.left !== this.prevPosition.left ) {
			props.left = this.position.left + "px";
		}
		if ( this.size.width !== this.prevSize.width ) {
			props.width = this.size.width + "px";
		}
		if ( this.size.height !== this.prevSize.height ) {
			props.height = this.size.height + "px";
		}

		this.helper.css( props );

		return props;
	},

	_updateVirtualBoundaries: function( forceAspectRatio ) {
		var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
			o = this.options;

		b = {
			minWidth: this._isNumber( o.minWidth ) ? o.minWidth : 0,
			maxWidth: this._isNumber( o.maxWidth ) ? o.maxWidth : Infinity,
			minHeight: this._isNumber( o.minHeight ) ? o.minHeight : 0,
			maxHeight: this._isNumber( o.maxHeight ) ? o.maxHeight : Infinity
		};

		if ( this._aspectRatio || forceAspectRatio ) {
			pMinWidth = b.minHeight * this.aspectRatio;
			pMinHeight = b.minWidth / this.aspectRatio;
			pMaxWidth = b.maxHeight * this.aspectRatio;
			pMaxHeight = b.maxWidth / this.aspectRatio;

			if ( pMinWidth > b.minWidth ) {
				b.minWidth = pMinWidth;
			}
			if ( pMinHeight > b.minHeight ) {
				b.minHeight = pMinHeight;
			}
			if ( pMaxWidth < b.maxWidth ) {
				b.maxWidth = pMaxWidth;
			}
			if ( pMaxHeight < b.maxHeight ) {
				b.maxHeight = pMaxHeight;
			}
		}
		this._vBoundaries = b;
	},

	_updateCache: function( data ) {
		this.offset = this.helper.offset();
		if ( this._isNumber( data.left ) ) {
			this.position.left = data.left;
		}
		if ( this._isNumber( data.top ) ) {
			this.position.top = data.top;
		}
		if ( this._isNumber( data.height ) ) {
			this.size.height = data.height;
		}
		if ( this._isNumber( data.width ) ) {
			this.size.width = data.width;
		}
	},

	_updateRatio: function( data ) {

		var cpos = this.position,
			csize = this.size,
			a = this.axis;

		if ( this._isNumber( data.height ) ) {
			data.width = ( data.height * this.aspectRatio );
		} else if ( this._isNumber( data.width ) ) {
			data.height = ( data.width / this.aspectRatio );
		}

		if ( a === "sw" ) {
			data.left = cpos.left + ( csize.width - data.width );
			data.top = null;
		}
		if ( a === "nw" ) {
			data.top = cpos.top + ( csize.height - data.height );
			data.left = cpos.left + ( csize.width - data.width );
		}

		return data;
	},

	_respectSize: function( data ) {

		var o = this._vBoundaries,
			a = this.axis,
			ismaxw = this._isNumber( data.width ) && o.maxWidth && ( o.maxWidth < data.width ),
			ismaxh = this._isNumber( data.height ) && o.maxHeight && ( o.maxHeight < data.height ),
			isminw = this._isNumber( data.width ) && o.minWidth && ( o.minWidth > data.width ),
			isminh = this._isNumber( data.height ) && o.minHeight && ( o.minHeight > data.height ),
			dw = this.originalPosition.left + this.originalSize.width,
			dh = this.originalPosition.top + this.originalSize.height,
			cw = /sw|nw|w/.test( a ), ch = /nw|ne|n/.test( a );
		if ( isminw ) {
			data.width = o.minWidth;
		}
		if ( isminh ) {
			data.height = o.minHeight;
		}
		if ( ismaxw ) {
			data.width = o.maxWidth;
		}
		if ( ismaxh ) {
			data.height = o.maxHeight;
		}

		if ( isminw && cw ) {
			data.left = dw - o.minWidth;
		}
		if ( ismaxw && cw ) {
			data.left = dw - o.maxWidth;
		}
		if ( isminh && ch ) {
			data.top = dh - o.minHeight;
		}
		if ( ismaxh && ch ) {
			data.top = dh - o.maxHeight;
		}

		// Fixing jump error on top/left - bug #2330
		if ( !data.width && !data.height && !data.left && data.top ) {
			data.top = null;
		} else if ( !data.width && !data.height && !data.top && data.left ) {
			data.left = null;
		}

		return data;
	},

	_getPaddingPlusBorderDimensions: function( element ) {
		var i = 0,
			widths = [],
			borders = [
				element.css( "borderTopWidth" ),
				element.css( "borderRightWidth" ),
				element.css( "borderBottomWidth" ),
				element.css( "borderLeftWidth" )
			],
			paddings = [
				element.css( "paddingTop" ),
				element.css( "paddingRight" ),
				element.css( "paddingBottom" ),
				element.css( "paddingLeft" )
			];

		for ( ; i < 4; i++ ) {
			widths[ i ] = ( parseFloat( borders[ i ] ) || 0 );
			widths[ i ] += ( parseFloat( paddings[ i ] ) || 0 );
		}

		return {
			height: widths[ 0 ] + widths[ 2 ],
			width: widths[ 1 ] + widths[ 3 ]
		};
	},

	_proportionallyResize: function() {

		if ( !this._proportionallyResizeElements.length ) {
			return;
		}

		var prel,
			i = 0,
			element = this.helper || this.element;

		for ( ; i < this._proportionallyResizeElements.length; i++ ) {

			prel = this._proportionallyResizeElements[ i ];

			// TODO: Seems like a bug to cache this.outerDimensions
			// considering that we are in a loop.
			if ( !this.outerDimensions ) {
				this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
			}

			prel.css( {
				height: ( element.height() - this.outerDimensions.height ) || 0,
				width: ( element.width() - this.outerDimensions.width ) || 0
			} );

		}

	},

	_renderProxy: function() {

		var el = this.element, o = this.options;
		this.elementOffset = el.offset();

		if ( this._helper ) {

			this.helper = this.helper || $( "<div style='overflow:hidden;'></div>" );

			this._addClass( this.helper, this._helper );
			this.helper.css( {
				width: this.element.outerWidth(),
				height: this.element.outerHeight(),
				position: "absolute",
				left: this.elementOffset.left + "px",
				top: this.elementOffset.top + "px",
				zIndex: ++o.zIndex //TODO: Don't modify option
			} );

			this.helper
				.appendTo( "body" )
				.disableSelection();

		} else {
			this.helper = this.element;
		}

	},

	_change: {
		e: function( event, dx ) {
			return { width: this.originalSize.width + dx };
		},
		w: function( event, dx ) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { left: sp.left + dx, width: cs.width - dx };
		},
		n: function( event, dx, dy ) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { top: sp.top + dy, height: cs.height - dy };
		},
		s: function( event, dx, dy ) {
			return { height: this.originalSize.height + dy };
		},
		se: function( event, dx, dy ) {
			return $.extend( this._change.s.apply( this, arguments ),
				this._change.e.apply( this, [ event, dx, dy ] ) );
		},
		sw: function( event, dx, dy ) {
			return $.extend( this._change.s.apply( this, arguments ),
				this._change.w.apply( this, [ event, dx, dy ] ) );
		},
		ne: function( event, dx, dy ) {
			return $.extend( this._change.n.apply( this, arguments ),
				this._change.e.apply( this, [ event, dx, dy ] ) );
		},
		nw: function( event, dx, dy ) {
			return $.extend( this._change.n.apply( this, arguments ),
				this._change.w.apply( this, [ event, dx, dy ] ) );
		}
	},

	_propagate: function( n, event ) {
		$.ui.plugin.call( this, n, [ event, this.ui() ] );
		( n !== "resize" && this._trigger( n, event, this.ui() ) );
	},

	plugins: {},

	ui: function() {
		return {
			originalElement: this.originalElement,
			element: this.element,
			helper: this.helper,
			position: this.position,
			size: this.size,
			originalSize: this.originalSize,
			originalPosition: this.originalPosition
		};
	}

} );

/*
 * Resizable Extensions
 */

$.ui.plugin.add( "resizable", "animate", {

	stop: function( event ) {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			pr = that._proportionallyResizeElements,
			ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName ),
			soffseth = ista && that._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height,
			soffsetw = ista ? 0 : that.sizeDiff.width,
			style = {
				width: ( that.size.width - soffsetw ),
				height: ( that.size.height - soffseth )
			},
			left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null,
			top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

		that.element.animate(
			$.extend( style, top && left ? { top: top, left: left } : {} ), {
				duration: o.animateDuration,
				easing: o.animateEasing,
				step: function() {

					var data = {
						width: parseFloat( that.element.css( "width" ) ),
						height: parseFloat( that.element.css( "height" ) ),
						top: parseFloat( that.element.css( "top" ) ),
						left: parseFloat( that.element.css( "left" ) )
					};

					if ( pr && pr.length ) {
						$( pr[ 0 ] ).css( { width: data.width, height: data.height } );
					}

					// Propagating resize, and updating values for each animation step
					that._updateCache( data );
					that._propagate( "resize", event );

				}
			}
		);
	}

} );

$.ui.plugin.add( "resizable", "containment", {

	start: function() {
		var element, p, co, ch, cw, width, height,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			el = that.element,
			oc = o.containment,
			ce = ( oc instanceof $ ) ?
				oc.get( 0 ) :
				( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;

		if ( !ce ) {
			return;
		}

		that.containerElement = $( ce );

		if ( /document/.test( oc ) || oc === document ) {
			that.containerOffset = {
				left: 0,
				top: 0
			};
			that.containerPosition = {
				left: 0,
				top: 0
			};

			that.parentData = {
				element: $( document ),
				left: 0,
				top: 0,
				width: $( document ).width(),
				height: $( document ).height() || document.body.parentNode.scrollHeight
			};
		} else {
			element = $( ce );
			p = [];
			$( [ "Top", "Right", "Left", "Bottom" ] ).each( function( i, name ) {
				p[ i ] = that._num( element.css( "padding" + name ) );
			} );

			that.containerOffset = element.offset();
			that.containerPosition = element.position();
			that.containerSize = {
				height: ( element.innerHeight() - p[ 3 ] ),
				width: ( element.innerWidth() - p[ 1 ] )
			};

			co = that.containerOffset;
			ch = that.containerSize.height;
			cw = that.containerSize.width;
			width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
			height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;

			that.parentData = {
				element: ce,
				left: co.left,
				top: co.top,
				width: width,
				height: height
			};
		}
	},

	resize: function( event ) {
		var woset, hoset, isParent, isOffsetRelative,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cp = that.position,
			pRatio = that._aspectRatio || event.shiftKey,
			cop = {
				top: 0,
				left: 0
			},
			ce = that.containerElement,
			continueResize = true;

		if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
			cop = co;
		}

		if ( cp.left < ( that._helper ? co.left : 0 ) ) {
			that.size.width = that.size.width +
				( that._helper ?
					( that.position.left - co.left ) :
					( that.position.left - cop.left ) );

			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
			that.position.left = o.helper ? co.left : 0;
		}

		if ( cp.top < ( that._helper ? co.top : 0 ) ) {
			that.size.height = that.size.height +
				( that._helper ?
					( that.position.top - co.top ) :
					that.position.top );

			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
			that.position.top = that._helper ? co.top : 0;
		}

		isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
		isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );

		if ( isParent && isOffsetRelative ) {
			that.offset.left = that.parentData.left + that.position.left;
			that.offset.top = that.parentData.top + that.position.top;
		} else {
			that.offset.left = that.element.offset().left;
			that.offset.top = that.element.offset().top;
		}

		woset = Math.abs( that.sizeDiff.width +
			( that._helper ?
				that.offset.left - cop.left :
				( that.offset.left - co.left ) ) );

		hoset = Math.abs( that.sizeDiff.height +
			( that._helper ?
				that.offset.top - cop.top :
				( that.offset.top - co.top ) ) );

		if ( woset + that.size.width >= that.parentData.width ) {
			that.size.width = that.parentData.width - woset;
			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
		}

		if ( hoset + that.size.height >= that.parentData.height ) {
			that.size.height = that.parentData.height - hoset;
			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
		}

		if ( !continueResize ) {
			that.position.left = that.prevPosition.left;
			that.position.top = that.prevPosition.top;
			that.size.width = that.prevSize.width;
			that.size.height = that.prevSize.height;
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cop = that.containerPosition,
			ce = that.containerElement,
			helper = $( that.helper ),
			ho = helper.offset(),
			w = helper.outerWidth() - that.sizeDiff.width,
			h = helper.outerHeight() - that.sizeDiff.height;

		if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
			$( this ).css( {
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			} );
		}

		if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
			$( this ).css( {
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			} );
		}
	}
} );

$.ui.plugin.add( "resizable", "alsoResize", {

	start: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options;

		$( o.alsoResize ).each( function() {
			var el = $( this );
			el.data( "ui-resizable-alsoresize", {
				width: parseFloat( el.width() ), height: parseFloat( el.height() ),
				left: parseFloat( el.css( "left" ) ), top: parseFloat( el.css( "top" ) )
			} );
		} );
	},

	resize: function( event, ui ) {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			os = that.originalSize,
			op = that.originalPosition,
			delta = {
				height: ( that.size.height - os.height ) || 0,
				width: ( that.size.width - os.width ) || 0,
				top: ( that.position.top - op.top ) || 0,
				left: ( that.position.left - op.left ) || 0
			};

			$( o.alsoResize ).each( function() {
				var el = $( this ), start = $( this ).data( "ui-resizable-alsoresize" ), style = {},
					css = el.parents( ui.originalElement[ 0 ] ).length ?
							[ "width", "height" ] :
							[ "width", "height", "top", "left" ];

				$.each( css, function( i, prop ) {
					var sum = ( start[ prop ] || 0 ) + ( delta[ prop ] || 0 );
					if ( sum && sum >= 0 ) {
						style[ prop ] = sum || null;
					}
				} );

				el.css( style );
			} );
	},

	stop: function() {
		$( this ).removeData( "ui-resizable-alsoresize" );
	}
} );

$.ui.plugin.add( "resizable", "ghost", {

	start: function() {

		var that = $( this ).resizable( "instance" ), cs = that.size;

		that.ghost = that.originalElement.clone();
		that.ghost.css( {
			opacity: 0.25,
			display: "block",
			position: "relative",
			height: cs.height,
			width: cs.width,
			margin: 0,
			left: 0,
			top: 0
		} );

		that._addClass( that.ghost, "ui-resizable-ghost" );

		// DEPRECATED
		// TODO: remove after 1.12
		if ( $.uiBackCompat !== false && typeof that.options.ghost === "string" ) {

			// Ghost option
			that.ghost.addClass( this.options.ghost );
		}

		that.ghost.appendTo( that.helper );

	},

	resize: function() {
		var that = $( this ).resizable( "instance" );
		if ( that.ghost ) {
			that.ghost.css( {
				position: "relative",
				height: that.size.height,
				width: that.size.width
			} );
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" );
		if ( that.ghost && that.helper ) {
			that.helper.get( 0 ).removeChild( that.ghost.get( 0 ) );
		}
	}

} );

$.ui.plugin.add( "resizable", "grid", {

	resize: function() {
		var outerDimensions,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			cs = that.size,
			os = that.originalSize,
			op = that.originalPosition,
			a = that.axis,
			grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
			gridX = ( grid[ 0 ] || 1 ),
			gridY = ( grid[ 1 ] || 1 ),
			ox = Math.round( ( cs.width - os.width ) / gridX ) * gridX,
			oy = Math.round( ( cs.height - os.height ) / gridY ) * gridY,
			newWidth = os.width + ox,
			newHeight = os.height + oy,
			isMaxWidth = o.maxWidth && ( o.maxWidth < newWidth ),
			isMaxHeight = o.maxHeight && ( o.maxHeight < newHeight ),
			isMinWidth = o.minWidth && ( o.minWidth > newWidth ),
			isMinHeight = o.minHeight && ( o.minHeight > newHeight );

		o.grid = grid;

		if ( isMinWidth ) {
			newWidth += gridX;
		}
		if ( isMinHeight ) {
			newHeight += gridY;
		}
		if ( isMaxWidth ) {
			newWidth -= gridX;
		}
		if ( isMaxHeight ) {
			newHeight -= gridY;
		}

		if ( /^(se|s|e)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
		} else if ( /^(ne)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.top = op.top - oy;
		} else if ( /^(sw)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.left = op.left - ox;
		} else {
			if ( newHeight - gridY <= 0 || newWidth - gridX <= 0 ) {
				outerDimensions = that._getPaddingPlusBorderDimensions( this );
			}

			if ( newHeight - gridY > 0 ) {
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else {
				newHeight = gridY - outerDimensions.height;
				that.size.height = newHeight;
				that.position.top = op.top + os.height - newHeight;
			}
			if ( newWidth - gridX > 0 ) {
				that.size.width = newWidth;
				that.position.left = op.left - ox;
			} else {
				newWidth = gridX - outerDimensions.width;
				that.size.width = newWidth;
				that.position.left = op.left + os.width - newWidth;
			}
		}
	}

} );

var widgetsResizable = $.ui.resizable;


/*!
 * jQuery UI Selectable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Selectable
//>>group: Interactions
//>>description: Allows groups of elements to be selected with the mouse.
//>>docs: http://api.jqueryui.com/selectable/
//>>demos: http://jqueryui.com/selectable/
//>>css.structure: ../../themes/base/selectable.css



var widgetsSelectable = $.widget( "ui.selectable", $.ui.mouse, {
	version: "1.12.1",
	options: {
		appendTo: "body",
		autoRefresh: true,
		distance: 0,
		filter: "*",
		tolerance: "touch",

		// Callbacks
		selected: null,
		selecting: null,
		start: null,
		stop: null,
		unselected: null,
		unselecting: null
	},
	_create: function() {
		var that = this;

		this._addClass( "ui-selectable" );

		this.dragged = false;

		// Cache selectee children based on filter
		this.refresh = function() {
			that.elementPos = $( that.element[ 0 ] ).offset();
			that.selectees = $( that.options.filter, that.element[ 0 ] );
			that._addClass( that.selectees, "ui-selectee" );
			that.selectees.each( function() {
				var $this = $( this ),
					selecteeOffset = $this.offset(),
					pos = {
						left: selecteeOffset.left - that.elementPos.left,
						top: selecteeOffset.top - that.elementPos.top
					};
				$.data( this, "selectable-item", {
					element: this,
					$element: $this,
					left: pos.left,
					top: pos.top,
					right: pos.left + $this.outerWidth(),
					bottom: pos.top + $this.outerHeight(),
					startselected: false,
					selected: $this.hasClass( "ui-selected" ),
					selecting: $this.hasClass( "ui-selecting" ),
					unselecting: $this.hasClass( "ui-unselecting" )
				} );
			} );
		};
		this.refresh();

		this._mouseInit();

		this.helper = $( "<div>" );
		this._addClass( this.helper, "ui-selectable-helper" );
	},

	_destroy: function() {
		this.selectees.removeData( "selectable-item" );
		this._mouseDestroy();
	},

	_mouseStart: function( event ) {
		var that = this,
			options = this.options;

		this.opos = [ event.pageX, event.pageY ];
		this.elementPos = $( this.element[ 0 ] ).offset();

		if ( this.options.disabled ) {
			return;
		}

		this.selectees = $( options.filter, this.element[ 0 ] );

		this._trigger( "start", event );

		$( options.appendTo ).append( this.helper );

		// position helper (lasso)
		this.helper.css( {
			"left": event.pageX,
			"top": event.pageY,
			"width": 0,
			"height": 0
		} );

		if ( options.autoRefresh ) {
			this.refresh();
		}

		this.selectees.filter( ".ui-selected" ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			selectee.startselected = true;
			if ( !event.metaKey && !event.ctrlKey ) {
				that._removeClass( selectee.$element, "ui-selected" );
				selectee.selected = false;
				that._addClass( selectee.$element, "ui-unselecting" );
				selectee.unselecting = true;

				// selectable UNSELECTING callback
				that._trigger( "unselecting", event, {
					unselecting: selectee.element
				} );
			}
		} );

		$( event.target ).parents().addBack().each( function() {
			var doSelect,
				selectee = $.data( this, "selectable-item" );
			if ( selectee ) {
				doSelect = ( !event.metaKey && !event.ctrlKey ) ||
					!selectee.$element.hasClass( "ui-selected" );
				that._removeClass( selectee.$element, doSelect ? "ui-unselecting" : "ui-selected" )
					._addClass( selectee.$element, doSelect ? "ui-selecting" : "ui-unselecting" );
				selectee.unselecting = !doSelect;
				selectee.selecting = doSelect;
				selectee.selected = doSelect;

				// selectable (UN)SELECTING callback
				if ( doSelect ) {
					that._trigger( "selecting", event, {
						selecting: selectee.element
					} );
				} else {
					that._trigger( "unselecting", event, {
						unselecting: selectee.element
					} );
				}
				return false;
			}
		} );

	},

	_mouseDrag: function( event ) {

		this.dragged = true;

		if ( this.options.disabled ) {
			return;
		}

		var tmp,
			that = this,
			options = this.options,
			x1 = this.opos[ 0 ],
			y1 = this.opos[ 1 ],
			x2 = event.pageX,
			y2 = event.pageY;

		if ( x1 > x2 ) { tmp = x2; x2 = x1; x1 = tmp; }
		if ( y1 > y2 ) { tmp = y2; y2 = y1; y1 = tmp; }
		this.helper.css( { left: x1, top: y1, width: x2 - x1, height: y2 - y1 } );

		this.selectees.each( function() {
			var selectee = $.data( this, "selectable-item" ),
				hit = false,
				offset = {};

			//prevent helper from being selected if appendTo: selectable
			if ( !selectee || selectee.element === that.element[ 0 ] ) {
				return;
			}

			offset.left   = selectee.left   + that.elementPos.left;
			offset.right  = selectee.right  + that.elementPos.left;
			offset.top    = selectee.top    + that.elementPos.top;
			offset.bottom = selectee.bottom + that.elementPos.top;

			if ( options.tolerance === "touch" ) {
				hit = ( !( offset.left > x2 || offset.right < x1 || offset.top > y2 ||
                    offset.bottom < y1 ) );
			} else if ( options.tolerance === "fit" ) {
				hit = ( offset.left > x1 && offset.right < x2 && offset.top > y1 &&
                    offset.bottom < y2 );
			}

			if ( hit ) {

				// SELECT
				if ( selectee.selected ) {
					that._removeClass( selectee.$element, "ui-selected" );
					selectee.selected = false;
				}
				if ( selectee.unselecting ) {
					that._removeClass( selectee.$element, "ui-unselecting" );
					selectee.unselecting = false;
				}
				if ( !selectee.selecting ) {
					that._addClass( selectee.$element, "ui-selecting" );
					selectee.selecting = true;

					// selectable SELECTING callback
					that._trigger( "selecting", event, {
						selecting: selectee.element
					} );
				}
			} else {

				// UNSELECT
				if ( selectee.selecting ) {
					if ( ( event.metaKey || event.ctrlKey ) && selectee.startselected ) {
						that._removeClass( selectee.$element, "ui-selecting" );
						selectee.selecting = false;
						that._addClass( selectee.$element, "ui-selected" );
						selectee.selected = true;
					} else {
						that._removeClass( selectee.$element, "ui-selecting" );
						selectee.selecting = false;
						if ( selectee.startselected ) {
							that._addClass( selectee.$element, "ui-unselecting" );
							selectee.unselecting = true;
						}

						// selectable UNSELECTING callback
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
				}
				if ( selectee.selected ) {
					if ( !event.metaKey && !event.ctrlKey && !selectee.startselected ) {
						that._removeClass( selectee.$element, "ui-selected" );
						selectee.selected = false;

						that._addClass( selectee.$element, "ui-unselecting" );
						selectee.unselecting = true;

						// selectable UNSELECTING callback
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
				}
			}
		} );

		return false;
	},

	_mouseStop: function( event ) {
		var that = this;

		this.dragged = false;

		$( ".ui-unselecting", this.element[ 0 ] ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			that._removeClass( selectee.$element, "ui-unselecting" );
			selectee.unselecting = false;
			selectee.startselected = false;
			that._trigger( "unselected", event, {
				unselected: selectee.element
			} );
		} );
		$( ".ui-selecting", this.element[ 0 ] ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			that._removeClass( selectee.$element, "ui-selecting" )
				._addClass( selectee.$element, "ui-selected" );
			selectee.selecting = false;
			selectee.selected = true;
			selectee.startselected = true;
			that._trigger( "selected", event, {
				selected: selectee.element
			} );
		} );
		this._trigger( "stop", event );

		this.helper.remove();

		return false;
	}

} );


/*!
 * jQuery UI Sortable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Sortable
//>>group: Interactions
//>>description: Enables items in a list to be sorted using the mouse.
//>>docs: http://api.jqueryui.com/sortable/
//>>demos: http://jqueryui.com/sortable/
//>>css.structure: ../../themes/base/sortable.css



var widgetsSortable = $.widget( "ui.sortable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "sort",
	ready: false,
	options: {
		appendTo: "parent",
		axis: false,
		connectWith: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		dropOnEmpty: true,
		forcePlaceholderSize: false,
		forceHelperSize: false,
		grid: false,
		handle: false,
		helper: "original",
		items: "> *",
		opacity: false,
		placeholder: false,
		revert: false,
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		scope: "default",
		tolerance: "intersect",
		zIndex: 1000,

		// Callbacks
		activate: null,
		beforeStop: null,
		change: null,
		deactivate: null,
		out: null,
		over: null,
		receive: null,
		remove: null,
		sort: null,
		start: null,
		stop: null,
		update: null
	},

	_isOverAxis: function( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	},

	_isFloating: function( item ) {
		return ( /left|right/ ).test( item.css( "float" ) ) ||
			( /inline|table-cell/ ).test( item.css( "display" ) );
	},

	_create: function() {
		this.containerCache = {};
		this._addClass( "ui-sortable" );

		//Get the items
		this.refresh();

		//Let's determine the parent's offset
		this.offset = this.element.offset();

		//Initialize mouse events for interaction
		this._mouseInit();

		this._setHandleClassName();

		//We're ready to go
		this.ready = true;

	},

	_setOption: function( key, value ) {
		this._super( key, value );

		if ( key === "handle" ) {
			this._setHandleClassName();
		}
	},

	_setHandleClassName: function() {
		var that = this;
		this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
		$.each( this.items, function() {
			that._addClass(
				this.instance.options.handle ?
					this.item.find( this.instance.options.handle ) :
					this.item,
				"ui-sortable-handle"
			);
		} );
	},

	_destroy: function() {
		this._mouseDestroy();

		for ( var i = this.items.length - 1; i >= 0; i-- ) {
			this.items[ i ].item.removeData( this.widgetName + "-item" );
		}

		return this;
	},

	_mouseCapture: function( event, overrideHandle ) {
		var currentItem = null,
			validHandle = false,
			that = this;

		if ( this.reverting ) {
			return false;
		}

		if ( this.options.disabled || this.options.type === "static" ) {
			return false;
		}

		//We have to refresh the items data once first
		this._refreshItems( event );

		//Find out if the clicked node (or one of its parents) is a actual item in this.items
		$( event.target ).parents().each( function() {
			if ( $.data( this, that.widgetName + "-item" ) === that ) {
				currentItem = $( this );
				return false;
			}
		} );
		if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
			currentItem = $( event.target );
		}

		if ( !currentItem ) {
			return false;
		}
		if ( this.options.handle && !overrideHandle ) {
			$( this.options.handle, currentItem ).find( "*" ).addBack().each( function() {
				if ( this === event.target ) {
					validHandle = true;
				}
			} );
			if ( !validHandle ) {
				return false;
			}
		}

		this.currentItem = currentItem;
		this._removeCurrentsFromItems();
		return true;

	},

	_mouseStart: function( event, overrideHandle, noActivation ) {

		var i, body,
			o = this.options;

		this.currentContainer = this;

		//We only need to call refreshPositions, because the refreshItems call has been moved to
		// mouseCapture
		this.refreshPositions();

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		//Cache the helper size
		this._cacheHelperProportions();

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Get the next scrolling parent
		this.scrollParent = this.helper.scrollParent();

		//The element's absolute position on the page minus margins
		this.offset = this.currentItem.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		$.extend( this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},
			parent: this._getParentOffset(),

			// This is a relative to absolute position minus the actual position calculation -
			// only used for relative positioned helper
			relative: this._getRelativeOffset()
		} );

		// Only after we got the offset, we can change the helper's position to absolute
		// TODO: Still need to figure out a way to make relative sorting possible
		this.helper.css( "position", "absolute" );
		this.cssPosition = this.helper.css( "position" );

		//Generate the original position
		this.originalPosition = this._generatePosition( event );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );

		//Cache the former DOM position
		this.domPosition = {
			prev: this.currentItem.prev()[ 0 ],
			parent: this.currentItem.parent()[ 0 ]
		};

		// If the helper is not the original, hide the original so it's not playing any role during
		// the drag, won't cause anything bad this way
		if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
			this.currentItem.hide();
		}

		//Create the placeholder
		this._createPlaceholder();

		//Set a containment if given in the options
		if ( o.containment ) {
			this._setContainment();
		}

		if ( o.cursor && o.cursor !== "auto" ) { // cursor option
			body = this.document.find( "body" );

			// Support: IE
			this.storedCursor = body.css( "cursor" );
			body.css( "cursor", o.cursor );

			this.storedStylesheet =
				$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
		}

		if ( o.opacity ) { // opacity option
			if ( this.helper.css( "opacity" ) ) {
				this._storedOpacity = this.helper.css( "opacity" );
			}
			this.helper.css( "opacity", o.opacity );
		}

		if ( o.zIndex ) { // zIndex option
			if ( this.helper.css( "zIndex" ) ) {
				this._storedZIndex = this.helper.css( "zIndex" );
			}
			this.helper.css( "zIndex", o.zIndex );
		}

		//Prepare scrolling
		if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ].tagName !== "HTML" ) {
			this.overflowOffset = this.scrollParent.offset();
		}

		//Call callbacks
		this._trigger( "start", event, this._uiHash() );

		//Recache the helper size
		if ( !this._preserveHelperProportions ) {
			this._cacheHelperProportions();
		}

		//Post "activate" events to possible containers
		if ( !noActivation ) {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
			}
		}

		//Prepare possible droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		this.dragging = true;

		this._addClass( this.helper, "ui-sortable-helper" );

		// Execute the drag once - this causes the helper not to be visiblebefore getting its
		// correct position
		this._mouseDrag( event );
		return true;

	},

	_mouseDrag: function( event ) {
		var i, item, itemElement, intersection,
			o = this.options,
			scrolled = false;

		//Compute the helpers position
		this.position = this._generatePosition( event );
		this.positionAbs = this._convertPositionTo( "absolute" );

		if ( !this.lastPositionAbs ) {
			this.lastPositionAbs = this.positionAbs;
		}

		//Do scrolling
		if ( this.options.scroll ) {
			if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {

				if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
						event.pageY < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
				} else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
				}

				if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
						event.pageX < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
				}

			} else {

				if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
					scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
				} else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
						o.scrollSensitivity ) {
					scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
				}

				if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
					scrolled = this.document.scrollLeft(
						this.document.scrollLeft() - o.scrollSpeed
					);
				} else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
						o.scrollSensitivity ) {
					scrolled = this.document.scrollLeft(
						this.document.scrollLeft() + o.scrollSpeed
					);
				}

			}

			if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
		}

		//Regenerate the absolute position used for position checks
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Set the helper position
		if ( !this.options.axis || this.options.axis !== "y" ) {
			this.helper[ 0 ].style.left = this.position.left + "px";
		}
		if ( !this.options.axis || this.options.axis !== "x" ) {
			this.helper[ 0 ].style.top = this.position.top + "px";
		}

		//Rearrange
		for ( i = this.items.length - 1; i >= 0; i-- ) {

			//Cache variables and intersection, continue if no intersection
			item = this.items[ i ];
			itemElement = item.item[ 0 ];
			intersection = this._intersectsWithPointer( item );
			if ( !intersection ) {
				continue;
			}

			// Only put the placeholder inside the current Container, skip all
			// items from other containers. This works because when moving
			// an item from one container to another the
			// currentContainer is switched before the placeholder is moved.
			//
			// Without this, moving items in "sub-sortables" can cause
			// the placeholder to jitter between the outer and inner container.
			if ( item.instance !== this.currentContainer ) {
				continue;
			}

			// Cannot intersect with itself
			// no useless actions that have been done before
			// no action if the item moved is the parent of the item checked
			if ( itemElement !== this.currentItem[ 0 ] &&
				this.placeholder[ intersection === 1 ? "next" : "prev" ]()[ 0 ] !== itemElement &&
				!$.contains( this.placeholder[ 0 ], itemElement ) &&
				( this.options.type === "semi-dynamic" ?
					!$.contains( this.element[ 0 ], itemElement ) :
					true
				)
			) {

				this.direction = intersection === 1 ? "down" : "up";

				if ( this.options.tolerance === "pointer" || this._intersectsWithSides( item ) ) {
					this._rearrange( event, item );
				} else {
					break;
				}

				this._trigger( "change", event, this._uiHash() );
				break;
			}
		}

		//Post events to containers
		this._contactContainers( event );

		//Interconnect with droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		//Call callbacks
		this._trigger( "sort", event, this._uiHash() );

		this.lastPositionAbs = this.positionAbs;
		return false;

	},

	_mouseStop: function( event, noPropagation ) {

		if ( !event ) {
			return;
		}

		//If we are using droppables, inform the manager about the drop
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			$.ui.ddmanager.drop( this, event );
		}

		if ( this.options.revert ) {
			var that = this,
				cur = this.placeholder.offset(),
				axis = this.options.axis,
				animation = {};

			if ( !axis || axis === "x" ) {
				animation.left = cur.left - this.offset.parent.left - this.margins.left +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollLeft
					);
			}
			if ( !axis || axis === "y" ) {
				animation.top = cur.top - this.offset.parent.top - this.margins.top +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollTop
					);
			}
			this.reverting = true;
			$( this.helper ).animate(
				animation,
				parseInt( this.options.revert, 10 ) || 500,
				function() {
					that._clear( event );
				}
			);
		} else {
			this._clear( event, noPropagation );
		}

		return false;

	},

	cancel: function() {

		if ( this.dragging ) {

			this._mouseUp( new $.Event( "mouseup", { target: null } ) );

			if ( this.options.helper === "original" ) {
				this.currentItem.css( this._storedCSS );
				this._removeClass( this.currentItem, "ui-sortable-helper" );
			} else {
				this.currentItem.show();
			}

			//Post deactivating events to containers
			for ( var i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		if ( this.placeholder ) {

			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
			// it unbinds ALL events from the original node!
			if ( this.placeholder[ 0 ].parentNode ) {
				this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
			}
			if ( this.options.helper !== "original" && this.helper &&
					this.helper[ 0 ].parentNode ) {
				this.helper.remove();
			}

			$.extend( this, {
				helper: null,
				dragging: false,
				reverting: false,
				_noFinalSort: null
			} );

			if ( this.domPosition.prev ) {
				$( this.domPosition.prev ).after( this.currentItem );
			} else {
				$( this.domPosition.parent ).prepend( this.currentItem );
			}
		}

		return this;

	},

	serialize: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			str = [];
		o = o || {};

		$( items ).each( function() {
			var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
				.match( o.expression || ( /(.+)[\-=_](.+)/ ) );
			if ( res ) {
				str.push(
					( o.key || res[ 1 ] + "[]" ) +
					"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
			}
		} );

		if ( !str.length && o.key ) {
			str.push( o.key + "=" );
		}

		return str.join( "&" );

	},

	toArray: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			ret = [];

		o = o || {};

		items.each( function() {
			ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
		} );
		return ret;

	},

	/* Be careful with the following core functions */
	_intersectsWith: function( item ) {

		var x1 = this.positionAbs.left,
			x2 = x1 + this.helperProportions.width,
			y1 = this.positionAbs.top,
			y2 = y1 + this.helperProportions.height,
			l = item.left,
			r = l + item.width,
			t = item.top,
			b = t + item.height,
			dyClick = this.offset.click.top,
			dxClick = this.offset.click.left,
			isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
				( y1 + dyClick ) < b ),
			isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
				( x1 + dxClick ) < r ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( this.options.tolerance === "pointer" ||
			this.options.forcePointerForContainers ||
			( this.options.tolerance !== "pointer" &&
				this.helperProportions[ this.floating ? "width" : "height" ] >
				item[ this.floating ? "width" : "height" ] )
		) {
			return isOverElement;
		} else {

			return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
				x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half

		}
	},

	_intersectsWithPointer: function( item ) {
		var verticalDirection, horizontalDirection,
			isOverElementHeight = ( this.options.axis === "x" ) ||
				this._isOverAxis(
					this.positionAbs.top + this.offset.click.top, item.top, item.height ),
			isOverElementWidth = ( this.options.axis === "y" ) ||
				this._isOverAxis(
					this.positionAbs.left + this.offset.click.left, item.left, item.width ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( !isOverElement ) {
			return false;
		}

		verticalDirection = this._getDragVerticalDirection();
		horizontalDirection = this._getDragHorizontalDirection();

		return this.floating ?
			( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 )
			: ( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );

	},

	_intersectsWithSides: function( item ) {

		var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
				this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
			isOverRightHalf = this._isOverAxis( this.positionAbs.left +
				this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if ( this.floating && horizontalDirection ) {
			return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
				( horizontalDirection === "left" && !isOverRightHalf ) );
		} else {
			return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
				( verticalDirection === "up" && !isOverBottomHalf ) );
		}

	},

	_getDragVerticalDirection: function() {
		var delta = this.positionAbs.top - this.lastPositionAbs.top;
		return delta !== 0 && ( delta > 0 ? "down" : "up" );
	},

	_getDragHorizontalDirection: function() {
		var delta = this.positionAbs.left - this.lastPositionAbs.left;
		return delta !== 0 && ( delta > 0 ? "right" : "left" );
	},

	refresh: function( event ) {
		this._refreshItems( event );
		this._setHandleClassName();
		this.refreshPositions();
		return this;
	},

	_connectWith: function() {
		var options = this.options;
		return options.connectWith.constructor === String ?
			[ options.connectWith ] :
			options.connectWith;
	},

	_getItemsAsjQuery: function( connected ) {

		var i, j, cur, inst,
			items = [],
			queries = [],
			connectWith = this._connectWith();

		if ( connectWith && connected ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ $.isFunction( inst.options.items ) ?
							inst.options.items.call( inst.element ) :
							$( inst.options.items, inst.element )
								.not( ".ui-sortable-helper" )
								.not( ".ui-sortable-placeholder" ), inst ] );
					}
				}
			}
		}

		queries.push( [ $.isFunction( this.options.items ) ?
			this.options.items
				.call( this.element, null, { options: this.options, item: this.currentItem } ) :
			$( this.options.items, this.element )
				.not( ".ui-sortable-helper" )
				.not( ".ui-sortable-placeholder" ), this ] );

		function addItems() {
			items.push( this );
		}
		for ( i = queries.length - 1; i >= 0; i-- ) {
			queries[ i ][ 0 ].each( addItems );
		}

		return $( items );

	},

	_removeCurrentsFromItems: function() {

		var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );

		this.items = $.grep( this.items, function( item ) {
			for ( var j = 0; j < list.length; j++ ) {
				if ( list[ j ] === item.item[ 0 ] ) {
					return false;
				}
			}
			return true;
		} );

	},

	_refreshItems: function( event ) {

		this.items = [];
		this.containers = [ this ];

		var i, j, cur, inst, targetData, _queries, item, queriesLength,
			items = this.items,
			queries = [ [ $.isFunction( this.options.items ) ?
				this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
				$( this.options.items, this.element ), this ] ],
			connectWith = this._connectWith();

		//Shouldn't be run the first time through due to massive slow-down
		if ( connectWith && this.ready ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ $.isFunction( inst.options.items ) ?
							inst.options.items
								.call( inst.element[ 0 ], event, { item: this.currentItem } ) :
							$( inst.options.items, inst.element ), inst ] );
						this.containers.push( inst );
					}
				}
			}
		}

		for ( i = queries.length - 1; i >= 0; i-- ) {
			targetData = queries[ i ][ 1 ];
			_queries = queries[ i ][ 0 ];

			for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
				item = $( _queries[ j ] );

				// Data for target checking (mouse manager)
				item.data( this.widgetName + "-item", targetData );

				items.push( {
					item: item,
					instance: targetData,
					width: 0, height: 0,
					left: 0, top: 0
				} );
			}
		}

	},

	refreshPositions: function( fast ) {

		// Determine whether items are being displayed horizontally
		this.floating = this.items.length ?
			this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
			false;

		//This has to be redone because due to the item being moved out/into the offsetParent,
		// the offsetParent's position will change
		if ( this.offsetParent && this.helper ) {
			this.offset.parent = this._getParentOffset();
		}

		var i, item, t, p;

		for ( i = this.items.length - 1; i >= 0; i-- ) {
			item = this.items[ i ];

			//We ignore calculating positions of all connected containers when we're not over them
			if ( item.instance !== this.currentContainer && this.currentContainer &&
					item.item[ 0 ] !== this.currentItem[ 0 ] ) {
				continue;
			}

			t = this.options.toleranceElement ?
				$( this.options.toleranceElement, item.item ) :
				item.item;

			if ( !fast ) {
				item.width = t.outerWidth();
				item.height = t.outerHeight();
			}

			p = t.offset();
			item.left = p.left;
			item.top = p.top;
		}

		if ( this.options.custom && this.options.custom.refreshContainers ) {
			this.options.custom.refreshContainers.call( this );
		} else {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				p = this.containers[ i ].element.offset();
				this.containers[ i ].containerCache.left = p.left;
				this.containers[ i ].containerCache.top = p.top;
				this.containers[ i ].containerCache.width =
					this.containers[ i ].element.outerWidth();
				this.containers[ i ].containerCache.height =
					this.containers[ i ].element.outerHeight();
			}
		}

		return this;
	},

	_createPlaceholder: function( that ) {
		that = that || this;
		var className,
			o = that.options;

		if ( !o.placeholder || o.placeholder.constructor === String ) {
			className = o.placeholder;
			o.placeholder = {
				element: function() {

					var nodeName = that.currentItem[ 0 ].nodeName.toLowerCase(),
						element = $( "<" + nodeName + ">", that.document[ 0 ] );

						that._addClass( element, "ui-sortable-placeholder",
								className || that.currentItem[ 0 ].className )
							._removeClass( element, "ui-sortable-helper" );

					if ( nodeName === "tbody" ) {
						that._createTrPlaceholder(
							that.currentItem.find( "tr" ).eq( 0 ),
							$( "<tr>", that.document[ 0 ] ).appendTo( element )
						);
					} else if ( nodeName === "tr" ) {
						that._createTrPlaceholder( that.currentItem, element );
					} else if ( nodeName === "img" ) {
						element.attr( "src", that.currentItem.attr( "src" ) );
					}

					if ( !className ) {
						element.css( "visibility", "hidden" );
					}

					return element;
				},
				update: function( container, p ) {

					// 1. If a className is set as 'placeholder option, we don't force sizes -
					// the class is responsible for that
					// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
					// class name is specified
					if ( className && !o.forcePlaceholderSize ) {
						return;
					}

					//If the element doesn't have a actual height by itself (without styles coming
					// from a stylesheet), it receives the inline height from the dragged item
					if ( !p.height() ) {
						p.height(
							that.currentItem.innerHeight() -
							parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
					}
					if ( !p.width() ) {
						p.width(
							that.currentItem.innerWidth() -
							parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
					}
				}
			};
		}

		//Create the placeholder
		that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );

		//Append it after the actual current item
		that.currentItem.after( that.placeholder );

		//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
		o.placeholder.update( that, that.placeholder );

	},

	_createTrPlaceholder: function( sourceTr, targetTr ) {
		var that = this;

		sourceTr.children().each( function() {
			$( "<td>&#160;</td>", that.document[ 0 ] )
				.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
				.appendTo( targetTr );
		} );
	},

	_contactContainers: function( event ) {
		var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
			floating, axis,
			innermostContainer = null,
			innermostIndex = null;

		// Get innermost container that intersects with item
		for ( i = this.containers.length - 1; i >= 0; i-- ) {

			// Never consider a container that's located within the item itself
			if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
				continue;
			}

			if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {

				// If we've already found a container and it's more "inner" than this, then continue
				if ( innermostContainer &&
						$.contains(
							this.containers[ i ].element[ 0 ],
							innermostContainer.element[ 0 ] ) ) {
					continue;
				}

				innermostContainer = this.containers[ i ];
				innermostIndex = i;

			} else {

				// container doesn't intersect. trigger "out" event if necessary
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		// If no intersecting containers found, return
		if ( !innermostContainer ) {
			return;
		}

		// Move the item into the container if it's not there already
		if ( this.containers.length === 1 ) {
			if ( !this.containers[ innermostIndex ].containerCache.over ) {
				this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
				this.containers[ innermostIndex ].containerCache.over = 1;
			}
		} else {

			// When entering a new container, we will find the item with the least distance and
			// append our item near it
			dist = 10000;
			itemWithLeastDistance = null;
			floating = innermostContainer.floating || this._isFloating( this.currentItem );
			posProperty = floating ? "left" : "top";
			sizeProperty = floating ? "width" : "height";
			axis = floating ? "pageX" : "pageY";

			for ( j = this.items.length - 1; j >= 0; j-- ) {
				if ( !$.contains(
						this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
				) {
					continue;
				}
				if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
					continue;
				}

				cur = this.items[ j ].item.offset()[ posProperty ];
				nearBottom = false;
				if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
					nearBottom = true;
				}

				if ( Math.abs( event[ axis ] - cur ) < dist ) {
					dist = Math.abs( event[ axis ] - cur );
					itemWithLeastDistance = this.items[ j ];
					this.direction = nearBottom ? "up" : "down";
				}
			}

			//Check if dropOnEmpty is enabled
			if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
				return;
			}

			if ( this.currentContainer === this.containers[ innermostIndex ] ) {
				if ( !this.currentContainer.containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
					this.currentContainer.containerCache.over = 1;
				}
				return;
			}

			itemWithLeastDistance ?
				this._rearrange( event, itemWithLeastDistance, null, true ) :
				this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
			this._trigger( "change", event, this._uiHash() );
			this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
			this.currentContainer = this.containers[ innermostIndex ];

			//Update the placeholder
			this.options.placeholder.update( this.currentContainer, this.placeholder );

			this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
			this.containers[ innermostIndex ].containerCache.over = 1;
		}

	},

	_createHelper: function( event ) {

		var o = this.options,
			helper = $.isFunction( o.helper ) ?
				$( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
				( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );

		//Add the helper to the DOM if that didn't happen already
		if ( !helper.parents( "body" ).length ) {
			$( o.appendTo !== "parent" ?
				o.appendTo :
				this.currentItem[ 0 ].parentNode )[ 0 ].appendChild( helper[ 0 ] );
		}

		if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
			this._storedCSS = {
				width: this.currentItem[ 0 ].style.width,
				height: this.currentItem[ 0 ].style.height,
				position: this.currentItem.css( "position" ),
				top: this.currentItem.css( "top" ),
				left: this.currentItem.css( "left" )
			};
		}

		if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
			helper.width( this.currentItem.width() );
		}
		if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
			helper.height( this.currentItem.height() );
		}

		return helper;

	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( $.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		// This needs to be actually done for all browsers, since pageX/pageY includes this
		// information with an ugly IE fix
		if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ||
				( this.offsetParent[ 0 ].tagName &&
				this.offsetParent[ 0 ].tagName.toLowerCase() === "html" && $.ui.ie ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {

		if ( this.cssPosition === "relative" ) {
			var p = this.currentItem.position();
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					this.scrollParent.scrollTop(),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var ce, co, over,
			o = this.options;
		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}
		if ( o.containment === "document" || o.containment === "window" ) {
			this.containment = [
				0 - this.offset.relative.left - this.offset.parent.left,
				0 - this.offset.relative.top - this.offset.parent.top,
				o.containment === "document" ?
					this.document.width() :
					this.window.width() - this.helperProportions.width - this.margins.left,
				( o.containment === "document" ?
					( this.document.height() || document.body.parentNode.scrollHeight ) :
					this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
				) - this.helperProportions.height - this.margins.top
			];
		}

		if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
			ce = $( o.containment )[ 0 ];
			co = $( o.containment ).offset();
			over = ( $( ce ).css( "overflow" ) !== "hidden" );

			this.containment = [
				co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
				co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
				co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width - this.margins.left,
				co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height - this.margins.top
			];
		}

	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}
		var mod = d === "absolute" ? 1 : -1,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
			scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
					scroll.scrollLeft() ) * mod )
			)
		};

	},

	_generatePosition: function( event ) {

		var top, left,
			o = this.options,
			pageX = event.pageX,
			pageY = event.pageY,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
				scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		// This is another very weird special case that only happens for relative elements:
		// 1. If the css position is relative
		// 2. and the scroll parent is the document or similar to the offset parent
		// we have to refresh the relative offset during the scroll so there are no jumps
		if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
			this.offset.relative = this._getRelativeOffset();
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if ( this.originalPosition ) { //If we are not dragging yet, we won't check for options

			if ( this.containment ) {
				if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
					pageX = this.containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
					pageY = this.containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
					pageX = this.containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
					pageY = this.containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {
				top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
					o.grid[ 1 ] ) * o.grid[ 1 ];
				pageY = this.containment ?
					( ( top - this.offset.click.top >= this.containment[ 1 ] &&
						top - this.offset.click.top <= this.containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
								top;

				left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
					o.grid[ 0 ] ) * o.grid[ 0 ];
				pageX = this.containment ?
					( ( left - this.offset.click.left >= this.containment[ 0 ] &&
						left - this.offset.click.left <= this.containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
								left;
			}

		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() :
					scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
			)
		};

	},

	_rearrange: function( event, i, a, hardRefresh ) {

		a ? a[ 0 ].appendChild( this.placeholder[ 0 ] ) :
			i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
				( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );

		//Various things done here to improve the performance:
		// 1. we create a setTimeout, that calls refreshPositions
		// 2. on the instance, we have a counter variable, that get's higher after every append
		// 3. on the local scope, we copy the counter variable, and check in the timeout,
		// if it's still the same
		// 4. this lets only the last addition to the timeout stack through
		this.counter = this.counter ? ++this.counter : 1;
		var counter = this.counter;

		this._delay( function() {
			if ( counter === this.counter ) {

				//Precompute after each DOM insertion, NOT on mousemove
				this.refreshPositions( !hardRefresh );
			}
		} );

	},

	_clear: function( event, noPropagation ) {

		this.reverting = false;

		// We delay all events that have to be triggered to after the point where the placeholder
		// has been removed and everything else normalized again
		var i,
			delayedTriggers = [];

		// We first have to update the dom position of the actual currentItem
		// Note: don't do it if the current item is already removed (by a user), or it gets
		// reappended (see #4088)
		if ( !this._noFinalSort && this.currentItem.parent().length ) {
			this.placeholder.before( this.currentItem );
		}
		this._noFinalSort = null;

		if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
			for ( i in this._storedCSS ) {
				if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
					this._storedCSS[ i ] = "";
				}
			}
			this.currentItem.css( this._storedCSS );
			this._removeClass( this.currentItem, "ui-sortable-helper" );
		} else {
			this.currentItem.show();
		}

		if ( this.fromOutside && !noPropagation ) {
			delayedTriggers.push( function( event ) {
				this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
			} );
		}
		if ( ( this.fromOutside ||
				this.domPosition.prev !==
				this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
				this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {

			// Trigger update callback if the DOM position has changed
			delayedTriggers.push( function( event ) {
				this._trigger( "update", event, this._uiHash() );
			} );
		}

		// Check if the items Container has Changed and trigger appropriate
		// events.
		if ( this !== this.currentContainer ) {
			if ( !noPropagation ) {
				delayedTriggers.push( function( event ) {
					this._trigger( "remove", event, this._uiHash() );
				} );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "receive", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "update", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
			}
		}

		//Post events to containers
		function delayEvent( type, instance, container ) {
			return function( event ) {
				container._trigger( type, event, instance._uiHash( instance ) );
			};
		}
		for ( i = this.containers.length - 1; i >= 0; i-- ) {
			if ( !noPropagation ) {
				delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
			}
			if ( this.containers[ i ].containerCache.over ) {
				delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
				this.containers[ i ].containerCache.over = 0;
			}
		}

		//Do what was originally in plugins
		if ( this.storedCursor ) {
			this.document.find( "body" ).css( "cursor", this.storedCursor );
			this.storedStylesheet.remove();
		}
		if ( this._storedOpacity ) {
			this.helper.css( "opacity", this._storedOpacity );
		}
		if ( this._storedZIndex ) {
			this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
		}

		this.dragging = false;

		if ( !noPropagation ) {
			this._trigger( "beforeStop", event, this._uiHash() );
		}

		//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
		// it unbinds ALL events from the original node!
		this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );

		if ( !this.cancelHelperRemoval ) {
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.helper.remove();
			}
			this.helper = null;
		}

		if ( !noPropagation ) {
			for ( i = 0; i < delayedTriggers.length; i++ ) {

				// Trigger all delayed events
				delayedTriggers[ i ].call( this, event );
			}
			this._trigger( "stop", event, this._uiHash() );
		}

		this.fromOutside = false;
		return !this.cancelHelperRemoval;

	},

	_trigger: function() {
		if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
			this.cancel();
		}
	},

	_uiHash: function( _inst ) {
		var inst = _inst || this;
		return {
			helper: inst.helper,
			placeholder: inst.placeholder || $( [] ),
			position: inst.position,
			originalPosition: inst.originalPosition,
			offset: inst.positionAbs,
			item: inst.currentItem,
			sender: _inst ? _inst.element : null
		};
	}

} );


/*!
 * jQuery UI Accordion 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Accordion
//>>group: Widgets
// jscs:disable maximumLineLength
//>>description: Displays collapsible content panels for presenting information in a limited amount of space.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/accordion/
//>>demos: http://jqueryui.com/accordion/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/accordion.css
//>>css.theme: ../../themes/base/theme.css



var widgetsAccordion = $.widget( "ui.accordion", {
	version: "1.12.1",
	options: {
		active: 0,
		animate: {},
		classes: {
			"ui-accordion-header": "ui-corner-top",
			"ui-accordion-header-collapsed": "ui-corner-all",
			"ui-accordion-content": "ui-corner-bottom"
		},
		collapsible: false,
		event: "click",
		header: "> li > :first-child, > :not(li):even",
		heightStyle: "auto",
		icons: {
			activeHeader: "ui-icon-triangle-1-s",
			header: "ui-icon-triangle-1-e"
		},

		// Callbacks
		activate: null,
		beforeActivate: null
	},

	hideProps: {
		borderTopWidth: "hide",
		borderBottomWidth: "hide",
		paddingTop: "hide",
		paddingBottom: "hide",
		height: "hide"
	},

	showProps: {
		borderTopWidth: "show",
		borderBottomWidth: "show",
		paddingTop: "show",
		paddingBottom: "show",
		height: "show"
	},

	_create: function() {
		var options = this.options;

		this.prevShow = this.prevHide = $();
		this._addClass( "ui-accordion", "ui-widget ui-helper-reset" );
		this.element.attr( "role", "tablist" );

		// Don't allow collapsible: false and active: false / null
		if ( !options.collapsible && ( options.active === false || options.active == null ) ) {
			options.active = 0;
		}

		this._processPanels();

		// handle negative values
		if ( options.active < 0 ) {
			options.active += this.headers.length;
		}
		this._refresh();
	},

	_getCreateEventData: function() {
		return {
			header: this.active,
			panel: !this.active.length ? $() : this.active.next()
		};
	},

	_createIcons: function() {
		var icon, children,
			icons = this.options.icons;

		if ( icons ) {
			icon = $( "<span>" );
			this._addClass( icon, "ui-accordion-header-icon", "ui-icon " + icons.header );
			icon.prependTo( this.headers );
			children = this.active.children( ".ui-accordion-header-icon" );
			this._removeClass( children, icons.header )
				._addClass( children, null, icons.activeHeader )
				._addClass( this.headers, "ui-accordion-icons" );
		}
	},

	_destroyIcons: function() {
		this._removeClass( this.headers, "ui-accordion-icons" );
		this.headers.children( ".ui-accordion-header-icon" ).remove();
	},

	_destroy: function() {
		var contents;

		// Clean up main element
		this.element.removeAttr( "role" );

		// Clean up headers
		this.headers
			.removeAttr( "role aria-expanded aria-selected aria-controls tabIndex" )
			.removeUniqueId();

		this._destroyIcons();

		// Clean up content panels
		contents = this.headers.next()
			.css( "display", "" )
			.removeAttr( "role aria-hidden aria-labelledby" )
			.removeUniqueId();

		if ( this.options.heightStyle !== "content" ) {
			contents.css( "height", "" );
		}
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		if ( key === "event" ) {
			if ( this.options.event ) {
				this._off( this.headers, this.options.event );
			}
			this._setupEvents( value );
		}

		this._super( key, value );

		// Setting collapsible: false while collapsed; open first panel
		if ( key === "collapsible" && !value && this.options.active === false ) {
			this._activate( 0 );
		}

		if ( key === "icons" ) {
			this._destroyIcons();
			if ( value ) {
				this._createIcons();
			}
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );

		// Support: IE8 Only
		// #5332 / #6059 - opacity doesn't cascade to positioned elements in IE
		// so we need to add the disabled class to the headers and panels
		this._toggleClass( null, "ui-state-disabled", !!value );
		this._toggleClass( this.headers.add( this.headers.next() ), null, "ui-state-disabled",
			!!value );
	},

	_keydown: function( event ) {
		if ( event.altKey || event.ctrlKey ) {
			return;
		}

		var keyCode = $.ui.keyCode,
			length = this.headers.length,
			currentIndex = this.headers.index( event.target ),
			toFocus = false;

		switch ( event.keyCode ) {
		case keyCode.RIGHT:
		case keyCode.DOWN:
			toFocus = this.headers[ ( currentIndex + 1 ) % length ];
			break;
		case keyCode.LEFT:
		case keyCode.UP:
			toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
			break;
		case keyCode.SPACE:
		case keyCode.ENTER:
			this._eventHandler( event );
			break;
		case keyCode.HOME:
			toFocus = this.headers[ 0 ];
			break;
		case keyCode.END:
			toFocus = this.headers[ length - 1 ];
			break;
		}

		if ( toFocus ) {
			$( event.target ).attr( "tabIndex", -1 );
			$( toFocus ).attr( "tabIndex", 0 );
			$( toFocus ).trigger( "focus" );
			event.preventDefault();
		}
	},

	_panelKeyDown: function( event ) {
		if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
			$( event.currentTarget ).prev().trigger( "focus" );
		}
	},

	refresh: function() {
		var options = this.options;
		this._processPanels();

		// Was collapsed or no panel
		if ( ( options.active === false && options.collapsible === true ) ||
				!this.headers.length ) {
			options.active = false;
			this.active = $();

		// active false only when collapsible is true
		} else if ( options.active === false ) {
			this._activate( 0 );

		// was active, but active panel is gone
		} else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {

			// all remaining panel are disabled
			if ( this.headers.length === this.headers.find( ".ui-state-disabled" ).length ) {
				options.active = false;
				this.active = $();

			// activate previous panel
			} else {
				this._activate( Math.max( 0, options.active - 1 ) );
			}

		// was active, active panel still exists
		} else {

			// make sure active index is correct
			options.active = this.headers.index( this.active );
		}

		this._destroyIcons();

		this._refresh();
	},

	_processPanels: function() {
		var prevHeaders = this.headers,
			prevPanels = this.panels;

		this.headers = this.element.find( this.options.header );
		this._addClass( this.headers, "ui-accordion-header ui-accordion-header-collapsed",
			"ui-state-default" );

		this.panels = this.headers.next().filter( ":not(.ui-accordion-content-active)" ).hide();
		this._addClass( this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevPanels ) {
			this._off( prevHeaders.not( this.headers ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	_refresh: function() {
		var maxHeight,
			options = this.options,
			heightStyle = options.heightStyle,
			parent = this.element.parent();

		this.active = this._findActive( options.active );
		this._addClass( this.active, "ui-accordion-header-active", "ui-state-active" )
			._removeClass( this.active, "ui-accordion-header-collapsed" );
		this._addClass( this.active.next(), "ui-accordion-content-active" );
		this.active.next().show();

		this.headers
			.attr( "role", "tab" )
			.each( function() {
				var header = $( this ),
					headerId = header.uniqueId().attr( "id" ),
					panel = header.next(),
					panelId = panel.uniqueId().attr( "id" );
				header.attr( "aria-controls", panelId );
				panel.attr( "aria-labelledby", headerId );
			} )
			.next()
				.attr( "role", "tabpanel" );

		this.headers
			.not( this.active )
				.attr( {
					"aria-selected": "false",
					"aria-expanded": "false",
					tabIndex: -1
				} )
				.next()
					.attr( {
						"aria-hidden": "true"
					} )
					.hide();

		// Make sure at least one header is in the tab order
		if ( !this.active.length ) {
			this.headers.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active.attr( {
				"aria-selected": "true",
				"aria-expanded": "true",
				tabIndex: 0
			} )
				.next()
					.attr( {
						"aria-hidden": "false"
					} );
		}

		this._createIcons();

		this._setupEvents( options.event );

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.headers.each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.headers.next()
				.each( function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.headers.next()
				.each( function() {
					var isVisible = $( this ).is( ":visible" );
					if ( !isVisible ) {
						$( this ).show();
					}
					maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
					if ( !isVisible ) {
						$( this ).hide();
					}
				} )
				.height( maxHeight );
		}
	},

	_activate: function( index ) {
		var active = this._findActive( index )[ 0 ];

		// Trying to activate the already active panel
		if ( active === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the currently active header
		active = active || this.active[ 0 ];

		this._eventHandler( {
			target: active,
			currentTarget: active,
			preventDefault: $.noop
		} );
	},

	_findActive: function( selector ) {
		return typeof selector === "number" ? this.headers.eq( selector ) : $();
	},

	_setupEvents: function( event ) {
		var events = {
			keydown: "_keydown"
		};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.headers.add( this.headers.next() ) );
		this._on( this.headers, events );
		this._on( this.headers.next(), { keydown: "_panelKeyDown" } );
		this._hoverable( this.headers );
		this._focusable( this.headers );
	},

	_eventHandler: function( event ) {
		var activeChildren, clickedChildren,
			options = this.options,
			active = this.active,
			clicked = $( event.currentTarget ),
			clickedIsActive = clicked[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : clicked.next(),
			toHide = active.next(),
			eventData = {
				oldHeader: active,
				oldPanel: toHide,
				newHeader: collapsing ? $() : clicked,
				newPanel: toShow
			};

		event.preventDefault();

		if (

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.headers.index( clicked );

		// When the call to ._toggle() comes after the class changes
		// it causes a very odd bug in IE 8 (see #6720)
		this.active = clickedIsActive ? $() : clicked;
		this._toggle( eventData );

		// Switch classes
		// corner classes on the previously active header stay after the animation
		this._removeClass( active, "ui-accordion-header-active", "ui-state-active" );
		if ( options.icons ) {
			activeChildren = active.children( ".ui-accordion-header-icon" );
			this._removeClass( activeChildren, null, options.icons.activeHeader )
				._addClass( activeChildren, null, options.icons.header );
		}

		if ( !clickedIsActive ) {
			this._removeClass( clicked, "ui-accordion-header-collapsed" )
				._addClass( clicked, "ui-accordion-header-active", "ui-state-active" );
			if ( options.icons ) {
				clickedChildren = clicked.children( ".ui-accordion-header-icon" );
				this._removeClass( clickedChildren, null, options.icons.header )
					._addClass( clickedChildren, null, options.icons.activeHeader );
			}

			this._addClass( clicked.next(), "ui-accordion-content-active" );
		}
	},

	_toggle: function( data ) {
		var toShow = data.newPanel,
			toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

		// Handle activating a panel during the animation for another activation
		this.prevShow.add( this.prevHide ).stop( true, true );
		this.prevShow = toShow;
		this.prevHide = toHide;

		if ( this.options.animate ) {
			this._animate( toShow, toHide, data );
		} else {
			toHide.hide();
			toShow.show();
			this._toggleComplete( data );
		}

		toHide.attr( {
			"aria-hidden": "true"
		} );
		toHide.prev().attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// if we're switching panels, remove the old header from the tab order
		// if we're opening from collapsed state, remove the previous header from the tab order
		// if we're collapsing, then keep the collapsing header in the tab order
		if ( toShow.length && toHide.length ) {
			toHide.prev().attr( {
				"tabIndex": -1,
				"aria-expanded": "false"
			} );
		} else if ( toShow.length ) {
			this.headers.filter( function() {
				return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow
			.attr( "aria-hidden", "false" )
			.prev()
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
	},

	_animate: function( toShow, toHide, data ) {
		var total, easing, duration,
			that = this,
			adjust = 0,
			boxSizing = toShow.css( "box-sizing" ),
			down = toShow.length &&
				( !toHide.length || ( toShow.index() < toHide.index() ) ),
			animate = this.options.animate || {},
			options = down && animate.down || animate,
			complete = function() {
				that._toggleComplete( data );
			};

		if ( typeof options === "number" ) {
			duration = options;
		}
		if ( typeof options === "string" ) {
			easing = options;
		}

		// fall back from options to animation in case of partial down settings
		easing = easing || options.easing || animate.easing;
		duration = duration || options.duration || animate.duration;

		if ( !toHide.length ) {
			return toShow.animate( this.showProps, duration, easing, complete );
		}
		if ( !toShow.length ) {
			return toHide.animate( this.hideProps, duration, easing, complete );
		}

		total = toShow.show().outerHeight();
		toHide.animate( this.hideProps, {
			duration: duration,
			easing: easing,
			step: function( now, fx ) {
				fx.now = Math.round( now );
			}
		} );
		toShow
			.hide()
			.animate( this.showProps, {
				duration: duration,
				easing: easing,
				complete: complete,
				step: function( now, fx ) {
					fx.now = Math.round( now );
					if ( fx.prop !== "height" ) {
						if ( boxSizing === "content-box" ) {
							adjust += fx.now;
						}
					} else if ( that.options.heightStyle !== "content" ) {
						fx.now = Math.round( total - toHide.outerHeight() - adjust );
						adjust = 0;
					}
				}
			} );
	},

	_toggleComplete: function( data ) {
		var toHide = data.oldPanel,
			prev = toHide.prev();

		this._removeClass( toHide, "ui-accordion-content-active" );
		this._removeClass( prev, "ui-accordion-header-active" )
			._addClass( prev, "ui-accordion-header-collapsed" );

		// Work around for rendering bug in IE (#5421)
		if ( toHide.length ) {
			toHide.parent()[ 0 ].className = toHide.parent()[ 0 ].className;
		}
		this._trigger( "activate", null, data );
	}
} );


/*!
 * jQuery UI Menu 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Menu
//>>group: Widgets
//>>description: Creates nestable menus.
//>>docs: http://api.jqueryui.com/menu/
//>>demos: http://jqueryui.com/menu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/menu.css
//>>css.theme: ../../themes/base/theme.css



var widgetsMenu = $.widget( "ui.menu", {
	version: "1.12.1",
	defaultElement: "<ul>",
	delay: 300,
	options: {
		icons: {
			submenu: "ui-icon-caret-1-e"
		},
		items: "> *",
		menus: "ul",
		position: {
			my: "left top",
			at: "right top"
		},
		role: "menu",

		// Callbacks
		blur: null,
		focus: null,
		select: null
	},

	_create: function() {
		this.activeMenu = this.element;

		// Flag used to prevent firing of the click handler
		// as the event bubbles up through nested menus
		this.mouseHandled = false;
		this.element
			.uniqueId()
			.attr( {
				role: this.options.role,
				tabIndex: 0
			} );

		this._addClass( "ui-menu", "ui-widget ui-widget-content" );
		this._on( {

			// Prevent focus from sticking to links inside menu after clicking
			// them (focus should always stay on UL during navigation).
			"mousedown .ui-menu-item": function( event ) {
				event.preventDefault();
			},
			"click .ui-menu-item": function( event ) {
				var target = $( event.target );
				var active = $( $.ui.safeActiveElement( this.document[ 0 ] ) );
				if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
					this.select( event );

					// Only set the mouseHandled flag if the event will bubble, see #9469.
					if ( !event.isPropagationStopped() ) {
						this.mouseHandled = true;
					}

					// Open submenu on click
					if ( target.has( ".ui-menu" ).length ) {
						this.expand( event );
					} else if ( !this.element.is( ":focus" ) &&
							active.closest( ".ui-menu" ).length ) {

						// Redirect focus to the menu
						this.element.trigger( "focus", [ true ] );

						// If the active item is on the top level, let it stay active.
						// Otherwise, blur the active item since it is no longer visible.
						if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
							clearTimeout( this.timer );
						}
					}
				}
			},
			"mouseenter .ui-menu-item": function( event ) {

				// Ignore mouse events while typeahead is active, see #10458.
				// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
				// is over an item in the menu
				if ( this.previousFilter ) {
					return;
				}

				var actualTarget = $( event.target ).closest( ".ui-menu-item" ),
					target = $( event.currentTarget );

				// Ignore bubbled events on parent items, see #11641
				if ( actualTarget[ 0 ] !== target[ 0 ] ) {
					return;
				}

				// Remove ui-state-active class from siblings of the newly focused menu item
				// to avoid a jump caused by adjacent elements both having a class with a border
				this._removeClass( target.siblings().children( ".ui-state-active" ),
					null, "ui-state-active" );
				this.focus( event, target );
			},
			mouseleave: "collapseAll",
			"mouseleave .ui-menu": "collapseAll",
			focus: function( event, keepActiveItem ) {

				// If there's already an active item, keep it active
				// If not, activate the first item
				var item = this.active || this.element.find( this.options.items ).eq( 0 );

				if ( !keepActiveItem ) {
					this.focus( event, item );
				}
			},
			blur: function( event ) {
				this._delay( function() {
					var notContained = !$.contains(
						this.element[ 0 ],
						$.ui.safeActiveElement( this.document[ 0 ] )
					);
					if ( notContained ) {
						this.collapseAll( event );
					}
				} );
			},
			keydown: "_keydown"
		} );

		this.refresh();

		// Clicks outside of a menu collapse any open menus
		this._on( this.document, {
			click: function( event ) {
				if ( this._closeOnDocumentClick( event ) ) {
					this.collapseAll( event );
				}

				// Reset the mouseHandled flag
				this.mouseHandled = false;
			}
		} );
	},

	_destroy: function() {
		var items = this.element.find( ".ui-menu-item" )
				.removeAttr( "role aria-disabled" ),
			submenus = items.children( ".ui-menu-item-wrapper" )
				.removeUniqueId()
				.removeAttr( "tabIndex role aria-haspopup" );

		// Destroy (sub)menus
		this.element
			.removeAttr( "aria-activedescendant" )
			.find( ".ui-menu" ).addBack()
				.removeAttr( "role aria-labelledby aria-expanded aria-hidden aria-disabled " +
					"tabIndex" )
				.removeUniqueId()
				.show();

		submenus.children().each( function() {
			var elem = $( this );
			if ( elem.data( "ui-menu-submenu-caret" ) ) {
				elem.remove();
			}
		} );
	},

	_keydown: function( event ) {
		var match, prev, character, skip,
			preventDefault = true;

		switch ( event.keyCode ) {
		case $.ui.keyCode.PAGE_UP:
			this.previousPage( event );
			break;
		case $.ui.keyCode.PAGE_DOWN:
			this.nextPage( event );
			break;
		case $.ui.keyCode.HOME:
			this._move( "first", "first", event );
			break;
		case $.ui.keyCode.END:
			this._move( "last", "last", event );
			break;
		case $.ui.keyCode.UP:
			this.previous( event );
			break;
		case $.ui.keyCode.DOWN:
			this.next( event );
			break;
		case $.ui.keyCode.LEFT:
			this.collapse( event );
			break;
		case $.ui.keyCode.RIGHT:
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				this.expand( event );
			}
			break;
		case $.ui.keyCode.ENTER:
		case $.ui.keyCode.SPACE:
			this._activate( event );
			break;
		case $.ui.keyCode.ESCAPE:
			this.collapse( event );
			break;
		default:
			preventDefault = false;
			prev = this.previousFilter || "";
			skip = false;

			// Support number pad values
			character = event.keyCode >= 96 && event.keyCode <= 105 ?
				( event.keyCode - 96 ).toString() : String.fromCharCode( event.keyCode );

			clearTimeout( this.filterTimer );

			if ( character === prev ) {
				skip = true;
			} else {
				character = prev + character;
			}

			match = this._filterMenuItems( character );
			match = skip && match.index( this.active.next() ) !== -1 ?
				this.active.nextAll( ".ui-menu-item" ) :
				match;

			// If no matches on the current filter, reset to the last character pressed
			// to move down the menu to the first item that starts with that character
			if ( !match.length ) {
				character = String.fromCharCode( event.keyCode );
				match = this._filterMenuItems( character );
			}

			if ( match.length ) {
				this.focus( event, match );
				this.previousFilter = character;
				this.filterTimer = this._delay( function() {
					delete this.previousFilter;
				}, 1000 );
			} else {
				delete this.previousFilter;
			}
		}

		if ( preventDefault ) {
			event.preventDefault();
		}
	},

	_activate: function( event ) {
		if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
			if ( this.active.children( "[aria-haspopup='true']" ).length ) {
				this.expand( event );
			} else {
				this.select( event );
			}
		}
	},

	refresh: function() {
		var menus, items, newSubmenus, newItems, newWrappers,
			that = this,
			icon = this.options.icons.submenu,
			submenus = this.element.find( this.options.menus );

		this._toggleClass( "ui-menu-icons", null, !!this.element.find( ".ui-icon" ).length );

		// Initialize nested menus
		newSubmenus = submenus.filter( ":not(.ui-menu)" )
			.hide()
			.attr( {
				role: this.options.role,
				"aria-hidden": "true",
				"aria-expanded": "false"
			} )
			.each( function() {
				var menu = $( this ),
					item = menu.prev(),
					submenuCaret = $( "<span>" ).data( "ui-menu-submenu-caret", true );

				that._addClass( submenuCaret, "ui-menu-icon", "ui-icon " + icon );
				item
					.attr( "aria-haspopup", "true" )
					.prepend( submenuCaret );
				menu.attr( "aria-labelledby", item.attr( "id" ) );
			} );

		this._addClass( newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front" );

		menus = submenus.add( this.element );
		items = menus.find( this.options.items );

		// Initialize menu-items containing spaces and/or dashes only as dividers
		items.not( ".ui-menu-item" ).each( function() {
			var item = $( this );
			if ( that._isDivider( item ) ) {
				that._addClass( item, "ui-menu-divider", "ui-widget-content" );
			}
		} );

		// Don't refresh list items that are already adapted
		newItems = items.not( ".ui-menu-item, .ui-menu-divider" );
		newWrappers = newItems.children()
			.not( ".ui-menu" )
				.uniqueId()
				.attr( {
					tabIndex: -1,
					role: this._itemRole()
				} );
		this._addClass( newItems, "ui-menu-item" )
			._addClass( newWrappers, "ui-menu-item-wrapper" );

		// Add aria-disabled attribute to any disabled menu item
		items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

		// If the active item has been removed, blur the menu
		if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			this.blur();
		}
	},

	_itemRole: function() {
		return {
			menu: "menuitem",
			listbox: "option"
		}[ this.options.role ];
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icons = this.element.find( ".ui-menu-icon" );
			this._removeClass( icons, null, this.options.icons.submenu )
				._addClass( icons, null, value.submenu );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", String( value ) );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	focus: function( event, item ) {
		var nested, focused, activeParent;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();

		focused = this.active.children( ".ui-menu-item-wrapper" );
		this._addClass( focused, null, "ui-state-active" );

		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		activeParent = this.active
			.parent()
				.closest( ".ui-menu-item" )
					.children( ".ui-menu-item-wrapper" );
		this._addClass( activeParent, null, "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay( function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening( nested );
		}
		this.activeMenu = item.parent();

		this._trigger( "focus", event, { item: item } );
	},

	_scrollIntoView: function( item ) {
		var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
		if ( this._hasScroll() ) {
			borderTop = parseFloat( $.css( this.activeMenu[ 0 ], "borderTopWidth" ) ) || 0;
			paddingTop = parseFloat( $.css( this.activeMenu[ 0 ], "paddingTop" ) ) || 0;
			offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
			scroll = this.activeMenu.scrollTop();
			elementHeight = this.activeMenu.height();
			itemHeight = item.outerHeight();

			if ( offset < 0 ) {
				this.activeMenu.scrollTop( scroll + offset );
			} else if ( offset + itemHeight > elementHeight ) {
				this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
			}
		}
	},

	blur: function( event, fromFocus ) {
		if ( !fromFocus ) {
			clearTimeout( this.timer );
		}

		if ( !this.active ) {
			return;
		}

		this._removeClass( this.active.children( ".ui-menu-item-wrapper" ),
			null, "ui-state-active" );

		this._trigger( "blur", event, { item: this.active } );
		this.active = null;
	},

	_startOpening: function( submenu ) {
		clearTimeout( this.timer );

		// Don't open if already open fixes a Firefox bug that caused a .5 pixel
		// shift in the submenu position when mousing over the caret icon
		if ( submenu.attr( "aria-hidden" ) !== "true" ) {
			return;
		}

		this.timer = this._delay( function() {
			this._close();
			this._open( submenu );
		}, this.delay );
	},

	_open: function( submenu ) {
		var position = $.extend( {
			of: this.active
		}, this.options.position );

		clearTimeout( this.timer );
		this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
			.hide()
			.attr( "aria-hidden", "true" );

		submenu
			.show()
			.removeAttr( "aria-hidden" )
			.attr( "aria-expanded", "true" )
			.position( position );
	},

	collapseAll: function( event, all ) {
		clearTimeout( this.timer );
		this.timer = this._delay( function() {

			// If we were passed an event, look for the submenu that contains the event
			var currentMenu = all ? this.element :
				$( event && event.target ).closest( this.element.find( ".ui-menu" ) );

			// If we found no valid submenu ancestor, use the main menu to close all
			// sub menus anyway
			if ( !currentMenu.length ) {
				currentMenu = this.element;
			}

			this._close( currentMenu );

			this.blur( event );

			// Work around active item staying active after menu is blurred
			this._removeClass( currentMenu.find( ".ui-state-active" ), null, "ui-state-active" );

			this.activeMenu = currentMenu;
		}, this.delay );
	},

	// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close: function( startMenu ) {
		if ( !startMenu ) {
			startMenu = this.active ? this.active.parent() : this.element;
		}

		startMenu.find( ".ui-menu" )
			.hide()
			.attr( "aria-hidden", "true" )
			.attr( "aria-expanded", "false" );
	},

	_closeOnDocumentClick: function( event ) {
		return !$( event.target ).closest( ".ui-menu" ).length;
	},

	_isDivider: function( item ) {

		// Match hyphen, em dash, en dash
		return !/[^\-\u2014\u2013\s]/.test( item.text() );
	},

	collapse: function( event ) {
		var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
		if ( newItem && newItem.length ) {
			this._close();
			this.focus( event, newItem );
		}
	},

	expand: function( event ) {
		var newItem = this.active &&
			this.active
				.children( ".ui-menu " )
					.find( this.options.items )
						.first();

		if ( newItem && newItem.length ) {
			this._open( newItem.parent() );

			// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
			this._delay( function() {
				this.focus( event, newItem );
			} );
		}
	},

	next: function( event ) {
		this._move( "next", "first", event );
	},

	previous: function( event ) {
		this._move( "prev", "last", event );
	},

	isFirstItem: function() {
		return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
	},

	isLastItem: function() {
		return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
	},

	_move: function( direction, filter, event ) {
		var next;
		if ( this.active ) {
			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.eq( -1 );
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.eq( 0 );
			}
		}
		if ( !next || !next.length || !this.active ) {
			next = this.activeMenu.find( this.options.items )[ filter ]();
		}

		this.focus( event, next );
	},

	nextPage: function( event ) {
		var item, base, height;

		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isLastItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.nextAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base - height < 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items )
				[ !this.active ? "first" : "last" ]() );
		}
	},

	previousPage: function( event ) {
		var item, base, height;
		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isFirstItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.prevAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base + height > 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items ).first() );
		}
	},

	_hasScroll: function() {
		return this.element.outerHeight() < this.element.prop( "scrollHeight" );
	},

	select: function( event ) {

		// TODO: It should never be possible to not have an active item at this
		// point, but the tests don't trigger mouseenter before click.
		this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
		var ui = { item: this.active };
		if ( !this.active.has( ".ui-menu" ).length ) {
			this.collapseAll( event, true );
		}
		this._trigger( "select", event, ui );
	},

	_filterMenuItems: function( character ) {
		var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
			regex = new RegExp( "^" + escapedCharacter, "i" );

		return this.activeMenu
			.find( this.options.items )

				// Only match on items, not dividers or other content (#10571)
				.filter( ".ui-menu-item" )
					.filter( function() {
						return regex.test(
							$.trim( $( this ).children( ".ui-menu-item-wrapper" ).text() ) );
					} );
	}
} );


/*!
 * jQuery UI Autocomplete 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Autocomplete
//>>group: Widgets
//>>description: Lists suggested words as the user is typing.
//>>docs: http://api.jqueryui.com/autocomplete/
//>>demos: http://jqueryui.com/autocomplete/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/autocomplete.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.autocomplete", {
	version: "1.12.1",
	defaultElement: "<input>",
	options: {
		appendTo: null,
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		response: null,
		search: null,
		select: null
	},

	requestIndex: 0,
	pending: 0,

	_create: function() {

		// Some browsers only repeat keydown events, not keypress events,
		// so we use the suppressKeyPress flag to determine if we've already
		// handled the keydown event. #7269
		// Unfortunately the code for & in keypress is the same as the up arrow,
		// so we use the suppressKeyPressRepeat flag to avoid handling keypress
		// events when we know the keydown event was used to modify the
		// search term. #7799
		var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
			nodeName = this.element[ 0 ].nodeName.toLowerCase(),
			isTextarea = nodeName === "textarea",
			isInput = nodeName === "input";

		// Textareas are always multi-line
		// Inputs are always single-line, even if inside a contentEditable element
		// IE also treats inputs as contentEditable
		// All other element types are determined by whether or not they're contentEditable
		this.isMultiLine = isTextarea || !isInput && this._isContentEditable( this.element );

		this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
		this.isNewMenu = true;

		this._addClass( "ui-autocomplete-input" );
		this.element.attr( "autocomplete", "off" );

		this._on( this.element, {
			keydown: function( event ) {
				if ( this.element.prop( "readOnly" ) ) {
					suppressKeyPress = true;
					suppressInput = true;
					suppressKeyPressRepeat = true;
					return;
				}

				suppressKeyPress = false;
				suppressInput = false;
				suppressKeyPressRepeat = false;
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					suppressKeyPress = true;
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					suppressKeyPress = true;
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					suppressKeyPress = true;
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					suppressKeyPress = true;
					this._keyEvent( "next", event );
					break;
				case keyCode.ENTER:

					// when menu is open and has focus
					if ( this.menu.active ) {

						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
						this.menu.select( event );
					}
					break;
				case keyCode.TAB:
					if ( this.menu.active ) {
						this.menu.select( event );
					}
					break;
				case keyCode.ESCAPE:
					if ( this.menu.element.is( ":visible" ) ) {
						if ( !this.isMultiLine ) {
							this._value( this.term );
						}
						this.close( event );

						// Different browsers have different default behavior for escape
						// Single press can mean undo or clear
						// Double press in IE means clear the whole form
						event.preventDefault();
					}
					break;
				default:
					suppressKeyPressRepeat = true;

					// search timeout should be triggered before the input value is changed
					this._searchTimeout( event );
					break;
				}
			},
			keypress: function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
						event.preventDefault();
					}
					return;
				}
				if ( suppressKeyPressRepeat ) {
					return;
				}

				// Replicate some key handlers to allow them to repeat in Firefox and Opera
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					this._keyEvent( "next", event );
					break;
				}
			},
			input: function( event ) {
				if ( suppressInput ) {
					suppressInput = false;
					event.preventDefault();
					return;
				}
				this._searchTimeout( event );
			},
			focus: function() {
				this.selectedItem = null;
				this.previous = this._value();
			},
			blur: function( event ) {
				if ( this.cancelBlur ) {
					delete this.cancelBlur;
					return;
				}

				clearTimeout( this.searching );
				this.close( event );
				this._change( event );
			}
		} );

		this._initSource();
		this.menu = $( "<ul>" )
			.appendTo( this._appendTo() )
			.menu( {

				// disable ARIA support, the live region takes care of that
				role: null
			} )
			.hide()
			.menu( "instance" );

		this._addClass( this.menu.element, "ui-autocomplete", "ui-front" );
		this._on( this.menu.element, {
			mousedown: function( event ) {

				// prevent moving focus out of the text field
				event.preventDefault();

				// IE doesn't prevent moving focus even with event.preventDefault()
				// so we set a flag to know when we should ignore the blur event
				this.cancelBlur = true;
				this._delay( function() {
					delete this.cancelBlur;

					// Support: IE 8 only
					// Right clicking a menu item or selecting text from the menu items will
					// result in focus moving out of the input. However, we've already received
					// and ignored the blur event because of the cancelBlur flag set above. So
					// we restore focus to ensure that the menu closes properly based on the user's
					// next actions.
					if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
						this.element.trigger( "focus" );
					}
				} );
			},
			menufocus: function( event, ui ) {
				var label, item;

				// support: Firefox
				// Prevent accidental activation of menu items in Firefox (#7024 #9118)
				if ( this.isNewMenu ) {
					this.isNewMenu = false;
					if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
						this.menu.blur();

						this.document.one( "mousemove", function() {
							$( event.target ).trigger( event.originalEvent );
						} );

						return;
					}
				}

				item = ui.item.data( "ui-autocomplete-item" );
				if ( false !== this._trigger( "focus", event, { item: item } ) ) {

					// use value to match what will end up in the input, if it was a key event
					if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
						this._value( item.value );
					}
				}

				// Announce the value in the liveRegion
				label = ui.item.attr( "aria-label" ) || item.value;
				if ( label && $.trim( label ).length ) {
					this.liveRegion.children().hide();
					$( "<div>" ).text( label ).appendTo( this.liveRegion );
				}
			},
			menuselect: function( event, ui ) {
				var item = ui.item.data( "ui-autocomplete-item" ),
					previous = this.previous;

				// Only trigger when focus was lost (click on menu)
				if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
					this.element.trigger( "focus" );
					this.previous = previous;

					// #6109 - IE triggers two focus events and the second
					// is asynchronous, so we need to reset the previous
					// term synchronously and asynchronously :-(
					this._delay( function() {
						this.previous = previous;
						this.selectedItem = item;
					} );
				}

				if ( false !== this._trigger( "select", event, { item: item } ) ) {
					this._value( item.value );
				}

				// reset the term after the select event
				// this allows custom select handling to work properly
				this.term = this._value();

				this.close( event );
				this.selectedItem = item;
			}
		} );

		this.liveRegion = $( "<div>", {
			role: "status",
			"aria-live": "assertive",
			"aria-relevant": "additions"
		} )
			.appendTo( this.document[ 0 ].body );

		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_destroy: function() {
		clearTimeout( this.searching );
		this.element.removeAttr( "autocomplete" );
		this.menu.element.remove();
		this.liveRegion.remove();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( this._appendTo() );
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_isEventTargetInWidget: function( event ) {
		var menuElement = this.menu.element[ 0 ];

		return event.target === this.element[ 0 ] ||
			event.target === menuElement ||
			$.contains( menuElement, event.target );
	},

	_closeOnClickOutside: function( event ) {
		if ( !this._isEventTargetInWidget( event ) ) {
			this.close();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_initSource: function() {
		var array, url,
			that = this;
		if ( $.isArray( this.options.source ) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter( array, request.term ) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( that.xhr ) {
					that.xhr.abort();
				}
				that.xhr = $.ajax( {
					url: url,
					data: request,
					dataType: "json",
					success: function( data ) {
						response( data );
					},
					error: function() {
						response( [] );
					}
				} );
			};
		} else {
			this.source = this.options.source;
		}
	},

	_searchTimeout: function( event ) {
		clearTimeout( this.searching );
		this.searching = this._delay( function() {

			// Search if the value has changed, or if the user retypes the same value (see #7434)
			var equalValues = this.term === this._value(),
				menuVisible = this.menu.element.is( ":visible" ),
				modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

			if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
				this.selectedItem = null;
				this.search( null, event );
			}
		}, this.options.delay );
	},

	search: function( value, event ) {
		value = value != null ? value : this._value();

		// Always save the actual value, not the one passed as an argument
		this.term = this._value();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this._addClass( "ui-autocomplete-loading" );
		this.cancelSearch = false;

		this.source( { term: value }, this._response() );
	},

	_response: function() {
		var index = ++this.requestIndex;

		return $.proxy( function( content ) {
			if ( index === this.requestIndex ) {
				this.__response( content );
			}

			this.pending--;
			if ( !this.pending ) {
				this._removeClass( "ui-autocomplete-loading" );
			}
		}, this );
	},

	__response: function( content ) {
		if ( content ) {
			content = this._normalize( content );
		}
		this._trigger( "response", null, { content: content } );
		if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
			this._suggest( content );
			this._trigger( "open" );
		} else {

			// use ._close() instead of .close() so we don't cancel future searches
			this._close();
		}
	},

	close: function( event ) {
		this.cancelSearch = true;
		this._close( event );
	},

	_close: function( event ) {

		// Remove the handler that closes the menu on outside clicks
		this._off( this.document, "mousedown" );

		if ( this.menu.element.is( ":visible" ) ) {
			this.menu.element.hide();
			this.menu.blur();
			this.isNewMenu = true;
			this._trigger( "close", event );
		}
	},

	_change: function( event ) {
		if ( this.previous !== this._value() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {

		// assume all items have the right format when the first item is complete
		if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
			return items;
		}
		return $.map( items, function( item ) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend( {}, item, {
				label: item.label || item.value,
				value: item.value || item.label
			} );
		} );
	},

	_suggest: function( items ) {
		var ul = this.menu.element.empty();
		this._renderMenu( ul, items );
		this.isNewMenu = true;
		this.menu.refresh();

		// Size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend( {
			of: this.element
		}, this.options.position ) );

		if ( this.options.autoFocus ) {
			this.menu.next();
		}

		// Listen for interactions outside of the widget (#6642)
		this._on( this.document, {
			mousedown: "_closeOnClickOutside"
		} );
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(

			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	},

	_renderItem: function( ul, item ) {
		return $( "<li>" )
			.append( $( "<div>" ).text( item.label ) )
			.appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

			if ( !this.isMultiLine ) {
				this._value( this.term );
			}

			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	},

	_value: function() {
		return this.valueMethod.apply( this.element, arguments );
	},

	_keyEvent: function( keyEvent, event ) {
		if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
			this._move( keyEvent, event );

			// Prevents moving cursor to beginning/end of the text field in some browsers
			event.preventDefault();
		}
	},

	// Support: Chrome <=50
	// We should be able to just use this.element.prop( "isContentEditable" )
	// but hidden elements always report false in Chrome.
	// https://code.google.com/p/chromium/issues/detail?id=313082
	_isContentEditable: function( element ) {
		if ( !element.length ) {
			return false;
		}

		var editable = element.prop( "contentEditable" );

		if ( editable === "inherit" ) {
		  return this._isContentEditable( element.parent() );
		}

		return editable === "true";
	}
} );

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
	},
	filter: function( array, term ) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
		return $.grep( array, function( value ) {
			return matcher.test( value.label || value.value || value );
		} );
	}
} );

// Live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
	options: {
		messages: {
			noResults: "No search results.",
			results: function( amount ) {
				return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
			}
		}
	},

	__response: function( content ) {
		var message;
		this._superApply( arguments );
		if ( this.options.disabled || this.cancelSearch ) {
			return;
		}
		if ( content && content.length ) {
			message = this.options.messages.results( content.length );
		} else {
			message = this.options.messages.noResults;
		}
		this.liveRegion.children().hide();
		$( "<div>" ).text( message ).appendTo( this.liveRegion );
	}
} );

var widgetsAutocomplete = $.ui.autocomplete;


/*!
 * jQuery UI Controlgroup 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Controlgroup
//>>group: Widgets
//>>description: Visually groups form control widgets
//>>docs: http://api.jqueryui.com/controlgroup/
//>>demos: http://jqueryui.com/controlgroup/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/controlgroup.css
//>>css.theme: ../../themes/base/theme.css


var controlgroupCornerRegex = /ui-corner-([a-z]){2,6}/g;

var widgetsControlgroup = $.widget( "ui.controlgroup", {
	version: "1.12.1",
	defaultElement: "<div>",
	options: {
		direction: "horizontal",
		disabled: null,
		onlyVisible: true,
		items: {
			"button": "input[type=button], input[type=submit], input[type=reset], button, a",
			"controlgroupLabel": ".ui-controlgroup-label",
			"checkboxradio": "input[type='checkbox'], input[type='radio']",
			"selectmenu": "select",
			"spinner": ".ui-spinner-input"
		}
	},

	_create: function() {
		this._enhance();
	},

	// To support the enhanced option in jQuery Mobile, we isolate DOM manipulation
	_enhance: function() {
		this.element.attr( "role", "toolbar" );
		this.refresh();
	},

	_destroy: function() {
		this._callChildMethod( "destroy" );
		this.childWidgets.removeData( "ui-controlgroup-data" );
		this.element.removeAttr( "role" );
		if ( this.options.items.controlgroupLabel ) {
			this.element
				.find( this.options.items.controlgroupLabel )
				.find( ".ui-controlgroup-label-contents" )
				.contents().unwrap();
		}
	},

	_initWidgets: function() {
		var that = this,
			childWidgets = [];

		// First we iterate over each of the items options
		$.each( this.options.items, function( widget, selector ) {
			var labels;
			var options = {};

			// Make sure the widget has a selector set
			if ( !selector ) {
				return;
			}

			if ( widget === "controlgroupLabel" ) {
				labels = that.element.find( selector );
				labels.each( function() {
					var element = $( this );

					if ( element.children( ".ui-controlgroup-label-contents" ).length ) {
						return;
					}
					element.contents()
						.wrapAll( "<span class='ui-controlgroup-label-contents'></span>" );
				} );
				that._addClass( labels, null, "ui-widget ui-widget-content ui-state-default" );
				childWidgets = childWidgets.concat( labels.get() );
				return;
			}

			// Make sure the widget actually exists
			if ( !$.fn[ widget ] ) {
				return;
			}

			// We assume everything is in the middle to start because we can't determine
			// first / last elements until all enhancments are done.
			if ( that[ "_" + widget + "Options" ] ) {
				options = that[ "_" + widget + "Options" ]( "middle" );
			} else {
				options = { classes: {} };
			}

			// Find instances of this widget inside controlgroup and init them
			that.element
				.find( selector )
				.each( function() {
					var element = $( this );
					var instance = element[ widget ]( "instance" );

					// We need to clone the default options for this type of widget to avoid
					// polluting the variable options which has a wider scope than a single widget.
					var instanceOptions = $.widget.extend( {}, options );

					// If the button is the child of a spinner ignore it
					// TODO: Find a more generic solution
					if ( widget === "button" && element.parent( ".ui-spinner" ).length ) {
						return;
					}

					// Create the widget if it doesn't exist
					if ( !instance ) {
						instance = element[ widget ]()[ widget ]( "instance" );
					}
					if ( instance ) {
						instanceOptions.classes =
							that._resolveClassesValues( instanceOptions.classes, instance );
					}
					element[ widget ]( instanceOptions );

					// Store an instance of the controlgroup to be able to reference
					// from the outermost element for changing options and refresh
					var widgetElement = element[ widget ]( "widget" );
					$.data( widgetElement[ 0 ], "ui-controlgroup-data",
						instance ? instance : element[ widget ]( "instance" ) );

					childWidgets.push( widgetElement[ 0 ] );
				} );
		} );

		this.childWidgets = $( $.uniqueSort( childWidgets ) );
		this._addClass( this.childWidgets, "ui-controlgroup-item" );
	},

	_callChildMethod: function( method ) {
		this.childWidgets.each( function() {
			var element = $( this ),
				data = element.data( "ui-controlgroup-data" );
			if ( data && data[ method ] ) {
				data[ method ]();
			}
		} );
	},

	_updateCornerClass: function( element, position ) {
		var remove = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all";
		var add = this._buildSimpleOptions( position, "label" ).classes.label;

		this._removeClass( element, null, remove );
		this._addClass( element, null, add );
	},

	_buildSimpleOptions: function( position, key ) {
		var direction = this.options.direction === "vertical";
		var result = {
			classes: {}
		};
		result.classes[ key ] = {
			"middle": "",
			"first": "ui-corner-" + ( direction ? "top" : "left" ),
			"last": "ui-corner-" + ( direction ? "bottom" : "right" ),
			"only": "ui-corner-all"
		}[ position ];

		return result;
	},

	_spinnerOptions: function( position ) {
		var options = this._buildSimpleOptions( position, "ui-spinner" );

		options.classes[ "ui-spinner-up" ] = "";
		options.classes[ "ui-spinner-down" ] = "";

		return options;
	},

	_buttonOptions: function( position ) {
		return this._buildSimpleOptions( position, "ui-button" );
	},

	_checkboxradioOptions: function( position ) {
		return this._buildSimpleOptions( position, "ui-checkboxradio-label" );
	},

	_selectmenuOptions: function( position ) {
		var direction = this.options.direction === "vertical";
		return {
			width: direction ? "auto" : false,
			classes: {
				middle: {
					"ui-selectmenu-button-open": "",
					"ui-selectmenu-button-closed": ""
				},
				first: {
					"ui-selectmenu-button-open": "ui-corner-" + ( direction ? "top" : "tl" ),
					"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "top" : "left" )
				},
				last: {
					"ui-selectmenu-button-open": direction ? "" : "ui-corner-tr",
					"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "bottom" : "right" )
				},
				only: {
					"ui-selectmenu-button-open": "ui-corner-top",
					"ui-selectmenu-button-closed": "ui-corner-all"
				}

			}[ position ]
		};
	},

	_resolveClassesValues: function( classes, instance ) {
		var result = {};
		$.each( classes, function( key ) {
			var current = instance.options.classes[ key ] || "";
			current = $.trim( current.replace( controlgroupCornerRegex, "" ) );
			result[ key ] = ( current + " " + classes[ key ] ).replace( /\s+/g, " " );
		} );
		return result;
	},

	_setOption: function( key, value ) {
		if ( key === "direction" ) {
			this._removeClass( "ui-controlgroup-" + this.options.direction );
		}

		this._super( key, value );
		if ( key === "disabled" ) {
			this._callChildMethod( value ? "disable" : "enable" );
			return;
		}

		this.refresh();
	},

	refresh: function() {
		var children,
			that = this;

		this._addClass( "ui-controlgroup ui-controlgroup-" + this.options.direction );

		if ( this.options.direction === "horizontal" ) {
			this._addClass( null, "ui-helper-clearfix" );
		}
		this._initWidgets();

		children = this.childWidgets;

		// We filter here because we need to track all childWidgets not just the visible ones
		if ( this.options.onlyVisible ) {
			children = children.filter( ":visible" );
		}

		if ( children.length ) {

			// We do this last because we need to make sure all enhancment is done
			// before determining first and last
			$.each( [ "first", "last" ], function( index, value ) {
				var instance = children[ value ]().data( "ui-controlgroup-data" );

				if ( instance && that[ "_" + instance.widgetName + "Options" ] ) {
					var options = that[ "_" + instance.widgetName + "Options" ](
						children.length === 1 ? "only" : value
					);
					options.classes = that._resolveClassesValues( options.classes, instance );
					instance.element[ instance.widgetName ]( options );
				} else {
					that._updateCornerClass( children[ value ](), value );
				}
			} );

			// Finally call the refresh method on each of the child widgets.
			this._callChildMethod( "refresh" );
		}
	}
} );

/*!
 * jQuery UI Checkboxradio 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Checkboxradio
//>>group: Widgets
//>>description: Enhances a form with multiple themeable checkboxes or radio buttons.
//>>docs: http://api.jqueryui.com/checkboxradio/
//>>demos: http://jqueryui.com/checkboxradio/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/button.css
//>>css.structure: ../../themes/base/checkboxradio.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.checkboxradio", [ $.ui.formResetMixin, {
	version: "1.12.1",
	options: {
		disabled: null,
		label: null,
		icon: true,
		classes: {
			"ui-checkboxradio-label": "ui-corner-all",
			"ui-checkboxradio-icon": "ui-corner-all"
		}
	},

	_getCreateOptions: function() {
		var disabled, labels;
		var that = this;
		var options = this._super() || {};

		// We read the type here, because it makes more sense to throw a element type error first,
		// rather then the error for lack of a label. Often if its the wrong type, it
		// won't have a label (e.g. calling on a div, btn, etc)
		this._readType();

		labels = this.element.labels();

		// If there are multiple labels, use the last one
		this.label = $( labels[ labels.length - 1 ] );
		if ( !this.label.length ) {
			$.error( "No label found for checkboxradio widget" );
		}

		this.originalLabel = "";

		// We need to get the label text but this may also need to make sure it does not contain the
		// input itself.
		this.label.contents().not( this.element[ 0 ] ).each( function() {

			// The label contents could be text, html, or a mix. We concat each element to get a
			// string representation of the label, without the input as part of it.
			that.originalLabel += this.nodeType === 3 ? $( this ).text() : this.outerHTML;
		} );

		// Set the label option if we found label text
		if ( this.originalLabel ) {
			options.label = this.originalLabel;
		}

		disabled = this.element[ 0 ].disabled;
		if ( disabled != null ) {
			options.disabled = disabled;
		}
		return options;
	},

	_create: function() {
		var checked = this.element[ 0 ].checked;

		this._bindFormResetHandler();

		if ( this.options.disabled == null ) {
			this.options.disabled = this.element[ 0 ].disabled;
		}

		this._setOption( "disabled", this.options.disabled );
		this._addClass( "ui-checkboxradio", "ui-helper-hidden-accessible" );
		this._addClass( this.label, "ui-checkboxradio-label", "ui-button ui-widget" );

		if ( this.type === "radio" ) {
			this._addClass( this.label, "ui-checkboxradio-radio-label" );
		}

		if ( this.options.label && this.options.label !== this.originalLabel ) {
			this._updateLabel();
		} else if ( this.originalLabel ) {
			this.options.label = this.originalLabel;
		}

		this._enhance();

		if ( checked ) {
			this._addClass( this.label, "ui-checkboxradio-checked", "ui-state-active" );
			if ( this.icon ) {
				this._addClass( this.icon, null, "ui-state-hover" );
			}
		}

		this._on( {
			change: "_toggleClasses",
			focus: function() {
				this._addClass( this.label, null, "ui-state-focus ui-visual-focus" );
			},
			blur: function() {
				this._removeClass( this.label, null, "ui-state-focus ui-visual-focus" );
			}
		} );
	},

	_readType: function() {
		var nodeName = this.element[ 0 ].nodeName.toLowerCase();
		this.type = this.element[ 0 ].type;
		if ( nodeName !== "input" || !/radio|checkbox/.test( this.type ) ) {
			$.error( "Can't create checkboxradio on element.nodeName=" + nodeName +
				" and element.type=" + this.type );
		}
	},

	// Support jQuery Mobile enhanced option
	_enhance: function() {
		this._updateIcon( this.element[ 0 ].checked );
	},

	widget: function() {
		return this.label;
	},

	_getRadioGroup: function() {
		var group;
		var name = this.element[ 0 ].name;
		var nameSelector = "input[name='" + $.ui.escapeSelector( name ) + "']";

		if ( !name ) {
			return $( [] );
		}

		if ( this.form.length ) {
			group = $( this.form[ 0 ].elements ).filter( nameSelector );
		} else {

			// Not inside a form, check all inputs that also are not inside a form
			group = $( nameSelector ).filter( function() {
				return $( this ).form().length === 0;
			} );
		}

		return group.not( this.element );
	},

	_toggleClasses: function() {
		var checked = this.element[ 0 ].checked;
		this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );

		if ( this.options.icon && this.type === "checkbox" ) {
			this._toggleClass( this.icon, null, "ui-icon-check ui-state-checked", checked )
				._toggleClass( this.icon, null, "ui-icon-blank", !checked );
		}

		if ( this.type === "radio" ) {
			this._getRadioGroup()
				.each( function() {
					var instance = $( this ).checkboxradio( "instance" );

					if ( instance ) {
						instance._removeClass( instance.label,
							"ui-checkboxradio-checked", "ui-state-active" );
					}
				} );
		}
	},

	_destroy: function() {
		this._unbindFormResetHandler();

		if ( this.icon ) {
			this.icon.remove();
			this.iconSpace.remove();
		}
	},

	_setOption: function( key, value ) {

		// We don't allow the value to be set to nothing
		if ( key === "label" && !value ) {
			return;
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this._toggleClass( this.label, null, "ui-state-disabled", value );
			this.element[ 0 ].disabled = value;

			// Don't refresh when setting disabled
			return;
		}
		this.refresh();
	},

	_updateIcon: function( checked ) {
		var toAdd = "ui-icon ui-icon-background ";

		if ( this.options.icon ) {
			if ( !this.icon ) {
				this.icon = $( "<span>" );
				this.iconSpace = $( "<span> </span>" );
				this._addClass( this.iconSpace, "ui-checkboxradio-icon-space" );
			}

			if ( this.type === "checkbox" ) {
				toAdd += checked ? "ui-icon-check ui-state-checked" : "ui-icon-blank";
				this._removeClass( this.icon, null, checked ? "ui-icon-blank" : "ui-icon-check" );
			} else {
				toAdd += "ui-icon-blank";
			}
			this._addClass( this.icon, "ui-checkboxradio-icon", toAdd );
			if ( !checked ) {
				this._removeClass( this.icon, null, "ui-icon-check ui-state-checked" );
			}
			this.icon.prependTo( this.label ).after( this.iconSpace );
		} else if ( this.icon !== undefined ) {
			this.icon.remove();
			this.iconSpace.remove();
			delete this.icon;
		}
	},

	_updateLabel: function() {

		// Remove the contents of the label ( minus the icon, icon space, and input )
		var contents = this.label.contents().not( this.element[ 0 ] );
		if ( this.icon ) {
			contents = contents.not( this.icon[ 0 ] );
		}
		if ( this.iconSpace ) {
			contents = contents.not( this.iconSpace[ 0 ] );
		}
		contents.remove();

		this.label.append( this.options.label );
	},

	refresh: function() {
		var checked = this.element[ 0 ].checked,
			isDisabled = this.element[ 0 ].disabled;

		this._updateIcon( checked );
		this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );
		if ( this.options.label !== null ) {
			this._updateLabel();
		}

		if ( isDisabled !== this.options.disabled ) {
			this._setOptions( { "disabled": isDisabled } );
		}
	}

} ] );

var widgetsCheckboxradio = $.ui.checkboxradio;


/*!
 * jQuery UI Button 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Button
//>>group: Widgets
//>>description: Enhances a form with themeable buttons.
//>>docs: http://api.jqueryui.com/button/
//>>demos: http://jqueryui.com/button/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/button.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.button", {
	version: "1.12.1",
	defaultElement: "<button>",
	options: {
		classes: {
			"ui-button": "ui-corner-all"
		},
		disabled: null,
		icon: null,
		iconPosition: "beginning",
		label: null,
		showLabel: true
	},

	_getCreateOptions: function() {
		var disabled,

			// This is to support cases like in jQuery Mobile where the base widget does have
			// an implementation of _getCreateOptions
			options = this._super() || {};

		this.isInput = this.element.is( "input" );

		disabled = this.element[ 0 ].disabled;
		if ( disabled != null ) {
			options.disabled = disabled;
		}

		this.originalLabel = this.isInput ? this.element.val() : this.element.html();
		if ( this.originalLabel ) {
			options.label = this.originalLabel;
		}

		return options;
	},

	_create: function() {
		if ( !this.option.showLabel & !this.options.icon ) {
			this.options.showLabel = true;
		}

		// We have to check the option again here even though we did in _getCreateOptions,
		// because null may have been passed on init which would override what was set in
		// _getCreateOptions
		if ( this.options.disabled == null ) {
			this.options.disabled = this.element[ 0 ].disabled || false;
		}

		this.hasTitle = !!this.element.attr( "title" );

		// Check to see if the label needs to be set or if its already correct
		if ( this.options.label && this.options.label !== this.originalLabel ) {
			if ( this.isInput ) {
				this.element.val( this.options.label );
			} else {
				this.element.html( this.options.label );
			}
		}
		this._addClass( "ui-button", "ui-widget" );
		this._setOption( "disabled", this.options.disabled );
		this._enhance();

		if ( this.element.is( "a" ) ) {
			this._on( {
				"keyup": function( event ) {
					if ( event.keyCode === $.ui.keyCode.SPACE ) {
						event.preventDefault();

						// Support: PhantomJS <= 1.9, IE 8 Only
						// If a native click is available use it so we actually cause navigation
						// otherwise just trigger a click event
						if ( this.element[ 0 ].click ) {
							this.element[ 0 ].click();
						} else {
							this.element.trigger( "click" );
						}
					}
				}
			} );
		}
	},

	_enhance: function() {
		if ( !this.element.is( "button" ) ) {
			this.element.attr( "role", "button" );
		}

		if ( this.options.icon ) {
			this._updateIcon( "icon", this.options.icon );
			this._updateTooltip();
		}
	},

	_updateTooltip: function() {
		this.title = this.element.attr( "title" );

		if ( !this.options.showLabel && !this.title ) {
			this.element.attr( "title", this.options.label );
		}
	},

	_updateIcon: function( option, value ) {
		var icon = option !== "iconPosition",
			position = icon ? this.options.iconPosition : value,
			displayBlock = position === "top" || position === "bottom";

		// Create icon
		if ( !this.icon ) {
			this.icon = $( "<span>" );

			this._addClass( this.icon, "ui-button-icon", "ui-icon" );

			if ( !this.options.showLabel ) {
				this._addClass( "ui-button-icon-only" );
			}
		} else if ( icon ) {

			// If we are updating the icon remove the old icon class
			this._removeClass( this.icon, null, this.options.icon );
		}

		// If we are updating the icon add the new icon class
		if ( icon ) {
			this._addClass( this.icon, null, value );
		}

		this._attachIcon( position );

		// If the icon is on top or bottom we need to add the ui-widget-icon-block class and remove
		// the iconSpace if there is one.
		if ( displayBlock ) {
			this._addClass( this.icon, null, "ui-widget-icon-block" );
			if ( this.iconSpace ) {
				this.iconSpace.remove();
			}
		} else {

			// Position is beginning or end so remove the ui-widget-icon-block class and add the
			// space if it does not exist
			if ( !this.iconSpace ) {
				this.iconSpace = $( "<span> </span>" );
				this._addClass( this.iconSpace, "ui-button-icon-space" );
			}
			this._removeClass( this.icon, null, "ui-wiget-icon-block" );
			this._attachIconSpace( position );
		}
	},

	_destroy: function() {
		this.element.removeAttr( "role" );

		if ( this.icon ) {
			this.icon.remove();
		}
		if ( this.iconSpace ) {
			this.iconSpace.remove();
		}
		if ( !this.hasTitle ) {
			this.element.removeAttr( "title" );
		}
	},

	_attachIconSpace: function( iconPosition ) {
		this.icon[ /^(?:end|bottom)/.test( iconPosition ) ? "before" : "after" ]( this.iconSpace );
	},

	_attachIcon: function( iconPosition ) {
		this.element[ /^(?:end|bottom)/.test( iconPosition ) ? "append" : "prepend" ]( this.icon );
	},

	_setOptions: function( options ) {
		var newShowLabel = options.showLabel === undefined ?
				this.options.showLabel :
				options.showLabel,
			newIcon = options.icon === undefined ? this.options.icon : options.icon;

		if ( !newShowLabel && !newIcon ) {
			options.showLabel = true;
		}
		this._super( options );
	},

	_setOption: function( key, value ) {
		if ( key === "icon" ) {
			if ( value ) {
				this._updateIcon( key, value );
			} else if ( this.icon ) {
				this.icon.remove();
				if ( this.iconSpace ) {
					this.iconSpace.remove();
				}
			}
		}

		if ( key === "iconPosition" ) {
			this._updateIcon( key, value );
		}

		// Make sure we can't end up with a button that has neither text nor icon
		if ( key === "showLabel" ) {
				this._toggleClass( "ui-button-icon-only", null, !value );
				this._updateTooltip();
		}

		if ( key === "label" ) {
			if ( this.isInput ) {
				this.element.val( value );
			} else {

				// If there is an icon, append it, else nothing then append the value
				// this avoids removal of the icon when setting label text
				this.element.html( value );
				if ( this.icon ) {
					this._attachIcon( this.options.iconPosition );
					this._attachIconSpace( this.options.iconPosition );
				}
			}
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this._toggleClass( null, "ui-state-disabled", value );
			this.element[ 0 ].disabled = value;
			if ( value ) {
				this.element.blur();
			}
		}
	},

	refresh: function() {

		// Make sure to only check disabled if its an element that supports this otherwise
		// check for the disabled class to determine state
		var isDisabled = this.element.is( "input, button" ) ?
			this.element[ 0 ].disabled : this.element.hasClass( "ui-button-disabled" );

		if ( isDisabled !== this.options.disabled ) {
			this._setOptions( { disabled: isDisabled } );
		}

		this._updateTooltip();
	}
} );

// DEPRECATED
if ( $.uiBackCompat !== false ) {

	// Text and Icons options
	$.widget( "ui.button", $.ui.button, {
		options: {
			text: true,
			icons: {
				primary: null,
				secondary: null
			}
		},

		_create: function() {
			if ( this.options.showLabel && !this.options.text ) {
				this.options.showLabel = this.options.text;
			}
			if ( !this.options.showLabel && this.options.text ) {
				this.options.text = this.options.showLabel;
			}
			if ( !this.options.icon && ( this.options.icons.primary ||
					this.options.icons.secondary ) ) {
				if ( this.options.icons.primary ) {
					this.options.icon = this.options.icons.primary;
				} else {
					this.options.icon = this.options.icons.secondary;
					this.options.iconPosition = "end";
				}
			} else if ( this.options.icon ) {
				this.options.icons.primary = this.options.icon;
			}
			this._super();
		},

		_setOption: function( key, value ) {
			if ( key === "text" ) {
				this._super( "showLabel", value );
				return;
			}
			if ( key === "showLabel" ) {
				this.options.text = value;
			}
			if ( key === "icon" ) {
				this.options.icons.primary = value;
			}
			if ( key === "icons" ) {
				if ( value.primary ) {
					this._super( "icon", value.primary );
					this._super( "iconPosition", "beginning" );
				} else if ( value.secondary ) {
					this._super( "icon", value.secondary );
					this._super( "iconPosition", "end" );
				}
			}
			this._superApply( arguments );
		}
	} );

	$.fn.button = ( function( orig ) {
		return function() {
			if ( !this.length || ( this.length && this[ 0 ].tagName !== "INPUT" ) ||
					( this.length && this[ 0 ].tagName === "INPUT" && (
						this.attr( "type" ) !== "checkbox" && this.attr( "type" ) !== "radio"
					) ) ) {
				return orig.apply( this, arguments );
			}
			if ( !$.ui.checkboxradio ) {
				$.error( "Checkboxradio widget missing" );
			}
			if ( arguments.length === 0 ) {
				return this.checkboxradio( {
					"icon": false
				} );
			}
			return this.checkboxradio.apply( this, arguments );
		};
	} )( $.fn.button );

	$.fn.buttonset = function() {
		if ( !$.ui.controlgroup ) {
			$.error( "Controlgroup widget missing" );
		}
		if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" && arguments[ 2 ] ) {
			return this.controlgroup.apply( this,
				[ arguments[ 0 ], "items.button", arguments[ 2 ] ] );
		}
		if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" ) {
			return this.controlgroup.apply( this, [ arguments[ 0 ], "items.button" ] );
		}
		if ( typeof arguments[ 0 ] === "object" && arguments[ 0 ].items ) {
			arguments[ 0 ].items = {
				button: arguments[ 0 ].items
			};
		}
		return this.controlgroup.apply( this, arguments );
	};
}

var widgetsButton = $.ui.button;


// jscs:disable maximumLineLength
/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
/*!
 * jQuery UI Datepicker 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Datepicker
//>>group: Widgets
//>>description: Displays a calendar from an input or inline for selecting dates.
//>>docs: http://api.jqueryui.com/datepicker/
//>>demos: http://jqueryui.com/datepicker/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/datepicker.css
//>>css.theme: ../../themes/base/theme.css



$.extend( $.ui, { datepicker: { version: "1.12.1" } } );

var datepicker_instActive;

function datepicker_getZindex( elem ) {
	var position, value;
	while ( elem.length && elem[ 0 ] !== document ) {

		// Ignore z-index if position is set to a value where z-index is ignored by the browser
		// This makes behavior of this function consistent across browsers
		// WebKit always returns auto if the element is positioned
		position = elem.css( "position" );
		if ( position === "absolute" || position === "relative" || position === "fixed" ) {

			// IE returns 0 when zIndex is not specified
			// other browsers return a string
			// we ignore the case of nested elements with an explicit value of 0
			// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
			value = parseInt( elem.css( "zIndex" ), 10 );
			if ( !isNaN( value ) && value !== 0 ) {
				return value;
			}
		}
		elem = elem.parent();
	}

	return 0;
}
/* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

function Datepicker() {
	this._curInst = null; // The current instance in use
	this._keyEvent = false; // If the last event was a key event
	this._disabledInputs = []; // List of date picker inputs that have been disabled
	this._datepickerShowing = false; // True if the popup picker is showing , false if not
	this._inDialog = false; // True if showing within a "dialog", false if not
	this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
	this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
	this._appendClass = "ui-datepicker-append"; // The name of the append marker class
	this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
	this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
	this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
	this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
	this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
	this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
	this.regional = []; // Available regional settings, indexed by language code
	this.regional[ "" ] = { // Default regional settings
		closeText: "Done", // Display text for close link
		prevText: "Prev", // Display text for previous month link
		nextText: "Next", // Display text for next month link
		currentText: "Today", // Display text for current month link
		monthNames: [ "January","February","March","April","May","June",
			"July","August","September","October","November","December" ], // Names of months for drop-down and formatting
		monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ], // For formatting
		dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ], // For formatting
		dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ], // For formatting
		dayNamesMin: [ "Su","Mo","Tu","We","Th","Fr","Sa" ], // Column headings for days starting at Sunday
		weekHeader: "Wk", // Column header for week of the year
		dateFormat: "mm/dd/yy", // See format options on parseDate
		firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
		isRTL: false, // True if right-to-left language, false if left-to-right
		showMonthAfterYear: false, // True if the year select precedes month, false for month then year
		yearSuffix: "" // Additional text to append to the year in the month headers
	};
	this._defaults = { // Global defaults for all the date picker instances
		showOn: "focus", // "focus" for popup on focus,
			// "button" for trigger button, or "both" for either
		showAnim: "fadeIn", // Name of jQuery animation for popup
		showOptions: {}, // Options for enhanced animations
		defaultDate: null, // Used when field is blank: actual date,
			// +/-number for offset from today, null for today
		appendText: "", // Display text following the input box, e.g. showing the format
		buttonText: "...", // Text for trigger button
		buttonImage: "", // URL for trigger button image
		buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
		hideIfNoPrevNext: false, // True to hide next/previous month links
			// if not applicable, false to just disable them
		navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
		gotoCurrent: false, // True if today link goes back to current selection instead
		changeMonth: false, // True if month can be selected directly, false if only prev/next
		changeYear: false, // True if year can be selected directly, false if only prev/next
		yearRange: "c-10:c+10", // Range of years to display in drop-down,
			// either relative to today's year (-nn:+nn), relative to currently displayed year
			// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
		showOtherMonths: false, // True to show dates in other months, false to leave blank
		selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
		showWeek: false, // True to show week of the year, false to not show it
		calculateWeek: this.iso8601Week, // How to calculate the week of the year,
			// takes a Date and returns the number of the week for it
		shortYearCutoff: "+10", // Short year values < this are in the current century,
			// > this are in the previous century,
			// string value starting with "+" for current year + value
		minDate: null, // The earliest selectable date, or null for no limit
		maxDate: null, // The latest selectable date, or null for no limit
		duration: "fast", // Duration of display/closure
		beforeShowDay: null, // Function that takes a date and returns an array with
			// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
			// [2] = cell title (optional), e.g. $.datepicker.noWeekends
		beforeShow: null, // Function that takes an input field and
			// returns a set of custom settings for the date picker
		onSelect: null, // Define a callback function when a date is selected
		onChangeMonthYear: null, // Define a callback function when the month or year is changed
		onClose: null, // Define a callback function when the datepicker is closed
		numberOfMonths: 1, // Number of months to show at a time
		showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
		stepMonths: 1, // Number of months to step back/forward
		stepBigMonths: 12, // Number of months to step back/forward for the big links
		altField: "", // Selector for an alternate field to store selected dates into
		altFormat: "", // The date format to use for the alternate field
		constrainInput: true, // The input is constrained by the current date format
		showButtonPanel: false, // True to show button panel, false to not show it
		autoSize: false, // True to size the input for the date format, false to leave as is
		disabled: false // The initial disabled state
	};
	$.extend( this._defaults, this.regional[ "" ] );
	this.regional.en = $.extend( true, {}, this.regional[ "" ] );
	this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
	this.dpDiv = datepicker_bindHover( $( "<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) );
}

$.extend( Datepicker.prototype, {
	/* Class name added to elements to indicate already configured with a date picker. */
	markerClassName: "hasDatepicker",

	//Keep track of the maximum number of rows displayed (see #7043)
	maxRows: 4,

	// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker: function() {
		return this.dpDiv;
	},

	/* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */
	setDefaults: function( settings ) {
		datepicker_extendRemove( this._defaults, settings || {} );
		return this;
	},

	/* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */
	_attachDatepicker: function( target, settings ) {
		var nodeName, inline, inst;
		nodeName = target.nodeName.toLowerCase();
		inline = ( nodeName === "div" || nodeName === "span" );
		if ( !target.id ) {
			this.uuid += 1;
			target.id = "dp" + this.uuid;
		}
		inst = this._newInst( $( target ), inline );
		inst.settings = $.extend( {}, settings || {} );
		if ( nodeName === "input" ) {
			this._connectDatepicker( target, inst );
		} else if ( inline ) {
			this._inlineDatepicker( target, inst );
		}
	},

	/* Create a new instance object. */
	_newInst: function( target, inline ) {
		var id = target[ 0 ].id.replace( /([^A-Za-z0-9_\-])/g, "\\\\$1" ); // escape jQuery meta chars
		return { id: id, input: target, // associated target
			selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
			drawMonth: 0, drawYear: 0, // month being drawn
			inline: inline, // is datepicker inline or not
			dpDiv: ( !inline ? this.dpDiv : // presentation div
			datepicker_bindHover( $( "<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) ) ) };
	},

	/* Attach the date picker to an input field. */
	_connectDatepicker: function( target, inst ) {
		var input = $( target );
		inst.append = $( [] );
		inst.trigger = $( [] );
		if ( input.hasClass( this.markerClassName ) ) {
			return;
		}
		this._attachments( input, inst );
		input.addClass( this.markerClassName ).on( "keydown", this._doKeyDown ).
			on( "keypress", this._doKeyPress ).on( "keyup", this._doKeyUp );
		this._autoSize( inst );
		$.data( target, "datepicker", inst );

		//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
		if ( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
	},

	/* Make attachments based on settings. */
	_attachments: function( input, inst ) {
		var showOn, buttonText, buttonImage,
			appendText = this._get( inst, "appendText" ),
			isRTL = this._get( inst, "isRTL" );

		if ( inst.append ) {
			inst.append.remove();
		}
		if ( appendText ) {
			inst.append = $( "<span class='" + this._appendClass + "'>" + appendText + "</span>" );
			input[ isRTL ? "before" : "after" ]( inst.append );
		}

		input.off( "focus", this._showDatepicker );

		if ( inst.trigger ) {
			inst.trigger.remove();
		}

		showOn = this._get( inst, "showOn" );
		if ( showOn === "focus" || showOn === "both" ) { // pop-up date picker when in the marked field
			input.on( "focus", this._showDatepicker );
		}
		if ( showOn === "button" || showOn === "both" ) { // pop-up date picker when button clicked
			buttonText = this._get( inst, "buttonText" );
			buttonImage = this._get( inst, "buttonImage" );
			inst.trigger = $( this._get( inst, "buttonImageOnly" ) ?
				$( "<img/>" ).addClass( this._triggerClass ).
					attr( { src: buttonImage, alt: buttonText, title: buttonText } ) :
				$( "<button type='button'></button>" ).addClass( this._triggerClass ).
					html( !buttonImage ? buttonText : $( "<img/>" ).attr(
					{ src:buttonImage, alt:buttonText, title:buttonText } ) ) );
			input[ isRTL ? "before" : "after" ]( inst.trigger );
			inst.trigger.on( "click", function() {
				if ( $.datepicker._datepickerShowing && $.datepicker._lastInput === input[ 0 ] ) {
					$.datepicker._hideDatepicker();
				} else if ( $.datepicker._datepickerShowing && $.datepicker._lastInput !== input[ 0 ] ) {
					$.datepicker._hideDatepicker();
					$.datepicker._showDatepicker( input[ 0 ] );
				} else {
					$.datepicker._showDatepicker( input[ 0 ] );
				}
				return false;
			} );
		}
	},

	/* Apply the maximum length for the date format. */
	_autoSize: function( inst ) {
		if ( this._get( inst, "autoSize" ) && !inst.inline ) {
			var findMax, max, maxI, i,
				date = new Date( 2009, 12 - 1, 20 ), // Ensure double digits
				dateFormat = this._get( inst, "dateFormat" );

			if ( dateFormat.match( /[DM]/ ) ) {
				findMax = function( names ) {
					max = 0;
					maxI = 0;
					for ( i = 0; i < names.length; i++ ) {
						if ( names[ i ].length > max ) {
							max = names[ i ].length;
							maxI = i;
						}
					}
					return maxI;
				};
				date.setMonth( findMax( this._get( inst, ( dateFormat.match( /MM/ ) ?
					"monthNames" : "monthNamesShort" ) ) ) );
				date.setDate( findMax( this._get( inst, ( dateFormat.match( /DD/ ) ?
					"dayNames" : "dayNamesShort" ) ) ) + 20 - date.getDay() );
			}
			inst.input.attr( "size", this._formatDate( inst, date ).length );
		}
	},

	/* Attach an inline date picker to a div. */
	_inlineDatepicker: function( target, inst ) {
		var divSpan = $( target );
		if ( divSpan.hasClass( this.markerClassName ) ) {
			return;
		}
		divSpan.addClass( this.markerClassName ).append( inst.dpDiv );
		$.data( target, "datepicker", inst );
		this._setDate( inst, this._getDefaultDate( inst ), true );
		this._updateDatepicker( inst );
		this._updateAlternate( inst );

		//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
		if ( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}

		// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
		// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
		inst.dpDiv.css( "display", "block" );
	},

	/* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */
	_dialogDatepicker: function( input, date, onSelect, settings, pos ) {
		var id, browserWidth, browserHeight, scrollX, scrollY,
			inst = this._dialogInst; // internal instance

		if ( !inst ) {
			this.uuid += 1;
			id = "dp" + this.uuid;
			this._dialogInput = $( "<input type='text' id='" + id +
				"' style='position: absolute; top: -100px; width: 0px;'/>" );
			this._dialogInput.on( "keydown", this._doKeyDown );
			$( "body" ).append( this._dialogInput );
			inst = this._dialogInst = this._newInst( this._dialogInput, false );
			inst.settings = {};
			$.data( this._dialogInput[ 0 ], "datepicker", inst );
		}
		datepicker_extendRemove( inst.settings, settings || {} );
		date = ( date && date.constructor === Date ? this._formatDate( inst, date ) : date );
		this._dialogInput.val( date );

		this._pos = ( pos ? ( pos.length ? pos : [ pos.pageX, pos.pageY ] ) : null );
		if ( !this._pos ) {
			browserWidth = document.documentElement.clientWidth;
			browserHeight = document.documentElement.clientHeight;
			scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			this._pos = // should use actual width/height below
				[ ( browserWidth / 2 ) - 100 + scrollX, ( browserHeight / 2 ) - 150 + scrollY ];
		}

		// Move input on screen for focus, but hidden behind dialog
		this._dialogInput.css( "left", ( this._pos[ 0 ] + 20 ) + "px" ).css( "top", this._pos[ 1 ] + "px" );
		inst.settings.onSelect = onSelect;
		this._inDialog = true;
		this.dpDiv.addClass( this._dialogClass );
		this._showDatepicker( this._dialogInput[ 0 ] );
		if ( $.blockUI ) {
			$.blockUI( this.dpDiv );
		}
		$.data( this._dialogInput[ 0 ], "datepicker", inst );
		return this;
	},

	/* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */
	_destroyDatepicker: function( target ) {
		var nodeName,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		$.removeData( target, "datepicker" );
		if ( nodeName === "input" ) {
			inst.append.remove();
			inst.trigger.remove();
			$target.removeClass( this.markerClassName ).
				off( "focus", this._showDatepicker ).
				off( "keydown", this._doKeyDown ).
				off( "keypress", this._doKeyPress ).
				off( "keyup", this._doKeyUp );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			$target.removeClass( this.markerClassName ).empty();
		}

		if ( datepicker_instActive === inst ) {
			datepicker_instActive = null;
		}
	},

	/* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_enableDatepicker: function( target ) {
		var nodeName, inline,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if ( nodeName === "input" ) {
			target.disabled = false;
			inst.trigger.filter( "button" ).
				each( function() { this.disabled = false; } ).end().
				filter( "img" ).css( { opacity: "1.0", cursor: "" } );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			inline = $target.children( "." + this._inlineClass );
			inline.children().removeClass( "ui-state-disabled" );
			inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
				prop( "disabled", false );
		}
		this._disabledInputs = $.map( this._disabledInputs,
			function( value ) { return ( value === target ? null : value ); } ); // delete entry
	},

	/* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_disableDatepicker: function( target ) {
		var nodeName, inline,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if ( nodeName === "input" ) {
			target.disabled = true;
			inst.trigger.filter( "button" ).
				each( function() { this.disabled = true; } ).end().
				filter( "img" ).css( { opacity: "0.5", cursor: "default" } );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			inline = $target.children( "." + this._inlineClass );
			inline.children().addClass( "ui-state-disabled" );
			inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
				prop( "disabled", true );
		}
		this._disabledInputs = $.map( this._disabledInputs,
			function( value ) { return ( value === target ? null : value ); } ); // delete entry
		this._disabledInputs[ this._disabledInputs.length ] = target;
	},

	/* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */
	_isDisabledDatepicker: function( target ) {
		if ( !target ) {
			return false;
		}
		for ( var i = 0; i < this._disabledInputs.length; i++ ) {
			if ( this._disabledInputs[ i ] === target ) {
				return true;
			}
		}
		return false;
	},

	/* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */
	_getInst: function( target ) {
		try {
			return $.data( target, "datepicker" );
		}
		catch ( err ) {
			throw "Missing instance data for this datepicker";
		}
	},

	/* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */
	_optionDatepicker: function( target, name, value ) {
		var settings, date, minDate, maxDate,
			inst = this._getInst( target );

		if ( arguments.length === 2 && typeof name === "string" ) {
			return ( name === "defaults" ? $.extend( {}, $.datepicker._defaults ) :
				( inst ? ( name === "all" ? $.extend( {}, inst.settings ) :
				this._get( inst, name ) ) : null ) );
		}

		settings = name || {};
		if ( typeof name === "string" ) {
			settings = {};
			settings[ name ] = value;
		}

		if ( inst ) {
			if ( this._curInst === inst ) {
				this._hideDatepicker();
			}

			date = this._getDateDatepicker( target, true );
			minDate = this._getMinMaxDate( inst, "min" );
			maxDate = this._getMinMaxDate( inst, "max" );
			datepicker_extendRemove( inst.settings, settings );

			// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
			if ( minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined ) {
				inst.settings.minDate = this._formatDate( inst, minDate );
			}
			if ( maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined ) {
				inst.settings.maxDate = this._formatDate( inst, maxDate );
			}
			if ( "disabled" in settings ) {
				if ( settings.disabled ) {
					this._disableDatepicker( target );
				} else {
					this._enableDatepicker( target );
				}
			}
			this._attachments( $( target ), inst );
			this._autoSize( inst );
			this._setDate( inst, date );
			this._updateAlternate( inst );
			this._updateDatepicker( inst );
		}
	},

	// Change method deprecated
	_changeDatepicker: function( target, name, value ) {
		this._optionDatepicker( target, name, value );
	},

	/* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */
	_refreshDatepicker: function( target ) {
		var inst = this._getInst( target );
		if ( inst ) {
			this._updateDatepicker( inst );
		}
	},

	/* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */
	_setDateDatepicker: function( target, date ) {
		var inst = this._getInst( target );
		if ( inst ) {
			this._setDate( inst, date );
			this._updateDatepicker( inst );
			this._updateAlternate( inst );
		}
	},

	/* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */
	_getDateDatepicker: function( target, noDefault ) {
		var inst = this._getInst( target );
		if ( inst && !inst.inline ) {
			this._setDateFromField( inst, noDefault );
		}
		return ( inst ? this._getDate( inst ) : null );
	},

	/* Handle keystrokes. */
	_doKeyDown: function( event ) {
		var onSelect, dateStr, sel,
			inst = $.datepicker._getInst( event.target ),
			handled = true,
			isRTL = inst.dpDiv.is( ".ui-datepicker-rtl" );

		inst._keyEvent = true;
		if ( $.datepicker._datepickerShowing ) {
			switch ( event.keyCode ) {
				case 9: $.datepicker._hideDatepicker();
						handled = false;
						break; // hide on tab out
				case 13: sel = $( "td." + $.datepicker._dayOverClass + ":not(." +
									$.datepicker._currentClass + ")", inst.dpDiv );
						if ( sel[ 0 ] ) {
							$.datepicker._selectDay( event.target, inst.selectedMonth, inst.selectedYear, sel[ 0 ] );
						}

						onSelect = $.datepicker._get( inst, "onSelect" );
						if ( onSelect ) {
							dateStr = $.datepicker._formatDate( inst );

							// Trigger custom callback
							onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );
						} else {
							$.datepicker._hideDatepicker();
						}

						return false; // don't submit the form
				case 27: $.datepicker._hideDatepicker();
						break; // hide on escape
				case 33: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
							-$.datepicker._get( inst, "stepBigMonths" ) :
							-$.datepicker._get( inst, "stepMonths" ) ), "M" );
						break; // previous month/year on page up/+ ctrl
				case 34: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
							+$.datepicker._get( inst, "stepBigMonths" ) :
							+$.datepicker._get( inst, "stepMonths" ) ), "M" );
						break; // next month/year on page down/+ ctrl
				case 35: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._clearDate( event.target );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._gotoToday( event.target );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // current on ctrl or command +home
				case 37: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, ( isRTL ? +1 : -1 ), "D" );
						}
						handled = event.ctrlKey || event.metaKey;

						// -1 day on ctrl or command +left
						if ( event.originalEvent.altKey ) {
							$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								-$.datepicker._get( inst, "stepBigMonths" ) :
								-$.datepicker._get( inst, "stepMonths" ) ), "M" );
						}

						// next month/year on alt +left on Mac
						break;
				case 38: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, -7, "D" );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // -1 week on ctrl or command +up
				case 39: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, ( isRTL ? -1 : +1 ), "D" );
						}
						handled = event.ctrlKey || event.metaKey;

						// +1 day on ctrl or command +right
						if ( event.originalEvent.altKey ) {
							$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								+$.datepicker._get( inst, "stepBigMonths" ) :
								+$.datepicker._get( inst, "stepMonths" ) ), "M" );
						}

						// next month/year on alt +right
						break;
				case 40: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, +7, "D" );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // +1 week on ctrl or command +down
				default: handled = false;
			}
		} else if ( event.keyCode === 36 && event.ctrlKey ) { // display the date picker on ctrl+home
			$.datepicker._showDatepicker( this );
		} else {
			handled = false;
		}

		if ( handled ) {
			event.preventDefault();
			event.stopPropagation();
		}
	},

	/* Filter entered characters - based on date format. */
	_doKeyPress: function( event ) {
		var chars, chr,
			inst = $.datepicker._getInst( event.target );

		if ( $.datepicker._get( inst, "constrainInput" ) ) {
			chars = $.datepicker._possibleChars( $.datepicker._get( inst, "dateFormat" ) );
			chr = String.fromCharCode( event.charCode == null ? event.keyCode : event.charCode );
			return event.ctrlKey || event.metaKey || ( chr < " " || !chars || chars.indexOf( chr ) > -1 );
		}
	},

	/* Synchronise manual entry and field/alternate field. */
	_doKeyUp: function( event ) {
		var date,
			inst = $.datepicker._getInst( event.target );

		if ( inst.input.val() !== inst.lastVal ) {
			try {
				date = $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
					( inst.input ? inst.input.val() : null ),
					$.datepicker._getFormatConfig( inst ) );

				if ( date ) { // only if valid
					$.datepicker._setDateFromField( inst );
					$.datepicker._updateAlternate( inst );
					$.datepicker._updateDatepicker( inst );
				}
			}
			catch ( err ) {
			}
		}
		return true;
	},

	/* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */
	_showDatepicker: function( input ) {
		input = input.target || input;
		if ( input.nodeName.toLowerCase() !== "input" ) { // find from button/image trigger
			input = $( "input", input.parentNode )[ 0 ];
		}

		if ( $.datepicker._isDisabledDatepicker( input ) || $.datepicker._lastInput === input ) { // already here
			return;
		}

		var inst, beforeShow, beforeShowSettings, isFixed,
			offset, showAnim, duration;

		inst = $.datepicker._getInst( input );
		if ( $.datepicker._curInst && $.datepicker._curInst !== inst ) {
			$.datepicker._curInst.dpDiv.stop( true, true );
			if ( inst && $.datepicker._datepickerShowing ) {
				$.datepicker._hideDatepicker( $.datepicker._curInst.input[ 0 ] );
			}
		}

		beforeShow = $.datepicker._get( inst, "beforeShow" );
		beforeShowSettings = beforeShow ? beforeShow.apply( input, [ input, inst ] ) : {};
		if ( beforeShowSettings === false ) {
			return;
		}
		datepicker_extendRemove( inst.settings, beforeShowSettings );

		inst.lastVal = null;
		$.datepicker._lastInput = input;
		$.datepicker._setDateFromField( inst );

		if ( $.datepicker._inDialog ) { // hide cursor
			input.value = "";
		}
		if ( !$.datepicker._pos ) { // position below input
			$.datepicker._pos = $.datepicker._findPos( input );
			$.datepicker._pos[ 1 ] += input.offsetHeight; // add the height
		}

		isFixed = false;
		$( input ).parents().each( function() {
			isFixed |= $( this ).css( "position" ) === "fixed";
			return !isFixed;
		} );

		offset = { left: $.datepicker._pos[ 0 ], top: $.datepicker._pos[ 1 ] };
		$.datepicker._pos = null;

		//to avoid flashes on Firefox
		inst.dpDiv.empty();

		// determine sizing offscreen
		inst.dpDiv.css( { position: "absolute", display: "block", top: "-1000px" } );
		$.datepicker._updateDatepicker( inst );

		// fix width for dynamic number of date pickers
		// and adjust position before showing
		offset = $.datepicker._checkOffset( inst, offset, isFixed );
		inst.dpDiv.css( { position: ( $.datepicker._inDialog && $.blockUI ?
			"static" : ( isFixed ? "fixed" : "absolute" ) ), display: "none",
			left: offset.left + "px", top: offset.top + "px" } );

		if ( !inst.inline ) {
			showAnim = $.datepicker._get( inst, "showAnim" );
			duration = $.datepicker._get( inst, "duration" );
			inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
			$.datepicker._datepickerShowing = true;

			if ( $.effects && $.effects.effect[ showAnim ] ) {
				inst.dpDiv.show( showAnim, $.datepicker._get( inst, "showOptions" ), duration );
			} else {
				inst.dpDiv[ showAnim || "show" ]( showAnim ? duration : null );
			}

			if ( $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.trigger( "focus" );
			}

			$.datepicker._curInst = inst;
		}
	},

	/* Generate the date picker content. */
	_updateDatepicker: function( inst ) {
		this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
		datepicker_instActive = inst; // for delegate hover events
		inst.dpDiv.empty().append( this._generateHTML( inst ) );
		this._attachHandlers( inst );

		var origyearshtml,
			numMonths = this._getNumberOfMonths( inst ),
			cols = numMonths[ 1 ],
			width = 17,
			activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );

		if ( activeCell.length > 0 ) {
			datepicker_handleMouseover.apply( activeCell.get( 0 ) );
		}

		inst.dpDiv.removeClass( "ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4" ).width( "" );
		if ( cols > 1 ) {
			inst.dpDiv.addClass( "ui-datepicker-multi-" + cols ).css( "width", ( width * cols ) + "em" );
		}
		inst.dpDiv[ ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-multi" );
		inst.dpDiv[ ( this._get( inst, "isRTL" ) ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-rtl" );

		if ( inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
			inst.input.trigger( "focus" );
		}

		// Deffered render of the years select (to avoid flashes on Firefox)
		if ( inst.yearshtml ) {
			origyearshtml = inst.yearshtml;
			setTimeout( function() {

				//assure that inst.yearshtml didn't change.
				if ( origyearshtml === inst.yearshtml && inst.yearshtml ) {
					inst.dpDiv.find( "select.ui-datepicker-year:first" ).replaceWith( inst.yearshtml );
				}
				origyearshtml = inst.yearshtml = null;
			}, 0 );
		}
	},

	// #6694 - don't focus the input if it's already focused
	// this breaks the change event in IE
	// Support: IE and jQuery <1.9
	_shouldFocusInput: function( inst ) {
		return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
	},

	/* Check positioning to remain on screen. */
	_checkOffset: function( inst, offset, isFixed ) {
		var dpWidth = inst.dpDiv.outerWidth(),
			dpHeight = inst.dpDiv.outerHeight(),
			inputWidth = inst.input ? inst.input.outerWidth() : 0,
			inputHeight = inst.input ? inst.input.outerHeight() : 0,
			viewWidth = document.documentElement.clientWidth + ( isFixed ? 0 : $( document ).scrollLeft() ),
			viewHeight = document.documentElement.clientHeight + ( isFixed ? 0 : $( document ).scrollTop() );

		offset.left -= ( this._get( inst, "isRTL" ) ? ( dpWidth - inputWidth ) : 0 );
		offset.left -= ( isFixed && offset.left === inst.input.offset().left ) ? $( document ).scrollLeft() : 0;
		offset.top -= ( isFixed && offset.top === ( inst.input.offset().top + inputHeight ) ) ? $( document ).scrollTop() : 0;

		// Now check if datepicker is showing outside window viewport - move to a better place if so.
		offset.left -= Math.min( offset.left, ( offset.left + dpWidth > viewWidth && viewWidth > dpWidth ) ?
			Math.abs( offset.left + dpWidth - viewWidth ) : 0 );
		offset.top -= Math.min( offset.top, ( offset.top + dpHeight > viewHeight && viewHeight > dpHeight ) ?
			Math.abs( dpHeight + inputHeight ) : 0 );

		return offset;
	},

	/* Find an object's position on the screen. */
	_findPos: function( obj ) {
		var position,
			inst = this._getInst( obj ),
			isRTL = this._get( inst, "isRTL" );

		while ( obj && ( obj.type === "hidden" || obj.nodeType !== 1 || $.expr.pseudos.hidden( obj ) ) ) {
			obj = obj[ isRTL ? "previousSibling" : "nextSibling" ];
		}

		position = $( obj ).offset();
		return [ position.left, position.top ];
	},

	/* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */
	_hideDatepicker: function( input ) {
		var showAnim, duration, postProcess, onClose,
			inst = this._curInst;

		if ( !inst || ( input && inst !== $.data( input, "datepicker" ) ) ) {
			return;
		}

		if ( this._datepickerShowing ) {
			showAnim = this._get( inst, "showAnim" );
			duration = this._get( inst, "duration" );
			postProcess = function() {
				$.datepicker._tidyDialog( inst );
			};

			// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
			if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
				inst.dpDiv.hide( showAnim, $.datepicker._get( inst, "showOptions" ), duration, postProcess );
			} else {
				inst.dpDiv[ ( showAnim === "slideDown" ? "slideUp" :
					( showAnim === "fadeIn" ? "fadeOut" : "hide" ) ) ]( ( showAnim ? duration : null ), postProcess );
			}

			if ( !showAnim ) {
				postProcess();
			}
			this._datepickerShowing = false;

			onClose = this._get( inst, "onClose" );
			if ( onClose ) {
				onClose.apply( ( inst.input ? inst.input[ 0 ] : null ), [ ( inst.input ? inst.input.val() : "" ), inst ] );
			}

			this._lastInput = null;
			if ( this._inDialog ) {
				this._dialogInput.css( { position: "absolute", left: "0", top: "-100px" } );
				if ( $.blockUI ) {
					$.unblockUI();
					$( "body" ).append( this.dpDiv );
				}
			}
			this._inDialog = false;
		}
	},

	/* Tidy up after a dialog display. */
	_tidyDialog: function( inst ) {
		inst.dpDiv.removeClass( this._dialogClass ).off( ".ui-datepicker-calendar" );
	},

	/* Close date picker if clicked elsewhere. */
	_checkExternalClick: function( event ) {
		if ( !$.datepicker._curInst ) {
			return;
		}

		var $target = $( event.target ),
			inst = $.datepicker._getInst( $target[ 0 ] );

		if ( ( ( $target[ 0 ].id !== $.datepicker._mainDivId &&
				$target.parents( "#" + $.datepicker._mainDivId ).length === 0 &&
				!$target.hasClass( $.datepicker.markerClassName ) &&
				!$target.closest( "." + $.datepicker._triggerClass ).length &&
				$.datepicker._datepickerShowing && !( $.datepicker._inDialog && $.blockUI ) ) ) ||
			( $target.hasClass( $.datepicker.markerClassName ) && $.datepicker._curInst !== inst ) ) {
				$.datepicker._hideDatepicker();
		}
	},

	/* Adjust one of the date sub-fields. */
	_adjustDate: function( id, offset, period ) {
		var target = $( id ),
			inst = this._getInst( target[ 0 ] );

		if ( this._isDisabledDatepicker( target[ 0 ] ) ) {
			return;
		}
		this._adjustInstDate( inst, offset +
			( period === "M" ? this._get( inst, "showCurrentAtPos" ) : 0 ), // undo positioning
			period );
		this._updateDatepicker( inst );
	},

	/* Action for current link. */
	_gotoToday: function( id ) {
		var date,
			target = $( id ),
			inst = this._getInst( target[ 0 ] );

		if ( this._get( inst, "gotoCurrent" ) && inst.currentDay ) {
			inst.selectedDay = inst.currentDay;
			inst.drawMonth = inst.selectedMonth = inst.currentMonth;
			inst.drawYear = inst.selectedYear = inst.currentYear;
		} else {
			date = new Date();
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
		}
		this._notifyChange( inst );
		this._adjustDate( target );
	},

	/* Action for selecting a new month/year. */
	_selectMonthYear: function( id, select, period ) {
		var target = $( id ),
			inst = this._getInst( target[ 0 ] );

		inst[ "selected" + ( period === "M" ? "Month" : "Year" ) ] =
		inst[ "draw" + ( period === "M" ? "Month" : "Year" ) ] =
			parseInt( select.options[ select.selectedIndex ].value, 10 );

		this._notifyChange( inst );
		this._adjustDate( target );
	},

	/* Action for selecting a day. */
	_selectDay: function( id, month, year, td ) {
		var inst,
			target = $( id );

		if ( $( td ).hasClass( this._unselectableClass ) || this._isDisabledDatepicker( target[ 0 ] ) ) {
			return;
		}

		inst = this._getInst( target[ 0 ] );
		inst.selectedDay = inst.currentDay = $( "a", td ).html();
		inst.selectedMonth = inst.currentMonth = month;
		inst.selectedYear = inst.currentYear = year;
		this._selectDate( id, this._formatDate( inst,
			inst.currentDay, inst.currentMonth, inst.currentYear ) );
	},

	/* Erase the input field and hide the date picker. */
	_clearDate: function( id ) {
		var target = $( id );
		this._selectDate( target, "" );
	},

	/* Update the input field with the selected date. */
	_selectDate: function( id, dateStr ) {
		var onSelect,
			target = $( id ),
			inst = this._getInst( target[ 0 ] );

		dateStr = ( dateStr != null ? dateStr : this._formatDate( inst ) );
		if ( inst.input ) {
			inst.input.val( dateStr );
		}
		this._updateAlternate( inst );

		onSelect = this._get( inst, "onSelect" );
		if ( onSelect ) {
			onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );  // trigger custom callback
		} else if ( inst.input ) {
			inst.input.trigger( "change" ); // fire the change event
		}

		if ( inst.inline ) {
			this._updateDatepicker( inst );
		} else {
			this._hideDatepicker();
			this._lastInput = inst.input[ 0 ];
			if ( typeof( inst.input[ 0 ] ) !== "object" ) {
				inst.input.trigger( "focus" ); // restore focus
			}
			this._lastInput = null;
		}
	},

	/* Update any alternate field to synchronise with the main field. */
	_updateAlternate: function( inst ) {
		var altFormat, date, dateStr,
			altField = this._get( inst, "altField" );

		if ( altField ) { // update alternate field too
			altFormat = this._get( inst, "altFormat" ) || this._get( inst, "dateFormat" );
			date = this._getDate( inst );
			dateStr = this.formatDate( altFormat, date, this._getFormatConfig( inst ) );
			$( altField ).val( dateStr );
		}
	},

	/* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */
	noWeekends: function( date ) {
		var day = date.getDay();
		return [ ( day > 0 && day < 6 ), "" ];
	},

	/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */
	iso8601Week: function( date ) {
		var time,
			checkDate = new Date( date.getTime() );

		// Find Thursday of this week starting on Monday
		checkDate.setDate( checkDate.getDate() + 4 - ( checkDate.getDay() || 7 ) );

		time = checkDate.getTime();
		checkDate.setMonth( 0 ); // Compare with Jan 1
		checkDate.setDate( 1 );
		return Math.floor( Math.round( ( time - checkDate ) / 86400000 ) / 7 ) + 1;
	},

	/* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */
	parseDate: function( format, value, settings ) {
		if ( format == null || value == null ) {
			throw "Invalid arguments";
		}

		value = ( typeof value === "object" ? value.toString() : value + "" );
		if ( value === "" ) {
			return null;
		}

		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = ( settings ? settings.shortYearCutoff : null ) || this._defaults.shortYearCutoff,
			shortYearCutoff = ( typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt( shortYearCutoffTemp, 10 ) ),
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
			year = -1,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},

			// Extract a number from the string value
			getNumber = function( match ) {
				var isDoubled = lookAhead( match ),
					size = ( match === "@" ? 14 : ( match === "!" ? 20 :
					( match === "y" && isDoubled ? 4 : ( match === "o" ? 3 : 2 ) ) ) ),
					minSize = ( match === "y" ? size : 1 ),
					digits = new RegExp( "^\\d{" + minSize + "," + size + "}" ),
					num = value.substring( iValue ).match( digits );
				if ( !num ) {
					throw "Missing number at position " + iValue;
				}
				iValue += num[ 0 ].length;
				return parseInt( num[ 0 ], 10 );
			},

			// Extract a name from the string value and convert to an index
			getName = function( match, shortNames, longNames ) {
				var index = -1,
					names = $.map( lookAhead( match ) ? longNames : shortNames, function( v, k ) {
						return [ [ k, v ] ];
					} ).sort( function( a, b ) {
						return -( a[ 1 ].length - b[ 1 ].length );
					} );

				$.each( names, function( i, pair ) {
					var name = pair[ 1 ];
					if ( value.substr( iValue, name.length ).toLowerCase() === name.toLowerCase() ) {
						index = pair[ 0 ];
						iValue += name.length;
						return false;
					}
				} );
				if ( index !== -1 ) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},

			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if ( value.charAt( iValue ) !== format.charAt( iFormat ) ) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};

		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d":
						day = getNumber( "d" );
						break;
					case "D":
						getName( "D", dayNamesShort, dayNames );
						break;
					case "o":
						doy = getNumber( "o" );
						break;
					case "m":
						month = getNumber( "m" );
						break;
					case "M":
						month = getName( "M", monthNamesShort, monthNames );
						break;
					case "y":
						year = getNumber( "y" );
						break;
					case "@":
						date = new Date( getNumber( "@" ) );
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date( ( getNumber( "!" ) - this._ticksTo1970 ) / 10000 );
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if ( lookAhead( "'" ) ) {
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}

		if ( iValue < value.length ) {
			extra = value.substr( iValue );
			if ( !/^\s+/.test( extra ) ) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}

		if ( year === -1 ) {
			year = new Date().getFullYear();
		} else if ( year < 100 ) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				( year <= shortYearCutoff ? 0 : -100 );
		}

		if ( doy > -1 ) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth( year, month - 1 );
				if ( day <= dim ) {
					break;
				}
				month++;
				day -= dim;
			} while ( true );
		}

		date = this._daylightSavingAdjust( new Date( year, month - 1, day ) );
		if ( date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day ) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	},

	/* Standard date formats. */
	ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
	COOKIE: "D, dd M yy",
	ISO_8601: "yy-mm-dd",
	RFC_822: "D, d M y",
	RFC_850: "DD, dd-M-y",
	RFC_1036: "D, d M y",
	RFC_1123: "D, d M yy",
	RFC_2822: "D, d M yy",
	RSS: "D, d M y", // RFC 822
	TICKS: "!",
	TIMESTAMP: "@",
	W3C: "yy-mm-dd", // ISO 8601

	_ticksTo1970: ( ( ( 1970 - 1 ) * 365 + Math.floor( 1970 / 4 ) - Math.floor( 1970 / 100 ) +
		Math.floor( 1970 / 400 ) ) * 24 * 60 * 60 * 10000000 ),

	/* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */
	formatDate: function( format, date, settings ) {
		if ( !date ) {
			return "";
		}

		var iFormat,
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},

			// Format a number, with leading zero if necessary
			formatNumber = function( match, value, len ) {
				var num = "" + value;
				if ( lookAhead( match ) ) {
					while ( num.length < len ) {
						num = "0" + num;
					}
				}
				return num;
			},

			// Format a name, short or long as requested
			formatName = function( match, value, shortNames, longNames ) {
				return ( lookAhead( match ) ? longNames[ value ] : shortNames[ value ] );
			},
			output = "",
			literal = false;

		if ( date ) {
			for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
				if ( literal ) {
					if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
						literal = false;
					} else {
						output += format.charAt( iFormat );
					}
				} else {
					switch ( format.charAt( iFormat ) ) {
						case "d":
							output += formatNumber( "d", date.getDate(), 2 );
							break;
						case "D":
							output += formatName( "D", date.getDay(), dayNamesShort, dayNames );
							break;
						case "o":
							output += formatNumber( "o",
								Math.round( ( new Date( date.getFullYear(), date.getMonth(), date.getDate() ).getTime() - new Date( date.getFullYear(), 0, 0 ).getTime() ) / 86400000 ), 3 );
							break;
						case "m":
							output += formatNumber( "m", date.getMonth() + 1, 2 );
							break;
						case "M":
							output += formatName( "M", date.getMonth(), monthNamesShort, monthNames );
							break;
						case "y":
							output += ( lookAhead( "y" ) ? date.getFullYear() :
								( date.getFullYear() % 100 < 10 ? "0" : "" ) + date.getFullYear() % 100 );
							break;
						case "@":
							output += date.getTime();
							break;
						case "!":
							output += date.getTime() * 10000 + this._ticksTo1970;
							break;
						case "'":
							if ( lookAhead( "'" ) ) {
								output += "'";
							} else {
								literal = true;
							}
							break;
						default:
							output += format.charAt( iFormat );
					}
				}
			}
		}
		return output;
	},

	/* Extract all possible characters from the date format. */
	_possibleChars: function( format ) {
		var iFormat,
			chars = "",
			literal = false,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			};

		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					chars += format.charAt( iFormat );
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d": case "m": case "y": case "@":
						chars += "0123456789";
						break;
					case "D": case "M":
						return null; // Accept anything
					case "'":
						if ( lookAhead( "'" ) ) {
							chars += "'";
						} else {
							literal = true;
						}
						break;
					default:
						chars += format.charAt( iFormat );
				}
			}
		}
		return chars;
	},

	/* Get a setting value, defaulting if necessary. */
	_get: function( inst, name ) {
		return inst.settings[ name ] !== undefined ?
			inst.settings[ name ] : this._defaults[ name ];
	},

	/* Parse existing date and initialise date picker. */
	_setDateFromField: function( inst, noDefault ) {
		if ( inst.input.val() === inst.lastVal ) {
			return;
		}

		var dateFormat = this._get( inst, "dateFormat" ),
			dates = inst.lastVal = inst.input ? inst.input.val() : null,
			defaultDate = this._getDefaultDate( inst ),
			date = defaultDate,
			settings = this._getFormatConfig( inst );

		try {
			date = this.parseDate( dateFormat, dates, settings ) || defaultDate;
		} catch ( event ) {
			dates = ( noDefault ? "" : dates );
		}
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		inst.currentDay = ( dates ? date.getDate() : 0 );
		inst.currentMonth = ( dates ? date.getMonth() : 0 );
		inst.currentYear = ( dates ? date.getFullYear() : 0 );
		this._adjustInstDate( inst );
	},

	/* Retrieve the default date shown on opening. */
	_getDefaultDate: function( inst ) {
		return this._restrictMinMax( inst,
			this._determineDate( inst, this._get( inst, "defaultDate" ), new Date() ) );
	},

	/* A date may be specified as an exact value or a relative one. */
	_determineDate: function( inst, date, defaultDate ) {
		var offsetNumeric = function( offset ) {
				var date = new Date();
				date.setDate( date.getDate() + offset );
				return date;
			},
			offsetString = function( offset ) {
				try {
					return $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
						offset, $.datepicker._getFormatConfig( inst ) );
				}
				catch ( e ) {

					// Ignore
				}

				var date = ( offset.toLowerCase().match( /^c/ ) ?
					$.datepicker._getDate( inst ) : null ) || new Date(),
					year = date.getFullYear(),
					month = date.getMonth(),
					day = date.getDate(),
					pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
					matches = pattern.exec( offset );

				while ( matches ) {
					switch ( matches[ 2 ] || "d" ) {
						case "d" : case "D" :
							day += parseInt( matches[ 1 ], 10 ); break;
						case "w" : case "W" :
							day += parseInt( matches[ 1 ], 10 ) * 7; break;
						case "m" : case "M" :
							month += parseInt( matches[ 1 ], 10 );
							day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
							break;
						case "y": case "Y" :
							year += parseInt( matches[ 1 ], 10 );
							day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
							break;
					}
					matches = pattern.exec( offset );
				}
				return new Date( year, month, day );
			},
			newDate = ( date == null || date === "" ? defaultDate : ( typeof date === "string" ? offsetString( date ) :
				( typeof date === "number" ? ( isNaN( date ) ? defaultDate : offsetNumeric( date ) ) : new Date( date.getTime() ) ) ) );

		newDate = ( newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate );
		if ( newDate ) {
			newDate.setHours( 0 );
			newDate.setMinutes( 0 );
			newDate.setSeconds( 0 );
			newDate.setMilliseconds( 0 );
		}
		return this._daylightSavingAdjust( newDate );
	},

	/* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */
	_daylightSavingAdjust: function( date ) {
		if ( !date ) {
			return null;
		}
		date.setHours( date.getHours() > 12 ? date.getHours() + 2 : 0 );
		return date;
	},

	/* Set the date(s) directly. */
	_setDate: function( inst, date, noChange ) {
		var clear = !date,
			origMonth = inst.selectedMonth,
			origYear = inst.selectedYear,
			newDate = this._restrictMinMax( inst, this._determineDate( inst, date, new Date() ) );

		inst.selectedDay = inst.currentDay = newDate.getDate();
		inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
		inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
		if ( ( origMonth !== inst.selectedMonth || origYear !== inst.selectedYear ) && !noChange ) {
			this._notifyChange( inst );
		}
		this._adjustInstDate( inst );
		if ( inst.input ) {
			inst.input.val( clear ? "" : this._formatDate( inst ) );
		}
	},

	/* Retrieve the date(s) directly. */
	_getDate: function( inst ) {
		var startDate = ( !inst.currentYear || ( inst.input && inst.input.val() === "" ) ? null :
			this._daylightSavingAdjust( new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
			return startDate;
	},

	/* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */
	_attachHandlers: function( inst ) {
		var stepMonths = this._get( inst, "stepMonths" ),
			id = "#" + inst.id.replace( /\\\\/g, "\\" );
		inst.dpDiv.find( "[data-handler]" ).map( function() {
			var handler = {
				prev: function() {
					$.datepicker._adjustDate( id, -stepMonths, "M" );
				},
				next: function() {
					$.datepicker._adjustDate( id, +stepMonths, "M" );
				},
				hide: function() {
					$.datepicker._hideDatepicker();
				},
				today: function() {
					$.datepicker._gotoToday( id );
				},
				selectDay: function() {
					$.datepicker._selectDay( id, +this.getAttribute( "data-month" ), +this.getAttribute( "data-year" ), this );
					return false;
				},
				selectMonth: function() {
					$.datepicker._selectMonthYear( id, this, "M" );
					return false;
				},
				selectYear: function() {
					$.datepicker._selectMonthYear( id, this, "Y" );
					return false;
				}
			};
			$( this ).on( this.getAttribute( "data-event" ), handler[ this.getAttribute( "data-handler" ) ] );
		} );
	},

	/* Generate the HTML for the current state of the date picker. */
	_generateHTML: function( inst ) {
		var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
			controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
			monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
			selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
			cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
			printDate, dRow, tbody, daySettings, otherMonth, unselectable,
			tempDate = new Date(),
			today = this._daylightSavingAdjust(
				new Date( tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() ) ), // clear time
			isRTL = this._get( inst, "isRTL" ),
			showButtonPanel = this._get( inst, "showButtonPanel" ),
			hideIfNoPrevNext = this._get( inst, "hideIfNoPrevNext" ),
			navigationAsDateFormat = this._get( inst, "navigationAsDateFormat" ),
			numMonths = this._getNumberOfMonths( inst ),
			showCurrentAtPos = this._get( inst, "showCurrentAtPos" ),
			stepMonths = this._get( inst, "stepMonths" ),
			isMultiMonth = ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ),
			currentDate = this._daylightSavingAdjust( ( !inst.currentDay ? new Date( 9999, 9, 9 ) :
				new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) ),
			minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			drawMonth = inst.drawMonth - showCurrentAtPos,
			drawYear = inst.drawYear;

		if ( drawMonth < 0 ) {
			drawMonth += 12;
			drawYear--;
		}
		if ( maxDate ) {
			maxDraw = this._daylightSavingAdjust( new Date( maxDate.getFullYear(),
				maxDate.getMonth() - ( numMonths[ 0 ] * numMonths[ 1 ] ) + 1, maxDate.getDate() ) );
			maxDraw = ( minDate && maxDraw < minDate ? minDate : maxDraw );
			while ( this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 ) ) > maxDraw ) {
				drawMonth--;
				if ( drawMonth < 0 ) {
					drawMonth = 11;
					drawYear--;
				}
			}
		}
		inst.drawMonth = drawMonth;
		inst.drawYear = drawYear;

		prevText = this._get( inst, "prevText" );
		prevText = ( !navigationAsDateFormat ? prevText : this.formatDate( prevText,
			this._daylightSavingAdjust( new Date( drawYear, drawMonth - stepMonths, 1 ) ),
			this._getFormatConfig( inst ) ) );

		prev = ( this._canAdjustMonth( inst, -1, drawYear, drawMonth ) ?
			"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
			" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" :
			( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" ) );

		nextText = this._get( inst, "nextText" );
		nextText = ( !navigationAsDateFormat ? nextText : this.formatDate( nextText,
			this._daylightSavingAdjust( new Date( drawYear, drawMonth + stepMonths, 1 ) ),
			this._getFormatConfig( inst ) ) );

		next = ( this._canAdjustMonth( inst, +1, drawYear, drawMonth ) ?
			"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
			" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" :
			( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" ) );

		currentText = this._get( inst, "currentText" );
		gotoDate = ( this._get( inst, "gotoCurrent" ) && inst.currentDay ? currentDate : today );
		currentText = ( !navigationAsDateFormat ? currentText :
			this.formatDate( currentText, gotoDate, this._getFormatConfig( inst ) ) );

		controls = ( !inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
			this._get( inst, "closeText" ) + "</button>" : "" );

		buttonPanel = ( showButtonPanel ) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + ( isRTL ? controls : "" ) +
			( this._isInRange( inst, gotoDate ) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
			">" + currentText + "</button>" : "" ) + ( isRTL ? "" : controls ) + "</div>" : "";

		firstDay = parseInt( this._get( inst, "firstDay" ), 10 );
		firstDay = ( isNaN( firstDay ) ? 0 : firstDay );

		showWeek = this._get( inst, "showWeek" );
		dayNames = this._get( inst, "dayNames" );
		dayNamesMin = this._get( inst, "dayNamesMin" );
		monthNames = this._get( inst, "monthNames" );
		monthNamesShort = this._get( inst, "monthNamesShort" );
		beforeShowDay = this._get( inst, "beforeShowDay" );
		showOtherMonths = this._get( inst, "showOtherMonths" );
		selectOtherMonths = this._get( inst, "selectOtherMonths" );
		defaultDate = this._getDefaultDate( inst );
		html = "";

		for ( row = 0; row < numMonths[ 0 ]; row++ ) {
			group = "";
			this.maxRows = 4;
			for ( col = 0; col < numMonths[ 1 ]; col++ ) {
				selectedDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, inst.selectedDay ) );
				cornerClass = " ui-corner-all";
				calender = "";
				if ( isMultiMonth ) {
					calender += "<div class='ui-datepicker-group";
					if ( numMonths[ 1 ] > 1 ) {
						switch ( col ) {
							case 0: calender += " ui-datepicker-group-first";
								cornerClass = " ui-corner-" + ( isRTL ? "right" : "left" ); break;
							case numMonths[ 1 ] - 1: calender += " ui-datepicker-group-last";
								cornerClass = " ui-corner-" + ( isRTL ? "left" : "right" ); break;
							default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
						}
					}
					calender += "'>";
				}
				calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
					( /all|left/.test( cornerClass ) && row === 0 ? ( isRTL ? next : prev ) : "" ) +
					( /all|right/.test( cornerClass ) && row === 0 ? ( isRTL ? prev : next ) : "" ) +
					this._generateMonthYearHeader( inst, drawMonth, drawYear, minDate, maxDate,
					row > 0 || col > 0, monthNames, monthNamesShort ) + // draw month headers
					"</div><table class='ui-datepicker-calendar'><thead>" +
					"<tr>";
				thead = ( showWeek ? "<th class='ui-datepicker-week-col'>" + this._get( inst, "weekHeader" ) + "</th>" : "" );
				for ( dow = 0; dow < 7; dow++ ) { // days of the week
					day = ( dow + firstDay ) % 7;
					thead += "<th scope='col'" + ( ( dow + firstDay + 6 ) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "" ) + ">" +
						"<span title='" + dayNames[ day ] + "'>" + dayNamesMin[ day ] + "</span></th>";
				}
				calender += thead + "</tr></thead><tbody>";
				daysInMonth = this._getDaysInMonth( drawYear, drawMonth );
				if ( drawYear === inst.selectedYear && drawMonth === inst.selectedMonth ) {
					inst.selectedDay = Math.min( inst.selectedDay, daysInMonth );
				}
				leadDays = ( this._getFirstDayOfMonth( drawYear, drawMonth ) - firstDay + 7 ) % 7;
				curRows = Math.ceil( ( leadDays + daysInMonth ) / 7 ); // calculate the number of rows to generate
				numRows = ( isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows ); //If multiple months, use the higher number of rows (see #7043)
				this.maxRows = numRows;
				printDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 - leadDays ) );
				for ( dRow = 0; dRow < numRows; dRow++ ) { // create date picker rows
					calender += "<tr>";
					tbody = ( !showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
						this._get( inst, "calculateWeek" )( printDate ) + "</td>" );
					for ( dow = 0; dow < 7; dow++ ) { // create date picker days
						daySettings = ( beforeShowDay ?
							beforeShowDay.apply( ( inst.input ? inst.input[ 0 ] : null ), [ printDate ] ) : [ true, "" ] );
						otherMonth = ( printDate.getMonth() !== drawMonth );
						unselectable = ( otherMonth && !selectOtherMonths ) || !daySettings[ 0 ] ||
							( minDate && printDate < minDate ) || ( maxDate && printDate > maxDate );
						tbody += "<td class='" +
							( ( dow + firstDay + 6 ) % 7 >= 5 ? " ui-datepicker-week-end" : "" ) + // highlight weekends
							( otherMonth ? " ui-datepicker-other-month" : "" ) + // highlight days from other months
							( ( printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent ) || // user pressed key
							( defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ) ?

							// or defaultDate is current printedDate and defaultDate is selectedDate
							" " + this._dayOverClass : "" ) + // highlight selected day
							( unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "" ) +  // highlight unselectable days
							( otherMonth && !showOtherMonths ? "" : " " + daySettings[ 1 ] + // highlight custom dates
							( printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "" ) + // highlight selected day
							( printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "" ) ) + "'" + // highlight today (if different)
							( ( !otherMonth || showOtherMonths ) && daySettings[ 2 ] ? " title='" + daySettings[ 2 ].replace( /'/g, "&#39;" ) + "'" : "" ) + // cell title
							( unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'" ) + ">" + // actions
							( otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
							( unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
							( printDate.getTime() === today.getTime() ? " ui-state-highlight" : "" ) +
							( printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "" ) + // highlight selected day
							( otherMonth ? " ui-priority-secondary" : "" ) + // distinguish dates from other months
							"' href='#'>" + printDate.getDate() + "</a>" ) ) + "</td>"; // display selectable date
						printDate.setDate( printDate.getDate() + 1 );
						printDate = this._daylightSavingAdjust( printDate );
					}
					calender += tbody + "</tr>";
				}
				drawMonth++;
				if ( drawMonth > 11 ) {
					drawMonth = 0;
					drawYear++;
				}
				calender += "</tbody></table>" + ( isMultiMonth ? "</div>" +
							( ( numMonths[ 0 ] > 0 && col === numMonths[ 1 ] - 1 ) ? "<div class='ui-datepicker-row-break'></div>" : "" ) : "" );
				group += calender;
			}
			html += group;
		}
		html += buttonPanel;
		inst._keyEvent = false;
		return html;
	},

	/* Generate the month and year header. */
	_generateMonthYearHeader: function( inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort ) {

		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get( inst, "changeMonth" ),
			changeYear = this._get( inst, "changeYear" ),
			showMonthAfterYear = this._get( inst, "showMonthAfterYear" ),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";

		// Month selection
		if ( secondary || !changeMonth ) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[ drawMonth ] + "</span>";
		} else {
			inMinYear = ( minDate && minDate.getFullYear() === drawYear );
			inMaxYear = ( maxDate && maxDate.getFullYear() === drawYear );
			monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++ ) {
				if ( ( !inMinYear || month >= minDate.getMonth() ) && ( !inMaxYear || month <= maxDate.getMonth() ) ) {
					monthHtml += "<option value='" + month + "'" +
						( month === drawMonth ? " selected='selected'" : "" ) +
						">" + monthNamesShort[ month ] + "</option>";
				}
			}
			monthHtml += "</select>";
		}

		if ( !showMonthAfterYear ) {
			html += monthHtml + ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" );
		}

		// Year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if ( secondary || !changeYear ) {
				html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
			} else {

				// determine range of years to display
				years = this._get( inst, "yearRange" ).split( ":" );
				thisYear = new Date().getFullYear();
				determineYear = function( value ) {
					var year = ( value.match( /c[+\-].*/ ) ? drawYear + parseInt( value.substring( 1 ), 10 ) :
						( value.match( /[+\-].*/ ) ? thisYear + parseInt( value, 10 ) :
						parseInt( value, 10 ) ) );
					return ( isNaN( year ) ? thisYear : year );
				};
				year = determineYear( years[ 0 ] );
				endYear = Math.max( year, determineYear( years[ 1 ] || "" ) );
				year = ( minDate ? Math.max( year, minDate.getFullYear() ) : year );
				endYear = ( maxDate ? Math.min( endYear, maxDate.getFullYear() ) : endYear );
				inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
				for ( ; year <= endYear; year++ ) {
					inst.yearshtml += "<option value='" + year + "'" +
						( year === drawYear ? " selected='selected'" : "" ) +
						">" + year + "</option>";
				}
				inst.yearshtml += "</select>";

				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}

		html += this._get( inst, "yearSuffix" );
		if ( showMonthAfterYear ) {
			html += ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" ) + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	},

	/* Adjust one of the date sub-fields. */
	_adjustInstDate: function( inst, offset, period ) {
		var year = inst.selectedYear + ( period === "Y" ? offset : 0 ),
			month = inst.selectedMonth + ( period === "M" ? offset : 0 ),
			day = Math.min( inst.selectedDay, this._getDaysInMonth( year, month ) ) + ( period === "D" ? offset : 0 ),
			date = this._restrictMinMax( inst, this._daylightSavingAdjust( new Date( year, month, day ) ) );

		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		if ( period === "M" || period === "Y" ) {
			this._notifyChange( inst );
		}
	},

	/* Ensure a date is within any min/max bounds. */
	_restrictMinMax: function( inst, date ) {
		var minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			newDate = ( minDate && date < minDate ? minDate : date );
		return ( maxDate && newDate > maxDate ? maxDate : newDate );
	},

	/* Notify change of month/year. */
	_notifyChange: function( inst ) {
		var onChange = this._get( inst, "onChangeMonthYear" );
		if ( onChange ) {
			onChange.apply( ( inst.input ? inst.input[ 0 ] : null ),
				[ inst.selectedYear, inst.selectedMonth + 1, inst ] );
		}
	},

	/* Determine the number of months to show. */
	_getNumberOfMonths: function( inst ) {
		var numMonths = this._get( inst, "numberOfMonths" );
		return ( numMonths == null ? [ 1, 1 ] : ( typeof numMonths === "number" ? [ 1, numMonths ] : numMonths ) );
	},

	/* Determine the current maximum date - ensure no time components are set. */
	_getMinMaxDate: function( inst, minMax ) {
		return this._determineDate( inst, this._get( inst, minMax + "Date" ), null );
	},

	/* Find the number of days in a given month. */
	_getDaysInMonth: function( year, month ) {
		return 32 - this._daylightSavingAdjust( new Date( year, month, 32 ) ).getDate();
	},

	/* Find the day of the week of the first of a month. */
	_getFirstDayOfMonth: function( year, month ) {
		return new Date( year, month, 1 ).getDay();
	},

	/* Determines if we should allow a "next/prev" month display change. */
	_canAdjustMonth: function( inst, offset, curYear, curMonth ) {
		var numMonths = this._getNumberOfMonths( inst ),
			date = this._daylightSavingAdjust( new Date( curYear,
			curMonth + ( offset < 0 ? offset : numMonths[ 0 ] * numMonths[ 1 ] ), 1 ) );

		if ( offset < 0 ) {
			date.setDate( this._getDaysInMonth( date.getFullYear(), date.getMonth() ) );
		}
		return this._isInRange( inst, date );
	},

	/* Is the given date in the accepted range? */
	_isInRange: function( inst, date ) {
		var yearSplit, currentYear,
			minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			minYear = null,
			maxYear = null,
			years = this._get( inst, "yearRange" );
			if ( years ) {
				yearSplit = years.split( ":" );
				currentYear = new Date().getFullYear();
				minYear = parseInt( yearSplit[ 0 ], 10 );
				maxYear = parseInt( yearSplit[ 1 ], 10 );
				if ( yearSplit[ 0 ].match( /[+\-].*/ ) ) {
					minYear += currentYear;
				}
				if ( yearSplit[ 1 ].match( /[+\-].*/ ) ) {
					maxYear += currentYear;
				}
			}

		return ( ( !minDate || date.getTime() >= minDate.getTime() ) &&
			( !maxDate || date.getTime() <= maxDate.getTime() ) &&
			( !minYear || date.getFullYear() >= minYear ) &&
			( !maxYear || date.getFullYear() <= maxYear ) );
	},

	/* Provide the configuration settings for formatting/parsing. */
	_getFormatConfig: function( inst ) {
		var shortYearCutoff = this._get( inst, "shortYearCutoff" );
		shortYearCutoff = ( typeof shortYearCutoff !== "string" ? shortYearCutoff :
			new Date().getFullYear() % 100 + parseInt( shortYearCutoff, 10 ) );
		return { shortYearCutoff: shortYearCutoff,
			dayNamesShort: this._get( inst, "dayNamesShort" ), dayNames: this._get( inst, "dayNames" ),
			monthNamesShort: this._get( inst, "monthNamesShort" ), monthNames: this._get( inst, "monthNames" ) };
	},

	/* Format the given date for display. */
	_formatDate: function( inst, day, month, year ) {
		if ( !day ) {
			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
		}
		var date = ( day ? ( typeof day === "object" ? day :
			this._daylightSavingAdjust( new Date( year, month, day ) ) ) :
			this._daylightSavingAdjust( new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
		return this.formatDate( this._get( inst, "dateFormat" ), date, this._getFormatConfig( inst ) );
	}
} );

/*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */
function datepicker_bindHover( dpDiv ) {
	var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
	return dpDiv.on( "mouseout", selector, function() {
			$( this ).removeClass( "ui-state-hover" );
			if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
				$( this ).removeClass( "ui-datepicker-prev-hover" );
			}
			if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
				$( this ).removeClass( "ui-datepicker-next-hover" );
			}
		} )
		.on( "mouseover", selector, datepicker_handleMouseover );
}

function datepicker_handleMouseover() {
	if ( !$.datepicker._isDisabledDatepicker( datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[ 0 ] : datepicker_instActive.input[ 0 ] ) ) {
		$( this ).parents( ".ui-datepicker-calendar" ).find( "a" ).removeClass( "ui-state-hover" );
		$( this ).addClass( "ui-state-hover" );
		if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
			$( this ).addClass( "ui-datepicker-prev-hover" );
		}
		if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
			$( this ).addClass( "ui-datepicker-next-hover" );
		}
	}
}

/* jQuery extend now ignores nulls! */
function datepicker_extendRemove( target, props ) {
	$.extend( target, props );
	for ( var name in props ) {
		if ( props[ name ] == null ) {
			target[ name ] = props[ name ];
		}
	}
	return target;
}

/* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */
$.fn.datepicker = function( options ) {

	/* Verify an empty collection wasn't passed - Fixes #6976 */
	if ( !this.length ) {
		return this;
	}

	/* Initialise the date picker. */
	if ( !$.datepicker.initialized ) {
		$( document ).on( "mousedown", $.datepicker._checkExternalClick );
		$.datepicker.initialized = true;
	}

	/* Append datepicker main container to body if not exist. */
	if ( $( "#" + $.datepicker._mainDivId ).length === 0 ) {
		$( "body" ).append( $.datepicker.dpDiv );
	}

	var otherArgs = Array.prototype.slice.call( arguments, 1 );
	if ( typeof options === "string" && ( options === "isDisabled" || options === "getDate" || options === "widget" ) ) {
		return $.datepicker[ "_" + options + "Datepicker" ].
			apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
	}
	if ( options === "option" && arguments.length === 2 && typeof arguments[ 1 ] === "string" ) {
		return $.datepicker[ "_" + options + "Datepicker" ].
			apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
	}
	return this.each( function() {
		typeof options === "string" ?
			$.datepicker[ "_" + options + "Datepicker" ].
				apply( $.datepicker, [ this ].concat( otherArgs ) ) :
			$.datepicker._attachDatepicker( this, options );
	} );
};

$.datepicker = new Datepicker(); // singleton instance
$.datepicker.initialized = false;
$.datepicker.uuid = new Date().getTime();
$.datepicker.version = "1.12.1";

var widgetsDatepicker = $.datepicker;


/*!
 * jQuery UI Dialog 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Dialog
//>>group: Widgets
//>>description: Displays customizable dialog windows.
//>>docs: http://api.jqueryui.com/dialog/
//>>demos: http://jqueryui.com/dialog/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/dialog.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.dialog", {
	version: "1.12.1",
	options: {
		appendTo: "body",
		autoOpen: true,
		buttons: [],
		classes: {
			"ui-dialog": "ui-corner-all",
			"ui-dialog-titlebar": "ui-corner-all"
		},
		closeOnEscape: true,
		closeText: "Close",
		draggable: true,
		hide: null,
		height: "auto",
		maxHeight: null,
		maxWidth: null,
		minHeight: 150,
		minWidth: 150,
		modal: false,
		position: {
			my: "center",
			at: "center",
			of: window,
			collision: "fit",

			// Ensure the titlebar is always visible
			using: function( pos ) {
				var topOffset = $( this ).css( pos ).offset().top;
				if ( topOffset < 0 ) {
					$( this ).css( "top", pos.top - topOffset );
				}
			}
		},
		resizable: true,
		show: null,
		title: null,
		width: 300,

		// Callbacks
		beforeClose: null,
		close: null,
		drag: null,
		dragStart: null,
		dragStop: null,
		focus: null,
		open: null,
		resize: null,
		resizeStart: null,
		resizeStop: null
	},

	sizeRelatedOptions: {
		buttons: true,
		height: true,
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true,
		width: true
	},

	resizableRelatedOptions: {
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true
	},

	_create: function() {
		this.originalCss = {
			display: this.element[ 0 ].style.display,
			width: this.element[ 0 ].style.width,
			minHeight: this.element[ 0 ].style.minHeight,
			maxHeight: this.element[ 0 ].style.maxHeight,
			height: this.element[ 0 ].style.height
		};
		this.originalPosition = {
			parent: this.element.parent(),
			index: this.element.parent().children().index( this.element )
		};
		this.originalTitle = this.element.attr( "title" );
		if ( this.options.title == null && this.originalTitle != null ) {
			this.options.title = this.originalTitle;
		}

		// Dialogs can't be disabled
		if ( this.options.disabled ) {
			this.options.disabled = false;
		}

		this._createWrapper();

		this.element
			.show()
			.removeAttr( "title" )
			.appendTo( this.uiDialog );

		this._addClass( "ui-dialog-content", "ui-widget-content" );

		this._createTitlebar();
		this._createButtonPane();

		if ( this.options.draggable && $.fn.draggable ) {
			this._makeDraggable();
		}
		if ( this.options.resizable && $.fn.resizable ) {
			this._makeResizable();
		}

		this._isOpen = false;

		this._trackFocus();
	},

	_init: function() {
		if ( this.options.autoOpen ) {
			this.open();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;
		if ( element && ( element.jquery || element.nodeType ) ) {
			return $( element );
		}
		return this.document.find( element || "body" ).eq( 0 );
	},

	_destroy: function() {
		var next,
			originalPosition = this.originalPosition;

		this._untrackInstance();
		this._destroyOverlay();

		this.element
			.removeUniqueId()
			.css( this.originalCss )

			// Without detaching first, the following becomes really slow
			.detach();

		this.uiDialog.remove();

		if ( this.originalTitle ) {
			this.element.attr( "title", this.originalTitle );
		}

		next = originalPosition.parent.children().eq( originalPosition.index );

		// Don't try to place the dialog next to itself (#8613)
		if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
			next.before( this.element );
		} else {
			originalPosition.parent.append( this.element );
		}
	},

	widget: function() {
		return this.uiDialog;
	},

	disable: $.noop,
	enable: $.noop,

	close: function( event ) {
		var that = this;

		if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
			return;
		}

		this._isOpen = false;
		this._focusedElement = null;
		this._destroyOverlay();
		this._untrackInstance();

		if ( !this.opener.filter( ":focusable" ).trigger( "focus" ).length ) {

			// Hiding a focused element doesn't trigger blur in WebKit
			// so in case we have nothing to focus on, explicitly blur the active element
			// https://bugs.webkit.org/show_bug.cgi?id=47182
			$.ui.safeBlur( $.ui.safeActiveElement( this.document[ 0 ] ) );
		}

		this._hide( this.uiDialog, this.options.hide, function() {
			that._trigger( "close", event );
		} );
	},

	isOpen: function() {
		return this._isOpen;
	},

	moveToTop: function() {
		this._moveToTop();
	},

	_moveToTop: function( event, silent ) {
		var moved = false,
			zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map( function() {
				return +$( this ).css( "z-index" );
			} ).get(),
			zIndexMax = Math.max.apply( null, zIndices );

		if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
			this.uiDialog.css( "z-index", zIndexMax + 1 );
			moved = true;
		}

		if ( moved && !silent ) {
			this._trigger( "focus", event );
		}
		return moved;
	},

	open: function() {
		var that = this;
		if ( this._isOpen ) {
			if ( this._moveToTop() ) {
				this._focusTabbable();
			}
			return;
		}

		this._isOpen = true;
		this.opener = $( $.ui.safeActiveElement( this.document[ 0 ] ) );

		this._size();
		this._position();
		this._createOverlay();
		this._moveToTop( null, true );

		// Ensure the overlay is moved to the top with the dialog, but only when
		// opening. The overlay shouldn't move after the dialog is open so that
		// modeless dialogs opened after the modal dialog stack properly.
		if ( this.overlay ) {
			this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
		}

		this._show( this.uiDialog, this.options.show, function() {
			that._focusTabbable();
			that._trigger( "focus" );
		} );

		// Track the dialog immediately upon openening in case a focus event
		// somehow occurs outside of the dialog before an element inside the
		// dialog is focused (#10152)
		this._makeFocusTarget();

		this._trigger( "open" );
	},

	_focusTabbable: function() {

		// Set focus to the first match:
		// 1. An element that was focused previously
		// 2. First element inside the dialog matching [autofocus]
		// 3. Tabbable element inside the content element
		// 4. Tabbable element inside the buttonpane
		// 5. The close button
		// 6. The dialog itself
		var hasFocus = this._focusedElement;
		if ( !hasFocus ) {
			hasFocus = this.element.find( "[autofocus]" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.element.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialog;
		}
		hasFocus.eq( 0 ).trigger( "focus" );
	},

	_keepFocus: function( event ) {
		function checkFocus() {
			var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
				isActive = this.uiDialog[ 0 ] === activeElement ||
					$.contains( this.uiDialog[ 0 ], activeElement );
			if ( !isActive ) {
				this._focusTabbable();
			}
		}
		event.preventDefault();
		checkFocus.call( this );

		// support: IE
		// IE <= 8 doesn't prevent moving focus even with event.preventDefault()
		// so we check again later
		this._delay( checkFocus );
	},

	_createWrapper: function() {
		this.uiDialog = $( "<div>" )
			.hide()
			.attr( {

				// Setting tabIndex makes the div focusable
				tabIndex: -1,
				role: "dialog"
			} )
			.appendTo( this._appendTo() );

		this._addClass( this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front" );
		this._on( this.uiDialog, {
			keydown: function( event ) {
				if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE ) {
					event.preventDefault();
					this.close( event );
					return;
				}

				// Prevent tabbing out of dialogs
				if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
					return;
				}
				var tabbables = this.uiDialog.find( ":tabbable" ),
					first = tabbables.filter( ":first" ),
					last = tabbables.filter( ":last" );

				if ( ( event.target === last[ 0 ] || event.target === this.uiDialog[ 0 ] ) &&
						!event.shiftKey ) {
					this._delay( function() {
						first.trigger( "focus" );
					} );
					event.preventDefault();
				} else if ( ( event.target === first[ 0 ] ||
						event.target === this.uiDialog[ 0 ] ) && event.shiftKey ) {
					this._delay( function() {
						last.trigger( "focus" );
					} );
					event.preventDefault();
				}
			},
			mousedown: function( event ) {
				if ( this._moveToTop( event ) ) {
					this._focusTabbable();
				}
			}
		} );

		// We assume that any existing aria-describedby attribute means
		// that the dialog content is marked up properly
		// otherwise we brute force the content as the description
		if ( !this.element.find( "[aria-describedby]" ).length ) {
			this.uiDialog.attr( {
				"aria-describedby": this.element.uniqueId().attr( "id" )
			} );
		}
	},

	_createTitlebar: function() {
		var uiDialogTitle;

		this.uiDialogTitlebar = $( "<div>" );
		this._addClass( this.uiDialogTitlebar,
			"ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix" );
		this._on( this.uiDialogTitlebar, {
			mousedown: function( event ) {

				// Don't prevent click on close button (#8838)
				// Focusing a dialog that is partially scrolled out of view
				// causes the browser to scroll it into view, preventing the click event
				if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {

					// Dialog isn't getting focus when dragging (#8063)
					this.uiDialog.trigger( "focus" );
				}
			}
		} );

		// Support: IE
		// Use type="button" to prevent enter keypresses in textboxes from closing the
		// dialog in IE (#9312)
		this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
			.button( {
				label: $( "<a>" ).text( this.options.closeText ).html(),
				icon: "ui-icon-closethick",
				showLabel: false
			} )
			.appendTo( this.uiDialogTitlebar );

		this._addClass( this.uiDialogTitlebarClose, "ui-dialog-titlebar-close" );
		this._on( this.uiDialogTitlebarClose, {
			click: function( event ) {
				event.preventDefault();
				this.close( event );
			}
		} );

		uiDialogTitle = $( "<span>" ).uniqueId().prependTo( this.uiDialogTitlebar );
		this._addClass( uiDialogTitle, "ui-dialog-title" );
		this._title( uiDialogTitle );

		this.uiDialogTitlebar.prependTo( this.uiDialog );

		this.uiDialog.attr( {
			"aria-labelledby": uiDialogTitle.attr( "id" )
		} );
	},

	_title: function( title ) {
		if ( this.options.title ) {
			title.text( this.options.title );
		} else {
			title.html( "&#160;" );
		}
	},

	_createButtonPane: function() {
		this.uiDialogButtonPane = $( "<div>" );
		this._addClass( this.uiDialogButtonPane, "ui-dialog-buttonpane",
			"ui-widget-content ui-helper-clearfix" );

		this.uiButtonSet = $( "<div>" )
			.appendTo( this.uiDialogButtonPane );
		this._addClass( this.uiButtonSet, "ui-dialog-buttonset" );

		this._createButtons();
	},

	_createButtons: function() {
		var that = this,
			buttons = this.options.buttons;

		// If we already have a button pane, remove it
		this.uiDialogButtonPane.remove();
		this.uiButtonSet.empty();

		if ( $.isEmptyObject( buttons ) || ( $.isArray( buttons ) && !buttons.length ) ) {
			this._removeClass( this.uiDialog, "ui-dialog-buttons" );
			return;
		}

		$.each( buttons, function( name, props ) {
			var click, buttonOptions;
			props = $.isFunction( props ) ?
				{ click: props, text: name } :
				props;

			// Default to a non-submitting button
			props = $.extend( { type: "button" }, props );

			// Change the context for the click callback to be the main element
			click = props.click;
			buttonOptions = {
				icon: props.icon,
				iconPosition: props.iconPosition,
				showLabel: props.showLabel,

				// Deprecated options
				icons: props.icons,
				text: props.text
			};

			delete props.click;
			delete props.icon;
			delete props.iconPosition;
			delete props.showLabel;

			// Deprecated options
			delete props.icons;
			if ( typeof props.text === "boolean" ) {
				delete props.text;
			}

			$( "<button></button>", props )
				.button( buttonOptions )
				.appendTo( that.uiButtonSet )
				.on( "click", function() {
					click.apply( that.element[ 0 ], arguments );
				} );
		} );
		this._addClass( this.uiDialog, "ui-dialog-buttons" );
		this.uiDialogButtonPane.appendTo( this.uiDialog );
	},

	_makeDraggable: function() {
		var that = this,
			options = this.options;

		function filteredUi( ui ) {
			return {
				position: ui.position,
				offset: ui.offset
			};
		}

		this.uiDialog.draggable( {
			cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
			handle: ".ui-dialog-titlebar",
			containment: "document",
			start: function( event, ui ) {
				that._addClass( $( this ), "ui-dialog-dragging" );
				that._blockFrames();
				that._trigger( "dragStart", event, filteredUi( ui ) );
			},
			drag: function( event, ui ) {
				that._trigger( "drag", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var left = ui.offset.left - that.document.scrollLeft(),
					top = ui.offset.top - that.document.scrollTop();

				options.position = {
					my: "left top",
					at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
					of: that.window
				};
				that._removeClass( $( this ), "ui-dialog-dragging" );
				that._unblockFrames();
				that._trigger( "dragStop", event, filteredUi( ui ) );
			}
		} );
	},

	_makeResizable: function() {
		var that = this,
			options = this.options,
			handles = options.resizable,

			// .ui-resizable has position: relative defined in the stylesheet
			// but dialogs have to use absolute or fixed positioning
			position = this.uiDialog.css( "position" ),
			resizeHandles = typeof handles === "string" ?
				handles :
				"n,e,s,w,se,sw,ne,nw";

		function filteredUi( ui ) {
			return {
				originalPosition: ui.originalPosition,
				originalSize: ui.originalSize,
				position: ui.position,
				size: ui.size
			};
		}

		this.uiDialog.resizable( {
			cancel: ".ui-dialog-content",
			containment: "document",
			alsoResize: this.element,
			maxWidth: options.maxWidth,
			maxHeight: options.maxHeight,
			minWidth: options.minWidth,
			minHeight: this._minHeight(),
			handles: resizeHandles,
			start: function( event, ui ) {
				that._addClass( $( this ), "ui-dialog-resizing" );
				that._blockFrames();
				that._trigger( "resizeStart", event, filteredUi( ui ) );
			},
			resize: function( event, ui ) {
				that._trigger( "resize", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var offset = that.uiDialog.offset(),
					left = offset.left - that.document.scrollLeft(),
					top = offset.top - that.document.scrollTop();

				options.height = that.uiDialog.height();
				options.width = that.uiDialog.width();
				options.position = {
					my: "left top",
					at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
					of: that.window
				};
				that._removeClass( $( this ), "ui-dialog-resizing" );
				that._unblockFrames();
				that._trigger( "resizeStop", event, filteredUi( ui ) );
			}
		} )
			.css( "position", position );
	},

	_trackFocus: function() {
		this._on( this.widget(), {
			focusin: function( event ) {
				this._makeFocusTarget();
				this._focusedElement = $( event.target );
			}
		} );
	},

	_makeFocusTarget: function() {
		this._untrackInstance();
		this._trackingInstances().unshift( this );
	},

	_untrackInstance: function() {
		var instances = this._trackingInstances(),
			exists = $.inArray( this, instances );
		if ( exists !== -1 ) {
			instances.splice( exists, 1 );
		}
	},

	_trackingInstances: function() {
		var instances = this.document.data( "ui-dialog-instances" );
		if ( !instances ) {
			instances = [];
			this.document.data( "ui-dialog-instances", instances );
		}
		return instances;
	},

	_minHeight: function() {
		var options = this.options;

		return options.height === "auto" ?
			options.minHeight :
			Math.min( options.minHeight, options.height );
	},

	_position: function() {

		// Need to show the dialog to get the actual offset in the position plugin
		var isVisible = this.uiDialog.is( ":visible" );
		if ( !isVisible ) {
			this.uiDialog.show();
		}
		this.uiDialog.position( this.options.position );
		if ( !isVisible ) {
			this.uiDialog.hide();
		}
	},

	_setOptions: function( options ) {
		var that = this,
			resize = false,
			resizableOptions = {};

		$.each( options, function( key, value ) {
			that._setOption( key, value );

			if ( key in that.sizeRelatedOptions ) {
				resize = true;
			}
			if ( key in that.resizableRelatedOptions ) {
				resizableOptions[ key ] = value;
			}
		} );

		if ( resize ) {
			this._size();
			this._position();
		}
		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", resizableOptions );
		}
	},

	_setOption: function( key, value ) {
		var isDraggable, isResizable,
			uiDialog = this.uiDialog;

		if ( key === "disabled" ) {
			return;
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.uiDialog.appendTo( this._appendTo() );
		}

		if ( key === "buttons" ) {
			this._createButtons();
		}

		if ( key === "closeText" ) {
			this.uiDialogTitlebarClose.button( {

				// Ensure that we always pass a string
				label: $( "<a>" ).text( "" + this.options.closeText ).html()
			} );
		}

		if ( key === "draggable" ) {
			isDraggable = uiDialog.is( ":data(ui-draggable)" );
			if ( isDraggable && !value ) {
				uiDialog.draggable( "destroy" );
			}

			if ( !isDraggable && value ) {
				this._makeDraggable();
			}
		}

		if ( key === "position" ) {
			this._position();
		}

		if ( key === "resizable" ) {

			// currently resizable, becoming non-resizable
			isResizable = uiDialog.is( ":data(ui-resizable)" );
			if ( isResizable && !value ) {
				uiDialog.resizable( "destroy" );
			}

			// Currently resizable, changing handles
			if ( isResizable && typeof value === "string" ) {
				uiDialog.resizable( "option", "handles", value );
			}

			// Currently non-resizable, becoming resizable
			if ( !isResizable && value !== false ) {
				this._makeResizable();
			}
		}

		if ( key === "title" ) {
			this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
		}
	},

	_size: function() {

		// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
		// divs will both have width and height set, so we need to reset them
		var nonContentHeight, minContentHeight, maxContentHeight,
			options = this.options;

		// Reset content sizing
		this.element.show().css( {
			width: "auto",
			minHeight: 0,
			maxHeight: "none",
			height: 0
		} );

		if ( options.minWidth > options.width ) {
			options.width = options.minWidth;
		}

		// Reset wrapper sizing
		// determine the height of all the non-content elements
		nonContentHeight = this.uiDialog.css( {
			height: "auto",
			width: options.width
		} )
			.outerHeight();
		minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
		maxContentHeight = typeof options.maxHeight === "number" ?
			Math.max( 0, options.maxHeight - nonContentHeight ) :
			"none";

		if ( options.height === "auto" ) {
			this.element.css( {
				minHeight: minContentHeight,
				maxHeight: maxContentHeight,
				height: "auto"
			} );
		} else {
			this.element.height( Math.max( 0, options.height - nonContentHeight ) );
		}

		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
		}
	},

	_blockFrames: function() {
		this.iframeBlocks = this.document.find( "iframe" ).map( function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( {
					position: "absolute",
					width: iframe.outerWidth(),
					height: iframe.outerHeight()
				} )
				.appendTo( iframe.parent() )
				.offset( iframe.offset() )[ 0 ];
		} );
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_allowInteraction: function( event ) {
		if ( $( event.target ).closest( ".ui-dialog" ).length ) {
			return true;
		}

		// TODO: Remove hack when datepicker implements
		// the .ui-front logic (#8989)
		return !!$( event.target ).closest( ".ui-datepicker" ).length;
	},

	_createOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		// We use a delay in case the overlay is created from an
		// event that we're going to be cancelling (#2804)
		var isOpening = true;
		this._delay( function() {
			isOpening = false;
		} );

		if ( !this.document.data( "ui-dialog-overlays" ) ) {

			// Prevent use of anchors and inputs
			// Using _on() for an event handler shared across many instances is
			// safe because the dialogs stack and must be closed in reverse order
			this._on( this.document, {
				focusin: function( event ) {
					if ( isOpening ) {
						return;
					}

					if ( !this._allowInteraction( event ) ) {
						event.preventDefault();
						this._trackingInstances()[ 0 ]._focusTabbable();
					}
				}
			} );
		}

		this.overlay = $( "<div>" )
			.appendTo( this._appendTo() );

		this._addClass( this.overlay, null, "ui-widget-overlay ui-front" );
		this._on( this.overlay, {
			mousedown: "_keepFocus"
		} );
		this.document.data( "ui-dialog-overlays",
			( this.document.data( "ui-dialog-overlays" ) || 0 ) + 1 );
	},

	_destroyOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		if ( this.overlay ) {
			var overlays = this.document.data( "ui-dialog-overlays" ) - 1;

			if ( !overlays ) {
				this._off( this.document, "focusin" );
				this.document.removeData( "ui-dialog-overlays" );
			} else {
				this.document.data( "ui-dialog-overlays", overlays );
			}

			this.overlay.remove();
			this.overlay = null;
		}
	}
} );

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for dialogClass option
	$.widget( "ui.dialog", $.ui.dialog, {
		options: {
			dialogClass: ""
		},
		_createWrapper: function() {
			this._super();
			this.uiDialog.addClass( this.options.dialogClass );
		},
		_setOption: function( key, value ) {
			if ( key === "dialogClass" ) {
				this.uiDialog
					.removeClass( this.options.dialogClass )
					.addClass( value );
			}
			this._superApply( arguments );
		}
	} );
}

var widgetsDialog = $.ui.dialog;


/*!
 * jQuery UI Progressbar 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Progressbar
//>>group: Widgets
// jscs:disable maximumLineLength
//>>description: Displays a status indicator for loading state, standard percentage, and other progress indicators.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/progressbar/
//>>demos: http://jqueryui.com/progressbar/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/progressbar.css
//>>css.theme: ../../themes/base/theme.css



var widgetsProgressbar = $.widget( "ui.progressbar", {
	version: "1.12.1",
	options: {
		classes: {
			"ui-progressbar": "ui-corner-all",
			"ui-progressbar-value": "ui-corner-left",
			"ui-progressbar-complete": "ui-corner-right"
		},
		max: 100,
		value: 0,

		change: null,
		complete: null
	},

	min: 0,

	_create: function() {

		// Constrain initial value
		this.oldValue = this.options.value = this._constrainedValue();

		this.element.attr( {

			// Only set static values; aria-valuenow and aria-valuemax are
			// set inside _refreshValue()
			role: "progressbar",
			"aria-valuemin": this.min
		} );
		this._addClass( "ui-progressbar", "ui-widget ui-widget-content" );

		this.valueDiv = $( "<div>" ).appendTo( this.element );
		this._addClass( this.valueDiv, "ui-progressbar-value", "ui-widget-header" );
		this._refreshValue();
	},

	_destroy: function() {
		this.element.removeAttr( "role aria-valuemin aria-valuemax aria-valuenow" );

		this.valueDiv.remove();
	},

	value: function( newValue ) {
		if ( newValue === undefined ) {
			return this.options.value;
		}

		this.options.value = this._constrainedValue( newValue );
		this._refreshValue();
	},

	_constrainedValue: function( newValue ) {
		if ( newValue === undefined ) {
			newValue = this.options.value;
		}

		this.indeterminate = newValue === false;

		// Sanitize value
		if ( typeof newValue !== "number" ) {
			newValue = 0;
		}

		return this.indeterminate ? false :
			Math.min( this.options.max, Math.max( this.min, newValue ) );
	},

	_setOptions: function( options ) {

		// Ensure "value" option is set after other values (like max)
		var value = options.value;
		delete options.value;

		this._super( options );

		this.options.value = this._constrainedValue( value );
		this._refreshValue();
	},

	_setOption: function( key, value ) {
		if ( key === "max" ) {

			// Don't allow a max less than min
			value = Math.max( this.min, value );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	_percentage: function() {
		return this.indeterminate ?
			100 :
			100 * ( this.options.value - this.min ) / ( this.options.max - this.min );
	},

	_refreshValue: function() {
		var value = this.options.value,
			percentage = this._percentage();

		this.valueDiv
			.toggle( this.indeterminate || value > this.min )
			.width( percentage.toFixed( 0 ) + "%" );

		this
			._toggleClass( this.valueDiv, "ui-progressbar-complete", null,
				value === this.options.max )
			._toggleClass( "ui-progressbar-indeterminate", null, this.indeterminate );

		if ( this.indeterminate ) {
			this.element.removeAttr( "aria-valuenow" );
			if ( !this.overlayDiv ) {
				this.overlayDiv = $( "<div>" ).appendTo( this.valueDiv );
				this._addClass( this.overlayDiv, "ui-progressbar-overlay" );
			}
		} else {
			this.element.attr( {
				"aria-valuemax": this.options.max,
				"aria-valuenow": value
			} );
			if ( this.overlayDiv ) {
				this.overlayDiv.remove();
				this.overlayDiv = null;
			}
		}

		if ( this.oldValue !== value ) {
			this.oldValue = value;
			this._trigger( "change" );
		}
		if ( value === this.options.max ) {
			this._trigger( "complete" );
		}
	}
} );


/*!
 * jQuery UI Selectmenu 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Selectmenu
//>>group: Widgets
// jscs:disable maximumLineLength
//>>description: Duplicates and extends the functionality of a native HTML select element, allowing it to be customizable in behavior and appearance far beyond the limitations of a native select.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/selectmenu/
//>>demos: http://jqueryui.com/selectmenu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/selectmenu.css, ../../themes/base/button.css
//>>css.theme: ../../themes/base/theme.css



var widgetsSelectmenu = $.widget( "ui.selectmenu", [ $.ui.formResetMixin, {
	version: "1.12.1",
	defaultElement: "<select>",
	options: {
		appendTo: null,
		classes: {
			"ui-selectmenu-button-open": "ui-corner-top",
			"ui-selectmenu-button-closed": "ui-corner-all"
		},
		disabled: null,
		icons: {
			button: "ui-icon-triangle-1-s"
		},
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		width: false,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		select: null
	},

	_create: function() {
		var selectmenuId = this.element.uniqueId().attr( "id" );
		this.ids = {
			element: selectmenuId,
			button: selectmenuId + "-button",
			menu: selectmenuId + "-menu"
		};

		this._drawButton();
		this._drawMenu();
		this._bindFormResetHandler();

		this._rendered = false;
		this.menuItems = $();
	},

	_drawButton: function() {
		var icon,
			that = this,
			item = this._parseOption(
				this.element.find( "option:selected" ),
				this.element[ 0 ].selectedIndex
			);

		// Associate existing label with the new button
		this.labels = this.element.labels().attr( "for", this.ids.button );
		this._on( this.labels, {
			click: function( event ) {
				this.button.focus();
				event.preventDefault();
			}
		} );

		// Hide original select element
		this.element.hide();

		// Create button
		this.button = $( "<span>", {
			tabindex: this.options.disabled ? -1 : 0,
			id: this.ids.button,
			role: "combobox",
			"aria-expanded": "false",
			"aria-autocomplete": "list",
			"aria-owns": this.ids.menu,
			"aria-haspopup": "true",
			title: this.element.attr( "title" )
		} )
			.insertAfter( this.element );

		this._addClass( this.button, "ui-selectmenu-button ui-selectmenu-button-closed",
			"ui-button ui-widget" );

		icon = $( "<span>" ).appendTo( this.button );
		this._addClass( icon, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button );
		this.buttonItem = this._renderButtonItem( item )
			.appendTo( this.button );

		if ( this.options.width !== false ) {
			this._resizeButton();
		}

		this._on( this.button, this._buttonEvents );
		this.button.one( "focusin", function() {

			// Delay rendering the menu items until the button receives focus.
			// The menu may have already been rendered via a programmatic open.
			if ( !that._rendered ) {
				that._refreshMenu();
			}
		} );
	},

	_drawMenu: function() {
		var that = this;

		// Create menu
		this.menu = $( "<ul>", {
			"aria-hidden": "true",
			"aria-labelledby": this.ids.button,
			id: this.ids.menu
		} );

		// Wrap menu
		this.menuWrap = $( "<div>" ).append( this.menu );
		this._addClass( this.menuWrap, "ui-selectmenu-menu", "ui-front" );
		this.menuWrap.appendTo( this._appendTo() );

		// Initialize menu widget
		this.menuInstance = this.menu
			.menu( {
				classes: {
					"ui-menu": "ui-corner-bottom"
				},
				role: "listbox",
				select: function( event, ui ) {
					event.preventDefault();

					// Support: IE8
					// If the item was selected via a click, the text selection
					// will be destroyed in IE
					that._setSelection();

					that._select( ui.item.data( "ui-selectmenu-item" ), event );
				},
				focus: function( event, ui ) {
					var item = ui.item.data( "ui-selectmenu-item" );

					// Prevent inital focus from firing and check if its a newly focused item
					if ( that.focusIndex != null && item.index !== that.focusIndex ) {
						that._trigger( "focus", event, { item: item } );
						if ( !that.isOpen ) {
							that._select( item, event );
						}
					}
					that.focusIndex = item.index;

					that.button.attr( "aria-activedescendant",
						that.menuItems.eq( item.index ).attr( "id" ) );
				}
			} )
			.menu( "instance" );

		// Don't close the menu on mouseleave
		this.menuInstance._off( this.menu, "mouseleave" );

		// Cancel the menu's collapseAll on document click
		this.menuInstance._closeOnDocumentClick = function() {
			return false;
		};

		// Selects often contain empty items, but never contain dividers
		this.menuInstance._isDivider = function() {
			return false;
		};
	},

	refresh: function() {
		this._refreshMenu();
		this.buttonItem.replaceWith(
			this.buttonItem = this._renderButtonItem(

				// Fall back to an empty object in case there are no options
				this._getSelectedItem().data( "ui-selectmenu-item" ) || {}
			)
		);
		if ( this.options.width === null ) {
			this._resizeButton();
		}
	},

	_refreshMenu: function() {
		var item,
			options = this.element.find( "option" );

		this.menu.empty();

		this._parseOptions( options );
		this._renderMenu( this.menu, this.items );

		this.menuInstance.refresh();
		this.menuItems = this.menu.find( "li" )
			.not( ".ui-selectmenu-optgroup" )
				.find( ".ui-menu-item-wrapper" );

		this._rendered = true;

		if ( !options.length ) {
			return;
		}

		item = this._getSelectedItem();

		// Update the menu to have the correct item focused
		this.menuInstance.focus( null, item );
		this._setAria( item.data( "ui-selectmenu-item" ) );

		// Set disabled state
		this._setOption( "disabled", this.element.prop( "disabled" ) );
	},

	open: function( event ) {
		if ( this.options.disabled ) {
			return;
		}

		// If this is the first time the menu is being opened, render the items
		if ( !this._rendered ) {
			this._refreshMenu();
		} else {

			// Menu clears focus on close, reset focus to selected item
			this._removeClass( this.menu.find( ".ui-state-active" ), null, "ui-state-active" );
			this.menuInstance.focus( null, this._getSelectedItem() );
		}

		// If there are no options, don't open the menu
		if ( !this.menuItems.length ) {
			return;
		}

		this.isOpen = true;
		this._toggleAttr();
		this._resizeMenu();
		this._position();

		this._on( this.document, this._documentClick );

		this._trigger( "open", event );
	},

	_position: function() {
		this.menuWrap.position( $.extend( { of: this.button }, this.options.position ) );
	},

	close: function( event ) {
		if ( !this.isOpen ) {
			return;
		}

		this.isOpen = false;
		this._toggleAttr();

		this.range = null;
		this._off( this.document );

		this._trigger( "close", event );
	},

	widget: function() {
		return this.button;
	},

	menuWidget: function() {
		return this.menu;
	},

	_renderButtonItem: function( item ) {
		var buttonItem = $( "<span>" );

		this._setText( buttonItem, item.label );
		this._addClass( buttonItem, "ui-selectmenu-text" );

		return buttonItem;
	},

	_renderMenu: function( ul, items ) {
		var that = this,
			currentOptgroup = "";

		$.each( items, function( index, item ) {
			var li;

			if ( item.optgroup !== currentOptgroup ) {
				li = $( "<li>", {
					text: item.optgroup
				} );
				that._addClass( li, "ui-selectmenu-optgroup", "ui-menu-divider" +
					( item.element.parent( "optgroup" ).prop( "disabled" ) ?
						" ui-state-disabled" :
						"" ) );

				li.appendTo( ul );

				currentOptgroup = item.optgroup;
			}

			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-selectmenu-item", item );
	},

	_renderItem: function( ul, item ) {
		var li = $( "<li>" ),
			wrapper = $( "<div>", {
				title: item.element.attr( "title" )
			} );

		if ( item.disabled ) {
			this._addClass( li, null, "ui-state-disabled" );
		}
		this._setText( wrapper, item.label );

		return li.append( wrapper ).appendTo( ul );
	},

	_setText: function( element, value ) {
		if ( value ) {
			element.text( value );
		} else {
			element.html( "&#160;" );
		}
	},

	_move: function( direction, event ) {
		var item, next,
			filter = ".ui-menu-item";

		if ( this.isOpen ) {
			item = this.menuItems.eq( this.focusIndex ).parent( "li" );
		} else {
			item = this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
			filter += ":not(.ui-state-disabled)";
		}

		if ( direction === "first" || direction === "last" ) {
			next = item[ direction === "first" ? "prevAll" : "nextAll" ]( filter ).eq( -1 );
		} else {
			next = item[ direction + "All" ]( filter ).eq( 0 );
		}

		if ( next.length ) {
			this.menuInstance.focus( event, next );
		}
	},

	_getSelectedItem: function() {
		return this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
	},

	_toggle: function( event ) {
		this[ this.isOpen ? "close" : "open" ]( event );
	},

	_setSelection: function() {
		var selection;

		if ( !this.range ) {
			return;
		}

		if ( window.getSelection ) {
			selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange( this.range );

		// Support: IE8
		} else {
			this.range.select();
		}

		// Support: IE
		// Setting the text selection kills the button focus in IE, but
		// restoring the focus doesn't kill the selection.
		this.button.focus();
	},

	_documentClick: {
		mousedown: function( event ) {
			if ( !this.isOpen ) {
				return;
			}

			if ( !$( event.target ).closest( ".ui-selectmenu-menu, #" +
					$.ui.escapeSelector( this.ids.button ) ).length ) {
				this.close( event );
			}
		}
	},

	_buttonEvents: {

		// Prevent text selection from being reset when interacting with the selectmenu (#10144)
		mousedown: function() {
			var selection;

			if ( window.getSelection ) {
				selection = window.getSelection();
				if ( selection.rangeCount ) {
					this.range = selection.getRangeAt( 0 );
				}

			// Support: IE8
			} else {
				this.range = document.selection.createRange();
			}
		},

		click: function( event ) {
			this._setSelection();
			this._toggle( event );
		},

		keydown: function( event ) {
			var preventDefault = true;
			switch ( event.keyCode ) {
			case $.ui.keyCode.TAB:
			case $.ui.keyCode.ESCAPE:
				this.close( event );
				preventDefault = false;
				break;
			case $.ui.keyCode.ENTER:
				if ( this.isOpen ) {
					this._selectFocusedItem( event );
				}
				break;
			case $.ui.keyCode.UP:
				if ( event.altKey ) {
					this._toggle( event );
				} else {
					this._move( "prev", event );
				}
				break;
			case $.ui.keyCode.DOWN:
				if ( event.altKey ) {
					this._toggle( event );
				} else {
					this._move( "next", event );
				}
				break;
			case $.ui.keyCode.SPACE:
				if ( this.isOpen ) {
					this._selectFocusedItem( event );
				} else {
					this._toggle( event );
				}
				break;
			case $.ui.keyCode.LEFT:
				this._move( "prev", event );
				break;
			case $.ui.keyCode.RIGHT:
				this._move( "next", event );
				break;
			case $.ui.keyCode.HOME:
			case $.ui.keyCode.PAGE_UP:
				this._move( "first", event );
				break;
			case $.ui.keyCode.END:
			case $.ui.keyCode.PAGE_DOWN:
				this._move( "last", event );
				break;
			default:
				this.menu.trigger( event );
				preventDefault = false;
			}

			if ( preventDefault ) {
				event.preventDefault();
			}
		}
	},

	_selectFocusedItem: function( event ) {
		var item = this.menuItems.eq( this.focusIndex ).parent( "li" );
		if ( !item.hasClass( "ui-state-disabled" ) ) {
			this._select( item.data( "ui-selectmenu-item" ), event );
		}
	},

	_select: function( item, event ) {
		var oldIndex = this.element[ 0 ].selectedIndex;

		// Change native select element
		this.element[ 0 ].selectedIndex = item.index;
		this.buttonItem.replaceWith( this.buttonItem = this._renderButtonItem( item ) );
		this._setAria( item );
		this._trigger( "select", event, { item: item } );

		if ( item.index !== oldIndex ) {
			this._trigger( "change", event, { item: item } );
		}

		this.close( event );
	},

	_setAria: function( item ) {
		var id = this.menuItems.eq( item.index ).attr( "id" );

		this.button.attr( {
			"aria-labelledby": id,
			"aria-activedescendant": id
		} );
		this.menu.attr( "aria-activedescendant", id );
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icon = this.button.find( "span.ui-icon" );
			this._removeClass( icon, null, this.options.icons.button )
				._addClass( icon, null, value.button );
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.menuWrap.appendTo( this._appendTo() );
		}

		if ( key === "width" ) {
			this._resizeButton();
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.menuInstance.option( "disabled", value );
		this.button.attr( "aria-disabled", value );
		this._toggleClass( this.button, null, "ui-state-disabled", value );

		this.element.prop( "disabled", value );
		if ( value ) {
			this.button.attr( "tabindex", -1 );
			this.close();
		} else {
			this.button.attr( "tabindex", 0 );
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_toggleAttr: function() {
		this.button.attr( "aria-expanded", this.isOpen );

		// We can't use two _toggleClass() calls here, because we need to make sure
		// we always remove classes first and add them second, otherwise if both classes have the
		// same theme class, it will be removed after we add it.
		this._removeClass( this.button, "ui-selectmenu-button-" +
			( this.isOpen ? "closed" : "open" ) )
			._addClass( this.button, "ui-selectmenu-button-" +
				( this.isOpen ? "open" : "closed" ) )
			._toggleClass( this.menuWrap, "ui-selectmenu-open", null, this.isOpen );

		this.menu.attr( "aria-hidden", !this.isOpen );
	},

	_resizeButton: function() {
		var width = this.options.width;

		// For `width: false`, just remove inline style and stop
		if ( width === false ) {
			this.button.css( "width", "" );
			return;
		}

		// For `width: null`, match the width of the original element
		if ( width === null ) {
			width = this.element.show().outerWidth();
			this.element.hide();
		}

		this.button.outerWidth( width );
	},

	_resizeMenu: function() {
		this.menu.outerWidth( Math.max(
			this.button.outerWidth(),

			// Support: IE10
			// IE10 wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping
			this.menu.width( "" ).outerWidth() + 1
		) );
	},

	_getCreateOptions: function() {
		var options = this._super();

		options.disabled = this.element.prop( "disabled" );

		return options;
	},

	_parseOptions: function( options ) {
		var that = this,
			data = [];
		options.each( function( index, item ) {
			data.push( that._parseOption( $( item ), index ) );
		} );
		this.items = data;
	},

	_parseOption: function( option, index ) {
		var optgroup = option.parent( "optgroup" );

		return {
			element: option,
			index: index,
			value: option.val(),
			label: option.text(),
			optgroup: optgroup.attr( "label" ) || "",
			disabled: optgroup.prop( "disabled" ) || option.prop( "disabled" )
		};
	},

	_destroy: function() {
		this._unbindFormResetHandler();
		this.menuWrap.remove();
		this.button.remove();
		this.element.show();
		this.element.removeUniqueId();
		this.labels.attr( "for", this.ids.element );
	}
} ] );


/*!
 * jQuery UI Slider 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Slider
//>>group: Widgets
//>>description: Displays a flexible slider with ranges and accessibility via keyboard.
//>>docs: http://api.jqueryui.com/slider/
//>>demos: http://jqueryui.com/slider/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/slider.css
//>>css.theme: ../../themes/base/theme.css



var widgetsSlider = $.widget( "ui.slider", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "slide",

	options: {
		animate: false,
		classes: {
			"ui-slider": "ui-corner-all",
			"ui-slider-handle": "ui-corner-all",

			// Note: ui-widget-header isn't the most fittingly semantic framework class for this
			// element, but worked best visually with a variety of themes
			"ui-slider-range": "ui-corner-all ui-widget-header"
		},
		distance: 0,
		max: 100,
		min: 0,
		orientation: "horizontal",
		range: false,
		step: 1,
		value: 0,
		values: null,

		// Callbacks
		change: null,
		slide: null,
		start: null,
		stop: null
	},

	// Number of pages in a slider
	// (how many times can you page up/down to go through the whole range)
	numPages: 5,

	_create: function() {
		this._keySliding = false;
		this._mouseSliding = false;
		this._animateOff = true;
		this._handleIndex = null;
		this._detectOrientation();
		this._mouseInit();
		this._calculateNewMax();

		this._addClass( "ui-slider ui-slider-" + this.orientation,
			"ui-widget ui-widget-content" );

		this._refresh();

		this._animateOff = false;
	},

	_refresh: function() {
		this._createRange();
		this._createHandles();
		this._setupEvents();
		this._refreshValue();
	},

	_createHandles: function() {
		var i, handleCount,
			options = this.options,
			existingHandles = this.element.find( ".ui-slider-handle" ),
			handle = "<span tabindex='0'></span>",
			handles = [];

		handleCount = ( options.values && options.values.length ) || 1;

		if ( existingHandles.length > handleCount ) {
			existingHandles.slice( handleCount ).remove();
			existingHandles = existingHandles.slice( 0, handleCount );
		}

		for ( i = existingHandles.length; i < handleCount; i++ ) {
			handles.push( handle );
		}

		this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

		this._addClass( this.handles, "ui-slider-handle", "ui-state-default" );

		this.handle = this.handles.eq( 0 );

		this.handles.each( function( i ) {
			$( this )
				.data( "ui-slider-handle-index", i )
				.attr( "tabIndex", 0 );
		} );
	},

	_createRange: function() {
		var options = this.options;

		if ( options.range ) {
			if ( options.range === true ) {
				if ( !options.values ) {
					options.values = [ this._valueMin(), this._valueMin() ];
				} else if ( options.values.length && options.values.length !== 2 ) {
					options.values = [ options.values[ 0 ], options.values[ 0 ] ];
				} else if ( $.isArray( options.values ) ) {
					options.values = options.values.slice( 0 );
				}
			}

			if ( !this.range || !this.range.length ) {
				this.range = $( "<div>" )
					.appendTo( this.element );

				this._addClass( this.range, "ui-slider-range" );
			} else {
				this._removeClass( this.range, "ui-slider-range-min ui-slider-range-max" );

				// Handle range switching from true to min/max
				this.range.css( {
					"left": "",
					"bottom": ""
				} );
			}
			if ( options.range === "min" || options.range === "max" ) {
				this._addClass( this.range, "ui-slider-range-" + options.range );
			}
		} else {
			if ( this.range ) {
				this.range.remove();
			}
			this.range = null;
		}
	},

	_setupEvents: function() {
		this._off( this.handles );
		this._on( this.handles, this._handleEvents );
		this._hoverable( this.handles );
		this._focusable( this.handles );
	},

	_destroy: function() {
		this.handles.remove();
		if ( this.range ) {
			this.range.remove();
		}

		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
			that = this,
			o = this.options;

		if ( o.disabled ) {
			return false;
		}

		this.elementSize = {
			width: this.element.outerWidth(),
			height: this.element.outerHeight()
		};
		this.elementOffset = this.element.offset();

		position = { x: event.pageX, y: event.pageY };
		normValue = this._normValueFromMouse( position );
		distance = this._valueMax() - this._valueMin() + 1;
		this.handles.each( function( i ) {
			var thisDistance = Math.abs( normValue - that.values( i ) );
			if ( ( distance > thisDistance ) ||
				( distance === thisDistance &&
					( i === that._lastChangedValue || that.values( i ) === o.min ) ) ) {
				distance = thisDistance;
				closestHandle = $( this );
				index = i;
			}
		} );

		allowed = this._start( event, index );
		if ( allowed === false ) {
			return false;
		}
		this._mouseSliding = true;

		this._handleIndex = index;

		this._addClass( closestHandle, null, "ui-state-active" );
		closestHandle.trigger( "focus" );

		offset = closestHandle.offset();
		mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
		this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
			left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
			top: event.pageY - offset.top -
				( closestHandle.height() / 2 ) -
				( parseInt( closestHandle.css( "borderTopWidth" ), 10 ) || 0 ) -
				( parseInt( closestHandle.css( "borderBottomWidth" ), 10 ) || 0 ) +
				( parseInt( closestHandle.css( "marginTop" ), 10 ) || 0 )
		};

		if ( !this.handles.hasClass( "ui-state-hover" ) ) {
			this._slide( event, index, normValue );
		}
		this._animateOff = true;
		return true;
	},

	_mouseStart: function() {
		return true;
	},

	_mouseDrag: function( event ) {
		var position = { x: event.pageX, y: event.pageY },
			normValue = this._normValueFromMouse( position );

		this._slide( event, this._handleIndex, normValue );

		return false;
	},

	_mouseStop: function( event ) {
		this._removeClass( this.handles, null, "ui-state-active" );
		this._mouseSliding = false;

		this._stop( event, this._handleIndex );
		this._change( event, this._handleIndex );

		this._handleIndex = null;
		this._clickOffset = null;
		this._animateOff = false;

		return false;
	},

	_detectOrientation: function() {
		this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
	},

	_normValueFromMouse: function( position ) {
		var pixelTotal,
			pixelMouse,
			percentMouse,
			valueTotal,
			valueMouse;

		if ( this.orientation === "horizontal" ) {
			pixelTotal = this.elementSize.width;
			pixelMouse = position.x - this.elementOffset.left -
				( this._clickOffset ? this._clickOffset.left : 0 );
		} else {
			pixelTotal = this.elementSize.height;
			pixelMouse = position.y - this.elementOffset.top -
				( this._clickOffset ? this._clickOffset.top : 0 );
		}

		percentMouse = ( pixelMouse / pixelTotal );
		if ( percentMouse > 1 ) {
			percentMouse = 1;
		}
		if ( percentMouse < 0 ) {
			percentMouse = 0;
		}
		if ( this.orientation === "vertical" ) {
			percentMouse = 1 - percentMouse;
		}

		valueTotal = this._valueMax() - this._valueMin();
		valueMouse = this._valueMin() + percentMouse * valueTotal;

		return this._trimAlignValue( valueMouse );
	},

	_uiHash: function( index, value, values ) {
		var uiHash = {
			handle: this.handles[ index ],
			handleIndex: index,
			value: value !== undefined ? value : this.value()
		};

		if ( this._hasMultipleValues() ) {
			uiHash.value = value !== undefined ? value : this.values( index );
			uiHash.values = values || this.values();
		}

		return uiHash;
	},

	_hasMultipleValues: function() {
		return this.options.values && this.options.values.length;
	},

	_start: function( event, index ) {
		return this._trigger( "start", event, this._uiHash( index ) );
	},

	_slide: function( event, index, newVal ) {
		var allowed, otherVal,
			currentValue = this.value(),
			newValues = this.values();

		if ( this._hasMultipleValues() ) {
			otherVal = this.values( index ? 0 : 1 );
			currentValue = this.values( index );

			if ( this.options.values.length === 2 && this.options.range === true ) {
				newVal =  index === 0 ? Math.min( otherVal, newVal ) : Math.max( otherVal, newVal );
			}

			newValues[ index ] = newVal;
		}

		if ( newVal === currentValue ) {
			return;
		}

		allowed = this._trigger( "slide", event, this._uiHash( index, newVal, newValues ) );

		// A slide can be canceled by returning false from the slide callback
		if ( allowed === false ) {
			return;
		}

		if ( this._hasMultipleValues() ) {
			this.values( index, newVal );
		} else {
			this.value( newVal );
		}
	},

	_stop: function( event, index ) {
		this._trigger( "stop", event, this._uiHash( index ) );
	},

	_change: function( event, index ) {
		if ( !this._keySliding && !this._mouseSliding ) {

			//store the last changed value index for reference when handles overlap
			this._lastChangedValue = index;
			this._trigger( "change", event, this._uiHash( index ) );
		}
	},

	value: function( newValue ) {
		if ( arguments.length ) {
			this.options.value = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, 0 );
			return;
		}

		return this._value();
	},

	values: function( index, newValue ) {
		var vals,
			newValues,
			i;

		if ( arguments.length > 1 ) {
			this.options.values[ index ] = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, index );
			return;
		}

		if ( arguments.length ) {
			if ( $.isArray( arguments[ 0 ] ) ) {
				vals = this.options.values;
				newValues = arguments[ 0 ];
				for ( i = 0; i < vals.length; i += 1 ) {
					vals[ i ] = this._trimAlignValue( newValues[ i ] );
					this._change( null, i );
				}
				this._refreshValue();
			} else {
				if ( this._hasMultipleValues() ) {
					return this._values( index );
				} else {
					return this.value();
				}
			}
		} else {
			return this._values();
		}
	},

	_setOption: function( key, value ) {
		var i,
			valsLength = 0;

		if ( key === "range" && this.options.range === true ) {
			if ( value === "min" ) {
				this.options.value = this._values( 0 );
				this.options.values = null;
			} else if ( value === "max" ) {
				this.options.value = this._values( this.options.values.length - 1 );
				this.options.values = null;
			}
		}

		if ( $.isArray( this.options.values ) ) {
			valsLength = this.options.values.length;
		}

		this._super( key, value );

		switch ( key ) {
			case "orientation":
				this._detectOrientation();
				this._removeClass( "ui-slider-horizontal ui-slider-vertical" )
					._addClass( "ui-slider-" + this.orientation );
				this._refreshValue();
				if ( this.options.range ) {
					this._refreshRange( value );
				}

				// Reset positioning from previous orientation
				this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
				break;
			case "value":
				this._animateOff = true;
				this._refreshValue();
				this._change( null, 0 );
				this._animateOff = false;
				break;
			case "values":
				this._animateOff = true;
				this._refreshValue();

				// Start from the last handle to prevent unreachable handles (#9046)
				for ( i = valsLength - 1; i >= 0; i-- ) {
					this._change( null, i );
				}
				this._animateOff = false;
				break;
			case "step":
			case "min":
			case "max":
				this._animateOff = true;
				this._calculateNewMax();
				this._refreshValue();
				this._animateOff = false;
				break;
			case "range":
				this._animateOff = true;
				this._refresh();
				this._animateOff = false;
				break;
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	//internal value getter
	// _value() returns value trimmed by min and max, aligned by step
	_value: function() {
		var val = this.options.value;
		val = this._trimAlignValue( val );

		return val;
	},

	//internal values getter
	// _values() returns array of values trimmed by min and max, aligned by step
	// _values( index ) returns single value trimmed by min and max, aligned by step
	_values: function( index ) {
		var val,
			vals,
			i;

		if ( arguments.length ) {
			val = this.options.values[ index ];
			val = this._trimAlignValue( val );

			return val;
		} else if ( this._hasMultipleValues() ) {

			// .slice() creates a copy of the array
			// this copy gets trimmed by min and max and then returned
			vals = this.options.values.slice();
			for ( i = 0; i < vals.length; i += 1 ) {
				vals[ i ] = this._trimAlignValue( vals[ i ] );
			}

			return vals;
		} else {
			return [];
		}
	},

	// Returns the step-aligned value that val is closest to, between (inclusive) min and max
	_trimAlignValue: function( val ) {
		if ( val <= this._valueMin() ) {
			return this._valueMin();
		}
		if ( val >= this._valueMax() ) {
			return this._valueMax();
		}
		var step = ( this.options.step > 0 ) ? this.options.step : 1,
			valModStep = ( val - this._valueMin() ) % step,
			alignValue = val - valModStep;

		if ( Math.abs( valModStep ) * 2 >= step ) {
			alignValue += ( valModStep > 0 ) ? step : ( -step );
		}

		// Since JavaScript has problems with large floats, round
		// the final value to 5 digits after the decimal point (see #4124)
		return parseFloat( alignValue.toFixed( 5 ) );
	},

	_calculateNewMax: function() {
		var max = this.options.max,
			min = this._valueMin(),
			step = this.options.step,
			aboveMin = Math.round( ( max - min ) / step ) * step;
		max = aboveMin + min;
		if ( max > this.options.max ) {

			//If max is not divisible by step, rounding off may increase its value
			max -= step;
		}
		this.max = parseFloat( max.toFixed( this._precision() ) );
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_valueMin: function() {
		return this.options.min;
	},

	_valueMax: function() {
		return this.max;
	},

	_refreshRange: function( orientation ) {
		if ( orientation === "vertical" ) {
			this.range.css( { "width": "", "left": "" } );
		}
		if ( orientation === "horizontal" ) {
			this.range.css( { "height": "", "bottom": "" } );
		}
	},

	_refreshValue: function() {
		var lastValPercent, valPercent, value, valueMin, valueMax,
			oRange = this.options.range,
			o = this.options,
			that = this,
			animate = ( !this._animateOff ) ? o.animate : false,
			_set = {};

		if ( this._hasMultipleValues() ) {
			this.handles.each( function( i ) {
				valPercent = ( that.values( i ) - that._valueMin() ) / ( that._valueMax() -
					that._valueMin() ) * 100;
				_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
				if ( that.options.range === true ) {
					if ( that.orientation === "horizontal" ) {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								left: valPercent + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								width: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					} else {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								bottom: ( valPercent ) + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								height: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					}
				}
				lastValPercent = valPercent;
			} );
		} else {
			value = this.value();
			valueMin = this._valueMin();
			valueMax = this._valueMax();
			valPercent = ( valueMax !== valueMin ) ?
					( value - valueMin ) / ( valueMax - valueMin ) * 100 :
					0;
			_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
			this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

			if ( oRange === "min" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
			if ( oRange === "min" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
		}
	},

	_handleEvents: {
		keydown: function( event ) {
			var allowed, curVal, newVal, step,
				index = $( event.target ).data( "ui-slider-handle-index" );

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
				case $.ui.keyCode.END:
				case $.ui.keyCode.PAGE_UP:
				case $.ui.keyCode.PAGE_DOWN:
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					event.preventDefault();
					if ( !this._keySliding ) {
						this._keySliding = true;
						this._addClass( $( event.target ), null, "ui-state-active" );
						allowed = this._start( event, index );
						if ( allowed === false ) {
							return;
						}
					}
					break;
			}

			step = this.options.step;
			if ( this._hasMultipleValues() ) {
				curVal = newVal = this.values( index );
			} else {
				curVal = newVal = this.value();
			}

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
					newVal = this._valueMin();
					break;
				case $.ui.keyCode.END:
					newVal = this._valueMax();
					break;
				case $.ui.keyCode.PAGE_UP:
					newVal = this._trimAlignValue(
						curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
					);
					break;
				case $.ui.keyCode.PAGE_DOWN:
					newVal = this._trimAlignValue(
						curVal - ( ( this._valueMax() - this._valueMin() ) / this.numPages ) );
					break;
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
					if ( curVal === this._valueMax() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal + step );
					break;
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					if ( curVal === this._valueMin() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal - step );
					break;
			}

			this._slide( event, index, newVal );
		},
		keyup: function( event ) {
			var index = $( event.target ).data( "ui-slider-handle-index" );

			if ( this._keySliding ) {
				this._keySliding = false;
				this._stop( event, index );
				this._change( event, index );
				this._removeClass( $( event.target ), null, "ui-state-active" );
			}
		}
	}
} );


/*!
 * jQuery UI Spinner 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Spinner
//>>group: Widgets
//>>description: Displays buttons to easily input numbers via the keyboard or mouse.
//>>docs: http://api.jqueryui.com/spinner/
//>>demos: http://jqueryui.com/spinner/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/spinner.css
//>>css.theme: ../../themes/base/theme.css



function spinnerModifer( fn ) {
	return function() {
		var previous = this.element.val();
		fn.apply( this, arguments );
		this._refresh();
		if ( previous !== this.element.val() ) {
			this._trigger( "change" );
		}
	};
}

$.widget( "ui.spinner", {
	version: "1.12.1",
	defaultElement: "<input>",
	widgetEventPrefix: "spin",
	options: {
		classes: {
			"ui-spinner": "ui-corner-all",
			"ui-spinner-down": "ui-corner-br",
			"ui-spinner-up": "ui-corner-tr"
		},
		culture: null,
		icons: {
			down: "ui-icon-triangle-1-s",
			up: "ui-icon-triangle-1-n"
		},
		incremental: true,
		max: null,
		min: null,
		numberFormat: null,
		page: 10,
		step: 1,

		change: null,
		spin: null,
		start: null,
		stop: null
	},

	_create: function() {

		// handle string values that need to be parsed
		this._setOption( "max", this.options.max );
		this._setOption( "min", this.options.min );
		this._setOption( "step", this.options.step );

		// Only format if there is a value, prevents the field from being marked
		// as invalid in Firefox, see #9573.
		if ( this.value() !== "" ) {

			// Format the value, but don't constrain.
			this._value( this.element.val(), true );
		}

		this._draw();
		this._on( this._events );
		this._refresh();

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_getCreateOptions: function() {
		var options = this._super();
		var element = this.element;

		$.each( [ "min", "max", "step" ], function( i, option ) {
			var value = element.attr( option );
			if ( value != null && value.length ) {
				options[ option ] = value;
			}
		} );

		return options;
	},

	_events: {
		keydown: function( event ) {
			if ( this._start( event ) && this._keydown( event ) ) {
				event.preventDefault();
			}
		},
		keyup: "_stop",
		focus: function() {
			this.previous = this.element.val();
		},
		blur: function( event ) {
			if ( this.cancelBlur ) {
				delete this.cancelBlur;
				return;
			}

			this._stop();
			this._refresh();
			if ( this.previous !== this.element.val() ) {
				this._trigger( "change", event );
			}
		},
		mousewheel: function( event, delta ) {
			if ( !delta ) {
				return;
			}
			if ( !this.spinning && !this._start( event ) ) {
				return false;
			}

			this._spin( ( delta > 0 ? 1 : -1 ) * this.options.step, event );
			clearTimeout( this.mousewheelTimer );
			this.mousewheelTimer = this._delay( function() {
				if ( this.spinning ) {
					this._stop( event );
				}
			}, 100 );
			event.preventDefault();
		},
		"mousedown .ui-spinner-button": function( event ) {
			var previous;

			// We never want the buttons to have focus; whenever the user is
			// interacting with the spinner, the focus should be on the input.
			// If the input is focused then this.previous is properly set from
			// when the input first received focus. If the input is not focused
			// then we need to set this.previous based on the value before spinning.
			previous = this.element[ 0 ] === $.ui.safeActiveElement( this.document[ 0 ] ) ?
				this.previous : this.element.val();
			function checkFocus() {
				var isActive = this.element[ 0 ] === $.ui.safeActiveElement( this.document[ 0 ] );
				if ( !isActive ) {
					this.element.trigger( "focus" );
					this.previous = previous;

					// support: IE
					// IE sets focus asynchronously, so we need to check if focus
					// moved off of the input because the user clicked on the button.
					this._delay( function() {
						this.previous = previous;
					} );
				}
			}

			// Ensure focus is on (or stays on) the text field
			event.preventDefault();
			checkFocus.call( this );

			// Support: IE
			// IE doesn't prevent moving focus even with event.preventDefault()
			// so we set a flag to know when we should ignore the blur event
			// and check (again) if focus moved off of the input.
			this.cancelBlur = true;
			this._delay( function() {
				delete this.cancelBlur;
				checkFocus.call( this );
			} );

			if ( this._start( event ) === false ) {
				return;
			}

			this._repeat( null, $( event.currentTarget )
				.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},
		"mouseup .ui-spinner-button": "_stop",
		"mouseenter .ui-spinner-button": function( event ) {

			// button will add ui-state-active if mouse was down while mouseleave and kept down
			if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
				return;
			}

			if ( this._start( event ) === false ) {
				return false;
			}
			this._repeat( null, $( event.currentTarget )
				.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},

		// TODO: do we really want to consider this a stop?
		// shouldn't we just stop the repeater and wait until mouseup before
		// we trigger the stop event?
		"mouseleave .ui-spinner-button": "_stop"
	},

	// Support mobile enhanced option and make backcompat more sane
	_enhance: function() {
		this.uiSpinner = this.element
			.attr( "autocomplete", "off" )
			.wrap( "<span>" )
			.parent()

				// Add buttons
				.append(
					"<a></a><a></a>"
				);
	},

	_draw: function() {
		this._enhance();

		this._addClass( this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content" );
		this._addClass( "ui-spinner-input" );

		this.element.attr( "role", "spinbutton" );

		// Button bindings
		this.buttons = this.uiSpinner.children( "a" )
			.attr( "tabIndex", -1 )
			.attr( "aria-hidden", true )
			.button( {
				classes: {
					"ui-button": ""
				}
			} );

		// TODO: Right now button does not support classes this is already updated in button PR
		this._removeClass( this.buttons, "ui-corner-all" );

		this._addClass( this.buttons.first(), "ui-spinner-button ui-spinner-up" );
		this._addClass( this.buttons.last(), "ui-spinner-button ui-spinner-down" );
		this.buttons.first().button( {
			"icon": this.options.icons.up,
			"showLabel": false
		} );
		this.buttons.last().button( {
			"icon": this.options.icons.down,
			"showLabel": false
		} );

		// IE 6 doesn't understand height: 50% for the buttons
		// unless the wrapper has an explicit height
		if ( this.buttons.height() > Math.ceil( this.uiSpinner.height() * 0.5 ) &&
				this.uiSpinner.height() > 0 ) {
			this.uiSpinner.height( this.uiSpinner.height() );
		}
	},

	_keydown: function( event ) {
		var options = this.options,
			keyCode = $.ui.keyCode;

		switch ( event.keyCode ) {
		case keyCode.UP:
			this._repeat( null, 1, event );
			return true;
		case keyCode.DOWN:
			this._repeat( null, -1, event );
			return true;
		case keyCode.PAGE_UP:
			this._repeat( null, options.page, event );
			return true;
		case keyCode.PAGE_DOWN:
			this._repeat( null, -options.page, event );
			return true;
		}

		return false;
	},

	_start: function( event ) {
		if ( !this.spinning && this._trigger( "start", event ) === false ) {
			return false;
		}

		if ( !this.counter ) {
			this.counter = 1;
		}
		this.spinning = true;
		return true;
	},

	_repeat: function( i, steps, event ) {
		i = i || 500;

		clearTimeout( this.timer );
		this.timer = this._delay( function() {
			this._repeat( 40, steps, event );
		}, i );

		this._spin( steps * this.options.step, event );
	},

	_spin: function( step, event ) {
		var value = this.value() || 0;

		if ( !this.counter ) {
			this.counter = 1;
		}

		value = this._adjustValue( value + step * this._increment( this.counter ) );

		if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false ) {
			this._value( value );
			this.counter++;
		}
	},

	_increment: function( i ) {
		var incremental = this.options.incremental;

		if ( incremental ) {
			return $.isFunction( incremental ) ?
				incremental( i ) :
				Math.floor( i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1 );
		}

		return 1;
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_adjustValue: function( value ) {
		var base, aboveMin,
			options = this.options;

		// Make sure we're at a valid step
		// - find out where we are relative to the base (min or 0)
		base = options.min !== null ? options.min : 0;
		aboveMin = value - base;

		// - round to the nearest step
		aboveMin = Math.round( aboveMin / options.step ) * options.step;

		// - rounding is based on 0, so adjust back to our base
		value = base + aboveMin;

		// Fix precision from bad JS floating point math
		value = parseFloat( value.toFixed( this._precision() ) );

		// Clamp the value
		if ( options.max !== null && value > options.max ) {
			return options.max;
		}
		if ( options.min !== null && value < options.min ) {
			return options.min;
		}

		return value;
	},

	_stop: function( event ) {
		if ( !this.spinning ) {
			return;
		}

		clearTimeout( this.timer );
		clearTimeout( this.mousewheelTimer );
		this.counter = 0;
		this.spinning = false;
		this._trigger( "stop", event );
	},

	_setOption: function( key, value ) {
		var prevValue, first, last;

		if ( key === "culture" || key === "numberFormat" ) {
			prevValue = this._parse( this.element.val() );
			this.options[ key ] = value;
			this.element.val( this._format( prevValue ) );
			return;
		}

		if ( key === "max" || key === "min" || key === "step" ) {
			if ( typeof value === "string" ) {
				value = this._parse( value );
			}
		}
		if ( key === "icons" ) {
			first = this.buttons.first().find( ".ui-icon" );
			this._removeClass( first, null, this.options.icons.up );
			this._addClass( first, null, value.up );
			last = this.buttons.last().find( ".ui-icon" );
			this._removeClass( last, null, this.options.icons.down );
			this._addClass( last, null, value.down );
		}

		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( this.uiSpinner, null, "ui-state-disabled", !!value );
		this.element.prop( "disabled", !!value );
		this.buttons.button( value ? "disable" : "enable" );
	},

	_setOptions: spinnerModifer( function( options ) {
		this._super( options );
	} ),

	_parse: function( val ) {
		if ( typeof val === "string" && val !== "" ) {
			val = window.Globalize && this.options.numberFormat ?
				Globalize.parseFloat( val, 10, this.options.culture ) : +val;
		}
		return val === "" || isNaN( val ) ? null : val;
	},

	_format: function( value ) {
		if ( value === "" ) {
			return "";
		}
		return window.Globalize && this.options.numberFormat ?
			Globalize.format( value, this.options.numberFormat, this.options.culture ) :
			value;
	},

	_refresh: function() {
		this.element.attr( {
			"aria-valuemin": this.options.min,
			"aria-valuemax": this.options.max,

			// TODO: what should we do with values that can't be parsed?
			"aria-valuenow": this._parse( this.element.val() )
		} );
	},

	isValid: function() {
		var value = this.value();

		// Null is invalid
		if ( value === null ) {
			return false;
		}

		// If value gets adjusted, it's invalid
		return value === this._adjustValue( value );
	},

	// Update the value without triggering change
	_value: function( value, allowAny ) {
		var parsed;
		if ( value !== "" ) {
			parsed = this._parse( value );
			if ( parsed !== null ) {
				if ( !allowAny ) {
					parsed = this._adjustValue( parsed );
				}
				value = this._format( parsed );
			}
		}
		this.element.val( value );
		this._refresh();
	},

	_destroy: function() {
		this.element
			.prop( "disabled", false )
			.removeAttr( "autocomplete role aria-valuemin aria-valuemax aria-valuenow" );

		this.uiSpinner.replaceWith( this.element );
	},

	stepUp: spinnerModifer( function( steps ) {
		this._stepUp( steps );
	} ),
	_stepUp: function( steps ) {
		if ( this._start() ) {
			this._spin( ( steps || 1 ) * this.options.step );
			this._stop();
		}
	},

	stepDown: spinnerModifer( function( steps ) {
		this._stepDown( steps );
	} ),
	_stepDown: function( steps ) {
		if ( this._start() ) {
			this._spin( ( steps || 1 ) * -this.options.step );
			this._stop();
		}
	},

	pageUp: spinnerModifer( function( pages ) {
		this._stepUp( ( pages || 1 ) * this.options.page );
	} ),

	pageDown: spinnerModifer( function( pages ) {
		this._stepDown( ( pages || 1 ) * this.options.page );
	} ),

	value: function( newVal ) {
		if ( !arguments.length ) {
			return this._parse( this.element.val() );
		}
		spinnerModifer( this._value ).call( this, newVal );
	},

	widget: function() {
		return this.uiSpinner;
	}
} );

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for spinner html extension points
	$.widget( "ui.spinner", $.ui.spinner, {
		_enhance: function() {
			this.uiSpinner = this.element
				.attr( "autocomplete", "off" )
				.wrap( this._uiSpinnerHtml() )
				.parent()

					// Add buttons
					.append( this._buttonHtml() );
		},
		_uiSpinnerHtml: function() {
			return "<span>";
		},

		_buttonHtml: function() {
			return "<a></a><a></a>";
		}
	} );
}

var widgetsSpinner = $.ui.spinner;


/*!
 * jQuery UI Tabs 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Tabs
//>>group: Widgets
//>>description: Transforms a set of container elements into a tab structure.
//>>docs: http://api.jqueryui.com/tabs/
//>>demos: http://jqueryui.com/tabs/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tabs.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.tabs", {
	version: "1.12.1",
	delay: 300,
	options: {
		active: null,
		classes: {
			"ui-tabs": "ui-corner-all",
			"ui-tabs-nav": "ui-corner-all",
			"ui-tabs-panel": "ui-corner-bottom",
			"ui-tabs-tab": "ui-corner-top"
		},
		collapsible: false,
		event: "click",
		heightStyle: "content",
		hide: null,
		show: null,

		// Callbacks
		activate: null,
		beforeActivate: null,
		beforeLoad: null,
		load: null
	},

	_isLocal: ( function() {
		var rhash = /#.*$/;

		return function( anchor ) {
			var anchorUrl, locationUrl;

			anchorUrl = anchor.href.replace( rhash, "" );
			locationUrl = location.href.replace( rhash, "" );

			// Decoding may throw an error if the URL isn't UTF-8 (#9518)
			try {
				anchorUrl = decodeURIComponent( anchorUrl );
			} catch ( error ) {}
			try {
				locationUrl = decodeURIComponent( locationUrl );
			} catch ( error ) {}

			return anchor.hash.length > 1 && anchorUrl === locationUrl;
		};
	} )(),

	_create: function() {
		var that = this,
			options = this.options;

		this.running = false;

		this._addClass( "ui-tabs", "ui-widget ui-widget-content" );
		this._toggleClass( "ui-tabs-collapsible", null, options.collapsible );

		this._processTabs();
		options.active = this._initialActive();

		// Take disabling tabs via class attribute from HTML
		// into account and update option properly.
		if ( $.isArray( options.disabled ) ) {
			options.disabled = $.unique( options.disabled.concat(
				$.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
					return that.tabs.index( li );
				} )
			) ).sort();
		}

		// Check for length avoids error when initializing empty list
		if ( this.options.active !== false && this.anchors.length ) {
			this.active = this._findActive( options.active );
		} else {
			this.active = $();
		}

		this._refresh();

		if ( this.active.length ) {
			this.load( options.active );
		}
	},

	_initialActive: function() {
		var active = this.options.active,
			collapsible = this.options.collapsible,
			locationHash = location.hash.substring( 1 );

		if ( active === null ) {

			// check the fragment identifier in the URL
			if ( locationHash ) {
				this.tabs.each( function( i, tab ) {
					if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
						active = i;
						return false;
					}
				} );
			}

			// Check for a tab marked active via a class
			if ( active === null ) {
				active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
			}

			// No active tab, set to false
			if ( active === null || active === -1 ) {
				active = this.tabs.length ? 0 : false;
			}
		}

		// Handle numbers: negative, out of range
		if ( active !== false ) {
			active = this.tabs.index( this.tabs.eq( active ) );
			if ( active === -1 ) {
				active = collapsible ? false : 0;
			}
		}

		// Don't allow collapsible: false and active: false
		if ( !collapsible && active === false && this.anchors.length ) {
			active = 0;
		}

		return active;
	},

	_getCreateEventData: function() {
		return {
			tab: this.active,
			panel: !this.active.length ? $() : this._getPanelForTab( this.active )
		};
	},

	_tabKeydown: function( event ) {
		var focusedTab = $( $.ui.safeActiveElement( this.document[ 0 ] ) ).closest( "li" ),
			selectedIndex = this.tabs.index( focusedTab ),
			goingForward = true;

		if ( this._handlePageNav( event ) ) {
			return;
		}

		switch ( event.keyCode ) {
		case $.ui.keyCode.RIGHT:
		case $.ui.keyCode.DOWN:
			selectedIndex++;
			break;
		case $.ui.keyCode.UP:
		case $.ui.keyCode.LEFT:
			goingForward = false;
			selectedIndex--;
			break;
		case $.ui.keyCode.END:
			selectedIndex = this.anchors.length - 1;
			break;
		case $.ui.keyCode.HOME:
			selectedIndex = 0;
			break;
		case $.ui.keyCode.SPACE:

			// Activate only, no collapsing
			event.preventDefault();
			clearTimeout( this.activating );
			this._activate( selectedIndex );
			return;
		case $.ui.keyCode.ENTER:

			// Toggle (cancel delayed activation, allow collapsing)
			event.preventDefault();
			clearTimeout( this.activating );

			// Determine if we should collapse or activate
			this._activate( selectedIndex === this.options.active ? false : selectedIndex );
			return;
		default:
			return;
		}

		// Focus the appropriate tab, based on which key was pressed
		event.preventDefault();
		clearTimeout( this.activating );
		selectedIndex = this._focusNextTab( selectedIndex, goingForward );

		// Navigating with control/command key will prevent automatic activation
		if ( !event.ctrlKey && !event.metaKey ) {

			// Update aria-selected immediately so that AT think the tab is already selected.
			// Otherwise AT may confuse the user by stating that they need to activate the tab,
			// but the tab will already be activated by the time the announcement finishes.
			focusedTab.attr( "aria-selected", "false" );
			this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

			this.activating = this._delay( function() {
				this.option( "active", selectedIndex );
			}, this.delay );
		}
	},

	_panelKeydown: function( event ) {
		if ( this._handlePageNav( event ) ) {
			return;
		}

		// Ctrl+up moves focus to the current tab
		if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
			event.preventDefault();
			this.active.trigger( "focus" );
		}
	},

	// Alt+page up/down moves focus to the previous/next tab (and activates)
	_handlePageNav: function( event ) {
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
			this._activate( this._focusNextTab( this.options.active - 1, false ) );
			return true;
		}
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
			this._activate( this._focusNextTab( this.options.active + 1, true ) );
			return true;
		}
	},

	_findNextTab: function( index, goingForward ) {
		var lastTabIndex = this.tabs.length - 1;

		function constrain() {
			if ( index > lastTabIndex ) {
				index = 0;
			}
			if ( index < 0 ) {
				index = lastTabIndex;
			}
			return index;
		}

		while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
			index = goingForward ? index + 1 : index - 1;
		}

		return index;
	},

	_focusNextTab: function( index, goingForward ) {
		index = this._findNextTab( index, goingForward );
		this.tabs.eq( index ).trigger( "focus" );
		return index;
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		this._super( key, value );

		if ( key === "collapsible" ) {
			this._toggleClass( "ui-tabs-collapsible", null, value );

			// Setting collapsible: false while collapsed; open first panel
			if ( !value && this.options.active === false ) {
				this._activate( 0 );
			}
		}

		if ( key === "event" ) {
			this._setupEvents( value );
		}

		if ( key === "heightStyle" ) {
			this._setupHeightStyle( value );
		}
	},

	_sanitizeSelector: function( hash ) {
		return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
	},

	refresh: function() {
		var options = this.options,
			lis = this.tablist.children( ":has(a[href])" );

		// Get disabled tabs from class attribute from HTML
		// this will get converted to a boolean if needed in _refresh()
		options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
			return lis.index( tab );
		} );

		this._processTabs();

		// Was collapsed or no tabs
		if ( options.active === false || !this.anchors.length ) {
			options.active = false;
			this.active = $();

		// was active, but active tab is gone
		} else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {

			// all remaining tabs are disabled
			if ( this.tabs.length === options.disabled.length ) {
				options.active = false;
				this.active = $();

			// activate previous tab
			} else {
				this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
			}

		// was active, active tab still exists
		} else {

			// make sure active index is correct
			options.active = this.tabs.index( this.active );
		}

		this._refresh();
	},

	_refresh: function() {
		this._setOptionDisabled( this.options.disabled );
		this._setupEvents( this.options.event );
		this._setupHeightStyle( this.options.heightStyle );

		this.tabs.not( this.active ).attr( {
			"aria-selected": "false",
			"aria-expanded": "false",
			tabIndex: -1
		} );
		this.panels.not( this._getPanelForTab( this.active ) )
			.hide()
			.attr( {
				"aria-hidden": "true"
			} );

		// Make sure one tab is in the tab order
		if ( !this.active.length ) {
			this.tabs.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
			this._addClass( this.active, "ui-tabs-active", "ui-state-active" );
			this._getPanelForTab( this.active )
				.show()
				.attr( {
					"aria-hidden": "false"
				} );
		}
	},

	_processTabs: function() {
		var that = this,
			prevTabs = this.tabs,
			prevAnchors = this.anchors,
			prevPanels = this.panels;

		this.tablist = this._getList().attr( "role", "tablist" );
		this._addClass( this.tablist, "ui-tabs-nav",
			"ui-helper-reset ui-helper-clearfix ui-widget-header" );

		// Prevent users from focusing disabled tabs via click
		this.tablist
			.on( "mousedown" + this.eventNamespace, "> li", function( event ) {
				if ( $( this ).is( ".ui-state-disabled" ) ) {
					event.preventDefault();
				}
			} )

			// Support: IE <9
			// Preventing the default action in mousedown doesn't prevent IE
			// from focusing the element, so if the anchor gets focused, blur.
			// We don't have to worry about focusing the previously focused
			// element since clicking on a non-focusable element should focus
			// the body anyway.
			.on( "focus" + this.eventNamespace, ".ui-tabs-anchor", function() {
				if ( $( this ).closest( "li" ).is( ".ui-state-disabled" ) ) {
					this.blur();
				}
			} );

		this.tabs = this.tablist.find( "> li:has(a[href])" )
			.attr( {
				role: "tab",
				tabIndex: -1
			} );
		this._addClass( this.tabs, "ui-tabs-tab", "ui-state-default" );

		this.anchors = this.tabs.map( function() {
			return $( "a", this )[ 0 ];
		} )
			.attr( {
				role: "presentation",
				tabIndex: -1
			} );
		this._addClass( this.anchors, "ui-tabs-anchor" );

		this.panels = $();

		this.anchors.each( function( i, anchor ) {
			var selector, panel, panelId,
				anchorId = $( anchor ).uniqueId().attr( "id" ),
				tab = $( anchor ).closest( "li" ),
				originalAriaControls = tab.attr( "aria-controls" );

			// Inline tab
			if ( that._isLocal( anchor ) ) {
				selector = anchor.hash;
				panelId = selector.substring( 1 );
				panel = that.element.find( that._sanitizeSelector( selector ) );

			// remote tab
			} else {

				// If the tab doesn't already have aria-controls,
				// generate an id by using a throw-away element
				panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
				selector = "#" + panelId;
				panel = that.element.find( selector );
				if ( !panel.length ) {
					panel = that._createPanel( panelId );
					panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
				}
				panel.attr( "aria-live", "polite" );
			}

			if ( panel.length ) {
				that.panels = that.panels.add( panel );
			}
			if ( originalAriaControls ) {
				tab.data( "ui-tabs-aria-controls", originalAriaControls );
			}
			tab.attr( {
				"aria-controls": panelId,
				"aria-labelledby": anchorId
			} );
			panel.attr( "aria-labelledby", anchorId );
		} );

		this.panels.attr( "role", "tabpanel" );
		this._addClass( this.panels, "ui-tabs-panel", "ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevTabs ) {
			this._off( prevTabs.not( this.tabs ) );
			this._off( prevAnchors.not( this.anchors ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	// Allow overriding how to find the list for rare usage scenarios (#7715)
	_getList: function() {
		return this.tablist || this.element.find( "ol, ul" ).eq( 0 );
	},

	_createPanel: function( id ) {
		return $( "<div>" )
			.attr( "id", id )
			.data( "ui-tabs-destroy", true );
	},

	_setOptionDisabled: function( disabled ) {
		var currentItem, li, i;

		if ( $.isArray( disabled ) ) {
			if ( !disabled.length ) {
				disabled = false;
			} else if ( disabled.length === this.anchors.length ) {
				disabled = true;
			}
		}

		// Disable tabs
		for ( i = 0; ( li = this.tabs[ i ] ); i++ ) {
			currentItem = $( li );
			if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
				currentItem.attr( "aria-disabled", "true" );
				this._addClass( currentItem, null, "ui-state-disabled" );
			} else {
				currentItem.removeAttr( "aria-disabled" );
				this._removeClass( currentItem, null, "ui-state-disabled" );
			}
		}

		this.options.disabled = disabled;

		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null,
			disabled === true );
	},

	_setupEvents: function( event ) {
		var events = {};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.anchors.add( this.tabs ).add( this.panels ) );

		// Always prevent the default action, even when disabled
		this._on( true, this.anchors, {
			click: function( event ) {
				event.preventDefault();
			}
		} );
		this._on( this.anchors, events );
		this._on( this.tabs, { keydown: "_tabKeydown" } );
		this._on( this.panels, { keydown: "_panelKeydown" } );

		this._focusable( this.tabs );
		this._hoverable( this.tabs );
	},

	_setupHeightStyle: function( heightStyle ) {
		var maxHeight,
			parent = this.element.parent();

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			maxHeight -= this.element.outerHeight() - this.element.height();

			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.element.children().not( this.panels ).each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.panels.each( function() {
				$( this ).height( Math.max( 0, maxHeight -
					$( this ).innerHeight() + $( this ).height() ) );
			} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.panels.each( function() {
				maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
			} ).height( maxHeight );
		}
	},

	_eventHandler: function( event ) {
		var options = this.options,
			active = this.active,
			anchor = $( event.currentTarget ),
			tab = anchor.closest( "li" ),
			clickedIsActive = tab[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : this._getPanelForTab( tab ),
			toHide = !active.length ? $() : this._getPanelForTab( active ),
			eventData = {
				oldTab: active,
				oldPanel: toHide,
				newTab: collapsing ? $() : tab,
				newPanel: toShow
			};

		event.preventDefault();

		if ( tab.hasClass( "ui-state-disabled" ) ||

				// tab is already loading
				tab.hasClass( "ui-tabs-loading" ) ||

				// can't switch durning an animation
				this.running ||

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.tabs.index( tab );

		this.active = clickedIsActive ? $() : tab;
		if ( this.xhr ) {
			this.xhr.abort();
		}

		if ( !toHide.length && !toShow.length ) {
			$.error( "jQuery UI Tabs: Mismatching fragment identifier." );
		}

		if ( toShow.length ) {
			this.load( this.tabs.index( tab ), event );
		}
		this._toggle( event, eventData );
	},

	// Handles show/hide for selecting tabs
	_toggle: function( event, eventData ) {
		var that = this,
			toShow = eventData.newPanel,
			toHide = eventData.oldPanel;

		this.running = true;

		function complete() {
			that.running = false;
			that._trigger( "activate", event, eventData );
		}

		function show() {
			that._addClass( eventData.newTab.closest( "li" ), "ui-tabs-active", "ui-state-active" );

			if ( toShow.length && that.options.show ) {
				that._show( toShow, that.options.show, complete );
			} else {
				toShow.show();
				complete();
			}
		}

		// Start out by hiding, then showing, then completing
		if ( toHide.length && this.options.hide ) {
			this._hide( toHide, this.options.hide, function() {
				that._removeClass( eventData.oldTab.closest( "li" ),
					"ui-tabs-active", "ui-state-active" );
				show();
			} );
		} else {
			this._removeClass( eventData.oldTab.closest( "li" ),
				"ui-tabs-active", "ui-state-active" );
			toHide.hide();
			show();
		}

		toHide.attr( "aria-hidden", "true" );
		eventData.oldTab.attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// If we're switching tabs, remove the old tab from the tab order.
		// If we're opening from collapsed state, remove the previous tab from the tab order.
		// If we're collapsing, then keep the collapsing tab in the tab order.
		if ( toShow.length && toHide.length ) {
			eventData.oldTab.attr( "tabIndex", -1 );
		} else if ( toShow.length ) {
			this.tabs.filter( function() {
				return $( this ).attr( "tabIndex" ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow.attr( "aria-hidden", "false" );
		eventData.newTab.attr( {
			"aria-selected": "true",
			"aria-expanded": "true",
			tabIndex: 0
		} );
	},

	_activate: function( index ) {
		var anchor,
			active = this._findActive( index );

		// Trying to activate the already active panel
		if ( active[ 0 ] === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the current active header
		if ( !active.length ) {
			active = this.active;
		}

		anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
		this._eventHandler( {
			target: anchor,
			currentTarget: anchor,
			preventDefault: $.noop
		} );
	},

	_findActive: function( index ) {
		return index === false ? $() : this.tabs.eq( index );
	},

	_getIndex: function( index ) {

		// meta-function to give users option to provide a href string instead of a numerical index.
		if ( typeof index === "string" ) {
			index = this.anchors.index( this.anchors.filter( "[href$='" +
				$.ui.escapeSelector( index ) + "']" ) );
		}

		return index;
	},

	_destroy: function() {
		if ( this.xhr ) {
			this.xhr.abort();
		}

		this.tablist
			.removeAttr( "role" )
			.off( this.eventNamespace );

		this.anchors
			.removeAttr( "role tabIndex" )
			.removeUniqueId();

		this.tabs.add( this.panels ).each( function() {
			if ( $.data( this, "ui-tabs-destroy" ) ) {
				$( this ).remove();
			} else {
				$( this ).removeAttr( "role tabIndex " +
					"aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded" );
			}
		} );

		this.tabs.each( function() {
			var li = $( this ),
				prev = li.data( "ui-tabs-aria-controls" );
			if ( prev ) {
				li
					.attr( "aria-controls", prev )
					.removeData( "ui-tabs-aria-controls" );
			} else {
				li.removeAttr( "aria-controls" );
			}
		} );

		this.panels.show();

		if ( this.options.heightStyle !== "content" ) {
			this.panels.css( "height", "" );
		}
	},

	enable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === false ) {
			return;
		}

		if ( index === undefined ) {
			disabled = false;
		} else {
			index = this._getIndex( index );
			if ( $.isArray( disabled ) ) {
				disabled = $.map( disabled, function( num ) {
					return num !== index ? num : null;
				} );
			} else {
				disabled = $.map( this.tabs, function( li, num ) {
					return num !== index ? num : null;
				} );
			}
		}
		this._setOptionDisabled( disabled );
	},

	disable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === true ) {
			return;
		}

		if ( index === undefined ) {
			disabled = true;
		} else {
			index = this._getIndex( index );
			if ( $.inArray( index, disabled ) !== -1 ) {
				return;
			}
			if ( $.isArray( disabled ) ) {
				disabled = $.merge( [ index ], disabled ).sort();
			} else {
				disabled = [ index ];
			}
		}
		this._setOptionDisabled( disabled );
	},

	load: function( index, event ) {
		index = this._getIndex( index );
		var that = this,
			tab = this.tabs.eq( index ),
			anchor = tab.find( ".ui-tabs-anchor" ),
			panel = this._getPanelForTab( tab ),
			eventData = {
				tab: tab,
				panel: panel
			},
			complete = function( jqXHR, status ) {
				if ( status === "abort" ) {
					that.panels.stop( false, true );
				}

				that._removeClass( tab, "ui-tabs-loading" );
				panel.removeAttr( "aria-busy" );

				if ( jqXHR === that.xhr ) {
					delete that.xhr;
				}
			};

		// Not remote
		if ( this._isLocal( anchor[ 0 ] ) ) {
			return;
		}

		this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

		// Support: jQuery <1.8
		// jQuery <1.8 returns false if the request is canceled in beforeSend,
		// but as of 1.8, $.ajax() always returns a jqXHR object.
		if ( this.xhr && this.xhr.statusText !== "canceled" ) {
			this._addClass( tab, "ui-tabs-loading" );
			panel.attr( "aria-busy", "true" );

			this.xhr
				.done( function( response, status, jqXHR ) {

					// support: jQuery <1.8
					// http://bugs.jquery.com/ticket/11778
					setTimeout( function() {
						panel.html( response );
						that._trigger( "load", event, eventData );

						complete( jqXHR, status );
					}, 1 );
				} )
				.fail( function( jqXHR, status ) {

					// support: jQuery <1.8
					// http://bugs.jquery.com/ticket/11778
					setTimeout( function() {
						complete( jqXHR, status );
					}, 1 );
				} );
		}
	},

	_ajaxSettings: function( anchor, event, eventData ) {
		var that = this;
		return {

			// Support: IE <11 only
			// Strip any hash that exists to prevent errors with the Ajax request
			url: anchor.attr( "href" ).replace( /#.*$/, "" ),
			beforeSend: function( jqXHR, settings ) {
				return that._trigger( "beforeLoad", event,
					$.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
			}
		};
	},

	_getPanelForTab: function( tab ) {
		var id = $( tab ).attr( "aria-controls" );
		return this.element.find( this._sanitizeSelector( "#" + id ) );
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for ui-tab class (now ui-tabs-tab)
	$.widget( "ui.tabs", $.ui.tabs, {
		_processTabs: function() {
			this._superApply( arguments );
			this._addClass( this.tabs, "ui-tab" );
		}
	} );
}

var widgetsTabs = $.ui.tabs;


/*!
 * jQuery UI Tooltip 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Tooltip
//>>group: Widgets
//>>description: Shows additional information for any element on hover or focus.
//>>docs: http://api.jqueryui.com/tooltip/
//>>demos: http://jqueryui.com/tooltip/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tooltip.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.tooltip", {
	version: "1.12.1",
	options: {
		classes: {
			"ui-tooltip": "ui-corner-all ui-widget-shadow"
		},
		content: function() {

			// support: IE<9, Opera in jQuery <1.7
			// .text() can't accept undefined, so coerce to a string
			var title = $( this ).attr( "title" ) || "";

			// Escape title, since we're going from an attribute to raw HTML
			return $( "<a>" ).text( title ).html();
		},
		hide: true,

		// Disabled elements have inconsistent behavior across browsers (#8661)
		items: "[title]:not([disabled])",
		position: {
			my: "left top+15",
			at: "left bottom",
			collision: "flipfit flip"
		},
		show: true,
		track: false,

		// Callbacks
		close: null,
		open: null
	},

	_addDescribedBy: function( elem, id ) {
		var describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ );
		describedby.push( id );
		elem
			.data( "ui-tooltip-id", id )
			.attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
	},

	_removeDescribedBy: function( elem ) {
		var id = elem.data( "ui-tooltip-id" ),
			describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ ),
			index = $.inArray( id, describedby );

		if ( index !== -1 ) {
			describedby.splice( index, 1 );
		}

		elem.removeData( "ui-tooltip-id" );
		describedby = $.trim( describedby.join( " " ) );
		if ( describedby ) {
			elem.attr( "aria-describedby", describedby );
		} else {
			elem.removeAttr( "aria-describedby" );
		}
	},

	_create: function() {
		this._on( {
			mouseover: "open",
			focusin: "open"
		} );

		// IDs of generated tooltips, needed for destroy
		this.tooltips = {};

		// IDs of parent tooltips where we removed the title attribute
		this.parents = {};

		// Append the aria-live region so tooltips announce correctly
		this.liveRegion = $( "<div>" )
			.attr( {
				role: "log",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			} )
			.appendTo( this.document[ 0 ].body );
		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		this.disabledTitles = $( [] );
	},

	_setOption: function( key, value ) {
		var that = this;

		this._super( key, value );

		if ( key === "content" ) {
			$.each( this.tooltips, function( id, tooltipData ) {
				that._updateContent( tooltipData.element );
			} );
		}
	},

	_setOptionDisabled: function( value ) {
		this[ value ? "_disable" : "_enable" ]();
	},

	_disable: function() {
		var that = this;

		// Close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {
			var event = $.Event( "blur" );
			event.target = event.currentTarget = tooltipData.element[ 0 ];
			that.close( event, true );
		} );

		// Remove title attributes to prevent native tooltips
		this.disabledTitles = this.disabledTitles.add(
			this.element.find( this.options.items ).addBack()
				.filter( function() {
					var element = $( this );
					if ( element.is( "[title]" ) ) {
						return element
							.data( "ui-tooltip-title", element.attr( "title" ) )
							.removeAttr( "title" );
					}
				} )
		);
	},

	_enable: function() {

		// restore title attributes
		this.disabledTitles.each( function() {
			var element = $( this );
			if ( element.data( "ui-tooltip-title" ) ) {
				element.attr( "title", element.data( "ui-tooltip-title" ) );
			}
		} );
		this.disabledTitles = $( [] );
	},

	open: function( event ) {
		var that = this,
			target = $( event ? event.target : this.element )

				// we need closest here due to mouseover bubbling,
				// but always pointing at the same event target
				.closest( this.options.items );

		// No element to show a tooltip for or the tooltip is already open
		if ( !target.length || target.data( "ui-tooltip-id" ) ) {
			return;
		}

		if ( target.attr( "title" ) ) {
			target.data( "ui-tooltip-title", target.attr( "title" ) );
		}

		target.data( "ui-tooltip-open", true );

		// Kill parent tooltips, custom or native, for hover
		if ( event && event.type === "mouseover" ) {
			target.parents().each( function() {
				var parent = $( this ),
					blurEvent;
				if ( parent.data( "ui-tooltip-open" ) ) {
					blurEvent = $.Event( "blur" );
					blurEvent.target = blurEvent.currentTarget = this;
					that.close( blurEvent, true );
				}
				if ( parent.attr( "title" ) ) {
					parent.uniqueId();
					that.parents[ this.id ] = {
						element: this,
						title: parent.attr( "title" )
					};
					parent.attr( "title", "" );
				}
			} );
		}

		this._registerCloseHandlers( event, target );
		this._updateContent( target, event );
	},

	_updateContent: function( target, event ) {
		var content,
			contentOption = this.options.content,
			that = this,
			eventType = event ? event.type : null;

		if ( typeof contentOption === "string" || contentOption.nodeType ||
				contentOption.jquery ) {
			return this._open( event, target, contentOption );
		}

		content = contentOption.call( target[ 0 ], function( response ) {

			// IE may instantly serve a cached response for ajax requests
			// delay this call to _open so the other call to _open runs first
			that._delay( function() {

				// Ignore async response if tooltip was closed already
				if ( !target.data( "ui-tooltip-open" ) ) {
					return;
				}

				// JQuery creates a special event for focusin when it doesn't
				// exist natively. To improve performance, the native event
				// object is reused and the type is changed. Therefore, we can't
				// rely on the type being correct after the event finished
				// bubbling, so we set it back to the previous value. (#8740)
				if ( event ) {
					event.type = eventType;
				}
				this._open( event, target, response );
			} );
		} );
		if ( content ) {
			this._open( event, target, content );
		}
	},

	_open: function( event, target, content ) {
		var tooltipData, tooltip, delayedShow, a11yContent,
			positionOption = $.extend( {}, this.options.position );

		if ( !content ) {
			return;
		}

		// Content can be updated multiple times. If the tooltip already
		// exists, then just update the content and bail.
		tooltipData = this._find( target );
		if ( tooltipData ) {
			tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
			return;
		}

		// If we have a title, clear it to prevent the native tooltip
		// we have to check first to avoid defining a title if none exists
		// (we don't want to cause an element to start matching [title])
		//
		// We use removeAttr only for key events, to allow IE to export the correct
		// accessible attributes. For mouse events, set to empty string to avoid
		// native tooltip showing up (happens only when removing inside mouseover).
		if ( target.is( "[title]" ) ) {
			if ( event && event.type === "mouseover" ) {
				target.attr( "title", "" );
			} else {
				target.removeAttr( "title" );
			}
		}

		tooltipData = this._tooltip( target );
		tooltip = tooltipData.tooltip;
		this._addDescribedBy( target, tooltip.attr( "id" ) );
		tooltip.find( ".ui-tooltip-content" ).html( content );

		// Support: Voiceover on OS X, JAWS on IE <= 9
		// JAWS announces deletions even when aria-relevant="additions"
		// Voiceover will sometimes re-read the entire log region's contents from the beginning
		this.liveRegion.children().hide();
		a11yContent = $( "<div>" ).html( tooltip.find( ".ui-tooltip-content" ).html() );
		a11yContent.removeAttr( "name" ).find( "[name]" ).removeAttr( "name" );
		a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
		a11yContent.appendTo( this.liveRegion );

		function position( event ) {
			positionOption.of = event;
			if ( tooltip.is( ":hidden" ) ) {
				return;
			}
			tooltip.position( positionOption );
		}
		if ( this.options.track && event && /^mouse/.test( event.type ) ) {
			this._on( this.document, {
				mousemove: position
			} );

			// trigger once to override element-relative positioning
			position( event );
		} else {
			tooltip.position( $.extend( {
				of: target
			}, this.options.position ) );
		}

		tooltip.hide();

		this._show( tooltip, this.options.show );

		// Handle tracking tooltips that are shown with a delay (#8644). As soon
		// as the tooltip is visible, position the tooltip using the most recent
		// event.
		// Adds the check to add the timers only when both delay and track options are set (#14682)
		if ( this.options.track && this.options.show && this.options.show.delay ) {
			delayedShow = this.delayedShow = setInterval( function() {
				if ( tooltip.is( ":visible" ) ) {
					position( positionOption.of );
					clearInterval( delayedShow );
				}
			}, $.fx.interval );
		}

		this._trigger( "open", event, { tooltip: tooltip } );
	},

	_registerCloseHandlers: function( event, target ) {
		var events = {
			keyup: function( event ) {
				if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
					var fakeEvent = $.Event( event );
					fakeEvent.currentTarget = target[ 0 ];
					this.close( fakeEvent, true );
				}
			}
		};

		// Only bind remove handler for delegated targets. Non-delegated
		// tooltips will handle this in destroy.
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			events.remove = function() {
				this._removeTooltip( this._find( target ).tooltip );
			};
		}

		if ( !event || event.type === "mouseover" ) {
			events.mouseleave = "close";
		}
		if ( !event || event.type === "focusin" ) {
			events.focusout = "close";
		}
		this._on( true, target, events );
	},

	close: function( event ) {
		var tooltip,
			that = this,
			target = $( event ? event.currentTarget : this.element ),
			tooltipData = this._find( target );

		// The tooltip may already be closed
		if ( !tooltipData ) {

			// We set ui-tooltip-open immediately upon open (in open()), but only set the
			// additional data once there's actually content to show (in _open()). So even if the
			// tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
			// the period between open() and _open().
			target.removeData( "ui-tooltip-open" );
			return;
		}

		tooltip = tooltipData.tooltip;

		// Disabling closes the tooltip, so we need to track when we're closing
		// to avoid an infinite loop in case the tooltip becomes disabled on close
		if ( tooltipData.closing ) {
			return;
		}

		// Clear the interval for delayed tracking tooltips
		clearInterval( this.delayedShow );

		// Only set title if we had one before (see comment in _open())
		// If the title attribute has changed since open(), don't restore
		if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
			target.attr( "title", target.data( "ui-tooltip-title" ) );
		}

		this._removeDescribedBy( target );

		tooltipData.hiding = true;
		tooltip.stop( true );
		this._hide( tooltip, this.options.hide, function() {
			that._removeTooltip( $( this ) );
		} );

		target.removeData( "ui-tooltip-open" );
		this._off( target, "mouseleave focusout keyup" );

		// Remove 'remove' binding only on delegated targets
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			this._off( target, "remove" );
		}
		this._off( this.document, "mousemove" );

		if ( event && event.type === "mouseleave" ) {
			$.each( this.parents, function( id, parent ) {
				$( parent.element ).attr( "title", parent.title );
				delete that.parents[ id ];
			} );
		}

		tooltipData.closing = true;
		this._trigger( "close", event, { tooltip: tooltip } );
		if ( !tooltipData.hiding ) {
			tooltipData.closing = false;
		}
	},

	_tooltip: function( element ) {
		var tooltip = $( "<div>" ).attr( "role", "tooltip" ),
			content = $( "<div>" ).appendTo( tooltip ),
			id = tooltip.uniqueId().attr( "id" );

		this._addClass( content, "ui-tooltip-content" );
		this._addClass( tooltip, "ui-tooltip", "ui-widget ui-widget-content" );

		tooltip.appendTo( this._appendTo( element ) );

		return this.tooltips[ id ] = {
			element: element,
			tooltip: tooltip
		};
	},

	_find: function( target ) {
		var id = target.data( "ui-tooltip-id" );
		return id ? this.tooltips[ id ] : null;
	},

	_removeTooltip: function( tooltip ) {
		tooltip.remove();
		delete this.tooltips[ tooltip.attr( "id" ) ];
	},

	_appendTo: function( target ) {
		var element = target.closest( ".ui-front, dialog" );

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_destroy: function() {
		var that = this;

		// Close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {

			// Delegate to close method to handle common cleanup
			var event = $.Event( "blur" ),
				element = tooltipData.element;
			event.target = event.currentTarget = element[ 0 ];
			that.close( event, true );

			// Remove immediately; destroying an open tooltip doesn't use the
			// hide animation
			$( "#" + id ).remove();

			// Restore the title
			if ( element.data( "ui-tooltip-title" ) ) {

				// If the title attribute has changed since open(), don't restore
				if ( !element.attr( "title" ) ) {
					element.attr( "title", element.data( "ui-tooltip-title" ) );
				}
				element.removeData( "ui-tooltip-title" );
			}
		} );
		this.liveRegion.remove();
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for tooltipClass option
	$.widget( "ui.tooltip", $.ui.tooltip, {
		options: {
			tooltipClass: null
		},
		_tooltip: function() {
			var tooltipData = this._superApply( arguments );
			if ( this.options.tooltipClass ) {
				tooltipData.tooltip.addClass( this.options.tooltipClass );
			}
			return tooltipData;
		}
	} );
}

var widgetsTooltip = $.ui.tooltip;


/*!
 * jQuery UI Effects 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Effects Core
//>>group: Effects
// jscs:disable maximumLineLength
//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/category/effects-core/
//>>demos: http://jqueryui.com/effect/



var dataSpace = "ui-effects-",
	dataSpaceStyle = "ui-effects-style",
	dataSpaceAnimated = "ui-effects-animated",

	// Create a local jQuery because jQuery Color relies on it and the
	// global may not exist with AMD and a custom build (#10199)
	jQuery = $;

$.effects = {
	effect: {}
};

/*!
 * jQuery Color Animations v2.1.2
 * https://github.com/jquery/jquery-color
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * Date: Wed Jan 16 08:47:09 2013 -0600
 */
( function( jQuery, undefined ) {

	var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
		"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

	// Plusequals test for += 100 -= 100
	rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,

	// A set of RE's that can match strings and generate color tuples.
	stringParsers = [ {
			re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ],
					execResult[ 3 ],
					execResult[ 4 ]
				];
			}
		}, {
			re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ] * 2.55,
					execResult[ 2 ] * 2.55,
					execResult[ 3 ] * 2.55,
					execResult[ 4 ]
				];
			}
		}, {

			// This regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ], 16 )
				];
			}
		}, {

			// This regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
				];
			}
		}, {
			re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			space: "hsla",
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ] / 100,
					execResult[ 3 ] / 100,
					execResult[ 4 ]
				];
			}
		} ],

	// JQuery.Color( )
	color = jQuery.Color = function( color, green, blue, alpha ) {
		return new jQuery.Color.fn.parse( color, green, blue, alpha );
	},
	spaces = {
		rgba: {
			props: {
				red: {
					idx: 0,
					type: "byte"
				},
				green: {
					idx: 1,
					type: "byte"
				},
				blue: {
					idx: 2,
					type: "byte"
				}
			}
		},

		hsla: {
			props: {
				hue: {
					idx: 0,
					type: "degrees"
				},
				saturation: {
					idx: 1,
					type: "percent"
				},
				lightness: {
					idx: 2,
					type: "percent"
				}
			}
		}
	},
	propTypes = {
		"byte": {
			floor: true,
			max: 255
		},
		"percent": {
			max: 1
		},
		"degrees": {
			mod: 360,
			floor: true
		}
	},
	support = color.support = {},

	// Element for support tests
	supportElem = jQuery( "<p>" )[ 0 ],

	// Colors = jQuery.Color.names
	colors,

	// Local aliases of functions called often
	each = jQuery.each;

// Determine rgba support immediately
supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;

// Define cache name and alpha properties
// for rgba and hsla spaces
each( spaces, function( spaceName, space ) {
	space.cache = "_" + spaceName;
	space.props.alpha = {
		idx: 3,
		type: "percent",
		def: 1
	};
} );

function clamp( value, prop, allowEmpty ) {
	var type = propTypes[ prop.type ] || {};

	if ( value == null ) {
		return ( allowEmpty || !prop.def ) ? null : prop.def;
	}

	// ~~ is an short way of doing floor for positive numbers
	value = type.floor ? ~~value : parseFloat( value );

	// IE will pass in empty strings as value for alpha,
	// which will hit this case
	if ( isNaN( value ) ) {
		return prop.def;
	}

	if ( type.mod ) {

		// We add mod before modding to make sure that negatives values
		// get converted properly: -10 -> 350
		return ( value + type.mod ) % type.mod;
	}

	// For now all property types without mod have min and max
	return 0 > value ? 0 : type.max < value ? type.max : value;
}

function stringParse( string ) {
	var inst = color(),
		rgba = inst._rgba = [];

	string = string.toLowerCase();

	each( stringParsers, function( i, parser ) {
		var parsed,
			match = parser.re.exec( string ),
			values = match && parser.parse( match ),
			spaceName = parser.space || "rgba";

		if ( values ) {
			parsed = inst[ spaceName ]( values );

			// If this was an rgba parse the assignment might happen twice
			// oh well....
			inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
			rgba = inst._rgba = parsed._rgba;

			// Exit each( stringParsers ) here because we matched
			return false;
		}
	} );

	// Found a stringParser that handled it
	if ( rgba.length ) {

		// If this came from a parsed string, force "transparent" when alpha is 0
		// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
		if ( rgba.join() === "0,0,0,0" ) {
			jQuery.extend( rgba, colors.transparent );
		}
		return inst;
	}

	// Named colors
	return colors[ string ];
}

color.fn = jQuery.extend( color.prototype, {
	parse: function( red, green, blue, alpha ) {
		if ( red === undefined ) {
			this._rgba = [ null, null, null, null ];
			return this;
		}
		if ( red.jquery || red.nodeType ) {
			red = jQuery( red ).css( green );
			green = undefined;
		}

		var inst = this,
			type = jQuery.type( red ),
			rgba = this._rgba = [];

		// More than 1 argument specified - assume ( red, green, blue, alpha )
		if ( green !== undefined ) {
			red = [ red, green, blue, alpha ];
			type = "array";
		}

		if ( type === "string" ) {
			return this.parse( stringParse( red ) || colors._default );
		}

		if ( type === "array" ) {
			each( spaces.rgba.props, function( key, prop ) {
				rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
			} );
			return this;
		}

		if ( type === "object" ) {
			if ( red instanceof color ) {
				each( spaces, function( spaceName, space ) {
					if ( red[ space.cache ] ) {
						inst[ space.cache ] = red[ space.cache ].slice();
					}
				} );
			} else {
				each( spaces, function( spaceName, space ) {
					var cache = space.cache;
					each( space.props, function( key, prop ) {

						// If the cache doesn't exist, and we know how to convert
						if ( !inst[ cache ] && space.to ) {

							// If the value was null, we don't need to copy it
							// if the key was alpha, we don't need to copy it either
							if ( key === "alpha" || red[ key ] == null ) {
								return;
							}
							inst[ cache ] = space.to( inst._rgba );
						}

						// This is the only case where we allow nulls for ALL properties.
						// call clamp with alwaysAllowEmpty
						inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
					} );

					// Everything defined but alpha?
					if ( inst[ cache ] &&
							jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {

						// Use the default of 1
						inst[ cache ][ 3 ] = 1;
						if ( space.from ) {
							inst._rgba = space.from( inst[ cache ] );
						}
					}
				} );
			}
			return this;
		}
	},
	is: function( compare ) {
		var is = color( compare ),
			same = true,
			inst = this;

		each( spaces, function( _, space ) {
			var localCache,
				isCache = is[ space.cache ];
			if ( isCache ) {
				localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
				each( space.props, function( _, prop ) {
					if ( isCache[ prop.idx ] != null ) {
						same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
						return same;
					}
				} );
			}
			return same;
		} );
		return same;
	},
	_space: function() {
		var used = [],
			inst = this;
		each( spaces, function( spaceName, space ) {
			if ( inst[ space.cache ] ) {
				used.push( spaceName );
			}
		} );
		return used.pop();
	},
	transition: function( other, distance ) {
		var end = color( other ),
			spaceName = end._space(),
			space = spaces[ spaceName ],
			startColor = this.alpha() === 0 ? color( "transparent" ) : this,
			start = startColor[ space.cache ] || space.to( startColor._rgba ),
			result = start.slice();

		end = end[ space.cache ];
		each( space.props, function( key, prop ) {
			var index = prop.idx,
				startValue = start[ index ],
				endValue = end[ index ],
				type = propTypes[ prop.type ] || {};

			// If null, don't override start value
			if ( endValue === null ) {
				return;
			}

			// If null - use end
			if ( startValue === null ) {
				result[ index ] = endValue;
			} else {
				if ( type.mod ) {
					if ( endValue - startValue > type.mod / 2 ) {
						startValue += type.mod;
					} else if ( startValue - endValue > type.mod / 2 ) {
						startValue -= type.mod;
					}
				}
				result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
			}
		} );
		return this[ spaceName ]( result );
	},
	blend: function( opaque ) {

		// If we are already opaque - return ourself
		if ( this._rgba[ 3 ] === 1 ) {
			return this;
		}

		var rgb = this._rgba.slice(),
			a = rgb.pop(),
			blend = color( opaque )._rgba;

		return color( jQuery.map( rgb, function( v, i ) {
			return ( 1 - a ) * blend[ i ] + a * v;
		} ) );
	},
	toRgbaString: function() {
		var prefix = "rgba(",
			rgba = jQuery.map( this._rgba, function( v, i ) {
				return v == null ? ( i > 2 ? 1 : 0 ) : v;
			} );

		if ( rgba[ 3 ] === 1 ) {
			rgba.pop();
			prefix = "rgb(";
		}

		return prefix + rgba.join() + ")";
	},
	toHslaString: function() {
		var prefix = "hsla(",
			hsla = jQuery.map( this.hsla(), function( v, i ) {
				if ( v == null ) {
					v = i > 2 ? 1 : 0;
				}

				// Catch 1 and 2
				if ( i && i < 3 ) {
					v = Math.round( v * 100 ) + "%";
				}
				return v;
			} );

		if ( hsla[ 3 ] === 1 ) {
			hsla.pop();
			prefix = "hsl(";
		}
		return prefix + hsla.join() + ")";
	},
	toHexString: function( includeAlpha ) {
		var rgba = this._rgba.slice(),
			alpha = rgba.pop();

		if ( includeAlpha ) {
			rgba.push( ~~( alpha * 255 ) );
		}

		return "#" + jQuery.map( rgba, function( v ) {

			// Default to 0 when nulls exist
			v = ( v || 0 ).toString( 16 );
			return v.length === 1 ? "0" + v : v;
		} ).join( "" );
	},
	toString: function() {
		return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
	}
} );
color.fn.parse.prototype = color.fn;

// Hsla conversions adapted from:
// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

function hue2rgb( p, q, h ) {
	h = ( h + 1 ) % 1;
	if ( h * 6 < 1 ) {
		return p + ( q - p ) * h * 6;
	}
	if ( h * 2 < 1 ) {
		return q;
	}
	if ( h * 3 < 2 ) {
		return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
	}
	return p;
}

spaces.hsla.to = function( rgba ) {
	if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
		return [ null, null, null, rgba[ 3 ] ];
	}
	var r = rgba[ 0 ] / 255,
		g = rgba[ 1 ] / 255,
		b = rgba[ 2 ] / 255,
		a = rgba[ 3 ],
		max = Math.max( r, g, b ),
		min = Math.min( r, g, b ),
		diff = max - min,
		add = max + min,
		l = add * 0.5,
		h, s;

	if ( min === max ) {
		h = 0;
	} else if ( r === max ) {
		h = ( 60 * ( g - b ) / diff ) + 360;
	} else if ( g === max ) {
		h = ( 60 * ( b - r ) / diff ) + 120;
	} else {
		h = ( 60 * ( r - g ) / diff ) + 240;
	}

	// Chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
	// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
	if ( diff === 0 ) {
		s = 0;
	} else if ( l <= 0.5 ) {
		s = diff / add;
	} else {
		s = diff / ( 2 - add );
	}
	return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
};

spaces.hsla.from = function( hsla ) {
	if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
		return [ null, null, null, hsla[ 3 ] ];
	}
	var h = hsla[ 0 ] / 360,
		s = hsla[ 1 ],
		l = hsla[ 2 ],
		a = hsla[ 3 ],
		q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
		p = 2 * l - q;

	return [
		Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
		Math.round( hue2rgb( p, q, h ) * 255 ),
		Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
		a
	];
};

each( spaces, function( spaceName, space ) {
	var props = space.props,
		cache = space.cache,
		to = space.to,
		from = space.from;

	// Makes rgba() and hsla()
	color.fn[ spaceName ] = function( value ) {

		// Generate a cache for this space if it doesn't exist
		if ( to && !this[ cache ] ) {
			this[ cache ] = to( this._rgba );
		}
		if ( value === undefined ) {
			return this[ cache ].slice();
		}

		var ret,
			type = jQuery.type( value ),
			arr = ( type === "array" || type === "object" ) ? value : arguments,
			local = this[ cache ].slice();

		each( props, function( key, prop ) {
			var val = arr[ type === "object" ? key : prop.idx ];
			if ( val == null ) {
				val = local[ prop.idx ];
			}
			local[ prop.idx ] = clamp( val, prop );
		} );

		if ( from ) {
			ret = color( from( local ) );
			ret[ cache ] = local;
			return ret;
		} else {
			return color( local );
		}
	};

	// Makes red() green() blue() alpha() hue() saturation() lightness()
	each( props, function( key, prop ) {

		// Alpha is included in more than one space
		if ( color.fn[ key ] ) {
			return;
		}
		color.fn[ key ] = function( value ) {
			var vtype = jQuery.type( value ),
				fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
				local = this[ fn ](),
				cur = local[ prop.idx ],
				match;

			if ( vtype === "undefined" ) {
				return cur;
			}

			if ( vtype === "function" ) {
				value = value.call( this, cur );
				vtype = jQuery.type( value );
			}
			if ( value == null && prop.empty ) {
				return this;
			}
			if ( vtype === "string" ) {
				match = rplusequals.exec( value );
				if ( match ) {
					value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
				}
			}
			local[ prop.idx ] = value;
			return this[ fn ]( local );
		};
	} );
} );

// Add cssHook and .fx.step function for each named hook.
// accept a space separated string of properties
color.hook = function( hook ) {
	var hooks = hook.split( " " );
	each( hooks, function( i, hook ) {
		jQuery.cssHooks[ hook ] = {
			set: function( elem, value ) {
				var parsed, curElem,
					backgroundColor = "";

				if ( value !== "transparent" && ( jQuery.type( value ) !== "string" ||
						( parsed = stringParse( value ) ) ) ) {
					value = color( parsed || value );
					if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
						curElem = hook === "backgroundColor" ? elem.parentNode : elem;
						while (
							( backgroundColor === "" || backgroundColor === "transparent" ) &&
							curElem && curElem.style
						) {
							try {
								backgroundColor = jQuery.css( curElem, "backgroundColor" );
								curElem = curElem.parentNode;
							} catch ( e ) {
							}
						}

						value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
							backgroundColor :
							"_default" );
					}

					value = value.toRgbaString();
				}
				try {
					elem.style[ hook ] = value;
				} catch ( e ) {

					// Wrapped to prevent IE from throwing errors on "invalid" values like
					// 'auto' or 'inherit'
				}
			}
		};
		jQuery.fx.step[ hook ] = function( fx ) {
			if ( !fx.colorInit ) {
				fx.start = color( fx.elem, hook );
				fx.end = color( fx.end );
				fx.colorInit = true;
			}
			jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
		};
	} );

};

color.hook( stepHooks );

jQuery.cssHooks.borderColor = {
	expand: function( value ) {
		var expanded = {};

		each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
			expanded[ "border" + part + "Color" ] = value;
		} );
		return expanded;
	}
};

// Basic color names only.
// Usage of any of the other color names requires adding yourself or including
// jquery.color.svg-names.js.
colors = jQuery.Color.names = {

	// 4.1. Basic color keywords
	aqua: "#00ffff",
	black: "#000000",
	blue: "#0000ff",
	fuchsia: "#ff00ff",
	gray: "#808080",
	green: "#008000",
	lime: "#00ff00",
	maroon: "#800000",
	navy: "#000080",
	olive: "#808000",
	purple: "#800080",
	red: "#ff0000",
	silver: "#c0c0c0",
	teal: "#008080",
	white: "#ffffff",
	yellow: "#ffff00",

	// 4.2.3. "transparent" color keyword
	transparent: [ null, null, null, 0 ],

	_default: "#ffffff"
};

} )( jQuery );

/******************************************************************************/
/****************************** CLASS ANIMATIONS ******************************/
/******************************************************************************/
( function() {

var classAnimationActions = [ "add", "remove", "toggle" ],
	shorthandStyles = {
		border: 1,
		borderBottom: 1,
		borderColor: 1,
		borderLeft: 1,
		borderRight: 1,
		borderTop: 1,
		borderWidth: 1,
		margin: 1,
		padding: 1
	};

$.each(
	[ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
	function( _, prop ) {
		$.fx.step[ prop ] = function( fx ) {
			if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
				jQuery.style( fx.elem, prop, fx.end );
				fx.setAttr = true;
			}
		};
	}
);

function getElementStyles( elem ) {
	var key, len,
		style = elem.ownerDocument.defaultView ?
			elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
			elem.currentStyle,
		styles = {};

	if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
		len = style.length;
		while ( len-- ) {
			key = style[ len ];
			if ( typeof style[ key ] === "string" ) {
				styles[ $.camelCase( key ) ] = style[ key ];
			}
		}

	// Support: Opera, IE <9
	} else {
		for ( key in style ) {
			if ( typeof style[ key ] === "string" ) {
				styles[ key ] = style[ key ];
			}
		}
	}

	return styles;
}

function styleDifference( oldStyle, newStyle ) {
	var diff = {},
		name, value;

	for ( name in newStyle ) {
		value = newStyle[ name ];
		if ( oldStyle[ name ] !== value ) {
			if ( !shorthandStyles[ name ] ) {
				if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
					diff[ name ] = value;
				}
			}
		}
	}

	return diff;
}

// Support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

$.effects.animateClass = function( value, duration, easing, callback ) {
	var o = $.speed( duration, easing, callback );

	return this.queue( function() {
		var animated = $( this ),
			baseClass = animated.attr( "class" ) || "",
			applyClassChange,
			allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

		// Map the animated objects to store the original styles.
		allAnimations = allAnimations.map( function() {
			var el = $( this );
			return {
				el: el,
				start: getElementStyles( this )
			};
		} );

		// Apply class change
		applyClassChange = function() {
			$.each( classAnimationActions, function( i, action ) {
				if ( value[ action ] ) {
					animated[ action + "Class" ]( value[ action ] );
				}
			} );
		};
		applyClassChange();

		// Map all animated objects again - calculate new styles and diff
		allAnimations = allAnimations.map( function() {
			this.end = getElementStyles( this.el[ 0 ] );
			this.diff = styleDifference( this.start, this.end );
			return this;
		} );

		// Apply original class
		animated.attr( "class", baseClass );

		// Map all animated objects again - this time collecting a promise
		allAnimations = allAnimations.map( function() {
			var styleInfo = this,
				dfd = $.Deferred(),
				opts = $.extend( {}, o, {
					queue: false,
					complete: function() {
						dfd.resolve( styleInfo );
					}
				} );

			this.el.animate( this.diff, opts );
			return dfd.promise();
		} );

		// Once all animations have completed:
		$.when.apply( $, allAnimations.get() ).done( function() {

			// Set the final class
			applyClassChange();

			// For each animated element,
			// clear all css properties that were animated
			$.each( arguments, function() {
				var el = this.el;
				$.each( this.diff, function( key ) {
					el.css( key, "" );
				} );
			} );

			// This is guarnteed to be there if you use jQuery.speed()
			// it also handles dequeuing the next anim...
			o.complete.call( animated[ 0 ] );
		} );
	} );
};

$.fn.extend( {
	addClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return speed ?
				$.effects.animateClass.call( this,
					{ add: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.addClass ),

	removeClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return arguments.length > 1 ?
				$.effects.animateClass.call( this,
					{ remove: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.removeClass ),

	toggleClass: ( function( orig ) {
		return function( classNames, force, speed, easing, callback ) {
			if ( typeof force === "boolean" || force === undefined ) {
				if ( !speed ) {

					// Without speed parameter
					return orig.apply( this, arguments );
				} else {
					return $.effects.animateClass.call( this,
						( force ? { add: classNames } : { remove: classNames } ),
						speed, easing, callback );
				}
			} else {

				// Without force parameter
				return $.effects.animateClass.call( this,
					{ toggle: classNames }, force, speed, easing );
			}
		};
	} )( $.fn.toggleClass ),

	switchClass: function( remove, add, speed, easing, callback ) {
		return $.effects.animateClass.call( this, {
			add: add,
			remove: remove
		}, speed, easing, callback );
	}
} );

} )();

/******************************************************************************/
/*********************************** EFFECTS **********************************/
/******************************************************************************/

( function() {

if ( $.expr && $.expr.pseudos && $.expr.pseudos.animated ) {
	$.expr.pseudos.animated = ( function( orig ) {
		return function( elem ) {
			return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
		};
	} )( $.expr.pseudos.animated );
}

if ( $.uiBackCompat !== false ) {
	$.extend( $.effects, {

		// Saves a set of properties in a data storage
		save: function( element, set ) {
			var i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
				}
			}
		},

		// Restores a set of previously saved properties from a data storage
		restore: function( element, set ) {
			var val, i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					val = element.data( dataSpace + set[ i ] );
					element.css( set[ i ], val );
				}
			}
		},

		setMode: function( el, mode ) {
			if ( mode === "toggle" ) {
				mode = el.is( ":hidden" ) ? "show" : "hide";
			}
			return mode;
		},

		// Wraps the element around a wrapper that copies position properties
		createWrapper: function( element ) {

			// If the element is already wrapped, return it
			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				return element.parent();
			}

			// Wrap the element
			var props = {
					width: element.outerWidth( true ),
					height: element.outerHeight( true ),
					"float": element.css( "float" )
				},
				wrapper = $( "<div></div>" )
					.addClass( "ui-effects-wrapper" )
					.css( {
						fontSize: "100%",
						background: "transparent",
						border: "none",
						margin: 0,
						padding: 0
					} ),

				// Store the size in case width/height are defined in % - Fixes #5245
				size = {
					width: element.width(),
					height: element.height()
				},
				active = document.activeElement;

			// Support: Firefox
			// Firefox incorrectly exposes anonymous content
			// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
			try {
				active.id;
			} catch ( e ) {
				active = document.body;
			}

			element.wrap( wrapper );

			// Fixes #7595 - Elements lose focus when wrapped.
			if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
				$( active ).trigger( "focus" );
			}

			// Hotfix for jQuery 1.4 since some change in wrap() seems to actually
			// lose the reference to the wrapped element
			wrapper = element.parent();

			// Transfer positioning properties to the wrapper
			if ( element.css( "position" ) === "static" ) {
				wrapper.css( { position: "relative" } );
				element.css( { position: "relative" } );
			} else {
				$.extend( props, {
					position: element.css( "position" ),
					zIndex: element.css( "z-index" )
				} );
				$.each( [ "top", "left", "bottom", "right" ], function( i, pos ) {
					props[ pos ] = element.css( pos );
					if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
						props[ pos ] = "auto";
					}
				} );
				element.css( {
					position: "relative",
					top: 0,
					left: 0,
					right: "auto",
					bottom: "auto"
				} );
			}
			element.css( size );

			return wrapper.css( props ).show();
		},

		removeWrapper: function( element ) {
			var active = document.activeElement;

			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				element.parent().replaceWith( element );

				// Fixes #7595 - Elements lose focus when wrapped.
				if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
					$( active ).trigger( "focus" );
				}
			}

			return element;
		}
	} );
}

$.extend( $.effects, {
	version: "1.12.1",

	define: function( name, mode, effect ) {
		if ( !effect ) {
			effect = mode;
			mode = "effect";
		}

		$.effects.effect[ name ] = effect;
		$.effects.effect[ name ].mode = mode;

		return effect;
	},

	scaledDimensions: function( element, percent, direction ) {
		if ( percent === 0 ) {
			return {
				height: 0,
				width: 0,
				outerHeight: 0,
				outerWidth: 0
			};
		}

		var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
			y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;

		return {
			height: element.height() * y,
			width: element.width() * x,
			outerHeight: element.outerHeight() * y,
			outerWidth: element.outerWidth() * x
		};

	},

	clipToBox: function( animation ) {
		return {
			width: animation.clip.right - animation.clip.left,
			height: animation.clip.bottom - animation.clip.top,
			left: animation.clip.left,
			top: animation.clip.top
		};
	},

	// Injects recently queued functions to be first in line (after "inprogress")
	unshift: function( element, queueLength, count ) {
		var queue = element.queue();

		if ( queueLength > 1 ) {
			queue.splice.apply( queue,
				[ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
		}
		element.dequeue();
	},

	saveStyle: function( element ) {
		element.data( dataSpaceStyle, element[ 0 ].style.cssText );
	},

	restoreStyle: function( element ) {
		element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
		element.removeData( dataSpaceStyle );
	},

	mode: function( element, mode ) {
		var hidden = element.is( ":hidden" );

		if ( mode === "toggle" ) {
			mode = hidden ? "show" : "hide";
		}
		if ( hidden ? mode === "hide" : mode === "show" ) {
			mode = "none";
		}
		return mode;
	},

	// Translates a [top,left] array into a baseline value
	getBaseline: function( origin, original ) {
		var y, x;

		switch ( origin[ 0 ] ) {
		case "top":
			y = 0;
			break;
		case "middle":
			y = 0.5;
			break;
		case "bottom":
			y = 1;
			break;
		default:
			y = origin[ 0 ] / original.height;
		}

		switch ( origin[ 1 ] ) {
		case "left":
			x = 0;
			break;
		case "center":
			x = 0.5;
			break;
		case "right":
			x = 1;
			break;
		default:
			x = origin[ 1 ] / original.width;
		}

		return {
			x: x,
			y: y
		};
	},

	// Creates a placeholder element so that the original element can be made absolute
	createPlaceholder: function( element ) {
		var placeholder,
			cssPosition = element.css( "position" ),
			position = element.position();

		// Lock in margins first to account for form elements, which
		// will change margin if you explicitly set height
		// see: http://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
		// Support: Safari
		element.css( {
			marginTop: element.css( "marginTop" ),
			marginBottom: element.css( "marginBottom" ),
			marginLeft: element.css( "marginLeft" ),
			marginRight: element.css( "marginRight" )
		} )
		.outerWidth( element.outerWidth() )
		.outerHeight( element.outerHeight() );

		if ( /^(static|relative)/.test( cssPosition ) ) {
			cssPosition = "absolute";

			placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {

				// Convert inline to inline block to account for inline elements
				// that turn to inline block based on content (like img)
				display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
					"inline-block" :
					"block",
				visibility: "hidden",

				// Margins need to be set to account for margin collapse
				marginTop: element.css( "marginTop" ),
				marginBottom: element.css( "marginBottom" ),
				marginLeft: element.css( "marginLeft" ),
				marginRight: element.css( "marginRight" ),
				"float": element.css( "float" )
			} )
			.outerWidth( element.outerWidth() )
			.outerHeight( element.outerHeight() )
			.addClass( "ui-effects-placeholder" );

			element.data( dataSpace + "placeholder", placeholder );
		}

		element.css( {
			position: cssPosition,
			left: position.left,
			top: position.top
		} );

		return placeholder;
	},

	removePlaceholder: function( element ) {
		var dataKey = dataSpace + "placeholder",
				placeholder = element.data( dataKey );

		if ( placeholder ) {
			placeholder.remove();
			element.removeData( dataKey );
		}
	},

	// Removes a placeholder if it exists and restores
	// properties that were modified during placeholder creation
	cleanUp: function( element ) {
		$.effects.restoreStyle( element );
		$.effects.removePlaceholder( element );
	},

	setTransition: function( element, list, factor, value ) {
		value = value || {};
		$.each( list, function( i, x ) {
			var unit = element.cssUnit( x );
			if ( unit[ 0 ] > 0 ) {
				value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
			}
		} );
		return value;
	}
} );

// Return an effect options object for the given parameters:
function _normalizeArguments( effect, options, speed, callback ) {

	// Allow passing all options as the first parameter
	if ( $.isPlainObject( effect ) ) {
		options = effect;
		effect = effect.effect;
	}

	// Convert to an object
	effect = { effect: effect };

	// Catch (effect, null, ...)
	if ( options == null ) {
		options = {};
	}

	// Catch (effect, callback)
	if ( $.isFunction( options ) ) {
		callback = options;
		speed = null;
		options = {};
	}

	// Catch (effect, speed, ?)
	if ( typeof options === "number" || $.fx.speeds[ options ] ) {
		callback = speed;
		speed = options;
		options = {};
	}

	// Catch (effect, options, callback)
	if ( $.isFunction( speed ) ) {
		callback = speed;
		speed = null;
	}

	// Add options to effect
	if ( options ) {
		$.extend( effect, options );
	}

	speed = speed || options.duration;
	effect.duration = $.fx.off ? 0 :
		typeof speed === "number" ? speed :
		speed in $.fx.speeds ? $.fx.speeds[ speed ] :
		$.fx.speeds._default;

	effect.complete = callback || options.complete;

	return effect;
}

function standardAnimationOption( option ) {

	// Valid standard speeds (nothing, number, named speed)
	if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
		return true;
	}

	// Invalid strings - treat as "normal" speed
	if ( typeof option === "string" && !$.effects.effect[ option ] ) {
		return true;
	}

	// Complete callback
	if ( $.isFunction( option ) ) {
		return true;
	}

	// Options hash (but not naming an effect)
	if ( typeof option === "object" && !option.effect ) {
		return true;
	}

	// Didn't match any standard API
	return false;
}

$.fn.extend( {
	effect: function( /* effect, options, speed, callback */ ) {
		var args = _normalizeArguments.apply( this, arguments ),
			effectMethod = $.effects.effect[ args.effect ],
			defaultMode = effectMethod.mode,
			queue = args.queue,
			queueName = queue || "fx",
			complete = args.complete,
			mode = args.mode,
			modes = [],
			prefilter = function( next ) {
				var el = $( this ),
					normalizedMode = $.effects.mode( el, mode ) || defaultMode;

				// Sentinel for duck-punching the :animated psuedo-selector
				el.data( dataSpaceAnimated, true );

				// Save effect mode for later use,
				// we can't just call $.effects.mode again later,
				// as the .show() below destroys the initial state
				modes.push( normalizedMode );

				// See $.uiBackCompat inside of run() for removal of defaultMode in 1.13
				if ( defaultMode && ( normalizedMode === "show" ||
						( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
					el.show();
				}

				if ( !defaultMode || normalizedMode !== "none" ) {
					$.effects.saveStyle( el );
				}

				if ( $.isFunction( next ) ) {
					next();
				}
			};

		if ( $.fx.off || !effectMethod ) {

			// Delegate to the original method (e.g., .show()) if possible
			if ( mode ) {
				return this[ mode ]( args.duration, complete );
			} else {
				return this.each( function() {
					if ( complete ) {
						complete.call( this );
					}
				} );
			}
		}

		function run( next ) {
			var elem = $( this );

			function cleanup() {
				elem.removeData( dataSpaceAnimated );

				$.effects.cleanUp( elem );

				if ( args.mode === "hide" ) {
					elem.hide();
				}

				done();
			}

			function done() {
				if ( $.isFunction( complete ) ) {
					complete.call( elem[ 0 ] );
				}

				if ( $.isFunction( next ) ) {
					next();
				}
			}

			// Override mode option on a per element basis,
			// as toggle can be either show or hide depending on element state
			args.mode = modes.shift();

			if ( $.uiBackCompat !== false && !defaultMode ) {
				if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, done );
				}
			} else {
				if ( args.mode === "none" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, cleanup );
				}
			}
		}

		// Run prefilter on all elements first to ensure that
		// any showing or hiding happens before placeholder creation,
		// which ensures that any layout changes are correctly captured.
		return queue === false ?
			this.each( prefilter ).each( run ) :
			this.queue( queueName, prefilter ).queue( queueName, run );
	},

	show: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "show";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.show ),

	hide: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "hide";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.hide ),

	toggle: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "toggle";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.toggle ),

	cssUnit: function( key ) {
		var style = this.css( key ),
			val = [];

		$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
			if ( style.indexOf( unit ) > 0 ) {
				val = [ parseFloat( style ), unit ];
			}
		} );
		return val;
	},

	cssClip: function( clipObj ) {
		if ( clipObj ) {
			return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
				clipObj.bottom + "px " + clipObj.left + "px)" );
		}
		return parseClip( this.css( "clip" ), this );
	},

	transfer: function( options, done ) {
		var element = $( this ),
			target = $( options.to ),
			targetFixed = target.css( "position" ) === "fixed",
			body = $( "body" ),
			fixTop = targetFixed ? body.scrollTop() : 0,
			fixLeft = targetFixed ? body.scrollLeft() : 0,
			endPosition = target.offset(),
			animation = {
				top: endPosition.top - fixTop,
				left: endPosition.left - fixLeft,
				height: target.innerHeight(),
				width: target.innerWidth()
			},
			startPosition = element.offset(),
			transfer = $( "<div class='ui-effects-transfer'></div>" )
				.appendTo( "body" )
				.addClass( options.className )
				.css( {
					top: startPosition.top - fixTop,
					left: startPosition.left - fixLeft,
					height: element.innerHeight(),
					width: element.innerWidth(),
					position: targetFixed ? "fixed" : "absolute"
				} )
				.animate( animation, options.duration, options.easing, function() {
					transfer.remove();
					if ( $.isFunction( done ) ) {
						done();
					}
				} );
	}
} );

function parseClip( str, element ) {
		var outerWidth = element.outerWidth(),
			outerHeight = element.outerHeight(),
			clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
			values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];

		return {
			top: parseFloat( values[ 1 ] ) || 0,
			right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
			bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
			left: parseFloat( values[ 4 ] ) || 0
		};
}

$.fx.step.clip = function( fx ) {
	if ( !fx.clipInit ) {
		fx.start = $( fx.elem ).cssClip();
		if ( typeof fx.end === "string" ) {
			fx.end = parseClip( fx.end, fx.elem );
		}
		fx.clipInit = true;
	}

	$( fx.elem ).cssClip( {
		top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
		right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
		bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
		left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
	} );
};

} )();

/******************************************************************************/
/*********************************** EASING ***********************************/
/******************************************************************************/

( function() {

// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

var baseEasings = {};

$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
	baseEasings[ name ] = function( p ) {
		return Math.pow( p, i + 2 );
	};
} );

$.extend( baseEasings, {
	Sine: function( p ) {
		return 1 - Math.cos( p * Math.PI / 2 );
	},
	Circ: function( p ) {
		return 1 - Math.sqrt( 1 - p * p );
	},
	Elastic: function( p ) {
		return p === 0 || p === 1 ? p :
			-Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
	},
	Back: function( p ) {
		return p * p * ( 3 * p - 2 );
	},
	Bounce: function( p ) {
		var pow2,
			bounce = 4;

		while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
		return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
	}
} );

$.each( baseEasings, function( name, easeIn ) {
	$.easing[ "easeIn" + name ] = easeIn;
	$.easing[ "easeOut" + name ] = function( p ) {
		return 1 - easeIn( 1 - p );
	};
	$.easing[ "easeInOut" + name ] = function( p ) {
		return p < 0.5 ?
			easeIn( p * 2 ) / 2 :
			1 - easeIn( p * -2 + 2 ) / 2;
	};
} );

} )();

var effect = $.effects;


/*!
 * jQuery UI Effects Blind 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Blind Effect
//>>group: Effects
//>>description: Blinds the element.
//>>docs: http://api.jqueryui.com/blind-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectBlind = $.effects.define( "blind", "hide", function( options, done ) {
	var map = {
			up: [ "bottom", "top" ],
			vertical: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			horizontal: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		element = $( this ),
		direction = options.direction || "up",
		start = element.cssClip(),
		animate = { clip: $.extend( {}, start ) },
		placeholder = $.effects.createPlaceholder( element );

	animate.clip[ map[ direction ][ 0 ] ] = animate.clip[ map[ direction ][ 1 ] ];

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animate ) );
		}

		animate.clip = start;
	}

	if ( placeholder ) {
		placeholder.animate( $.effects.clipToBox( animate ), options.duration, options.easing );
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Bounce 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Bounce Effect
//>>group: Effects
//>>description: Bounces an element horizontally or vertically n times.
//>>docs: http://api.jqueryui.com/bounce-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectBounce = $.effects.define( "bounce", function( options, done ) {
	var upAnim, downAnim, refValue,
		element = $( this ),

		// Defaults:
		mode = options.mode,
		hide = mode === "hide",
		show = mode === "show",
		direction = options.direction || "up",
		distance = options.distance,
		times = options.times || 5,

		// Number of internal animations
		anims = times * 2 + ( show || hide ? 1 : 0 ),
		speed = options.duration / anims,
		easing = options.easing,

		// Utility:
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ),
		i = 0,

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	refValue = element.css( ref );

	// Default distance for the BIGGEST bounce is the outer Distance / 3
	if ( !distance ) {
		distance = element[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
	}

	if ( show ) {
		downAnim = { opacity: 1 };
		downAnim[ ref ] = refValue;

		// If we are showing, force opacity 0 and set the initial position
		// then do the "first" animation
		element
			.css( "opacity", 0 )
			.css( ref, motion ? -distance * 2 : distance * 2 )
			.animate( downAnim, speed, easing );
	}

	// Start at the smallest distance if we are hiding
	if ( hide ) {
		distance = distance / Math.pow( 2, times - 1 );
	}

	downAnim = {};
	downAnim[ ref ] = refValue;

	// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
	for ( ; i < times; i++ ) {
		upAnim = {};
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element
			.animate( upAnim, speed, easing )
			.animate( downAnim, speed, easing );

		distance = hide ? distance * 2 : distance / 2;
	}

	// Last Bounce when Hiding
	if ( hide ) {
		upAnim = { opacity: 0 };
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element.animate( upAnim, speed, easing );
	}

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Clip 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Clip Effect
//>>group: Effects
//>>description: Clips the element on and off like an old TV.
//>>docs: http://api.jqueryui.com/clip-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectClip = $.effects.define( "clip", "hide", function( options, done ) {
	var start,
		animate = {},
		element = $( this ),
		direction = options.direction || "vertical",
		both = direction === "both",
		horizontal = both || direction === "horizontal",
		vertical = both || direction === "vertical";

	start = element.cssClip();
	animate.clip = {
		top: vertical ? ( start.bottom - start.top ) / 2 : start.top,
		right: horizontal ? ( start.right - start.left ) / 2 : start.right,
		bottom: vertical ? ( start.bottom - start.top ) / 2 : start.bottom,
		left: horizontal ? ( start.right - start.left ) / 2 : start.left
	};

	$.effects.createPlaceholder( element );

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		animate.clip = start;
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );

} );


/*!
 * jQuery UI Effects Drop 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Drop Effect
//>>group: Effects
//>>description: Moves an element in one direction and hides it at the same time.
//>>docs: http://api.jqueryui.com/drop-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectDrop = $.effects.define( "drop", "hide", function( options, done ) {

	var distance,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ) ? "-=" : "+=",
		oppositeMotion = ( motion === "+=" ) ? "-=" : "+=",
		animation = {
			opacity: 0
		};

	$.effects.createPlaceholder( element );

	distance = options.distance ||
		element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;

	animation[ ref ] = motion + distance;

	if ( show ) {
		element.css( animation );

		animation[ ref ] = oppositeMotion + distance;
		animation.opacity = 1;
	}

	// Animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Explode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Explode Effect
//>>group: Effects
// jscs:disable maximumLineLength
//>>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/explode-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectExplode = $.effects.define( "explode", "hide", function( options, done ) {

	var i, j, left, top, mx, my,
		rows = options.pieces ? Math.round( Math.sqrt( options.pieces ) ) : 3,
		cells = rows,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",

		// Show and then visibility:hidden the element before calculating offset
		offset = element.show().css( "visibility", "hidden" ).offset(),

		// Width and height of a piece
		width = Math.ceil( element.outerWidth() / cells ),
		height = Math.ceil( element.outerHeight() / rows ),
		pieces = [];

	// Children animate complete:
	function childComplete() {
		pieces.push( this );
		if ( pieces.length === rows * cells ) {
			animComplete();
		}
	}

	// Clone the element for each row and cell.
	for ( i = 0; i < rows; i++ ) { // ===>
		top = offset.top + i * height;
		my = i - ( rows - 1 ) / 2;

		for ( j = 0; j < cells; j++ ) { // |||
			left = offset.left + j * width;
			mx = j - ( cells - 1 ) / 2;

			// Create a clone of the now hidden main element that will be absolute positioned
			// within a wrapper div off the -left and -top equal to size of our pieces
			element
				.clone()
				.appendTo( "body" )
				.wrap( "<div></div>" )
				.css( {
					position: "absolute",
					visibility: "visible",
					left: -j * width,
					top: -i * height
				} )

				// Select the wrapper - make it overflow: hidden and absolute positioned based on
				// where the original was located +left and +top equal to the size of pieces
				.parent()
					.addClass( "ui-effects-explode" )
					.css( {
						position: "absolute",
						overflow: "hidden",
						width: width,
						height: height,
						left: left + ( show ? mx * width : 0 ),
						top: top + ( show ? my * height : 0 ),
						opacity: show ? 0 : 1
					} )
					.animate( {
						left: left + ( show ? 0 : mx * width ),
						top: top + ( show ? 0 : my * height ),
						opacity: show ? 1 : 0
					}, options.duration || 500, options.easing, childComplete );
		}
	}

	function animComplete() {
		element.css( {
			visibility: "visible"
		} );
		$( pieces ).remove();
		done();
	}
} );


/*!
 * jQuery UI Effects Fade 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Fade Effect
//>>group: Effects
//>>description: Fades the element.
//>>docs: http://api.jqueryui.com/fade-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectFade = $.effects.define( "fade", "toggle", function( options, done ) {
	var show = options.mode === "show";

	$( this )
		.css( "opacity", show ? 0 : 1 )
		.animate( {
			opacity: show ? 1 : 0
		}, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Fold 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Fold Effect
//>>group: Effects
//>>description: Folds an element first horizontally and then vertically.
//>>docs: http://api.jqueryui.com/fold-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectFold = $.effects.define( "fold", "hide", function( options, done ) {

	// Create element
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		size = options.size || 15,
		percent = /([0-9]+)%/.exec( size ),
		horizFirst = !!options.horizFirst,
		ref = horizFirst ? [ "right", "bottom" ] : [ "bottom", "right" ],
		duration = options.duration / 2,

		placeholder = $.effects.createPlaceholder( element ),

		start = element.cssClip(),
		animation1 = { clip: $.extend( {}, start ) },
		animation2 = { clip: $.extend( {}, start ) },

		distance = [ start[ ref[ 0 ] ], start[ ref[ 1 ] ] ],

		queuelen = element.queue().length;

	if ( percent ) {
		size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
	}
	animation1.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 1 ] ] = 0;

	if ( show ) {
		element.cssClip( animation2.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animation2 ) );
		}

		animation2.clip = start;
	}

	// Animate
	element
		.queue( function( next ) {
			if ( placeholder ) {
				placeholder
					.animate( $.effects.clipToBox( animation1 ), duration, options.easing )
					.animate( $.effects.clipToBox( animation2 ), duration, options.easing );
			}

			next();
		} )
		.animate( animation1, duration, options.easing )
		.animate( animation2, duration, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, 4 );
} );


/*!
 * jQuery UI Effects Highlight 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Highlight Effect
//>>group: Effects
//>>description: Highlights the background of an element in a defined color for a custom duration.
//>>docs: http://api.jqueryui.com/highlight-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectHighlight = $.effects.define( "highlight", "show", function( options, done ) {
	var element = $( this ),
		animation = {
			backgroundColor: element.css( "backgroundColor" )
		};

	if ( options.mode === "hide" ) {
		animation.opacity = 0;
	}

	$.effects.saveStyle( element );

	element
		.css( {
			backgroundImage: "none",
			backgroundColor: options.color || "#ffff99"
		} )
		.animate( animation, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Size 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Size Effect
//>>group: Effects
//>>description: Resize an element to a specified width and height.
//>>docs: http://api.jqueryui.com/size-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectSize = $.effects.define( "size", function( options, done ) {

	// Create element
	var baseline, factor, temp,
		element = $( this ),

		// Copy for children
		cProps = [ "fontSize" ],
		vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
		hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],

		// Set options
		mode = options.mode,
		restore = mode !== "effect",
		scale = options.scale || "both",
		origin = options.origin || [ "middle", "center" ],
		position = element.css( "position" ),
		pos = element.position(),
		original = $.effects.scaledDimensions( element ),
		from = options.from || original,
		to = options.to || $.effects.scaledDimensions( element, 0 );

	$.effects.createPlaceholder( element );

	if ( mode === "show" ) {
		temp = from;
		from = to;
		to = temp;
	}

	// Set scaling factor
	factor = {
		from: {
			y: from.height / original.height,
			x: from.width / original.width
		},
		to: {
			y: to.height / original.height,
			x: to.width / original.width
		}
	};

	// Scale the css box
	if ( scale === "box" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, vProps, factor.from.y, from );
			to = $.effects.setTransition( element, vProps, factor.to.y, to );
		}

		// Horizontal props scaling
		if ( factor.from.x !== factor.to.x ) {
			from = $.effects.setTransition( element, hProps, factor.from.x, from );
			to = $.effects.setTransition( element, hProps, factor.to.x, to );
		}
	}

	// Scale the content
	if ( scale === "content" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, cProps, factor.from.y, from );
			to = $.effects.setTransition( element, cProps, factor.to.y, to );
		}
	}

	// Adjust the position properties based on the provided origin points
	if ( origin ) {
		baseline = $.effects.getBaseline( origin, original );
		from.top = ( original.outerHeight - from.outerHeight ) * baseline.y + pos.top;
		from.left = ( original.outerWidth - from.outerWidth ) * baseline.x + pos.left;
		to.top = ( original.outerHeight - to.outerHeight ) * baseline.y + pos.top;
		to.left = ( original.outerWidth - to.outerWidth ) * baseline.x + pos.left;
	}
	element.css( from );

	// Animate the children if desired
	if ( scale === "content" || scale === "both" ) {

		vProps = vProps.concat( [ "marginTop", "marginBottom" ] ).concat( cProps );
		hProps = hProps.concat( [ "marginLeft", "marginRight" ] );

		// Only animate children with width attributes specified
		// TODO: is this right? should we include anything with css width specified as well
		element.find( "*[width]" ).each( function() {
			var child = $( this ),
				childOriginal = $.effects.scaledDimensions( child ),
				childFrom = {
					height: childOriginal.height * factor.from.y,
					width: childOriginal.width * factor.from.x,
					outerHeight: childOriginal.outerHeight * factor.from.y,
					outerWidth: childOriginal.outerWidth * factor.from.x
				},
				childTo = {
					height: childOriginal.height * factor.to.y,
					width: childOriginal.width * factor.to.x,
					outerHeight: childOriginal.height * factor.to.y,
					outerWidth: childOriginal.width * factor.to.x
				};

			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				childFrom = $.effects.setTransition( child, vProps, factor.from.y, childFrom );
				childTo = $.effects.setTransition( child, vProps, factor.to.y, childTo );
			}

			// Horizontal props scaling
			if ( factor.from.x !== factor.to.x ) {
				childFrom = $.effects.setTransition( child, hProps, factor.from.x, childFrom );
				childTo = $.effects.setTransition( child, hProps, factor.to.x, childTo );
			}

			if ( restore ) {
				$.effects.saveStyle( child );
			}

			// Animate children
			child.css( childFrom );
			child.animate( childTo, options.duration, options.easing, function() {

				// Restore children
				if ( restore ) {
					$.effects.restoreStyle( child );
				}
			} );
		} );
	}

	// Animate
	element.animate( to, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: function() {

			var offset = element.offset();

			if ( to.opacity === 0 ) {
				element.css( "opacity", from.opacity );
			}

			if ( !restore ) {
				element
					.css( "position", position === "static" ? "relative" : position )
					.offset( offset );

				// Need to save style here so that automatic style restoration
				// doesn't restore to the original styles from before the animation.
				$.effects.saveStyle( element );
			}

			done();
		}
	} );

} );


/*!
 * jQuery UI Effects Scale 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Scale Effect
//>>group: Effects
//>>description: Grows or shrinks an element and its content.
//>>docs: http://api.jqueryui.com/scale-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectScale = $.effects.define( "scale", function( options, done ) {

	// Create element
	var el = $( this ),
		mode = options.mode,
		percent = parseInt( options.percent, 10 ) ||
			( parseInt( options.percent, 10 ) === 0 ? 0 : ( mode !== "effect" ? 0 : 100 ) ),

		newOptions = $.extend( true, {
			from: $.effects.scaledDimensions( el ),
			to: $.effects.scaledDimensions( el, percent, options.direction || "both" ),
			origin: options.origin || [ "middle", "center" ]
		}, options );

	// Fade option to support puff
	if ( options.fade ) {
		newOptions.from.opacity = 1;
		newOptions.to.opacity = 0;
	}

	$.effects.effect.size.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Puff 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Puff Effect
//>>group: Effects
//>>description: Creates a puff effect by scaling the element up and hiding it at the same time.
//>>docs: http://api.jqueryui.com/puff-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectPuff = $.effects.define( "puff", "hide", function( options, done ) {
	var newOptions = $.extend( true, {}, options, {
		fade: true,
		percent: parseInt( options.percent, 10 ) || 150
	} );

	$.effects.effect.scale.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Pulsate 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Pulsate Effect
//>>group: Effects
//>>description: Pulsates an element n times by changing the opacity to zero and back.
//>>docs: http://api.jqueryui.com/pulsate-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectPulsate = $.effects.define( "pulsate", "show", function( options, done ) {
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		showhide = show || hide,

		// Showing or hiding leaves off the "last" animation
		anims = ( ( options.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
		duration = options.duration / anims,
		animateTo = 0,
		i = 1,
		queuelen = element.queue().length;

	if ( show || !element.is( ":visible" ) ) {
		element.css( "opacity", 0 ).show();
		animateTo = 1;
	}

	// Anims - 1 opacity "toggles"
	for ( ; i < anims; i++ ) {
		element.animate( { opacity: animateTo }, duration, options.easing );
		animateTo = 1 - animateTo;
	}

	element.animate( { opacity: animateTo }, duration, options.easing );

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Shake 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Shake Effect
//>>group: Effects
//>>description: Shakes an element horizontally or vertically n times.
//>>docs: http://api.jqueryui.com/shake-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectShake = $.effects.define( "shake", function( options, done ) {

	var i = 1,
		element = $( this ),
		direction = options.direction || "left",
		distance = options.distance || 20,
		times = options.times || 3,
		anims = times * 2 + 1,
		speed = Math.round( options.duration / anims ),
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		animation = {},
		animation1 = {},
		animation2 = {},

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	// Animation
	animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
	animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
	animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;

	// Animate
	element.animate( animation, speed, options.easing );

	// Shakes
	for ( ; i < times; i++ ) {
		element
			.animate( animation1, speed, options.easing )
			.animate( animation2, speed, options.easing );
	}

	element
		.animate( animation1, speed, options.easing )
		.animate( animation, speed / 2, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Slide 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Slide Effect
//>>group: Effects
//>>description: Slides an element in and out of the viewport.
//>>docs: http://api.jqueryui.com/slide-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectSlide = $.effects.define( "slide", "show", function( options, done ) {
	var startClip, startRef,
		element = $( this ),
		map = {
			up: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		mode = options.mode,
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		distance = options.distance ||
			element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ),
		animation = {};

	$.effects.createPlaceholder( element );

	startClip = element.cssClip();
	startRef = element.position()[ ref ];

	// Define hide animation
	animation[ ref ] = ( positiveMotion ? -1 : 1 ) * distance + startRef;
	animation.clip = element.cssClip();
	animation.clip[ map[ direction ][ 1 ] ] = animation.clip[ map[ direction ][ 0 ] ];

	// Reverse the animation if we're showing
	if ( mode === "show" ) {
		element.cssClip( animation.clip );
		element.css( ref, animation[ ref ] );
		animation.clip = startClip;
		animation[ ref ] = startRef;
	}

	// Actually animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Transfer 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Transfer Effect
//>>group: Effects
//>>description: Displays a transfer effect from one element to another.
//>>docs: http://api.jqueryui.com/transfer-effect/
//>>demos: http://jqueryui.com/effect/



var effect;
if ( $.uiBackCompat !== false ) {
	effect = $.effects.define( "transfer", function( options, done ) {
		$( this ).transfer( options, done );
	} );
}
var effectsEffectTransfer = effect;




}));

/***/ }),

/***/ "./node_modules/jquery/dist/jquery.js":
/*!********************************************!*\
  !*** ./node_modules/jquery/dist/jquery.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if (  true && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "./node_modules/jsonpickle/build/jsonpickle.min.js":
/*!*********************************************************!*\
  !*** ./node_modules/jsonpickle/build/jsonpickle.min.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * 
 * jsonpickle.js 1.1.2 built on 2019-08-31
 * Copyright (c) 2013-2019 Michael Scott Cuthbert and cuthbertLab. BSD License
 * 
 * http://github.com/cuthbertLab/jsonpickleJS
 * 
 */
!function(t,e){ true?module.exports=e():undefined}(window,function(){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)r.d(n,o,function(e){return t[e]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=1)}([function(t,e,r){var n=function(t){"use strict";var e,r=Object.prototype,n=r.hasOwnProperty,o="function"==typeof Symbol?Symbol:{},i=o.iterator||"@@iterator",u=o.asyncIterator||"@@asyncIterator",a=o.toStringTag||"@@toStringTag";function s(t,e,r,n){var o=e&&e.prototype instanceof y?e:y,i=Object.create(o.prototype),u=new O(n||[]);return i._invoke=function(t,e,r){var n=f;return function(o,i){if(n===h)throw new Error("Generator is already running");if(n===_){if("throw"===o)throw i;return L()}for(r.method=o,r.arg=i;;){var u=r.delegate;if(u){var a=w(u,r);if(a){if(a===p)continue;return a}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if(n===f)throw n=_,r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n=h;var s=c(t,e,r);if("normal"===s.type){if(n=r.done?_:l,s.arg===p)continue;return{value:s.arg,done:r.done}}"throw"===s.type&&(n=_,r.method="throw",r.arg=s.arg)}}}(t,r,u),i}function c(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}t.wrap=s;var f="suspendedStart",l="suspendedYield",h="executing",_="completed",p={};function y(){}function d(){}function v(){}var b={};b[i]=function(){return this};var m=Object.getPrototypeOf,k=m&&m(m(T([])));k&&k!==r&&n.call(k,i)&&(b=k);var g=v.prototype=y.prototype=Object.create(b);function E(t){["next","throw","return"].forEach(function(e){t[e]=function(t){return this._invoke(e,t)}})}function S(t){var e;this._invoke=function(r,o){function i(){return new Promise(function(e,i){!function e(r,o,i,u){var a=c(t[r],t,o);if("throw"!==a.type){var s=a.arg,f=s.value;return f&&"object"==typeof f&&n.call(f,"__await")?Promise.resolve(f.__await).then(function(t){e("next",t,i,u)},function(t){e("throw",t,i,u)}):Promise.resolve(f).then(function(t){s.value=t,i(s)},function(t){return e("throw",t,i,u)})}u(a.arg)}(r,o,e,i)})}return e=e?e.then(i,i):i()}}function w(t,r){var n=t.iterator[r.method];if(n===e){if(r.delegate=null,"throw"===r.method){if(t.iterator.return&&(r.method="return",r.arg=e,w(t,r),"throw"===r.method))return p;r.method="throw",r.arg=new TypeError("The iterator does not provide a 'throw' method")}return p}var o=c(n,t.iterator,r.arg);if("throw"===o.type)return r.method="throw",r.arg=o.arg,r.delegate=null,p;var i=o.arg;return i?i.done?(r[t.resultName]=i.value,r.next=t.nextLoc,"return"!==r.method&&(r.method="next",r.arg=e),r.delegate=null,p):i:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,p)}function j(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function x(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function O(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(j,this),this.reset(!0)}function T(t){if(t){var r=t[i];if(r)return r.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var o=-1,u=function r(){for(;++o<t.length;)if(n.call(t,o))return r.value=t[o],r.done=!1,r;return r.value=e,r.done=!0,r};return u.next=u}}return{next:L}}function L(){return{value:e,done:!0}}return d.prototype=g.constructor=v,v.constructor=d,v[a]=d.displayName="GeneratorFunction",t.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===d||"GeneratorFunction"===(e.displayName||e.name))},t.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,v):(t.__proto__=v,a in t||(t[a]="GeneratorFunction")),t.prototype=Object.create(g),t},t.awrap=function(t){return{__await:t}},E(S.prototype),S.prototype[u]=function(){return this},t.AsyncIterator=S,t.async=function(e,r,n,o){var i=new S(s(e,r,n,o));return t.isGeneratorFunction(r)?i:i.next().then(function(t){return t.done?t.value:i.next()})},E(g),g[a]="Generator",g[i]=function(){return this},g.toString=function(){return"[object Generator]"},t.keys=function(t){var e=[];for(var r in t)e.push(r);return e.reverse(),function r(){for(;e.length;){var n=e.pop();if(n in t)return r.value=n,r.done=!1,r}return r.done=!0,r}},t.values=T,O.prototype={constructor:O,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=e,this.done=!1,this.delegate=null,this.method="next",this.arg=e,this.tryEntries.forEach(x),!t)for(var r in this)"t"===r.charAt(0)&&n.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=e)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var r=this;function o(n,o){return a.type="throw",a.arg=t,r.next=n,o&&(r.method="next",r.arg=e),!!o}for(var i=this.tryEntries.length-1;i>=0;--i){var u=this.tryEntries[i],a=u.completion;if("root"===u.tryLoc)return o("end");if(u.tryLoc<=this.prev){var s=n.call(u,"catchLoc"),c=n.call(u,"finallyLoc");if(s&&c){if(this.prev<u.catchLoc)return o(u.catchLoc,!0);if(this.prev<u.finallyLoc)return o(u.finallyLoc)}else if(s){if(this.prev<u.catchLoc)return o(u.catchLoc,!0)}else{if(!c)throw new Error("try statement without catch or finally");if(this.prev<u.finallyLoc)return o(u.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var o=this.tryEntries[r];if(o.tryLoc<=this.prev&&n.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===t||"continue"===t)&&i.tryLoc<=e&&e<=i.finallyLoc&&(i=null);var u=i?i.completion:{};return u.type=t,u.arg=e,i?(this.method="next",this.next=i.finallyLoc,p):this.complete(u)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),p},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),x(r),p}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var o=n.arg;x(r)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(t,r,n){return this.delegate={iterator:T(t),resultName:r,nextLoc:n},"next"===this.method&&(this.arg=e),p}},t}(t.exports);try{regeneratorRuntime=n}catch(t){Function("r","regeneratorRuntime = r")(n)}},function(t,e,r){"use strict";r.r(e);var n={};r.r(n),r.d(n,"merge",function(){return s}),r.d(n,"PRIMITIVES",function(){return c}),r.d(n,"is_type",function(){return f}),r.d(n,"is_object",function(){return l}),r.d(n,"is_primitive",function(){return h}),r.d(n,"is_dictionary",function(){return _}),r.d(n,"is_sequence",function(){return p}),r.d(n,"is_list",function(){return y}),r.d(n,"is_set",function(){return d}),r.d(n,"is_tuple",function(){return v}),r.d(n,"is_dictionary_subclass",function(){return b}),r.d(n,"is_sequence_subclass",function(){return m}),r.d(n,"is_noncomplex",function(){return k}),r.d(n,"is_function",function(){return g}),r.d(n,"is_module",function(){return E}),r.d(n,"is_picklable",function(){return S}),r.d(n,"is_installed",function(){return w}),r.d(n,"is_list_like",function(){return j});var o={};r.r(o),r.d(o,"decode",function(){return L}),r.d(o,"Unpickler",function(){return P}),r.d(o,"getargs",function(){return R}),r.d(o,"loadclass",function(){return Y}),r.d(o,"has_tag",function(){return A}),r.d(o,"construct",function(){return C});var i={};r.r(i),r.d(i,"encode",function(){return I}),r.d(i,"Pickler",function(){return F});r(0);var u={ID:"py/id",OBJECT:"py/object",TYPE:"py/type",REPR:"py/repr",REF:"py/ref",TUPLE:"py/tuple",SET:"py/set",SEQ:"py/seq",STATE:"py/state",JSON_KEY:"json://"};function a(t){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function s(t,e){if(void 0===e)return t;for(var r in e)({}).hasOwnProperty.call(e,r)&&(t[r]=e[r]);return t}u.RESERVED=[u.ID,u.OBJECT,u.TYPE,u.REPR,u.REF,u.TUPLE,u.SET,u.SEQ,u.STATE,u.JSON_KEY],u.PY_CLASS="_py_class";var c=["string","number","boolean"],f=function(t){return!1},l=function(t){return _(t)},h=function(t){return void 0===t||null==t||-1!==c.indexOf(a(t))},_=function(t){return"object"===a(t)&&null!==t},p=function(t){return y(t)||d(t)||v(t)},y=function(t){return t instanceof Array},d=function(t){return!1},v=function(t){return!1},b=function(t){return!1},m=function(t){return!1},k=function(t){return!1},g=function(t){return"function"==typeof t},E=function(t){return!1},S=function(t,e){return-1===u.RESERVED.indexOf(t)&&!g(e)},w=function(t){return!0},j=function(t){return y(t)},x={"fractions.Fraction":{restore:function(t){return t._numerator/t._denominator}}};function O(t){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function T(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function L(t,e,r){var n={keys:!1,safe:!1,reset:!0,backend:JSON};s(n,r);var o,i={};if(s(i,x),s(i,e),void 0===n.context){var u={keys:n.keys,backend:n.backend,safe:n.safe};o=new P(u,i)}else o=n.context;var a=n.backend.parse(t);return o.restore(a,n.reset)}var P=function(){function t(e,r){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t);var n={keys:!1,safe:!1};s(n,e),this.keys=n.keys,this.safe=n.safe,this.handlers=r,this._namestack=[],this._obj_to_idx={},this._objs=[]}var e,r,n;return e=t,(r=[{key:"reset",value:function(){this._namestack=[],this._obj_to_idx={},this._objs=[]}},{key:"restore",value:function(t,e){return e&&this.reset(),this._restore(t)}},{key:"_restore",value:function(t){var e=function(t){return t};return A(t,u.ID)?e=this._restore_id.bind(this):A(t,u.REF)||(A(t,u.TYPE)?e=this._restore_type.bind(this):A(t,u.REPR)||(A(t,u.OBJECT)?e=this._restore_object.bind(this):A(t,u.TUPLE)?e=this._restore_tuple.bind(this):A(t,u.SET)?e=this._restore_set.bind(this):y(t)?e=this._restore_list.bind(this):_(t)&&(e=this._restore_dict.bind(this)))),e(t)}},{key:"_restore_id",value:function(t){return this._objs[t[u.ID]]}},{key:"_restore_type",value:function(t){var e=Y(t[u.TYPE]);return void 0===e?t:e}},{key:"_restore_object",value:function(t){var e=t[u.OBJECT],r=this.handlers[e];if(void 0!==r&&void 0!==r.restore){var n=r.restore(t);try{n[u.PY_CLASS]=e}catch(t){}return this._mkref(n)}var o=Y(e);if(void 0===o)return t[u.PY_CLASS]=e,this._mkref(t);var i=this._restore_object_instance(t,o);return i[u.PY_CLASS]=e,void 0!==r&&void 0!==r.post_restore?r.post_restore(i):i}},{key:"_loadfactory",value:function(t){var e=t.default_factory;return void 0===e?void 0:(t.default_factory=void 0,this._restore(e))}},{key:"_restore_object_instance",value:function(t,e){var r=R(t);r.length>0&&(r=this._restore(r));var n=C(e,r);return this._mkref(n),this._restore_object_instance_variables(t,n)}},{key:"_restore_object_instance_variables",value:function(t,e){var r=this._restore_key_fn(),n=[];for(var o in t)({}).hasOwnProperty.call(t,o)&&n.push(o);n.sort();for(var i=0;i<n.length;i++){var a=n[i];if(-1===u.RESERVED.indexOf(a)){var s=t[a];this._namestack.push(a),a=r(a);var c=void 0;null!=s&&(c=this._restore(s)),e[a]=c,this._namestack.pop()}}if(A(t,u.SEQ)&&void 0!==e.push)for(var f in t[u.SEQ])({}).hasOwnProperty.call(t[u.SEQ],f)&&e.push(this._restore(f));return A(t,u.STATE)&&(e=this._restore_state(t,e)),e}},{key:"_restore_state",value:function(t,e){if(void 0!==e.__setstate__){var r=this._restore(t[u.STATE]);e.__setstate__(r)}else e=this._restore_object_instance_variables(t[u.STATE],e);return e}},{key:"_restore_list",value:function(t){var e=[];this._mkref(e);for(var r=[],n=0;n<t.length;n++){var o=t[n],i=this._restore(o);r.push(i)}return e.push.apply(e,r),e}},{key:"_restore_tuple",value:function(t){for(var e=[],r=t[u.TUPLE],n=0;n<r.length;n++)e.push(this._restore(r[n]));return e}},{key:"_restore_set",value:function(t){for(var e=[],r=t[u.SET],n=0;n<r.length;n++)e.push(this._restore(r[n]));return e}},{key:"_restore_dict",value:function(t){var e={},r=[];for(var n in t)({}).hasOwnProperty.call(t,n)&&r.push(n);r.sort();for(var o=0;o<r.length;o++){var i=r[o],u=t[i];this._namestack.push(i),e[i]=this._restore(u),this._namestack.pop()}return e}},{key:"_restore_key_fn",value:function(){var t=this;return this.keys?function(e){return 0===e.indexOf(u.JSON_KEY)?e=L(e.slice(u.JSON_KEY.length),t.handlers,{context:t,keys:t.keys,reset:!1}):e}:function(t){return t}}},{key:"_mkref",value:function(t){return this._objs.push(t),t}}])&&T(e.prototype,r),n&&T(e,n),t}();function R(t){var e=t[u.SEQ],r=t[u.OBJECT];if(void 0===e||void 0===r)return[];var n=Y(r);return void 0===n?[]:void 0!==n._fields&&n._fields.length===e.length?e:[]}function Y(t){0===t.indexOf("__main__.")&&(t=t.slice("__main__.".length));for(var e=window,r=t.split("."),n=0;n<r.length;n++){if(void 0===(e=e[r[n]]))return e}return e}function A(t,e){return"object"===O(t)&&null!==t&&void 0!==t[e]}function C(t,e){function r(){return t.apply(this,e)}return r.prototype=t.prototype,new r}function N(t){return(N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function J(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function I(t,e){var r={unpicklable:!1,make_refs:!0,keys:!1,max_depth:void 0,reset:!0,backend:void 0,context:void 0};if(s(r,e),void 0===r.context){var n={unpicklable:r.unpicklable,make_refs:r.make_refs,keys:r.keys,backend:r.backend,max_depth:r.max_depth};r.context=new F(n);var o=r.context.flatten(t,r.reset);return JSON.stringify(o)}}var F=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t);var r={unpicklable:!0,make_refs:!0,max_depth:void 0,backend:void 0,keys:!1};s(r,e),this.unpicklable=r.unpicklable,this.make_refs=r.make_refs,this.backend=r.backend,this.keys=r.keys,this._depth=-1,this._max_depth=r.max_depth,this._objs=[],this._seen=[]}var e,r,n;return e=t,(r=[{key:"reset",value:function(){this._objs=[],this._depth=-1,this._seen=[]}},{key:"_push",value:function(){this._depth+=1}},{key:"_pop",value:function(t){return this._depth-=1,-1===this._depth&&this.reset(),t}},{key:"_mkref",value:function(t){return-1===this._get_id_in_objs(t)&&(this._objs.push(t),!0)}},{key:"_get_id_in_objs",value:function(t){for(var e=this._objs.length,r=0;r<e;r++)if(t===this._objs[r])return r;return-1}},{key:"_getref",value:function(t){var e={};return e[u.ID]=this._get_id_in_objs(t),e}},{key:"flatten",value:function(t,e){return void 0===e&&(e=!0),e&&this.reset(),this._flatten(t)}},{key:"_flatten",value:function(t){return this._push(),this._pop(this._flatten_obj(t))}},{key:"_flatten_obj",value:function(t){return this._seen.push(t),this._depth===this._max_depth||!1===this.make_refs&&-1!==this._get_id_in_objs(t)?t.toString():this._get_flattener(t).call(this,t)}},{key:"_list_recurse",value:function(t){for(var e=[],r=0;r<t.length;r++)e.push(this._flatten(t[r]));return e}},{key:"_get_flattener",value:function(t){var e=this;return h(t)?function(t){return t}:y(t)?this._mkref(t)?this._list_recurse:(this._push(),this._getref):v(t)?this.unpicklable?function(t){({})[u.TUPLE]=e._list_recurse(t)}:this._list_recurse:d(t)?this.unpicklable?function(t){({})[u.SET]=e._list_recurse(t)}:this._list_recurse:l(t)?this._ref_obj_instance:void console.log("no flattener for ",t," of type ",N(t))}},{key:"_ref_obj_instance",value:function(t){return this._mkref(t)?this._flatten_obj_instance(t):this._getref(t)}},{key:"_flatten_obj_instance",value:function(t){var e={},r=void 0!==t[u.PY_CLASS],n=void 0!==t.__getstate__;if(r&&!1===E(t)){var o=this._getclassdetail(t);this.unpicklable&&(e[u.OBJECT]=o);var i=x[o];void 0!==i&&i.flatten(t,e)}return E(t),b(t),m(t),n?this._getstate(t,e):this._flatten_dict_obj(t,e)}},{key:"_flatten_dict_obj",value:function(t,e){void 0===e&&(e=new t.prototype.constructor);var r=[];for(var n in t)({}).hasOwnProperty.call(t,n)&&r.push(n);for(var o=0;o<r.length;o++){var i=r[o],a=t[i];i!==u.PY_CLASS&&this._flatten_key_value_pair(i,a,e)}return e}},{key:"_flatten_key_value_pair",value:function(t,e,r){return!1===S(t,e)?r:(r[t]=this._flatten(e),r)}},{key:"_getstate",value:function(t,e){var r=this._flatten_obj(t.__getstate__());return this.unpicklable?e[u.STATE]=r:e=r,e}},{key:"_getclassdetail",value:function(t){return t[u.PY_CLASS]}}])&&J(e.prototype,r),n&&J(e,n),t}();function D(t){return I(t,{unpicklable:!(arguments.length>1&&void 0!==arguments[1])||arguments[1],make_refs:!(arguments.length>2&&void 0!==arguments[2])||arguments[2],keys:arguments.length>3&&void 0!==arguments[3]&&arguments[3],max_depth:arguments.length>4?arguments[4]:void 0,backend:arguments.length>5?arguments[5]:void 0})}function G(t,e){return L(t,e,arguments.length>2&&void 0!==arguments[2]&&arguments[2])}r.d(e,"encode",function(){return D}),r.d(e,"decode",function(){return G}),r.d(e,"pickler",function(){return i}),r.d(e,"unpickler",function(){return o}),r.d(e,"util",function(){return n}),r.d(e,"tags",function(){return u}),r.d(e,"handlers",function(){return x})}])});
//# sourceMappingURL=jsonpickle.min.js.map

/***/ }),

/***/ "./node_modules/midicube/releases/midicube.js":
/*!****************************************************!*\
  !*** ./node_modules/midicube/releases/midicube.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * 
 * midicube 0.6.1 built on 2019-11-24.
 * 
 */
!function(t,e){ true?module.exports=e():undefined}(window,function(){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)r.d(n,o,function(e){return t[e]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=164)}([function(t,e,r){"use strict";var n,o=r(5),i=r(1),a=r(11),u=r(8),c=r(51),s=r(9),f=r(13),l=r(7).f,p=r(50),d=r(37),h=r(4),v=r(44),y=i.DataView,g=y&&y.prototype,_=i.Int8Array,m=_&&_.prototype,b=i.Uint8ClampedArray,A=b&&b.prototype,E=_&&p(_),w=m&&p(m),x=Object.prototype,S=x.isPrototypeOf,T=h("toStringTag"),O=v("TYPED_ARRAY_TAG"),I=!(!i.ArrayBuffer||!y),k=I&&!!d&&"Opera"!==c(i.opera),M=!1,C={Int8Array:1,Uint8Array:1,Uint8ClampedArray:1,Int16Array:2,Uint16Array:2,Int32Array:4,Uint32Array:4,Float32Array:4,Float64Array:8},q=function(t){return a(t)&&u(C,c(t))};for(n in C)i[n]||(k=!1);if((!k||"function"!=typeof E||E===Function.prototype)&&(E=function(){throw TypeError("Incorrect invocation")},k))for(n in C)i[n]&&d(i[n],E);if((!k||!w||w===x)&&(w=E.prototype,k))for(n in C)i[n]&&d(i[n].prototype,w);if(k&&p(A)!==w&&d(A,w),o&&!u(w,T))for(n in M=!0,l(w,T,{get:function(){return a(this)?this[O]:void 0}}),C)i[n]&&s(i[n],O,n);I&&d&&p(g)!==x&&d(g,x),t.exports={NATIVE_ARRAY_BUFFER:I,NATIVE_ARRAY_BUFFER_VIEWS:k,TYPED_ARRAY_TAG:M&&O,aTypedArray:function(t){if(q(t))return t;throw TypeError("Target is not a typed array")},aTypedArrayConstructor:function(t){if(d){if(S.call(E,t))return t}else for(var e in C)if(u(C,n)){var r=i[e];if(r&&(t===r||S.call(r,t)))return t}throw TypeError("Target is not a typed array constructor")},exportProto:function(t,e,r){if(o){if(r)for(var n in C){var a=i[n];a&&u(a.prototype,t)&&delete a.prototype[t]}w[t]&&!r||f(w,t,r?e:k&&m[t]||e)}},exportStatic:function(t,e,r){var n,a;if(o){if(d){if(r)for(n in C)(a=i[n])&&u(a,t)&&delete a[t];if(E[t]&&!r)return;try{return f(E,t,r?e:k&&_[t]||e)}catch(t){}}for(n in C)!(a=i[n])||a[t]&&!r||f(a,t,e)}},isView:function(t){var e=c(t);return"DataView"===e||u(C,e)},isTypedArray:q,TypedArray:E,TypedArrayPrototype:w}},function(t,e,r){(function(e){var r="object",n=function(t){return t&&t.Math==Math&&t};t.exports=n(typeof globalThis==r&&globalThis)||n(typeof window==r&&window)||n(typeof self==r&&self)||n(typeof e==r&&e)||Function("return this")()}).call(this,r(100))},function(t,e,r){var n=r(1),o=r(33).f,i=r(9),a=r(13),u=r(55),c=r(71),s=r(75);t.exports=function(t,e){var r,f,l,p,d,h=t.target,v=t.global,y=t.stat;if(r=v?n:y?n[h]||u(h,{}):(n[h]||{}).prototype)for(f in e){if(p=e[f],l=t.noTargetGet?(d=o(r,f))&&d.value:r[f],!s(v?f:h+(y?".":"#")+f,t.forced)&&void 0!==l){if(typeof p==typeof l)continue;c(p,l)}(t.sham||l&&l.sham)&&i(p,"sham",!0),a(r,f,p,t)}}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,r){var n=r(1),o=r(34),i=r(44),a=r(76),u=n.Symbol,c=o("wks");t.exports=function(t){return c[t]||(c[t]=a&&u[t]||(a?u:i)("Symbol."+t))}},function(t,e,r){var n=r(3);t.exports=!n(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e,r){var n=r(17),o=Math.min;t.exports=function(t){return t>0?o(n(t),9007199254740991):0}},function(t,e,r){var n=r(5),o=r(68),i=r(10),a=r(24),u=Object.defineProperty;e.f=n?u:function(t,e,r){if(i(t),e=a(e,!0),i(r),o)try{return u(t,e,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported");return"value"in r&&(t[e]=r.value),t}},function(t,e){var r={}.hasOwnProperty;t.exports=function(t,e){return r.call(t,e)}},function(t,e,r){var n=r(5),o=r(7),i=r(21);t.exports=n?function(t,e,r){return o.f(t,e,i(1,r))}:function(t,e,r){return t[e]=r,t}},function(t,e,r){var n=r(11);t.exports=function(t){if(!n(t))throw TypeError(String(t)+" is not an object");return t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,r){var n=r(23);t.exports=function(t){return Object(n(t))}},function(t,e,r){var n=r(1),o=r(34),i=r(9),a=r(8),u=r(55),c=r(70),s=r(25),f=s.get,l=s.enforce,p=String(c).split("toString");o("inspectSource",function(t){return c.call(t)}),(t.exports=function(t,e,r,o){var c=!!o&&!!o.unsafe,s=!!o&&!!o.enumerable,f=!!o&&!!o.noTargetGet;"function"==typeof r&&("string"!=typeof e||a(r,"name")||i(r,"name",e),l(r).source=p.join("string"==typeof e?e:"")),t!==n?(c?!f&&t[e]&&(s=!0):delete t[e],s?t[e]=r:i(t,e,r)):s?t[e]=r:u(e,r)})(Function.prototype,"toString",function(){return"function"==typeof this&&f(this).source||c.call(this)})},function(t,e,r){var n=r(41),o=r(23);t.exports=function(t){return n(o(t))}},function(t,e,r){var n=r(58),o=r(41),i=r(12),a=r(6),u=r(106),c=[].push,s=function(t){var e=1==t,r=2==t,s=3==t,f=4==t,l=6==t,p=5==t||l;return function(d,h,v,y){for(var g,_,m=i(d),b=o(m),A=n(h,v,3),E=a(b.length),w=0,x=y||u,S=e?x(d,E):r?x(d,0):void 0;E>w;w++)if((p||w in b)&&(_=A(g=b[w],w,m),t))if(e)S[w]=_;else if(_)switch(t){case 3:return!0;case 5:return g;case 6:return w;case 2:c.call(S,g)}else if(f)return!1;return l?-1:s||f?f:S}};t.exports={forEach:s(0),map:s(1),filter:s(2),some:s(3),every:s(4),find:s(5),findIndex:s(6)}},function(t,e,r){"use strict";var n=r(14),o=r(107),i=r(36),a=r(25),u=r(79),c=a.set,s=a.getterFor("Array Iterator");t.exports=u(Array,"Array",function(t,e){c(this,{type:"Array Iterator",target:n(t),index:0,kind:e})},function(){var t=s(this),e=t.target,r=t.kind,n=t.index++;return!e||n>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==r?{value:n,done:!1}:"values"==r?{value:e[n],done:!1}:{value:[n,e[n]],done:!1}},"values"),i.Arguments=i.Array,o("keys"),o("values"),o("entries")},function(t,e){var r=Math.ceil,n=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?n:r)(t)}},function(t,e,r){var n=r(13),o=r(113),i=Object.prototype;o!==i.toString&&n(i,"toString",o,{unsafe:!0})},function(t,e,r){"use strict";var n=r(82).charAt,o=r(25),i=r(79),a=o.set,u=o.getterFor("String Iterator");i(String,"String",function(t){a(this,{type:"String Iterator",string:String(t),index:0})},function(){var t,e=u(this),r=e.string,o=e.index;return o>=r.length?{value:void 0,done:!0}:(t=n(r,o),e.index+=t.length,{value:t,done:!1})})},function(t,e,r){"use strict";var n=r(2),o=r(1),i=r(42),a=r(5),u=r(76),c=r(3),s=r(8),f=r(57),l=r(11),p=r(10),d=r(12),h=r(14),v=r(24),y=r(21),g=r(27),_=r(48),m=r(26),b=r(105),A=r(74),E=r(33),w=r(7),x=r(54),S=r(9),T=r(13),O=r(34),I=r(43),k=r(45),M=r(44),C=r(4),q=r(77),B=r(78),P=r(49),F=r(25),R=r(15).forEach,D=I("hidden"),L=C("toPrimitive"),j=F.set,U=F.getterFor("Symbol"),W=Object.prototype,K=o.Symbol,N=o.JSON,G=N&&N.stringify,V=E.f,Y=w.f,H=b.f,J=x.f,Z=O("symbols"),X=O("op-symbols"),Q=O("string-to-symbol-registry"),z=O("symbol-to-string-registry"),$=O("wks"),tt=o.QObject,et=!tt||!tt.prototype||!tt.prototype.findChild,rt=a&&c(function(){return 7!=g(Y({},"a",{get:function(){return Y(this,"a",{value:7}).a}})).a})?function(t,e,r){var n=V(W,e);n&&delete W[e],Y(t,e,r),n&&t!==W&&Y(W,e,n)}:Y,nt=function(t,e){var r=Z[t]=g(K.prototype);return j(r,{type:"Symbol",tag:t,description:e}),a||(r.description=e),r},ot=u&&"symbol"==typeof K.iterator?function(t){return"symbol"==typeof t}:function(t){return Object(t)instanceof K},it=function(t,e,r){t===W&&it(X,e,r),p(t);var n=v(e,!0);return p(r),s(Z,n)?(r.enumerable?(s(t,D)&&t[D][n]&&(t[D][n]=!1),r=g(r,{enumerable:y(0,!1)})):(s(t,D)||Y(t,D,y(1,{})),t[D][n]=!0),rt(t,n,r)):Y(t,n,r)},at=function(t,e){p(t);var r=h(e),n=_(r).concat(ft(r));return R(n,function(e){a&&!ut.call(r,e)||it(t,e,r[e])}),t},ut=function(t){var e=v(t,!0),r=J.call(this,e);return!(this===W&&s(Z,e)&&!s(X,e))&&(!(r||!s(this,e)||!s(Z,e)||s(this,D)&&this[D][e])||r)},ct=function(t,e){var r=h(t),n=v(e,!0);if(r!==W||!s(Z,n)||s(X,n)){var o=V(r,n);return!o||!s(Z,n)||s(r,D)&&r[D][n]||(o.enumerable=!0),o}},st=function(t){var e=H(h(t)),r=[];return R(e,function(t){s(Z,t)||s(k,t)||r.push(t)}),r},ft=function(t){var e=t===W,r=H(e?X:h(t)),n=[];return R(r,function(t){!s(Z,t)||e&&!s(W,t)||n.push(Z[t])}),n};u||(T((K=function(){if(this instanceof K)throw TypeError("Symbol is not a constructor");var t=arguments.length&&void 0!==arguments[0]?String(arguments[0]):void 0,e=M(t),r=function(t){this===W&&r.call(X,t),s(this,D)&&s(this[D],e)&&(this[D][e]=!1),rt(this,e,y(1,t))};return a&&et&&rt(W,e,{configurable:!0,set:r}),nt(e,t)}).prototype,"toString",function(){return U(this).tag}),x.f=ut,w.f=it,E.f=ct,m.f=b.f=st,A.f=ft,a&&(Y(K.prototype,"description",{configurable:!0,get:function(){return U(this).description}}),i||T(W,"propertyIsEnumerable",ut,{unsafe:!0})),q.f=function(t){return nt(C(t),t)}),n({global:!0,wrap:!0,forced:!u,sham:!u},{Symbol:K}),R(_($),function(t){B(t)}),n({target:"Symbol",stat:!0,forced:!u},{for:function(t){var e=String(t);if(s(Q,e))return Q[e];var r=K(e);return Q[e]=r,z[r]=e,r},keyFor:function(t){if(!ot(t))throw TypeError(t+" is not a symbol");if(s(z,t))return z[t]},useSetter:function(){et=!0},useSimple:function(){et=!1}}),n({target:"Object",stat:!0,forced:!u,sham:!a},{create:function(t,e){return void 0===e?g(t):at(g(t),e)},defineProperty:it,defineProperties:at,getOwnPropertyDescriptor:ct}),n({target:"Object",stat:!0,forced:!u},{getOwnPropertyNames:st,getOwnPropertySymbols:ft}),n({target:"Object",stat:!0,forced:c(function(){A.f(1)})},{getOwnPropertySymbols:function(t){return A.f(d(t))}}),N&&n({target:"JSON",stat:!0,forced:!u||c(function(){var t=K();return"[null]"!=G([t])||"{}"!=G({a:t})||"{}"!=G(Object(t))})},{stringify:function(t){for(var e,r,n=[t],o=1;arguments.length>o;)n.push(arguments[o++]);if(r=e=n[1],(l(e)||void 0!==t)&&!ot(t))return f(e)||(e=function(t,e){if("function"==typeof r&&(e=r.call(this,t,e)),!ot(e))return e}),n[1]=e,G.apply(N,n)}}),K.prototype[L]||S(K.prototype,L,K.prototype.valueOf),P(K,"Symbol"),k[D]=!0},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,e){t.exports=function(t){if(null==t)throw TypeError("Can't call method on "+t);return t}},function(t,e,r){var n=r(11);t.exports=function(t,e){if(!n(t))return t;var r,o;if(e&&"function"==typeof(r=t.toString)&&!n(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!n(o=r.call(t)))return o;if(!e&&"function"==typeof(r=t.toString)&&!n(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,r){var n,o,i,a=r(101),u=r(1),c=r(11),s=r(9),f=r(8),l=r(43),p=r(45),d=u.WeakMap;if(a){var h=new d,v=h.get,y=h.has,g=h.set;n=function(t,e){return g.call(h,t,e),e},o=function(t){return v.call(h,t)||{}},i=function(t){return y.call(h,t)}}else{var _=l("state");p[_]=!0,n=function(t,e){return s(t,_,e),e},o=function(t){return f(t,_)?t[_]:{}},i=function(t){return f(t,_)}}t.exports={set:n,get:o,has:i,enforce:function(t){return i(t)?o(t):n(t,{})},getterFor:function(t){return function(e){var r;if(!c(e)||(r=o(e)).type!==t)throw TypeError("Incompatible receiver, "+t+" required");return r}}}},function(t,e,r){var n=r(73),o=r(56).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return n(t,o)}},function(t,e,r){var n=r(10),o=r(103),i=r(56),a=r(45),u=r(104),c=r(69),s=r(43)("IE_PROTO"),f=function(){},l=function(){var t,e=c("iframe"),r=i.length;for(e.style.display="none",u.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),l=t.F;r--;)delete l.prototype[i[r]];return l()};t.exports=Object.create||function(t,e){var r;return null!==t?(f.prototype=n(t),r=new f,f.prototype=null,r[s]=t):r=l(),void 0===e?r:o(r,e)},a[s]=!0},function(t,e,r){"use strict";var n=r(2),o=r(5),i=r(1),a=r(8),u=r(11),c=r(7).f,s=r(71),f=i.Symbol;if(o&&"function"==typeof f&&(!("description"in f.prototype)||void 0!==f().description)){var l={},p=function(){var t=arguments.length<1||void 0===arguments[0]?void 0:String(arguments[0]),e=this instanceof p?new f(t):void 0===t?f():f(t);return""===t&&(l[e]=!0),e};s(p,f);var d=p.prototype=f.prototype;d.constructor=p;var h=d.toString,v="Symbol(test)"==String(f("test")),y=/^Symbol\((.*)\)[^)]+$/;c(d,"description",{configurable:!0,get:function(){var t=u(this)?this.valueOf():this,e=h.call(t);if(a(l,t))return"";var r=v?e.slice(7,-1):e.replace(y,"$1");return""===r?void 0:r}}),n({global:!0,forced:!0},{Symbol:p})}},function(t,e,r){r(78)("iterator")},function(t,e,r){var n=r(1),o=r(114),i=r(16),a=r(9),u=r(4),c=u("iterator"),s=u("toStringTag"),f=i.values;for(var l in o){var p=n[l],d=p&&p.prototype;if(d){if(d[c]!==f)try{a(d,c,f)}catch(t){d[c]=f}if(d[s]||a(d,s,l),o[l])for(var h in i)if(d[h]!==i[h])try{a(d,h,i[h])}catch(t){d[h]=i[h]}}}},function(t,e,r){"use strict";var n=r(2),o=r(52);n({target:"RegExp",proto:!0,forced:/./.exec!==o},{exec:o})},function(t,e,r){var n=r(10),o=r(59),i=r(4)("species");t.exports=function(t,e){var r,a=n(t).constructor;return void 0===a||null==(r=n(a)[i])?e:o(r)}},function(t,e,r){var n=r(5),o=r(54),i=r(21),a=r(14),u=r(24),c=r(8),s=r(68),f=Object.getOwnPropertyDescriptor;e.f=n?f:function(t,e){if(t=a(t),e=u(e,!0),s)try{return f(t,e)}catch(t){}if(c(t,e))return i(!o.f.call(t,e),t[e])}},function(t,e,r){var n=r(1),o=r(55),i=r(42),a=n["__core-js_shared__"]||o("__core-js_shared__",{});(t.exports=function(t,e){return a[t]||(a[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.2.1",mode:i?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},function(t,e,r){var n=r(17),o=Math.max,i=Math.min;t.exports=function(t,e){var r=n(t);return r<0?o(r+e,0):i(r,e)}},function(t,e){t.exports={}},function(t,e,r){var n=r(10),o=r(109);t.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,r={};try{(t=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(r,[]),e=r instanceof Array}catch(t){}return function(r,i){return n(r),o(i),e?t.call(r,i):r.__proto__=i,r}}():void 0)},function(t,e,r){var n=r(2),o=r(5);n({target:"Object",stat:!0,forced:!o,sham:!o},{defineProperty:r(7).f})},function(t,e,r){"use strict";var n=r(2),o=r(47).indexOf,i=r(60),a=[].indexOf,u=!!a&&1/[1].indexOf(1,-0)<0,c=i("indexOf");n({target:"Array",proto:!0,forced:u||c},{indexOf:function(t){return u?a.apply(this,arguments)||0:o(this,t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,r){var n=r(2),o=r(1),i=r(122),a=[].slice,u=function(t){return function(e,r){var n=arguments.length>2,o=n?a.call(arguments,2):void 0;return t(n?function(){("function"==typeof e?e:Function(e)).apply(this,o)}:e,r)}};n({global:!0,bind:!0,forced:/MSIE .\./.test(i)},{setTimeout:u(o.setTimeout),setInterval:u(o.setInterval)})},function(t,e,r){var n=r(3),o=r(22),i="".split;t.exports=n(function(){return!Object("z").propertyIsEnumerable(0)})?function(t){return"String"==o(t)?i.call(t,""):Object(t)}:Object},function(t,e){t.exports=!1},function(t,e,r){var n=r(34),o=r(44),i=n("keys");t.exports=function(t){return i[t]||(i[t]=o(t))}},function(t,e){var r=0,n=Math.random();t.exports=function(t){return"Symbol("+String(void 0===t?"":t)+")_"+(++r+n).toString(36)}},function(t,e){t.exports={}},function(t,e,r){var n=r(72),o=r(1),i=function(t){return"function"==typeof t?t:void 0};t.exports=function(t,e){return arguments.length<2?i(n[t])||i(o[t]):n[t]&&n[t][e]||o[t]&&o[t][e]}},function(t,e,r){var n=r(14),o=r(6),i=r(35),a=function(t){return function(e,r,a){var u,c=n(e),s=o(c.length),f=i(a,s);if(t&&r!=r){for(;s>f;)if((u=c[f++])!=u)return!0}else for(;s>f;f++)if((t||f in c)&&c[f]===r)return t||f||0;return!t&&-1}};t.exports={includes:a(!0),indexOf:a(!1)}},function(t,e,r){var n=r(73),o=r(56);t.exports=Object.keys||function(t){return n(t,o)}},function(t,e,r){var n=r(7).f,o=r(8),i=r(4)("toStringTag");t.exports=function(t,e,r){t&&!o(t=r?t:t.prototype,i)&&n(t,i,{configurable:!0,value:e})}},function(t,e,r){var n=r(8),o=r(12),i=r(43),a=r(81),u=i("IE_PROTO"),c=Object.prototype;t.exports=a?Object.getPrototypeOf:function(t){return t=o(t),n(t,u)?t[u]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?c:null}},function(t,e,r){var n=r(22),o=r(4)("toStringTag"),i="Arguments"==n(function(){return arguments}());t.exports=function(t){var e,r,a;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(r=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),o))?r:i?n(e):"Object"==(a=n(e))&&"function"==typeof e.callee?"Arguments":a}},function(t,e,r){"use strict";var n,o,i=r(86),a=RegExp.prototype.exec,u=String.prototype.replace,c=a,s=(n=/a/,o=/b*/g,a.call(n,"a"),a.call(o,"a"),0!==n.lastIndex||0!==o.lastIndex),f=void 0!==/()??/.exec("")[1];(s||f)&&(c=function(t){var e,r,n,o,c=this;return f&&(r=new RegExp("^"+c.source+"$(?!\\s)",i.call(c))),s&&(e=c.lastIndex),n=a.call(c,t),s&&n&&(c.lastIndex=c.global?n.index+n[0].length:e),f&&n&&n.length>1&&u.call(n[0],r,function(){for(o=1;o<arguments.length-2;o++)void 0===arguments[o]&&(n[o]=void 0)}),n}),t.exports=c},function(t,e,r){"use strict";var n=r(88),o=r(121),i=r(10),a=r(23),u=r(32),c=r(89),s=r(6),f=r(90),l=r(52),p=r(3),d=[].push,h=Math.min,v=!p(function(){return!RegExp(4294967295,"y")});n("split",2,function(t,e,r){var n;return n="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(t,r){var n=String(a(this)),i=void 0===r?4294967295:r>>>0;if(0===i)return[];if(void 0===t)return[n];if(!o(t))return e.call(n,t,i);for(var u,c,s,f=[],p=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),h=0,v=new RegExp(t.source,p+"g");(u=l.call(v,n))&&!((c=v.lastIndex)>h&&(f.push(n.slice(h,u.index)),u.length>1&&u.index<n.length&&d.apply(f,u.slice(1)),s=u[0].length,h=c,f.length>=i));)v.lastIndex===u.index&&v.lastIndex++;return h===n.length?!s&&v.test("")||f.push(""):f.push(n.slice(h)),f.length>i?f.slice(0,i):f}:"0".split(void 0,0).length?function(t,r){return void 0===t&&0===r?[]:e.call(this,t,r)}:e,[function(e,r){var o=a(this),i=null==e?void 0:e[t];return void 0!==i?i.call(e,o,r):n.call(String(o),e,r)},function(t,o){var a=r(n,t,this,o,n!==e);if(a.done)return a.value;var l=i(t),p=String(this),d=u(l,RegExp),y=l.unicode,g=(l.ignoreCase?"i":"")+(l.multiline?"m":"")+(l.unicode?"u":"")+(v?"y":"g"),_=new d(v?l:"^(?:"+l.source+")",g),m=void 0===o?4294967295:o>>>0;if(0===m)return[];if(0===p.length)return null===f(_,p)?[p]:[];for(var b=0,A=0,E=[];A<p.length;){_.lastIndex=v?A:0;var w,x=f(_,v?p:p.slice(A));if(null===x||(w=h(s(_.lastIndex+(v?0:A)),p.length))===b)A=c(p,A,y);else{if(E.push(p.slice(b,A)),E.length===m)return E;for(var S=1;S<=x.length-1;S++)if(E.push(x[S]),E.length===m)return E;A=b=w}}return E.push(p.slice(b)),E}]},!v)},function(t,e,r){"use strict";var n={}.propertyIsEnumerable,o=Object.getOwnPropertyDescriptor,i=o&&!n.call({1:2},1);e.f=i?function(t){var e=o(this,t);return!!e&&e.enumerable}:n},function(t,e,r){var n=r(1),o=r(9);t.exports=function(t,e){try{o(n,t,e)}catch(r){n[t]=e}return e}},function(t,e){t.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},function(t,e,r){var n=r(22);t.exports=Array.isArray||function(t){return"Array"==n(t)}},function(t,e,r){var n=r(59);t.exports=function(t,e,r){if(n(t),void 0===e)return t;switch(r){case 0:return function(){return t.call(e)};case 1:return function(r){return t.call(e,r)};case 2:return function(r,n){return t.call(e,r,n)};case 3:return function(r,n,o){return t.call(e,r,n,o)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(String(t)+" is not a function");return t}},function(t,e,r){"use strict";var n=r(3);t.exports=function(t,e){var r=[][t];return!r||!n(function(){r.call(null,e||function(){throw 1},1)})}},function(t,e,r){var n=r(13),o=Date.prototype,i=o.toString,a=o.getTime;new Date(NaN)+""!="Invalid Date"&&n(o,"toString",function(){var t=a.call(this);return t==t?i.call(this):"Invalid Date"})},function(t,e,r){var n=r(2),o=r(12),i=r(48);n({target:"Object",stat:!0,forced:r(3)(function(){i(1)})},{keys:function(t){return i(o(t))}})},function(t,e,r){var n=r(2),o=r(124);n({global:!0,forced:parseInt!=o},{parseInt:o})},function(t,e,r){var n=r(23),o="["+r(65)+"]",i=RegExp("^"+o+o+"*"),a=RegExp(o+o+"*$"),u=function(t){return function(e){var r=String(n(e));return 1&t&&(r=r.replace(i,"")),2&t&&(r=r.replace(a,"")),r}};t.exports={start:u(1),end:u(2),trim:u(3)}},function(t,e){t.exports="\t\n\v\f\r                　\u2028\u2029\ufeff"},function(t,e,r){"use strict";var n=r(1),o=r(5),i=r(0).NATIVE_ARRAY_BUFFER,a=r(9),u=r(126),c=r(3),s=r(94),f=r(17),l=r(6),p=r(95),d=r(26).f,h=r(7).f,v=r(96),y=r(49),g=r(25),_=g.get,m=g.set,b=n.ArrayBuffer,A=b,E=n.DataView,w=n.Math,x=n.RangeError,S=w.abs,T=w.pow,O=w.floor,I=w.log,k=w.LN2,M=function(t,e,r){var n,o,i,a=new Array(r),u=8*r-e-1,c=(1<<u)-1,s=c>>1,f=23===e?T(2,-24)-T(2,-77):0,l=t<0||0===t&&1/t<0?1:0,p=0;for((t=S(t))!=t||t===1/0?(o=t!=t?1:0,n=c):(n=O(I(t)/k),t*(i=T(2,-n))<1&&(n--,i*=2),(t+=n+s>=1?f/i:f*T(2,1-s))*i>=2&&(n++,i/=2),n+s>=c?(o=0,n=c):n+s>=1?(o=(t*i-1)*T(2,e),n+=s):(o=t*T(2,s-1)*T(2,e),n=0));e>=8;a[p++]=255&o,o/=256,e-=8);for(n=n<<e|o,u+=e;u>0;a[p++]=255&n,n/=256,u-=8);return a[--p]|=128*l,a},C=function(t,e){var r,n=t.length,o=8*n-e-1,i=(1<<o)-1,a=i>>1,u=o-7,c=n-1,s=t[c--],f=127&s;for(s>>=7;u>0;f=256*f+t[c],c--,u-=8);for(r=f&(1<<-u)-1,f>>=-u,u+=e;u>0;r=256*r+t[c],c--,u-=8);if(0===f)f=1-a;else{if(f===i)return r?NaN:s?-1/0:1/0;r+=T(2,e),f-=a}return(s?-1:1)*r*T(2,f-e)},q=function(t){return t[3]<<24|t[2]<<16|t[1]<<8|t[0]},B=function(t){return[255&t]},P=function(t){return[255&t,t>>8&255]},F=function(t){return[255&t,t>>8&255,t>>16&255,t>>24&255]},R=function(t){return M(t,23,4)},D=function(t){return M(t,52,8)},L=function(t,e){h(t.prototype,e,{get:function(){return _(this)[e]}})},j=function(t,e,r,n){var o=p(+r),i=_(t);if(o+e>i.byteLength)throw x("Wrong index");var a=_(i.buffer).bytes,u=o+i.byteOffset,c=a.slice(u,u+e);return n?c:c.reverse()},U=function(t,e,r,n,o,i){var a=p(+r),u=_(t);if(a+e>u.byteLength)throw x("Wrong index");for(var c=_(u.buffer).bytes,s=a+u.byteOffset,f=n(+o),l=0;l<e;l++)c[s+l]=f[i?l:e-l-1]};if(i){if(!c(function(){b(1)})||!c(function(){new b(-1)})||c(function(){return new b,new b(1.5),new b(NaN),"ArrayBuffer"!=b.name})){for(var W,K=(A=function(t){return s(this,A),new b(p(t))}).prototype=b.prototype,N=d(b),G=0;N.length>G;)(W=N[G++])in A||a(A,W,b[W]);K.constructor=A}var V=new E(new A(2)),Y=E.prototype.setInt8;V.setInt8(0,2147483648),V.setInt8(1,2147483649),!V.getInt8(0)&&V.getInt8(1)||u(E.prototype,{setInt8:function(t,e){Y.call(this,t,e<<24>>24)},setUint8:function(t,e){Y.call(this,t,e<<24>>24)}},{unsafe:!0})}else A=function(t){s(this,A,"ArrayBuffer");var e=p(t);m(this,{bytes:v.call(new Array(e),0),byteLength:e}),o||(this.byteLength=e)},E=function(t,e,r){s(this,E,"DataView"),s(t,A,"DataView");var n=_(t).byteLength,i=f(e);if(i<0||i>n)throw x("Wrong offset");if(i+(r=void 0===r?n-i:l(r))>n)throw x("Wrong length");m(this,{buffer:t,byteLength:r,byteOffset:i}),o||(this.buffer=t,this.byteLength=r,this.byteOffset=i)},o&&(L(A,"byteLength"),L(E,"buffer"),L(E,"byteLength"),L(E,"byteOffset")),u(E.prototype,{getInt8:function(t){return j(this,1,t)[0]<<24>>24},getUint8:function(t){return j(this,1,t)[0]},getInt16:function(t){var e=j(this,2,t,arguments.length>1?arguments[1]:void 0);return(e[1]<<8|e[0])<<16>>16},getUint16:function(t){var e=j(this,2,t,arguments.length>1?arguments[1]:void 0);return e[1]<<8|e[0]},getInt32:function(t){return q(j(this,4,t,arguments.length>1?arguments[1]:void 0))},getUint32:function(t){return q(j(this,4,t,arguments.length>1?arguments[1]:void 0))>>>0},getFloat32:function(t){return C(j(this,4,t,arguments.length>1?arguments[1]:void 0),23)},getFloat64:function(t){return C(j(this,8,t,arguments.length>1?arguments[1]:void 0),52)},setInt8:function(t,e){U(this,1,t,B,e)},setUint8:function(t,e){U(this,1,t,B,e)},setInt16:function(t,e){U(this,2,t,P,e,arguments.length>2?arguments[2]:void 0)},setUint16:function(t,e){U(this,2,t,P,e,arguments.length>2?arguments[2]:void 0)},setInt32:function(t,e){U(this,4,t,F,e,arguments.length>2?arguments[2]:void 0)},setUint32:function(t,e){U(this,4,t,F,e,arguments.length>2?arguments[2]:void 0)},setFloat32:function(t,e){U(this,4,t,R,e,arguments.length>2?arguments[2]:void 0)},setFloat64:function(t,e){U(this,8,t,D,e,arguments.length>2?arguments[2]:void 0)}});y(A,"ArrayBuffer"),y(E,"DataView"),e.ArrayBuffer=A,e.DataView=E},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"a",function(){return Color});var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(20),core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default=__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__),core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(28),core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default=__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__),core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(29),core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default=__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__),core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__=__webpack_require__(39),core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default=__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__),core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__=__webpack_require__(16),core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default=__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__),core_js_modules_es_date_to_string__WEBPACK_IMPORTED_MODULE_5__=__webpack_require__(61),core_js_modules_es_date_to_string__WEBPACK_IMPORTED_MODULE_5___default=__webpack_require__.n(core_js_modules_es_date_to_string__WEBPACK_IMPORTED_MODULE_5__),core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__=__webpack_require__(18),core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default=__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__),core_js_modules_es_parse_float__WEBPACK_IMPORTED_MODULE_7__=__webpack_require__(162),core_js_modules_es_parse_float__WEBPACK_IMPORTED_MODULE_7___default=__webpack_require__.n(core_js_modules_es_parse_float__WEBPACK_IMPORTED_MODULE_7__),core_js_modules_es_parse_int__WEBPACK_IMPORTED_MODULE_8__=__webpack_require__(63),core_js_modules_es_parse_int__WEBPACK_IMPORTED_MODULE_8___default=__webpack_require__.n(core_js_modules_es_parse_int__WEBPACK_IMPORTED_MODULE_8__),core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__=__webpack_require__(31),core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9___default=__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__),core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__=__webpack_require__(87),core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default=__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__),core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__=__webpack_require__(19),core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default=__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__),core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__=__webpack_require__(53),core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12___default=__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__),core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__=__webpack_require__(30),core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13___default=__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__);function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}var Color={Space:{}};!function(){var useEval=!1,functions={},shortcuts={"HEX24>HSL":"HEX24>RGB>HSL","HEX32>HSLA":"HEX32>RGBA>HSLA","HEX24>CMYK":"HEX24>RGB>CMY>CMYK","RGB>CMYK":"RGB>CMY>CMYK"},root=Color.Space=function(color,route){shortcuts[route]&&(route=shortcuts[route]);var r=route.split(">");if("object"===_typeof(color)&&color[0]>=0){for(var type=r[0],tmp={},i=0;i<type.length;i++){var str=type.substr(i,1);tmp[str]=color[i]}color=tmp}if(functions[route])return functions[route](color);for(var f="color",pos=1,key=r[0];pos<r.length;pos++)pos>1&&(key=key.substr(key.indexOf("_")+1)),key+=(0===pos?"":"_")+r[pos],color=root[key](color),useEval&&(f="Color.Space."+key+"("+f+")");return useEval&&(functions[route]=eval("(function(color) { return "+f+" })")),color};root.RGB_W3=function(t){return"rgb("+(t.R>>0)+","+(t.G>>0)+","+(t.B>>0)+")"},root.RGBA_W3=function(t){var e="number"==typeof t.A?t.A/255:1;return"rgba("+(t.R>>0)+","+(t.G>>0)+","+(t.B>>0)+","+e+")"},root.W3_RGB=function(t){t=t.substr(4,t.length-5).split(",");return{R:parseInt(t[0]),G:parseInt(t[1]),B:parseInt(t[2])}},root.W3_RGBA=function(t){t=t.substr(5,t.length-6).split(",");return{R:parseInt(t[0]),G:parseInt(t[1]),B:parseInt(t[2]),A:255*parseFloat(t[3])}},root.HSL_W3=function(t){return"hsl("+(t.H+.5>>0)+","+(t.S+.5>>0)+"%,"+(t.L+.5>>0)+"%)"},root.HSLA_W3=function(t){var e="number"==typeof t.A?t.A/255:1;return"hsla("+(t.H+.5>>0)+","+(t.S+.5>>0)+"%,"+(t.L+.5>>0)+"%,"+e+")"},root.W3_HSL=function(t){t=t.substr(4,t.length-5).split(",");return{H:parseInt(t[0]),S:parseInt(t[1]),L:parseInt(t[2])}},root.W3_HSLA=function(t){t=t.substr(5,t.length-6).split(",");return{H:parseInt(t[0]),S:parseInt(t[1]),L:parseInt(t[2]),A:255*parseFloat(t[3])}},root.W3_HEX=root.W3_HEX24=function(t){return"#"===t.substr(0,1)&&(t=t.substr(1)),3===t.length&&(t=t[0]+t[0]+t[1]+t[1]+t[2]+t[2]),parseInt("0x"+t)},root.W3_HEX32=function(t){return"#"===t.substr(0,1)&&(t=t.substr(1)),6===t.length?parseInt("0xFF"+t):parseInt("0x"+t)},root.HEX_W3=root.HEX24_W3=function(t,e){e||(e=6),t||(t=0);for(var r=t.toString(16),n=r.length;n<e;)r="0"+r,n++;for(n=r.length;n>e;)r=r.substr(1),n--;return"#"+r},root.HEX32_W3=function(t){return root.HEX_W3(t,8)},root.HEX_RGB=root.HEX24_RGB=function(t){return{R:t>>16,G:t>>8&255,B:255&t}},root.HEX32_RGBA=function(t){return{R:t>>>16&255,G:t>>>8&255,B:255&t,A:t>>>24}},root.RGBA_HEX32=function(t){return(t.A<<24|t.R<<16|t.G<<8|t.B)>>>0},root.RGB_HEX24=root.RGB_HEX=function(t){return t.R<0&&(t.R=0),t.G<0&&(t.G=0),t.B<0&&(t.B=0),t.R>255&&(t.R=255),t.G>255&&(t.G=255),t.B>255&&(t.B=255),t.R<<16|t.G<<8|t.B},root.RGB_CMY=function(t){return{C:1-t.R/255,M:1-t.G/255,Y:1-t.B/255}},root.RGBA_HSLA=root.RGB_HSL=function(t){var e,r,n=t.R/255,o=t.G/255,i=t.B/255,a=Math.min(n,o,i),u=Math.max(n,o,i),c=u-a,s=(u+a)/2;if(0===c)e=0,r=0;else{r=s<.5?c/(u+a):c/(2-u-a);var f=((u-n)/6+c/2)/c,l=((u-o)/6+c/2)/c,p=((u-i)/6+c/2)/c;n===u?e=p-l:o===u?e=1/3+f-p:i===u&&(e=2/3+l-f),e<0&&(e+=1),e>1&&(e-=1)}return{H:360*e,S:100*r,L:100*s,A:t.A}},root.RGBA_HSVA=root.RGB_HSV=function(t){var e,r,n=t.R/255,o=t.G/255,i=t.B/255,a=Math.min(n,o,i),u=Math.max(n,o,i),c=u-a;if(0===c)e=0,r=0;else{r=c/u;var s=((u-n)/6+c/2)/c,f=((u-o)/6+c/2)/c,l=((u-i)/6+c/2)/c;n===u?e=l-f:o===u?e=1/3+s-l:i===u&&(e=2/3+f-s),e<0&&(e+=1),e>1&&(e-=1)}return{H:360*e,S:100*r,V:100*u,A:t.A}},root.CMY_RGB=function(t){return{R:Math.max(0,255*(1-t.C)),G:Math.max(0,255*(1-t.M)),B:Math.max(0,255*(1-t.Y))}},root.CMY_CMYK=function(t){var e=t.C,r=t.M,n=t.Y,o=Math.min(n,Math.min(r,Math.min(e,1)));return{C:e=Math.round((e-o)/(1-o)*100),M:r=Math.round((r-o)/(1-o)*100),Y:n=Math.round((n-o)/(1-o)*100),K:o=Math.round(100*o)}},root.CMYK_CMY=function(t){return{C:t.C*(1-t.K)+t.K,M:t.M*(1-t.K)+t.K,Y:t.Y*(1-t.K)+t.K}},root.HSLA_RGBA=root.HSL_RGB=function(t){var e,r,n,o,i,a,u=t.H/360,c=t.S/100,s=t.L/100;return 0===c?e=r=n=s:(o=2*s-(i=s<.5?s*(1+c):s+c-c*s),(a=u+1/3)<0&&(a+=1),a>1&&(a-=1),e=6*a<1?o+6*(i-o)*a:2*a<1?i:3*a<2?o+(i-o)*(2/3-a)*6:o,(a=u)<0&&(a+=1),a>1&&(a-=1),r=6*a<1?o+6*(i-o)*a:2*a<1?i:3*a<2?o+(i-o)*(2/3-a)*6:o,(a=u-1/3)<0&&(a+=1),a>1&&(a-=1),n=6*a<1?o+6*(i-o)*a:2*a<1?i:3*a<2?o+(i-o)*(2/3-a)*6:o),{R:255*e,G:255*r,B:255*n,A:t.A}},root.HSVA_RGBA=root.HSV_RGB=function(t){var e,r,n,o,i,a,u=t.H/360,c=t.S/100,s=t.V/100;if(0===c)e=r=n=Math.round(255*s);else switch(u>=1&&(u=0),o=(u*=6)-Math.floor(u),i=Math.round(255*s*(1-c)),n=Math.round(255*s*(1-c*o)),a=Math.round(255*s*(1-c*(1-o))),s=Math.round(255*s),Math.floor(u)){case 0:e=s,r=a,n=i;break;case 1:e=n,r=s,n=i;break;case 2:e=i,r=s,n=a;break;case 3:e=i,r=n,n=s;break;case 4:e=a,r=i,n=s;break;case 5:e=s,r=i,n=n}return{R:e,G:r,B:n,A:t.A}}}()},function(t,e,r){var n=r(5),o=r(3),i=r(69);t.exports=!n&&!o(function(){return 7!=Object.defineProperty(i("div"),"a",{get:function(){return 7}}).a})},function(t,e,r){var n=r(1),o=r(11),i=n.document,a=o(i)&&o(i.createElement);t.exports=function(t){return a?i.createElement(t):{}}},function(t,e,r){var n=r(34);t.exports=n("native-function-to-string",Function.toString)},function(t,e,r){var n=r(8),o=r(102),i=r(33),a=r(7);t.exports=function(t,e){for(var r=o(e),u=a.f,c=i.f,s=0;s<r.length;s++){var f=r[s];n(t,f)||u(t,f,c(e,f))}}},function(t,e,r){t.exports=r(1)},function(t,e,r){var n=r(8),o=r(14),i=r(47).indexOf,a=r(45);t.exports=function(t,e){var r,u=o(t),c=0,s=[];for(r in u)!n(a,r)&&n(u,r)&&s.push(r);for(;e.length>c;)n(u,r=e[c++])&&(~i(s,r)||s.push(r));return s}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,r){var n=r(3),o=/#|\.prototype\./,i=function(t,e){var r=u[a(t)];return r==s||r!=c&&("function"==typeof e?n(e):!!e)},a=i.normalize=function(t){return String(t).replace(o,".").toLowerCase()},u=i.data={},c=i.NATIVE="N",s=i.POLYFILL="P";t.exports=i},function(t,e,r){var n=r(3);t.exports=!!Object.getOwnPropertySymbols&&!n(function(){return!String(Symbol())})},function(t,e,r){e.f=r(4)},function(t,e,r){var n=r(72),o=r(8),i=r(77),a=r(7).f;t.exports=function(t){var e=n.Symbol||(n.Symbol={});o(e,t)||a(e,t,{value:i.f(t)})}},function(t,e,r){"use strict";var n=r(2),o=r(108),i=r(50),a=r(37),u=r(49),c=r(9),s=r(13),f=r(4),l=r(42),p=r(36),d=r(80),h=d.IteratorPrototype,v=d.BUGGY_SAFARI_ITERATORS,y=f("iterator"),g=function(){return this};t.exports=function(t,e,r,f,d,_,m){o(r,e,f);var b,A,E,w=function(t){if(t===d&&I)return I;if(!v&&t in T)return T[t];switch(t){case"keys":case"values":case"entries":return function(){return new r(this,t)}}return function(){return new r(this)}},x=e+" Iterator",S=!1,T=t.prototype,O=T[y]||T["@@iterator"]||d&&T[d],I=!v&&O||w(d),k="Array"==e&&T.entries||O;if(k&&(b=i(k.call(new t)),h!==Object.prototype&&b.next&&(l||i(b)===h||(a?a(b,h):"function"!=typeof b[y]&&c(b,y,g)),u(b,x,!0,!0),l&&(p[x]=g))),"values"==d&&O&&"values"!==O.name&&(S=!0,I=function(){return O.call(this)}),l&&!m||T[y]===I||c(T,y,I),p[e]=I,d)if(A={values:w("values"),keys:_?I:w("keys"),entries:w("entries")},m)for(E in A)!v&&!S&&E in T||s(T,E,A[E]);else n({target:e,proto:!0,forced:v||S},A);return A}},function(t,e,r){"use strict";var n,o,i,a=r(50),u=r(9),c=r(8),s=r(4),f=r(42),l=s("iterator"),p=!1;[].keys&&("next"in(i=[].keys())?(o=a(a(i)))!==Object.prototype&&(n=o):p=!0),null==n&&(n={}),f||c(n,l)||u(n,l,function(){return this}),t.exports={IteratorPrototype:n,BUGGY_SAFARI_ITERATORS:p}},function(t,e,r){var n=r(3);t.exports=!n(function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype})},function(t,e,r){var n=r(17),o=r(23),i=function(t){return function(e,r){var i,a,u=String(o(e)),c=n(r),s=u.length;return c<0||c>=s?t?"":void 0:(i=u.charCodeAt(c))<55296||i>56319||c+1===s||(a=u.charCodeAt(c+1))<56320||a>57343?t?u.charAt(c):i:t?u.slice(c,c+2):a-56320+(i-55296<<10)+65536}};t.exports={codeAt:i(!1),charAt:i(!0)}},function(t,e,r){var n=r(4),o=r(36),i=n("iterator"),a=Array.prototype;t.exports=function(t){return void 0!==t&&(o.Array===t||a[i]===t)}},function(t,e,r){var n=r(51),o=r(36),i=r(4)("iterator");t.exports=function(t){if(null!=t)return t[i]||t["@@iterator"]||o[n(t)]}},function(t,e,r){var n=r(4)("iterator"),o=!1;try{var i=0,a={next:function(){return{done:!!i++}},return:function(){o=!0}};a[n]=function(){return this},Array.from(a,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var r=!1;try{var i={};i[n]=function(){return{next:function(){return{done:r=!0}}}},t(i)}catch(t){}return r}},function(t,e,r){"use strict";var n=r(10);t.exports=function(){var t=n(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,r){"use strict";var n=r(13),o=r(10),i=r(3),a=r(86),u=RegExp.prototype,c=u.toString,s=i(function(){return"/a/b"!=c.call({source:"a",flags:"b"})}),f="toString"!=c.name;(s||f)&&n(RegExp.prototype,"toString",function(){var t=o(this),e=String(t.source),r=t.flags;return"/"+e+"/"+String(void 0===r&&t instanceof RegExp&&!("flags"in u)?a.call(t):r)},{unsafe:!0})},function(t,e,r){"use strict";var n=r(9),o=r(13),i=r(3),a=r(4),u=r(52),c=a("species"),s=!i(function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}),f=!i(function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var r="ab".split(t);return 2!==r.length||"a"!==r[0]||"b"!==r[1]});t.exports=function(t,e,r,l){var p=a(t),d=!i(function(){var e={};return e[p]=function(){return 7},7!=""[t](e)}),h=d&&!i(function(){var e=!1,r=/a/;return r.exec=function(){return e=!0,null},"split"===t&&(r.constructor={},r.constructor[c]=function(){return r}),r[p](""),!e});if(!d||!h||"replace"===t&&!s||"split"===t&&!f){var v=/./[p],y=r(p,""[t],function(t,e,r,n,o){return e.exec===u?d&&!o?{done:!0,value:v.call(e,r,n)}:{done:!0,value:t.call(r,e,n)}:{done:!1}}),g=y[0],_=y[1];o(String.prototype,t,g),o(RegExp.prototype,p,2==e?function(t,e){return _.call(t,this,e)}:function(t){return _.call(t,this)}),l&&n(RegExp.prototype[p],"sham",!0)}}},function(t,e,r){"use strict";var n=r(82).charAt;t.exports=function(t,e,r){return e+(r?n(t,e).length:1)}},function(t,e,r){var n=r(22),o=r(52);t.exports=function(t,e){var r=t.exec;if("function"==typeof r){var i=r.call(t,e);if("object"!=typeof i)throw TypeError("RegExp exec method returned something other than an Object or null");return i}if("RegExp"!==n(t))throw TypeError("RegExp#exec called on incompatible receiver");return o.call(t,e)}},function(t,e,r){r(2)({target:"Array",stat:!0},{isArray:r(57)})},function(t,e,r){var n=r(2),o=r(123).entries;n({target:"Object",stat:!0},{entries:function(t){return o(t)}})},function(t,e,r){"use strict";var n=r(88),o=r(10),i=r(12),a=r(6),u=r(17),c=r(23),s=r(89),f=r(90),l=Math.max,p=Math.min,d=Math.floor,h=/\$([$&'`]|\d\d?|<[^>]*>)/g,v=/\$([$&'`]|\d\d?)/g;n("replace",2,function(t,e,r){return[function(r,n){var o=c(this),i=null==r?void 0:r[t];return void 0!==i?i.call(r,o,n):e.call(String(o),r,n)},function(t,i){var c=r(e,t,this,i);if(c.done)return c.value;var d=o(t),h=String(this),v="function"==typeof i;v||(i=String(i));var y=d.global;if(y){var g=d.unicode;d.lastIndex=0}for(var _=[];;){var m=f(d,h);if(null===m)break;if(_.push(m),!y)break;""===String(m[0])&&(d.lastIndex=s(h,a(d.lastIndex),g))}for(var b,A="",E=0,w=0;w<_.length;w++){m=_[w];for(var x=String(m[0]),S=l(p(u(m.index),h.length),0),T=[],O=1;O<m.length;O++)T.push(void 0===(b=m[O])?b:String(b));var I=m.groups;if(v){var k=[x].concat(T,S,h);void 0!==I&&k.push(I);var M=String(i.apply(void 0,k))}else M=n(x,h,S,T,I,i);S>=E&&(A+=h.slice(E,S)+M,E=S+x.length)}return A+h.slice(E)}];function n(t,r,n,o,a,u){var c=n+t.length,s=o.length,f=v;return void 0!==a&&(a=i(a),f=h),e.call(u,f,function(e,i){var u;switch(i.charAt(0)){case"$":return"$";case"&":return t;case"`":return r.slice(0,n);case"'":return r.slice(c);case"<":u=a[i.slice(1,-1)];break;default:var f=+i;if(0===f)return e;if(f>s){var l=d(f/10);return 0===l?e:l<=s?void 0===o[l-1]?i.charAt(1):o[l-1]+i.charAt(1):e}u=o[f-1]}return void 0===u?"":u})}})},function(t,e){t.exports=function(t,e,r){if(!(t instanceof e))throw TypeError("Incorrect "+(r?r+" ":"")+"invocation");return t}},function(t,e,r){var n=r(17),o=r(6);t.exports=function(t){if(void 0===t)return 0;var e=n(t),r=o(e);if(e!==r)throw RangeError("Wrong length or index");return r}},function(t,e,r){"use strict";var n=r(12),o=r(35),i=r(6);t.exports=function(t){for(var e=n(this),r=i(e.length),a=arguments.length,u=o(a>1?arguments[1]:void 0,r),c=a>2?arguments[2]:void 0,s=void 0===c?r:o(c,r);s>u;)e[u++]=t;return e}},function(t,e,r){"use strict";var n=r(46),o=r(7),i=r(4),a=r(5),u=i("species");t.exports=function(t){var e=n(t),r=o.f;a&&e&&!e[u]&&r(e,u,{configurable:!0,get:function(){return this}})}},function(t,e,r){var n=r(17);t.exports=function(t,e){var r=n(t);if(r<0||r%e)throw RangeError("Wrong offset");return r}},function(t,e,r){var n=r(59),o=r(12),i=r(41),a=r(6),u=function(t){return function(e,r,u,c){n(r);var s=o(e),f=i(s),l=a(s.length),p=t?l-1:0,d=t?-1:1;if(u<2)for(;;){if(p in f){c=f[p],p+=d;break}if(p+=d,t?p<0:l<=p)throw TypeError("Reduce of empty array with no initial value")}for(;t?p>=0:l>p;p+=d)p in f&&(c=r(c,f[p],p,s));return c}};t.exports={left:u(!1),right:u(!0)}},function(t,e){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(t){"object"==typeof window&&(r=window)}t.exports=r},function(t,e,r){var n=r(1),o=r(70),i=n.WeakMap;t.exports="function"==typeof i&&/native code/.test(o.call(i))},function(t,e,r){var n=r(46),o=r(26),i=r(74),a=r(10);t.exports=n("Reflect","ownKeys")||function(t){var e=o.f(a(t)),r=i.f;return r?e.concat(r(t)):e}},function(t,e,r){var n=r(5),o=r(7),i=r(10),a=r(48);t.exports=n?Object.defineProperties:function(t,e){i(t);for(var r,n=a(e),u=n.length,c=0;u>c;)o.f(t,r=n[c++],e[r]);return t}},function(t,e,r){var n=r(46);t.exports=n("document","documentElement")},function(t,e,r){var n=r(14),o=r(26).f,i={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return a&&"[object Window]"==i.call(t)?function(t){try{return o(t)}catch(t){return a.slice()}}(t):o(n(t))}},function(t,e,r){var n=r(11),o=r(57),i=r(4)("species");t.exports=function(t,e){var r;return o(t)&&("function"!=typeof(r=t.constructor)||r!==Array&&!o(r.prototype)?n(r)&&null===(r=r[i])&&(r=void 0):r=void 0),new(void 0===r?Array:r)(0===e?0:e)}},function(t,e,r){var n=r(4),o=r(27),i=r(9),a=n("unscopables"),u=Array.prototype;null==u[a]&&i(u,a,o(null)),t.exports=function(t){u[a][t]=!0}},function(t,e,r){"use strict";var n=r(80).IteratorPrototype,o=r(27),i=r(21),a=r(49),u=r(36),c=function(){return this};t.exports=function(t,e,r){var s=e+" Iterator";return t.prototype=o(n,{next:i(1,r)}),a(t,s,!1,!0),u[s]=c,t}},function(t,e,r){var n=r(11);t.exports=function(t){if(!n(t)&&null!==t)throw TypeError("Can't set "+String(t)+" as a prototype");return t}},function(t,e,r){r(2)({target:"Object",stat:!0,sham:!r(5)},{create:r(27)})},function(t,e,r){var n=r(2),o=r(3),i=r(12),a=r(50),u=r(81);n({target:"Object",stat:!0,forced:o(function(){a(1)}),sham:!u},{getPrototypeOf:function(t){return a(i(t))}})},function(t,e,r){r(2)({target:"Object",stat:!0},{setPrototypeOf:r(37)})},function(t,e,r){"use strict";var n=r(51),o={};o[r(4)("toStringTag")]="z",t.exports="[object z]"!==String(o)?function(){return"[object "+n(this)+"]"}:o.toString},function(t,e){t.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}},function(t,e,r){var n=function(t){"use strict";var e,r=Object.prototype,n=r.hasOwnProperty,o="function"==typeof Symbol?Symbol:{},i=o.iterator||"@@iterator",a=o.asyncIterator||"@@asyncIterator",u=o.toStringTag||"@@toStringTag";function c(t,e,r,n){var o=e&&e.prototype instanceof v?e:v,i=Object.create(o.prototype),a=new O(n||[]);return i._invoke=function(t,e,r){var n=f;return function(o,i){if(n===p)throw new Error("Generator is already running");if(n===d){if("throw"===o)throw i;return k()}for(r.method=o,r.arg=i;;){var a=r.delegate;if(a){var u=x(a,r);if(u){if(u===h)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if(n===f)throw n=d,r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n=p;var c=s(t,e,r);if("normal"===c.type){if(n=r.done?d:l,c.arg===h)continue;return{value:c.arg,done:r.done}}"throw"===c.type&&(n=d,r.method="throw",r.arg=c.arg)}}}(t,r,a),i}function s(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}t.wrap=c;var f="suspendedStart",l="suspendedYield",p="executing",d="completed",h={};function v(){}function y(){}function g(){}var _={};_[i]=function(){return this};var m=Object.getPrototypeOf,b=m&&m(m(I([])));b&&b!==r&&n.call(b,i)&&(_=b);var A=g.prototype=v.prototype=Object.create(_);function E(t){["next","throw","return"].forEach(function(e){t[e]=function(t){return this._invoke(e,t)}})}function w(t){var e;this._invoke=function(r,o){function i(){return new Promise(function(e,i){!function e(r,o,i,a){var u=s(t[r],t,o);if("throw"!==u.type){var c=u.arg,f=c.value;return f&&"object"==typeof f&&n.call(f,"__await")?Promise.resolve(f.__await).then(function(t){e("next",t,i,a)},function(t){e("throw",t,i,a)}):Promise.resolve(f).then(function(t){c.value=t,i(c)},function(t){return e("throw",t,i,a)})}a(u.arg)}(r,o,e,i)})}return e=e?e.then(i,i):i()}}function x(t,r){var n=t.iterator[r.method];if(n===e){if(r.delegate=null,"throw"===r.method){if(t.iterator.return&&(r.method="return",r.arg=e,x(t,r),"throw"===r.method))return h;r.method="throw",r.arg=new TypeError("The iterator does not provide a 'throw' method")}return h}var o=s(n,t.iterator,r.arg);if("throw"===o.type)return r.method="throw",r.arg=o.arg,r.delegate=null,h;var i=o.arg;return i?i.done?(r[t.resultName]=i.value,r.next=t.nextLoc,"return"!==r.method&&(r.method="next",r.arg=e),r.delegate=null,h):i:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,h)}function S(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function T(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function O(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(S,this),this.reset(!0)}function I(t){if(t){var r=t[i];if(r)return r.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var o=-1,a=function r(){for(;++o<t.length;)if(n.call(t,o))return r.value=t[o],r.done=!1,r;return r.value=e,r.done=!0,r};return a.next=a}}return{next:k}}function k(){return{value:e,done:!0}}return y.prototype=A.constructor=g,g.constructor=y,g[u]=y.displayName="GeneratorFunction",t.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===y||"GeneratorFunction"===(e.displayName||e.name))},t.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,g):(t.__proto__=g,u in t||(t[u]="GeneratorFunction")),t.prototype=Object.create(A),t},t.awrap=function(t){return{__await:t}},E(w.prototype),w.prototype[a]=function(){return this},t.AsyncIterator=w,t.async=function(e,r,n,o){var i=new w(c(e,r,n,o));return t.isGeneratorFunction(r)?i:i.next().then(function(t){return t.done?t.value:i.next()})},E(A),A[u]="Generator",A[i]=function(){return this},A.toString=function(){return"[object Generator]"},t.keys=function(t){var e=[];for(var r in t)e.push(r);return e.reverse(),function r(){for(;e.length;){var n=e.pop();if(n in t)return r.value=n,r.done=!1,r}return r.done=!0,r}},t.values=I,O.prototype={constructor:O,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=e,this.done=!1,this.delegate=null,this.method="next",this.arg=e,this.tryEntries.forEach(T),!t)for(var r in this)"t"===r.charAt(0)&&n.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=e)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var r=this;function o(n,o){return u.type="throw",u.arg=t,r.next=n,o&&(r.method="next",r.arg=e),!!o}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],u=a.completion;if("root"===a.tryLoc)return o("end");if(a.tryLoc<=this.prev){var c=n.call(a,"catchLoc"),s=n.call(a,"finallyLoc");if(c&&s){if(this.prev<a.catchLoc)return o(a.catchLoc,!0);if(this.prev<a.finallyLoc)return o(a.finallyLoc)}else if(c){if(this.prev<a.catchLoc)return o(a.catchLoc,!0)}else{if(!s)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return o(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var o=this.tryEntries[r];if(o.tryLoc<=this.prev&&n.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===t||"continue"===t)&&i.tryLoc<=e&&e<=i.finallyLoc&&(i=null);var a=i?i.completion:{};return a.type=t,a.arg=e,i?(this.method="next",this.next=i.finallyLoc,h):this.complete(a)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),h},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),T(r),h}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var o=n.arg;T(r)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(t,r,n){return this.delegate={iterator:I(t),resultName:r,nextLoc:n},"next"===this.method&&(this.arg=e),h}},t}(t.exports);try{regeneratorRuntime=n}catch(t){Function("r","regeneratorRuntime = r")(n)}},function(t,e,r){var n=r(2),o=r(117);n({target:"Array",stat:!0,forced:!r(85)(function(t){Array.from(t)})},{from:o})},function(t,e,r){"use strict";var n=r(58),o=r(12),i=r(118),a=r(83),u=r(6),c=r(119),s=r(84);t.exports=function(t){var e,r,f,l,p=o(t),d="function"==typeof this?this:Array,h=arguments.length,v=h>1?arguments[1]:void 0,y=void 0!==v,g=0,_=s(p);if(y&&(v=n(v,h>2?arguments[2]:void 0,2)),null==_||d==Array&&a(_))for(r=new d(e=u(p.length));e>g;g++)c(r,g,y?v(p[g],g):p[g]);else for(l=_.call(p),r=new d;!(f=l.next()).done;g++)c(r,g,y?i(l,v,[f.value,g],!0):f.value);return r.length=g,r}},function(t,e,r){var n=r(10);t.exports=function(t,e,r,o){try{return o?e(n(r)[0],r[1]):e(r)}catch(e){var i=t.return;throw void 0!==i&&n(i.call(t)),e}}},function(t,e,r){"use strict";var n=r(24),o=r(7),i=r(21);t.exports=function(t,e,r){var a=n(e);a in t?o.f(t,a,i(0,r)):t[a]=r}},function(t,e,r){var n=r(5),o=r(7).f,i=Function.prototype,a=i.toString,u=/^\s*function ([^ (]*)/;!n||"name"in i||o(i,"name",{configurable:!0,get:function(){try{return a.call(this).match(u)[1]}catch(t){return""}}})},function(t,e,r){var n=r(11),o=r(22),i=r(4)("match");t.exports=function(t){var e;return n(t)&&(void 0!==(e=t[i])?!!e:"RegExp"==o(t))}},function(t,e,r){var n=r(46);t.exports=n("navigator","userAgent")||""},function(t,e,r){var n=r(5),o=r(48),i=r(14),a=r(54).f,u=function(t){return function(e){for(var r,u=i(e),c=o(u),s=c.length,f=0,l=[];s>f;)r=c[f++],n&&!a.call(u,r)||l.push(t?[r,u[r]]:u[r]);return l}};t.exports={entries:u(!0),values:u(!1)}},function(t,e,r){var n=r(1),o=r(64).trim,i=r(65),a=n.parseInt,u=/^[+-]?0[Xx]/,c=8!==a(i+"08")||22!==a(i+"0x16");t.exports=c?function(t,e){var r=o(String(t));return a(r,e>>>0||(u.test(r)?16:10))}:a},function(t,e,r){"use strict";var n=r(2),o=r(1),i=r(66),a=r(97),u=i.ArrayBuffer;n({global:!0,forced:o.ArrayBuffer!==u},{ArrayBuffer:u}),a("ArrayBuffer")},function(t,e,r){var n=r(13);t.exports=function(t,e,r){for(var o in e)n(t,o,e[o],r);return t}},function(t,e,r){"use strict";var n=r(2),o=r(3),i=r(66),a=r(10),u=r(35),c=r(6),s=r(32),f=i.ArrayBuffer,l=i.DataView,p=f.prototype.slice;n({target:"ArrayBuffer",proto:!0,unsafe:!0,forced:o(function(){return!new f(2).slice(1,void 0).byteLength})},{slice:function(t,e){if(void 0!==p&&void 0===e)return p.call(a(this),t);for(var r=a(this).byteLength,n=u(t,r),o=u(void 0===e?r:e,r),i=new(s(this,f))(c(o-n)),d=new l(this),h=new l(i),v=0;n<o;)h.setUint8(v++,d.getUint8(n++));return i}})},function(t,e,r){r(129)("Uint8",1,function(t){return function(e,r,n){return t(this,e,r,n)}})},function(t,e,r){"use strict";var n=r(2),o=r(1),i=r(5),a=r(130),u=r(0),c=r(66),s=r(94),f=r(21),l=r(9),p=r(6),d=r(95),h=r(98),v=r(24),y=r(8),g=r(51),_=r(11),m=r(27),b=r(37),A=r(26).f,E=r(131),w=r(15).forEach,x=r(97),S=r(7),T=r(33),O=r(25),I=O.get,k=O.set,M=S.f,C=T.f,q=Math.round,B=o.RangeError,P=c.ArrayBuffer,F=c.DataView,R=u.NATIVE_ARRAY_BUFFER_VIEWS,D=u.TYPED_ARRAY_TAG,L=u.TypedArray,j=u.TypedArrayPrototype,U=u.aTypedArrayConstructor,W=u.isTypedArray,K=function(t,e){for(var r=0,n=e.length,o=new(U(t))(n);n>r;)o[r]=e[r++];return o},N=function(t,e){M(t,e,{get:function(){return I(this)[e]}})},G=function(t){var e;return t instanceof P||"ArrayBuffer"==(e=g(t))||"SharedArrayBuffer"==e},V=function(t,e){return W(t)&&"symbol"!=typeof e&&e in t&&String(+e)==String(e)},Y=function(t,e){return V(t,e=v(e,!0))?f(2,t[e]):C(t,e)},H=function(t,e,r){return!(V(t,e=v(e,!0))&&_(r)&&y(r,"value"))||y(r,"get")||y(r,"set")||r.configurable||y(r,"writable")&&!r.writable||y(r,"enumerable")&&!r.enumerable?M(t,e,r):(t[e]=r.value,t)};i?(R||(T.f=Y,S.f=H,N(j,"buffer"),N(j,"byteOffset"),N(j,"byteLength"),N(j,"length")),n({target:"Object",stat:!0,forced:!R},{getOwnPropertyDescriptor:Y,defineProperty:H}),t.exports=function(t,e,r,i){var u=t+(i?"Clamped":"")+"Array",c="get"+t,f="set"+t,v=o[u],y=v,g=y&&y.prototype,S={},T=function(t,r){M(t,r,{get:function(){return function(t,r){var n=I(t);return n.view[c](r*e+n.byteOffset,!0)}(this,r)},set:function(t){return function(t,r,n){var o=I(t);i&&(n=(n=q(n))<0?0:n>255?255:255&n),o.view[f](r*e+o.byteOffset,n,!0)}(this,r,t)},enumerable:!0})};R?a&&(y=r(function(t,r,n,o){return s(t,y,u),_(r)?G(r)?void 0!==o?new v(r,h(n,e),o):void 0!==n?new v(r,h(n,e)):new v(r):W(r)?K(y,r):E.call(y,r):new v(d(r))}),b&&b(y,L),w(A(v),function(t){t in y||l(y,t,v[t])}),y.prototype=g):(y=r(function(t,r,n,o){s(t,y,u);var i,a,c,f=0,l=0;if(_(r)){if(!G(r))return W(r)?K(y,r):E.call(y,r);i=r,l=h(n,e);var v=r.byteLength;if(void 0===o){if(v%e)throw B("Wrong length");if((a=v-l)<0)throw B("Wrong length")}else if((a=p(o)*e)+l>v)throw B("Wrong length");c=a/e}else c=d(r),i=new P(a=c*e);for(k(t,{buffer:i,byteOffset:l,byteLength:a,length:c,view:new F(i)});f<c;)T(t,f++)}),b&&b(y,L),g=y.prototype=m(j)),g.constructor!==y&&l(g,"constructor",y),D&&l(g,D,u),S[u]=y,n({global:!0,forced:y!=v,sham:!R},S),"BYTES_PER_ELEMENT"in y||l(y,"BYTES_PER_ELEMENT",e),"BYTES_PER_ELEMENT"in g||l(g,"BYTES_PER_ELEMENT",e),x(u)}):t.exports=function(){}},function(t,e,r){var n=r(1),o=r(3),i=r(85),a=r(0).NATIVE_ARRAY_BUFFER_VIEWS,u=n.ArrayBuffer,c=n.Int8Array;t.exports=!a||!o(function(){c(1)})||!o(function(){new c(-1)})||!i(function(t){new c,new c(null),new c(1.5),new c(t)},!0)||o(function(){return 1!==new c(new u(2),1,void 0).length})},function(t,e,r){var n=r(12),o=r(6),i=r(84),a=r(83),u=r(58),c=r(0).aTypedArrayConstructor;t.exports=function(t){var e,r,s,f,l,p=n(t),d=arguments.length,h=d>1?arguments[1]:void 0,v=void 0!==h,y=i(p);if(null!=y&&!a(y))for(l=y.call(p),p=[];!(f=l.next()).done;)p.push(f.value);for(v&&d>2&&(h=u(h,arguments[2],2)),r=o(p.length),s=new(c(this))(r),e=0;r>e;e++)s[e]=v?h(p[e],e):p[e];return s}},function(t,e,r){"use strict";var n=r(0),o=r(133),i=n.aTypedArray;n.exportProto("copyWithin",function(t,e){return o.call(i(this),t,e,arguments.length>2?arguments[2]:void 0)})},function(t,e,r){"use strict";var n=r(12),o=r(35),i=r(6),a=Math.min;t.exports=[].copyWithin||function(t,e){var r=n(this),u=i(r.length),c=o(t,u),s=o(e,u),f=arguments.length>2?arguments[2]:void 0,l=a((void 0===f?u:o(f,u))-s,u-c),p=1;for(s<c&&c<s+l&&(p=-1,s+=l-1,c+=l-1);l-- >0;)s in r?r[c]=r[s]:delete r[c],c+=p,s+=p;return r}},function(t,e,r){"use strict";var n=r(0),o=r(15).every,i=n.aTypedArray;n.exportProto("every",function(t){return o(i(this),t,arguments.length>1?arguments[1]:void 0)})},function(t,e,r){"use strict";var n=r(0),o=r(96),i=n.aTypedArray;n.exportProto("fill",function(t){return o.apply(i(this),arguments)})},function(t,e,r){"use strict";var n=r(0),o=r(15).filter,i=r(32),a=n.aTypedArray,u=n.aTypedArrayConstructor;n.exportProto("filter",function(t){for(var e=o(a(this),t,arguments.length>1?arguments[1]:void 0),r=i(this,this.constructor),n=0,c=e.length,s=new(u(r))(c);c>n;)s[n]=e[n++];return s})},function(t,e,r){"use strict";var n=r(0),o=r(15).find,i=n.aTypedArray;n.exportProto("find",function(t){return o(i(this),t,arguments.length>1?arguments[1]:void 0)})},function(t,e,r){"use strict";var n=r(0),o=r(15).findIndex,i=n.aTypedArray;n.exportProto("findIndex",function(t){return o(i(this),t,arguments.length>1?arguments[1]:void 0)})},function(t,e,r){"use strict";var n=r(0),o=r(15).forEach,i=n.aTypedArray;n.exportProto("forEach",function(t){o(i(this),t,arguments.length>1?arguments[1]:void 0)})},function(t,e,r){"use strict";var n=r(0),o=r(47).includes,i=n.aTypedArray;n.exportProto("includes",function(t){return o(i(this),t,arguments.length>1?arguments[1]:void 0)})},function(t,e,r){"use strict";var n=r(0),o=r(47).indexOf,i=n.aTypedArray;n.exportProto("indexOf",function(t){return o(i(this),t,arguments.length>1?arguments[1]:void 0)})},function(t,e,r){"use strict";var n=r(1),o=r(0),i=r(16),a=r(4)("iterator"),u=n.Uint8Array,c=i.values,s=i.keys,f=i.entries,l=o.aTypedArray,p=o.exportProto,d=u&&u.prototype[a],h=!!d&&("values"==d.name||null==d.name),v=function(){return c.call(l(this))};p("entries",function(){return f.call(l(this))}),p("keys",function(){return s.call(l(this))}),p("values",v,!h),p(a,v,!h)},function(t,e,r){"use strict";var n=r(0),o=n.aTypedArray,i=[].join;n.exportProto("join",function(t){return i.apply(o(this),arguments)})},function(t,e,r){"use strict";var n=r(0),o=r(145),i=n.aTypedArray;n.exportProto("lastIndexOf",function(t){return o.apply(i(this),arguments)})},function(t,e,r){"use strict";var n=r(14),o=r(17),i=r(6),a=r(60),u=Math.min,c=[].lastIndexOf,s=!!c&&1/[1].lastIndexOf(1,-0)<0,f=a("lastIndexOf");t.exports=s||f?function(t){if(s)return c.apply(this,arguments)||0;var e=n(this),r=i(e.length),a=r-1;for(arguments.length>1&&(a=u(a,o(arguments[1]))),a<0&&(a=r+a);a>=0;a--)if(a in e&&e[a]===t)return a||0;return-1}:c},function(t,e,r){"use strict";var n=r(0),o=r(15).map,i=r(32),a=n.aTypedArray,u=n.aTypedArrayConstructor;n.exportProto("map",function(t){return o(a(this),t,arguments.length>1?arguments[1]:void 0,function(t,e){return new(u(i(t,t.constructor)))(e)})})},function(t,e,r){"use strict";var n=r(0),o=r(99).left,i=n.aTypedArray;n.exportProto("reduce",function(t){return o(i(this),t,arguments.length,arguments.length>1?arguments[1]:void 0)})},function(t,e,r){"use strict";var n=r(0),o=r(99).right,i=n.aTypedArray;n.exportProto("reduceRight",function(t){return o(i(this),t,arguments.length,arguments.length>1?arguments[1]:void 0)})},function(t,e,r){"use strict";var n=r(0),o=n.aTypedArray,i=Math.floor;n.exportProto("reverse",function(){for(var t,e=o(this).length,r=i(e/2),n=0;n<r;)t=this[n],this[n++]=this[--e],this[e]=t;return this})},function(t,e,r){"use strict";var n=r(0),o=r(6),i=r(98),a=r(12),u=r(3),c=n.aTypedArray,s=u(function(){new Int8Array(1).set({})});n.exportProto("set",function(t){c(this);var e=i(arguments.length>1?arguments[1]:void 0,1),r=this.length,n=a(t),u=o(n.length),s=0;if(u+e>r)throw RangeError("Wrong length");for(;s<u;)this[e+s]=n[s++]},s)},function(t,e,r){"use strict";var n=r(0),o=r(32),i=r(3),a=n.aTypedArray,u=n.aTypedArrayConstructor,c=[].slice,s=i(function(){new Int8Array(1).slice()});n.exportProto("slice",function(t,e){for(var r=c.call(a(this),t,e),n=o(this,this.constructor),i=0,s=r.length,f=new(u(n))(s);s>i;)f[i]=r[i++];return f},s)},function(t,e,r){"use strict";var n=r(0),o=r(15).some,i=n.aTypedArray;n.exportProto("some",function(t){return o(i(this),t,arguments.length>1?arguments[1]:void 0)})},function(t,e,r){"use strict";var n=r(0),o=n.aTypedArray,i=[].sort;n.exportProto("sort",function(t){return i.call(o(this),t)})},function(t,e,r){"use strict";var n=r(0),o=r(6),i=r(35),a=r(32),u=n.aTypedArray;n.exportProto("subarray",function(t,e){var r=u(this),n=r.length,c=i(t,n);return new(a(r,r.constructor))(r.buffer,r.byteOffset+c*r.BYTES_PER_ELEMENT,o((void 0===e?n:i(e,n))-c))})},function(t,e,r){"use strict";var n=r(1),o=r(0),i=r(3),a=n.Int8Array,u=o.aTypedArray,c=[].toLocaleString,s=[].slice,f=!!a&&i(function(){c.call(new a(1))}),l=i(function(){return[1,2].toLocaleString()!=new a([1,2]).toLocaleString()})||!i(function(){a.prototype.toLocaleString.call([1,2])});o.exportProto("toLocaleString",function(){return c.apply(f?s.call(u(this)):u(this),arguments)},l)},function(t,e,r){"use strict";var n=r(1),o=r(0),i=r(3),a=n.Uint8Array,u=a&&a.prototype,c=[].toString,s=[].join;i(function(){c.call({})})&&(c=function(){return s.call(this)}),o.exportProto("toString",c,(u||{}).toString!=c)},function(t,e,r){"use strict";var n=r(2),o=r(41),i=r(14),a=r(60),u=[].join,c=o!=Object,s=a("join",",");n({target:"Array",proto:!0,forced:c||s},{join:function(t){return u.call(i(this),void 0===t?",":t)}})},function(t,e,r){r(2)({target:"Date",stat:!0},{now:function(){return(new Date).getTime()}})},function(t,e,r){"use strict";var n=r(5),o=r(1),i=r(75),a=r(13),u=r(8),c=r(22),s=r(160),f=r(24),l=r(3),p=r(27),d=r(26).f,h=r(33).f,v=r(7).f,y=r(64).trim,g=o.Number,_=g.prototype,m="Number"==c(p(_)),b=function(t){var e,r,n,o,i,a,u,c,s=f(t,!1);if("string"==typeof s&&s.length>2)if(43===(e=(s=y(s)).charCodeAt(0))||45===e){if(88===(r=s.charCodeAt(2))||120===r)return NaN}else if(48===e){switch(s.charCodeAt(1)){case 66:case 98:n=2,o=49;break;case 79:case 111:n=8,o=55;break;default:return+s}for(a=(i=s.slice(2)).length,u=0;u<a;u++)if((c=i.charCodeAt(u))<48||c>o)return NaN;return parseInt(i,n)}return+s};if(i("Number",!g(" 0o1")||!g("0b1")||g("+0x1"))){for(var A,E=function(t){var e=arguments.length<1?0:t,r=this;return r instanceof E&&(m?l(function(){_.valueOf.call(r)}):"Number"!=c(r))?s(new g(b(e)),r,E):b(e)},w=n?d(g):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;w.length>x;x++)u(g,A=w[x])&&!u(E,A)&&v(E,A,h(g,A));E.prototype=_,_.constructor=E,a(o,"Number",E)}},function(t,e,r){var n=r(11),o=r(37);t.exports=function(t,e,r){var i,a;return o&&"function"==typeof(i=e.constructor)&&i!==r&&n(a=i.prototype)&&a!==r.prototype&&o(t,a),t}},function(t,e,r){r(2)({target:"Number",stat:!0},{isNaN:function(t){return t!=t}})},function(t,e,r){var n=r(2),o=r(163);n({global:!0,forced:parseFloat!=o},{parseFloat:o})},function(t,e,r){var n=r(1),o=r(64).trim,i=r(65),a=n.parseFloat,u=1/a(i+"-0")!=-1/0;t.exports=u?function(t){var e=o(String(t)),r=a(e);return 0===r&&"-"==e.charAt(0)?-0:r}:a},function(t,e,r){"use strict";r.r(e);var n={};r.r(n),r.d(n,"api",function(){return v}),r.d(n,"shared_root_info",function(){return y}),r.d(n,"connect",function(){return x}),r.d(n,"send",function(){return S}),r.d(n,"setController",function(){return T}),r.d(n,"pitchBend",function(){return O}),r.d(n,"setEffects",function(){return I}),r.d(n,"getContext",function(){return k}),r.d(n,"setContext",function(){return M}),r.d(n,"playChannel",function(){return C}),r.d(n,"stopChannel",function(){return q}),r.d(n,"setVolume",function(){return B}),r.d(n,"programChange",function(){return P}),r.d(n,"noteOn",function(){return F}),r.d(n,"noteOff",function(){return R}),r.d(n,"chordOn",function(){return D}),r.d(n,"chordOff",function(){return L}),r.d(n,"stopAllNotes",function(){return j});var o={};r.r(o),r.d(o,"api",function(){return G}),r.d(o,"shared_root_info",function(){return V}),r.d(o,"connect",function(){return X}),r.d(o,"playChannel",function(){return Q}),r.d(o,"stopChannel",function(){return z}),r.d(o,"send",function(){return $}),r.d(o,"setController",function(){return tt}),r.d(o,"setVolume",function(){return et}),r.d(o,"programChange",function(){return rt}),r.d(o,"pitchBend",function(){return nt}),r.d(o,"noteOn",function(){return ot}),r.d(o,"noteOff",function(){return it}),r.d(o,"chordOn",function(){return at}),r.d(o,"chordOff",function(){return ut}),r.d(o,"stopAllNotes",function(){return ct}),r.d(o,"setEffects",function(){return st}),r.d(o,"getContext",function(){return ft}),r.d(o,"setContext",function(){return lt}),r.d(o,"loadAudio",function(){return pt}),r.d(o,"createAudioContext",function(){return dt});var i={};r.r(i),r.d(i,"api",function(){return ht}),r.d(i,"shared_root_info",function(){return vt}),r.d(i,"connect",function(){return gt}),r.d(i,"playChannel",function(){return _t}),r.d(i,"stopChannel",function(){return mt}),r.d(i,"setEffects",function(){return bt}),r.d(i,"getContext",function(){return At}),r.d(i,"setContext",function(){return Et}),r.d(i,"send",function(){return wt}),r.d(i,"setController",function(){return xt}),r.d(i,"setVolume",function(){return St}),r.d(i,"programChange",function(){return Tt}),r.d(i,"pitchBend",function(){return Ot}),r.d(i,"noteOn",function(){return It}),r.d(i,"noteOff",function(){return kt}),r.d(i,"chordOn",function(){return Mt}),r.d(i,"chordOff",function(){return Ct}),r.d(i,"stopAllNotes",function(){return qt});var a={};r.r(a),r.d(a,"data",function(){return Nt}),r.d(a,"map",function(){return Gt});r(20),r(28),r(29),r(16),r(110),r(38),r(111),r(112),r(18),r(19),r(30),r(115),r(116),r(39),r(61),r(120),r(31),r(87),r(53),r(40);var u={},c=0,s=function(t){c+=1;var e=document.body,r=new Audio,n=t.split(";")[0];r.id="audio",r.setAttribute("preload","auto"),r.setAttribute("audiobuffer","true"),r.addEventListener("error",function(){e.removeChild(r),u[n]=!1,c-=1},!1),r.addEventListener("canplaythrough",function(){e.removeChild(r),u[n]=!0,c-=1},!1),r.src="data:"+t,e.appendChild(r)};r(62),r(91),r(92),r(63),r(93);function f(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var r=[],n=!0,o=!1,i=void 0;try{for(var a,u=t[Symbol.iterator]();!(n=(a=u.next()).done)&&(r.push(a.value),!e||r.length!==e);n=!0);}catch(t){o=!0,i=t}finally{try{n||null==u.return||u.return()}finally{if(o)throw i}}return r}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}var l=function(t){for(var e=function(t){return t.replace(/[^a-z0-9 ]/gi,"").replace(/[ ]/g,"_").toLowerCase()},r={byName:{},byId:{},byCategory:{}},n=0,o=Object.entries(t);n<o.length;n++){var i=f(o[n],2),a=i[0],u=i[1],c=!0,s=!1,l=void 0;try{for(var p,d=u[Symbol.iterator]();!(c=(p=d.next()).done);c=!0){var h=p.value;if(h){var v=parseInt(h.substr(0,h.indexOf(" ")),10),y=v-1,g=h.replace(v+" ",""),_=e(g),m=e(a),b={id:_,name:g,program:y,category:a};r.byId[y]=b,r.byName[_]=b,r.byCategory[m]=r.byCategory[m]||[],r.byCategory[m].push(b)}}}catch(t){s=!0,l=t}finally{try{c||null==d.return||d.return()}finally{if(s)throw l}}}return r}({Piano:["1 Acoustic Grand Piano","2 Bright Acoustic Piano","3 Electric Grand Piano","4 Honky-tonk Piano","5 Electric Piano 1","6 Electric Piano 2","7 Harpsichord","8 Clavinet"],"Chromatic Percussion":["9 Celesta","10 Glockenspiel","11 Music Box","12 Vibraphone","13 Marimba","14 Xylophone","15 Tubular Bells","16 Dulcimer"],Organ:["17 Drawbar Organ","18 Percussive Organ","19 Rock Organ","20 Church Organ","21 Reed Organ","22 Accordion","23 Harmonica","24 Tango Accordion"],Guitar:["25 Acoustic Guitar (nylon)","26 Acoustic Guitar (steel)","27 Electric Guitar (jazz)","28 Electric Guitar (clean)","29 Electric Guitar (muted)","30 Overdriven Guitar","31 Distortion Guitar","32 Guitar Harmonics"],Bass:["33 Acoustic Bass","34 Electric Bass (finger)","35 Electric Bass (pick)","36 Fretless Bass","37 Slap Bass 1","38 Slap Bass 2","39 Synth Bass 1","40 Synth Bass 2"],Strings:["41 Violin","42 Viola","43 Cello","44 Contrabass","45 Tremolo Strings","46 Pizzicato Strings","47 Orchestral Harp","48 Timpani"],Ensemble:["49 String Ensemble 1","50 String Ensemble 2","51 Synth Strings 1","52 Synth Strings 2","53 Choir Aahs","54 Voice Oohs","55 Synth Choir","56 Orchestra Hit"],Brass:["57 Trumpet","58 Trombone","59 Tuba","60 Muted Trumpet","61 French Horn","62 Brass Section","63 Synth Brass 1","64 Synth Brass 2"],Reed:["65 Soprano Sax","66 Alto Sax","67 Tenor Sax","68 Baritone Sax","69 Oboe","70 English Horn","71 Bassoon","72 Clarinet"],Pipe:["73 Piccolo","74 Flute","75 Recorder","76 Pan Flute","77 Blown Bottle","78 Shakuhachi","79 Whistle","80 Ocarina"],"Synth Lead":["81 Lead 1 (square)","82 Lead 2 (sawtooth)","83 Lead 3 (calliope)","84 Lead 4 (chiff)","85 Lead 5 (charang)","86 Lead 6 (voice)","87 Lead 7 (fifths)","88 Lead 8 (bass + lead)"],"Synth Pad":["89 Pad 1 (new age)","90 Pad 2 (warm)","91 Pad 3 (polysynth)","92 Pad 4 (choir)","93 Pad 5 (bowed)","94 Pad 6 (metallic)","95 Pad 7 (halo)","96 Pad 8 (sweep)"],"Synth Effects":["97 FX 1 (rain)","98 FX 2 (soundtrack)","99 FX 3 (crystal)","100 FX 4 (atmosphere)","101 FX 5 (brightness)","102 FX 6 (goblins)","103 FX 7 (echoes)","104 FX 8 (sci-fi)"],Ethnic:["105 Sitar","106 Banjo","107 Shamisen","108 Koto","109 Kalimba","110 Bagpipe","111 Fiddle","112 Shanai"],Percussive:["113 Tinkle Bell","114 Agogo","115 Steel Drums","116 Woodblock","117 Taiko Drum","118 Melodic Tom","119 Synth Drum"],"Sound effects":["120 Reverse Cymbal","121 Guitar Fret Noise","122 Breath Noise","123 Seashore","124 Bird Tweet","125 Telephone Ring","126 Helicopter","127 Applause","128 Gunshot"]}),p=function(){for(var t={},e=0;e<16;e++)t[e]={program:e,pitchBend:0,mute:!1,mono:!1,omni:!1,solo:!1};return t}(),d={},h={};!function(){for(var t=["C","Db","D","Eb","E","F","Gb","G","Ab","A","Bb","B"],e=21;e<=108;e++){var r=Math.floor((e-12)/12),n=t[e%12]+r;d[n]=e,h[e]=n}}();for(var v="audiotag",y={},g=[],_=0;_<16;_++)g[_]=127;for(var m=-1,b=[],A={},E=[],w=0;w<12;w++)E[w]=new Audio;var x=function(t){for(var e=0,r=Object.keys(d);e<r.length;e++){var n=r[e];A[n]={id:n}}t.onsuccess&&t.onsuccess()},S=function(t,e){},T=function(t,e,r,n){},O=function(t,e,r){},I=function(){},k=function(){},M=function(){},C=function(t,e){if(p[t]){var r=p[t].program,n=l.byId[r].id,o=A[e];if(o){var i=n+""+o.id,a=(m+1)%E.length,u=E[a];if(b[a]=i,!y.Soundfont[n])return void 0;u.src=y.Soundfont[n][o.id],u.volume=g[t]/127,u.play(),m=a}}},q=function(t,e){if(p[t]){var r=p[t].program,n=l.byId[r].id,o=A[e];if(o)for(var i=n+""+o.id,a=0,u=E.length;a<u;a++){var c=(a+m+1)%u,s=b[c];if(s&&s===i)return E[c].pause(),void(b[c]=null)}}},B=function(t,e){g[t]=e},P=function(t,e){p[t].instrument=e},F=function(t,e,r,n){var o=h[e];return!!A[o]&&(n?setTimeout(function(){g[t]=r,C(t,o)},1e3*n):(g[t]=r,C(t,o),!0))},R=function(t,e,r){},D=function(t,e,r,n){for(var o=function(r){var o=e[r],i=h[o];if(!A[i])return"continue";n?setTimeout(function(){C(t,i)},1e3*n):C(t,i)},i=0;i<e.length;i++)o(i)},L=function(t,e,r){for(var n=function(n){var o=e[n],i=h[o];if(!A[i])return"continue";r?setTimeout(function(){q(t,i)},1e3*r):q(t,i)},o=0;o<e.length;o++)n(o)},j=function(){for(var t=0,e=E.length;t<e;t++)E[t].pause()},U=(r(125),r(127),r(128),r(132),r(134),r(135),r(136),r(137),r(138),r(139),r(140),r(141),r(142),r(143),r(144),r(146),r(147),r(148),r(149),r(150),r(151),r(152),r(153),r(154),r(155),r(156),"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=");function W(t){var e=Math.ceil(3*t.length/4),r=new ArrayBuffer(e);return function(t,e){var r,n,o,i,a,u,c,s,f=U.indexOf(t.charAt(t.length-1)),l=U.indexOf(t.charAt(t.length-1)),p=Math.ceil(3*t.length/4);64===f&&p--;64===l&&p--;var d=0;r=e?new Uint8Array(e):new Uint8Array(p);t=t.replace(/[^A-Za-z0-9+\/=]/g,"");for(var h=0;h<p;h+=3)a=U.indexOf(t.charAt(d++)),u=U.indexOf(t.charAt(d++)),c=U.indexOf(t.charAt(d++)),s=U.indexOf(t.charAt(d++)),n=a<<2|u>>4,o=(15&u)<<4|c>>2,i=(3&c)<<6|s,r[h]=n,64!==c&&(r[h+1]=o),64!==s&&(r[h+2]=i)}(t,r),r}function K(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var r=[],n=!0,o=!1,i=void 0;try{for(var a,u=t[Symbol.iterator]();!(n=(a=u.next()).done)&&(r.push(a.value),!e||r.length!==e);n=!0);}catch(t){o=!0,i=t}finally{try{n||null==u.return||u.return()}finally{if(o)throw i}}return r}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}var N,G="webaudio",V={},Y={},H={},J=127,Z={},X=function(t){lt(N||dt(),t.onsuccess)},Q=function(){},z=function(){},$=function(t,e){},tt=function(t,e,r,n){},et=function(t,e,r){r?setTimeout(function(){J=e},1e3*r):J=e},rt=function(t,e,r){var n=p[t];n&&(n.program=e)},nt=function(t,e,r){var n=p[t];n&&(r?setTimeout(function(){n.pitchBend=e},r):n.pitchBend=e)},ot=function(t,e,r){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,o=p[t],i=o.program,a=i+"x"+e,u=Z[a];if(u&&N){var c;if(n<N.currentTime&&(n+=N.currentTime),(c=N.createBufferSource()).buffer=u,H)for(var s=c,f=0,l=Object.keys(H);f<l.length;f++){var d=l[f];s.connect(H[d].input),s=H[d]}var h=r/127*(J/127)*2-1;return c.connect(N.destination),c.playbackRate.value=1,c.gainNode=N.createGain(),c.gainNode.connect(N.destination),c.gainNode.gain.value=Math.min(1,Math.max(-1,h)),c.connect(c.gainNode),c.start(n||0),Y[t+"x"+e]=c,c}},it=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,n=p[t],o=n.program,i=o+"x"+e,a=Z[i];if(N&&a){r<N.currentTime&&(r+=N.currentTime);var u=Y[t+"x"+e];if(u){if(u.gainNode){var c=u.gainNode.gain;c.linearRampToValueAtTime(c.value,r),c.linearRampToValueAtTime(-1,r+.3)}return u.noteOff?u.noteOff(r+.5):u.stop(r+.5),delete Y[t+"x"+e],u}}},at=function(t,e,r,n){var o={},i=!0,a=!1,u=void 0;try{for(var c,s=e[Symbol.iterator]();!(i=(c=s.next()).done);i=!0){var f=c.value;o[f]=ot(t,f,r,n)}}catch(t){a=!0,u=t}finally{try{i||null==s.return||s.return()}finally{if(a)throw u}}return o},ut=function(t,e,r){var n={},o=!0,i=!1,a=void 0;try{for(var u,c=e[Symbol.iterator]();!(o=(u=c.next()).done);o=!0){var s=u.value;n[s]=it(t,s,r)}}catch(t){i=!0,a=t}finally{try{o||null==c.return||c.return()}finally{if(i)throw a}}return n},ct=function(){if(N)for(var t=0,e=Object.keys(Y);t<e.length;t++){var r=e[t],n=0;n<N.currentTime&&(n+=N.currentTime);var o=Y[r];o.gain.linearRampToValueAtTime(1,n),o.gain.linearRampToValueAtTime(0,n+.3),o.noteOff?o.noteOff(n+.3):o.stop(n+.3),delete Y[r]}},st=function(t){if(N&&N.tunajs){var e=!0,r=!1,n=void 0;try{for(var o,i=t[Symbol.iterator]();!(e=(o=i.next()).done);e=!0){var a=o.value,u=new N.tunajs[a.type](a);u.connect(N.destination),H[a.type]=u}}catch(t){r=!0,n=t}finally{try{e||null==i.return||i.return()}finally{if(r)throw n}}}else console.log("Effects module not installed.")},ft=function(){return N},lt=function(t,e,r,n){N=t,"undefined"==typeof Tuna||N.tunajs instanceof Tuna||(N.tunajs=new Tuna(N));for(var o=[],i=0,a=Object.keys(d);i<a.length;i++){var u=a[i];o.push(u)}for(var c=function(t){for(var r=0,n=Object.keys(f);r<n.length;r++){var o=n[r];if(f[o])return}e&&(e(),e=null)},s=function(t,e,r,n){var o=t[n];o&&(f[e]+=1,pt(o,function(r){r.id=n;var o=d[n];if(Z[e+"x"+o]=r,f[e]-=1,0===f[e]){0,t.isLoaded=!0,c()}},function(t){console.log(t)}))},f={},p=0,h=Object.entries(V.Soundfont);p<h.length;p++){var v=K(h[p],2),y=v[0],g=v[1];if(!g.isLoaded){var _=l.byName[y];if(_){var m=_.program;f[m]=0;for(var b=0;b<o.length;b++){s(g,m,0,o[b])}}}}setTimeout(c,1)},pt=function(t,e,r){if(0===t.indexOf("data:audio")){var n=W(t.split(",")[1]);return N.decodeAudioData(n,e,r)}var o=new XMLHttpRequest;return o.open("GET",t,!0),o.responseType="arraybuffer",o.onsuccess=function(){return N.decodeAudioData(o.response,e,r)},void o.send()},dt=function(){return new(window.AudioContext||window.webkitAudioContext)},ht="webmidi",vt={},yt=null,gt=function(t){var e=function(e){console.error("Could not connect to web midi! Falling back to WebAudio:",e),vt.webaudio_backup_connect&&(vt.config.api="webaudio",vt.webaudio_backup_connect(t))};navigator.requestMIDIAccess().then(function(r){var n=r.outputs;return void 0===(yt="function"==typeof n?n()[0]:n[0])?e("No outputs defined"):t.onsuccess&&t.onsuccess()},e)},_t=function(){},mt=function(){},bt=function(){},At=function(){},Et=function(){},wt=function(t,e){yt.send(t,1e3*e)},xt=function(t,e,r,n){yt.send([t,e,r],1e3*n)},St=function(t,e,r){yt.send([176+t,7,e],1e3*r)},Tt=function(t,e,r){yt.send([192+t,e],1e3*r)},Ot=function(t,e,r){yt.send([224+t,e],1e3*r)},It=function(t,e,r,n){yt.send([144+t,e,r],1e3*n)},kt=function(t,e,r){yt.send([128+t,e,0],1e3*r)},Mt=function(t,e,r,n){var o=!0,i=!1,a=void 0;try{for(var u,c=e[Symbol.iterator]();!(o=(u=c.next()).done);o=!0){var s=u.value;yt.send([144+t,s,r],1e3*n)}}catch(t){i=!0,a=t}finally{try{o||null==c.return||c.return()}finally{if(i)throw a}}},Ct=function(t,e,r){var n=!0,o=!1,i=void 0;try{for(var a,u=e[Symbol.iterator]();!(n=(a=u.next()).done);n=!0){var c=a.value;yt.send([128+t,c,0],1e3*r)}}catch(t){o=!0,i=t}finally{try{n||null==u.return||u.return()}finally{if(o)throw i}}},qt=function(){yt.cancel();for(var t=0;t<16;t++)yt.send([176+t,123,0])};r(157),r(158),r(159),r(161);function Bt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var Pt=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.str=e,this.position=0}var e,r,n;return e=t,(r=[{key:"read",value:function(t){var e=this.str.substr(this.position,t);return this.position+=t,e}},{key:"readInt32",value:function(){var t=(this.str.charCodeAt(this.position)<<24)+(this.str.charCodeAt(this.position+1)<<16)+(this.str.charCodeAt(this.position+2)<<8)+this.str.charCodeAt(this.position+3);return this.position+=4,t}},{key:"readInt16",value:function(){var t=(this.str.charCodeAt(this.position)<<8)+this.str.charCodeAt(this.position+1);return this.position+=2,t}},{key:"readInt8",value:function(t){var e=this.str.charCodeAt(this.position);return t&&e>127&&(e-=256),this.position+=1,e}},{key:"eof",value:function(){return this.position>=this.str.length}},{key:"readVarInt",value:function(){for(var t=0;;){var e=this.readInt8();if(!(128&e))return t+e;t+=127&e,t<<=7}}}])&&Bt(e.prototype,r),n&&Bt(e,n),t}();function Ft(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var Rt=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.data=e,this.stream=new Pt(e),this.lastEventTypeByte=void 0}var e,r,n;return e=t,(r=[{key:"readChunk",value:function(t){var e=t.read(4),r=t.readInt32();return{id:e,length:r,data:t.read(r)}}},{key:"readEvent",value:function(t){var e={};e.deltaTime=t.readVarInt();var r=t.readInt8();if(240==(240&r)){if(255!==r){if(240===r){e.type="sysEx";var n=t.readVarInt();return e.data=t.read(n),e}if(247===r){e.type="dividedSysEx";var o=t.readVarInt();return e.data=t.read(o),e}throw"Unrecognised MIDI event type byte: "+r}e.type="meta";var i=t.readInt8(),a=t.readVarInt();switch(i){case 0:if(e.subtype="sequenceNumber",2!==a)throw"Expected length for sequenceNumber event is 2, got "+a;return e.number=t.readInt16(),e;case 1:return e.subtype="text",e.text=t.read(a),e;case 2:return e.subtype="copyrightNotice",e.text=t.read(a),e;case 3:return e.subtype="trackName",e.text=t.read(a),e;case 4:return e.subtype="instrumentName",e.text=t.read(a),e;case 5:return e.subtype="lyrics",e.text=t.read(a),e;case 6:return e.subtype="marker",e.text=t.read(a),e;case 7:return e.subtype="cuePoint",e.text=t.read(a),e;case 32:if(e.subtype="midiChannelPrefix",1!==a)throw"Expected length for midiChannelPrefix event is 1, got "+a;return e.channel=t.readInt8(),e;case 47:if(e.subtype="endOfTrack",0!==a)throw"Expected length for endOfTrack event is 0, got "+a;return e;case 81:if(e.subtype="setTempo",3!==a)throw"Expected length for setTempo event is 3, got "+a;return e.microsecondsPerBeat=(t.readInt8()<<16)+(t.readInt8()<<8)+t.readInt8(),e;case 84:if(e.subtype="smpteOffset",5!==a)throw"Expected length for smpteOffset event is 5, got "+a;var u=t.readInt8();return e.frameRate={0:24,32:25,64:29,96:30}[96&u],e.hour=31&u,e.min=t.readInt8(),e.sec=t.readInt8(),e.frame=t.readInt8(),e.subframe=t.readInt8(),e;case 88:if(e.subtype="timeSignature",4!==a)throw"Expected length for timeSignature event is 4, got "+a;return e.numerator=t.readInt8(),e.denominator=Math.pow(2,t.readInt8()),e.metronome=t.readInt8(),e.thirtyseconds=t.readInt8(),e;case 89:if(e.subtype="keySignature",2!==a)throw"Expected length for keySignature event is 2, got "+a;return e.key=t.readInt8(!0),e.scale=t.readInt8(),e;case 127:return e.subtype="sequencerSpecific",e.data=t.read(a),e;default:return e.subtype="unknown",e.data=t.read(a),e}}else{var c;0==(128&r)?(c=r,r=this.lastEventTypeByte):(c=t.readInt8(),this.lastEventTypeByte=r);var s=r>>4;switch(e.channel=15&r,e.type="channel",s){case 8:return e.subtype="noteOff",e.noteNumber=c,e.velocity=t.readInt8(),e;case 9:return e.noteNumber=c,e.velocity=t.readInt8(),0===e.velocity?e.subtype="noteOff":e.subtype="noteOn",e;case 10:return e.subtype="noteAftertouch",e.noteNumber=c,e.amount=t.readInt8(),e;case 11:return e.subtype="controller",e.controllerType=c,e.value=t.readInt8(),e;case 12:return e.subtype="programChange",e.programNumber=c,e;case 13:return e.subtype="channelAftertouch",e.amount=c,e;case 14:return e.subtype="pitchBend",e.value=c+(t.readInt8()<<7),e;default:throw"Unrecognised MIDI event type: "+s}}}},{key:"parseAndReturn",value:function(){var t=this.stream,e=this.readChunk(t);if("MThd"!==e.id||6!==e.length)throw"Bad .mid file - header not found";var r=new Pt(e.data),n=r.readInt16(),o=r.readInt16(),i=r.readInt16();if(32768&i)throw"Expressing time division in SMTPE frames is not supported yet";for(var a={formatType:n,trackCount:o,ticksPerBeat:i},u=[],c=0;c<a.trackCount;c++){u[c]=[];var s=this.readChunk(t);if("MTrk"!==s.id)throw"Unexpected chunk - expected MTrk, got "+s.id;for(var f=new Pt(s.data);!f.eof();){var l=this.readEvent(f);u[c].push(l)}}return{header:a,tracks:u}}}])&&Ft(e.prototype,r),n&&Ft(e,n),t}();function Dt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function Lt(t){return(Lt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}var jt=function(){function t(e,r,n,o){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.midiFile=e,this.timeWarp=r,this.eventProcessor=n,this.trackStates=[],this.beatsPerMinute=o||120,this.bpmOverride=!!o,this.ticksPerBeat=e.header.ticksPerBeat;for(var i=0;i<e.tracks.length;i++)this.trackStates[i]={nextEventIndex:0,ticksToNextEvent:e.tracks[i].length?e.tracks[i][0].deltaTime:null};this.temporal=[],this.processEvents()}var e,r,n;return e=t,(r=[{key:"getNextEvent",value:function(){for(var t=null,e=null,r=null,n=0;n<this.trackStates.length;n++)null!=this.trackStates[n].ticksToNextEvent&&(null==t||this.trackStates[n].ticksToNextEvent<t)&&(t=this.trackStates[n].ticksToNextEvent,e=n,r=this.trackStates[n].nextEventIndex);if(null!=e){var o=this.midiFile.tracks[e][r];this.midiFile.tracks[e][r+1]?this.trackStates[e].ticksToNextEvent+=this.midiFile.tracks[e][r+1].deltaTime:this.trackStates[e].ticksToNextEvent=null,this.trackStates[e].nextEventIndex+=1;for(var i=0;i<this.trackStates.length;i++)null!=this.trackStates[i].ticksToNextEvent&&(this.trackStates[i].ticksToNextEvent-=t);return{ticksToEvent:t,event:o,track:e}}return null}},{key:"processEvents",value:function(){for(var t=this.getNextEvent();t;){this.bpmOverride||"meta"!==t.event.type||"setTempo"!==t.event.subtype||(this.beatsPerMinute=6e7/t.event.microsecondsPerBeat);var e=0;t.ticksToEvent>0&&(e=t.ticksToEvent/this.ticksPerBeat/(this.beatsPerMinute/60));var r=1e3*e*this.timeWarp||0;this.temporal.push([t,r]),t=this.getNextEvent()}}},{key:"getData",value:function(){return function t(e){if("object"!=Lt(e))return e;if(null==e)return e;var r="number"==typeof e.length?[]:{};for(var n in e)r[n]=t(e[n]);return r}(this.temporal)}}])&&Dt(e.prototype,r),n&&Dt(e,n),t}();function Ut(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var Wt=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.plugin=e,this.currentTime=0,this.endTime=0,this.restart=0,this.playing=!1,this.timeWarp=1,this.startDelay=0,this.BPM=120,this.data=[],this.eventQueue=[],this.queuedTime=0,this.startTime=0,this.noteRegistrar={},this.onMidiEvent=void 0,this.MIDIOffset=0,this.frame=void 0,this.__now=void 0}var e,r,n;return e=t,(r=[{key:"start",value:function(t){this.currentTime<-1&&(this.currentTime=-1),this.startAudio(this.currentTime,null,t)}},{key:"resume",value:function(t){return this.start(t)}},{key:"pause",value:function(){var t=this.restart;this.stopAudio(),this.restart=t}},{key:"stop",value:function(){this.stopAudio(),this.restart=0,this.currentTime=0}},{key:"addListener",value:function(t){this.onMidiEvent=t}},{key:"removeListener",value:function(){this.onMidiEvent=void 0}},{key:"clearAnimation",value:function(){this.animationFrameId&&cancelAnimationFrame(this.animationFrameId)}},{key:"setAnimation",value:function(t){var e=this,r=0,n=0,o=0;this.clearAnimation(),this.frame=function(){if(e.animationFrameId=requestAnimationFrame(e.frame),0!==e.endTime){e.playing?(r=o===e.currentTime?n-Date.now():0,r=0===e.currentTime?0:e.currentTime-r,o!==e.currentTime&&(n=Date.now(),o=e.currentTime)):r=e.currentTime;var i=e.endTime,a=r/1e3,u=a/60,c=60*u+(a-60*u),s=i/1e3;s-c<-1||t({now:c,end:s,events:e.noteRegistrar})}},requestAnimationFrame(this.frame)}},{key:"loadMidiFile",value:function(t,e,r){try{this.replayer=new jt((n=this.currentData,new Rt(n).parseAndReturn()),this.timeWarp,null,this.BPM),this.data=this.replayer.getData(),this.endTime=this.getLength(),this.loadPlugin({onsuccess:t,onprogress:e,onerror:r})}catch(t){r&&r(t)}var n}},{key:"loadPlugin",value:function(){}},{key:"loadFile",value:function(t,e,r,n){var o=this;if(this.stop(),-1!==t.indexOf("base64,"))this.currentData=atob(t.split(",")[1]),this.loadMidiFile(e,r,n);else{var i=new XMLHttpRequest;i.open("GET",t),i.overrideMimeType("text/plain; charset=x-user-defined"),i.onreadystatechange=function(){if(4===i.readyState)if(200===i.status){for(var t=i.responseText||"",a=[],u=t.length,c=String.fromCharCode,s=0;s<u;s++)a[s]=c(255&t.charCodeAt(s));o.currentData=a.join(""),o.loadMidiFile(e,r,n)}else n&&n("Unable to load MIDI file")},i.send()}}},{key:"getFileInstruments",value:function(){for(var t={},e={},r=0;r<this.data.length;r++){var n=this.data[r][0].event;if("channel"===n.type){var o=n.channel;switch(n.subtype){case"controller":break;case"programChange":e[o]=n.programNumber;break;case"noteOn":var i=e[o],a=Number.isNaN(parseInt(i))?o:i;t[l.byId[a].id]=!0}}}for(var u=[],c=0,s=Object.keys(t);c<s.length;c++){var f=s[c];u.push(f)}return u}},{key:"scheduleTracking",value:function(t,e,r,n,o,i,a){var u=this;return setTimeout(function(){var n={channel:t,note:e,now:r,end:u.endTime,message:o,velocity:i};128===o?delete u.noteRegistrar[e]:u.noteRegistrar[e]=n,u.onMidiEvent&&u.onMidiEvent(n),u.currentTime=r,u.eventQueue.shift(),u.eventQueue.length<1e3?u.startAudio(u.queuedTime,!0):u.currentTime===u.queuedTime&&u.queuedTime<u.endTime&&u.startAudio(u.queuedTime,!0)},r-n)}},{key:"getContext",value:function(){return"webaudio"===this.plugin.api?this.plugin.getContext():(this.ctx={currentTime:0},this.ctx)}},{key:"getLength",value:function(){for(var t=this.data,e=t.length,r=.5,n=0;n<e;n++)r+=t[n][1];return r}},{key:"getNow",value:function(){return window.performance&&window.performance.now?window.performance.now():Date.now()}},{key:"startAudio",value:function(t,e,r){if(this.replayer){var n;e||(void 0===t&&(t=this.restart),this.playing&&this.stopAudio(),this.playing=!0,this.data=this.replayer.getData(),this.endTime=this.getLength());var o=0,i=0,a=this.data,u=this.getContext(),c=a.length;this.queuedTime=.5;var s=t-this.currentTime;if("webaudio"!==this.plugin.api){var f=this.getNow();this.__now=this.__now||f,u.currentTime=(f-this.__now)/1e3}this.startTime=u.currentTime;for(var l=0;l<c&&i<100;l++){var d=a[l];if(this.queuedTime+=d[1],this.queuedTime<=t)o=this.queuedTime;else{t=this.queuedTime-o;var h=d[0].event;if("channel"===h.type){var v=h.channel,y=p[v],g=u.currentTime+(t+s+this.startDelay)/1e3,_=this.queuedTime-o+this.startDelay;switch(h.subtype){case"controller":this.plugin.setController(v,h.controllerType,h.value,g);break;case"programChange":this.plugin.programChange(v,h.programNumber,g);break;case"pitchBend":this.plugin.pitchBend(v,h.value,g);break;case"noteOn":if(y.mute)break;n=h.noteNumber-(this.MIDIOffset||0),this.eventQueue.push({event:h,time:_,source:this.plugin.noteOn(v,h.noteNumber,h.velocity,g),interval:this.scheduleTracking(v,n,this.queuedTime+this.startDelay,o-s,144,h.velocity)}),i+=1;break;case"noteOff":if(y.mute)break;n=h.noteNumber-(this.MIDIOffset||0),this.eventQueue.push({event:h,time:_,source:this.plugin.noteOff(v,h.noteNumber,g),interval:this.scheduleTracking(v,n,this.queuedTime,o-s,128,0)})}}}}r&&r(this.eventQueue)}}},{key:"stopAudio",value:function(){var t=this.getContext();for(this.playing=!1,this.restart+=1e3*(t.currentTime-this.startTime);this.eventQueue.length;){var e=this.eventQueue.pop();window.clearInterval(e.interval),e.source&&("number"==typeof e.source?window.clearTimeout(e.source):e.source.disconnect(0))}for(var r=0,n=Object.keys(this.noteRegistrar);r<n.length;r++){var o=n[r],i=this.noteRegistrar[o];144===this.noteRegistrar[o].message&&this.onMidiEvent&&this.onMidiEvent({channel:i.channel,note:i.note,now:i.now,end:i.end,message:128,velocity:i.velocity})}this.noteRegistrar={}}}])&&Ut(e.prototype,r),n&&Ut(e,n),t}(),Kt=r(67),Nt={"Isaac Newton (1704)":{format:"HSL",ref:"Gerstner, p.167",english:["red",null,"orange",null,"yellow","green",null,"blue",null,"indigo",null,"violet"],0:[0,96,51],1:[0,0,0],2:[29,94,52],3:[0,0,0],4:[60,90,60],5:[135,76,32],6:[0,0,0],7:[248,82,28],8:[0,0,0],9:[302,88,26],10:[0,0,0],11:[325,84,46]},"Louis Bertrand Castel (1734)":{format:"HSL",ref:"Peacock, p.400",english:["blue","blue-green","green","olive green","yellow","yellow-orange","orange","red","crimson","violet","agate","indigo"],0:[248,82,28],1:[172,68,34],2:[135,76,32],3:[79,59,36],4:[60,90,60],5:[49,90,60],6:[29,94,52],7:[360,96,51],8:[1,89,33],9:[325,84,46],10:[273,80,27],11:[302,88,26]},"George Field (1816)":{format:"HSL",ref:"Klein, p.69",english:["blue",null,"purple",null,"red","orange",null,"yellow",null,"yellow green",null,"green"],0:[248,82,28],1:[0,0,0],2:[302,88,26],3:[0,0,0],4:[360,96,51],5:[29,94,52],6:[0,0,0],7:[60,90,60],8:[0,0,0],9:[79,59,36],10:[0,0,0],11:[135,76,32]},"D. D. Jameson (1844)":{format:"HSL",ref:"Jameson, p.12",english:["red","red-orange","orange","orange-yellow","yellow","green","green-blue","blue","blue-purple","purple","purple-violet","violet"],0:[360,96,51],1:[14,91,51],2:[29,94,52],3:[49,90,60],4:[60,90,60],5:[135,76,32],6:[172,68,34],7:[248,82,28],8:[273,80,27],9:[302,88,26],10:[313,78,37],11:[325,84,46]},"Theodor Seemann (1881)":{format:"HSL",ref:"Klein, p.86",english:["carmine","scarlet","orange","yellow-orange","yellow","green","green blue","blue","indigo","violet","brown","black"],0:[0,58,26],1:[360,96,51],2:[29,94,52],3:[49,90,60],4:[60,90,60],5:[135,76,32],6:[172,68,34],7:[248,82,28],8:[302,88,26],9:[325,84,46],10:[0,58,26],11:[0,0,3]},"A. Wallace Rimington (1893)":{format:"HSL",ref:"Peacock, p.402",english:["deep red","crimson","orange-crimson","orange","yellow","yellow-green","green","blueish green","blue-green","indigo","deep blue","violet"],0:[360,96,51],1:[1,89,33],2:[14,91,51],3:[29,94,52],4:[60,90,60],5:[79,59,36],6:[135,76,32],7:[163,62,40],8:[172,68,34],9:[302,88,26],10:[248,82,28],11:[325,84,46]},"Bainbridge Bishop (1893)":{format:"HSL",ref:"Bishop, p.11",english:["red","orange-red or scarlet","orange","gold or yellow-orange","yellow or green-gold","yellow-green","green","greenish-blue or aquamarine","blue","indigo or violet-blue","violet","violet-red","red"],0:[360,96,51],1:[1,89,33],2:[29,94,52],3:[50,93,52],4:[60,90,60],5:[73,73,55],6:[135,76,32],7:[163,62,40],8:[302,88,26],9:[325,84,46],10:[343,79,47],11:[360,96,51]},"H. von Helmholtz (1910)":{format:"HSL",ref:"Helmholtz, p.22",english:["yellow","green","greenish blue","cyan-blue","indigo blue","violet","end of red","red","red","red","red orange","orange"],0:[60,90,60],1:[135,76,32],2:[172,68,34],3:[211,70,37],4:[302,88,26],5:[325,84,46],6:[330,84,34],7:[360,96,51],8:[10,91,43],9:[10,91,43],10:[8,93,51],11:[28,89,50]},"Alexander Scriabin (1911)":{format:"HSL",ref:"Jones, p.104",english:["red","violet","yellow","steely with the glint of metal","pearly blue the shimmer of moonshine","dark red","bright blue","rosy orange","purple","green","steely with a glint of metal","pearly blue the shimmer of moonshine"],0:[360,96,51],1:[325,84,46],2:[60,90,60],3:[245,21,43],4:[211,70,37],5:[1,89,33],6:[248,82,28],7:[29,94,52],8:[302,88,26],9:[135,76,32],10:[245,21,43],11:[211,70,37]},"Adrian Bernard Klein (1930)":{format:"HSL",ref:"Klein, p.209",english:["dark red","red","red orange","orange","yellow","yellow green","green","blue-green","blue","blue violet","violet","dark violet"],0:[0,91,40],1:[360,96,51],2:[14,91,51],3:[29,94,52],4:[60,90,60],5:[73,73,55],6:[135,76,32],7:[172,68,34],8:[248,82,28],9:[292,70,31],10:[325,84,46],11:[330,84,34]},"August Aeppli (1940)":{format:"HSL",ref:"Gerstner, p.169",english:["red",null,"orange",null,"yellow",null,"green","blue-green",null,"ultramarine blue","violet","purple"],0:[0,96,51],1:[0,0,0],2:[29,94,52],3:[0,0,0],4:[60,90,60],5:[0,0,0],6:[135,76,32],7:[172,68,34],8:[0,0,0],9:[211,70,37],10:[273,80,27],11:[302,88,26]},"I. J. Belmont (1944)":{ref:"Belmont, p.226",english:["red","red-orange","orange","yellow-orange","yellow","yellow-green","green","blue-green","blue","blue-violet","violet","red-violet"],0:[360,96,51],1:[14,91,51],2:[29,94,52],3:[50,93,52],4:[60,90,60],5:[73,73,55],6:[135,76,32],7:[172,68,34],8:[248,82,28],9:[313,78,37],10:[325,84,46],11:[338,85,37]},"Steve Zieverink (2004)":{format:"HSL",ref:"Cincinnati Contemporary Art Center",english:["yellow-green","green","blue-green","blue","indigo","violet","ultra violet","infra red","red","orange","yellow-white","yellow"],0:[73,73,55],1:[135,76,32],2:[172,68,34],3:[248,82,28],4:[302,88,26],5:[325,84,46],6:[326,79,24],7:[1,89,33],8:[360,96,51],9:[29,94,52],10:[62,78,74],11:[60,90,60]},"Circle of Fifths (Johnston 2003)":{format:"RGB",ref:"Joseph Johnston",english:["yellow","blue","orange","teal","red","green","purple","light orange","light blue","dark orange","dark green","violet"],0:[255,255,0],1:[50,0,255],2:[255,150,0],3:[0,210,180],4:[255,0,0],5:[130,255,0],6:[150,0,200],7:[255,195,0],8:[30,130,255],9:[255,100,0],10:[0,200,0],11:[225,0,225]},"Circle of Fifths (Wheatman 2002)":{format:"HEX",ref:"Stuart Wheatman",english:[],data:["#122400","#2E002E","#002914","#470000","#002142","#2E2E00","#290052","#003D00","#520029","#003D3D","#522900","#000080","#244700","#570057","#004D26","#7A0000","#003B75","#4C4D00","#47008F","#006100","#850042","#005C5C","#804000","#0000C7","#366B00","#80007F","#00753B","#B80000","#0057AD","#6B6B00","#6600CC","#008A00","#B8005C","#007F80","#B35900","#2424FF","#478F00","#AD00AD","#00994D","#F00000","#0073E6","#8F8F00","#8A14FF","#00AD00","#EB0075","#00A3A3","#E07000","#6B6BFF","#5CB800","#DB00DB","#00C261","#FF5757","#3399FF","#ADAD00","#B56BFF","#00D600","#FF57AB","#00C7C7","#FF9124","#9999FF","#6EDB00","#FF29FF","#00E070","#FF9999","#7ABDFF","#D1D100","#D1A3FF","#00FA00","#FFA3D1","#00E5E6","#FFC285","#C2C2FF","#80FF00","#FFA8FF","#00E070","#FFCCCC","#C2E0FF","#F0F000","#EBD6FF","#ADFFAD","#FFD6EB","#8AFFFF","#FFEBD6","#EBEBFF","#E0FFC2","#FFEBFF","#E5FFF2","#FFF5F5"]}},Gt=function(t){for(var e,r,n,o,i,a={},u=Nt,c=u[t]||u["D. D. Jameson (1844)"],s=c[3],f=0;f<=88;f++)if(c.data)a[f]={hsl:c.data[f],hex:c.data[f]};else{var l=c[(f+9)%12];"RGB"===c.format?(l=Kt.a.Space(l,"RGB>HSL"),e=Math.floor(l.H),r=Math.floor(l.S),n=Math.floor(l.L)):(e=l[0],r=l[1],n=l[2]),e===r&&r===n&&(o=s,i=c[(f+10)%12],l=[Math.floor(.5*o[0]+.5*i[0]+.5),Math.floor(.5*o[1]+.5*i[1]+.5),Math.floor(.5*o[2]+.5*i[2]+.5)]),a[f]={hsl:"hsla("+e+","+r+"%,"+n+"%, 1)",hex:Kt.a.Space({H:e,S:r,L:n},"HSL>RGB>HEX>W3")},s=l}return a};function Vt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function Yt(t,e){return!e||"object"!==Zt(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Ht(t){return(Ht=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Jt(t,e){return(Jt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Zt(t){return(Zt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}
/*!
    ----------------------------------------------------------
    midicube
    2019-08-17

    based on MIDI.js.Plugin : 0.3.4 : 2015-03-26

    MIT License
    https://github.com/mscuthbert/midicube/

    ----------------------------------------------------------
    Inspired by javax.sound.midi (albeit a super simple version):
        http://docs.oracle.com/javase/6/docs/api/javax/sound/midi/package-summary.html
    ----------------------------------------------------------
    Technologies
    ----------------------------------------------------------
        Web MIDI API - native support in Chrome. (Jazz plugin for safari, firefox, opera?)
        Web Audio API - firefox 25+, chrome 10+, safari 6+, opera 15+, edge 18+
            WebAudioShim allows Firefox < 25 to use, but not imported by default.
        HTML5 Audio Tag - ie 9+, firefox 3.5+, chrome 4+, safari 4+,
            opera 9.5+, ios 4+, android 2.3+
    ----------------------------------------------------------
*/r.d(e,"Soundfont",function(){return Xt}),r.d(e,"audio_contexts",function(){return Qt}),r.d(e,"config",function(){return zt}),r.d(e,"loadPlugin",function(){return $t}),r.d(e,"loadProgram",function(){return te}),r.d(e,"requestQueue",function(){return ne}),r.d(e,"sendRequest",function(){return oe}),r.d(e,"playChannel",function(){return ie}),r.d(e,"stopChannel",function(){return ae}),r.d(e,"send",function(){return ue}),r.d(e,"setController",function(){return ce}),r.d(e,"setVolume",function(){return se}),r.d(e,"programChange",function(){return fe}),r.d(e,"pitchBend",function(){return le}),r.d(e,"noteOn",function(){return pe}),r.d(e,"noteOff",function(){return de}),r.d(e,"chordOn",function(){return he}),r.d(e,"chordOff",function(){return ve}),r.d(e,"stopAllNotes",function(){return ye}),r.d(e,"setEffects",function(){return ge}),r.d(e,"getContext",function(){return _e}),r.d(e,"setContext",function(){return me}),r.d(e,"Player",function(){return be}),r.d(e,"GM",function(){return l}),r.d(e,"noteToKey",function(){return h}),r.d(e,"keyToNote",function(){return d}),r.d(e,"channels",function(){return p}),r.d(e,"AudioTag",function(){return n}),r.d(e,"WebAudio",function(){return o}),r.d(e,"WebMIDI",function(){return i}),r.d(e,"Synesthesia",function(){return a});var Xt={},Qt={AudioTag:n,WebAudio:o,WebMIDI:i},zt={soundfontUrl:"./soundfont/",api:"",audioFormat:"",supports:{},connected_plugin:o,is_connected:!1},$t=function(t){"function"==typeof t&&(t={onsuccess:t}),t.onprogress=t.onprogress||void 0,t.api=t.api||"",t.targetFormat=t.targetFormat||"",t.instrument=t.instrument||"acoustic_grand_piano",t.instruments=t.instruments||void 0,t.apiPrecedence=t.apiPrecedence||["webaudio","webmidi","audiotag"],zt.soundfontUrl=t.soundfontUrl||zt.soundfontUrl,function(t){if("undefined"!=typeof navigator&&navigator.requestMIDIAccess)if(Function.prototype.toString.call(navigator.requestMIDIAccess).indexOf("[native code]"))u.webmidi=!0;else if("undefined"!=typeof navigator&&void 0!==navigator.plugins)for(var e=0,r=Array.from(navigator.plugins);e<r.length;e++)r[e].name.indexOf("Jazz-Plugin")>=0&&(u.webmidi=!0);if("undefined"==typeof Audio)return t({});u.audiotag=!0;var n=window.AudioContext||window.webkitAudioContext;n&&n.prototype.createGain&&(u.webaudio=!0);var o=new Audio;if(void 0===o.canPlayType)return t(u);var i=o.canPlayType('audio/ogg; codecs="vorbis"'),a="probably"===i||"maybe"===i,f=o.canPlayType("audio/mpeg"),l="probably"===f||"maybe"===f;if(u.ogg_mp3_precedence="probably"===i?"ogg":"probably"===f?"mp3":"ogg",!a&&!l)return t(u);a&&s("audio/ogg;base64,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"),l&&s("audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqq/+MYxEkNmdJkUYc4AKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");var p=(new Date).getTime(),d=window.setInterval(function(){var e=(new Date).getTime();c&&!(e-p>5e3)||(window.clearInterval(d),t(u))},1)}(function(e){var r=window.location.hash,n="";if(e[t.api])n=t.api;else if(e[r.substr(1)])n=r.substr(1);else{var o=!0,i=!1,a=void 0;try{for(var u,c=t.apiPrecedence[Symbol.iterator]();!(o=(u=c.next()).done);o=!0){var s=u.value;if(e[s]){n=s;break}}}catch(t){i=!0,a=t}finally{try{o||null==c.return||c.return()}finally{if(i)throw a}}}if(ee[n]){var f="",l=e["audio/ogg"],p=e["audio/mpeg"],d=e.ogg_mp3_precedence;t.targetFormat?f=t.targetFormat:l&&"ogg"===d?f="ogg":p&&"mp3"===d?f="mp3":l?f="ogg":p?f="mp3":"webmidi"!==n&&(console.warn("no supporting playback formats...will try mp3 but unlikely"),f="mp3"),zt.api=n,zt.audioFormat=f,zt.supports=e,te(t)}})},te=function(t){var e=t.instruments||t.instrument||"acoustic_grand_piano";"object"!==Zt(e)&&(e=e||0===e?[e]:[]);for(var r=0;r<e.length;r++){var n=e[r];n===n+0&&l.byId[n]&&(e[r]=l.byId[n].id)}t.format=zt.audioFormat,t.instruments=e,ee[zt.api](t)},ee={webmidi:function(t){re(i,t),gt(t),zt.is_connected=!0},audiotag:function(t){re(n,t),ne(t,"AudioTag")},webaudio:function(t){re(o,t),ne(t,"WebAudio")}},re=function(t,e){zt.connected_plugin=t,t.shared_root_info.Soundfont=Xt,t.shared_root_info.config=zt,t.shared_root_info.webaudio_backup_connect=function(t){return ee.webaudio(t)}},ne=function(t,e){var r=t.format,n=t.instruments,o=t.onprogress,i=t.onerror,a=Qt[e]||e.WebAudio,u=n.length,c=u,s=function(){(c-=1)||(a.connect(t),zt.is_connected=!0,o&&o("load",1))},f=!0,l=!1,p=void 0;try{for(var d,h=function(){var t=d.value;if(Xt[t])s();else{oe(t,r,function(e,r){return function(t,e,r){o&&o("load",e/u+(u-c)/u,r)}(0,r,t)},function(){return s()},i)}},v=n[Symbol.iterator]();!(f=(d=v.next()).done);f=!0)h()}catch(t){l=!0,p=t}finally{try{f||null==v.return||v.return()}finally{if(l)throw p}}},oe=function(t,e,r,n,o){var i=zt.soundfontUrl+t+"-"+e+".js",a=new XMLHttpRequest;a.open("GET",i),a.setRequestHeader("Content-Type","text/plain"),a.onload=function(){if(200===a.status){var t=document.createElement("script");t.language="javascript",t.type="text/javascript",t.text=a.responseText,document.body.appendChild(t),n()}else o?o():console.error("Could not load soundfont; path was ".concat(i))},a.send()},ie=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).playChannel.apply(t,arguments);console.error("Connect before calling")},ae=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).stopChannel.apply(t,arguments);console.error("Connect before calling")},ue=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).send.apply(t,arguments);console.error("Connect before calling")},ce=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).setController.apply(t,arguments);console.error("Connect before calling")},se=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).setVolume.apply(t,arguments);console.error("Connect before calling")},fe=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).programChange.apply(t,arguments);console.error("Connect before calling")},le=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).pitchBend.apply(t,arguments);console.error("Connect before calling")},pe=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).noteOn.apply(t,arguments);console.error("Connect before calling")},de=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).noteOff.apply(t,arguments);console.error("Connect before calling")},he=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).chordOn.apply(t,arguments);console.error("Connect before calling")},ve=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).chordOff.apply(t,arguments);console.error("Connect before calling")},ye=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).stopAllNotes.apply(t,arguments);console.error("Connect before calling")},ge=function(){if(zt.is_connected)return zt.connected_plugin.setEffects();console.error("Connect before calling")},_e=function(){if(zt.is_connected)return zt.connected_plugin.getContext();console.error("Connect before calling")},me=function(){var t;if(zt.is_connected)return(t=zt.connected_plugin).setContext.apply(t,arguments);console.error("Connect before calling")},be=function(t){function e(){return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),Yt(this,Ht(e).call(this,zt.connected_plugin))}var r,n,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Jt(t,e)}(e,Wt),r=e,(n=[{key:"loadPlugin",value:function(){return $t.apply(void 0,arguments)}}])&&Vt(r.prototype,n),o&&Vt(r,o),e}()}])});
//# sourceMappingURL=midicube.js.map

/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ "./node_modules/style-loader/lib/addStyles.js":
/*!****************************************************!*\
  !*** ./node_modules/style-loader/lib/addStyles.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(/*! ./urls */ "./node_modules/style-loader/lib/urls.js");

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css) 
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "./node_modules/style-loader/lib/urls.js":
/*!***********************************************!*\
  !*** ./node_modules/style-loader/lib/urls.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "./node_modules/vexflow/releases/vexflow-debug.js":
/*!********************************************************!*\
  !*** ./node_modules/vexflow/releases/vexflow-debug.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():undefined}(window,(function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var o=e[i]={i:i,l:!1,exports:{}};return t[i].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(i,o,function(e){return t[e]}.bind(null,o));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=0)}([function(t,e,n){"use strict";function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function o(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){return!e||"object"!==i(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function a(t){var e="function"==typeof Map?new Map:void 0;return(a=function(t){if(null===t||(n=t,-1===Function.toString.call(n).indexOf("[native code]")))return t;var n;if("function"!=typeof t)throw new TypeError("Super expression must either be null or a function");if(void 0!==e){if(e.has(t))return e.get(t);e.set(t,i)}function i(){return u(t,arguments,h(this).constructor)}return i.prototype=Object.create(t.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}),c(i,t)})(t)}function l(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}function u(t,e,n){return(u=l()?Reflect.construct:function(t,e,n){var i=[null];i.push.apply(i,e);var o=new(Function.bind.apply(t,i));return n&&c(o,n.prototype),o}).apply(null,arguments)}function c(t,e){return(c=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function h(t){return(h=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}n.r(e);var b=function(){};function f(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function p(t,e,n){return e&&f(t.prototype,e),n&&f(t,n),t}b.L=function(t,e){if(e){var n=Array.prototype.slice.call(e).join(" ");window.console.log(t+": "+n)}},b.MakeException=function(t){return function(e){function n(e,i){var o;return r(this,n),(o=s(this,h(n).call(this,e))).name=t,o.message=e,o.data=i,o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&c(t,e)}(n,e),n}(a(Error))},b.RERR=b.RuntimeError=function(){function t(e,n){r(this,t),this.code=e,this.message=n}var e,n,i;return e=t,(n=[{key:"toString",value:function(){return"[RuntimeError] "+this.code+":"+this.message}}])&&o(e.prototype,n),i&&o(e,i),t}(),b.Merge=function(t,e){for(var n in e)t[n]=e[n];return t},b.Min=Math.min,b.Max=Math.max,b.forEach=function(t,e){for(var n=0;n<t.length;n++)e(t[n],n)},b.RoundN=function(t,e){return t%e>=e/2?parseInt(t/e,10)*e+e:parseInt(t/e,10)*e},b.MidLine=function(t,e){var n=e+(t-e)/2;return n%2>0&&(n=b.RoundN(10*n,5)/10),n},b.SortAndUnique=function(t,e,n){if(t.length>1){var i,o=[];t.sort(e);for(var r=0;r<t.length;++r)0!==r&&n(t[r],i)||o.push(t[r]),i=t[r];return o}return t},b.Contains=function(t,e){for(var n=t.length;n--;)if(t[n]===e)return!0;return!1},b.getCanvasContext=function(t){if(!t)throw new b.RERR("BadArgument","Invalid canvas selector: "+t);var e=document.getElementById(t);if(!e||!e.getContext)throw new b.RERR("UnsupportedBrowserError","This browser does not support HTML5 Canvas");return e.getContext("2d")},b.drawDot=function(t,e,n){var i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"#55";t.save(),t.setFillStyle(i),t.beginPath(),t.arc(e,n,3,0,2*Math.PI,!0),t.closePath(),t.fill(),t.restore()},b.BM=function(t,e){var n=(new Date).getTime();e();var i=(new Date).getTime()-n;b.L(t+i+"ms")},b.StackTrace=function(){return(new Error).stack},b.W=function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];var i=e.join(" ");window.console.log("Warning: ",i,b.StackTrace())},(b.Prefix=function(t){return b.Prefix.prefix+t}).prefix="vf-";var y=function(){function t(e,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.set(e,n)}return p(t,null,[{key:"GCD",value:function(t,e){if("number"!=typeof t||"number"!=typeof e)throw new b.RERR("BadArgument","Invalid numbers: ".concat(t,", ").concat(e));for(var n;0!==e;)n=e,e=t%e,t=n;return t}},{key:"LCM",value:function(e,n){return e*n/t.GCD(e,n)}},{key:"LCMM",value:function(e){if(0===e.length)return 0;if(1===e.length)return e[0];if(2===e.length)return t.LCM(e[0],e[1]);var n=e[0];return e.shift(),t.LCM(n,t.LCMM(e))}}]),p(t,[{key:"set",value:function(t,e){return this.numerator=void 0===t?1:t,this.denominator=void 0===e?1:e,this}},{key:"value",value:function(){return this.numerator/this.denominator}},{key:"simplify",value:function(){var e=this.numerator,n=this.denominator,i=t.GCD(e,n);return e/=i,(n/=i)<0&&(n=-n,e=-e),this.set(e,n)}},{key:"add",value:function(e,n){var i,o;e instanceof t?(i=e.numerator,o=e.denominator):(i=void 0!==e?e:0,o=void 0!==n?n:1);var r=t.LCM(this.denominator,o),s=r/this.denominator,a=r/o,l=this.numerator*s+i*a;return this.set(l,r)}},{key:"subtract",value:function(e,n){var i,o;e instanceof t?(i=e.numerator,o=e.denominator):(i=void 0!==e?e:0,o=void 0!==n?n:1);var r=t.LCM(this.denominator,o),s=r/this.denominator,a=r/o,l=this.numerator*s-i*a;return this.set(l,r)}},{key:"multiply",value:function(e,n){var i,o;return e instanceof t?(i=e.numerator,o=e.denominator):(i=void 0!==e?e:1,o=void 0!==n?n:1),this.set(this.numerator*i,this.denominator*o)}},{key:"divide",value:function(e,n){var i,o;return e instanceof t?(i=e.numerator,o=e.denominator):(i=void 0!==e?e:1,o=void 0!==n?n:1),this.set(this.numerator*o,this.denominator*i)}},{key:"equals",value:function(e){var n=t.__compareA.copy(e).simplify(),i=t.__compareB.copy(this).simplify();return n.numerator===i.numerator&&n.denominator===i.denominator}},{key:"greaterThan",value:function(e){var n=t.__compareB.copy(this);return n.subtract(e),n.numerator>0}},{key:"greaterThanEquals",value:function(e){var n=t.__compareB.copy(this);return n.subtract(e),n.numerator>=0}},{key:"lessThan",value:function(t){return!this.greaterThanEquals(t)}},{key:"lessThanEquals",value:function(t){return!this.greaterThan(t)}},{key:"clone",value:function(){return new t(this.numerator,this.denominator)}},{key:"copy",value:function(t){return"number"==typeof t?this.set(t||0,1):this.set(t.numerator,t.denominator)}},{key:"quotient",value:function(){return Math.floor(this.numerator/this.denominator)}},{key:"fraction",value:function(){return this.numerator%this.denominator}},{key:"abs",value:function(){return this.denominator=Math.abs(this.denominator),this.numerator=Math.abs(this.numerator),this}},{key:"toString",value:function(){return this.numerator+"/"+this.denominator}},{key:"toSimplifiedString",value:function(){return t.__tmp.copy(this).simplify().toString()}},{key:"toMixedString",value:function(){var e="",n=this.quotient(),i=t.__tmp.copy(this);return n<0?i.abs().fraction():i.fraction(),0!==n?(e+=n,0!==i.numerator&&(e+=" "+i.toSimplifiedString())):e=0===i.numerator?"0":i.toSimplifiedString(),e}},{key:"parse",value:function(t){var e=t.split("/"),n=parseInt(e[0],10),i=e[1]?parseInt(e[1],10):1;return this.set(n,i)}}]),t}();function d(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function v(t,e,n){return e&&d(t.prototype,e),n&&d(t,n),t}y.__compareA=new y,y.__compareB=new y,y.__tmp=new y;var g=b.MakeException("RegistryError");function m(t,e,n,i,o){t[e][n]||(t[e][n]={}),t[e][n][i]=o}var _=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.clear()}return v(t,null,[{key:"INDEXES",get:function(){return["type"]}}]),v(t,[{key:"clear",value:function(){return this.index={id:{},type:{},class:{}},this}},{key:"updateIndex",value:function(t){var e=t.id,n=t.name,i=t.value,o=t.oldValue,r=this.getElementById(e);null!==o&&this.index[n][o]&&delete this.index[n][o][e],null!==i&&m(this.index,n,i,r.getAttribute("id"),r)}},{key:"register",value:function(e,n){var i=this;if(!(n=n||e.getAttribute("id")))throw new g("Can't add element without `id` attribute to registry",e);return e.setAttribute("id",n),m(this.index,"id",n,n,e),t.INDEXES.forEach((function(t){i.updateIndex({id:n,name:t,value:e.getAttribute(t),oldValue:null})})),e.onRegister(this),this}},{key:"getElementById",value:function(t){return this.index.id[t]?this.index.id[t][t]:null}},{key:"getElementsByAttribute",value:function(t,e){var n=this.index[t];return n&&n[e]?Object.keys(n[e]).map((function(t){return n[e][t]})):[]}},{key:"getElementsByType",value:function(t){return this.getElementsByAttribute("type",t)}},{key:"getElementsByClass",value:function(t){return this.getElementsByAttribute("class",t)}},{key:"onUpdate",value:function(e){var n=e.id,i=e.name,o=e.value,r=e.oldValue;return function(t,e){return t.filter((function(t){return t===e})).length>0}(t.INDEXES.concat(["id","class"]),i)?(this.updateIndex({id:n,name:i,value:o,oldValue:r}),this):this}}],[{key:"enableDefaultRegistry",value:function(e){t.defaultRegistry=e}},{key:"getDefaultRegistry",value:function(){return t.defaultRegistry}},{key:"disableDefaultRegistry",value:function(){t.defaultRegistry=null}}]),t}();function x(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function w(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function k(t,e,n){return e&&w(t.prototype,e),n&&w(t,n),t}_.defaultRegistry=null;var S=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.type;x(this,t),this.attrs={id:t.newID(),el:null,type:n||"Base",classes:{}},this.boundingBox=null,this.context=null,this.rendered=!1,_.getDefaultRegistry()&&_.getDefaultRegistry().register(this)}return k(t,null,[{key:"newID",value:function(){return"auto"+t.ID++}}]),k(t,[{key:"setStyle",value:function(t){return this.style=t,this}},{key:"getStyle",value:function(){return this.style}},{key:"applyStyle",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.context,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getStyle();return e?(t.save(),e.shadowColor&&t.setShadowColor(e.shadowColor),e.shadowBlur&&t.setShadowBlur(e.shadowBlur),e.fillStyle&&t.setFillStyle(e.fillStyle),e.strokeStyle&&t.setStrokeStyle(e.strokeStyle),e.lineWidth&&t.setLineWidth(e.lineWidth),this):this}},{key:"restoreStyle",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.context,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getStyle();return e?(t.restore(),this):this}},{key:"drawWithStyle",value:function(){this.checkContext(),this.applyStyle(),this.draw(),this.restoreStyle()}},{key:"hasClass",value:function(t){return!0===this.attrs.classes[t]}},{key:"addClass",value:function(t){return this.attrs.classes[t]=!0,this.registry&&this.registry.onUpdate({id:this.getAttribute("id"),name:"class",value:t,oldValue:null}),this}},{key:"removeClass",value:function(t){return delete this.attrs.classes[t],this.registry&&this.registry.onUpdate({id:this.getAttribute("id"),name:"class",value:null,oldValue:t}),this}},{key:"onRegister",value:function(t){return this.registry=t,this}},{key:"isRendered",value:function(){return this.rendered}},{key:"setRendered",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];return this.rendered=t,this}},{key:"getAttributes",value:function(){return this.attrs}},{key:"getAttribute",value:function(t){return this.attrs[t]}},{key:"setAttribute",value:function(t,e){var n=this.attrs.id,i=this.attrs[t];return this.attrs[t]=e,this.registry&&this.registry.onUpdate({id:n,name:t,value:e,oldValue:i}),this}},{key:"getContext",value:function(){return this.context}},{key:"setContext",value:function(t){return this.context=t,this}},{key:"getBoundingBox",value:function(){return this.boundingBox}},{key:"checkContext",value:function(){if(!this.context)throw new b.RERR("NoContext","No rendering context attached to instance");return this.context}}]),t}();function T(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}S.ID=1e3;var E=function(){function t(e,n,i,o){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.x1=Number.NaN,this.y1=Number.NaN,this.x2=Number.NaN,this.y2=Number.NaN,this.addPoint(e,n),this.addPoint(i,o)}var e,n,i;return e=t,(n=[{key:"width",value:function(){return this.x2-this.x1}},{key:"height",value:function(){return this.y2-this.y1}},{key:"addPoint",value:function(t,e){null!=t&&((isNaN(this.x1)||isNaN(this.x2))&&(this.x1=t,this.x2=t),t<this.x1&&(this.x1=t),t>this.x2&&(this.x2=t)),null!=e&&((isNaN(this.y1)||isNaN(this.y2))&&(this.y1=e,this.y2=e),e<this.y1&&(this.y1=e),e>this.y2&&(this.y2=e))}},{key:"addX",value:function(t){this.addPoint(t,null)}},{key:"addY",value:function(t){this.addPoint(null,t)}},{key:"addQuadraticCurve",value:function(t,e,n,i,o,r){var s=t+2/3*(n-t),a=e+2/3*(i-e),l=s+1/3*(o-t),u=a+1/3*(r-e);this.addBezierCurve(t,e,s,a,l,u,o,r)}},{key:"addBezierCurve",value:function(t,e,n,i,o,r,s,a){var l,u=[t,e],c=[n,i],h=[o,r],b=[s,a];this.addPoint(u[0],u[1]),this.addPoint(b[0],b[1]);var f=function(t,e){return Math.pow(1-t,3)*u[e]+3*Math.pow(1-t,2)*t*c[e]+3*(1-t)*Math.pow(t,2)*h[e]+Math.pow(t,3)*b[e]};for(l=0;l<=1;l++){var p=6*u[l]-12*c[l]+6*h[l],y=-3*u[l]+9*c[l]-9*h[l]+3*b[l],d=3*c[l]-3*u[l];if(0!==y){var v=Math.pow(p,2)-4*d*y;if(!(v<0)){var g=(-p+Math.sqrt(v))/(2*y);0<g&&g<1&&(0===l&&this.addX(f(g,l)),1===l&&this.addY(f(g,l)));var m=(-p-Math.sqrt(v))/(2*y);0<m&&m<1&&(0===l&&this.addX(f(m,l)),1===l&&this.addY(f(m,l)))}}else{if(0===p)continue;var _=-d/p;0<_&&_<1&&(0===l&&this.addX(f(_,l)),1===l&&this.addY(f(_,l)))}}}}])&&T(e.prototype,n),i&&T(e,i),t}();function O(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function R(t,e,n){return e&&O(t.prototype,e),n&&O(t,n),t}var P=function(){function t(e,n,i,o){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.x=e,this.y=n,this.w=i,this.h=o}return R(t,null,[{key:"copy",value:function(e){return new t(e.x,e.y,e.w,e.h)}}]),R(t,[{key:"getX",value:function(){return this.x}},{key:"getY",value:function(){return this.y}},{key:"getW",value:function(){return this.w}},{key:"getH",value:function(){return this.h}},{key:"setX",value:function(t){return this.x=t,this}},{key:"setY",value:function(t){return this.y=t,this}},{key:"setW",value:function(t){return this.w=t,this}},{key:"setH",value:function(t){return this.h=t,this}},{key:"move",value:function(t,e){this.x+=t,this.y+=e}},{key:"clone",value:function(){return t.copy(this)}},{key:"mergeWith",value:function(t,e){var n=t,i=this.x<n.x?this.x:n.x,o=this.y<n.y?this.y:n.y,r=Math.max(this.x+this.w,n.x+n.w)-i,s=Math.max(this.y+this.h,n.y+n.h)-o;return this.x=i,this.y=o,this.w=r,this.h=s,e&&this.draw(e),this}},{key:"draw",value:function(t,e,n){e||(e=0),n||(n=0),t.rect(this.x+e,this.y+n,this.w,this.h),t.stroke()}}]),t}(),C={glyphs:{v0:{x_min:0,x_max:514.5,ha:525,o:"m 236 648 b 246 648 238 648 242 648 b 288 646 261 648 283 648 b 472 513 364 634 428 587 b 514 347 502 464 514 413 b 462 163 514 272 499 217 b 257 44 409 83 333 44 b 50 163 181 44 103 83 b 0 347 14 217 0 272 b 40 513 0 413 12 464 b 236 648 87 591 155 638 m 277 614 b 253 616 273 616 261 616 b 242 616 247 616 243 616 b 170 499 193 609 181 589 b 159 348 163 446 159 398 b 166 222 159 308 161 266 b 201 91 174 138 183 106 b 257 76 215 81 235 76 b 311 91 277 76 299 81 b 347 222 330 106 338 138 b 353 348 352 266 353 308 b 344 499 353 398 351 446 b 277 614 333 587 322 606 m 257 -1 l 258 -1 l 255 -1 l 257 -1 m 257 673 l 258 673 l 255 673 l 257 673 "},v1:{x_min:-1.359375,x_max:344.359375,ha:351,o:"m 126 637 l 129 638 l 198 638 l 266 638 l 269 635 b 274 631 272 634 273 632 l 277 627 l 277 395 b 279 156 277 230 277 161 b 329 88 281 123 295 106 b 344 69 341 81 344 79 b 337 55 344 62 343 59 l 333 54 l 197 54 l 61 54 l 58 55 b 50 69 53 59 50 62 b 65 88 50 79 53 81 b 80 97 72 91 74 93 b 117 156 103 113 112 129 b 117 345 117 161 117 222 l 117 528 l 100 503 l 38 406 b 14 383 24 384 23 383 b -1 398 5 383 -1 390 b 4 415 -1 403 1 409 b 16 437 5 416 10 426 l 72 539 l 100 596 b 121 632 119 631 119 631 b 126 637 122 634 125 635 m 171 -1 l 172 -1 l 170 -1 l 171 -1 m 171 673 l 172 673 l 170 673 l 171 673 "},v2:{x_min:-1.359375,x_max:458.6875,ha:468,o:"m 197 648 b 216 648 201 648 208 648 b 258 646 232 648 253 648 b 419 546 333 637 393 599 b 432 489 428 528 432 509 b 356 342 432 440 405 384 b 235 278 322 313 288 295 b 69 170 166 256 107 217 b 69 169 69 170 69 169 b 69 169 69 169 69 169 b 74 173 69 169 72 170 b 209 222 112 204 163 222 b 310 195 247 222 274 215 b 371 179 332 184 352 179 b 396 181 379 179 387 179 b 428 202 409 184 423 194 b 442 212 431 209 436 212 b 458 197 450 212 458 206 b 441 148 458 190 449 165 b 299 44 409 84 353 44 b 288 45 295 44 292 44 b 250 61 274 45 268 49 b 122 99 212 86 164 99 b 73 91 104 99 88 97 b 28 63 53 84 34 72 b 14 54 25 56 20 54 b 1 62 9 54 4 56 l -1 65 l -1 79 b 0 99 -1 91 0 95 b 2 113 1 102 2 108 b 164 309 20 197 81 272 b 285 470 232 341 277 398 b 287 487 287 476 287 481 b 171 595 287 551 239 595 b 155 595 166 595 160 595 b 142 592 145 594 142 594 b 145 589 142 592 142 591 b 179 527 168 576 179 551 b 132 455 179 496 163 467 b 104 451 122 452 112 451 b 27 530 62 451 27 487 b 29 555 27 538 27 546 b 197 648 44 601 115 639 m 228 -1 l 230 -1 l 227 -1 l 228 -1 m 228 673 l 230 673 l 227 673 l 228 673 "},v3:{x_min:-1.359375,x_max:409.6875,ha:418,o:"m 174 648 b 191 648 176 648 183 648 b 225 648 204 648 220 648 b 402 523 317 638 389 588 b 404 503 404 517 404 510 b 402 484 404 495 404 488 b 264 373 389 437 334 394 b 257 370 259 371 257 371 b 257 370 257 370 257 370 b 264 369 258 370 261 369 b 409 202 359 334 409 267 b 318 72 409 152 381 104 b 200 43 281 52 240 43 b 23 113 134 43 69 68 b 0 169 6 129 0 149 b 77 249 0 210 29 249 l 77 249 b 152 174 125 249 152 212 b 103 102 152 145 137 116 b 103 102 103 102 103 102 b 147 94 103 101 132 95 b 153 94 149 94 151 94 b 265 206 219 94 265 141 b 264 226 265 213 265 219 b 147 355 253 299 204 353 b 126 371 133 356 126 362 b 147 388 126 383 132 388 b 254 474 196 391 238 424 b 259 502 258 484 259 494 b 182 592 259 544 228 582 b 156 595 175 595 166 595 b 115 592 142 595 129 594 l 111 591 l 115 588 b 152 524 141 574 152 549 b 92 449 152 491 130 458 b 76 448 87 448 81 448 b -1 530 32 448 -1 488 b 20 581 -1 548 5 566 b 174 648 55 619 108 641 m 204 -1 l 205 -1 l 202 -1 l 204 -1 m 204 673 l 205 673 l 202 673 l 204 673 "},v4:{x_min:0,x_max:468.21875,ha:478,o:"m 174 637 b 232 638 175 638 189 638 b 277 638 245 638 259 638 l 378 638 l 381 635 b 389 623 386 632 389 627 b 382 609 389 617 386 613 b 366 589 381 606 372 598 l 313 528 l 245 451 l 209 410 l 155 348 l 84 267 b 59 240 72 252 59 240 b 59 240 59 240 59 240 b 151 238 59 238 68 238 l 242 238 l 242 303 b 243 371 242 369 242 370 b 289 426 245 374 254 385 l 303 441 l 317 456 l 338 483 l 360 506 l 371 520 b 386 527 375 526 381 527 b 400 519 392 527 397 524 b 401 440 401 516 401 514 b 401 377 401 423 401 402 l 401 238 l 426 238 b 453 237 449 238 450 238 b 465 217 461 234 465 226 b 460 202 465 212 464 206 b 426 197 454 197 453 197 l 401 197 l 401 180 b 451 88 402 129 412 109 b 468 69 465 81 468 79 b 461 55 468 62 466 59 l 458 54 l 321 54 l 185 54 l 182 55 b 175 69 176 59 175 62 b 191 88 175 79 176 81 b 240 180 230 109 240 129 l 240 197 l 125 197 b 73 195 104 195 87 195 b 8 197 10 195 9 197 b 0 212 2 199 0 205 b 0 212 0 212 0 212 b 20 242 0 219 0 219 b 163 610 104 344 163 492 b 174 637 163 628 166 634 m 234 -1 l 235 -1 l 232 -1 l 234 -1 m 234 673 l 235 673 l 232 673 l 234 673 "},v5:{x_min:0,x_max:409.6875,ha:418,o:"m 47 637 b 53 638 49 638 50 638 b 69 634 55 638 61 637 b 210 610 114 619 161 610 b 363 634 259 610 311 619 b 382 638 372 637 378 638 b 392 634 386 638 389 637 b 397 623 396 630 397 627 b 393 610 397 620 396 616 b 298 505 368 552 338 520 b 212 494 277 498 246 494 b 65 517 163 494 106 502 b 61 517 62 517 61 517 b 61 517 61 517 61 517 b 51 408 61 517 51 412 b 51 408 51 408 51 408 b 51 408 51 408 51 408 b 61 412 53 408 55 409 b 125 434 80 421 103 430 b 185 441 145 440 166 441 b 409 244 310 441 409 353 b 401 191 409 227 406 209 b 197 43 375 105 287 43 b 159 47 183 43 171 44 b 23 123 112 56 61 86 b 0 180 6 140 0 159 b 76 260 0 220 31 260 b 92 259 81 260 87 259 b 152 183 132 251 152 216 b 100 112 152 152 134 122 b 95 111 98 112 95 111 b 95 111 95 111 95 111 b 129 98 95 109 119 101 b 148 97 136 97 141 97 b 264 235 206 97 261 158 b 265 248 265 240 265 244 b 210 398 265 312 243 373 b 179 408 201 406 194 408 b 174 408 178 408 176 408 b 53 369 130 408 88 394 b 34 359 39 359 38 359 b 17 374 24 359 17 365 b 39 628 17 384 38 625 b 47 637 40 631 43 635 m 204 -1 l 205 -1 l 202 -1 l 204 -1 m 204 673 l 205 673 l 202 673 l 204 673 "},v6:{x_min:0,x_max:475.03125,ha:485,o:"m 255 648 b 274 648 259 648 266 648 b 314 646 288 648 307 648 b 450 555 374 637 438 594 b 454 530 453 546 454 538 b 375 451 454 485 416 451 b 328 467 359 451 343 455 b 300 526 310 483 300 503 b 352 598 300 557 319 589 b 356 599 355 598 356 599 b 352 602 356 599 355 601 b 288 616 330 612 308 616 b 210 584 257 616 230 605 b 164 433 189 559 174 508 b 160 374 163 415 160 381 b 160 374 160 374 160 374 b 160 374 160 374 160 374 b 168 377 160 374 164 376 b 258 395 200 390 228 395 b 366 367 294 395 328 387 b 475 223 436 333 475 283 b 472 197 475 215 473 206 b 349 65 462 141 419 95 b 259 43 317 51 288 43 b 167 69 230 43 200 52 b 4 290 80 113 20 195 b 0 349 1 309 0 328 b 20 467 0 391 6 433 b 255 648 58 563 155 637 m 269 363 b 257 363 265 363 261 363 b 210 345 236 363 220 356 b 186 226 196 324 186 272 b 187 198 186 216 186 206 b 213 95 191 151 202 112 b 257 76 221 83 238 76 b 270 77 261 76 266 76 b 321 156 299 81 310 99 b 329 229 326 183 329 206 b 321 301 329 252 326 274 b 269 363 311 342 298 359 m 236 -1 l 238 -1 l 235 -1 l 236 -1 m 236 673 l 238 673 l 235 673 l 236 673 "},v7:{x_min:0,x_max:442.359375,ha:451,o:"m 147 648 b 166 649 153 649 160 649 b 313 598 217 649 273 630 b 340 587 323 588 328 587 l 341 587 b 412 628 367 587 390 601 b 427 638 416 635 421 638 b 439 632 431 638 435 637 b 442 623 441 630 442 628 b 430 569 442 616 439 603 b 352 369 408 492 377 410 b 300 259 325 324 313 298 b 273 84 283 205 273 140 b 265 55 273 65 272 59 l 261 54 l 181 54 l 99 54 l 96 55 b 91 61 95 56 92 59 l 89 63 l 89 77 b 147 263 89 133 111 202 b 261 401 176 313 212 355 b 378 541 315 449 349 489 l 382 548 l 375 544 b 240 495 333 512 285 495 b 129 535 198 495 160 509 b 84 560 108 552 95 560 b 76 559 81 560 78 560 b 31 487 59 555 43 530 b 14 470 27 473 24 470 b 1 477 8 470 4 471 l 0 480 l 0 553 l 0 627 l 1 630 b 16 638 4 635 9 638 b 23 635 17 638 20 637 b 49 626 36 626 39 626 b 96 638 59 626 80 630 b 104 639 99 638 102 639 b 117 644 107 641 112 642 b 147 648 125 645 137 648 m 220 -1 l 221 -1 l 219 -1 l 220 -1 m 220 673 l 221 673 l 219 673 l 220 673 "},v8:{x_min:0,x_max:488.640625,ha:499,o:"m 217 648 b 245 649 225 648 235 649 b 453 516 343 649 430 595 b 458 478 455 503 458 491 b 412 370 458 440 441 398 b 411 369 412 369 411 369 b 415 365 411 367 412 367 b 488 231 462 331 488 281 b 472 165 488 208 483 186 b 243 43 434 86 338 43 b 63 104 178 43 112 62 b 0 233 20 140 0 186 b 73 365 0 283 24 331 l 77 369 l 72 374 b 29 476 42 406 29 441 b 217 648 29 557 103 635 m 258 605 b 242 606 253 605 247 606 b 157 552 198 606 157 580 b 160 541 157 548 159 544 b 319 413 176 503 242 452 l 337 403 l 338 406 b 359 476 352 428 359 452 b 258 605 359 537 318 595 m 138 326 b 130 330 134 328 130 330 b 130 330 130 330 130 330 b 107 305 127 330 112 313 b 84 231 91 281 84 256 b 243 86 84 156 151 86 b 249 87 245 86 246 87 b 347 156 303 88 347 120 b 344 172 347 162 345 167 b 156 319 325 227 257 281 b 138 326 151 322 144 324 m 243 -1 l 245 -1 l 242 -1 l 243 -1 m 243 673 l 245 673 l 242 673 l 243 673 "},v9:{x_min:0,x_max:475.03125,ha:485,o:"m 191 646 b 212 649 198 648 205 649 b 255 644 227 649 243 646 b 458 448 348 616 428 539 b 475 342 469 415 475 378 b 460 244 475 308 469 274 b 193 44 421 124 303 44 b 91 69 157 44 122 51 b 19 161 43 97 19 126 b 21 181 19 167 20 174 b 98 241 32 220 65 241 b 170 186 129 241 160 223 b 172 166 171 179 172 173 b 121 94 172 134 152 102 b 117 93 118 94 117 93 b 121 90 117 93 118 91 b 185 76 142 80 164 76 b 270 119 220 76 251 91 b 308 259 287 145 300 194 b 313 317 310 277 313 310 b 313 317 313 317 313 317 b 313 317 313 317 313 317 b 304 315 313 317 308 316 b 216 295 273 302 245 295 b 145 308 193 295 170 299 b 19 398 88 327 42 360 b 0 469 5 420 0 444 b 24 551 0 496 8 526 b 191 646 54 596 125 637 m 227 614 b 215 616 224 616 220 616 b 202 614 210 616 206 616 b 152 535 174 610 163 592 b 144 463 147 509 144 485 b 152 391 144 440 147 417 b 216 328 163 344 179 328 b 280 391 253 328 269 344 b 288 463 285 417 288 440 b 280 535 288 485 285 509 b 227 614 269 594 258 610 m 236 -1 l 238 -1 l 235 -1 l 236 -1 m 236 673 l 238 673 l 235 673 l 236 673 "},va:{x_min:-149.71875,x_max:148.359375,ha:151,o:"m -8 -1 b -1 0 -5 -1 -4 0 b 16 -11 5 0 13 -4 b 83 -186 17 -12 47 -90 l 148 -358 l 148 -363 b 127 -385 148 -376 138 -385 b 112 -378 122 -385 118 -383 b 54 -226 110 -374 114 -385 b 0 -81 24 -147 0 -81 b -55 -226 -1 -81 -25 -147 b -114 -378 -115 -385 -111 -374 b -129 -385 -119 -383 -123 -385 b -149 -363 -140 -385 -149 -376 l -149 -358 l -84 -186 b -19 -11 -49 -90 -19 -12 b -8 -1 -17 -8 -12 -4 "},vb:{x_min:0,x_max:428.75,ha:438,o:"m 262 186 b 273 186 266 186 272 186 b 274 186 273 186 274 186 b 285 186 274 186 280 186 b 428 48 375 181 428 122 b 386 -68 428 12 416 -29 b 155 -187 329 -145 236 -187 b 12 -111 92 -187 38 -162 b 0 -51 4 -91 0 -72 b 262 186 0 58 122 179 "},vc:{x_min:0,x_max:447.8125,ha:457,o:"m 0 86 l 0 173 l 223 173 l 447 173 l 447 86 l 447 0 l 223 0 l 0 0 l 0 86 "},vf:{x_min:0,x_max:370.21875,ha:378,o:"m 0 0 l 0 277 l 61 277 l 122 277 l 122 0 l 122 -278 l 61 -278 l 0 -278 l 0 0 m 246 -1 l 246 277 l 308 277 l 370 277 l 370 -1 l 370 -278 l 308 -278 l 246 -278 l 246 -1 "},v10:{x_min:0,x_max:559.421875,ha:571,o:"m 5 127 b 14 127 6 127 9 127 b 51 126 25 127 43 127 b 175 98 93 122 138 112 l 186 94 b 279 51 210 86 255 65 b 285 47 280 51 283 48 b 319 27 291 44 311 31 l 326 22 b 359 0 332 19 352 4 l 367 -6 b 371 -9 368 -6 370 -8 l 379 -15 b 387 -22 383 -18 386 -20 l 398 -30 l 411 -40 l 417 -47 l 427 -55 l 434 -61 b 441 -66 436 -62 439 -65 l 446 -72 l 453 -77 l 462 -87 b 558 -188 490 -113 549 -176 b 559 -195 559 -191 559 -194 b 548 -205 559 -201 555 -205 b 541 -204 547 -205 544 -205 b 534 -198 539 -201 536 -199 l 525 -191 b 481 -162 518 -187 490 -167 b 472 -155 477 -159 472 -156 b 468 -152 470 -155 469 -154 b 461 -149 466 -152 464 -151 b 428 -130 454 -145 441 -137 b 371 -99 413 -122 372 -99 b 363 -95 371 -99 367 -98 b 353 -91 357 -94 353 -91 b 348 -90 353 -91 352 -91 b 332 -81 343 -87 341 -86 b 27 -12 230 -37 127 -13 b 0 -5 4 -11 2 -11 b 0 58 0 -2 0 27 b 0 122 0 88 0 120 b 5 127 1 124 4 126 "},v11:{x_min:-155.171875,x_max:153.8125,ha:157,o:"m -137 353 b -130 353 -136 353 -133 353 b -112 349 -125 353 -119 352 b -100 342 -110 347 -104 344 b 0 317 -69 326 -35 317 b 111 349 38 317 76 328 b 129 353 117 352 123 353 b 153 327 142 353 153 344 b 144 302 153 320 153 317 b 27 6 93 226 50 113 b 21 -13 24 -11 24 -11 b 0 -26 17 -22 8 -26 b -24 -12 -9 -26 -19 -22 b -28 5 -24 -9 -27 -2 b -145 302 -53 117 -95 224 b -155 327 -155 317 -155 320 b -137 353 -155 340 -148 349 "},v18:{x_min:0,x_max:323.9375,ha:331,o:"m 217 535 b 225 537 220 537 221 537 b 245 524 235 537 242 533 l 246 521 l 247 390 l 247 258 l 273 265 b 306 270 288 269 299 270 b 322 259 315 270 319 267 b 323 208 323 256 323 233 b 322 158 323 184 323 159 b 288 140 318 148 315 147 b 247 130 254 131 247 130 b 247 65 247 130 247 104 b 247 20 247 51 247 36 l 247 -88 l 273 -81 b 306 -76 289 -77 299 -76 b 318 -81 311 -76 315 -77 b 323 -123 323 -87 323 -86 l 323 -138 l 323 -154 b 318 -195 323 -191 323 -190 b 269 -210 314 -199 315 -199 b 249 -216 259 -213 250 -216 l 247 -216 l 247 -349 l 246 -483 l 245 -487 b 225 -499 242 -495 234 -499 b 206 -487 219 -499 210 -495 l 205 -483 l 205 -355 l 205 -227 l 204 -227 l 181 -233 l 138 -244 b 117 -249 127 -247 117 -249 b 115 -385 115 -249 115 -256 l 115 -523 l 114 -526 b 95 -538 110 -534 102 -538 b 74 -526 87 -538 78 -534 l 73 -523 l 73 -391 b 72 -260 73 -269 73 -260 b 72 -260 72 -260 72 -260 b 19 -273 61 -263 23 -273 b 0 -260 10 -273 4 -267 b 0 -209 0 -256 0 -256 l 0 -162 l 1 -158 b 61 -134 5 -148 5 -148 l 73 -131 l 73 -22 b 72 86 73 79 73 86 b 72 86 72 86 72 86 b 19 74 61 83 23 74 b 0 86 10 74 4 79 b 0 137 0 90 0 90 l 0 184 l 1 188 b 61 212 5 198 5 198 l 73 215 l 73 348 l 73 481 l 74 485 b 95 498 78 492 87 498 b 103 495 98 498 100 496 b 114 485 107 494 111 489 l 115 481 l 115 353 l 115 226 l 121 226 b 159 235 123 227 141 231 l 198 247 l 205 248 l 205 384 l 205 521 l 206 524 b 217 535 209 528 212 533 m 205 9 b 205 119 205 70 205 119 l 205 119 b 182 113 204 119 194 116 l 138 102 b 117 97 127 99 117 97 b 115 -12 115 97 115 91 l 115 -122 l 121 -120 b 159 -111 123 -119 141 -115 l 198 -101 l 205 -98 l 205 9 "},v1b:{x_min:0,x_max:559.421875,ha:571,o:"m 544 204 b 548 204 545 204 547 204 b 559 194 555 204 559 199 b 559 190 559 192 559 191 b 530 156 559 188 556 184 b 462 86 510 134 481 104 b 453 76 458 81 454 77 l 446 70 l 441 65 b 434 59 439 63 436 61 l 427 54 b 409 37 426 51 416 44 b 392 23 398 29 394 26 b 387 19 389 22 387 20 b 379 13 386 19 383 16 l 371 8 l 367 5 l 359 -1 l 337 -16 b 285 -48 319 -29 298 -41 l 279 -52 b 186 -95 255 -66 210 -87 l 175 -99 b 23 -129 127 -117 68 -129 b 17 -129 20 -129 19 -129 b 1 -123 2 -129 2 -129 b 0 -49 0 -122 0 -83 b 0 4 0 -22 0 1 b 27 11 2 9 4 9 b 185 31 78 12 145 20 b 198 34 186 31 193 33 b 314 73 234 44 277 58 b 349 88 328 79 340 84 b 353 90 352 90 353 90 b 363 94 353 90 357 93 b 371 98 367 97 371 98 b 428 129 372 98 413 120 b 461 148 441 136 454 144 b 468 151 464 149 466 151 b 472 154 469 152 470 154 b 481 161 473 155 477 158 b 525 190 490 166 518 186 l 534 197 b 540 201 536 198 539 199 b 544 204 541 202 544 204 "},v1d:{x_min:0,x_max:619.3125,ha:632,o:"m 274 184 b 307 186 285 186 296 186 b 616 22 465 186 597 116 b 619 -1 617 13 619 5 b 308 -187 619 -104 483 -187 b 0 -1 133 -187 0 -102 b 5 36 0 11 1 23 b 274 184 29 115 141 176 m 289 161 b 272 162 284 162 277 162 b 171 41 209 162 171 108 b 205 -73 171 5 182 -34 b 345 -163 243 -133 298 -163 b 436 -98 385 -163 420 -142 b 446 -43 443 -80 446 -62 b 289 161 446 47 377 147 "},v1e:{x_min:-402.890625,x_max:401.53125,ha:410,o:"m -219 173 b -213 174 -217 174 -215 174 b -202 173 -209 174 -205 173 b -114 86 -200 172 -179 151 b -28 0 -66 37 -28 0 b 40 84 -28 0 2 37 b 117 174 111 173 110 172 b 122 174 118 174 119 174 b 132 173 125 174 129 173 b 295 11 134 172 171 134 l 307 -1 l 336 34 b 374 76 366 72 368 74 b 381 77 375 77 378 77 b 401 56 392 77 401 68 b 400 48 401 54 401 51 b 223 -172 397 41 230 -166 b 210 -176 220 -174 215 -176 b 201 -174 206 -176 204 -176 b 112 -87 198 -173 178 -152 b 27 0 65 -38 27 0 b -42 -86 27 0 -4 -38 b -118 -174 -112 -174 -111 -173 b -123 -176 -119 -176 -121 -176 b -133 -174 -126 -176 -130 -174 b -296 -12 -136 -173 -172 -137 l -308 0 l -337 -34 b -375 -77 -367 -73 -370 -76 b -382 -79 -377 -79 -379 -79 b -402 -58 -393 -79 -402 -69 b -401 -49 -402 -55 -402 -52 b -224 172 -398 -43 -228 167 b -219 173 -223 172 -220 173 "},v1f:{x_min:-340.28125,x_max:338.921875,ha:346,o:"m -32 520 b -29 521 -31 520 -31 521 b -23 519 -27 521 -24 520 b -20 513 -21 517 -20 516 b -21 506 -20 512 -20 509 b -31 474 -23 502 -27 488 l -53 402 l -66 352 l -68 349 l -57 349 b -32 351 -51 349 -40 351 b 123 370 19 352 74 359 b 137 371 127 370 133 371 b 170 356 152 371 164 366 b 171 355 170 355 170 355 b 216 366 174 355 183 358 b 280 378 268 377 266 377 b 287 378 283 378 284 378 b 332 349 307 378 322 369 b 338 319 336 341 338 330 b 332 301 338 310 336 302 b 242 280 329 299 246 280 b 242 280 242 280 242 280 b 235 288 236 280 235 283 b 235 292 235 290 235 291 b 236 302 236 297 236 299 b 220 337 236 316 230 330 l 216 340 l 210 335 b 159 276 189 322 172 301 b 118 149 152 265 156 274 b 81 34 84 36 85 36 b -8 13 78 33 -4 13 b -8 13 -8 13 -8 13 b -14 20 -12 15 -14 15 b -8 44 -14 24 -12 31 b -2 66 -5 55 -2 65 b -2 66 -2 66 -2 66 l -2 66 b -43 41 -2 66 -21 55 b -114 4 -98 8 -98 8 b -144 0 -123 0 -134 0 b -242 99 -197 0 -242 43 b -242 109 -242 102 -242 105 b -212 219 -240 122 -242 116 b -185 312 -197 270 -185 312 l -185 312 b -189 312 -185 312 -186 312 b -259 312 -200 312 -227 312 b -321 310 -291 312 -310 310 b -334 312 -330 310 -334 312 b -340 319 -338 313 -340 316 b -336 326 -340 322 -338 324 b -291 337 -334 326 -314 331 l -247 347 l -210 348 b -172 348 -190 348 -172 348 b -168 363 -172 348 -171 355 b -145 442 -151 424 -145 441 b -133 452 -144 444 -140 446 l -77 489 b -32 520 -53 506 -32 520 m 57 334 b 53 335 55 335 54 335 b 44 334 50 335 49 335 b -70 316 8 326 -28 320 b -78 309 -78 316 -78 316 b -108 202 -80 305 -88 274 b -141 81 -136 112 -141 93 b -140 74 -141 79 -141 77 b -117 49 -137 59 -127 49 b -107 52 -114 49 -110 51 b 16 127 -106 54 14 126 b 42 217 16 127 42 215 b 49 241 42 222 44 229 b 73 320 53 251 73 317 b 57 334 73 327 65 333 "},v20:{x_min:-571.671875,x_max:570.3125,ha:582,o:"m -559 351 b -551 352 -556 352 -553 352 b -530 338 -543 352 -533 348 b -529 169 -530 337 -529 291 l -529 1 l -507 27 l -441 112 b -382 174 -394 169 -390 174 b -378 174 -381 174 -379 174 b -281 86 -370 174 -375 179 b -196 0 -234 37 -196 0 b -126 84 -196 0 -164 37 b -50 174 -55 173 -57 172 b -44 174 -49 174 -47 174 b -35 173 -42 174 -38 173 b 53 86 -32 172 -12 151 b 138 0 100 37 138 0 b 208 84 140 0 170 37 b 284 174 279 173 279 172 b 289 174 285 174 288 174 b 300 173 294 174 298 173 b 462 11 303 172 340 134 l 475 -1 l 503 34 b 541 76 534 72 536 74 b 548 77 544 77 545 77 b 570 56 560 77 570 68 b 567 48 570 54 568 51 b 392 -172 564 41 397 -166 b 378 -176 387 -174 382 -176 b 368 -174 375 -176 371 -176 b 280 -87 367 -173 347 -152 b 194 0 234 -38 194 0 b 126 -86 194 0 163 -38 b 49 -174 54 -174 55 -173 b 44 -176 47 -176 46 -176 b 34 -174 40 -176 36 -174 b -54 -87 31 -173 10 -152 b -140 0 -102 -38 -140 0 b -209 -86 -140 0 -171 -38 b -285 -174 -280 -174 -279 -173 b -291 -176 -287 -176 -288 -176 b -300 -174 -294 -176 -298 -174 b -464 -11 -303 -173 -374 -102 l -476 0 l -506 -37 b -539 -76 -528 -65 -537 -74 b -551 -80 -543 -79 -547 -80 b -570 -68 -558 -80 -566 -76 l -571 -65 l -571 136 b -570 340 -571 331 -571 337 b -559 351 -568 344 -564 348 "},v22:{x_min:0,x_max:432.828125,ha:442,o:"m 209 186 b 213 187 210 187 212 187 b 216 187 215 187 216 187 b 224 174 216 186 220 180 b 420 -1 269 105 338 43 b 432 -12 431 -8 432 -9 b 421 -23 432 -15 432 -16 b 228 -180 345 -70 264 -137 b 219 -188 221 -188 221 -188 l 219 -188 b 208 -177 215 -188 215 -188 b 10 1 163 -106 93 -44 b 0 11 0 6 0 8 b 10 22 0 13 0 15 b 202 179 87 69 167 136 b 209 186 206 183 209 186 "},v23:{x_min:0,x_max:133.390625,ha:136,o:"m 54 66 b 65 68 58 68 61 68 b 122 37 88 68 110 56 b 133 -1 130 26 133 12 b 104 -58 133 -23 123 -44 b 66 -69 92 -65 78 -69 b 10 -38 44 -69 23 -58 b 0 -1 2 -27 0 -13 b 54 66 0 30 20 61 "},v25:{x_min:0,x_max:318.5,ha:325,o:"m 20 376 b 167 377 23 377 96 377 b 296 376 231 377 294 377 b 318 347 311 371 318 359 b 296 316 318 333 311 320 b 159 315 294 315 227 315 b 21 316 91 315 24 315 b 0 345 6 320 0 333 b 20 376 0 359 6 371 "},v26:{x_min:-21.78125,x_max:483.1875,ha:493,o:"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 383 20 616 20 616 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 179 164 199 187 192 l 210 176 l 210 396 l 210 617 l 212 621 b 231 632 216 628 223 632 b 250 620 239 632 247 628 b 251 383 251 616 251 616 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 201 l -21 616 l -20 620 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "},v27:{x_min:0,x_max:432.828125,ha:442,o:"m 208 184 b 213 187 209 186 212 187 b 224 176 217 187 221 183 b 245 147 225 172 235 159 b 419 -1 288 90 347 38 b 431 -8 424 -4 431 -8 b 432 -12 432 -9 432 -11 b 430 -18 432 -13 432 -16 b 364 -61 424 -20 383 -47 b 225 -183 307 -102 250 -152 b 223 -187 224 -184 223 -187 b 220 -188 221 -188 220 -188 b 208 -176 216 -188 210 -184 b 187 -148 205 -173 197 -159 b 12 0 144 -90 84 -38 b 0 11 4 5 0 8 b 16 24 0 13 4 18 b 183 158 83 69 141 115 b 208 184 194 169 198 173 m 183 105 b 176 113 181 109 176 113 b 172 109 176 113 175 112 b 92 45 149 90 117 62 l 88 41 l 102 31 b 247 -105 160 -6 210 -55 l 254 -115 l 257 -112 l 269 -102 b 340 -45 287 -87 319 -61 l 344 -43 l 330 -33 b 183 105 272 6 221 54 "},v28:{x_min:-73.5,x_max:72.140625,ha:74,o:"m -72 252 l -73 254 l 0 254 l 72 254 l 70 252 b 0 -1 70 248 0 -1 b -72 252 -1 -1 -72 248 "},v29:{x_min:-590.71875,x_max:589.359375,ha:601,o:"m 175 273 b 182 274 178 273 181 274 b 202 262 190 274 198 269 b 204 158 204 259 204 259 l 204 56 l 250 112 b 303 174 296 172 298 172 b 308 174 304 174 307 174 b 318 173 313 174 317 173 b 481 11 322 172 357 134 l 494 -1 l 522 34 b 560 76 553 72 555 74 b 567 77 563 77 564 77 b 589 56 579 77 589 68 b 586 48 589 54 588 51 b 411 -172 583 41 416 -166 b 397 -176 406 -174 401 -176 b 387 -174 393 -176 390 -176 b 299 -87 386 -173 366 -152 b 213 0 253 -38 213 0 b 208 -6 213 0 210 -2 l 204 -12 l 204 -147 b 204 -210 204 -173 204 -194 b 198 -292 204 -297 204 -287 b 183 -299 194 -297 189 -299 b 164 -287 175 -299 167 -295 b 163 -174 163 -284 163 -284 l 161 -63 l 119 -117 b 65 -176 76 -170 73 -176 b 61 -176 63 -176 62 -176 b -35 -87 51 -174 57 -180 b -121 0 -83 -38 -121 0 b -190 -86 -122 0 -152 -38 b -266 -174 -261 -174 -259 -173 b -272 -176 -268 -176 -270 -176 b -281 -174 -276 -176 -280 -174 b -371 -86 -284 -173 -304 -152 b -457 0 -417 -38 -457 0 l -457 0 b -477 -26 -457 0 -470 -16 b -548 -227 -524 -88 -548 -161 b -536 -303 -548 -254 -544 -280 b -533 -317 -534 -309 -533 -313 b -553 -338 -533 -330 -541 -338 b -577 -315 -566 -338 -571 -333 b -590 -227 -586 -287 -590 -258 b -518 -9 -590 -154 -564 -77 b -465 56 -509 2 -504 8 l -402 134 b -363 174 -374 170 -371 174 b -359 174 -362 174 -360 174 b -262 86 -351 174 -356 179 b -176 0 -216 37 -176 0 b -107 84 -176 0 -145 37 b -31 174 -36 173 -38 172 b -25 174 -29 174 -28 174 b -16 173 -23 174 -19 173 b 147 11 -13 172 35 123 l 157 -1 l 160 1 l 163 4 l 163 130 b 164 260 163 256 163 258 b 175 273 166 266 170 270 "},v2a:{x_min:-21.78125,x_max:366.140625,ha:374,o:"m 276 1378 b 284 1379 279 1379 281 1379 b 306 1360 292 1379 298 1374 b 352 1247 326 1326 343 1286 b 366 1139 362 1213 366 1175 b 347 1009 366 1093 359 1049 l 344 1002 l 347 992 b 352 971 348 986 351 977 b 366 863 362 936 366 899 b 347 732 366 818 359 773 l 344 725 l 347 716 b 352 695 348 710 351 700 b 366 588 362 659 366 623 b 223 262 366 464 314 345 b 189 233 212 252 212 252 b 35 76 126 183 73 129 b -1 16 20 56 2 27 b -19 4 -4 9 -12 4 l -21 4 l -21 137 l -21 270 l -17 270 b 186 344 59 281 134 308 b 319 606 270 399 319 499 b 317 650 319 620 319 635 l 315 659 l 314 655 b 223 537 288 607 258 570 b 189 509 212 528 212 528 b 35 352 126 459 73 405 b -1 292 20 333 2 303 b -19 280 -4 285 -12 280 l -21 280 l -21 413 l -21 546 l -17 546 b 186 620 59 557 134 584 b 319 882 270 675 319 775 b 317 925 319 896 319 911 l 315 935 l 314 931 b 223 813 288 884 258 846 b 189 785 212 805 212 805 b 35 628 126 735 73 681 b -1 569 20 609 2 580 b -19 556 -4 562 -12 556 l -21 556 l -21 689 l -21 823 l -17 823 b 202 907 68 835 152 867 b 319 1157 280 968 319 1061 b 270 1338 319 1218 303 1281 b 262 1358 264 1349 262 1353 b 262 1364 262 1360 262 1363 b 276 1378 265 1371 269 1376 "},v2c:{x_min:-597.53125,x_max:596.171875,ha:608,o:"m -413 173 b -408 174 -412 174 -409 174 b -397 173 -404 174 -400 173 b -308 86 -394 172 -374 151 b -223 0 -261 37 -223 0 b -153 84 -223 0 -191 37 b -77 174 -83 173 -84 172 b -72 174 -76 174 -74 174 b -62 173 -68 174 -63 173 b 25 86 -59 172 -39 151 b 112 0 73 37 111 0 b 181 84 112 0 144 37 b 257 174 251 173 251 172 b 262 174 258 174 261 174 b 273 173 266 174 270 173 b 436 9 276 172 347 101 l 447 -1 l 477 36 b 522 79 511 79 513 79 l 522 79 b 552 51 533 79 539 73 b 596 -112 582 6 596 -51 b 567 -262 596 -161 586 -213 b 539 -322 558 -287 544 -316 b 524 -327 534 -326 529 -327 b 504 -315 515 -327 507 -323 b 503 -308 503 -312 503 -309 b 511 -285 503 -302 504 -297 b 555 -113 540 -227 555 -169 b 544 -34 555 -86 551 -59 b 522 19 540 -16 530 8 l 521 22 l 481 -26 l 405 -122 b 353 -176 366 -172 362 -176 b 349 -176 352 -176 351 -176 b 253 -87 341 -176 347 -180 b 167 0 206 -38 167 0 b 99 -86 167 0 136 -38 b 21 -174 27 -174 28 -173 b 17 -176 20 -176 19 -176 b 6 -174 13 -176 9 -174 b -81 -87 4 -173 -14 -152 b -167 0 -129 -38 -167 0 b -236 -86 -167 0 -198 -38 b -313 -174 -307 -174 -306 -173 b -318 -176 -314 -176 -315 -176 b -328 -174 -321 -176 -325 -174 b -491 -12 -330 -173 -367 -137 l -503 0 l -530 -34 b -570 -77 -562 -73 -564 -76 b -577 -79 -571 -79 -574 -79 b -597 -58 -588 -79 -597 -69 b -596 -49 -597 -55 -597 -52 b -417 172 -593 -43 -423 167 b -413 173 -417 172 -415 173 "},v2d:{x_min:0,x_max:438.28125,ha:447,o:"m 212 190 b 219 191 213 191 216 191 b 236 176 225 191 228 190 b 419 18 277 105 341 49 b 436 5 431 13 434 11 b 438 -1 438 4 438 1 b 424 -16 438 -8 432 -13 b 356 -49 409 -20 379 -36 b 234 -180 306 -83 258 -133 b 219 -192 230 -188 224 -192 b 200 -176 213 -192 206 -187 b 9 -15 157 -102 89 -45 b 0 0 2 -12 0 -6 b 16 18 0 9 2 12 b 200 176 93 48 159 104 b 212 190 205 186 208 188 m 239 113 b 236 117 238 116 238 117 b 230 108 235 117 234 115 b 92 -15 196 58 140 8 b 88 -18 91 -16 88 -18 b 92 -20 88 -18 91 -19 b 198 -116 130 -43 166 -74 b 200 -117 200 -117 200 -117 b 201 -117 200 -117 201 -117 b 264 -43 212 -98 242 -62 b 345 15 288 -19 321 4 b 348 18 347 16 348 16 b 344 20 348 18 347 19 b 239 113 307 41 266 79 "},v2f:{x_min:-1.359375,x_max:680.5625,ha:694,o:"m 597 1042 b 604 1042 600 1042 602 1042 b 642 1002 627 1042 642 1022 b 619 966 642 988 635 974 b 439 927 574 942 503 927 l 426 927 l 426 921 b 430 838 428 893 430 866 b 345 480 430 696 398 560 b 179 391 307 423 249 391 b 156 392 171 391 164 392 b 138 394 149 394 142 394 b 103 434 115 396 103 416 b 129 471 103 451 111 466 b 141 474 133 473 137 474 b 172 459 153 474 164 469 b 181 455 175 456 176 455 b 187 456 182 455 185 455 b 253 520 212 460 234 483 b 315 836 294 605 315 714 b 311 928 315 867 314 898 b 302 945 310 943 311 942 b 245 953 283 950 262 953 b 130 891 193 953 149 931 b 84 860 119 870 102 860 b 36 905 61 860 39 877 b 36 910 36 907 36 909 b 80 970 36 931 50 949 b 249 1017 125 1000 187 1017 b 322 1009 273 1017 299 1014 l 341 1003 b 436 991 372 995 406 991 b 577 1031 495 991 545 1004 b 597 1042 583 1038 590 1041 m 416 360 b 424 360 419 360 421 360 b 481 309 454 360 479 338 b 503 145 484 280 495 199 b 585 -185 525 16 555 -106 b 630 -245 596 -213 613 -237 l 634 -247 l 638 -245 b 647 -244 641 -245 645 -244 b 680 -278 666 -244 680 -262 b 664 -308 680 -290 675 -301 b 638 -312 658 -310 650 -312 b 613 -309 631 -312 623 -310 b 477 -201 555 -303 502 -260 b 417 -2 460 -159 434 -72 b 416 5 417 1 416 5 b 416 5 416 5 416 5 b 411 -5 415 5 413 0 b 359 -97 397 -33 377 -70 b 353 -106 355 -102 353 -105 b 359 -112 353 -108 355 -109 b 409 -130 375 -123 390 -129 b 426 -134 420 -130 421 -131 b 431 -147 428 -137 431 -141 b 420 -162 431 -152 427 -159 b 382 -169 409 -166 396 -169 b 323 -155 363 -169 341 -165 l 317 -152 l 314 -155 b 62 -303 240 -240 148 -295 b 36 -305 55 -305 44 -305 b 23 -303 29 -305 24 -305 b -1 -273 6 -299 -1 -287 b 31 -240 -1 -256 10 -240 b 36 -240 32 -240 34 -240 b 42 -241 38 -241 39 -241 b 134 -204 63 -241 99 -226 b 367 288 265 -115 357 81 b 375 330 368 313 370 320 b 416 360 383 347 400 358 m 360 -359 b 379 -359 363 -359 371 -359 b 424 -360 396 -359 416 -359 b 646 -502 536 -373 624 -430 b 649 -527 649 -510 649 -519 b 530 -673 649 -578 604 -635 l 521 -677 l 529 -681 b 653 -811 592 -714 637 -762 b 660 -853 658 -827 660 -839 b 645 -911 660 -873 656 -892 b 426 -1021 608 -981 519 -1021 b 283 -989 377 -1021 328 -1011 b 235 -949 249 -972 239 -964 b 234 -936 234 -946 234 -941 b 234 -928 234 -934 234 -931 l 235 -925 l 234 -927 l 225 -934 b 87 -982 186 -966 138 -982 b 80 -982 85 -982 83 -982 b 55 -981 70 -981 58 -981 b 17 -943 32 -981 17 -964 b 54 -904 17 -921 35 -904 b 78 -914 62 -904 72 -909 l 83 -918 l 88 -918 b 190 -831 122 -918 166 -881 b 269 -506 242 -727 269 -612 b 268 -462 269 -492 269 -477 b 266 -449 266 -458 266 -452 b 265 -444 266 -445 266 -444 b 257 -446 264 -444 261 -445 b 132 -545 196 -470 152 -505 b 88 -573 122 -563 104 -573 b 39 -523 63 -573 39 -553 b 63 -476 39 -505 44 -494 b 360 -359 136 -408 235 -369 m 419 -424 b 393 -423 411 -423 406 -423 l 375 -423 l 377 -426 b 379 -439 377 -427 378 -434 b 383 -510 382 -463 383 -487 b 314 -811 383 -609 360 -710 b 266 -893 296 -850 285 -870 b 264 -898 265 -896 264 -898 l 264 -898 b 264 -898 264 -898 264 -898 b 268 -898 264 -898 266 -898 b 273 -898 270 -898 272 -898 b 300 -909 283 -898 291 -900 b 426 -957 340 -941 385 -957 b 476 -949 443 -957 460 -954 b 547 -853 522 -931 547 -893 b 485 -745 547 -816 526 -775 b 397 -707 460 -727 432 -714 b 366 -675 375 -703 366 -692 b 396 -642 366 -657 377 -645 b 530 -557 455 -637 511 -601 b 536 -527 534 -548 536 -537 b 419 -424 536 -480 490 -437 "},v30:{x_min:-21.78125,x_max:367.5,ha:375,o:"m 276 1900 b 284 1901 279 1900 281 1901 b 306 1883 291 1901 298 1896 b 367 1686 347 1825 367 1757 b 343 1558 367 1643 359 1600 l 338 1549 l 343 1537 b 367 1411 359 1497 367 1454 b 343 1282 367 1367 359 1324 l 338 1272 l 343 1261 b 367 1135 359 1221 367 1178 b 343 1007 367 1090 359 1047 l 338 996 l 343 985 b 367 859 359 945 367 902 b 343 731 367 814 359 771 l 338 720 l 343 709 b 367 582 359 667 367 626 b 289 362 367 503 340 426 b 239 312 276 345 259 330 b 29 77 152 237 76 152 b -1 18 14 54 2 30 b -19 4 -4 11 -12 4 l -21 4 l -21 133 l -20 260 l -13 262 b 98 299 17 269 62 284 b 111 305 103 302 110 305 b 167 334 123 310 156 327 b 319 595 264 391 319 491 b 313 659 319 616 318 638 b 310 667 311 664 311 667 b 307 663 310 667 308 666 b 240 588 289 637 269 614 b 16 331 141 505 62 413 b -1 294 8 316 1 302 b -19 280 -4 287 -12 280 l -21 280 l -21 408 l -20 537 l -13 538 b 98 576 17 545 62 560 b 111 581 103 578 110 581 b 167 610 123 587 156 603 b 319 871 264 667 319 767 b 313 935 319 892 318 913 b 310 942 311 941 311 942 b 307 939 310 942 308 941 b 240 864 289 913 269 889 b 16 607 141 781 62 689 b -1 570 8 592 1 578 b -19 556 -4 563 -12 556 l -21 556 l -21 684 l -20 813 l -13 814 b 98 852 17 821 62 836 b 111 857 103 855 110 857 b 167 886 123 863 156 880 b 319 1147 264 943 319 1043 b 313 1211 319 1168 318 1189 b 310 1218 311 1217 311 1218 b 307 1215 310 1218 308 1217 b 240 1140 289 1188 269 1165 b 16 884 141 1057 62 966 b -1 846 8 868 1 855 b -19 832 -4 839 -12 832 l -21 832 l -21 960 l -20 1089 l -13 1090 b 98 1128 17 1097 62 1111 b 111 1134 103 1131 110 1134 b 167 1163 123 1139 156 1156 b 319 1424 264 1220 319 1320 b 313 1486 319 1444 318 1465 b 310 1494 311 1493 311 1494 b 307 1492 310 1494 308 1493 b 240 1417 289 1464 269 1442 b 16 1160 141 1333 62 1242 b -1 1121 8 1145 1 1131 b -19 1109 -4 1115 -12 1109 l -21 1109 l -21 1236 l -20 1365 l -13 1367 b 98 1404 17 1374 62 1388 b 111 1410 103 1407 110 1410 b 250 1508 172 1437 215 1467 b 319 1701 296 1564 319 1633 b 270 1859 319 1757 303 1814 b 262 1882 265 1868 262 1875 b 276 1900 262 1890 266 1896 "},v31:{x_min:0,x_max:386.5625,ha:394,o:"m 0 173 l 0 347 l 193 347 l 386 347 l 386 173 l 386 0 l 193 0 l 0 0 l 0 173 "},v33:{x_min:-423.3125,x_max:421.9375,ha:431,o:"m -10 276 b -2 277 -8 277 -5 277 b 17 265 5 277 13 273 b 19 163 19 260 19 260 l 19 68 l 39 45 b 277 -95 122 -34 200 -81 b 289 -97 281 -97 285 -97 b 378 0 332 -97 371 -54 b 378 11 378 4 378 6 b 302 83 378 55 345 83 b 242 66 283 83 262 77 b 208 56 231 59 219 56 b 148 120 175 56 148 81 b 200 186 148 151 164 172 b 261 198 220 194 240 198 b 420 45 341 198 411 137 b 421 22 421 37 421 29 b 257 -198 421 -86 347 -188 b 242 -198 251 -198 247 -198 b 20 -105 181 -198 95 -163 l 19 -104 l 19 -183 b 19 -216 19 -195 19 -206 b 12 -273 19 -272 17 -267 b -2 -278 8 -277 2 -278 b -21 -266 -10 -278 -19 -274 b -23 -165 -23 -263 -23 -262 l -23 -69 l -44 -47 b -250 86 -117 23 -183 66 b -295 94 -270 93 -284 94 b -315 91 -302 94 -308 94 b -381 5 -356 81 -381 43 b -355 -56 -381 -16 -372 -40 b -299 -81 -338 -73 -319 -81 b -246 -68 -283 -81 -265 -77 b -212 -58 -234 -61 -223 -58 b -168 -77 -196 -58 -179 -65 b -151 -122 -156 -90 -151 -105 b -179 -174 -151 -141 -160 -162 b -239 -195 -194 -184 -217 -192 b -257 -197 -245 -195 -250 -197 b -423 -5 -349 -197 -423 -113 b -423 0 -423 -4 -423 -1 b -277 194 -420 97 -362 173 b -247 197 -268 197 -258 197 b -24 104 -185 197 -100 162 l -23 102 l -23 181 b -21 265 -23 260 -23 260 b -10 276 -20 269 -14 274 "},v34:{x_min:0,x_max:622.03125,ha:635,o:"m 398 417 b 406 419 401 419 404 419 b 427 398 417 419 427 409 b 427 391 427 395 427 392 b 34 -274 424 385 38 -272 b 20 -280 29 -278 25 -280 b 0 -259 9 -280 0 -270 b 0 -252 0 -256 0 -254 b 393 413 2 -247 389 410 b 398 417 394 415 397 416 m 592 417 b 600 419 594 419 597 419 b 622 398 611 419 622 409 b 620 391 622 395 620 392 b 227 -274 617 385 231 -272 b 213 -280 223 -278 219 -280 b 193 -259 202 -280 193 -270 b 194 -252 193 -256 193 -254 b 586 413 196 -247 582 410 b 592 417 588 415 590 416 "},v36:{x_min:-1.359375,x_max:1064.390625,ha:1086,o:"m 296 692 b 314 694 302 694 307 694 b 386 685 337 694 366 689 b 548 498 480 660 548 580 b 548 481 548 492 548 487 b 455 395 541 426 499 395 b 370 462 420 395 383 417 b 362 496 364 477 362 488 b 377 514 362 509 367 514 b 393 501 386 514 390 510 b 432 474 397 484 413 474 b 470 487 445 474 458 478 b 491 530 484 496 491 510 b 490 544 491 534 491 539 b 333 660 479 606 411 657 l 323 662 l 315 646 b 269 524 285 591 269 556 b 321 431 269 492 287 466 b 349 395 338 413 343 408 b 363 342 359 378 363 362 b 359 312 363 333 362 322 b 285 158 348 266 318 206 b 281 152 283 155 281 152 b 281 152 281 152 281 152 b 287 154 283 152 284 152 b 318 155 298 154 308 155 b 461 98 371 155 419 136 l 464 97 l 483 112 b 503 129 494 120 503 127 b 504 130 503 129 504 129 b 503 138 504 131 503 134 b 500 180 500 152 500 166 b 553 326 500 238 518 288 b 604 366 560 331 592 358 b 649 381 617 376 632 381 b 696 362 665 381 681 374 b 724 302 714 347 724 324 b 695 238 724 278 714 255 b 660 210 691 234 662 212 b 579 148 658 209 582 151 b 579 148 579 148 579 148 b 596 106 579 144 589 119 b 622 77 604 88 609 83 b 657 69 632 72 645 69 b 748 112 688 69 721 84 b 755 123 754 117 755 120 b 755 127 755 124 755 126 b 751 165 752 137 751 151 b 758 219 751 183 754 202 b 894 387 774 290 820 347 b 896 390 896 388 896 388 b 891 398 896 391 895 392 b 622 560 827 477 730 535 b 600 580 605 564 600 569 b 617 596 600 591 607 596 b 628 595 622 596 624 596 b 1057 248 846 552 1020 412 b 1064 191 1061 229 1064 209 b 922 0 1064 94 1005 9 b 902 -1 916 -1 909 -1 b 774 76 847 -1 800 26 b 769 83 770 81 770 83 b 769 81 769 83 769 83 b 627 -1 733 29 677 -1 b 548 27 597 -1 570 8 b 515 88 537 37 525 61 l 513 95 l 510 93 l 453 45 b 390 0 396 0 396 0 b 390 0 390 0 390 0 b 374 15 381 0 377 4 b 268 105 359 69 314 105 b 250 104 262 105 257 105 l 243 102 l 234 90 b 155 1 201 49 159 2 b 147 -1 152 0 149 -1 b 130 15 138 -1 130 6 b 132 20 130 18 132 19 b 136 31 133 22 134 27 b 220 131 149 74 178 109 b 231 137 225 134 230 136 b 302 278 280 202 302 244 b 265 335 302 299 295 309 b 209 442 234 363 213 402 b 209 455 209 446 209 451 b 279 648 209 502 232 564 l 285 659 l 283 659 b 176 627 238 653 210 645 b 57 477 111 594 66 538 b 55 459 55 471 55 464 b 72 409 55 437 61 415 b 93 403 78 405 87 403 b 152 467 123 403 151 431 b 168 488 153 483 157 488 b 185 462 181 488 185 483 l 185 460 b 137 344 183 409 168 369 b 78 322 119 328 98 322 b 13 360 50 322 25 335 b -1 426 4 380 -1 402 b 89 610 -1 488 32 559 b 296 692 147 659 210 685 m 926 348 b 921 353 924 351 922 353 b 914 348 920 353 918 351 b 823 167 857 306 823 237 b 828 124 823 154 826 138 b 890 31 837 79 862 40 b 896 31 892 31 894 31 b 956 104 916 31 940 59 b 970 191 965 129 970 159 b 966 241 970 208 969 224 b 926 348 959 277 945 313 m 627 326 b 619 326 624 326 622 326 b 598 316 611 326 604 323 b 568 215 579 288 568 255 b 568 208 568 213 568 210 b 571 183 570 195 570 184 l 571 183 b 594 201 571 183 582 191 l 634 231 b 660 259 653 247 656 248 b 664 278 662 266 664 272 b 627 326 664 299 649 320 "},v38:{x_min:-1.359375,x_max:651.96875,ha:665,o:"m 389 644 b 405 645 394 645 400 645 b 504 566 450 645 492 613 b 507 541 506 557 507 549 b 480 471 507 514 498 489 l 477 467 l 483 470 b 609 591 539 485 586 531 b 613 601 611 595 613 599 b 631 609 619 607 624 609 b 651 588 641 609 651 602 b 200 -946 651 584 204 -941 b 182 -957 197 -953 190 -957 b 163 -945 174 -957 166 -953 b 161 -939 161 -942 161 -942 b 217 -743 161 -931 170 -904 b 272 -555 247 -639 272 -555 b 272 -555 272 -555 272 -555 b 264 -560 272 -555 268 -557 b 140 -603 227 -589 182 -603 b 36 -567 102 -603 65 -592 b -1 -487 12 -548 -1 -517 b 17 -427 -1 -466 5 -445 b 103 -380 38 -395 70 -380 b 191 -433 137 -380 172 -398 b 205 -484 201 -448 205 -466 b 178 -553 205 -509 196 -535 l 175 -557 l 182 -555 b 307 -435 236 -539 284 -494 b 372 -213 308 -430 372 -215 b 372 -213 372 -213 372 -213 b 364 -219 372 -213 368 -216 b 240 -262 328 -247 283 -262 b 137 -226 202 -262 166 -249 b 99 -145 112 -206 99 -176 b 118 -84 99 -124 106 -104 b 204 -38 138 -54 171 -38 b 292 -91 238 -38 273 -56 b 306 -141 302 -106 306 -124 b 279 -212 306 -167 296 -194 l 276 -215 l 281 -213 b 408 -93 336 -198 385 -151 b 473 129 409 -88 473 127 b 473 129 473 129 473 129 b 465 122 473 129 469 126 b 341 80 428 94 383 80 b 236 115 303 80 266 91 b 200 195 213 136 200 165 b 217 256 200 217 206 238 b 304 303 239 287 272 303 b 393 249 338 303 374 285 b 406 199 402 234 406 217 b 379 129 406 173 397 148 l 377 126 l 382 127 b 509 248 436 142 485 190 b 574 470 510 254 574 469 b 574 470 574 470 574 470 b 566 464 574 470 570 467 b 442 421 529 435 484 421 b 337 458 404 421 367 433 b 300 537 313 478 300 508 b 389 644 300 585 334 635 "},v39:{x_min:-171.5,x_max:251.8125,ha:257,o:"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 553 20 616 20 614 b 20 491 20 503 20 491 l 20 491 b 153 535 47 501 149 535 b 174 514 167 535 174 524 b 164 496 174 508 171 501 b 92 470 164 495 132 484 l 20 445 l 20 390 b 20 363 20 378 20 370 b 20 333 20 340 20 333 l 20 333 b 153 377 47 344 149 377 b 174 356 167 377 174 367 b 164 338 174 349 171 342 b 92 312 164 338 132 326 l 20 288 l 20 219 l 20 148 l 21 151 b 137 199 59 183 99 199 b 182 191 152 199 167 197 b 251 84 227 176 251 134 b 228 0 251 58 243 29 b 100 -142 206 -40 178 -72 l 23 -215 b -1 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 b -21 30 -21 -212 -21 -212 b -21 273 -21 163 -21 273 b -84 252 -21 273 -50 263 b -152 230 -133 234 -145 230 b -157 231 -155 230 -156 231 b -171 252 -166 234 -171 244 b -160 270 -171 259 -167 266 b -27 316 -159 270 -93 294 l -21 319 l -21 374 b -21 431 -21 406 -21 431 b -84 409 -21 431 -50 421 b -152 388 -133 392 -145 388 b -157 390 -155 388 -156 388 b -171 409 -166 392 -171 401 b -160 428 -171 417 -167 424 b -27 474 -159 428 -93 451 l -21 476 l -21 546 b -20 620 -21 614 -21 616 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 "},v3b:{x_min:0,x_max:484.5625,ha:494,o:"m 228 245 b 239 247 234 247 239 247 b 243 247 240 247 242 247 b 303 238 257 247 287 242 b 484 -2 417 208 484 104 b 412 -177 484 -65 461 -127 b 243 -248 363 -226 303 -248 b 6 -63 138 -248 36 -180 b 0 -1 1 -41 0 -20 b 228 245 0 127 98 240 m 255 181 b 240 183 247 183 245 183 b 232 181 238 183 235 183 b 142 152 200 180 168 170 l 138 149 l 190 97 l 242 44 l 294 97 l 345 149 l 340 152 b 255 181 315 169 284 180 m 147 -54 l 197 -1 l 147 51 l 95 104 l 91 99 b 62 -1 72 70 62 34 b 66 -43 62 -15 63 -29 b 91 -101 72 -63 80 -84 l 95 -106 l 147 -54 m 393 99 b 389 104 390 102 389 104 b 337 51 389 104 366 80 l 285 -1 l 337 -54 l 389 -106 l 393 -101 b 421 -1 412 -72 421 -36 b 393 99 421 34 412 69 m 294 -98 b 242 -45 265 -69 242 -45 b 190 -98 242 -45 219 -69 l 138 -151 l 142 -154 b 242 -184 172 -174 206 -184 b 340 -154 276 -184 311 -174 l 345 -151 l 294 -98 "},v3c:{x_min:0,x_max:450.53125,ha:460,o:"m 189 302 b 204 303 193 302 198 303 b 303 224 250 303 292 270 b 306 199 304 216 306 208 b 279 129 306 173 296 147 l 276 126 l 281 127 b 408 249 337 142 385 190 b 412 259 409 254 412 258 b 430 267 417 265 423 267 b 450 247 441 267 450 259 b 200 -605 450 242 204 -599 b 182 -616 197 -612 190 -616 b 163 -602 174 -616 166 -610 b 161 -598 161 -601 161 -601 b 217 -402 161 -589 170 -562 b 272 -213 247 -298 272 -213 b 272 -213 272 -213 272 -213 b 264 -219 272 -213 268 -216 b 140 -262 227 -247 182 -262 b 36 -226 102 -262 65 -249 b 0 -145 12 -206 0 -176 b 17 -84 0 -124 5 -104 b 103 -38 38 -54 70 -38 b 191 -91 137 -38 172 -56 b 205 -141 201 -106 205 -124 b 178 -212 205 -167 196 -194 l 175 -215 l 182 -213 b 307 -93 236 -198 284 -151 b 372 129 308 -88 372 127 b 372 129 372 129 372 129 b 364 122 372 129 368 126 b 240 80 328 94 283 80 b 137 115 202 80 166 91 b 99 194 111 136 99 165 b 189 302 99 244 133 292 "},v3e:{x_min:0,x_max:406.96875,ha:415,o:"m 21 183 b 28 183 24 183 25 183 b 42 181 34 183 39 183 b 127 108 47 179 47 179 b 202 41 168 72 202 41 b 279 108 204 41 238 72 b 357 177 321 145 356 176 b 375 183 363 181 370 183 b 406 151 392 183 406 169 b 404 137 406 147 405 141 b 322 62 401 131 398 129 b 251 0 284 27 251 0 b 322 -63 251 -1 284 -29 b 404 -138 398 -130 401 -133 b 406 -152 405 -142 406 -148 b 375 -184 406 -170 392 -184 b 357 -179 370 -184 363 -183 b 279 -109 356 -177 321 -147 b 202 -43 238 -73 204 -43 b 127 -109 202 -43 168 -73 b 49 -179 85 -147 50 -177 b 31 -184 43 -183 36 -184 b 0 -152 13 -184 0 -170 b 2 -138 0 -148 0 -142 b 83 -63 5 -133 8 -130 b 155 0 122 -29 155 -1 b 83 62 155 0 122 27 b 8 129 43 97 10 127 b 0 151 2 136 0 144 b 21 183 0 165 8 177 "},v3f:{x_min:-24.5,x_max:317.140625,ha:324,o:"m -24 -147 l -24 -5 l -20 -5 b -1 -19 -12 -5 -4 -11 b 58 -123 6 -43 31 -86 b 196 -278 93 -173 134 -219 b 317 -570 274 -356 317 -460 b 294 -713 317 -617 308 -666 l 289 -724 l 294 -735 b 317 -873 308 -780 317 -827 b 235 -1132 317 -963 288 -1054 b 209 -1165 228 -1140 224 -1146 b 189 -1177 204 -1172 196 -1177 b 171 -1164 182 -1177 175 -1172 b 168 -1154 170 -1161 168 -1159 b 181 -1132 168 -1149 172 -1142 b 269 -891 238 -1064 269 -975 b 269 -881 269 -886 269 -884 b 262 -814 269 -857 265 -827 b 258 -800 261 -811 259 -806 b 142 -628 240 -731 198 -667 b -8 -589 112 -606 47 -589 b -20 -589 -13 -589 -19 -589 l -24 -589 l -24 -449 l -24 -308 l -20 -308 b -1 -322 -12 -308 -4 -313 b 58 -424 6 -345 31 -388 b 194 -580 93 -476 136 -523 b 259 -660 221 -606 245 -635 b 261 -663 259 -662 261 -663 b 264 -656 262 -663 262 -660 b 269 -587 268 -632 269 -610 b 264 -521 269 -566 268 -544 b 262 -512 264 -517 262 -513 b 258 -498 261 -509 259 -503 b 142 -326 240 -428 198 -365 b -8 -287 112 -303 47 -288 b -20 -287 -13 -287 -19 -287 l -24 -287 l -24 -147 "},v40:{x_min:-1.359375,x_max:436.921875,ha:446,o:"m 213 205 b 217 205 215 205 216 205 b 234 194 224 205 234 199 b 236 187 234 194 235 190 l 245 167 l 261 129 l 270 106 b 355 -61 294 54 329 -13 b 420 -163 381 -105 402 -138 b 436 -188 435 -184 436 -184 b 436 -191 436 -190 436 -190 b 421 -206 436 -201 431 -206 l 421 -206 l 416 -206 l 405 -201 b 217 -158 347 -172 283 -158 b 31 -201 153 -158 88 -172 l 20 -206 l 14 -206 l 14 -206 b 0 -191 5 -206 0 -201 b -1 -188 0 -190 -1 -190 b 14 -163 -1 -186 0 -184 b 95 -34 36 -136 72 -77 b 166 106 119 8 148 68 l 175 129 l 183 148 l 200 188 b 213 205 205 199 208 202 "},v41:{x_min:-1.359375,x_max:556.6875,ha:568,o:"m 294 322 b 318 323 299 322 308 323 b 360 320 334 323 352 322 b 526 217 430 310 490 273 b 543 166 537 202 543 184 b 447 70 543 117 503 70 b 445 70 447 70 446 70 b 359 159 394 72 359 113 b 368 201 359 173 362 187 b 442 245 382 229 412 245 b 455 244 446 245 451 245 b 460 244 458 244 460 244 b 460 244 460 244 460 244 b 454 248 460 244 458 245 b 325 291 417 276 372 291 b 285 287 313 291 299 290 b 144 -2 183 269 144 190 b 281 -290 144 -208 179 -280 b 304 -291 289 -291 298 -291 b 524 -105 412 -291 506 -212 b 541 -84 526 -88 530 -84 b 556 -101 551 -84 556 -90 b 549 -138 556 -111 553 -122 b 334 -322 521 -237 435 -310 b 302 -324 323 -323 313 -324 b 13 -101 172 -324 54 -234 b -1 -1 4 -68 -1 -34 b 294 322 -1 161 121 303 "},v42:{x_min:-348.4375,x_max:24.5,ha:25,o:"m -330 155 b -322 156 -329 156 -326 156 b -315 156 -319 156 -317 156 b -298 147 -311 155 -308 154 b -19 30 -224 98 -122 55 l 2 26 b 24 -1 17 22 24 13 b 2 -27 24 -15 17 -23 l -19 -31 b -298 -148 -122 -56 -224 -99 b -322 -158 -313 -158 -315 -158 b -348 -131 -338 -158 -348 -145 b -344 -117 -348 -127 -347 -122 b -328 -104 -341 -112 -338 -111 b -127 -8 -269 -65 -202 -33 b -106 0 -115 -4 -106 -1 b -127 6 -106 0 -115 2 b -328 102 -202 31 -269 63 b -344 116 -338 109 -341 111 b -348 130 -347 120 -348 124 b -330 155 -348 141 -341 152 "},v43:{x_min:-442.359375,x_max:441,ha:450,o:"m -31 487 b -1 488 -21 488 -10 488 b 434 104 216 488 397 330 b 441 27 438 79 441 47 b 439 12 441 20 439 15 b 419 0 435 4 427 0 b 404 5 413 0 408 1 b 398 30 400 11 398 13 b 0 351 390 213 213 351 b -59 348 -20 351 -39 349 b -400 30 -251 324 -393 191 b -405 5 -400 13 -401 11 b -420 0 -409 1 -415 0 b -441 12 -428 0 -436 4 b -442 27 -441 15 -442 20 b -435 104 -442 47 -439 79 b -31 487 -401 316 -235 474 m -13 131 b -1 133 -9 133 -5 133 b 51 105 19 133 39 123 b 61 70 58 95 61 83 b 51 34 61 58 58 45 b -1 6 39 16 19 6 b -46 27 -17 6 -34 13 b -62 69 -57 38 -62 54 b -13 131 -62 98 -44 124 "},v44:{x_min:-21.78125,x_max:251.8125,ha:257,o:"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 383 20 616 20 616 l 20 148 l 21 151 b 137 199 59 183 99 199 b 182 191 152 199 167 197 b 251 84 227 176 251 134 b 228 0 251 58 243 29 b 100 -142 206 -40 178 -72 l 23 -215 b 0 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 201 l -21 616 l -20 620 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 "},v45:{x_min:-402.890625,x_max:401.53125,ha:410,o:"m -10 273 b -4 274 -9 273 -6 274 b 16 262 4 274 12 269 b 17 158 17 259 17 259 l 17 56 l 62 112 b 117 174 110 172 110 172 b 122 174 118 174 119 174 b 132 173 125 174 129 173 b 295 11 134 172 171 134 l 307 -1 l 336 34 b 374 76 366 72 368 74 b 381 77 375 77 378 77 b 401 56 392 77 401 68 b 400 48 401 54 401 51 b 223 -172 397 41 230 -166 b 210 -176 220 -174 215 -176 b 201 -174 206 -176 204 -176 b 112 -87 198 -173 178 -152 b 27 0 65 -38 27 0 b 21 -6 27 0 24 -2 l 17 -12 l 17 -147 b 17 -210 17 -173 17 -194 b 10 -292 17 -297 16 -287 b -2 -299 6 -297 2 -299 b -21 -287 -10 -299 -19 -295 b -24 -174 -23 -284 -23 -284 l -24 -63 l -66 -117 b -121 -176 -110 -170 -114 -176 b -125 -176 -122 -176 -123 -176 b -296 -12 -134 -174 -125 -184 l -308 0 l -337 -34 b -375 -77 -367 -73 -370 -76 b -382 -79 -377 -79 -379 -79 b -402 -58 -393 -79 -402 -69 b -401 -49 -402 -55 -402 -52 b -224 170 -398 -43 -231 165 b -212 174 -221 173 -216 174 b -202 173 -208 174 -205 174 b -39 11 -200 172 -151 122 l -28 -1 l -25 1 l -24 4 l -24 130 b -23 260 -24 256 -24 258 b -10 273 -20 266 -16 270 "},v46:{x_min:0,x_max:627.46875,ha:640,o:"m 306 190 b 314 191 308 191 311 191 b 326 184 318 191 322 190 l 336 173 b 510 52 377 127 442 80 b 515 49 513 51 515 49 b 611 16 537 40 579 24 b 627 0 624 13 627 9 b 607 -18 627 -11 624 -13 b 330 -181 490 -49 389 -109 b 314 -192 323 -190 319 -192 b 306 -191 311 -192 308 -192 b 294 -177 302 -188 302 -188 b 257 -140 287 -170 265 -148 b 19 -18 193 -84 114 -44 b 0 0 2 -13 0 -11 b 16 16 0 9 2 13 b 110 49 47 24 89 40 b 117 52 111 49 114 51 b 145 65 126 56 130 58 b 281 163 200 93 245 124 b 300 186 288 170 291 174 b 306 190 300 187 303 188 m 317 137 b 313 142 315 141 314 142 b 308 137 313 142 311 141 b 161 4 276 84 220 33 b 155 0 159 1 155 0 b 163 -4 155 0 159 -2 b 308 -138 220 -34 276 -84 b 313 -142 311 -141 313 -142 b 317 -138 314 -142 315 -141 b 464 -4 351 -84 406 -34 b 470 0 468 -2 470 0 b 464 4 470 0 468 1 b 317 137 406 33 351 84 "},v47:{x_min:-24.5,x_max:315.78125,ha:322,o:"m -24 -145 l -24 -5 l -20 -5 b 1 -26 -10 -5 -6 -9 b 175 -241 31 -86 96 -166 b 314 -548 259 -323 304 -420 b 315 -589 315 -555 315 -571 b 314 -630 315 -606 315 -623 b 298 -730 311 -664 306 -699 l 295 -742 l 296 -748 b 314 -850 304 -778 311 -813 b 315 -892 315 -857 315 -874 b 314 -932 315 -909 315 -925 b 298 -1032 311 -967 306 -1002 l 295 -1045 l 296 -1050 b 314 -1153 304 -1081 311 -1115 b 315 -1193 315 -1160 315 -1177 b 314 -1235 315 -1211 315 -1228 b 217 -1526 306 -1338 270 -1444 b 201 -1533 213 -1532 208 -1533 b 182 -1522 193 -1533 185 -1529 b 179 -1514 181 -1518 179 -1517 b 189 -1489 179 -1508 182 -1501 b 266 -1217 240 -1403 266 -1308 b 262 -1156 266 -1196 265 -1177 b 110 -907 247 -1043 190 -950 b 0 -889 87 -895 50 -889 l -1 -889 l -24 -889 l -24 -749 l -24 -610 l -20 -610 b 1 -631 -10 -610 -6 -614 b 175 -846 31 -691 96 -771 b 259 -956 213 -884 236 -914 b 265 -966 262 -961 264 -966 b 265 -966 265 -966 265 -966 b 265 -953 265 -964 265 -959 b 266 -920 266 -943 266 -932 b 262 -853 266 -898 265 -873 b 110 -605 247 -741 190 -648 b 0 -587 87 -592 50 -587 l -1 -587 l -24 -587 l -24 -448 l -24 -308 l -20 -308 b 1 -328 -10 -308 -6 -312 b 175 -544 31 -388 96 -469 b 259 -655 213 -581 236 -612 b 265 -663 262 -659 264 -663 b 265 -663 265 -663 265 -663 b 265 -650 265 -663 265 -657 b 266 -617 266 -641 266 -630 b 262 -551 266 -595 265 -570 b 110 -303 247 -438 190 -345 b 0 -284 87 -290 50 -284 l -1 -284 l -24 -284 l -24 -145 "},v49:{x_min:0,x_max:630.203125,ha:643,o:"m 308 204 b 314 205 310 205 313 205 b 326 201 319 205 323 204 b 355 154 328 199 338 180 b 401 83 362 142 392 95 l 409 72 b 431 41 412 66 424 49 b 619 -174 498 -51 570 -134 b 630 -192 626 -180 630 -186 b 626 -202 630 -195 628 -199 b 616 -206 623 -205 620 -206 b 552 -188 608 -206 592 -202 b 310 -155 488 -169 392 -155 b 268 -156 295 -155 281 -155 b 77 -188 197 -161 126 -173 b 13 -206 35 -202 20 -206 b 9 -206 12 -206 10 -206 b 0 -191 2 -202 0 -197 b 8 -176 0 -186 2 -180 b 204 49 58 -136 138 -43 l 220 72 l 227 83 b 295 188 245 108 281 166 b 308 204 299 197 304 202 m 315 147 b 314 147 315 147 314 147 b 314 147 314 147 314 147 b 306 129 314 145 310 138 l 296 105 b 281 72 292 97 284 77 l 274 56 b 181 -123 247 -4 212 -72 l 174 -134 l 176 -133 b 314 -123 215 -127 272 -123 b 451 -133 356 -123 413 -127 l 454 -134 l 449 -123 b 353 56 417 -72 381 -4 l 347 72 b 332 105 344 77 336 97 l 322 129 b 315 147 318 138 315 145 "},v4a:{x_min:70.78125,x_max:378.390625,ha:315,o:"m 246 373 b 254 373 249 373 251 373 b 372 324 303 373 360 351 b 378 302 377 317 378 309 b 338 251 378 278 362 255 b 328 249 334 249 332 249 b 283 294 303 249 283 270 b 288 315 283 301 284 308 b 289 319 289 317 289 319 b 289 319 289 319 289 319 b 283 320 289 320 287 320 b 270 322 279 322 274 322 b 206 288 242 322 215 308 b 206 283 206 287 206 285 b 257 223 206 267 230 238 b 284 206 272 213 277 210 b 351 90 328 173 351 130 b 340 47 351 74 348 59 b 205 -30 314 -2 264 -30 b 182 -29 198 -30 190 -30 b 84 15 147 -24 103 -5 b 70 48 74 24 70 36 b 108 99 70 70 85 94 b 121 102 112 101 117 102 b 167 56 147 102 167 80 b 159 31 167 48 164 40 l 156 26 l 157 26 b 190 20 167 22 178 20 b 220 26 201 20 212 22 b 258 65 243 34 258 51 b 257 70 258 66 258 69 b 204 126 249 94 234 109 b 114 258 148 158 114 209 b 125 302 114 273 118 288 b 246 373 147 342 193 370 "},v4b:{x_min:0,x_max:503.609375,ha:514,o:"m 274 430 b 277 430 276 430 277 430 b 310 394 296 430 310 415 b 308 383 310 391 308 387 b 306 367 307 381 307 374 b 236 120 298 305 272 210 b 40 -273 189 -5 125 -134 b 20 -287 35 -283 27 -287 b 5 -281 14 -287 9 -285 b 0 -267 1 -277 0 -273 b 9 -242 0 -262 2 -255 b 246 395 137 -12 232 242 b 274 430 249 416 257 427 m 468 430 b 472 430 469 430 470 430 b 503 394 490 430 503 415 b 502 383 503 391 503 387 b 499 367 502 381 500 374 b 431 120 491 305 465 210 b 234 -273 382 -5 318 -134 b 213 -287 228 -283 220 -287 b 198 -281 208 -287 202 -285 b 193 -267 194 -277 193 -273 b 202 -242 193 -262 196 -255 b 439 395 330 -12 426 242 b 468 430 442 416 451 427 "},v4d:{x_min:-311.6875,x_max:310.328125,ha:317,o:"m -9 388 b -2 390 -8 390 -5 390 b 5 388 1 390 4 390 b 19 378 10 387 16 383 b 23 333 23 371 23 371 b 24 298 23 299 24 298 b 81 276 34 298 65 285 b 213 91 145 240 190 177 b 224 24 217 76 224 36 b 257 24 224 24 235 24 b 299 19 292 24 292 24 b 310 -1 306 15 310 6 b 299 -23 310 -11 306 -19 b 257 -27 292 -27 292 -27 b 224 -29 235 -27 224 -29 b 213 -95 224 -40 217 -80 b 81 -280 190 -181 145 -244 b 24 -301 65 -290 34 -301 b 23 -335 24 -301 23 -303 l 23 -340 b 17 -381 23 -374 23 -374 b -1 -391 13 -388 5 -391 b -21 -381 -9 -391 -17 -388 b -27 -340 -27 -374 -27 -374 l -27 -335 b -28 -301 -27 -303 -27 -301 b -85 -280 -38 -301 -69 -290 b -217 -95 -149 -244 -194 -181 b -228 -29 -221 -80 -228 -40 b -259 -27 -228 -29 -238 -27 b -300 -23 -294 -27 -294 -27 b -311 -2 -307 -19 -311 -11 b -294 23 -311 8 -304 19 b -259 24 -291 23 -284 24 b -228 24 -239 24 -228 24 b -217 91 -228 36 -221 76 b -85 276 -194 177 -149 240 b -28 298 -69 285 -38 298 b -27 333 -27 298 -27 299 b -27 371 -27 362 -27 369 b -9 388 -24 378 -17 385 m -27 136 b -28 247 -27 197 -28 247 b -61 216 -31 247 -53 226 b -123 33 -95 172 -121 98 l -125 24 l -76 24 l -27 24 l -27 136 m 29 242 b 24 247 27 245 24 247 b 23 136 24 247 23 197 l 23 24 l 72 24 l 121 24 l 119 33 b 29 242 115 116 77 206 m -27 -140 l -27 -27 l -76 -27 l -125 -27 l -123 -36 b -61 -220 -121 -102 -95 -176 b -28 -251 -53 -230 -31 -251 b -27 -140 -28 -251 -27 -201 m 119 -36 l 121 -27 l 72 -27 l 23 -27 l 23 -140 b 24 -251 23 -201 24 -251 b 57 -220 27 -251 49 -230 b 119 -36 91 -176 117 -102 "},v4e:{x_min:0,x_max:239.5625,ha:244,o:"m 10 460 b 20 462 13 462 14 462 b 39 449 28 462 35 458 l 40 446 l 40 326 b 40 205 40 259 40 205 b 127 227 40 205 80 215 b 220 249 196 244 213 249 b 227 247 224 249 225 248 b 238 237 231 245 235 241 l 239 233 l 239 -106 l 239 -448 l 238 -451 b 219 -463 234 -459 225 -463 b 198 -451 210 -463 202 -459 l 197 -448 l 197 -324 b 197 -201 197 -248 197 -201 b 110 -223 196 -201 157 -210 b 17 -245 42 -240 24 -245 b 10 -242 13 -245 13 -244 b 0 -233 6 -241 2 -237 l 0 -230 l 0 108 l 0 446 l 0 449 b 10 460 2 453 6 458 m 197 22 b 197 70 197 41 197 58 b 196 116 197 113 197 116 l 196 116 b 118 97 196 116 160 106 l 40 77 l 40 -18 b 40 -112 40 -69 40 -112 l 119 -93 l 197 -73 l 197 22 "},v51:{x_min:-1.359375,x_max:455.96875,ha:465,o:"m 352 541 b 357 542 353 542 355 542 b 377 530 364 542 372 537 l 378 526 l 378 394 l 379 262 l 404 266 b 436 270 420 269 430 270 b 450 265 443 270 446 269 b 455 220 455 259 455 260 l 455 208 l 455 161 l 454 156 b 411 140 449 147 447 147 b 378 133 393 137 379 134 b 378 68 378 133 378 106 b 378 22 378 54 378 38 l 379 -87 l 404 -83 b 436 -79 420 -80 430 -79 b 450 -84 443 -79 446 -80 b 455 -129 455 -90 455 -88 l 455 -141 l 455 -188 l 454 -192 b 413 -209 449 -202 447 -202 b 382 -215 398 -212 383 -215 l 378 -215 l 378 -345 l 378 -380 b 375 -485 378 -484 378 -480 b 357 -494 371 -491 364 -494 b 340 -485 351 -494 344 -491 b 336 -383 337 -480 336 -484 l 336 -349 l 336 -223 l 334 -223 b 291 -231 334 -223 314 -227 l 247 -240 l 247 -371 l 246 -503 l 245 -506 b 225 -519 242 -514 234 -519 b 206 -506 219 -519 210 -514 l 205 -503 l 205 -376 l 205 -248 l 160 -256 l 115 -265 l 115 -396 l 115 -527 l 114 -531 b 95 -544 110 -539 102 -544 b 76 -531 87 -544 78 -539 l 73 -527 l 73 -399 b 73 -273 73 -330 73 -273 b 49 -277 73 -273 61 -274 b 17 -281 32 -280 24 -281 b 4 -276 10 -281 8 -280 b -1 -234 0 -269 -1 -272 b 0 -219 -1 -229 0 -224 l 0 -170 l 1 -167 b 10 -158 2 -163 6 -159 b 49 -149 13 -156 16 -155 l 73 -145 l 73 -34 b 73 76 73 26 73 76 b 49 72 73 76 61 74 b 17 68 32 69 24 68 b 4 73 10 68 8 69 b -1 115 0 80 -1 77 b 0 130 -1 120 0 124 l 0 179 l 1 181 b 10 191 2 186 6 190 b 49 199 13 192 16 194 l 73 204 l 73 338 b 73 374 73 352 73 365 b 77 483 73 484 73 477 b 95 492 81 489 88 492 b 111 483 100 492 107 489 b 115 378 115 477 115 483 l 115 342 b 117 212 115 223 115 212 b 204 229 117 212 200 227 l 205 229 l 205 365 l 205 502 l 206 505 b 225 517 210 513 219 517 b 245 505 234 517 242 513 l 246 502 l 247 369 l 247 237 l 249 237 b 336 254 253 238 336 254 b 337 390 336 254 337 302 l 337 526 l 338 530 b 352 541 341 535 347 539 m 336 15 b 336 126 336 102 336 126 l 336 126 b 291 117 336 126 315 122 l 247 109 l 247 -1 l 247 -112 l 249 -112 b 336 -95 253 -111 336 -95 b 336 15 336 -95 336 -56 m 205 -120 b 205 -55 205 -120 205 -93 b 205 -9 205 -41 205 -24 l 205 101 l 160 93 l 115 84 l 115 -26 b 115 -83 115 -49 115 -69 b 117 -137 115 -133 115 -137 b 205 -120 118 -137 204 -120 "},v52:{x_min:-10.890625,x_max:298.078125,ha:294,o:"m 138 473 b 142 474 140 473 141 474 b 164 459 148 474 153 470 b 191 402 183 442 191 423 b 181 353 191 388 187 371 b 178 349 179 352 178 349 b 179 348 178 348 179 348 b 185 349 181 348 182 348 b 255 376 210 355 234 363 b 272 381 264 381 266 381 b 298 355 287 381 298 370 b 288 330 298 348 298 345 b 171 34 238 254 194 141 b 166 13 168 16 168 16 b 144 1 161 5 152 1 b 121 15 134 1 125 5 b 115 33 119 18 117 24 b 0 330 91 145 49 252 b -10 355 -9 345 -10 348 b 13 381 -10 371 0 381 b 31 376 19 381 25 380 b 132 345 61 358 103 345 l 136 345 l 137 355 b 145 378 138 359 142 370 b 152 415 149 394 152 405 b 137 452 152 427 148 438 b 133 464 134 458 133 460 b 138 473 133 467 134 470 "},v53:{x_min:0,x_max:902.421875,ha:921,o:"m 17 240 b 24 241 19 241 21 241 b 32 240 28 241 31 241 b 46 229 38 238 43 234 b 50 88 50 223 50 237 b 50 -1 50 63 50 34 b 50 -90 50 -36 50 -65 b 46 -231 50 -238 50 -224 b 25 -242 42 -238 34 -242 b 0 -224 14 -242 4 -235 b 0 2 0 -222 0 -108 b 0 223 0 112 0 220 b 17 240 2 230 9 237 m 110 240 b 118 241 111 241 114 241 b 126 240 121 241 123 241 b 142 223 133 237 140 230 b 144 123 144 220 144 205 b 144 29 144 45 144 29 b 144 29 144 29 144 29 b 393 183 166 106 264 167 b 450 186 412 184 431 186 b 756 29 600 186 732 120 b 756 29 756 29 756 29 b 758 123 758 29 758 45 b 760 227 758 226 758 223 b 784 241 766 237 774 241 b 804 229 792 241 800 237 b 809 88 808 223 809 237 l 809 -1 l 809 -90 b 804 -231 809 -238 808 -224 b 784 -242 800 -238 792 -242 b 762 -231 775 -242 766 -238 b 758 -124 756 -224 758 -231 b 756 -30 758 -47 758 -30 b 756 -30 756 -30 756 -30 b 509 -184 736 -108 637 -169 b 450 -187 488 -187 469 -187 b 144 -30 300 -187 168 -122 b 144 -30 144 -30 144 -30 b 144 -124 144 -30 144 -47 b 140 -231 144 -231 144 -224 b 118 -242 134 -238 126 -242 b 92 -224 107 -242 96 -235 b 92 2 92 -222 92 -108 b 92 223 92 112 92 220 b 110 240 95 230 102 237 m 432 161 b 413 162 426 162 420 162 b 313 41 351 162 313 109 b 347 -73 313 5 323 -34 b 487 -163 385 -133 439 -163 b 578 -97 526 -163 562 -142 b 588 -43 585 -80 588 -62 b 432 161 588 47 518 147 m 868 240 b 876 241 869 241 872 241 b 884 240 879 241 882 241 b 898 229 890 238 894 234 b 902 88 902 223 902 237 l 902 -1 l 902 -90 b 898 -231 902 -238 902 -224 b 876 -242 892 -238 884 -242 b 852 -224 865 -242 854 -235 b 850 2 850 -222 850 -108 b 852 223 850 112 850 220 b 868 240 853 230 860 237 "},v54:{x_min:-24.5,x_max:317.140625,ha:324,o:"m -24 -161 l -24 -5 l -20 -5 b 0 -24 -9 -5 -2 -12 b 171 -315 21 -124 84 -233 b 317 -660 268 -406 317 -531 b 187 -1014 317 -782 274 -909 b 161 -1034 172 -1034 171 -1034 b 141 -1013 149 -1034 141 -1025 b 152 -991 141 -1004 142 -1002 b 266 -682 228 -899 266 -788 b 174 -430 266 -588 236 -498 b -23 -317 136 -388 66 -348 b -24 -161 -23 -316 -24 -285 "},v55:{x_min:0,x_max:551.25,ha:563,o:"m 289 644 b 304 645 294 645 299 645 b 404 566 349 645 392 613 b 406 541 405 557 406 549 b 379 471 406 514 397 489 l 377 467 l 382 470 b 509 591 438 485 485 531 b 513 601 510 595 513 599 b 530 609 518 607 524 609 b 551 588 540 609 551 602 b 200 -605 551 584 204 -599 b 182 -616 197 -612 190 -616 b 163 -602 174 -616 166 -610 b 161 -598 161 -601 161 -601 b 217 -402 161 -589 170 -562 b 272 -213 247 -298 272 -213 b 272 -213 272 -213 272 -213 b 264 -219 272 -213 268 -216 b 140 -262 227 -247 182 -262 b 36 -226 102 -262 65 -249 b 0 -145 12 -206 0 -176 b 17 -84 0 -124 5 -104 b 103 -38 38 -54 70 -38 b 191 -91 137 -38 172 -56 b 205 -141 201 -106 205 -124 b 178 -212 205 -167 196 -194 l 175 -215 l 182 -213 b 307 -93 236 -198 284 -151 b 372 129 308 -88 372 127 b 372 129 372 129 372 129 b 364 122 372 129 368 126 b 240 80 328 94 283 80 b 137 115 202 80 166 91 b 99 195 112 136 99 165 b 118 256 99 217 106 238 b 204 303 138 287 171 303 b 292 249 238 303 273 285 b 306 199 302 234 306 217 b 279 129 306 173 296 148 l 276 126 l 281 127 b 408 248 336 142 385 190 b 473 470 409 254 473 469 b 473 470 473 470 473 470 b 465 464 473 470 469 467 b 341 421 428 435 383 421 b 236 458 303 421 266 433 b 200 537 212 478 200 508 b 289 644 200 585 234 635 "},v58:{x_min:-21.78125,x_max:367.5,ha:375,o:"m 259 1553 b 265 1553 261 1553 264 1553 b 288 1540 272 1553 277 1550 b 367 1351 340 1493 367 1424 b 336 1221 367 1308 357 1263 l 332 1211 l 333 1208 b 367 1077 356 1170 367 1124 b 336 945 367 1032 357 986 l 332 935 l 333 932 b 367 800 356 893 367 848 b 336 669 367 756 357 710 l 332 659 l 333 656 b 367 523 356 617 367 571 b 345 412 367 485 360 446 b 231 273 322 356 284 310 b -1 19 121 195 27 93 b -17 4 -4 11 -10 5 l -21 4 l -21 134 l -21 265 l -17 265 b 133 291 20 265 96 278 b 318 537 245 328 318 433 b 307 603 318 559 315 582 b 303 614 304 612 304 614 b 298 609 302 614 300 613 b 231 549 281 589 258 567 b -1 295 121 471 27 369 b -17 280 -4 287 -10 281 l -21 280 l -21 410 l -21 541 l -17 541 b 133 567 20 541 96 555 b 318 813 245 605 318 709 b 307 880 318 835 315 859 b 303 891 304 888 304 891 b 298 885 302 891 300 888 b 231 825 281 866 258 843 b -1 571 121 748 27 645 b -17 556 -4 563 -10 557 l -21 556 l -21 687 l -21 817 l -17 817 b 133 843 20 817 96 830 b 318 1089 245 881 318 985 b 307 1156 318 1111 315 1134 b 303 1167 304 1164 304 1167 b 298 1161 302 1167 300 1164 b 231 1102 281 1140 258 1120 b -1 848 121 1024 27 921 b -17 832 -4 839 -10 834 l -21 832 l -21 963 l -21 1093 l -17 1093 b 114 1113 12 1093 78 1103 b 313 1314 215 1142 289 1218 b 318 1364 317 1331 318 1347 b 255 1511 318 1422 295 1478 b 243 1532 247 1519 243 1525 b 259 1553 243 1540 250 1550 "},v59:{x_min:0,x_max:464.140625,ha:474,o:"m 0 0 l 0 347 l 76 347 l 153 347 l 153 0 l 153 -348 l 76 -348 l 0 -348 l 0 0 m 308 -1 l 308 347 l 386 347 l 464 347 l 464 -1 l 464 -348 l 386 -348 l 308 -348 l 308 -1 "},v5a:{x_min:-171.5,x_max:170.140625,ha:174,o:"m -6 566 b 0 567 -5 567 -2 567 b 14 556 6 567 12 563 b 92 285 14 555 50 433 b 170 13 166 33 170 19 b 168 13 170 13 170 13 b 161 1 168 8 167 4 l 159 0 l 122 0 l 84 0 l 81 1 b 21 195 76 5 78 -5 b -32 381 -8 297 -32 381 b -87 197 -32 381 -57 298 b -141 8 -115 94 -140 9 b -155 0 -142 2 -149 0 b -171 15 -163 0 -171 5 b -14 556 -171 18 -24 528 b -6 566 -14 560 -10 564 "},v5b:{x_min:-441,x_max:439.640625,ha:449,o:"m -428 -2 b -421 0 -427 -1 -424 0 b -406 -6 -416 0 -409 -2 b -400 -31 -401 -12 -400 -15 b -1 -352 -392 -215 -215 -352 b 58 -349 19 -352 38 -351 b 398 -31 250 -326 392 -192 b 404 -6 398 -15 400 -12 b 419 -1 408 -2 413 -1 b 439 -13 427 -1 435 -5 b 439 -29 439 -16 439 -22 b 434 -105 439 -48 438 -80 b 0 -489 397 -333 213 -489 b -68 -484 -23 -489 -44 -488 b -441 -36 -280 -452 -436 -263 b -441 -30 -441 -34 -441 -31 b -428 -2 -441 -11 -439 -5 m -13 -9 b -1 -8 -9 -8 -5 -8 b 50 -36 19 -8 39 -19 b 61 -72 57 -47 61 -59 b 50 -106 61 -84 57 -97 b -1 -134 39 -124 19 -134 b -46 -115 -17 -134 -34 -129 b -62 -72 -57 -102 -62 -87 b -13 -9 -62 -44 -44 -16 "},v5c:{x_min:0,x_max:447.8125,ha:457,o:"m 0 -87 l 0 0 l 223 0 l 447 0 l 447 -87 l 447 -174 l 223 -174 l 0 -174 l 0 -87 "},v5d:{x_min:-1.359375,x_max:592.078125,ha:604,o:"m 280 692 b 295 694 283 692 289 694 b 310 692 300 694 307 692 b 357 630 340 684 357 657 b 336 580 357 612 351 594 b 311 538 321 566 311 549 b 352 492 311 512 330 492 b 366 495 357 492 362 492 b 397 553 390 503 397 517 b 415 603 397 576 402 591 b 460 623 427 617 443 623 b 509 599 479 623 498 614 b 522 559 518 587 522 573 b 494 506 522 538 513 519 b 451 495 481 498 473 496 b 415 488 432 495 426 494 b 394 449 404 483 394 464 b 394 448 394 448 394 448 l 394 440 l 397 433 b 428 409 404 420 413 413 b 438 408 431 408 435 408 b 479 431 450 408 462 415 b 528 455 495 448 510 455 b 548 452 534 455 541 453 b 592 391 577 442 592 416 b 549 331 592 365 577 340 b 528 327 541 328 534 327 b 479 351 510 327 495 335 b 438 374 464 367 450 374 b 417 369 431 374 424 373 b 394 333 402 360 394 348 b 400 312 394 326 396 319 b 451 287 408 294 420 288 b 513 258 484 285 499 278 b 522 223 519 247 522 234 b 461 159 522 190 496 159 b 449 161 457 159 453 159 b 397 229 416 167 397 191 b 366 288 397 265 390 278 b 352 290 362 290 357 290 b 315 262 336 290 321 280 b 311 245 313 256 311 251 b 334 204 311 233 318 220 b 355 170 348 190 351 184 b 357 152 356 166 357 159 b 355 136 357 147 356 140 b 295 88 345 104 321 88 b 232 152 264 88 232 112 b 255 204 232 174 238 186 b 279 244 273 222 279 231 l 279 245 b 238 290 279 270 259 290 b 224 288 234 290 228 290 b 193 229 200 278 193 265 b 141 161 193 191 174 167 b 129 159 137 159 133 159 b 68 223 93 159 68 190 b 77 258 68 234 70 247 b 138 287 91 278 106 285 b 185 302 166 287 175 291 b 196 333 193 312 196 323 b 174 369 196 347 187 360 b 152 374 166 373 159 374 b 111 351 140 374 126 367 b 62 327 95 335 80 327 b 51 328 58 327 54 327 b -1 391 16 334 -1 363 b 53 455 -1 420 17 449 b 62 455 57 455 59 455 b 111 431 80 455 95 448 b 152 408 127 415 140 408 b 161 409 155 408 159 408 b 193 433 176 413 186 420 l 196 440 l 196 448 b 196 451 196 449 196 449 b 190 471 196 459 194 463 b 137 495 182 489 167 495 l 134 495 l 134 495 b 68 560 95 495 68 521 b 129 623 68 596 95 623 b 144 621 134 623 138 623 b 193 553 175 614 193 589 b 224 495 193 517 200 503 b 238 492 228 492 234 492 b 279 538 259 492 279 512 b 254 580 279 549 269 566 b 232 630 239 594 232 612 b 280 692 232 657 250 684 m 307 456 b 295 458 303 458 299 458 b 230 391 258 458 230 426 b 236 360 230 381 231 371 b 295 324 249 337 272 324 b 353 360 318 324 341 337 b 360 391 357 370 360 381 b 307 456 360 421 340 451 "},v60:{x_min:-590.71875,x_max:589.359375,ha:601,o:"m -367 173 b -362 174 -366 174 -364 174 b -351 173 -357 174 -353 173 b -262 86 -348 172 -328 151 b -176 0 -216 37 -176 0 b -107 84 -176 0 -145 37 b -31 174 -36 173 -38 172 b -25 174 -29 174 -28 174 b -16 173 -23 174 -19 173 b 72 86 -13 172 6 151 b 157 0 119 37 157 0 b 227 84 159 0 189 37 b 303 174 298 173 296 172 b 308 174 304 174 307 174 b 318 173 313 174 317 173 b 481 11 322 172 357 134 l 494 -1 l 522 34 b 560 76 553 72 555 74 b 567 77 563 77 564 77 b 589 56 579 77 589 68 b 586 48 589 54 588 51 b 411 -172 583 41 416 -166 b 397 -176 406 -174 401 -176 b 387 -174 393 -176 390 -176 b 299 -87 386 -173 366 -152 b 213 0 253 -38 213 0 b 144 -86 213 0 182 -38 b 68 -174 73 -174 74 -173 b 62 -176 66 -176 65 -176 b 53 -174 59 -176 55 -174 b -35 -87 50 -173 29 -152 b -121 0 -83 -38 -121 0 b -190 -86 -122 0 -152 -38 b -266 -174 -261 -174 -259 -173 b -272 -176 -268 -176 -270 -176 b -281 -174 -276 -176 -280 -174 b -371 -86 -284 -173 -304 -152 b -457 0 -417 -38 -457 0 l -457 0 b -477 -26 -457 0 -470 -16 b -548 -227 -524 -88 -548 -161 b -536 -303 -548 -254 -544 -280 b -533 -317 -534 -309 -533 -313 b -553 -338 -533 -330 -541 -338 b -577 -315 -566 -338 -571 -333 b -590 -227 -586 -287 -590 -258 b -518 -9 -590 -154 -564 -77 b -465 56 -509 2 -504 8 l -402 134 b -367 173 -375 169 -372 172 "},v62:{x_min:46.28125,x_max:669.671875,ha:563,o:"m 183 376 b 189 376 185 376 187 376 b 212 374 197 376 208 376 b 265 337 234 369 253 355 b 274 317 268 331 273 320 b 274 316 274 317 274 316 b 280 323 276 316 276 319 b 311 358 288 337 299 348 b 319 366 315 360 318 365 b 356 376 326 373 340 376 b 382 371 364 376 374 374 b 428 337 400 366 417 352 b 436 317 431 331 436 320 b 438 316 436 317 436 316 b 442 323 438 316 439 319 b 475 358 451 337 462 348 b 483 366 477 360 481 365 b 518 376 488 373 503 376 b 544 373 528 376 536 376 b 604 285 579 360 604 326 b 597 249 604 273 601 258 b 543 63 596 247 544 70 b 541 54 543 61 541 55 b 540 44 540 51 540 47 b 552 23 540 33 545 23 b 552 23 552 23 552 23 b 647 126 586 29 627 72 b 658 138 651 136 653 138 b 660 138 660 138 660 138 b 669 129 666 137 669 136 b 654 88 669 122 665 109 b 562 -12 631 43 602 9 l 549 -19 b 521 -27 540 -24 530 -27 b 447 30 490 -27 458 -4 b 443 58 445 38 443 48 b 450 93 443 72 446 84 b 504 278 453 97 504 272 b 507 288 506 283 506 287 b 509 298 507 292 509 295 b 491 326 509 310 502 320 b 487 327 490 327 488 327 b 479 324 484 327 483 326 b 441 270 462 316 443 288 b 435 249 441 265 436 254 b 398 127 434 248 419 195 b 362 4 379 61 362 5 b 328 -1 359 -1 362 -1 b 314 -1 323 -1 319 -1 b 302 -1 310 -1 306 -1 b 266 4 266 -1 269 -1 b 265 6 265 5 265 5 b 303 144 265 13 272 34 b 343 278 325 216 343 276 b 344 288 343 281 344 285 b 345 298 345 291 345 295 b 330 326 345 310 340 320 b 323 327 328 327 325 327 b 317 324 322 327 321 326 b 279 270 300 316 281 288 b 273 249 279 265 274 254 b 236 127 272 248 255 195 b 200 4 216 61 200 5 b 164 -1 197 -1 198 -1 b 151 -1 161 -1 156 -1 b 140 -1 147 -1 142 -1 b 103 4 104 -1 106 -1 b 103 6 103 5 103 5 b 141 144 103 13 108 34 b 181 278 161 216 179 276 b 182 288 181 281 181 285 b 183 298 182 291 183 295 b 168 324 183 310 178 320 b 160 327 166 326 163 327 b 141 320 156 327 151 324 b 69 230 112 305 85 272 b 57 215 65 217 62 215 b 55 215 57 215 55 215 b 46 224 49 215 46 217 b 59 260 46 231 50 242 b 151 363 81 306 112 341 b 161 369 155 365 160 367 b 183 376 166 371 174 374 "},v68:{x_min:-597.53125,x_max:596.171875,ha:608,o:"m -533 324 b -525 327 -530 326 -528 327 b -504 305 -514 327 -504 317 b -504 305 -504 305 -504 305 b -513 284 -504 299 -504 299 b -556 112 -541 226 -556 167 b -545 33 -556 84 -552 58 b -524 -20 -541 15 -532 -9 l -522 -23 l -491 15 l -413 111 b -355 174 -367 169 -363 174 b -351 174 -353 174 -352 174 b -254 86 -343 174 -348 179 b -168 -1 -208 37 -168 -1 b -100 84 -168 -1 -137 37 b -23 173 -28 173 -29 172 b -19 174 -21 174 -20 174 b -8 173 -14 174 -10 173 b 155 11 -5 172 43 123 l 166 -1 l 168 1 l 170 4 l 170 130 b 171 260 170 256 170 258 b 191 274 175 269 183 274 b 205 267 196 274 201 272 b 212 158 212 262 210 273 l 212 56 l 257 112 b 311 173 304 172 304 172 b 317 174 313 174 314 174 b 326 173 319 174 323 173 b 490 11 329 172 366 134 l 502 -1 l 530 34 b 568 76 560 72 563 74 b 575 77 570 77 573 77 b 596 56 586 77 596 68 b 594 48 596 54 596 51 b 417 -172 592 41 424 -166 b 405 -176 415 -174 409 -176 b 396 -174 401 -176 398 -176 b 307 -87 393 -173 372 -152 b 221 -1 259 -38 221 -1 b 216 -6 221 -1 219 -2 l 212 -12 l 212 -147 b 212 -210 212 -173 212 -194 b 205 -292 212 -297 210 -287 b 191 -299 201 -297 196 -299 b 172 -287 183 -299 175 -295 b 170 -174 171 -284 171 -284 l 170 -63 l 127 -117 b 73 -176 84 -170 80 -176 b 68 -176 72 -176 70 -176 b -27 -87 59 -174 65 -180 b -114 0 -74 -38 -112 0 b -182 -86 -114 0 -145 -38 b -258 -174 -253 -174 -253 -173 b -264 -176 -259 -176 -262 -176 b -274 -174 -268 -176 -272 -174 b -438 -11 -277 -173 -348 -102 l -449 0 l -479 -37 b -524 -80 -513 -80 -514 -80 l -524 -80 b -553 -52 -534 -80 -540 -74 b -597 109 -583 -8 -597 48 b -560 280 -597 165 -585 224 b -533 324 -548 310 -540 322 "},v6c:{x_min:-1.359375,x_max:193.28125,ha:197,o:"m 78 233 b 87 233 81 233 84 233 b 187 140 132 233 174 195 b 193 102 190 127 193 115 b 43 -113 193 22 136 -62 b 27 -119 36 -116 31 -119 b 19 -108 21 -119 19 -115 b 29 -97 19 -102 20 -101 b 102 13 73 -72 102 -27 b 92 51 102 26 98 40 l 91 54 l 84 54 b 8 104 53 54 21 74 b -1 142 1 116 -1 130 b 78 233 -1 187 31 227 "},v6d:{x_min:-590.71875,x_max:589.359375,ha:601,o:"m 544 335 b 553 337 548 337 551 337 b 575 313 563 337 570 330 b 589 226 583 285 589 256 b 517 8 589 152 563 76 b 464 -58 507 -4 503 -9 l 401 -136 b 362 -176 372 -172 370 -176 b 357 -176 360 -176 359 -176 b 261 -87 349 -174 355 -180 b 175 0 215 -38 175 0 b 106 -86 175 0 144 -38 b 29 -174 35 -174 36 -173 b 24 -176 28 -176 27 -176 b 14 -174 21 -176 17 -174 b -73 -87 12 -173 -8 -152 b -159 0 -121 -38 -159 0 b -228 -86 -160 0 -190 -38 b -304 -174 -299 -174 -298 -173 b -310 -176 -306 -176 -308 -176 b -319 -174 -314 -176 -318 -174 b -483 -12 -323 -173 -359 -137 l -495 0 l -524 -34 b -562 -77 -553 -73 -556 -76 b -568 -79 -564 -79 -566 -79 b -590 -58 -581 -79 -590 -69 b -588 -49 -590 -55 -589 -52 b -412 170 -585 -43 -417 165 b -398 174 -408 173 -402 174 b -389 173 -394 174 -392 174 b -300 86 -387 172 -366 151 b -215 -1 -254 37 -215 -1 b -145 84 -215 -1 -183 37 b -69 173 -74 173 -76 172 b -63 174 -68 174 -66 174 b -54 173 -61 174 -57 173 b 34 86 -51 172 -31 151 b 119 -1 81 37 119 -1 b 189 84 121 -1 151 37 b 265 173 259 173 258 172 b 270 174 266 174 269 174 b 280 173 274 174 279 173 b 370 84 283 172 303 151 b 455 -1 416 37 455 -1 l 455 -1 b 476 24 455 -1 469 15 b 547 226 522 87 547 159 b 534 302 547 252 543 278 b 532 317 533 308 532 313 b 544 335 532 326 536 333 "},v6f:{x_min:-80.3125,x_max:78.9375,ha:81,o:"m 63 191 b 69 192 65 192 66 192 b 77 188 72 192 76 191 b 78 183 78 187 78 186 b 74 158 78 179 77 172 l 66 115 b 9 -161 49 30 10 -158 b -10 -187 6 -172 -1 -181 b -34 -194 -17 -191 -25 -194 b -80 -147 -58 -194 -80 -174 b -80 -141 -80 -144 -80 -142 b 9 70 -80 -134 -73 -117 l 49 163 b 63 191 59 188 61 190 "},v70:{x_min:0,x_max:436.921875,ha:446,o:"m 213 190 b 217 191 215 191 216 191 b 231 184 223 191 228 188 b 249 154 240 167 246 159 b 419 18 292 91 348 45 b 436 -1 435 11 436 8 b 424 -16 436 -9 434 -13 b 308 -87 394 -26 340 -59 b 231 -186 276 -117 257 -142 b 219 -192 228 -191 225 -192 b 198 -174 209 -192 208 -191 b 47 -33 161 -113 110 -63 b 10 -16 34 -26 17 -19 b 0 -1 2 -13 0 -9 b 17 18 0 8 1 11 b 198 173 95 48 156 101 b 213 190 206 187 208 188 "},v72:{x_min:-423.3125,x_max:421.9375,ha:431,o:"m -262 197 b -247 197 -257 197 -253 197 b -118 162 -210 197 -163 184 b 40 45 -61 134 -13 98 b 277 -95 119 -33 200 -81 b 289 -97 281 -97 285 -97 b 378 0 332 -97 371 -55 b 378 11 378 4 378 6 b 302 83 378 55 345 83 b 242 66 283 83 262 77 b 208 56 231 59 219 56 b 148 120 175 56 148 81 b 201 186 148 151 164 172 b 261 198 220 194 240 198 b 420 45 341 198 411 136 b 421 22 421 37 421 29 b 245 -199 421 -93 338 -199 b 238 -198 243 -199 240 -199 b -44 -47 148 -194 50 -141 b -250 86 -114 22 -183 66 b -295 94 -270 91 -283 94 b -315 91 -302 94 -307 94 b -381 4 -356 81 -381 43 b -355 -56 -381 -18 -372 -40 b -298 -81 -338 -73 -319 -81 b -246 -68 -283 -81 -265 -77 b -212 -58 -234 -61 -223 -58 b -178 -69 -200 -58 -189 -62 b -151 -122 -160 -81 -151 -101 b -171 -167 -151 -138 -157 -155 b -239 -195 -185 -181 -213 -192 b -257 -197 -245 -197 -250 -197 b -423 -5 -352 -197 -423 -109 b -412 65 -423 16 -419 40 b -262 197 -389 137 -329 188 "},v74:{x_min:-206.890625,x_max:428.75,ha:438,o:"m 389 -351 b 394 -351 390 -351 393 -351 b 428 -385 413 -351 428 -367 b 428 -394 428 -388 428 -391 b 394 -428 426 -406 421 -410 l 332 -473 l 269 -516 l 205 -560 l 141 -603 l 77 -648 l 13 -692 l -50 -737 l -114 -780 l -145 -802 b -171 -813 -157 -810 -163 -813 b -175 -813 -172 -813 -174 -813 b -206 -777 -194 -811 -206 -795 b -202 -760 -206 -771 -205 -766 b -87 -675 -197 -752 -206 -757 l -34 -639 l 83 -557 l 145 -514 l 209 -470 l 272 -427 b 389 -351 375 -356 381 -352 "},v75:{x_min:-149.71875,x_max:148.359375,ha:151,o:"m -137 381 b -130 383 -134 383 -133 383 b -111 371 -122 383 -114 378 b -55 224 -110 370 -85 305 b 0 80 -25 145 -1 80 b 54 224 0 80 24 145 b 112 377 114 384 110 373 b 127 384 118 381 122 384 b 148 362 138 384 148 374 l 148 356 l 83 183 b 16 9 47 88 17 11 b -1 0 12 2 5 0 b -14 5 -5 0 -10 1 b -84 183 -19 9 -13 -6 l -149 356 l -149 362 b -137 381 -149 371 -145 378 "},v78:{x_min:0,x_max:193.28125,ha:197,o:"m 85 514 b 95 517 88 517 89 517 b 114 505 103 517 110 513 l 115 502 l 115 376 b 115 249 115 306 115 249 b 141 258 117 249 127 252 l 167 266 l 172 266 b 190 254 181 265 187 262 l 193 251 l 193 202 l 193 188 b 187 147 193 149 191 152 b 147 130 183 142 182 141 l 115 119 l 115 9 b 115 -99 115 -51 115 -99 b 141 -91 115 -99 127 -95 b 171 -81 166 -81 167 -81 l 171 -81 b 191 -94 181 -81 189 -87 b 193 -142 191 -97 193 -120 b 191 -195 193 -167 191 -194 b 125 -227 187 -205 187 -204 l 115 -230 l 115 -366 l 115 -503 l 114 -506 b 95 -519 110 -514 102 -519 b 74 -506 87 -519 78 -514 l 73 -503 l 73 -374 b 73 -245 73 -260 73 -245 b 73 -245 73 -245 73 -245 b 55 -252 72 -245 63 -249 l 32 -260 b 19 -263 27 -262 23 -263 b 4 -256 13 -263 8 -260 b 0 -215 0 -251 0 -254 b 0 -199 0 -210 0 -206 l 0 -152 l 1 -149 b 8 -140 2 -145 5 -141 b 42 -127 9 -140 24 -133 l 73 -116 l 73 -5 b 73 23 73 4 73 15 b 73 105 73 70 73 105 b 49 97 73 105 61 101 b 17 88 32 91 23 88 b 4 95 10 88 8 91 b 0 137 0 101 0 98 b 0 151 0 141 0 145 l 0 199 l 1 202 b 43 224 5 212 5 212 l 73 234 l 73 367 l 73 502 l 74 505 b 85 514 77 509 81 513 "},v79:{x_min:-1.359375,x_max:899.703125,ha:918,o:"m 307 349 b 332 351 315 351 323 351 b 443 340 367 351 408 347 b 741 47 607 306 720 195 b 744 0 743 31 744 16 b 660 -303 744 -90 713 -206 b 28 -755 534 -531 304 -695 b 14 -756 23 -755 19 -756 b -1 -741 4 -756 -1 -750 b 21 -720 -1 -731 1 -728 b 567 -56 337 -601 548 -344 b 568 -11 568 -41 568 -24 b 442 285 568 129 525 233 b 325 319 406 308 367 319 b 93 177 232 319 137 266 b 84 154 91 170 84 155 b 84 154 84 154 84 154 b 88 156 84 154 85 155 b 159 177 110 170 134 177 b 257 134 194 177 231 162 b 294 41 281 108 294 73 b 171 -97 294 -24 246 -90 b 156 -98 166 -97 161 -98 b 6 74 73 -98 6 -22 b 6 80 6 76 6 79 b 307 349 10 223 141 340 m 839 215 b 845 216 841 216 842 216 b 862 213 852 216 860 215 b 899 163 887 206 899 184 b 872 117 899 145 890 127 b 847 111 865 112 856 111 b 808 130 833 111 818 117 b 796 162 800 140 796 151 b 839 215 796 187 812 212 m 839 -112 b 845 -112 841 -112 842 -112 b 862 -115 852 -112 860 -113 b 899 -165 887 -122 899 -144 b 872 -210 899 -183 890 -201 b 847 -217 865 -215 856 -217 b 808 -198 833 -217 818 -210 b 796 -165 800 -188 796 -177 b 839 -112 796 -140 812 -116 "},v7a:{x_min:-1.359375,x_max:386.5625,ha:394,o:"m 249 535 b 257 537 251 537 253 537 b 276 524 266 537 273 533 l 277 521 l 279 419 l 279 316 l 304 323 b 337 328 319 326 330 328 b 353 316 347 328 349 324 b 355 266 355 315 355 290 b 353 215 355 241 355 217 b 319 198 349 206 347 205 b 279 187 284 190 279 188 b 279 156 279 187 279 174 b 279 136 279 151 279 144 l 279 84 l 289 87 l 330 98 b 367 105 352 102 362 105 b 378 101 372 105 375 104 b 386 61 385 95 386 94 b 386 40 386 55 386 48 l 386 -5 l 385 -8 b 374 -19 383 -12 378 -18 b 291 -40 372 -19 347 -26 b 279 -43 284 -41 279 -43 b 279 -83 279 -43 279 -59 b 279 -95 279 -87 279 -91 l 279 -145 l 304 -140 b 337 -133 321 -136 330 -133 b 349 -140 343 -133 347 -136 b 355 -181 355 -145 355 -142 l 355 -197 l 355 -210 b 349 -252 355 -249 355 -247 b 300 -269 345 -258 347 -258 b 280 -274 291 -272 281 -273 l 279 -274 l 277 -378 l 277 -483 l 276 -487 b 257 -499 273 -495 265 -499 b 238 -487 249 -499 242 -495 l 236 -483 l 236 -384 l 236 -285 l 235 -285 l 212 -291 l 170 -301 b 148 -308 159 -305 148 -306 b 147 -415 147 -308 147 -313 l 147 -523 l 145 -526 b 126 -538 141 -534 133 -538 b 106 -526 118 -538 110 -534 l 104 -523 l 104 -420 b 103 -317 104 -326 104 -317 b 103 -317 103 -317 103 -317 b 50 -330 92 -322 54 -330 b 31 -317 42 -330 35 -326 b 29 -267 29 -315 29 -315 l 29 -219 l 32 -216 b 92 -192 36 -206 36 -206 l 104 -190 l 104 -138 b 103 -87 104 -91 104 -87 b 103 -87 103 -87 103 -87 b 88 -91 103 -87 96 -88 l 49 -101 b 17 -106 32 -105 23 -106 b 6 -102 13 -106 10 -105 b -1 -62 0 -97 -1 -95 b 0 -41 -1 -56 0 -49 l 0 4 l 1 6 b 10 16 2 11 6 15 b 91 37 12 18 38 24 l 104 41 l 104 93 b 103 144 104 140 104 144 b 103 144 103 144 103 144 b 50 131 92 141 54 131 b 31 144 42 131 35 137 b 29 195 29 147 29 148 l 29 242 l 32 245 b 92 269 36 255 36 255 l 104 273 l 104 377 l 104 481 l 106 485 b 126 498 110 492 118 498 b 134 495 129 498 132 496 b 145 485 138 494 142 489 l 147 481 l 147 383 l 147 283 l 152 284 b 190 294 155 285 171 290 l 230 303 l 236 305 l 236 413 l 236 521 l 238 524 b 249 535 240 528 243 533 m 236 126 b 235 177 236 154 236 177 l 235 177 b 213 172 235 177 225 174 l 170 161 b 147 155 157 158 147 155 b 147 124 147 155 147 142 b 147 102 147 117 147 111 l 147 52 l 153 54 l 228 72 l 236 74 l 236 126 m 236 -105 b 235 -54 236 -65 236 -54 l 235 -54 b 231 -55 235 -54 234 -54 b 172 -69 227 -55 204 -62 l 149 -76 l 147 -76 l 147 -127 l 147 -179 l 152 -177 b 190 -167 155 -177 171 -173 l 230 -158 l 236 -156 l 236 -105 "},v7c:{x_min:0,x_max:300.8125,ha:307,o:"m 49 505 b 53 506 50 505 51 506 b 70 496 58 506 62 503 b 81 485 73 492 78 488 l 96 473 l 111 459 l 122 449 l 134 438 l 182 396 l 255 330 b 292 291 292 298 292 298 l 292 290 l 292 284 l 283 270 b 209 36 234 197 209 113 b 288 -170 209 -44 235 -119 b 299 -184 295 -179 299 -181 b 300 -191 300 -187 300 -188 b 285 -206 300 -199 294 -206 b 280 -206 283 -206 281 -206 b 247 -201 270 -202 259 -201 b 176 -222 223 -201 197 -208 b 114 -340 136 -249 114 -292 b 172 -471 114 -384 134 -433 b 185 -492 182 -481 185 -487 b 181 -502 185 -496 183 -499 b 171 -508 176 -505 174 -508 b 152 -498 166 -508 160 -503 b 0 -284 65 -428 12 -352 b 0 -260 0 -278 0 -270 b 1 -238 0 -252 0 -242 b 148 -140 16 -177 73 -140 b 209 -148 167 -140 189 -142 b 215 -149 212 -148 215 -149 b 215 -149 215 -149 215 -149 l 215 -149 b 201 -136 215 -148 209 -142 l 157 -97 l 96 -41 b 17 34 21 24 17 29 b 17 37 17 36 17 36 b 17 38 17 37 17 38 b 25 56 17 44 17 44 b 110 298 81 131 110 219 b 46 474 110 367 88 431 b 38 491 40 480 38 487 b 49 505 38 498 42 502 "},v7d:{x_min:-1.359375,x_max:436.921875,ha:446,o:"m 213 205 b 217 205 215 205 216 205 b 234 194 224 205 234 199 b 236 187 234 194 235 190 l 245 167 l 261 129 l 270 106 b 355 -61 294 54 329 -13 b 420 -163 381 -105 402 -138 b 436 -188 435 -184 436 -184 b 436 -191 436 -190 436 -190 b 421 -206 436 -201 431 -206 l 421 -206 l 416 -206 l 405 -201 b 217 -158 347 -172 283 -158 b 31 -201 153 -158 88 -172 l 20 -206 l 14 -206 l 14 -206 b 0 -191 5 -206 0 -201 b -1 -188 0 -190 -1 -190 b 14 -163 -1 -186 0 -184 b 95 -34 36 -136 72 -77 b 166 106 119 8 148 68 l 175 129 l 183 148 l 200 188 b 213 205 205 199 208 202 "},v7f:{x_min:0,x_max:367.5,ha:375,o:"m 0 124 l 0 187 l 61 187 l 122 187 l 122 138 l 122 91 l 153 61 l 183 30 l 213 61 l 243 91 l 243 138 l 243 187 l 306 187 l 367 187 l 367 124 l 367 61 l 321 61 l 274 61 l 243 30 l 213 0 l 243 -31 l 274 -62 l 321 -62 l 367 -62 l 367 -124 l 367 -188 l 306 -188 l 243 -188 l 243 -140 l 243 -93 l 213 -62 l 183 -31 l 153 -62 l 122 -93 l 122 -140 l 122 -188 l 61 -188 l 0 -188 l 0 -124 l 0 -62 l 46 -62 l 92 -62 l 123 -31 l 153 0 l 123 30 l 92 61 l 46 61 l 0 61 l 0 124 "},v80:{x_min:29.9375,x_max:420.578125,ha:371,o:"m 115 345 b 221 347 117 345 166 347 b 411 345 306 347 409 345 b 420 330 416 342 420 335 b 415 319 420 326 419 321 b 178 118 397 303 179 118 b 178 117 178 118 178 117 b 181 117 178 117 178 117 b 189 117 182 117 185 117 b 193 117 190 117 191 117 b 247 98 215 117 232 111 b 296 75 266 83 280 76 b 302 75 299 75 300 75 b 322 91 311 75 315 79 b 322 91 322 91 322 91 b 322 91 322 91 322 91 b 319 91 322 91 321 91 b 313 90 318 90 315 90 b 283 107 300 90 288 97 b 277 126 279 114 277 121 b 319 167 277 149 295 167 b 319 167 319 167 319 167 b 362 118 347 167 362 147 b 355 82 362 108 359 96 b 311 33 349 65 340 55 b 224 1 284 12 253 1 b 194 5 213 1 204 2 b 168 18 183 8 178 11 b 110 36 151 30 130 36 b 57 15 88 36 68 29 b 47 11 54 12 51 11 b 31 20 40 11 34 13 b 29 26 31 22 29 25 b 68 66 29 36 39 45 b 285 250 73 71 281 248 b 285 250 285 250 285 250 b 231 252 285 252 261 252 b 137 250 190 252 141 250 b 93 227 122 248 110 241 b 78 220 88 222 83 220 b 66 227 74 220 70 222 b 63 234 65 229 63 231 b 85 291 63 241 69 252 b 115 345 108 342 108 344 "},v81:{x_min:0,x_max:428.75,ha:438,o:"m 262 186 b 273 186 266 186 272 186 b 274 186 273 186 274 186 b 285 186 274 186 280 186 b 428 48 375 181 428 122 b 386 -68 428 12 416 -29 b 155 -187 329 -145 236 -187 b 12 -111 92 -187 38 -162 b 0 -51 4 -91 0 -72 b 262 186 0 58 122 179 m 366 131 b 352 134 362 133 357 134 b 219 81 321 134 269 115 b 47 -111 126 23 50 -62 b 47 -112 47 -111 47 -112 b 77 -136 47 -129 58 -136 b 264 -45 118 -136 194 -101 b 382 109 336 12 382 76 b 366 131 382 120 377 129 "},v83:{x_min:-1.359375,x_max:847.96875,ha:865,o:"m 488 1499 b 495 1500 490 1500 492 1500 b 541 1465 507 1500 521 1490 b 679 1078 622 1372 679 1210 b 677 1050 679 1068 677 1060 b 477 642 668 893 604 764 l 443 609 l 431 596 l 431 592 l 438 562 l 449 508 l 460 458 b 481 355 475 390 481 355 b 481 355 481 355 481 355 b 490 356 481 355 485 355 b 528 358 495 356 511 358 b 558 356 540 358 552 356 b 839 95 699 338 808 237 b 847 22 845 72 847 47 b 631 -303 847 -113 766 -242 b 620 -309 623 -308 620 -309 l 620 -310 b 631 -359 620 -310 626 -333 l 646 -435 l 660 -496 b 672 -588 668 -535 672 -563 b 664 -653 672 -610 669 -630 b 383 -875 630 -792 509 -875 b 201 -810 321 -875 257 -855 b 129 -680 151 -768 129 -730 b 274 -530 129 -592 200 -530 b 351 -553 300 -530 326 -538 b 412 -669 393 -582 412 -626 b 287 -805 412 -735 366 -800 l 279 -805 l 285 -809 b 383 -830 318 -823 351 -830 b 586 -718 464 -830 540 -789 b 626 -584 612 -678 626 -631 b 619 -528 626 -566 623 -548 b 612 -495 619 -526 616 -510 b 577 -324 590 -387 577 -324 b 577 -324 577 -324 577 -324 b 568 -326 575 -324 571 -324 b 528 -334 558 -328 537 -333 b 465 -338 506 -337 485 -338 b 24 -11 269 -338 87 -206 b -1 145 8 41 -1 93 b 96 442 -1 249 32 351 b 322 714 166 541 236 626 l 352 745 l 345 782 l 332 843 l 315 921 b 303 984 310 950 304 978 b 295 1082 298 1017 295 1049 b 413 1426 295 1208 336 1329 b 488 1499 436 1456 477 1496 m 549 1301 b 541 1301 547 1301 544 1301 b 411 1207 500 1301 447 1263 b 355 1004 374 1152 355 1079 b 359 942 355 984 356 963 b 371 881 362 927 363 917 l 385 818 b 392 782 389 799 392 784 l 392 782 b 434 828 393 782 424 816 b 607 1165 534 941 594 1060 b 608 1193 608 1175 608 1183 b 597 1270 608 1224 604 1254 b 549 1301 589 1286 571 1299 m 398 528 b 393 555 396 542 393 553 b 392 555 393 555 393 555 b 317 470 390 555 347 505 b 190 298 266 408 212 334 b 127 70 148 227 127 148 b 155 -77 127 19 137 -30 b 468 -303 209 -216 333 -303 b 519 -299 484 -303 502 -302 b 568 -284 541 -295 568 -287 l 568 -284 b 563 -263 568 -284 566 -274 l 534 -120 l 511 -13 l 496 61 l 480 133 b 469 187 472 176 469 187 b 468 188 469 187 469 188 b 416 162 462 188 430 172 b 337 13 364 126 337 69 b 413 -124 337 -40 363 -93 b 428 -144 424 -131 428 -137 b 428 -149 428 -145 428 -148 b 409 -166 426 -161 419 -166 b 394 -162 405 -166 400 -165 b 240 77 302 -122 240 -27 l 240 77 b 430 342 240 197 315 301 l 436 344 l 426 394 l 398 528 m 548 194 b 526 195 540 195 532 195 b 519 195 524 195 521 195 l 514 195 l 518 177 l 539 79 l 552 15 l 566 -48 l 594 -187 l 605 -240 b 612 -266 609 -254 611 -266 b 612 -266 612 -266 612 -266 b 641 -248 613 -266 630 -256 b 744 -98 692 -212 730 -156 b 751 -40 749 -79 751 -59 b 548 194 751 76 665 181 "},v84:{x_min:25.859375,x_max:164.6875,ha:168,o:"m 34 369 b 40 370 35 370 38 370 b 59 353 49 370 50 367 b 164 40 122 254 155 158 b 164 0 164 33 164 16 b 164 -40 164 -16 164 -34 b 59 -353 155 -158 122 -254 b 40 -371 53 -366 47 -371 b 34 -370 38 -371 36 -370 b 25 -358 28 -367 25 -363 b 31 -337 25 -352 27 -347 b 92 0 72 -234 92 -117 b 31 335 92 116 72 233 b 25 356 27 345 25 352 b 34 369 25 363 28 366 "},v86:{x_min:-571.671875,x_max:570.3125,ha:582,o:"m -386 173 b -381 174 -385 174 -383 174 b -370 173 -377 174 -372 173 b -281 86 -367 172 -347 151 b -196 0 -235 37 -196 0 b -126 84 -196 0 -164 37 b -50 174 -55 173 -57 172 b -44 174 -49 174 -47 174 b -35 173 -42 174 -38 173 b 53 86 -32 172 -12 151 b 138 0 100 37 138 0 b 208 84 140 0 170 37 b 284 174 279 173 277 172 b 289 174 285 174 288 174 b 299 173 294 174 298 173 b 462 11 303 172 338 134 l 475 -1 l 503 34 b 541 76 534 72 536 74 b 548 77 544 77 545 77 b 570 56 560 77 570 68 b 567 48 570 54 568 51 b 392 -172 564 41 397 -166 b 378 -176 387 -174 382 -176 b 368 -174 374 -176 371 -176 b 280 -87 367 -173 345 -152 b 194 0 234 -38 194 0 b 125 -86 194 0 163 -38 b 49 -174 54 -174 55 -173 b 43 -176 47 -176 46 -176 b 34 -174 40 -176 36 -174 b -54 -87 31 -173 10 -152 b -140 0 -102 -38 -140 0 b -209 -86 -141 0 -171 -38 b -285 -174 -280 -174 -279 -173 b -291 -176 -287 -176 -289 -176 b -300 -174 -295 -176 -299 -174 b -464 -12 -304 -173 -340 -137 l -476 0 l -504 -34 b -543 -77 -534 -73 -537 -76 b -549 -79 -545 -79 -547 -79 b -571 -58 -562 -79 -571 -69 b -568 -49 -571 -55 -570 -52 b -392 172 -566 -43 -396 167 b -386 173 -390 172 -387 173 "},v8a:{x_min:-170.140625,x_max:168.78125,ha:172,o:"m -160 567 b -122 567 -159 567 -149 567 l -87 567 l -84 566 b -74 553 -78 563 -77 560 b -20 366 -73 551 -49 466 b 31 186 8 267 31 186 b 85 371 31 186 55 269 b 140 559 114 473 138 557 b 153 567 141 564 148 567 b 168 559 159 567 166 564 b 168 555 168 557 168 557 b 92 281 168 548 159 513 b 14 13 50 134 14 13 b 0 0 14 6 6 0 b -17 15 -8 0 -17 8 b -93 283 -17 15 -51 136 b -170 552 -166 533 -170 548 b -170 553 -170 552 -170 552 b -160 567 -170 560 -167 564 "},v8b:{x_min:0,x_max:319.859375,ha:326,o:"m 149 508 b 159 509 152 509 155 509 b 186 494 170 509 181 503 b 190 440 190 487 190 488 l 190 430 l 190 377 l 242 377 l 251 377 b 303 373 298 377 296 377 b 319 345 314 367 319 356 b 304 319 319 335 314 324 b 250 315 296 315 299 315 l 242 315 l 190 315 l 190 262 l 190 252 b 186 198 190 204 190 205 b 159 183 179 188 170 183 b 132 198 148 183 138 188 b 127 252 127 205 127 204 l 127 262 l 127 315 l 76 315 l 68 315 b 14 319 20 315 21 315 b 0 347 4 324 0 335 b 14 373 0 356 4 367 b 68 377 21 377 20 377 l 76 377 l 127 377 l 127 430 l 127 440 b 132 494 127 488 127 487 b 149 508 136 501 142 505 "},v8c:{x_min:-330.75,x_max:329.390625,ha:336,o:"m -133 483 b -117 484 -127 484 -122 484 b 31 373 -51 484 9 440 b 35 348 34 365 35 356 b -25 285 35 313 10 285 b -87 331 -55 285 -76 302 b -167 402 -100 376 -133 402 b -191 398 -175 402 -183 401 b -227 341 -215 388 -227 369 b -225 320 -227 334 -227 327 b -13 74 -209 230 -125 133 b 6 65 -4 70 5 66 l 9 63 l 10 65 b 117 231 12 68 40 112 l 189 341 l 242 424 b 268 460 262 456 264 458 b 283 464 273 463 277 464 b 308 438 296 464 308 453 l 308 437 b 287 396 308 430 308 428 l 95 98 l 59 43 l 58 41 l 65 37 b 253 -156 151 -8 217 -77 b 281 -285 272 -199 281 -244 b 148 -481 281 -381 231 -463 b 115 -485 137 -484 126 -485 b -32 -376 51 -485 -9 -442 b -36 -349 -35 -366 -36 -358 b 25 -287 -36 -315 -12 -287 b 85 -333 54 -287 74 -302 b 166 -403 99 -377 133 -403 b 190 -399 174 -403 182 -402 b 225 -342 215 -390 225 -370 b 224 -322 225 -335 225 -328 b 12 -76 208 -231 125 -134 b -8 -66 2 -72 -6 -68 l -10 -65 l -12 -66 b -118 -231 -13 -68 -42 -113 l -190 -342 l -243 -426 b -269 -462 -264 -458 -265 -458 b -284 -466 -274 -464 -279 -466 b -310 -440 -298 -466 -310 -455 l -310 -438 b -288 -398 -310 -430 -308 -430 l -96 -99 l -59 -44 l -59 -43 l -66 -38 b -281 284 -198 33 -281 158 l -281 284 b -133 483 -281 392 -220 474 m 254 177 b 266 179 258 177 262 179 b 319 149 287 179 307 167 b 329 115 326 140 329 127 b 319 79 329 102 326 90 b 268 51 307 61 287 51 b 221 72 250 51 234 58 b 205 115 210 84 205 99 b 254 177 205 142 223 170 m -281 -54 b -269 -52 -277 -52 -273 -52 b -223 -73 -253 -52 -235 -59 b -206 -116 -212 -84 -206 -101 b -216 -151 -206 -129 -209 -141 b -269 -179 -228 -170 -249 -179 b -314 -159 -285 -179 -302 -173 b -330 -116 -325 -147 -330 -131 b -281 -54 -330 -88 -313 -61 "},v8d:{x_min:-1.359375,x_max:255.890625,ha:261,o:"m 118 514 b 127 517 121 517 122 517 b 147 505 136 517 142 513 l 148 502 l 148 403 b 148 306 148 351 148 306 b 174 315 149 306 160 310 l 200 324 l 205 323 b 223 312 213 323 220 319 l 225 308 l 225 260 b 225 245 225 255 225 249 b 220 204 225 208 224 209 b 179 188 216 199 215 199 l 148 177 l 148 124 l 148 70 l 189 84 b 236 98 219 94 230 98 b 247 94 240 98 243 97 b 255 52 254 88 255 87 b 255 33 255 47 255 40 l 254 -12 l 253 -15 b 249 -22 253 -18 250 -20 l 245 -24 l 196 -41 l 148 -58 l 148 -108 b 148 -158 148 -136 148 -158 b 174 -148 148 -158 160 -154 b 204 -140 198 -140 200 -140 l 204 -140 b 224 -152 213 -140 221 -145 b 225 -201 224 -155 225 -177 b 224 -254 225 -226 224 -251 b 157 -284 220 -262 220 -262 l 148 -288 l 148 -395 l 148 -503 l 147 -506 b 127 -519 142 -514 134 -519 b 107 -506 119 -519 111 -514 l 106 -503 l 106 -403 b 106 -303 106 -316 106 -303 b 104 -303 104 -303 104 -303 b 88 -310 104 -303 96 -306 l 63 -319 b 51 -322 59 -320 55 -322 b 36 -315 46 -322 40 -319 b 31 -273 32 -309 31 -312 b 31 -258 31 -269 31 -263 l 31 -210 l 34 -206 b 40 -198 35 -204 38 -199 b 74 -186 42 -197 57 -191 l 106 -173 l 106 -123 b 106 -97 106 -112 106 -104 b 106 -72 106 -76 106 -72 b 104 -72 106 -72 106 -72 b 20 -99 89 -79 23 -99 b 0 -84 10 -99 2 -93 b -1 -37 0 -81 -1 -59 b 0 11 -1 -15 0 9 b 58 40 4 22 2 22 l 106 56 l 106 109 b 106 123 106 115 106 119 b 106 162 106 147 106 162 b 81 155 106 162 93 159 b 50 147 65 149 55 147 b 36 152 43 147 40 148 b 31 194 32 158 31 156 b 31 209 31 198 31 204 l 31 256 l 34 260 b 76 281 38 269 38 269 l 106 292 l 106 396 l 106 502 l 107 505 b 118 514 110 509 114 513 "},v8f:{x_min:-21.78125,x_max:362.0625,ha:369,o:"m 302 1031 b 308 1032 304 1032 307 1032 b 330 1016 318 1032 325 1027 b 362 867 351 970 362 920 b 340 738 362 824 353 780 l 336 727 l 340 717 b 362 591 355 677 362 634 b 257 323 362 496 325 401 b 204 272 243 306 227 290 b 20 56 129 206 66 133 b -1 18 12 44 0 22 b -19 4 -4 9 -12 4 l -21 4 l -21 140 l -21 276 l -12 277 b 167 333 61 288 127 309 b 319 598 262 388 319 491 b 311 664 319 620 317 642 l 310 673 l 304 664 b 204 548 279 620 250 587 b 20 333 129 483 66 409 b -1 292 12 320 0 298 b -19 280 -4 285 -12 280 l -21 280 l -21 416 l -21 552 l -12 553 b 167 609 61 564 127 585 b 319 874 264 666 319 770 b 294 992 319 914 311 954 b 288 1011 288 1004 288 1007 b 302 1031 288 1021 294 1028 "},v90:{x_min:-171.5,x_max:483.1875,ha:493,o:"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 495 20 616 20 616 b 20 373 20 427 20 373 b 115 410 20 373 63 390 l 210 448 l 210 531 b 212 620 210 614 210 616 b 231 632 215 628 223 632 b 246 627 236 632 242 631 b 251 541 251 620 251 628 l 251 463 l 315 489 b 387 514 368 509 381 514 b 393 513 390 514 392 514 b 406 494 402 510 406 502 b 397 476 406 487 404 480 b 323 446 396 474 363 462 l 251 417 l 251 283 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -19 -217 -9 -229 -16 -224 l -20 -215 l -21 48 l -21 310 l -83 287 b -152 262 -133 266 -145 262 b -157 263 -153 262 -155 262 b -171 283 -166 266 -171 274 b -161 301 -171 290 -167 297 b -91 328 -160 302 -129 315 l -21 356 l -21 487 l -20 617 l -19 621 b -8 631 -17 626 -12 630 m 210 288 b 210 401 210 351 210 401 b 114 365 209 401 167 384 l 20 327 l 20 238 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 180 164 199 187 192 l 209 177 b 209 177 209 177 209 177 b 210 288 210 177 210 199 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "},v92:{x_min:0,x_max:598.890625,ha:611,o:"m 62 181 b 77 183 66 183 72 183 b 91 181 83 183 88 183 b 202 131 100 180 106 177 l 299 87 l 394 131 b 517 183 499 181 502 183 b 519 183 517 183 518 183 b 598 104 567 183 598 144 b 577 49 598 84 592 65 b 518 15 567 38 563 37 b 484 0 499 6 484 0 b 518 -16 484 -1 499 -8 b 577 -51 563 -38 567 -40 b 598 -105 592 -66 598 -86 b 519 -184 598 -145 567 -184 b 517 -184 518 -184 517 -184 b 394 -133 502 -184 499 -183 l 299 -88 l 202 -133 b 81 -184 99 -183 95 -184 b 77 -184 80 -184 78 -184 b 0 -105 29 -184 0 -145 b 20 -51 0 -86 5 -66 b 80 -16 29 -40 34 -38 b 114 -1 98 -8 114 -1 b 80 15 114 0 98 6 b 20 49 34 37 29 38 b 0 104 6 65 0 84 b 62 181 0 140 23 174 m 88 134 b 74 136 85 134 80 136 b 68 134 72 136 69 136 b 46 104 54 130 46 117 b 55 81 46 95 49 88 b 149 34 59 76 53 80 b 224 -1 190 15 224 0 b 144 -38 224 -1 187 -18 b 54 -84 59 -79 58 -79 b 46 -105 49 -90 46 -98 b 76 -137 46 -122 58 -137 b 78 -137 77 -137 77 -137 b 194 -86 87 -137 76 -141 b 298 -36 250 -58 298 -36 b 298 -36 298 -36 298 -36 b 402 -84 299 -36 345 -58 b 518 -137 522 -141 510 -137 b 521 -137 519 -137 519 -137 b 551 -105 539 -137 551 -122 b 541 -83 551 -98 548 -90 b 447 -36 537 -77 544 -81 b 374 -1 406 -16 374 -1 b 447 34 374 0 406 15 b 541 81 544 80 537 76 b 551 104 548 88 551 97 b 521 136 551 120 539 136 b 518 136 519 136 519 136 b 517 136 518 136 517 136 l 517 136 b 402 83 511 136 511 136 b 298 34 345 56 299 34 b 298 34 298 34 298 34 b 194 84 298 34 250 56 b 88 134 137 111 89 133 "},v93:{x_min:0,x_max:438.28125,ha:447,o:"m 212 205 b 219 205 213 205 216 205 b 239 183 228 205 231 204 b 421 -163 298 40 363 -83 b 438 -191 434 -180 438 -186 b 436 -197 438 -192 438 -195 b 424 -206 434 -204 431 -206 b 406 -201 420 -206 415 -205 b 216 -156 347 -172 281 -156 b 23 -205 148 -156 80 -173 b 14 -206 20 -206 17 -206 b 0 -191 6 -206 0 -201 b 6 -176 0 -187 1 -183 b 202 192 63 -104 142 45 b 212 205 205 199 208 202 m 264 48 l 249 81 l 243 94 l 242 91 b 89 -126 208 36 137 -66 b 81 -138 85 -133 81 -138 b 81 -138 81 -138 81 -138 b 81 -138 81 -138 81 -138 b 95 -133 81 -138 87 -136 b 280 -94 156 -108 221 -94 b 334 -98 299 -94 317 -95 b 343 -99 338 -99 343 -99 b 343 -99 343 -99 343 -99 b 338 -94 343 -99 341 -97 b 264 48 318 -58 287 1 "},v94:{x_min:-149.71875,x_max:148.359375,ha:151,o:"m -9 215 b 0 217 -6 217 -4 217 b 19 205 8 217 14 213 b 20 142 20 202 20 201 l 20 84 l 23 84 b 144 -27 81 74 129 30 b 148 -66 147 -40 148 -54 b 36 -213 148 -134 103 -197 b 0 -219 24 -217 12 -219 b -145 -104 -68 -219 -129 -173 b -149 -68 -148 -91 -149 -79 b -24 84 -149 6 -98 74 l -21 84 l -21 142 b -19 205 -20 201 -20 202 b -9 215 -17 209 -13 213 m -21 -15 b -23 41 -21 37 -21 41 b -23 41 -23 41 -23 41 b -76 11 -35 40 -62 26 b -108 -65 -98 -11 -108 -38 b -1 -176 -108 -122 -65 -176 b 107 -65 63 -176 107 -122 b 74 11 107 -38 96 -11 b 20 41 61 26 32 41 b 20 -15 20 41 20 15 b 19 -74 20 -72 20 -72 b 0 -87 14 -83 6 -87 b -19 -74 -8 -87 -16 -83 b -21 -15 -20 -72 -20 -72 "},v95:{x_min:0,x_max:406.96875,ha:415,o:"m 55 181 b 70 183 61 183 66 183 b 111 170 85 183 99 179 b 160 130 115 167 137 149 l 202 95 l 245 130 b 319 181 299 176 302 179 b 334 183 325 183 330 183 b 406 109 375 183 406 148 b 401 81 406 99 405 91 b 348 24 394 65 390 59 b 318 -1 332 11 318 0 b 348 -26 318 -1 332 -12 b 401 -83 390 -61 394 -66 b 406 -111 405 -93 406 -101 b 334 -184 406 -149 375 -184 b 319 -183 330 -184 325 -184 b 245 -131 302 -180 299 -177 l 202 -97 l 160 -131 b 85 -183 107 -177 103 -180 b 70 -184 80 -184 76 -184 b 0 -111 31 -184 0 -149 b 4 -83 0 -101 1 -93 b 58 -26 10 -66 16 -61 b 88 -1 74 -12 88 -1 b 58 24 88 0 74 11 b 10 69 23 54 17 59 b 0 109 2 81 0 95 b 55 181 0 142 21 173 m 83 133 b 72 136 78 136 76 136 b 57 131 66 136 61 134 b 46 109 49 126 46 117 b 50 93 46 104 47 98 b 107 45 51 91 77 70 b 160 0 137 20 160 0 b 107 -47 160 -1 137 -22 b 50 -94 77 -72 51 -93 b 46 -111 47 -99 46 -105 b 59 -134 46 -120 50 -130 b 72 -137 62 -136 68 -137 b 83 -136 76 -137 80 -136 b 144 -84 84 -134 107 -116 b 202 -36 176 -58 202 -36 b 261 -84 202 -36 230 -58 b 323 -136 299 -116 321 -134 b 334 -137 326 -136 330 -137 b 345 -134 338 -137 343 -136 b 360 -111 355 -130 360 -120 b 355 -94 360 -105 359 -99 b 299 -47 353 -93 329 -72 b 245 0 269 -22 245 -1 b 299 45 245 0 269 20 b 355 93 329 70 353 91 b 360 109 359 98 360 104 b 345 133 360 119 355 129 b 334 136 343 134 338 136 b 323 134 330 136 326 134 b 261 83 321 133 299 115 b 202 34 230 56 202 34 b 144 83 202 34 176 56 b 83 133 106 115 84 133 "},v97:{x_min:-228.671875,x_max:227.3125,ha:232,o:"m -217 487 l -213 488 l 0 488 l 212 488 l 216 487 b 225 476 220 484 224 480 l 227 473 l 227 244 l 227 15 l 225 12 b 206 0 223 4 215 0 b 197 1 204 0 200 0 b 187 12 193 4 189 6 l 186 15 l 186 138 l 186 262 l -1 262 l -187 262 l -187 138 l -187 15 l -189 12 b -208 0 -193 4 -200 0 b -227 12 -216 0 -223 4 l -228 15 l -228 244 l -228 473 l -227 476 b -217 487 -225 480 -221 484 "},v9a:{x_min:-21.78125,x_max:367.5,ha:375,o:"m 230 1031 b 238 1032 232 1032 235 1032 b 259 1014 245 1032 251 1027 b 367 662 330 906 367 782 b 364 602 367 641 367 621 b 232 317 352 488 304 384 b 57 120 155 245 103 187 b -1 18 31 84 6 40 b -19 4 -4 11 -12 4 l -21 4 l -21 159 l -21 315 l -16 315 b 96 335 10 315 62 324 b 315 695 227 380 315 527 b 313 738 315 709 314 724 b 224 991 304 825 273 916 b 216 1013 219 999 216 1007 b 230 1031 216 1021 220 1028 "},v9b:{x_min:-24.5,x_max:313.0625,ha:319,o:"m -24 -133 l -24 -5 l -20 -5 b -1 -19 -12 -5 -4 -11 b 142 -213 13 -61 74 -144 b 258 -376 196 -269 230 -315 b 313 -605 295 -449 313 -528 b 292 -742 313 -652 306 -699 b 288 -752 289 -748 288 -752 b 288 -752 288 -752 288 -752 b 292 -764 289 -753 291 -757 b 313 -907 306 -811 313 -860 b 292 -1045 313 -954 306 -1002 b 288 -1054 289 -1050 288 -1054 b 288 -1054 288 -1054 288 -1054 b 292 -1067 289 -1054 291 -1060 b 313 -1210 306 -1113 313 -1161 b 292 -1346 313 -1257 306 -1304 b 288 -1357 289 -1353 288 -1357 b 288 -1357 288 -1357 288 -1357 b 292 -1368 289 -1357 291 -1363 b 313 -1512 306 -1415 313 -1464 b 292 -1648 313 -1560 306 -1605 b 288 -1660 289 -1654 288 -1660 b 288 -1660 288 -1660 288 -1660 b 292 -1671 289 -1660 291 -1665 b 313 -1814 306 -1719 313 -1766 b 250 -2040 313 -1897 291 -1977 b 232 -2062 238 -2057 236 -2059 b 221 -2065 230 -2063 225 -2065 b 200 -2045 210 -2065 201 -2057 b 200 -2043 200 -2044 200 -2044 b 208 -2026 200 -2037 202 -2034 b 269 -1826 249 -1966 269 -1897 b 153 -1544 269 -1726 230 -1625 b -9 -1472 115 -1506 58 -1481 b -21 -1471 -14 -1471 -19 -1471 l -24 -1471 l -24 -1343 l -24 -1215 l -20 -1215 b -1 -1229 -12 -1215 -4 -1221 b 142 -1424 13 -1270 74 -1353 b 257 -1582 196 -1478 228 -1524 b 264 -1594 261 -1589 264 -1594 l 264 -1594 b 265 -1582 264 -1594 264 -1589 b 270 -1525 268 -1562 270 -1544 b 153 -1243 270 -1424 228 -1321 b -9 -1170 115 -1203 58 -1178 b -21 -1168 -14 -1170 -19 -1168 l -24 -1168 l -24 -1041 l -24 -913 l -20 -913 b -1 -927 -12 -913 -4 -918 b 142 -1121 13 -967 74 -1050 b 257 -1281 196 -1175 228 -1221 b 264 -1292 261 -1286 264 -1292 l 264 -1292 b 265 -1279 264 -1292 264 -1286 b 270 -1222 268 -1261 270 -1242 b 153 -941 270 -1121 228 -1018 b -9 -867 115 -900 58 -875 b -21 -866 -14 -867 -19 -866 l -24 -866 l -24 -738 l -24 -610 l -20 -610 b -1 -624 -12 -610 -4 -616 b 142 -818 13 -664 74 -749 b 257 -978 196 -873 228 -918 b 264 -989 261 -984 264 -989 l 264 -989 b 265 -977 264 -989 264 -984 b 270 -920 268 -959 270 -939 b 153 -638 270 -818 228 -716 b -9 -564 115 -598 58 -573 b -21 -563 -14 -564 -19 -563 l -24 -563 l -24 -435 l -24 -308 l -20 -308 b -1 -322 -12 -308 -4 -313 b 142 -516 13 -363 74 -446 b 257 -675 196 -571 228 -616 b 264 -687 261 -681 264 -687 l 264 -687 b 265 -674 264 -687 264 -681 b 270 -617 268 -656 270 -637 b 153 -335 270 -516 228 -413 b -9 -262 115 -295 58 -270 b -21 -260 -14 -262 -19 -260 l -24 -260 l -24 -133 "},v9c:{x_min:-166.0625,x_max:-25.859375,ha:0,o:"m -49 369 b -42 370 -46 369 -44 370 b -27 360 -36 370 -29 366 b -25 355 -27 359 -25 358 b -32 335 -25 351 -28 347 b -92 52 -66 248 -87 159 b -93 -1 -93 43 -93 20 b -92 -54 -93 -23 -93 -45 b -32 -337 -85 -162 -66 -251 b -25 -355 -27 -349 -25 -352 b -42 -371 -25 -365 -32 -371 b -61 -353 -50 -371 -51 -369 b -163 -63 -119 -262 -153 -165 b -166 -1 -166 -37 -166 -31 b -163 62 -166 30 -166 36 b -61 352 -153 163 -119 260 b -49 369 -54 365 -51 366 "},v9e:{x_min:0,x_max:607.0625,ha:619,o:"m 243 631 b 250 632 246 632 249 632 b 270 620 259 632 268 628 l 272 616 l 272 201 l 272 -212 l 270 -216 b 251 -229 268 -224 259 -229 b 227 -215 243 -229 240 -229 l 151 -142 b 32 -16 81 -80 53 -49 b 0 84 9 18 0 52 b 111 199 0 149 42 199 b 137 197 119 199 127 198 b 228 151 168 191 197 177 l 231 148 l 231 383 b 232 620 231 616 231 616 b 243 631 234 624 238 630 m 168 131 b 152 133 163 133 157 133 b 107 102 130 133 111 120 b 106 86 107 97 106 91 b 111 41 106 73 108 56 b 227 -152 125 -13 171 -90 l 231 -156 l 231 -37 l 231 80 l 225 87 b 168 131 210 111 190 126 m 347 631 b 353 632 348 632 351 632 b 374 620 363 632 371 628 b 375 383 375 616 375 616 l 375 148 l 377 151 b 492 199 415 183 454 199 b 537 191 507 199 522 197 b 607 84 582 176 607 134 b 583 0 607 58 598 29 b 455 -142 562 -40 533 -72 l 378 -215 b 355 -229 364 -229 362 -229 b 334 -216 345 -229 337 -224 l 333 -212 l 333 201 l 333 616 l 334 620 b 347 631 337 624 341 630 m 465 131 b 451 133 461 133 455 133 b 445 133 449 133 446 133 b 379 87 419 129 396 113 l 375 80 l 375 -37 l 375 -156 l 378 -152 b 499 81 451 -72 499 20 l 499 83 b 465 131 499 113 490 126 "},va3:{x_min:58.53125,x_max:228.671875,ha:294,o:"m 138 371 b 142 373 140 371 141 373 b 178 342 149 373 156 366 b 228 251 217 297 228 278 b 228 244 228 248 228 247 b 176 147 227 212 212 184 b 123 73 152 122 132 93 b 121 62 122 70 121 66 b 145 13 121 48 129 31 b 153 -2 151 6 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 145 -11 b 129 -1 140 -11 136 -8 b 61 87 89 37 68 68 b 58 113 59 95 58 105 b 110 215 58 144 74 177 b 163 287 134 240 155 269 b 166 299 166 291 166 295 b 141 348 166 313 157 330 b 133 360 134 356 133 358 b 133 363 133 362 133 362 b 138 371 133 367 136 370 "},va5:{x_min:0,x_max:349.8125,ha:357,o:"m 88 302 b 103 303 93 302 98 303 b 202 224 149 303 191 270 b 205 199 204 216 205 208 b 178 129 205 173 196 147 l 175 126 l 182 127 b 307 249 236 142 284 190 b 313 259 308 254 311 258 b 329 267 317 265 323 267 b 349 247 340 267 349 259 b 201 -263 349 242 204 -258 b 182 -273 197 -270 190 -273 b 163 -260 174 -273 166 -269 b 161 -256 161 -259 161 -258 b 217 -59 161 -248 170 -220 b 272 129 247 43 272 127 b 272 129 272 129 272 129 b 264 122 272 129 268 126 b 140 80 227 94 183 80 b 36 115 102 80 65 91 b 0 194 10 136 0 165 b 88 302 0 244 32 292 "},va9:{x_min:-24.5,x_max:314.421875,ha:321,o:"m -24 -145 l -24 -5 l -20 -5 b 0 -23 -9 -5 -2 -12 b 27 -87 4 -38 14 -66 b 138 -220 53 -136 88 -177 b 235 -328 179 -255 208 -288 b 314 -592 287 -409 314 -501 b 292 -732 314 -639 307 -687 l 289 -742 l 294 -756 b 314 -896 307 -802 314 -849 b 292 -1035 314 -943 307 -991 l 289 -1045 l 294 -1057 b 314 -1197 307 -1104 314 -1152 b 292 -1338 314 -1246 307 -1292 l 289 -1347 l 294 -1360 b 314 -1500 307 -1407 314 -1454 b 273 -1689 314 -1565 300 -1628 b 250 -1712 265 -1710 261 -1712 b 228 -1691 236 -1712 228 -1704 l 228 -1685 l 234 -1675 b 270 -1507 258 -1621 270 -1564 b 98 -1193 270 -1381 209 -1261 b 40 -1174 76 -1179 58 -1174 b -10 -1189 24 -1174 8 -1178 b -20 -1192 -14 -1192 -16 -1192 l -24 -1192 l -24 -1052 l -24 -913 l -20 -913 b 0 -931 -9 -913 -2 -920 b 27 -995 4 -946 14 -974 b 138 -1128 53 -1043 88 -1085 b 257 -1275 190 -1172 228 -1220 b 262 -1283 259 -1279 262 -1283 l 262 -1283 b 269 -1249 264 -1282 268 -1260 b 270 -1206 270 -1233 270 -1220 b 98 -891 270 -1075 206 -957 b 40 -871 76 -877 58 -871 b -10 -886 24 -871 8 -875 b -20 -889 -14 -889 -16 -889 l -24 -889 l -24 -749 l -24 -610 l -20 -610 b 0 -628 -9 -610 -2 -617 b 27 -692 4 -644 14 -671 b 138 -825 53 -741 88 -782 b 257 -973 190 -870 228 -917 b 262 -981 259 -977 262 -981 l 262 -981 b 269 -946 264 -979 268 -957 b 270 -903 270 -931 270 -917 b 98 -588 270 -774 206 -655 b 40 -569 76 -574 58 -569 b -10 -584 24 -569 8 -574 b -20 -587 -14 -587 -16 -587 l -24 -587 l -24 -448 l -24 -308 l -20 -308 b 0 -326 -9 -308 -2 -315 b 27 -390 4 -341 14 -369 b 138 -523 53 -438 88 -480 b 257 -670 190 -567 228 -614 b 262 -678 259 -674 262 -678 b 262 -678 262 -678 262 -678 b 269 -644 264 -677 268 -656 b 270 -601 270 -628 270 -614 b 98 -285 270 -471 206 -352 b 40 -266 76 -273 58 -266 b -10 -281 24 -266 8 -272 b -20 -284 -14 -284 -16 -284 l -24 -284 l -24 -145 "},vaa:{x_min:-1.359375,x_max:752.703125,ha:768,o:"m 490 985 b 504 986 495 986 500 986 b 604 907 551 986 593 954 b 607 884 607 900 607 892 b 581 813 607 857 597 831 l 578 810 l 583 811 b 710 932 638 827 687 873 b 714 943 711 936 713 942 b 730 952 720 949 725 952 b 752 931 741 952 752 943 b 200 -946 752 927 204 -941 b 182 -957 197 -953 190 -957 b 163 -945 174 -957 166 -953 b 161 -939 161 -942 161 -942 b 217 -743 161 -931 170 -904 b 272 -555 247 -639 272 -555 b 272 -555 272 -555 272 -555 b 264 -560 272 -555 268 -557 b 140 -603 227 -589 182 -603 b 36 -567 102 -603 65 -592 b -1 -487 12 -548 -1 -517 b 17 -427 -1 -466 5 -445 b 103 -380 38 -395 70 -380 b 191 -433 137 -380 172 -398 b 205 -484 201 -448 205 -466 b 178 -553 205 -509 196 -535 l 175 -557 l 182 -555 b 307 -435 236 -539 284 -494 b 372 -213 308 -430 372 -215 b 372 -213 372 -213 372 -213 b 364 -219 372 -213 368 -216 b 240 -262 328 -247 283 -262 b 137 -226 202 -262 166 -249 b 99 -145 112 -206 99 -176 b 118 -84 99 -124 106 -104 b 204 -38 138 -54 171 -38 b 292 -91 238 -38 273 -56 b 306 -141 302 -106 306 -124 b 279 -212 306 -167 296 -194 l 276 -215 l 281 -213 b 408 -93 336 -198 385 -151 b 473 129 409 -88 473 127 b 473 129 473 129 473 129 b 465 122 473 129 469 126 b 341 80 428 94 383 80 b 236 115 303 80 266 91 b 200 195 213 136 200 165 b 217 256 200 217 206 238 b 304 303 239 287 272 303 b 393 249 338 303 374 285 b 406 199 402 234 406 217 b 379 129 406 173 397 148 l 377 126 l 382 127 b 509 248 436 142 485 190 b 574 470 510 254 574 469 b 574 470 574 470 574 470 b 566 464 574 470 570 467 b 442 421 529 435 484 421 b 337 458 404 421 367 433 b 300 538 314 477 300 508 b 318 598 300 559 306 580 b 404 645 340 630 372 645 b 494 592 439 645 475 627 b 507 541 502 577 507 559 b 480 471 507 516 498 489 l 477 467 l 483 470 b 608 589 537 485 586 531 b 675 811 611 595 675 810 b 675 811 675 811 675 811 b 666 806 675 811 671 809 b 543 763 628 777 585 763 b 438 799 504 763 468 775 b 401 878 412 820 401 849 b 490 985 401 928 434 977 "},vab:{x_min:0,x_max:272.21875,ha:278,o:"m 243 631 b 250 632 246 632 249 632 b 270 620 259 632 268 628 l 272 616 l 272 201 l 272 -212 l 270 -216 b 251 -229 268 -224 259 -229 b 227 -215 243 -229 240 -229 l 151 -142 b 32 -16 81 -80 53 -49 b 0 84 9 18 0 52 b 111 199 0 149 42 199 b 137 197 119 199 127 198 b 228 151 168 191 197 177 l 231 148 l 231 383 b 232 620 231 616 231 616 b 243 631 234 624 238 630 m 168 131 b 152 133 163 133 157 133 b 107 102 130 133 111 120 b 106 86 107 97 106 91 b 111 41 106 73 108 56 b 227 -152 125 -13 171 -90 l 231 -156 l 231 -37 l 231 80 l 225 87 b 168 131 210 111 190 126 "},vad:{x_min:0,x_max:873.828125,ha:892,o:"m 0 0 l 0 703 l 81 703 l 164 703 l 164 0 l 164 -705 l 81 -705 l 0 -705 l 0 0 m 225 0 l 225 703 l 246 703 l 268 703 l 268 366 l 268 30 l 274 36 b 314 79 284 44 302 63 b 413 302 357 137 392 213 b 432 327 419 324 421 327 b 449 306 443 327 447 322 b 611 115 457 195 529 115 b 651 122 624 115 638 117 b 728 316 705 140 724 188 b 729 388 728 342 729 366 b 671 635 729 533 711 602 b 581 662 649 652 616 662 b 477 637 545 662 510 653 l 475 635 l 477 634 b 503 627 488 632 495 631 b 545 556 532 612 545 584 b 491 480 545 524 526 491 b 465 474 481 476 473 474 b 379 563 417 474 379 516 b 389 602 379 576 382 588 b 541 691 409 641 479 681 b 582 694 555 692 568 694 b 865 462 714 694 834 598 b 873 392 871 440 873 416 b 865 317 873 367 871 341 b 639 84 839 194 748 101 b 612 83 630 83 620 83 b 511 116 577 83 543 94 b 504 120 509 119 506 120 b 504 120 504 120 504 120 b 469 59 504 120 488 93 l 432 -1 l 469 -61 b 504 -122 488 -94 504 -122 b 504 -122 504 -122 504 -122 b 511 -117 506 -122 509 -120 b 612 -84 543 -95 577 -84 b 665 -91 630 -84 647 -87 b 869 -338 771 -122 850 -216 b 873 -392 872 -356 873 -374 b 798 -595 873 -469 847 -539 b 581 -695 741 -662 660 -695 b 406 -626 517 -695 454 -671 b 381 -563 389 -607 381 -585 b 465 -477 381 -519 413 -477 b 545 -559 514 -477 545 -519 b 503 -628 545 -587 532 -613 b 477 -635 495 -632 488 -634 l 475 -637 l 477 -638 b 581 -663 510 -655 545 -663 b 671 -637 616 -663 649 -653 b 729 -391 711 -603 729 -534 b 728 -317 729 -367 728 -344 b 623 -117 722 -173 698 -124 b 611 -116 619 -116 615 -116 b 449 -308 528 -116 457 -198 b 432 -328 447 -323 443 -328 b 413 -303 421 -328 419 -326 b 314 -80 392 -215 357 -138 b 274 -37 302 -65 284 -45 l 268 -31 l 268 -367 l 268 -705 l 246 -705 l 225 -705 l 225 0 "},vb1:{x_min:78.9375,x_max:485.921875,ha:417,o:"m 362 378 b 378 380 367 380 372 380 b 472 348 415 380 453 367 b 485 315 481 338 485 327 b 462 273 485 298 477 281 b 439 267 454 269 446 267 b 398 290 424 267 409 274 b 344 319 385 309 364 319 b 281 269 315 319 289 301 b 279 262 280 266 279 262 b 276 256 279 260 277 258 b 274 249 276 254 274 251 b 238 127 273 248 257 192 b 201 4 217 61 201 5 b 166 -1 198 -1 200 -1 b 153 -1 163 -1 157 -1 b 141 -1 148 -1 144 -1 b 104 4 106 -1 107 -1 b 104 6 104 5 104 5 b 142 144 104 13 110 34 b 182 278 164 219 181 276 b 183 288 182 281 182 285 b 185 302 185 292 185 298 b 164 330 185 317 176 328 b 159 330 163 330 161 330 b 102 302 140 330 119 320 b 91 294 95 295 93 294 b 88 294 91 294 89 294 b 78 303 83 294 78 298 b 81 312 78 306 78 309 b 200 373 106 347 160 373 b 215 371 205 373 209 371 b 266 335 235 367 254 353 b 269 331 268 333 269 331 b 269 331 269 331 269 331 b 273 335 269 331 270 334 b 362 378 298 359 330 376 "},vb3:{x_min:0,x_max:227.3125,ha:232,o:"m 91 213 b 100 215 93 215 96 215 b 227 58 167 215 224 144 b 227 52 227 56 227 54 b 61 -201 227 -43 164 -138 b 29 -216 44 -212 36 -216 b 23 -210 27 -216 24 -213 b 21 -205 21 -208 21 -206 b 34 -192 21 -201 25 -197 b 122 -55 89 -161 122 -106 b 104 6 122 -33 117 -12 l 103 9 l 96 9 b 4 79 57 9 17 38 b 0 112 1 90 0 101 b 91 213 0 163 36 209 "},vb4:{x_min:-597.53125,x_max:596.171875,ha:608,o:"m -533 324 b -525 327 -530 326 -528 327 b -504 305 -514 327 -504 317 b -504 305 -504 305 -504 305 b -513 284 -504 299 -504 299 b -556 112 -541 226 -556 167 b -545 33 -556 84 -552 58 b -524 -20 -541 15 -532 -9 l -522 -23 l -491 15 l -413 111 b -355 174 -367 169 -363 174 b -351 174 -353 174 -352 174 b -254 86 -343 174 -348 179 b -168 -1 -208 37 -168 -1 b -100 84 -168 -1 -137 37 b -23 173 -28 173 -29 172 b -19 174 -21 174 -20 174 b -8 173 -14 174 -10 173 b 80 86 -5 172 13 151 b 166 -1 127 37 166 -1 b 235 84 166 -1 197 37 b 311 173 306 173 304 172 b 317 174 313 174 314 174 b 326 173 319 174 323 173 b 490 11 329 172 366 134 l 502 -1 l 530 34 b 568 76 560 72 563 74 b 575 77 570 77 573 77 b 596 56 586 77 596 68 b 594 48 596 54 596 51 b 417 -172 592 41 424 -166 b 405 -176 415 -174 409 -176 b 396 -174 401 -176 398 -176 b 307 -87 393 -173 372 -152 b 221 -1 259 -38 221 -1 b 152 -86 221 -1 190 -38 b 76 -176 81 -174 83 -173 b 70 -176 74 -176 73 -176 b 61 -174 66 -176 62 -174 b -27 -87 58 -173 38 -152 b -114 -1 -74 -38 -112 -1 b -182 -86 -114 -1 -145 -38 b -258 -176 -253 -174 -253 -173 b -264 -176 -259 -176 -262 -176 b -274 -174 -268 -176 -272 -174 b -438 -11 -277 -173 -348 -102 l -449 0 l -479 -37 b -524 -80 -513 -80 -514 -80 l -524 -80 b -553 -52 -534 -80 -540 -74 b -597 109 -583 -8 -597 48 b -560 280 -597 165 -585 224 b -533 324 -548 310 -540 322 "},vb6:{x_min:0,x_max:556.6875,ha:568,o:"m 289 545 b 298 546 292 545 295 546 b 318 533 306 546 315 541 b 319 428 319 530 319 528 l 319 327 l 334 327 b 526 223 412 326 485 285 b 543 172 537 206 543 190 b 447 76 543 122 503 76 b 445 76 446 76 446 76 b 359 165 394 77 359 119 b 368 205 359 179 362 192 b 441 251 382 233 412 251 b 455 249 446 251 451 251 b 460 248 458 249 460 248 b 460 248 460 248 460 248 b 454 254 460 249 458 251 b 334 295 419 280 378 294 l 319 295 l 319 4 l 319 -287 l 321 -285 b 328 -285 322 -285 325 -285 b 524 -99 424 -277 507 -198 b 541 -79 526 -84 530 -79 b 556 -97 551 -79 556 -84 b 548 -133 556 -105 553 -117 b 334 -317 521 -233 434 -306 b 322 -319 329 -317 323 -317 l 319 -319 l 319 -424 b 319 -471 319 -444 319 -459 b 313 -541 319 -544 318 -535 b 298 -548 308 -545 303 -548 b 279 -534 289 -548 281 -542 b 277 -424 277 -531 277 -530 l 277 -317 l 273 -317 b 13 -95 153 -305 51 -217 b 0 2 4 -62 0 -29 b 182 295 0 126 66 238 b 274 324 210 309 249 320 l 277 324 l 277 427 b 279 533 277 528 277 530 b 289 545 281 538 285 542 m 277 2 b 277 291 277 161 277 291 b 268 288 277 291 273 290 b 144 1 179 265 144 184 b 276 -284 144 -199 175 -267 l 277 -285 l 277 2 "},vb7:{x_min:-176.9375,x_max:251.8125,ha:257,o:"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 503 20 616 20 614 b 20 391 20 442 20 391 b 84 424 20 391 49 406 l 147 456 l 152 456 b 153 456 153 456 153 456 b 175 435 166 456 175 446 b 172 427 175 433 174 430 b 92 380 170 420 172 421 l 20 342 l 20 245 l 20 148 l 21 151 b 137 199 59 183 99 199 b 182 191 152 199 167 197 b 251 84 227 176 251 134 b 228 0 251 58 243 29 b 100 -142 206 -40 178 -72 l 23 -215 b 0 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 b -21 54 -21 -212 -21 -212 b -21 322 -21 201 -21 322 b -85 290 -21 322 -50 308 l -148 256 l -153 256 b -155 256 -155 256 -155 256 b -176 277 -167 256 -176 266 b -174 285 -176 280 -175 283 b -93 333 -171 294 -174 292 l -21 370 l -21 494 b -20 620 -21 616 -21 616 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 "},vb9:{x_min:-122.5,x_max:121.140625,ha:124,o:"m -16 145 b 0 147 -10 147 -5 147 b 121 -1 66 147 121 77 b 114 -49 121 -16 118 -33 b -1 -148 95 -112 47 -148 b -85 -106 -31 -148 -61 -134 b -122 -1 -110 -76 -122 -38 b -16 145 -122 68 -81 134 m 12 111 b 0 113 8 113 4 113 b -68 22 -29 113 -61 73 b -70 0 -69 15 -70 6 b -13 -113 -70 -49 -47 -98 b -1 -115 -9 -115 -5 -115 b 63 -40 24 -115 53 -83 b 68 -1 66 -27 68 -15 b 12 111 68 48 46 97 "},vba:{x_min:-118.421875,x_max:597.53125,ha:381,o:"m 460 574 b 464 574 461 574 462 574 b 488 574 470 574 481 574 b 500 573 491 574 498 574 b 594 503 543 570 588 538 b 597 488 596 498 597 494 b 528 417 597 449 564 417 b 502 423 519 417 510 419 b 465 481 477 434 465 458 b 488 528 465 499 472 516 b 490 530 490 530 490 530 b 490 530 490 530 490 530 b 468 517 488 530 475 523 b 349 340 419 485 377 420 b 347 330 348 334 347 330 b 383 328 347 328 363 328 b 428 326 423 328 424 328 b 442 302 438 320 442 312 b 430 281 442 294 438 285 b 385 276 424 277 426 276 l 377 276 l 332 276 l 330 269 b 178 -117 303 126 250 -9 b 1 -249 129 -194 69 -237 b -20 -251 -6 -251 -13 -251 b -114 -187 -65 -251 -100 -227 b -118 -156 -117 -177 -118 -166 b -51 -84 -118 -116 -91 -84 b -31 -87 -46 -84 -39 -86 b 16 -152 0 -95 16 -124 b -12 -205 16 -173 8 -194 b -16 -208 -14 -206 -16 -208 b -14 -208 -16 -208 -14 -208 b -9 -206 -14 -208 -12 -208 b 74 -124 23 -197 54 -166 b 172 224 98 -79 125 22 b 185 276 178 252 183 274 b 185 276 185 276 185 276 b 141 276 185 276 181 276 b 91 280 96 276 96 276 b 77 302 83 285 77 294 b 91 326 77 312 83 320 b 148 328 95 328 96 328 l 198 330 l 202 341 b 460 574 249 473 351 566 "},vbf:{x_min:-53.078125,x_max:513.140625,ha:485,o:"m 185 383 b 196 384 187 383 191 384 b 277 334 230 384 259 365 b 288 301 281 324 288 306 b 288 297 288 298 288 297 b 294 302 289 297 291 299 b 394 370 323 338 367 367 b 404 371 398 370 401 371 b 510 272 453 371 498 328 b 513 237 513 262 513 251 b 507 172 513 217 511 192 b 326 -34 487 59 412 -26 b 314 -36 322 -36 318 -36 b 274 -24 298 -36 283 -31 l 265 -16 b 224 44 246 -1 232 20 b 223 49 224 47 223 49 b 223 49 223 49 223 49 b 149 -197 221 48 149 -194 b 149 -198 149 -197 149 -198 b 170 -210 149 -202 155 -205 b 187 -215 174 -210 175 -212 b 204 -231 201 -219 204 -222 b 197 -245 204 -240 202 -242 l 194 -248 l 76 -248 l -42 -248 l -46 -245 b -53 -231 -51 -242 -53 -240 b -35 -215 -53 -222 -49 -217 b -13 -210 -21 -212 -20 -212 b -6 -208 -10 -209 -8 -208 b 0 -206 -6 -208 -2 -206 b 25 -188 13 -201 21 -195 b 163 280 28 -183 163 276 b 166 291 163 283 164 287 b 167 302 167 295 167 299 b 155 324 167 315 161 324 b 155 324 155 324 155 324 b 65 230 125 322 85 280 b 53 215 61 217 58 215 b 51 215 53 215 51 215 b 42 224 46 215 42 217 b 57 263 42 231 47 244 b 140 360 77 305 104 337 b 152 370 144 365 149 369 b 185 383 157 376 172 381 m 374 306 b 366 308 371 308 368 308 b 300 273 348 308 321 294 b 284 254 288 262 287 259 b 280 242 283 249 281 245 b 257 169 279 240 270 213 l 236 98 l 236 93 b 251 48 238 77 243 61 b 279 27 258 37 272 27 b 281 27 279 27 280 27 b 291 31 281 27 287 30 b 396 170 334 52 378 109 b 406 247 402 197 406 224 b 401 277 406 259 405 270 b 374 306 397 290 383 303 "},vc3:{x_min:-10.890625,x_max:299.4375,ha:294,o:"m 136 460 b 142 462 137 462 140 462 b 166 449 152 462 161 456 b 171 428 168 446 168 445 b 288 131 194 322 238 209 b 298 115 295 120 296 117 b 299 106 298 112 299 109 b 273 81 299 91 287 81 b 255 86 268 81 261 83 b 155 116 225 104 183 116 l 152 116 l 149 108 b 141 83 148 102 144 91 b 134 48 137 69 134 58 b 149 9 134 34 140 24 b 153 -1 152 5 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 147 -11 b 122 2 138 -11 133 -6 b 95 61 104 20 95 38 b 107 108 95 74 99 90 b 108 113 107 111 108 112 b 107 113 108 113 108 113 b 102 113 106 113 104 113 b 31 86 76 108 53 98 b 14 80 24 81 20 80 b -10 106 0 80 -10 91 b 0 131 -10 115 -9 116 b 115 430 49 209 91 317 b 136 460 119 451 123 456 "},vd0:{x_min:-10.890625,x_max:299.4375,ha:294,o:"m 44 174 b 51 174 47 174 49 174 b 68 173 55 174 61 174 l 287 112 l 551 40 b 615 20 617 22 609 23 b 626 0 622 16 626 8 b 615 -22 626 -9 622 -18 b 613 -23 613 -23 613 -23 b 613 -23 613 -23 613 -23 b 287 -113 613 -24 597 -29 l 68 -174 b 53 -176 61 -176 57 -176 b 39 -172 47 -176 43 -174 b 27 -151 31 -167 27 -159 b 39 -129 27 -141 31 -133 b 230 -74 43 -124 20 -131 l 370 -36 l 468 -9 b 498 0 484 -4 498 -1 b 468 8 498 0 484 2 l 370 34 l 230 73 b 40 126 28 129 43 124 b 27 149 31 131 27 140 b 44 174 27 161 34 170 m 205 110 l 205 300 b 205 330 245 330 245 300 l 245 300 l 245 -300 b 245 -330 205 -330 205 -300 l 205 -300 l 205 110 l 345 90 m 345 90 l 345 330 b 345 360 385 360 385 330 l 385 330 l 385 -270 b 385 -300 345 -300 345 -270 l 345 -270 l 345 90 "},vd1:{x_min:-20,x_max:320,ha:257,o:"m -8 200 b -8 210 8 200 16 200 l 20 148 -199 l 23 -615 b 0 -629 9 -629 6 -629 l -21 -612 l -21 -201 l -21 216 l -20 200 m 16 200 l 310 0 l 240 0 l 16 140 l 16 -120 l 240 0 l 310 0 l 16 -200 "},vd2:{x_min:0,x_max:430.75,ha:386,o:"m 0 200 l 0 -200 l 430 -200 l 430 200 l 0 200 "},vd3:{x_min:0,x_max:430.75,ha:386,o:"m 0 200 l 0 -200 l 430 -200 l 430 200 l 0 200 l 50 150 l 380 150 l 380 -150 l 50 -150 l 50 150 "},vd4:{x_min:0,x_max:430.75,ha:360,o:"m 0 150 l 0 -150 l 430 -150 l 430 150 l 0 150 "},vd5:{x_min:0,x_max:430.75,ha:360,o:"m 0 150 l 0 -150 l 430 -150 l 430 150 l 0 150 l 50 100 l 380 100 l 380 -100 l 50 -100 l 50 100"},vd6:{x_min:0,x_max:430.75,ha:360,o:"m -146 537 b -138 538 -143 538 -141 538 b -118 525 -129 538 -121 533 b -117 390 -117 522 -117 521 b -115 259 -117 268 -117 259 b -115 259 -115 259 -115 259 b -59 272 -104 263 -62 272 b -39 259 -50 272 -42 267 b -37 209 -38 257 -37 233 b -39 159 -37 185 -38 162 b -85 138 -43 149 -44 149 l -117 131 l -117 21 b -115 -88 -117 -80 -117 -88 b -115 -88 -115 -88 -115 -88 b -59 -75 -104 -84 -62 -75 b -44 -81 -52 -75 -48 -77 b -38 -124 -38 -87 -38 -85 b -38 -138 -38 -124 -38 -138 b -38 -152 -38 -138 -38 -152 b -44 -195 -38 -191 -38 -190 b -85 -209 -48 -200 -48 -200 l -117 -217 l -117 -349 b -118 -486 -117 -481 -117 -482 b -138 -499 -121 -494 -129 -499 b -153 -493 -143 -499 -149 -497 b -159 -415 -158 -487 -159 -496 b -159 -355 -159 -398 -159 -379 b -159 -227 -159 -284 -159 -227 b -205 -238 -159 -227 -180 -232 b -250 -249 -230 -244 -250 -249 b -251 -386 -251 -249 -251 -311 b -252 -525 -251 -521 -251 -522 b -272 -538 -255 -534 -264 -538 b -287 -532 -277 -538 -283 -536 b -293 -452 -292 -527 -293 -536 b -293 -391 -293 -436 -293 -415 b -294 -260 -293 -269 -293 -260 b -294 -260 -294 -260 -294 -260 b -348 -272 -306 -264 -345 -272 b -368 -259 -357 -272 -365 -267 b -369 -209 -369 -257 -369 -233 b -368 -159 -369 -185 -369 -162 b -323 -139 -364 -149 -362 -148 l -293 -131 l -293 -22 b -294 87 -293 80 -293 87 b -294 87 -294 87 -294 87 b -348 75 -306 84 -345 75 b -368 88 -357 75 -365 80 b -369 138 -369 91 -369 114 b -368 188 -369 162 -369 186 b -323 209 -364 198 -362 199 l -293 216 l -293 349 b -292 486 -293 481 -293 482 b -272 499 -288 494 -280 499 b -257 493 -266 499 -261 497 b -251 414 -251 487 -251 496 b -251 354 -251 398 -251 378 b -251 226 -251 284 -251 226 b -205 238 -250 226 -230 231 b -159 249 -180 244 -159 249 b -159 385 -159 249 -159 310 b -157 525 -159 521 -159 522 b -146 537 -156 530 -151 535 z m -159 11 b -159 120 -159 98 -159 120 l -159 120 b -175 116 -160 120 -167 119 b -221 105 -184 114 -204 109 l -251 98 l -251 -12 b -251 -121 -251 -72 -251 -121 b -205 -110 -250 -121 -230 -116 b -159 -99 -180 -104 -159 -99 b -159 11 -159 -99 -159 -49 z m 89 517 b 97 519 92 518 94 519 b 117 505 106 519 114 513 b 119 376 119 502 119 501 l 119 249 l 145 258 b 176 267 169 266 172 267 b 177 267 176 267 177 267 b 196 255 186 267 192 263 l 197 252 l 197 205 b 197 181 197 195 197 187 b 193 149 197 153 197 153 b 152 131 190 144 187 143 l 119 120 l 119 10 b 119 -100 119 -62 119 -100 b 145 -91 120 -100 131 -96 b 173 -82 159 -86 171 -82 b 176 -81 174 -81 175 -81 b 196 -94 185 -81 193 -87 b 198 -151 197 -97 198 -125 b 197 -194 198 -172 197 -192 b 153 -218 193 -203 192 -204 l 119 -230 l 119 -367 l 118 -504 l 117 -507 b 97 -519 113 -514 105 -519 b 82 -512 92 -519 87 -517 b 76 -434 77 -507 76 -516 b 76 -374 76 -418 76 -398 b 76 -245 76 -303 76 -245 b 52 -254 76 -245 65 -249 b 19 -263 34 -260 25 -263 b 6 -257 13 -263 10 -261 b 0 -214 0 -251 0 -253 b 0 -200 0 -210 0 -205 b 0 -188 0 -196 0 -192 b 6 -143 0 -147 0 -149 b 46 -126 10 -139 10 -139 l 76 -115 l 76 -5 b 76 106 76 56 76 106 b 51 98 76 106 64 102 b 18 89 34 92 25 89 b 6 95 13 89 10 91 b 0 139 0 101 0 99 b 0 153 0 143 0 148 b 0 179 0 163 0 172 b 44 225 0 215 3 211 l 76 236 l 76 369 b 78 505 76 501 76 502 b 89 517 80 510 85 515 z "},vd7:{x_min:0,x_max:430.75,ha:360,o:"m 283 633 b 291 634 286 634 289 634 b 311 621 300 634 308 629 b 313 505 313 618 313 617 b 313 393 313 443 313 393 b 378 425 313 393 343 407 l 443 458 l 448 458 b 449 458 449 458 449 458 b 471 437 462 458 471 448 b 469 429 471 434 470 432 b 387 382 466 421 469 423 l 313 344 l 313 247 l 313 150 l 315 152 b 433 201 353 184 394 201 b 479 193 448 201 464 198 b 549 86 524 177 549 135 b 526 1 549 59 541 29 b 395 -143 504 -39 475 -71 b 316 -214 351 -182 341 -191 b 292 -229 302 -228 300 -229 b 272 -216 283 -229 275 -224 b 271 55 271 -212 271 -212 b 270 323 271 203 270 323 b 205 291 270 323 241 308 l 140 258 l 135 258 b 134 258 135 258 134 258 b 112 279 121 258 112 267 b 114 287 112 281 113 284 b 196 334 117 295 114 293 l 271 371 l 271 495 b 272 621 271 617 271 618 b 283 633 274 626 279 631 z m 404 133 b 391 134 400 134 395 134 b 384 134 388 134 386 134 b 318 88 358 130 335 114 l 313 81 l 313 -37 l 313 -156 l 316 -152 b 439 83 391 -71 439 22 l 439 84 b 404 133 439 115 430 128 z m -8 633 l -8 633 b 0 634 -6 634 -3 634 b 20 621 8 634 17 629 b 21 384 21 618 21 617 l 21 150 l 24 152 b 141 201 62 184 102 201 b 187 193 157 201 172 198 b 257 86 232 177 257 135 b 234 1 257 59 250 29 b 103 -143 212 -39 183 -71 b 24 -214 60 -182 49 -191 b 0 -229 10 -228 8 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 203 l -21 618 l -20 621 b -8 633 -18 626 -13 631 z m 113 133 l 113 133 b 99 134 109 134 103 134 b 93 134 97 134 94 134 b 26 88 66 130 43 114 l 21 81 l 21 -37 l 21 -156 l 25 -152 b 148 83 99 -71 148 22 l 148 84 b 113 133 148 115 138 128 z "}},cssFontWeight:"normal",ascender:1903,underlinePosition:-125,cssFontStyle:"normal",boundingBox:{yMin:-2065.375,xMin:-695.53125,yMax:1901.578125,xMax:1159.671875},resolution:1e3,descender:-2066,familyName:"VexFlow-18",lineHeight:4093,underlineThickness:50};function N(t){return(N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function A(t,e){return!e||"object"!==N(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function L(t){return(L=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function M(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function F(t,e,n){return e&&M(t.prototype,e),n&&M(t,n),t}function B(t,e){return(B=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function j(t,e,n,i,o,r){var s,a,l,u=0;function c(){return e+t[u++]*i}function h(){return n+t[u++]*o}for(;u<t.length;)switch(s=t[u++]){case"m":case"l":r[s](c(),h());break;case"q":a=c(),l=h(),r.q(c(),h(),a,l);break;case"b":a=c(),l=h(),r.b(c(),h(),c(),h(),a,l)}}var D=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=A(this,L(e).call(this))).setAttribute("type","Glyph"),o.code=t,o.point=n,o.options={cache:!0,font:C},o.metrics=null,o.x_shift=0,o.y_shift=0,o.originShift={x:0,y:0},i?o.setOptions(i):o.reset(),o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&B(t,e)}(e,t),F(e,null,[{key:"loadMetrics",value:function(t,e,n){var i=t.glyphs[e];if(!i)throw new b.RERR("BadGlyph","Glyph ".concat(e," does not exist in font."));var o,r=i.x_min,s=i.x_max,a=i.ha;if(i.o)return n?i.cached_outline?o=i.cached_outline:(o=i.o.split(" "),i.cached_outline=o):(i.cached_outline&&delete i.cached_outline,o=i.o.split(" ")),{x_min:r,x_max:s,ha:a,outline:o};throw new b.RERR("BadGlyph","Glyph ".concat(e," has no outline defined."))}},{key:"renderGlyph",value:function(t,n,i,o,r,s){var a=72*o/(100*C.resolution),l=e.loadMetrics(C,r,!s);e.renderOutline(t,l.outline,a,n,i)}},{key:"renderOutline",value:function(t,e,n,i,o){t.beginPath(),t.moveTo(i,o),j(e,i,o,n,-n,{m:t.moveTo.bind(t),l:t.lineTo.bind(t),q:t.quadraticCurveTo.bind(t),b:t.bezierCurveTo.bind(t)}),t.fill()}},{key:"getOutlineBoundingBox",value:function(t,e,n,i){var o=new E;return j(t,n,i,e,-e,{m:o.addPoint.bind(o),l:o.addPoint.bind(o),q:o.addQuadraticCurve.bind(o),b:o.addBezierCurve.bind(o)}),new P(o.x1,o.y1,o.width(),o.height())}}]),F(e,[{key:"setOptions",value:function(t){b.Merge(this.options,t),this.reset()}},{key:"setPoint",value:function(t){return this.point=t,this}},{key:"setStave",value:function(t){return this.stave=t,this}},{key:"setXShift",value:function(t){return this.x_shift=t,this}},{key:"setYShift",value:function(t){return this.y_shift=t,this}},{key:"reset",value:function(){this.scale=72*this.point/(100*this.options.font.resolution),this.metrics=e.loadMetrics(this.options.font,this.code,this.options.cache),this.bbox=e.getOutlineBoundingBox(this.metrics.outline,this.scale,0,0)}},{key:"getMetrics",value:function(){if(!this.metrics)throw new b.RuntimeError("BadGlyph","Glyph ".concat(this.code," is not initialized."));return{x_min:this.metrics.x_min*this.scale,x_max:this.metrics.x_max*this.scale,width:this.bbox.getW(),height:this.bbox.getH()}}},{key:"setOriginX",value:function(t){var e=this.bbox,n=(t-Math.abs(e.getX()/e.getW()))*e.getW();this.originShift.x=-n}},{key:"setOriginY",value:function(t){var e=this.bbox,n=(t-Math.abs(e.getY()/e.getH()))*e.getH();this.originShift.y=-n}},{key:"setOrigin",value:function(t,e){this.setOriginX(t),this.setOriginY(e)}},{key:"render",value:function(t,n,i){if(!this.metrics)throw new b.RuntimeError("BadGlyph","Glyph ".concat(this.code," is not initialized."));var o=this.metrics.outline,r=this.scale;this.setRendered(),this.applyStyle(t),e.renderOutline(t,o,r,n+this.originShift.x,i+this.originShift.y),this.restoreStyle(t)}},{key:"renderToStave",value:function(t){if(this.checkContext(),!this.metrics)throw new b.RuntimeError("BadGlyph","Glyph ".concat(this.code," is not initialized."));if(!this.stave)throw new b.RuntimeError("GlyphError","No valid stave");var n=this.metrics.outline,i=this.scale;this.setRendered(),this.applyStyle(),e.renderOutline(this.context,n,i,t+this.x_shift,this.stave.getYForGlyphs()+this.y_shift),this.restoreStyle()}}]),e}(S);function I(t){return(I="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}var G={STEM_WIDTH:1.5,STEM_HEIGHT:35,STAVE_LINE_THICKNESS:1,RESOLUTION:16384,DEFAULT_NOTATION_FONT_SCALE:39,DEFAULT_TABLATURE_FONT_SCALE:39,SLASH_NOTEHEAD_WIDTH:15,TEXT_HEIGHT_OFFSET_HACK:1,IsKerned:!0};function Y(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function W(t,e,n){return e&&Y(t.prototype,e),n&&Y(t,n),t}G.clefProperties=function(t){if(!t)throw new b.RERR("BadArgument","Invalid clef: "+t);var e=G.clefProperties.values[t];if(!e)throw new b.RERR("BadArgument","Invalid clef: "+t);return e},G.clefProperties.values={treble:{line_shift:0},bass:{line_shift:6},tenor:{line_shift:4},alto:{line_shift:3},soprano:{line_shift:1},percussion:{line_shift:0},"mezzo-soprano":{line_shift:2},"baritone-c":{line_shift:5},"baritone-f":{line_shift:5},subbass:{line_shift:7},french:{line_shift:-1}},G.keyProperties=function(t,e,n){void 0===e&&(e="treble");var i={octave_shift:0};"object"===I(n)&&b.Merge(i,n);var o=t.split("/");if(o.length<2)throw new b.RERR("BadArguments","Key must have note + octave and an optional glyph: ".concat(t));var r=o[0].toUpperCase(),s=G.keyProperties.note_values[r];if(!s)throw new b.RERR("BadArguments","Invalid key name: "+r);s.octave&&(o[1]=s.octave);var a=parseInt(o[1],10),l=(7*(a+=-1*i.octave_shift)-28+s.index)/2,u=0;(l+=G.clefProperties(e).line_shift)<=0&&2*l%2==0&&(u=1),l>=6&&2*l%2==0&&(u=-1);var c=void 0!==s.int_val?12*a+s.int_val:null,h=s.code,f=s.shift_right;if(o.length>2&&o[2]){var p=o[2].toUpperCase(),y=G.keyProperties.note_glyph[p];y&&(h=y.code,f=y.shift_right)}return{key:r,octave:a,line:l,int_value:c,accidental:s.accidental,code:h,stroke:u,shift_right:f,displaced:!1}},G.keyProperties.note_values={C:{index:0,int_val:0,accidental:null},CN:{index:0,int_val:0,accidental:"n"},"C#":{index:0,int_val:1,accidental:"#"},"C##":{index:0,int_val:2,accidental:"##"},CB:{index:0,int_val:-1,accidental:"b"},CBB:{index:0,int_val:-2,accidental:"bb"},D:{index:1,int_val:2,accidental:null},DN:{index:1,int_val:2,accidental:"n"},"D#":{index:1,int_val:3,accidental:"#"},"D##":{index:1,int_val:4,accidental:"##"},DB:{index:1,int_val:1,accidental:"b"},DBB:{index:1,int_val:0,accidental:"bb"},E:{index:2,int_val:4,accidental:null},EN:{index:2,int_val:4,accidental:"n"},"E#":{index:2,int_val:5,accidental:"#"},"E##":{index:2,int_val:6,accidental:"##"},EB:{index:2,int_val:3,accidental:"b"},EBB:{index:2,int_val:2,accidental:"bb"},F:{index:3,int_val:5,accidental:null},FN:{index:3,int_val:5,accidental:"n"},"F#":{index:3,int_val:6,accidental:"#"},"F##":{index:3,int_val:7,accidental:"##"},FB:{index:3,int_val:4,accidental:"b"},FBB:{index:3,int_val:3,accidental:"bb"},G:{index:4,int_val:7,accidental:null},GN:{index:4,int_val:7,accidental:"n"},"G#":{index:4,int_val:8,accidental:"#"},"G##":{index:4,int_val:9,accidental:"##"},GB:{index:4,int_val:6,accidental:"b"},GBB:{index:4,int_val:5,accidental:"bb"},A:{index:5,int_val:9,accidental:null},AN:{index:5,int_val:9,accidental:"n"},"A#":{index:5,int_val:10,accidental:"#"},"A##":{index:5,int_val:11,accidental:"##"},AB:{index:5,int_val:8,accidental:"b"},ABB:{index:5,int_val:7,accidental:"bb"},B:{index:6,int_val:11,accidental:null},BN:{index:6,int_val:11,accidental:"n"},"B#":{index:6,int_val:12,accidental:"#"},"B##":{index:6,int_val:13,accidental:"##"},BB:{index:6,int_val:10,accidental:"b"},BBB:{index:6,int_val:9,accidental:"bb"},R:{index:6,int_val:9,rest:!0},X:{index:6,accidental:"",octave:4,code:"v3e",shift_right:5.5}},G.keyProperties.note_glyph={D0:{code:"v27",shift_right:-.5},D1:{code:"v2d",shift_right:-.5},D2:{code:"v22",shift_right:-.5},D3:{code:"v70",shift_right:-.5},T0:{code:"v49",shift_right:-2,stem_up_y_offset:-4,stem_down_y_offset:4},T1:{code:"v93",shift_right:.5,stem_up_y_offset:-4,stem_down_y_offset:4},T2:{code:"v40",shift_right:.5,stem_up_y_offset:-4,stem_down_y_offset:4},T3:{code:"v7d",shift_right:.5,stem_up_y_offset:-4,stem_down_y_offset:4},X0:{code:"v92",shift_right:-2,stem_up_y_offset:4,stem_down_y_offset:4},X1:{code:"v95",shift_right:-.5,stem_up_y_offset:4,stem_down_y_offset:4},X2:{code:"v3e",shift_right:.5,stem_up_y_offset:4,stem_down_y_offset:4},X3:{code:"v3b",shift_right:-2,stem_up_y_offset:2,stem_down_y_offset:2},S1:{code:"vd3",shift_right:0},S2:{code:"vd2",shift_right:0},R1:{code:"vd5",shift_right:0},R2:{code:"vd4",shift_right:0}},G.integerToNote=function(t){if(void 0===t)throw new b.RERR("BadArguments","Undefined integer for integerToNote");if(t<-2)throw new b.RERR("BadArguments","integerToNote requires integer > -2: ".concat(t));var e=G.integerToNote.table[t];if(!e)throw new b.RERR("BadArguments","Unknown note value for integer: ".concat(t));return e},G.integerToNote.table={0:"C",1:"C#",2:"D",3:"D#",4:"E",5:"F",6:"F#",7:"G",8:"G#",9:"A",10:"A#",11:"B"},G.tabToGlyph=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=null,i=0,o=0;if("X"===t.toString().toUpperCase()){var r=new D("v7f",G.DEFAULT_TABLATURE_FONT_SCALE).getMetrics();n="v7f",i=r.width,o=-r.height/2}else i=G.textWidth(t.toString());return{text:t,code:n,getWidth:function(){return i*e},shift_y:o}},G.textWidth=function(t){return 7*t.toString().length},G.articulationCodes=function(t){return G.articulationCodes.articulations[t]},G.articulationCodes.articulations={"a.":{code:"v23",between_lines:!0},av:{code:"v28",between_lines:!0},"a>":{code:"v42",between_lines:!0},"a-":{code:"v25",between_lines:!0},"a^":{code:"va",between_lines:!1},"a+":{code:"v8b",between_lines:!1},ao:{code:"v94",between_lines:!1},ah:{code:"vb9",between_lines:!1},"a@a":{code:"v43",between_lines:!1},"a@u":{code:"v5b",between_lines:!1},"a|":{code:"v75",between_lines:!1},am:{code:"v97",between_lines:!1},"a,":{code:"vb3",between_lines:!1}},G.accidentalCodes=function(t){return G.accidentalCodes.accidentals[t]},G.accidentalCodes.accidentals={"#":{code:"v18",parenRightPaddingAdjustment:-1},"##":{code:"v7f",parenRightPaddingAdjustment:-1},b:{code:"v44",parenRightPaddingAdjustment:-2},bb:{code:"v26",parenRightPaddingAdjustment:-2},n:{code:"v4e",parenRightPaddingAdjustment:-1},"{":{code:"v9c",parenRightPaddingAdjustment:-1},"}":{code:"v84",parenRightPaddingAdjustment:-1},db:{code:"v9e",parenRightPaddingAdjustment:-1},d:{code:"vab",parenRightPaddingAdjustment:0},bbs:{code:"v90",parenRightPaddingAdjustment:-1},"++":{code:"v51",parenRightPaddingAdjustment:-1},"+":{code:"v78",parenRightPaddingAdjustment:-1},"+-":{code:"v8d",parenRightPaddingAdjustment:-1},"++-":{code:"v7a",parenRightPaddingAdjustment:-1},bs:{code:"vb7",parenRightPaddingAdjustment:-1},bss:{code:"v39",parenRightPaddingAdjustment:-1},o:{code:"vd0",parenRightPaddingAdjustment:-1},k:{code:"vd1",parenRightPaddingAdjustment:-1},ashs:{code:"vd6",parenRightPaddingAdjustment:-1},afhf:{code:"vd7",parenRightPaddingAdjustment:-1}},G.accidentalColumnsTable={1:{a:[1],b:[1]},2:{a:[1,2]},3:{a:[1,3,2],b:[1,2,1],second_on_bottom:[1,2,3]},4:{a:[1,3,4,2],b:[1,2,3,1],spaced_out_tetrachord:[1,2,1,2]},5:{a:[1,3,5,4,2],b:[1,2,4,3,1],spaced_out_pentachord:[1,2,3,2,1],very_spaced_out_pentachord:[1,2,1,2,1]},6:{a:[1,3,5,6,4,2],b:[1,2,4,5,3,1],spaced_out_hexachord:[1,3,2,1,3,2],very_spaced_out_hexachord:[1,2,1,2,1,2]}},G.ornamentCodes=function(t){return G.ornamentCodes.ornaments[t]},G.ornamentCodes.ornaments={mordent:{code:"v1e"},mordent_inverted:{code:"v45"},turn:{code:"v72"},turn_inverted:{code:"v33"},tr:{code:"v1f"},upprall:{code:"v60"},downprall:{code:"vb4"},prallup:{code:"v6d"},pralldown:{code:"v2c"},upmordent:{code:"v29"},downmordent:{code:"v68"},lineprall:{code:"v20"},prallprall:{code:"v86"}},G.keySignature=function(t){var e=G.keySignature.keySpecs[t];if(!e)throw new b.RERR("BadKeySignature","Bad key signature spec: '".concat(t,"'"));if(!e.acc)return[];for(var n=G.keySignature.accidentalList(e.acc),i=[],o=0;o<e.num;++o){var r=n[o];i.push({type:e.acc,line:r})}return i},G.keySignature.keySpecs={C:{acc:null,num:0},Am:{acc:null,num:0},F:{acc:"b",num:1},Dm:{acc:"b",num:1},Bb:{acc:"b",num:2},Gm:{acc:"b",num:2},Eb:{acc:"b",num:3},Cm:{acc:"b",num:3},Ab:{acc:"b",num:4},Fm:{acc:"b",num:4},Db:{acc:"b",num:5},Bbm:{acc:"b",num:5},Gb:{acc:"b",num:6},Ebm:{acc:"b",num:6},Cb:{acc:"b",num:7},Abm:{acc:"b",num:7},G:{acc:"#",num:1},Em:{acc:"#",num:1},D:{acc:"#",num:2},Bm:{acc:"#",num:2},A:{acc:"#",num:3},"F#m":{acc:"#",num:3},E:{acc:"#",num:4},"C#m":{acc:"#",num:4},B:{acc:"#",num:5},"G#m":{acc:"#",num:5},"F#":{acc:"#",num:6},"D#m":{acc:"#",num:6},"C#":{acc:"#",num:7},"A#m":{acc:"#",num:7}},G.unicode={sharp:String.fromCharCode(parseInt("266F",16)),flat:String.fromCharCode(parseInt("266D",16)),natural:String.fromCharCode(parseInt("266E",16)),triangle:String.fromCharCode(parseInt("25B3",16)),"o-with-slash":String.fromCharCode(parseInt("00F8",16)),degrees:String.fromCharCode(parseInt("00B0",16)),circle:String.fromCharCode(parseInt("25CB",16))},G.keySignature.accidentalList=function(t){return{b:[2,.5,2.5,1,3,1.5,3.5],"#":[0,1.5,-.5,1,2.5,.5,2]}[t]},G.parseNoteDurationString=function(t){if("string"!=typeof t)return null;var e=/(\d*\/?\d+|[a-z])(d*)([nrhms]|$)/.exec(t);if(!e)return null;var n=e[1],i=e[2].length,o=e[3];return 0===o.length&&(o="n"),{duration:n,dots:i,type:o}},G.parseNoteData=function(t){var e=t.duration,n=G.parseNoteDurationString(e);if(!n)return null;var i=G.durationToTicks(n.duration);if(null==i)return null;var o=t.type;if(o){if("n"!==o&&"r"!==o&&"h"!==o&&"m"!==o&&"s"!==o)return null}else{if(o=n.type,void 0!==t.keys){var r=t.keys[0].split("/");r&&3===r.length&&(o=r[2])}o||(o="n")}var s=t.dots?t.dots:n.dots;if("number"!=typeof s)return null;for(var a=i,l=0;l<s;l++){if(a<=1)return null;i+=a/=2}return{duration:n.duration,type:o,dots:s,ticks:i}},G.sanitizeDuration=function(t){var e=G.durationAliases[t];if(void 0!==e&&(t=e),void 0===G.durationToTicks.durations[t])throw new b.RERR("BadArguments","The provided duration is not valid: ".concat(t));return t},G.durationToFraction=function(t){return(new y).parse(G.sanitizeDuration(t))},G.durationToNumber=function(t){return G.durationToFraction(t).value()},G.durationToTicks=function(t){t=G.sanitizeDuration(t);var e=G.durationToTicks.durations[t];return void 0===e?null:e},G.durationToTicks.durations={"1/2":2*G.RESOLUTION,1:G.RESOLUTION/1,2:G.RESOLUTION/2,4:G.RESOLUTION/4,8:G.RESOLUTION/8,16:G.RESOLUTION/16,32:G.RESOLUTION/32,64:G.RESOLUTION/64,128:G.RESOLUTION/128,256:G.RESOLUTION/256},G.durationAliases={w:"1",h:"2",q:"4",b:"256"},G.durationToGlyph=function(t,e){t=G.sanitizeDuration(t);var n=G.durationToGlyph.duration_codes[t];if(void 0===n)return null;e||(e="n");var i=n.type[e];if(void 0===i){var o=G.keyProperties.note_glyph[e.toUpperCase()];if(void 0===o)return null;i={code_head:o.code,stem_up_y_offset:o.stem_up_y_offset,stem_down_y_offset:o.stem_down_y_offset}}return b.Merge(b.Merge({},n.common),i)},G.durationToGlyph.duration_codes={"1/2":{common:{getWidth:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:G.DEFAULT_NOTATION_FONT_SCALE;return new D(this.code_head||"v53",t).getMetrics().width},stem:!1,stem_offset:0,flag:!1,stem_up_extension:-G.STEM_HEIGHT,stem_down_extension:-G.STEM_HEIGHT,tabnote_stem_up_extension:-G.STEM_HEIGHT,tabnote_stem_down_extension:-G.STEM_HEIGHT,dot_shiftY:0,line_above:0,line_below:0},type:{n:{code_head:"v53"},h:{code_head:"v59"},m:{code_head:"vf",stem_offset:0},r:{code_head:"v31",rest:!0,position:"B/5",dot_shiftY:.5},s:{getWidth:function(){return G.SLASH_NOTEHEAD_WIDTH},position:"B/4"}}},1:{common:{getWidth:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:G.DEFAULT_NOTATION_FONT_SCALE;return new D(this.code_head||"v1d",t).getMetrics().width},stem:!1,stem_offset:0,flag:!1,stem_up_extension:-G.STEM_HEIGHT,stem_down_extension:-G.STEM_HEIGHT,tabnote_stem_up_extension:-G.STEM_HEIGHT,tabnote_stem_down_extension:-G.STEM_HEIGHT,dot_shiftY:0,line_above:0,line_below:0},type:{n:{code_head:"v1d"},h:{code_head:"v46"},m:{code_head:"v92",stem_offset:-3},r:{code_head:"v5c",rest:!0,position:"D/5",dot_shiftY:.5},s:{getWidth:function(){return G.SLASH_NOTEHEAD_WIDTH},position:"B/4"}}},2:{common:{getWidth:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:G.DEFAULT_NOTATION_FONT_SCALE;return new D(this.code_head||"v81",t).getMetrics().width},stem:!0,stem_offset:0,flag:!1,stem_up_extension:0,stem_down_extension:0,tabnote_stem_up_extension:0,tabnote_stem_down_extension:0,dot_shiftY:0,line_above:0,line_below:0},type:{n:{code_head:"v81"},h:{code_head:"v2d"},m:{code_head:"v95",stem_offset:-3},r:{code_head:"vc",stem:!1,rest:!0,position:"B/4",dot_shiftY:-.5},s:{getWidth:function(){return G.SLASH_NOTEHEAD_WIDTH},position:"B/4"}}},4:{common:{getWidth:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:G.DEFAULT_NOTATION_FONT_SCALE;return new D(this.code_head||"vb",t).getMetrics().width},stem:!0,stem_offset:0,flag:!1,stem_up_extension:0,stem_down_extension:0,tabnote_stem_up_extension:0,tabnote_stem_down_extension:0,dot_shiftY:0,line_above:0,line_below:0},type:{n:{code_head:"vb"},h:{code_head:"v22"},m:{code_head:"v3e",stem_offset:-3},r:{code_head:"v7c",stem:!1,rest:!0,position:"B/4",dot_shiftY:-.5,line_above:1.5,line_below:1.5},s:{getWidth:function(){return G.SLASH_NOTEHEAD_WIDTH},position:"B/4"}}},8:{common:{getWidth:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:G.DEFAULT_NOTATION_FONT_SCALE;return new D(this.code_head||"vb",t).getMetrics().width},stem:!0,stem_offset:0,flag:!0,beam_count:1,code_flag_upstem:"v54",code_flag_downstem:"v9a",stem_up_extension:0,stem_down_extension:0,tabnote_stem_up_extension:0,tabnote_stem_down_extension:0,dot_shiftY:0,line_above:0,line_below:0},type:{n:{code_head:"vb"},h:{code_head:"v22"},m:{code_head:"v3e"},r:{code_head:"va5",stem:!1,flag:!1,rest:!0,position:"B/4",dot_shiftY:-.5,line_above:1,line_below:1},s:{getWidth:function(){return G.SLASH_NOTEHEAD_WIDTH},position:"B/4"}}},16:{common:{beam_count:2,getWidth:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:G.DEFAULT_NOTATION_FONT_SCALE;return new D(this.code_head||"vb",t).getMetrics().width},stem:!0,stem_offset:0,flag:!0,code_flag_upstem:"v3f",code_flag_downstem:"v8f",stem_up_extension:0,stem_down_extension:0,tabnote_stem_up_extension:0,tabnote_stem_down_extension:0,dot_shiftY:0,line_above:0,line_below:0},type:{n:{code_head:"vb"},h:{code_head:"v22"},m:{code_head:"v3e"},r:{code_head:"v3c",stem:!1,flag:!1,rest:!0,position:"B/4",dot_shiftY:-.5,line_above:1,line_below:2},s:{getWidth:function(){return G.SLASH_NOTEHEAD_WIDTH},position:"B/4"}}},32:{common:{beam_count:3,getWidth:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:G.DEFAULT_NOTATION_FONT_SCALE;return new D(this.code_head||"vb",t).getMetrics().width},stem:!0,stem_offset:0,flag:!0,code_flag_upstem:"v47",code_flag_downstem:"v2a",stem_up_extension:9,stem_down_extension:9,tabnote_stem_up_extension:8,tabnote_stem_down_extension:5,dot_shiftY:0,line_above:0,line_below:0},type:{n:{code_head:"vb"},h:{code_head:"v22"},m:{code_head:"v3e"},r:{code_head:"v55",stem:!1,flag:!1,rest:!0,position:"B/4",dot_shiftY:-1.5,line_above:2,line_below:2},s:{getWidth:function(){return G.SLASH_NOTEHEAD_WIDTH},position:"B/4"}}},64:{common:{beam_count:4,getWidth:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:G.DEFAULT_NOTATION_FONT_SCALE;return new D(this.code_head||"vb",t).getMetrics().width},stem:!0,stem_offset:0,flag:!0,code_flag_upstem:"va9",code_flag_downstem:"v58",stem_up_extension:13,stem_down_extension:13,tabnote_stem_up_extension:12,tabnote_stem_down_extension:9,dot_shiftY:0,line_above:0,line_below:0},type:{n:{code_head:"vb"},h:{code_head:"v22"},m:{code_head:"v3e"},r:{code_head:"v38",stem:!1,flag:!1,rest:!0,position:"B/4",dot_shiftY:-1.5,line_above:2,line_below:3},s:{getWidth:function(){return G.SLASH_NOTEHEAD_WIDTH},position:"B/4"}}},128:{common:{beam_count:5,getWidth:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:G.DEFAULT_NOTATION_FONT_SCALE;return new D(this.code_head||"vb",t).getMetrics().width},stem:!0,stem_offset:0,flag:!0,code_flag_upstem:"v9b",code_flag_downstem:"v30",stem_up_extension:22,stem_down_extension:22,tabnote_stem_up_extension:21,tabnote_stem_down_extension:18,dot_shiftY:0,line_above:0,line_below:0},type:{n:{code_head:"vb"},h:{code_head:"v22"},m:{code_head:"v3e"},r:{code_head:"vaa",stem:!1,flag:!1,rest:!0,position:"B/4",dot_shiftY:1.5,line_above:3,line_below:3},s:{getWidth:function(){return G.SLASH_NOTEHEAD_WIDTH},position:"B/4"}}}},G.smufl={},G.smufl.to_code_points={bracketTop:"v1b",bracketBottom:"v10",barlineTick:"v6f",segno:"v8c",coda:"v4d",gClef:"v83",cClef:"vad",fClef:"v79",unpitchedPercussionClef1:"v59","6stringTabClef":"v2f",timeSig0:"v0",timeSig1:"v1",timeSig2:"v2",timeSig3:"v3",timeSig4:"v4",timeSig5:"v5",timeSig6:"v6",timeSig7:"v7",timeSig8:"v8",timeSig9:"v9",timeSigCommon:"v41",timeSigCutCommon:"vb6",noteheadDoubleWhole:"v53",noteheadWhole:"v1d",noteheadHalf:"v81",noteheadBlack:"vb",noteheadXWhole:"v92",noteheadXHalf:"v95",noteheadXBlack:"v3e",noteheadCircleX:"v3b",noteheadTriangleUpWhole:"v49",noteheadTriangleUpHalf:"v93",noteheadTriangleUpBlack:"v40",noteheadDiamondWhole:"v46",noteheadDiamondHalf:"v2d",noteheadDiamondBlack:"v22",augmentationDot:"v23",tremolo1:"v74",flag8thUp:"v54",flag8thDown:"v9a",flag16thUp:"v3f",flag16thDown:"v8f",flag32ndUp:"v47",flag32ndDown:"v2a",flag64thUp:"va9",flag64thDown:"v58",flag128thUp:"v9b",flag128thDown:"v30",accidentalFlat:"v44",accidentalNatural:"v4e",accidentalSharp:"v18",accidentalDoubleSharp:"v7f",accidentalDoubleFlat:"v26",accidentalParensLeft:"v9c",accidentalParensRight:"v84",accidentalQuarterToneFlatStein:"vab",accidentalThreeQuarterTonesFlatZimmermann:"v9e",accidentalQuarterToneSharpStein:"v78",accidentalThreeQuarterTonesSharpStein:"v51",accidentalBuyukMucennebFlat:"v39",accidentalBakiyeFlat:"vb7",accidentalKomaSharp:"v51",accidentalKucukMucennebSharp:"v8d",accidentalKoron:"vd1",accidentalSori:"vd0",articAccentAbove:"v42",articAccentBelow:"v42",articTenutoAbove:"v25",articTenutoBelow:"v25",articStaccatoAbove:"v23",articStaccatoBelow:"v23",articStaccatissimoAbove:"v28",articMarcatoAbove:"va",fermataAbove:"v43",fermataBelow:"v5b",breathMarkComma:"v6c",breathMarkUpbow:"v8a",caesura:"v34",caesuraCurved:"v4b",restMaxima:"v59",restDoubleWhole:"v31",restWhole:"v5c",restHalf:"vc",restQuarter:"v7c",rest8th:"va5",rest16th:"v3c",rest32nd:"v55",rest64th:"v38",rest128th:"vaa",dynamicPiano:"vbf",dynamicMezzo:"v62",dynamicForte:"vba",dynamicRinforzando:"vba",dynamicSforzando:"v4a",dynamicZ:"v80",ornamentTrill:"v1f",ornamentTurn:"v72",ornamentTurnSlash:"v33",ornamentMordent:"v45",ornamentMordentInverted:"v1e",ornamentTremblement:"v86",ornamentPrecompAppoggTrill:"v20",ornamentPrecompSlideTrillDAnglebert:"v60",ornamentPrecompSlideTrillBach:"v29",ornamentPrecompTrillSuffixDandrieu:"v6d",ornamentPrecompDoubleCadenceUpperPrefix:"vb4",ornamentPrecompDoubleCadenceUpperPrefixTurn:"v68",ornamentPrecompTrillLowerSuffix:"v2c",stringsDownBow:"v94",stringsUpBow:"v75",stringsHarmonic:"vb9",pluckedSnapPizzicatoAbove:"v94",pluckedLeftHandPizzicato:"v8b",keyboardPedalPed:"v36",keyboardPedalUp:"v5d",pictChokeCymbal:"vb3",wiggleArpeggiatoUp:"va3",arrowheadBlackUp:"vc3",arrowheadBlackDown:"v52"},G.TIME4_4={num_beats:4,beat_value:4,resolution:G.RESOLUTION};var X=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.vexFlowCanvasContext=e,e.canvas?this.canvas=e.canvas:this.canvas={width:t.WIDTH,height:t.HEIGHT}}return W(t,null,[{key:"WIDTH",get:function(){return 600}},{key:"HEIGHT",get:function(){return 400}}]),W(t,[{key:"clear",value:function(){this.vexFlowCanvasContext.clearRect(0,0,this.canvas.width,this.canvas.height)}},{key:"openGroup",value:function(){}},{key:"closeGroup",value:function(){}},{key:"add",value:function(){}},{key:"setFont",value:function(t,e,n){return this.vexFlowCanvasContext.font=(n||"")+" "+e+"pt "+t,this}},{key:"setRawFont",value:function(t){return this.vexFlowCanvasContext.font=t,this}},{key:"setFillStyle",value:function(t){return this.vexFlowCanvasContext.fillStyle=t,this}},{key:"setBackgroundFillStyle",value:function(t){return this.background_fillStyle=t,this}},{key:"setStrokeStyle",value:function(t){return this.vexFlowCanvasContext.strokeStyle=t,this}},{key:"setShadowColor",value:function(t){return this.vexFlowCanvasContext.shadowColor=t,this}},{key:"setShadowBlur",value:function(t){return this.vexFlowCanvasContext.shadowBlur=t,this}},{key:"setLineWidth",value:function(t){return this.vexFlowCanvasContext.lineWidth=t,this}},{key:"setLineCap",value:function(t){return this.vexFlowCanvasContext.lineCap=t,this}},{key:"setLineDash",value:function(t){return this.vexFlowCanvasContext.lineDash=t,this}},{key:"scale",value:function(t,e){return this.vexFlowCanvasContext.scale(parseFloat(t),parseFloat(e))}},{key:"resize",value:function(t,e){return this.vexFlowCanvasContext.resize(parseInt(t,10),parseInt(e,10))}},{key:"rect",value:function(t,e,n,i){return this.vexFlowCanvasContext.rect(t,e,n,i)}},{key:"fillRect",value:function(t,e,n,i){return this.vexFlowCanvasContext.fillRect(t,e,n,i)}},{key:"clearRect",value:function(t,e,n,i){return this.vexFlowCanvasContext.clearRect(t,e,n,i)}},{key:"beginPath",value:function(){return this.vexFlowCanvasContext.beginPath()}},{key:"moveTo",value:function(t,e){return this.vexFlowCanvasContext.moveTo(t,e)}},{key:"lineTo",value:function(t,e){return this.vexFlowCanvasContext.lineTo(t,e)}},{key:"bezierCurveTo",value:function(t,e,n,i,o,r){return this.vexFlowCanvasContext.bezierCurveTo(t,e,n,i,o,r)}},{key:"quadraticCurveTo",value:function(t,e,n,i){return this.vexFlowCanvasContext.quadraticCurveTo(t,e,n,i)}},{key:"arc",value:function(t,e,n,i,o,r){return this.vexFlowCanvasContext.arc(t,e,n,i,o,r)}},{key:"glow",value:function(){return this.vexFlowCanvasContext.glow()}},{key:"fill",value:function(){return this.vexFlowCanvasContext.fill()}},{key:"stroke",value:function(){return this.vexFlowCanvasContext.stroke()}},{key:"closePath",value:function(){return this.vexFlowCanvasContext.closePath()}},{key:"measureText",value:function(t){return this.vexFlowCanvasContext.measureText(t)}},{key:"fillText",value:function(t,e,n){return this.vexFlowCanvasContext.fillText(t,e,n)}},{key:"save",value:function(){return this.vexFlowCanvasContext.save()}},{key:"restore",value:function(){return this.vexFlowCanvasContext.restore()}}]),t}();function H(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var U=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.element=e,this.paper=Raphael(e),this.path="",this.pen={x:0,y:0},this.lineWidth=1,this.state={scale:{x:1,y:1},font_family:"Arial",font_size:8,font_weight:800},this.attributes={"stroke-width":.3,fill:"black",stroke:"black",font:"10pt Arial"},this.background_attributes={"stroke-width":0,fill:"white",stroke:"white",font:"10pt Arial"},this.shadow_attributes={width:0,color:"black"},this.state_stack=[]}var e,n,i;return e=t,(n=[{key:"openGroup",value:function(){}},{key:"closeGroup",value:function(){}},{key:"add",value:function(){}},{key:"setFont",value:function(t,e,n){return this.state.font_family=t,this.state.font_size=e,this.state.font_weight=n,this.attributes.font=(this.state.font_weight||"")+" "+this.state.font_size*this.state.scale.x+"pt "+this.state.font_family,this}},{key:"setRawFont",value:function(t){return this.attributes.font=t,this}},{key:"setFillStyle",value:function(t){return this.attributes.fill=t,this}},{key:"setBackgroundFillStyle",value:function(t){return this.background_attributes.fill=t,this.background_attributes.stroke=t,this}},{key:"setStrokeStyle",value:function(t){return this.attributes.stroke=t,this}},{key:"setShadowColor",value:function(t){return this.shadow_attributes.color=t,this}},{key:"setShadowBlur",value:function(t){return this.shadow_attributes.width=t,this}},{key:"setLineWidth",value:function(t){this.attributes["stroke-width"]=t,this.lineWidth=t}},{key:"setLineDash",value:function(){return this}},{key:"setLineCap",value:function(){return this}},{key:"scale",value:function(t,e){return this.state.scale={x:t,y:e},this.attributes.transform="S"+t+","+e+",0,0",this.attributes.scale=t+","+e+",0,0",this.attributes.font=this.state.font_size*this.state.scale.x+"pt "+this.state.font_family,this.background_attributes.transform="S"+t+","+e+",0,0",this.background_attributes.font=this.state.font_size*this.state.scale.x+"pt "+this.state.font_family,this}},{key:"clear",value:function(){this.paper.clear()}},{key:"resize",value:function(t,e){return this.element.style.width=t,this.paper.setSize(t,e),this}},{key:"setViewBox",value:function(t){this.paper.canvas.setAttribute("viewBox",t)}},{key:"rect",value:function(t,e,n,i){return i<0&&(e+=i,i=-i),this.paper.rect(t,e,n-.5,i-.5).attr(this.attributes).attr("fill","none").attr("stroke-width",this.lineWidth),this}},{key:"fillRect",value:function(t,e,n,i){return i<0&&(e+=i,i=-i),this.paper.rect(t,e,n-.5,i-.5).attr(this.attributes),this}},{key:"clearRect",value:function(t,e,n,i){return i<0&&(e+=i,i=-i),this.paper.rect(t,e,n-.5,i-.5).attr(this.background_attributes),this}},{key:"beginPath",value:function(){return this.path="",this.pen.x=0,this.pen.y=0,this}},{key:"moveTo",value:function(t,e){return this.path+="M"+t+","+e,this.pen.x=t,this.pen.y=e,this}},{key:"lineTo",value:function(t,e){return this.path+="L"+t+","+e,this.pen.x=t,this.pen.y=e,this}},{key:"bezierCurveTo",value:function(t,e,n,i,o,r){return this.path+="C"+t+","+e+","+n+","+i+","+o+","+r,this.pen.x=o,this.pen.y=r,this}},{key:"quadraticCurveTo",value:function(t,e,n,i){return this.path+="Q"+t+","+e+","+n+","+i,this.pen.x=n,this.pen.y=i,this}},{key:"arc",value:function(t,e,n,i,o,r){function s(t){for(;t<0;)t+=2*Math.PI;for(;t>2*Math.PI;)t-=2*Math.PI;return t}if((i=s(i))>(o=s(o))){var a=i;i=o,o=a,r=!r}var l=o-i;return l>Math.PI?(this.arcHelper(t,e,n,i,i+l/2,r),this.arcHelper(t,e,n,i+l/2,o,r)):this.arcHelper(t,e,n,i,o,r),this}},{key:"arcHelper",value:function(t,e,n,i,o,r){var s=t+n*Math.cos(i),a=e+n*Math.sin(i),l=t+n*Math.cos(o),u=e+n*Math.sin(o),c=0,h=0;r?(h=1,o-i<Math.PI&&(c=1)):o-i>Math.PI&&(c=1),this.path+="M"+s+","+a+",A"+n+","+n+",0,"+c+","+h+","+l+","+u+"M"+this.pen.x+","+this.pen.y}},{key:"glow",value:function(){var t=this.paper.set();if(this.shadow_attributes.width>0)for(var e=this.shadow_attributes,n=e.width/2,i=1;i<=n;i++)t.push(this.paper.path(this.path).attr({stroke:e.color,"stroke-linejoin":"round","stroke-linecap":"round","stroke-width":+(e.width/n*i).toFixed(3),opacity:+((e.opacity||.3)/n).toFixed(3),transform:this.attributes.transform,scale:this.attributes.scale}));return t}},{key:"fill",value:function(){var t=this.paper.path(this.path).attr(this.attributes).attr("stroke-width",0);return this.glow(t),this}},{key:"stroke",value:function(){var t=this.lineWidth*(this.state.scale.x+this.state.scale.y)/2,e=this.paper.path(this.path).attr(this.attributes).attr("fill","none").attr("stroke-width",t);return this.glow(e),this}},{key:"closePath",value:function(){return this.path+="Z",this}},{key:"measureText",value:function(t){var e=this.paper.text(0,0,t).attr(this.attributes).attr("fill","none").attr("stroke","none"),n=e.getBBox();return e.remove(),{width:n.width,height:n.height}}},{key:"fillText",value:function(t,e,n){return this.paper.text(e+this.measureText(t).width/2,n-this.state.font_size/(2.25*this.state.scale.y),t).attr(this.attributes),this}},{key:"save",value:function(){return this.state_stack.push({state:{font_family:this.state.font_family},attributes:{font:this.attributes.font,fill:this.attributes.fill,stroke:this.attributes.stroke,"stroke-width":this.attributes["stroke-width"]},shadow_attributes:{width:this.shadow_attributes.width,color:this.shadow_attributes.color}}),this}},{key:"restore",value:function(){var t=this.state_stack.pop();return this.state.font_family=t.state.font_family,this.attributes.font=t.attributes.font,this.attributes.fill=t.attributes.fill,this.attributes.stroke=t.attributes.stroke,this.attributes["stroke-width"]=t.attributes["stroke-width"],this.shadow_attributes.width=t.shadow_attributes.width,this.shadow_attributes.color=t.shadow_attributes.color,this}}])&&H(e.prototype,n),i&&H(e,i),t}();function V(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var z={path:{x:!0,y:!0,width:!0,height:!0},rect:{},text:{width:!0,height:!0}},K={"font-family":!0,"font-weight":!0,"font-style":!0,"font-size":!0};b.Merge(z.rect,K),b.Merge(z.path,K);var J=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.element=e,this.svgNS="http://www.w3.org/2000/svg";var n=this.create("svg");this.element.appendChild(n),this.svg=n,this.groups=[this.svg],this.parent=this.svg,this.path="",this.pen={x:NaN,y:NaN},this.lineWidth=1,this.state={scale:{x:1,y:1},"font-family":"Arial","font-size":"8pt","font-weight":"normal"},this.attributes={"stroke-width":.3,fill:"black",stroke:"black","stroke-dasharray":"none","font-family":"Arial","font-size":"10pt","font-weight":"normal","font-style":"normal"},this.background_attributes={"stroke-width":0,fill:"white",stroke:"white","stroke-dasharray":"none","font-family":"Arial","font-size":"10pt","font-weight":"normal","font-style":"normal"},this.shadow_attributes={width:0,color:"black"},this.state_stack=[],this.iePolyfill()}var e,n,i;return e=t,(n=[{key:"create",value:function(t){return document.createElementNS(this.svgNS,t)}},{key:"openGroup",value:function(t,e,n){var i=this.create("g");return this.groups.push(i),this.parent.appendChild(i),this.parent=i,t&&i.setAttribute("class",b.Prefix(t)),e&&i.setAttribute("id",b.Prefix(e)),n&&n.pointerBBox&&i.setAttribute("pointer-events","bounding-box"),i}},{key:"closeGroup",value:function(){this.groups.pop(),this.parent=this.groups[this.groups.length-1]}},{key:"add",value:function(t){this.parent.appendChild(t)}},{key:"iePolyfill",value:function(){"undefined"!=typeof navigator&&(this.ie=/MSIE 9/i.test(navigator.userAgent)||/MSIE 10/i.test(navigator.userAgent)||/rv:11\.0/i.test(navigator.userAgent)||/Trident/i.test(navigator.userAgent))}},{key:"setFont",value:function(t,e,n){var i=!1,o=!1,r="normal";"string"==typeof n&&(-1!==n.indexOf("italic")&&(n=n.replace(/italic/g,""),o=!0),-1!==n.indexOf("bold")&&(n=n.replace(/bold/g,""),i=!0),n=n.replace(/ /g,""));var s={"font-family":t,"font-size":e+"pt","font-weight":n=void 0===(n=i?"bold":n)||""===n?"normal":n,"font-style":r=o?"italic":r};return this.fontSize=Number(e),b.Merge(this.attributes,s),b.Merge(this.state,s),this}},{key:"setRawFont",value:function(t){var e=(t=t.trim()).split(" ");return this.attributes["font-family"]=e[1],this.state["font-family"]=e[1],this.attributes["font-size"]=e[0],this.state["font-size"]=e[0],this.fontSize=Number(e[0].match(/\d+/)),this}},{key:"setFillStyle",value:function(t){return this.attributes.fill=t,this}},{key:"setBackgroundFillStyle",value:function(t){return this.background_attributes.fill=t,this.background_attributes.stroke=t,this}},{key:"setStrokeStyle",value:function(t){return this.attributes.stroke=t,this}},{key:"setShadowColor",value:function(t){return this.shadow_attributes.color=t,this}},{key:"setShadowBlur",value:function(t){return this.shadow_attributes.width=t,this}},{key:"setLineWidth",value:function(t){this.attributes["stroke-width"]=t,this.lineWidth=t}},{key:"setLineDash",value:function(t){if("[object Array]"===Object.prototype.toString.call(t))return t=t.join(", "),this.attributes["stroke-dasharray"]=t,this;throw new b.RERR("ArgumentError","lineDash must be an array of integers.")}},{key:"setLineCap",value:function(t){return this.attributes["stroke-linecap"]=t,this}},{key:"resize",value:function(t,e){this.width=t,this.height=e,this.element.style.width=t;var n={width:t,height:e};return this.applyAttributes(this.svg,n),this.scale(this.state.scale.x,this.state.scale.y),this}},{key:"scale",value:function(t,e){this.state.scale={x:t,y:e};var n=this.width/t,i=this.height/e;return this.setViewBox(0,0,n,i),this}},{key:"setViewBox",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];if(1===e.length){var i=e[0];this.svg.setAttribute("viewBox",i)}else{var o=e[0],r=e[1],s=e[2],a=e[3],l=o+" "+r+" "+s+" "+a;this.svg.setAttribute("viewBox",l)}}},{key:"applyAttributes",value:function(t,e){var n=z[t.nodeName];return Object.keys(e).forEach((function(i){n&&n[i]||t.setAttributeNS(null,i,e[i])})),t}},{key:"clear",value:function(){for(;this.svg.lastChild;)this.svg.removeChild(this.svg.lastChild);this.scale(this.state.scale.x,this.state.scale.y)}},{key:"rect",value:function(t,e,n,i,o){i<0&&(e+=i,i*=-1);var r=this.create("rect");return void 0===o&&(o={fill:"none","stroke-width":this.lineWidth,stroke:"black"}),b.Merge(o,{x:t,y:e,width:n,height:i}),this.applyAttributes(r,o),this.add(r),this}},{key:"fillRect",value:function(t,e,n,i){return i<0&&(e+=i,i*=-1),this.rect(t,e,n,i,this.attributes),this}},{key:"clearRect",value:function(t,e,n,i){return this.rect(t,e,n,i,this.background_attributes),this}},{key:"beginPath",value:function(){return this.path="",this.pen.x=NaN,this.pen.y=NaN,this}},{key:"moveTo",value:function(t,e){return this.path+="M"+t+" "+e,this.pen.x=t,this.pen.y=e,this}},{key:"lineTo",value:function(t,e){return this.path+="L"+t+" "+e,this.pen.x=t,this.pen.y=e,this}},{key:"bezierCurveTo",value:function(t,e,n,i,o,r){return this.path+="C"+t+" "+e+","+n+" "+i+","+o+" "+r,this.pen.x=o,this.pen.y=r,this}},{key:"quadraticCurveTo",value:function(t,e,n,i){return this.path+="Q"+t+" "+e+","+n+" "+i,this.pen.x=n,this.pen.y=i,this}},{key:"arc",value:function(t,e,n,i,o,r){function s(t){for(;t<0;)t+=2*Math.PI;for(;t>2*Math.PI;)t-=2*Math.PI;return t}if((i=s(i))>(o=s(o))){var a=i;i=o,o=a,r=!r}var l=o-i;return l>Math.PI?(this.arcHelper(t,e,n,i,i+l/2,r),this.arcHelper(t,e,n,i+l/2,o,r)):this.arcHelper(t,e,n,i,o,r),this}},{key:"arcHelper",value:function(t,e,n,i,o,r){var s=t+n*Math.cos(i),a=e+n*Math.sin(i),l=t+n*Math.cos(o),u=e+n*Math.sin(o),c=0,h=0;r?(h=1,o-i<Math.PI&&(c=1)):o-i>Math.PI&&(c=1),this.path+="M"+s+" "+a+" A"+n+" "+n+" 0 "+c+" "+h+" "+l+" "+u,isNaN(this.pen.x)||isNaN(this.pen.y)||(this.peth+="M"+this.pen.x+" "+this.pen.y)}},{key:"closePath",value:function(){return this.path+="Z",this}},{key:"glow",value:function(){if(this.shadow_attributes.width>0)for(var t=this.shadow_attributes,e=t.width/2,n=1;n<=e;n++){var i={stroke:t.color,"stroke-linejoin":"round","stroke-linecap":"round","stroke-width":+(.4*t.width/e*n).toFixed(3),opacity:+((t.opacity||.3)/e).toFixed(3)},o=this.create("path");i.d=this.path,this.applyAttributes(o,i),this.add(o)}return this}},{key:"fill",value:function(t){this.glow();var e=this.create("path");return void 0===t&&(b.Merge(t={},this.attributes),t.stroke="none"),t.d=this.path,this.applyAttributes(e,t),this.add(e),this}},{key:"stroke",value:function(){this.glow();var t=this.create("path"),e={};return b.Merge(e,this.attributes),e.fill="none",e["stroke-width"]=this.lineWidth,e.d=this.path,this.applyAttributes(t,e),this.add(t),this}},{key:"measureText",value:function(t){var e=this.create("text");if("function"!=typeof e.getBBox)return{x:0,y:0,width:0,height:0};e.textContent=t,this.applyAttributes(e,this.attributes),this.svg.appendChild(e);var n=e.getBBox();return this.ie&&""!==t&&"italic"===this.attributes["font-style"]&&(n=this.ieMeasureTextFix(n,t)),this.svg.removeChild(e),n}},{key:"ieMeasureTextFix",value:function(t){var e=1.196*Number(this.fontSize)+1.9598,n=t.width-e,i=t.height-1.5;return{x:t.x,y:t.y,width:n,height:i}}},{key:"fillText",value:function(t,e,n){if(t&&!(t.length<=0)){var i={};b.Merge(i,this.attributes),i.stroke="none",i.x=e,i.y=n;var o=this.create("text");o.textContent=t,this.applyAttributes(o,i),this.add(o)}}},{key:"save",value:function(){return this.state_stack.push({state:{"font-family":this.state["font-family"],"font-weight":this.state["font-weight"],"font-style":this.state["font-style"],"font-size":this.state["font-size"],scale:this.state.scale},attributes:{"font-family":this.attributes["font-family"],"font-weight":this.attributes["font-weight"],"font-style":this.attributes["font-style"],"font-size":this.attributes["font-size"],fill:this.attributes.fill,stroke:this.attributes.stroke,"stroke-width":this.attributes["stroke-width"],"stroke-dasharray":this.attributes["stroke-dasharray"]},shadow_attributes:{width:this.shadow_attributes.width,color:this.shadow_attributes.color},lineWidth:this.lineWidth}),this}},{key:"restore",value:function(){var t=this.state_stack.pop();return this.state["font-family"]=t.state["font-family"],this.state["font-weight"]=t.state["font-weight"],this.state["font-style"]=t.state["font-style"],this.state["font-size"]=t.state["font-size"],this.state.scale=t.state.scale,this.attributes["font-family"]=t.attributes["font-family"],this.attributes["font-weight"]=t.attributes["font-weight"],this.attributes["font-style"]=t.attributes["font-style"],this.attributes["font-size"]=t.attributes["font-size"],this.attributes.fill=t.attributes.fill,this.attributes.stroke=t.attributes.stroke,this.attributes["stroke-width"]=t.attributes["stroke-width"],this.attributes["stroke-dasharray"]=t.attributes["stroke-dasharray"],this.shadow_attributes.width=t.shadow_attributes.width,this.shadow_attributes.color=t.shadow_attributes.color,this.lineWidth=t.lineWidth,this}}])&&V(e.prototype,n),i&&V(e,i),t}();function q(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Q(t,e,n){return e&&q(t.prototype,e),n&&q(t,n),t}var Z=null,$=function(){function t(e,n){if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.elementId=e,!this.elementId)throw new b.RERR("BadArgument","Invalid id for renderer.");if(this.element=document.getElementById(e),this.element||(this.element=e),this.ctx=null,this.paper=null,this.backend=n,this.backend===t.Backends.CANVAS){if(!this.element.getContext)throw new b.RERR("BadElement","Can't get canvas context from element: ".concat(e));this.ctx=t.bolsterCanvasContext(this.element.getContext("2d"))}else if(this.backend===t.Backends.RAPHAEL)this.ctx=new U(this.element);else{if(this.backend!==t.Backends.SVG)throw new b.RERR("InvalidBackend","No support for backend: ".concat(this.backend));this.ctx=new J(this.element)}}return Q(t,null,[{key:"buildContext",value:function(e,n,i,o,r){var s=new t(e,n);i&&o&&s.resize(i,o),r||(r="#FFF");var a=s.getContext();return a.setBackgroundFillStyle(r),t.lastContext=a,a}},{key:"getCanvasContext",value:function(e,n,i,o){return t.buildContext(e,t.Backends.CANVAS,n,i,o)}},{key:"getRaphaelContext",value:function(e,n,i,o){return t.buildContext(e,t.Backends.RAPHAEL,n,i,o)}},{key:"getSVGContext",value:function(e,n,i,o){return t.buildContext(e,t.Backends.SVG,n,i,o)}},{key:"bolsterCanvasContext",value:function(e){if(t.USE_CANVAS_PROXY)return new X(e);return e.vexFlowCanvasContext=e,["clear","setFont","setRawFont","setFillStyle","setBackgroundFillStyle","setStrokeStyle","setShadowColor","setShadowBlur","setLineWidth","setLineCap","setLineDash","openGroup","closeGroup","getGroup"].forEach((function(t){e[t]=e[t]||X.prototype[t]})),e}},{key:"drawDashedLine",value:function(t,e,n,i,o,r){t.beginPath();var s=i-e,a=o-n,l=Math.atan2(a,s),u=e,c=n;t.moveTo(e,n);for(var h=0,b=!0;!(s<0?u<=i:u>=i)||!(a<0?c<=o:c>=o);){var f=r[h++%r.length],p=u+Math.cos(l)*f;u=s<0?Math.max(i,p):Math.min(i,p);var y=c+Math.sin(l)*f;c=a<0?Math.max(o,y):Math.min(o,y),b?t.lineTo(u,c):t.moveTo(u,c),b=!b}t.closePath(),t.stroke()}},{key:"Backends",get:function(){return{CANVAS:1,RAPHAEL:2,SVG:3,VML:4}}},{key:"LineEndType",get:function(){return{NONE:1,UP:2,DOWN:3}}},{key:"USE_CANVAS_PROXY",get:function(){return!1}},{key:"lastContext",get:function(){return Z},set:function(t){Z=t}}]),Q(t,[{key:"resize",value:function(e,n){if(this.backend===t.Backends.CANVAS){if(!this.element.getContext)throw new b.RERR("BadElement","Can't get canvas context from element: ".concat(this.elementId));var i=window.devicePixelRatio||1;this.element.width=e*i,this.element.height=n*i,this.element.style.width=e+"px",this.element.style.height=n+"px",this.ctx=t.bolsterCanvasContext(this.element.getContext("2d")),this.ctx.scale(i,i)}else this.ctx.resize(e,n);return this}},{key:"getContext",value:function(){return this.ctx}}]),t}();function tt(t){return(tt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function et(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function nt(t,e){return!e||"object"!==tt(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function it(t){return(it=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ot(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function rt(t,e,n){return e&&ot(t.prototype,e),n&&ot(t,n),t}function st(t,e){return(st=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var at=function(t){function e(){var t,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return et(this,e),(t=nt(this,it(e).call(this))).setAttribute("type","Stem"),t.x_begin=n.x_begin||0,t.x_end=n.x_end||0,t.y_top=n.y_top||0,t.y_bottom=n.y_bottom||0,t.stem_extension=n.stem_extension||0,t.stem_direction=n.stem_direction||0,t.hide=n.hide||!1,t.isStemlet=n.isStemlet||!1,t.stemletHeight=n.stemletHeight||0,t.stem_up_y_offset=n.stem_up_y_offset||0,t.stem_down_y_offset=n.stem_down_y_offset||0,t.renderHeightAdjustment=0,t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&st(t,e)}(e,t),rt(e,null,[{key:"CATEGORY",get:function(){return"stem"}},{key:"UP",get:function(){return 1}},{key:"DOWN",get:function(){return-1}},{key:"WIDTH",get:function(){return G.STEM_WIDTH}},{key:"HEIGHT",get:function(){return G.STEM_HEIGHT}}]),rt(e,[{key:"setNoteHeadXBounds",value:function(t,e){return this.x_begin=t,this.x_end=e,this}},{key:"setDirection",value:function(t){this.stem_direction=t}},{key:"setExtension",value:function(t){this.stem_extension=t}},{key:"getExtension",value:function(){return this.stem_extension}},{key:"setYBounds",value:function(t,e){this.y_top=t,this.y_bottom=e}},{key:"getCategory",value:function(){return e.CATEGORY}},{key:"getHeight",value:function(){var t=this.stem_direction===e.UP?this.stem_up_y_offset:this.stem_down_y_offset;return(this.y_bottom-this.y_top)*this.stem_direction+(e.HEIGHT-t+this.stem_extension)*this.stem_direction}},{key:"getBoundingBox",value:function(){throw new b.RERR("NotImplemented","getBoundingBox() not implemented.")}},{key:"getExtents",value:function(){var t=this.stem_direction===e.UP,n=[this.y_top,this.y_bottom],i=e.HEIGHT+this.stem_extension,o=(t?Math.min:Math.max).apply(void 0,n),r=(t?Math.max:Math.min).apply(void 0,n);return{topY:o+i*-this.stem_direction,baseY:r}}},{key:"setVisibility",value:function(t){return this.hide=!t,this}},{key:"setStemlet",value:function(t,e){return this.isStemlet=t,this.stemletHeight=e,this}},{key:"draw",value:function(){if(this.setRendered(),!this.hide){var t,n,i=this.checkContext(),o=this.stem_direction;o===e.DOWN?(t=this.x_begin,n=this.y_top+this.stem_down_y_offset):(t=this.x_end,n=this.y_bottom-this.stem_up_y_offset);var r=this.getHeight();!function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];at.DEBUG&&b.L("Vex.Flow.Stem",e)}("Rendering stem - ","Top Y: ",this.y_top,"Bottom Y: ",this.y_bottom);var s=this.isStemlet?r-this.stemletHeight*this.stem_direction:0;i.save(),this.applyStyle(i),i.beginPath(),i.setLineWidth(e.WIDTH),i.moveTo(t,n-s),i.lineTo(t,n-r-this.renderHeightAdjustment*o),i.stroke(),this.restoreStyle(i),i.restore()}}}]),e}(S);function lt(t){return(lt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ut(t,e){return!e||"object"!==lt(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function ct(t){return(ct=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ht(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function bt(t,e,n){return e&&ht(t.prototype,e),n&&ht(t,n),t}function ft(t,e){return(ft=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var pt=function(t){function e(t,n){var i;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=ut(this,ct(e).call(this))).setAttribute("type","Tuplet"),!t||!t.length)throw new b.RuntimeError("BadArguments","No notes provided for tuplet.");return i.options=b.Merge({},n),i.notes=t,i.num_notes="num_notes"in i.options?i.options.num_notes:t.length,i.options.beats_occupied&&i.beatsOccupiedDeprecationWarning(),i.notes_occupied=i.options.notes_occupied||i.options.beats_occupied||2,"bracketed"in i.options?i.bracketed=i.options.bracketed:i.bracketed=t.some((function(t){return null===t.beam})),i.ratioed="ratioed"in i.options?i.options.ratioed:Math.abs(i.notes_occupied-i.num_notes)>1,i.point=28,i.y_pos=16,i.x_pos=100,i.width=200,i.location=i.options.location||e.LOCATION_TOP,eo.AlignRestsToNotes(t,!0,!0),i.resolveGlyphs(),i.attach(),i}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ft(t,e)}(e,t),bt(e,null,[{key:"LOCATION_TOP",get:function(){return 1}},{key:"LOCATION_BOTTOM",get:function(){return-1}},{key:"NESTING_OFFSET",get:function(){return 15}}]),bt(e,[{key:"attach",value:function(){for(var t=0;t<this.notes.length;t++){this.notes[t].setTuplet(this)}}},{key:"detach",value:function(){for(var t=0;t<this.notes.length;t++){this.notes[t].resetTuplet(this)}}},{key:"setBracketed",value:function(t){return this.bracketed=!!t,this}},{key:"setRatioed",value:function(t){return this.ratioed=!!t,this}},{key:"setTupletLocation",value:function(t){if(t){if(t!==e.LOCATION_TOP&&t!==e.LOCATION_BOTTOM)throw new b.RERR("BadArgument","Invalid tuplet location: "+t)}else t=e.LOCATION_TOP;return this.location=t,this}},{key:"getNotes",value:function(){return this.notes}},{key:"getNoteCount",value:function(){return this.num_notes}},{key:"beatsOccupiedDeprecationWarning",value:function(){var t=["beats_occupied has been deprecated as an ","option for tuplets. Please use notes_occupied ","instead. Calls to getBeatsOccupied and ","setBeatsOccupied should now be routed to ","getNotesOccupied and setNotesOccupied instead"].join("");console&&console.warn?console.warn(t):console&&console.log(t)}},{key:"getBeatsOccupied",value:function(){return this.beatsOccupiedDeprecationWarning(),this.getNotesOccupied()}},{key:"setBeatsOccupied",value:function(t){return this.beatsOccupiedDeprecationWarning(),this.setNotesOccupied(t)}},{key:"getNotesOccupied",value:function(){return this.notes_occupied}},{key:"setNotesOccupied",value:function(t){this.detach(),this.notes_occupied=t,this.resolveGlyphs(),this.attach()}},{key:"resolveGlyphs",value:function(){this.numerator_glyphs=[];for(var t=this.num_notes;t>=1;)this.numerator_glyphs.unshift(new D("v"+t%10,this.point)),t=parseInt(t/10,10);for(this.denom_glyphs=[],t=this.notes_occupied;t>=1;)this.denom_glyphs.unshift(new D("v"+t%10,this.point)),t=parseInt(t/10,10)}},{key:"getNestedTupletCount",value:function(){var t=this.location,e=this.notes[0],n=o(e,t),i=o(e,t);function o(t,e){return t.tupletStack.filter((function(t){return t.location===e})).length}return this.notes.forEach((function(e){var r=o(e,t);n=r>n?r:n,i=r<i?r:i})),n-i}},{key:"getYPosition",value:function(){var t,n=this.getNestedTupletCount()*e.NESTING_OFFSET*-this.location,i=this.options.y_offset||0,o=this.notes[0];if(this.location===e.LOCATION_TOP){t=o.getStave().getYForLine(0)-15;for(var r=0;r<this.notes.length;++r){var s=this.notes[r].getStemDirection()===at.UP?this.notes[r].getStemExtents().topY-10:this.notes[r].getStemExtents().baseY-20;s<t&&(t=s)}}else{t=o.getStave().getYForLine(4)+20;for(var a=0;a<this.notes.length;++a){var l=this.notes[a].getStemDirection()===at.UP?this.notes[a].getStemExtents().baseY+20:this.notes[a].getStemExtents().topY+10;l>t&&(t=l)}}return t+n+i}},{key:"draw",value:function(){var t=this;this.checkContext(),this.setRendered();var n=this.notes[0],i=this.notes[this.notes.length-1];this.bracketed?(this.x_pos=n.getTieLeftX()-5,this.width=i.getTieRightX()-this.x_pos+5):(this.x_pos=n.getStemX(),this.width=i.getStemX()-this.x_pos),this.y_pos=this.getYPosition();var o=function(t,e){return t+e.getMetrics().width},r=this.numerator_glyphs.reduce(o,0);this.ratioed&&(r=this.denom_glyphs.reduce(o,r),r+=.32*this.point);var s=this.x_pos+this.width/2-r/2;if(this.bracketed){var a=this.width/2-r/2-5;a>0&&(this.context.fillRect(this.x_pos,this.y_pos,a,1),this.context.fillRect(this.x_pos+this.width/2+r/2+5,this.y_pos,a,1),this.context.fillRect(this.x_pos,this.y_pos+(this.location===e.LOCATION_BOTTOM),1,10*this.location),this.context.fillRect(this.x_pos+this.width,this.y_pos+(this.location===e.LOCATION_BOTTOM),1,10*this.location))}var l=0;if(this.numerator_glyphs.forEach((function(e){e.render(t.context,s+l,t.y_pos+t.point/3-2),l+=e.getMetrics().width})),this.ratioed){var u=s+l+.16*this.point,c=.06*this.point;this.context.beginPath(),this.context.arc(u,this.y_pos-.08*this.point,c,0,2*Math.PI,!0),this.context.closePath(),this.context.fill(),this.context.beginPath(),this.context.arc(u,this.y_pos+.12*this.point,c,0,2*Math.PI,!0),this.context.closePath(),this.context.fill(),l+=.32*this.point,this.denom_glyphs.forEach((function(e){e.render(t.context,s+l,t.y_pos+t.point/3-2),l+=e.getMetrics().width}))}}}]),e}(S);function yt(t){return(yt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function dt(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function vt(t){return(vt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function gt(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function mt(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function _t(t,e,n){return e&&mt(t.prototype,e),n&&mt(t,n),t}function xt(t,e){return(xt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function wt(t){var e=0;return t.forEach((function(t){t.keyProps&&t.keyProps.forEach((function(t){e+=t.line-3}))})),e>=0?at.DOWN:at.UP}var kt="L",St="B",Tt=function(t){function e(t,n){var i,o,r,s,a;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),o=this,(i=!(r=vt(e).call(this))||"object"!==yt(r)&&"function"!=typeof r?gt(o):r).setAttribute("type","Beam"),!t||t===[])throw new b.RuntimeError("BadArguments","No notes provided for beam.");if(1===t.length)throw new b.RuntimeError("BadArguments","Too few notes for beam.");if(i.ticks=t[0].getIntrinsicTicks(),i.ticks>=G.durationToTicks("4"))throw new b.RuntimeError("BadArguments","Beams can only be applied to notes shorter than a quarter note.");for(i.stem_direction=at.UP,s=0;s<t.length;++s)if((a=t[s]).hasStem()){i.stem_direction=a.getStemDirection();break}var l=i.stem_direction;if(n&&"stavenotes"===t[0].getCategory())l=wt(t);else if(n&&"tabnotes"===t[0].getCategory()){l=t.reduce((function(t,e){return t+e.stem_direction}),0)>-1?at.UP:at.DOWN}for(s=0;s<t.length;++s)a=t[s],n&&(a.setStemDirection(l),i.stem_direction=l),a.setBeam(gt(i));return i.postFormatted=!1,i.notes=t,i.beam_count=i.getBeamCount(),i.break_on_indices=[],i.render_options={beam_width:5,max_slope:.25,min_slope:-.25,slope_iterations:20,slope_cost:100,show_stemlets:!1,stemlet_extension:7,partial_beam_length:10,flat_beams:!1,min_flat_beam_offset:15},i}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&xt(t,e)}(e,t),_t(e,null,[{key:"getDefaultBeamGroups",value:function(t){t&&"c"!==t||(t="4/4");var e={"1/2":["1/2"],"2/2":["1/2"],"3/2":["1/2"],"4/2":["1/2"],"1/4":["1/4"],"2/4":["1/4"],"3/4":["1/4"],"4/4":["1/4"],"1/8":["1/8"],"2/8":["2/8"],"3/8":["3/8"],"4/8":["2/8"],"1/16":["1/16"],"2/16":["2/16"],"3/16":["3/16"],"4/16":["2/16"]}[t];if(void 0!==e)return e.map((function(t){return(new y).parse(t)}));var n=parseInt(t.split("/")[0],10),i=parseInt(t.split("/")[1],10);return n%3==0?[new y(3,i)]:i>4?[new y(2,i)]:i<=4?[new y(1,i)]:[new y(1,4)]}},{key:"applyAndGetBeams",value:function(t,n,i){return e.generateBeams(t.getTickables(),{groups:i,stem_direction:n})}},{key:"generateBeams",value:function(t,n){n||(n={}),n.groups&&n.groups.length||(n.groups=[new y(2,8)]);var i,o,r=n.groups.map((function(t){if(!t.multiply)throw new b.RuntimeError("InvalidBeamGroups","The beam groups must be an array of Vex.Flow.Fractions");return t.clone().multiply(G.RESOLUTION,1)})),s=0,a=[],l=[];function u(){r.length-1>s?s+=1:s=0}i=[],t.forEach((function(t){if(i=[],t.shouldIgnoreTicks())return a.push(l),void(l=i);l.push(t);var e=r[s].clone(),n=l.reduce((function(t,e){return e.getTicks().clone().add(t)}),new y(0,1)),o=G.durationToNumber(t.duration)<8;o&&t.tuplet&&(e.numerator*=2),n.greaterThan(e)?(o||i.push(l.pop()),a.push(l),l=i,u()):n.equals(e)&&(a.push(l),l=i,u())})),l.length>0&&a.push(l),o=[],a.forEach((function(t){var e=[];t.forEach((function(t,i,r){var s=0===i||i===r.length-1,a=r[i-1],l=!n.beam_rests&&t.isRest(),u=n.beam_rests&&n.beam_middle_only&&t.isRest()&&s,c=!1;if(n.maintain_stem_directions&&a&&!t.isRest()&&!a.isRest()){var h=a.getStemDirection();c=t.getStemDirection()!==h}var b=parseInt(t.duration,10)<8;l||u||c||b?(e.length>0&&o.push(e),e=c?[t]:[]):e.push(t)})),e.length>0&&o.push(e)})),(a=o).forEach((function(t){var e;if(n.maintain_stem_directions){var i=function(t){for(var e=0;e<t.length;e++){var n=t[e];if(!n.isRest())return n}return!1}(t);e=i?i.getStemDirection():at.UP}else e=n.stem_direction?n.stem_direction:wt(t);!function(t,e){t.forEach((function(t){t.setStemDirection(e)}))}(t,e)}));var c,h=a.filter((function(t){if(t.length>1){var e=!0;return t.forEach((function(t){t.getIntrinsicTicks()>=G.durationToTicks("4")&&(e=!1)})),e}return!1})),f=(c=[],a.forEach((function(t){var e=null;t.forEach((function(t){t.tuplet&&e!==t.tuplet&&(e=t.tuplet,c.push(e))}))})),c),p=[];return h.forEach((function(t){var i=new e(t);n.show_stemlets&&(i.render_options.show_stemlets=!0),n.secondary_breaks&&(i.render_options.secondary_break_ticks=G.durationToTicks(n.secondary_breaks)),!0===n.flat_beams&&(i.render_options.flat_beams=!0,i.render_options.flat_beam_offset=n.flat_beam_offset),p.push(i)})),f.forEach((function(t){var e=t.notes[0].stem_direction===at.DOWN?pt.LOCATION_BOTTOM:pt.LOCATION_TOP;t.setTupletLocation(e);for(var n=!1,i=0;i<t.notes.length;i++){if(null===t.notes[i].beam){n=!0;break}}t.setBracketed(n)})),p}}]),_t(e,[{key:"getNotes",value:function(){return this.notes}},{key:"getBeamCount",value:function(){return this.notes.map((function(t){return t.getGlyph().beam_count})).reduce((function(t,e){return e>t?e:t}))}},{key:"breakSecondaryAt",value:function(t){return this.break_on_indices=t,this}},{key:"getSlopeY",value:function(t,e,n,i){return n+(t-e)*i}},{key:"calculateSlope",value:function(){for(var t=this.notes,e=this.stem_direction,n=this.render_options,i=n.max_slope,o=n.min_slope,r=n.slope_iterations,s=n.slope_cost,a=t[0],l=function(t,e){var n=t.getStemExtents().topY,i=t.getStemX();return(e.getStemExtents().topY-n)/(e.getStemX()-i)}(a,t[t.length-1]),u=(i-o)/r,c=Number.MAX_VALUE,h=0,b=0,f=o;f<=i;f+=u){for(var p=0,y=0,d=1;d<t.length;++d){var v=t[d],g=this.getSlopeY(v.getStemX(),a.getStemX(),a.getStemExtents().topY,f)+y,m=v.getStemExtents().topY;if(m*e<g*e){var _=Math.abs(m-g);y+=_*-e,p+=_*d}else p+=(m-g)*e}var x=l/2,w=s*Math.abs(x-f)+Math.abs(p);w<c&&(c=w,h=f,b=y)}this.slope=h,this.y_shift=b}},{key:"calculateFlatSlope",value:function(){for(var t=this.notes,e=this.stem_direction,n=this.render_options,i=n.beam_width,o=n.min_flat_beam_offset,r=n.flat_beam_offset,s=0,a=0,l=0,u=0,c=0;c<t.length;c++){var h=t[c],b=h.getStemExtents().topY;s+=b,e===at.DOWN&&u<b?(u=b,a=Math.max.apply(Math,dt(h.getYs())),l=h.getBeamCount()):e===at.UP&&(0===u||u>b)&&(u=b,a=Math.min.apply(Math,dt(h.getYs())),l=h.getBeamCount())}var f=s/t.length,p=o+l*(1.5*i),y=a+p*-e;e===at.DOWN&&f<y?f=a+p:e===at.UP&&f>y&&(f=a-p),r?e===at.DOWN&&f>r?this.render_options.flat_beam_offset=f:e===at.UP&&f<r&&(this.render_options.flat_beam_offset=f):this.render_options.flat_beam_offset=f,this.slope=0,this.y_shift=0}},{key:"getBeamYToDraw",value:function(){var t=this.notes[0].getStemExtents().topY;return this.render_options.flat_beams&&this.render_options.flat_beam_offset&&(t=this.render_options.flat_beam_offset),t}},{key:"applyStemExtensions",value:function(){for(var t=this.notes,e=this.slope,n=this.y_shift,i=this.stem_direction,o=this.beam_count,r=this.render_options,s=r.show_stemlets,a=r.stemlet_extension,l=r.beam_width,u=t[0],c=this.getBeamYToDraw(),h=u.getStemX(),b=0;b<t.length;++b){var f=t[b],p=f.getStemX(),y=f.getStemExtents().topY,d=this.getSlopeY(p,h,c,e)+n,v=f.getStem().getExtension(),g=i===at.UP?y-d:d-y;if(f.stem.setExtension(v+g),f.stem.renderHeightAdjustment=-at.WIDTH/2,f.isRest()&&s){var m=(o-1)*l*1.5+l;f.stem.setVisibility(!0).setStemlet(!0,m+a)}}}},{key:"lookupBeamDirection",value:function(t,e,n,i){if("4"===t)return kt;var o="".concat(G.durationToNumber(t)/2),r=e<G.durationToTicks(o),s=i<G.durationToTicks(o),a=n<G.durationToTicks(o);return r&&s&&a?St:r&&!s&&a?kt:!r&&s&&a?"R":this.lookupBeamDirection(o,e,n,i)}},{key:"getBeamLines",value:function(t){for(var e=G.durationToTicks(t),n=[],i=!1,o=null,r=this.render_options.partial_beam_length,s=!1,a=0,l=0;l<this.notes.length;++l){var u=this.notes[l];a+=u.ticks.value();var c=!1;parseInt(t,10)>=8&&(c=-1!==this.break_on_indices.indexOf(l),this.render_options.secondary_break_ticks&&a>=this.render_options.secondary_break_ticks&&(a=0,c=!0));var h=u.getIntrinsicTicks()<e,b=u.getStemX()-at.WIDTH/2,f=this.notes[l-1],p=this.notes[l+1],y=p&&p.getIntrinsicTicks()<e,d=f&&f.getIntrinsicTicks()<e,v=f&&p&&h&&!d&&!y;if(h)if(i)(o=n[n.length-1]).end=b,c&&(i=!1,p&&!y&&null===o.end&&(o.end=o.start-r));else{if(o={start:b,end:null},i=!0,v){var g=f.getIntrinsicTicks(),m=p.getIntrinsicTicks(),_=u.getIntrinsicTicks(),x=this.lookupBeamDirection(t,g,_,m);[kt,St].includes(x)?o.end=o.start-r:o.end=o.start+r}else y?c&&(o.end=o.start-r,i=!1):o.end=(s||0===l)&&p?o.start+r:o.start-r;n.push(o)}else i=!1;s=c}var w=n[n.length-1];return w&&null===w.end&&(w.end=w.start-r),n}},{key:"drawStems",value:function(){var t=this;this.notes.forEach((function(e){e.getStem()&&e.getStem().setContext(t.context).draw()}),this)}},{key:"drawBeamLines",value:function(){this.checkContext();for(var t=["4","8","16","32","64"],e=this.notes[0],n=this.getBeamYToDraw(),i=e.getStemX(),o=this.render_options.beam_width*this.stem_direction,r=0;r<t.length;++r){for(var s=t[r],a=this.getBeamLines(s),l=0;l<a.length;++l){var u=a[l],c=u.start,h=this.getSlopeY(c,i,n,this.slope),b=u.end,f=this.getSlopeY(b,i,n,this.slope);this.context.beginPath(),this.context.moveTo(c,h),this.context.lineTo(c,h+o),this.context.lineTo(b+1,f+o),this.context.lineTo(b+1,f),this.context.closePath(),this.context.fill()}n+=1.5*o}}},{key:"preFormat",value:function(){return this}},{key:"postFormat",value:function(){this.postFormatted||("tabnotes"===this.notes[0].getCategory()||this.render_options.flat_beams?this.calculateFlatSlope():this.calculateSlope(),this.applyStemExtensions(),this.postFormatted=!0)}},{key:"draw",value:function(){this.checkContext(),this.setRendered(),this.unbeamable||(this.postFormatted||this.postFormat(),this.drawStems(),this.applyStyle(),this.drawBeamLines(),this.restoreStyle())}}]),e}(S);function Et(t){return(Et="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ot(t,e){return!e||"object"!==Et(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Rt(t){return(Rt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Pt(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Ct(t,e,n){return e&&Pt(t.prototype,e),n&&Pt(t,n),t}function Nt(t,e){return(Nt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var At=function(t){function e(t){var n;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Ot(this,Rt(e).call(this))).setAttribute("type","Voice"),"string"==typeof t){var i=t.match(/(\d+)\/(\d+)/);i&&(t={num_beats:i[1],beat_value:i[2],resolution:G.RESOLUTION})}return n.time=b.Merge({num_beats:4,beat_value:4,resolution:G.RESOLUTION},t),n.totalTicks=new y(n.time.num_beats*(n.time.resolution/n.time.beat_value),1),n.resolutionMultiplier=1,n.tickables=[],n.ticksUsed=new y(0,1),n.smallestTickCount=n.totalTicks.clone(),n.largestTickWidth=0,n.stave=null,n.mode=e.Mode.STRICT,n.voiceGroup=null,n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Nt(t,e)}(e,t),Ct(e,null,[{key:"Mode",get:function(){return{STRICT:1,SOFT:2,FULL:3}}}]),Ct(e,[{key:"getTotalTicks",value:function(){return this.totalTicks}},{key:"getTicksUsed",value:function(){return this.ticksUsed}},{key:"getLargestTickWidth",value:function(){return this.largestTickWidth}},{key:"getSmallestTickCount",value:function(){return this.smallestTickCount}},{key:"getTickables",value:function(){return this.tickables}},{key:"getMode",value:function(){return this.mode}},{key:"setMode",value:function(t){return this.mode=t,this}},{key:"getResolutionMultiplier",value:function(){return this.resolutionMultiplier}},{key:"getActualResolution",value:function(){return this.resolutionMultiplier*this.time.resolution}},{key:"setStave",value:function(t){return this.stave=t,this.boundingBox=null,this}},{key:"getBoundingBox",value:function(){var t,e,n,i;if(!this.boundingBox){if(!this.stave)throw new b.RERR("NoStave","Can't get bounding box without stave.");for(t=this.stave,e=null,i=0;i<this.tickables.length;++i)this.tickables[i].setStave(t),(n=this.tickables[i].getBoundingBox())&&(e=e?e.mergeWith(n):n);this.boundingBox=e}return this.boundingBox}},{key:"getVoiceGroup",value:function(){if(!this.voiceGroup)throw new b.RERR("NoVoiceGroup","No voice group for voice.");return this.voiceGroup}},{key:"setVoiceGroup",value:function(t){return this.voiceGroup=t,this}},{key:"setStrict",value:function(t){return this.mode=t?e.Mode.STRICT:e.Mode.SOFT,this}},{key:"isComplete",value:function(){return this.mode!==e.Mode.STRICT&&this.mode!==e.Mode.FULL||this.ticksUsed.equals(this.totalTicks)}},{key:"addTickable",value:function(t){if(!t.shouldIgnoreTicks()){var n=t.getTicks();if(this.ticksUsed.add(n),(this.mode===e.Mode.STRICT||this.mode===e.Mode.FULL)&&this.ticksUsed.greaterThan(this.totalTicks))throw this.ticksUsed.subtract(n),new b.RERR("BadArgument","Too many ticks.");n.lessThan(this.smallestTickCount)&&(this.smallestTickCount=n.clone()),this.resolutionMultiplier=this.ticksUsed.denominator,this.totalTicks.add(0,this.ticksUsed.denominator)}return this.tickables.push(t),t.setVoice(this),this}},{key:"addTickables",value:function(t){for(var e=0;e<t.length;++e)this.addTickable(t[e]);return this}},{key:"preFormat",value:function(){var t=this;return this.preFormatted?this:(this.tickables.forEach((function(e){e.getStave()||e.setStave(t.stave)})),this.preFormatted=!0,this)}},{key:"draw",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.context,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.stave;this.setRendered();for(var n=null,i=0;i<this.tickables.length;++i){var o=this.tickables[i];if(e&&o.setStave(e),!o.getStave())throw new b.RuntimeError("MissingStave","The voice cannot draw tickables without staves.");if(0===i&&(n=o.getBoundingBox()),i>0&&n){var r=o.getBoundingBox();r&&n.mergeWith(r)}o.setContext(t),o.drawWithStyle()}this.boundingBox=n}}]),e}(S);function Lt(t){return(Lt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Mt(t,e){return!e||"object"!==Lt(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Ft(t){return(Ft=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Bt(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function jt(t,e,n){return e&&Bt(t.prototype,e),n&&Bt(t,n),t}function Dt(t,e){return(Dt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function It(t,e,n,i,o){if(e!==Gt.type.BOLD_DOUBLE_LEFT&&e!==Gt.type.BOLD_DOUBLE_RIGHT)throw new b.RERR("InvalidConnector","A REPEAT_BEGIN or REPEAT_END type must be provided.");var r=3,s=3.5;e===Gt.type.BOLD_DOUBLE_RIGHT&&(r=-5,s=3),t.fillRect(n+r,i,1,o-i),t.fillRect(n-2,i,s,o-i)}var Gt=function(t){function e(t,n){var i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=Mt(this,Ft(e).call(this))).setAttribute("type","StaveConnector"),i.thickness=G.STAVE_LINE_THICKNESS,i.width=3,i.top_stave=t,i.bottom_stave=n,i.type=e.type.DOUBLE,i.font={family:"times",size:16,weight:"normal"},i.x_shift=0,i.texts=[],i}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Dt(t,e)}(e,t),jt(e,null,[{key:"type",get:function(){return{SINGLE_RIGHT:0,SINGLE_LEFT:1,SINGLE:1,DOUBLE:2,BRACE:3,BRACKET:4,BOLD_DOUBLE_LEFT:5,BOLD_DOUBLE_RIGHT:6,THIN_DOUBLE:7,NONE:8}}},{key:"typeString",get:function(){return{singleRight:e.type.SINGLE_RIGHT,singleLeft:e.type.SINGLE_LEFT,single:e.type.SINGLE,double:e.type.DOUBLE,brace:e.type.BRACE,bracket:e.type.BRACKET,boldDoubleLeft:e.type.BOLD_DOUBLE_LEFT,boldDoubleRight:e.type.BOLD_DOUBLE_RIGHT,thinDouble:e.type.THIN_DOUBLE,none:e.type.NONE}}}]),jt(e,[{key:"setType",value:function(t){return(t="string"==typeof t?e.typeString[t]:t)>=e.type.SINGLE_RIGHT&&t<=e.type.NONE&&(this.type=t),this}},{key:"setText",value:function(t,e){return this.texts.push({content:t,options:b.Merge({shift_x:0,shift_y:0},e)}),this}},{key:"setFont",value:function(t){b.Merge(this.font,t)}},{key:"setXShift",value:function(t){if("number"!=typeof t)throw b.RERR("InvalidType","x_shift must be a Number");return this.x_shift=t,this}},{key:"draw",value:function(){var t=this.checkContext();this.setRendered();var n=this.top_stave.getYForLine(0),i=this.bottom_stave.getYForLine(this.bottom_stave.getNumLines()-1)+this.thickness,o=this.width,r=this.top_stave.getX();(this.type===e.type.SINGLE_RIGHT||this.type===e.type.BOLD_DOUBLE_RIGHT||this.type===e.type.THIN_DOUBLE)&&(r=this.top_stave.getX()+this.top_stave.width);var s=i-n;switch(this.type){case e.type.SINGLE:case e.type.SINGLE_LEFT:case e.type.SINGLE_RIGHT:o=1;break;case e.type.DOUBLE:r-=this.width+2;break;case e.type.BRACE:o=12;var a=this.top_stave.getX()-2+this.x_shift,l=n,u=a,c=i,h=a-o,f=l+s/2,p=h-.9*o,y=l+.2*s,d=a+1.1*o,v=f-.135*s,g=d,m=f+.135*s,_=p,x=c-.2*s,w=h-o,k=x,S=a+.4*o,T=f+.135*s,E=S,O=f-.135*s,R=w,P=y;t.beginPath(),t.moveTo(a,l),t.bezierCurveTo(p,y,d,v,h,f),t.bezierCurveTo(g,m,_,x,u,c),t.bezierCurveTo(w,k,S,T,h,f),t.bezierCurveTo(E,O,R,P,a,l),t.fill(),t.stroke();break;case e.type.BRACKET:s=(i+=4)-(n-=4),D.renderGlyph(t,r-5,n-3,40,"v1b",!0),D.renderGlyph(t,r-5,i+3,40,"v10",!0),r-=this.width+2;break;case e.type.BOLD_DOUBLE_LEFT:It(t,this.type,r+this.x_shift,n,i);break;case e.type.BOLD_DOUBLE_RIGHT:It(t,this.type,r,n,i);break;case e.type.THIN_DOUBLE:o=1;break;case e.type.NONE:break;default:throw new b.RERR("InvalidType","The provided StaveConnector.type (".concat(this.type,") is invalid"))}this.type!==e.type.BRACE&&this.type!==e.type.BOLD_DOUBLE_LEFT&&this.type!==e.type.BOLD_DOUBLE_RIGHT&&this.type!==e.type.NONE&&t.fillRect(r,n,o,s),this.type===e.type.THIN_DOUBLE&&t.fillRect(r-3,n,o,s),t.save(),t.lineWidth=2,t.setFont(this.font.family,this.font.size,this.font.weight);for(var C=0;C<this.texts.length;C++){var N=this.texts[C],A=t.measureText(""+N.content).width,L=this.top_stave.getX()-A-24+N.options.shift_x,M=(this.top_stave.getYForLine(0)+this.bottom_stave.getBottomLineY())/2+N.options.shift_y;t.fillText(""+N.content,L,M+4)}t.restore()}}]),e}(S);function Yt(t){return(Yt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Wt(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Xt(t,e){return!e||"object"!==Yt(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Ht(t){return(Ht=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ut(t,e){return(Ut=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Vt=function(t){function e(){var t;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(t=Xt(this,Ht(e).call(this))).setAttribute("type","Tickable"),t.ticks=new y(0,1),t.intrinsicTicks=0,t.tickMultiplier=new y(1,1),t.width=0,t.x_shift=0,t.voice=null,t.tickContext=null,t.modifierContext=null,t.modifiers=[],t.preFormatted=!1,t.postFormatted=!1,t.tuplet=null,t.tupletStack=[],t.align_center=!1,t.center_x_shift=0,t.ignore_ticks=!1,t.formatterMetrics={freedom:{left:0,right:0},duration:"",iterations:0,space:{used:0,mean:0,deviation:0}},t}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Ut(t,e)}(e,t),n=e,(i=[{key:"reset",value:function(){return this}},{key:"getTicks",value:function(){return this.ticks}},{key:"shouldIgnoreTicks",value:function(){return this.ignore_ticks}},{key:"getWidth",value:function(){return this.width}},{key:"getFormatterMetrics",value:function(){return this.formatterMetrics}},{key:"setXShift",value:function(t){this.x_shift=t}},{key:"getCenterXShift",value:function(){return this.isCenterAligned()?this.center_x_shift:0}},{key:"isCenterAligned",value:function(){return this.align_center}},{key:"setCenterAlignment",value:function(t){return this.align_center=t,this}},{key:"getVoice",value:function(){if(!this.voice)throw new b.RERR("NoVoice","Tickable has no voice.");return this.voice}},{key:"setVoice",value:function(t){this.voice=t}},{key:"getTuplet",value:function(){return this.tuplet}},{key:"resetTuplet",value:function(t){var e,n;if(t){var i=this.tupletStack.indexOf(t);return-1!==i&&(this.tupletStack.splice(i,1),e=t.getNoteCount(),n=t.getNotesOccupied(),this.applyTickMultiplier(e,n)),this}for(;this.tupletStack.length;)e=(t=this.tupletStack.pop()).getNoteCount(),n=t.getNotesOccupied(),this.applyTickMultiplier(e,n);return this}},{key:"setTuplet",value:function(t){if(t){this.tupletStack.push(t);var e=t.getNoteCount(),n=t.getNotesOccupied();this.applyTickMultiplier(n,e)}return this.tuplet=t,this}},{key:"addToModifierContext",value:function(t){this.modifierContext=t,this.preFormatted=!1}},{key:"addModifier",value:function(t){return this.modifiers.push(t),this.preFormatted=!1,this}},{key:"getModifiers",value:function(){return this.modifiers}},{key:"setTickContext",value:function(t){this.tickContext=t,this.preFormatted=!1}},{key:"preFormat",value:function(){this.preFormatted||(this.width=0,this.modifierContext&&(this.modifierContext.preFormat(),this.width+=this.modifierContext.getWidth()))}},{key:"postFormat",value:function(){return this.postFormatted?this:(this.postFormatted=!0,this)}},{key:"getIntrinsicTicks",value:function(){return this.intrinsicTicks}},{key:"setIntrinsicTicks",value:function(t){this.intrinsicTicks=t,this.ticks=this.tickMultiplier.clone().multiply(this.intrinsicTicks)}},{key:"getTickMultiplier",value:function(){return this.tickMultiplier}},{key:"applyTickMultiplier",value:function(t,e){this.tickMultiplier.multiply(t,e),this.ticks=this.tickMultiplier.clone().multiply(this.intrinsicTicks)}},{key:"setDuration",value:function(t){var e=t.numerator*(G.RESOLUTION/t.denominator);this.ticks=this.tickMultiplier.clone().multiply(e),this.intrinsicTicks=this.ticks.value()}}])&&Wt(n.prototype,i),o&&Wt(n,o),e}(S);function zt(t){return(zt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Kt(t,e){return!e||"object"!==zt(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Jt(t){return(Jt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function qt(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Qt(t,e,n){return e&&qt(t.prototype,e),n&&qt(t,n),t}function Zt(t,e){return(Zt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var $t=function(t){function e(t){var n;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Kt(this,Jt(e).call(this))).setAttribute("type","Note"),!t)throw new b.RuntimeError("BadArguments","Note must have valid initialization data to identify duration and type.");var i=G.parseNoteData(t);if(!i)throw new b.RuntimeError("BadArguments","Invalid note initialization object: ".concat(JSON.stringify(t)));if(n.duration=i.duration,n.dots=i.dots,n.noteType=i.type,t.duration_override?n.setDuration(t.duration_override):n.setIntrinsicTicks(i.ticks),n.modifiers=[],n.glyph=G.durationToGlyph(n.duration,n.noteType),n.positions&&("object"!==zt(n.positions)||!n.positions.length))throw new b.RuntimeError("BadArguments","Note keys must be array type.");return n.playNote=null,n.tickContext=null,n.modifierContext=null,n.ignore_ticks=!1,n.width=0,n.extraLeftPx=0,n.extraRightPx=0,n.x_shift=0,n.left_modPx=0,n.right_modPx=0,n.voice=null,n.preFormatted=!1,n.ys=[],t.align_center&&n.setCenterAlignment(t.align_center),n.stave=null,n.render_options={annotation_spacing:5,stave_padding:e.STAVEPADDING},n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Zt(t,e)}(e,t),Qt(e,null,[{key:"plotMetrics",value:function(t,e,n){var i=e.getMetrics(),o=e.getAbsoluteX()-i.modLeftPx-i.extraLeftPx,r=e.getAbsoluteX()-i.extraLeftPx,s=e.getAbsoluteX(),a=e.getAbsoluteX()+i.noteWidth,l=e.getAbsoluteX()+i.noteWidth+i.extraRightPx,u=e.getAbsoluteX()+i.noteWidth+i.extraRightPx+i.modRightPx,c=u+e.getFormatterMetrics().freedom.right,h=u-o;t.save(),t.setFont("Arial",8,""),t.fillText(Math.round(h)+"px",o+e.getXShift(),n);var f=n+7;function p(n,i,o){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:f;t.beginPath(),t.setStrokeStyle(o),t.setFillStyle(o),t.setLineWidth(3),t.moveTo(n+e.getXShift(),r),t.lineTo(i+e.getXShift(),r),t.stroke()}p(o,r,"red"),p(r,s,"#999"),p(s,a,"green"),p(a,l,"#999"),p(l,u,"red"),p(u,c,"#DD0"),p(o-e.getXShift(),o,"#BBB"),b.drawDot(t,s+e.getXShift(),f,"blue");var y=e.getFormatterMetrics();if(y.iterations>0){var d=y.space.deviation,v=d>=0?"+":"";t.setFillStyle("red"),t.fillText(v+Math.round(d),s+e.getXShift(),n-10)}t.restore()}},{key:"CATEGORY",get:function(){return"note"}},{key:"STAVEPADDING",get:function(){return 12}}]),Qt(e,[{key:"getPlayNote",value:function(){return this.playNote}},{key:"setPlayNote",value:function(t){return this.playNote=t,this}},{key:"isRest",value:function(){return!1}},{key:"addStroke",value:function(t,e){return e.setNote(this),e.setIndex(t),this.modifiers.push(e),this.setPreFormatted(!1),this}},{key:"getStave",value:function(){return this.stave}},{key:"setStave",value:function(t){return this.stave=t,this.setYs([t.getYForLine(0)]),this.context=this.stave.context,this}},{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setContext",value:function(t){return this.context=t,this}},{key:"getExtraLeftPx",value:function(){return this.extraLeftPx}},{key:"getExtraRightPx",value:function(){return this.extraRightPx}},{key:"setExtraLeftPx",value:function(t){return this.extraLeftPx=t,this}},{key:"setExtraRightPx",value:function(t){return this.extraRightPx=t,this}},{key:"shouldIgnoreTicks",value:function(){return this.ignore_ticks}},{key:"getLineNumber",value:function(){return 0}},{key:"getLineForRest",value:function(){return 0}},{key:"getGlyph",value:function(){return this.glyph}},{key:"getGlyphWidth",value:function(){return this.glyph.getWidth(this.render_options.glyph_font_scale)}},{key:"setYs",value:function(t){return this.ys=t,this}},{key:"getYs",value:function(){if(0===this.ys.length)throw new b.RERR("NoYValues","No Y-values calculated for this note.");return this.ys}},{key:"getYForTopText",value:function(t){if(!this.stave)throw new b.RERR("NoStave","No stave attached to this note.");return this.stave.getYForTopText(t)}},{key:"getBoundingBox",value:function(){return null}},{key:"getVoice",value:function(){if(!this.voice)throw new b.RERR("NoVoice","Note has no voice.");return this.voice}},{key:"setVoice",value:function(t){return this.voice=t,this.preFormatted=!1,this}},{key:"getTickContext",value:function(){return this.tickContext}},{key:"setTickContext",value:function(t){return this.tickContext=t,this.preFormatted=!1,this}},{key:"getDuration",value:function(){return this.duration}},{key:"isDotted",value:function(){return this.dots>0}},{key:"hasStem",value:function(){return!1}},{key:"getDots",value:function(){return this.dots}},{key:"getNoteType",value:function(){return this.noteType}},{key:"setBeam",value:function(){return this}},{key:"setModifierContext",value:function(t){return this.modifierContext=t,this}},{key:"addModifier",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return t.setNote(this),t.setIndex(e),this.modifiers.push(t),this.setPreFormatted(!1),this}},{key:"getModifierStartXY",value:function(){if(!this.preFormatted)throw new b.RERR("UnformattedNote","Can't call GetModifierStartXY on an unformatted note");return{x:this.getAbsoluteX(),y:this.ys[0]}}},{key:"getMetrics",value:function(){if(!this.preFormatted)throw new b.RERR("UnformattedNote","Can't call getMetrics on an unformatted note.");var t=0,e=0;null!=this.modifierContext&&(t=this.modifierContext.state.left_shift,e=this.modifierContext.state.right_shift);var n=this.getWidth();return{width:n,noteWidth:n-t-e-this.extraLeftPx-this.extraRightPx,left_shift:this.x_shift,modLeftPx:t,modRightPx:e,extraLeftPx:this.extraLeftPx,extraRightPx:this.extraRightPx}}},{key:"setWidth",value:function(t){this.width=t}},{key:"getWidth",value:function(){if(!this.preFormatted)throw new b.RERR("UnformattedNote","Can't call GetWidth on an unformatted note.");return this.width+(this.modifierContext?this.modifierContext.getWidth():0)}},{key:"setXShift",value:function(t){return this.x_shift=t,this}},{key:"getXShift",value:function(){return this.x_shift}},{key:"getX",value:function(){if(!this.tickContext)throw new b.RERR("NoTickContext","Note needs a TickContext assigned for an X-Value");return this.tickContext.getX()+this.x_shift}},{key:"getAbsoluteX",value:function(){if(!this.tickContext)throw new b.RERR("NoTickContext","Note needs a TickContext assigned for an X-Value");var t=this.tickContext.getX();return this.stave&&(t+=this.stave.getNoteStartX()+this.render_options.stave_padding),this.isCenterAligned()&&(t+=this.getCenterXShift()),t}},{key:"setPreFormatted",value:function(t){if(this.preFormatted=t,this.preFormatted){var e=this.tickContext.getExtraPx();this.left_modPx=Math.max(this.left_modPx,e.left),this.right_modPx=Math.max(this.right_modPx,e.right)}}}]),e}(Vt);function te(t){return(te="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ee(t,e){return!e||"object"!==te(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function ne(t,e,n){return(ne="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=ie(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function ie(t){return(ie=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function oe(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function re(t,e,n){return e&&oe(t.prototype,e),n&&oe(t,n),t}function se(t,e){return(se=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var ae=function(t){function e(t){var n;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=ee(this,ie(e).call(this,t))).setAttribute("type","NoteHead"),n.index=t.index,n.x=t.x||0,n.y=t.y||0,n.note_type=t.note_type,n.duration=t.duration,n.displaced=t.displaced||!1,n.stem_direction=t.stem_direction||je.STEM_UP,n.line=t.line,n.glyph=G.durationToGlyph(n.duration,n.note_type),!n.glyph)throw new b.RuntimeError("BadArguments","No glyph found for duration '".concat(n.duration,"' and type '").concat(n.note_type,"'"));return n.glyph_code=n.glyph.code_head,n.x_shift=t.x_shift,t.custom_glyph_code&&(n.custom_glyph=!0,n.glyph_code=t.custom_glyph_code),n.style=t.style,n.slashed=t.slashed,b.Merge(n.render_options,{glyph_font_scale:t.glyph_font_scale||G.DEFAULT_NOTATION_FONT_SCALE,stroke_px:3}),n.setWidth(n.glyph.getWidth(n.render_options.glyph_font_scale)),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&se(t,e)}(e,t),re(e,null,[{key:"CATEGORY",get:function(){return"notehead"}}]),re(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"getWidth",value:function(){return this.width}},{key:"isDisplaced",value:function(){return!0===this.displaced}},{key:"getGlyph",value:function(){return this.glyph}},{key:"setX",value:function(t){return this.x=t,this}},{key:"getY",value:function(){return this.y}},{key:"setY",value:function(t){return this.y=t,this}},{key:"getLine",value:function(){return this.line}},{key:"setLine",value:function(t){return this.line=t,this}},{key:"getAbsoluteX",value:function(){var t=this.preFormatted?ne(ie(e.prototype),"getAbsoluteX",this).call(this):this.x,n=at.WIDTH/2;return t+(this.displaced?(this.width-n)*this.stem_direction:0)}},{key:"getBoundingBox",value:function(){if(!this.preFormatted)throw new b.RERR("UnformattedNote","Can't call getBoundingBox on an unformatted note.");var t=this.stave.getSpacingBetweenLines(),e=t/2,n=this.y-e;return new G.BoundingBox(this.getAbsoluteX(),n,this.width,t)}},{key:"setStave",value:function(t){var e=this.getLine();return this.stave=t,this.setY(t.getYForNote(e)),this.context=this.stave.context,this}},{key:"preFormat",value:function(){if(this.preFormatted)return this;var t=this.getWidth()+this.extraLeftPx+this.extraRightPx;return this.setWidth(t),this.setPreFormatted(!0),this}},{key:"draw",value:function(){this.checkContext(),this.setRendered();var t=this.context,e=this.getAbsoluteX(),n=this.y;!function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];ae.DEBUG&&b.L("Vex.Flow.NoteHead",e)}("Drawing note head '",this.note_type,this.duration,"' at",e,n);var i=this.stem_direction,o=this.render_options.glyph_font_scale;if(this.style&&this.applyStyle(t),"s"===this.note_type){var r=this.stave.getSpacingBetweenLines();!function(t,e,n,i,o,r){var s=G.SLASH_NOTEHEAD_WIDTH;t.save(),t.setLineWidth(G.STEM_WIDTH);var a=!1;if(G.durationToNumber(e)>2&&(a=!0),a||(n-=G.STEM_WIDTH/2*o),t.beginPath(),t.moveTo(n,i+r),t.lineTo(n,i+1),t.lineTo(n+s,i-r),t.lineTo(n+s,i),t.lineTo(n,i+r),t.closePath(),a?t.fill():t.stroke(),G.durationToFraction(e).equals(.5))for(var l=[-3,-1,s+1,s+3],u=0;u<l.length;u++)t.beginPath(),t.moveTo(n+l[u],i-10),t.lineTo(n+l[u],i+11),t.stroke();t.restore()}(t,this.duration,e,n,i,r)}else D.renderGlyph(t,e,n,o,this.glyph_code);this.style&&this.restoreStyle(t)}}]),e}($t);function le(t){return(le="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ue(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function ce(t,e){return!e||"object"!==le(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function he(t){return(he=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function be(t,e){return(be=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var fe=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=ce(this,he(e).call(this,t))).setAttribute("type","StemmableNote"),n.stem=null,n.stemExtensionOverride=null,n.beam=null,n}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&be(t,e)}(e,t),n=e,(i=[{key:"getStem",value:function(){return this.stem}},{key:"setStem",value:function(t){return this.stem=t,this}},{key:"buildStem",value:function(){var t=new at;return this.setStem(t),this}},{key:"buildFlag",value:function(){var t=this.glyph,e=null===this.beam;if(t&&t.flag&&e){var n=this.getStemDirection()===at.DOWN?t.code_flag_downstem:t.code_flag_upstem;this.flag=new D(n,this.render_options.glyph_font_scale)}}},{key:"getStemLength",value:function(){return at.HEIGHT+this.getStemExtension()}},{key:"getBeamCount",value:function(){var t=this.getGlyph();return t?t.beam_count:0}},{key:"getStemMinumumLength",value:function(){var t=G.durationToFraction(this.duration).value()<=1?0:20;switch(this.duration){case"8":null==this.beam&&(t=35);break;case"16":t=null==this.beam?35:25;break;case"32":t=null==this.beam?45:35;break;case"64":t=null==this.beam?50:40;break;case"128":t=null==this.beam?55:45}return t}},{key:"getStemDirection",value:function(){return this.stem_direction}},{key:"setStemDirection",value:function(t){if(t||(t=at.UP),t!==at.UP&&t!==at.DOWN)throw new b.RERR("BadArgument","Invalid stem direction: ".concat(t));return this.stem_direction=t,this.stem&&(this.stem.setDirection(t),this.stem.setExtension(this.getStemExtension())),this.reset(),this.flag&&this.buildFlag(),this.beam=null,this.preFormatted&&this.preFormat(),this}},{key:"getStemX",value:function(){var t=this.getAbsoluteX()+this.x_shift,e=this.getAbsoluteX()+this.x_shift+this.getGlyphWidth();return this.stem_direction===at.DOWN?t:e}},{key:"getCenterGlyphX",value:function(){return this.getAbsoluteX()+this.x_shift+this.getGlyphWidth()/2}},{key:"getStemExtension",value:function(){var t=this.getGlyph();return null!=this.stemExtensionOverride?this.stemExtensionOverride:t?1===this.getStemDirection()?t.stem_up_extension:t.stem_down_extension:0}},{key:"setStemLength",value:function(t){return this.stemExtensionOverride=t-at.HEIGHT,this}},{key:"getStemExtents",value:function(){return this.stem.getExtents()}},{key:"setBeam",value:function(t){return this.beam=t,this}},{key:"getYForTopText",value:function(t){var e=this.getStemExtents();return this.hasStem()?Math.min(this.stave.getYForTopText(t),e.topY-this.render_options.annotation_spacing*(t+1)):this.stave.getYForTopText(t)}},{key:"getYForBottomText",value:function(t){var e=this.getStemExtents();return this.hasStem()?Math.max(this.stave.getYForTopText(t),e.baseY+this.render_options.annotation_spacing*t):this.stave.getYForBottomText(t)}},{key:"hasFlag",value:function(){return G.durationToGlyph(this.duration).flag&&!this.beam}},{key:"postFormat",value:function(){return this.beam&&this.beam.postFormat(),this.postFormatted=!0,this}},{key:"drawStem",value:function(t){this.checkContext(),this.setRendered(),this.setStem(new at(t)),this.stem.setContext(this.context).draw()}}])&&ue(n.prototype,i),o&&ue(n,o),e}($t);function pe(t){return(pe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ye(t,e){return!e||"object"!==pe(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function de(t){return(de=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ve(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function ge(t,e,n){return e&&ve(t.prototype,e),n&&ve(t,n),t}function me(t,e){return(me=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var _e=function(t){function e(){var t;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(t=ye(this,de(e).call(this))).setAttribute("type","Modifier"),t.width=0,t.note=null,t.index=null,t.text_line=0,t.position=e.Position.LEFT,t.modifier_context=null,t.x_shift=0,t.y_shift=0,t.spacingFromNextModifier=0,t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&me(t,e)}(e,t),ge(e,null,[{key:"CATEGORY",get:function(){return"none"}},{key:"Position",get:function(){return{LEFT:1,RIGHT:2,ABOVE:3,BELOW:4}}},{key:"PositionString",get:function(){return{above:e.Position.ABOVE,below:e.Position.BELOW,left:e.Position.LEFT,right:e.Position.RIGHT}}}]),ge(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"getWidth",value:function(){return this.width}},{key:"setWidth",value:function(t){return this.width=t,this}},{key:"getNote",value:function(){return this.note}},{key:"setNote",value:function(t){return this.note=t,this}},{key:"getIndex",value:function(){return this.index}},{key:"setIndex",value:function(t){return this.index=t,this}},{key:"getModifierContext",value:function(){return this.modifier_context}},{key:"setModifierContext",value:function(t){return this.modifier_context=t,this}},{key:"getPosition",value:function(){return this.position}},{key:"setPosition",value:function(t){return this.position="string"==typeof t?e.PositionString[t]:t,this}},{key:"setTextLine",value:function(t){return this.text_line=t,this}},{key:"setYShift",value:function(t){return this.y_shift=t,this}},{key:"setSpacingFromNextModifier",value:function(t){this.spacingFromNextModifier=t}},{key:"getSpacingFromNextModifier",value:function(){return this.spacingFromNextModifier}},{key:"setXShift",value:function(t){this.x_shift=0,this.position===e.Position.LEFT?this.x_shift-=t:this.x_shift+=t}},{key:"getXShift",value:function(){return this.x_shift}},{key:"draw",value:function(){throw this.checkContext(),new b.RERR("MethodNotImplemented","draw() not implemented for this modifier.")}},{key:"alignSubNotesWithNote",value:function(t,e){var n=e.getTickContext(),i=n.getExtraPx(),o=n.getX()-i.left-i.extraLeft+this.getSpacingFromNextModifier();t.forEach((function(t){var n=t.getTickContext();t.setStave(e.stave),n.setXOffset(o)}))}}]),e}(S);function xe(t){return(xe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function we(t,e){return!e||"object"!==xe(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function ke(t){return(ke=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Se(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Te(t,e,n){return e&&Se(t.prototype,e),n&&Se(t,n),t}function Ee(t,e){return(Ee=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Oe=function(t){function e(){var t;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(t=we(this,ke(e).call(this))).setAttribute("type","Dot"),t.note=null,t.index=null,t.position=_e.Position.RIGHT,t.radius=2,t.setWidth(5),t.dot_shiftY=0,t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Ee(t,e)}(e,t),Te(e,null,[{key:"format",value:function(t,e){var n=e.right_shift;if(!t||0===t.length)return!1;for(var i=[],o={},r=0;r<t.length;++r){var s=t[r],a=s.getNote(),l=void 0,u=void 0;"function"==typeof a.getKeyProps?u=(l=a.getKeyProps()[s.getIndex()]).displaced?a.getExtraRightPx():0:(l={line:.5},u=0);var c=a.getAttribute("id");i.push({line:l.line,note:a,note_id:c,dot:s}),o[c]=Math.max(o[c]||u,u)}i.sort((function(t,e){return e.line-t.line}));for(var h=n,b=0,f=null,p=null,y=null,d=0,v=0;v<i.length;++v){var g=i[v],m=g.dot,_=g.note,x=g.note_id,w=g.line;w===f&&_===p||(h=o[x]),_.isRest()||w===f||(.5===Math.abs(w%1)?d=0:(d=.5,null==p||p.isRest()||f-w!=.5?w+d===y&&(d=-.5):d=-.5)),_.isRest()?m.dot_shiftY+=-d:m.dot_shiftY=-d,y=w+d,m.setXShift(h),b=(h+=m.getWidth()+1)>b?h:b,f=w,p=_}return e.right_shift+=b,!0}},{key:"CATEGORY",get:function(){return"dots"}}]),Te(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setNote",value:function(t){this.note=t,"gracenotes"===this.note.getCategory()&&(this.radius*=.5,this.setWidth(3))}},{key:"setDotShiftY",value:function(t){return this.dot_shiftY=t,this}},{key:"draw",value:function(){if(this.checkContext(),this.setRendered(),!this.note||null===this.index)throw new b.RERR("NoAttachedNote","Can't draw dot without a note and index.");var t=this.note.stave.options.spacing_between_lines_px,e=this.note.getModifierStartXY(this.position,this.index,{forceFlagRight:!0});"tabnotes"===this.note.getCategory()&&(e.y=this.note.getStemExtents().baseY);var n=e.x+this.x_shift+this.width-this.radius,i=e.y+this.y_shift+this.dot_shiftY*t,o=this.context;o.beginPath(),o.arc(n,i,this.radius,0,2*Math.PI,!1),o.fill()}}]),e}(_e);function Re(t){return(Re="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pe(){return(Pe=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t}).apply(this,arguments)}function Ce(t,e){return!e||"object"!==Re(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Ne(t,e,n){return(Ne="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=Ae(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function Ae(t){return(Ae=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Le(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Me(t,e,n){return e&&Le(t.prototype,e),n&&Le(t,n),t}function Fe(t,e){return(Fe=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Be(t,e,n){var i=(e.isrest?0:1)*n;t.line+=i,t.maxLine+=i,t.minLine+=i,t.note.setKeyLine(0,t.note.getKeyLine(0)+i)}var je=function(t){function e(t){var n;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Ce(this,Ae(e).call(this,t))).setAttribute("type","StaveNote"),n.keys=t.keys,n.clef=t.clef,n.octave_shift=t.octave_shift,n.beam=null,n.glyph=G.durationToGlyph(n.duration,n.noteType),!n.glyph)throw new b.RuntimeError("BadArguments","Invalid note initialization data (No glyph found): ".concat(JSON.stringify(t)));return n.displaced=!1,n.dot_shiftY=0,n.keyProps=[],n.use_default_head_x=!1,n.note_heads=[],n.modifiers=[],b.Merge(n.render_options,{glyph_font_scale:t.glyph_font_scale||G.DEFAULT_NOTATION_FONT_SCALE,stroke_px:t.stroke_px||e.DEFAULT_LEDGER_LINE_OFFSET}),n.calculateKeyProps(),n.buildStem(),t.auto_stem?n.autoStem():n.setStemDirection(t.stem_direction),n.reset(),n.buildFlag(),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Fe(t,e)}(e,t),Me(e,null,[{key:"format",value:function(t,n){if(!t||t.length<2)return!1;if(t[0].getStave())return e.formatByY(t,n);for(var i=[],o=0;o<t.length;o++){var r=t[o].getKeyProps(),s=r[0].line,a=r[r.length-1].line,l=t[o].getStemDirection(),u=t[o].getStemLength()/10,c=t[o].getStemMinumumLength()/10,h=void 0;t[o].isRest()?(h=s+t[o].glyph.line_above,a=s-t[o].glyph.line_below):(h=1===l?r[r.length-1].line+u:r[r.length-1].line,a=1===l?r[0].line:r[0].line-u),i.push({line:r[0].line,maxLine:h,minLine:a,isrest:t[o].isRest(),stemDirection:l,stemMax:u,stemMin:c,voice_shift:t[o].getVoiceShiftWidth(),is_displaced:t[o].isDisplaced(),note:t[o]})}var f=i.length,p=i[0],y=f>2?i[1]:null,d=f>2?i[2]:i[1];2===f&&-1===p.stemDirection&&1===d.stemDirection&&(p=i[1],d=i[0]);var v,g=Math.max(p.voice_shift,d.voice_shift),m=0;if(2===f){var _=p.stemDirection===d.stemDirection?0:.5;return p.stemDirection===d.stemDirection&&p.minLine<=d.maxLine&&(p.isrest||(v=Math.abs(p.line-(d.maxLine+.5)),v=Math.max(v,p.stemMin),p.minLine=p.line-v,p.note.setStemLength(10*v))),p.minLine<=d.maxLine+_&&(p.isrest?Be(p,d,1):d.isrest?Be(d,p,-1):(m=g,p.stemDirection===d.stemDirection?p.note.setXShift(m+3):d.note.setXShift(m))),!0}if((null!==y&&y.minLine<d.maxLine+.5&&(y.isrest||(v=Math.abs(y.line-(d.maxLine+.5)),v=Math.max(v,y.stemMin),y.minLine=y.line-v,y.note.setStemLength(10*v))),y.isrest&&!p.isrest&&!d.isrest)&&(p.minLine<=y.maxLine||y.minLine<=d.maxLine))return y.maxLine-y.minLine<p.minLine-d.maxLine?function(t,e,n){var i=t.line-b.MidLine(e.minLine,n.maxLine);t.note.setKeyLine(0,t.note.getKeyLine(0)-i),t.line-=i,t.maxLine-=i,t.minLine-=i}(y,p,d):(m=g+3,y.note.setXShift(m)),!0;return p.isrest&&y.isrest&&d.isrest?(Be(p,y,1),Be(d,y,-1),!0):(y.isrest&&p.isrest&&y.minLine<=d.maxLine&&Be(y,d,1),y.isrest&&d.isrest&&p.minLine<=y.maxLine&&Be(y,p,-1),p.isrest&&p.minLine<=y.maxLine&&Be(p,y,1),d.isrest&&y.minLine<=d.maxLine&&Be(d,y,-1),(!p.isrest&&!y.isrest&&p.minLine<=y.maxLine+.5||!y.isrest&&!d.isrest&&y.minLine<=d.maxLine)&&(m=g+3,y.note.setXShift(m)),!0)}},{key:"formatByY",value:function(t,e){for(var n=!0,i=0;i<t.length;i++)n=n&&null!=t[i].getStave();if(!n)throw new b.RERR("Stave Missing","All notes must have a stave - Vex.Flow.ModifierContext.formatMultiVoice!");for(var o=0,r=0;r<t.length-1;r++){var s=t[r],a=t[r+1];s.getStemDirection()===at.DOWN&&(s=t[r+1],a=t[r]);var l=s.getKeyProps(),u=a.getKeyProps(),c=s.getStave().getYForLine(5-l[0].line+.5);a.getStave().getYForLine(5-u[u.length-1].line-.5)-c<0&&(o=s.getVoiceShiftWidth()+2,a.setXShift(o))}e.right_shift+=o}},{key:"postFormat",value:function(t){return!!t&&(t.forEach((function(t){return t.postFormat()})),!0)}},{key:"CATEGORY",get:function(){return"stavenotes"}},{key:"STEM_UP",get:function(){return at.UP}},{key:"STEM_DOWN",get:function(){return at.DOWN}},{key:"DEFAULT_LEDGER_LINE_OFFSET",get:function(){return 3}}]),Me(e,[{key:"reset",value:function(){var t=this;Ne(Ae(e.prototype),"reset",this).call(this);var n=this.note_heads.map((function(t){return t.getStyle()}));this.buildNoteHeads(),this.note_heads.forEach((function(t,e){return t.setStyle(n[e])})),this.stave&&this.note_heads.forEach((function(e){return e.setStave(t.stave)})),this.calcExtraPx()}},{key:"setBeam",value:function(t){return this.beam=t,this.calcExtraPx(),this}},{key:"getCategory",value:function(){return e.CATEGORY}},{key:"buildStem",value:function(){var t=this.getGlyph();this.setStem(new at({stem_up_y_offset:t.stem_up_y_offset,stem_down_y_offset:t.stem_down_y_offset,hide:!!this.isRest()}))}},{key:"buildNoteHeads",value:function(){this.note_heads=[];var t,e,n,i=this.getStemDirection(),o=this.getKeys(),r=null,s=null,a=!1;i===at.UP?(t=0,e=o.length,n=1):i===at.DOWN&&(t=o.length-1,e=-1,n=-1);for(var l=t;l!==e;l+=n){var u=this.keyProps[l],c=u.line;null===r?r=c:0===(s=Math.abs(r-c))||.5===s?a=!a:(a=!1,this.use_default_head_x=!0),r=c;var h=new ae({duration:this.duration,note_type:this.noteType,displaced:a,stem_direction:i,custom_glyph_code:u.code,glyph_font_scale:this.render_options.glyph_font_scale,x_shift:u.shift_right,line:u.line});this.note_heads[l]=h}}},{key:"autoStem",value:function(){this.minLine=this.keyProps[0].line,this.maxLine=this.keyProps[this.keyProps.length-1].line;var t=(this.minLine+this.maxLine)/2<3?at.UP:at.DOWN;this.setStemDirection(t)}},{key:"calculateKeyProps",value:function(){for(var t=null,e=0;e<this.keys.length;++e){var n=this.keys[e];this.glyph.rest&&(this.glyph.position=n);var i={octave_shift:this.octave_shift||0},o=G.keyProperties(n,this.clef,i);if(!o)throw new b.RuntimeError("BadArguments","Invalid key for note properties: ".concat(n));"R"===o.key&&("1"===this.duration||"w"===this.duration?o.line=4:o.line=3);var r=o.line;null===t?t=r:.5===Math.abs(t-r)&&(this.displaced=!0,o.displaced=!0,this.keyProps.length>0&&(this.keyProps[e-1].displaced=!0)),t=r,this.keyProps.push(o)}t=-1/0,this.keyProps.forEach((function(e){e.line<t&&b.W("Unsorted keys in note will be sorted. See https://github.com/0xfe/vexflow/issues/104 for details."),t=e.line})),this.keyProps.sort((function(t,e){return t.line-e.line}))}},{key:"getBoundingBox",value:function(){if(!this.preFormatted)throw new b.RERR("UnformattedNote","Can't call getBoundingBox on an unformatted note.");var t=this.getMetrics(),e=t.width,n=t.modLeftPx,i=t.extraLeftPx,o=this.getAbsoluteX()-n-i,r=0,s=0,a=this.getStave().getSpacingBetweenLines()/2,l=2*a;if(this.isRest()){var u=this.ys[0],c=G.durationToFraction(this.duration);c.equals(1)||c.equals(2)?(r=u-a,s=u+a):(r=u-this.glyph.line_above*l,s=u+this.glyph.line_below*l)}else if(this.glyph.stem){var h=this.getStemExtents();h.baseY+=a*this.stem_direction,r=Math.min(h.topY,h.baseY),s=Math.max(h.topY,h.baseY)}else{r=null,s=null;for(var f=0;f<this.ys.length;++f){var p=this.ys[f];0===f?(r=p,s=p):(r=Math.min(p,r),s=Math.max(p,s))}r-=a,s+=a}return new P(o,r,e,s-r)}},{key:"getLineNumber",value:function(t){if(!this.keyProps.length)throw new b.RERR("NoKeyProps","Can't get bottom note line, because note is not initialized properly.");for(var e=this.keyProps[0].line,n=0;n<this.keyProps.length;n++){var i=this.keyProps[n].line;t?i>e&&(e=i):i<e&&(e=i)}return e}},{key:"isRest",value:function(){return this.glyph.rest}},{key:"isChord",value:function(){return!this.isRest()&&this.keys.length>1}},{key:"hasStem",value:function(){return this.glyph.stem}},{key:"hasFlag",value:function(){return Ne(Ae(e.prototype),"hasFlag",this).call(this)&&!this.isRest()}},{key:"getStemX",value:function(){return"r"===this.noteType?this.getCenterGlyphX():Ne(Ae(e.prototype),"getStemX",this).call(this)+(t=this,at.WIDTH/(2*-t.getStemDirection()));var t}},{key:"getYForTopText",value:function(t){var e=this.getStemExtents();return Math.min(this.stave.getYForTopText(t),e.topY-this.render_options.annotation_spacing*(t+1))}},{key:"getYForBottomText",value:function(t){var e=this.getStemExtents();return Math.max(this.stave.getYForTopText(t),e.baseY+this.render_options.annotation_spacing*t)}},{key:"setStave",value:function(t){Ne(Ae(e.prototype),"setStave",this).call(this,t);var n=this.note_heads.map((function(e){return e.setStave(t),e.getY()}));if(this.setYs(n),this.stem){var i=this.getNoteHeadBounds(),o=i.y_top,r=i.y_bottom;this.stem.setYBounds(o,r)}return this}},{key:"getKeys",value:function(){return this.keys}},{key:"getKeyProps",value:function(){return this.keyProps}},{key:"isDisplaced",value:function(){return this.displaced}},{key:"setNoteDisplaced",value:function(t){return this.displaced=t,this}},{key:"getTieRightX",value:function(){var t=this.getAbsoluteX();return t+=this.getGlyphWidth()+this.x_shift+this.extraRightPx,this.modifierContext&&(t+=this.modifierContext.getExtraRightPx()),t}},{key:"getTieLeftX",value:function(){var t=this.getAbsoluteX();return t+=this.x_shift-this.extraLeftPx}},{key:"getLineForRest",value:function(){var t=this.keyProps[0].line;if(this.keyProps.length>1){var e=this.keyProps[this.keyProps.length-1].line,n=Math.max(t,e),i=Math.min(t,e);t=b.MidLine(n,i)}return t}},{key:"getModifierStartXY",value:function(t,e,n){if(n=n||{},!this.preFormatted)throw new b.RERR("UnformattedNote","Can't call GetModifierStartXY on an unformatted note");if(0===this.ys.length)throw new b.RERR("NoYValues","No Y-Values calculated for this note.");var i=_e.Position,o=i.ABOVE,r=i.BELOW,s=i.LEFT,a=i.RIGHT,l=0;return t===s?l=-2:t===a?(l=this.getGlyphWidth()+this.x_shift+2,this.stem_direction===at.UP&&this.hasFlag()&&(n.forceFlagRight||function(t,e){return e===(t.getStemDirection()===at.UP?t.keyProps.length-1:0)}(this,e))&&(l+=this.flag.getMetrics().width)):t!==r&&t!==o||(l=this.getGlyphWidth()/2),{x:this.getAbsoluteX()+l,y:this.ys[e]}}},{key:"setStyle",value:function(t){Ne(Ae(e.prototype),"setStyle",this).call(this,t),this.note_heads.forEach((function(e){return e.setStyle(t)})),this.stem.setStyle(t)}},{key:"setStemStyle",value:function(t){this.getStem().setStyle(t)}},{key:"getStemStyle",value:function(){return this.stem.getStyle()}},{key:"setLedgerLineStyle",value:function(t){this.ledgerLineStyle=t}},{key:"getLedgerLineStyle",value:function(){return this.ledgerLineStyle}},{key:"setFlagStyle",value:function(t){this.flagStyle=t}},{key:"getFlagStyle",value:function(){return this.flagStyle}},{key:"setKeyStyle",value:function(t,e){return this.note_heads[t].setStyle(e),this}},{key:"setKeyLine",value:function(t,e){return this.keyProps[t].line=e,this.reset(),this}},{key:"getKeyLine",value:function(t){return this.keyProps[t].line}},{key:"addToModifierContext",value:function(t){this.setModifierContext(t);for(var e=0;e<this.modifiers.length;++e)this.modifierContext.addModifier(this.modifiers[e]);return this.modifierContext.addModifier(this),this.setPreFormatted(!1),this}},{key:"addModifier",value:function(t,e){return e.setNote(this),e.setIndex(t),this.modifiers.push(e),this.setPreFormatted(!1),this}},{key:"addAccidental",value:function(t,e){return this.addModifier(t,e)}},{key:"addArticulation",value:function(t,e){return this.addModifier(t,e)}},{key:"addAnnotation",value:function(t,e){return this.addModifier(t,e)}},{key:"addDot",value:function(t){var e=new Oe;return e.setDotShiftY(this.glyph.dot_shiftY),this.dots++,this.addModifier(t,e)}},{key:"addDotToAll",value:function(){for(var t=0;t<this.keys.length;++t)this.addDot(t);return this}},{key:"getAccidentals",value:function(){return this.modifierContext.getModifiers("accidentals")}},{key:"getDots",value:function(){return this.modifierContext.getModifiers("dots")}},{key:"getVoiceShiftWidth",value:function(){return this.getGlyphWidth()*(this.displaced?2:1)}},{key:"calcExtraPx",value:function(){this.setExtraLeftPx(this.displaced&&this.stem_direction===at.DOWN?this.getGlyphWidth():0),this.setExtraRightPx(!this.hasFlag()&&this.displaced&&this.stem_direction===at.UP?this.getGlyphWidth():0)}},{key:"preFormat",value:function(){if(!this.preFormatted){this.modifierContext&&this.modifierContext.preFormat();var t=this.getGlyphWidth()+this.extraLeftPx+this.extraRightPx;this.glyph.flag&&null===this.beam&&this.stem_direction===at.UP&&(t+=this.getGlyphWidth()),this.setWidth(t),this.setPreFormatted(!0)}}},{key:"getNoteHeadBounds",value:function(){var t=null,e=null,n=null,i=null,o=this.stave.getNumLines(),r=1,s=!1,a=!1,l=o,u=r;return this.note_heads.forEach((function(c){var h=c.getLine(),b=c.getY();(null===t||b<t)&&(t=b),(null===e||b>e)&&(e=b),null===i&&c.isDisplaced()&&(i=c.getAbsoluteX()),null!==n||c.isDisplaced()||(n=c.getAbsoluteX()),o=h>o?h:o,r=h<r?h:r,c.isDisplaced()?(s=!1===s?h:Math.max(h,s),a=!1===a?h:Math.min(h,a)):(l=Math.max(h,l),u=Math.min(h,u))}),this),{y_top:t,y_bottom:e,displaced_x:i,non_displaced_x:n,highest_line:o,lowest_line:r,highest_displaced_line:s,lowest_displaced_line:a,highest_non_displaced_line:l,lowest_non_displaced_line:u}}},{key:"getNoteHeadBeginX",value:function(){return this.getAbsoluteX()+this.x_shift}},{key:"getNoteHeadEndX",value:function(){return this.getNoteHeadBeginX()+this.getGlyphWidth()}},{key:"drawLedgerLines",value:function(){var t=this.stave,e=this.glyph,n=this.render_options.stroke_px,i=this.context,o=e.getWidth()+2*n,r=2*(e.getWidth()+n)-at.WIDTH/2;if(!this.isRest()){if(!i)throw new b.RERR("NoCanvasContext","Can't draw without a canvas context.");var s=this.getNoteHeadBounds(),a=s.highest_line,l=s.lowest_line,u=s.highest_displaced_line,c=s.highest_non_displaced_line,h=s.lowest_displaced_line,f=s.lowest_non_displaced_line,p=s.displaced_x,y=s.non_displaced_x,d=Math.min(p,y),v=function(t,e,s){var a;a=s&&e?d-n:e?y-n:p-n;var l=e&&s?r:o;i.beginPath(),i.moveTo(a,t),i.lineTo(a+l,t),i.stroke()},g=Pe({},t.getStyle()||{},this.getLedgerLineStyle()||{});this.applyStyle(i,g);for(var m=6;m<=a;++m){var _=null!==y&&m<=c,x=null!==p&&m<=u;v(t.getYForNote(m),_,x)}for(var w=0;w>=l;--w){var k=null!==y&&w>=f,S=null!==p&&w>=h;v(t.getYForNote(w),k,S)}this.restoreStyle(i,g)}}},{key:"drawModifiers",value:function(){if(!this.context)throw new b.RERR("NoCanvasContext","Can't draw without a canvas context.");var t=this.context;t.openGroup("modifiers");for(var e=0;e<this.modifiers.length;e++){var n=this.modifiers[e],i=this.note_heads[n.getIndex()],o=i.getStyle();i.applyStyle(t,o),n.setContext(t),n.drawWithStyle(),i.restoreStyle(t,o)}t.closeGroup()}},{key:"drawFlag",value:function(){var t=this.stem,e=this.beam,n=this.context;if(!n)throw new b.RERR("NoCanvasContext","Can't draw without a canvas context.");var i=null===e;if(this.getGlyph().flag&&i){var o=this.getNoteHeadBounds(),r=o.y_top,s=o.y_bottom,a=t.getHeight(),l=this.getStemX(),u=this.getStemDirection()===at.DOWN?r-a+2:s-a-2;n.openGroup("flag",null,{pointerBBox:!0}),this.applyStyle(n,this.getFlagStyle()||!1),this.flag.render(n,l,u),this.restoreStyle(n,this.getFlagStyle()||!1),n.closeGroup()}}},{key:"drawNoteHeads",value:function(){var t=this;this.note_heads.forEach((function(e){t.context.openGroup("notehead",null,{pointerBBox:!0}),e.setContext(t.context).draw(),t.context.closeGroup()}))}},{key:"drawStem",value:function(t){if(!this.context)throw new b.RERR("NoCanvasContext","Can't draw without a canvas context.");t&&this.setStem(new at(t)),this.context.openGroup("stem",null,{pointerBBox:!0}),this.stem.setContext(this.context).draw(),this.context.closeGroup()}},{key:"draw",value:function(){if(!this.context)throw new b.RERR("NoCanvasContext","Can't draw without a canvas context.");if(!this.stave)throw new b.RERR("NoStave","Can't draw without a stave.");if(0===this.ys.length)throw new b.RERR("NoYValues","Can't draw note without Y values.");var t=this.getNoteHeadBeginX(),e=this.hasStem()&&!this.beam;this.note_heads.forEach((function(e){return e.setX(t)}));var n=this.getStemX();this.stem.setNoteHeadXBounds(n,n),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];je.DEBUG&&b.L("Vex.Flow.StaveNote",e)}("Rendering ",this.isChord()?"chord :":"note :",this.keys),this.drawLedgerLines(),this.applyStyle(),this.setAttribute("el",this.context.openGroup("stavenote",this.getAttribute("id"))),this.context.openGroup("note",null,{pointerBBox:!0}),e&&this.drawStem(),this.drawNoteHeads(),this.drawFlag(),this.context.closeGroup(),this.drawModifiers(),this.context.closeGroup(),this.restoreStyle(),this.setRendered()}}]),e}(fe);function De(t){return(De="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ie(t,e){return!e||"object"!==De(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Ge(t){return(Ge=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ye(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function We(t,e,n){return e&&Ye(t.prototype,e),n&&Ye(t,n),t}function Xe(t,e){return(Xe=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var He=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Ie(this,Ge(e).call(this))).setAttribute("type","FretHandFinger"),n.note=null,n.index=null,n.finger=t,n.width=7,n.position=_e.Position.LEFT,n.x_shift=0,n.y_shift=0,n.x_offset=0,n.y_offset=0,n.font={family:"sans-serif",size:9,weight:"bold"},n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Xe(t,e)}(e,t),We(e,null,[{key:"format",value:function(t,e){var n=e.left_shift,i=e.right_shift;if(!t||0===t.length)return!1;for(var o=[],r=null,s=0,a=0,l=0;l<t.length;++l){var u=t[l],c=u.getNote(),h=u.getPosition(),b=c.getKeyProps()[u.getIndex()];if(c!==r){for(var f=0;f<c.keys.length;++f){var p=c.getKeyProps()[f];0===n&&(s=p.displaced?c.getExtraLeftPx():s),0===i&&(a=p.displaced?c.getExtraRightPx():a)}r=c}o.push({note:c,num:u,pos:h,line:b.line,shiftL:s,shiftR:a})}o.sort((function(t,e){return e.line-t.line}));for(var y=0,d=0,v=0,g=0,m=null,_=null,x=0;x<o.length;++x){var w=0,k=o[x],S=k.note,T=k.pos,E=k.num,O=k.line,R=k.shiftL,P=k.shiftR;O===m&&S===_||(y=n+R,d=i+P);var C=E.getWidth()+1;T===_e.Position.LEFT?(E.setXShift(n+y),v=(w=n+C)>v?w:v):T===_e.Position.RIGHT&&(E.setXShift(d),g=(w=a+C)>g?w:g),m=O,_=S}return e.left_shift+=v,e.right_shift+=g,!0}},{key:"CATEGORY",get:function(){return"frethandfinger"}}]),We(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setFretHandFinger",value:function(t){return this.finger=t,this}},{key:"setOffsetX",value:function(t){return this.x_offset=t,this}},{key:"setOffsetY",value:function(t){return this.y_offset=t,this}},{key:"draw",value:function(){if(this.checkContext(),!this.note||null==this.index)throw new b.RERR("NoAttachedNote","Can't draw string number without a note and index.");this.setRendered();var t=this.context,e=this.note.getModifierStartXY(this.position,this.index),n=e.x+this.x_shift+this.x_offset,i=e.y+this.y_shift+this.y_offset+5;switch(this.position){case _e.Position.ABOVE:n-=4,i-=12;break;case _e.Position.BELOW:n-=2,i+=10;break;case _e.Position.LEFT:n-=this.width;break;case _e.Position.RIGHT:n+=1;break;default:throw new b.RERR("InvalidPostion","The position ".concat(this.position," does not exist"))}t.save(),t.setFont(this.font.family,this.font.size,this.font.weight),t.fillText(""+this.finger,n,i),t.restore()}}]),e}(_e);function Ue(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var Ve=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t)}var e,n,i;return e=t,i=[{key:"NUM_TONES",get:function(){return 12}},{key:"roots",get:function(){return["c","d","e","f","g","a","b"]}},{key:"root_values",get:function(){return[0,2,4,5,7,9,11]}},{key:"root_indices",get:function(){return{c:0,d:1,e:2,f:3,g:4,a:5,b:6}}},{key:"canonical_notes",get:function(){return["c","c#","d","d#","e","f","f#","g","g#","a","a#","b"]}},{key:"diatonic_intervals",get:function(){return["unison","m2","M2","m3","M3","p4","dim5","p5","m6","M6","b7","M7","octave"]}},{key:"diatonic_accidentals",get:function(){return{unison:{note:0,accidental:0},m2:{note:1,accidental:-1},M2:{note:1,accidental:0},m3:{note:2,accidental:-1},M3:{note:2,accidental:0},p4:{note:3,accidental:0},dim5:{note:4,accidental:-1},p5:{note:4,accidental:0},m6:{note:5,accidental:-1},M6:{note:5,accidental:0},b7:{note:6,accidental:-1},M7:{note:6,accidental:0},octave:{note:7,accidental:0}}}},{key:"intervals",get:function(){return{u:0,unison:0,m2:1,b2:1,min2:1,S:1,H:1,2:2,M2:2,maj2:2,T:2,W:2,m3:3,b3:3,min3:3,M3:4,3:4,maj3:4,4:5,p4:5,"#4":6,b5:6,aug4:6,dim5:6,5:7,p5:7,"#5":8,b6:8,aug5:8,6:9,M6:9,maj6:9,b7:10,m7:10,min7:10,dom7:10,M7:11,maj7:11,8:12,octave:12}}},{key:"scales",get:function(){return{major:[2,2,1,2,2,2,1],dorian:[2,1,2,2,2,1,2],mixolydian:[2,2,1,2,2,1,2],minor:[2,1,2,2,1,2,2]}}},{key:"scaleTypes",get:function(){return{M:t.scales.major,m:t.scales.minor}}},{key:"accidentals",get:function(){return["bb","b","n","#","##"]}},{key:"noteValues",get:function(){return{c:{root_index:0,int_val:0},cn:{root_index:0,int_val:0},"c#":{root_index:0,int_val:1},"c##":{root_index:0,int_val:2},cb:{root_index:0,int_val:11},cbb:{root_index:0,int_val:10},d:{root_index:1,int_val:2},dn:{root_index:1,int_val:2},"d#":{root_index:1,int_val:3},"d##":{root_index:1,int_val:4},db:{root_index:1,int_val:1},dbb:{root_index:1,int_val:0},e:{root_index:2,int_val:4},en:{root_index:2,int_val:4},"e#":{root_index:2,int_val:5},"e##":{root_index:2,int_val:6},eb:{root_index:2,int_val:3},ebb:{root_index:2,int_val:2},f:{root_index:3,int_val:5},fn:{root_index:3,int_val:5},"f#":{root_index:3,int_val:6},"f##":{root_index:3,int_val:7},fb:{root_index:3,int_val:4},fbb:{root_index:3,int_val:3},g:{root_index:4,int_val:7},gn:{root_index:4,int_val:7},"g#":{root_index:4,int_val:8},"g##":{root_index:4,int_val:9},gb:{root_index:4,int_val:6},gbb:{root_index:4,int_val:5},a:{root_index:5,int_val:9},an:{root_index:5,int_val:9},"a#":{root_index:5,int_val:10},"a##":{root_index:5,int_val:11},ab:{root_index:5,int_val:8},abb:{root_index:5,int_val:7},b:{root_index:6,int_val:11},bn:{root_index:6,int_val:11},"b#":{root_index:6,int_val:0},"b##":{root_index:6,int_val:1},bb:{root_index:6,int_val:10},bbb:{root_index:6,int_val:9}}}}],(n=[{key:"isValidNoteValue",value:function(e){return!(null==e||e<0||e>=t.NUM_TONES)}},{key:"isValidIntervalValue",value:function(t){return this.isValidNoteValue(t)}},{key:"getNoteParts",value:function(t){if(!t||t.length<1)throw new b.RERR("BadArguments","Invalid note name: "+t);if(t.length>3)throw new b.RERR("BadArguments","Invalid note name: "+t);var e=t.toLowerCase(),n=/^([cdefgab])(b|bb|n|#|##)?$/.exec(e);if(null!=n)return{root:n[1],accidental:n[2]};throw new b.RERR("BadArguments","Invalid note name: "+t)}},{key:"getKeyParts",value:function(t){if(!t||t.length<1)throw new b.RERR("BadArguments","Invalid key: "+t);var e=t.toLowerCase(),n=/^([cdefgab])(b|#)?(mel|harm|m|M)?$/.exec(e);if(null!=n){var i=n[1],o=n[2],r=n[3];return r||(r="M"),{root:i,accidental:o,type:r}}throw new b.RERR("BadArguments","Invalid key: ".concat(t))}},{key:"getNoteValue",value:function(e){var n=t.noteValues[e];if(null==n)throw new b.RERR("BadArguments","Invalid note name: ".concat(e));return n.int_val}},{key:"getIntervalValue",value:function(e){var n=t.intervals[e];if(null==n)throw new b.RERR("BadArguments","Invalid interval name: ".concat(e));return n}},{key:"getCanonicalNoteName",value:function(e){if(!this.isValidNoteValue(e))throw new b.RERR("BadArguments","Invalid note value: ".concat(e));return t.canonical_notes[e]}},{key:"getCanonicalIntervalName",value:function(e){if(!this.isValidIntervalValue(e))throw new b.RERR("BadArguments","Invalid interval value: ".concat(e));return t.diatonic_intervals[e]}},{key:"getRelativeNoteValue",value:function(e,n,i){if(null==i&&(i=1),1!==i&&-1!==i)throw new b.RERR("BadArguments","Invalid direction: ".concat(i));var o=(e+i*n)%t.NUM_TONES;return o<0&&(o+=t.NUM_TONES),o}},{key:"getRelativeNoteName",value:function(e,n){var i=this.getNoteParts(e),o=this.getNoteValue(i.root),r=n-o;if(Math.abs(r)>t.NUM_TONES-3){var s=1;r>0&&(s=-1);var a=(n+1+(o+1))%t.NUM_TONES*s;if(Math.abs(a)>2)throw new b.RERR("BadArguments","Notes not related: ".concat(e,", ").concat(n,")"));r=a}if(Math.abs(r)>2)throw new b.RERR("BadArguments","Notes not related: ".concat(e,", ").concat(n,")"));var l=i.root;if(r>0)for(var u=1;u<=r;++u)l+="#";else if(r<0)for(var c=-1;c>=r;--c)l+="b";return l}},{key:"getScaleTones",value:function(t,e){for(var n=[t],i=t,o=0;o<e.length;o+=1)(i=this.getRelativeNoteValue(i,e[o]))!==t&&n.push(i);return n}},{key:"getIntervalBetween",value:function(e,n,i){if(null==i&&(i=1),1!==i&&-1!==i)throw new b.RERR("BadArguments","Invalid direction: ".concat(i));if(!this.isValidNoteValue(e)||!this.isValidNoteValue(n))throw new b.RERR("BadArguments","Invalid notes: ".concat(e,", ").concat(n));var o=1===i?n-e:e-n;return o<0&&(o+=t.NUM_TONES),o}},{key:"createScaleMap",value:function(e){var n=this.getKeyParts(e),i=t.scaleTypes[n.type],o=n.root;if(n.accidental&&(o+=n.accidental),!i)throw new b.RERR("BadArguments","Unsupported key type: "+e);for(var r=this.getScaleTones(this.getNoteValue(o),i),s=t.root_indices[n.root],a={},l=0;l<t.roots.length;++l){var u=(s+l)%t.roots.length,c=t.roots[u],h=this.getRelativeNoteName(c,r[l]);1===h.length&&(h+="n"),a[c]=h}return a}}])&&Ue(e.prototype,n),i&&Ue(e,i),t}();function ze(t){return(ze="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ke(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function Je(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=[],i=!0,o=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(i=(s=a.next()).done)&&(n.push(s.value),!e||n.length!==e);i=!0);}catch(t){o=!0,r=t}finally{try{i||null==a.return||a.return()}finally{if(o)throw r}}return n}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function qe(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function Qe(t,e){return!e||"object"!==ze(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Ze(t){return(Ze=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function $e(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function tn(t,e,n){return e&&$e(t.prototype,e),n&&$e(t,n),t}function en(t,e){return(en=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function nn(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];rn.DEBUG&&b.L("Vex.Flow.Accidental",e)}var on=function(t){return t.getMetrics().width},rn=function(t){function e(){var t,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(qe(this,e),(t=Qe(this,Ze(e).call(this))).setAttribute("type","Accidental"),nn("New accidental: ",n),t.note=null,t.index=null,t.type=n,t.position=_e.Position.LEFT,t.render_options={font_scale:38,stroke_px:3,parenLeftPadding:2,parenRightPadding:2},t.accidental=G.accidentalCodes(t.type),!t.accidental)throw new b.RERR("ArgumentError","Unknown accidental type: ".concat(n));return t.cautionary=!1,t.parenLeft=null,t.parenRight=null,t.reset(),t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&en(t,e)}(e,t),tn(e,null,[{key:"format",value:function(t,e){var n=this,i=e.left_shift+1;if(t&&0!==t.length){for(var o=[],r=null,s=0,a=0;a<t.length;++a){var l=t[a],u=l.getNote(),c=u.getStave(),h=u.getKeyProps()[l.getIndex()];if(u!==r){for(var b=0;b<u.keys.length;++b)s=u.getKeyProps()[b].displaced?u.getExtraLeftPx():s;r=u}if(null!==c){var f=c.options.spacing_between_lines_px,p=c.getYForLine(h.line),y=Math.round(p/f*2)/2;o.push({y:p,line:y,shift:s,acc:l,lineSpace:f})}else o.push({line:h.line,shift:s,acc:l})}o.sort((function(t,e){return e.line-t.line}));for(var d=[],v=0,g=null,m=0;m<o.length;m++){var _=o[m];null!==g&&g===_.line||d.push({line:_.line,flatLine:!0,dblSharpLine:!0,numAcc:0,width:0}),"b"!==_.acc.type&&"bb"!==_.acc.type&&(d[d.length-1].flatLine=!1),"##"!==_.acc.type&&(d[d.length-1].dblSharpLine=!1),d[d.length-1].numAcc++,d[d.length-1].width+=_.acc.getWidth()+3,v=_.shift>v?_.shift:v,g=_.line}for(var x=0,w=function(t){for(var e=!1,i=t,o=t;o+1<d.length&&!e;)n.checkCollision(d[o],d[o+1])?o++:e=!0;var r=function(t){return d[i+t]},s=function(t){return t.map(r)},a=function(e,n){var i=Je(s([e,n]).map((function(t){return t.line})),2),o=i[0],r=i[1];return k=t,o-r},l=function(){for(var t=arguments.length,e=new Array(t),i=0;i<t;i++)e[i]=arguments[i];return e.map(s).every((function(t){return!n.checkCollision.apply(n,Ke(t))}))},u=o-i+1,c=n.checkCollision(d[i],d[o])?"a":"b";switch(u){case 3:"a"===c&&.5===a(1,2)&&.5!==a(0,1)&&(c="second_on_bottom");break;case 4:l([0,2],[1,3])&&(c="spaced_out_tetrachord");break;case 5:"b"===c&&l([1,3])&&(c="spaced_out_pentachord",l([0,2],[2,4])&&(c="very_spaced_out_pentachord"));break;case 6:l([0,3],[1,4],[2,5])&&(c="spaced_out_hexachord"),l([0,2],[2,4],[1,3],[3,5])&&(c="very_spaced_out_hexachord")}var h=void 0,b=void 0;if(u>=7){for(var f=2,p=!0;!0===p;){p=!1;for(var y=0;y+f<d.length;y++)if(n.checkCollision(d[y],d[y+f])){p=!0,f++;break}}for(h=t;h<=o;h++)b=(h-t)%f+1,d[h].column=b,x=x>b?x:b}else for(h=t;h<=o;h++)b=G.accidentalColumnsTable[u][c][h-t],d[h].column=b,x=x>b?x:b;k=t=o},k=0;k<d.length;k++)w(k);for(var S=[],T=[],E=0;E<=x;E++)S[E]=0,T[E]=0;S[0]=v+i,T[0]=v+i,d.forEach((function(t){t.width>S[t.column]&&(S[t.column]=t.width)}));for(var O=1;O<S.length;O++)T[O]=S[O]+T[O-1];var R=T[T.length-1],P=0;d.forEach((function(t){for(var e=0,n=P+t.numAcc;P<n;P++){var i=T[t.column-1]+e;o[P].acc.setXShift(i),e+=o[P].acc.getWidth()+3,nn("Line, accCount, shift: ",t.line,P,i)}})),e.left_shift+=R}}},{key:"checkCollision",value:function(t,e){var n=e.line-t.line,i=3;n>0?(i=e.flatLine||e.dblSharpLine?2.5:3,t.dblSharpLine&&(n-=.5)):(i=t.flatLine||t.dblSharpLine?2.5:3,e.dblSharpLine&&(n-=.5));var o=Math.abs(n)<i;return nn("Line_1, Line_2, Collision: ",t.line,e.line,o),o}},{key:"applyAccidentals",value:function(t,n){var i=[],o={};t.forEach((function(t){var e=new y(0,1);t.getTickables().forEach((function(t){if(!t.shouldIgnoreTicks()){var n=o[e.value()];n?n.push(t):(i.push(e.value()),o[e.value()]=[t]),e.add(t.getTicks())}}))}));var r=new Ve;n||(n="C");var s=r.createScaleMap(n);i.forEach((function(t){var n=o[t],i=[];n.forEach((function t(n){n.isRest()||n.shouldIgnoreTicks()||(n.keys.forEach((function(t,o){var a=r.getNoteParts(t.split("/")[0]),l=a.accidental||"n",u=a.root+l,c=s[a.root]===u,h=i.indexOf(u)>-1;if(!c||c&&h){s[a.root]=u;var b=new e(l);n.addAccidental(o,b),i.push(u)}})),n.getModifiers().forEach((function(e){"gracenotegroups"===e.getCategory()&&e.getGraceNotes().forEach(t)})))}))}))}},{key:"CATEGORY",get:function(){return"accidentals"}}]),tn(e,[{key:"reset",value:function(){var t=this.render_options.font_scale;this.glyph=new D(this.accidental.code,t),this.glyph.setOriginX(1),this.cautionary&&(this.parenLeft=new D(G.accidentalCodes("{").code,t),this.parenRight=new D(G.accidentalCodes("}").code,t),this.parenLeft.setOriginX(1),this.parenRight.setOriginX(1))}},{key:"getCategory",value:function(){return e.CATEGORY}},{key:"getWidth",value:function(){var t=this.cautionary?on(this.parenLeft)+on(this.parenRight)+this.render_options.parenLeftPadding+this.render_options.parenRightPadding:0;return on(this.glyph)+t}},{key:"setNote",value:function(t){if(!t)throw new b.RERR("ArgumentError","Bad note value: ".concat(t));this.note=t,"gracenotes"===this.note.getCategory()&&(this.render_options.font_scale=25,this.reset())}},{key:"setAsCautionary",value:function(){return this.cautionary=!0,this.render_options.font_scale=28,this.reset(),this}},{key:"draw",value:function(){var t=this.context,e=this.type,n=this.position,i=this.note,o=this.index,r=this.cautionary,s=this.x_shift,a=this.y_shift,l=this.glyph,u=this.parenLeft,c=this.parenRight,h=this.render_options,f=h.parenLeftPadding,p=h.parenRightPadding;if(this.checkContext(),!i||null==o)throw new b.RERR("NoAttachedNote","Can't draw accidental without a note and index.");var y=i.getModifierStartXY(n,o),d=y.x+s,v=y.y+a;nn("Rendering: ",e,d,v),r?(c.render(t,d,v),d-=on(c),d-=p,d-=this.accidental.parenRightPaddingAdjustment,l.render(t,d,v),d-=on(l),d-=f,u.render(t,d,v)):l.render(t,d,v),this.setRendered()}}]),e}(_e);function sn(t){return(sn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function an(t,e){return!e||"object"!==sn(e)&&"function"!=typeof e?un(t):e}function ln(t){return(ln=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function un(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function cn(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function hn(t,e,n){return e&&cn(t.prototype,e),n&&cn(t,n),t}function bn(t,e){return(bn=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var fn=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=an(this,ln(e).call(this))).setAttribute("type","NoteSubGroup"),n.note=null,n.index=null,n.position=_e.Position.LEFT,n.subNotes=t,n.subNotes.forEach((function(t){t.ignore_ticks=!1})),n.width=0,n.preFormatted=!1,n.formatter=new eo,n.voice=new At({num_beats:4,beat_value:4,resolution:G.RESOLUTION}).setStrict(!1),n.voice.addTickables(n.subNotes),an(n,un(n))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&bn(t,e)}(e,t),hn(e,null,[{key:"format",value:function(t,e){if(!t||0===t.length)return!1;for(var n=0,i=0;i<t.length;++i){var o=t[i];o.preFormat(),n+=o.getWidth()}return e.left_shift+=n,!0}},{key:"CATEGORY",get:function(){return"notesubgroup"}}]),hn(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"preFormat",value:function(){this.preFormatted||(this.formatter.joinVoices([this.voice]).format([this.voice],0),this.setWidth(this.formatter.getMinTotalWidth()),this.preFormatted=!0)}},{key:"setNote",value:function(t){this.note=t}},{key:"setWidth",value:function(t){this.width=t}},{key:"getWidth",value:function(){return this.width}},{key:"draw",value:function(){var t=this;this.checkContext();var e=this.getNote();if(!e||null===this.index)throw new b.RuntimeError("NoAttachedNote","Can't draw notes without a parent note and parent note index.");this.setRendered(),this.alignSubNotesWithNote(this.subNotes,e),this.subNotes.forEach((function(e){return e.setContext(t.context).drawWithStyle()}))}}]),e}(_e);function pn(t){return(pn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function yn(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function dn(t,e){return!e||"object"!==pn(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function vn(t){return(vn=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function gn(t,e){return(gn=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var mn=function(t){function e(t,n){var i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=dn(this,vn(e).call(this))).setAttribute("type","StaveTie"),i.notes=t,i.context=null,i.text=n,i.direction=null,i.render_options={cp1:8,cp2:12,text_shift_x:0,first_x_shift:0,last_x_shift:0,y_shift:7,tie_spacing:0,font:{family:"Arial",size:10,style:""}},i.font=i.render_options.font,i.setNotes(t),i}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&gn(t,e)}(e,t),n=e,(i=[{key:"setFont",value:function(t){return this.font=t,this}},{key:"setDirection",value:function(t){return this.direction=t,this}},{key:"setNotes",value:function(t){if(!t.first_note&&!t.last_note)throw new b.RuntimeError("BadArguments","Tie needs to have either first_note or last_note set.");if(t.first_indices||(t.first_indices=[0]),t.last_indices||(t.last_indices=[0]),t.first_indices.length!==t.last_indices.length)throw new b.RuntimeError("BadArguments","Tied notes must have similar index sizes");return this.first_note=t.first_note,this.first_indices=t.first_indices,this.last_note=t.last_note,this.last_indices=t.last_indices,this}},{key:"isPartial",value:function(){return!this.first_note||!this.last_note}},{key:"renderTie",value:function(t){if(0===t.first_ys.length||0===t.last_ys.length)throw new b.RERR("BadArguments","No Y-values to render");var e=this.context,n=this.render_options.cp1,i=this.render_options.cp2;Math.abs(t.last_x_px-t.first_x_px)<10&&(n=2,i=8);for(var o=this.render_options.first_x_shift,r=this.render_options.last_x_shift,s=this.render_options.y_shift*t.direction,a=0;a<this.first_indices.length;++a){var l=(t.last_x_px+r+(t.first_x_px+o))/2,u=t.first_ys[this.first_indices[a]]+s,c=t.last_ys[this.last_indices[a]]+s;if(isNaN(u)||isNaN(c))throw new b.RERR("BadArguments","Bad indices for tie rendering.");var h=(u+c)/2+n*t.direction,f=(u+c)/2+i*t.direction;e.beginPath(),e.moveTo(t.first_x_px+o,u),e.quadraticCurveTo(l,h,t.last_x_px+r,c),e.quadraticCurveTo(l,f,t.first_x_px+o,u),e.closePath(),e.fill()}}},{key:"renderText",value:function(t,e){if(this.text){var n=(t+e)/2;n-=this.context.measureText(this.text).width/2,this.context.save(),this.context.setFont(this.font.family,this.font.size,this.font.style),this.context.fillText(this.text,n+this.render_options.text_shift_x,(this.first_note||this.last_note).getStave().getYForTopText()-1),this.context.restore()}}},{key:"draw",value:function(){this.checkContext(),this.setRendered();var t,e,n,i,o,r=this.first_note,s=this.last_note;return r?(t=r.getTieRightX()+this.render_options.tie_spacing,o=r.getStemDirection(),n=r.getYs()):(t=s.getStave().getTieStartX(),n=s.getYs(),this.first_indices=this.last_indices),s?(e=s.getTieLeftX()+this.render_options.tie_spacing,o=s.getStemDirection(),i=s.getYs()):(e=r.getStave().getTieEndX(),i=r.getYs(),this.last_indices=this.first_indices),this.direction&&(o=this.direction),this.renderTie({first_x_px:t,last_x_px:e,first_ys:n,last_ys:i,direction:o}),this.renderText(t,e),!0}}])&&yn(n.prototype,i),o&&yn(n,o),e}(S);function _n(t){return(_n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function xn(t,e){return!e||"object"!==_n(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function wn(t){return(wn=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function kn(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Sn(t,e,n){return e&&kn(t.prototype,e),n&&kn(t,n),t}function Tn(t,e){return(Tn=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var En=function(t){function e(t,n){var i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=xn(this,wn(e).call(this,t,n))).setAttribute("type","TabTie"),i.render_options.cp1=9,i.render_options.cp2=11,i.render_options.y_shift=3,i.setNotes(t),i}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Tn(t,e)}(e,t),Sn(e,null,[{key:"createHammeron",value:function(t){return new e(t,"H")}},{key:"createPulloff",value:function(t){return new e(t,"P")}}]),Sn(e,[{key:"draw",value:function(){this.checkContext(),this.setRendered();var t,e,n,i,o=this.first_note,r=this.last_note;return o?(t=o.getTieRightX()+this.render_options.tie_spacing,n=o.getYs()):(t=r.getStave().getTieStartX(),n=r.getYs(),this.first_indices=this.last_indices),r?(e=r.getTieLeftX()+this.render_options.tie_spacing,i=r.getYs()):(e=o.getStave().getTieEndX(),i=o.getYs(),this.last_indices=this.first_indices),this.renderTie({first_x_px:t,last_x_px:e,first_ys:n,last_ys:i,direction:-1}),this.renderText(t,e),!0}}]),e}(mn);function On(t){return(On="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Rn(t,e){return!e||"object"!==On(e)&&"function"!=typeof e?Cn(t):e}function Pn(t){return(Pn=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Cn(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function Nn(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function An(t,e,n){return e&&Nn(t.prototype,e),n&&Nn(t,n),t}function Ln(t,e){return(Ln=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Mn=function(t){function e(t,n){var i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=Rn(this,Pn(e).call(this))).setAttribute("type","GraceNoteGroup"),i.note=null,i.index=null,i.position=_e.Position.LEFT,i.grace_notes=t,i.width=0,i.preFormatted=!1,i.show_slur=n,i.slur=null,i.formatter=new eo,i.voice=new At({num_beats:4,beat_value:4,resolution:G.RESOLUTION}).setStrict(!1),i.render_options={slur_y_shift:0},i.beams=[],i.voice.addTickables(i.grace_notes),Rn(i,Cn(i))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Ln(t,e)}(e,t),An(e,null,[{key:"format",value:function(t,e){if(!t||0===t.length)return!1;for(var n=[],i=null,o=0,r=0;r<t.length;++r){var s=t[r],a=s.getNote(),l=a.getCategory()===je.CATEGORY,u=l?4:0;if(l&&a!==i){for(var c=0;c<a.keys.length;++c){o=a.getKeyProps()[c].displaced?a.getExtraLeftPx():o}i=a}n.push({shift:o,gracenote_group:s,spacing:u})}for(var h,b=n[0].shift,f=0;f<n.length;++f){var p=n[f].gracenote_group;p.preFormat(),h=p.getWidth()+n[f].spacing,b=Math.max(h,b)}for(var y=0;y<n.length;++y){var d=n[y].gracenote_group;h=d.getWidth()+n[y].spacing,d.setSpacingFromNextModifier(b-Math.min(h,b))}return e.left_shift+=b,!0}},{key:"CATEGORY",get:function(){return"gracenotegroups"}}]),An(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"preFormat",value:function(){this.preFormatted||(this.formatter.joinVoices([this.voice]).format([this.voice],0),this.setWidth(this.formatter.getMinTotalWidth()),this.preFormatted=!0)}},{key:"beamNotes",value:function(t){if((t=t||this.grace_notes).length>1){var e=new Tt(t);e.render_options.beam_width=3,e.render_options.partial_beam_length=4,this.beams.push(e)}return this}},{key:"setNote",value:function(t){this.note=t}},{key:"setWidth",value:function(t){this.width=t}},{key:"getWidth",value:function(){return this.width}},{key:"getGraceNotes",value:function(){return this.grace_notes}},{key:"draw",value:function(){var t=this;this.checkContext();var e=this.getNote();if(function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];Mn.DEBUG&&b.L("Vex.Flow.GraceNoteGroup",e)}("Drawing grace note group for:",e),!e||null===this.index)throw new b.RuntimeError("NoAttachedNote","Can't draw grace note without a parent note and parent note index.");if(this.setRendered(),this.alignSubNotesWithNote(this.getGraceNotes(),e),this.grace_notes.forEach((function(e){e.setContext(t.context).draw()})),this.beams.forEach((function(e){e.setContext(t.context).draw()})),this.show_slur){var n=this.getNote().getCategory()===je.CATEGORY,i=n?mn:En;this.slur=new i({last_note:this.grace_notes[0],first_note:e,first_indices:[0],last_indices:[0]}),this.slur.render_options.cp2=12,this.slur.render_options.y_shift=(n?7:5)+this.render_options.slur_y_shift,this.slur.setContext(this.context).draw()}}}]),e}(_e);function Fn(t){return(Fn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Bn(t,e){return!e||"object"!==Fn(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function jn(t){return(jn=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Dn(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function In(t,e,n){return e&&Dn(t.prototype,e),n&&Dn(t,n),t}function Gn(t,e){return(Gn=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Yn=function(t){function e(t,n){var i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=Bn(this,jn(e).call(this))).setAttribute("type","Stroke"),i.note=null,i.options=b.Merge({},n),i.all_voices=!("all_voices"in i.options)||i.options.all_voices,i.note_end=null,i.index=null,i.type=t,i.position=_e.Position.LEFT,i.render_options={font_scale:38,stroke_px:3,stroke_spacing:10},i.font={family:"serif",size:10,weight:"bold italic"},i.setXShift(0),i.setWidth(10),i}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Gn(t,e)}(e,t),In(e,null,[{key:"format",value:function(t,e){var n=e.left_shift;if(!t||0===t.length)return this;var i=t.map((function(t){var e=t.getNote();if(e instanceof je){var n=e.getKeyProps()[t.getIndex()];return{line:n.line,shift:n.displaced?e.getExtraLeftPx():0,stroke:t}}return{line:e.getPositions()[t.getIndex()].str,shift:0,stroke:t}})),o=n,r=i.reduce((function(t,e){var n=e.stroke,i=e.shift;return n.setXShift(o+i),Math.max(n.getWidth()+0,t)}),0);return e.left_shift+=r,!0}},{key:"CATEGORY",get:function(){return"strokes"}},{key:"Type",get:function(){return{BRUSH_DOWN:1,BRUSH_UP:2,ROLL_DOWN:3,ROLL_UP:4,RASQUEDO_DOWN:5,RASQUEDO_UP:6,ARPEGGIO_DIRECTIONLESS:7}}}]),In(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"getPosition",value:function(){return this.position}},{key:"addEndNote",value:function(t){return this.note_end=t,this}},{key:"draw",value:function(){if(this.checkContext(),this.setRendered(),!this.note||null==this.index)throw new b.RERR("NoAttachedNote","Can't draw stroke without a note and index.");for(var t,n,i,o,r,s=this.note.getModifierStartXY(this.position,this.index),a=this.note.getYs(),l=s.y,u=s.y,c=s.x-5,h=this.note.stave.options.spacing_between_lines_px,f=this.getModifierContext().getModifiers(this.note.getCategory()),p=0;p<f.length;p++){a=f[p].getYs();for(var y=0;y<a.length;y++)(this.note===f[p]||this.all_voices)&&(l=b.Min(l,a[y]),u=b.Max(u,a[y]))}switch(this.type){case e.Type.BRUSH_DOWN:t="vc3",n=-3,i=l-h/2+10,u+=h/2;break;case e.Type.BRUSH_UP:t="v11",n=.5,i=u+h/2,l-=h/2;break;case e.Type.ROLL_DOWN:case e.Type.RASQUEDO_DOWN:t="vc3",n=-3,o=this.x_shift+n-2,this.note instanceof je?(i=(l+=1.5*h)-h,r=(u+=(u-l)%2!=0?.5*h:h)+h+2):(i=(l+=1.5*h)-.75*h,r=(u+=h)+.25*h);break;case e.Type.ROLL_UP:case e.Type.RASQUEDO_UP:t="v52",n=-4,o=this.x_shift+n-1,this.note instanceof je?(i=h/2,(u-(l+=.5*h))%2==0&&(u+=h/2),i=u+.5*h,r=l-1.25*h):(i=(u+=.5*h)+.25*h,r=(l+=.25*h)-h);break;case e.Type.ARPEGGIO_DIRECTIONLESS:l+=.5*h,u+=h;break;default:throw new b.RERR("InvalidType","The stroke type ".concat(this.type," does not exist"))}if(this.type===e.Type.BRUSH_DOWN||this.type===e.Type.BRUSH_UP)this.context.fillRect(c+this.x_shift,l,1,u-l);else if(this.note instanceof je)for(var d=l;d<=u;d+=h)D.renderGlyph(this.context,c+this.x_shift-4,d,this.render_options.font_scale,"va3");else{var v;for(v=l;v<=u;v+=10)D.renderGlyph(this.context,c+this.x_shift-4,v,this.render_options.font_scale,"va3");this.type===e.Type.RASQUEDO_DOWN&&(r=v+.25*h)}this.type!==e.Type.ARPEGGIO_DIRECTIONLESS&&(D.renderGlyph(this.context,c+this.x_shift+n,i,this.render_options.font_scale,t),this.type!==e.Type.RASQUEDO_DOWN&&this.type!==e.Type.RASQUEDO_UP||(this.context.save(),this.context.setFont(this.font.family,this.font.size,this.font.weight),this.context.fillText("R",c+o,r),this.context.restore()))}}]),e}(_e);function Wn(t){return(Wn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Xn(t,e){return!e||"object"!==Wn(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Hn(t){return(Hn=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Un(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Vn(t,e,n){return e&&Un(t.prototype,e),n&&Un(t,n),t}function zn(t,e){return(zn=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Kn=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Xn(this,Hn(e).call(this))).setAttribute("type","StringNumber"),n.note=null,n.last_note=null,n.index=null,n.string_number=t,n.setWidth(20),n.position=_e.Position.ABOVE,n.x_shift=0,n.y_shift=0,n.x_offset=0,n.y_offset=0,n.dashed=!0,n.leg=$.LineEndType.NONE,n.radius=8,n.font={family:"sans-serif",size:10,weight:"bold"},n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&zn(t,e)}(e,t),Vn(e,null,[{key:"format",value:function(t,e){var n=e.left_shift,i=e.right_shift;if(!t||0===t.length)return this;var o,r,s,a,l,u=[],c=null,h=0,b=0;for(o=0;o<t.length;++o)for(s=(r=t[o]).getNote(),o=0;o<t.length;++o){s=(r=t[o]).getNote(),a=r.getPosition();var f=s.getKeyProps()[r.getIndex()];if(s!==c){for(var p=0;p<s.keys.length;++p)l=s.getKeyProps()[p],0===n&&(h=l.displaced?s.getExtraLeftPx():h),0===i&&(b=l.displaced?s.getExtraRightPx():b);c=s}u.push({pos:a,note:s,num:r,line:f.line,shiftL:h,shiftR:b})}u.sort((function(t,e){return e.line-t.line}));var y=0,d=0,v=0,g=null,m=null;for(o=0;o<u.length;++o){var _=0;s=u[o].note,a=u[o].pos,r=u[o].num;var x=u[o].line,w=u[o].shiftL,k=u[o].shiftR;x===g&&s===m||(n+w,y=i+k);var S=r.getWidth()+1;a===_e.Position.LEFT?(r.setXShift(n),d=(_=h+S)>d?_:d):a===_e.Position.RIGHT&&(r.setXShift(y),v=(_+=S)>v?_:v),g=x,m=s}return e.left_shift+=d,e.right_shift+=v,!0}},{key:"CATEGORY",get:function(){return"stringnumber"}}]),Vn(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"getNote",value:function(){return this.note}},{key:"setNote",value:function(t){return this.note=t,this}},{key:"getIndex",value:function(){return this.index}},{key:"setIndex",value:function(t){return this.index=t,this}},{key:"setLineEndType",value:function(t){return t>=$.LineEndType.NONE&&t<=$.LineEndType.DOWN&&(this.leg=t),this}},{key:"setStringNumber",value:function(t){return this.string_number=t,this}},{key:"setOffsetX",value:function(t){return this.x_offset=t,this}},{key:"setOffsetY",value:function(t){return this.y_offset=t,this}},{key:"setLastNote",value:function(t){return this.last_note=t,this}},{key:"setDashed",value:function(t){return this.dashed=t,this}},{key:"draw",value:function(){var t=this.checkContext();if(!this.note||null==this.index)throw new b.RERR("NoAttachedNote","Can't draw string number without a note and index.");this.setRendered();var e=this.note.stave.options.spacing_between_lines_px,n=this.note.getModifierStartXY(this.position,this.index),i=n.x+this.x_shift+this.x_offset,o=n.y+this.y_shift+this.y_offset;switch(this.position){case _e.Position.ABOVE:case _e.Position.BELOW:var r=this.note.getStemExtents(),s=r.topY,a=r.baseY+2;this.note.stem_direction===je.STEM_DOWN&&(s=r.baseY,a=r.topY-2),o=this.position===_e.Position.ABOVE?this.note.hasStem()?s-1.75*e:n.y-1.75*e:this.note.hasStem()?a+1.5*e:n.y+1.75*e,o+=this.y_shift+this.y_offset;break;case _e.Position.LEFT:i-=this.radius/2+5;break;case _e.Position.RIGHT:i+=this.radius/2+6;break;default:throw new b.RERR("InvalidPosition","The position ".concat(this.position," is invalid"))}t.save(),t.beginPath(),t.arc(i,o,this.radius,0,2*Math.PI,!1),t.lineWidth=1.5,t.stroke(),t.setFont(this.font.family,this.font.size,this.font.weight);var l=i-t.measureText(this.string_number).width/2;if(t.fillText(""+this.string_number,l,o+4.5),null!=this.last_note){var u,c,h=this.last_note.getStemX()-this.note.getX()+5;switch(t.strokeStyle="#000000",t.lineCap="round",t.lineWidth=.6,this.dashed?$.drawDashedLine(t,i+10,o,i+h,o,[3,3]):$.drawDashedLine(t,i+10,o,i+h,o,[3,0]),this.leg){case $.LineEndType.UP:u=-10,c=this.dashed?[3,3]:[3,0],$.drawDashedLine(t,i+h,o,i+h,o+u,c);break;case $.LineEndType.DOWN:u=10,c=this.dashed?[3,3]:[3,0],$.drawDashedLine(t,i+h,o,i+h,o+u,c)}}t.restore()}}]),e}(_e);function Jn(t){return(Jn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function qn(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function Qn(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=[],i=!0,o=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(i=(s=a.next()).done)&&(n.push(s.value),!e||n.length!==e);i=!0);}catch(t){o=!0,r=t}finally{try{i||null==a.return||a.return()}finally{if(o)throw r}}return n}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function Zn(t,e){return!e||"object"!==Jn(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function $n(t){return($n=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ti(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function ei(t,e,n){return e&&ti(t.prototype,e),n&&ti(t,n),t}function ni(t,e){return(ni=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function ii(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var oi=_e.Position,ri=oi.ABOVE,si=oi.BELOW,ai=function(t,e){return.5*t(e/.5)},li=function(t,e){return e===ri?t<=5:t>=1},ui=function(t,e){return li(t,e)?e===ri?Math.ceil:Math.floor:Math.round},ci=function(t){var e=t.getCategory();return"stavenotes"===e||"gracenotes"===e},hi=function(t){function e(t){var n;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Zn(this,$n(e).call(this))).setAttribute("type","Articulation"),n.note=null,n.index=null,n.type=t,n.position=si,n.render_options={font_scale:38},n.articulation=G.articulationCodes(n.type),!n.articulation)throw new b.RERR("ArgumentError","Articulation not found: ".concat(n.type));return n.glyph=new D(n.articulation.code,n.render_options.font_scale),n.setWidth(n.glyph.getMetrics().width),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ni(t,e)}(e,t),ei(e,null,[{key:"format",value:function(t,e){if(!t||0===t.length)return!1;var n=function(t,e,n){return ai(ui(e,n),t.glyph.getMetrics().height/10+.5)};t.filter((function(t){return t.getPosition()===ri})).forEach((function(t){t.setTextLine(e.top_text_line),e.top_text_line+=n(t,e.top_text_line,ri)})),t.filter((function(t){return t.getPosition()===si})).forEach((function(t){t.setTextLine(e.text_line),e.text_line+=n(t,e.text_line,si)}));var i=t.map((function(t){return t.getWidth()})).reduce((function(t,e){return Math.max(e,t)}));return e.left_shift+=i/2,e.right_shift+=i/2,!0}},{key:"easyScoreHook",value:function(t,e,n){var i=t.articulations;if(i){var o={staccato:"a.",tenuto:"a-"};i.split(",").map((function(t){return t.trim().split(".")})).map((function(t){var e=Qn(t,2),i=e[0],r=e[1],s={type:o[i]};return r&&(s.position=_e.PositionString[r]),n.getFactory().Articulation(s)})).map((function(t){return e.addModifier(0,t)}))}}},{key:"CATEGORY",get:function(){return"articulations"}},{key:"INITIAL_OFFSET",get:function(){return-.5}}]),ei(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"draw",value:function(){var t,n=this.note,i=this.index,o=this.position,r=this.glyph,s=this.articulation.between_lines,a=this.text_line,l=this.context;if(this.checkContext(),!n||null==i)throw new b.RERR("NoAttachedNote","Can't draw Articulation without a note and index.");this.setRendered();var u=n.getStave(),c=u.getSpacingBetweenLines(),h="tabnotes"===n.getCategory(),f=n.getModifierStartXY(o,i).x,p=!s||h,y=function(t,e){var n=e===ri&&t.getStemDirection()===at.UP||e===si&&t.getStemDirection()===at.DOWN;return ci(t)?t.hasStem()&&n?.5:1:t.hasStem()&&n?1:0}(n,o),d=(t={},qn(t,ri,(function(){r.setOrigin(.5,1);var t=function(t,e){var n=t.getStave(),i=t.getStemDirection(),o=t.getStemExtents(),r=o.topY,s=o.baseY;if(ci(t))return t.hasStem()?i===at.UP?r:s:Math.min.apply(Math,ii(t.getYs()));if("tabnotes"===t.getCategory())return t.hasStem()&&i===at.UP?r:n.getYForTopText(e);throw new b.RERR("UnknownCategory","Only can get the top and bottom ys of stavenotes and tabnotes")}(n,a)-(a+y)*c;return p?Math.min(u.getYForTopText(e.INITIAL_OFFSET),t):t})),qn(t,si,(function(){r.setOrigin(.5,0);var t=function(t,e){var n=t.getStave(),i=t.getStemDirection(),o=t.getStemExtents(),r=o.topY,s=o.baseY;if(ci(t))return t.hasStem()?i===at.UP?s:r:Math.max.apply(Math,ii(t.getYs()));if("tabnotes"===t.getCategory())return t.hasStem()?i===at.UP?n.getYForBottomText(e):r:n.getYForBottomText(e);throw new b.RERR("UnknownCategory","Only can get the top and bottom ys of stavenotes and tabnotes")}(n,a)+(a+y)*c;return p?Math.max(u.getYForBottomText(e.INITIAL_OFFSET),t):t})),t)[o]();if(!h){var v=o===ri?-1:1,g=h?n.positions[i].str:n.getKeyProps()[i].line,m=(n.getYs()[i]-d)/c+g,_=function(t,e,n,i){var o=ai(ui(e,n),e);if(t&&li(o,n)&&o%1==0){return o+.5*-i}return o}(s,m,o,v);li(_,o)&&r.setOrigin(.5,.5),d+=Math.abs(_-m)*c*v}!function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];hi.DEBUG&&b.L("Vex.Flow.Articulation",e)}("Rendering articulation at (x: ".concat(f,", y: ").concat(d,")")),r.render(l,f,d)}}]),e}(_e);function bi(t){return(bi="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function fi(t,e){return!e||"object"!==bi(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function pi(t){return(pi=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function yi(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function di(t,e,n){return e&&yi(t.prototype,e),n&&yi(t,n),t}function vi(t,e){return(vi=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var gi=function(t){function e(){var t;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(t=fi(this,pi(e).call(this))).setAttribute("type","TickContext"),t.currentTick=new y(0,1),t.maxTicks=new y(0,1),t.minTicks=null,t.padding=3,t.x=0,t.xBase=0,t.xOffset=0,t.tickables=[],t.notePx=0,t.extraLeftPx=0,t.extraRightPx=0,t.tContexts=[],t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&vi(t,e)}(e,t),di(e,null,[{key:"getNextContext",value:function(t){var e=t.tContexts,n=e.indexOf(t);return e[n+1]}}]),di(e,[{key:"getX",value:function(){return this.x}},{key:"setX",value:function(t){return this.x=t,this.xBase=t,this.xOffset=0,this}},{key:"getXBase",value:function(){return this.xBase}},{key:"setXBase",value:function(t){this.xBase=t,this.x=t+this.xOffset}},{key:"getXOffset",value:function(){return this.xOffset}},{key:"setXOffset",value:function(t){this.xOffset=t,this.x=this.xBase+t}},{key:"getWidth",value:function(){return this.width+2*this.padding}},{key:"setPadding",value:function(t){return this.padding=t,this}},{key:"getMaxTicks",value:function(){return this.maxTicks}},{key:"getMinTicks",value:function(){return this.minTicks}},{key:"getTickables",value:function(){return this.tickables}},{key:"getCenterAlignedTickables",value:function(){return this.tickables.filter((function(t){return t.isCenterAligned()}))}},{key:"getMetrics",value:function(){return{width:this.width,notePx:this.notePx,extraLeftPx:this.extraLeftPx,extraRightPx:this.extraRightPx}}},{key:"getCurrentTick",value:function(){return this.currentTick}},{key:"setCurrentTick",value:function(t){this.currentTick=t,this.preFormatted=!1}},{key:"getExtraPx",value:function(){for(var t=0,e=0,n=0,i=0,o=0;o<this.tickables.length;o++){n=Math.max(this.tickables[o].extraLeftPx||0,n),i=Math.max(this.tickables[o].extraRightPx||0,i);var r=this.tickables[o].modifierContext;r&&null!=r&&(t=Math.max(t,r.state.left_shift),e=Math.max(e,r.state.right_shift))}return{left:t,right:e,extraLeft:n,extraRight:i}}},{key:"addTickable",value:function(t){if(!t)throw new b.RERR("BadArgument","Invalid tickable added.");if(!t.shouldIgnoreTicks()){this.ignore_ticks=!1;var e=t.getTicks();e.greaterThan(this.maxTicks)&&(this.maxTicks=e.clone()),null==this.minTicks?this.minTicks=e.clone():e.lessThan(this.minTicks)&&(this.minTicks=e.clone())}return t.setTickContext(this),this.tickables.push(t),this.preFormatted=!1,this}},{key:"preFormat",value:function(){if(this.preFormatted)return this;for(var t=0;t<this.tickables.length;++t){var e=this.tickables[t];e.preFormat();var n=e.getMetrics();this.extraLeftPx=Math.max(this.extraLeftPx,n.extraLeftPx+n.modLeftPx),this.extraRightPx=Math.max(this.extraRightPx,n.extraRightPx+n.modRightPx),this.notePx=Math.max(this.notePx,n.noteWidth),this.width=this.notePx+this.extraLeftPx+this.extraRightPx}return this}},{key:"postFormat",value:function(){return this.postFormatted?this:(this.postFormatted=!0,this)}}]),e}(Vt);function mi(t){return(mi="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function _i(t,e){return!e||"object"!==mi(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function xi(t){return(xi=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function wi(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function ki(t,e,n){return e&&wi(t.prototype,e),n&&wi(t,n),t}function Si(t,e){return(Si=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Ti=function(t){function e(t){var n;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=_i(this,xi(e).call(this))).setAttribute("type","Ornament"),n.note=null,n.index=null,n.type=t,n.position=_e.Position.ABOVE,n.delayed=!1,n.accidentalUpper=null,n.accidentalLower=null,n.render_options={font_scale:38,accidentalLowerPadding:3,accidentalUpperPadding:3},n.ornament=G.ornamentCodes(n.type),!n.ornament)throw new b.RERR("ArgumentError","Ornament not found: '".concat(n.type,"'"));return n.glyph=new D(n.ornament.code,n.render_options.font_scale),n.glyph.setOrigin(.5,1),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Si(t,e)}(e,t),ki(e,null,[{key:"format",value:function(t,e){if(!t||0===t.length)return!1;for(var n=0,i=0;i<t.length;++i){var o=t[i];n=Math.max(o.getWidth(),n),o.getPosition()===_e.Position.ABOVE?(o.setTextLine(e.top_text_line),e.top_text_line+=2):(o.setTextLine(e.text_line),e.text_line+=2)}return e.left_shift+=n/2,e.right_shift+=n/2,!0}},{key:"CATEGORY",get:function(){return"ornaments"}}]),ki(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setDelayed",value:function(t){return this.delayed=t,this}},{key:"setUpperAccidental",value:function(t){var e=this.render_options.font_scale/1.3;return this.accidentalUpper=new D(G.accidentalCodes(t).code,e),this.accidentalUpper.setOrigin(.5,1),this}},{key:"setLowerAccidental",value:function(t){var e=this.render_options.font_scale/1.3;return this.accidentalLower=new D(G.accidentalCodes(t).code,e),this.accidentalLower.setOrigin(.5,1),this}},{key:"draw",value:function(){if(this.checkContext(),!this.note||null==this.index)throw new b.RERR("NoAttachedNote","Can't draw Ornament without a note and index.");this.setRendered();var t=this.context,e=this.note.getStemDirection(),n=this.note.getStave(),i=this.note.getStem().getExtents(),o=e===je.STEM_DOWN?i.baseY:i.topY;"tabnotes"===this.note.getCategory()&&(this.note.hasStem()?e===je.STEM_DOWN&&(o=n.getYForTopText(this.text_line)):o=n.getYForTopText(this.text_line));var r=e===je.STEM_DOWN,s=n.getSpacingBetweenLines(),a=1;!r&&this.note.beam&&(a+=.5);var l=o-s*(this.text_line+a),u=this.note.getModifierStartXY(this.position,this.index).x,c=Math.min(n.getYForTopText(this.text_line),l);if(c+=this.y_shift,this.delayed){var h=0;if(void 0!==this.delayXShift)h=this.delayXShift;else{h+=this.glyph.getMetrics().width/2;var f=gi.getNextContext(this.note.getTickContext());h+=f?.5*(f.getX()-u):.5*(n.x+n.width-u),this.delayXShift=h}u+=h}!function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];Ti.DEBUG&&b.L("Vex.Flow.Ornament",e)}("Rendering ornament: ",this.ornament,u,c),this.accidentalLower&&(this.accidentalLower.render(t,u,c),c-=this.accidentalLower.getMetrics().height,c-=this.render_options.accidentalLowerPadding),this.glyph.render(t,u,c),c-=this.glyph.getMetrics().height,this.accidentalUpper&&(c-=this.render_options.accidentalUpperPadding,this.accidentalUpper.render(t,u,c))}}]),e}(_e);function Ei(t){return(Ei="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Oi(t,e){return!e||"object"!==Ei(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Ri(t){return(Ri=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Pi(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Ci(t,e,n){return e&&Pi(t.prototype,e),n&&Pi(t,n),t}function Ni(t,e){return(Ni=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Ai=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Oi(this,Ri(e).call(this))).setAttribute("type","Annotation"),n.note=null,n.index=null,n.text=t,n.justification=e.Justify.CENTER,n.vert_justification=e.VerticalJustify.TOP,n.font={family:"Arial",size:10,weight:""},n.setWidth(G.textWidth(t)),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Ni(t,e)}(e,t),Ci(e,null,[{key:"format",value:function(t,e){if(!t||0===t.length)return!1;for(var n=0,i=0;i<t.length;++i){var o=t[i];n=Math.max(o.getWidth(),n),o.getPosition()===_e.Position.ABOVE?(o.setTextLine(e.top_text_line),e.top_text_line++):(o.setTextLine(e.text_line),e.text_line++)}return e.left_shift+=n/2,e.right_shift+=n/2,!0}},{key:"CATEGORY",get:function(){return"annotations"}},{key:"Justify",get:function(){return{LEFT:1,CENTER:2,RIGHT:3,CENTER_STEM:4}}},{key:"JustifyString",get:function(){return{left:e.Justify.LEFT,right:e.Justify.RIGHT,center:e.Justify.CENTER,centerStem:e.Justify.CENTER_STEM}}},{key:"VerticalJustify",get:function(){return{TOP:1,CENTER:2,BOTTOM:3,CENTER_STEM:4}}},{key:"VerticalJustifyString",get:function(){return{above:e.VerticalJustify.TOP,top:e.VerticalJustify.TOP,below:e.VerticalJustify.BOTTOM,bottom:e.VerticalJustify.BOTTOM,center:e.VerticalJustify.CENTER,centerStem:e.VerticalJustify.CENTER_STEM}}}]),Ci(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setFont",value:function(t,e,n){return this.font={family:t,size:e,weight:n},this}},{key:"setVerticalJustification",value:function(t){return this.vert_justification="string"==typeof t?e.VerticalJustifyString[t]:t,this}},{key:"getJustification",value:function(){return this.justification}},{key:"setJustification",value:function(t){return this.justification="string"==typeof t?e.JustifyString[t]:t,this}},{key:"draw",value:function(){if(this.checkContext(),!this.note)throw new b.RERR("NoNoteForAnnotation","Can't draw text annotation without an attached note.");this.setRendered();var t=this.note.getModifierStartXY(_e.Position.ABOVE,this.index);this.context.save(),this.context.setFont(this.font.family,this.font.size,this.font.weight);var n,i,o,r,s=this.context.measureText(this.text).width,a=this.context.measureText("m").width;n=this.justification===e.Justify.LEFT?t.x:this.justification===e.Justify.RIGHT?t.x-s:this.justification===e.Justify.CENTER?t.x-s/2:this.note.getStemX()-s/2;var l=this.note.hasStem(),u=this.note.getStave();if(l&&(o=this.note.getStem().getExtents(),r=u.getSpacingBetweenLines()),this.vert_justification===e.VerticalJustify.BOTTOM){if(i=u.getYForBottomText(this.text_line+G.TEXT_HEIGHT_OFFSET_HACK),l){var c=1===this.note.getStemDirection()?o.baseY:o.topY;i=Math.max(i,c+r*(this.text_line+2))}}else if(this.vert_justification===e.VerticalJustify.CENTER){var h=this.note.getYForTopText(this.text_line)-1;i=h+(u.getYForBottomText(this.text_line)-h)/2+a/2}else if(this.vert_justification===e.VerticalJustify.TOP)i=Math.min(u.getYForTopText(this.text_line),this.note.getYs()[0]-10),l&&(i=Math.min(i,o.topY-5-r*this.text_line));else{var f=this.note.getStemExtents();i=f.topY+(f.baseY-f.topY)/2+a/2}!function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];Ai.DEBUG&&b.L("Vex.Flow.Annotation",e)}("Rendering annotation: ",this.text,n,i),this.context.fillText(this.text,n,i),this.context.restore()}}]),e}(_e);function Li(t){return(Li="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Mi(t,e){return!e||"object"!==Li(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Fi(t){return(Fi=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Bi(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function ji(t,e,n){return e&&Bi(t.prototype,e),n&&Bi(t,n),t}function Di(t,e){return(Di=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Ii=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=Mi(this,Fi(e).call(this))).setAttribute("type","Bend"),o.text=t,o.x_shift=0,o.release=n||!1,o.font="10pt Arial",o.render_options={line_width:1.5,line_style:"#777777",bend_width:8,release_width:8},i?o.phrase=i:(o.phrase=[{type:e.UP,text:o.text}],o.release&&o.phrase.push({type:e.DOWN,text:""})),o.updateWidth(),o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Di(t,e)}(e,t),ji(e,null,[{key:"format",value:function(t,e){if(!t||0===t.length)return!1;for(var n=0,i=e.top_text_line,o=0;o<t.length;++o){var r=t[o];r.setXShift(n),n=r.getWidth(),r.setTextLine(i)}return e.right_shift+=n,e.top_text_line+=1,!0}},{key:"CATEGORY",get:function(){return"bends"}},{key:"UP",get:function(){return 0}},{key:"DOWN",get:function(){return 1}}]),ji(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setXShift",value:function(t){this.x_shift=t,this.updateWidth()}},{key:"setFont",value:function(t){return this.font=t,this}},{key:"getText",value:function(){return this.text}},{key:"updateWidth",value:function(){var t=this;for(var n,i=0,o=0;o<this.phrase.length;++o){var r=this.phrase[o];if("width"in r)i+=r.width;else{var s=r.type===e.UP?this.render_options.bend_width:this.render_options.release_width;r.width=b.Max(s,(n=r.text,t.context?t.context.measureText(n).width:G.textWidth(n)))+3,r.draw_width=r.width/2,i+=r.width}}return this.setWidth(i+this.x_shift),this}},{key:"draw",value:function(){if(this.checkContext(),!this.note||null==this.index)throw new b.RERR("NoNoteForBend","Can't draw bend without a note or index.");this.setRendered();var t=this.note.getModifierStartXY(_e.Position.RIGHT,this.index);t.x+=3,t.y+=.5;var n=this.x_shift,i=this.context,o=this.note.getStave().getYForTopText(this.text_line)+3,r=this.note.getStave().getYForTopText(this.text_line)-1,s=this;function a(t,e,n,o){i.save(),i.beginPath(),i.setLineWidth(s.render_options.line_width),i.setStrokeStyle(s.render_options.line_style),i.setFillStyle(s.render_options.line_style),i.moveTo(t,o),i.quadraticCurveTo(t+n,o,t+n,e),i.stroke(),i.restore()}function l(t,e,n){var o=n||1;i.beginPath(),i.moveTo(t,e),i.lineTo(t-4,e+4*o),i.lineTo(t+4,e+4*o),i.closePath(),i.fill()}function u(t,e){i.save(),i.setRawFont(s.font);var n=t-i.measureText(e).width/2;i.fillText(e,n,r),i.restore()}for(var c,h,f,p,y,d,v=null,g=0,m=0;m<this.phrase.length;++m){var _=this.phrase[m];0===m&&(_.draw_width+=n),g=_.draw_width+(v?v.draw_width:0)-(1===m?n:0),_.type===e.UP&&(v&&v.type===e.UP&&l(t.x,o),c=t.x,h=t.y,p=o,y=void 0,d=void 0,y=c+(f=g),d=h,i.save(),i.beginPath(),i.setLineWidth(s.render_options.line_width),i.setStrokeStyle(s.render_options.line_style),i.setFillStyle(s.render_options.line_style),i.moveTo(c,h),i.quadraticCurveTo(y,d,c+f,p),i.stroke(),i.restore()),_.type===e.DOWN&&(v&&v.type===e.UP&&a(t.x,t.y,g,o),v&&v.type===e.DOWN&&(l(t.x,t.y,-1),a(t.x,t.y,g,o)),null===v&&(g=_.draw_width,a(t.x,t.y,g,o))),u(t.x+g,_.text),(v=_).x=t.x,t.x+=g}v.type===e.UP?l(v.x+g,o):v.type===e.DOWN&&l(v.x+g,t.y,-1)}}]),e}(_e);function Gi(t){return(Gi="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Yi(t,e){return!e||"object"!==Gi(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Wi(t){return(Wi=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Xi(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Hi(t,e,n){return e&&Xi(t.prototype,e),n&&Xi(t,n),t}function Ui(t,e){return(Ui=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Vi=function(t){function e(){var t;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(t=Yi(this,Wi(e).call(this))).setAttribute("type","Vibrato"),t.position=_e.Position.RIGHT,t.render_options={harsh:!1,vibrato_width:20,wave_height:6,wave_width:4,wave_girth:2},t.setVibratoWidth(t.render_options.vibrato_width),t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Ui(t,e)}(e,t),Hi(e,null,[{key:"format",value:function(t,e,n){if(!t||0===t.length)return!1;var i=e.top_text_line,o=0,r=e.right_shift-7,s=n.getModifiers(Ii.CATEGORY);s&&s.length>0&&i--;for(var a=0;a<t.length;++a){var l=t[a];l.setXShift(r),l.setTextLine(i),r+=o+=l.getWidth()}return e.right_shift+=o,e.top_text_line+=1,!0}},{key:"CATEGORY",get:function(){return"vibratos"}}]),Hi(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setHarsh",value:function(t){return this.render_options.harsh=t,this}},{key:"setVibratoWidth",value:function(t){return this.render_options.vibrato_width=t,this.setWidth(t),this}},{key:"draw",value:function(){var t=this.checkContext();if(!this.note)throw new b.RERR("NoNoteForVibrato","Can't draw vibrato without an attached note.");this.setRendered();var n=this.note.getModifierStartXY(_e.Position.RIGHT,this.index).x+this.x_shift,i=this.note.getYForTopText(this.text_line)+2;e.renderVibrato(t,n,i,this.render_options)}}],[{key:"renderVibrato",value:function(t,e,n,i){var o,r=i.harsh,s=i.vibrato_width,a=i.wave_width,l=i.wave_girth,u=i.wave_height,c=s/a;if(t.beginPath(),r){for(t.moveTo(e,n+l+1),o=0;o<c/2;++o)t.lineTo(e+a,n-u/2),e+=a,t.lineTo(e+a,n+u/2),e+=a;for(o=0;o<c/2;++o)t.lineTo(e-a,n-u/2+l+1),e-=a,t.lineTo(e-a,n+u/2+l+1),e-=a;t.fill()}else{for(t.moveTo(e,n+l),o=0;o<c/2;++o)t.quadraticCurveTo(e+a/2,n-u/2,e+a,n),e+=a,t.quadraticCurveTo(e+a/2,n+u/2,e+a,n),e+=a;for(o=0;o<c/2;++o)t.quadraticCurveTo(e-a/2,n+u/2+l,e-a,n+l),e-=a,t.quadraticCurveTo(e-a/2,n-u/2+l,e-a,n+l),e-=a;t.fill()}}}]),e}(_e);function zi(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Ki(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];Ji.DEBUG&&b.L("Vex.Flow.ModifierContext",e)}var Ji=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.modifiers={},this.preFormatted=!1,this.postFormatted=!1,this.width=0,this.spacing=0,this.state={left_shift:0,right_shift:0,text_line:0,top_text_line:0},this.PREFORMAT=[je,Oe,He,rn,Yn,Mn,fn,Kn,hi,Ti,Ai,Ii,Vi],this.POSTFORMAT=[je]}var e,n,i;return e=t,(n=[{key:"addModifier",value:function(t){var e=t.getCategory();return this.modifiers[e]||(this.modifiers[e]=[]),this.modifiers[e].push(t),t.setModifierContext(this),this.preFormatted=!1,this}},{key:"getModifiers",value:function(t){return this.modifiers[t]}},{key:"getWidth",value:function(){return this.width}},{key:"getExtraLeftPx",value:function(){return this.state.left_shift}},{key:"getExtraRightPx",value:function(){return this.state.right_shift}},{key:"getState",value:function(){return this.state}},{key:"getMetrics",value:function(){if(!this.formatted)throw new b.RERR("UnformattedModifier","Unformatted modifier has no metrics.");return{width:this.state.left_shift+this.state.right_shift+this.spacing,spacing:this.spacing,extra_left_px:this.state.left_shift,extra_right_px:this.state.right_shift}}},{key:"preFormat",value:function(){var t=this;this.preFormatted||(this.PREFORMAT.forEach((function(e){Ki("Preformatting ModifierContext: ",e.CATEGORY),e.format(t.getModifiers(e.CATEGORY),t.state,t)})),this.width=this.state.left_shift+this.state.right_shift,this.preFormatted=!0)}},{key:"postFormat",value:function(){var t=this;this.postFormatted||this.POSTFORMAT.forEach((function(e){Ki("Postformatting ModifierContext: ",e.CATEGORY),e.postFormat(t.getModifiers(e.CATEGORY),t)}))}}])&&zi(e.prototype,n),i&&zi(e,i),t}();function qi(t){return(qi="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Qi(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Zi(t,e,n){return e&&Qi(t.prototype,e),n&&Qi(t,n),t}function $i(t,e,n,i){var o=e;for(n+=1;n<t.length;n+=1){var r=t[n];if(!r.isRest()&&!r.shouldIgnoreTicks()){o=r.getLineForRest();break}}if(i&&e!==o){var s=Math.max(e,o),a=Math.min(e,o);o=b.MidLine(s,a)}return o}function to(t,e,n){if(!t||!t.length)throw new b.RERR("BadArgument","No voices to format");var i=t[0].getTotalTicks(),o=t.reduce((function(t,e){if(!e.getTotalTicks().equals(i))throw new b.RERR("TickMismatch","Voices should have same total note duration in ticks.");if(e.getMode()===At.Mode.STRICT&&!e.isComplete())throw new b.RERR("IncompleteVoice","Voice does not have enough notes.");return Math.max(t,y.LCM(t,e.getResolutionMultiplier()))}),1),r={},s=[],a=[];return t.forEach((function(t){var i=new y(0,o);t.getTickables().forEach((function(t){var o=i.numerator;if(!r[o]){var l=new e;a.push(l),r[o]=l}n(t,r[o]),s.push(o),i.add(t.getTicks())}))})),{map:r,array:a,list:b.SortAndUnique(s,(function(t,e){return t-e}),(function(t,e){return t===e})),resolutionMultiplier:o}}var eo=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.minTotalWidth=0,this.hasMinTotalWidth=!1,this.totalTicks=new y(0,1),this.tickContexts=null,this.modiferContexts=null,this.contextGaps={total:0,gaps:[]},this.voices=[]}return Zi(t,null,[{key:"SimpleFormat",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},i=n.paddingBetween,o=void 0===i?10:i;t.reduce((function(t,e){e.addToModifierContext(new Ji);var n=(new gi).addTickable(e).preFormat(),i=n.getExtraPx();return n.setX(t+i.left),t+n.getWidth()+i.right+o}),e)}},{key:"plotDebugging",value:function(t,e,n,i,o){var r=n+$t.STAVEPADDING,s=e.contextGaps;t.save(),t.setFont("Arial",8,""),s.gaps.forEach((function(e){var n,s,a;n=r+e.x1,s=r+e.x2,a="#aaa",t.beginPath(),t.setStrokeStyle(a),t.setFillStyle(a),t.setLineWidth(1),t.fillRect(n,i,s-n,o-i),t.fillText(Math.round(e.x2-e.x1),r+e.x1,o+12)})),t.fillText(Math.round(s.total)+"px",r-20,o+12),t.setFillStyle("red"),t.fillText("Loss: "+e.lossHistory.map((function(t){return Math.round(t)})),r-20,o+22),t.restore()}},{key:"FormatAndDraw",value:function(e,n,i,o){var r={auto_beam:!1,align_rests:!1};"object"===qi(o)?b.Merge(r,o):"boolean"==typeof o&&(r.auto_beam=o);var s=new At(G.TIME4_4).setMode(At.Mode.SOFT).addTickables(i),a=r.auto_beam?Tt.applyAndGetBeams(s):[];return(new t).joinVoices([s],{align_rests:r.align_rests}).formatToStave([s],n,{align_rests:r.align_rests,stave:n}),s.setStave(n).draw(e,n),a.forEach((function(t){return t.setContext(e).draw()})),s.getBoundingBox()}},{key:"FormatAndDrawTab",value:function(e,n,i,o,r,s,a){var l={auto_beam:s,align_rests:!1};"object"===qi(a)?b.Merge(l,a):"boolean"==typeof a&&(l.auto_beam=a);var u=new At(G.TIME4_4).setMode(At.Mode.SOFT).addTickables(r),c=new At(G.TIME4_4).setMode(At.Mode.SOFT).addTickables(o),h=l.auto_beam?Tt.applyAndGetBeams(u):[];(new t).joinVoices([u],{align_rests:l.align_rests}).joinVoices([c]).formatToStave([u,c],i,{align_rests:l.align_rests}),u.draw(e,i),c.draw(e,n),h.forEach((function(t){return t.setContext(e).draw()})),new Gt(i,n).setContext(e).draw()}},{key:"AlignRestsToNotes",value:function(t,e,n){return t.forEach((function(i,o){if(i instanceof je&&i.isRest()){if(i.tuplet&&!n)return;var r=i.getGlyph().position.toUpperCase();if("R/4"!==r&&"B/4"!==r)return;if(e||null!=i.beam){var s=i.getKeyProps()[0];if(0===o)s.line=$i(t,s.line,o,!1),i.setKeyLine(0,s.line);else if(o>0&&o<t.length){var a;t[o-1].isRest()?(a=t[o-1].getKeyProps()[0].line,s.line=a):(a=t[o-1].getLineForRest(),s.line=$i(t,a,o,!0)),i.setKeyLine(0,s.line)}}}})),this}}]),Zi(t,[{key:"alignRests",value:function(e,n){if(!e||!e.length)throw new b.RERR("BadArgument","No voices to format rests");e.forEach((function(e){return t.AlignRestsToNotes(e.getTickables(),n)}))}},{key:"preCalculateMinTotalWidth",value:function(t){if(this.hasMinTotalWidth)return this.minTotalWidth;if(!this.tickContexts){if(!t)throw new b.RERR("BadArgument","'voices' required to run preCalculateMinTotalWidth");this.createTickContexts(t)}var e=this.tickContexts,n=e.list,i=e.map;return this.minTotalWidth=n.map((function(t){var e=i[t];return e.preFormat(),e.getWidth()})).reduce((function(t,e){return t+e}),0),this.hasMinTotalWidth=!0,this.minTotalWidth}},{key:"getMinTotalWidth",value:function(){if(!this.hasMinTotalWidth)throw new b.RERR("NoMinTotalWidth","Call 'preCalculateMinTotalWidth' or 'preFormat' before calling 'getMinTotalWidth'");return this.minTotalWidth}},{key:"createModifierContexts",value:function(t){var e=to(t,Ji,(function(t,e){return t.addToModifierContext(e)}));return this.modiferContexts=e,e}},{key:"createTickContexts",value:function(t){var e=to(t,gi,(function(t,e){return e.addTickable(t)}));return e.array.forEach((function(t){t.tContexts=e.array})),this.totalTicks=t[0].getTicksUsed().clone(),this.tickContexts=e,e}},{key:"preFormat",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1?arguments[1]:void 0,i=arguments.length>2?arguments[2]:void 0,o=arguments.length>3?arguments[3]:void 0,r=this.tickContexts,s=r.list,a=r.map,l=r.resolutionMultiplier;i&&o&&i.forEach((function(t){return t.setStave(o).preFormat()}));var u=0,c=0,h=e/2;if(this.minTotalWidth=0,s.forEach((function(e){var i=a[e];n&&i.setContext(n),i.preFormat();var o=i.getWidth();t.minTotalWidth+=o;var r=i.getMetrics();u=u+c+r.extraLeftPx,i.setX(u),c=o-r.extraLeftPx})),this.minTotalWidth=u+c,this.hasMinTotalWidth=!0,!(e<=0)){var b=e-this.minTotalWidth,f=b/(this.totalTicks.value()*l),p=0;s.forEach((function(t,e){var n=s[e-1]||0,i=a[t];p+=(t-n)*f,i.setX(i.getX()+p),i.getCenterAlignedTickables().forEach((function(t){t.center_x_shift=h-i.getX()}))})),1!==s.length&&(this.justifyWidth=e,this.lossHistory=[],this.evaluate())}}},{key:"evaluate",value:function(){var t=this,e=this.justifyWidth;this.contextGaps={total:0,gaps:[]},this.tickContexts.list.forEach((function(e,n){if(0!==n){var i=t.tickContexts.list[n-1],o=t.tickContexts.map[i],r=t.tickContexts.map[e],s=o.getMetrics(),a=o.getX()+s.width,l=r.getX(),u=l-a;t.contextGaps.total+=u,t.contextGaps.gaps.push({x1:a,x2:l}),r.getFormatterMetrics().freedom.left=u,o.getFormatterMetrics().freedom.right=u}}));var n=this.durationStats={};this.voices.forEach((function(t){t.getTickables().forEach((function(t,i,o){var r=t.getTicks().clone().simplify().toString(),s=t.getMetrics(),a=t.getFormatterMetrics(),l=t.getX()+s.noteWidth+s.modRightPx+s.extraRightPx,u=0;if(i<o.length-1){var c=o[i+1],h=c.getMetrics();u=c.getX()-h.modLeftPx-h.extraLeftPx-l,a.space.used=c.getX()-t.getX(),c.getFormatterMetrics().freedom.left=u}else u=e-l,a.space.used=e-t.getX();a.freedom.right=u,function(t,e){var i=n[t];void 0===i?n[t]={mean:e,count:1}:(i.count+=1,i.mean=(i.mean+e)/2)}(r,a.space.used)}))}));var i=0;return this.voices.forEach((function(t){t.getTickables().forEach((function(t){var e=t.getTicks().clone().simplify().toString(),o=t.getFormatterMetrics();o.iterations+=1,o.space.deviation=o.space.used-n[e].mean,o.duration=e,o.space.mean=n[e].mean,i+=Math.pow(n[e].mean,2)}))})),this.totalCost=Math.sqrt(i),this.lossHistory.push(this.totalCost),this}},{key:"tune",value:function(){var t=this;var e=0;return this.tickContexts.list.forEach((function(n,i,o){var r=t.tickContexts.map[n],s=i>0?t.tickContexts.map[o[i-1]]:null,a=i<o.length-1?t.tickContexts.map[o[i+1]]:null;!function(t,e,n,i){t.setX(t.getX()+i),t.getFormatterMetrics().freedom.left+=i,t.getFormatterMetrics().freedom.right-=i,e&&(e.getFormatterMetrics().freedom.right+=i),n&&(n.getFormatterMetrics().freedom.left-=i)}(r,s,a,e);var l=-r.getTickables().map((function(t){return t.getFormatterMetrics().space.deviation})).reduce((function(t,e){return t+e}));l>0?e=-Math.min(r.getFormatterMetrics().freedom.right,Math.abs(l)):l<0&&(e=a?Math.min(a.getFormatterMetrics().freedom.right,Math.abs(l)):0);var u=Math.min(5,Math.abs(e));e=e>0?u:-u})),this.evaluate()}},{key:"postFormat",value:function(){var t=function(t){return t.list.forEach((function(e){return t.map[e].postFormat()}))};return t(this.modiferContexts),t(this.tickContexts),this}},{key:"joinVoices",value:function(t){return this.createModifierContexts(t),this.hasMinTotalWidth=!1,this}},{key:"format",value:function(t,e,n){var i={align_rests:!1,context:null,stave:null};return b.Merge(i,n),this.voices=t,this.alignRests(t,i.align_rests),this.createTickContexts(t),this.preFormat(e,i.context,t,i.stave),i.stave&&this.postFormat(),this}},{key:"formatToStave",value:function(t,e,n){var i=e.getNoteEndX()-e.getNoteStartX()-10;!function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];eo.DEBUG&&b.L("Vex.Flow.Formatter",e)}("Formatting voices to width: ",i);var o={context:e.getContext()};return b.Merge(o,n),this.format(t,i,o)}}]),t}();function no(t){return(no="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function io(t,e){return!e||"object"!==no(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function oo(t){return(oo=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ro(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function so(t,e,n){return e&&ro(t.prototype,e),n&&ro(t,n),t}function ao(t,e){return(ao=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var lo=function(t){function e(){var t;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(t=io(this,oo(e).call(this))).setAttribute("type","StaveModifier"),t.padding=10,t.position=e.Position.ABOVE,t.layoutMetrics=null,t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ao(t,e)}(e,t),so(e,null,[{key:"Position",get:function(){return{LEFT:1,RIGHT:2,ABOVE:3,BELOW:4,BEGIN:5,END:6}}}]),so(e,[{key:"getPosition",value:function(){return this.position}},{key:"setPosition",value:function(t){return this.position=t,this}},{key:"getStave",value:function(){return this.stave}},{key:"setStave",value:function(t){return this.stave=t,this}},{key:"getWidth",value:function(){return this.width}},{key:"setWidth",value:function(t){return this.width=t,this}},{key:"getX",value:function(){return this.x}},{key:"setX",value:function(t){return this.x=t,this}},{key:"getCategory",value:function(){return""}},{key:"makeSpacer",value:function(t){return{getContext:function(){return!0},setStave:function(){},renderToStave:function(){},getMetrics:function(){return{width:t}}}}},{key:"placeGlyphOnLine",value:function(t,e,n){t.setYShift(e.getYForLine(n)-e.getYForGlyphs())}},{key:"getPadding",value:function(t){return void 0!==t&&t<2?0:this.padding}},{key:"setPadding",value:function(t){return this.padding=t,this}},{key:"setLayoutMetrics",value:function(t){return this.layoutMetrics=t,this}},{key:"getLayoutMetrics",value:function(){return this.layoutMetrics}}]),e}(S);function uo(t){return(uo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function co(t,e){return!e||"object"!==uo(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function ho(t){return(ho=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function bo(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function fo(t,e,n){return e&&bo(t.prototype,e),n&&bo(t,n),t}function po(t,e){return(po=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var yo=function(t){function e(t){var n;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=co(this,ho(e).call(this))).setAttribute("type","Barline"),n.thickness=G.STAVE_LINE_THICKNESS;var i=e.type;return n.widths={},n.widths[i.SINGLE]=5,n.widths[i.DOUBLE]=5,n.widths[i.END]=5,n.widths[i.REPEAT_BEGIN]=5,n.widths[i.REPEAT_END]=5,n.widths[i.REPEAT_BOTH]=5,n.widths[i.NONE]=5,n.paddings={},n.paddings[i.SINGLE]=0,n.paddings[i.DOUBLE]=0,n.paddings[i.END]=0,n.paddings[i.REPEAT_BEGIN]=15,n.paddings[i.REPEAT_END]=15,n.paddings[i.REPEAT_BOTH]=15,n.paddings[i.NONE]=0,n.layoutMetricsMap={},n.layoutMetricsMap[i.SINGLE]={xMin:0,xMax:1,paddingLeft:5,paddingRight:5},n.layoutMetricsMap[i.DOUBLE]={xMin:-3,xMax:1,paddingLeft:5,paddingRight:5},n.layoutMetricsMap[i.END]={xMin:-5,xMax:1,paddingLeft:5,paddingRight:5},n.layoutMetricsMap[i.REPEAT_END]={xMin:-10,xMax:1,paddingLeft:5,paddingRight:5},n.layoutMetricsMap[i.REPEAT_BEGIN]={xMin:-2,xMax:10,paddingLeft:5,paddingRight:5},n.layoutMetricsMap[i.REPEAT_BOTH]={xMin:-10,xMax:10,paddingLeft:5,paddingRight:5},n.layoutMetricsMap[i.NONE]={xMin:0,xMax:0,paddingLeft:5,paddingRight:5},n.setPosition(lo.Position.BEGIN),n.setType(t),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&po(t,e)}(e,t),fo(e,null,[{key:"CATEGORY",get:function(){return"barlines"}},{key:"type",get:function(){return{SINGLE:1,DOUBLE:2,END:3,REPEAT_BEGIN:4,REPEAT_END:5,REPEAT_BOTH:6,NONE:7}}},{key:"typeString",get:function(){return{single:e.type.SINGLE,double:e.type.DOUBLE,end:e.type.END,repeatBegin:e.type.REPEAT_BEGIN,repeatEnd:e.type.REPEAT_END,repeatBoth:e.type.REPEAT_BOTH,none:e.type.NONE}}}]),fo(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"getType",value:function(){return this.type}},{key:"setType",value:function(t){return this.type="string"==typeof t?e.typeString[t]:t,this.setWidth(this.widths[this.type]),this.setPadding(this.paddings[this.type]),this.setLayoutMetrics(this.layoutMetricsMap[this.type]),this}},{key:"draw",value:function(t){switch(t.checkContext(),this.setRendered(),this.type){case e.type.SINGLE:this.drawVerticalBar(t,this.x,!1);break;case e.type.DOUBLE:this.drawVerticalBar(t,this.x,!0);break;case e.type.END:this.drawVerticalEndBar(t,this.x);break;case e.type.REPEAT_BEGIN:this.drawRepeatBar(t,this.x,!0),t.getX()!==this.x&&this.drawVerticalBar(t,t.getX());break;case e.type.REPEAT_END:this.drawRepeatBar(t,this.x,!1);break;case e.type.REPEAT_BOTH:this.drawRepeatBar(t,this.x,!1),this.drawRepeatBar(t,this.x,!0)}}},{key:"drawVerticalBar",value:function(t,e,n){t.checkContext();var i=t.getTopLineTopY(),o=t.getBottomLineBottomY();n&&t.context.fillRect(e-3,i,1,o-i),t.context.fillRect(e,i,1,o-i)}},{key:"drawVerticalEndBar",value:function(t,e){t.checkContext();var n=t.getTopLineTopY(),i=t.getBottomLineBottomY();t.context.fillRect(e-5,n,1,i-n),t.context.fillRect(e-2,n,3,i-n)}},{key:"drawRepeatBar",value:function(t,e,n){t.checkContext();var i=t.getTopLineTopY(),o=t.getBottomLineBottomY(),r=3;n||(r=-5),t.context.fillRect(e+r,i,1,o-i),t.context.fillRect(e-2,i,3,o-i);n?r+=4:r-=4;var s=e+r+1,a=(t.getNumLines()-1)*t.getSpacingBetweenLines(),l=i+(a=a/2-t.getSpacingBetweenLines()/2)+1;t.context.beginPath(),t.context.arc(s,l,2,0,2*Math.PI,!1),t.context.fill(),l+=t.getSpacingBetweenLines(),t.context.beginPath(),t.context.arc(s,l,2,0,2*Math.PI,!1),t.context.fill()}}]),e}(lo);function vo(t){return(vo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function go(t,e){return!e||"object"!==vo(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function mo(t){return(mo=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function _o(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function xo(t,e,n){return e&&_o(t.prototype,e),n&&_o(t,n),t}function wo(t,e){return(wo=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var ko=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=go(this,mo(e).call(this))).setAttribute("type","Repetition"),o.symbol_type=t,o.x=n,o.x_shift=0,o.y_shift=i,o.font={family:"times",size:12,weight:"bold italic"},o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&wo(t,e)}(e,t),xo(e,null,[{key:"CATEGORY",get:function(){return"repetitions"}},{key:"type",get:function(){return{NONE:1,CODA_LEFT:2,CODA_RIGHT:3,SEGNO_LEFT:4,SEGNO_RIGHT:5,DC:6,DC_AL_CODA:7,DC_AL_FINE:8,DS:9,DS_AL_CODA:10,DS_AL_FINE:11,FINE:12}}}]),xo(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setShiftX",value:function(t){return this.x_shift=t,this}},{key:"setShiftY",value:function(t){return this.y_shift=t,this}},{key:"draw",value:function(t,n){switch(this.setRendered(),this.symbol_type){case e.type.CODA_RIGHT:this.drawCodaFixed(t,n+t.width);break;case e.type.CODA_LEFT:this.drawSymbolText(t,n,"Coda",!0);break;case e.type.SEGNO_LEFT:this.drawSignoFixed(t,n);break;case e.type.SEGNO_RIGHT:this.drawSignoFixed(t,n+t.width);break;case e.type.DC:this.drawSymbolText(t,n,"D.C.",!1);break;case e.type.DC_AL_CODA:this.drawSymbolText(t,n,"D.C. al",!0);break;case e.type.DC_AL_FINE:this.drawSymbolText(t,n,"D.C. al Fine",!1);break;case e.type.DS:this.drawSymbolText(t,n,"D.S.",!1);break;case e.type.DS_AL_CODA:this.drawSymbolText(t,n,"D.S. al",!0);break;case e.type.DS_AL_FINE:this.drawSymbolText(t,n,"D.S. al Fine",!1);break;case e.type.FINE:this.drawSymbolText(t,n,"Fine",!1)}return this}},{key:"drawCodaFixed",value:function(t,e){var n=t.getYForTopText(t.options.num_lines)+this.y_shift;return D.renderGlyph(t.context,this.x+e+this.x_shift,n+25,40,"v4d",!0),this}},{key:"drawSignoFixed",value:function(t,e){var n=t.getYForTopText(t.options.num_lines)+this.y_shift;return D.renderGlyph(t.context,this.x+e+this.x_shift,n+25,30,"v8c",!0),this}},{key:"drawSymbolText",value:function(t,n,i,o){var r=t.checkContext();r.save(),r.setFont(this.font.family,this.font.size,this.font.weight);var s=0+this.x_shift,a=n+this.x_shift;this.symbol_type===e.type.CODA_LEFT?a=(s=this.x+t.options.vertical_bar_width)+r.measureText(i).width+12:s=(a=this.x+n+t.width-5+this.x_shift)-+r.measureText(i).width-12;var l=t.getYForTopText(t.options.num_lines)+this.y_shift;return o&&D.renderGlyph(r,a,l,40,"v4d",!0),r.fillText(i,s,l+5),r.restore(),this}}]),e}(lo);function So(t){return(So="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function To(t,e){return!e||"object"!==So(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Eo(t){return(Eo=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Oo(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Ro(t,e,n){return e&&Oo(t.prototype,e),n&&Oo(t,n),t}function Po(t,e){return(Po=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Co=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=To(this,Eo(e).call(this))).setAttribute("type","StaveSection"),o.setWidth(16),o.section=t,o.x=n,o.shift_x=0,o.shift_y=i,o.font={family:"sans-serif",size:12,weight:"bold"},o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Po(t,e)}(e,t),Ro(e,null,[{key:"CATEGORY",get:function(){return"stavesection"}}]),Ro(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setStaveSection",value:function(t){return this.section=t,this}},{key:"setShiftX",value:function(t){return this.shift_x=t,this}},{key:"setShiftY",value:function(t){return this.shift_y=t,this}},{key:"draw",value:function(t,e){var n=t.checkContext();this.setRendered(),n.save(),n.lineWidth=2,n.setFont(this.font.family,this.font.size,this.font.weight);var i=n.measureText(""+this.section).width,o=i+6;o<18&&(o=18);var r=t.getYForTopText(3)+this.shift_y,s=this.x+e;return n.beginPath(),n.lineWidth=2,n.rect(s,r,o,20),n.stroke(),s+=(o-i)/2,n.fillText(""+this.section,s,r+16),n.restore(),this}}]),e}(lo);function No(t){return(No="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ao(t,e){return!e||"object"!==No(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Lo(t){return(Lo=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Mo(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Fo(t,e,n){return e&&Mo(t.prototype,e),n&&Mo(t,n),t}function Bo(t,e){return(Bo=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var jo=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=Ao(this,Lo(e).call(this))).setAttribute("type","StaveTempo"),o.tempo=t,o.position=_e.Position.ABOVE,o.x=n,o.shift_x=10,o.shift_y=i,o.font={family:"times",size:14,weight:"bold"},o.render_options={glyph_font_scale:30},o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Bo(t,e)}(e,t),Fo(e,null,[{key:"CATEGORY",get:function(){return"stavetempo"}}]),Fo(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setTempo",value:function(t){return this.tempo=t,this}},{key:"setShiftX",value:function(t){return this.shift_x=t,this}},{key:"setShiftY",value:function(t){return this.shift_y=t,this}},{key:"draw",value:function(t,e){var n=t.checkContext();this.setRendered();var i=this.render_options,o=i.glyph_font_scale/38,r=this.tempo.name,s=this.tempo.duration,a=this.tempo.dots,l=this.tempo.bpm,u=this.font,c=this.x+this.shift_x+e,h=t.getYForTopText(1)+this.shift_y;if(n.save(),r&&(n.setFont(u.family,u.size,u.weight),n.fillText(r,c,h),c+=n.measureText(r).width),s&&l){n.setFont(u.family,u.size,"normal"),r&&(c+=n.measureText(" ").width,n.fillText("(",c,h),c+=n.measureText("(").width);var b=G.durationToGlyph(s);if(c+=3*o,D.renderGlyph(n,c,h,i.glyph_font_scale,b.code_head),c+=b.getWidth()*o,b.stem){var f=30;b.beam_count&&(f+=3*(b.beam_count-1));var p=h-(f*=o);n.fillRect(c-o,p,o,f),b.flag&&(D.renderGlyph(n,c,p,i.glyph_font_scale,b.code_flag_upstem),a||(c+=6*o))}for(var y=0;y<a;y++)c+=6*o,n.beginPath(),n.arc(c,h+2*o,2*o,0,2*Math.PI,!1),n.fill();n.fillText(" = "+l+(r?")":""),c+3*o,h)}return n.restore(),this}}]),e}(lo);function Do(t){return(Do="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Io(t,e){return!e||"object"!==Do(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Go(t){return(Go=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Yo(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Wo(t,e,n){return e&&Yo(t.prototype,e),n&&Yo(t,n),t}function Xo(t,e){return(Xo=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Ho=function(t){function e(t){var n;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Io(this,Go(e).call(this,t))).setAttribute("type","TextNote"),n.text=t.text,n.superscript=t.superscript,n.subscript=t.subscript,n.glyph_type=t.glyph,n.glyph=null,n.font={family:"Arial",size:12,weight:""},t.font&&(n.font=t.font),n.glyph_type){var i=e.GLYPHS[n.glyph_type];if(!i)throw new b.RERR("Invalid glyph type: "+n.glyph_type);n.glyph=new D(i.code,i.point,{cache:!1}),i.width?n.setWidth(i.width):n.setWidth(n.glyph.getMetrics().width),n.glyph_struct=i}else n.setWidth(G.textWidth(n.text));return n.line=t.line||0,n.smooth=t.smooth||!1,n.ignore_ticks=t.ignore_ticks||!1,n.justification=e.Justification.LEFT,n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Xo(t,e)}(e,t),Wo(e,null,[{key:"Justification",get:function(){return{LEFT:1,CENTER:2,RIGHT:3}}},{key:"GLYPHS",get:function(){return{segno:{code:"v8c",point:40,x_shift:0,y_shift:-10},tr:{code:"v1f",point:40,x_shift:0,y_shift:0},mordent_upper:{code:"v1e",point:40,x_shift:0,y_shift:0},mordent_lower:{code:"v45",point:40,x_shift:0,y_shift:0},f:{code:"vba",point:40,x_shift:0,y_shift:0},p:{code:"vbf",point:40,x_shift:0,y_shift:0},m:{code:"v62",point:40,x_shift:0,y_shift:0},s:{code:"v4a",point:40,x_shift:0,y_shift:0},z:{code:"v80",point:40,x_shift:0,y_shift:0},coda:{code:"v4d",point:40,x_shift:0,y_shift:-8},pedal_open:{code:"v36",point:40,x_shift:0,y_shift:0},pedal_close:{code:"v5d",point:40,x_shift:0,y_shift:3},caesura_straight:{code:"v34",point:40,x_shift:0,y_shift:2},caesura_curved:{code:"v4b",point:40,x_shift:0,y_shift:2},breath:{code:"v6c",point:40,x_shift:0,y_shift:0},tick:{code:"v6f",point:50,x_shift:0,y_shift:0},turn:{code:"v72",point:40,x_shift:0,y_shift:0},turn_inverted:{code:"v33",point:40,x_shift:0,y_shift:0},mordent:{code:"v1e",point:40,x_shift:0,y_shift:0}}}}]),Wo(e,[{key:"setJustification",value:function(t){return this.justification=t,this}},{key:"setLine",value:function(t){return this.line=t,this}},{key:"preFormat",value:function(){this.checkContext(),this.preFormatted||(this.smooth?this.setWidth(0):this.glyph||this.setWidth(this.context.measureText(this.text).width),this.justification===e.Justification.CENTER?this.extraLeftPx=this.width/2:this.justification===e.Justification.RIGHT&&(this.extraLeftPx=this.width),this.setPreFormatted(!0))}},{key:"draw",value:function(){if(this.checkContext(),!this.stave)throw new b.RERR("NoStave","Can't draw without a stave.");this.setRendered();var t,n=this.context,i=this.getAbsoluteX();if(this.justification===e.Justification.CENTER?i-=this.getWidth()/2:this.justification===e.Justification.RIGHT&&(i-=this.getWidth()),this.glyph)t=this.stave.getYForLine(this.line+-3),this.glyph.render(this.context,i+this.glyph_struct.x_shift,t+this.glyph_struct.y_shift);else{t=this.stave.getYForLine(this.line+-3),this.applyStyle(n),n.setFont(this.font.family,this.font.size,this.font.weight),n.fillText(this.text,i,t);var o=n.measureText("M").width,r=n.measureText(this.text).width;this.superscript&&(n.setFont(this.font.family,this.font.size/1.3,this.font.weight),n.fillText(this.superscript,i+r+2,t-o/2.2)),this.subscript&&(n.setFont(this.font.family,this.font.size/1.3,this.font.weight),n.fillText(this.subscript,i+r+2,t+o/2.2-1)),this.restoreStyle(n)}}}]),e}($t);function Uo(t){return(Uo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Vo(t,e){return!e||"object"!==Uo(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function zo(t){return(zo=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ko(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Jo(t,e,n){return e&&Ko(t.prototype,e),n&&Ko(t,n),t}function qo(t,e){return(qo=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Qo=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=Vo(this,zo(e).call(this))).setAttribute("type","StaveText"),o.setWidth(16),o.text=t,o.position=n,o.options={shift_x:0,shift_y:0,justification:Ho.Justification.CENTER},b.Merge(o.options,i),o.font={family:"times",size:16,weight:"normal"},o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&qo(t,e)}(e,t),Jo(e,null,[{key:"CATEGORY",get:function(){return"stavetext"}}]),Jo(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setStaveText",value:function(t){return this.text=t,this}},{key:"setShiftX",value:function(t){return this.shift_x=t,this}},{key:"setShiftY",value:function(t){return this.shift_y=t,this}},{key:"setFont",value:function(t){b.Merge(this.font,t)}},{key:"setText",value:function(t){this.text=t}},{key:"draw",value:function(t){var e=t.checkContext();this.setRendered(),e.save(),e.lineWidth=2,e.setFont(this.font.family,this.font.size,this.font.weight);var n,i,o=e.measureText(""+this.text).width,r=lo.Position,s=Ho.Justification;switch(this.position){case r.LEFT:case r.RIGHT:i=(t.getYForLine(0)+t.getBottomLineY())/2+this.options.shift_y,n=this.position===r.LEFT?t.getX()-o-24+this.options.shift_x:t.getX()+t.getWidth()+24+this.options.shift_x;break;case r.ABOVE:case r.BELOW:n=t.getX()+this.options.shift_x,this.options.justification===s.CENTER?n+=t.getWidth()/2-o/2:this.options.justification===s.RIGHT&&(n+=t.getWidth()-o),i=this.position===r.ABOVE?t.getYForTopText(2)+this.options.shift_y:t.getYForBottomText(2)+this.options.shift_y;break;default:throw new b.RERR("InvalidPosition","Value Must be in Modifier.Position.")}return e.fillText(""+this.text,n,i+4),e.restore(),this}}]),e}(lo);function Zo(t){return(Zo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function $o(t,e){return!e||"object"!==Zo(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function tr(t){return(tr=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function er(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function nr(t,e,n){return e&&er(t.prototype,e),n&&er(t,n),t}function ir(t,e){return(ir=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var or=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=$o(this,tr(e).call(this))).setAttribute("type","Clef"),o.setPosition(lo.Position.BEGIN),o.setType(t,n,i),o.setWidth(o.glyph.getMetrics().width),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];or.DEBUG&&b.L("Vex.Flow.Clef",e)}("Creating clef:",t),o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ir(t,e)}(e,t),nr(e,null,[{key:"CATEGORY",get:function(){return"clefs"}},{key:"types",get:function(){return{treble:{code:"v83",line:3},bass:{code:"v79",line:1},alto:{code:"vad",line:2},tenor:{code:"vad",line:1},percussion:{code:"v59",line:2},soprano:{code:"vad",line:4},"mezzo-soprano":{code:"vad",line:3},"baritone-c":{code:"vad",line:0},"baritone-f":{code:"v79",line:2},subbass:{code:"v79",line:0},french:{code:"v83",line:4},tab:{code:"v2f"}}}},{key:"sizes",get:function(){return{default:40,small:32}}},{key:"annotations",get:function(){return{"8va":{code:"v8",sizes:{default:{point:20,attachments:{treble:{line:-1.2,x_shift:11}}},small:{point:18,attachments:{treble:{line:-.4,x_shift:8}}}}},"8vb":{code:"v8",sizes:{default:{point:20,attachments:{treble:{line:6.3,x_shift:10},bass:{line:4,x_shift:1}}},small:{point:18,attachments:{treble:{line:5.8,x_shift:6},bass:{line:3.5,x_shift:.5}}}}}}}}]),nr(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setType",value:function(t,n,i){if(this.type=t,this.clef=e.types[t],this.size=void 0===n?"default":n,this.clef.point=e.sizes[this.size],this.glyph=new D(this.clef.code,this.clef.point),void 0!==i){var o=e.annotations[i];this.annotation={code:o.code,point:o.sizes[this.size].point,line:o.sizes[this.size].attachments[this.type].line,x_shift:o.sizes[this.size].attachments[this.type].x_shift},this.attachment=new D(this.annotation.code,this.annotation.point),this.attachment.metrics.x_max=0,this.attachment.setXShift(this.annotation.x_shift)}else this.annotation=void 0;return this}},{key:"getWidth",value:function(){if("tab"===this.type&&!this.stave)throw new b.RERR("ClefError","Can't get width without stave.");return this.width}},{key:"setStave",value:function(t){if(this.stave=t,"tab"!==this.type)return this;var e,n,i=this.stave.getOptions().num_lines;switch(i){case 8:e=55,n=14;break;case 7:e=47,n=8;break;case 6:e=40,n=1;break;case 5:e=30,n=-6;break;case 4:e=23,n=-12;break;default:throw new b.RERR("ClefError","Invalid number of lines: ".concat(i))}return this.glyph.setPoint(e),this.glyph.setYShift(n),this}},{key:"draw",value:function(){if(!this.x)throw new b.RERR("ClefError","Can't draw clef without x.");if(!this.stave)throw new b.RERR("ClefError","Can't draw clef without stave.");this.setRendered(),this.glyph.setStave(this.stave),this.glyph.setContext(this.stave.context),void 0!==this.clef.line&&this.placeGlyphOnLine(this.glyph,this.stave,this.clef.line),this.glyph.renderToStave(this.x),void 0!==this.annotation&&(this.placeGlyphOnLine(this.attachment,this.stave,this.annotation.line),this.attachment.setStave(this.stave),this.attachment.setContext(this.stave.context),this.attachment.renderToStave(this.x))}}]),e}(lo);function rr(t){return(rr="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function sr(t,e){return!e||"object"!==rr(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function ar(t){return(ar=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function lr(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function ur(t,e,n){return e&&lr(t.prototype,e),n&&lr(t,n),t}function cr(t,e){return(cr=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var hr=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=sr(this,ar(e).call(this))).setAttribute("type","KeySignature"),o.setKeySig(t,n,i),o.setPosition(lo.Position.BEGIN),o.glyphFontScale=38,o.glyphs=[],o.xPositions=[],o.paddingForced=!1,o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&cr(t,e)}(e,t),ur(e,null,[{key:"CATEGORY",get:function(){return"keysignatures"}},{key:"accidentalSpacing",get:function(){return{"#":{above:6,below:4},b:{above:4,below:7},n:{above:4,below:1},"##":{above:6,below:4},bb:{above:4,below:7},db:{above:4,below:7},d:{above:4,below:7},bbs:{above:4,below:7},"++":{above:6,below:4},"+":{above:6,below:4},"+-":{above:6,below:4},"++-":{above:6,below:4},bs:{above:4,below:10},bss:{above:4,below:10}}}}]),ur(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"convertToGlyph",value:function(t,n){var i=G.accidentalCodes(t.type),o=new D(i.code,this.glyphFontScale),r=1;if("n"===t.type&&n){var s=e.accidentalSpacing[n.type];if(s)r=n.line>=t.line?s.above:s.below}this.placeGlyphOnLine(o,this.stave,t.line),this.glyphs.push(o);var a=this.xPositions[this.xPositions.length-1],l=o.getMetrics().width+r;this.xPositions.push(a+l),this.width+=l}},{key:"cancelKey",value:function(t){return this.formatted=!1,this.cancelKeySpec=t,this}},{key:"convertToCancelAccList",value:function(t){var e=G.keySignature(t),n=this.accList.length>0&&e.length>0&&e[0].type!==this.accList[0].type,i=n?e.length:e.length-this.accList.length;if(!(i<1)){for(var o=[],r=0;r<i;r++){var s=r;n||(s=e.length-i+r);var a=e[s];o.push({type:"n",line:a.line})}return this.accList=o.concat(this.accList),{accList:o,type:e[0].type}}}},{key:"addToStave",value:function(t){return this.paddingForced=!0,t.addModifier(this),this}},{key:"convertAccLines",value:function(t,e){var n,i,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.accList,r=0;switch(t){case"soprano":"#"===e?n=[2.5,.5,2,0,1.5,-.5,1]:r=-1;break;case"mezzo-soprano":"b"===e?n=[0,2,.5,2.5,1,3,1.5]:r=1.5;break;case"alto":r=.5;break;case"tenor":"#"===e?n=[3,1,2.5,.5,2,0,1.5]:r=-.5;break;case"baritone-f":case"baritone-c":"b"===e?n=[.5,2.5,1,3,1.5,3.5,2]:r=2;break;case"bass":case"french":r=1}if(void 0!==n)for(i=0;i<o.length;++i)o[i].line=n[i];else if(0!==r)for(i=0;i<o.length;++i)o[i].line+=r}},{key:"getPadding",value:function(t){return this.formatted||this.format(),0===this.glyphs.length||!this.paddingForced&&t<2?0:this.padding}},{key:"getWidth",value:function(){return this.formatted||this.format(),this.width}},{key:"setKeySig",value:function(t,e,n){return this.formatted=!1,this.keySpec=t,this.cancelKeySpec=e,this.alterKeySpec=n,this}},{key:"alterKey",value:function(t){return this.formatted=!1,this.alterKeySpec=t,this}},{key:"convertToAlterAccList",value:function(t){for(var e=Math.min(t.length,this.accList.length),n=0;n<e;++n)t[n]&&(this.accList[n].type=t[n])}},{key:"format",value:function(){if(!this.stave)throw new b.RERR("KeySignatureError","Can't draw key signature without stave.");this.width=0,this.glyphs=[],this.xPositions=[0],this.accList=G.keySignature(this.keySpec);var t,e=this.accList,n=e.length>0?e[0].type:null;if(this.cancelKeySpec&&(t=this.convertToCancelAccList(this.cancelKeySpec)),this.alterKeySpec&&this.convertToAlterAccList(this.alterKeySpec),this.accList.length>0){var i=(this.position===lo.Position.END?this.stave.endClef:this.stave.clef)||this.stave.clef;t&&this.convertAccLines(i,t.type,t.accList),this.convertAccLines(i,n,e);for(var o=0;o<this.accList.length;++o)this.convertToGlyph(this.accList[o],this.accList[o+1])}this.formatted=!0}},{key:"draw",value:function(){if(!this.x)throw new b.RERR("KeySignatureError","Can't draw key signature without x.");if(!this.stave)throw new b.RERR("KeySignatureError","Can't draw key signature without stave.");this.formatted||this.format(),this.setRendered();for(var t=0;t<this.glyphs.length;t++){var e=this.glyphs[t],n=this.x+this.xPositions[t];e.setStave(this.stave),e.setContext(this.stave.context),e.renderToStave(n)}}}]),e}(lo);function br(t){return(br="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function fr(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=[],i=!0,o=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(i=(s=a.next()).done)&&(n.push(s.value),!e||n.length!==e);i=!0);}catch(t){o=!0,r=t}finally{try{i||null==a.return||a.return()}finally{if(o)throw r}}return n}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function pr(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function yr(t,e){return!e||"object"!==br(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function dr(t){return(dr=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function vr(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function gr(t,e,n){return e&&vr(t.prototype,e),n&&vr(t,n),t}function mr(t,e){return(mr=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var _r=function(t){function e(){var t,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:15,o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];if(pr(this,e),(t=yr(this,dr(e).call(this))).setAttribute("type","TimeSignature"),t.validate_args=o,null===n)return yr(t);var r=i;return t.point=40,t.topLine=2,t.bottomLine=4,t.setPosition(lo.Position.BEGIN),t.setTimeSig(n),t.setWidth(t.timeSig.glyph.getMetrics().width),t.setPadding(r),t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&mr(t,e)}(e,t),gr(e,null,[{key:"CATEGORY",get:function(){return"timesignatures"}},{key:"glyphs",get:function(){return{C:{code:"v41",point:40,line:2},"C|":{code:"vb6",point:40,line:2}}}}]),gr(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"parseTimeSpec",value:function(t){if("C"===t||"C|"===t){var n=e.glyphs[t],i=n.line,o=n.code,r=n.point;return{line:i,num:!1,glyph:new D(o,r)}}this.validate_args&&function(t){var e=t.split("/").filter((function(t){return""!==t}));if(2!==e.length)throw new b.RERR("BadTimeSignature","Invalid time spec: ".concat(t,'. Must be in the form "<numerator>/<denominator>"'));e.forEach((function(e){if(isNaN(Number(e)))throw new b.RERR("BadTimeSignature","Invalid time spec: ".concat(t,". Must contain two valid numbers."))}))}(t);var s=fr(t.split("/").map((function(t){return t.split("")})),2),a=s[0],l=s[1];return{num:!0,glyph:this.makeTimeSignatureGlyph(a,l)}}},{key:"makeTimeSignatureGlyph",value:function(t,e){var n=new D("v0",this.point);n.topGlyphs=[],n.botGlyphs=[];for(var i=0,o=0;o<t.length;++o){var r=t[o],s=new D("v"+r,this.point);n.topGlyphs.push(s),i+=s.getMetrics().width}for(var a=0,l=0;l<e.length;++l){var u=e[l],c=new D("v"+u,this.point);n.botGlyphs.push(c),a+=c.getMetrics().width}var h=i>a?i:a,b=n.getMetrics().x_min;n.getMetrics=function(){return{x_min:b,x_max:b+h,width:h}};var f=(h-i)/2,p=(h-a)/2,y=this;return n.renderToStave=function(t){for(var e=t+f,n=0;n<this.topGlyphs.length;++n){var i=this.topGlyphs[n];D.renderOutline(this.context,i.metrics.outline,i.scale,e+i.x_shift,this.stave.getYForLine(y.topLine)+1),e+=i.getMetrics().width}e=t+p;for(var o=0;o<this.botGlyphs.length;++o){var r=this.botGlyphs[o];y.placeGlyphOnLine(r,this.stave,r.line),D.renderOutline(this.context,r.metrics.outline,r.scale,e+r.x_shift,this.stave.getYForLine(y.bottomLine)+1),e+=r.getMetrics().width}},n}},{key:"getTimeSig",value:function(){return this.timeSig}},{key:"setTimeSig",value:function(t){return this.timeSig=this.parseTimeSpec(t),this}},{key:"draw",value:function(){if(!this.x)throw new b.RERR("TimeSignatureError","Can't draw time signature without x.");if(!this.stave)throw new b.RERR("TimeSignatureError","Can't draw time signature without stave.");this.setRendered(),this.timeSig.glyph.setStave(this.stave),this.timeSig.glyph.setContext(this.stave.context),this.placeGlyphOnLine(this.timeSig.glyph,this.stave,this.timeSig.line),this.timeSig.glyph.renderToStave(this.x)}}]),e}(lo);function xr(t){return(xr="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function wr(t,e){return!e||"object"!==xr(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function kr(t){return(kr=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Sr(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Tr(t,e,n){return e&&Sr(t.prototype,e),n&&Sr(t,n),t}function Er(t,e){return(Er=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Or=function(t){function e(t,n,i,o){var r;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(r=wr(this,kr(e).call(this))).setAttribute("type","Volta"),r.volta=t,r.x=i,r.y_shift=o,r.number=n,r.font={family:"sans-serif",size:9,weight:"bold"},r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Er(t,e)}(e,t),Tr(e,null,[{key:"CATEGORY",get:function(){return"voltas"}},{key:"type",get:function(){return{NONE:1,BEGIN:2,MID:3,END:4,BEGIN_END:5}}}]),Tr(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setShiftY",value:function(t){return this.y_shift=t,this}},{key:"draw",value:function(t,n){var i=t.checkContext();this.setRendered();var o=t.width,r=t.getYForTopText(t.options.num_lines)+this.y_shift,s=1.5*t.options.spacing_between_lines_px;switch(this.volta){case e.type.BEGIN:i.fillRect(this.x+n,r,1,s);break;case e.type.END:o-=5,i.fillRect(this.x+n+o,r,1,s);break;case e.type.BEGIN_END:o-=3,i.fillRect(this.x+n,r,1,s),i.fillRect(this.x+n+o,r,1,s)}return this.volta!==e.type.BEGIN&&this.volta!==e.type.BEGIN_END||(i.save(),i.setFont(this.font.family,this.font.size,this.font.weight),i.fillText(this.number,this.x+n+5,r+15),i.restore()),i.fillRect(this.x+n,r,o,1),this}}]),e}(lo);function Rr(t){return(Rr="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pr(){return(Pr=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t}).apply(this,arguments)}function Cr(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Nr(t,e){return!e||"object"!==Rr(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Ar(t){return(Ar=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Lr(t,e){return(Lr=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Mr=function(t){function e(t,n,i,o){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(r=Nr(this,Ar(e).call(this))).setAttribute("type","Stave"),r.x=t,r.y=n,r.width=i,r.formatted=!1,r.start_x=t+5,r.end_x=t+i,r.modifiers=[],r.measure=0,r.clef="treble",r.endClef=void 0,r.font={family:"sans-serif",size:8,weight:""},r.options={vertical_bar_width:10,glyph_spacing_px:10,num_lines:5,fill_style:"#999999",left_bar:!0,right_bar:!0,spacing_between_lines_px:10,space_above_staff_ln:4,space_below_staff_ln:4,top_text_position:1},r.bounds={x:r.x,y:r.y,w:r.width,h:0},b.Merge(r.options,o),r.resetLines();var s=yo.type;return r.addModifier(new yo(r.options.left_bar?s.SINGLE:s.NONE)),r.addEndModifier(new yo(r.options.right_bar?s.SINGLE:s.NONE)),r}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Lr(t,e)}(e,t),n=e,(i=[{key:"space",value:function(t){return this.options.spacing_between_lines_px*t}},{key:"resetLines",value:function(){this.options.line_config=[];for(var t=0;t<this.options.num_lines;t++)this.options.line_config.push({visible:!0});this.height=(this.options.num_lines+this.options.space_above_staff_ln)*this.options.spacing_between_lines_px,this.options.bottom_text_position=this.options.num_lines}},{key:"getOptions",value:function(){return this.options}},{key:"setNoteStartX",value:function(t){if(this.formatted||this.format(),this.start_x=t,this.modifiers.length>0){var e=this.modifiers[0];e.getType()===yo.type.REPEAT_BEGIN&&e.setX(this.start_x-e.getWidth())}return this}},{key:"getNoteStartX",value:function(){return this.formatted||this.format(),this.start_x}},{key:"getNoteEndX",value:function(){return this.formatted||this.format(),this.end_x}},{key:"getTieStartX",value:function(){return this.start_x}},{key:"getTieEndX",value:function(){return this.x+this.width}},{key:"getX",value:function(){return this.x}},{key:"getNumLines",value:function(){return this.options.num_lines}},{key:"setNumLines",value:function(t){return this.options.num_lines=parseInt(t,10),this.resetLines(),this}},{key:"setY",value:function(t){return this.y=t,this}},{key:"getTopLineTopY",value:function(){return this.getYForLine(0)-G.STAVE_LINE_THICKNESS/2}},{key:"getBottomLineBottomY",value:function(){return this.getYForLine(this.getNumLines()-1)+G.STAVE_LINE_THICKNESS/2}},{key:"setX",value:function(t){var e=t-this.x;this.formatted=!1,this.x=t,this.start_x+=e,this.end_x+=e;for(var n=0;n<this.modifiers.length;n++){var i=this.modifiers[n];void 0!==i.x&&(i.x+=e)}return this}},{key:"setWidth",value:function(t){return this.formatted=!1,this.width=t,this.end_x=this.x+t,this}},{key:"getWidth",value:function(){return this.width}},{key:"getStyle",value:function(){return Pr({fillStyle:this.options.fill_style,strokeStyle:this.options.fill_style,lineWidth:G.STAVE_LINE_THICKNESS},this.style||{})}},{key:"setMeasure",value:function(t){return this.measure=t,this}},{key:"getModifierXShift",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;if("number"!=typeof t)throw new b.RERR("InvalidIndex","Must be of number type");if(this.formatted||this.format(),1===this.getModifiers(lo.Position.BEGIN).length)return 0;var e=this.start_x-this.x,n=this.modifiers[0];return n.getType()===yo.type.REPEAT_BEGIN&&e>n.getWidth()&&(e-=n.getWidth()),e}},{key:"setRepetitionTypeLeft",value:function(t,e){return this.modifiers.push(new ko(t,this.x,e)),this}},{key:"setRepetitionTypeRight",value:function(t,e){return this.modifiers.push(new ko(t,this.x,e)),this}},{key:"setVoltaType",value:function(t,e,n){return this.modifiers.push(new Or(t,e,this.x,n)),this}},{key:"setSection",value:function(t,e){return this.modifiers.push(new Co(t,this.x,e)),this}},{key:"setTempo",value:function(t,e){return this.modifiers.push(new jo(t,this.x,e)),this}},{key:"setText",value:function(t,e,n){return this.modifiers.push(new Qo(t,e,n)),this}},{key:"getHeight",value:function(){return this.height}},{key:"getSpacingBetweenLines",value:function(){return this.options.spacing_between_lines_px}},{key:"getBoundingBox",value:function(){return new P(this.x,this.y,this.width,this.getBottomY()-this.y)}},{key:"getBottomY",value:function(){var t=this.options,e=t.spacing_between_lines_px;return this.getYForLine(t.num_lines)+t.space_below_staff_ln*e}},{key:"getBottomLineY",value:function(){return this.getYForLine(this.options.num_lines)}},{key:"getYForLine",value:function(t){var e=this.options,n=e.spacing_between_lines_px,i=e.space_above_staff_ln;return this.y+t*n+i*n}},{key:"getLineForY",value:function(t){var e=this.options,n=e.spacing_between_lines_px,i=e.space_above_staff_ln;return(t-this.y)/n-i}},{key:"getYForTopText",value:function(t){var e=t||0;return this.getYForLine(-e-this.options.top_text_position)}},{key:"getYForBottomText",value:function(t){var e=t||0;return this.getYForLine(this.options.bottom_text_position+e)}},{key:"getYForNote",value:function(t){var e=this.options,n=e.spacing_between_lines_px,i=e.space_above_staff_ln;return this.y+i*n+5*n-t*n}},{key:"getYForGlyphs",value:function(){return this.getYForLine(3)}},{key:"addModifier",value:function(t,e){return void 0!==e&&t.setPosition(e),t.setStave(this),this.formatted=!1,this.modifiers.push(t),this}},{key:"addEndModifier",value:function(t){return this.addModifier(t,lo.Position.END),this}},{key:"setBegBarType",value:function(t){var e=yo.type,n=e.SINGLE,i=e.REPEAT_BEGIN,o=e.NONE;return t!==n&&t!==i&&t!==o||(this.modifiers[0].setType(t),this.formatted=!1),this}},{key:"setEndBarType",value:function(t){return t!==yo.type.REPEAT_BEGIN&&(this.modifiers[1].setType(t),this.formatted=!1),this}},{key:"setClef",value:function(t,e,n,i){void 0===i&&(i=lo.Position.BEGIN),i===lo.Position.END?this.endClef=t:this.clef=t;var o=this.getModifiers(i,or.CATEGORY);return 0===o.length?this.addClef(t,e,n,i):o[0].setType(t,e,n),this}},{key:"setEndClef",value:function(t,e,n){return this.setClef(t,e,n,lo.Position.END),this}},{key:"setKeySignature",value:function(t,e,n){void 0===n&&(n=lo.Position.BEGIN);var i=this.getModifiers(n,hr.CATEGORY);return 0===i.length?this.addKeySignature(t,e,n):i[0].setKeySig(t,e),this}},{key:"setEndKeySignature",value:function(t,e){return this.setKeySignature(t,e,lo.Position.END),this}},{key:"setTimeSignature",value:function(t,e,n){void 0===n&&(n=lo.Position.BEGIN);var i=this.getModifiers(n,_r.CATEGORY);return 0===i.length?this.addTimeSignature(t,e,n):i[0].setTimeSig(t),this}},{key:"setEndTimeSignature",value:function(t,e){return this.setTimeSignature(t,e,lo.Position.END),this}},{key:"addKeySignature",value:function(t,e,n){return void 0===n&&(n=lo.Position.BEGIN),this.addModifier(new hr(t,e).setPosition(n),n),this}},{key:"addClef",value:function(t,e,n,i){return void 0===i||i===lo.Position.BEGIN?this.clef=t:i===lo.Position.END&&(this.endClef=t),this.addModifier(new or(t,e,n),i),this}},{key:"addEndClef",value:function(t,e,n){return this.addClef(t,e,n,lo.Position.END),this}},{key:"addTimeSignature",value:function(t,e,n){return this.addModifier(new _r(t,e),n),this}},{key:"addEndTimeSignature",value:function(t,e){return this.addTimeSignature(t,e,lo.Position.END),this}},{key:"addTrebleGlyph",value:function(){return this.addClef("treble"),this}},{key:"getModifiers",value:function(t,e){return void 0===t&&void 0===e?this.modifiers:this.modifiers.filter((function(n){return!(void 0!==t&&t!==n.getPosition()||void 0!==e&&e!==n.getCategory())}))}},{key:"sortByCategory",value:function(t,e){for(var n=t.length-1;n>=0;n--)for(var i=0;i<n;i++)if(e[t[i].getCategory()]>e[t[i+1].getCategory()]){var o=t[i];t[i]=t[i+1],t[i+1]=o}}},{key:"format",value:function(){var t,e,n,i=this.modifiers[0],o=this.modifiers[1],r=this.getModifiers(lo.Position.BEGIN),s=this.getModifiers(lo.Position.END);this.sortByCategory(r,{barlines:0,clefs:1,keysignatures:2,timesignatures:3}),this.sortByCategory(s,{timesignatures:0,keysignatures:1,barlines:2,clefs:3}),r.length>1&&i.getType()===yo.type.REPEAT_BEGIN&&(r.push(r.splice(0,1)[0]),r.splice(0,0,new yo(yo.type.SINGLE))),s.indexOf(o)>0&&s.splice(0,0,new yo(yo.type.NONE));for(var a=0,l=this.x,u=0;u<r.length;u++)e=(n=r[u]).getPadding(u+a),t=n.getWidth(),l+=e,n.setX(l),l+=t,e+t===0&&a--;this.start_x=l,l=this.x+this.width;for(var c={left:0,right:0,paddingRight:0,paddingLeft:0},h=0,b=0;b<s.length;b++){h="barlines"===(n=s[b]).getCategory()?b:h,c.right=0,c.left=0,c.paddingRight=0,c.paddingLeft=0;var f=n.getLayoutMetrics();f?(0!==b&&(c.right=f.xMax||0,c.paddingRight=f.paddingRight||0),c.left=-f.xMin||0,c.paddingLeft=f.paddingLeft||0,b===s.length-1&&(c.paddingLeft=0)):(c.paddingRight=n.getPadding(b-h),0!==b&&(c.right=n.getWidth()),0===b&&(c.left=n.getWidth())),l-=c.paddingRight,l-=c.right,n.setX(l),l-=c.left,l-=c.paddingLeft}this.end_x=1===s.length?this.x+this.width:l,this.formatted=!0}},{key:"draw",value:function(){this.checkContext(),this.setRendered(),this.formatted||this.format();for(var t,e=this.options.num_lines,n=this.width,i=this.x,o=0;o<e;o++)t=this.getYForLine(o),this.applyStyle(),this.options.line_config[o].visible&&(this.context.beginPath(),this.context.moveTo(i,t),this.context.lineTo(i+n,t),this.context.stroke()),this.restoreStyle();for(var r=0;r<this.modifiers.length;r++)"function"==typeof this.modifiers[r].draw&&(this.modifiers[r].applyStyle(this.context),this.modifiers[r].draw(this,this.getModifierXShift(r)),this.modifiers[r].restoreStyle(this.context));if(this.measure>0){this.context.save(),this.context.setFont(this.font.family,this.font.size,this.font.weight);var s=this.context.measureText(""+this.measure).width;t=this.getYForTopText(0)+3,this.context.fillText(""+this.measure,this.x-s/2,t),this.context.restore()}return this}},{key:"drawVertical",value:function(t,e){this.drawVerticalFixed(this.x+t,e)}},{key:"drawVerticalFixed",value:function(t,e){this.checkContext();var n=this.getYForLine(0),i=this.getYForLine(this.options.num_lines-1);e&&this.context.fillRect(t-3,n,1,i-n+1),this.context.fillRect(t,n,1,i-n+1)}},{key:"drawVerticalBar",value:function(t){this.drawVerticalBarFixed(this.x+t,!1)}},{key:"drawVerticalBarFixed",value:function(t){this.checkContext();var e=this.getYForLine(0),n=this.getYForLine(this.options.num_lines-1);this.context.fillRect(t,e,1,n-e+1)}},{key:"getConfigForLines",value:function(){return this.options.line_config}},{key:"setConfigForLine",value:function(t,e){if(t>=this.options.num_lines||t<0)throw new b.RERR("StaveConfigError","The line number must be within the range of the number of lines in the Stave.");if(void 0===e.visible)throw new b.RERR("StaveConfigError","The line configuration object is missing the 'visible' property.");if("boolean"!=typeof e.visible)throw new b.RERR("StaveConfigError","The line configuration objects 'visible' property must be true or false.");return this.options.line_config[t]=e,this}},{key:"setConfigForLines",value:function(t){if(t.length!==this.options.num_lines)throw new b.RERR("StaveConfigError","The length of the lines configuration array must match the number of lines in the Stave");for(var e in t)t[e]||(t[e]=this.options.line_config[e]),b.Merge(this.options.line_config[e],t[e]);return this.options.line_config=t,this}}])&&Cr(n.prototype,i),o&&Cr(n,o),e}(S);function Fr(t){return(Fr="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Br(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function jr(t,e){return!e||"object"!==Fr(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Dr(t){return(Dr=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ir(t,e){return(Ir=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Gr=function(t){function e(t,n,i,o){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var s={spacing_between_lines_px:13,num_lines:6,top_text_position:1};return b.Merge(s,o),(r=jr(this,Dr(e).call(this,t,n,i,s))).setAttribute("type","TabStave"),r}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Ir(t,e)}(e,t),n=e,(i=[{key:"getYForGlyphs",value:function(){return this.getYForLine(2.5)}},{key:"addTabGlyph",value:function(){return this.addClef("tab"),this}}])&&Br(n.prototype,i),o&&Br(n,o),e}(Mr);function Yr(t){return(Yr="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Wr(t,e){return!e||"object"!==Yr(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Xr(t,e,n){return(Xr="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=Hr(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function Hr(t){return(Hr=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ur(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Vr(t,e,n){return e&&Ur(t.prototype,e),n&&Ur(t,n),t}function zr(t,e){return(zr=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Kr=function(t){function e(t,n){var i;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=Wr(this,Hr(e).call(this,t))).setAttribute("type","TabNote"),i.ghost=!1,i.positions=t.positions,b.Merge(i.render_options,{glyph_font_scale:G.DEFAULT_TABLATURE_FONT_SCALE,draw_stem:n,draw_dots:n,draw_stem_through_stave:!1,y_shift:0,scale:1,font:"10pt Arial"}),i.glyph=G.durationToGlyph(i.duration,i.noteType),!i.glyph)throw new b.RuntimeError("BadArguments","Invalid note initialization data (No glyph found): ".concat(JSON.stringify(t)));return i.buildStem(),t.stem_direction?i.setStemDirection(t.stem_direction):i.setStemDirection(at.UP),i.ghost=!1,i.updateWidth(),i}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&zr(t,e)}(e,t),Vr(e,null,[{key:"CATEGORY",get:function(){return"tabnotes"}}]),Vr(e,[{key:"reset",value:function(){this.stave&&this.setStave(this.stave)}},{key:"getCategory",value:function(){return e.CATEGORY}},{key:"setGhost",value:function(t){return this.ghost=t,this.updateWidth(),this}},{key:"hasStem",value:function(){return this.render_options.draw_stem}},{key:"getStemExtension",value:function(){var t=this.getGlyph();return null!=this.stem_extension_override?this.stem_extension_override:t?1===this.getStemDirection()?t.tabnote_stem_up_extension:t.tabnote_stem_down_extension:0}},{key:"addDot",value:function(){var t=new Oe;return this.dots+=1,this.addModifier(t,0)}},{key:"updateWidth",value:function(){var t=this;this.glyphs=[],this.width=0;for(var e=0;e<this.positions.length;++e){var n=this.positions[e].fret;this.ghost&&(n="("+n+")");var i=G.tabToGlyph(n,this.render_options.scale);this.glyphs.push(i),this.width=Math.max(i.getWidth(),this.width)}this.glyph.getWidth=function(){return t.width}}},{key:"setStave",value:function(t){var n,i=this;if(Xr(Hr(e.prototype),"setStave",this).call(this,t),this.context=t.context,this.context){var o=this.context;this.width=0;var r=function(){var t=i.glyphs[n],e=""+t.text;"X"!==e.toUpperCase()&&(o.save(),o.setRawFont(i.render_options.font),t.width=o.measureText(e).width,o.restore(),t.getWidth=function(){return t.width}),i.width=Math.max(t.getWidth(),i.width)};for(n=0;n<this.glyphs.length;++n)r();this.glyph.getWidth=function(){return i.width}}var s=this.positions.map((function(e){var n=e.str;return t.getYForLine(n-1)}));return this.setYs(s),this.stem&&this.stem.setYBounds(this.getStemY(),this.getStemY()),this}},{key:"getPositions",value:function(){return this.positions}},{key:"addToModifierContext",value:function(t){this.setModifierContext(t);for(var e=0;e<this.modifiers.length;++e)this.modifierContext.addModifier(this.modifiers[e]);return this.modifierContext.addModifier(this),this.preFormatted=!1,this}},{key:"getTieRightX",value:function(){var t=this.getAbsoluteX();return t+=this.glyph.getWidth()/2,t+=-this.width/2+this.width+2}},{key:"getTieLeftX",value:function(){var t=this.getAbsoluteX();return t+=this.glyph.getWidth()/2,t-=this.width/2+2}},{key:"getModifierStartXY",value:function(t,e){if(!this.preFormatted)throw new b.RERR("UnformattedNote","Can't call GetModifierStartXY on an unformatted note");if(0===this.ys.length)throw new b.RERR("NoYValues","No Y-Values calculated for this note.");var n=0;if(t===_e.Position.LEFT)n=-2;else if(t===_e.Position.RIGHT)n=this.width+2;else if(t===_e.Position.BELOW||t===_e.Position.ABOVE){n=this.glyph.getWidth()/2}return{x:this.getAbsoluteX()+n,y:this.ys[e]}}},{key:"getLineForRest",value:function(){return this.positions[0].str}},{key:"preFormat",value:function(){this.preFormatted||(this.modifierContext&&this.modifierContext.preFormat(),this.setPreFormatted(!0))}},{key:"getStemX",value:function(){return this.getCenterGlyphX()}},{key:"getStemY",value:function(){var t=this.stave.getNumLines()-.5,e=at.UP===this.stem_direction?-.5:t;return this.stave.getYForLine(e)}},{key:"getStemExtents",value:function(){return this.stem.getExtents()}},{key:"drawFlag",value:function(){var t=this.beam,e=this.glyph,n=this.context,i=this.stem,o=this.stem_direction,r=this.render_options,s=r.draw_stem,a=r.glyph_font_scale,l=null==t&&s;if(e.flag&&l){var u=this.getStemX()+1,c=this.getStemY()-i.getHeight(),h=o===at.DOWN?e.code_flag_downstem:e.code_flag_upstem;D.renderGlyph(n,u,c,a,h)}}},{key:"drawModifiers",value:function(){var t=this;this.modifiers.forEach((function(e){("dots"!==e.getCategory()||t.render_options.draw_dots)&&(e.setContext(t.context),e.drawWithStyle())}))}},{key:"drawStemThrough",value:function(){var t=this.getStemX(),e=this.getStemY(),n=this.context,i=this.render_options.draw_stem_through_stave;if(this.render_options.draw_stem&&i){var o=function(t,e,n,i){var o=1!==i,r=-1!==i,s=n.getSpacingBetweenLines(),a=n.getNumLines(),l=[];return e.forEach((function(e){var u=e.indexOf(a)>-1,c=e.indexOf(1)>-1;if(!(o&&c||r&&u)){1===e.length&&e.push(e[0]);var h=[];e.forEach((function(e,o,r){var l=1===e,u=e===a,c=n.getYForLine(e-1);0!==o||l?o!==r.length-1||u||(c+=s/2-1):c-=s/2-1,h.push(c),1===i&&l?h.push(t-2):-1===i&&u&&h.push(t+2)})),l.push(h.sort((function(t,e){return t-e})))}})),l}(e,function(t,e){for(var n=[],i=[],o=1;o<=t;o++){e.indexOf(o)>-1?(n.push(i),i=[]):i.push(o)}return i.length>0&&n.push(i),n}(this.stave.getNumLines(),this.positions.map((function(t){return t.str}))),this.getStave(),this.getStemDirection());n.save(),n.setLineWidth(at.WIDTH),o.forEach((function(e){0!==e.length&&(n.beginPath(),n.moveTo(t,e[0]),n.lineTo(t,e[e.length-1]),n.stroke(),n.closePath())})),n.restore()}}},{key:"drawPositions",value:function(){for(var t=this.context,e=this.getAbsoluteX(),n=this.ys,i=0;i<this.positions.length;++i){var o=n[i]+this.render_options.y_shift,r=this.glyphs[i],s=e+this.glyph.getWidth()/2-r.getWidth()/2;if(t.clearRect(s-2,o-3,r.getWidth()+4,6),r.code)D.renderGlyph(t,s,o,this.render_options.glyph_font_scale*this.render_options.scale,r.code);else{t.save(),t.setRawFont(this.render_options.font);var a=r.text.toString();t.fillText(a,s,o+5*this.render_options.scale),t.restore()}}}},{key:"draw",value:function(){if(this.checkContext(),!this.stave)throw new b.RERR("NoStave","Can't draw without a stave.");if(0===this.ys.length)throw new b.RERR("NoYValues","Can't draw note without Y values.");this.setRendered();var t=null==this.beam&&this.render_options.draw_stem;this.drawPositions(),this.drawStemThrough();var e=this.getStemX();this.stem.setNoteHeadXBounds(e,e),t&&(this.context.openGroup("stem",null,{pointerBBox:!0}),this.stem.setContext(this.context).draw(),this.context.closeGroup()),this.drawFlag(),this.drawModifiers()}}]),e}(fe);function Jr(t){return(Jr="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function qr(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Qr(t,e){return!e||"object"!==Jr(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Zr(t){return(Zr=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function $r(t,e){return($r=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var ts,es=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Qr(this,Zr(e).call(this))).setAttribute("type","VibratoBracket"),n.start=t.start,n.stop=t.stop,n.line=1,n.render_options={harsh:!1,wave_height:6,wave_width:4,wave_girth:2},n}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&$r(t,e)}(e,t),n=e,(i=[{key:"setLine",value:function(t){return this.line=t,this}},{key:"setHarsh",value:function(t){return this.render_options.harsh=t,this}},{key:"draw",value:function(){var t=this.context;this.setRendered();var e=this.start?this.start.getStave().getYForTopText(this.line):this.stop.getStave().getYForTopText(this.line),n=this.start?this.start.getAbsoluteX():this.stop.getStave().getTieStartX(),i=this.stop?this.stop.getAbsoluteX()-this.stop.getWidth()-5:this.start.getStave().getTieEndX()-10;this.render_options.vibrato_width=i-n,function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];es.DEBUG&&b.L("Vex.Flow.VibratoBracket",e)}("Rendering VibratoBracket: start_x:",n,"stop_x:",i,"y:",e),Vi.renderVibrato(t,n,e,this.render_options)}}])&&qr(n.prototype,i),o&&qr(n,o),e}(S);function ns(t){return(ns="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function is(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function os(t,e){return!e||"object"!==ns(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function rs(t){return(rs=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ss(t,e){return(ss=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var as=function(t){function e(t,n){var i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=os(this,rs(e).call(this))).setAttribute("type","MultiMeasureRest"),i.render_options={show_number:!0,number_line:-.5,number_glyph_point:40,padding_left:void 0,padding_right:void 0,line:2,spacing_between_lines_px:10,line_thickness:void 0,serif_thickness:2,use_symbols:!1,symbol_spacing:void 0,semibrave_rest_glyph_scale:G.DEFAULT_NOTATION_FONT_SCALE},b.Merge(i.render_options,n),i.number_of_measures=t,i.xs={left:NaN,right:NaN},i}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ss(t,e)}(e,t),n=e,(i=[{key:"getXs",value:function(){return this.xs}},{key:"setStave",value:function(t){return this.stave=t,this}},{key:"getStave",value:function(){return this.stave}},{key:"drawLine",value:function(t,e,n,i){var o=this.stave.getYForLine(this.render_options.line),r=.1*(n-e);e+=r,n-=r;var s=this.render_options.serif_thickness,a=.25*i;isNaN(this.render_options.line_thickness)||(a=.5*this.render_options.line_thickness),t.save(),t.beginPath(),t.moveTo(e,o-i),t.lineTo(e+s,o-i),t.lineTo(e+s,o-a),t.lineTo(n-s,o-a),t.lineTo(n-s,o-i),t.lineTo(n,o-i),t.lineTo(n,o+i),t.lineTo(n-s,o+i),t.lineTo(n-s,o+a),t.lineTo(e+s,o+a),t.lineTo(e+s,o+i),t.lineTo(e,o+i),t.closePath(),t.fill()}},{key:"drawSymbols",value:function(t,e,n,i){var o=Math.floor(this.number_of_measures/4),r=this.number_of_measures%4,s=Math.floor(r/2),a=r%2,l=function(){if(!ts){var t=new ae({duration:"w",note_type:"r"});ts={glyph_font_scale:t.render_options.glyph_font_scale,glyph_code:t.glyph_code,width:t.getWidth()}}return ts}(),u=l.width*(this.render_options.semibrave_rest_glyph_scale/l.glyph_font_scale),c={2:{width:.5*u,height:i},1:{width:u}},h=1.35*u;isNaN(this.render_options.symbol_spacing)||(h=this.render_options.symbol_spacing);var b=e+.5*(n-e)-.5*(o*c[2].width+s*c[2].width+a*c[1].width+(o+s+a-1)*h),f=this.stave.getYForLine(this.render_options.line-1),p=this.stave.getYForLine(this.render_options.line),y=this.stave.getYForLine(this.render_options.line+1);t.save(),t.setStrokeStyle("none"),t.setLineWidth(0);for(var d=0;d<o;++d)t.fillRect(b,p-c[2].height,c[2].width,c[2].height),t.fillRect(b,y-c[2].height,c[2].width,c[2].height),b+=c[2].width+h;for(var v=0;v<s;++v)t.fillRect(b,p-c[2].height,c[2].width,c[2].height),b+=c[2].width+h;for(var g=0;g<a;++g)D.renderGlyph(t,b,f,this.render_options.semibrave_rest_glyph_scale,l.glyph_code),b+=c[1].width+h;t.restore()}},{key:"draw",value:function(){this.checkContext(),this.setRendered();var t=this.context,e=this.stave,n=this.render_options.spacing_between_lines_px,i=e.getNoteStartX(),o=e.getNoteEndX(),r=e.getModifiers(lo.Position.BEGIN);if(1===r.length&&"barlines"===r[0].getCategory()&&(i-=r[0].getWidth()),isNaN(this.render_options.padding_left)||(i=e.getX()+this.render_options.padding_left),isNaN(this.render_options.padding_right)||(o=e.getX()+e.getWidth()-this.render_options.padding_right),this.xs.left=i,this.xs.right=o,this.render_options.use_symbols?this.drawSymbols(t,i,o,n):this.drawLine(t,i,o,n),this.render_options.show_number){var s="/"+this.number_of_measures,a=new _r(null,void 0,!1);a.point=this.render_options.number_glyph_point,a.setTimeSig(s),a.setStave(e),a.x=i+.5*(o-i)-.5*a.timeSig.glyph.getMetrics().width,a.bottomLine=this.render_options.number_line,a.setContext(t).draw()}}}])&&is(n.prototype,i),o&&is(n,o),e}(S);function ls(t){return(ls="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function us(t,e){return!e||"object"!==ls(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function cs(t,e,n){return(cs="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=hs(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function hs(t){return(hs=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function bs(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function fs(t,e,n){return e&&bs(t.prototype,e),n&&bs(t,n),t}function ps(t,e){return(ps=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var ys=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=us(this,hs(e).call(this,{duration:"b"}))).setAttribute("type","ClefNote"),o.setType(t,n,i),o.ignore_ticks=!0,o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ps(t,e)}(e,t),fs(e,null,[{key:"CATEGORY",get:function(){return"clefnote"}}]),fs(e,[{key:"setType",value:function(t,e,n){return this.type=t,this.clef_obj=new or(t,e,n),this.clef=this.clef_obj.clef,this.glyph=new D(this.clef.code,this.clef.point),this.setWidth(this.glyph.getMetrics().width),this}},{key:"getClef",value:function(){return this.clef}},{key:"setContext",value:function(t){return this.context=t,this.glyph.setContext(this.context),this}},{key:"getBoundingBox",value:function(){return cs(hs(e.prototype),"getBoundingBox",this).call(this)}},{key:"addToModifierContext",value:function(){return this}},{key:"getCategory",value:function(){return e.CATEGORY}},{key:"preFormat",value:function(){return this.setPreFormatted(!0),this}},{key:"draw",value:function(){if(!this.stave)throw new b.RERR("NoStave","Can't draw without a stave.");this.glyph.getContext()||this.glyph.setContext(this.context),this.setRendered();var t=this.getAbsoluteX();if(this.glyph.setStave(this.stave),this.glyph.setYShift(this.stave.getYForLine(this.clef.line)-this.stave.getYForGlyphs()),this.glyph.renderToStave(t),void 0!==this.clef_obj.annotation){var e=new D(this.clef_obj.annotation.code,this.clef_obj.annotation.point);e.getContext()||e.setContext(this.context),e.setStave(this.stave),e.setYShift(this.stave.getYForLine(this.clef_obj.annotation.line)-this.stave.getYForGlyphs()),e.setXShift(this.clef_obj.annotation.x_shift),e.renderToStave(t)}}}]),e}($t);function ds(t){return(ds="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function vs(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function gs(t,e){return!e||"object"!==ds(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function ms(t,e,n){return(ms="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=_s(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function _s(t){return(_s=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function xs(t,e){return(xs=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var ws=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=gs(this,_s(e).call(this,{duration:"b"}))).setAttribute("type","KeySigNote"),o.keySignature=new hr(t,n,i),o.ignore_ticks=!0,o}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&xs(t,e)}(e,t),n=e,(i=[{key:"getBoundingBox",value:function(){return ms(_s(e.prototype),"getBoundingBox",this).call(this)}},{key:"addToModifierContext",value:function(){return this}},{key:"preFormat",value:function(){return this.setPreFormatted(!0),this.keySignature.setStave(this.stave),this.keySignature.format(),this.setWidth(this.keySignature.width),this}},{key:"draw",value:function(){this.stave.checkContext(),this.setRendered(),this.keySignature.x=this.getAbsoluteX(),this.keySignature.setContext(this.context),this.keySignature.draw()}}])&&vs(n.prototype,i),o&&vs(n,o),e}($t);function ks(t){return(ks="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ss(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Ts(t,e){return!e||"object"!==ks(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Es(t,e,n){return(Es="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=Os(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function Os(t){return(Os=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Rs(t,e){return(Rs=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Ps=function(t){function e(t,n){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=Ts(this,Os(e).call(this,{duration:"b"}))).setAttribute("type","TimeSigNote");var o=new _r(t,n);return i.timeSig=o.getTimeSig(),i.setWidth(i.timeSig.glyph.getMetrics().width),i.ignore_ticks=!0,i}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Rs(t,e)}(e,t),n=e,(i=[{key:"getBoundingBox",value:function(){return Es(Os(e.prototype),"getBoundingBox",this).call(this)}},{key:"addToModifierContext",value:function(){return this}},{key:"preFormat",value:function(){return this.setPreFormatted(!0),this}},{key:"draw",value:function(){this.stave.checkContext(),this.setRendered(),this.timeSig.glyph.getContext()||this.timeSig.glyph.setContext(this.context),this.timeSig.glyph.setStave(this.stave),this.timeSig.glyph.setYShift(this.stave.getYForLine(this.timeSig.line)-this.stave.getYForGlyphs()),this.timeSig.glyph.renderToStave(this.getAbsoluteX())}}])&&Ss(n.prototype,i),o&&Ss(n,o),e}($t);function Cs(t){return(Cs="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ns(t,e){return!e||"object"!==Cs(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function As(t){return(As=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ls(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Ms(t,e,n){return e&&Ls(t.prototype,e),n&&Ls(t,n),t}function Fs(t,e){return(Fs=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Bs=function(t){function e(t,n){var i;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=Ns(this,As(e).call(this,t,"sl."))).setAttribute("type","TabSlide"),!n){var o=t.first_note.getPositions()[0].fret,r=t.last_note.getPositions()[0].fret;n=parseInt(o,10)>parseInt(r,10)?e.SLIDE_DOWN:e.SLIDE_UP}return i.slide_direction=n,i.render_options.cp1=11,i.render_options.cp2=14,i.render_options.y_shift=.5,i.setFont({font:"Times",size:10,style:"bold italic"}),i.setNotes(t),i}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Fs(t,e)}(e,t),Ms(e,null,[{key:"createSlideUp",value:function(t){return new e(t,e.SLIDE_UP)}},{key:"createSlideDown",value:function(t){return new e(t,e.SLIDE_DOWN)}},{key:"SLIDE_UP",get:function(){return 1}},{key:"SLIDE_DOWN",get:function(){return-1}}]),Ms(e,[{key:"renderTie",value:function(t){if(0===t.first_ys.length||0===t.last_ys.length)throw new b.RERR("BadArguments","No Y-values to render");var n=this.context,i=t.first_x_px,o=t.first_ys,r=t.last_x_px,s=this.slide_direction;if(s!==e.SLIDE_UP&&s!==e.SLIDE_DOWN)throw new b.RERR("BadSlide","Invalid slide direction");for(var a=0;a<this.first_indices.length;++a){var l=o[this.first_indices[a]]+this.render_options.y_shift;if(isNaN(l))throw new b.RERR("BadArguments","Bad indices for slide rendering.");n.beginPath(),n.moveTo(i,l+3*s),n.lineTo(r,l-3*s),n.closePath(),n.stroke()}this.setRendered()}}]),e}(En);function js(t){return(js="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ds(){return(Ds=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t}).apply(this,arguments)}function Is(t,e){return!e||"object"!==js(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Gs(t,e,n){return(Gs="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=Ys(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function Ys(t){return(Ys=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ws(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Xs(t,e,n){return e&&Ws(t.prototype,e),n&&Ws(t,n),t}function Hs(t,e){return(Hs=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Us=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Is(this,Ys(e).call(this,Ds(t,{glyph_font_scale:G.DEFAULT_NOTATION_FONT_SCALE*e.SCALE,stroke_px:e.LEDGER_LINE_OFFSET})))).setAttribute("type","GraceNote"),n.slash=t.slash,n.slur=!0,n.buildNoteHeads(),n.width=3,n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Hs(t,e)}(e,t),Xs(e,null,[{key:"CATEGORY",get:function(){return"gracenotes"}},{key:"LEDGER_LINE_OFFSET",get:function(){return 2}},{key:"SCALE",get:function(){return.66}}]),Xs(e,[{key:"getStemExtension",value:function(){if(null!=this.stem_extension_override)return this.stem_extension_override;var t=this.getGlyph();if(t){var n=Gs(Ys(e.prototype),"getStemExtension",this).call(this);if(t.stem){var i=this.getStaveNoteScale();n=(at.HEIGHT+n)*i-at.HEIGHT}return n}return 0}},{key:"getCategory",value:function(){return e.CATEGORY}},{key:"getStaveNoteScale",value:function(){return this.render_options.glyph_font_scale/G.DEFAULT_NOTATION_FONT_SCALE}},{key:"draw",value:function(){Gs(Ys(e.prototype),"draw",this).call(this),this.setRendered();var t=this.stem;if(this.slash&&t){var n=this.getStaveNoteScale(),i=n/.66,o=void 0,r=this.beam;if(r)r.postFormatted||r.postFormat(),o=this.calcBeamedNotesSlashBBox(8*i,8*i,{stem:6*i,beam:5*i});else{var s=this.getStemDirection(),a=this.getNoteHeadBounds(),l=t.getHeight(),u=this.getAbsoluteX(),c=s===G.Stem.DOWN?a.y_top-l:a.y_bottom-l,h=s===G.Stem.DOWN?this.glyph.stem_down_extension:this.glyph.stem_up_extension,b=G.STEM_HEIGHT;b-=b/2.8,c+=(b+=h)*n*s;var f=s===G.Stem.UP?{x1:1,y1:0,x2:13,y2:-9}:{x1:-4,y1:1,x2:13,y2:9};o={x1:u+=f.x1*i,y1:c+=f.y1*i,x2:u+f.x2*i,y2:c+f.y2*i}}var p=this.context;p.save(),p.setLineWidth(1*i),p.beginPath(),p.moveTo(o.x1,o.y1),p.lineTo(o.x2,o.y2),p.closePath(),p.stroke(),p.restore()}}},{key:"calcBeamedNotesSlashBBox",value:function(t,e,n){var i=this.beam,o=i.slope,r=i.notes[i.notes.length-1]===this?-1:1,s=Math.atan(o*r),a=Math.cos(s)*e,l=Math.sin(s)*e;t*=this.getStemDirection();var u=Math.atan((l-t)/a),c=Math.cos(u)*n.stem*r,h=Math.sin(u)*n.stem,b=Math.cos(u)*n.beam*r,f=Math.sin(u)*n.beam,p=this.getStemX(),y=i.notes[0].getStemX(),d=this.beam.getBeamYToDraw()+(p-y)*o;return{x1:p-c,y1:d+t-h,x2:p+a*r+b,y2:d+l+f}}}]),e}(je);function Vs(t){return(Vs="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function zs(t,e){return!e||"object"!==Vs(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Ks(t,e,n){return(Ks="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=Js(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function Js(t){return(Js=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function qs(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Qs(t,e,n){return e&&qs(t.prototype,e),n&&qs(t,n),t}function Zs(t,e){return(Zs=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var $s=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=zs(this,Js(e).call(this,t,!1))).setAttribute("type","GraceTabNote"),b.Merge(n.render_options,{y_shift:.3,scale:.6,font:"7.5pt Arial"}),n.updateWidth(),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Zs(t,e)}(e,t),Qs(e,null,[{key:"CATEGORY",get:function(){return"gracetabnotes"}}]),Qs(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"draw",value:function(){Ks(Js(e.prototype),"draw",this).call(this),this.setRendered()}}]),e}(Kr);function ta(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function ea(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function na(t,e,n){return e&&ea(t.prototype,e),n&&ea(t,n),t}var ia=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"E/5,B/4,G/4,D/4,A/3,E/3,B/2,E/2";ta(this,t),this.setTuning(e)}return na(t,null,[{key:"names",get:function(){return{standard:"E/5,B/4,G/4,D/4,A/3,E/3",dagdad:"D/5,A/4,G/4,D/4,A/3,D/3",dropd:"E/5,B/4,G/4,D/4,A/3,D/3",eb:"Eb/5,Bb/4,Gb/4,Db/4,Ab/3,Db/3",standardBanjo:"D/5,B/4,G/4,D/4,G/5"}}}]),na(t,[{key:"noteToInteger",value:function(t){return G.keyProperties(t).int_value}},{key:"setTuning",value:function(e){t.names[e]&&(e=t.names[e]),this.tuningString=e,this.tuningValues=[],this.numStrings=0;var n=e.split(/\s*,\s*/);if(0===n.length)throw new b.RERR("BadArguments","Invalid tuning string: "+e);this.numStrings=n.length;for(var i=0;i<this.numStrings;++i)this.tuningValues[i]=this.noteToInteger(n[i])}},{key:"getValueForString",value:function(t){var e=parseInt(t,10);if(e<1||e>this.numStrings)throw new b.RERR("BadArguments","String number must be between 1 and ".concat(this.numStrings,":").concat(t));return this.tuningValues[e-1]}},{key:"getValueForFret",value:function(t,e){var n=this.getValueForString(e),i=parseInt(t,10);if(i<0)throw new b.RERR("BadArguments","Fret number must be 0 or higher: "+t);return n+i}},{key:"getNoteForFret",value:function(t,e){var n=this.getValueForFret(t,e),i=Math.floor(n/12),o=n%12;return G.integerToNote(o)+"/"+i}}]),t}();function oa(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var ra=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.music=new Ve,this.setKey(e)}var e,n,i;return e=t,(n=[{key:"setKey",value:function(t){return this.key=t,this.reset(),this}},{key:"getKey",value:function(){return this.key}},{key:"reset",value:function(){if(this.keyParts=this.music.getKeyParts(this.key),this.keyString=this.keyParts.root,this.keyParts.accidental&&(this.keyString+=this.keyParts.accidental),!Ve.scaleTypes[this.keyParts.type])throw new b.RERR("BadArguments","Unsupported key type: ".concat(this.key));this.scale=this.music.getScaleTones(this.music.getNoteValue(this.keyString),Ve.scaleTypes[this.keyParts.type]),this.scaleMap={},this.scaleMapByValue={},this.originalScaleMapByValue={};for(var t=Ve.root_indices[this.keyParts.root],e=0;e<Ve.roots.length;++e){var n=(t+e)%Ve.roots.length,i=Ve.roots[n],o=this.music.getRelativeNoteName(i,this.scale[e]);this.scaleMap[i]=o,this.scaleMapByValue[this.scale[e]]=o,this.originalScaleMapByValue[this.scale[e]]=o}return this}},{key:"getAccidental",value:function(t){var e=this.music.getKeyParts(t).root,n=this.music.getNoteParts(this.scaleMap[e]);return{note:this.scaleMap[e],accidental:n.accidental}}},{key:"selectNote",value:function(t){t=t.toLowerCase();var e=this.music.getNoteParts(t),n=this.scaleMap[e.root],i=this.music.getNoteParts(n);if(n===t)return{note:n,accidental:e.accidental,change:!1};var o=this.scaleMapByValue[this.music.getNoteValue(t)];if(null!=o)return{note:o,accidental:this.music.getNoteParts(o).accidental,change:!1};var r=this.originalScaleMapByValue[this.music.getNoteValue(t)];return null!=r?(this.scaleMap[i.root]=r,delete this.scaleMapByValue[this.music.getNoteValue(n)],this.scaleMapByValue[this.music.getNoteValue(t)]=r,{note:r,accidental:this.music.getNoteParts(r).accidental,change:!0}):i.root===t?(delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[e.root])],this.scaleMapByValue[this.music.getNoteValue(i.root)]=i.root,this.scaleMap[i.root]=i.root,{note:i.root,accidental:null,change:!0}):(delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[e.root])],this.scaleMapByValue[this.music.getNoteValue(t)]=t,delete this.scaleMap[i.root],this.scaleMap[i.root]=t,{note:t,accidental:e.accidental,change:!0})}}])&&oa(e.prototype,n),i&&oa(e,i),t}();function sa(t){return(sa="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function aa(t,e){return!e||"object"!==sa(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function la(t){return(la=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ua(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function ca(t,e,n){return e&&ua(t.prototype,e),n&&ua(t,n),t}function ha(t,e){return(ha=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var ba=function(t){function e(t,n){var i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=aa(this,la(e).call(this))).setAttribute("type","StaveHairpin"),i.notes=t,i.hairpin=n,i.position=_e.Position.BELOW,i.render_options={height:10,y_shift:0,left_shift_px:0,right_shift_px:0},i.setNotes(t),i}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ha(t,e)}(e,t),ca(e,null,[{key:"FormatByTicksAndDraw",value:function(t,n,i,o,r,s){var a=n.pixelsPerTick;if(null==a)throw new b.RuntimeError("BadArguments","A valid Formatter must be provide to draw offsets by ticks.");var l=a*s.left_shift_ticks,u=a*s.right_shift_ticks,c={height:s.height,y_shift:s.y_shift,left_shift_px:l,right_shift_px:u};new e({first_note:i.first_note,last_note:i.last_note},o).setContext(t).setRenderOptions(c).setPosition(r).draw()}},{key:"type",get:function(){return{CRESC:1,DECRESC:2}}}]),ca(e,[{key:"setPosition",value:function(t){return t!==_e.Position.ABOVE&&t!==_e.Position.BELOW||(this.position=t),this}},{key:"setRenderOptions",value:function(t){return null!=t.height&&null!=t.y_shift&&null!=t.left_shift_px&&null!=t.right_shift_px&&(this.render_options=t),this}},{key:"setNotes",value:function(t){if(!t.first_note&&!t.last_note)throw new b.RuntimeError("BadArguments","Hairpin needs to have either first_note or last_note set.");return this.first_note=t.first_note,this.last_note=t.last_note,this}},{key:"renderHairpin",value:function(t){var n=this.checkContext(),i=this.render_options.y_shift+20,o=t.first_y;this.position===_e.Position.ABOVE&&(i=30-i,o=t.first_y-t.staff_height);var r=this.render_options.left_shift_px,s=this.render_options.right_shift_px;switch(n.beginPath(),this.hairpin){case e.type.CRESC:n.moveTo(t.last_x+s,o+i),n.lineTo(t.first_x+r,o+this.render_options.height/2+i),n.lineTo(t.last_x+s,o+this.render_options.height+i);break;case e.type.DECRESC:n.moveTo(t.first_x+r,o+i),n.lineTo(t.last_x+s,o+this.render_options.height/2+i),n.lineTo(t.first_x+r,o+this.render_options.height+i)}n.stroke(),n.closePath()}},{key:"draw",value:function(){this.checkContext(),this.setRendered();var t=this.first_note,e=this.last_note,n=t.getModifierStartXY(this.position,0),i=e.getModifierStartXY(this.position,0);return this.renderHairpin({first_x:n.x,last_x:i.x,first_y:t.getStave().y+t.getStave().height,last_y:e.getStave().y+e.getStave().height,staff_height:t.getStave().height}),!0}}]),e}(S);function fa(t){return(fa="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function pa(t,e){return!e||"object"!==fa(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function ya(t){return(ya=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function da(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function va(t,e,n){return e&&da(t.prototype,e),n&&da(t,n),t}function ga(t,e){return(ga=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var ma=function(t){function e(t,n,i){var o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(o=pa(this,ya(e).call(this))).setAttribute("type","Curve"),o.render_options={spacing:2,thickness:2,x_shift:0,y_shift:10,position:e.Position.NEAR_HEAD,position_end:e.Position.NEAR_HEAD,invert:!1,cps:[{x:0,y:10},{x:0,y:10}]},b.Merge(o.render_options,i),o.setNotes(t,n),o}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ga(t,e)}(e,t),va(e,null,[{key:"Position",get:function(){return{NEAR_HEAD:1,NEAR_TOP:2}}},{key:"PositionString",get:function(){return{nearHead:e.Position.NEAR_HEAD,nearTop:e.Position.NEAR_TOP}}}]),va(e,[{key:"setNotes",value:function(t,e){if(!t&&!e)throw new b.RuntimeError("BadArguments","Curve needs to have either first_note or last_note set.");return this.from=t,this.to=e,this}},{key:"isPartial",value:function(){return!this.from||!this.to}},{key:"renderCurve",value:function(t){var e=this.context,n=this.render_options.cps,i=this.render_options.x_shift,o=this.render_options.y_shift*t.direction,r=t.first_x+i,s=t.first_y+o,a=t.last_x-i,l=t.last_y+o,u=this.render_options.thickness,c=(a-r)/(n.length+2);e.beginPath(),e.moveTo(r,s),e.bezierCurveTo(r+c+n[0].x,s+n[0].y*t.direction,a-c+n[1].x,l+n[1].y*t.direction,a,l),e.bezierCurveTo(a-c+n[1].x,l+(n[1].y+u)*t.direction,r+c+n[0].x,s+(n[0].y+u)*t.direction,r,s),e.stroke(),e.closePath(),e.fill()}},{key:"draw",value:function(){this.checkContext(),this.setRendered();var t,n,i,o,r,s=this.from,a=this.to,l="baseY",u="baseY";function c(t){return"string"==typeof t?e.PositionString[t]:t}var h=c(this.render_options.position),b=c(this.render_options.position_end);return h===e.Position.NEAR_TOP&&(l="topY",u="topY"),b===e.Position.NEAR_HEAD?u="baseY":b===e.Position.NEAR_TOP&&(u="topY"),s?(t=s.getTieRightX(),r=s.getStemDirection(),i=s.getStemExtents()[l]):(t=a.getStave().getTieStartX(),i=a.getStemExtents()[l]),a?(n=a.getTieLeftX(),r=a.getStemDirection(),o=a.getStemExtents()[u]):(n=s.getStave().getTieEndX(),o=s.getStemExtents()[u]),this.renderCurve({first_x:t,last_x:n,first_y:i,last_y:o,direction:r*(!0===this.render_options.invert?-1:1)}),!0}}]),e}(S);function _a(t){return(_a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function xa(t,e){return!e||"object"!==_a(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function wa(t){return(wa=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ka(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Sa(t,e,n){return e&&ka(t.prototype,e),n&&ka(t,n),t}function Ta(t,e){return(Ta=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Ea(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];Oa.DEBUG&&b.L("Vex.Flow.TextDynamics",e)}var Oa=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=xa(this,wa(e).call(this,t))).setAttribute("type","TextDynamics"),n.sequence=t.text.toLowerCase(),n.line=t.line||0,n.glyphs=[],b.Merge(n.render_options,{glyph_font_size:40}),Ea("New Dynamics Text: ",n.sequence),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Ta(t,e)}(e,t),Sa(e,null,[{key:"GLYPHS",get:function(){return{f:{code:"vba",width:12},p:{code:"vbf",width:14},m:{code:"v62",width:17},s:{code:"v4a",width:10},z:{code:"v80",width:12},r:{code:"vb1",width:12}}}}]),Sa(e,[{key:"setLine",value:function(t){return this.line=t,this}},{key:"preFormat",value:function(){var t=this,n=0;return this.sequence.split("").forEach((function(i){var o=e.GLYPHS[i];if(!o)throw new b.RERR("Invalid dynamics character: "+i);var r=t.render_options.glyph_font_size,s=new D(o.code,r);t.glyphs.push(s),n+=o.width})),this.setWidth(n),this.preFormatted=!0,this}},{key:"draw",value:function(){var t=this;this.setRendered();var n=this.getAbsoluteX(),i=this.stave.getYForLine(this.line+-3);Ea("Rendering Dynamics: ",this.sequence);var o=n;this.glyphs.forEach((function(n,r){var s=t.sequence[r];n.render(t.context,o,i),o+=e.GLYPHS[s].width}))}}]),e}($t);function Ra(t){return(Ra="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pa(t,e){return!e||"object"!==Ra(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Ca(t){return(Ca=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Na(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Aa(t,e,n){return e&&Na(t.prototype,e),n&&Na(t,n),t}function La(t,e){return(La=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Ma(t,e,n,i,o,r,s){t.beginPath(),t.moveTo(e,n),t.lineTo(i,o),t.lineTo(r,s),t.lineTo(e,n),t.closePath(),t.fill()}var Fa=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Pa(this,Ca(e).call(this))).setAttribute("type","StaveLine"),n.notes=t,n.text="",n.font={family:"Arial",size:10,weight:""},n.render_options={padding_left:4,padding_right:3,line_width:1,line_dash:null,rounded_end:!0,color:null,draw_start_arrow:!1,draw_end_arrow:!1,arrowhead_length:10,arrowhead_angle:Math.PI/8,text_position_vertical:e.TextVerticalPosition.TOP,text_justification:e.TextJustification.CENTER},n.setNotes(t),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&La(t,e)}(e,t),Aa(e,null,[{key:"TextVerticalPosition",get:function(){return{TOP:1,BOTTOM:2}}},{key:"TextJustification",get:function(){return{LEFT:1,CENTER:2,RIGHT:3}}}]),Aa(e,[{key:"setFont",value:function(t){return this.font=t,this}},{key:"setText",value:function(t){return this.text=t,this}},{key:"setNotes",value:function(t){if(!t.first_note&&!t.last_note)throw new b.RuntimeError("BadArguments","Notes needs to have either first_note or last_note set.");if(t.first_indices||(t.first_indices=[0]),t.last_indices||(t.last_indices=[0]),t.first_indices.length!==t.last_indices.length)throw new b.RuntimeError("BadArguments","Connected notes must have similar index sizes");return this.first_note=t.first_note,this.first_indices=t.first_indices,this.last_note=t.last_note,this.last_indices=t.last_indices,this}},{key:"applyLineStyle",value:function(){var t=this.checkContext(),e=this.render_options;e.line_dash&&t.setLineDash(e.line_dash),e.line_width&&t.setLineWidth(e.line_width),e.rounded_end?t.setLineCap("round"):t.setLineCap("square")}},{key:"applyFontStyle",value:function(){var t=this.checkContext();this.font&&t.setFont(this.font.family,this.font.size,this.font.weight),this.render_options.color&&(t.setStrokeStyle(this.render_options.color),t.setFillStyle(this.render_options.color))}},{key:"draw",value:function(){var t=this,n=this.checkContext();this.setRendered();var i,o,r=this.first_note,s=this.last_note,a=this.render_options;n.save(),this.applyLineStyle(),this.first_indices.forEach((function(e,l){var u=t.last_indices[l];i=r.getModifierStartXY(2,e),o=s.getModifierStartXY(1,u);var c=i.y>o.y;i.x+=r.getMetrics().modRightPx+a.padding_left,o.x-=s.getMetrics().modLeftPx+a.padding_right;var h=r.getGlyph().getWidth();r.getKeyProps()[e].displaced&&1===r.getStemDirection()&&(i.x+=h+a.padding_left),s.getKeyProps()[u].displaced&&-1===s.getStemDirection()&&(o.x-=h+a.padding_right),i.y+=c?-3:1,o.y+=c?2:0,function(t,e,n,i){var o,r,s,a,l=i.draw_start_arrow&&i.draw_end_arrow,u=e.x,c=e.y,h=n.x,b=n.y,f=Math.sqrt((h-u)*(h-u)+(b-c)*(b-c)),p=(f-i.arrowhead_length/3)/f;i.draw_end_arrow||l?(o=Math.round(u+(h-u)*p),r=Math.round(c+(b-c)*p)):(o=h,r=b),i.draw_start_arrow||l?(s=u+(h-u)*(1-p),a=c+(b-c)*(1-p)):(s=u,a=c),i.color&&(t.setStrokeStyle(i.color),t.setFillStyle(i.color)),t.beginPath(),t.moveTo(s,a),t.lineTo(o,r),t.stroke(),t.closePath();var y,d,v,g,m=Math.atan2(b-c,h-u),_=Math.abs(i.arrowhead_length/Math.cos(i.arrowhead_angle));(i.draw_end_arrow||l)&&(y=m+Math.PI+i.arrowhead_angle,v=h+Math.cos(y)*_,g=b+Math.sin(y)*_,d=m+Math.PI-i.arrowhead_angle,Ma(t,v,g,h,b,h+Math.cos(d)*_,b+Math.sin(d)*_)),(i.draw_start_arrow||l)&&(y=m+i.arrowhead_angle,v=u+Math.cos(y)*_,g=c+Math.sin(y)*_,d=m-i.arrowhead_angle,Ma(t,v,g,u,c,u+Math.cos(d)*_,c+Math.sin(d)*_))}(n,i,o,t.render_options)})),n.restore();var l,u=n.measureText(this.text).width,c=a.text_justification,h=0;if(c===e.TextJustification.LEFT)h=i.x;else if(c===e.TextJustification.CENTER){h=(o.x-i.x)/2+i.x-u/2}else c===e.TextJustification.RIGHT&&(h=o.x-u);var b=a.text_position_vertical;return b===e.TextVerticalPosition.TOP?l=r.getStave().getYForTopText():b===e.TextVerticalPosition.BOTTOM&&(l=r.getStave().getYForBottomText(G.TEXT_HEIGHT_OFFSET_HACK)),n.save(),this.applyFontStyle(),n.fillText(this.text,h,l),n.restore(),this}}]),e}(S);function Ba(t){return(Ba="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ja(t,e){return!e||"object"!==Ba(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Da(t){return(Da=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ia(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Ga(t,e,n){return e&&Ia(t.prototype,e),n&&Ia(t,n),t}function Ya(t,e){return(Ya=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Wa(t,e,n,i,o){var r=Xa.GLYPHS[t];new D(r.code,o).render(e,n+r.x_shift,i+r.y_shift)}var Xa=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=ja(this,Da(e).call(this))).setAttribute("type","PedalMarking"),n.notes=t,n.style=e.TEXT,n.line=0,n.custom_depress_text="",n.custom_release_text="",n.font={family:"Times New Roman",size:12,weight:"italic bold"},n.render_options={bracket_height:10,text_margin_right:6,bracket_line_width:1,glyph_point_size:40,color:"black"},n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Ya(t,e)}(e,t),Ga(e,null,[{key:"createSustain",value:function(t){return new e(t)}},{key:"createSostenuto",value:function(t){var n=new e(t);return n.setStyle(e.Styles.MIXED),n.setCustomText("Sost. Ped."),n}},{key:"createUnaCorda",value:function(t){var n=new e(t);return n.setStyle(e.Styles.TEXT),n.setCustomText("una corda","tre corda"),n}},{key:"GLYPHS",get:function(){return{pedal_depress:{code:"v36",x_shift:-10,y_shift:0},pedal_release:{code:"v5d",x_shift:-2,y_shift:3}}}},{key:"Styles",get:function(){return{TEXT:1,BRACKET:2,MIXED:3}}},{key:"StylesString",get:function(){return{text:e.Styles.TEXT,bracket:e.Styles.BRACKET,mixed:e.Styles.MIXED}}}]),Ga(e,[{key:"setCustomText",value:function(t,e){return this.custom_depress_text=t||"",this.custom_release_text=e||"",this}},{key:"setStyle",value:function(t){if(t<1&&t>3)throw new b.RERR("InvalidParameter","The style must be one found in PedalMarking.Styles");return this.style=t,this}},{key:"setLine",value:function(t){return this.line=t,this}},{key:"drawBracketed",value:function(){var t,n,i=this.context,o=!1,r=this;this.notes.forEach((function(s,a,l){o=!o;var u=s.getAbsoluteX(),c=s.getStave().getYForBottomText(r.line+3);if(u<t)throw new b.RERR("InvalidConfiguration","The notes provided must be in order of ascending x positions");var h=l[a+1]===s,f=l[a-1]===s,p=0;if(o)if(p=f?5:0,r.style!==e.Styles.MIXED||f)i.beginPath(),i.moveTo(u,c-r.render_options.bracket_height),i.lineTo(u+p,c),i.stroke(),i.closePath();else if(r.custom_depress_text){var y=i.measureText(r.custom_depress_text).width;i.fillText(r.custom_depress_text,u-y/2,c),p=y/2+r.render_options.text_margin_right}else Wa("pedal_depress",i,u,c,r.render_options.glyph_point_size),p=20+r.render_options.text_margin_right;else p=h?-5:0,i.beginPath(),i.moveTo(t,n),i.lineTo(u+p,c),i.lineTo(u,c-r.render_options.bracket_height),i.stroke(),i.closePath();t=u+p,n=c}))}},{key:"drawText",value:function(){var t=this.context,e=!1,n=this,i=n.render_options.glyph_point_size;this.notes.forEach((function(o){e=!e;var r=o.getStave(),s=o.getAbsoluteX(),a=r.getYForBottomText(n.line+3),l=0;e?n.custom_depress_text?(l=t.measureText(n.custom_depress_text).width,t.fillText(n.custom_depress_text,s-l/2,a)):Wa("pedal_depress",t,s,a,i):n.custom_release_text?(l=t.measureText(n.custom_release_text).width,t.fillText(n.custom_release_text,s-l/2,a)):Wa("pedal_release",t,s,a,i)}))}},{key:"draw",value:function(){var t=this.checkContext();this.setRendered(),t.save(),t.setStrokeStyle(this.render_options.color),t.setFillStyle(this.render_options.color),t.setFont(this.font.family,this.font.size,this.font.weight),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];Xa.DEBUG&&b.L("Vex.Flow.PedalMarking",e)}("Rendering Pedal Marking"),this.style===e.Styles.BRACKET||this.style===e.Styles.MIXED?(t.setLineWidth(this.render_options.bracket_line_width),this.drawBracketed()):this.style===e.Styles.TEXT&&this.drawText(),t.restore()}}]),e}(S);function Ha(t){return(Ha="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ua(){return(Ua=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t}).apply(this,arguments)}function Va(t,e){return!e||"object"!==Ha(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function za(t){return(za=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ka(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Ja(t,e,n){return e&&Ka(t.prototype,e),n&&Ka(t,n),t}function qa(t,e){return(qa=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var Qa=function(t){function e(t){var n,i=t.start,o=t.stop,r=t.text,s=void 0===r?"":r,a=t.superscript,l=void 0===a?"":a,u=t.position,c=void 0===u?e.Positions.TOP:u;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=Va(this,za(e).call(this))).setAttribute("type","TextBracket"),n.start=i,n.stop=o,n.text=s,n.superscript=l,n.position="string"==typeof c?e.PositionString[c]:c,n.line=1,n.font={family:"Serif",size:15,weight:"italic"},n.render_options={dashed:!0,dash:[5],color:"black",line_width:1,show_bracket:!0,bracket_height:8,underline_superscript:!0},n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&qa(t,e)}(e,t),Ja(e,null,[{key:"Positions",get:function(){return{TOP:1,BOTTOM:-1}}},{key:"PositionString",get:function(){return{top:e.Positions.TOP,bottom:e.Positions.BOTTOM}}}]),Ja(e,[{key:"applyStyle",value:function(t){return t.setFont(this.font.family,this.font.size,this.font.weight),t.setStrokeStyle(this.render_options.color),t.setFillStyle(this.render_options.color),t.setLineWidth(this.render_options.line_width),this}},{key:"setDashed",value:function(t,e){return this.render_options.dashed=t,e&&(this.render_options.dash=e),this}},{key:"setFont",value:function(t){return this.font=Ua({},this.font,t),this}},{key:"setLine",value:function(t){return this.line=t,this}},{key:"draw",value:function(){var t=this.context;this.setRendered();var n=0;switch(this.position){case e.Positions.TOP:n=this.start.getStave().getYForTopText(this.line);break;case e.Positions.BOTTOM:n=this.start.getStave().getYForBottomText(this.line+G.TEXT_HEIGHT_OFFSET_HACK);break;default:throw new b.RERR("InvalidPosition","The position ".concat(this.position," is invalid"))}var i={x:this.start.getAbsoluteX(),y:n},o={x:this.stop.getAbsoluteX(),y:n};!function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];Qa.DEBUG&&b.L("Vex.Flow.TextBracket",e)}("Rendering TextBracket: start:",i,"stop:",o,"y:",n);var r=this.render_options.bracket_height*this.position;t.save(),this.applyStyle(t),t.fillText(this.text,i.x,i.y);var s=t.measureText(this.text).width,a=t.measureText("M").width,l=i.y-a/2.5;t.setFont(this.font.family,this.font.size/1.4,this.font.weight),t.fillText(this.superscript,i.x+s+1,l);var u=t.measureText(this.superscript).width,c=t.measureText("M").width,h=i.x,f=l,p=o.x+this.stop.getGlyph().getWidth();this.position===e.Positions.TOP?(h+=s+u+5,f-=c/2.7):this.position===e.Positions.BOTTOM&&(f+=c/2.7,h+=s+2,this.render_options.underline_superscript||(h+=u)),this.render_options.dashed?($.drawDashedLine(t,h,f,p,f,this.render_options.dash),this.render_options.show_bracket&&$.drawDashedLine(t,p,f+1*this.position,p,f+r,this.render_options.dash)):(t.beginPath(),t.moveTo(h,f),t.lineTo(p,f),this.render_options.show_bracket&&t.lineTo(p,f+r),t.stroke(),t.closePath()),t.restore()}}]),e}(S);function Za(t){return(Za="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function $a(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function tl(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function el(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function nl(t,e){return!e||"object"!==Za(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function il(t,e,n){return(il="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=ol(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function ol(t){return(ol=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function rl(t,e){return(rl=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var sl=function(t){function e(){var t,n,i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:yo.type.SINGLE;tl(this,e),(n=nl(this,ol(e).call(this,{duration:"b"}))).setAttribute("type","BarNote"),n.metrics={widths:{}};var o=yo.type;return n.metrics.widths=($a(t={},o.SINGLE,8),$a(t,o.DOUBLE,12),$a(t,o.END,15),$a(t,o.REPEAT_BEGIN,14),$a(t,o.REPEAT_END,14),$a(t,o.REPEAT_BOTH,18),$a(t,o.NONE,0),t),n.ignore_ticks=!0,n.setType(i),n}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&rl(t,e)}(e,t),n=e,(i=[{key:"getType",value:function(){return this.type}},{key:"setType",value:function(t){return this.type="string"==typeof t?yo.typeString[t]:t,this.setWidth(this.metrics.widths[this.type]),this}},{key:"getBoundingBox",value:function(){return il(ol(e.prototype),"getBoundingBox",this).call(this)}},{key:"addToModifierContext",value:function(){return this}},{key:"preFormat",value:function(){return this.setPreFormatted(!0),this}},{key:"draw",value:function(){if(this.checkContext(),!this.stave)throw new b.RERR("NoStave","Can't draw without a stave.");!function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];sl.DEBUG&&b.L("Vex.Flow.BarNote",e)}("Rendering bar line at: ",this.getAbsoluteX());var t=new yo(this.type);t.setX(this.getAbsoluteX()),t.draw(this.stave),this.setRendered()}}])&&el(n.prototype,i),o&&el(n,o),e}($t);function al(t){return(al="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ll(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function ul(t,e){return!e||"object"!==al(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function cl(t,e,n){return(cl="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=hl(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function hl(t){return(hl=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function bl(t,e){return(bl=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var fl=function(t){function e(t){var n,i;if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),!t)throw new b.RuntimeError("BadArguments","Ghost note must have valid initialization data to identify duration.");if("string"==typeof t)i={duration:t};else{if("object"!==al(t))throw new b.RuntimeError("BadArguments","Ghost note must have valid initialization data to identify duration.");i=t}return(n=ul(this,hl(e).call(this,i))).setAttribute("type","GhostNote"),n.setWidth(0),n}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&bl(t,e)}(e,t),n=e,(i=[{key:"isRest",value:function(){return!0}},{key:"setStave",value:function(t){cl(hl(e.prototype),"setStave",this).call(this,t)}},{key:"addToModifierContext",value:function(){return this}},{key:"preFormat",value:function(){return this.setPreFormatted(!0),this}},{key:"draw",value:function(){if(!this.stave)throw new b.RERR("NoStave","Can't draw without a stave.");this.setRendered();for(var t=0;t<this.modifiers.length;++t){var e=this.modifiers[t];e.setContext(this.context),e.drawWithStyle()}}}])&&ll(n.prototype,i),o&&ll(n,o),e}(fe);function pl(t){return(pl="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function yl(t,e){return!e||"object"!==pl(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function dl(t){return(dl=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function vl(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function gl(t,e,n){return e&&vl(t.prototype,e),n&&vl(t,n),t}function ml(t,e){return(ml=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var _l=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=yl(this,dl(e).call(this))).setAttribute("type","Tremolo"),n.num=t,n.note=null,n.index=null,n.position=_e.Position.CENTER,n.code="v74",n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ml(t,e)}(e,t),gl(e,null,[{key:"CATEGORY",get:function(){return"tremolo"}},{key:"YOFFSETSTEMUP",get:function(){return-9}},{key:"YOFFSETSTEMDOWN",get:function(){return-21}},{key:"XOFFSETSTEMUP",get:function(){return 6}},{key:"XOFFSETSTEMDOWN",get:function(){return-2}}]),gl(e,[{key:"getCategory",value:function(){return e.CATEGORY}},{key:"draw",value:function(){if(this.checkContext(),!this.note||null==this.index)throw new b.RERR("NoAttachedNote","Can't draw Tremolo without a note and index.");this.setRendered();var t=this.note.getStemDirection();this.y_spacing=4*t;var n=this.note.getModifierStartXY(this.position,this.index).x,i=this.note.stem.getExtents().topY,o="gracenotes"===this.note.getCategory()?Us.SCALE:1;i+=t<0?e.YOFFSETSTEMDOWN*o:e.YOFFSETSTEMUP*o,this.font={family:"Arial",size:16*o,weight:""},this.render_options={font_scale:35*o,stroke_px:3,stroke_spacing:10*o},n+=t<0?e.XOFFSETSTEMDOWN:e.XOFFSETSTEMUP;for(var r=0;r<this.num;++r)D.renderGlyph(this.context,n,i,this.render_options.font_scale,this.code),i+=this.y_spacing}}]),e}(_e);function xl(t){return(xl="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function wl(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function kl(t,e){return!e||"object"!==xl(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function Sl(t){return(Sl=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Tl(t,e){return(Tl=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var El=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=kl(this,Sl(e).call(this,t))).setAttribute("type","Crescendo"),n.decrescendo=!1,n.line=t.line||0,n.height=15,b.Merge(n.render_options,{extend_left:0,extend_right:0,y_shift:0}),n}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Tl(t,e)}(e,t),n=e,(i=[{key:"setLine",value:function(t){return this.line=t,this}},{key:"setHeight",value:function(t){return this.height=t,this}},{key:"setDecrescendo",value:function(t){return this.decrescendo=t,this}},{key:"preFormat",value:function(){return this.preFormatted=!0,this}},{key:"draw",value:function(){this.checkContext(),this.setRendered();var t=this.getTickContext(),e=gi.getNextContext(t),n=this.getAbsoluteX(),i=e?e.getX():this.stave.x+this.stave.width,o=this.stave.getYForLine(this.line+-3)+1;!function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];El.DEBUG&&b.L("Vex.Flow.Crescendo",e)}("Drawing ",this.decrescendo?"decrescendo ":"crescendo ",this.height,"x",n-i),function(t,e){var n=e.begin_x,i=e.end_x,o=e.y,r=e.height/2;t.beginPath(),e.reverse?(t.moveTo(n,o-r),t.lineTo(i,o),t.lineTo(n,o+r)):(t.moveTo(i,o-r),t.lineTo(n,o),t.lineTo(i,o+r)),t.stroke(),t.closePath()}(this.context,{begin_x:n-this.render_options.extend_left,end_x:i+this.render_options.extend_right,y:o+this.render_options.y_shift,height:this.height,reverse:this.decrescendo})}}])&&wl(n.prototype,i),o&&wl(n,o),e}($t);function Ol(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Rl(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];Nl.DEBUG&&b.L("Vex.Flow.Parser",e)}var Pl=b.MakeException("ParserError");function Cl(t){return void 0!==t.matchedString?t.matchedString:t.results?Cl(t.results):1===t.length?Cl(t[0]):0===t.length?null:t.map(Cl)}var Nl=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.grammar=e}var e,n,i;return e=t,(n=[{key:"parse",value:function(t){this.line=t,this.pos=0,this.errorPos=-1;var e=this.expect(this.grammar.begin());return e.errorPos=this.errorPos,e}},{key:"matchFail",value:function(t){-1===this.errorPos&&(this.errorPos=this.pos),this.pos=t}},{key:"matchSuccess",value:function(){this.errorPos=-1}},{key:"matchToken",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=e?new RegExp("^(("+t+"))"):new RegExp("^(("+t+")\\s*)"),i=this.line.slice(this.pos),o=i.match(n);return null!==o?{success:!0,matchedString:o[2],incrementPos:o[1].length,pos:this.pos}:{success:!1,pos:this.pos}}},{key:"expectOne",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=[],i=this.pos,o=!0,r=!1;e=!0===e||!0===t.maybe;for(var s=0;s<t.expect.length;s++){var a=t.expect[s],l=this.pos,u=this.expect(a);if(u.success){if(n.push(u),r=!0,t.or)break}else if(o=!1,!t.or){this.pos=l;break}}var c=t.or&&r||o,h=c||!0===e;return e&&!c&&(this.pos=i),h?this.matchSuccess():this.matchFail(i),{success:h,results:n,numMatches:c?1:0}}},{key:"expectOneOrMore",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=[],i=this.pos,o=0,r=!0;do{var s=this.expectOne(t);s.success?(o++,n.push(s.results)):r=!1}while(r);var a=o>0||!0===e;return!e||o>0||(this.pos=i),a?this.matchSuccess():this.matchFail(i),{success:a,results:n,numMatches:o}}},{key:"expectZeroOrMore",value:function(t){return this.expectOneOrMore(t,!0)}},{key:"expect",value:function(t){var e;if(Rl("Evaluating rules:",t),!t)throw new Pl("Invalid Rule: "+t,t);var n=t.bind(this.grammar)();if(n.token)(e=this.matchToken(n.token,!0===n.noSpace)).success&&(this.pos+=e.incrementPos);else{if(!n.expect)throw new Pl("Bad grammar! No `token` or `expect` property",n);e=n.oneOrMore?this.expectOneOrMore(n):n.zeroOrMore?this.expectZeroOrMore(n):this.expectOne(n)}return e.matches=[],e.results&&e.results.forEach((function(t){return e.matches.push(Cl(t))})),n.run&&e.success&&n.run(e),e}}])&&Ol(e.prototype,n),i&&Ol(e,i),t}();function Al(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function Ll(t){return(Ll="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ml(){return(Ml=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t}).apply(this,arguments)}function Fl(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function Bl(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function jl(t,e,n){return e&&Bl(t.prototype,e),n&&Bl(t,n),t}function Dl(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];Hl.DEBUG&&b.L("Vex.Flow.EasyScore",e)}var Il=b.MakeException("EasyScoreError"),Gl=function(){function t(e){Fl(this,t),this.builder=e}return jl(t,[{key:"begin",value:function(){return this.LINE}},{key:"LINE",value:function(){return{expect:[this.PIECE,this.PIECES,this.EOL]}}},{key:"PIECE",value:function(){var t=this;return{expect:[this.CHORDORNOTE,this.PARAMS],run:function(){return t.builder.commitPiece()}}}},{key:"PIECES",value:function(){return{expect:[this.COMMA,this.PIECE],zeroOrMore:!0}}},{key:"PARAMS",value:function(){return{expect:[this.DURATION,this.TYPE,this.DOTS,this.OPTS]}}},{key:"CHORDORNOTE",value:function(){return{expect:[this.CHORD,this.SINGLENOTE],or:!0}}},{key:"CHORD",value:function(){var t=this;return{expect:[this.LPAREN,this.NOTES,this.RPAREN],run:function(e){return t.builder.addChord(e.matches[1])}}}},{key:"NOTES",value:function(){return{expect:[this.NOTE],oneOrMore:!0}}},{key:"NOTE",value:function(){return{expect:[this.NOTENAME,this.ACCIDENTAL,this.OCTAVE]}}},{key:"SINGLENOTE",value:function(){var t=this;return{expect:[this.NOTENAME,this.ACCIDENTAL,this.OCTAVE],run:function(e){return t.builder.addSingleNote(e.matches[0],e.matches[1],e.matches[2])}}}},{key:"ACCIDENTAL",value:function(){return{expect:[this.ACCIDENTALS],maybe:!0}}},{key:"DOTS",value:function(){var t=this;return{expect:[this.DOT],zeroOrMore:!0,run:function(e){return t.builder.setNoteDots(e.matches[0])}}}},{key:"TYPE",value:function(){var t=this;return{expect:[this.SLASH,this.MAYBESLASH,this.TYPES],maybe:!0,run:function(e){return t.builder.setNoteType(e.matches[2])}}}},{key:"DURATION",value:function(){var t=this;return{expect:[this.SLASH,this.DURATIONS],maybe:!0,run:function(e){return t.builder.setNoteDuration(e.matches[1])}}}},{key:"OPTS",value:function(){return{expect:[this.LBRACKET,this.KEYVAL,this.KEYVALS,this.RBRACKET],maybe:!0}}},{key:"KEYVALS",value:function(){return{expect:[this.COMMA,this.KEYVAL],zeroOrMore:!0}}},{key:"KEYVAL",value:function(){var t=this;return{expect:[this.KEY,this.EQUALS,this.VAL],run:function(e){return t.builder.addNoteOption(e.matches[0],e.matches[2].slice(1,-1))}}}},{key:"VAL",value:function(){return{expect:[this.SVAL,this.DVAL],or:!0}}},{key:"KEY",value:function(){return{token:"[a-zA-Z][a-zA-Z0-9]*"}}},{key:"DVAL",value:function(){return{token:'["][^"]*["]'}}},{key:"SVAL",value:function(){return{token:"['][^']*[']"}}},{key:"NOTENAME",value:function(){return{token:"[a-gA-G]"}}},{key:"OCTAVE",value:function(){return{token:"[0-9]+"}}},{key:"ACCIDENTALS",value:function(){return{token:"bbs|bb|bss|bs|b|db|d|##|#|n|\\+\\+-|\\+-|\\+\\+|\\+|k|o"}}},{key:"DURATIONS",value:function(){return{token:"[0-9whq]+"}}},{key:"TYPES",value:function(){return{token:"[rRsSxX]"}}},{key:"LPAREN",value:function(){return{token:"[(]"}}},{key:"RPAREN",value:function(){return{token:"[)]"}}},{key:"COMMA",value:function(){return{token:"[,]"}}},{key:"DOT",value:function(){return{token:"[.]"}}},{key:"SLASH",value:function(){return{token:"[/]"}}},{key:"MAYBESLASH",value:function(){return{token:"[/]?"}}},{key:"EQUALS",value:function(){return{token:"[=]"}}},{key:"LBRACKET",value:function(){return{token:"\\["}}},{key:"RBRACKET",value:function(){return{token:"\\]"}}},{key:"EOL",value:function(){return{token:"$"}}}]),t}(),Yl=function(){function t(e){Fl(this,t),this.factory=e,this.commitHooks=[],this.reset()}return jl(t,[{key:"reset",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.options={stem:"auto",clef:"treble"},this.elements={notes:[],accidentals:[]},this.rollingDuration="8",this.resetPiece(),Ml(this.options,t)}},{key:"getFactory",value:function(){return this.factory}},{key:"getElements",value:function(){return this.elements}},{key:"addCommitHook",value:function(t){this.commitHooks.push(t)}},{key:"resetPiece",value:function(){Dl("resetPiece"),this.piece={chord:[],duration:this.rollingDuration,dots:0,type:void 0,options:{}}}},{key:"setNoteDots",value:function(t){Dl("setNoteDots:",t),t&&(this.piece.dots=t.length)}},{key:"setNoteDuration",value:function(t){Dl("setNoteDuration:",t),this.rollingDuration=this.piece.duration=t||this.rollingDuration}},{key:"setNoteType",value:function(t){Dl("setNoteType:",t),t&&(this.piece.type=t)}},{key:"addNoteOption",value:function(t,e){Dl("addNoteOption: key:",t,"value:",e),this.piece.options[t]=e}},{key:"addNote",value:function(t,e,n){Dl("addNote:",t,e,n),this.piece.chord.push({key:t,accid:e,octave:n})}},{key:"addSingleNote",value:function(t,e,n){Dl("addSingleNote:",t,e,n),this.addNote(t,e,n)}},{key:"addChord",value:function(t){var e=this;Dl("startChord"),"object"!==Ll(t[0])?this.addSingleNote(t[0]):t.forEach((function(t){t&&e.addNote.apply(e,Al(t))})),Dl("endChord")}},{key:"commitPiece",value:function(){var t=this;Dl("commitPiece");var e=this.factory;if(e){var n=Ml({},this.options,this.piece.options),i=n.stem,o=n.clef,r="auto"===i.toLowerCase(),s=r||"up"!==i.toLowerCase()?je.STEM_DOWN:je.STEM_UP,a=this.piece,l=a.chord,u=a.duration,c=a.dots,h=a.type,b=l.map((function(t){return t.key+"/"+t.octave})),f=e.StaveNote({keys:b,duration:u,dots:c,type:h,clef:o,auto_stem:r});r||f.setStemDirection(s);var p=l.map((function(t){return t.accid||null}));p.forEach((function(t,n){t&&f.addAccidental(n,e.Accidental({type:t}))}));for(var y=0;y<c;y++)f.addDotToAll();this.commitHooks.forEach((function(e){return e(n,f,t)})),this.elements.notes.push(f),this.elements.accidentals.concat(p),this.resetPiece()}}}]),t}();function Wl(t,e){var n=t.id;void 0!==n&&e.setAttribute("id",n)}function Xl(t,e){if(t.class){t.class.split(/\s*,\s*/).forEach((function(t){return e.addClass(t)}))}}var Hl=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Fl(this,t),this.setOptions(e),this.defaults={clef:"treble",time:"4/4",stem:"auto"}}return jl(t,[{key:"set",value:function(t){return Ml(this.defaults,t),this}},{key:"setOptions",value:function(t){var e=this;return this.options=Ml({factory:null,builder:null,commitHooks:[Wl,Xl,hi.easyScoreHook],throwOnError:!1},t),this.factory=this.options.factory,this.builder=this.options.builder||new Yl(this.factory),this.grammar=new Gl(this.builder),this.parser=new Nl(this.grammar),this.options.commitHooks.forEach((function(t){return e.addCommitHook(t)})),this}},{key:"setContext",value:function(t){return this.factory&&this.factory.setContext(t),this}},{key:"parse",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};this.builder.reset(e);var n=this.parser.parse(t);if(!n.success&&this.options.throwOnError)throw new Il("Error parsing line: "+t,n);return n}},{key:"beam",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return this.factory.Beam({notes:t,options:e}),t}},{key:"tuplet",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return this.factory.Tuplet({notes:t,options:e}),t}},{key:"notes",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return e=Ml({clef:this.defaults.clef,stem:this.defaults.stem},e),this.parse(t,e),this.builder.getElements().notes}},{key:"voice",value:function(t,e){return e=Ml({time:this.defaults.time},e),this.factory.Voice(e).addTickables(t)}},{key:"addCommitHook",value:function(t){return this.builder.addCommitHook(t)}}]),t}();function Ul(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Vl(){return(Vl=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t}).apply(this,arguments)}var zl=b.MakeException("FactoryError");function Kl(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=arguments.length>1?arguments[1]:void 0,n=e.options;return(t=Vl(e,t)).options=Vl(n,t.options),t}var Jl=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];Jl.DEBUG&&b.L("Vex.Flow.Factory",e)}("New factory: ",e);var n={stave:{space:10},renderer:{context:null,elementId:"",backend:$.Backends.SVG,width:500,height:200,background:"#FFF"},font:{face:"Arial",point:10,style:""}};this.options=n,this.setOptions(e)}var e,n,i;return e=t,i=[{key:"newFromElementId",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:500,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:200;return new t({renderer:{elementId:e,width:n,height:i}})}}],(n=[{key:"reset",value:function(){this.renderQ=[],this.systems=[],this.staves=[],this.voices=[],this.stave=null}},{key:"getOptions",value:function(){return this.options}},{key:"setOptions",value:function(t){for(var e=["stave","renderer","font"],n=0;n<e.length;n++){var i=e[n];Vl(this.options[i],t[i])}(null!==this.options.renderer.elementId||this.options.renderer.context)&&this.initRenderer(),this.reset()}},{key:"initRenderer",value:function(){var t=this.options.renderer,e=t.elementId,n=t.backend,i=t.width,o=t.height,r=t.background;if(""===e)throw new zl("HTML DOM element not set in Factory");this.context=$.buildContext(e,n,i,o,r)}},{key:"getContext",value:function(){return this.context}},{key:"setContext",value:function(t){return this.context=t,this}},{key:"getStave",value:function(){return this.stave}},{key:"getVoices",value:function(){return this.voices}},{key:"space",value:function(t){return this.options.stave.space*t}},{key:"Stave",value:function(t){t=Kl(t,{x:0,y:0,width:this.options.renderer.width-this.space(1),options:{spacing_between_lines_px:this.options.stave.space}});var e=new Mr(t.x,t.y,t.width,t.options);return this.staves.push(e),e.setContext(this.context),this.stave=e,e}},{key:"TabStave",value:function(t){t=Kl(t,{x:0,y:0,width:this.options.renderer.width-this.space(1),options:{spacing_between_lines_px:1.3*this.options.stave.space}});var e=new Gr(t.x,t.y,t.width,t.options);return this.staves.push(e),e.setContext(this.context),this.stave=e,e}},{key:"StaveNote",value:function(t){var e=new je(t);return this.stave&&e.setStave(this.stave),e.setContext(this.context),this.renderQ.push(e),e}},{key:"GhostNote",value:function(t){var e=new fl(t);return this.stave&&e.setStave(this.stave),e.setContext(this.context),this.renderQ.push(e),e}},{key:"TextNote",value:function(t){var e=new Ho(t);return this.stave&&e.setStave(this.stave),e.setContext(this.context),this.renderQ.push(e),e}},{key:"BarNote",value:function(t){t=Kl(t,{type:"single",options:{}});var e=new sl(t.type);return this.stave&&e.setStave(this.stave),e.setContext(this.context),this.renderQ.push(e),e}},{key:"ClefNote",value:function(t){t=Kl(t,{type:"treble",options:{size:"default"}});var e=new ys(t.type,t.options.size,t.options.annotation);return this.stave&&e.setStave(this.stave),e.setContext(this.context),this.renderQ.push(e),e}},{key:"TimeSigNote",value:function(t){t=Kl(t,{time:"4/4",options:{}});var e=new Ps(t.time);return this.stave&&e.setStave(this.stave),e.setContext(this.context),this.renderQ.push(e),e}},{key:"KeySigNote",value:function(t){var e=new ws(t.key,t.cancelKey,t.alterKey);return this.stave&&e.setStave(this.stave),e.setContext(this.context),this.renderQ.push(e),e}},{key:"TabNote",value:function(t){var e=new Kr(t);return this.stave&&e.setStave(this.stave),e.setContext(this.context),this.renderQ.push(e),e}},{key:"GraceNote",value:function(t){var e=new Us(t);return this.stave&&e.setStave(this.stave),e.setContext(this.context),e}},{key:"GraceNoteGroup",value:function(t){var e=new Mn(t.notes,t.slur);return e.setContext(this.context),e}},{key:"Accidental",value:function(t){t=Kl(t,{type:null,options:{}});var e=new rn(t.type);return e.setContext(this.context),e}},{key:"Annotation",value:function(t){t=Kl(t,{text:"p",vJustify:"below",hJustify:"center",fontFamily:"Times",fontSize:14,fontWeight:"bold italic",options:{}});var e=new Ai(t.text);return e.setJustification(t.hJustify),e.setVerticalJustification(t.vJustify),e.setFont(t.fontFamily,t.fontSize,t.fontWeight),e.setContext(this.context),e}},{key:"Articulation",value:function(t){t=Kl(t,{type:"a.",position:"above",options:{}});var e=new hi(t.type);return e.setPosition(t.position),e.setContext(this.context),e}},{key:"TextDynamics",value:function(t){t=Kl(t,{text:"p",duration:"q",dots:0,line:0,options:{}});var e=new Oa({text:t.text,line:t.line,duration:t.duration,dots:t.dots});return this.stave&&e.setStave(this.stave),e.setContext(this.context),this.renderQ.push(e),e}},{key:"Fingering",value:function(t){t=Kl(t,{number:"0",position:"left",options:{}});var e=new He(t.number);return e.setPosition(t.position),e.setContext(this.context),e}},{key:"StringNumber",value:function(t){t=Kl(t,{number:"0",position:"left",options:{}});var e=new Kn(t.number);return e.setPosition(t.position),e.setContext(this.context),e}},{key:"TickContext",value:function(){return(new gi).setContext(this.context)}},{key:"ModifierContext",value:function(){return new Ji}},{key:"MultiMeasureRest",value:function(t){var e=new as(t.number_of_measures,t);return e.setContext(this.context),this.renderQ.push(e),e}},{key:"Voice",value:function(t){t=Kl(t,{time:"4/4",options:{}});var e=new At(t.time);return this.voices.push(e),e}},{key:"StaveConnector",value:function(t){t=Kl(t,{top_stave:null,bottom_stave:null,type:"double",options:{}});var e=new Gt(t.top_stave,t.bottom_stave);return e.setType(t.type).setContext(this.context),this.renderQ.push(e),e}},{key:"Formatter",value:function(){return new eo}},{key:"Tuplet",value:function(t){t=Kl(t,{notes:[],options:{}});var e=new pt(t.notes,t.options).setContext(this.context);return this.renderQ.push(e),e}},{key:"Beam",value:function(t){t=Kl(t,{notes:[],options:{autoStem:!1,secondaryBeamBreaks:[]}});var e=new Tt(t.notes,t.options.autoStem).setContext(this.context);return e.breakSecondaryAt(t.options.secondaryBeamBreaks),this.renderQ.push(e),e}},{key:"Curve",value:function(t){t=Kl(t,{from:null,to:null,options:{}});var e=new ma(t.from,t.to,t.options).setContext(this.context);return this.renderQ.push(e),e}},{key:"StaveTie",value:function(t){t=Kl(t,{from:null,to:null,first_indices:[0],last_indices:[0],text:null,options:{direction:void 0}});var e=new mn({first_note:t.from,last_note:t.to,first_indices:t.first_indices,last_indices:t.last_indices},t.text);return t.options.direction&&e.setDirection(t.options.direction),e.setContext(this.context),this.renderQ.push(e),e}},{key:"StaveLine",value:function(t){t=Kl(t,{from:null,to:null,first_indices:[0],last_indices:[0],options:{}});var e=new Fa({first_note:t.from,last_note:t.to,first_indices:t.first_indices,last_indices:t.last_indices});return t.options.text&&e.setText(t.options.text),t.options.font&&e.setFont(t.options.font),e.setContext(this.context),this.renderQ.push(e),e}},{key:"VibratoBracket",value:function(t){t=Kl(t,{from:null,to:null,options:{harsh:!1}});var e=new es({start:t.from,stop:t.to});return t.options.line&&e.setLine(t.options.line),t.options.harsh&&e.setHarsh(t.options.harsh),e.setContext(this.context),this.renderQ.push(e),e}},{key:"TextBracket",value:function(t){t=Kl(t,{from:null,to:null,text:"",options:{superscript:"",position:1}});var e=new Qa({start:t.from,stop:t.to,text:t.text,superscript:t.options.superscript,position:t.options.position});return t.options.line&&e.setLine(t.options.line),t.options.font&&e.setFont(t.options.font),e.setContext(this.context),this.renderQ.push(e),e}},{key:"System",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};t.factory=this;var e=new ru(t).setContext(this.context);return this.systems.push(e),e}},{key:"EasyScore",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return t.factory=this,new Hl(t)}},{key:"PedalMarking",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};t=Kl(t,{notes:[],options:{style:"mixed"}});var e=new Xa(t.notes);return e.setStyle(Xa.StylesString[t.options.style]),e.setContext(this.context),this.renderQ.push(e),e}},{key:"NoteSubGroup",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};t=Kl(t,{notes:[],options:{}});var e=new fn(t.notes);return e.setContext(this.context),e}},{key:"draw",value:function(){var t=this;this.systems.forEach((function(e){return e.setContext(t.context).format()})),this.staves.forEach((function(e){return e.setContext(t.context).draw()})),this.voices.forEach((function(e){return e.setContext(t.context).draw()})),this.renderQ.forEach((function(e){e.isRendered()||e.setContext(t.context).draw()})),this.systems.forEach((function(e){return e.setContext(t.context).draw()})),this.reset()}}])&&Ul(e.prototype,n),i&&Ul(e,i),t}();function ql(t){return(ql="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ql(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function Zl(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function $l(t,e){return!e||"object"!==ql(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function tu(t,e,n){return(tu="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=eu(t)););return t}(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}})(t,e,n||t)}function eu(t){return(eu=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function nu(t,e){return(nu=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function iu(){return(iu=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t}).apply(this,arguments)}function ou(t,e){var n=e.options;return(t=iu(e,t)).options=iu(n,t.options),t}var ru=function(t){function e(){var t,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return Ql(this,e),(t=$l(this,eu(e).call(this))).setAttribute("type","System"),t.setOptions(n),t.parts=[],t}var n,i,o;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&nu(t,e)}(e,t),n=e,(i=[{key:"setOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.options=ou(t,{x:10,y:10,width:500,connector:null,spaceBetweenStaves:12,factory:null,debugFormatter:!1,formatIterations:0,options:{}}),this.factory=this.options.factory||new Jl({renderer:{el:null}})}},{key:"setContext",value:function(t){return tu(eu(e.prototype),"setContext",this).call(this,t),this.factory.setContext(t),this}},{key:"addConnector",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"double";return this.connector=this.factory.StaveConnector({top_stave:this.parts[0].stave,bottom_stave:this.parts[this.parts.length-1].stave,type:t}),this.connector}},{key:"addStave",value:function(t){var e=this;return(t=ou(t,{stave:null,voices:[],spaceAbove:0,spaceBelow:0,debugNoteMetrics:!1,options:{left_bar:!1}})).stave||(t.stave=this.factory.Stave({x:this.options.x,y:this.options.y,width:this.options.width,options:t.options})),t.voices.forEach((function(n){return n.setContext(e.context).setStave(t.stave).getTickables().forEach((function(e){return e.setStave(t.stave)}))})),this.parts.push(t),t.stave}},{key:"format",value:function(){var t=this,e=new eo;this.formatter=e;var n=this.options.y,i=0,o=[],r=[];this.parts.forEach((function(s){n+=s.stave.space(s.spaceAbove),s.stave.setY(n),e.joinVoices(s.voices),n+=s.stave.space(s.spaceBelow),n+=s.stave.space(t.options.spaceBetweenStaves),s.debugNoteMetrics&&(r.push({y:n,voice:s.voices[0]}),n+=15),o=o.concat(s.voices),i=Math.max(i,s.stave.getNoteStartX())})),this.parts.forEach((function(t){return t.stave.setNoteStartX(i)}));var s=this.options.width-(i-this.options.x)-$t.STAVEPADDING;e.format(o,s);for(var a=0;a<this.options.formatIterations;a++)e.tune();this.startX=i,this.debugNoteMetricsYs=r,this.lastY=n}},{key:"draw",value:function(){var t=this.checkContext();this.setRendered(),this.options.debugFormatter&&eo.plotDebugging(t,this.formatter,this.startX,this.options.y,this.lastY),this.debugNoteMetricsYs.forEach((function(e){e.voice.getTickables().forEach((function(n){return $t.plotMetrics(t,n,e.y)}))}))}}])&&Zl(n.prototype,i),o&&Zl(n,o),e}(S);(b.Flow=G).Element=S,b.Flow.Fraction=y,b.Flow.Renderer=$,b.Flow.Formatter=eo,b.Flow.Music=Ve,b.Flow.Glyph=D,b.Flow.Stave=Mr,b.Flow.StaveNote=je,b.Flow.StaveModifier=lo,b.Flow.StaveTempo=jo,b.Flow.Voice=At,b.Flow.Accidental=rn,b.Flow.Beam=Tt,b.Flow.StaveTie=mn,b.Flow.TabStave=Gr,b.Flow.TabNote=Kr,b.Flow.Bend=Ii,b.Flow.Vibrato=Vi,b.Flow.VibratoBracket=es,b.Flow.Note=$t,b.Flow.ModifierContext=Ji,b.Flow.MultiMeasureRest=as,b.Flow.TickContext=gi,b.Flow.Articulation=hi,b.Flow.Annotation=Ai,b.Flow.Barline=yo,b.Flow.NoteHead=ae,b.Flow.StaveConnector=Gt,b.Flow.ClefNote=ys,b.Flow.KeySignature=hr,b.Flow.KeySigNote=ws,b.Flow.TimeSignature=_r,b.Flow.TimeSigNote=Ps,b.Flow.Stem=at,b.Flow.TabTie=En,b.Flow.Clef=or,b.Flow.Dot=Oe,b.Flow.Modifier=_e,b.Flow.TabSlide=Bs,b.Flow.Tuplet=pt,b.Flow.GraceNote=Us,b.Flow.GraceTabNote=$s,b.Flow.Tuning=ia,b.Flow.KeyManager=ra,b.Flow.StaveHairpin=ba,b.Flow.BoundingBox=P,b.Flow.Stroke=Yn,b.Flow.TextNote=Ho,b.Flow.Curve=ma,b.Flow.TextDynamics=Oa,b.Flow.StaveLine=Fa,b.Flow.Ornament=Ti,b.Flow.PedalMarking=Xa,b.Flow.TextBracket=Qa,b.Flow.FretHandFinger=He,b.Flow.Repetition=ko,b.Flow.BarNote=sl,b.Flow.GhostNote=fl,b.Flow.NoteSubGroup=fn,b.Flow.GraceNoteGroup=Mn,b.Flow.Tremolo=_l,b.Flow.StringNumber=Kn,b.Flow.Crescendo=El,b.Flow.Volta=Or,b.Flow.Font=C,b.Flow.System=ru,b.Flow.Factory=Jl,b.Flow.Parser=Nl,b.Flow.EasyScore=Hl,b.Flow.Registry=_;e.default=b}]).default}));
//# sourceMappingURL=vexflow-debug.js.map

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/music21/articulations.ts":
/*!**************************************!*\
  !*** ./src/music21/articulations.ts ***!
  \**************************************/
/*! exports provided: Articulation, LengthArticulation, DynamicArticulation, PitchArticulation, TimbreArticulation, Accent, StrongAccent, Staccato, Staccatissimo, Spiccato, Marcato, Tenuto */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Articulation", function() { return Articulation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LengthArticulation", function() { return LengthArticulation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DynamicArticulation", function() { return DynamicArticulation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PitchArticulation", function() { return PitchArticulation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimbreArticulation", function() { return TimbreArticulation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Accent", function() { return Accent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StrongAccent", function() { return StrongAccent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Staccato", function() { return Staccato; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Staccatissimo", function() { return Staccatissimo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Spiccato", function() { return Spiccato; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Marcato", function() { return Marcato; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tenuto", function() { return Tenuto; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vexflow */ "./node_modules/vexflow/releases/vexflow-debug.js");
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vexflow__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _prebase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./prebase */ "./src/music21/prebase.ts");



/**
 * articulations module. See {@link music21.articulations} namespace
 *
 * @namespace music21.articulations
 * @memberof music21
 * @requires music21/prebase
 * @requires vexflow
 * @requires music21/common
 */



/**
 * Represents a single articulation, usually in the `.articulations` Array
 * on a {@link music21.note.Note} or something like that.
 *
 * @class Articulation
 * @memberof music21.articulations
 * @property {string} name
 * @property {string} [placement='above']
 * @property {string|undefined} vexflowModifier - the string code to get this accidental in Vexflow
 * @property {number} [dynamicScale=1.0] - multiplier for the dynamic of a note that this is attached to
 * @property {number} [lengthScale=1.0] - multiplier for the length of a note that this is attached to.
 */

class Articulation extends _prebase__WEBPACK_IMPORTED_MODULE_4__["ProtoM21Object"] {
  constructor() {
    super(...arguments);
    this.placement = 'above';
    this.dynamicScale = 1.0;
    this.lengthScale = 1.0;
  }

  static get className() {
    return 'music21.articulation.Articulation';
  }
  /**
   * Generates a Vex.Flow.Articulation for this articulation.
   *
   * @returns {Vex.Flow.Articulation}
   */


  vexflow() {
    var vfa = new vexflow__WEBPACK_IMPORTED_MODULE_2___default.a.Flow.Articulation(this.vexflowModifier);

    if (this.setPosition) {
      vfa.setPosition(this.setPosition);
    }

    return vfa;
  }

}
/**
 * base class for articulations that change the length of a note...
 *
 * @class LengthArticulation
 * @memberof music21.articulations
 */

class LengthArticulation extends Articulation {
  static get className() {
    return 'music21.articulation.LengthArticulation';
  }

  constructor() {
    super();
    this.name = 'length-articulation';
  }

}
/**
 * base class for articulations that change the dynamic of a note...
 *
 * @class DynamicArticulation
 * @memberof music21.articulations
 */

class DynamicArticulation extends Articulation {
  static get className() {
    return 'music21.articulation.DynamicArticulation';
  }

  constructor() {
    super();
    this.name = 'dynamic-articulation';
  }

}
/**
 * base class for articulations that change the pitch of a note...
 *
 * @class PitchArticulation
 * @memberof music21.articulations
 */

class PitchArticulation extends Articulation {
  static get className() {
    return 'music21.articulation.PitchArticulation';
  }

  constructor() {
    super();
    this.name = 'pitch-articulation';
  }

}
/**
 * base class for articulations that change the timbre of a note...
 *
 * @class TimbreArticulation
 * @memberof music21.articulations
 */

class TimbreArticulation extends Articulation {
  static get className() {
    return 'music21.articulation.TimbreArticulation';
  }

  constructor() {
    super();
    this.name = 'timbre-articulation';
  }

}
/**
 * 50% louder than usual
 *
 * @class Accent
 * @memberof music21.articulations
 */

class Accent extends DynamicArticulation {
  static get className() {
    return 'music21.articulation.Accent';
  }

  constructor() {
    super();
    this.name = 'accent';
    this.vexflowModifier = 'a>';
    this.dynamicScale = 1.5;
  }

}
/**
 * 100% louder than usual
 *
 * @class StrongAccent
 * @memberof music21.articulations
 */

class StrongAccent extends Accent {
  static get className() {
    return 'music21.articulation.StrongAccent';
  }

  constructor() {
    super();
    this.name = 'strong accent';
    this.vexflowModifier = 'a^';
    this.dynamicScale = 2.0;
  }

}
/**
 * no playback for now.
 *
 * @class Staccato
 * @memberof music21.articulations
 */

class Staccato extends LengthArticulation {
  static get className() {
    return 'music21.articulation.Staccato';
  }

  constructor() {
    super();
    this.name = 'staccato';
    this.vexflowModifier = 'a.';
  }

}
/**
 * no playback for now.
 *
 * @class Staccatissimo
 * @memberof music21.articulations
 */

class Staccatissimo extends Staccato {
  static get className() {
    return 'music21.articulation.Staccatissimo';
  }

  constructor() {
    super();
    this.name = 'staccatissimo';
    this.vexflowModifier = 'av';
  }

}
/**
 * no playback or display for now.
 *
 * @class Spiccato
 * @memberof music21.articulations
 */

class Spiccato extends Staccato {
  static get className() {
    return 'music21.articulation.Spiccato';
  }

  constructor() {
    super();
    this.name = 'spiccato';
    this.vexflowModifier = undefined;
  }

}
/**
 * @class Marcato
 * @memberof music21.articulations
 *
 * is both a DynamicArticulation and a LengthArticulation
 * TODO(msc): check that `.classes` reflects that
 */

class Marcato extends DynamicArticulation {
  static get className() {
    return 'music21.articulation.Marcato';
  }

  constructor() {
    super();
    _common__WEBPACK_IMPORTED_MODULE_3__["mixin"](LengthArticulation, this);
    this.name = 'marcato';
    this.vexflowModifier = 'a^';
    this.dynamicScale = 1.7;
  }

}
/**
 * @class Tenuto
 * @memberof music21.articulations
 */

class Tenuto extends LengthArticulation {
  static get className() {
    return 'music21.articulation.Tenuto';
  }

  constructor() {
    super();
    this.name = 'tenuto';
    this.vexflowModifier = 'a-';
  }

}

/***/ }),

/***/ "./src/music21/audioRecording.ts":
/*!***************************************!*\
  !*** ./src/music21/audioRecording.ts ***!
  \***************************************/
/*! exports provided: Recorder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Recorder", function() { return Recorder; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_buffer_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array-buffer.slice */ "./node_modules/core-js/modules/es.array-buffer.slice.js");
/* harmony import */ var core_js_modules_es_array_buffer_slice__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_buffer_slice__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.typed-array.uint8-array */ "./node_modules/core-js/modules/es.typed-array.uint8-array.js");
/* harmony import */ var core_js_modules_es_typed_array_uint8_array__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_uint8_array__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.typed-array.to-locale-string */ "./node_modules/core-js/modules/es.typed-array.to-locale-string.js");
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_to_locale_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.url */ "./node_modules/core-js/modules/web.url.js");
/* harmony import */ var core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _audioSearch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./audioSearch */ "./src/music21/audioSearch.ts");








/**
 * Adopted from Matt Diamond's recorder.js code MIT License
 */

class Recorder {
  constructor() {
    var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.recording = false;
    var config = cfg || {};
    this.bufferLen = config.bufferLen || 4096;
    this.config = config;
    this.recording = false;
    this.currCallback = undefined;
    this.audioContext = _audioSearch__WEBPACK_IMPORTED_MODULE_7__["config"].audioContext;
    this.frequencyCanvasInfo = {
      id: 'frequencyAnalyser',
      width: undefined,
      height: undefined,
      canvasContext: undefined,
      animationFrameID: undefined
    };
    this.waveformCanvasInfo = {
      id: 'waveformCanvas',
      width: undefined,
      height: undefined,
      canvasContext: undefined
    };
    this.analyserNode = undefined;
    /**
     *
     * @type {BaseAudioContext|undefined}
     */

    this.context = undefined;
  }
  /**
   * Start here -- polyfills navigator, runs getUserMedia and then sends to audioStreamConnected
   */


  initAudio() {
    var constraints = {
      audio: {
        echoCancellation: false,
        autoGainControl: false,
        noiseSuppression: false
      },
      video: false
    };
    navigator.mediaDevices.getUserMedia(constraints).then(s => this.audioStreamConnected(s)).catch(error => {
      console.log('Error getting audio -- try on google Chrome?');
      console.log(error);
    });
  }
  /**
   * After the user has given permission to record, this method is called.
   * It creates a gain point, and then connects the input source to the gain.
   * It connects an analyserNode (fftSize 2048) to the gain.
   *
   * It creates a second gain of 0.0 connected to the destination, so that
   * we're not hearing what we're playing in in an infinite loop (SUCKS to turn this off...)
   *
   * And it calls this.connectSource on the inputPoint so that
   * we can do something with all these wonderful inputs.
   */


  audioStreamConnected(stream) {
    /**
     *
     * @type {GainNode}
     */
    var inputPoint = this.audioContext.createGain(); // Create an AudioNode from the stream.

    var audioInput = this.audioContext.createMediaStreamSource(stream);
    audioInput.connect(inputPoint);
    var analyserNode = this.audioContext.createAnalyser();
    analyserNode.fftSize = _audioSearch__WEBPACK_IMPORTED_MODULE_7__["config"].fftSize;
    this.analyserNode = analyserNode;
    inputPoint.connect(analyserNode);
    this.connectSource(inputPoint);
    var zeroGain = this.audioContext.createGain();
    zeroGain.gain.value = 0.0;
    inputPoint.connect(zeroGain);
    zeroGain.connect(this.audioContext.destination);
  }
  /**
   * Creates a worker to receive and process all the messages asynchronously.
   *
   * @param {GainNode} source;
   */


  connectSource(source) {
    /**
     *
      * @type {BaseAudioContext}
     */
    var context = source.context;
    this.context = context;
    this.setNode(); // create a Worker with inline code...

    var workerBlob = new Blob(['(', recorderWorkerJs, ')()'], {
      type: 'application/javascript'
    });
    var workerURL = URL.createObjectURL(workerBlob);
    this.worker = new Worker(workerURL);
    /**
     * When worker sends a message, we just send it to the currentCallback...
     */

    this.worker.onmessage = e => {
      var blob = e.data;
      this.currCallback(blob);
    };

    URL.revokeObjectURL(workerURL);
    this.worker.postMessage({
      command: 'init',
      config: {
        sampleRate: this.context.sampleRate
      }
    });
    /**
     * Whenever the ScriptProcessorNode receives enough audio to process
     * (i.e., this.bufferLen stereo samples; default 4096), then it calls onaudioprocess
     * which is set up to send the event's .getChannelData to the WebWorker via a
     * postMessage.
     *
     * The 'record' command sends no message back.
     */
    // should be replaced by workers somehow.

    this.node.onaudioprocess = e => {
      if (!this.recording) {
        return;
      }

      this.worker.postMessage({
        command: 'record',
        buffer: [e.inputBuffer.getChannelData(0), e.inputBuffer.getChannelData(1)]
      });
    };

    source.connect(this.node);
    /**
     * polyfill for Chrome error.
     *
     * if the ScriptProcessorNode (this.node) is not connected to an output
     * the "onaudioprocess" event is not triggered in Chrome.
     */

    this.node.connect(this.context.destination);
  }
  /**
   * Creates a ScriptProcessorNode (preferably) to allow for direct audio processing.
   *
   * Sets it to this.node and returns it.
   */


  setNode() {
    var numInputChannels = 2;
    var numOutputChannels = 2;
    this.node = this.context.createScriptProcessor(this.bufferLen, numInputChannels, numOutputChannels);
    return this.node;
  }
  /**
   * Configure from another source...
   */


  configure(cfg) {
    for (var prop in cfg) {
      if (Object.hasOwnProperty.call(cfg, prop)) {
        this.config[prop] = cfg[prop];
      }
    }
  }

  record() {
    this.recording = true;
  }

  stop() {
    this.recording = false;
  }

  clear() {
    this.worker.postMessage({
      command: 'clear'
    });
  }
  /**
   * Directly get the buffers from the worker and then call cb.
   */


  getBuffers(cb) {
    this.currCallback = cb || this.config.callback;
    this.worker.postMessage({
      command: 'getBuffers'
    });
  }
  /**
   * call exportWAV or exportMonoWAV on the worker, then call cb or (if undefined) setupDownload.
   */


  exportWAV(cb, type, isMono) {
    var command = 'exportWAV';

    if (isMono === true) {
      // default false
      command = 'exportMonoWAV';
    }

    this.currCallback = cb || this.config.callback;
    type = type || this.config.type || 'audio/wav';

    if (!this.currCallback) {
      this.currCallback = blob => {
        this.setupDownload(blob, 'myRecording' + Date.now().toString() + '.wav');
      };
    }

    this.worker.postMessage({
      command,
      type
    });
  }

  exportMonoWAV(cb, type) {
    this.exportWAV(cb, type, true);
  }

  setupDownload(blob) {
    var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'output.wav';
    var elementId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'save';
    var url = (window.URL || window.webkitURL).createObjectURL(blob);
    var link = document.getElementById(elementId);
    link.href = url;
    link.download = filename;
  }

  setContextForCanvasInfo(canvasInfo) {
    if (canvasInfo.canvasContext) {
      return;
    }

    var canvas = document.getElementById(canvasInfo.id);

    if (!canvas) {
      return;
    }

    canvasInfo.width = canvas.width;
    canvasInfo.height = canvas.height;
    canvasInfo.canvasContext = canvas.getContext('2d');
  }
  /**
   * Update the Analysers.
   *
   * @param {number} [time]
   */


  updateAnalysers(time) {
    this.setContextForCanvasInfo(this.frequencyCanvasInfo); // analyser draw code here

    var SPACING = 3;
    var BAR_WIDTH = 1;
    var numBars = Math.round(this.frequencyCanvasInfo.width / SPACING);
    var freqByteData = new Uint8Array(this.analyserNode.frequencyBinCount);
    this.analyserNode.getByteFrequencyData(freqByteData);
    var canvasContext = this.frequencyCanvasInfo.canvasContext;
    canvasContext.clearRect(0, 0, this.frequencyCanvasInfo.width, this.frequencyCanvasInfo.height);
    canvasContext.fillStyle = '#F6D565';
    canvasContext.lineCap = 'round';
    var multiplier = this.analyserNode.frequencyBinCount / numBars; // Draw rectangle for each frequency bin.

    for (var i = 0; i < numBars; ++i) {
      var magnitude = 0;
      var offset = Math.floor(i * multiplier);

      for (var j = 0; j < multiplier; j++) {
        magnitude += freqByteData[offset + j];
      }

      magnitude = magnitude * (this.frequencyCanvasInfo.height / 256) / multiplier;
      canvasContext.fillStyle = 'hsl( ' + Math.round(i * 360 / numBars) + ', 100%, 50%)';
      canvasContext.fillRect(i * SPACING, this.frequencyCanvasInfo.height, BAR_WIDTH, -1 * magnitude);
    }

    this.frequencyCanvasInfo.animationFrameID = window.requestAnimationFrame(t => this.updateAnalysers(t));
  }
  /**
   *
   * @param {number[][]} buffers
   */


  drawWaveformCanvas(buffers) {
    var data = buffers[0]; // one track of stereo recording.

    this.setContextForCanvasInfo(this.waveformCanvasInfo);
    var context = this.waveformCanvasInfo.canvasContext;
    var step = Math.ceil(data.length / this.waveformCanvasInfo.width);
    var amp = this.waveformCanvasInfo.height / 2;
    context.fillStyle = 'silver';
    context.clearRect(0, 0, this.waveformCanvasInfo.width, this.waveformCanvasInfo.height);

    for (var i = 0; i < this.waveformCanvasInfo.width; i++) {
      var min = 1.0;
      var max = -1.0;

      for (var j = 0; j < step; j++) {
        var datum = data[i * step + j];

        if (datum < min) {
          min = datum;
        }

        if (datum > max) {
          max = datum;
        }
      }

      context.fillRect(i, (1 + min) * amp, 1, Math.max(1, (max - min) * amp));
    }
  }
  /**
   * set this as a callback from getBuffers.  Returns the source so that a stop() command
   * is possible.
   */


  playBuffers(buffers) {
    var channels = 2;
    var numFrames = buffers[0].length;
    var audioBuffer = this.context.createBuffer(channels, numFrames, this.context.sampleRate);

    for (var channel = 0; channel < channels; channel++) {
      var thisChannelBuffer = audioBuffer.getChannelData(channel);

      for (var i = 0; i < numFrames; i++) {
        thisChannelBuffer[i] = buffers[channel][i];
      }
    }

    var source = this.context.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(this.context.destination);
    source.start();
    return source;
  }

}
/**
 * This code does NOT go through babel, so no arrow functions, let, const, etc.
 */

var recorderWorkerJs = "function recorderWorkerJs() {\n    /**\n     *\n     *   Rewritten from Matt Diamond's recorderWorker -- MIT License\n     */\n    RecorderWorker = function RecorderWorker(parentContext) {\n            this.parent = parentContext;\n            this.recLength = 0;\n            this.recBuffersL = [];\n            this.recBuffersR = [];\n            this.sampleRate = undefined;\n    };\n    RecorderWorker.prototype.onmessage = function onmessage(e) {\n            switch (e.data.command) {\n            case 'init':\n                this.init(e.data.config);\n                break;\n            case 'record':\n                this.record(e.data.buffer);\n                break;\n            case 'exportWAV':\n                this.exportWAV(e.data.type);\n                break;\n            case 'exportMonoWAV':\n                this.exportMonoWAV(e.data.type);\n                break;\n            case 'getBuffers':\n                this.getBuffers();\n                break;\n            case 'clear':\n                this.clear();\n                break;\n            default:\n                break;\n            }\n   };\n   RecorderWorker.prototype.postMessage = function postMessage(msg) {\n            this.parent.postMessage(msg);\n   };\n\n   RecorderWorker.prototype.init = function init(config) {\n            this.sampleRate = config.sampleRate;\n   };\n\n   RecorderWorker.prototype.record = function record(inputBuffer) {\n            var inputBufferL = inputBuffer[0];\n            var inputBufferR = inputBuffer[1];\n            this.recBuffersL.push(inputBufferL);\n            this.recBuffersR.push(inputBufferR);\n            this.recLength += inputBufferL.length;\n   };\n\n   RecorderWorker.prototype.exportWAV = function exportWAV(type) {\n            var bufferL = this.mergeBuffers(this.recBuffersL);\n            var bufferR = this.mergeBuffers(this.recBuffersR);\n            var interleaved = this.interleave(bufferL, bufferR);\n            var dataview = this.encodeWAV(interleaved);\n            var audioBlob = new Blob([dataview], { 'type': type });\n\n            this.postMessage(audioBlob);\n   };\n\n   RecorderWorker.prototype.exportMonoWAV = function exportMonoWAV(type) {\n            var bufferL = this.mergeBuffers(this.recBuffersL);\n            var dataview = this.encodeWAV(bufferL);\n            var audioBlob = new Blob([dataview], { 'type': type });\n\n            this.postMessage(audioBlob);\n   };\n\n   RecorderWorker.prototype.mergeBuffers = function mergeBuffers(recBuffers) {\n            var result = new Float32Array(this.recLength);\n            var offset = 0;\n            for (var i = 0; i < recBuffers.length; i++) {\n                result.set(recBuffers[i], offset);\n                offset += recBuffers[i].length;\n            }\n            return result;\n    };\n\n    RecorderWorker.prototype.getBuffers = function getBuffers() {\n            var buffers = [];\n            buffers.push(this.mergeBuffers(this.recBuffersL));\n            buffers.push(this.mergeBuffers(this.recBuffersR));\n            this.postMessage(buffers);\n        };\n\n    RecorderWorker.prototype.clear = function clear() {\n            this.recLength = 0;\n            this.recBuffersL = [];\n            this.recBuffersR = [];\n        }\n\n    RecorderWorker.prototype.interleave = function interleave(inputL, inputR) {\n            var combinedLength = inputL.length + inputR.length;\n            var result = new Float32Array(combinedLength);\n\n            var index = 0;\n            var inputIndex = 0;\n\n            while (index < combinedLength) {\n                result[index++] = inputL[inputIndex];\n                result[index++] = inputR[inputIndex];\n                inputIndex++;\n            }\n            return result;\n        }\n    RecorderWorker.prototype.encodeWAV = function encodeWAV(samples, mono) {\n            var buffer = new ArrayBuffer(44 + (samples.length * 2));\n            var view = new DataView(buffer);\n\n            /* RIFF identifier */\n            writeString(view, 0, 'RIFF');\n\n            /* file length */\n            view.setUint32(4, 32 + samples.length * 2, true);\n\n            /* RIFF type */\n            writeString(view, 8, 'WAVE');\n\n            /* format chunk identifier */\n            writeString(view, 12, 'fmt ');\n\n            /* format chunk length */\n            view.setUint32(16, 16, true);\n\n            /* sample format (raw) */\n            view.setUint16(20, 1, true);\n\n            /* channel count */\n            view.setUint16(22, mono ? 1 : 2, true);\n\n            /* sample rate */\n            view.setUint32(24, this.sampleRate, true);\n\n            /* byte rate (sample rate * block align) */\n            view.setUint32(28, this.sampleRate * 4, true);\n\n            /* block align (channel count * bytes per sample) */\n            view.setUint16(32, 4, true);\n\n            /* bits per sample */\n            view.setUint16(34, 16, true);\n\n            /* data chunk identifier */\n            writeString(view, 36, 'data');\n\n            /* data chunk length */\n            view.setUint32(40, samples.length * 2, true);\n\n            floatTo16BitPCM(view, 44, samples);\n\n            return view;\n        }\n\n    function floatTo16BitPCM(output, offset, input) {\n        for (var i = 0; i < input.length; i++, offset += 2) {\n            var s = Math.max(-1, Math.min(1, input[i]));\n            output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);\n        }\n    }\n\n    function writeString(view, offset, string) {\n        for (var i = 0; i < string.length; i++) {\n            view.setUint8(offset + i, string.charCodeAt(i));\n        }\n    }\n\n    var recordWorker = new RecorderWorker(this);\n    this.onmessage = (function mainOnMessage(e) { recordWorker.onmessage(e) }).bind(this);\n}";

/***/ }),

/***/ "./src/music21/audioSearch.ts":
/*!************************************!*\
  !*** ./src/music21/audioSearch.ts ***!
  \************************************/
/*! exports provided: config, getUserMedia, userMediaStarted, animateLoop, smoothPitchExtraction, sampleCallback, autoCorrelate, midiNumDiffFromFrequency */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserMedia", function() { return getUserMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userMediaStarted", function() { return userMediaStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animateLoop", function() { return animateLoop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "smoothPitchExtraction", function() { return smoothPitchExtraction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sampleCallback", function() { return sampleCallback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autoCorrelate", function() { return autoCorrelate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "midiNumDiffFromFrequency", function() { return midiNumDiffFromFrequency; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_buffer_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array-buffer.slice */ "./node_modules/core-js/modules/es.array-buffer.slice.js");
/* harmony import */ var core_js_modules_es_array_buffer_slice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_buffer_slice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_typed_array_float32_array__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.typed-array.float32-array */ "./node_modules/core-js/modules/es.typed-array.float32-array.js");
/* harmony import */ var core_js_modules_es_typed_array_float32_array__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_float32_array__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.typed-array.to-locale-string */ "./node_modules/core-js/modules/es.typed-array.to-locale-string.js");
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_to_locale_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! midicube */ "./node_modules/midicube/releases/midicube.js");
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(midicube__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");








function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * audioSearch module. See {@link music21.audioSearch} namespace
 *
 * @exports music21/audioSearch
 * @namespace music21.audioSearch
 * @memberof music21
 * @requires music21/pitch
 * @requires music21/common
 */

 // functions based on the prototype created by Chris Wilson's MIT License version
// and on Jordi Bartolome Guillen's audioSearch module for music21
// TODO(msc): Rewrite as a class -- config is just a class in disguise

class _ConfigSingletonCreator {
  constructor() {
    this.fftSize = 2048;
    this._audioContext = null;
    this.animationFrameCallbackId = -1;
    this.sampleBuffer = null;
    this.minFrequency = 55;
    this.maxFrequency = 1050;
    this.pitchSmoothingSize = 40;
    this.lastPitchClassesDetected = [];
    this.lastPitchesDetected = [];
    this.lastCentsDeviationsDetected = [];
    this.AudioContextCaller = window.AudioContext || window.webkitAudioContext;
  }

  get audioContext() {
    if (this._audioContext !== null) {
      return this._audioContext;
    } else {
      // AudioContext should be a singleton, but MIDI reports loaded before it is!
      if (midicube__WEBPACK_IMPORTED_MODULE_7__ !== undefined && midicube__WEBPACK_IMPORTED_MODULE_7__["WebAudio"] !== undefined && midicube__WEBPACK_IMPORTED_MODULE_7__["WebAudio"].getContext() !== undefined) {
        window.globalAudioContext = midicube__WEBPACK_IMPORTED_MODULE_7__["WebAudio"].getContext();
      } else if (typeof window.globalAudioContext === 'undefined') {
        window.globalAudioContext = new this.AudioContextCaller();
      }

      this._audioContext = window.globalAudioContext;
      return this._audioContext;
    }
  }

  set audioContext(ac) {
    this._audioContext = ac;
  }

}

var config = new _ConfigSingletonCreator();
/**
 * Note: audioRecording uses the newer getUserMedia routines, so
 * this should be ported to be similar to there.
 *
 * @function music21.audioSearch.getUserMedia
 * @memberof music21.audioSearch
 * @param {Object} dictionary - optional dictionary to fill
 * @param {function} callback - callback on success
 * @param {function} error - callback on error
 */

function getUserMedia(dictionary, callback, error) {
  if (error === undefined) {
    /* eslint no-alert: "off"*/
    error = () => {
      alert('navigator.getUserMedia either not defined (Safari, IE) or denied.');
    };
  }

  if (callback === undefined) {
    callback = mediaStream => {
      userMediaStarted(mediaStream);
    };
  }

  var n = navigator; // need to polyfill navigator, or binding problems are hard...
  // noinspection JSUnresolvedVariable

  n.getUserMedia = n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia;

  if (n.getUserMedia === undefined) {
    error();
  }

  if (dictionary === undefined) {
    dictionary = {
      audio: {
        mandatory: {},
        optional: []
      }
    };
  }

  n.getUserMedia(dictionary, callback, error);
}
function userMediaStarted(audioStream) {
  /**
   * This function which patches Safari requires some time to get started
   * so we call it on object creation.
   */
  config.sampleBuffer = new Float32Array(config.fftSize / 2);
  var mediaStreamSource = config.audioContext.createMediaStreamSource(audioStream);
  var analyser = config.audioContext.createAnalyser();
  analyser.fftSize = config.fftSize;
  mediaStreamSource.connect(analyser);
  config.currentAnalyser = analyser;
  animateLoop();
}
var animateLoop = () => {
  config.currentAnalyser.getFloatTimeDomainData(config.sampleBuffer); // returns best frequency or -1

  var frequencyDetected = autoCorrelate(config.sampleBuffer, config.audioContext.sampleRate, config.minFrequency, config.maxFrequency);
  var retValue = sampleCallback(frequencyDetected); // callback can be anything.
  // noinspection JSIncompatibleTypesComparison

  if (retValue !== -1) {
    config.animationFrameCallbackId = window.requestAnimationFrame(animateLoop);
  }
};
function smoothPitchExtraction(frequency) {
  if (frequency === -1) {
    config.lastPitchClassesDetected.shift();
    config.lastPitchesDetected.shift();
    config.lastCentsDeviationsDetected.shift();
  } else {
    var _midiNumDiffFromFrequ = midiNumDiffFromFrequency(frequency),
        _midiNumDiffFromFrequ2 = _slicedToArray(_midiNumDiffFromFrequ, 2),
        midiNum = _midiNumDiffFromFrequ2[0],
        _centsOff = _midiNumDiffFromFrequ2[1];

    if (config.lastPitchClassesDetected.length > config.pitchSmoothingSize) {
      config.lastPitchClassesDetected.shift();
      config.lastPitchesDetected.shift();
      config.lastCentsDeviationsDetected.shift();
    }

    config.lastPitchClassesDetected.push(midiNum % 12);
    config.lastPitchesDetected.push(midiNum);
    config.lastCentsDeviationsDetected.push(_centsOff);
  }

  var mostCommonPitchClass = _common__WEBPACK_IMPORTED_MODULE_8__["statisticalMode"](config.lastPitchClassesDetected);

  if (mostCommonPitchClass === null) {
    return [-1, 0];
  }

  var pitchesMatchingClass = [];
  var centsMatchingClass = [];

  for (var i = 0; i < config.lastPitchClassesDetected.length; i++) {
    if (config.lastPitchClassesDetected[i] === mostCommonPitchClass) {
      pitchesMatchingClass.push(config.lastPitchesDetected[i]);
      centsMatchingClass.push(config.lastCentsDeviationsDetected[i]);
    }
  }

  var mostCommonPitch = _common__WEBPACK_IMPORTED_MODULE_8__["statisticalMode"](pitchesMatchingClass); // find cents difference; weighing more recent samples more...

  var totalSamplePoints = 0;
  var totalSample = 0;

  for (var j = 0; j < centsMatchingClass.length; j++) {
    var weight = Math.pow(j, 2) + 1;
    totalSample += weight * centsMatchingClass[j];
    totalSamplePoints += weight;
  }

  var centsOff = Math.floor(totalSample / totalSamplePoints);
  return [mostCommonPitch, centsOff];
}
function sampleCallback(frequency) {
  // noinspection JSUnusedLocalSymbols
  var _smoothPitchExtractio = smoothPitchExtraction(frequency),
      _smoothPitchExtractio2 = _slicedToArray(_smoothPitchExtractio, 2),
      unused_midiNum = _smoothPitchExtractio2[0],
      unused_centsOff = _smoothPitchExtractio2[1];

  return 0;
} // from Chris Wilson. Replace with Jordi's

function autoCorrelate(buf, sampleRate, minFrequency, maxFrequency) {
  var SIZE = buf.length;
  var MAX_SAMPLES = Math.floor(SIZE / 2);

  if (minFrequency === undefined) {
    minFrequency = 0;
  }

  if (maxFrequency === undefined) {
    maxFrequency = sampleRate;
  }

  var best_offset = -1;
  var best_correlation = 0;
  var rms = 0;
  var foundGoodCorrelation = false;
  var correlations = new Array(MAX_SAMPLES);

  for (var i = 0; i < SIZE; i++) {
    var val = buf[i];
    rms += val * val;
  }

  rms = Math.sqrt(rms / SIZE);

  if (rms < 0.01) {
    return -1;
  } // not enough signal


  var lastCorrelation = 1;

  for (var offset = 0; offset < MAX_SAMPLES; offset++) {
    var correlation = 0;
    var offsetFrequency = sampleRate / offset;

    if (offsetFrequency < minFrequency) {
      break;
    }

    if (offsetFrequency > maxFrequency) {
      continue;
    }

    for (var _i2 = 0; _i2 < MAX_SAMPLES; _i2++) {
      correlation += Math.abs(buf[_i2] - buf[_i2 + offset]);
    }

    correlation = 1 - correlation / MAX_SAMPLES;
    correlations[offset] = correlation; // store it, for the tweaking we need to do below.

    if (correlation > 0.9 && correlation > lastCorrelation) {
      foundGoodCorrelation = true;

      if (correlation > best_correlation) {
        best_correlation = correlation;
        best_offset = offset;
      }
    } else if (foundGoodCorrelation) {
      // short-circuit - we found a good correlation, then a bad one, so we'd just be seeing copies from here.
      // Now we need to tweak the offset - by interpolating between the values to the left and right of the
      // best offset, and shifting it a bit.  This is complex, and HACKY in this code (happy to take PRs!) -
      // we need to do a curve fit on correlations[] around best_offset in order to better determine precise
      // (anti-aliased) offset.
      // we know best_offset >=1,
      // since foundGoodCorrelation cannot go to true until the second pass (offset=1), and
      // we can't drop into this clause until the following pass (else if).
      var shift = (correlations[best_offset + 1] - correlations[best_offset - 1]) / correlations[best_offset];
      return sampleRate / (best_offset + 8 * shift);
    }

    lastCorrelation = correlation;
  }

  if (best_correlation > 0.01) {
    // console.log("f = " + sampleRate/best_offset + "Hz (rms: " + rms + " confidence: " + best_correlation + ")")
    return sampleRate / best_offset;
  }

  return -1; //  var best_frequency = sampleRate/best_offset;
}
/**
 *
 * @function midiNumDiffFromFrequency
 * @param {Number} frequency
 * @returns {Array<int>} [miniNumber, centsOff]
 */

function midiNumDiffFromFrequency(frequency) {
  var midiNumFloat = 12 * (Math.log(frequency / 440) / Math.log(2)) + 69;
  var midiNum = Math.round(midiNumFloat);
  var centsOff = Math.round(100 * (midiNumFloat - midiNum));
  return [midiNum, centsOff];
}

/***/ }),

/***/ "./src/music21/bar.ts":
/*!****************************!*\
  !*** ./src/music21/bar.ts ***!
  \****************************/
/*! exports provided: BarException, Barline, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BarException", function() { return BarException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Barline", function() { return Barline; });
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");
/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/bar -- Barline objects
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–19, Michael Scott Cuthbert and cuthbertLab
 *
 */


var barTypeList = ['regular', 'dotted', 'dashed', 'heavy', 'double', 'final', 'heavy-light', 'heavy-heavy', 'tick', 'short', 'none'];
var barTypeDict = {
  'light-light': 'double',
  'light-heavy': 'final'
};
var reverseBarTypeDict = {
  'double': 'light-light',
  'final': 'light-heavy'
};
class BarException extends _exceptions21__WEBPACK_IMPORTED_MODULE_1__["Music21Exception"] {}

function typeToMusicXMLBarStyle(value) {
  if (reverseBarTypeDict[value] !== undefined) {
    return reverseBarTypeDict[value];
  } else {
    return value;
  }
}

function standardizeBarType() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'regular';
  value = value.toLowerCase();

  if (barTypeList.includes(value)) {
    return value;
  }

  if (barTypeDict[value] !== undefined) {
    return barTypeDict[value];
  }

  throw new BarException("cannot process style: ".concat(value));
}

class Barline extends _base__WEBPACK_IMPORTED_MODULE_0__["Music21Object"] {
  constructor() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'regular';
    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    super();
    this.type = type;
    this.location = location; // left, right, middle, None
  }

  static get className() {
    return 'music21.bar.Barline';
  }

  get type() {
    return this._type;
  }

  set type(v) {
    this._type = standardizeBarType(v);
  }

  musicXMLBarStyle() {
    return typeToMusicXMLBarStyle(this.type);
  }

}
/* harmony default export */ __webpack_exports__["default"] = (Barline);

/***/ }),

/***/ "./src/music21/base.ts":
/*!*****************************!*\
  !*** ./src/music21/base.ts ***!
  \*****************************/
/*! exports provided: Music21Object */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Music21Object", function() { return Music21Object; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _derivation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./derivation */ "./src/music21/derivation.ts");
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./duration */ "./src/music21/duration.ts");
/* harmony import */ var _editorial__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./editorial */ "./src/music21/editorial.ts");
/* harmony import */ var _prebase__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./prebase */ "./src/music21/prebase.ts");
/* harmony import */ var _sites__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./sites */ "./src/music21/sites.ts");
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");








function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/base -- objects in base in music21p routines
 *
 * does not load the other modules.
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–19, Michael Scott Cuthbert and cuthbertLab
 *
 * module for Music21Objects, see {@link music21.base}
 *
 * @requires music21/common
 * @requires music21/duration
 * @requires music21/prebase
 * @requires music21/sites
 * @exports music21/base
 * @namespace music21.base
 * @memberof music21
 */







/**
 * Base class for any object that can be placed in a {@link Stream}.
 *
 * @property {Stream} [activeSite] - hardlink to a
 *     {@link Stream} containing the element.
 * @property {number} classSortOrder - Default sort order for this class
 *     (default 20; override in other classes). Lower numbered objects will sort
 *     before other objects in the staff if priority and offset are the same.
 * @property {music21.duration.Duration} duration - the duration (object) for
 *     the element. (can be set with a quarterLength also)
 * @property {string[]} groups - An Array of strings representing group
 *     (equivalent to css classes) to assign to the object. (default [])
 * @property {boolean} isMusic21Object - true
 * @property {boolean} isStream - false
 * @property {number} offset - offset from the beginning of the stream (in quarterLength)
 * @property {number} priority - The priority (lower = earlier or more left) for
 *     elements at the same offset. (default 0)
 */

class Music21Object extends _prebase__WEBPACK_IMPORTED_MODULE_11__["ProtoM21Object"] {
  // beat, measureNumber, etc.
  // lots to do...
  constructor() {
    var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    this.classSortOrder = 20; // default;

    this._activeSiteStoredOffset = 0;
    this._naiveOffset = 0;
    this._priority = 0;
    this.id = 0;
    this.groups = []; // custom object in m21p

    this.isMusic21Object = true;
    this.isStream = false;
    this._duration = new _duration__WEBPACK_IMPORTED_MODULE_9__["Duration"](0.0);
    this.id = _sites__WEBPACK_IMPORTED_MODULE_12__["getId"](this);
    this.sites = new _sites__WEBPACK_IMPORTED_MODULE_12__["Sites"]();
    this._cloneCallbacks._activeSite = false;
    this._cloneCallbacks._activeSiteStoredOffset = false;

    this._cloneCallbacks._derivation = function Music21Music21Object_cloneCallbacks_derivation(keyName, newObj, self, deep, memo) {
      var newDerivation = new _derivation__WEBPACK_IMPORTED_MODULE_8__["Derivation"](newObj);
      newDerivation.origin = self;
      newDerivation.method = 'clone';
      newObj[keyName] = newDerivation;
    }; // noinspection JSUnusedLocalSymbols


    this._cloneCallbacks.sites = function Music21Object_cloneCallbacks_sites(keyName, newObj, self, deep, memo) {
      newObj.sites = new _sites__WEBPACK_IMPORTED_MODULE_12__["Sites"]();
    };
  }

  static get className() {
    return 'music21.base.Music21Object';
  }
  /**
   * Override clone on prebase to add a derivation.
   */


  clone() {
    var deep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var memo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var ret = super.clone(deep, memo);
    var newDerivation = new _derivation__WEBPACK_IMPORTED_MODULE_8__["Derivation"](ret);
    newDerivation.origin = this;
    newDerivation.method = 'clone'; // '__deepcopy__' in m21p

    ret.derivation = newDerivation;
    return ret;
  }

  stringInfo() {
    var id16 = this.id;

    if (typeof id16 === 'number') {
      var idNumber = id16;
      id16 = idNumber.toString(16);

      while (id16.length < 4) {
        id16 = '0' + id16;
      }

      id16 = '0x' + id16;
    }

    return id16;
  }

  get activeSite() {
    return this._activeSite;
  }

  set activeSite(site) {
    if (site === undefined) {
      this._activeSite = undefined;
      this._activeSiteStoredOffset = undefined;
    } else {
      var offset;

      try {
        offset = site.elementOffset(this);
      } catch (e) {
        throw new _sites__WEBPACK_IMPORTED_MODULE_12__["SitesException"]('activeSite cannot be set for an object not in the stream');
      }

      this._activeSite = site;
      this._activeSiteStoredOffset = offset;
    }
  }

  get derivation() {
    if (this._derivation === undefined) {
      this._derivation = new _derivation__WEBPACK_IMPORTED_MODULE_8__["Derivation"](this);
    }

    return this._derivation;
  }

  set derivation(newDerivation) {
    this._derivation = newDerivation;
  }

  get editorial() {
    if (this._editorial === undefined) {
      this._editorial = new _editorial__WEBPACK_IMPORTED_MODULE_10__["Editorial"]();
    }

    return this._editorial;
  }

  set editorial(newEditorial) {
    this._editorial = newEditorial;
  }

  get hasEditorialInformation() {
    return this._editorial !== undefined;
  }

  get measureNumber() {
    if (this.activeSite !== undefined && this.activeSite.classes.includes('Measure')) {
      var activeMeasure = this.activeSite;
      return activeMeasure.number;
    } else {
      var m = this.sites.getObjByClass('Measure');

      if (m !== undefined) {
        return m.number;
      } else {
        return undefined;
      }
    }
  }

  get offset() {
    if (this.activeSite === undefined) {
      return this._naiveOffset;
    } else {
      return this.activeSite.elementOffset(this);
    }
  }

  set offset(newOffset) {
    if (this.activeSite === undefined) {
      this._naiveOffset = newOffset;
    } else {
      this.activeSite.setElementOffset(this, newOffset);
    }
  }

  get priority() {
    return this._priority;
  }

  set priority(p) {
    this._priority = p;
  }

  get duration() {
    return this._duration;
  }

  set duration(newDuration) {
    if (typeof newDuration === 'object') {
      this._duration = newDuration; // common errors below...
    } else if (typeof newDuration === 'number') {
      this._duration.quarterLength = newDuration;
    } else if (typeof newDuration === 'string') {
      this._duration.type = newDuration;
    }
  }

  get quarterLength() {
    return this.duration.quarterLength;
  }

  set quarterLength(ql) {
    this.duration.quarterLength = ql;
  }

  mergeAttributes(other) {
    // id;
    this.groups = other.groups.slice();
    return this;
  }
  /**
   * Return the offset of this element in a given site -- use .offset if you are sure that
   * site === activeSite.
   *
   * Raises an Error if not in site.
   *
   * Does not change activeSite or .offset
   *
   * @param {Stream} site
   * @param {boolean} [stringReturns=false] -- allow strings to be returned
   * @returns {number|string|undefined}
   */


  getOffsetBySite() {
    var site = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var stringReturns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (site === undefined) {
      return this._naiveOffset;
    }

    return site.elementOffset(this, stringReturns);
  }
  /**
   * setOffsetBySite - sets the offset for a given Stream
   *
   * @param {Stream} site Stream object
   * @param {number} value offset
   */


  setOffsetBySite(site, value) {
    if (site !== undefined) {
      site.setElementOffset(this, value);
    } else {
      this._naiveOffset = value;
    }
  }
  /**
   * For an element which may not be in site, but might be in a Stream
   * in site (or further in streams), find the cumulative offset of the
   * clement in that site.
   *
   * See also music21.stream.iterator.RecursiveIterator.currentHierarchyOffset for
   * a method that is about 10x faster when running through a recursed stream.
   *
   * @param {Stream} site
   * @returns {number|undefined}
   */


  getOffsetInHierarchy(site) {
    try {
      return this.getOffsetBySite(site);
    } catch (e) {} // eslint-disable-line no-empty
    // noinspection JSUnusedLocalSymbols


    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.contextSites()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 3),
            csSite = _step$value[0],
            csOffset = _step$value[1],
            unused_csRecursionType = _step$value[2];

        if (csSite === site) {
          return csOffset;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    throw new Error("Element ".concat(this, " is not in hierarchy of ").concat(site));
  } // ---------- Contexts -------------


  getContextByClass(className) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var params = {
      getElementMethod: 'getElementAtOrBefore',
      sortByCreationTime: false
    };
    _common__WEBPACK_IMPORTED_MODULE_7__["merge"](params, options);
    var getElementMethod = params.getElementMethod;
    var sortByCreationTime = params.sortByCreationTime;

    if (className !== undefined && !(className instanceof Array)) {
      className = [className];
    }

    if (getElementMethod.includes('At') && this.isClassOrSubclass(className)) {
      return this;
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this.contextSites({
        returnSortTuples: true,
        sortByCreationTime
      })[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _step2$value = _slicedToArray(_step2.value, 3),
            site = _step2$value[0],
            positionStart = _step2$value[1],
            searchType = _step2$value[2];

        if (getElementMethod.includes('At') && site.isClassOrSubclass(className)) {
          return site;
        }

        if (searchType === 'elementsOnly' || searchType === 'elementsFirst') {
          var contextEl = getContextByClassPayloadExtractor(site, false, positionStart, getElementMethod, className);

          if (contextEl !== undefined) {
            return contextEl;
          }
        } else if (searchType !== 'elementsOnly') {
          if (getElementMethod.includes('After') && (className === undefined || site.isClassOrSubclass(className))) {
            if (!getElementMethod.includes('NotSelf') && this !== site) {
              return site;
            }
          }

          var _contextEl = getContextByClassPayloadExtractor(site, 'semiFlat', positionStart, getElementMethod, className);

          if (_contextEl !== undefined) {
            return _contextEl;
          }

          if (getElementMethod.includes('Before') && (className === undefined || site.isClassOrSubclass(className))) {
            if (!getElementMethod.includes('NotSelf') || this !== site) {
              return site;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return undefined;
  }

  contextSites() {
    var _arguments = arguments,
        _this = this;

    return (
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var options, params, memo, streamThis, recursionType, topLevel, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, siteObj, offsetInStream, newOffset, positionInStream, _recursionType, newParams, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, _step6$value, topLevelInner, inStreamPos, recurType, inStreamOffset, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, derivedObject, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _step5$value, derivedSite, derivedOffset, derivedRecurseType, offsetAdjustedCsTuple;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                params = {
                  callerFirst: undefined,
                  memo: new Map(),
                  offsetAppend: 0.0,
                  sortByCreationTime: false,
                  priorityTarget: undefined,
                  returnSortTuples: false,
                  followDerivation: true
                };
                _common__WEBPACK_IMPORTED_MODULE_7__["merge"](params, options);
                memo = params.memo;

                if (!(params.callerFirst === undefined)) {
                  _context.next = 12;
                  break;
                }

                params.callerFirst = _this;

                if (!(_this.isStream && !memo.has(_this))) {
                  _context.next = 11;
                  break;
                }

                streamThis = _this;
                recursionType = streamThis.recursionType;
                _context.next = 11;
                return [_this, 0.0, recursionType];

              case 11:
                memo.set(_this, true);

              case 12:
                if (params.priorityTarget === undefined && !params.sortByCreationTime) {
                  params.priorityTarget = _this.activeSite;
                }

                topLevel = _this;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context.prev = 17;
                _iterator3 = _this.sites.yieldSites(params.sortByCreationTime, params.priorityTarget, true // excludeNone
                )[Symbol.iterator]();

              case 19:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context.next = 73;
                  break;
                }

                siteObj = _step3.value;

                if (!memo.has(siteObj)) {
                  _context.next = 23;
                  break;
                }

                return _context.abrupt("continue", 70);

              case 23:
                if (!siteObj.classes.includes('SpannerStorage')) {
                  _context.next = 25;
                  break;
                }

                return _context.abrupt("continue", 70);

              case 25:
                // let offset = this.getOffsetBySite(siteObj);
                // followDerivation;
                offsetInStream = void 0;
                _context.prev = 26;
                offsetInStream = siteObj.elementOffset(_this);
                _context.next = 34;
                break;

              case 30:
                _context.prev = 30;
                _context.t0 = _context["catch"](26);
                console.error("".concat(_this + '', " is not in ").concat(siteObj + ''));
                return _context.abrupt("continue", 70);

              case 34:
                newOffset = offsetInStream + params.offsetAppend;
                positionInStream = newOffset;
                _recursionType = siteObj.recursionType;
                _context.next = 39;
                return [siteObj, positionInStream, _recursionType];

              case 39:
                memo.set(siteObj, true);
                newParams = {
                  callerFirst: params.callerFirst,
                  memo,
                  offsetAppend: positionInStream,
                  returnSortTuples: true,
                  sortByCreationTime: params.sortByCreationTime
                };
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context.prev = 44;
                _iterator6 = siteObj.contextSites(newParams)[Symbol.iterator]();

              case 46:
                if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                  _context.next = 56;
                  break;
                }

                _step6$value = _slicedToArray(_step6.value, 3), topLevelInner = _step6$value[0], inStreamPos = _step6$value[1], recurType = _step6$value[2];
                inStreamOffset = inStreamPos; // .offset;
                // const hypotheticalPosition = inStreamOffset; // more complex w/ sortTuples

                if (memo.has(topLevelInner)) {
                  _context.next = 53;
                  break;
                }

                _context.next = 52;
                return [topLevelInner, inStreamOffset, recurType];

              case 52:
                memo.set(topLevelInner, true);

              case 53:
                _iteratorNormalCompletion6 = true;
                _context.next = 46;
                break;

              case 56:
                _context.next = 62;
                break;

              case 58:
                _context.prev = 58;
                _context.t1 = _context["catch"](44);
                _didIteratorError6 = true;
                _iteratorError6 = _context.t1;

              case 62:
                _context.prev = 62;
                _context.prev = 63;

                if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                  _iterator6.return();
                }

              case 65:
                _context.prev = 65;

                if (!_didIteratorError6) {
                  _context.next = 68;
                  break;
                }

                throw _iteratorError6;

              case 68:
                return _context.finish(65);

              case 69:
                return _context.finish(62);

              case 70:
                _iteratorNormalCompletion3 = true;
                _context.next = 19;
                break;

              case 73:
                _context.next = 79;
                break;

              case 75:
                _context.prev = 75;
                _context.t2 = _context["catch"](17);
                _didIteratorError3 = true;
                _iteratorError3 = _context.t2;

              case 79:
                _context.prev = 79;
                _context.prev = 80;

                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }

              case 82:
                _context.prev = 82;

                if (!_didIteratorError3) {
                  _context.next = 85;
                  break;
                }

                throw _iteratorError3;

              case 85:
                return _context.finish(82);

              case 86:
                return _context.finish(79);

              case 87:
                if (!params.followDerivation) {
                  _context.next = 139;
                  break;
                }

                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context.prev = 91;
                _iterator4 = topLevel.derivation.chain()[Symbol.iterator]();

              case 93:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context.next = 125;
                  break;
                }

                derivedObject = _step4.value;
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context.prev = 98;
                _iterator5 = derivedObject.contextSites({
                  callerFirst: undefined,
                  memo,
                  offsetAppend: 0.0,
                  returnSortTuples: true,
                  sortByCreationTime: params.sortByCreationTime
                })[Symbol.iterator]();

              case 100:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context.next = 108;
                  break;
                }

                _step5$value = _slicedToArray(_step5.value, 3), derivedSite = _step5$value[0], derivedOffset = _step5$value[1], derivedRecurseType = _step5$value[2];
                offsetAdjustedCsTuple = [derivedSite, derivedOffset + params.offsetAppend, derivedRecurseType];
                _context.next = 105;
                return offsetAdjustedCsTuple;

              case 105:
                _iteratorNormalCompletion5 = true;
                _context.next = 100;
                break;

              case 108:
                _context.next = 114;
                break;

              case 110:
                _context.prev = 110;
                _context.t3 = _context["catch"](98);
                _didIteratorError5 = true;
                _iteratorError5 = _context.t3;

              case 114:
                _context.prev = 114;
                _context.prev = 115;

                if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                  _iterator5.return();
                }

              case 117:
                _context.prev = 117;

                if (!_didIteratorError5) {
                  _context.next = 120;
                  break;
                }

                throw _iteratorError5;

              case 120:
                return _context.finish(117);

              case 121:
                return _context.finish(114);

              case 122:
                _iteratorNormalCompletion4 = true;
                _context.next = 93;
                break;

              case 125:
                _context.next = 131;
                break;

              case 127:
                _context.prev = 127;
                _context.t4 = _context["catch"](91);
                _didIteratorError4 = true;
                _iteratorError4 = _context.t4;

              case 131:
                _context.prev = 131;
                _context.prev = 132;

                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                  _iterator4.return();
                }

              case 134:
                _context.prev = 134;

                if (!_didIteratorError4) {
                  _context.next = 137;
                  break;
                }

                throw _iteratorError4;

              case 137:
                return _context.finish(134);

              case 138:
                return _context.finish(131);

              case 139:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[17, 75, 79, 87], [26, 30], [44, 58, 62, 70], [63,, 65, 69], [80,, 82, 86], [91, 127, 131, 139], [98, 110, 114, 122], [115,, 117, 121], [132,, 134, 138]]);
      })()
    );
  }
  /*
      Given an object and a number, run append that many times on
      a deepcopy of the object.
      numberOfTimes should of course be a positive integer.
       a = stream.Stream()
      n = note.Note('D--')
      n.duration.type = 'whole'
      a.repeatAppend(n, 10)
  */


  repeatAppend(item, numberOfTimes) {
    var unused = null;

    try {
      unused = item.isStream;
    } catch (AttributeError) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_13__["StreamException"]('to put a non Music21Object in a stream, ' + 'create a music21.ElementWrapper for the item');
    }

    for (var i = 0; i < numberOfTimes; i++) {
      this.append(item.clone(true));
    }
  }

}

function getContextByClassPayloadExtractor(useSite, flatten, // true, false, or semiflat
positionStart, getElementMethod, classList) {
  // this should all be done as a tree...
  // do not use .flat or .semiFlat so as not
  // to create new sites.
  // VERY HACKY...
  var lastElement;
  var useSiteElements = useSite.elements; // we want sorting.

  for (var i = 0; i < useSiteElements.length; i++) {
    var thisElement = useSiteElements[i];
    var matchClass = thisElement.isClassOrSubclass(classList);

    if (flatten === false && !matchClass) {
      continue;
    } else if (!thisElement.isStream && !matchClass) {
      continue;
    }

    var indexOffset = useSite.elementOffset(thisElement); // thisElement is a stream or has the appropriate class...
    // first check normal elements

    if (getElementMethod.includes('Before') && indexOffset >= positionStart) {
      if (getElementMethod.includes('At') && lastElement === undefined) {
        lastElement = thisElement;
      } else if (lastElement !== undefined && lastElement.isClassOrSubclass(classList)) {
        lastElement.activeSite = useSite;
        return lastElement;
      } else if (matchClass) {
        thisElement.activeSite = useSite;
        return thisElement;
      }
    } else {
      lastElement = thisElement;
    }

    if (getElementMethod.includes('After') && indexOffset > positionStart && matchClass) {
      thisElement.activeSite = useSite;
      return thisElement;
    } // now check stream... already filtered out flatten == false;


    if (thisElement.isStream) {
      var potentialElement = getContextByClassPayloadExtractor(thisElement, flatten, positionStart + indexOffset, getElementMethod, classList);

      if (potentialElement !== undefined) {
        return potentialElement;
      }
    }
  }

  if (lastElement !== undefined && lastElement.isClassOrSubclass(classList)) {
    lastElement.activeSite = useSite;
    return lastElement;
  } else {
    return undefined;
  }
} // TODO(msc) -- ElementWrapper

/***/ }),

/***/ "./src/music21/beam.ts":
/*!*****************************!*\
  !*** ./src/music21/beam.ts ***!
  \*****************************/
/*! exports provided: validBeamTypes, beamableDurationTypes, Beam, Beams */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validBeamTypes", function() { return validBeamTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "beamableDurationTypes", function() { return beamableDurationTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Beam", function() { return Beam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Beams", function() { return Beams; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony import */ var _prebase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./prebase */ "./src/music21/prebase.ts");
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./duration */ "./src/music21/duration.ts");






/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/beam -- Beams and Beam class
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–19, Michael Scott Cuthbert and cuthbertLab
 *
 * Module holding beam materials. See {@link music21.beam} namespace.
 * {@link music21.beam.Beam} and {music21.beam.Beams} objects
 *
 * @exports music21/beam
 * @namespace music21.beam
 * @memberof music21
 * @requires music21/prebase
 * @requires music21/duration
 */



var validBeamTypes = {
  start: true,
  stop: true,
  continue: true,
  partial: true
};
var beamableDurationTypes = [_duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][8], _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][16], _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][32], _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][64], _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][128], _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][256]];
/**
 * Object representing a single beam (e.g., a 16th note that is beamed needs two)
 *
 * @class Beam
 * @memberof music21.beam
 * @param {string} type - "start", "stop", "continue", "partial"
 * @param {string} direction - only needed for partial beams: "left" or "right"
 * @property {number|undefined} number - which beam line does this refer to;
 *     8th = 1, 16th = 2, etc.
 * @property {number|undefined} independentAngle - the angle of this beam
 *     if it is different than others (feathered beams)
 */

class Beam extends _prebase__WEBPACK_IMPORTED_MODULE_6__["ProtoM21Object"] {
  constructor(type) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    super();
    this.type = type;
    this.direction = direction;
  }

  static get className() {
    return 'music21.beam.Beam';
  }

}
/**
 * Object representing a collection of Beams
 *
 * @class Beams
 * @memberof music21.beam
 * @property {Beam[]} beamsList - a list of Beam objects
 * @property {boolean} [feathered=false] - is this a feathered beam.
 * @property {number} length - length of beamsList
 */

class Beams extends _prebase__WEBPACK_IMPORTED_MODULE_6__["ProtoM21Object"] {
  constructor() {
    super(...arguments);
    this.beamsList = [];
    this.feathered = false;
  }

  static get className() {
    return 'music21.beam.Beams';
  }

  static naiveBeams(srcList) {
    var beamsList = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = srcList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var el = _step.value;

        if (!beamableDurationTypes.includes(el.duration.type)) {
          beamsList.push(undefined);
        } else if (el.isRest) {
          beamsList.push(undefined);
        } else {
          var b = new Beams();
          b.fill(el.duration.type);
          beamsList.push(b);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return beamsList;
  }

  static removeSandwichedUnbeamables(beamsList) {
    var beamLast;
    var beamNext;

    for (var i = 0; i < beamsList.length; i++) {
      if (i !== beamsList.length - 1) {
        beamNext = beamsList[i + 1];
      } else {
        beamNext = undefined;
      }

      if (beamLast === undefined && beamNext === undefined) {
        beamsList[i] = undefined;
      }

      beamLast = beamsList[i];
    }

    return beamsList;
  }

  static sanitizePartialBeams(beamsList) {
    for (var i = 0; i < beamsList.length; i++) {
      if (beamsList[i] === undefined) {
        continue;
      }

      var allTypes = beamsList[i].getTypes();

      if (!allTypes.includes('start') && !allTypes.includes('stop') && !allTypes.includes('continue')) {
        // nothing but partials;
        beamsList[i] = undefined;
        continue;
      }

      var hasStart = false;
      var hasStop = false;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = beamsList[i].beamsList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var b = _step2.value;

          if (b.type === 'start') {
            hasStart = true;
            continue;
          }

          if (b.type === 'stop') {
            hasStop = true;
            continue;
          }

          if (hasStart && b.type === 'partial' && b.direction === 'left') {
            b.direction = 'right';
          } else if (hasStop && b.type === 'partial' && b.direction === 'right') {
            b.direction = 'left';
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    return beamsList;
  }

  static mergeConnectingPartialBeams(beamsList) {
    for (var i = 0; i < beamsList.length - 1; i++) {
      var bThis = beamsList[i];
      var bNext = beamsList[i + 1];

      if (!bThis || !bNext) {
        continue;
      }

      var bThisNum = bThis.getNumbers();

      if (!bThisNum || bThisNum.length === 0) {
        continue;
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = bThisNum[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var thisNum = _step3.value;
          var thisBeam = bThis.getByNumber(thisNum);

          if (thisBeam.type !== 'partial' || thisBeam.direction !== 'right') {
            continue;
          }

          if (!bNext.getNumbers().includes(thisNum)) {
            continue;
          }

          var nextBeam = bNext.getByNumber(thisNum);

          if (nextBeam.type === 'partial' || nextBeam.direction === 'right') {
            continue;
          }

          if (nextBeam.type === 'continue' || nextBeam.type === 'stop') {
            // should not happen.
            continue;
          }

          thisBeam.type = 'start';
          thisBeam.direction = undefined;

          if (nextBeam.type === 'partial') {
            nextBeam.type = 'stop';
          } else if (nextBeam.type === 'start') {
            nextBeam.type = 'continue';
          }

          nextBeam.direction = undefined;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    } // now fix partial-lefts that follow stops:


    for (var _i = 1; _i < beamsList.length; _i++) {
      var _bThis = beamsList[_i];
      var bPrev = beamsList[_i - 1];

      if (!_bThis || !bPrev) {
        continue;
      }

      var _bThisNum = _bThis.getNumbers();

      if (!_bThisNum || _bThisNum.length === 0) {
        continue;
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = _bThisNum[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _thisNum = _step4.value;

          var _thisBeam = _bThis.getByNumber(_thisNum);

          if (_thisBeam.type !== 'partial' || _thisBeam.direction !== 'left') {
            continue;
          }

          if (!bPrev.getNumbers().includes(_thisNum)) {
            continue;
          }

          var prevBeam = bPrev.getByNumber(_thisNum);

          if (prevBeam.type !== 'stop') {
            continue;
          }

          _thisBeam.type = 'stop';
          _thisBeam.direction = undefined;
          prevBeam.type = 'continue';
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }

    return beamsList;
  }

  get length() {
    return this.beamsList.length;
  }
  /**
   * Append a new {@link Beam} object to this Beams, automatically creating the Beam
   *   object and incrementing the number count.
   *
   * @param {string} type - the type (passed to {@link Beam})
   * @param {string} [direction=undefined] - the direction if type is "partial"
   * @returns {Beam} newly appended object
   */


  append(type) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var obj = new Beam(type, direction);
    obj.number = this.beamsList.length + 1;
    this.beamsList.push(obj);
    return obj;
  }
  /**
   * A quick way of setting the beams list for a particular duration, for
          instance, fill("16th") will clear the current list of beams in the
          Beams object and add two beams.  fill(2) will do the same (though note
          that that is an int, not a string).
    * It does not do anything to the direction that the beams are going in,
          or by default.  Either set type here or call setAll() on the Beams
          object afterwards.
    * Both "eighth" and "8th" work.  Adding more than six beams (i.e. things
          like 512th notes) raises an error.
    * @param {string|number} level - either a string like "eighth" or a number like 1 (="eighth")
   * @param {string} [type] - type to fill all beams to.
   * @returns {this}
   */


  fill(level) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    this.beamsList = [];
    var count = 1;

    if (level === 1 || level === '8th' || level === _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][8]) {
      count = 1;
    } else if (level === 2 || level === _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][16]) {
      count = 2;
    } else if (level === 3 || level === _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][32]) {
      count = 3;
    } else if (level === 4 || level === _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][64]) {
      count = 4;
    } else if (level === 5 || level === _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][128]) {
      count = 5;
    } else if (level === 6 || level === _duration__WEBPACK_IMPORTED_MODULE_7__["typeFromNumDict"][256]) {
      count = 6;
    } else {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_5__["Music21Exception"]('cannot fill beams for level ' + level);
    }

    for (var i = 1; i <= count; i++) {
      var obj = new Beam(type);
      obj.number = i;
      this.beamsList.push(obj);
    }

    return this;
  }
  /**
   * Get the beam with the given number or throw an exception.
   *
   * @param {number} number - the beam number to retrieve (usually one less than the position in `.beamsList`)
   * @returns {Beam|undefined}
   */


  getByNumber(number) {
    if (!this.getNumbers().includes(number)) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_5__["Music21Exception"]('beam number error: ' + number);
    }

    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = this.beamsList[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var thisBeam = _step5.value;

        if (thisBeam.number === number) {
          return thisBeam;
        }
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    return undefined;
  }
  /**
   * Get an Array of all the numbers for the beams
   *
   * @returns {Array<number>} all the numbers
   */


  getNumbers() {
    var numbers = [];
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = this.beamsList[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var thisBeam = _step6.value;
        numbers.push(thisBeam.number);
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    return numbers;
  }
  /**
   * Returns the type + "-" + direction (if direction is defined)
   * for the beam with the given number.
   *
   * @param {number} number
   * @returns {string|undefined}
   */


  getTypeByNumber(number) {
    var beamObj = this.getByNumber(number);

    if (beamObj === undefined) {
      return undefined;
    }

    if (beamObj.direction === undefined) {
      return beamObj.type;
    } else {
      var x = beamObj.type + '-' + beamObj.direction;
      return x;
    }
  }
  /**
   * Get an Array of all the types for the beams
   *
   * @returns {Array<string>} all the types
   */


  getTypes() {
    var types = [];

    for (var i = 0; i < this.length; i++) {
      types.push(this.beamsList[i].type);
    }

    return types;
  }
  /**
   * Set all the {@link Beam} objects to a given type/direction
   *
   * @param {string} type - beam type
   * @param {string} [direction] - beam direction
   * @returns {this}
   */


  setAll(type) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    if (validBeamTypes[type] === undefined) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_5__["Music21Exception"]('invalid beam type: ' + type);
    }

    for (var i = 0; i < this.length; i++) {
      var b = this.beamsList[i];
      b.type = type;
      b.direction = direction;
    }

    return this;
  }
  /**
   * Set the {@link Beam} object specified by `number` to a given type/direction
   *
   * @param {number} number
   * @param {string} type
   * @param {string} [direction]
   * @returns {this}
   */


  setByNumber(number, type) {
    var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    if (direction === undefined) {
      var splitIt = type.split('-');
      type = splitIt[0];
      direction = splitIt[1]; // not unpacking because. can be undefined...
    }

    if (validBeamTypes[type] === undefined) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_5__["Music21Exception"]('invalid beam type: ' + type);
    }

    for (var i = 0; i < this.length; i++) {
      if (this.beamsList[i].number === number) {
        this.beamsList[i].type = type;
        this.beamsList[i].direction = direction;
      }
    }

    return this;
  }

}

/***/ }),

/***/ "./src/music21/chord.ts":
/*!******************************!*\
  !*** ./src/music21/chord.ts ***!
  \******************************/
/*! exports provided: chordTables, Chord, chordDefinitions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Chord", function() { return Chord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chordDefinitions", function() { return chordDefinitions; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.sort */ "./node_modules/core-js/modules/es.array.sort.js");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! vexflow */ "./node_modules/vexflow/releases/vexflow-debug.js");
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(vexflow__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! midicube */ "./node_modules/midicube/releases/midicube.js");
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(midicube__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony import */ var _interval__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./interval */ "./src/music21/interval.ts");
/* harmony import */ var _note__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./note */ "./src/music21/note.ts");
/* harmony import */ var _chordTables__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./chordTables */ "./src/music21/chordTables.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "chordTables", function() { return _chordTables__WEBPACK_IMPORTED_MODULE_13__; });









/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/chord -- Chord
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–19, Michael Scott Cuthbert and cuthbertLab
 *
 * chord Module. See {@link music21.chord} namespace for more details.
 * Chord related objects (esp. {@link music21.chord.Chord}) and methods.
 *
 * @exports music21/chord
 * @namespace music21.chord
 * @memberof music21
 * @requires vexflow
 * @requires music21/interval
 * @requires music21/note
 */







/**
 * Chord related objects (esp. {@link music21.chord.Chord}) and methods.
 *
 * @class Chord
 * @memberof music21.chord
 * @param {Array<string|note.Note|Pitch>} [notes] -
 *     an Array of strings
 *     (see {@link Pitch} for valid formats), note.Note,
 *     or pitch.Pitch objects.
 * @extends music21.note.NotRest
 * @property {number} length - the number of pitches in the Chord (readonly)
 * @property {Pitch[]} pitches - an Array of Pitch objects in the
 *     chord. (Consider the Array read only and pass in a new Array to change)
 * @property {Boolean} [isChord=true]
 * @property {Boolean} [isNote=false]
 * @property {Boolean} [isRest=false]
 */

class Chord extends _note__WEBPACK_IMPORTED_MODULE_12__["NotRest"] {
  constructor() {
    var notes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    super();
    this._notes = [];
    this.isChord = true; // for speed

    this.isNote = false; // for speed

    this.isRest = false; // for speed

    this._overrides = {};
    this._cache = {};
    this._chordTablesAddress = undefined;
    this._chordTablesAddressNeedsUpdating = true; // only update when needed

    if (typeof notes === 'undefined') {
      notes = [];
    } else if (typeof notes === 'string') {
      notes = notes.split(/\s+/);
    }

    notes.forEach(x => this.add(x, false), this);

    if (notes.length > 0 && notes[0].duration !== undefined && notes[0].duration.quarterLength !== this.duration.quarterLength) {
      this.duration = notes[0].duration;
    }

    this.sortPitches();
  }

  static get className() {
    return 'music21.chord.Chord';
  }

  stringInfo() {
    var info = this.pitches.map(x => x.nameWithOctave);
    return info.join(' ');
  }

  get length() {
    return this._notes.length;
  } // Typescript restriction... preventing full allowing of set pitches()
  // to take string[] or Note[].
  // https://github.com/microsoft/TypeScript/issues/2521


  get pitches() {
    var tempPitches = [];

    for (var i = 0; i < this._notes.length; i++) {
      tempPitches.push(this._notes[i].pitch);
    }

    return tempPitches;
  }

  set pitches(tempPitches) {
    this._notes = [];

    for (var i = 0; i < tempPitches.length; i++) {
      var addNote = void 0;

      if (typeof tempPitches[i] === 'string') {
        addNote = new _note__WEBPACK_IMPORTED_MODULE_12__["Note"](tempPitches[i]);
      } else if (tempPitches[i].isClassOrSubclass('Pitch')) {
        addNote = new _note__WEBPACK_IMPORTED_MODULE_12__["Note"]();
        addNote.pitch = tempPitches[i];
      } else if (tempPitches[i].isClassOrSubclass('Note')) {
        addNote = tempPitches[i];
      } else {
        console.warn('bad pitch', tempPitches[i]);
        throw new _exceptions21__WEBPACK_IMPORTED_MODULE_10__["Music21Exception"]('Cannot add pitch from ' + tempPitches[i]);
      }

      this._notes.push(addNote);
    }

    this._cache = {};
    this._overrides = {};
  }

  get notes() {
    return [...this._notes];
  }

  set notes(newNotes) {
    this._notes = [...newNotes];
    this._cache = {};
    this._overrides = {};
  }

  get orderedPitchClasses() {
    var pcGroup = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.pitches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var p = _step.value;

        if (pcGroup.includes(p.pitchClass)) {
          continue;
        }

        pcGroup.push(p.pitchClass);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    pcGroup.sort((a, b) => a - b);
    return pcGroup;
  }

  get chordTablesAddress() {
    if (this._chordTablesAddressNeedsUpdating) {
      this._chordTablesAddress = _chordTables__WEBPACK_IMPORTED_MODULE_13__["seekChordTablesAddress"](this);
    }

    this._chordTablesAddressNeedsUpdating = false;
    return this._chordTablesAddress;
  }

  get commonName() {
    // TODO: many more exemptions from music21p
    var cta = this.chordTablesAddress;
    var ctn = _chordTables__WEBPACK_IMPORTED_MODULE_13__["addressToCommonNames"](cta);
    var forteClass = this.forteClass;
    var enharmonicTests = {
      '3-11A': () => this.isMinorTriad(),
      '3-11B': () => this.isMajorTriad(),
      '3-10': () => this.isDiminishedTriad(),
      '3-12': () => this.isAugmentedTriad()
    };

    if (enharmonicTests[forteClass] !== undefined) {
      var out = ctn[0];
      var test = enharmonicTests[forteClass];

      if (!test()) {
        out = 'enharmonic equivalent to ' + out;
      }

      return out;
    }

    if (ctn === undefined) {
      return '';
    } else {
      return ctn[0];
    }
  }

  get forteClass() {
    return _chordTables__WEBPACK_IMPORTED_MODULE_13__["addressToForteName"](this.chordTablesAddress, 'tn');
  }

  get forteClassNumber() {
    return this.chordTablesAddress.forteClass;
  }

  get forteClassTnI() {
    return _chordTables__WEBPACK_IMPORTED_MODULE_13__["addressToForteName"](this.chordTablesAddress, 'tni');
  }

  get(i) {
    if (typeof i === 'number') {
      return this._notes[i];
    } else {
      return undefined; // TODO(msc): add other get methods.
    }
  }

  [Symbol.iterator]() {
    var _this = this;

    return (
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < _this.length)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return _this.get(i);

              case 4:
                i++;
                _context.next = 1;
                break;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })()
    );
  }

  areZRelations(other) {
    var zRelationAddress = _chordTables__WEBPACK_IMPORTED_MODULE_13__["addressToZAddress"](this.chordTablesAddress);

    if (zRelationAddress === undefined) {
      return false;
    }

    for (var _i = 0, _arr = ['cardinality', 'forteClass', 'inversion']; _i < _arr.length; _i++) {
      var key = _arr[_i];

      if (other.chordTablesAddress[key] !== zRelationAddress[key]) {
        return false;
      }
    }

    return true;
  }

  getZRelation() {
    if (!this.hasZRelation) {
      return undefined;
    }

    var chordTablesAddress = this.chordTablesAddress;
    var v = _chordTables__WEBPACK_IMPORTED_MODULE_13__["addressToIntervalVector"](chordTablesAddress);
    var addresses = _chordTables__WEBPACK_IMPORTED_MODULE_13__["intervalVectorToAddress"](v);
    var other;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = addresses[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var thisAddress = _step2.value;

        if (thisAddress.forteClass !== chordTablesAddress.forteClass) {
          other = thisAddress;
        }
      } // other should always be defined;

    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    var prime = _chordTables__WEBPACK_IMPORTED_MODULE_13__["addressToTransposedNormalForm"](other);
    return new Chord(prime);
  }

  get hasZRelation() {
    var post = _chordTables__WEBPACK_IMPORTED_MODULE_13__["addressToZAddress"](this.chordTablesAddress);

    if (post !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  get intervalVector() {
    return _chordTables__WEBPACK_IMPORTED_MODULE_13__["addressToIntervalVector"](this.chordTablesAddress);
  } //    get intervalVectorString() {
  //
  //    }
  //
  //    static formatVectorString() {
  //        // needs pitch._convertPitchClassToStr
  //    }


  setStemDirectionFromClef(clef) {
    if (clef === undefined) {
      return this;
    } else {
      var midLine = clef.lowestLine + 4; // console.log(midLine, 'midLine');

      var maxDNNfromCenter = 0;
      var pA = this.pitches;

      for (var i = 0; i < this.pitches.length; i++) {
        var p = pA[i];
        var DNNfromCenter = p.diatonicNoteNum - midLine; // >= not > so that the highest pitch wins the tie and thus stem down.

        if (Math.abs(DNNfromCenter) >= Math.abs(maxDNNfromCenter)) {
          maxDNNfromCenter = DNNfromCenter;
        }
      }

      if (maxDNNfromCenter >= 0) {
        this.stemDirection = 'down';
      } else {
        this.stemDirection = 'up';
      }

      return this;
    }
  }
  /**
   * Adds a note to the chord, sorting the note array
   *
   * @param {
   *     string|string[]|note.Note|Pitch|
   *     music21.note.Note[]|Pitch[]} notes - the
   *     Note or Pitch to be added or a string defining a pitch.
   * @param {boolean} runSort - Sort after running (default true)
   * @returns {music21.chord.Chord} the original chord.
   */


  add(notes) {
    var runSort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!(notes instanceof Array)) {
      notes = [notes];
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = notes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var noteObj = _step3.value;

        // takes in either a note or a pitch
        if (typeof noteObj === 'string') {
          noteObj = new _note__WEBPACK_IMPORTED_MODULE_12__["Note"](noteObj);
        } else if (noteObj.isClassOrSubclass('Pitch')) {
          var pitchObj = noteObj;
          var noteObj2 = new _note__WEBPACK_IMPORTED_MODULE_12__["Note"]();
          noteObj2.pitch = pitchObj;
          noteObj = noteObj2;
        }

        this._notes.push(noteObj);
      } // inefficient because sorts after each add, but safe and #(p) is small

    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    if (runSort === true) {
      this.sortPitches();
    }

    this._cache = {};
    return this;
  }

  sortPitches() {
    this._notes.sort((a, b) => a.pitch.ps - b.pitch.ps);
  } // TODO: add remove

  /**
   * Removes any pitches that appear more than once (in any octave),
   * removing the higher ones, and returns a new Chord.
   *
   * @returns {Chord} A new Chord object with duplicate pitches removed.
   */


  removeDuplicatePitches() {
    var stepsFound = [];
    var nonDuplicatingPitches = [];
    var pitches = this.pitches;

    for (var i = 0; i < pitches.length; i++) {
      var p = pitches[i];

      if (stepsFound.indexOf(p.step) === -1) {
        stepsFound.push(p.step);
        nonDuplicatingPitches.push(p);
      }
    }

    var closedChord = new Chord(nonDuplicatingPitches);
    return closedChord;
  }
  /**
   * Finds the Root of the chord.
   *
   * @param {Pitch} [newroot]
   * @returns {Pitch} the root of the chord.
   */


  root() {
    var newroot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    if (newroot !== undefined) {
      this._overrides.root = newroot;
      this._cache.root = newroot;
      this._cache.inversion = undefined;
    }

    if (this._overrides.root !== undefined) {
      return this._overrides.root;
    }

    if (this._cache.root !== undefined) {
      return this._cache.root;
    }

    var closedChord = this.removeDuplicatePitches();
    /* var chordBass = closedChord.bass(); */

    var closedPitches = closedChord.pitches;

    if (closedPitches.length === 0) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_10__["Music21Exception"]('No notes in Chord!');
    } else if (closedPitches.length === 1) {
      return this.pitches[0];
    } // const indexOfPitchesWithPerfectlyStackedThirds = [];


    var testSteps = [3, 5, 7, 2, 4, 6];

    for (var i = 0; i < closedPitches.length; i++) {
      var p = closedPitches[i];
      var currentListOfThirds = [];

      for (var tsIndex = 0; tsIndex < testSteps.length; tsIndex++) {
        var chordStepPitch = closedChord.getChordStep(testSteps[tsIndex], p);

        if (chordStepPitch !== undefined) {
          // console.log(p.name + " " + testSteps[tsIndex].toString() + " " + chordStepPitch.name);
          currentListOfThirds.push(true);
        } else {
          currentListOfThirds.push(false);
        }
      } // console.log(currentListOfThirds);


      var hasFalse = false;

      for (var j = 0; j < closedPitches.length - 1; j++) {
        if (currentListOfThirds[j] === false) {
          hasFalse = true;
        }
      }

      if (hasFalse === false) {
        // indexOfPitchesWithPerfectlyStackedThirds.push(i);
        return closedChord.pitches[i]; // should do more, but fine...
        // should test rootedness function, etc. 13ths. etc.
      }
    }

    var newRoot = closedChord.pitches[0]; // fallback, just return the bass...

    this._cache.root = newRoot;
    return newRoot;
  }
  /**
   * Returns the number of semitones above the root that a given chordstep is.
   *
   * For instance, in a G dominant 7th chord (G, B, D, F), would
   * return 4 for chordStep=3, since the third of the chord (B) is four semitones above G.
   *
   * @param {number} chordStep - the step to find, e.g., 1, 2, 3, etc.
   * @param {Pitch} [testRoot] - the pitch to temporarily consider the root.
   * @returns {number|undefined} Number of semitones above the root for this
   *     chord step or undefined if no pitch matches that chord step.
   */


  semitonesFromChordStep(chordStep) {
    var testRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    if (testRoot === undefined) {
      testRoot = this.root();
    }

    var tempChordStep = this.getChordStep(chordStep, testRoot);

    if (tempChordStep === undefined) {
      return undefined;
    } else {
      var semitones = (tempChordStep.ps - testRoot.ps) % 12;

      if (semitones < 0) {
        semitones += 12;
      }

      return semitones;
    }
  }
  /**
   * Gets the lowest note (based on .ps not name) in the chord.
   *
   * @returns {[Pitch]} bass pitch
   */


  bass() {
    var newBass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    if (newBass !== undefined) {
      this._overrides.bass = newBass;
      this._cache.bass = newBass;
      this._cache.inversion = undefined;
    }

    if (this._overrides.bass !== undefined) {
      return this._overrides.bass;
    }

    if (this._cache.bass !== undefined) {
      return this._cache.bass;
    }

    var lowest;
    var pitches = this.pitches;

    for (var i = 0; i < pitches.length; i++) {
      var p = pitches[i];

      if (lowest === undefined) {
        lowest = p;
      } else {
        // noinspection JSUnusedAssignment
        if (p.ps < lowest.ps) {
          lowest = p;
        }
      }
    }

    return lowest;
  }
  /**
   * Counts the number of non-duplicate pitch MIDI Numbers in the chord.
   *
   * Call after "closedPosition()" to get Forte style cardinality disregarding octave.
   *
   * @returns {number}
   */


  cardinality() {
    var uniqueChord = this.removeDuplicatePitches();
    return uniqueChord.pitches.length;
  }
  /**
  *
  * @returns {Boolean}
  */


  isMajorTriad() {
    if (this.cardinality() !== 3) {
      return false;
    }

    var thirdST = this.semitonesFromChordStep(3);
    var fifthST = this.semitonesFromChordStep(5);

    if (thirdST === 4 && fifthST === 7) {
      return true;
    } else {
      return false;
    }
  }
  /**
  *
  * @returns {Boolean}
  */


  isMinorTriad() {
    if (this.cardinality() !== 3) {
      return false;
    }

    var thirdST = this.semitonesFromChordStep(3);
    var fifthST = this.semitonesFromChordStep(5);

    if (thirdST === 3 && fifthST === 7) {
      return true;
    } else {
      return false;
    }
  }
  /**
  *
  * @returns {Boolean}
  */


  isDiminishedTriad() {
    if (this.cardinality() !== 3) {
      return false;
    }

    var thirdST = this.semitonesFromChordStep(3);
    var fifthST = this.semitonesFromChordStep(5);

    if (thirdST === 3 && fifthST === 6) {
      return true;
    } else {
      return false;
    }
  }
  /**
  *
  * @returns {Boolean}
  */


  isAugmentedTriad() {
    if (this.cardinality() !== 3) {
      return false;
    }

    var thirdST = this.semitonesFromChordStep(3);
    var fifthST = this.semitonesFromChordStep(5);

    if (thirdST === 4 && fifthST === 8) {
      return true;
    } else {
      return false;
    }
  }

  isDominantSeventh() {
    return this.isSeventhOfType([0, 4, 7, 10]);
  }

  isDiminishedSeventh() {
    return this.isSeventhOfType([0, 3, 6, 9]);
  }

  isSeventhOfType(intervalArray) {
    if (intervalArray === undefined) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_10__["Music21Exception"]('intervalArray is required');
    }

    var third = this.third;
    var fifth = this.fifth;
    var seventh = this.seventh;

    if (third === undefined || fifth === undefined || seventh === undefined) {
      return false;
    }

    var root = this.root();
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = this.pitches[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var thisPitch = _step4.value;
        var thisInterval = new _interval__WEBPACK_IMPORTED_MODULE_11__["Interval"](root, thisPitch);

        if (!intervalArray.includes(thisInterval.chromatic.mod12)) {
          return false;
        } //            // check if it doesn't have any other pitches, such as C E F- G Bb != Dominant Seventh
        //            if (!ignoreSpelling && !chordalNames.includes(thisPitch.name)) {
        //                return false;
        //            }

      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return true;
  }
  /**
   * canBeDominantV - Returns true if the chord is a Major Triad or a Dominant Seventh
   *
   * @return {Boolean}
   */


  canBeDominantV() {
    if (this.isMajorTriad() || this.isDominantSeventh()) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Returns true if the chord is a major or minor triad
   *
   * @returns {Boolean}
   */


  canBeTonic() {
    if (this.isMajorTriad() || this.isMinorTriad()) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Returns the inversion of the chord as a number (root-position = 0)
   *
   * Unlike music21 version, cannot set the inversion, yet.
   *
   * TODO: add.
   *
   * @returns {number}
   */


  inversion() {
    var bass = this.bass();
    var root = this.root();
    var chordStepsToInversions = [1, 6, 4, 2, 7, 5, 3];

    for (var i = 0; i < chordStepsToInversions.length; i++) {
      var testNote = this.getChordStep(chordStepsToInversions[i], bass);

      if (testNote !== undefined && testNote.name === root.name) {
        return i;
      }
    }

    return undefined;
  }
  /**
   * @param {Object} options - a dictionary of options `{clef: {@music21.clef.Clef} }` is especially important
   * @returns {Vex.Flow.StaveNote}
   */


  vexflowNote() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      clef: undefined
    };
    var clef = options.clef;
    var pitchKeys = [];

    for (var i = 0; i < this._notes.length; i++) {
      pitchKeys.push(this._notes[i].pitch.vexflowName(clef));
    }

    var vfn = new vexflow__WEBPACK_IMPORTED_MODULE_8___default.a.Flow.StaveNote({
      keys: pitchKeys,
      duration: this.duration.vexflowDuration
    });
    this.vexflowAccidentalsAndDisplay(vfn, options); // clean up stuff...

    for (var _i2 = 0; _i2 < this._notes.length; _i2++) {
      var tn = this._notes[_i2];

      if (tn.pitch.accidental !== undefined) {
        if (tn.pitch.accidental.vexflowModifier !== 'n' && tn.pitch.accidental.displayStatus !== false) {
          vfn.addAccidental(_i2, new vexflow__WEBPACK_IMPORTED_MODULE_8___default.a.Flow.Accidental(tn.pitch.accidental.vexflowModifier));
        } else if (tn.pitch.accidental.displayType === 'always' || tn.pitch.accidental.displayStatus === true) {
          vfn.addAccidental(_i2, new vexflow__WEBPACK_IMPORTED_MODULE_8___default.a.Flow.Accidental(tn.pitch.accidental.vexflowModifier));
        }
      }
    }

    this.activeVexflowNote = vfn;
    return vfn;
  }

  playMidi() {
    var tempo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 120;
    var nextElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$instrument = _ref.instrument,
        instrument = _ref$instrument === void 0 ? undefined : _ref$instrument,
        _ref$channel = _ref.channel,
        channel = _ref$channel === void 0 ? undefined : _ref$channel;

    var milliseconds = super.playMidi(tempo, nextElement, {
      instrument,
      channel
    });

    if (channel === undefined) {
      channel = this.activeChannel();
    }

    var midNum;
    var volume = this.midiVolume; // TODO: Tied Chords.

    for (var j = 0; j < this._notes.length; j++) {
      midNum = this._notes[j].pitch.midi;

      try {
        midicube__WEBPACK_IMPORTED_MODULE_9__["noteOn"](channel, midNum, volume, 0);
        midicube__WEBPACK_IMPORTED_MODULE_9__["noteOff"](channel, midNum, milliseconds / 1000);
      } catch (e) {// do nothing -- might not have an output channel because of audio not connected
      }
    }

    return milliseconds;
  }
  /**
   * Returns the Pitch object that is a Generic interval (2, 3, 4, etc., but not 9, 10, etc.) above
   * the `.root()`
   *
   * In case there is more that one note with that designation (e.g., `[A-C-C#-E].getChordStep(3)`)
   * the first one in `.pitches` is returned.
   *
   * @param {number} chordStep a positive integer representing the chord step
   * @param {Pitch} [testRoot] - the Pitch to use as a temporary root
   * @returns {Pitch|undefined}
   */


  getChordStep(chordStep) {
    var testRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    if (testRoot === undefined) {
      testRoot = this.root();
    }

    if (chordStep >= 8) {
      chordStep %= 7;
    }

    var thisPitches = this.pitches;
    var testRootDNN = testRoot.diatonicNoteNum;

    for (var i = 0; i < thisPitches.length; i++) {
      var thisPitch = thisPitches[i];
      var thisInterval = (thisPitch.diatonicNoteNum - testRootDNN + 1) % 7; // fast cludge

      if (thisInterval <= 0) {
        thisInterval += 7;
      }

      if (thisInterval === chordStep) {
        return thisPitch;
      }
    }

    return undefined;
  }

  get third() {
    return this.getChordStep(3);
  }

  get fifth() {
    return this.getChordStep(5);
  }

  get seventh() {
    return this.getChordStep(7);
  }

}
var chordDefinitions = {
  major: ['M3', 'm3'],
  minor: ['m3', 'M3'],
  diminished: ['m3', 'm3'],
  augmented: ['M3', 'M3'],
  'major-seventh': ['M3', 'm3', 'M3'],
  'dominant-seventh': ['M3', 'm3', 'm3'],
  'minor-seventh': ['m3', 'M3', 'm3'],
  'diminished-seventh': ['m3', 'm3', 'm3'],
  'half-diminished-seventh': ['m3', 'm3', 'M3']
};

/***/ }),

/***/ "./src/music21/chordTables.ts":
/*!************************************!*\
  !*** ./src/music21/chordTables.ts ***!
  \************************************/
/*! exports provided: FORTE, SCDICT, TNMAX, TNIMAX, TNREF, SCREF, forteIndexToInversionsAvailable, addressToTransposedNormalForm, addressToPrimeForm, addressToIntervalVector, intervalVectorToAddress, addressToZAddress, addressToCommonNames, addressToForteName, seekChordTablesAddress */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORTE", function() { return FORTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCDICT", function() { return SCDICT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TNMAX", function() { return TNMAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TNIMAX", function() { return TNIMAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TNREF", function() { return TNREF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCREF", function() { return SCREF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forteIndexToInversionsAvailable", function() { return forteIndexToInversionsAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addressToTransposedNormalForm", function() { return addressToTransposedNormalForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addressToPrimeForm", function() { return addressToPrimeForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addressToIntervalVector", function() { return addressToIntervalVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intervalVectorToAddress", function() { return intervalVectorToAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addressToZAddress", function() { return addressToZAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addressToCommonNames", function() { return addressToCommonNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addressToForteName", function() { return addressToForteName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "seekChordTablesAddress", function() { return seekChordTablesAddress; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.reverse */ "./node_modules/core-js/modules/es.array.reverse.js");
/* harmony import */ var core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");







function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


var t1;
var t2;
var t3;
var t4;
var t5;
var t6;
var t7;
var t8;
var t9;
var t10;
var t11;
var t12;
var t13;
var t14;
var t15;
var t16;
var t17;
var t18;
var t19;
var t20;
var t21;
var t22;
var t23;
var t24;
var t25;
var t26;
var t27;
var t28;
var t29;
var t30;
var t31;
var t32;
var t33;
var t34;
var t35;
var t36;
var t37;
var t38;
t1 = [[0], [0, 0, 0, 0, 0, 0], [1, 1, 1, 1, 11, 11, 11, 11], 0]; // 1-1

var monad = [undefined, t1];
t1 = [[0, 1], [1, 0, 0, 0, 0, 0], [1, 1, 0, 0, 9, 9, 8, 8], 0]; // 2-1

t2 = [[0, 2], [0, 1, 0, 0, 0, 0], [1, 1, 1, 1, 9, 9, 9, 9], 0]; // 2-2

t3 = [[0, 3], [0, 0, 1, 0, 0, 0], [1, 1, 1, 1, 9, 9, 9, 9], 0]; // 2-3

t4 = [[0, 4], [0, 0, 0, 1, 0, 0], [1, 1, 1, 1, 9, 9, 9, 9], 0]; // 2-4

t5 = [[0, 5], [0, 0, 0, 0, 1, 0], [1, 1, 0, 0, 9, 9, 8, 8], 0]; // 2-5

t6 = [[0, 6], [0, 0, 0, 0, 0, 1], [2, 2, 2, 2, 10, 10, 10], 0]; // 2-6

var diad = [undefined, t1, t2, t3, t4, t5, t6];
t1 = [[0, 1, 2], [2, 1, 0, 0, 0, 0], [1, 1, 0, 0, 7, 7, 4, 4], 0]; // 3-1

t2 = [[0, 1, 3], [1, 1, 1, 0, 0, 0], [1, 0, 0, 0, 5, 6, 5, 5], 0]; // 3-2

t3 = [[0, 1, 4], [1, 0, 1, 1, 0, 0], [1, 0, 0, 0, 5, 6, 5, 5], 0]; // 3-3

t4 = [[0, 1, 5], [1, 0, 0, 1, 1, 0], [1, 0, 1, 0, 5, 6, 5, 6], 0]; // 3-4

t5 = [[0, 1, 6], [1, 0, 0, 0, 1, 1], [1, 0, 0, 1, 6, 7, 7, 6], 0]; // 3-5

t6 = [[0, 2, 4], [0, 2, 0, 1, 0, 0], [1, 1, 1, 1, 7, 7, 7, 7], 0]; // 3-6

t7 = [[0, 2, 5], [0, 1, 1, 0, 1, 0], [1, 0, 0, 0, 5, 6, 5, 5], 0]; // 3-7

t8 = [[0, 2, 6], [0, 1, 0, 1, 0, 1], [1, 0, 0, 1, 6, 7, 7, 6], 0]; // 3-8

t9 = [[0, 2, 7], [0, 1, 0, 0, 2, 0], [1, 1, 0, 0, 7, 7, 4, 4], 0]; // 3-9

t10 = [[0, 3, 6], [0, 0, 2, 0, 0, 1], [1, 1, 1, 1, 8, 8, 8, 8], 0]; // 3-10

t11 = [[0, 3, 7], [0, 0, 1, 1, 1, 0], [1, 0, 0, 0, 5, 6, 5, 5], 0]; // 3-11

t12 = [[0, 4, 8], [0, 0, 0, 3, 0, 0], [3, 3, 3, 3, 9, 9, 9, 9], 0]; // 3-12

var trichord = [undefined, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12];
t1 = [[0, 1, 2, 3], [3, 2, 1, 0, 0, 0], [1, 1, 0, 0, 5, 5, 1, 1], 0]; // 4-1

t2 = [[0, 1, 2, 4], [2, 2, 1, 1, 0, 0], [1, 0, 0, 0, 3, 4, 1, 1], 0]; // 4-2

t3 = [[0, 1, 3, 4], [2, 1, 2, 1, 0, 0], [1, 1, 0, 0, 3, 3, 2, 2], 0]; // 4-3

t4 = [[0, 1, 2, 5], [2, 1, 1, 1, 1, 0], [1, 0, 0, 0, 1, 3, 2, 3], 0]; // 4-4

t5 = [[0, 1, 2, 6], [2, 1, 0, 1, 1, 1], [1, 0, 0, 0, 2, 4, 3, 2], 0]; // 4-5

t6 = [[0, 1, 2, 7], [2, 1, 0, 0, 2, 1], [1, 1, 1, 1, 4, 4, 4, 4], 0]; // 4-6

t7 = [[0, 1, 4, 5], [2, 0, 1, 2, 1, 0], [1, 1, 0, 0, 3, 3, 3, 3], 0]; // 4-7

t8 = [[0, 1, 5, 6], [2, 0, 0, 1, 2, 1], [1, 1, 1, 1, 4, 4, 4, 4], 0]; // 4-8

t9 = [[0, 1, 6, 7], [2, 0, 0, 0, 2, 2], [2, 2, 2, 2, 6, 6, 6, 6], 0]; // 4-9

t10 = [[0, 2, 3, 5], [1, 2, 2, 0, 1, 0], [1, 1, 1, 1, 3, 3, 3, 3], 0]; // 4-10

t11 = [[0, 1, 3, 5], [1, 2, 1, 1, 1, 0], [1, 0, 1, 0, 1, 3, 1, 3], 0]; // 4-11

t12 = [[0, 2, 3, 6], [1, 1, 2, 1, 0, 1], [1, 0, 0, 0, 2, 4, 3, 2], 0]; // 4-12

t13 = [[0, 1, 3, 6], [1, 1, 2, 0, 1, 1], [1, 0, 0, 1, 2, 4, 4, 2], 0]; // 4-13

t14 = [[0, 2, 3, 7], [1, 1, 1, 1, 2, 0], [1, 0, 0, 0, 1, 3, 2, 3], 0]; // 4-14

t15 = [[0, 1, 4, 6], [1, 1, 1, 1, 1, 1], [1, 0, 0, 0, 0, 3, 3, 1], 29]; // 4-15z

t16 = [[0, 1, 5, 7], [1, 1, 0, 1, 2, 1], [1, 0, 0, 0, 2, 4, 3, 2], 0]; // 4-16

t17 = [[0, 3, 4, 7], [1, 0, 2, 2, 1, 0], [1, 1, 1, 1, 3, 3, 3, 3], 0]; // 4-17

t18 = [[0, 1, 4, 7], [1, 0, 2, 1, 1, 1], [1, 0, 0, 1, 2, 4, 4, 2], 0]; // 4-18

t19 = [[0, 1, 4, 8], [1, 0, 1, 3, 1, 0], [1, 0, 1, 0, 3, 5, 3, 5], 0]; // 4-19

t20 = [[0, 1, 5, 8], [1, 0, 1, 2, 2, 0], [1, 1, 0, 0, 3, 3, 3, 3], 0]; // 4-20

t21 = [[0, 2, 4, 6], [0, 3, 0, 2, 0, 1], [1, 1, 1, 1, 6, 6, 6, 6], 0]; // 4-21

t22 = [[0, 2, 4, 7], [0, 2, 1, 1, 2, 0], [1, 0, 0, 0, 3, 4, 1, 1], 0]; // 4-22

t23 = [[0, 2, 5, 7], [0, 2, 1, 0, 3, 0], [1, 1, 0, 0, 5, 5, 1, 1], 0]; // 4-23

t24 = [[0, 2, 4, 8], [0, 2, 0, 3, 0, 1], [1, 1, 1, 1, 6, 6, 6, 6], 0]; // 4-24

t25 = [[0, 2, 6, 8], [0, 2, 0, 2, 0, 2], [2, 2, 2, 2, 6, 6, 6, 6], 0]; // 4-25

t26 = [[0, 3, 5, 8], [0, 1, 2, 1, 2, 0], [1, 1, 0, 0, 3, 3, 2, 2], 0]; // 4-26

t27 = [[0, 2, 5, 8], [0, 1, 2, 1, 1, 1], [1, 0, 0, 0, 2, 4, 3, 2], 0]; // 4-27

t28 = [[0, 3, 6, 9], [0, 0, 4, 0, 0, 2], [4, 4, 4, 4, 8, 8, 8, 8], 0]; // 4-28

t29 = [[0, 1, 3, 7], [1, 1, 1, 1, 1, 1], [1, 0, 0, 0, 0, 3, 3, 1], 15]; // 4-29z

var tetrachord = [undefined, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, t17, t18, t19, t20, t21, t22, t23, t24, t25, t26, t27, t28, t29];
t1 = [[0, 1, 2, 3, 4], [4, 3, 2, 1, 0, 0], [1, 1, 0, 0, 3, 3, 0, 0], 0]; // 5-1

t2 = [[0, 1, 2, 3, 5], [3, 3, 2, 1, 1, 0], [1, 0, 0, 0, 1, 2, 1, 1], 0]; // 5-2

t3 = [[0, 1, 2, 4, 5], [3, 2, 2, 2, 1, 0], [1, 0, 0, 0, 1, 1, 1, 0], 0]; // 5-3

t4 = [[0, 1, 2, 3, 6], [3, 2, 2, 1, 1, 1], [1, 0, 0, 0, 0, 2, 0, 0], 0]; // 5-4

t5 = [[0, 1, 2, 3, 7], [3, 2, 1, 1, 2, 1], [1, 0, 0, 0, 0, 1, 1, 1], 0]; // 5-5

t6 = [[0, 1, 2, 5, 6], [3, 1, 1, 2, 2, 1], [1, 0, 0, 0, 0, 1, 1, 1], 0]; // 5-6

t7 = [[0, 1, 2, 6, 7], [3, 1, 0, 1, 3, 2], [1, 0, 0, 1, 2, 3, 3, 2], 0]; // 5-7

t8 = [[0, 2, 3, 4, 6], [2, 3, 2, 2, 0, 1], [1, 1, 0, 0, 2, 2, 0, 0], 0]; // 5-8

t9 = [[0, 1, 2, 4, 6], [2, 3, 1, 2, 1, 1], [1, 0, 0, 0, 0, 2, 0, 1], 0]; // 5-9

t10 = [[0, 1, 3, 4, 6], [2, 2, 3, 1, 1, 1], [1, 0, 0, 0, 0, 1, 1, 0], 0]; // 5-10

t11 = [[0, 2, 3, 4, 7], [2, 2, 2, 2, 2, 0], [1, 0, 1, 0, 1, 1, 1, 1], 0]; // 5-11

t12 = [[0, 1, 3, 5, 6], [2, 2, 2, 1, 2, 1], [1, 1, 1, 1, 0, 0, 0, 0], [36]]; // 5-12

t13 = [[0, 1, 2, 4, 8], [2, 2, 1, 3, 1, 1], [1, 0, 0, 0, 0, 2, 0, 1], 0]; // 5-13

t14 = [[0, 1, 2, 5, 7], [2, 2, 1, 1, 3, 1], [1, 0, 0, 0, 0, 1, 1, 1], 0]; // 5-14

t15 = [[0, 1, 2, 6, 8], [2, 2, 0, 2, 2, 2], [1, 1, 1, 1, 2, 2, 2, 2], 0]; // 5-15

t16 = [[0, 1, 3, 4, 7], [2, 1, 3, 2, 1, 1], [1, 0, 0, 0, 0, 1, 1, 0], 0]; // 5-16

t17 = [[0, 1, 3, 4, 8], [2, 1, 2, 3, 2, 0], [1, 1, 0, 0, 1, 1, 2, 2], [37]]; // 5-17

t18 = [[0, 1, 4, 5, 7], [2, 1, 2, 2, 2, 1], [1, 0, 0, 0, 0, 1, 1, 0], [38]]; // 5-18

t19 = [[0, 1, 3, 6, 7], [2, 1, 2, 1, 2, 2], [1, 0, 0, 1, 0, 2, 2, 0], 0]; // 5-19

t20 = [[0, 1, 3, 7, 8], [2, 1, 1, 2, 3, 1], [1, 0, 0, 0, 0, 1, 1, 1], 0]; // 5-20

t21 = [[0, 1, 4, 5, 8], [2, 0, 2, 4, 2, 0], [1, 0, 1, 0, 3, 3, 3, 3], 0]; // 5-21

t22 = [[0, 1, 4, 7, 8], [2, 0, 2, 3, 2, 1], [1, 1, 1, 1, 2, 2, 2, 2], 0]; // 5-22

t23 = [[0, 2, 3, 5, 7], [1, 3, 2, 1, 3, 0], [1, 0, 0, 0, 1, 2, 1, 1], 0]; // 5-23

t24 = [[0, 1, 3, 5, 7], [1, 3, 1, 2, 2, 1], [1, 0, 0, 0, 0, 2, 0, 1], 0]; // 5-24

t25 = [[0, 2, 3, 5, 8], [1, 2, 3, 1, 2, 1], [1, 0, 0, 0, 0, 1, 1, 0], 0]; // 5-25

t26 = [[0, 2, 4, 5, 8], [1, 2, 2, 3, 1, 1], [1, 0, 1, 0, 0, 2, 0, 2], 0]; // 5-26

t27 = [[0, 1, 3, 5, 8], [1, 2, 2, 2, 3, 0], [1, 0, 0, 0, 1, 1, 1, 0], 0]; // 5-27

t28 = [[0, 2, 3, 6, 8], [1, 2, 2, 2, 1, 2], [1, 0, 0, 1, 0, 2, 2, 0], 0]; // 5-28

t29 = [[0, 1, 3, 6, 8], [1, 2, 2, 1, 3, 1], [1, 0, 0, 0, 0, 2, 0, 0], 0]; // 5-29

t30 = [[0, 1, 4, 6, 8], [1, 2, 1, 3, 2, 1], [1, 0, 0, 0, 0, 2, 0, 1], 0]; // 5-30

t31 = [[0, 1, 3, 6, 9], [1, 1, 4, 1, 1, 2], [1, 0, 0, 1, 0, 3, 3, 0], 0]; // 5-31

t32 = [[0, 1, 4, 6, 9], [1, 1, 3, 2, 2, 1], [1, 0, 0, 0, 0, 1, 1, 0], 0]; // 5-32

t33 = [[0, 2, 4, 6, 8], [0, 4, 0, 4, 0, 2], [1, 1, 1, 1, 6, 6, 6, 6], 0]; // 5-33

t34 = [[0, 2, 4, 6, 9], [0, 3, 2, 2, 2, 1], [1, 1, 0, 0, 2, 2, 0, 0], 0]; // 5-34

t35 = [[0, 2, 4, 7, 9], [0, 3, 2, 1, 4, 0], [1, 1, 0, 0, 3, 3, 0, 0], 0]; // 5-35

t36 = [[0, 1, 2, 4, 7], [2, 2, 2, 1, 2, 1], [1, 0, 0, 1, 0, 1, 1, 0], 12]; // 5-36

t37 = [[0, 3, 4, 5, 8], [2, 1, 2, 2, 2, 0], [1, 1, 0, 0, 1, 1, 2, 2], 17]; // 5-37

t38 = [[0, 1, 2, 5, 8], [2, 1, 2, 2, 2, 1], [1, 0, 0, 0, 0, 1, 1, 0], 18]; // 5-38

var pentachord = [undefined, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, t17, t18, t19, t20, t21, t22, t23, t24, t25, t26, t27, t28, t29, t30, t31, t32, t33, t34, t35, t36, t37, t38];
t1 = [[0, 1, 2, 3, 4, 5], [5, 4, 3, 2, 1, 0], [1, 1, 0, 0, 1, 1, 0, 0], 0]; // 6-1  A

t2 = [[0, 1, 2, 3, 4, 6], [4, 4, 3, 2, 1, 1], [1, 0, 0, 0, 0, 1, 0, 0], 0]; // 6-2

t3 = [[0, 1, 2, 3, 5, 6], [4, 3, 3, 2, 2, 1], [1, 0, 0, 0, 0, 0, 0, 0], 36]; // 6-3

t4 = [[0, 1, 2, 4, 5, 6], [4, 3, 2, 3, 2, 1], [1, 1, 0, 0, 0, 0, 0, 0], 37]; // 6-4

t5 = [[0, 1, 2, 3, 6, 7], [4, 2, 2, 2, 3, 2], [1, 0, 0, 0, 0, 1, 0, 0], 0]; // 6-5

t6 = [[0, 1, 2, 5, 6, 7], [4, 2, 1, 2, 4, 2], [1, 1, 0, 0, 0, 0, 1, 1], 38]; // 6-6

t7 = [[0, 1, 2, 6, 7, 8], [4, 2, 0, 2, 4, 3], [2, 2, 2, 2, 2, 2, 2, 2], 0]; // 6-7 B

t8 = [[0, 2, 3, 4, 5, 7], [3, 4, 3, 2, 3, 0], [1, 1, 1, 1, 1, 1, 1, 1], 0]; // 6-8 D

t9 = [[0, 1, 2, 3, 5, 7], [3, 4, 2, 2, 3, 1], [1, 0, 1, 0, 0, 1, 0, 1], 0]; // 6-9

t10 = [[0, 1, 3, 4, 5, 7], [3, 3, 3, 3, 2, 1], [1, 0, 0, 0, 0, 0, 0, 0], 39]; // 6-10

t11 = [[0, 1, 2, 4, 5, 7], [3, 3, 3, 2, 3, 1], [1, 0, 0, 0, 0, 0, 1, 0], 40]; // 6-11

t12 = [[0, 1, 2, 4, 6, 7], [3, 3, 2, 2, 3, 2], [1, 0, 0, 1, 0, 0, 0, 0], 41]; // 6-12

t13 = [[0, 1, 3, 4, 6, 7], [3, 2, 4, 2, 2, 2], [1, 1, 0, 0, 0, 0, 0, 0], 42]; // 6-13

t14 = [[0, 1, 3, 4, 5, 8], [3, 2, 3, 4, 3, 0], [1, 0, 1, 0, 1, 0, 1, 0], 0]; // 6-14

t15 = [[0, 1, 2, 4, 5, 8], [3, 2, 3, 4, 2, 1], [1, 0, 0, 0, 0, 1, 0, 0], 0]; // 6-15

t16 = [[0, 1, 4, 5, 6, 8], [3, 2, 2, 4, 3, 1], [1, 0, 1, 0, 0, 1, 0, 1], 0]; // 6-16

t17 = [[0, 1, 2, 4, 7, 8], [3, 2, 2, 3, 3, 2], [1, 0, 0, 1, 0, 0, 0, 0], 43]; // 6-17

t18 = [[0, 1, 2, 5, 7, 8], [3, 2, 2, 2, 4, 2], [1, 0, 0, 0, 0, 1, 0, 0], 0]; // 6-18

t19 = [[0, 1, 3, 4, 7, 8], [3, 1, 3, 4, 3, 1], [1, 0, 0, 0, 0, 0, 1, 0], 44]; // 6-19

t20 = [[0, 1, 4, 5, 8, 9], [3, 0, 3, 6, 3, 0], [3, 3, 3, 3, 3, 3, 3, 3], 0]; // 6-20 E

t21 = [[0, 2, 3, 4, 6, 8], [2, 4, 2, 4, 1, 2], [1, 0, 0, 0, 0, 1, 0, 0], 0]; // 6-21

t22 = [[0, 1, 2, 4, 6, 8], [2, 4, 1, 4, 2, 2], [1, 0, 1, 0, 0, 1, 0, 1], 0]; // 6-22

t23 = [[0, 2, 3, 5, 6, 8], [2, 3, 4, 2, 2, 2], [1, 1, 1, 1, 0, 0, 0, 0], 45]; // 6-23

t24 = [[0, 1, 3, 4, 6, 8], [2, 3, 3, 3, 3, 1], [1, 0, 0, 0, 0, 0, 0, 0], 46]; // 6-24

t25 = [[0, 1, 3, 5, 6, 8], [2, 3, 3, 2, 4, 1], [1, 0, 0, 0, 0, 0, 0, 0], 47]; // 6-25

t26 = [[0, 1, 3, 5, 7, 8], [2, 3, 2, 3, 4, 1], [1, 1, 0, 0, 0, 0, 0, 0], 48]; // 6-26

t27 = [[0, 1, 3, 4, 6, 9], [2, 2, 5, 2, 2, 2], [1, 0, 0, 1, 0, 1, 1, 0], 0]; // 6-27

t28 = [[0, 1, 3, 5, 6, 9], [2, 2, 4, 3, 2, 2], [1, 1, 1, 1, 0, 0, 0, 0], 49]; // 6-28

t29 = [[0, 1, 3, 6, 8, 9], [2, 2, 4, 2, 3, 2], [1, 1, 0, 0, 0, 0, 0, 0], 50]; // 6- d29

t30 = [[0, 1, 3, 6, 7, 9], [2, 2, 4, 2, 2, 3], [2, 0, 0, 2, 0, 2, 2, 0], 0]; // 6-30

t31 = [[0, 1, 3, 5, 8, 9], [2, 2, 3, 4, 3, 1], [1, 0, 0, 0, 0, 1, 0, 0], 0]; // 6-31

t32 = [[0, 2, 4, 5, 7, 9], [1, 4, 3, 2, 5, 0], [1, 1, 0, 0, 1, 1, 0, 0], 0]; // 6-32 C

t33 = [[0, 2, 3, 5, 7, 9], [1, 4, 3, 2, 4, 1], [1, 0, 0, 0, 0, 1, 0, 0], 0]; // 6-33

t34 = [[0, 1, 3, 5, 7, 9], [1, 4, 2, 4, 2, 2], [1, 0, 0, 0, 0, 1, 0, 0], 0]; // 6-34

t35 = [[0, 2, 4, 6, 8, 10], [0, 6, 0, 6, 0, 3], [6, 6, 6, 6, 6, 6, 6, 6], 0]; // 6-35 F

t36 = [[0, 1, 2, 3, 4, 7], [4, 3, 3, 2, 2, 1], [1, 0, 0, 0, 0, 0, 0, 0], 3]; // 6-36

t37 = [[0, 1, 2, 3, 4, 8], [4, 3, 2, 3, 2, 1], [1, 1, 0, 0, 0, 0, 0, 0], 4]; // 6-37

t38 = [[0, 1, 2, 3, 7, 8], [4, 2, 1, 2, 4, 2], [1, 1, 0, 0, 0, 0, 1, 1], 6]; // 6-38

var t39 = [[0, 2, 3, 4, 5, 8], [3, 3, 3, 3, 2, 1], [1, 0, 0, 0, 0, 0, 0, 0], 10]; // 6-39

var t40 = [[0, 1, 2, 3, 5, 8], [3, 3, 3, 2, 3, 1], [1, 0, 0, 0, 0, 0, 1, 0], 11]; // 6-40

var t41 = [[0, 1, 2, 3, 6, 8], [3, 3, 2, 2, 3, 2], [1, 0, 0, 1, 0, 0, 0, 0], 12]; // 6-41

var t42 = [[0, 1, 2, 3, 6, 9], [3, 2, 4, 2, 2, 2], [1, 1, 0, 0, 0, 0, 0, 0], 13]; // 6-42

var t43 = [[0, 1, 2, 5, 6, 8], [3, 2, 2, 3, 3, 2], [1, 0, 0, 1, 0, 0, 0, 0], 17]; // 6-43

var t44 = [[0, 1, 2, 5, 6, 9], [3, 1, 3, 4, 3, 1], [1, 0, 0, 0, 0, 0, 1, 0], 19]; // 6-44

var t45 = [[0, 2, 3, 4, 6, 9], [2, 3, 4, 2, 2, 2], [1, 1, 1, 1, 0, 0, 0, 0], 23]; // 6-45

var t46 = [[0, 1, 2, 4, 6, 9], [2, 3, 3, 3, 3, 1], [1, 0, 0, 0, 0, 0, 0, 0], 24]; // 6-46

var t47 = [[0, 1, 2, 4, 7, 9], [2, 3, 3, 2, 4, 1], [1, 0, 0, 0, 0, 0, 0, 0], 25]; // 6-47

var t48 = [[0, 1, 2, 5, 7, 9], [2, 3, 2, 3, 4, 1], [1, 1, 0, 0, 0, 0, 0, 0], 26]; // 6-48

var t49 = [[0, 1, 3, 4, 7, 9], [2, 2, 4, 3, 2, 2], [1, 1, 1, 1, 0, 0, 0, 0], 28]; // 6-49

var t50 = [[0, 1, 4, 6, 7, 9], [2, 2, 4, 2, 3, 2], [1, 1, 0, 0, 0, 0, 0, 0], 29]; // 6-50

var hexachord = [undefined, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, t17, t18, t19, t20, t21, t22, t23, t24, t25, t26, t27, t28, t29, t30, t31, t32, t33, t34, t35, t36, t37, t38, t39, t40, t41, t42, t43, t44, t45, t46, t47, t48, t49, t50];
t1 = [[0, 1, 2, 3, 4, 5, 6], [6, 5, 4, 3, 2, 1], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 7-1

t2 = [[0, 1, 2, 3, 4, 5, 7], [5, 5, 4, 3, 3, 1], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-2

t3 = [[0, 1, 2, 3, 4, 5, 8], [5, 4, 4, 4, 3, 1], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-3

t4 = [[0, 1, 2, 3, 4, 6, 7], [5, 4, 4, 3, 3, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-4

t5 = [[0, 1, 2, 3, 5, 6, 7], [5, 4, 3, 3, 4, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-5

t6 = [[0, 1, 2, 3, 4, 7, 8], [5, 3, 3, 4, 4, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-6

t7 = [[0, 1, 2, 3, 6, 7, 8], [5, 3, 2, 3, 5, 3], [1, 0, 0, 1, 0, 0, 0, 0], 0]; // 7-7

t8 = [[0, 2, 3, 4, 5, 6, 8], [4, 5, 4, 4, 2, 2], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 7-8

t9 = [[0, 1, 2, 3, 4, 6, 8], [4, 5, 3, 4, 3, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-9

t10 = [[0, 1, 2, 3, 4, 6, 9], [4, 4, 5, 3, 3, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-10

t11 = [[0, 1, 3, 4, 5, 6, 8], [4, 4, 4, 4, 4, 1], [1, 0, 1, 0, 0, 0, 0, 0], 0]; // 7-11

t12 = [[0, 1, 2, 3, 4, 7, 9], [4, 4, 4, 3, 4, 2], [1, 1, 1, 1, 0, 0, 0, 0], 36]; // 7-12 z

t13 = [[0, 1, 2, 4, 5, 6, 8], [4, 4, 3, 5, 3, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-13

t14 = [[0, 1, 2, 3, 5, 7, 8], [4, 4, 3, 3, 5, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-14

t15 = [[0, 1, 2, 4, 6, 7, 8], [4, 4, 2, 4, 4, 3], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 7-15

t16 = [[0, 1, 2, 3, 5, 6, 9], [4, 3, 5, 4, 3, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-16

t17 = [[0, 1, 2, 4, 5, 6, 9], [4, 3, 4, 5, 4, 1], [1, 1, 0, 0, 0, 0, 0, 0], 37]; // 7-17 z

t18 = [[0, 1, 2, 3, 5, 8, 9], [4, 3, 4, 4, 4, 2], [1, 0, 0, 0, 0, 0, 0, 0], 38]; // 7-18 z

t19 = [[0, 1, 2, 3, 6, 7, 9], [4, 3, 4, 3, 4, 3], [1, 0, 0, 1, 0, 0, 0, 0], 0]; // 7-19

t20 = [[0, 1, 2, 4, 7, 8, 9], [4, 3, 3, 4, 5, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-20

t21 = [[0, 1, 2, 4, 5, 8, 9], [4, 2, 4, 6, 4, 1], [1, 0, 1, 0, 0, 0, 0, 0], 0]; // 7-21

t22 = [[0, 1, 2, 5, 6, 8, 9], [4, 2, 4, 5, 4, 2], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 7-22

t23 = [[0, 2, 3, 4, 5, 7, 9], [3, 5, 4, 3, 5, 1], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-23

t24 = [[0, 1, 2, 3, 5, 7, 9], [3, 5, 3, 4, 4, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-24

t25 = [[0, 2, 3, 4, 6, 7, 9], [3, 4, 5, 3, 4, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-25

t26 = [[0, 1, 3, 4, 5, 7, 9], [3, 4, 4, 5, 3, 2], [1, 0, 1, 0, 0, 0, 0, 0], 0]; // 7-26

t27 = [[0, 1, 2, 4, 5, 7, 9], [3, 4, 4, 4, 5, 1], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-27

t28 = [[0, 1, 3, 5, 6, 7, 9], [3, 4, 4, 4, 3, 3], [1, 0, 0, 1, 0, 0, 0, 0], 0]; // 7-28

t29 = [[0, 1, 2, 4, 6, 7, 9], [3, 4, 4, 3, 5, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-29

t30 = [[0, 1, 2, 4, 6, 8, 9], [3, 4, 3, 5, 4, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-30

t31 = [[0, 1, 3, 4, 6, 7, 9], [3, 3, 6, 3, 3, 3], [1, 0, 0, 1, 0, 0, 0, 0], 0]; // 7-31

t32 = [[0, 1, 3, 4, 6, 8, 9], [3, 3, 5, 4, 4, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 7-32

t33 = [[0, 1, 2, 4, 6, 8, 10], [2, 6, 2, 6, 2, 3], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 7-33

t34 = [[0, 1, 3, 4, 6, 8, 10], [2, 5, 4, 4, 4, 2], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 7-34

t35 = [[0, 1, 3, 5, 6, 8, 10], [2, 5, 4, 3, 6, 1], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 7-35

t36 = [[0, 1, 2, 3, 5, 6, 8], [4, 4, 4, 3, 4, 2], [1, 0, 0, 1, 0, 0, 0, 0], 12]; // 7-36 z

t37 = [[0, 1, 3, 4, 5, 7, 8], [4, 3, 4, 5, 4, 1], [1, 1, 0, 0, 0, 0, 0, 0], 17]; // 7-37 z

t38 = [[0, 1, 2, 4, 5, 7, 8], [4, 3, 4, 4, 4, 2], [1, 0, 0, 0, 0, 0, 0, 0], 18]; // 7-38 z

var septachord = [undefined, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, t17, t18, t19, t20, t21, t22, t23, t24, t25, t26, t27, t28, t29, t30, t31, t32, t33, t34, t35, t36, t37, t38];
t1 = [[0, 1, 2, 3, 4, 5, 6, 7], [7, 6, 5, 4, 4, 2], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 8-1

t2 = [[0, 1, 2, 3, 4, 5, 6, 8], [6, 6, 5, 5, 4, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 8-2

t3 = [[0, 1, 2, 3, 4, 5, 6, 9], [6, 5, 6, 5, 4, 2], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 8-3

t4 = [[0, 1, 2, 3, 4, 5, 7, 8], [6, 5, 5, 5, 5, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 8-4

t5 = [[0, 1, 2, 3, 4, 6, 7, 8], [6, 5, 4, 5, 5, 3], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 8-5

t6 = [[0, 1, 2, 3, 5, 6, 7, 8], [6, 5, 4, 4, 6, 3], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 8-6

t7 = [[0, 1, 2, 3, 4, 5, 8, 9], [6, 4, 5, 6, 5, 2], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 8-7

t8 = [[0, 1, 2, 3, 4, 7, 8, 9], [6, 4, 4, 5, 6, 3], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 8-8

t9 = [[0, 1, 2, 3, 6, 7, 8, 9], [6, 4, 4, 4, 6, 4], [2, 2, 2, 2, 0, 0, 0, 0], 0]; // 8-9

t10 = [[0, 2, 3, 4, 5, 6, 7, 9], [5, 6, 6, 4, 5, 2], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 8-10

t11 = [[0, 1, 2, 3, 4, 5, 7, 9], [5, 6, 5, 5, 5, 2], [1, 0, 1, 0, 0, 0, 0, 0], 0]; // 8-11

t12 = [[0, 1, 3, 4, 5, 6, 7, 9], [5, 5, 6, 5, 4, 3], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 8-12

t13 = [[0, 1, 2, 3, 4, 6, 7, 9], [5, 5, 6, 4, 5, 3], [1, 0, 0, 1, 0, 0, 0, 0], 0]; // 8-13

t14 = [[0, 1, 2, 4, 5, 6, 7, 9], [5, 5, 5, 5, 6, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 8-14

t15 = [[0, 1, 2, 3, 4, 6, 8, 9], [5, 5, 5, 5, 5, 3], [1, 0, 0, 0, 0, 0, 0, 0], 29]; // 8-15  zz

t16 = [[0, 1, 2, 3, 5, 7, 8, 9], [5, 5, 4, 5, 6, 3], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 8-16

t17 = [[0, 1, 3, 4, 5, 6, 8, 9], [5, 4, 6, 6, 5, 2], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 8-17

t18 = [[0, 1, 2, 3, 5, 6, 8, 9], [5, 4, 6, 5, 5, 3], [1, 0, 0, 1, 0, 0, 0, 0], 0]; // 8-18

t19 = [[0, 1, 2, 4, 5, 6, 8, 9], [5, 4, 5, 7, 5, 2], [1, 0, 1, 0, 0, 0, 0, 0], 0]; // 8-19

t20 = [[0, 1, 2, 4, 5, 7, 8, 9], [5, 4, 5, 6, 6, 2], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 8-20

t21 = [[0, 1, 2, 3, 4, 6, 8, 10], [4, 7, 4, 6, 4, 3], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 8-21

t22 = [[0, 1, 2, 3, 5, 6, 8, 10], [4, 6, 5, 5, 6, 2], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 8-22

t23 = [[0, 1, 2, 3, 5, 7, 8, 10], [4, 6, 5, 4, 7, 2], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 8-23

t24 = [[0, 1, 2, 4, 5, 6, 8, 10], [4, 6, 4, 7, 4, 3], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 8-24

t25 = [[0, 1, 2, 4, 6, 7, 8, 10], [4, 6, 4, 6, 4, 4], [2, 2, 2, 2, 0, 0, 0, 0], 0]; // 8-25

t26 = [[0, 1, 2, 4, 5, 7, 9, 10], [4, 5, 6, 5, 6, 2], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 8-26

t27 = [[0, 1, 2, 4, 5, 7, 8, 10], [4, 5, 6, 5, 5, 3], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 8-27

t28 = [[0, 1, 3, 4, 6, 7, 9, 10], [4, 4, 8, 4, 4, 4], [4, 4, 4, 4, 0, 0, 0, 0], 0]; // 8-28

t29 = [[0, 1, 2, 3, 5, 6, 7, 9], [5, 5, 5, 5, 5, 3], [1, 0, 0, 0, 0, 0, 0, 0], 15]; // 8-29

var octachord = [undefined, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, t17, t18, t19, t20, t21, t22, t23, t24, t25, t26, t27, t28, t29];
t1 = [[0, 1, 2, 3, 4, 5, 6, 7, 8], [8, 7, 6, 6, 6, 3], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 9-1

t2 = [[0, 1, 2, 3, 4, 5, 6, 7, 9], [7, 7, 7, 6, 6, 3], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 9-2

t3 = [[0, 1, 2, 3, 4, 5, 6, 8, 9], [7, 6, 7, 7, 6, 3], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 9-3

t4 = [[0, 1, 2, 3, 4, 5, 7, 8, 9], [7, 6, 6, 7, 7, 3], [1, 0, 1, 0, 0, 0, 0, 0], 0]; // 9-4

t5 = [[0, 1, 2, 3, 4, 6, 7, 8, 9], [7, 6, 6, 6, 7, 4], [1, 0, 0, 1, 0, 0, 0, 0], 0]; // 9-5

t6 = [[0, 1, 2, 3, 4, 5, 6, 8, 10], [6, 8, 6, 7, 6, 3], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 9-6

t7 = [[0, 1, 2, 3, 4, 5, 7, 8, 10], [6, 7, 7, 6, 7, 3], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 9-7

t8 = [[0, 1, 2, 3, 4, 6, 7, 8, 10], [6, 7, 6, 7, 6, 4], [1, 0, 0, 1, 0, 0, 0, 0], 0]; // 9-8

t9 = [[0, 1, 2, 3, 5, 6, 7, 8, 10], [6, 7, 6, 6, 8, 3], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 9-9

t10 = [[0, 1, 2, 3, 4, 6, 7, 9, 10], [6, 6, 8, 6, 6, 4], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 9-10

t11 = [[0, 1, 2, 3, 5, 6, 7, 9, 10], [6, 6, 7, 7, 7, 3], [1, 0, 0, 0, 0, 0, 0, 0], 0]; // 9-11

t12 = [[0, 1, 2, 4, 5, 6, 8, 9, 10], [6, 6, 6, 9, 6, 3], [3, 3, 3, 3, 0, 0, 0, 0], 0]; // 9-12

var nonachord = [undefined, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12];
t1 = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [9, 8, 8, 8, 8, 4], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 10-1

t2 = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 10], [8, 9, 8, 8, 8, 4], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 10-2

t3 = [[0, 1, 2, 3, 4, 5, 6, 7, 9, 10], [8, 8, 9, 8, 8, 4], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 10-3

t4 = [[0, 1, 2, 3, 4, 5, 6, 8, 9, 10], [8, 8, 8, 9, 8, 4], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 10-4

t5 = [[0, 1, 2, 3, 4, 5, 7, 8, 9, 10], [8, 8, 8, 8, 9, 4], [1, 1, 0, 0, 0, 0, 0, 0], 0]; // 10-5

t6 = [[0, 1, 2, 3, 4, 6, 7, 8, 9, 10], [8, 8, 8, 8, 8, 5], [2, 2, 2, 2, 0, 0, 0, 0], 0]; // 10-6

var decachord = [undefined, t1, t2, t3, t4, t5, t6];
t1 = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], [10, 10, 10, 10, 10, 5], [1, 1, 1, 1, 0, 0, 0, 0], 0]; // 11-1

var undecachord = [undefined, t1];
t1 = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], [12, 12, 12, 12, 12, 6], [12, 12, 12, 12, 0, 0, 0, 0], 0]; // 12-1

var dodecachord = [undefined, t1]; // -------------------------------------------------------------------------------

var FORTE = [undefined, monad, diad, trichord, tetrachord, pentachord, hexachord, septachord, octachord, nonachord, decachord, undecachord, dodecachord]; // to access the data for a single form, use:
// forte   [size[tetra]] = 4
//         [number[forte]] = 3
//         [data[0=pitches, 1=ICV, 2=invariance vector [morris], 3 = Z-relation]]
//         [element in list]
//-------------------------------------------------------------------------------
// cardinality 1

var card_1 = {
  '1,0': [FORTE[1][1][0], FORTE[1][1][2], FORTE[1][1][1]]
}; // cardinality 2

var card_2 = {
  '1,0': [FORTE[2][1][0], FORTE[2][1][2], FORTE[2][1][1]],
  '2,0': [FORTE[2][2][0], FORTE[2][2][2], FORTE[2][2][1]],
  '3,0': [FORTE[2][3][0], FORTE[2][3][2], FORTE[2][3][1]],
  '4,0': [FORTE[2][4][0], FORTE[2][4][2], FORTE[2][4][1]],
  '5,0': [FORTE[2][5][0], FORTE[2][5][2], FORTE[2][5][1]],
  '6,0': [FORTE[2][6][0], FORTE[2][6][2], FORTE[2][6][1]]
}; // cardinality 3

var card_3 = {
  '1,0': [FORTE[3][1][0], FORTE[3][1][2], FORTE[3][1][1]],
  '2,1': [FORTE[3][2][0], FORTE[3][2][2], FORTE[3][2][1]],
  '2,-1': [[0, 2, 3], FORTE[3][2][2], FORTE[3][2][1]],
  '3,1': [FORTE[3][3][0], FORTE[3][3][2], FORTE[3][3][1]],
  '3,-1': [[0, 3, 4], FORTE[3][3][2], FORTE[3][3][1]],
  '4,1': [FORTE[3][4][0], FORTE[3][4][2], FORTE[3][4][1]],
  '4,-1': [[0, 4, 5], FORTE[3][4][2], FORTE[3][4][1]],
  '5,1': [FORTE[3][5][0], FORTE[3][5][2], FORTE[3][5][1]],
  '5,-1': [[0, 5, 6], FORTE[3][5][2], FORTE[3][5][1]],
  '6,0': [FORTE[3][6][0], FORTE[3][6][2], FORTE[3][6][1]],
  '7,1': [FORTE[3][7][0], FORTE[3][7][2], FORTE[3][7][1]],
  '7,-1': [[0, 3, 5], FORTE[3][7][2], FORTE[3][7][1]],
  '8,1': [FORTE[3][8][0], FORTE[3][8][2], FORTE[3][8][1]],
  '8,-1': [[0, 4, 6], FORTE[3][8][2], FORTE[3][8][1]],
  '9,0': [FORTE[3][9][0], FORTE[3][9][2], FORTE[3][9][1]],
  '10,0': [FORTE[3][10][0], FORTE[3][10][2], FORTE[3][10][1]],
  '11,1': [FORTE[3][11][0], FORTE[3][11][2], FORTE[3][11][1]],
  '11,-1': [[0, 4, 7], FORTE[3][11][2], FORTE[3][11][1]],
  '12,0': [FORTE[3][12][0], FORTE[3][12][2], FORTE[3][12][1]]
}; // cardinality 4

var card_4 = {
  '1,0': [FORTE[4][1][0], FORTE[4][1][2], FORTE[4][1][1]],
  '2,1': [FORTE[4][2][0], FORTE[4][2][2], FORTE[4][2][1]],
  '2,-1': [[0, 2, 3, 4], FORTE[4][2][2], FORTE[4][2][1]],
  '3,0': [FORTE[4][3][0], FORTE[4][3][2], FORTE[4][3][1]],
  '4,1': [FORTE[4][4][0], FORTE[4][4][2], FORTE[4][4][1]],
  '4,-1': [[0, 3, 4, 5], FORTE[4][4][2], FORTE[4][4][1]],
  '5,1': [FORTE[4][5][0], FORTE[4][5][2], FORTE[4][5][1]],
  '5,-1': [[0, 4, 5, 6], FORTE[4][5][2], FORTE[4][5][1]],
  '6,0': [FORTE[4][6][0], FORTE[4][6][2], FORTE[4][6][1]],
  '7,0': [FORTE[4][7][0], FORTE[4][7][2], FORTE[4][7][1]],
  '8,0': [FORTE[4][8][0], FORTE[4][8][2], FORTE[4][8][1]],
  '9,0': [FORTE[4][9][0], FORTE[4][9][2], FORTE[4][9][1]],
  '10,0': [FORTE[4][10][0], FORTE[4][10][2], FORTE[4][10][1]],
  '11,1': [FORTE[4][11][0], FORTE[4][11][2], FORTE[4][11][1]],
  '11,-1': [[0, 2, 4, 5], FORTE[4][11][2], FORTE[4][11][1]],
  '12,1': [FORTE[4][12][0], FORTE[4][12][2], FORTE[4][12][1]],
  '12,-1': [[0, 3, 4, 6], FORTE[4][12][2], FORTE[4][12][1]],
  '13,1': [FORTE[4][13][0], FORTE[4][13][2], FORTE[4][13][1]],
  '13,-1': [[0, 3, 5, 6], FORTE[4][13][2], FORTE[4][13][1]],
  '14,1': [FORTE[4][14][0], FORTE[4][14][2], FORTE[4][14][1]],
  '14,-1': [[0, 4, 5, 7], FORTE[4][14][2], FORTE[4][14][1]],
  '15,1': [FORTE[4][15][0], FORTE[4][15][2], FORTE[4][15][1]],
  '15,-1': [[0, 2, 5, 6], FORTE[4][15][2], FORTE[4][15][1]],
  '16,1': [FORTE[4][16][0], FORTE[4][16][2], FORTE[4][16][1]],
  '16,-1': [[0, 2, 6, 7], FORTE[4][16][2], FORTE[4][16][1]],
  '17,0': [FORTE[4][17][0], FORTE[4][17][2], FORTE[4][17][1]],
  '18,1': [FORTE[4][18][0], FORTE[4][18][2], FORTE[4][18][1]],
  '18,-1': [[0, 3, 6, 7], FORTE[4][18][2], FORTE[4][18][1]],
  '19,1': [FORTE[4][19][0], FORTE[4][19][2], FORTE[4][19][1]],
  '19,-1': [[0, 4, 7, 8], FORTE[4][19][2], FORTE[4][19][1]],
  '20,0': [FORTE[4][20][0], FORTE[4][20][2], FORTE[4][20][1]],
  '21,0': [FORTE[4][21][0], FORTE[4][21][2], FORTE[4][21][1]],
  '22,1': [FORTE[4][22][0], FORTE[4][22][2], FORTE[4][22][1]],
  '22,-1': [[0, 3, 5, 7], FORTE[4][22][2], FORTE[4][22][1]],
  '23,0': [FORTE[4][23][0], FORTE[4][23][2], FORTE[4][23][1]],
  '24,0': [FORTE[4][24][0], FORTE[4][24][2], FORTE[4][24][1]],
  '25,0': [FORTE[4][25][0], FORTE[4][25][2], FORTE[4][25][1]],
  '26,0': [FORTE[4][26][0], FORTE[4][26][2], FORTE[4][26][1]],
  '27,1': [FORTE[4][27][0], FORTE[4][27][2], FORTE[4][27][1]],
  '27,-1': [[0, 3, 6, 8], FORTE[4][27][2], FORTE[4][27][1]],
  '28,0': [FORTE[4][28][0], FORTE[4][28][2], FORTE[4][28][1]],
  '29,1': [FORTE[4][29][0], FORTE[4][29][2], FORTE[4][29][1]],
  '29,-1': [[0, 4, 6, 7], FORTE[4][29][2], FORTE[4][29][1]]
}; // cardinality 5

var card_5 = {
  '1,0': [FORTE[5][1][0], FORTE[5][1][2], FORTE[5][1][1]],
  '2,1': [FORTE[5][2][0], FORTE[5][2][2], FORTE[5][2][1]],
  '2,-1': [[0, 2, 3, 4, 5], FORTE[5][2][2], FORTE[5][2][1]],
  '3,1': [FORTE[5][3][0], FORTE[5][3][2], FORTE[5][3][1]],
  '3,-1': [[0, 1, 3, 4, 5], FORTE[5][3][2], FORTE[5][3][1]],
  '4,1': [FORTE[5][4][0], FORTE[5][4][2], FORTE[5][4][1]],
  '4,-1': [[0, 3, 4, 5, 6], FORTE[5][4][2], FORTE[5][4][1]],
  '5,1': [FORTE[5][5][0], FORTE[5][5][2], FORTE[5][5][1]],
  '5,-1': [[0, 4, 5, 6, 7], FORTE[5][5][2], FORTE[5][5][1]],
  '6,1': [FORTE[5][6][0], FORTE[5][6][2], FORTE[5][6][1]],
  '6,-1': [[0, 1, 4, 5, 6], FORTE[5][6][2], FORTE[5][6][1]],
  '7,1': [FORTE[5][7][0], FORTE[5][7][2], FORTE[5][7][1]],
  '7,-1': [[0, 1, 5, 6, 7], FORTE[5][7][2], FORTE[5][7][1]],
  '8,0': [FORTE[5][8][0], FORTE[5][8][2], FORTE[5][8][1]],
  '9,1': [FORTE[5][9][0], FORTE[5][9][2], FORTE[5][9][1]],
  '9,-1': [[0, 2, 4, 5, 6], FORTE[5][9][2], FORTE[5][9][1]],
  '10,1': [FORTE[5][10][0], FORTE[5][10][2], FORTE[5][10][1]],
  '10,-1': [[0, 2, 3, 5, 6], FORTE[5][10][2], FORTE[5][10][1]],
  '11,1': [FORTE[5][11][0], FORTE[5][11][2], FORTE[5][11][1]],
  '11,-1': [[0, 3, 4, 5, 7], FORTE[5][11][2], FORTE[5][11][1]],
  '12,0': [FORTE[5][12][0], FORTE[5][12][2], FORTE[5][12][1]],
  '13,1': [FORTE[5][13][0], FORTE[5][13][2], FORTE[5][13][1]],
  '13,-1': [[0, 4, 6, 7, 8], FORTE[5][13][2], FORTE[5][13][1]],
  '14,1': [FORTE[5][14][0], FORTE[5][14][2], FORTE[5][14][1]],
  '14,-1': [[0, 2, 5, 6, 7], FORTE[5][14][2], FORTE[5][14][1]],
  '15,0': [FORTE[5][15][0], FORTE[5][15][2], FORTE[5][15][1]],
  '16,1': [FORTE[5][16][0], FORTE[5][16][2], FORTE[5][16][1]],
  '16,-1': [[0, 3, 4, 6, 7], FORTE[5][16][2], FORTE[5][16][1]],
  '17,0': [FORTE[5][17][0], FORTE[5][17][2], FORTE[5][17][1]],
  '18,1': [FORTE[5][18][0], FORTE[5][18][2], FORTE[5][18][1]],
  '18,-1': [[0, 2, 3, 6, 7], FORTE[5][18][2], FORTE[5][18][1]],
  '19,1': [FORTE[5][19][0], FORTE[5][19][2], FORTE[5][19][1]],
  '19,-1': [[0, 1, 4, 6, 7], FORTE[5][19][2], FORTE[5][19][1]],
  '20,1': [FORTE[5][20][0], FORTE[5][20][2], FORTE[5][20][1]],
  '20,-1': [[0, 1, 5, 7, 8], FORTE[5][20][2], FORTE[5][20][1]],
  '21,1': [FORTE[5][21][0], FORTE[5][21][2], FORTE[5][21][1]],
  '21,-1': [[0, 3, 4, 7, 8], FORTE[5][21][2], FORTE[5][21][1]],
  '22,0': [FORTE[5][22][0], FORTE[5][22][2], FORTE[5][22][1]],
  '23,1': [FORTE[5][23][0], FORTE[5][23][2], FORTE[5][23][1]],
  '23,-1': [[0, 2, 4, 5, 7], FORTE[5][23][2], FORTE[5][23][1]],
  '24,1': [FORTE[5][24][0], FORTE[5][24][2], FORTE[5][24][1]],
  '24,-1': [[0, 2, 4, 6, 7], FORTE[5][24][2], FORTE[5][24][1]],
  '25,1': [FORTE[5][25][0], FORTE[5][25][2], FORTE[5][25][1]],
  '25,-1': [[0, 3, 5, 6, 8], FORTE[5][25][2], FORTE[5][25][1]],
  '26,1': [FORTE[5][26][0], FORTE[5][26][2], FORTE[5][26][1]],
  '26,-1': [[0, 3, 4, 6, 8], FORTE[5][26][2], FORTE[5][26][1]],
  '27,1': [FORTE[5][27][0], FORTE[5][27][2], FORTE[5][27][1]],
  '27,-1': [[0, 3, 5, 7, 8], FORTE[5][27][2], FORTE[5][27][1]],
  '28,1': [FORTE[5][28][0], FORTE[5][28][2], FORTE[5][28][1]],
  '28,-1': [[0, 2, 5, 6, 8], FORTE[5][28][2], FORTE[5][28][1]],
  '29,1': [FORTE[5][29][0], FORTE[5][29][2], FORTE[5][29][1]],
  '29,-1': [[0, 2, 5, 7, 8], FORTE[5][29][2], FORTE[5][29][1]],
  '30,1': [FORTE[5][30][0], FORTE[5][30][2], FORTE[5][30][1]],
  '30,-1': [[0, 2, 4, 7, 8], FORTE[5][30][2], FORTE[5][30][1]],
  '31,1': [FORTE[5][31][0], FORTE[5][31][2], FORTE[5][31][1]],
  '31,-1': [[0, 3, 6, 8, 9], FORTE[5][31][2], FORTE[5][31][1]],
  '32,1': [FORTE[5][32][0], FORTE[5][32][2], FORTE[5][32][1]],
  '32,-1': [[0, 3, 5, 8, 9], FORTE[5][32][2], FORTE[5][32][1]],
  '33,0': [FORTE[5][33][0], FORTE[5][33][2], FORTE[5][33][1]],
  '34,0': [FORTE[5][34][0], FORTE[5][34][2], FORTE[5][34][1]],
  '35,0': [FORTE[5][35][0], FORTE[5][35][2], FORTE[5][35][1]],
  '36,1': [FORTE[5][36][0], FORTE[5][36][2], FORTE[5][36][1]],
  '36,-1': [[0, 3, 5, 6, 7], FORTE[5][36][2], FORTE[5][36][1]],
  '37,0': [FORTE[5][37][0], FORTE[5][37][2], FORTE[5][37][1]],
  '38,1': [FORTE[5][38][0], FORTE[5][38][2], FORTE[5][38][1]],
  '38,-1': [[0, 3, 6, 7, 8], FORTE[5][38][2], FORTE[5][38][1]]
}; // cardinality 6

var card_6 = {
  '1,0': [FORTE[6][1][0], FORTE[6][1][2], FORTE[6][1][1]],
  '2,1': [FORTE[6][2][0], FORTE[6][2][2], FORTE[6][2][1]],
  '2,-1': [[0, 2, 3, 4, 5, 6], FORTE[6][2][2], FORTE[6][2][1]],
  '3,1': [FORTE[6][3][0], FORTE[6][3][2], FORTE[6][3][1]],
  '3,-1': [[0, 1, 3, 4, 5, 6], FORTE[6][3][2], FORTE[6][3][1]],
  '4,0': [FORTE[6][4][0], FORTE[6][4][2], FORTE[6][4][1]],
  '5,1': [FORTE[6][5][0], FORTE[6][5][2], FORTE[6][5][1]],
  '5,-1': [[0, 1, 4, 5, 6, 7], FORTE[6][5][2], FORTE[6][5][1]],
  '6,0': [FORTE[6][6][0], FORTE[6][6][2], FORTE[6][6][1]],
  '7,0': [FORTE[6][7][0], FORTE[6][7][2], FORTE[6][7][1]],
  '8,0': [FORTE[6][8][0], FORTE[6][8][2], FORTE[6][8][1]],
  '9,1': [FORTE[6][9][0], FORTE[6][9][2], FORTE[6][9][1]],
  '9,-1': [[0, 2, 4, 5, 6, 7], FORTE[6][9][2], FORTE[6][9][1]],
  '10,1': [FORTE[6][10][0], FORTE[6][10][2], FORTE[6][10][1]],
  '10,-1': [[0, 2, 3, 4, 6, 7], FORTE[6][10][2], FORTE[6][10][1]],
  '11,1': [FORTE[6][11][0], FORTE[6][11][2], FORTE[6][11][1]],
  '11,-1': [[0, 2, 3, 5, 6, 7], FORTE[6][11][2], FORTE[6][11][1]],
  '12,1': [FORTE[6][12][0], FORTE[6][12][2], FORTE[6][12][1]],
  '12,-1': [[0, 1, 3, 5, 6, 7], FORTE[6][12][2], FORTE[6][12][1]],
  '13,0': [FORTE[6][13][0], FORTE[6][13][2], FORTE[6][13][1]],
  '14,1': [FORTE[6][14][0], FORTE[6][14][2], FORTE[6][14][1]],
  '14,-1': [[0, 3, 4, 5, 7, 8], FORTE[6][14][2], FORTE[6][14][1]],
  '15,1': [FORTE[6][15][0], FORTE[6][15][2], FORTE[6][15][1]],
  '15,-1': [[0, 3, 4, 6, 7, 8], FORTE[6][15][2], FORTE[6][15][1]],
  '16,1': [FORTE[6][16][0], FORTE[6][16][2], FORTE[6][16][1]],
  '16,-1': [[0, 2, 3, 4, 7, 8], FORTE[6][16][2], FORTE[6][16][1]],
  '17,1': [FORTE[6][17][0], FORTE[6][17][2], FORTE[6][17][1]],
  '17,-1': [[0, 1, 4, 6, 7, 8], FORTE[6][17][2], FORTE[6][17][1]],
  '18,1': [FORTE[6][18][0], FORTE[6][18][2], FORTE[6][18][1]],
  '18,-1': [[0, 1, 3, 6, 7, 8], FORTE[6][18][2], FORTE[6][18][1]],
  '19,1': [FORTE[6][19][0], FORTE[6][19][2], FORTE[6][19][1]],
  '19,-1': [[0, 1, 4, 5, 7, 8], FORTE[6][19][2], FORTE[6][19][1]],
  '20,0': [FORTE[6][20][0], FORTE[6][20][2], FORTE[6][20][1]],
  '21,1': [FORTE[6][21][0], FORTE[6][21][2], FORTE[6][21][1]],
  '21,-1': [[0, 2, 4, 5, 6, 8], FORTE[6][21][2], FORTE[6][21][1]],
  '22,1': [FORTE[6][22][0], FORTE[6][22][2], FORTE[6][22][1]],
  '22,-1': [[0, 2, 4, 6, 7, 8], FORTE[6][22][2], FORTE[6][22][1]],
  '23,0': [FORTE[6][23][0], FORTE[6][23][2], FORTE[6][23][1]],
  '24,1': [FORTE[6][24][0], FORTE[6][24][2], FORTE[6][24][1]],
  '24,-1': [[0, 2, 4, 5, 7, 8], FORTE[6][24][2], FORTE[6][24][1]],
  '25,1': [FORTE[6][25][0], FORTE[6][25][2], FORTE[6][25][1]],
  '25,-1': [[0, 2, 3, 5, 7, 8], FORTE[6][25][2], FORTE[6][25][1]],
  '26,0': [FORTE[6][26][0], FORTE[6][26][2], FORTE[6][26][1]],
  '27,1': [FORTE[6][27][0], FORTE[6][27][2], FORTE[6][27][1]],
  '27,-1': [[0, 3, 5, 6, 8, 9], FORTE[6][27][2], FORTE[6][27][1]],
  '28,0': [FORTE[6][28][0], FORTE[6][28][2], FORTE[6][28][1]],
  '29,0': [FORTE[6][29][0], FORTE[6][29][2], FORTE[6][29][1]],
  '30,1': [FORTE[6][30][0], FORTE[6][30][2], FORTE[6][30][1]],
  '30,-1': [[0, 2, 3, 6, 8, 9], FORTE[6][30][2], FORTE[6][30][1]],
  '31,1': [FORTE[6][31][0], FORTE[6][31][2], FORTE[6][31][1]],
  '31,-1': [[0, 1, 4, 6, 8, 9], FORTE[6][31][2], FORTE[6][31][1]],
  '32,0': [FORTE[6][32][0], FORTE[6][32][2], FORTE[6][32][1]],
  '33,1': [FORTE[6][33][0], FORTE[6][33][2], FORTE[6][33][1]],
  '33,-1': [[0, 2, 4, 6, 7, 9], FORTE[6][33][2], FORTE[6][33][1]],
  '34,1': [FORTE[6][34][0], FORTE[6][34][2], FORTE[6][34][1]],
  '34,-1': [[0, 2, 4, 6, 8, 9], FORTE[6][34][2], FORTE[6][34][1]],
  '35,0': [FORTE[6][35][0], FORTE[6][35][2], FORTE[6][35][1]],
  '36,1': [FORTE[6][36][0], FORTE[6][36][2], FORTE[6][36][1]],
  '36,-1': [[0, 3, 4, 5, 6, 7], FORTE[6][36][2], FORTE[6][36][1]],
  '37,0': [FORTE[6][37][0], FORTE[6][37][2], FORTE[6][37][1]],
  '38,0': [FORTE[6][38][0], FORTE[6][38][2], FORTE[6][38][1]],
  '39,1': [FORTE[6][39][0], FORTE[6][39][2], FORTE[6][39][1]],
  '39,-1': [[0, 3, 4, 5, 6, 8], FORTE[6][39][2], FORTE[6][39][1]],
  '40,1': [FORTE[6][40][0], FORTE[6][40][2], FORTE[6][40][1]],
  '40,-1': [[0, 3, 5, 6, 7, 8], FORTE[6][40][2], FORTE[6][40][1]],
  '41,1': [FORTE[6][41][0], FORTE[6][41][2], FORTE[6][41][1]],
  '41,-1': [[0, 2, 5, 6, 7, 8], FORTE[6][41][2], FORTE[6][41][1]],
  '42,0': [FORTE[6][42][0], FORTE[6][42][2], FORTE[6][42][1]],
  '43,1': [FORTE[6][43][0], FORTE[6][43][2], FORTE[6][43][1]],
  '43,-1': [[0, 2, 3, 6, 7, 8], FORTE[6][43][2], FORTE[6][43][1]],
  '44,1': [FORTE[6][44][0], FORTE[6][44][2], FORTE[6][44][1]],
  '44,-1': [[0, 3, 4, 7, 8, 9], FORTE[6][44][2], FORTE[6][44][1]],
  '45,0': [FORTE[6][45][0], FORTE[6][45][2], FORTE[6][45][1]],
  '46,1': [FORTE[6][46][0], FORTE[6][46][2], FORTE[6][46][1]],
  '46,-1': [[0, 3, 5, 7, 8, 9], FORTE[6][46][2], FORTE[6][46][1]],
  '47,1': [FORTE[6][47][0], FORTE[6][47][2], FORTE[6][47][1]],
  '47,-1': [[0, 2, 5, 7, 8, 9], FORTE[6][47][2], FORTE[6][47][1]],
  '48,0': [FORTE[6][48][0], FORTE[6][48][2], FORTE[6][48][1]],
  '49,0': [FORTE[6][49][0], FORTE[6][49][2], FORTE[6][49][1]],
  '50,0': [FORTE[6][50][0], FORTE[6][50][2], FORTE[6][50][1]]
}; // cardinality 7

var card_7 = {
  '1,0': [FORTE[7][1][0], FORTE[7][1][2], FORTE[7][1][1]],
  '2,1': [FORTE[7][2][0], FORTE[7][2][2], FORTE[7][2][1]],
  '2,-1': [[0, 2, 3, 4, 5, 6, 7], FORTE[7][2][2], FORTE[7][2][1]],
  '3,1': [FORTE[7][3][0], FORTE[7][3][2], FORTE[7][3][1]],
  '3,-1': [[0, 3, 4, 5, 6, 7, 8], FORTE[7][3][2], FORTE[7][3][1]],
  '4,1': [FORTE[7][4][0], FORTE[7][4][2], FORTE[7][4][1]],
  '4,-1': [[0, 1, 3, 4, 5, 6, 7], FORTE[7][4][2], FORTE[7][4][1]],
  '5,1': [FORTE[7][5][0], FORTE[7][5][2], FORTE[7][5][1]],
  '5,-1': [[0, 1, 2, 4, 5, 6, 7], FORTE[7][5][2], FORTE[7][5][1]],
  '6,1': [FORTE[7][6][0], FORTE[7][6][2], FORTE[7][6][1]],
  '6,-1': [[0, 1, 4, 5, 6, 7, 8], FORTE[7][6][2], FORTE[7][6][1]],
  '7,1': [FORTE[7][7][0], FORTE[7][7][2], FORTE[7][7][1]],
  '7,-1': [[0, 1, 2, 5, 6, 7, 8], FORTE[7][7][2], FORTE[7][7][1]],
  '8,0': [FORTE[7][8][0], FORTE[7][8][2], FORTE[7][8][1]],
  '9,1': [FORTE[7][9][0], FORTE[7][9][2], FORTE[7][9][1]],
  '9,-1': [[0, 2, 4, 5, 6, 7, 8], FORTE[7][9][2], FORTE[7][9][1]],
  '10,1': [FORTE[7][10][0], FORTE[7][10][2], FORTE[7][10][1]],
  '10,-1': [[0, 3, 5, 6, 7, 8, 9], FORTE[7][10][2], FORTE[7][10][1]],
  '11,1': [FORTE[7][11][0], FORTE[7][11][2], FORTE[7][11][1]],
  '11,-1': [[0, 2, 3, 4, 5, 7, 8], FORTE[7][11][2], FORTE[7][11][1]],
  '12,0': [FORTE[7][12][0], FORTE[7][12][2], FORTE[7][12][1]],
  '13,1': [FORTE[7][13][0], FORTE[7][13][2], FORTE[7][13][1]],
  '13,-1': [[0, 2, 3, 4, 6, 7, 8], FORTE[7][13][2], FORTE[7][13][1]],
  '14,1': [FORTE[7][14][0], FORTE[7][14][2], FORTE[7][14][1]],
  '14,-1': [[0, 1, 3, 5, 6, 7, 8], FORTE[7][14][2], FORTE[7][14][1]],
  '15,0': [FORTE[7][15][0], FORTE[7][15][2], FORTE[7][15][1]],
  '16,1': [FORTE[7][16][0], FORTE[7][16][2], FORTE[7][16][1]],
  '16,-1': [[0, 3, 4, 6, 7, 8, 9], FORTE[7][16][2], FORTE[7][16][1]],
  '17,0': [FORTE[7][17][0], FORTE[7][17][2], FORTE[7][17][1]],
  '18,1': [FORTE[7][18][0], FORTE[7][18][2], FORTE[7][18][1]],
  '18,-1': [[0, 1, 4, 6, 7, 8, 9], FORTE[7][18][2], FORTE[7][18][1]],
  '19,1': [FORTE[7][19][0], FORTE[7][19][2], FORTE[7][19][1]],
  '19,-1': [[0, 2, 3, 6, 7, 8, 9], FORTE[7][19][2], FORTE[7][19][1]],
  '20,1': [FORTE[7][20][0], FORTE[7][20][2], FORTE[7][20][1]],
  '20,-1': [[0, 1, 2, 5, 7, 8, 9], FORTE[7][20][2], FORTE[7][20][1]],
  '21,1': [FORTE[7][21][0], FORTE[7][21][2], FORTE[7][21][1]],
  '21,-1': [[0, 1, 4, 5, 7, 8, 9], FORTE[7][21][2], FORTE[7][21][1]],
  '22,0': [FORTE[7][22][0], FORTE[7][22][2], FORTE[7][22][1]],
  '23,1': [FORTE[7][23][0], FORTE[7][23][2], FORTE[7][23][1]],
  '23,-1': [[0, 2, 4, 5, 6, 7, 9], FORTE[7][23][2], FORTE[7][23][1]],
  '24,1': [FORTE[7][24][0], FORTE[7][24][2], FORTE[7][24][1]],
  '24,-1': [[0, 2, 4, 6, 7, 8, 9], FORTE[7][24][2], FORTE[7][24][1]],
  '25,1': [FORTE[7][25][0], FORTE[7][25][2], FORTE[7][25][1]],
  '25,-1': [[0, 2, 3, 5, 6, 7, 9], FORTE[7][25][2], FORTE[7][25][1]],
  '26,1': [FORTE[7][26][0], FORTE[7][26][2], FORTE[7][26][1]],
  '26,-1': [[0, 2, 4, 5, 6, 8, 9], FORTE[7][26][2], FORTE[7][26][1]],
  '27,1': [FORTE[7][27][0], FORTE[7][27][2], FORTE[7][27][1]],
  '27,-1': [[0, 2, 4, 5, 7, 8, 9], FORTE[7][27][2], FORTE[7][27][1]],
  '28,1': [FORTE[7][28][0], FORTE[7][28][2], FORTE[7][28][1]],
  '28,-1': [[0, 2, 3, 4, 6, 8, 9], FORTE[7][28][2], FORTE[7][28][1]],
  '29,1': [FORTE[7][29][0], FORTE[7][29][2], FORTE[7][29][1]],
  '29,-1': [[0, 2, 3, 5, 7, 8, 9], FORTE[7][29][2], FORTE[7][29][1]],
  '30,1': [FORTE[7][30][0], FORTE[7][30][2], FORTE[7][30][1]],
  '30,-1': [[0, 1, 3, 5, 7, 8, 9], FORTE[7][30][2], FORTE[7][30][1]],
  '31,1': [FORTE[7][31][0], FORTE[7][31][2], FORTE[7][31][1]],
  '31,-1': [[0, 2, 3, 5, 6, 8, 9], FORTE[7][31][2], FORTE[7][31][1]],
  '32,1': [FORTE[7][32][0], FORTE[7][32][2], FORTE[7][32][1]],
  '32,-1': [[0, 1, 3, 5, 6, 8, 9], FORTE[7][32][2], FORTE[7][32][1]],
  '33,0': [FORTE[7][33][0], FORTE[7][33][2], FORTE[7][33][1]],
  '34,0': [FORTE[7][34][0], FORTE[7][34][2], FORTE[7][34][1]],
  '35,0': [FORTE[7][35][0], FORTE[7][35][2], FORTE[7][35][1]],
  '36,1': [FORTE[7][36][0], FORTE[7][36][2], FORTE[7][36][1]],
  '36,-1': [[0, 2, 3, 5, 6, 7, 8], FORTE[7][36][2], FORTE[7][36][1]],
  '37,0': [FORTE[7][37][0], FORTE[7][37][2], FORTE[7][37][1]],
  '38,1': [FORTE[7][38][0], FORTE[7][38][2], FORTE[7][38][1]],
  '38,-1': [[0, 1, 3, 4, 6, 7, 8], FORTE[7][38][2], FORTE[7][38][1]]
}; // cardinality 8

var card_8 = {
  '1,0': [FORTE[8][1][0], FORTE[8][1][2], FORTE[8][1][1]],
  '2,1': [FORTE[8][2][0], FORTE[8][2][2], FORTE[8][2][1]],
  '2,-1': [[0, 2, 3, 4, 5, 6, 7, 8], FORTE[8][2][2], FORTE[8][2][1]],
  '3,0': [FORTE[8][3][0], FORTE[8][3][2], FORTE[8][3][1]],
  '4,1': [FORTE[8][4][0], FORTE[8][4][2], FORTE[8][4][1]],
  '4,-1': [[0, 1, 3, 4, 5, 6, 7, 8], FORTE[8][4][2], FORTE[8][4][1]],
  '5,1': [FORTE[8][5][0], FORTE[8][5][2], FORTE[8][5][1]],
  '5,-1': [[0, 1, 2, 4, 5, 6, 7, 8], FORTE[8][5][2], FORTE[8][5][1]],
  '6,0': [FORTE[8][6][0], FORTE[8][6][2], FORTE[8][6][1]],
  '7,0': [FORTE[8][7][0], FORTE[8][7][2], FORTE[8][7][1]],
  '8,0': [FORTE[8][8][0], FORTE[8][8][2], FORTE[8][8][1]],
  '9,0': [FORTE[8][9][0], FORTE[8][9][2], FORTE[8][9][1]],
  '10,0': [FORTE[8][10][0], FORTE[8][10][2], FORTE[8][10][1]],
  '11,1': [FORTE[8][11][0], FORTE[8][11][2], FORTE[8][11][1]],
  '11,-1': [[0, 2, 4, 5, 6, 7, 8, 9], FORTE[8][11][2], FORTE[8][11][1]],
  '12,1': [FORTE[8][12][0], FORTE[8][12][2], FORTE[8][12][1]],
  '12,-1': [[0, 2, 3, 4, 5, 6, 8, 9], FORTE[8][12][2], FORTE[8][12][1]],
  '13,1': [FORTE[8][13][0], FORTE[8][13][2], FORTE[8][13][1]],
  '13,-1': [[0, 2, 3, 5, 6, 7, 8, 9], FORTE[8][13][2], FORTE[8][13][1]],
  '14,1': [FORTE[8][14][0], FORTE[8][14][2], FORTE[8][14][1]],
  '14,-1': [[0, 2, 3, 4, 5, 7, 8, 9], FORTE[8][14][2], FORTE[8][14][1]],
  '15,1': [FORTE[8][15][0], FORTE[8][15][2], FORTE[8][15][1]],
  '15,-1': [[0, 1, 3, 5, 6, 7, 8, 9], FORTE[8][15][2], FORTE[8][15][1]],
  '16,1': [FORTE[8][16][0], FORTE[8][16][2], FORTE[8][16][1]],
  '16,-1': [[0, 1, 2, 4, 6, 7, 8, 9], FORTE[8][16][2], FORTE[8][16][1]],
  '17,0': [FORTE[8][17][0], FORTE[8][17][2], FORTE[8][17][1]],
  '18,1': [FORTE[8][18][0], FORTE[8][18][2], FORTE[8][18][1]],
  '18,-1': [[0, 1, 3, 4, 6, 7, 8, 9], FORTE[8][18][2], FORTE[8][18][1]],
  '19,1': [FORTE[8][19][0], FORTE[8][19][2], FORTE[8][19][1]],
  '19,-1': [[0, 1, 3, 4, 5, 7, 8, 9], FORTE[8][19][2], FORTE[8][19][1]],
  '20,0': [FORTE[8][20][0], FORTE[8][20][2], FORTE[8][20][1]],
  '21,0': [FORTE[8][21][0], FORTE[8][21][2], FORTE[8][21][1]],
  '22,1': [FORTE[8][22][0], FORTE[8][22][2], FORTE[8][22][1]],
  '22,-1': [[0, 2, 4, 5, 7, 8, 9, 10], FORTE[8][22][2], FORTE[8][22][1]],
  '23,0': [FORTE[8][23][0], FORTE[8][23][2], FORTE[8][23][1]],
  '24,0': [FORTE[8][24][0], FORTE[8][24][2], FORTE[8][24][1]],
  '25,0': [FORTE[8][25][0], FORTE[8][25][2], FORTE[8][25][1]],
  '26,0': [FORTE[8][26][0], FORTE[8][26][2], FORTE[8][26][1]],
  '27,1': [FORTE[8][27][0], FORTE[8][27][2], FORTE[8][27][1]],
  '27,-1': [[0, 2, 3, 5, 6, 8, 9, 10], FORTE[8][27][2], FORTE[8][27][1]],
  '28,0': [FORTE[8][28][0], FORTE[8][28][2], FORTE[8][28][1]],
  '29,1': [FORTE[8][29][0], FORTE[8][29][2], FORTE[8][29][1]],
  '29,-1': [[0, 2, 3, 4, 6, 7, 8, 9], FORTE[8][29][2], FORTE[8][29][1]]
}; // cardinality 9

var card_9 = {
  '1,0': [FORTE[9][1][0], FORTE[9][1][2], FORTE[9][1][1]],
  '2,1': [FORTE[9][2][0], FORTE[9][2][2], FORTE[9][2][1]],
  '2,-1': [[0, 2, 3, 4, 5, 6, 7, 8, 9], FORTE[9][2][2], FORTE[9][2][1]],
  '3,1': [FORTE[9][3][0], FORTE[9][3][2], FORTE[9][3][1]],
  '3,-1': [[0, 1, 3, 4, 5, 6, 7, 8, 9], FORTE[9][3][2], FORTE[9][3][1]],
  '4,1': [FORTE[9][4][0], FORTE[9][4][2], FORTE[9][4][1]],
  '4,-1': [[0, 1, 2, 4, 5, 6, 7, 8, 9], FORTE[9][4][2], FORTE[9][4][1]],
  '5,1': [FORTE[9][5][0], FORTE[9][5][2], FORTE[9][5][1]],
  '5,-1': [[0, 1, 2, 3, 5, 6, 7, 8, 9], FORTE[9][5][2], FORTE[9][5][1]],
  '6,0': [FORTE[9][6][0], FORTE[9][6][2], FORTE[9][6][1]],
  '7,1': [FORTE[9][7][0], FORTE[9][7][2], FORTE[9][7][1]],
  '7,-1': [[0, 2, 3, 5, 6, 7, 8, 9, 10], FORTE[9][7][2], FORTE[9][7][1]],
  '8,1': [FORTE[9][8][0], FORTE[9][8][2], FORTE[9][8][1]],
  '8,-1': [[0, 2, 3, 4, 6, 7, 8, 9, 10], FORTE[9][8][2], FORTE[9][8][1]],
  '9,0': [FORTE[9][9][0], FORTE[9][9][2], FORTE[9][9][1]],
  '10,0': [FORTE[9][10][0], FORTE[9][10][2], FORTE[9][10][1]],
  '11,1': [FORTE[9][11][0], FORTE[9][11][2], FORTE[9][11][1]],
  '11,-1': [[0, 1, 3, 4, 5, 7, 8, 9, 10], FORTE[9][11][2], FORTE[9][11][1]],
  '12,0': [FORTE[9][12][0], FORTE[9][12][2], FORTE[9][12][1]]
}; // cardinality 10

var card_10 = {
  '1,0': [FORTE[10][1][0], FORTE[10][1][2], FORTE[10][1][1]],
  '2,0': [FORTE[10][2][0], FORTE[10][2][2], FORTE[10][2][1]],
  '3,0': [FORTE[10][3][0], FORTE[10][3][2], FORTE[10][3][1]],
  '4,0': [FORTE[10][4][0], FORTE[10][4][2], FORTE[10][4][1]],
  '5,0': [FORTE[10][5][0], FORTE[10][5][2], FORTE[10][5][1]],
  '6,0': [FORTE[10][6][0], FORTE[10][6][2], FORTE[10][6][1]]
}; // cardinality 11

var card_11 = {
  '1,0': [FORTE[11][1][0], FORTE[11][1][2], FORTE[11][1][1]]
}; // cardinality 12

var card_12 = {
  '1,0': [FORTE[12][1][0], FORTE[12][1][2], FORTE[12][1][1]]
}; //-------------------------------------------------------------------------------

var SCDICT = {
  1: card_1,
  2: card_2,
  3: card_3,
  4: card_4,
  5: card_5,
  6: card_6,
  7: card_7,
  8: card_8,
  9: card_9,
  10: card_10,
  11: card_11,
  12: card_12
}; //-------------------------------------------------------------------------------
// these dicts provide index max fr cardinality key

var TNMAX = {
  0: 1,
  1: 1,
  2: 6,
  3: 19,
  4: 43,
  5: 66,
  6: 80,
  7: 66,
  8: 43,
  9: 19,
  10: 6,
  11: 1,
  12: 1
};
var TNIMAX = {
  0: 1,
  1: 1,
  2: 6,
  3: 12,
  4: 29,
  5: 38,
  6: 50,
  7: 38,
  8: 29,
  9: 12,
  10: 6,
  11: 1,
  12: 1
}; // used to find TnI index numbers under Tn classification

var TNREF = {
  '1,1,0': 1,
  '2,1,0': 1,
  '2,2,0': 2,
  '2,3,0': 3,
  '2,4,0': 4,
  '2,5,0': 5,
  '2,6,0': 6,
  '3,1,0': 1,
  '3,2,1': 2,
  '3,2,-1': 3,
  '3,3,1': 4,
  '3,3,-1': 5,
  '3,4,1': 6,
  '3,4,-1': 7,
  '3,5,1': 8,
  '3,5,-1': 9,
  '3,6,0': 10,
  '3,7,1': 11,
  '3,7,-1': 12,
  '3,8,1': 13,
  '3,8,-1': 14,
  '3,9,0': 15,
  '3,10,0': 16,
  '3,11,1': 17,
  '3,11,-1': 18,
  '3,12,0': 19,
  '4,1,0': 1,
  '4,2,1': 2,
  '4,2,-1': 3,
  '4,3,0': 4,
  '4,4,1': 5,
  '4,4,-1': 6,
  '4,5,1': 7,
  '4,5,-1': 8,
  '4,6,0': 9,
  '4,7,0': 10,
  '4,8,0': 11,
  '4,9,0': 12,
  '4,10,0': 13,
  '4,11,1': 14,
  '4,11,-1': 15,
  '4,12,1': 16,
  '4,12,-1': 17,
  '4,13,1': 18,
  '4,13,-1': 19,
  '4,14,1': 20,
  '4,14,-1': 21,
  '4,15,1': 22,
  '4,15,-1': 23,
  '4,16,1': 24,
  '4,16,-1': 25,
  '4,17,0': 26,
  '4,18,1': 27,
  '4,18,-1': 28,
  '4,19,1': 29,
  '4,19,-1': 30,
  '4,20,0': 31,
  '4,21,0': 32,
  '4,22,1': 33,
  '4,22,-1': 34,
  '4,23,0': 35,
  '4,24,0': 36,
  '4,25,0': 37,
  '4,26,0': 38,
  '4,27,1': 39,
  '4,27,-1': 40,
  '4,28,0': 41,
  '4,29,1': 42,
  '4,29,-1': 43,
  '5,1,0': 1,
  '5,2,1': 2,
  '5,2,-1': 3,
  '5,3,1': 4,
  '5,3,-1': 5,
  '5,4,1': 6,
  '5,4,-1': 7,
  '5,5,1': 8,
  '5,5,-1': 9,
  '5,6,1': 10,
  '5,6,-1': 11,
  '5,7,1': 12,
  '5,7,-1': 13,
  '5,8,0': 14,
  '5,9,1': 15,
  '5,9,-1': 16,
  '5,10,1': 17,
  '5,10,-1': 18,
  '5,11,1': 19,
  '5,11,-1': 20,
  '5,12,0': 21,
  '5,13,1': 22,
  '5,13,-1': 23,
  '5,14,1': 24,
  '5,14,-1': 25,
  '5,15,0': 26,
  '5,16,1': 27,
  '5,16,-1': 28,
  '5,17,0': 29,
  '5,18,1': 30,
  '5,18,-1': 31,
  '5,19,1': 32,
  '5,19,-1': 33,
  '5,20,1': 34,
  '5,20,-1': 35,
  '5,21,1': 36,
  '5,21,-1': 37,
  '5,22,0': 38,
  '5,23,1': 39,
  '5,23,-1': 40,
  '5,24,1': 41,
  '5,24,-1': 42,
  '5,25,1': 43,
  '5,25,-1': 44,
  '5,26,1': 45,
  '5,26,-1': 46,
  '5,27,1': 47,
  '5,27,-1': 48,
  '5,28,1': 49,
  '5,28,-1': 50,
  '5,29,1': 51,
  '5,29,-1': 52,
  '5,30,1': 53,
  '5,30,-1': 54,
  '5,31,1': 55,
  '5,31,-1': 56,
  '5,32,1': 57,
  '5,32,-1': 58,
  '5,33,0': 59,
  '5,34,0': 60,
  '5,35,0': 61,
  '5,36,1': 62,
  '5,36,-1': 63,
  '5,37,0': 64,
  '5,38,1': 65,
  '5,38,-1': 66,
  '6,1,0': 1,
  '6,2,1': 2,
  '6,2,-1': 3,
  '6,3,1': 4,
  '6,3,-1': 5,
  '6,4,0': 6,
  '6,5,1': 7,
  '6,5,-1': 8,
  '6,6,0': 9,
  '6,7,0': 10,
  '6,8,0': 11,
  '6,9,1': 12,
  '6,9,-1': 13,
  '6,10,1': 14,
  '6,10,-1': 15,
  '6,11,1': 16,
  '6,11,-1': 17,
  '6,12,1': 18,
  '6,12,-1': 19,
  '6,13,0': 20,
  '6,14,1': 21,
  '6,14,-1': 22,
  '6,15,1': 23,
  '6,15,-1': 24,
  '6,16,1': 25,
  '6,16,-1': 26,
  '6,17,1': 27,
  '6,17,-1': 28,
  '6,18,1': 29,
  '6,18,-1': 30,
  '6,19,1': 31,
  '6,19,-1': 32,
  '6,20,0': 33,
  '6,21,1': 34,
  '6,21,-1': 35,
  '6,22,1': 36,
  '6,22,-1': 37,
  '6,23,0': 38,
  '6,24,1': 39,
  '6,24,-1': 40,
  '6,25,1': 41,
  '6,25,-1': 42,
  '6,26,0': 43,
  '6,27,1': 44,
  '6,27,-1': 45,
  '6,28,0': 46,
  '6,29,0': 47,
  '6,30,1': 48,
  '6,30,-1': 49,
  '6,31,1': 50,
  '6,31,-1': 51,
  '6,32,0': 52,
  '6,33,1': 53,
  '6,33,-1': 54,
  '6,34,1': 55,
  '6,34,-1': 56,
  '6,35,0': 57,
  '6,36,1': 58,
  '6,36,-1': 59,
  '6,37,0': 60,
  '6,38,0': 61,
  '6,39,1': 62,
  '6,39,-1': 63,
  '6,40,1': 64,
  '6,40,-1': 65,
  '6,41,1': 66,
  '6,41,-1': 67,
  '6,42,0': 68,
  '6,43,1': 69,
  '6,43,-1': 70,
  '6,44,1': 71,
  '6,44,-1': 72,
  '6,45,0': 73,
  '6,46,1': 74,
  '6,46,-1': 75,
  '6,47,1': 76,
  '6,47,-1': 77,
  '6,48,0': 78,
  '6,49,0': 79,
  '6,50,0': 80,
  '7,1,0': 1,
  '7,2,1': 2,
  '7,2,-1': 3,
  '7,3,1': 4,
  '7,3,-1': 5,
  '7,4,1': 6,
  '7,4,-1': 7,
  '7,5,1': 8,
  '7,5,-1': 9,
  '7,6,1': 10,
  '7,6,-1': 11,
  '7,7,1': 12,
  '7,7,-1': 13,
  '7,8,0': 14,
  '7,9,1': 15,
  '7,9,-1': 16,
  '7,10,1': 17,
  '7,10,-1': 18,
  '7,11,1': 19,
  '7,11,-1': 20,
  '7,12,0': 21,
  '7,13,1': 22,
  '7,13,-1': 23,
  '7,14,1': 24,
  '7,14,-1': 25,
  '7,15,0': 26,
  '7,16,1': 27,
  '7,16,-1': 28,
  '7,17,0': 29,
  '7,18,1': 30,
  '7,18,-1': 31,
  '7,19,1': 32,
  '7,19,-1': 33,
  '7,20,1': 34,
  '7,20,-1': 35,
  '7,21,1': 36,
  '7,21,-1': 37,
  '7,22,0': 38,
  '7,23,1': 39,
  '7,23,-1': 40,
  '7,24,1': 41,
  '7,24,-1': 42,
  '7,25,1': 43,
  '7,25,-1': 44,
  '7,26,1': 45,
  '7,26,-1': 46,
  '7,27,1': 47,
  '7,27,-1': 48,
  '7,28,1': 49,
  '7,28,-1': 50,
  '7,29,1': 51,
  '7,29,-1': 52,
  '7,30,1': 53,
  '7,30,-1': 54,
  '7,31,1': 55,
  '7,31,-1': 56,
  '7,32,1': 57,
  '7,32,-1': 58,
  '7,33,0': 59,
  '7,34,0': 60,
  '7,35,0': 61,
  '7,36,1': 62,
  '7,36,-1': 63,
  '7,37,0': 64,
  '7,38,1': 65,
  '7,38,-1': 66,
  '8,1,0': 1,
  '8,2,1': 2,
  '8,2,-1': 3,
  '8,3,0': 4,
  '8,4,1': 5,
  '8,4,-1': 6,
  '8,5,1': 7,
  '8,5,-1': 8,
  '8,6,0': 9,
  '8,7,0': 10,
  '8,8,0': 11,
  '8,9,0': 12,
  '8,10,0': 13,
  '8,11,1': 14,
  '8,11,-1': 15,
  '8,12,1': 16,
  '8,12,-1': 17,
  '8,13,1': 18,
  '8,13,-1': 19,
  '8,14,1': 20,
  '8,14,-1': 21,
  '8,15,1': 22,
  '8,15,-1': 23,
  '8,16,1': 24,
  '8,16,-1': 25,
  '8,17,0': 26,
  '8,18,1': 27,
  '8,18,-1': 28,
  '8,19,1': 29,
  '8,19,-1': 30,
  '8,20,0': 31,
  '8,21,0': 32,
  '8,22,1': 33,
  '8,22,-1': 34,
  '8,23,0': 35,
  '8,24,0': 36,
  '8,25,0': 37,
  '8,26,0': 38,
  '8,27,1': 39,
  '8,27,-1': 40,
  '8,28,0': 41,
  '8,29,1': 42,
  '8,29,-1': 43,
  '9,1,0': 1,
  '9,2,1': 2,
  '9,2,-1': 3,
  '9,3,1': 4,
  '9,3,-1': 5,
  '9,4,1': 6,
  '9,4,-1': 7,
  '9,5,1': 8,
  '9,5,-1': 9,
  '9,6,0': 10,
  '9,7,1': 11,
  '9,7,-1': 12,
  '9,8,1': 13,
  '9,8,-1': 14,
  '9,9,0': 15,
  '9,10,0': 16,
  '9,11,1': 17,
  '9,11,-1': 18,
  '9,12,0': 19,
  '10,1,0': 1,
  '10,2,0': 2,
  '10,3,0': 3,
  '10,4,0': 4,
  '10,5,0': 5,
  '10,6,0': 6,
  '11,1,0': 1,
  '12,1,0': 1
}; // -----------------------------------------------------------------||||||||||||--
// reference dict stores name and citation references
// names found from many sources, including:
// http://solo1.home.mindspring.com/pcsets.htm
// Larry Solomon, 1997, 2000
// Larry Solomon's 'The List of Chords, Their Properties and Use in Analysis,'
// in Interface, Journal of New Music Research , 1982, v11/2.
// http://www.sweb.cz/vladimir_ladma/english/music/structs/mus_rot.htm
// Vladimir Ladma, Czech Republic
// some changes: unison preferred to monad

var SCREF = {
  '1,1,0': {
    'name': ['unison', 'monad', 'singleton']
  },
  '2,1,0': {
    'name': ['interval class 1', 'minor second', 'm2', 'half step', 'semitone']
  },
  '2,2,0': {
    'name': ['interval class 2', 'major second', 'M2', 'whole step', 'whole tone']
  },
  '2,3,0': {
    'name': ['interval class 3', 'minor third', 'm3']
  },
  '2,4,0': {
    'name': ['interval class 4', 'major third', 'M3']
  },
  '2,5,0': {
    'name': ['interval class 5', 'perfect fourth', 'P4']
  },
  '2,6,0': {
    'name': ['tritone', 'diminished fifth', 'augmented fourth']
  },
  '3,1,0': {
    'name': ['chromatic trimirror']
  },
  '3,2,1': {
    'name': ['phrygian trichord']
  },
  '3,2,-1': {
    'name': ['minor trichord']
  },
  '3,3,1': {
    'name': ['major-minor trichord']
  },
  '3,3,-1': {
    'name': ['major-minor trichord']
  },
  '3,4,1': {
    'name': ['incomplete major-seventh chord']
  },
  '3,4,-1': {
    'name': ['incomplete major-seventh chord']
  },
  '3,5,1': {
    'name': ['tritone-fourth']
  },
  '3,5,-1': {
    'name': ['tritone-fourth']
  },
  '3,6,0': {
    'name': ['whole-tone trichord']
  },
  '3,7,1': {
    'name': ['incomplete minor-seventh chord']
  },
  '3,7,-1': {
    'name': ['incomplete dominant-seventh chord']
  },
  '3,8,1': {
    'name': ['incomplete dominant-seventh chord', 'Italian augmented sixth chord']
  },
  '3,8,-1': {
    'name': ['incomplete half-diminished seventh chord']
  },
  '3,9,0': {
    'name': ['quartal trichord']
  },
  '3,10,0': {
    'name': ['diminished triad']
  },
  '3,11,1': {
    'name': ['minor triad']
  },
  '3,11,-1': {
    'name': ['major triad']
  },
  '3,12,0': {
    'name': ['augmented triad', 'equal 3-part octave division']
  },
  '4,1,0': {
    'name': ['chromatic tetramirror', 'BACH']
  },
  '4,2,1': {
    'name': ['major-second tetracluster']
  },
  '4,2,-1': {
    'name': ['major-second tetracluster']
  },
  '4,3,0': {
    'name': ['alternating tetramirror']
  },
  '4,4,1': {
    'name': ['minor third tetracluster']
  },
  '4,4,-1': {
    'name': ['minor third tetracluster']
  },
  '4,5,1': {
    'name': ['major third tetracluster']
  },
  '4,5,-1': {
    'name': ['major third tetracluster']
  },
  '4,6,0': {
    'name': ['perfect fourth tetramirror']
  },
  '4,7,0': {
    'name': ['Arabian tetramirror']
  },
  '4,8,0': {
    'name': ['double-fourth tetramirror']
  },
  '4,9,0': {
    'name': ['double tritone tetramirror']
  },
  '4,10,0': {
    'name': ['minor tetramirror']
  },
  '4,11,1': {
    'name': ['phrygian tetrachord']
  },
  '4,11,-1': {
    'name': ['lydian tetrachord', 'major tetrachord']
  },
  '4,12,1': {
    'name': ['harmonic minor tetrachord']
  },
  '4,12,-1': {
    'name': ['major-third diminished tetrachord']
  },
  '4,13,1': {
    'name': ['minor-second diminished tetrachord']
  },
  '4,13,-1': {
    'name': ['perfect-fourth diminished tetrachord']
  },
  '4,14,1': {
    'name': ['major-second minor tetrachord']
  },
  '4,14,-1': {
    'name': ['perfect-fourth major tetrachord']
  },
  '4,15,1': {
    'name': ['all-interval tetrachord']
  },
  '4,15,-1': {
    'name': ['all-interval tetrachord']
  },
  '4,16,1': {
    'name': ['minor-second quartal tetrachord']
  },
  '4,16,-1': {
    'name': ['tritone quartal tetrachord']
  },
  '4,17,0': {
    'name': ['major-minor tetramirror']
  },
  '4,18,1': {
    'name': ['major-diminished tetrachord']
  },
  '4,18,-1': {
    'name': ['minor-diminished tetrachord']
  },
  '4,19,1': {
    'name': ['minor-augmented tetrachord']
  },
  '4,19,-1': {
    'name': ['augmented major tetrachord']
  },
  '4,20,0': {
    'name': ['major seventh chord']
  },
  '4,21,0': {
    'name': ['whole-tone tetramirror']
  },
  '4,22,1': {
    'name': ['major-second major tetrachord']
  },
  '4,22,-1': {
    'name': ['perfect-fourth minor tetrachord']
  },
  '4,23,0': {
    'name': ['quartal tetramirror']
  },
  '4,24,0': {
    'name': ['augmented seventh chord']
  },
  '4,25,0': {
    'name': ["Messiaen's truncated mode 6", 'French augmented sixth chord']
  },
  '4,26,0': {
    'name': ['minor seventh chord']
  },
  '4,27,1': {
    'name': ['half-diminished seventh chord']
  },
  '4,27,-1': {
    'name': ['dominant seventh chord', 'major minor seventh chord', 'German augmented sixth chord', 'Swiss augmented sixth chord']
  },
  '4,28,0': {
    'name': ['diminished seventh chord', 'equal 4-part octave division']
  },
  '4,29,1': {
    'name': ['all-interval tetrachord']
  },
  '4,29,-1': {
    'name': ['all-interval tetrachord']
  },
  '5,1,0': {
    'name': ['chromatic pentamirror']
  },
  '5,2,1': {
    'name': ['major-second pentacluster']
  },
  '5,2,-1': {
    'name': ['major-second pentacluster']
  },
  '5,3,1': {
    'name': ['minor-second major pentachord']
  },
  '5,3,-1': {
    'name': ['Spanish pentacluster']
  },
  '5,4,1': {
    'name': ['blues pentacluster']
  },
  '5,4,-1': {
    'name': ['minor-third pentacluster']
  },
  '5,5,1': {
    'name': ['major-third pentacluster']
  },
  '5,5,-1': {
    'name': ['major-third pentacluster']
  },
  '5,6,1': {
    'name': ['Asian pentacluster', 'quasi raga Megharanji']
  },
  '5,6,-1': {
    'name': ['Asian pentacluster']
  },
  '5,7,1': {
    'name': ['double pentacluster', 'quasi raga Nabhomani ']
  },
  '5,7,-1': {
    'name': ['double pentacluster']
  },
  '5,8,0': {
    'name': ['tritone-symmetric pentamirror']
  },
  '5,9,1': {
    'name': ['tritone-expanding pentachord']
  },
  '5,9,-1': {
    'name': ['tritone-contracting pentachord']
  },
  '5,10,1': {
    'name': ['alternating pentachord']
  },
  '5,10,-1': {
    'name': ['alternating pentachord']
  },
  '5,11,1': {
    'name': ['center-cluster pentachord']
  },
  '5,11,-1': {
    'name': ['center-cluster pentachord']
  },
  '5,12,0': {
    'name': ['locrian pentachord']
  },
  '5,13,1': {
    'name': ['augmented pentacluster']
  },
  '5,13,-1': {
    'name': ['augmented pentacluster']
  },
  '5,14,1': {
    'name': ['double-seconds triple-fourth pentachord']
  },
  '5,14,-1': {
    'name': ['double-seconds triple-fourth pentachord']
  },
  '5,15,0': {
    'name': ['asymmetric pentamirror']
  },
  '5,16,1': {
    'name': ['major-minor-diminished pentachord']
  },
  '5,16,-1': {
    'name': ['major-minor diminished pentachord']
  },
  '5,17,0': {
    'name': ['minor-major ninth chord']
  },
  '5,18,1': {
    'name': ['Roma [Gypsy] pentachord']
  },
  '5,18,-1': {
    'name': ['Roma [Gypsy] pentachord']
  },
  '5,19,1': {
    'name': ['Javanese pentachord']
  },
  '5,19,-1': {
    'name': ['Balinese pentachord']
  },
  '5,20,1': {
    'name': ['Balinese Pelog pentatonic', 'quasi raga Bhupala', 'quasi raga Bibhas']
  },
  '5,20,-1': {
    'name': ['Hirajoshi pentatonic', 'Iwato', 'Sakura', 'quasi raga Saveri']
  },
  '5,21,1': {
    'name': ['major-augmented ninth chord', 'Syrian pentatonic', 'quasi raga Megharanji']
  },
  '5,21,-1': {
    'name': ['Lebanese pentachord', 'augmented-minor chord']
  },
  '5,22,0': {
    'name': ['Persian pentamirror', 'quasi raga Ramkali']
  },
  '5,23,1': {
    'name': ['dorian pentachord', 'minor pentachord']
  },
  '5,23,-1': {
    'name': ['major pentachord']
  },
  '5,24,1': {
    'name': ['phrygian pentachord']
  },
  '5,24,-1': {
    'name': ['lydian pentachord']
  },
  '5,25,1': {
    'name': ['diminished-major ninth chord']
  },
  '5,25,-1': {
    'name': ['minor-diminished ninth chord']
  },
  '5,26,1': {
    'name': ['diminished-augmented ninth chord']
  },
  '5,26,-1': {
    'name': ['augmented-diminished ninth chord']
  },
  '5,27,1': {
    'name': ['major-ninth chord']
  },
  '5,27,-1': {
    'name': ['minor-ninth chord']
  },
  '5,28,1': {
    'name': ['augmented-sixth pentachord']
  },
  '5,28,-1': {
    'name': ['Javanese pentatonic', 'augmented-sixth pentachord']
  },
  '5,29,1': {
    'name': ['Kumoi pentachord']
  },
  '5,29,-1': {
    'name': ['Kumoi pentachord']
  },
  '5,30,1': {
    'name': ['enigmatic pentachord']
  },
  '5,30,-1': {
    'name': ['enigmatic pentachord', 'altered pentatonic']
  },
  '5,31,1': {
    'name': ['diminished minor-ninth chord']
  },
  '5,31,-1': {
    'name': ['flat-ninth pentachord', 'quasi raga Ranjaniraga']
  },
  '5,32,1': {
    'name': ['Neapolitan pentachord']
  },
  '5,32,-1': {
    'name': ['Neapolitan pentachord']
  },
  '5,33,0': {
    'name': ['whole-tone pentachord']
  },
  '5,34,0': {
    'name': ['dominant-ninth', 'major-minor', 'Prometheus pentamirror', 'dominant pentatonic']
  },
  '5,35,0': {
    'name': ['major pentatonic', 'black-key scale', 'blues pentatonic', 'slendro', 'quartal pentamirror']
  },
  '5,36,1': {
    'name': ['major-seventh pentacluster']
  },
  '5,36,-1': {
    'name': ['minor-seventh pentacluster']
  },
  '5,37,0': {
    'name': ['center-cluster pentamirror']
  },
  '5,38,1': {
    'name': ['diminished pentacluster']
  },
  '5,38,-1': {
    'name': ['diminished pentacluster']
  },
  '6,1,0': {
    'name': ['A all combinatorial [P6, I11, RI5, RI11]', 'chromatic hexamirror', 'first-order all-combinatorial']
  },
  '6,2,1': {
    'name': ['combinatorial I [I11]']
  },
  '6,2,-1': {
    'name': ['combinatorial I [I1]']
  },
  '6,3,1': {},
  '6,3,-1': {},
  '6,4,0': {
    'name': ['combinatorial RI [RI6]']
  },
  '6,5,1': {
    'name': ['combinatorial I [I11]']
  },
  '6,5,-1': {
    'name': ['combinatorial I [I3]']
  },
  '6,6,0': {
    'name': ['double cluster hexamirror']
  },
  '6,7,0': {
    'name': ['B all combinatorial [P3, P9, I5, R6, R12, R8]', "Messiaen's mode 5", 'second-order all combinatorial']
  },
  '6,8,0': {
    'name': ['D all combinatorial [P6, I1, RI7]']
  },
  '6,9,1': {
    'name': ['combinatorial I [I11]']
  },
  '6,9,-1': {
    'name': ['combinatorial I [I3]']
  },
  '6,10,1': {},
  '6,10,-1': {},
  '6,11,1': {},
  '6,11,-1': {},
  '6,12,1': {},
  '6,12,-1': {},
  '6,13,0': {
    'name': ['alternating hexamirror', 'combinatorial I [I7]']
  },
  '6,14,1': {
    'name': ['combinatorial P [P6]']
  },
  '6,14,-1': {
    'name': ['combinatorial P [P6]']
  },
  '6,15,1': {
    'name': ['combinatorial I [I11]']
  },
  '6,15,-1': {
    'name': ['combinatorial I [I5]']
  },
  '6,16,1': {
    'name': ['combinatorial I [I3]']
  },
  '6,16,-1': {
    'name': ['combinatorial I [I1]', 'quasi raga Megha']
  },
  '6,17,1': {
    'name': ['all tri-chord hexachord']
  },
  '6,17,-1': {
    'name': ['all tri-chord hexachord [inverted form]']
  },
  '6,18,1': {
    'name': ['combinatorial I [I11]']
  },
  '6,18,-1': {
    'name': ['combinatorial I [I5]']
  },
  '6,19,1': {},
  '6,19,-1': {},
  '6,20,0': {
    'name': ['E all combinatorial [P2, P6, P10, I3, I7, R4, R8, RI1, RI5, RI9]', "Messiaen's truncated mode 3", 'Genus tertium', 'third-order all combinatorial']
  },
  '6,21,1': {
    'name': ['combinatorial I [I1]']
  },
  '6,21,-1': {
    'name': ['combinatorial I [I3]']
  },
  '6,22,1': {
    'name': ['combinatorial I [I11]']
  },
  '6,22,-1': {
    'name': ['combinatorial I [I5]']
  },
  '6,23,0': {
    'name': ['combinatorial RI [RI8]', 'super-locrian hexamirror']
  },
  '6,24,1': {},
  '6,24,-1': {
    'name': ['melodic-minor hexachord']
  },
  '6,25,1': {
    'name': ['locrian hexachord']
  },
  '6,25,-1': {
    'name': ['minor hexachord']
  },
  '6,26,0': {
    'name': ['phrygian hexamirror', 'combinatorial RI [RI8]']
  },
  '6,27,1': {
    'name': ['combinatorial I [I11]']
  },
  '6,27,-1': {
    'name': ['combinatorial I [I1]', 'pyramid hexachord']
  },
  '6,28,0': {
    'name': ['double-phrygian hexachord', 'combinatorial RI [RI6]']
  },
  '6,29,0': {
    'name': ['combinatorial RI [RI9]']
  },
  '6,30,1': {
    'name': ["Messiaen's truncated mode 2", 'minor-bitonal hexachord', 'combinatorial R [R6]', 'combinatorial I [I1, I7]']
  },
  '6,30,-1': {
    'name': ["Stravinsky's Petrushka-chord", "Messiaen's truncated mode 2", 'major-bitonal hexachord', 'combinatorial R [R6]', 'combinatorial I [I1, I7]']
  },
  '6,31,1': {
    'name': ['combinatorial I [I7]']
  },
  '6,31,-1': {
    'name': ['combinatorial I [I11]']
  },
  '6,32,0': {
    'name': ['C all combinatorial [P6, I3, RI9]', 'Guidon/Arezzo', 'Arezzo major diatonic', 'major hexamirror', 'quartal hexamirror', 'first-order all combinatorial']
  },
  '6,33,1': {
    'name': ['dorian hexachord', 'combinatorial I [I6]']
  },
  '6,33,-1': {
    'name': ['dominant-eleventh', 'lydian hexachord', 'combinatorial I [I1]']
  },
  '6,34,1': {
    'name': ["Scriabin's Mystic-chord", 'Prometheus hexachord', 'combinatorial I [I11]']
  },
  '6,34,-1': {
    'name': ['augmented-eleventh', 'harmonic hexachord', 'combinatorial I [I7]']
  },
  '6,35,0': {
    'name': ['whole tone scale', '6 equal part division', 'F all-combinatorial [P1, P3, P5, P7, P9, P11, I1, I3, I5, I7, ' + 'I9, I11, R2, R4, R6, R8, R10, RI2, RI4, RI6, RI8, RI10]', "Messiaen's mode 1", 'sixth-order all combinatorial']
  },
  '6,36,1': {},
  '6,36,-1': {},
  '6,37,0': {
    'name': ['combinatorial RI [RI4]']
  },
  '6,38,0': {
    'name': ['combinatorial RI [RI3]']
  },
  '6,39,1': {},
  '6,39,-1': {},
  '6,40,1': {},
  '6,40,-1': {},
  '6,41,1': {},
  '6,41,-1': {},
  '6,42,0': {
    'name': ['combinatorial RI [RI3]']
  },
  '6,43,1': {
    'name': ['complement of all tri-chord hexachord']
  },
  '6,43,-1': {
    'name': ['complement of all-tri-chord hexachord [inverted form]']
  },
  '6,44,1': {
    'name': ['Schoenberg Anagram hexachord']
  },
  '6,44,-1': {
    'name': ['quasi raga Bauli']
  },
  '6,45,0': {
    'name': ['combinatorial RI [RI6]']
  },
  '6,46,1': {},
  '6,46,-1': {},
  '6,47,1': {},
  '6,47,-1': {
    'name': ['blues scale']
  },
  '6,48,0': {
    'name': ['combinatorial RI [RI2]']
  },
  '6,49,0': {
    'name': ['combinatorial RI [RI4]', 'Prometheus Neapolitan mode']
  },
  '6,50,0': {
    'name': ['combinatorial RI [RI1]']
  },
  '7,1,0': {
    'name': ['chromatic heptamirror']
  },
  '7,2,1': {},
  '7,2,-1': {},
  '7,3,1': {},
  '7,3,-1': {},
  '7,4,1': {},
  '7,4,-1': {},
  '7,5,1': {},
  '7,5,-1': {},
  '7,6,1': {},
  '7,6,-1': {},
  '7,7,1': {},
  '7,7,-1': {},
  '7,8,0': {},
  '7,9,1': {},
  '7,9,-1': {},
  '7,10,1': {},
  '7,10,-1': {},
  '7,11,1': {},
  '7,11,-1': {},
  '7,12,0': {},
  '7,13,1': {},
  '7,13,-1': {},
  '7,14,1': {},
  '7,14,-1': {},
  '7,15,0': {},
  '7,16,1': {
    'name': ["Debussy's heptatonic"]
  },
  '7,16,-1': {},
  '7,17,0': {},
  '7,18,1': {},
  '7,18,-1': {},
  '7,19,1': {},
  '7,19,-1': {},
  '7,20,1': {
    'name': ['chromatic phrygian inverse']
  },
  '7,20,-1': {
    'name': ['Greek chromatic', 'chromatic mixolydian', 'chromatic dorian', 'quasi raga Pantuvarali', 'mela Kanakangi']
  },
  '7,21,1': {},
  '7,21,-1': {
    'name': ['Gypsy [Roma] hepatonic']
  },
  '7,22,0': {
    'name': ['double harmonic scale', 'Persian', 'major Gypsy [Roma]', 'Hungarian minor', 'double harmonic scale', 'Asian', 'quasi raga Mayamdavagaula']
  },
  '7,23,1': {},
  '7,23,-1': {
    'name': ['tritone major heptachord']
  },
  '7,24,1': {},
  '7,24,-1': {
    'name': ['mystic heptachord', 'Enigmatic heptatonic']
  },
  '7,25,1': {},
  '7,25,-1': {},
  '7,26,1': {},
  '7,26,-1': {},
  '7,27,1': {},
  '7,27,-1': {
    'name': ['modified blues']
  },
  '7,28,1': {},
  '7,28,-1': {},
  '7,29,1': {},
  '7,29,-1': {},
  '7,30,1': {
    'name': ['Neapolitan-minor mode']
  },
  '7,30,-1': {},
  '7,31,1': {
    'name': ['alternating heptachord', 'Hungarian major mode']
  },
  '7,31,-1': {
    'name': ['diminished scale', 'alternating heptachord']
  },
  '7,32,1': {
    'name': ['harmonic minor scale', 'Spanish Gypsy', 'mela Kiravani']
  },
  '7,32,-1': {
    'name': ['harmonic major scale', 'harmonic minor inverse', 'mela Cakravana', 'quasi raga Ahir Bhairav']
  },
  '7,33,0': {
    'name': ['Neapolitan-major mode', 'leading-whole-tone mode']
  },
  '7,34,0': {
    'name': ['melodic minor ascending scale', 'jazz minor', 'augmented thirteenth heptamirror', 'harmonic/super-locrian']
  },
  '7,35,0': {
    'name': ['major scale', 'major diatonic heptachord', 'natural minor scale', 'dominant thirteenth', 'locrian', 'phrygian', 'major inverse']
  },
  '7,36,1': {},
  '7,36,-1': {},
  '7,37,0': {},
  '7,38,1': {},
  '7,38,-1': {},
  '8,1,0': {
    'name': ['chromatic octamirror']
  },
  '8,2,1': {},
  '8,2,-1': {},
  '8,3,0': {},
  '8,4,1': {},
  '8,4,-1': {},
  '8,5,1': {},
  '8,5,-1': {},
  '8,6,0': {},
  '8,7,0': {},
  '8,8,0': {},
  '8,9,0': {
    'name': ["Messiaen's mode 4"]
  },
  '8,10,0': {},
  '8,11,1': {},
  '8,11,-1': {
    'name': ['blues octatonic']
  },
  '8,12,1': {},
  '8,12,-1': {},
  '8,13,1': {
    'name': ['blues octatonic']
  },
  '8,13,-1': {},
  '8,14,1': {},
  '8,14,-1': {},
  '8,15,1': {},
  '8,15,-1': {},
  '8,16,1': {},
  '8,16,-1': {
    'name': ['enigmatic octachord']
  },
  '8,17,0': {},
  '8,18,1': {},
  '8,18,-1': {},
  '8,19,1': {},
  '8,19,-1': {},
  '8,20,0': {},
  '8,21,0': {},
  '8,22,1': {},
  '8,22,-1': {
    'name': ['Spanish octatonic scale']
  },
  '8,23,0': {
    'name': ['Greek', 'blues', 'quartal octachord', 'diatonic octad']
  },
  '8,24,0': {},
  '8,25,0': {
    'name': ["Messiaen's mode 6"]
  },
  '8,26,0': {
    'name': ['blues', 'Spanish phrygian']
  },
  '8,27,1': {},
  '8,27,-1': {},
  '8,28,0': {
    'name': ['octatonic scale', "Messiaen's mode 2", 'alternating octatonic scale', 'diminished scale']
  },
  '8,29,1': {},
  '8,29,-1': {},
  '9,1,0': {
    'name': ['chromatic nonamirror']
  },
  '9,2,1': {},
  '9,2,-1': {},
  '9,3,1': {},
  '9,3,-1': {},
  '9,4,1': {},
  '9,4,-1': {},
  '9,5,1': {},
  '9,5,-1': {},
  '9,6,0': {},
  '9,7,1': {
    'name': ['nonatonic blues']
  },
  '9,7,-1': {},
  '9,8,1': {},
  '9,8,-1': {},
  '9,9,0': {},
  '9,10,0': {},
  '9,11,1': {},
  '9,11,-1': {
    'name': ['diminishing nonachord']
  },
  '9,12,0': {
    'name': ["Messiaen's mode 3", 'Tsjerepnin']
  },
  '10,1,0': {
    'name': ['chromatic decamirror']
  },
  '10,2,0': {},
  '10,3,0': {},
  '10,4,0': {},
  '10,5,0': {
    'name': ['major-minor mixed']
  },
  '10,6,0': {
    'name': ["Messiaen's mode 7"]
  },
  '11,1,0': {
    'name': ['chromatic undecamirror']
  },
  '12,1,0': {
    'name': ['aggregate', 'dodecachord', 'twelve-tone chromatic', 'chromatic scale', 'dodecamirror']
  }
};
function forteIndexToInversionsAvailable(card, index) {
  if (card < 1 || card > 12) {
    throw new Error("cardinality ".concat(card, " is not valid"));
  }

  if (index < 1 || index > TNMAX[card]) {
    throw new Error("index ".concat(index, " is invalid"));
  } // get morris invariance vector


  var morris = FORTE[card][index][2];

  if (morris[1] > 0) {
    // second value stored inversion status
    return [0];
  } else {
    return [-1, 1];
  }
}

function _chordTableAddress(cardinality, forteClass) {
  var inversion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var pcOriginal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  return {
    cardinality,
    forteClass,
    inversion,
    pcOriginal
  };
}

function _validateAddress(address) {
  if (address !== undefined && address.cardinality !== undefined) {
    // got an object...
    address = [address.cardinality, address.forteClass, address.inversion, address.pcOriginal];
  }

  var _address$slice = address.slice(0, 2),
      _address$slice2 = _slicedToArray(_address$slice, 2),
      card = _address$slice2[0],
      index = _address$slice2[1];

  var inversion;

  if (address.length >= 3 && address[2] !== undefined) {
    inversion = address[2];
  }

  if (card < 1 || card > 13) {
    throw new Error("cardinality ".concat(card, " not valid"));
  } // using TN mode for all comparisons


  if (index < 1 || index > TNMAX[card]) {
    throw new Error("index ".concat(index, " not valid"));
  }

  var inversionsAvailable = forteIndexToInversionsAvailable(card, index);

  if (inversion !== undefined) {
    if (!inversionsAvailable.includes(inversion)) {
      throw new Error("inversion ".concat(inversion, " not valid"));
    }
  }

  if (inversion === undefined) {
    // get a default inversion
    if (inversionsAvailable.includes(0)) {
      inversion = 0;
    } else {
      inversion = 1;
    }
  }

  return [card, index, inversion];
}

function addressToTransposedNormalForm(address) {
  var _validateAddress2 = _validateAddress(address),
      _validateAddress3 = _slicedToArray(_validateAddress2, 3),
      card = _validateAddress3[0],
      index = _validateAddress3[1],
      inversion = _validateAddress3[2];

  var i2 = String([index, inversion]);
  return SCDICT[card][i2][0];
}
function addressToPrimeForm(address) {
  var _validateAddress4 = _validateAddress(address.slice(0, 2)),
      _validateAddress5 = _slicedToArray(_validateAddress4, 3),
      card = _validateAddress5[0],
      index = _validateAddress5[1],
      inversion = _validateAddress5[2];

  var i2 = String([index, inversion]);
  return SCDICT[card][i2][0];
}
function addressToIntervalVector(address) {
  var _validateAddress6 = _validateAddress(address),
      _validateAddress7 = _slicedToArray(_validateAddress6, 3),
      card = _validateAddress7[0],
      index = _validateAddress7[1],
      inversion = _validateAddress7[2];

  var i2 = String([index, inversion]);
  return SCDICT[card][i2][2];
}
function intervalVectorToAddress(vector) {
  var post = [];

  for (var card = 1; card < 13; card++) {
    var num = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = FORTE[card][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var sc = _step.value;

        if (sc === undefined) {
          num += 1;
          continue; // first, used for spacing
        } // index 1 is vector


        if (Object(_common__WEBPACK_IMPORTED_MODULE_6__["arrayEquals"])(sc[1], vector)) {
          post.push(_chordTableAddress(card, num));
        }

        num += 1;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return post;
}
function addressToZAddress(address) {
  // noinspection JSUnusedLocalSymbols
  var _validateAddress8 = _validateAddress(address),
      _validateAddress9 = _slicedToArray(_validateAddress8, 3),
      card = _validateAddress9[0],
      index = _validateAddress9[1],
      unused_inversion = _validateAddress9[2];

  var z = FORTE[card][index][3];

  if (z === 0) {
    return undefined;
  } else {
    var zReal = z;

    if (Array.isArray(z)) {
      zReal = z[0];
    }

    var zAddress = _validateAddress([card, zReal, undefined]);

    return _chordTableAddress(zAddress[0], zAddress[1], zAddress[2]);
  }
}
function addressToCommonNames(address) {
  var addressNew = _validateAddress(address);

  var refDict = SCREF[String(addressNew)];
  return refDict.name;
}
function addressToForteName(address) {
  var classification = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tn';

  var _validateAddress10 = _validateAddress(address),
      _validateAddress11 = _slicedToArray(_validateAddress10, 3),
      card = _validateAddress11[0],
      index = _validateAddress11[1],
      inversion = _validateAddress11[2];

  var iStr;

  if (classification.toLowerCase() === 'tn') {
    if (inversion === -1) {
      iStr = 'B';
    } else if (inversion === 1) {
      iStr = 'A';
    } else if (inversion === 0) {
      iStr = '';
    }
  } else {
    // tni, ignore inversion
    iStr = '';
  }

  return "".concat(card, "-").concat(index).concat(iStr);
}
function seekChordTablesAddress(c) {
  var pcSet = c.orderedPitchClasses;

  if (!pcSet.length) {
    throw new Error('cannot access chord tables address for Chord with no pitches');
  }

  var card = pcSet.length;

  if (card === 1) {
    // its a singleton: return
    return _chordTableAddress(1, 1, 0, pcSet[0]);
  } else if (card === 12) {
    // its the aggregate
    return _chordTableAddress(12, 1, 0, 0);
  } // go through each rotation of pcSet


  var candidates = [];

  for (var rot = 0; rot < card; rot++) {
    var testSetOrig = pcSet.slice(rot);

    for (var rotRemainder = 0; rotRemainder < rot; rotRemainder++) {
      testSetOrig.push(pcSet[rotRemainder]);
    } // transpose to lead with zero


    var testSetOriginalPC = testSetOrig[0];
    var testSet = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = testSetOrig[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var x = _step2.value;
        var zeroTransposed = Object(_common__WEBPACK_IMPORTED_MODULE_6__["posMod"])(x - testSetOriginalPC, 12);
        testSet.push(zeroTransposed);
      } // create inversion; first take difference from 12 mod 12

    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    var testSetInvert = [];

    for (var _i2 = 0, _testSet = testSet; _i2 < _testSet.length; _i2++) {
      var _x = _testSet[_i2];
      testSetInvert.push(Object(_common__WEBPACK_IMPORTED_MODULE_6__["posMod"])(12 - _x, 12));
    }

    testSetInvert.reverse(); // reverse order (first steps now last)
    // transpose all steps (were last) to zero, mod 12

    var testSetInvertOriginalPC = testSetInvert[0];

    for (var i = 0; i < testSetInvert.length; i++) {
      testSetInvert[i] = Object(_common__WEBPACK_IMPORTED_MODULE_6__["posMod"])(testSetInvert[i] + (12 - testSetInvertOriginalPC), 12);
    }

    var candidateTuple = [testSet, testSetInvert, testSetOriginalPC];
    candidates.push(candidateTuple);
  } // compare sets to those in table


  var match = false;
  var matchedPCOriginal;
  var index;
  var inversion;

  for (var indexCandidate = 0; indexCandidate < FORTE[card].length; indexCandidate++) {
    var dataLine = FORTE[card][indexCandidate];

    if (dataLine === undefined) {
      continue; // spacer lines
    }

    var dataLinePcs = dataLine[0];
    var inversionsAvailable = forteIndexToInversionsAvailable(card, indexCandidate);
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = candidates[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var _step3$value = _slicedToArray(_step3.value, 3),
            candidate = _step3$value[0],
            candidateInversion = _step3$value[1],
            candidateOriginalPC = _step3$value[2];

        if (Object(_common__WEBPACK_IMPORTED_MODULE_6__["arrayEquals"])(dataLinePcs, candidate)) {
          index = indexCandidate;

          if (inversionsAvailable.includes(0)) {
            inversion = 0;
          } else {
            inversion = 1;
          }

          matchedPCOriginal = candidateOriginalPC;
          match = true;
          break;
        } else if (Object(_common__WEBPACK_IMPORTED_MODULE_6__["arrayEquals"])(dataLinePcs, candidateInversion)) {
          index = indexCandidate;

          if (inversionsAvailable.includes(0)) {
            inversion = 0;
          } else {
            inversion = -1;
          }

          matchedPCOriginal = candidateOriginalPC;
          match = true;
          break;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }

  if (!match) {
    throw new Error("cannot find a chord table address for ".concat(pcSet));
  }

  return _chordTableAddress(card, index, inversion, matchedPCOriginal);
}

/***/ }),

/***/ "./src/music21/clef.ts":
/*!*****************************!*\
  !*** ./src/music21/clef.ts ***!
  \*****************************/
/*! exports provided: lowestLines, nameToLine, nameToSign, Clef, TrebleClef, Treble8vbClef, Treble8vaClef, BassClef, Bass8vbClef, AltoClef, TenorClef, SopranoClef, MezzoSopranoClef, PercussionClef, all_clefs, bestClef, clefFromString */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lowestLines", function() { return lowestLines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nameToLine", function() { return nameToLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nameToSign", function() { return nameToSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Clef", function() { return Clef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrebleClef", function() { return TrebleClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Treble8vbClef", function() { return Treble8vbClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Treble8vaClef", function() { return Treble8vaClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BassClef", function() { return BassClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bass8vbClef", function() { return Bass8vbClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AltoClef", function() { return AltoClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TenorClef", function() { return TenorClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SopranoClef", function() { return SopranoClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MezzoSopranoClef", function() { return MezzoSopranoClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PercussionClef", function() { return PercussionClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all_clefs", function() { return all_clefs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bestClef", function() { return bestClef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clefFromString", function() { return clefFromString; });
/* harmony import */ var core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.flat */ "./node_modules/core-js/modules/es.array.flat.js");
/* harmony import */ var core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.unscopables.flat */ "./node_modules/core-js/modules/es.array.unscopables.flat.js");
/* harmony import */ var core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./pitch */ "./src/music21/pitch.ts");




/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/clef -- Clef objects
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–19, Michael Scott Cuthbert and cuthbertLab
 *
 * Clef module, see {@link music21.clef} for namespace
 * Clef related objects and properties
 *
 * @exports music21/clef
 * @namespace music21.clef
 * @memberof music21
 * @requires music21/base
 * @requires music21/pitch
 */


/*  music21.Clef
    must be defined before Stream since Stream subclasses call new music21.Clef...
 */
// TODO: Fix to newest Vexflow format...

/**
 *
 * @type {
 *     {bass: number, soprano: number, tenor: number, percussion: number,
 *     'mezzo-soprano': number, alto: number, treble: number}}
 */

var lowestLines = {
  treble: 31,
  soprano: 29,
  'mezzo-soprano': 27,
  alto: 25,
  tenor: 23,
  bass: 19,
  percussion: 31
};
/**
 *
 * @type {
 *     {bass: number, soprano: number, tenor: number, percussion: number,
 *     'mezzo-soprano': number, alto: number, treble: number}}
 */

var nameToLine = {
  treble: 2,
  soprano: 1,
  'mezzo-soprano': 2,
  alto: 3,
  tenor: 4,
  bass: 4,
  percussion: 3
};
/**
 *
 * @type {
 *     {bass: string, soprano: string, tenor: string, percussion: string,
 *     'mezzo-soprano': string, alto: string, treble: string}}
 */

var nameToSign = {
  treble: 'G',
  soprano: 'C',
  'mezzo-soprano': 'C',
  alto: 'C',
  tenor: 'C',
  bass: 'F',
  percussion: 'percussion'
};
/**
 * Clef name can be one of
 * "treble", "bass", "soprano", "mezzo-soprano", "alto", "tenor", "percussion"
 *
 * @class Clef
 * @memberof music21.clef
 * @extends music21.base.Music21Object
 * @param {string} name - clef name
 * @param {number} [octaveChange=0] - ottava
 * @property {string} [name]
 * @property {number} lowestLine - diatonicNoteNum (C4 = 29) for the
 *     lowest line (in a five-line staff)
 * @property {number} lowestLineTrebleOffset - difference between the first line
 *     of this staff and the first line in treble clef
 * @property {number} octaveChange
 */

class Clef extends _base__WEBPACK_IMPORTED_MODULE_3__["Music21Object"] {
  constructor(name) {
    var octaveChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    super();
    this.name = undefined;
    this.sign = undefined;
    this.line = 1;
    this.lowestLine = lowestLines.treble;
    this.lowestLineTrebleOffset = 0;
    this.classSortOrder = 0;

    if (name !== undefined) {
      name = name.toLowerCase();
      this.name = name;
      this.lowestLine = lowestLines[name];
      this.sign = nameToSign[name];
      this.line = nameToLine[name] || 1;
      this.lowestLineTrebleOffset = lowestLines.treble - this.lowestLine;
    }

    this.octaveChange = octaveChange;
    this.lowestLine += 7 * octaveChange;
    this.lowestLineTrebleOffset -= 7 * octaveChange;
  }

  static get className() {
    return 'music21.clef.Clef';
  }

  stringInfo() {
    return '';
  }
  /**
   * returns a new pitch object if the clef name is not Treble
   * designed so it would look the same as it would in treble clef.
   * for instance, bass-clef 2nd-space C# becomes treble clef 2nd-space A#
   * used for Vex.Flow which requires all pitches to be input as if they
   * are in treble clef.
   *
   * @param {music21.pitch.Pitch} p
   * @returns {music21.pitch.Pitch} new pitch
   */


  convertPitchToTreble(p) {
    if (this.lowestLine === undefined) {
      console.log('no first line defined for clef', this.name, this);
      return p; // error
    }

    var lowestLineDifference = this.lowestLineTrebleOffset;
    var tempPitch = new _pitch__WEBPACK_IMPORTED_MODULE_4__["Pitch"](p.step);
    tempPitch.octave = p.octave;
    tempPitch.diatonicNoteNum += lowestLineDifference;
    tempPitch.accidental = p.accidental;
    return tempPitch;
  }

}
/**
 * A TrebleClef (same as new music21.clef.Clef('treble'))
 *
 * @class TrebleClef
 * @memberof music21.clef
 * @extends music21.clef.Clef
 */

class TrebleClef extends Clef {
  static get className() {
    return 'music21.clef.TrebleClef';
  }

  constructor() {
    super('treble');
    this.sign = 'G';
    this.line = 2;
  }

}
/**
 * A TrebleClef down an octave (same as new music21.clef.Clef('treble', -1))
 *
 * Unlike music21p, currently not a subclass of TrebleClef.
 *
 * @class Treble8vbClef
 * @memberof music21.clef
 * @extends music21.clef.Clef
 */

class Treble8vbClef extends Clef {
  static get className() {
    return 'music21.clef.Treble8vbClef';
  }

  constructor() {
    super('treble', -1);
  }

}
/**
 * A TrebleClef up an octave (same as new music21.clef.Clef('treble', 1))
 *
 * @class Treble8vaClef
 * @memberof music21.clef
 * @extends music21.clef.Clef
 */

class Treble8vaClef extends Clef {
  static get className() {
    return 'music21.clef.Treble8vaClef';
  }

  constructor() {
    super('treble', 1);
  }

}
/**
 * A BassClef (same as new music21.clef.Clef('bass'))
 *
 * @class BassClef
 * @memberof music21.clef
 * @extends music21.clef.Clef
 */

class BassClef extends Clef {
  static get className() {
    return 'music21.clef.BassClef';
  }

  constructor() {
    super('bass');
    this.sign = 'F';
    this.line = 4;
  }

}
/**
 * A BassClef down an octave (same as new music21.clef.Clef('bass', -1))
 *
 * @class Bass8vbClef
 * @memberof music21.clef
 * @extends music21.clef.Clef
 */

class Bass8vbClef extends Clef {
  static get className() {
    return 'music21.clef.Bass8vbClef';
  }

  constructor() {
    super('bass', -1);
    this.sign = 'F';
    this.line = 4;
  }

}
/**
 * An AltoClef (same as new music21.clef.Clef('alto'))
 *
 * @class AltoClef
 * @memberof music21.clef
 * @extends music21.clef.Clef
 */

class AltoClef extends Clef {
  static get className() {
    return 'music21.clef.AltoClef';
  }

  constructor() {
    super('alto');
    this.sign = 'C';
    this.line = 3;
  }

}
/**
 * A Tenor Clef (same as new music21.clef.Clef('tenor'))
 *
 * @class TenorClef
 * @memberof music21.clef
 * @extends music21.clef.Clef
 */

class TenorClef extends Clef {
  static get className() {
    return 'music21.clef.TenorClef';
  }

  constructor() {
    super('tenor');
    this.sign = 'C';
    this.line = 4;
  }

}
/**
 * A Soprano Clef (same as new music21.clef.Clef('soprano'))
 *
 * @class SopranoClef
 * @memberof music21.clef
 * @extends music21.clef.Clef
 */

class SopranoClef extends Clef {
  static get className() {
    return 'music21.clef.SopranoClef';
  }

  constructor() {
    super('soprano');
    this.sign = 'C';
    this.line = 1;
  }

}
/**
 * A Mezzo-Soprano Clef (same as new music21.clef.Clef('mezzo-soprano'))
 *
 * @class MezzoSopranoClef
 * @memberof music21.clef
 * @extends music21.clef.Clef
 */

class MezzoSopranoClef extends Clef {
  static get className() {
    return 'music21.clef.MezzoSopranoClef';
  }

  constructor() {
    super('mezzo-soprano');
    this.sign = 'C';
    this.line = 2;
  }

}
/**
 * A Percussion Clef (same as new music21.clef.Clef('percussion'))
 *
 * First line is treated as if it's treble clef. Not available as "bestClef"
 *
 * @class PercussionClef
 * @memberof music21.clef
 * @extends music21.clef.Clef
 */

class PercussionClef extends Clef {
  static get className() {
    return 'music21.clef.PercussionClef';
  }

  constructor() {
    super('percussion');
    this.sign = 'percussion';
    this.line = 3;
  }

}
var all_clefs = {
  TrebleClef,
  Treble8vbClef,
  Treble8vaClef,
  BassClef,
  Bass8vbClef,
  AltoClef,
  TenorClef,
  SopranoClef,
  MezzoSopranoClef,
  PercussionClef
};
/**
 * Looks at the pitches in a Stream and returns the best clef
 * of Treble and Bass
 *
 * @function music21.clef.bestClef
 * @memberof music21.clef
 * @param {music21.stream.Stream} st
 * @param {Object} [options]
 * @param {boolean} [options.recurse=true]
 * @returns {music21.clef.Clef}
 */

function bestClef(st) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$recurse = _ref.recurse,
      recurse = _ref$recurse === void 0 ? true : _ref$recurse;

  // console.log('calling flat on stream: ', st.elements.length, st.classes[st.classes.length - 1]);
  var stFlat;

  if (recurse) {
    stFlat = st.flat;
  } else {
    stFlat = st;
  }

  var totalNotes = 0;
  var totalPitch = 0.0;

  for (var i = 0; i < stFlat.length; i++) {
    var el = stFlat.get(i);

    if (el.pitch !== undefined) {
      totalNotes += 1;
      totalPitch += el.pitch.diatonicNoteNum;
    } else if (el.pitches !== undefined) {
      for (var j = 0; j < el.pitches.length; j++) {
        totalNotes += 1;
        totalPitch += el.pitches[j].diatonicNoteNum;
      }
    }
  }

  var averageHeight;

  if (totalNotes === 0) {
    averageHeight = 29;
  } else {
    averageHeight = totalPitch / totalNotes;
  } // console.log('bestClef: average height', averageHeight);


  if (averageHeight > 28) {
    // 29 = c4
    return new TrebleClef();
  } else {
    return new BassClef();
  }
}
/**
 *
 * @param {string} clefString
 * @param {number} [octaveShift=0]
 * @returns {music21.clef.Clef}
 */

function clefFromString(clefString) {
  var octaveShift = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var xnStr = clefString.trim();
  var thisType;
  var lineNum;

  if (xnStr.toLowerCase() === 'percussion') {
    return new PercussionClef();
  } // todo: tab, none, jianpu


  if (xnStr.length === 2) {
    thisType = xnStr[0].toUpperCase();
    lineNum = parseInt(xnStr[1]);
  } else if (xnStr.length === 1) {
    thisType = xnStr[0].toUpperCase();

    if (thisType === 'G') {
      lineNum = 2;
    } else if (thisType === 'F') {
      lineNum = 4;
    } else if (thisType === 'C') {
      lineNum = 3;
    } else {
      lineNum = 0;
    }
  } else if (xnStr.length > 2) {
    // try to get any clef in the module
    var searchLower = xnStr.toLowerCase();

    for (var _i = 0, _Object$keys = Object.keys(all_clefs); _i < _Object$keys.length; _i++) {
      var clefKey = _Object$keys[_i];
      var clefLower = clefKey.toLowerCase();
      var potentialClass = all_clefs[clefKey];

      if (typeof potentialClass !== 'function') {
        continue;
      }

      if (clefLower !== searchLower && clefLower !== searchLower + 'clef') {
        continue;
      }

      return new potentialClass();
    }
  }

  var arrayEqual = (a, b) => a.length === b.length && a.every((el, ix) => el === b[ix]);

  var params = [thisType, lineNum, octaveShift];

  if (arrayEqual(params, ['G', 2, 0])) {
    return new TrebleClef();
  } else if (arrayEqual(params, ['G', 2, -1])) {
    return new Treble8vbClef();
  } else if (arrayEqual(params, ['G', 2, 1])) {
    return new Treble8vaClef();
  } else if (arrayEqual(params, ['F', 4, 0])) {
    return new BassClef();
  } else if (arrayEqual(params, ['F', 4, -1])) {
    return new Bass8vbClef();
  } else if (arrayEqual(params, ['C', 3, 0])) {
    return new AltoClef();
  } else if (arrayEqual(params, ['C', 4, 0])) {
    return new TenorClef();
  } else {
    return new Clef(xnStr, octaveShift);
  }
}

/***/ }),

/***/ "./src/music21/common.ts":
/*!*******************************!*\
  !*** ./src/music21/common.ts ***!
  \*******************************/
/*! exports provided: merge, range, mixin, posMod, statisticalMode, fromRoman, toRoman, makeSVGright, ordinalAbbreviation, rationalize, stripPx, urlParam, arrayEquals, SingletonCounter, urls, hyphenToCamelCase, numToIntOrFloat, pathSimplify, isFloat */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return mixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "posMod", function() { return posMod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "statisticalMode", function() { return statisticalMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromRoman", function() { return fromRoman; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRoman", function() { return toRoman; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeSVGright", function() { return makeSVGright; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ordinalAbbreviation", function() { return ordinalAbbreviation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rationalize", function() { return rationalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stripPx", function() { return stripPx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urlParam", function() { return urlParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayEquals", function() { return arrayEquals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SingletonCounter", function() { return SingletonCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urls", function() { return urls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hyphenToCamelCase", function() { return hyphenToCamelCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numToIntOrFloat", function() { return numToIntOrFloat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pathSimplify", function() { return pathSimplify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFloat", function() { return isFloat; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.constructor */ "./node_modules/core-js/modules/es.regexp.constructor.js");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.search */ "./node_modules/core-js/modules/es.string.search.js");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7__);









/**
 * common functions
 * functions that are useful everywhere...
 *
 * @exports music21/common
 * @memberof music21
 */

/**
 * concept borrowed from Vex.Flow.Merge, though here the source can be undefined;
 * http://stackoverflow.com/questions/171251/how-can-i-merge-properties-of-two-javascript-objects-dynamically
 * recursive parts used in .clone()
 *
 * @function music21.common.merge
 * @param {Object} destination - object to have attributes placed into
 * @param {Object} source - object to take attributes from.
 * @memberof music21.common
 * @returns {Object} destination
 */
function merge(destination, source) {
  if (source === undefined || source === null) {
    return destination;
  }

  for (var p in source) {
    if (!{}.hasOwnProperty.call(source, p)) {
      continue;
    }

    try {
      // Property in destination object set; update its value.
      if (source[p] && source[p].constructor === Object) {
        destination[p] = merge(destination[p], source[p]);
      } else {
        destination[p] = source[p];
      }
    } catch (e) {
      // Property in destination object not set; create it and set its value.
      destination[p] = source[p];
    }
  }

  return destination;
}
function range(start, stop, step) {
  if (step === undefined) {
    step = 1;
  }

  if (stop === undefined) {
    stop = start;
    start = 0;
  }

  var count = Math.ceil((stop - start) / step);
  return Array.apply(0, Array(count)).map((e, i) => i * step + start);
}
/**
 * Mix in another class into this class -- a simple form of multiple inheritance.
 * See articulations.Marcato for an example.
 *
 */

function mixin(OtherParent, thisClassOrObject) {
  var proto = Object.getPrototypeOf(OtherParent);
  var classProto = Object.getPrototypeOf(thisClassOrObject);

  while (proto) {
    for (var key in Object.keys(proto)) {
      if (!{}.hasOwnProperty.call(proto, key)) {
        continue;
      }

      if (!(key in classProto)) {
        classProto[key] = proto[key];
      }
    }

    proto = Object.getPrototypeOf(proto);
  }
}
/**
 * Aggregation -- closer to true multiple inheritance -- prefers last class's functions.  See
 * https://stackoverflow.com/questions/29879267/es6-class-multiple-inheritance
 *
 *  not currently used...
 */
// export const aggregation = (baseClass, ...mixins) => {
//     class base extends baseClass {
//         constructor(...args) {
//             super(...args);
//             mixins.forEach(mixin => {
//                 copyProps(this, new mixin());
//             });
//         }
//     }
//     const copyProps = (target, source) => {
//         // this function copies all properties and symbols, filtering out some special ones
//         // noinspection JSUnresolvedFunction,JSCheckFunctionSignatures
//         Object.getOwnPropertyNames(source)
//             .concat(Object.getOwnPropertySymbols(source))
//             .forEach(prop => {
//                 if (
//                     !prop.match(
//                         /^(?:constructor|prototype|arguments|caller|name|bind|call|apply|toString|length)$/
//                     )
//                 ) {
//                     Object.defineProperty(
//                         target,
//                         prop,
//                         Object.getOwnPropertyDescriptor(source, prop)
//                     );
//                 }
//             });
//     };
//     mixins.forEach(mixin => {
//         // outside constructor() to allow aggregation(A,B,C).staticFunction() to be called etc.
//         copyProps(base.prototype, mixin.prototype);
//         copyProps(base, mixin);
//     });
//     return base;
// };

/**
 * posMod - return a modulo value that is not negative
 *
 * @param  {int} a value
 * @param  {int} b modulo
 * @return {int}   a mod b between 0 and b - 1
 */

function posMod(a, b) {
  if (a === undefined || b === undefined) {
    throw new Error('Modulo needs two numbers');
  }

  return (a % b + b) % b;
}
/**
 *
 * Returns the statistical mode (most commonly appearing element)
 * in a.
 *
 * In case of tie, returns the first element to reach the maximum
 * number of occurrences.
 *
 * @function music21.common.statisticalMode
 * @param {Array<*>} a - an array to analyze
 * @returns {Object} element with the highest frequency in a
 */

function statisticalMode(a) {
  if (a.length === 0) {
    return null;
  }

  var modeMap = {};
  var maxEl = a[0];
  var maxCount = 1;

  for (var i = 0; i < a.length; i++) {
    var el = a[i];

    if (modeMap[el] == null) {
      modeMap[el] = 0;
    }

    modeMap[el] += 1;

    if (modeMap[el] > maxCount) {
      maxEl = el;
      maxCount = modeMap[el];
    }
  }

  return maxEl;
}
/**
 * fromRoman - Convert a Roman numeral (upper or lower) to an int.
 *
 * @param  {string} num roman numeral representation of a number
 * @return {int}     integer value of roman numeral;
 */

function fromRoman(num) {
  var inputRoman = num.toUpperCase();
  var subtractionValues = [1, 10, 100];
  var nums = ['M', 'D', 'C', 'L', 'X', 'V', 'I'];
  var ints = [1000, 500, 100, 50, 10, 5, 1];
  var places = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = inputRoman[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _c = _step.value;

      if (!nums.includes(_c)) {
        throw new Error('Value is not a valid roman numeral: ' + inputRoman);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  for (var i = 0; i < inputRoman.length; i++) {
    var c = inputRoman[i];
    var value = ints[nums.indexOf(c)];

    if (i < inputRoman.length - 1) {
      var nextValue = ints[nums.indexOf(inputRoman[i + 1])];

      if (nextValue > value && subtractionValues.includes(value)) {
        value *= -1;
      }
    }

    places.push(value);
  }

  var summation = 0;

  for (var _i = 0, _places = places; _i < _places.length; _i++) {
    var n = _places[_i];
    summation += n;
  }

  return summation;
}
/**
 * toRoman - Convert a number from 1 to 3999 to a roman numeral
 *
 * @param  {int} num number to convert
 * @return {string}     as roman numeral
 */

function toRoman(num) {
  if (typeof num !== 'number') {
    throw new Error('expected integer, got ' + typeof num);
  }

  if (num < 0 || num > 4000) {
    throw new Error('Argument must be between 1 and 3999');
  }

  var ints = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
  var nums = ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I'];
  var result = '';

  for (var i = 0; i < ints.length; i++) {
    var count = Math.floor(num / ints[i]);
    result += nums[i].repeat(count);
    num -= ints[i] * count;
  }

  return result;
}
/**
 * Creates an SVGElement of an SVG figure using the correct `document.createElementNS` call.
 *
 * @function music21.common.makeSVGright
 * @param {string} [tag='svg'] - a tag, such as 'rect', 'circle', 'text', or 'svg'
 * @param {Object} [attrs] - attributes to pass to the tag.
 * @memberof music21.common
 * @returns {SVGElement}
 */

function makeSVGright() {
  var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'svg';
  var attrs = arguments.length > 1 ? arguments[1] : undefined;

  // see http://stackoverflow.com/questions/3642035/jquerys-append-not-working-with-svg-element
  // normal JQuery does not work.
  if (attrs === undefined) {
    attrs = {};
  }

  var el = document.createElementNS('http://www.w3.org/2000/svg', tag);

  for (var k in attrs) {
    if (!{}.hasOwnProperty.call(attrs, k)) {
      continue;
    }

    el.setAttribute(k, attrs[k]);
  }

  return el;
}
/**
 * Take a number such as 32 and return a string such as "nd"
 * (for "32nd") etc.
 *
 * @function music21.common.ordinalAbbreviation
 * @param {number} value
 * @param {boolean} [plural=false] - make plural (note that "21st" plural is "21st")
 * @return {string}
 */

function ordinalAbbreviation(value) {
  var plural = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var post;
  var valueHundredths = value % 100;

  if (valueHundredths === 11 || valueHundredths === 12 || valueHundredths === 13) {
    post = 'th';
  } else {
    var valueMod = value % 10;

    if (valueMod === 1) {
      post = 'st';
    } else if (valueMod === 2) {
      post = 'nd';
    } else if (valueMod === 3) {
      post = 'rd';
    } else {
      post = 'th';
    }
  }

  if (post !== 'st' && plural) {
    post += 's';
  }

  return post;
}
/**
 * Find a rational number approximation of this floating point.
 *
 * @function music21.common.rationalize
 * @param {number} ql - number to rationalize
 * @param {number} [epsilon=0.001] - how close to get
 * @param {int} [maxDenominator=50] - maximum denominator
 * @returns {object|undefined} {'numerator: numerator, 'denominator': denominator}
 */

function rationalize(ql) {
  var epsilon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.001;
  var maxDenominator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;

  for (var i = 2; i < maxDenominator; i++) {
    if (Math.abs(ql * i - Math.round(ql * i)) < epsilon) {
      var numerator = Math.round(ql * i);
      var denominator = i;
      return {
        numerator,
        denominator
      };
    }
  }

  return undefined;
}
/**
 * Change something that could be a string or number and might
 * end with "px" to a number.
 *
 * "400px" -> 400
 *
 * @function music21.common.stripPx
 * @param {number|string} str -- string that might have 'px' at the end or not
 * @returns {number} a number to use
 */

function stripPx(str) {
  if (typeof str === 'string') {
    var pxIndex = str.indexOf('px');
    str = str.slice(0, pxIndex);
    return parseInt(str);
  } else {
    return str;
  }
}
/**
 * Find name in the query string (?name=value) and return value.
 *
 * @function music21.common.urlParam
 * @param {string} name - url parameter to find
 * @returns {string} may be "" if empty.
 */

function urlParam(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(window.location.search);
  return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
function arrayEquals(a1, a2) {
  if (a1.length !== a2.length) {
    return false;
  }

  for (var i = 0; i < a1.length; i++) {
    if (a1[i] instanceof Array && a2[i] instanceof Array) {
      if (!arrayEquals(a1[i], a2[i])) {
        return false;
      }
    } else if (a1[i] !== a2[i]) {
      return false;
    }
  }

  return true;
}
var _singletonCounter = {
  value: 0
};
class SingletonCounter {
  call() {
    var post = _singletonCounter.value;
    _singletonCounter.value += 1;
    return post;
  }

}
var urls = {
  css: '/css',
  webResources: '/webResources',
  midiPlayer: '/webResources/midiPlayer',
  soundfontUrl: '/soundfonts/midi-js-soundfonts-master/FluidR3_GM/'
};
function hyphenToCamelCase(usrStr) {
  return usrStr.replace(/-([a-zA-Z])/g, (all, match) => match.toUpperCase());
}
function numToIntOrFloat(value) {
  var intVal = Math.round(value);

  if (Math.abs(value - intVal) < 0.000001) {
    return intVal;
  } else {
    return value;
  }
}
/**
 *
 * @param {string} path
 * @returns {string}
 */

var pathSimplify = path => {
  var pPrefix = '';

  if (path.indexOf('//') === 0) {
    pPrefix = '//'; //cdn loading;

    path = path.slice(2);
    console.log('cdn load: ', pPrefix, ' into ', path);
  } else if (path.indexOf('://') !== -1) {
    // for cross site requests...
    var protoSpace = path.indexOf('://');
    pPrefix = path.slice(0, protoSpace + 3);
    path = path.slice(protoSpace + 3);
    console.log('cross-site split', pPrefix, path);
  }

  var ps = path.split('/');
  var addSlash = path.slice(path.length - 1, path.length) === '/';
  var pout = [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = ps[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      if (el === '..') {
        if (pout.length > 0) {
          if (pout[pout.length - 1] !== '..') {
            pout.pop();
          } else {
            pout.push('..');
          }
        } else {
          pout.push('..');
        }
      } else {
        pout.push(el);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var pNew = pout.join('/');

  if (addSlash) {
    pNew += '/';
  }

  pNew = pPrefix + pNew;
  return pNew;
};
function isFloat(num) {
  return Number(num) === num && num % 1 !== 0;
} // TODO: implement and test
// export function opFrac(num) {
//
//     //const DENOM_LIMIT = 65535; // move to another location
//     if (isFloat(num)) { // no builtin isFloat function exists
//         // no fraction support yet
//         return num;
//     }
//     else if (Number.isInteger(num)) {
//         return num; // number, no int's
//     }
//     else if (num === 'Fraction') { // Replace with fraction object
//         return num; // no fraction support yet
//     }
//     else if (num === null) {
//         return null;
//     }
//     else {
//         return null;
//     }
// }

/***/ }),

/***/ "./src/music21/converter.ts":
/*!**********************************!*\
  !*** ./src/music21/converter.ts ***!
  \**********************************/
/*! exports provided: parse */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
/* harmony import */ var _musicxml_xmlToM21__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./musicxml/xmlToM21 */ "./src/music21/musicxml/xmlToM21.ts");

function parse(txt) {
  var sp = new _musicxml_xmlToM21__WEBPACK_IMPORTED_MODULE_0__["ScoreParser"]();
  return sp.scoreFromText(txt);
}

/***/ }),

/***/ "./src/music21/debug.ts":
/*!******************************!*\
  !*** ./src/music21/debug.ts ***!
  \******************************/
/*! exports provided: debug */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debug", function() { return debug; });
var debug = false;

/***/ }),

/***/ "./src/music21/derivation.ts":
/*!***********************************!*\
  !*** ./src/music21/derivation.ts ***!
  \***********************************/
/*! exports provided: Derivation, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Derivation", function() { return Derivation; });
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_1__);


class Derivation {
  constructor(client) {
    this.client = client;
  }

  clone() {
    var newThing = new Derivation(this.client);
    newThing.method = this.method;
    newThing.origin = this.origin;
    return newThing;
  }

  chain() {
    var _this = this;

    return (
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var origin;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                origin = _this.origin;

              case 1:
                if (!(origin !== undefined)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return origin;

              case 4:
                origin = origin.derivation.origin;
                _context.next = 1;
                break;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })()
    );
  }

  rootDerivation() {
    var derivationChain = Array.from(this.chain());

    if (derivationChain.length) {
      return derivationChain[derivationChain.length - 1];
    } else {
      return undefined;
    }
  }

}
/* harmony default export */ __webpack_exports__["default"] = (Derivation);

/***/ }),

/***/ "./src/music21/duration.ts":
/*!*********************************!*\
  !*** ./src/music21/duration.ts ***!
  \*********************************/
/*! exports provided: typeFromNumDict, quarterTypeIndex, ordinalTypeFromNum, vexflowDurationArray, Duration, Tuplet */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "typeFromNumDict", function() { return typeFromNumDict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quarterTypeIndex", function() { return quarterTypeIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ordinalTypeFromNum", function() { return ordinalTypeFromNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vexflowDurationArray", function() { return vexflowDurationArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Duration", function() { return Duration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tuplet", function() { return Tuplet; });
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./debug */ "./src/music21/debug.ts");
/* harmony import */ var _prebase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./prebase */ "./src/music21/prebase.ts");



/**
 * music21j -- Javascript reimplementation of Core music21 features.
 * music21/duration -- duration routines
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21, Copyright (c) 2006-19, Michael Scott Cuthbert and cuthbertLab
 *
 * Module that holds **music21** classes and
 * tools for dealing with durations, especially
 * the {@link music21.duration.Duration} class.
 *
 * Duration module. See {@link music21.duration}
 *
 * @module music21/duration
 * @namespace music21.duration
 * @memberof music21
 * @requires music21/common
 * @requires music21/prebase
 * @exports music21/duration
 */




/**
 * Object mapping int to name, as in `{1: 'whole'}` etc.
 *
 * @memberof music21.duration
 * @type {Object}
 */

var typeFromNumDict = {
  1: 'whole',
  2: 'half',
  4: 'quarter',
  8: 'eighth',
  16: '16th',
  32: '32nd',
  64: '64th',
  128: '128th',
  256: '256th',
  512: '512th',
  1024: '1024th',
  0: 'zero',
  '0.5': 'breve',
  '0.25': 'longa',
  '0.125': 'maxima',
  '0.0625': 'duplex-maxima'
};
var quarterTypeIndex = 6; // where is quarter in the following array.

var ordinalTypeFromNum = ['duplex-maxima', 'maxima', 'longa', 'breve', 'whole', 'half', 'quarter', 'eighth', '16th', '32nd', '64th', '128th', '256th', '512th', '1024th'];
var vexflowDurationArray = [undefined, undefined, undefined, undefined, 'w', 'h', 'q', '8', '16', '32', undefined, undefined, undefined, undefined, undefined];
/**
 * Duration object; found as the `.duration` attribute on {@link music21.base.Music21Object} instances
 * such as {@link music21.note.Note}
 *
 * @class Duration
 * @memberof music21.duration
 * @param {(number|undefined)} ql - quarterLength (default 1.0)
 */

class Duration extends _prebase__WEBPACK_IMPORTED_MODULE_5__["ProtoM21Object"] {
  constructor() {
    var ql = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.0;
    super();
    this.isGrace = false;
    this._quarterLength = 0.0;
    this._dots = 0;
    this._durationNumber = undefined;
    this._type = 'zero';
    this._tuplets = [];

    if (typeof ql === 'string') {
      this.type = ql;
    } else if (ql !== undefined) {
      this.quarterLength = ql;
    }

    this._cloneCallbacks._tuplets = this.cloneCallbacksTupletFunction;
  }

  static get className() {
    return 'music21.duration.Duration';
  }

  stringInfo() {
    return this.quarterLength.toString();
  }
  /**
   * Read or sets the number of dots on the duration.
   *
   * Updates the quarterLength
   *
   * @type {number}
   * @default 0
   * @example
   * var d = new music21.duration.Duration(2);
   * d.dots === 0; // true
   * d.dots = 1;
   * d.quarterLength == 3; // true;
   */


  get dots() {
    return this._dots;
  }

  set dots(numDots) {
    this._dots = numDots;
    this.updateQlFromFeatures();
  }
  /**
   * Read or sets the quarterLength of the Duration
   *
   * Updates the type, dots, tuplets(?)
   *
   * @type {number}
   * @default 1.0
   * @example
   * var d = new music21.duration.Duration(2);
   * d.quarterLength == 2.0; // true;
   * d.quarterLength = 1.75;
   * d.dots == 2; // true
   * d.type == 'quarter'; // true
   */


  get quarterLength() {
    return this._quarterLength;
  }

  set quarterLength(ql) {
    if (ql === undefined) {
      ql = 1.0;
    }

    this._quarterLength = ql;
    this.updateFeaturesFromQl();
  }
  /**
   * Read or sets the type of the duration.
   *
   * Updates the quarterLength
   *
   * @type {string}
   * @default 'quarter'
   * @example
   * var d = new music21.duration.Duration(2);
   * d.type == 'half; // true
   * d.type = 'breve';
   * d.quarterLength == 8.0; // true
   * d.dots = 1;
   * d.type = 'quarter'; // will not change dots
   * d.quarterLength == 1.5; // true
   */


  get type() {
    return this._type;
  }

  set type(typeIn) {
    var typeNumber = ordinalTypeFromNum.indexOf(typeIn);

    if (typeNumber === -1) {
      console.log('invalid type ' + typeIn);
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_2__["Music21Exception"]('invalid type ' + typeIn);
    }

    this._type = typeIn;
    this.updateQlFromFeatures();
  }
  /**
   * Reads the tuplet Array for the duration.
   *
   * The tuplet array should be considered Read Only.
   * Use {@link music21.duration.Duration#appendTuplet} to
   * add a tuplet (no way to remove yet)
   *
   * @type {Tuplet[]}
   * @default []
   */


  get tuplets() {
    return this._tuplets;
  }
  /**
   * Read-only: the duration expressed for VexFlow
   *
   * @type {string}
   * @default 'd'
   * @readonly
   * @example
   * var d = new music21.duration.Duration(2);
   * d.vexflowDuration == 'h'; // true;
   * d.dots = 2;
   * d.vexflowDuration == 'hdd'; // true;
   */


  get vexflowDuration() {
    var typeNumber = ordinalTypeFromNum.indexOf(this.type);
    var vd = vexflowDurationArray[typeNumber];

    if (this.dots > 0) {
      for (var i = 0; i < this.dots; i++) {
        vd += 'd'; // vexflow does not handle double dots .. or does it???
      }
    }

    return vd;
  }

  cloneCallbacksTupletFunction(tupletKey, ret, obj, deep, memo) {
    // make sure that tuplets clone properly
    var newTuplets = [];

    for (var i = 0; i < obj[tupletKey].length; i++) {
      var newTuplet = obj[tupletKey][i].clone(); // console.log('cloning tuplets', obj[tupletKey][i], newTuplet);

      newTuplets.push(newTuplet);
    }

    ret[tupletKey] = newTuplets;
  }
  /**
   *
   * @param {number} ql
   * @returns {number}
   * @private
   */


  _findDots(ql) {
    if (ql === 0) {
      return 0;
    } // zero length stream probably;


    var typeNumber = ordinalTypeFromNum.indexOf(this._type);
    var powerOfTwo = Math.pow(2, quarterTypeIndex - typeNumber); // alert(undottedQL * 1.5 + " " + ql)
    // console.log('find dots called on ql: ', ql, typeNumber, powerOfTwo);

    for (var dotsNum = 0; dotsNum <= 4; dotsNum++) {
      var dotMultiplier = (Math.pow(2, dotsNum) - 1.0) / Math.pow(2, dotsNum);
      var durationMultiplier = 1 + dotMultiplier;

      if (Math.abs(powerOfTwo * durationMultiplier - ql) < 0.0001) {
        return dotsNum;
      }
    }

    if (_debug__WEBPACK_IMPORTED_MODULE_4__["debug"]) {
      console.log('no dots available for ql; probably a tuplet', ql);
    }

    return 0;
  }

  updateQlFromFeatures() {
    var typeNumber = ordinalTypeFromNum.indexOf(this._type); // must be set property

    var undottedQuarterLength = Math.pow(2, quarterTypeIndex - typeNumber);
    var dottedMultiplier = 1 + (Math.pow(2, this._dots) - 1.0) / Math.pow(2, this._dots);
    var unTupletedQl = undottedQuarterLength * dottedMultiplier;
    var tupletCorrectedQl = unTupletedQl;

    this._tuplets.forEach(tuplet => {
      tupletCorrectedQl *= tuplet.tupletMultiplier();
    });

    this._quarterLength = tupletCorrectedQl;
  }

  updateFeaturesFromQl() {
    var ql = this._quarterLength;
    this._tuplets = [];

    if (ql === 0) {
      this._type = 'zero';
      this._dots = 0;
      return;
    }

    var powerOfTwo = Math.floor(Math.log(ql + 0.00001) / Math.log(2));
    var typeNumber = quarterTypeIndex - powerOfTwo;
    this._type = ordinalTypeFromNum[typeNumber]; // console.log(this._findDots);

    this._dots = this._findDots(ql);
    var undottedQuarterLength = Math.pow(2, quarterTypeIndex - typeNumber);
    var dottedMultiplier = 1 + (Math.pow(2, this._dots) - 1) / Math.pow(2, this._dots);
    var unTupletedQl = undottedQuarterLength * dottedMultiplier;

    if (unTupletedQl !== ql && ql !== 0) {
      typeNumber -= 1;
      this._type = ordinalTypeFromNum[typeNumber]; // increase type: eighth to quarter etc.

      unTupletedQl *= 2;
      var tupletRatio = ql / unTupletedQl;
      var ratioRat = _common__WEBPACK_IMPORTED_MODULE_3__["rationalize"](tupletRatio);

      if (ratioRat === undefined) {// probably a Stream with a length that is inexpressable;
      } else {
        var t = new Tuplet(ratioRat.denominator, ratioRat.numerator, new Duration(unTupletedQl));
        this.appendTuplet(t, true); // skipUpdateQl
      } // console.log(ratioRat, ql, unTupletedQl);

    }
  }
  /**
   * Add a tuplet to music21j
   *
   * @param {Tuplet} newTuplet - tuplet to add to `.tuplets`
   * @param {boolean} [skipUpdateQl=false] - update the quarterLength afterwards?
   * @returns {this}
   */


  appendTuplet(newTuplet) {
    var skipUpdateQl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    newTuplet.frozen = true;

    this._tuplets.push(newTuplet);

    if (skipUpdateQl !== true) {
      this.updateQlFromFeatures();
    }

    return this;
  }

}
/**
 * Represents a Tuplet; found in {@link music21.duration.Duration#tuplets}
 *
 * @memberof music21.duration
 * @param {number} [numberNotesActual=3] - numerator of the tuplet
 * @param {number} [numberNotesNormal=2] - denominator of the tuplet
 * @param {(music21.duration.Duration|number)} [durationActual] - duration or
 *     quarterLength of duration type, default music21.duration.Duration(0.5)
 * @param {(music21.duration.Duration|number)} [durationNormal] - unused;
 *     see music21p for description
 */

class Tuplet extends _prebase__WEBPACK_IMPORTED_MODULE_5__["ProtoM21Object"] {
  constructor() {
    var numberNotesActual = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
    var numberNotesNormal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var durationActual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var durationNormal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    super();
    this.frozen = false;
    this.bracket = true;
    this.placement = 'above';
    this.numberNotesActual = numberNotesActual;
    this.numberNotesNormal = numberNotesNormal;
    this.durationActual = durationActual || new Duration(0.5);

    if (typeof this.durationActual === 'number') {
      this.durationActual = new Duration(this.durationActual);
    }

    this.durationNormal = durationNormal || this.durationActual;
    this.frozen = false;
    this.type = undefined;
    /**
     * Show a bracket above the tuplet
     */

    this.bracket = true;
    /**
     * Bracket placement. Options are `above` or `below`.
     */

    this.placement = 'above';
    /**
     * What to show above the Tuplet. Options are `number`, `type`, or (string) `none`.
     *
     * @property {string} tupletActualShow
     * @default 'number'
     */

    this.tupletActualShow = 'number';
    this.tupletNormalShow = undefined; // undefined, 'ratio' for ratios, 'type' for ratioed notes (does not work)
  }

  static get className() {
    return 'music21.duration.Tuplet';
  }
  /**
   * A nice name for the tuplet.
   *
   * @type {string}
   * @readonly
   */


  get fullName() {
    // actual is what is presented to viewer
    var numActual = this.numberNotesActual;
    var numNormal = this.numberNotesNormal;

    if (numActual === 3 && numNormal === 2) {
      return 'Triplet';
    } else if (numActual === 5 && (numNormal === 4 || numNormal === 2)) {
      return 'Quintuplet';
    } else if (numActual === 6 && numNormal === 4) {
      return 'Sextuplet';
    }

    var ordStr = _common__WEBPACK_IMPORTED_MODULE_3__["ordinalAbbreviation"](numNormal, true); // plural

    return 'Tuplet of ' + numActual.toString() + '/' + numNormal.toString() + ordStr;
  }
  /**
   * Set both durationActual and durationNormal for the tuplet.
   *
   * @param {string} type - a duration type, such as `half`, `quarter`
   * @returns {music21.duration.Duration} A converted {@link music21.duration.Duration} matching `type`
   */


  setDurationType(type) {
    if (this.frozen === true) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_2__["Music21Exception"]('A frozen tuplet (or one attached to a duration) is immutable');
    }

    this.durationActual = new Duration(type);
    this.durationNormal = this.durationActual;
    return this.durationActual;
  }
  /**
   * Sets the tuplet ratio.
   *
   * @param {Number} actual - number of notes in actual (e.g., 3)
   * @param {Number} normal - number of notes in normal (e.g., 2)
   * @returns {undefined}
   */


  setRatio(actual, normal) {
    if (this.frozen === true) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_2__["Music21Exception"]('A frozen tuplet (or one attached to a duration) is immutable');
    }

    this.numberNotesActual = actual || 3;
    this.numberNotesNormal = normal || 2;
  }
  /**
   * Get the quarterLength corresponding to the total length that
   * the completed tuplet (i.e., 3 notes in a triplet) would occupy.
   *
   * @returns {Number} A quarter length.
   */


  totalTupletLength() {
    return this.numberNotesNormal * this.durationNormal.quarterLength;
  }
  /**
   * The amount by which each quarter length is multiplied to get
   * the tuplet. For instance, in a normal triplet, this is 0.666
   *
   * @returns {Number} A float of the multiplier
   */


  tupletMultiplier() {
    var lengthActual = this.durationActual.quarterLength;
    return this.totalTupletLength() / (this.numberNotesActual * lengthActual);
  }

}

/***/ }),

/***/ "./src/music21/dynamics.ts":
/*!*********************************!*\
  !*** ./src/music21/dynamics.ts ***!
  \*********************************/
/*! exports provided: shortNames, longNames, englishNames, dynamicStrToScalar, Dynamic */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shortNames", function() { return shortNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "longNames", function() { return longNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "englishNames", function() { return englishNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dynamicStrToScalar", function() { return dynamicStrToScalar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dynamic", function() { return Dynamic; });
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");
/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/dynamics -- Dynamics
 *
 * note that Vex.Flow does not support Dynamics yet and we do not support MIDI dynamics,
 *  so currently of limited value...
 *
 * Copyright (c) 2013-14, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–14, Michael Scott Cuthbert and cuthbertLab
 * dynamics Module. See {@link music21.dynamics} for namespace
 *
 * Dynamics related objects.
 *
 * Currently do not export to Vexflow.  :-(
 *
 * @exports music21/dynamics
 * @namespace music21.dynamics
 * @memberof music21
 * @requires music21/base
 */
 // noinspection SpellCheckingInspection

var shortNames = ['pppppp', 'ppppp', 'pppp', 'ppp', 'pp', 'p', 'mp', 'mf', 'f', 'fp', 'sf', 'ff', 'fff', 'ffff', 'fffff', 'ffffff']; // noinspection SpellCheckingInspection

var longNames = {
  ppp: ['pianississimo'],
  pp: ['pianissimo'],
  p: ['piano'],
  mp: ['mezzopiano'],
  mf: ['mezzoforte'],
  f: ['forte'],
  fp: ['fortepiano'],
  sf: ['sforzando'],
  ff: ['fortissimo'],
  fff: ['fortississimo']
};
var englishNames = {
  ppp: ['extremely soft'],
  pp: ['very soft'],
  p: ['soft'],
  mp: ['moderately soft'],
  mf: ['moderately loud'],
  f: ['loud'],
  ff: ['very loud'],
  fff: ['extremely loud']
};
var dynamicStrToScalar = {
  None: [0.5],
  n: [0.0],
  pppp: [0.1],
  ppp: [0.15],
  pp: [0.25],
  p: [0.35],
  mp: [0.45],
  mf: [0.55],
  f: [0.7],
  fp: [0.75],
  sf: [0.85],
  ff: [0.85],
  fff: [0.9],
  ffff: [0.95]
};
/**
 * A representation of a dynamic.
 *
 * @class Dynamic
 * @memberof music21.dynamics
 * @extends music21.base.Music21Object
 * @param {number|string} value - either a number between 0 and 1 or a dynamic mark such as "ff" or "mp"
 * @property {string|undefined} value - a name such as "pp" etc.
 * @property {string|undefined} longName - a longer name such as "pianissimo"
 * @property {string|undefined} englishName - a name such as "very soft"
 * @property {number} volumeScalar - a number between 0 and 1.
 */

class Dynamic extends _base__WEBPACK_IMPORTED_MODULE_0__["Music21Object"] {
  constructor(value) {
    super();
    this.value = value;
  }

  static get className() {
    return 'music21.dynamics.Dynamic';
  }

  get value() {
    return this._value;
  }

  set value(value) {
    if (typeof value !== 'string') {
      // assume number
      this._volumeScalar = value;

      if (value <= 0) {
        this._value = 'n';
      } else if (value < 0.11) {
        this._value = 'pppp';
      } else if (value < 0.16) {
        this._value = 'ppp';
      } else if (value < 0.26) {
        this._value = 'pp';
      } else if (value < 0.36) {
        this._value = 'p';
      } else if (value < 0.5) {
        this._value = 'mp';
      } else if (value < 0.65) {
        this._value = 'mf';
      } else if (value < 0.8) {
        this._value = 'f';
      } else if (value < 0.9) {
        this._value = 'ff';
      } else {
        this._value = 'fff';
      }
    } else {
      this._value = value;
      this._volumeScalar = undefined;
    }

    if (this._value in longNames) {
      this.longName = longNames[this._value][0];
    } else {
      this.longName = '';
    }

    if (this._value in englishNames) {
      this.englishName = englishNames[this._value][0];
    } else {
      this.englishName = '';
    }
  }

  get volumeScalar() {
    if (this._volumeScalar !== undefined) {
      return this._volumeScalar;
    } else if (this._value in dynamicStrToScalar) {
      return dynamicStrToScalar[this._value][0];
    } else {
      return 0.5;
    }
  }

  set volumeScalar(value) {
    if (typeof value === 'number' && value <= 1 && value >= 0) {
      this._volumeScalar = value;
    }
  }

}

/***/ }),

/***/ "./src/music21/editorial.ts":
/*!**********************************!*\
  !*** ./src/music21/editorial.ts ***!
  \**********************************/
/*! exports provided: Editorial, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Editorial", function() { return Editorial; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _prebase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./prebase */ "./src/music21/prebase.ts");



/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/editorial -- Representations of editorial information
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–16, Michael Scott Cuthbert and cuthbertLab
 */

class Editorial extends _prebase__WEBPACK_IMPORTED_MODULE_2__["ProtoM21Object"] {
  constructor() {
    super(...arguments);
    this.comments = []; // noinspection JSUnusedGlobalSymbols

    this.footnotes = []; // these are already deprecated.
    // noinspection JSUnusedGlobalSymbols

    this.ficta = undefined; // noinspection JSUnusedGlobalSymbols

    this.harmonicInterval = undefined; // noinspection JSUnusedGlobalSymbols

    this.melodicInterval = undefined; // noinspection JSUnusedGlobalSymbols

    this.misc = {};
  }

  static get className() {
    return 'music21.editorial.Editorial';
  }

}
/* harmony default export */ __webpack_exports__["default"] = (Editorial);

/***/ }),

/***/ "./src/music21/exceptions21.ts":
/*!*************************************!*\
  !*** ./src/music21/exceptions21.ts ***!
  \*************************************/
/*! exports provided: Music21Exception, StreamException */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Music21Exception", function() { return Music21Exception; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StreamException", function() { return StreamException; });
// this is not completely working properly...
class ExtendableError extends Error {
  constructor(message) {
    super(); // restore prototype chain

    var actualProto = new.target.prototype;
    Object.setPrototypeOf(this, actualProto);
    this.name = this.constructor.name;
    this.message = message;
    this.stack = new Error(message).stack; // until this lands in Node
    // if (typeof Error.captureStackTrace === 'function') {
    //     Error.captureStackTrace(this, this.constructor);
    // } else {
    //     this.stack = new Error(message).stack;
    // }
  }

}

class Music21Exception extends ExtendableError {}
class StreamException extends Music21Exception {}

/***/ }),

/***/ "./src/music21/expressions.ts":
/*!************************************!*\
  !*** ./src/music21/expressions.ts ***!
  \************************************/
/*! exports provided: Expression, Fermata */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Expression", function() { return Expression; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fermata", function() { return Fermata; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vexflow */ "./node_modules/vexflow/releases/vexflow-debug.js");
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vexflow__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");



/**
 * Expressions module.  See {@link music21.expressions}
 * Expressions can be note attached (`music21.note.Note.expressions[]`) or floating...
 *
 * @exports music21/expressions
 * @namespace music21.expressions
 * @memberof music21
 * @requires music21/expressions
 */


/**
 * Expressions can be note attached (`music21.note.Note.expressions[]`) or floating...
 *
 * @class Expression
 * @memberof music21.expressions
 * @extends music21.base.Music21Object
 * @property {string} name
 * @property {string} vexflowModifier
 * @property {number} setPosition
 */

class Expression extends _base__WEBPACK_IMPORTED_MODULE_3__["Music21Object"] {
  constructor() {
    super(...arguments);
    this.name = 'expression';
    this.vexflowModifier = '';
    this.setPosition = undefined;
  }

  static get className() {
    return 'music21.expressions.Expression';
  }
  /**
   * Renders this Expression as a Vex.Flow.Articulation
   *
   * (this is not right for all cases)
   *
   * @returns {Vex.Flow.Articulation}
   */


  vexflow() {
    var vfe = new vexflow__WEBPACK_IMPORTED_MODULE_2___default.a.Flow.Articulation(this.vexflowModifier);

    if (this.setPosition) {
      vfe.setPosition(this.setPosition);
    }

    return vfe;
  }

}
/**
 * A fermata...
 *
 * @class Fermata
 * @memberof music21.expressions
 * @extends music21.expressions.Expression
 */

class Fermata extends Expression {
  static get className() {
    return 'music21.expressions.Fermata';
  }

  constructor() {
    super();
    this.name = 'fermata';
    this.vexflowModifier = 'a@a';
    this.setPosition = 3;
  }

}

/***/ }),

/***/ "./src/music21/figuredBass.ts":
/*!************************************!*\
  !*** ./src/music21/figuredBass.ts ***!
  \************************************/
/*! exports provided: Notation, Figure, Modifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Notation", function() { return Notation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Figure", function() { return Figure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Modifier", function() { return Modifier; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.match */ "./node_modules/core-js/modules/es.string.match.js");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./pitch */ "./src/music21/pitch.ts");











/**
 * @namespace music21.figuredBass
 * @exports music21/figuredBass
 */

var shorthandNotation = {
  '': [5, 3],
  '5': [5, 3],
  '6': [6, 3],
  '7': [7, 5, 3],
  '9': [9, 7, 5, 3],
  '11': [11, 9, 7, 5, 3],
  '13': [13, 11, 9, 7, 5, 3],
  '6,5': [6, 5, 3],
  '4,3': [6, 4, 3],
  '4,2': [6, 4, 2],
  '2': [6, 4, 2]
};
/**
 * In music21p is in figuredBass.notation -- eventually to be moved there.
 */

/**
 * @memberof music21.figuredBass
 */

class Notation {
  /**
   *
   * @param {string} [notationColumn='']
   * @property {string[]} figureStrings
   * @property {int[]} origNumbers
   * @property {int[]} numbers
   * @property {string[]} modifierStrings
   * @property {Modifier[]} modifiers
   * @property {Figure[]} figures
   */
  constructor() {
    var notationColumn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    this.figureStrings = undefined;
    this.origNumbers = undefined;
    this.origModStrings = undefined;
    this.numbers = undefined;
    this.modifierStrings = undefined;
    this.notationColumn = notationColumn;

    this._parseNotationColumn();

    this._translateToLonghand();

    this.modifiers = [];
    this.figures = [];

    this._getModifiers();

    this._getFigures();
  }
  /**
   * _parseNotationColumn - Given a notation column below a pitch, defines both this.numbers
   *    and this.modifierStrings, which provide the intervals above the
   *    bass and (if necessary) how to modify the corresponding pitches
   *    accordingly.
   *
   * @return {undefined}
   */


  _parseNotationColumn() {
    var nc = this.notationColumn;
    var figures = nc.split(/,/);
    var numbers = [];
    var modifierStrings = [];
    var figureStrings = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = figures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var figure = _step.value;
        figure = figure.trim();
        figureStrings.push(figure);
        var numberString = '';
        var modifierString = '';
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = figure[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var c = _step2.value;

            if (c.match(/\d/)) {
              numberString += c;
            } else {
              modifierString += c;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var number = void 0;

        if (numberString !== '') {
          number = parseInt(numberString);
        }

        numbers.push(number);

        if (modifierString === '') {
          modifierString = undefined;
        }

        modifierStrings.push(modifierString);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this.origNumbers = numbers;
    this.numbers = numbers;
    this.modifierStrings = modifierStrings;
    this.figureStrings = figureStrings;
  }

  _translateToLonghand() {
    var oldNumbers = this.numbers;
    var newNumbers = oldNumbers;
    var oldModifierStrings = this.modifierStrings;
    var newModifierStrings = oldModifierStrings;
    var oldNumbersString = oldNumbers.toString();

    if (shorthandNotation[oldNumbersString] !== undefined) {
      newNumbers = shorthandNotation[oldNumbersString];
      newModifierStrings = [];
      var temp = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = oldNumbers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var number = _step3.value;

          if (number === undefined) {
            temp.push(3);
          } else {
            temp.push(number);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      oldNumbers = temp;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = newNumbers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _number = _step4.value;
          var newModifierString = void 0;

          if (oldNumbers.includes(_number)) {
            var modifierStringIndex = oldNumbers.indexOf(_number);
            newModifierString = oldModifierStrings[modifierStringIndex];
          }

          newModifierStrings.push(newModifierString);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    } else {
      var _temp = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = oldNumbers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _number2 = _step5.value;

          if (_number2 === undefined) {
            _temp.push(3);
          } else {
            _temp.push(_number2);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      newNumbers = _temp;
    }

    this.numbers = newNumbers;
    this.modifierStrings = newModifierStrings;
  }

  _getModifiers() {
    var modifiers = [];

    for (var i = 0; i < this.numbers.length; i++) {
      var modifierString = this.modifierStrings[i];
      var modifier = new Modifier(modifierString);
      modifiers.push(modifier);
    }

    this.modifiers = modifiers;
  }

  _getFigures() {
    var figures = [];

    for (var i = 0; i < this.numbers.length; i++) {
      var number = this.numbers[i];
      var modifierString = this.modifierStrings[i];
      var figure = new Figure(number, modifierString);
      figures.push(figure);
    }

    this.figures = figures;
  }

}
/**
 * @memberOf music21.figuredBass
 */

class Figure {
  constructor(number, modifierString) {
    this.number = number;
    this.modifierString = modifierString;
    this.modifier = new Modifier(modifierString);
  }

}
var specialModifiers = {
  '+': '#',
  '/': '-',
  '\\': '#',
  b: '-',
  bb: '--',
  bbb: '---',
  bbbb: '-----',
  '++': '##',
  '+++': '###',
  '++++': '####'
};
/**
 * @memberOf music21.figuredBass
 */

class Modifier {
  constructor(modifierString) {
    this.modifierString = modifierString;
    this.accidental = this._toAccidental();
  }

  _toAccidental() {
    var modStr = this.modifierString;

    if (modStr === undefined || modStr === '') {
      return undefined;
    }

    if (specialModifiers[modStr] !== undefined) {
      modStr = specialModifiers[modStr];
    }

    var a = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Accidental"](modStr);
    return a;
  }

  modifyPitchName(pitchNameToAlter) {
    var pitchToAlter = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"](pitchNameToAlter);
    this.modifyPitch(pitchToAlter, true);
    return pitchToAlter.name;
  }

  modifyPitch(pitchToAlter, inPlace) {
    if (inPlace !== true) {
      pitchToAlter = pitchToAlter.clone();
    }

    if (this.accidental === undefined) {
      return pitchToAlter;
    }

    if (this.accidental.alter === 0.0 || pitchToAlter.accidental === undefined) {
      pitchToAlter.accidental = this.accidental.clone();
    } else {
      var newAlter = pitchToAlter.accidental.alter + this.accidental.alter;
      var newAccidental = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Accidental"](newAlter);
      pitchToAlter.accidental = newAccidental;
    }

    return pitchToAlter;
  }

}

/***/ }),

/***/ "./src/music21/fromPython.ts":
/*!***********************************!*\
  !*** ./src/music21/fromPython.ts ***!
  \***********************************/
/*! exports provided: Converter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Converter", function() { return Converter; });
/* harmony import */ var jsonpickle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jsonpickle */ "./node_modules/jsonpickle/build/jsonpickle.min.js");
/* harmony import */ var jsonpickle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsonpickle__WEBPACK_IMPORTED_MODULE_0__);
/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/fromPython -- Conversion from music21p jsonpickle streams
 *
 * Copyright (c) 2013-16, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–16, Michael Scott Cuthbert and cuthbertLab
 *
 * fromPython module -- see {@link music21.fromPython}
 *
 * Converter for taking a Python-encoded jsonpickle music21p stream
 * and loading it into music21j
 *
 * Very very alpha.  See music21(p).vexflow modules to see how it works.
 *
 * Requires Cuthbert's jsonpickle.js port.
 *
 * @namespace music21.fromPython
 * @extends music21
 * @requires jsonpickle
 * @example
 * in python:
 *
 * s = corpus.parse('bwv66.6')
 * stringRepresentingM21JsonPickle = s.freezeStream('jsonpickle')
 *
 * in js:
 *
 * pyConv = new music21.fromPython.Converter();
 * s = pyConv.run(stringRepresentingM21JsonPickle);
 *
 */

var jp = jsonpickle__WEBPACK_IMPORTED_MODULE_0__;
var unpickler = jp.unpickler;
/**
 *
 * @class Converter
 * @memberof music21.fromPython
 * @property {boolean} debug
 * @property {Array<string>} knownUnparsables - list of classes that cannot be parsed
 * @property {Object} handlers - object mapping string names of classes to a set of
 * function calls to perform when restoring or post-restoring.
 * (too complicated to explain; read the code)
 */

class Converter {
  constructor() {
    this.debug = true;
    this.knownUnparsables = ['music21.spanner.Line', 'music21.instrument.Instrument', 'music21.layout.StaffGroup', 'music21.layout.StaffLayout', 'music21.layout.SystemLayout', 'music21.layout.PageLayout', 'music21.expressions.TextExpression', 'music21.bar.Barline', 'music21.tempo.MetronomeMark', 'music21.metadata.Metadata'];
    this.currentPart = undefined;
    this.lastClef = undefined;
    this.lastKeySignature = undefined;
    this.lastTimeSignature = undefined;
    this.handlers = {
      'music21.duration.Duration': {
        post_restore: d => {
          d.quarterLength = d._qtrLength;
          return d;
        }
      },
      'music21.meter.TimeSignature': {
        post_restore: ts => {
          ts._numerator = ts.displaySequence._numerator;
          ts._denominator = ts.displaySequence._denominator;
          return ts;
        }
      },
      'music21.stream.Part': {
        post_restore: p => {
          this.currentPart = p;
          this.lastClef = undefined;
          this.lastKeySignature = undefined;
          this.lastTimeSignature = undefined;
          this.streamPostRestore(p);
          return p;
        }
      },
      // TODO: all inherit somehow, through _classes or better, prototype...
      'music21.stream.Score': {
        post_restore: this.streamPostRestore.bind(this)
      },
      'music21.stream.Stream': {
        post_restore: this.streamPostRestore.bind(this)
      },
      'music21.stream.Measure': {
        post_restore: this.streamPostRestore.bind(this)
      },
      'music21.stream.Voice': {
        post_restore: this.streamPostRestore.bind(this)
      }
    };
  }
  /**
   * Fixes up some references that cannot be unpacked from jsonpickle.
   *
   * @param {music21.stream.Stream} s - stream after unpacking from jsonpickle
   * @returns {music21.stream.Stream}
   */


  streamPostRestore(s) {
    var st = s._storedElementOffsetTuples;
    s._clef = this.lastClef;
    s._keySignature = this.lastKeySignature;
    s._timeSignature = this.lastTimeSignature;

    for (var i = 0; i < st.length; i++) {
      var el = st[i][0];
      el.offset = st[i][1];
      var classList = el.classes;

      if (classList === undefined) {
        console.warn('M21object without classes: ', el);
        console.warn('Javascript classes are: ', el._py_class);
        classList = [];
      }

      var streamPart = this.currentPart;

      if (streamPart === undefined) {
        streamPart = s; // possibly a Stream constructed from .measures()
      }

      var appendEl = true;
      var insertAtStart = false;

      for (var j = 0; j < classList.length; j++) {
        var thisClass = classList[j];

        for (var kn = 0; kn < this.knownUnparsables.length; kn++) {
          var unparsable = this.knownUnparsables[kn];

          if (unparsable.indexOf(thisClass) !== -1) {
            appendEl = false;
          }
        }

        if (thisClass === 'TimeSignature') {
          // console.log("Got timeSignature", streamPart, newM21pObj, storedElement);
          s._timeSignature = el;
          this.lastTimeSignature = el;

          if (streamPart !== undefined && streamPart.timeSignature === undefined) {
            streamPart.timeSignature = el;
          }

          appendEl = false;
        } else if (thisClass === 'Clef') {
          s._clef = el;
          this.lastClef = el;

          if (streamPart !== undefined && streamPart.clef === undefined) {
            streamPart.clef = el;
          }

          appendEl = false;
        } else if (thisClass === 'KeySignature') {
          s._keySignature = el;
          this.lastKeySignature = el;

          if (streamPart !== undefined && streamPart.keySignature === undefined) {
            streamPart.keySignature = el;
          }

          appendEl = false;
        } else if (thisClass === 'Part') {
          appendEl = false;
          insertAtStart = true;
        }
      }

      if (appendEl) {
        s.append(el); // all but clef, ts, ks
      } else if (insertAtStart) {
        s.insert(0, el); // Part
      }
    }

    return s;
  }
  /**
   * Run the main decoder
   *
   * @param {string} jss - stream encoded as JSON
   * @returns {music21.stream.Stream}
   */


  run(jss) {
    var outStruct = unpickler.decode(jss, this.handlers);
    return outStruct.stream;
  }

}

/***/ }),

/***/ "./src/music21/harmony.ts":
/*!********************************!*\
  !*** ./src/music21/harmony.ts ***!
  \********************************/
/*! exports provided: Harmony */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Harmony", function() { return Harmony; });
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _chord__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./chord */ "./src/music21/chord.ts");
/* harmony import */ var _key__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./key */ "./src/music21/key.ts");



class Harmony extends _chord__WEBPACK_IMPORTED_MODULE_1__["Chord"] {
  constructor(figure) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$parseFigure = _ref.parseFigure,
        parseFigure = _ref$parseFigure === void 0 ? true : _ref$parseFigure,
        _ref$updatePitches = _ref.updatePitches,
        updatePitches = _ref$updatePitches === void 0 ? false : _ref$updatePitches;

    super();
    this._writeAsChord = false;
    this.chordStepModifications = [];
    this._degreesList = []; // this._updateBasedOnXMLInput(keywords);

    figure = figure.replace('/o', 'ø');
    this._figure = figure;

    if (parseFigure !== false && this._figure !== undefined) {
      this._parseFigure();
    }

    if (this._overrides.bass === undefined && this._overrides.root !== undefined) {
      this.bass(this._overrides.root);
    }

    if (updatePitches && this._figure !== undefined || this._overrides.root !== undefined || this._overrides.bass !== undefined) {
      this._updatePitches();
    } // this._updateBasedOnXMLInput(keywords);


    if (parseFigure !== false && this._figure !== undefined && this._figure.indexOf('sus') !== -1 && this._figure.indexOf('sus2') === -1) {
      this.root(this.bass());
    }
  }

  static get className() {
    return 'music21.harmony.Harmony';
  }

  _parseFigure() {}

  _updatePitches() {}

  get figure() {
    if (this._figure === undefined) {
      this.findFigure();
    }

    return this._figure;
  }

  set figure(newFigure) {
    this._figure = newFigure;

    if (this._figure !== undefined) {
      this._parseFigure();

      this._updatePitches();
    }
  }

  get key() {
    return this._key;
  }

  set key(keyOrScale) {
    if (typeof keyOrScale === 'string') {
      this._key = new _key__WEBPACK_IMPORTED_MODULE_2__["Key"](keyOrScale);
    } else {
      this._key = keyOrScale;
      this._roman = undefined;
    }
  }

  findFigure() {}

}

/***/ }),

/***/ "./src/music21/instrument.ts":
/*!***********************************!*\
  !*** ./src/music21/instrument.ts ***!
  \***********************************/
/*! exports provided: global_usedChannels, maxMidi, info, Instrument, find */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "global_usedChannels", function() { return global_usedChannels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxMidi", function() { return maxMidi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "info", function() { return info; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Instrument", function() { return Instrument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");




/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/instrument -- instrument objects
 *
 * Copyright (c) 2013-16, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–16, Michael Scott Cuthbert and cuthbertLab
 *
 * Instrument module, see {@link music21.instrument}
 * Looking for the {@link music21.instrument.Instrument} object? :-)
 *
 * @exports music21/instrument
 *
 * @namespace music21.instrument
 * @memberof music21
 * @requires music21/base
 */

var global_usedChannels = []; // differs from m21p -- stored midiProgram numbers

var maxMidi = 16;
/**
 *
 * @type {Array<{fn: string, name: string, midiNumber: number}>}
 */

var info = [{
  fn: 'acoustic_grand_piano',
  name: 'Acoustic Grand Piano',
  midiNumber: 0
}, {
  fn: 'bright_acoustic_piano',
  name: 'Bright Acoustic Piano',
  midiNumber: 1
}, {
  fn: 'electric_grand_piano',
  name: 'Electric Grand Piano',
  midiNumber: 2
}, {
  fn: 'honkytonk_piano',
  name: 'Honky-tonk Piano',
  midiNumber: 3
}, {
  fn: 'electric_piano_1',
  name: 'Electric Piano 1',
  midiNumber: 4
}, {
  fn: 'electric_piano_2',
  name: 'Electric Piano 2',
  midiNumber: 5
}, {
  fn: 'harpsichord',
  name: 'Harpsichord',
  midiNumber: 6
}, {
  fn: 'clavinet',
  name: 'Clavinet',
  midiNumber: 7
}, {
  fn: 'celesta',
  name: 'Celesta',
  midiNumber: 8
}, {
  fn: 'glockenspiel',
  name: 'Glockenspiel',
  midiNumber: 9
}, {
  fn: 'music_box',
  name: 'Music Box',
  midiNumber: 10
}, {
  fn: 'vibraphone',
  name: 'Vibraphone',
  midiNumber: 11
}, {
  fn: 'marimba',
  name: 'Marimba',
  midiNumber: 12
}, {
  fn: 'xylophone',
  name: 'Xylophone',
  midiNumber: 13
}, {
  fn: 'tubular_bells',
  name: 'Tubular Bells',
  midiNumber: 14
}, {
  fn: 'dulcimer',
  name: 'Dulcimer',
  midiNumber: 15
}, {
  fn: 'drawbar_organ',
  name: 'Drawbar Organ',
  midiNumber: 16
}, {
  fn: 'percussive_organ',
  name: 'Percussive Organ',
  midiNumber: 17
}, {
  fn: 'rock_organ',
  name: 'Rock Organ',
  midiNumber: 18
}, {
  fn: 'church_organ',
  name: 'Church Organ',
  midiNumber: 19
}, {
  fn: 'reed_organ',
  name: 'Reed Organ',
  midiNumber: 20
}, {
  fn: 'accordion',
  name: 'Accordion',
  midiNumber: 21
}, {
  fn: 'harmonica',
  name: 'Harmonica',
  midiNumber: 22
}, {
  fn: 'tango_accordion',
  name: 'Tango Accordion',
  midiNumber: 23
}, {
  fn: 'acoustic_guitar_nylon',
  name: 'Acoustic Guitar (nylon)',
  midiNumber: 24
}, {
  fn: 'acoustic_guitar_steel',
  name: 'Acoustic Guitar (steel)',
  midiNumber: 25
}, {
  fn: 'electric_guitar_jazz',
  name: 'Electric Guitar (jazz)',
  midiNumber: 26
}, {
  fn: 'electric_guitar_clean',
  name: 'Electric Guitar (clean)',
  midiNumber: 27
}, {
  fn: 'electric_guitar_muted',
  name: 'Electric Guitar (muted)',
  midiNumber: 28
}, {
  fn: 'overdriven_guitar',
  name: 'Overdriven Guitar',
  midiNumber: 29
}, {
  fn: 'distortion_guitar',
  name: 'Distortion Guitar',
  midiNumber: 30
}, {
  fn: 'guitar_harmonics',
  name: 'Guitar Harmonics',
  midiNumber: 31
}, {
  fn: 'acoustic_bass',
  name: 'Acoustic Bass',
  midiNumber: 32
}, {
  fn: 'electric_bass_finger',
  name: 'Electric Bass (finger)',
  midiNumber: 33
}, {
  fn: 'electric_bass_pick',
  name: 'Electric Bass (pick)',
  midiNumber: 34
}, {
  fn: 'fretless_bass',
  name: 'Fretless Bass',
  midiNumber: 35
}, {
  fn: 'slap_bass_1',
  name: 'Slap Bass 1',
  midiNumber: 36
}, {
  fn: 'slap_bass_2',
  name: 'Slap Bass 2',
  midiNumber: 37
}, {
  fn: 'synth_bass_1',
  name: 'Synth Bass 1',
  midiNumber: 38
}, {
  fn: 'synth_bass_2',
  name: 'Synth Bass 2',
  midiNumber: 39
}, {
  fn: 'violin',
  name: 'Violin',
  midiNumber: 40
}, {
  fn: 'viola',
  name: 'Viola',
  midiNumber: 41
}, {
  fn: 'cello',
  name: 'Cello',
  midiNumber: 42
}, {
  fn: 'contrabass',
  name: 'Contrabass',
  midiNumber: 43
}, {
  fn: 'tremolo_strings',
  name: 'Tremolo Strings',
  midiNumber: 44
}, {
  fn: 'pizzicato_strings',
  name: 'Pizzicato Strings',
  midiNumber: 45
}, {
  fn: 'orchestral_harp',
  name: 'Orchestral Harp',
  midiNumber: 46
}, {
  fn: 'timpani',
  name: 'Timpani',
  midiNumber: 47
}, {
  fn: 'string_ensemble_1',
  name: 'String Ensemble 1',
  midiNumber: 48
}, {
  fn: 'string_ensemble_2',
  name: 'String Ensemble 2',
  midiNumber: 49
}, {
  fn: 'synth_strings_1',
  name: 'Synth Strings 1',
  midiNumber: 50
}, {
  fn: 'synth_strings_2',
  name: 'Synth Strings 2',
  midiNumber: 51
}, {
  fn: 'choir_aahs',
  name: 'Choir Aahs',
  midiNumber: 52
}, {
  fn: 'voice_oohs',
  name: 'Voice Oohs',
  midiNumber: 53
}, {
  fn: 'synth_choir',
  name: 'Synth Choir',
  midiNumber: 54
}, {
  fn: 'orchestra_hit',
  name: 'Orchestra Hit',
  midiNumber: 55
}, {
  fn: 'trumpet',
  name: 'Trumpet',
  midiNumber: 56
}, {
  fn: 'trombone',
  name: 'Trombone',
  midiNumber: 57
}, {
  fn: 'tuba',
  name: 'Tuba',
  midiNumber: 58
}, {
  fn: 'muted_trumpet',
  name: 'Muted Trumpet',
  midiNumber: 59
}, {
  fn: 'french_horn',
  name: 'French Horn',
  midiNumber: 60
}, {
  fn: 'brass_section',
  name: 'Brass Section',
  midiNumber: 61
}, {
  fn: 'synth_brass_1',
  name: 'Synth Brass 1',
  midiNumber: 62
}, {
  fn: 'synth_brass_2',
  name: 'Synth Brass 2',
  midiNumber: 63
}, {
  fn: 'soprano_sax',
  name: 'Soprano Sax',
  midiNumber: 64
}, {
  fn: 'alto_sax',
  name: 'Alto Sax',
  midiNumber: 65
}, {
  fn: 'tenor_sax',
  name: 'Tenor Sax',
  midiNumber: 66
}, {
  fn: 'baritone_sax',
  name: 'Baritone Sax',
  midiNumber: 67
}, {
  fn: 'oboe',
  name: 'Oboe',
  midiNumber: 68
}, {
  fn: 'english_horn',
  name: 'English Horn',
  midiNumber: 69
}, {
  fn: 'bassoon',
  name: 'Bassoon',
  midiNumber: 70
}, {
  fn: 'clarinet',
  name: 'Clarinet',
  midiNumber: 71
}, {
  fn: 'piccolo',
  name: 'Piccolo',
  midiNumber: 72
}, {
  fn: 'flute',
  name: 'Flute',
  midiNumber: 73
}, {
  fn: 'recorder',
  name: 'Recorder',
  midiNumber: 74
}, {
  fn: 'pan_flute',
  name: 'Pan Flute',
  midiNumber: 75
}, {
  fn: 'blown_bottle',
  name: 'Blown bottle',
  midiNumber: 76
}, {
  fn: 'shakuhachi',
  name: 'Shakuhachi',
  midiNumber: 77
}, {
  fn: 'whistle',
  name: 'Whistle',
  midiNumber: 78
}, {
  fn: 'ocarina',
  name: 'Ocarina',
  midiNumber: 79
}, {
  fn: 'lead_1_square',
  name: 'Lead 1 (square)',
  midiNumber: 80
}, {
  fn: 'lead_2_sawtooth',
  name: 'Lead 2 (sawtooth)',
  midiNumber: 81
}, {
  fn: 'lead_3_calliope',
  name: 'Lead 3 (calliope)',
  midiNumber: 82
}, {
  fn: 'lead_4_chiff',
  name: 'Lead 4 chiff',
  midiNumber: 83
}, {
  fn: 'lead_5_charang',
  name: 'Lead 5 (charang)',
  midiNumber: 84
}, {
  fn: 'lead_6_voice',
  name: 'Lead 6 (voice)',
  midiNumber: 85
}, {
  fn: 'lead_7_fifths',
  name: 'Lead 7 (fifths)',
  midiNumber: 86
}, {
  fn: 'lead_8_bass__lead',
  name: 'Lead 8 (bass + lead)',
  midiNumber: 87
}, {
  fn: 'pad_1_new_age',
  name: 'Pad 1 (new age)',
  midiNumber: 88
}, {
  fn: 'pad_2_warm',
  name: 'Pad 2 (warm)',
  midiNumber: 89
}, {
  fn: 'pad_3_polysynth',
  name: 'Pad 3 (polysynth)',
  midiNumber: 90
}, {
  fn: 'pad_4_choir',
  name: 'Pad 4 (choir)',
  midiNumber: 91
}, {
  fn: 'pad_5_bowed',
  name: 'Pad 5 (bowed)',
  midiNumber: 92
}, {
  fn: 'pad_6_metallic',
  name: 'Pad 6 (metallic)',
  midiNumber: 93
}, {
  fn: 'pad_7_halo',
  name: 'Pad 7 (halo)',
  midiNumber: 94
}, {
  fn: 'pad_8_sweep',
  name: 'Pad 8 (sweep)',
  midiNumber: 95
}, {
  fn: 'fx_1_rain',
  name: 'FX 1 (rain)',
  midiNumber: 96
}, {
  fn: 'fx_2_soundtrack',
  name: 'FX 2 (soundtrack)',
  midiNumber: 97
}, {
  fn: 'fx_3_crystal',
  name: 'FX 3 (crystal)',
  midiNumber: 98
}, {
  fn: 'fx_4_atmosphere',
  name: 'FX 4 (atmosphere)',
  midiNumber: 99
}, {
  fn: 'fx_5_brightness',
  name: 'FX 5 (brightness)',
  midiNumber: 100
}, {
  fn: 'fx_6_goblins',
  name: 'FX 6 (goblins)',
  midiNumber: 101
}, {
  fn: 'fx_7_echoes',
  name: 'FX 7 (echoes)',
  midiNumber: 102
}, {
  fn: 'fx_8_scifi',
  name: 'FX 8 (sci-fi)',
  midiNumber: 103
}, {
  fn: 'sitar',
  name: 'Sitar',
  midiNumber: 104
}, {
  fn: 'banjo',
  name: 'Banjo',
  midiNumber: 105
}, {
  fn: 'shamisen',
  name: 'Shamisen',
  midiNumber: 106
}, {
  fn: 'koto',
  name: 'Koto',
  midiNumber: 107
}, {
  fn: 'kalimba',
  name: 'Kalimba',
  midiNumber: 108
}, {
  fn: 'bagpipe',
  name: 'Bagpipe',
  midiNumber: 109
}, {
  fn: 'fiddle',
  name: 'Fiddle',
  midiNumber: 110
}, {
  fn: 'shanai',
  name: 'Shanai',
  midiNumber: 111
}, {
  fn: 'tinkle_bell',
  name: 'Tinkle Bell',
  midiNumber: 112
}, {
  fn: 'agogo',
  name: 'Agogo',
  midiNumber: 113
}, {
  fn: 'steel_drums',
  name: 'Steel Drums',
  midiNumber: 114
}, {
  fn: 'woodblock',
  name: 'Woodblock',
  midiNumber: 115
}, {
  fn: 'taiko_drum',
  name: 'Taiko Drum',
  midiNumber: 116
}, {
  fn: 'melodic_tom',
  name: 'Melodic Tom',
  midiNumber: 117
}, {
  fn: 'synth_drum',
  name: 'Synth Drum',
  midiNumber: 118
}, {
  fn: 'reverse_cymbal',
  name: 'Reverse Cymbal',
  midiNumber: 119
}, {
  fn: 'guitar_fret_noise',
  name: 'Guitar Fret Noise',
  midiNumber: 120
}, {
  fn: 'breath_noise',
  name: 'Breath Noise',
  midiNumber: 121
}, {
  fn: 'seashore',
  name: 'Seashore',
  midiNumber: 122
}, {
  fn: 'bird_tweet',
  name: 'Bird Tweet',
  midiNumber: 123
}, {
  fn: 'telephone_ring',
  name: 'Telephone Ring',
  midiNumber: 124
}, {
  fn: 'helicopter',
  name: 'Helicopter',
  midiNumber: 125
}, {
  fn: 'applause',
  name: 'Applause',
  midiNumber: 126
}, {
  fn: 'gunshot',
  name: 'Gunshot',
  midiNumber: 127
}];
/**
 * Represents an instrument.  instrumentNames are found in the ext/soundfonts directory
 *
 * See {@link music21.miditools} and esp. `loadSoundfont` for a way of loading soundfonts into
 * instruments.
 *
 * @class Instrument
 * @memberof music21.instrument
 * @param {string} instrumentName
 * @property {string|undefined} partId
 * @property {string|undefined} partName
 * @property {string|undefined} partAbbreviation
 * @property {string|undefined} instrumentId
 * @property {string|undefined} instrumentName
 * @property {string|undefined} instrumentAbbreviation
 * @property {int|undefined} midiProgram
 * @property {int|undefined} midiChannel
 * @property {int|undefined} lowestNote
 * @property {int|undefined} highestNote
 * @property {music21.interval.Interval|undefined} transposition
 * @property {Boolean} inGMPercMap=false
 * @property {string|undefined} soundfontFn
 * @property {string|undefined} oggSoundfont - url of oggSoundfont for this instrument
 * @property {string|undefined} mp3Soundfont - url of mp3Soundfont for this instrument
 */

class Instrument extends _base__WEBPACK_IMPORTED_MODULE_3__["Music21Object"] {
  constructor() {
    var instrumentName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    super();
    this.partId = undefined;
    this.partName = undefined;
    this.partAbbreviation = undefined;
    this.instrumentId = undefined;
    this.instrumentName = '';
    this.instrumentAbbreviation = undefined;
    this.midiProgram = undefined;
    this._midiChannel = undefined;
    this.lowestNote = undefined;
    this.highestNote = undefined;
    this.transpostion = undefined;
    this.inGMPercMap = false;
    this.soundfontFn = undefined;
    this.classSortOrder = -25;
    this.instrumentName = instrumentName;

    if (instrumentName !== '') {
      find(instrumentName, this);
    }
  }

  static get className() {
    return 'music21.instrument.Instrument';
  }
  /**
   * Assign an instrument to an unused midi channel.
   *
   * Will use the global list of used channels (`music21.instrument.Instrument.usedChannels`)
   * if not given.  Assigns up to `music21.instrument.maxMidi` channels (16)
   * Skips 10 unless this.inGMPercMap is true
   *
   * @param {int[]} [usedChannels]
   * @returns {number|undefined}
   */


  autoAssignMidiChannel() {
    var usedChannels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    if (usedChannels === undefined) {
      usedChannels = global_usedChannels;
    }

    var startChannel = 0;

    if (this.inGMPercMap) {
      startChannel = 10;
    }

    for (var ch = startChannel; ch < maxMidi; ch++) {
      if (ch % 16 === 10 && this.inGMPercMap !== true) {
        continue; // skip 10 / percussion.
      }

      if (usedChannels[ch] === undefined || usedChannels[ch] === this.midiProgram) {
        usedChannels[ch] = this.midiProgram;
        this.midiChannel = ch;
        return ch;
      }
    } // TODO: no channels! throw exception!


    return undefined;
  }

  get oggSoundfont() {
    return this.soundfontFn + '-ogg.js';
  }

  get mp3Soundfont() {
    return this.soundfontFn + '-mp3.js';
  }

  get midiChannel() {
    if (this._midiChannel === undefined) {
      this.autoAssignMidiChannel();
    }

    return this._midiChannel;
  }

  set midiChannel(ch) {
    this._midiChannel = ch;
  }

}
/**
 * Find information for a given instrument (by filename or name)
 * and load it into an instrument object.
 *
 * @function music21.instrument.find
 * @memberof music21.instrument
 * @param {string} fn - name or filename of instrument
 * @param {music21.instrument.Instrument} [inst] - instrument object to load into
 * @returns {music21.instrument.Instrument|undefined}
 */

function find(fn) {
  var inst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (inst === undefined) {
    inst = new Instrument();
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = info[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var innerInfo = _step.value;

      if (innerInfo.fn === fn || innerInfo.name === fn) {
        inst.soundfontFn = innerInfo.fn;
        inst.instrumentName = innerInfo.name;
        inst.midiProgram = innerInfo.midiNumber;
        return inst;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return undefined;
}

/***/ }),

/***/ "./src/music21/interval.ts":
/*!*********************************!*\
  !*** ./src/music21/interval.ts ***!
  \*********************************/
/*! exports provided: Direction, IntervalDirectionTerms, MusicOrdinals, GenericInterval, IntervalSpecifiersEnum, IntervalNiceSpecNames, IntervalPrefixSpecs, IntervalOrderedPerfSpecs, IntervalPerfSpecifiers, IntervalPerfOffset, IntervalOrderedImperfSpecs, IntervalSpecifiers, IntervalMajOffset, IntervalSemitonesGeneric, IntervalAdjustPerfect, IntervalAdjustImperf, DiatonicInterval, ChromaticInterval, IntervalStepNames, convertDiatonicNumberToStep, Interval, intervalFromGenericAndChromatic, notesToGeneric, convertStaffDistanceToInterval, notesToChromatic, intervalsToDiatonic, _getSpecifierFromGenericChromatic, add */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Direction", function() { return Direction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalDirectionTerms", function() { return IntervalDirectionTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MusicOrdinals", function() { return MusicOrdinals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GenericInterval", function() { return GenericInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalSpecifiersEnum", function() { return IntervalSpecifiersEnum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalNiceSpecNames", function() { return IntervalNiceSpecNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalPrefixSpecs", function() { return IntervalPrefixSpecs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalOrderedPerfSpecs", function() { return IntervalOrderedPerfSpecs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalPerfSpecifiers", function() { return IntervalPerfSpecifiers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalPerfOffset", function() { return IntervalPerfOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalOrderedImperfSpecs", function() { return IntervalOrderedImperfSpecs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalSpecifiers", function() { return IntervalSpecifiers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalMajOffset", function() { return IntervalMajOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalSemitonesGeneric", function() { return IntervalSemitonesGeneric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalAdjustPerfect", function() { return IntervalAdjustPerfect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalAdjustImperf", function() { return IntervalAdjustImperf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DiatonicInterval", function() { return DiatonicInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChromaticInterval", function() { return ChromaticInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalStepNames", function() { return IntervalStepNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertDiatonicNumberToStep", function() { return convertDiatonicNumberToStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Interval", function() { return Interval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intervalFromGenericAndChromatic", function() { return intervalFromGenericAndChromatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notesToGeneric", function() { return notesToGeneric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertStaffDistanceToInterval", function() { return convertStaffDistanceToInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notesToChromatic", function() { return notesToChromatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intervalsToDiatonic", function() { return intervalsToDiatonic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_getSpecifierFromGenericChromatic", function() { return _getSpecifierFromGenericChromatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "add", function() { return add; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.reverse */ "./node_modules/core-js/modules/es.array.reverse.js");
/* harmony import */ var core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./debug */ "./src/music21/debug.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _note__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./note */ "./src/music21/note.ts");
/* harmony import */ var _prebase__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./prebase */ "./src/music21/prebase.ts");
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./pitch */ "./src/music21/pitch.ts");








function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/interval -- Interval routines
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006-19, Michael Scott Cuthbert and cuthbertLab
 *
 * interval module. See {@link music21.interval} for namespace
 * Interval related objects
 *
 * @exports music21/interval
 *
 * @namespace music21.interval
 * @memberof music21
 * @requires music21/prebase
 * @requires music21/pitch
 */





/**
 * Interval Directions as an Object/map
 *
 * @memberof music21.interval
 * @example
 * if (music21.interval.Direction.OBLIQUE >
 *     music21.interval.Direction.ASCENDING ) {
 *    console.log(music21.interval.Direction.DESCENDING);
 * }
 *
 */

var Direction = {
  DESCENDING: -1,
  OBLIQUE: 0,
  ASCENDING: 1
};
/**
 * N.B. a dict in music21p -- the indexes here let Direction call them + 1
 *
 * @memberof music21.interval
 * @example
 * console.log(music21.interval.IntervalDirectionTerms[music21l.interval.Direction.OBLIQUE + 1])
 * // "Oblique"
 */

var IntervalDirectionTerms = ['Descending', 'Oblique', 'Ascending'];
/**
 * ordinals for music terms...
 *
 * @memberof music21.interval
 * @example
 * for (var i = 1; // N.B. 0 = undefined
 *      i < music21.interval.MusicOrdinals.length;
 *      i++) {
 *     console.log(i, music21.interval.MusicOrdinals[i]);
 * }
 * // 1, Unison
 * // 2, Second
 * // 3, Third
 * // ...
 * // 8, Octave
 * // ...
 * // 15, Double Octave
 */

var MusicOrdinals = [undefined, 'Unison', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Octave', 'Ninth', 'Tenth', 'Eleventh', 'Twelfth', 'Thirteenth', 'Fourteenth', 'Double Octave'];
/**
 * Represents an interval such as unison, second, etc.
 *
 * Properties are demonstrated below.
 *
 * @class GenericInterval
 * @memberof music21.interval
 * @param {number} [gi=1] - generic interval (1 or higher, or -2 or lower)
 * @example
 * var gi = new music21.interval.GenericInterval(-14)
 * gi.value
 * // -14
 * gi.directed
 * // -14
 * gi.undirected
 * // 14
 * gi.direction == music21.interval.Direction.DESCENDING
 * // true
 * gi.isSkip
 * // true
 * gi.isStep
 * // false
 * gi.isDiatonicStep
 * // false  // augmented unisons are not diatonicSteps but can't tell yet..
 * gi.isUnison
 * // false
 * gi.simpledDirected
 * // -7
 * gi.simpleUndirected
 * // 7
 * gi.undirectedOctaves
 * // 1
 * gi.semiSimpleUndirected
 * // 7  -- semiSimple distinguishes between 8 and 1; that's all
 * gi.semiSimpleDirected
 * // 7  -- semiSimple distinguishes between 8 and 1; that's all
 * gi.perfectable
 * // false
 * gi.niceName
 * // "Fourteenth"
 * gi.directedNiceName
 * // "Descending Fourteenth"
 * gi.simpleNiceName
 * // "Seventh"
 * gi.staffDistance
 * // -13
 * gi.mod7inversion
 * // 2  // sevenths invert to seconds
 *
 */

class GenericInterval extends _prebase__WEBPACK_IMPORTED_MODULE_10__["ProtoM21Object"] {
  constructor(gi) {
    super();

    if (gi === undefined) {
      gi = 1;
    }

    this.value = gi; // todo: convertGeneric() from python

    this.directed = this.value;
    this.undirected = Math.abs(this.value);

    if (this.directed === 1) {
      this.direction = Direction.OBLIQUE;
    } else if (this.directed < 0) {
      this.direction = Direction.DESCENDING;
    } else if (this.directed > 1) {
      this.direction = Direction.ASCENDING;
    } // else (raise exception)


    if (this.undirected > 2) {
      this.isSkip = true;
    } else {
      this.isSkip = false;
    }

    if (this.undirected === 2) {
      this.isDiatonicStep = true;
    } else {
      this.isDiatonicStep = false;
    }

    this.isStep = this.isDiatonicStep;

    if (this.undirected === 1) {
      this.isUnison = true;
    } else {
      this.isUnison = false;
    }

    var tempSteps = _common__WEBPACK_IMPORTED_MODULE_8__["posMod"](this.undirected, 7);
    var tempOctaves = Math.floor(this.undirected / 7);

    if (tempSteps === 0) {
      tempOctaves -= 1;
      tempSteps = 7;
    }

    this.simpleUndirected = tempSteps;
    this.undirectedOctaves = tempOctaves;

    if (tempSteps === 1 && tempOctaves >= 1) {
      this.semiSimpleUndirected = 8;
    } else {
      this.semiSimpleUndirected = this.simpleUndirected;
    }

    if (this.direction === Direction.DESCENDING) {
      this.octaves = -1 * tempOctaves;

      if (tempSteps !== 1) {
        this.simpleDirected = -1 * tempSteps;
      } else {
        this.simpleDirected = 1; // no descending unisons...
      }

      this.semiSimpleDirected = -1 * this.semiSimpleUndirected;
    } else {
      this.octaves = tempOctaves;
      this.simpleDirected = tempSteps;
      this.semiSimpleDirected = this.semiSimpleUndirected;
    }

    if (this.simpleUndirected === 1 || this.simpleUndirected === 4 || this.simpleUndirected === 5) {
      this.perfectable = true;
    } else {
      this.perfectable = false;
    }

    if (this.undirected < MusicOrdinals.length) {
      this.niceName = MusicOrdinals[this.undirected];
    } else {
      this.niceName = this.undirected.toString();
    }

    this.simpleNiceName = MusicOrdinals[this.simpleUndirected];
    this.semiSimpleNiceName = MusicOrdinals[this.semiSimpleUndirected];

    if (Math.abs(this.directed) === 1) {
      this.staffDistance = 0;
    } else if (this.directed > 1) {
      this.staffDistance = this.directed - 1;
    } else if (this.directed < -1) {
      this.staffDistance = this.directed + 1;
    } // else: raise IntervalException("Non-integer, -1, or 0 not permitted as a diatonic interval")
    // 2 -> 7; 3 -> 6; 8 -> 1 etc.


    this.mod7inversion = 9 - this.semiSimpleUndirected;

    if (this.direction === Direction.DESCENDING) {
      this.mod7 = this.mod7inversion; // see chord.semitonesFromChordStep for usage...
    } else {
      this.mod7 = this.simpleDirected;
    }
  }

  static get className() {
    return 'music21.interval.GenericInterval';
  }
  /**
   * Returns a new GenericInterval which is the mod7inversion; 3rds (and 10ths etc.) to 6ths, etc.
   *
   * @returns {music21.interval.GenericInterval}
   */


  complement() {
    return new GenericInterval(this.mod7inversion);
  }
  /**
   * Returns a new GenericInterval which has the opposite direction
   * (descending becomes ascending, etc.)
   *
   * @returns {music21.interval.GenericInterval}
   */


  reverse() {
    if (this.undirected === 1) {
      return new GenericInterval(1);
    } else {
      return new GenericInterval(this.undirected * (-1 * this.direction));
    }
  }
  /**
   * Given a specifier, return a new DiatonicInterval with this generic.
   *
   * @param {string|number} specifier - a specifier such as "P", "m", "M", "A", "dd" etc.
   * @returns {music21.interval.DiatonicInterval}
   */


  getDiatonic(specifier) {
    return new DiatonicInterval(specifier, this);
  }
  /**
   * Transpose a pitch by this generic interval, maintaining accidentals
   *
   * @param {music21.pitch.Pitch} p
   * @returns {music21.pitch.Pitch}
   */


  transposePitch(p) {
    var pitch2 = new _pitch__WEBPACK_IMPORTED_MODULE_11__["Pitch"]();
    pitch2.step = p.step;
    pitch2.octave = p.octave;
    var oldDiatonicNum = p.diatonicNoteNum;
    var distanceToMove = this.staffDistance; // if not reverse...

    var newDiatonicNumber = oldDiatonicNum + distanceToMove;

    var _convertDiatonicNumbe = convertDiatonicNumberToStep(newDiatonicNumber),
        _convertDiatonicNumbe2 = _slicedToArray(_convertDiatonicNumbe, 2),
        newStep = _convertDiatonicNumbe2[0],
        newOctave = _convertDiatonicNumbe2[1];

    pitch2.step = newStep;
    pitch2.octave = newOctave;

    if (p.accidental !== undefined) {
      pitch2.accidental = new _pitch__WEBPACK_IMPORTED_MODULE_11__["Accidental"](p.accidental.name);
    }

    return pitch2;
  }

}
var IntervalSpecifiersEnum = {
  PERFECT: 1,
  MAJOR: 2,
  MINOR: 3,
  AUGMENTED: 4,
  DIMINISHED: 5,
  DBLAUG: 6,
  DBLDIM: 7,
  TRPAUG: 8,
  TRPDIM: 9,
  QUADAUG: 10,
  QUADDMIN: 11
};
var IntervalNiceSpecNames = ['ERROR', 'Perfect', 'Major', 'Minor', 'Augmented', 'Diminished', 'Doubly-Augmented', 'Doubly-Diminished', 'Triply-Augmented', 'Triply-Diminished', 'Quadruply-Augmented', 'Quadruply-Diminished'];
var IntervalPrefixSpecs = [undefined, 'P', 'M', 'm', 'A', 'd', 'AA', 'dd', 'AAA', 'ddd', 'AAAA', 'dddd'];
var IntervalOrderedPerfSpecs = ['dddd', 'ddd', 'dd', 'd', 'P', 'A', 'AA', 'AAA', 'AAAA'];
var IntervalPerfSpecifiers = [IntervalSpecifiersEnum.QUADDMIN, IntervalSpecifiersEnum.TRPDIM, IntervalSpecifiersEnum.DBLDIM, IntervalSpecifiersEnum.DIMINISHED, IntervalSpecifiersEnum.PERFECT, IntervalSpecifiersEnum.AUGMENTED, IntervalSpecifiersEnum.DBLAUG, IntervalSpecifiersEnum.TRPAUG, IntervalSpecifiersEnum.QUADAUG];
var IntervalPerfOffset = 4;
var IntervalOrderedImperfSpecs = ['dddd', 'ddd', 'dd', 'd', 'm', 'M', 'A', 'AA', 'AAA', 'AAAA'];
var IntervalSpecifiers = [IntervalSpecifiersEnum.QUADDMIN, IntervalSpecifiersEnum.TRPDIM, IntervalSpecifiersEnum.DBLDIM, IntervalSpecifiersEnum.DIMINISHED, IntervalSpecifiersEnum.MINOR, IntervalSpecifiersEnum.MAJOR, IntervalSpecifiersEnum.AUGMENTED, IntervalSpecifiersEnum.DBLAUG, IntervalSpecifiersEnum.TRPAUG, IntervalSpecifiersEnum.QUADAUG];
var IntervalMajOffset = 5;
var IntervalSemitonesGeneric = {
  1: 0,
  2: 2,
  3: 4,
  4: 5,
  5: 7,
  6: 9,
  7: 11
};
var IntervalAdjustPerfect = {
  P: 0,
  A: 1,
  AA: 2,
  AAA: 3,
  AAAA: 4,
  d: -1,
  dd: -2,
  ddd: -3,
  dddd: -4
}; // offset from Perfect

var IntervalAdjustImperf = {
  M: 0,
  m: -1,
  A: 1,
  AA: 2,
  AAA: 3,
  AAAA: 4,
  d: -2,
  dd: -3,
  ddd: -4,
  dddd: -5
}; // offset from major

/**
 * Represents a Diatonic interval.  See example for usage.
 *
 * @class DiatonicInterval
 * @memberof music21.interval
 * @param {string|number|undefined} [specifier='P'] - a specifier such as "P", "d", "m", "M" etc.
 * @param {music21.interval.GenericInterval|number} [generic=1] - a `GenericInterval`
 *              object or a number to be converted to one
 * @example
 * var di = new music21.interval.DiatonicInterval("M", 10);
 * di.generic.isClassOrSubclass('GenericInterval');
 * // true
 * di.specifierAbbreviation;
 * // 'M'
 * di.name;
 * // 'M10'
 * di.direction == music21.interval.Direction.ASCENDING;
 * // true
 * di.niceName
 * // "Major Tenth"
 *
 * // See music21p for more possibilities.
 */

class DiatonicInterval extends _prebase__WEBPACK_IMPORTED_MODULE_10__["ProtoM21Object"] {
  constructor(specifier, generic) {
    super();

    if (specifier === undefined) {
      specifier = 'P';
    }

    if (generic === undefined) {
      generic = new GenericInterval(1);
    } else if (typeof generic === 'number') {
      generic = new GenericInterval(generic);
    }

    this.name = '';

    if (typeof specifier === 'number') {
      this.specifier = specifier;
    } else {
      this.specifier = IntervalPrefixSpecs.indexOf(specifier); // TODO: convertSpecifier();
    }

    this.generic = generic;

    if (generic.undirected !== 1 || specifier === IntervalSpecifiersEnum.PERFECT) {
      this.direction = generic.direction;
    } else if (IntervalPerfSpecifiers.indexOf(this.specifier) <= IntervalPerfSpecifiers.indexOf(IntervalSpecifiersEnum.DIMINISHED)) {
      // diminished unisons -- very controversial
      this.direction = Direction.DESCENDING;
    } else {
      this.direction = Direction.ASCENDING;
    }

    var diatonicDirectionNiceName = IntervalDirectionTerms[this.direction + 1];
    this.name = IntervalPrefixSpecs[this.specifier] + generic.undirected.toString();
    this.niceName = IntervalNiceSpecNames[this.specifier] + ' ' + generic.niceName;
    this.simpleName = IntervalPrefixSpecs[this.specifier] + generic.simpleUndirected.toString();
    this.simpleNiceName = IntervalNiceSpecNames[this.specifier] + ' ' + generic.simpleNiceName;
    this.semiSimpleName = IntervalPrefixSpecs[this.specifier] + generic.semiSimpleUndirected.toString();
    this.semiSimpleNiceName = IntervalNiceSpecNames[this.specifier] + ' ' + generic.semiSimpleNiceName;
    this.directedName = IntervalPrefixSpecs[this.specifier] + generic.directed.toString();
    this.directedNiceName = diatonicDirectionNiceName + ' ' + this.niceName;
    this.directedSimpleName = IntervalPrefixSpecs[this.specifier] + generic.simpleDirected.toString();
    this.directedSimpleNiceName = diatonicDirectionNiceName + ' ' + this.simpleNiceName;
    this.directedSemiSimpleName = IntervalPrefixSpecs[this.specifier] + generic.semiSimpleDirected.toString();
    this.directedSemiSimpleNiceName = diatonicDirectionNiceName + ' ' + this.semiSimpleNiceName;
    this.specificName = IntervalNiceSpecNames[this.specifier];
    this.perfectable = generic.perfectable;
    this.isDiatonicStep = generic.isDiatonicStep;
    this.isStep = generic.isStep;
    this.isSkip = generic.isSkip; // generate inversions

    if (this.perfectable) {
      this.orderedSpecifierIndex = IntervalOrderedPerfSpecs.indexOf(IntervalPrefixSpecs[this.specifier]);
      this.invertedOrderedSpecIndex = IntervalOrderedPerfSpecs.length - 1 - this.orderedSpecifierIndex;
      this.invertedOrderedSpecifier = IntervalOrderedPerfSpecs[this.invertedOrderedSpecIndex];
    } else {
      this.orderedSpecifierIndex = IntervalOrderedImperfSpecs.indexOf(IntervalPrefixSpecs[this.specifier]);
      this.invertedOrderedSpecIndex = IntervalOrderedImperfSpecs.length - 1 - this.orderedSpecifierIndex;
      this.invertedOrderedSpecifier = IntervalOrderedImperfSpecs[this.invertedOrderedSpecIndex];
    }

    this.mod7inversion = this.invertedOrderedSpecifier + generic.mod7inversion.toString(); // if (this.direction == Direction.DESCENDING) {
    //     this.mod7 = this.mod7inversion;
    // } else {
    //    this.mod7 = this.simpleName;
    // }
    // TODO: reverse()
    // TODO: property cents
  }

  static get className() {
    return 'music21.interval.DiatonicInterval';
  }
  /**
   * Returns a ChromaticInterval object of the same size.
   *
   * @returns {music21.interval.ChromaticInterval}
   */


  getChromatic() {
    var octaveOffset = Math.floor(Math.abs(this.generic.staffDistance) / 7);
    var semitonesStart = IntervalSemitonesGeneric[this.generic.simpleUndirected];
    var specName = IntervalPrefixSpecs[this.specifier];
    var semitonesAdjust;

    if (this.generic.perfectable) {
      semitonesAdjust = IntervalAdjustPerfect[specName];
    } else {
      semitonesAdjust = IntervalAdjustImperf[specName];
    }

    var semitones = octaveOffset * 12 + semitonesStart + semitonesAdjust; // direction should be same as original

    if (this.generic.direction === Direction.DESCENDING) {
      semitones *= -1;
    }

    if (_debug__WEBPACK_IMPORTED_MODULE_7__["debug"]) {
      console.log('DiatonicInterval.getChromatic -- octaveOffset: ' + octaveOffset);
      console.log('DiatonicInterval.getChromatic -- semitonesStart: ' + semitonesStart);
      console.log('DiatonicInterval.getChromatic -- specName: ' + specName);
      console.log('DiatonicInterval.getChromatic -- semitonesAdjust: ' + semitonesAdjust);
      console.log('DiatonicInterval.getChromatic -- semitones: ' + semitones);
    }

    return new ChromaticInterval(semitones);
  }
  /**
   *
   * @param {music21.pitch.Pitch} p
   * @returns {music21.pitch.Pitch}
   */


  transposePitch(p) {
    var fullIntervalObject = new Interval(this, this.getChromatic());
    return fullIntervalObject.transposePitch(p);
  }
  /**
   *
   * @type {string}
   */


  get specifierAbbreviation() {
    return IntervalPrefixSpecs[this.specifier];
  }
  /**
   *
   * @returns {number}
   */


  get cents() {
    return this.getChromatic().cents;
  }

}
/**
 * @class ChromaticInterval
 * @memberof music21.interval
 * @param {number} value - number of semitones (positive or negative)
 * @property {number} cents
 * @property {number} value
 * @property {number} undirected - absolute value of value
 * @property {number} mod12 - reduction to one octave
 * @property {number} intervalClass - reduction to within a tritone (11 = 1, etc.)
 *
 */

class ChromaticInterval extends _prebase__WEBPACK_IMPORTED_MODULE_10__["ProtoM21Object"] {
  constructor() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    super();
    this.semitones = value;
    this.cents = Math.round(value * 100.0);
    this.directed = value;
    this.undirected = Math.abs(value);

    if (this.directed === 0) {
      this.direction = Direction.OBLIQUE;
    } else if (this.directed === this.undirected) {
      this.direction = Direction.ASCENDING;
    } else {
      this.direction = Direction.DESCENDING;
    }

    this.mod12 = _common__WEBPACK_IMPORTED_MODULE_8__["posMod"](this.semitones, 12);
    this.simpleUndirected = _common__WEBPACK_IMPORTED_MODULE_8__["posMod"](this.undirected, 12);

    if (this.direction === Direction.DESCENDING) {
      this.simpleDirected = -1 * this.simpleUndirected;
    } else {
      this.simpleDirected = this.simpleUndirected;
    }

    this.intervalClass = this.mod12;

    if (this.mod12 > 6) {
      this.intervalClass = 12 - this.mod12;
    }

    if (this.undirected === 1) {
      this.isChromaticStep = true;
    } else {
      this.isChromaticStep = false;
    }
  }

  static get className() {
    return 'music21.interval.ChromaticInterval';
  }
  /**
   *
   * @returns {music21.interval.ChromaticInterval}
   */


  reverse() {
    return new ChromaticInterval(this.undirected * (-1 * this.direction));
  } //  TODO: this.getDiatonic()

  /**
   * Transposes pitches but does not maintain accidentals, etc.
   *
   * @property {music21.pitch.Pitch} p - pitch to transpose
   * @returns {music21.pitch.Pitch}
   */


  transposePitch(p) {
    var useImplicitOctave = false;

    if (p.octave === undefined) {
      // not yet implemented in m21j
      useImplicitOctave = true;
    }

    var pps = p.ps;
    var newPitch = new _pitch__WEBPACK_IMPORTED_MODULE_11__["Pitch"]();
    newPitch.ps = pps + this.semitones;

    if (useImplicitOctave) {
      newPitch.octave = undefined;
    }

    return newPitch;
  }

}
var IntervalStepNames = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
/**
 * @function music21.interval.convertDiatonicNumberToStep
 * @memberof music21.interval
 * @param {number} dn - diatonic number, where 29 = C4, C#4 etc.
 * @returns {Array} two element array of {string} stepName and {number} octave
 */

function convertDiatonicNumberToStep(dn) {
  var stepNumber;
  var octave;

  if (dn === 0) {
    return ['B', -1];
  } else if (dn > 0) {
    octave = Math.floor((dn - 1) / 7);
    stepNumber = dn - 1 - octave * 7;
  } else {
    // low notes... test, because js(floor) != py(int);
    octave = Math.floor(dn / 7);
    stepNumber = dn - 1 - (octave + 1) * 7;
  }

  var stepName = IntervalStepNames[stepNumber];
  return [stepName, octave];
}
/**
 * This is the main, powerful Interval class.
 *
 * Instantiate with either a string ("M3") or two {@link music21.pitch.Pitch} or two {@link music21.note.Note}
 *
 * See music21p instructions for usage.
 *
 * @class Interval
 * @memberof music21.interval
 * @example
 * var n1 = new music21.note.Note("C4");
 * var n2 = new music21.note.Note("F#5");
 * var iv = new music21.interval.Interval(n1, n2);
 * iv.isConsonant();
 * // false
 * iv.semitones;
 * // 18
 * iv.niceName
 * // "Augmented Eleventh"
 */

class Interval extends _prebase__WEBPACK_IMPORTED_MODULE_10__["ProtoM21Object"] {
  constructor() {
    super(); // todo: allow full range of ways of specifying as in m21p

    var noteStart;
    var noteEnd;

    for (var _len = arguments.length, restArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      restArgs[_key] = arguments[_key];
    }

    if (restArgs.length === 1) {
      var arg0 = restArgs[0];

      if (typeof arg0 === 'string') {
        // simple...
        var specifier = arg0.replace(/\d+/, '').replace(/-/, '');
        var generic = parseInt(arg0.replace(/\D+/, ''));

        if (arg0.includes('-')) {
          generic *= -1;
        }

        var gI = new GenericInterval(generic);
        var dI = new DiatonicInterval(specifier, gI);
        this.diatonic = dI;
        this.chromatic = this.diatonic.getChromatic();
      } else if (arg0.specifier !== undefined) {
        // assume diatonic...
        this.diatonic = arg0;
        this.chromatic = this.diatonic.getChromatic();
      } else {
        console.error('cant parse string arguments to Interval yet');
      }
    } else if (restArgs.length === 2) {
      if (restArgs[0].pitch === undefined && restArgs[0].diatonicNoteNum === undefined) {
        this.diatonic = restArgs[0];
        this.chromatic = restArgs[1];
      } else {
        var n1 = restArgs[0];
        var n2 = restArgs[1];

        if (n1.classes !== undefined && n1.classes.includes('Pitch')) {
          var p1 = n1;
          n1 = new _note__WEBPACK_IMPORTED_MODULE_9__["Note"]();
          n1.pitch = p1;
        }

        if (n2.classes !== undefined && n2.classes.includes('Pitch')) {
          var p2 = n2;
          n2 = new _note__WEBPACK_IMPORTED_MODULE_9__["Note"]();
          n2.pitch = p2;
        }

        var gInt = notesToGeneric(n1, n2);
        var cInt = notesToChromatic(n1, n2);
        this.diatonic = intervalsToDiatonic(gInt, cInt);
        this.chromatic = cInt;
        noteStart = n1;
        noteEnd = n2;
      }
    }

    this._noteStart = noteStart;
    this._noteEnd = noteEnd;
    this.reinit();
  }

  static get className() {
    return 'music21.interval.Interval';
  }
  /**
   *
   * @returns {music21.interval.Interval}
   */


  get complement() {
    return new Interval(this.diatonic.mod7inversion);
  }

  reinit() {
    this.direction = this.chromatic.direction;
    this.specifier = this.diatonic.specifier;
    this.diatonicType = this.diatonic.specifier; // this.specificName = this.diatonic.specificName;

    this.generic = this.diatonic.generic;
    this.name = this.diatonic.name;
    this.niceName = this.diatonic.niceName;
    this.simpleName = this.diatonic.simpleName;
    this.simpleNiceName = this.diatonic.simpleNiceName;
    this.semiSimpleName = this.diatonic.semiSimpleName;
    this.semiSimpleNiceName = this.diatonic.semiSimpleNiceName;
    this.directedName = this.diatonic.directedName;
    this.directedNiceName = this.diatonic.directedNiceName;
    this.directedSimpleName = this.diatonic.directedSimpleName;
    this.directedSimpleNiceName = this.diatonic.directedSimpleNiceName; // other names...

    this.isDiatonicStep = this.diatonic.isDiatonicStep;
    this.isChromaticStep = this.chromatic.isChromaticStep;
    this.semitones = this.chromatic.semitones;
    this.intervalClass = this.chromatic.intervalClass;
    this.cents = this.chromatic.cents;
    this.isStep = this.isChromaticStep || this.isDiatonicStep;
    this.isSkip = this.diatonic.isSkip;
  }
  /**
   *
   * @type {music21.note.Note|undefined}
   */


  get noteStart() {
    return this._noteStart;
  }

  set noteStart(n) {
    this._noteStart = n;
    var p1 = n.pitch;
    var p2 = this.transposePitch(p1);
    this._noteEnd = n.clone();
    this._noteEnd.pitch = p2;
  }
  /**
   *
   * @type {music21.note.Note|undefined}
   */


  get noteEnd() {
    return this._noteEnd;
  }

  set noteEnd(n) {
    this._noteEnd = n;
    var p1 = n.pitch;
    var p2 = this.transposePitch(p1, {
      reverse: true
    });
    this._noteStart = n.clone();
    this._noteStart.pitch = p2;
  }
  /**
   * @returns {Boolean}
   */


  isConsonant() {
    var sn = this.simpleName;
    var consonantNames = ['P5', 'm3', 'M3', 'm6', 'M6', 'P1'];

    if (consonantNames.indexOf(sn) !== -1) {
      return true;
    } else {
      return false;
    }
  } //  todo general: microtones
  // noinspection JSUnusedLocalSymbols

  /**
   * TODO: maxAccidental
   *
   * @param {music21.pitch.Pitch} p - pitch to transpose
   * @param {Object} config - configuration
   * @param {boolean} [config.reverse=false] -- reverse direction
   * @param {number} [config.maxAccidental=4] -- maximum accidentals to retain (unused)
   * @returns {music21.pitch.Pitch}
   */


  transposePitch(p) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$reverse = _ref.reverse,
        reverse = _ref$reverse === void 0 ? false : _ref$reverse,
        _ref$maxAccidental = _ref.maxAccidental,
        maxAccidental = _ref$maxAccidental === void 0 ? 4 : _ref$maxAccidental;

    /*
    var useImplicitOctave = false;
    if (p.octave === undefined) {
        useImplicitOctave = true;
    }
     */
    var pitch2 = this.diatonic.generic.transposePitch(p);
    pitch2.accidental = undefined; // step and octave are right now, but not necessarily accidental

    var halfStepsToFix;

    if (!reverse) {
      halfStepsToFix = this.chromatic.semitones - Math.floor(pitch2.ps - p.ps);
    } else {
      halfStepsToFix = -1 * this.chromatic.semitones - Math.floor(pitch2.ps - p.ps);
    }

    if (halfStepsToFix !== 0) {
      pitch2.accidental = new _pitch__WEBPACK_IMPORTED_MODULE_11__["Accidental"](halfStepsToFix);
    }

    if (_debug__WEBPACK_IMPORTED_MODULE_7__["debug"]) {
      console.log('Interval.transposePitch -- new step ' + pitch2.step);
      console.log('Interval.transposePitch -- new octave ' + pitch2.octave);
      console.log('Interval.transposePitch -- fixing half steps for ' + halfStepsToFix);
    }

    return pitch2;
  }

}
function intervalFromGenericAndChromatic(gInt, cInt) {
  if (typeof gInt === 'number') {
    gInt = new GenericInterval(gInt);
  }

  if (typeof cInt === 'number') {
    cInt = new ChromaticInterval(cInt);
  }

  var specifier = _getSpecifierFromGenericChromatic(gInt, cInt);

  var dInt = new DiatonicInterval(specifier, gInt);
  return new Interval(dInt, cInt);
}
/**
 * Convert two notes or pitches to a GenericInterval;
 */

function notesToGeneric(n1, n2) {
  var p1 = n1;

  if (n1.pitch !== undefined) {
    p1 = n1.pitch;
  }

  var p2 = n2;

  if (n2.pitch !== undefined) {
    p2 = n2.pitch;
  }

  var staffDist = p2.diatonicNoteNum - p1.diatonicNoteNum;
  var genDist = convertStaffDistanceToInterval(staffDist);
  return new GenericInterval(genDist);
}
function convertStaffDistanceToInterval(staffDist) {
  if (staffDist === 0) {
    return 1;
  } else if (staffDist > 0) {
    return staffDist + 1;
  } else {
    return staffDist - 1;
  }
}
function notesToChromatic(n1, n2) {
  var p1 = n1;

  if (n1.pitch !== undefined) {
    p1 = n1.pitch;
  }

  var p2 = n2;

  if (n2.pitch !== undefined) {
    p2 = n2.pitch;
  }

  return new ChromaticInterval(p2.ps - p1.ps);
}
function intervalsToDiatonic(gInt, cInt) {
  var specifier = _getSpecifierFromGenericChromatic(gInt, cInt); // todo -- convert specifier...


  return new DiatonicInterval(specifier, gInt);
}
function _getSpecifierFromGenericChromatic(gInt, cInt) {
  var noteVals = [undefined, 0, 2, 4, 5, 7, 9, 11];
  var normalSemis = noteVals[gInt.simpleUndirected] + 12 * gInt.undirectedOctaves;
  var theseSemis = 0;

  if (gInt.direction !== cInt.direction && gInt.direction !== Direction.OBLIQUE && cInt.direction !== Direction.OBLIQUE) {
    // intervals like d2 and dd2 etc. (the last test doesn't matter,
    // since -1 * 0 === 0, but in theory it should be there)
    theseSemis = -1 * cInt.undirected;
  } else if (gInt.undirected === 1) {
    theseSemis = cInt.directed; // matters for unison
  } else {
    // all normal intervals
    theseSemis = cInt.undirected;
  }

  var semisRounded = Math.round(theseSemis);
  var specifier;

  if (gInt.perfectable) {
    specifier = IntervalPerfSpecifiers[IntervalPerfOffset + semisRounded - normalSemis];
  } else {
    specifier = IntervalSpecifiers[IntervalMajOffset + semisRounded - normalSemis];
  }

  return specifier;
}
/**
 *
 * @param {music21.interval.Interval[]} intervalList
 * @returns {music21.interval.Interval}
 */

function add(intervalList) {
  var p1 = new _pitch__WEBPACK_IMPORTED_MODULE_11__["Pitch"]('C4');
  var p2 = new _pitch__WEBPACK_IMPORTED_MODULE_11__["Pitch"]('C4');
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = intervalList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var i = _step.value;
      p2 = i.transposePitch(p2);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return new Interval(p1, p2);
}

/***/ }),

/***/ "./src/music21/key.ts":
/*!****************************!*\
  !*** ./src/music21/key.ts ***!
  \****************************/
/*! exports provided: modeSharpsAlter, convertKeyStringToMusic21KeyString, KeySignature, Key */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modeSharpsAlter", function() { return modeSharpsAlter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertKeyStringToMusic21KeyString", function() { return convertKeyStringToMusic21KeyString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeySignature", function() { return KeySignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Key", function() { return Key; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./debug */ "./src/music21/debug.ts");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");
/* harmony import */ var _interval__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./interval */ "./src/music21/interval.ts");
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./pitch */ "./src/music21/pitch.ts");
/* harmony import */ var _scale__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./scale */ "./src/music21/scale.ts");







/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/key -- KeySignature and Key objects
 *
 * Copyright (c) 2013-16, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–16, Michael Scott Cuthbert and cuthbertLab
 *
 * key and key signature module. See {@link music21.key} namespace for details
 * Key and KeySignature related objects and methods
 *
 * @exports music21/key
 *
 * @namespace music21.key
 * @memberof music21
 * @requires music21/base
 * @requires music21/pitch
 * @requires music21/interval
 * @requires music21/scale
 */






var modeSharpsAlter = {
  major: 0,
  minor: -3,
  dorian: -2,
  phrygian: -4,
  lydian: 1,
  mixolydian: -1,
  locrian: -5
};
/**
 *
 * @param {string} textString
 * @returns {string}
 */

function convertKeyStringToMusic21KeyString(textString) {
  if (textString === 'bb') {
    textString = 'b-';
  } else if (textString === 'Bb') {
    textString = 'B-';
  } else if (textString.endsWith('b') && !textString.startsWith('b')) {
    textString = textString.replace(/b$/, '-');
  }

  return textString;
}
/**
 * @class KeySignature
 * @memberof music21.key
 * @description Represents a key signature
 * @param {int} [sharps=0] -- the number of sharps (negative for flats)
 * @property {int} [sharps=0] -- number of sharps (negative for flats)
 * @property {string[]} flatMapping -- flat signatures 0-12 flats
 * @property {string[]} sharpMapping -- sharp signatures 0-12 sharps
 * @extends music21.base.Music21Object
 * @example
 * var ks = new music21.key.KeySignature(-3); //E-flat major or c minor
 * var s = new music21.stream.Stream();
 * s.keySignature = ks;
 * var n = new music21.note.Note('A-'); // A-flat
 * s.append(n);
 * s.appendNewDOM();
 */

class KeySignature extends _base__WEBPACK_IMPORTED_MODULE_8__["Music21Object"] {
  constructor() {
    var sharps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    super();
    this._sharps = 0; // 12 flats/sharps enough for now...

    this.flatMapping = ['C', 'F', 'B-', 'E-', 'A-', 'D-', 'G-', 'C-', 'F-', 'B--', 'E--', 'A--', 'D--'];
    this.sharpMapping = ['C', 'G', 'D', 'A', 'E', 'B', 'F#', 'C#', 'G#', 'D#', 'A#', 'E#', 'B#'];
    this.classSortOrder = 2;
    this._sharps = sharps;
    this._alteredPitchesCache = undefined;
  }

  static get className() {
    return 'music21.key.KeySignature';
  }

  stringInfo() {
    if (this.sharps === 0) {
      return 'of no sharps or flats';
    } else if (this.sharps === -1) {
      return 'of 1 flat';
    } else if (this.sharps === 1) {
      return 'of 1 sharp';
    } else if (this.sharps < 0) {
      return "of ".concat(Math.abs(this.sharps), " flats");
    } else {
      return "of ".concat(this.sharps, " sharps");
    }
  }

  get sharps() {
    return this._sharps;
  }

  set sharps(s) {
    this._alteredPitchesCache = [];
    this._sharps = s;
  }
  /**
   * Gives the width in pixels necessary to represent the key signature.
   */


  get width() {
    if (this.sharps === 0) {
      return 0;
    } else {
      // add 6 to add extra space after the KS...
      return 12 * Math.abs(this.sharps) + 6;
    }
  }
  /**
   * An Array of Altered Pitches in KeySignature order (i.e., for flats, Bb, Eb, etc.)
   *
   * @type {music21.pitch.Pitch[]}
   * @readonly
   * @example
   * var ks = new music21.key.KeySignature(3)
   * var ap = ks.alteredPitches
   * var apName = [];
   * for (var i = 0; i < ap.length; i++) {
   *     apName.push(ap[i].name);
   * }
   * apName
   * // ["F#", "C#", "G#"]
   */


  get alteredPitches() {
    if (this._alteredPitchesCache !== undefined) {
      return this._alteredPitchesCache;
    }

    var transStr = 'P5';
    var startPitch = 'B';

    if (this.sharps < 0) {
      transStr = 'P4';
      startPitch = 'F';
    }

    var transInterval = new _interval__WEBPACK_IMPORTED_MODULE_9__["Interval"](transStr);
    var post = [];
    var pKeep = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"](startPitch);

    for (var i = 0; i < Math.abs(this.sharps); i++) {
      pKeep = transInterval.transposePitch(pKeep);
      pKeep.octave = 4;
      post.push(pKeep);
    }

    this._alteredPitchesCache = post;
    return post;
  }
  /**
   * Return the name of the major key with this many sharps
   *
   * @returns {(string|undefined)} name of key
   * @example
   * var ks = new music21.key.KeySignature(-3)
   * ks.majorName()
   * // "E-"
   */


  majorName() {
    if (this.sharps >= 0) {
      return this.sharpMapping[this.sharps];
    } else {
      return this.flatMapping[Math.abs(this.sharps)];
    }
  }
  /**
   * Return the name of the minor key with this many sharps
   * @returns {(string|undefined)}
   */


  minorName() {
    var tempSharps = this.sharps + 3;

    if (tempSharps >= 0) {
      return this.sharpMapping[tempSharps];
    } else {
      return this.flatMapping[Math.abs(tempSharps)];
    }
  }
  /**
   * returns the vexflow name (just the `majorName()` with "b" for "-") for
   * the key signature.  Does not create the object.
   *
   * Deprecated.
   *
   * @returns {string}
   */


  vexflow() {
    console.log('calling deprecated function KeySignature.vexflow');
    var tempName = this.majorName();
    return tempName.replace(/-/g, 'b');
  }
  /**
   * Returns the accidental associated with a step in this key, or undefined if none.
   *
   * @param {string} step - a valid step name such as "C","D", etc., but not "C#" etc.
   * @returns {(music21.pitch.Accidental|undefined)}
   */


  accidentalByStep(step) {
    var aps = this.alteredPitches;

    for (var i = 0; i < aps.length; i++) {
      if (aps[i].step === step) {
        if (aps[i].accidental === undefined) {
          return undefined;
        } // make a new accidental;


        return new _pitch__WEBPACK_IMPORTED_MODULE_10__["Accidental"](aps[i].accidental.alter);
      }
    }

    return undefined;
  }
  /**
   * Takes a pitch in C major and transposes it so that it has
   * the same step position in the current key signature.
   *
   * Does not support inPlace unlike music21p v6.
   *
   * @returns {music21.pitch.Pitch}
   * @example
   * var ks = new music21.key.KeySignature(-3)
   * var p1 = new music21.pitch.Pitch('B')
   * var p2 = ks.transposePitchFromC(p1)
   * p2.name
   * // "D"
   * var p3 = new music21.pitch.Pitch('G-')
   * var p4 = ks.transposePitchFromC(p3)
   * p4.name
   * // "B--"
   */


  transposePitchFromC(p) {
    var originalOctave = p.octave;
    var transInterval;
    var transTimes;

    if (this.sharps === 0) {
      return new _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"](p.nameWithOctave);
    } else if (this.sharps < 0) {
      transTimes = Math.abs(this.sharps);
      transInterval = new _interval__WEBPACK_IMPORTED_MODULE_9__["Interval"]('P4');
    } else {
      transTimes = this.sharps;
      transInterval = new _interval__WEBPACK_IMPORTED_MODULE_9__["Interval"]('P5');
    }

    var newPitch = p;

    for (var i = 0; i < transTimes; i++) {
      newPitch = transInterval.transposePitch(newPitch);
    }

    newPitch.octave = originalOctave;
    return newPitch;
  }

}
/**
 * Create a Key object. Like a KeySignature but with ideas about Tonic, Dominant, etc.
 *
 * TODO: allow keyName to be a {@link music21.pitch.Pitch}
 * TODO: Scale mixin.
 *
 * @class Key
 * @memberof music21.key
 * @extends music21.key.KeySignature
 * @param {string} keyName -- a pitch name representing the key (w/ "-" for flat)
 * @param {string} [mode] -- if not given then the CASE of the keyName will be used ("C" => "major", "c" => "minor")
 */

class Key extends KeySignature {
  constructor() {
    var keyName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'C';
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    if (keyName === undefined) {
      keyName = 'C';
    }

    if (mode === undefined) {
      var lowerCase = keyName.toLowerCase();

      if (keyName === lowerCase) {
        mode = 'minor';
      } else {
        mode = 'major';
      }
    }

    var sharpsArray = 'A-- E-- B-- F- C- G- D- A- E- B- F C G D A E B F# C# G# D# A# E# B#'.split(' ');
    var sharpsIndex = sharpsArray.indexOf(keyName.toUpperCase());

    if (sharpsIndex === -1) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_6__["Music21Exception"]('Cannot find the key for ' + keyName);
    }

    var modeShift = modeSharpsAlter[mode] || 0;
    var sharps = sharpsIndex + modeShift - 11;

    if (_debug__WEBPACK_IMPORTED_MODULE_7__["debug"]) {
      console.log('Found sharps ' + sharps + ' for key: ' + keyName);
    }

    super(sharps);
    this.tonic = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"](keyName);
    this.mode = mode;
    this._scale = this.getScale();
  }

  static get className() {
    return 'music21.key.Key';
  }

  stringInfo() {
    return this.tonicPitchNameWithCase + ' ' + this.mode;
  }

  get tonicPitchNameWithCase() {
    var tonicName = this.tonic.name;

    if (this.mode === 'major') {
      tonicName = tonicName.toUpperCase();
    } else if (this.mode === 'minor') {
      tonicName = tonicName.toLowerCase();
    }

    return tonicName;
  }
  /**
   * returns a {@link music21.scale.MajorScale} or {@link music21.scale.MinorScale}
   * object from the pitch object.
   *
   * @param {string|undefined} [scaleType=this.mode] - the type of scale, or the mode.
   * @returns {Object} A music21.scale.Scale subclass.
   */


  getScale() {
    var scaleType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    if (scaleType === undefined) {
      scaleType = this.mode;
    }

    var pitchObj = this.tonic;

    if (scaleType === 'major') {
      return new _scale__WEBPACK_IMPORTED_MODULE_11__["MajorScale"](pitchObj);
    } else if (scaleType === 'minor') {
      return new _scale__WEBPACK_IMPORTED_MODULE_11__["MinorScale"](pitchObj);
    } else if (['harmonic minor', 'harmonic-minor'].includes(scaleType)) {
      return new _scale__WEBPACK_IMPORTED_MODULE_11__["HarmonicMinorScale"](pitchObj);
    } else if (['melodic minor', 'melodic-minor'].includes(scaleType)) {
      return new _scale__WEBPACK_IMPORTED_MODULE_11__["AscendingMelodicMinorScale"](pitchObj);
    } else {
      return new _scale__WEBPACK_IMPORTED_MODULE_11__["ConcreteScale"](pitchObj);
    }
  } // Because of lack of multiple inheritance,
  // whenever scale.js adds functionality, it must be added here.


  get isConcrete() {
    return this._scale.isConcrete;
  }

  getPitches() {
    return this._scale.getPitches(...arguments);
  }

  pitchFromDegree(degree) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return this._scale.pitchFromDegree(degree, ...args);
  }

  getScaleDegreeFromPitch(pitchTarget) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return this._scale.getScaleDegreeFromPitch(pitchTarget, ...args);
  }

}

/***/ }),

/***/ "./src/music21/keyboard.ts":
/*!*********************************!*\
  !*** ./src/music21/keyboard.ts ***!
  \*********************************/
/*! exports provided: Key, WhiteKey, BlackKey, Keyboard, triggerToggleShow, jazzHighlight */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Key", function() { return Key; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WhiteKey", function() { return WhiteKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BlackKey", function() { return BlackKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Keyboard", function() { return Keyboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triggerToggleShow", function() { return triggerToggleShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jazzHighlight", function() { return jazzHighlight; });
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! midicube */ "./node_modules/midicube/releases/midicube.js");
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(midicube__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _miditools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./miditools */ "./src/music21/miditools.ts");
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./pitch */ "./src/music21/pitch.ts");


/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/keyboard -- PianoKeyboard rendering and display objects
 *
 * Copyright (c) 2013-18, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–17, Michael Scott Cuthbert and cuthbertLab
 *
 * Keyboard module, see {@link music21.keyboard} namespace
 *
 * @exports music21/keyboard
 *
 * keyboard namespace -- tools for creating an onscreen keyboard and interacting with it.
 *
 * @namespace music21.keyboard
 * @memberof music21
 * @requires music21/pitch
 * @requires music21/common
 * @requires music21/miditools
 * @requires jquery
 * @requires MIDI
 *
 * @example Minimum usage:
 * const kd = document.getElementById('keyboardDiv');
 * const k = new music21.keyboard.Keyboard();
 * k.appendKeyboard(kd, 6, 57); // 88 key keyboard
 *
 * // configurable:
 * k.scaleFactor = 1.2;  // default 1
 * k.whiteKeyWidth = 40; // default 23
 *
 */





/**
 * Represents a single Key
 *
 * @class Key
 * @memberof music21.keyboard
 * @property {Array<function>} callbacks - called when key is clicked/selected
 * @property {number} [scaleFactor=1]
 * @property {music21.keyboard.Keyboard|undefined} parent
 * @property {int} id - midi number associated with the key.
 * @property {music21.pitch.Pitch|undefined} pitchObj
 * @property {SVGElement|undefined} svgObj - SVG representing the drawing of the key
 * @property {SVGElement|undefined} noteNameSvgObj - SVG representing the note name drawn on the key
 * @property {string} keyStyle='' - css style information for the key
 * @property {string} keyClass='' - css class information for the key ("keyboardkey" + this is the class)
 * @property {number} width - width of key
 * @property {number} height - height of key
 */

class Key {
  constructor() {
    this.classes = ['Key']; // name conflict with key.Key

    this.callbacks = {
      click: undefined
    };
    this.scaleFactor = 1;
    this.parent = undefined;
    this.id = 0;
    this.width = 23;
    this.height = 120;
    this.pitchObj = undefined;
    this.svgObj = undefined;
    this.noteNameSvgObj = undefined;
    this.keyStyle = '';
    this.keyClass = '';
  }
  /**
   * Gets an SVG object for the key
   *
   * @param {number} startX - X position in pixels from left of keyboard to draw key at
   * @returns {SVGElement} a SVG rectangle for the key
   */


  makeKey(startX) {
    var keyAttrs = {
      style: this.keyStyle,
      x: startX,
      y: 0,
      class: 'keyboardkey ' + this.keyClass,
      id: this.id,
      width: this.width * this.scaleFactor,
      height: this.height * this.scaleFactor,
      rx: 3,
      ry: 3
    };
    var keyDOM = _common__WEBPACK_IMPORTED_MODULE_3__["makeSVGright"]('rect', keyAttrs);

    for (var x in this.callbacks) {
      if ({}.hasOwnProperty.call(this.callbacks, x)) {
        keyDOM.addEventListener(x, this.callbacks[x], false);
      }
    }

    this.svgObj = keyDOM;
    return keyDOM;
  }
  /**
   * Adds a circle (red) on the key (to mark middle C etc.)
   *
   * @param {string} [strokeColor='red']
   * @returns {SVGElement}
   */


  addCircle(strokeColor) {
    if (this.svgObj === undefined || this.parent === undefined || this.parent.svgObj === undefined) {
      return undefined;
    }

    if (strokeColor === undefined) {
      strokeColor = 'red';
    }

    var x = parseInt(this.svgObj.getAttribute('x'));
    var cx = x + this.parent.scaleFactor * this.width / 2; // console.log('cx', cx);

    var keyattrs = {
      stroke: strokeColor,
      'stroke-width': 3,
      fill: 'none',
      cx,
      cy: (this.height - 10) * this.parent.scaleFactor,
      class: 'keyboardkeyannotation',
      r: this.width * this.parent.scaleFactor / 4
    };
    var circleDom = _common__WEBPACK_IMPORTED_MODULE_3__["makeSVGright"]('circle', keyattrs);
    this.parent.svgObj.appendChild(circleDom); // console.log(circleDom);

    return circleDom;
  }
  /**
   * Adds the note name on the key
   *
   * @param {Boolean} [labelOctaves=false] - use octave numbers too?
   * @returns {this}
   */


  addNoteName(labelOctaves) {
    if (this.svgObj === undefined || this.parent === undefined || this.parent.svgObj === undefined) {
      return this;
    }

    if (this.id === 0 && this.pitchObj === undefined) {
      return this;
    } else if (this.pitchObj === undefined) {
      this.pitchObj = new _pitch__WEBPACK_IMPORTED_MODULE_5__["Pitch"]();
      this.pitchObj.ps = this.id;
    }

    if (this.pitchObj.accidental !== undefined && this.pitchObj.accidental.alter !== 0) {
      return this;
    }

    var x = parseInt(this.svgObj.getAttribute('x'));
    var idStr = this.pitchObj.name;
    var fontSize = 14;

    if (labelOctaves === true) {
      idStr = this.pitchObj.nameWithOctave;
      fontSize = 12;
      x -= 2;
    }

    fontSize = Math.floor(fontSize * this.parent.scaleFactor);
    var textfill = 'white';

    if (this.keyClass === 'whitekey') {
      textfill = 'black';
    }

    var textattrs = {
      fill: textfill,
      x: x + this.parent.scaleFactor * (this.width / 2 - 5),
      y: this.parent.scaleFactor * (this.height - 20),
      class: 'keyboardkeyname',
      'font-size': fontSize
    };
    var textDom = _common__WEBPACK_IMPORTED_MODULE_3__["makeSVGright"]('text', textattrs);
    var textNode = document.createTextNode(idStr);
    textDom.appendChild(textNode);
    this.noteNameSvgObj = textDom; // store for removing...

    this.parent.svgObj.appendChild(textDom);
    return this;
  }
  /**
   * Removes the note name from the key (if exists)
   *
   * @returns {undefined}
   */


  removeNoteName() {
    if (this.svgObj === undefined || this.parent === undefined || this.parent.svgObj === undefined) {
      return;
    }

    if (this.noteNameSvgObj === undefined) {
      return;
    }

    if (this.noteNameSvgObj.parentNode === this.parent.svgObj) {
      this.parent.svgObj.removeChild(this.noteNameSvgObj);
    }

    this.noteNameSvgObj = undefined;
  }

}
/**
 * Defaults for a WhiteKey (width, height, keyStyle, keyClass)
 *
 * @class WhiteKey
 * @memberof music21.keyboard
 * @extends music21.keyboard.Key
 */

class WhiteKey extends Key {
  constructor() {
    super();
    this.width = 23;
    this.height = 120;
    this.keyStyle = 'fill:#fffff6;stroke:black';
    this.keyClass = 'whitekey';
  }

}
/**
 * Defaults for a BlackKey (width, height, keyStyle, keyClass)
 *
 * @class BlackKey
 * @memberof music21.keyboard
 * @extends music21.keyboard.Key
 */

class BlackKey extends Key {
  constructor() {
    super();
    this.width = 13;
    this.height = 80;
    this.keyStyle = 'fill:black;stroke:black';
    this.keyClass = 'blackkey';
  }

}
/**
 * A Class representing a whole Keyboard full of keys.
 *
 * @class Keyboard
 * @memberof music21.keyboard
 * @property {number} whiteKeyWidth - default 23
 * @property {number} scaleFactor - default 1
 * @property {Object} keyObjects - a mapping of id to {@link music21.keyboard.Key} objects
 * @property {SVGElement} svgObj - the SVG object of the keyboard
 * @property {Boolean} markC - default true
 * @property {Boolean} showNames - default false
 * @property {Boolean} showOctaves - default false
 * @property {string|number} startPitch - default "C3" (a pitch string or midi number)
 * @property {string|number} endPitch - default "C5" (a pitch string or midi number)
 * @property {Boolean} hideable - default false -- add a way to hide and show keyboard
 * @property {Boolean} scrollable - default false -- add scroll bars to change octave
 */

class Keyboard {
  constructor() {
    this.whiteKeyWidth = 23;
    this._defaultWhiteKeyWidth = 23;
    this._defaultBlackKeyWidth = 13;
    this.scaleFactor = 1;
    this.height = 120; // does nothing right now...

    this.keyObjects = {};
    this.svgObj = undefined;
    this.markC = true;
    this.showNames = false;
    this.showOctaves = false;
    this.startPitch = 'C3';
    this.endPitch = 'C5';
    this._startDNN = undefined;
    this._endDNN = undefined;
    this.hideable = false;
    this.scrollable = false;
    this.callbacks = {
      click: undefined
    }; //   more accurate offsets from http://www.mathpages.com/home/kmath043.htm

    this.sharpOffsets = {
      0: 14.3333,
      1: 18.6666,
      3: 13.25,
      4: 16.25,
      5: 19.75
    };
    /**
     * An object of callbacks on events.
     *
     * default:
     *
     * - click: this.clickHandler
     *
     * @name callbacks
     * @type {Object}
     */

    this.callbacks = {
      click: keyClicked => this.clickHandler(keyClicked)
    };
  }
  /**
   * Redraws the SVG associated with this Keyboard
   *
   * @returns {SVGElement} new svgDOM
   */


  redrawSVG() {
    if (this.svgObj === undefined) {
      return undefined;
    }

    var oldSVG = this.svgObj;
    var svgParent = oldSVG.parentNode;
    this.keyObjects = {};
    var svgDOM = this.createSVG();
    svgParent.replaceChild(svgDOM, oldSVG);
    return svgDOM;
  }
  /**
   * Appends a keyboard to the `where` parameter
   *
   * @param {jQuery|Node} [where]
   * @returns {music21.keyboard.Keyboard} this
   */


  appendKeyboard(where) {
    if (where === undefined) {
      where = document.body;
    } else {
      // noinspection JSUnresolvedVariable
      if (typeof where.jquery !== 'undefined') {
        where = where[0];
      }
    }

    var svgDOM = this.createSVG();

    if (this.scrollable) {
      svgDOM = this.wrapScrollable(svgDOM)[0];
    }

    if (this.hideable) {
      // make it so the keyboard can be shown or hidden...
      this.appendHideableKeyboard(where, svgDOM);
    } else {
      where.appendChild(svgDOM); // svg must use appendChild, not append.
    }

    return this;
  }
  /**
   * Handle a click on a given SVG object
   *
   * TODO(msc) - 2019-Dec -- separate into two calls, one for highlighting and one for playing.
   *
   * @param {SVGElement} keyRect - the dom object with the keyboard.
   */


  clickHandler(keyRect) {
    // to-do : integrate with jazzHighlight...
    var id = keyRect.id;
    var thisKeyObject = this.keyObjects[id];

    if (thisKeyObject === undefined) {
      return; // not on keyboard;
    }

    var storedStyle = thisKeyObject.keyStyle;
    var fillColor = '#c0c000';

    if (thisKeyObject.keyClass === 'whitekey') {
      fillColor = 'yellow';
    }

    keyRect.setAttribute('style', 'fill:' + fillColor + ';stroke:black');
    _miditools__WEBPACK_IMPORTED_MODULE_4__["loadSoundfont"]('acoustic_grand_piano', i => {
      midicube__WEBPACK_IMPORTED_MODULE_2__["noteOn"](i.midiChannel, id, 100, 0);
      midicube__WEBPACK_IMPORTED_MODULE_2__["noteOff"](i.midiChannel, id, 500);
    });
    setTimeout(() => {
      keyRect.setAttribute('style', storedStyle);
    }, 500);
  }
  /**
   * Draws the SVG associated with this Keyboard
   */


  createSVG() {
    // DNN = pitch.diatonicNoteNum;
    // this._endDNN = final key note. I.e., the last note to be included, not the first note not included.
    // 6, 57 gives a standard 88-key keyboard;
    if (this._startDNN === undefined) {
      if (typeof this.startPitch === 'string') {
        var tempP = new _pitch__WEBPACK_IMPORTED_MODULE_5__["Pitch"](this.startPitch);
        this._startDNN = tempP.diatonicNoteNum;
      } else {
        this._startDNN = this.startPitch;
      }
    }

    if (this._endDNN === undefined) {
      if (typeof this.endPitch === 'string') {
        var _tempP = new _pitch__WEBPACK_IMPORTED_MODULE_5__["Pitch"](this.endPitch);

        this._endDNN = _tempP.diatonicNoteNum;
      } else {
        this._endDNN = this.endPitch;
      }
    }

    var currentIndex = (this._startDNN - 1) % 7; // C = 0

    var keyboardDiatonicLength = 1 + this._endDNN - this._startDNN;
    var totalWidth = this.whiteKeyWidth * this.scaleFactor * keyboardDiatonicLength;
    var height = 120 * this.scaleFactor;
    var heightString = height.toString() + 'px';
    var svgDOM = _common__WEBPACK_IMPORTED_MODULE_3__["makeSVGright"]('svg', {
      'xml:space': 'preserve',
      height: heightString,
      width: totalWidth.toString() + 'px',
      class: 'keyboardSVG'
    });
    var movingPitch = new _pitch__WEBPACK_IMPORTED_MODULE_5__["Pitch"]('C4');
    var blackKeys = [];
    var thisKeyboardObject = this;

    for (var wki = 0; wki < keyboardDiatonicLength; wki++) {
      movingPitch.diatonicNoteNum = this._startDNN + wki;
      var wk = new WhiteKey();
      wk.id = movingPitch.midi;
      wk.parent = this;
      this.keyObjects[movingPitch.midi] = wk;
      wk.scaleFactor = this.scaleFactor;
      wk.width = this.whiteKeyWidth;

      wk.callbacks.click = function whitekeyCallbacksClick() {
        thisKeyboardObject.callbacks.click(this);
      };

      var wkSVG = wk.makeKey(this.whiteKeyWidth * this.scaleFactor * wki);
      svgDOM.appendChild(wkSVG);

      if ((currentIndex === 0 || currentIndex === 1 || currentIndex === 3 || currentIndex === 4 || currentIndex === 5) && wki !== keyboardDiatonicLength - 1) {
        // create but do not append BlackKey to the right of WhiteKey
        var bk = new BlackKey();
        bk.id = movingPitch.midi + 1;
        this.keyObjects[movingPitch.midi + 1] = bk;
        bk.parent = this;
        bk.scaleFactor = this.scaleFactor;
        bk.width = this._defaultBlackKeyWidth * this.whiteKeyWidth / this._defaultWhiteKeyWidth;

        bk.callbacks.click = function blackKeyClicksCallback() {
          thisKeyboardObject.callbacks.click(this);
        };

        var offsetFromWhiteKey = this.sharpOffsets[currentIndex];
        offsetFromWhiteKey *= this.whiteKeyWidth / this._defaultWhiteKeyWidth * this.scaleFactor;
        var bkSVG = bk.makeKey(this.whiteKeyWidth * this.scaleFactor * wki + offsetFromWhiteKey);
        blackKeys.push(bkSVG);
      }

      currentIndex += 1;
      currentIndex %= 7;
    } // append blackkeys later since they overlap white keys;


    for (var bki = 0; bki < blackKeys.length; bki++) {
      svgDOM.appendChild(blackKeys[bki]);
    }

    this.svgObj = svgDOM;

    if (this.markC) {
      this.markMiddleC();
    }

    if (this.showNames) {
      this.markNoteNames(this.showOctaves);
    }

    return svgDOM;
  }
  /**
   * Puts a circle on middle c.
   *
   * @param {string} [strokeColor='red']
   */


  markMiddleC() {
    var strokeColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'red';
    var midC = this.keyObjects[60];

    if (midC !== undefined) {
      midC.addCircle(strokeColor);
    }
  }
  /**
   * Puts note names on every white key.
   *
   * @param {Boolean} [labelOctaves=false]
   */


  markNoteNames(labelOctaves) {
    this.removeNoteNames(); // in case...

    for (var midi in this.keyObjects) {
      if ({}.hasOwnProperty.call(this.keyObjects, midi)) {
        var keyObj = this.keyObjects[midi];
        keyObj.addNoteName(labelOctaves);
      }
    }
  }
  /**
   * Remove note names on the keys, if they exist
   *
   * @returns {this}
   */


  removeNoteNames() {
    for (var midi in this.keyObjects) {
      if ({}.hasOwnProperty.call(this.keyObjects, midi)) {
        var keyObj = this.keyObjects[midi];
        keyObj.removeNoteName();
      }
    }

    return this;
  }
  /**
   * Wraps the SVG object inside a scrollable set of buttons
   *
   * Do not call this directly, just use createSVG after changing the
   * scrollable property on the keyboard to True.
   *
   * @param {SVGElement} svgDOM
   * @returns {JQuery}
   */


  wrapScrollable(svgDOM) {
    var $wrapper = jquery__WEBPACK_IMPORTED_MODULE_1__("<div class='keyboardScrollableWrapper'></div>").css({
      display: 'inline-block'
    });
    var $bDown = jquery__WEBPACK_IMPORTED_MODULE_1__("<button class='keyboardOctaveDown'>&lt;&lt;</button>").css({
      'font-size': Math.floor(this.scaleFactor * 15).toString() + 'px'
    }).bind('click', () => {
      _miditools__WEBPACK_IMPORTED_MODULE_4__["config"].transposeOctave -= 1;
      this._startDNN -= 7;
      this._endDNN -= 7;
      this.redrawSVG();
    });
    var $bUp = jquery__WEBPACK_IMPORTED_MODULE_1__("<button class='keyboardOctaveUp'>&gt;&gt;</button>").css({
      'font-size': Math.floor(this.scaleFactor * 15).toString() + 'px'
    }).bind('click', () => {
      _miditools__WEBPACK_IMPORTED_MODULE_4__["config"].transposeOctave += 1;
      this._startDNN += 7;
      this._endDNN += 7;
      this.redrawSVG();
    });
    var $kWrapper = jquery__WEBPACK_IMPORTED_MODULE_1__("<div style='display:inline-block; vertical-align: middle' class='keyboardScrollableInnerDiv'></div>");
    $kWrapper[0].appendChild(svgDOM);
    $wrapper.append($bDown);
    $wrapper.append($kWrapper);
    $wrapper.append($bUp);
    return $wrapper;
  }
  /**
   * Puts a hideable keyboard inside a Div with the proper controls.
   *
   * Do not call this directly, just use createSVG after changing the
   * hideable property on the keyboard to True.
   *
   * @param {Node} where
   * @param {SVGElement} keyboardSVG
   */


  appendHideableKeyboard(where, keyboardSVG) {
    var $container = jquery__WEBPACK_IMPORTED_MODULE_1__("<div class='keyboardHideableContainer'/>");
    var $bInside = jquery__WEBPACK_IMPORTED_MODULE_1__("<div class='keyboardToggleInside'>↥</div>").css({
      display: 'inline-block',
      'padding-top': '40px',
      'font-size': '40px'
    });
    var $b = jquery__WEBPACK_IMPORTED_MODULE_1__("<div class='keyboardToggleOutside'/>").css({
      display: 'inline-block',
      'vertical-align': 'top',
      background: 'white'
    });
    $b.append($bInside);
    $b.data('defaultDisplay', $container.find('.keyboardSVG').css('display'));
    $b.data('state', 'down');
    $b.click(triggerToggleShow);
    var $explain = jquery__WEBPACK_IMPORTED_MODULE_1__("<div class='keyboardExplain'>Show keyboard</div>").css({
      display: 'none',
      'background-color': 'white',
      padding: '10px 10px 10px 10px',
      'font-size': '12pt'
    });
    $b.append($explain);
    $container.append($b);
    $container[0].appendChild(keyboardSVG); // svg must use appendChild, not $.append.

    jquery__WEBPACK_IMPORTED_MODULE_1__(where).append($container);
    return $container;
  }

} // noinspection JSUnusedLocalSymbols

/**
 * triggerToggleShow -- event for keyboard is shown or hidden.
 *
 * @function music21.keyboard.triggerToggleShow
 * @param {Event} [e]
 */

var triggerToggleShow = e => {
  // "this" refers to the object clicked
  // e -- event is not used.
  var $t = jquery__WEBPACK_IMPORTED_MODULE_1__(undefined);
  var state = $t.data('state');
  var $parent = $t.parent();
  var $k = $parent.find('.keyboardScrollableWrapper');

  if ($k.length === 0) {
    // not scrollable
    $k = $parent.find('.keyboardSVG');
  }

  var $bInside = $t.find('.keyboardToggleInside');
  var $explain = $parent.find('.keyboardExplain');

  if (state === 'up') {
    $bInside.text('↥');
    $bInside.css('padding-top', '40px');
    $explain.css('display', 'none');
    var dd = $t.data('defaultDisplay');

    if (dd === undefined) {
      dd = 'inline';
    }

    $k.css('display', dd);
    $t.data('state', 'down');
  } else {
    $k.css('display', 'none');
    $explain.css('display', 'inline-block');
    $bInside.text('↧');
    $bInside.css('padding-top', '10px');
    $t.data('state', 'up');
  }
};
/**
 * highlight the keyboard stored in "this" appropriately
 *
 * @function music21.keyboard.jazzHighlight
 * @param {music21.miditools.Event} e
 * @example
 * var midiCallbacksPlay = [music21.miditools.makeChords,
 *                          music21.miditools.sendToMIDIjs,
 *                          music21.keyboard.jazzHighlight.bind(k)];
 */

function jazzHighlight(e) {
  // e is a miditools.event object -- call with this = keyboard.Keyboard object via bind...
  if (e === undefined) {
    return;
  }

  if (e.noteOn) {
    var midiNote = e.midiNote;

    if (this.keyObjects[midiNote] !== undefined) {
      var keyObj = this.keyObjects[midiNote];
      var svgObj = keyObj.svgObj;
      var normalizedVelocity = (e.velocity + 25) / 127;

      if (normalizedVelocity > 1) {
        normalizedVelocity = 1.0;
      }

      var intensityRGB;

      if (keyObj.keyClass === 'whitekey') {
        var intensity = normalizedVelocity.toString();
        intensityRGB = 'rgba(255, 255, 0, ' + intensity + ')';
      } else {
        var _intensity = Math.floor(normalizedVelocity * 255).toString();

        intensityRGB = 'rgb(' + _intensity + ',' + _intensity + ',0)'; // console.log(intensityRGB);
      }

      svgObj.setAttribute('style', 'fill:' + intensityRGB + ';stroke:black');
    }
  } else if (e.noteOff) {
    var _midiNote = e.midiNote;

    if (this.keyObjects[_midiNote] !== undefined) {
      var _keyObj = this.keyObjects[_midiNote];
      var _svgObj = _keyObj.svgObj;

      _svgObj.setAttribute('style', _keyObj.keyStyle);
    }
  }
} // call this with a bind(keyboard.Keyboard object)...

/***/ }),

/***/ "./src/music21/layout.ts":
/*!*******************************!*\
  !*** ./src/music21/layout.ts ***!
  \*******************************/
/*! exports provided: makeLayoutFromScore, LayoutScore, Page, System, Staff */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeLayoutFromScore", function() { return makeLayoutFromScore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutScore", function() { return LayoutScore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Page", function() { return Page; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "System", function() { return System; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Staff", function() { return Staff; });
/* harmony import */ var _stream__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./stream */ "./src/music21/stream.ts");
/**
 *
 * THIS IS CURRENTLY UNUSED
 * Does not work yet, so not documented
 *
 */
// future -- rewrite of Score and Part to Page, System, SystemPart
// not currently used
// import * as $ from 'jquery';
//
// import { base } from './base';
// import { renderOptions } from './renderOptions';

/**
 * Divide a part up into systems and fix the measure
 * widths so that they are all even.
 *
 * Note that this is done on the part level even though
 * the measure widths need to be consistent across parts.
 *
 * This is possible because the system is deterministic and
 * will come to the same result for each part.  Opportunity
 * for making more efficient through this...
 *
 * @param {music21.stream.Score} score
 * @param {number} containerWidth
 * @returns {LayoutScore}
 */

function makeLayoutFromScore(score, containerWidth) {
  // var systemHeight = score.systemHeight; /* part.show() called... */
  // var systemPadding = score.systemPadding;
  var parts = score.parts.stream(); // console.log(parts);

  var numParts = parts.length;
  var partZero = parts.get(0);
  var numMeasures = partZero.getElementsByClass('Measure').length;
  var measureWidths = partZero.getMeasureWidths();
  var maxSystemWidth = containerWidth || score.maxSystemWidth;
  /* of course fix! */

  var layoutScore = new LayoutScore();
  var currentPage = new Page(); // to-do multiple pages...

  currentPage.measureStart = 1;
  currentPage.measureEnd = numMeasures;
  layoutScore.insert(0, currentPage);
  var currentSystem = new System();
  var currentSystemNumber = 1;
  currentSystem.measureStart = 1;
  var currentStaves = [];

  var staffMaker = (staffHolder, numParts, measureStart) => {
    for (var pNum = 0; pNum < numParts; pNum++) {
      var staff = new Staff();
      staff.measureStart = measureStart;
      staff.staffNumber = pNum + 1;
      staffHolder.push(staff);
    }
  };

  staffMaker(currentStaves, numParts, 1); // noinspection JSMismatchedCollectionQueryUpdate

  var systemCurrentWidths = []; // noinspection JSMismatchedCollectionQueryUpdate

  var systemBreakIndexes = [];
  var lastSystemBreak = 0;
  /* needed to ensure each line has at least one measure */

  var startLeft = 20;
  /* TODO: make it obtained elsewhere */

  var currentLeft = startLeft; // let currentSystemTop = 0;
  // var partTopOffsets = [];
  // const ignoreSystemsInCalculatingScoreHeight = true;
  // const systemHeight = score.estimateStreamHeight(ignoreSystemsInCalculatingScoreHeight);

  for (var i = 0; i < measureWidths.length; i++) {
    var currentRight = currentLeft + measureWidths[i];
    /* console.log("left: " + currentLeft + " ; right: " + currentRight + " ; m: " + i); */

    if (currentRight > maxSystemWidth && lastSystemBreak !== i) {
      // new system...
      for (var j = 0; j < currentStaves.length; j++) {
        currentStaves[j].measureEnd = i;
        currentSystem.insert(0, currentStaves[j]);
      }

      currentStaves = [];
      staffMaker(currentStaves, numParts, i + 1); // currentSystemTop += systemHeight;

      currentSystem.measureEnd = i;
      currentPage.insert(0, currentSystem);
      currentSystemNumber += 1;
      currentSystem = new System();
      currentSystem.measureStart = i + 1;
      currentSystem.systemNumber = currentSystemNumber;
      systemBreakIndexes.push(i - 1);
      systemCurrentWidths.push(currentLeft);
      console.log('setting new width at ' + currentLeft + ' measure ' + i);
      currentLeft = startLeft + measureWidths[i];
      lastSystemBreak = i;
    } else {
      currentLeft = currentRight;
    }

    for (var pNum = 0; pNum < currentStaves.length; pNum++) {
      currentStaves[pNum].append(parts.get(pNum).get(i));
    }
  }

  for (var _j = 0; _j < currentStaves.length; _j++) {
    currentStaves[_j].measureEnd = measureWidths.length - 1;
    currentSystem.insert(0, currentStaves[_j]);
  }

  currentPage.insert(0, currentSystem);
  return layoutScore;
}
/**
 * @extends music21.stream.Score
 * @property {number|undefined} measureStart
 * @property {number|undefined} measureEnd
 * @property {number|undefined} width
 * @property {number|undefined} height
 */

class LayoutScore extends _stream__WEBPACK_IMPORTED_MODULE_0__["Score"] {
  constructor() {
    super();
    this.scoreLayout = undefined;
    this.measureStart = undefined;
    this.measureEnd = undefined;
    /**
     *
     * @type {number|undefined}
     * @private
     */

    this._width = undefined;
    this.height = undefined;
    this.top = 0;
    this.left = 0;
  }

  static get className() {
    return 'music21.layout.LayoutScore';
  }

  get pages() {
    return this.getElementsByClass('Page');
  }

  get width() {
    if (this._width) {
      return this._width;
    } else if (this.activeSite) {
      return this.activeSite.width;
    } else {
      return undefined;
    }
  }

}
/**
 * All music must currently be on page 1.
 *
 * @extends music21.stream.Score
 * @property {number|undefined} measureStart
 * @property {number|undefined} measureEnd
 * @property {number|undefined} systemStart
 * @property {number|undefined} systemEnd
 */

class Page extends _stream__WEBPACK_IMPORTED_MODULE_0__["Score"] {
  constructor() {
    super();
    this.pageNumber = 1;
    this.measureStart = undefined;
    this.measureEnd = undefined;
    this.systemStart = undefined;
    this.systemEnd = undefined;
    this.pageLayout = undefined;
  }

  static get className() {
    return 'music21.layout.Page';
  }

  get systems() {
    return this.getElementsByClass('System');
  }

  get width() {
    if (this._width) {
      return this._width;
    } else if (this.activeSite) {
      return this.activeSite.width;
    } else {
      return undefined;
    }
  }

}
/**
 * @extends music21.stream.Score
 * @property {number|undefined} measureStart
 * @property {number|undefined} measureEnd
 * @property {number|undefined} width
 * @property {number|undefined} height
 * @property {number|undefined} top
 * @property {number|undefined} left
 */

class System extends _stream__WEBPACK_IMPORTED_MODULE_0__["Score"] {
  constructor() {
    super();
    this.systemNumber = 1;
    this.systemLayout = undefined;
    this.measureStart = undefined;
    this.measureEnd = undefined;
    this.height = undefined;
    this.top = undefined;
    this.left = undefined;
  }

  static get className() {
    return 'music21.layout.System';
  }

  get staves() {
    return this.getElementsByClass('Staff');
  }

  get width() {
    if (this._width) {
      return this._width;
    } else if (this.activeSite) {
      return this.activeSite.width;
    } else {
      return undefined;
    }
  }

}
/**
 * @extends music21.stream.Score
 *
 */

class Staff extends _stream__WEBPACK_IMPORTED_MODULE_0__["Part"] {
  constructor() {
    super();
    this.staffNumber = 1;
    this.optimized = 0;
    this.top = undefined;
    this.left = undefined;
    this._width = undefined;
    this.height = undefined;
    this.inheritedHeight = undefined;
    this.staffLayout = undefined;
  }

  static get className() {
    return 'music21.layout.Staff';
  }

  get width() {
    if (this._width) {
      return this._width;
    } else if (this.activeSite) {
      return this.activeSite.width;
    } else {
      return undefined;
    }
  }

}

/***/ }),

/***/ "./src/music21/meter.ts":
/*!******************************!*\
  !*** ./src/music21/meter.ts ***!
  \******************************/
/*! exports provided: TimeSignature */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeSignature", function() { return TimeSignature; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! vexflow */ "./node_modules/vexflow/releases/vexflow-debug.js");
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(vexflow__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");
/* harmony import */ var _beam__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./beam */ "./src/music21/beam.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./duration */ "./src/music21/duration.ts");







function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/meter -- TimeSignature objects
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–17, Michael Scott Cuthbert and cuthbertLab
 *
 * meter module. See {@link music21.meter} namespace for details.
 * Meter and TimeSignature Classes (esp. {@link music21.meter.TimeSignature} ) and methods.
 *
 * @exports music21/meter
 *
 * @namespace music21.meter
 * @memberof music21
 * @requires music21/base
 * @requires music21/duration
 */





/**
 * A MUCH simpler version of the music21p TimeSignature object.
 *
 * @class TimeSignature
 * @memberof music21.meter
 * @extends music21.base.Music21Object
 * @param {string} meterString - a string ("4/4", "3/8" etc.) to initialize the TimeSignature.
 * @property {int} [numerator=4]
 * @property {int} [denominator=4]
 * @property {number[][]} beatGroups - groupings of beats; inner arrays are numerator, denominator
 * @property {string} ratioString - a string like "4/4"
 * @property {music21.duration.Duration} barDuration - a Duration object
 *     representing the expressed total length of the TimeSignature.
 */

class TimeSignature extends _base__WEBPACK_IMPORTED_MODULE_7__["Music21Object"] {
  constructor() {
    var meterString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '4/4';
    super();
    this.classSortOrder = 4;
    this._numerator = 4;
    this._denominator = 4;
    this._beatGroups = [];
    this._overwrittenBeatCount = undefined;
    this._overwrittenBeatDuration = undefined;

    if (typeof meterString === 'string') {
      this.ratioString = meterString;
    }
  }

  static get className() {
    return 'music21.meter.TimeSignature';
  }

  stringInfo() {
    return this.ratioString;
  }

  get numerator() {
    return this._numerator;
  }

  set numerator(s) {
    this._numerator = s;
  }

  get denominator() {
    return this._denominator;
  }

  set denominator(s) {
    this._denominator = s;
  }

  get ratioString() {
    return this.numerator.toString() + '/' + this.denominator.toString();
  }

  set ratioString(meterString) {
    var meterList = meterString.split('/');
    this.numerator = parseInt(meterList[0]);
    this.denominator = parseInt(meterList[1]);
    this._beatGroups = [];
  }
  /**
   *
   * @type {music21.duration.Duration}
   */


  get barDuration() {
    var ql = 4.0 * this._numerator / this._denominator;
    return new _duration__WEBPACK_IMPORTED_MODULE_10__["Duration"](ql);
  }

  get beatGroups() {
    if (this._beatGroups.length === 0) {
      this._beatGroups = this.computeBeatGroups();
    }

    return this._beatGroups;
  }

  set beatGroups(newGroups) {
    this._beatGroups = newGroups;
  }
  /**
   *  Get the beatCount from the numerator, assuming fast 6/8, etc.
   *  unless .beatCount has been set manually.
   */


  get beatCount() {
    if (this._overwrittenBeatCount !== undefined) {
      return this._overwrittenBeatCount;
    }

    if (this.numerator > 3 && this.numerator % 3 === 0) {
      return this.numerator / 3;
    } else {
      return this.numerator;
    }
  }
  /**
   *  Manually set the beatCount to an int.
   */


  set beatCount(overwrite) {
    this._overwrittenBeatCount = overwrite;
  }
  /**
   * Gets a single duration.Duration object representing
   * the length of a beat in this time signature (using beatCount)
   * or, if set manually, it can return a list of Durations For
   * asymmetrical meters.
   */


  get beatDuration() {
    var dur = this.barDuration;
    dur.quarterLength /= this.beatCount;
    return dur;
  }
  /**
   * Set beatDuration to a duration.Duration object or
   * if the client can handle it, a list of Duration objects...
   */


  set beatDuration(overwrite) {
    this._overwrittenBeatDuration = overwrite;
  }
  /**
   * Compute the Beat Group according to this time signature.
   *
   * @returns {Array<Array<int>>} a list of numerator and denominators, find a list of beat groups.
   */


  computeBeatGroups() {
    var tempBeatGroups = [];
    var numBeats = this.numerator;
    var beatValue = this.denominator;

    if (beatValue < 8 && numBeats >= 5) {
      var beatsToEighthNoteRatio = 8 / beatValue; // hopefully Int -- right Brian Ferneyhough?

      beatValue = 8;
      numBeats *= beatsToEighthNoteRatio;
    }

    if (beatValue >= 8) {
      while (numBeats >= 5) {
        tempBeatGroups.push([3, beatValue]);
        numBeats -= 3;
      }

      if (numBeats === 4) {
        tempBeatGroups.push([2, beatValue]);
        tempBeatGroups.push([2, beatValue]);
      } else if (numBeats > 0) {
        tempBeatGroups.push([numBeats, beatValue]);
      }
    } else if (beatValue === 2) {
      tempBeatGroups.push([1, 2]);
    } else if (beatValue <= 1) {
      tempBeatGroups.push([1, 1]);
    } else {
      // 4/4, 2/4, 3/4, standard stuff
      tempBeatGroups.push([2, 8]);
    }

    return tempBeatGroups;
  }
  /**
   * Return a span of [start, end] for the current beat/beam grouping
   */


  offsetToSpan(offset) {
    var beatDuration = this.beatDuration.quarterLength;
    var beatsFromStart = Math.floor(offset / beatDuration);
    var start = beatsFromStart * beatDuration;
    var end = start + beatDuration;
    return [start, end];
  }
  /**
   * @param {music21.stream.Stream} srcStream - a stream of elements.
   * @param {Object} options - an object with measureStartOffset
   */


  getBeams(srcStream) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var params = {
      measureStartOffset: 0.0
    };
    _common__WEBPACK_IMPORTED_MODULE_9__["merge"](params, options);
    var measureStartOffset = params.measureStartOffset;
    var beamsList = _beam__WEBPACK_IMPORTED_MODULE_8__["Beams"].naiveBeams(srcStream);
    beamsList = _beam__WEBPACK_IMPORTED_MODULE_8__["Beams"].removeSandwichedUnbeamables(beamsList);

    var fixBeamsOneElementDepth = (i, el, depth) => {
      var beams = beamsList[i];

      if (!beams) {
        return;
      }

      var beamNumber = depth + 1;

      if (!beams.getNumbers().includes(beamNumber)) {
        return;
      }

      var dur = el.duration;
      var pos = el.offset + measureStartOffset;
      var start = pos; // opFrac

      var end = pos + dur.quarterLength; // opFrac;

      var startNext = end;
      var isLast = i === srcStream.length - 1;
      var isFirst = i === 0;
      var beamNext;
      var beamPrevious;

      if (!isFirst) {
        beamPrevious = beamsList[i - 1];
      }

      if (!isLast) {
        beamNext = beamsList[i + 1];
      }

      var _this$offsetToSpan = this.offsetToSpan(start),
          _this$offsetToSpan2 = _slicedToArray(_this$offsetToSpan, 2),
          archetypeSpanStart = _this$offsetToSpan2[0],
          archetypeSpanEnd = _this$offsetToSpan2[1];

      var archetypeSpanNextStart = 0.0;

      if (beamNext !== undefined) {
        archetypeSpanNextStart = this.offsetToSpan(startNext)[0];
      }

      if (start === archetypeSpanStart && end === archetypeSpanEnd) {
        beamsList[i] = undefined;
        return;
      }

      var beamType;

      if (isFirst) {
        beamType = 'start';

        if (beamNext === undefined || !beamNext.getNumbers().includes(beamNumber)) {
          beamType = 'partial-right';
        }
      } else if (isLast) {
        beamType = 'start';

        if (beamPrevious === undefined || !beamPrevious.getNumbers().includes(beamNumber)) {
          beamType = 'partial-left';
        }
      } else if (beamPrevious === undefined || !beamPrevious.getNumbers().includes(beamNumber)) {
        if (beamNumber === 1 && beamNext === undefined) {
          beamsList[i] = undefined;
          return;
        } else if (beamNext === undefined && beamNumber > 1) {
          beamType = 'partial-left';
        } else if (startNext >= archetypeSpanEnd) {
          beamType = 'partial-left';
        } else if (beamNext === undefined || !beamNext.getNumbers().includes(beamNumber)) {
          beamType = 'partial-right';
        } else {
          beamType = 'start';
        }
      } else if (beamPrevious && beamPrevious.getNumbers().includes(beamNumber) && ['stop', 'partial-left'].includes(beamPrevious.getTypeByNumber(beamNumber))) {
        if (beamNext !== undefined) {
          beamType = 'start';
        } else {
          beamType = 'partial-left';
        }
      } else if (beamNext === undefined || !beamNext.getNumbers().includes(beamNumber)) {
        beamType = 'stop';
      } else if (startNext < archetypeSpanEnd) {
        beamType = 'continue';
      } else if (startNext >= archetypeSpanNextStart) {
        beamType = 'stop';
      } else {
        console.warn('Cannot match beamType');
        return;
      }

      beams.setByNumber(beamNumber, beamType);
    };

    for (var depth = 0; depth < _beam__WEBPACK_IMPORTED_MODULE_8__["beamableDurationTypes"].length; depth++) {
      var i = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = srcStream[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;
          fixBeamsOneElementDepth(i, el, depth);
          i += 1;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    beamsList = _beam__WEBPACK_IMPORTED_MODULE_8__["Beams"].sanitizePartialBeams(beamsList);
    beamsList = _beam__WEBPACK_IMPORTED_MODULE_8__["Beams"].mergeConnectingPartialBeams(beamsList);
    return beamsList;
  }
  /**
   * Compute the Beat Group according to this time signature for VexFlow. For beaming.
   *
   * @returns {Array<Vex.Flow.Fraction>} a list of numerator and denominator groups, for VexFlow
   */


  vexflowBeatGroups() {
    var tempBeatGroups = this.beatGroups; // console.log(tempBeatGroups);

    var vfBeatGroups = [];

    for (var i = 0; i < tempBeatGroups.length; i++) {
      var bg = tempBeatGroups[i];
      vfBeatGroups.push(new vexflow__WEBPACK_IMPORTED_MODULE_6___default.a.Flow.Fraction(bg[0], bg[1]));
    }

    return vfBeatGroups; //  if (numBeats % 3 == 0 && beatValue < 4) {
    //  // 6/8, 3/8, 9/8, etc.
    //  numBeats = numBeats / 3;
    //  beatValue = beatValue / 3;
    //  }
  }

}

/***/ }),

/***/ "./src/music21/miditools.ts":
/*!**********************************!*\
  !*** ./src/music21/miditools.ts ***!
  \**********************************/
/*! exports provided: config, Event, loadedSoundfonts, clearOldChords, makeChords, sendOutChord, quantizeLastNote, sendToMIDIjs, postLoadCallback, loadSoundfont, MidiPlayer, callbacks, callBacks */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Event", function() { return Event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadedSoundfonts", function() { return loadedSoundfonts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearOldChords", function() { return clearOldChords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeChords", function() { return makeChords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendOutChord", function() { return sendOutChord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quantizeLastNote", function() { return quantizeLastNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendToMIDIjs", function() { return sendToMIDIjs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postLoadCallback", function() { return postLoadCallback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadSoundfont", function() { return loadSoundfont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MidiPlayer", function() { return MidiPlayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "callbacks", function() { return callbacks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "callBacks", function() { return callBacks; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! midicube */ "./node_modules/midicube/releases/midicube.js");
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(midicube__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./debug */ "./src/music21/debug.ts");
/* harmony import */ var _css_midiPlayer_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../css/midiPlayer.css */ "./css/midiPlayer.css");
/* harmony import */ var _css_midiPlayer_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_css_midiPlayer_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _chord__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./chord */ "./src/music21/chord.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _instrument__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./instrument */ "./src/music21/instrument.ts");
/* harmony import */ var _note__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./note */ "./src/music21/note.ts");
/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/miditools -- A collection of tools for midi.
 *
 * Copyright (c) 2014-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–19, Michael Scott Cuthbert and cuthbertLab
 *
 * @author Michael Scott Cuthbert
 *
 * A collection of tools for midi. See the namespace.
 *
 * Module that holds **music21j** tools for connecting with MIDI.js and somewhat with the
 * events from the Jazz plugin or the WebMIDI protocol.
 *
 *
 * @exports music21/miditools
 * @memberof music21
 */







 // expose midicube's MIDI to window for soundfonts to load.

window.MIDI = midicube__WEBPACK_IMPORTED_MODULE_1__;

class _ConfigSingletonClass {
  constructor() {
    /**
     * Number of octaves to transpose all incoming midi signals
     */
    this.transposeOctave = 0;
    /**
     * How long to wait in milliseconds before deciding
     * that a note belongs to another chord. Default 100ms
     */

    this.maxDelay = 100; // in ms

    /**
     * At what time (in ms since Epoch) the chord started.
     */

    this.heldChordTime = 0; // in ms

    /**
     * An Array (or undefined) of currently held Notes that have not been sent out yet.
     */

    this.heldChordNotes = undefined;
    /**
     * When, in MS since Jan 1, 1970, was the last {@link note.Note} played.
     * Defaults to the time that the module was loaded.
     */

    this.timeOfLastNote = Date.now(); // in ms

    /**
     * The last Note or Chord to be sent out from miditools.  This is an important semi-global
     * attribute, since the last element may need to be quantized by quantizeLastNote() to
     * determine its length, since the note may need to be placed into a staff before its total
     * length can be determined.
     */

    this.lastElement = undefined;
    this._baseTempo = 60;
    /**
     * Assign (or query) a Metronome object to run all timing information.
     */

    this.metronome = undefined;
  }

  get tempo() {
    if (this.metronome === undefined) {
      return this._baseTempo;
    } else {
      return this.metronome.tempo;
    }
  }

  set tempo(t) {
    if (this.metronome === undefined) {
      this._baseTempo = t;
    } else {
      this.metronome.tempo = t;
    }
  }

}

var config = new _ConfigSingletonClass();
/**
 * @class Event
 * @memberof music21.miditools
 * @param {number} t - timing information
 * @param {number} a - midi data 1 (N.B. a >> 4 = midiCommand )
 * @param {number} b - midi data 2
 * @param {number} c - midi data 3
 */

class Event {
  constructor(t, a, b, c) {
    this.velocity = undefined;
    this.timing = t;
    this.data1 = a;
    this.data2 = b;
    this.data3 = c;
    this.midiCommand = a >> 4; // eslint-disable-line no-bitwise

    this.noteOff = this.midiCommand === 8;
    this.noteOn = this.midiCommand === 9;
    this.midiNote = undefined;

    if (this.noteOn || this.noteOff) {
      this.midiNote = this.data2 + 12 * config.transposeOctave;
      this.velocity = this.data3;
    }
  }
  /**
   * Calls MIDI.noteOn or MIDI.noteOff for the note
   * represented by the Event (if appropriate)
   *
   * @returns {undefined}
   */


  sendToMIDIjs() {
    if (midicube__WEBPACK_IMPORTED_MODULE_1__["config"].is_connected) {
      // noteOn check because does not exist if no audio context
      // or soundfont has been loaded, such as if a play event
      // is triggered before soundfont has been loaded.
      if (this.noteOn) {
        midicube__WEBPACK_IMPORTED_MODULE_1__["noteOn"](0, this.midiNote, this.velocity, 0);
      } else if (this.noteOff) {
        midicube__WEBPACK_IMPORTED_MODULE_1__["noteOff"](0, this.midiNote, 0);
      }
    } else {
      console.warn('could not playback note because no MIDI connection defined');
    }
  }
  /**
   * Makes a {@link note.Note} object from the event's midiNote number.
   *
   * @returns {note.Note} - the {@link note.Note} object represented by Event.midiNote
   */


  music21Note() {
    var m21n = new _note__WEBPACK_IMPORTED_MODULE_7__["Note"]();
    m21n.pitch.ps = this.midiNote;
    return m21n;
  }

}
/**
 * a mapping of soundfont text names to true, false, or "loading".
 *
 * @memberof music21.miditools
 * @type {Object}
 */

var loadedSoundfonts = {};
/* --------- chords ------------- */

/**
 *  Clears chords that are older than miditools.heldChordTime
 *
 *  Runs a setTimeout on itself.
 *  Calls miditools.sendOutChord
 *
 *  @memberof music21.miditools
 */

function clearOldChords() {
  // clear out notes that may be a chord...
  var nowInMs = Date.now(); // in ms

  if (config.heldChordTime + config.maxDelay < nowInMs) {
    config.heldChordTime = nowInMs;

    if (config.heldChordNotes !== undefined) {
      // console.log('to send out chords');
      sendOutChord(config.heldChordNotes);
      config.heldChordNotes = undefined;
    }
  }

  setTimeout(clearOldChords, config.maxDelay);
}
/**
 *  Take a series of jEvent noteOn objects and convert them to a single Chord object
 *  so long as they are all sounded within miditools.maxDelay milliseconds of each other.
 *  this method stores notes in miditools.heldChordNotes (Array).
 *
 *  @param {music21.miditools.Event} jEvent
 *  @memberof music21.miditools
 *  @returns undefined
 */

function makeChords(jEvent) {
  // jEvent is a miditools.Event object
  if (jEvent.noteOn) {
    var m21n = jEvent.music21Note();

    if (config.heldChordNotes === undefined) {
      config.heldChordNotes = [m21n];
    } else {
      for (var i = 0; i < config.heldChordNotes.length; i++) {
        var foundNote = config.heldChordNotes[i];

        if (foundNote.pitch.ps === m21n.pitch.ps) {
          return; // no duplicates
        }
      }

      config.heldChordNotes.push(m21n);
    }
  }
}
/**
 * Take the list of Notes and makes a chord out of it, if appropriate and call
 * {@link music21.miditools.callbacks.sendOutChord} callback with the Chord or Note as a parameter.
 *
 * @memberof music21.miditools
 * @param {Array<music21.note.Note>} chordNoteList - an Array of {@link music21.note.Note} objects
 * @returns {(music21.note.Note|music21.chord.Chord|undefined)} A {@link music21.chord.Chord} object,
 * most likely, but maybe a {@link music21.note.Note} object)
 */

function sendOutChord(chordNoteList) {
  var appendObject;

  if (chordNoteList.length > 1) {
    // console.log(chordNoteList[0].name, chordNoteList[1].name);
    appendObject = new _chord__WEBPACK_IMPORTED_MODULE_4__["Chord"](chordNoteList);
  } else if (chordNoteList.length === 1) {
    appendObject = chordNoteList[0]; // note object
  } else {
    return undefined;
  }

  appendObject.stemDirection = 'noStem';
  quantizeLastNote();
  config.lastElement = appendObject;

  if (callbacks.sendOutChord !== undefined) {
    callbacks.sendOutChord(appendObject);
  }

  return appendObject;
}
/* ----------- callbacks --------- */
// TODO: all callbacks (incl. raw, sendOutChord) should be able to be a function or an array of functions

/**
 * Quantizes the lastElement (passed in) or music21.miditools.lastElement.
 *
 * @memberof music21.miditools
 * @param {music21.note.GeneralNote} [lastElement] - A {@link music21.note.Note} to be quantized
 * @returns {music21.note.GeneralNote} The same {@link music21.note.Note} object passed in with
 * duration quantized
 */

function quantizeLastNote() {
  var lastElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  if (lastElement === undefined) {
    lastElement = config.lastElement;
  }

  if (lastElement === undefined) {
    return undefined;
  }

  if (lastElement instanceof _note__WEBPACK_IMPORTED_MODULE_7__["NotRest"]) {
    lastElement.stemDirection = undefined;
  }

  var nowInMS = Date.now();
  var msSinceLastNote = nowInMS - config.timeOfLastNote;
  config.timeOfLastNote = nowInMS;
  var normalQuarterNoteLength = 1000 * 60 / config.tempo;
  var numQuarterNotes = msSinceLastNote / normalQuarterNoteLength;
  var roundedQuarterLength = Math.round(4 * numQuarterNotes) / 4;

  if (roundedQuarterLength >= 4) {
    roundedQuarterLength = 4;
  } else if (roundedQuarterLength >= 3) {
    roundedQuarterLength = 3;
  } else if (roundedQuarterLength > 2) {
    roundedQuarterLength = 2;
  } else if (roundedQuarterLength === 1.25) {
    roundedQuarterLength = 1;
  } else if (roundedQuarterLength === 0.75) {
    roundedQuarterLength = 0.5;
  } else if (roundedQuarterLength === 0) {
    roundedQuarterLength = 0.125;
  }

  lastElement.duration.quarterLength = roundedQuarterLength;
  return lastElement;
}
/* ----------- callbacks --------- */

/**
 * Callback to midiEvent.sendToMIDIjs.
 *
 * @memberof music21.miditools
 * @param {music21.miditools.Event} midiEvent - event to send out.
 * @returns undefined
 */

var sendToMIDIjs = midiEvent => {
  midiEvent.sendToMIDIjs();
};
/* ------------ MIDI.js ----------- */

/**
 * Called after a soundfont has been loaded. The callback is better to be specified elsewhere
 * rather than overriding this important method.
 *
 * @memberof music21.miditools
 * @param {string} soundfont The name of the soundfont that was just loaded
 * @param {function} callback A function to be called after the soundfont is loaded.
 */

function postLoadCallback(soundfont, callback) {
  // this should be bound to MIDI
  if (_debug__WEBPACK_IMPORTED_MODULE_2__["debug"]) {
    console.log('soundfont loaded about to execute callback.');
    console.log('first playing two notes very softly -- seems to flush the buffer.');
  }

  jquery__WEBPACK_IMPORTED_MODULE_0__('.loadingSoundfont').remove();
  var isAudioTag = midicube__WEBPACK_IMPORTED_MODULE_1__["config"].api === 'audiotag';
  var instrumentObj = _instrument__WEBPACK_IMPORTED_MODULE_6__["find"](soundfont);

  if (instrumentObj !== undefined) {
    midicube__WEBPACK_IMPORTED_MODULE_1__["programChange"](instrumentObj.midiChannel, instrumentObj.midiProgram);

    if (_debug__WEBPACK_IMPORTED_MODULE_2__["debug"]) {
      console.log(soundfont + ' (' + instrumentObj.midiProgram + ') loaded on ', instrumentObj.midiChannel);
    }

    if (isAudioTag === false) {
      // Firefox ignores sound volume! so don't play!
      // as does IE and others using HTML audio tag.
      // these old browsers don't have auto prevention anyhow.
      var channel = instrumentObj.midiChannel;
      midicube__WEBPACK_IMPORTED_MODULE_1__["noteOn"](channel, 36, 1, 0); // if no notes have been played before then

      midicube__WEBPACK_IMPORTED_MODULE_1__["noteOff"](channel, 36, 1, 0.1); // the second note to be played is always

      midicube__WEBPACK_IMPORTED_MODULE_1__["noteOn"](channel, 48, 1, 0.2); // very clipped (on Safari at least)

      midicube__WEBPACK_IMPORTED_MODULE_1__["noteOff"](channel, 48, 1, 0.3); // this helps a lot.

      midicube__WEBPACK_IMPORTED_MODULE_1__["noteOn"](channel, 60, 1, 0.3); // chrome needs three notes?

      midicube__WEBPACK_IMPORTED_MODULE_1__["noteOff"](channel, 60, 1, 0.4);
    }
  }

  if (callback !== undefined) {
    callback(instrumentObj);
  }

  loadedSoundfonts[soundfont] = true;
}
/**
 * method to load soundfonts while waiting for other processes that need them
 * to load first.
 *
 * @memberof music21.miditools
 * @param {string} soundfont The name of the soundfont that was just loaded
 * @param {function} [callback] A function to be called after the soundfont is loaded.
 * @example
 * s = new music21.stream.Stream();
 * music21.miditools.loadSoundfont(
 *     'clarinet',
 *     function(i) {
 *         console.log('instrument object', i, 'loaded');
 *         s.instrument = i;
 * });
 */

function loadSoundfont(soundfont) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (loadedSoundfonts[soundfont] === true) {
    // this soundfont has already been loaded once, so just call the callback.
    if (callback !== undefined) {
      var instrumentObj = _instrument__WEBPACK_IMPORTED_MODULE_6__["find"](soundfont);
      callback(instrumentObj);
    }
  } else if (loadedSoundfonts[soundfont] === 'loading') {
    // we are still waiting for this instrument to load, so
    // wait for it before calling callback.
    var waitThenCall = () => {
      if (loadedSoundfonts[soundfont] === true) {
        if (_debug__WEBPACK_IMPORTED_MODULE_2__["debug"]) {
          console.log('other process has finished loading; calling callback');
        }

        if (callback !== undefined) {
          var _instrumentObj = _instrument__WEBPACK_IMPORTED_MODULE_6__["find"](soundfont);

          callback(_instrumentObj);
        }
      } else {
        if (_debug__WEBPACK_IMPORTED_MODULE_2__["debug"]) {
          console.log('waiting for other process load');
        }

        setTimeout(waitThenCall, 100);
      }
    };

    waitThenCall();
  } else {
    // soundfont we have not seen before:
    // set its status to loading and then load it.
    loadedSoundfonts[soundfont] = 'loading';

    if (_debug__WEBPACK_IMPORTED_MODULE_2__["debug"]) {
      console.log('waiting for document ready');
    }

    jquery__WEBPACK_IMPORTED_MODULE_0__(document).ready(() => {
      if (_debug__WEBPACK_IMPORTED_MODULE_2__["debug"]) {
        console.log('document ready, waiting to load soundfont');
      }

      jquery__WEBPACK_IMPORTED_MODULE_0__(document.body).append(jquery__WEBPACK_IMPORTED_MODULE_0__("<div class='loadingSoundfont'><b></b></div>"));//"<div class='loadingSoundfont'><b>Loading MIDI Instrument</b>: " + 'audio will begin when this message disappears.</div>'));
      midicube__WEBPACK_IMPORTED_MODULE_1__["loadPlugin"]({
        soundfontUrl: _common__WEBPACK_IMPORTED_MODULE_5__["urls"].soundfontUrl,
        instrument: soundfont,
        onsuccess: postLoadCallback.bind(midicube__WEBPACK_IMPORTED_MODULE_1__, soundfont, callback)
      });
    });
  }
}
/**
 * MidiPlayer -- an embedded midi player including the ability to create a
 * playback device.
 *
 * @class MidiPlayer
 * @memberOf music21.miditools
 * @property {number} speed - playback speed scaling (1=default).
 * @property {JQuery|undefined} $playDiv - div holding the player,
 */

class MidiPlayer {
  constructor() {
    this.speed = 1.0;
    this.state = ''; // up, down, or empty...

    this.player = new midicube__WEBPACK_IMPORTED_MODULE_1__["Player"]();
  }
  /**
   * @param {jQuery|HTMLElement} [where]
   * @returns {jQuery}
   */


  addPlayer(where) {
    var $where;

    if (where === undefined) {
      where = document.body;
    }

    if (!(where instanceof jquery__WEBPACK_IMPORTED_MODULE_0__)) {
      $where = jquery__WEBPACK_IMPORTED_MODULE_0__(where);
    } else {
      $where = where;
    }
    /**
     *
     * @type {jQuery}
     */


    var $playDiv = jquery__WEBPACK_IMPORTED_MODULE_0__('<div class="midiPlayer">');
    /**
     *
     * @type {jQuery}
     */

    var $controls = jquery__WEBPACK_IMPORTED_MODULE_0__('<div class="positionControls">');
    /**
     *
     * @type {jQuery}
     */

    var $playPause = jquery__WEBPACK_IMPORTED_MODULE_0__('<input type="image" alt="play" src="' + this.playPng() + '" value="play" class="playPause">');
    /**
     *
     * @type {jQuery}
     */

    var $stop = jquery__WEBPACK_IMPORTED_MODULE_0__('<input type="image" alt="stop" src="' + this.stopPng() + '" value="stop" class="stopButton">');
    $playPause.on('click', () => this.pausePlayStop());
    $stop.on('click', () => this.stopButton());
    $controls.append($playPause);
    $controls.append($stop);
    $playDiv.append($controls);
    /**
     *
     * @type {jQuery}
     */

    var $time = jquery__WEBPACK_IMPORTED_MODULE_0__('<div class="timeControls">');
    /**
     *
     * @type {jQuery}
     */

    var $timePlayed = jquery__WEBPACK_IMPORTED_MODULE_0__('<span class="timePlayed">0:00</span>');
    /**
     *
     * @type {jQuery}
     */

    var $capsule = jquery__WEBPACK_IMPORTED_MODULE_0__('<span class="capsule"><span class="cursor"></span></span>');
    /**
     *
     * @type {jQuery}
     */

    var $timeRemaining = jquery__WEBPACK_IMPORTED_MODULE_0__('<span class="timeRemaining">-0:00</span>');
    $time.append($timePlayed);
    $time.append($capsule);
    $time.append($timeRemaining);
    $playDiv.append($time);
    $where.append($playDiv);
    this.$playDiv = $playDiv;
    return $playDiv;
  }

  stopButton() {
    this.pausePlayStop('yes');
  }
  /**
   *
   * @returns {string}
   */


  playPng() {
    return _common__WEBPACK_IMPORTED_MODULE_5__["urls"].midiPlayer + '/play.png';
  }
  /**
   *
   * @returns {string}
   */


  pausePng() {
    return _common__WEBPACK_IMPORTED_MODULE_5__["urls"].midiPlayer + '/pause.png';
  }
  /**
   *
   * @returns {string}
   */


  stopPng() {
    return _common__WEBPACK_IMPORTED_MODULE_5__["urls"].midiPlayer + '/stop.png';
  }

  pausePlayStop() {
    var stop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'no';
    var d;

    if (this.$playDiv === undefined) {
      d = {
        src: 'doesnt matter'
      };
    } else {
      d = this.$playDiv.find('.playPause')[0];
    }

    if (stop === 'yes') {
      this.player.stop();
      d.src = this.playPng();
    } else if (this.player.playing || stop === 'pause') {
      d.src = this.playPng();
      this.player.pause(true);
    } else {
      d.src = this.pausePng();
      this.player.resume().catch(console.error);
    }
  }

  base64Load(b64data) {
    var player = this.player;
    player.timeWarp = this.speed;
    var m21MidiPlayer = this;
    loadSoundfont('acoustic_grand_piano', () => {
      player.loadFile(b64data, () => {
        // success
        m21MidiPlayer.fileLoaded();
      }, undefined, // loading
      // loading
      e => {
        // failure
        console.log(e);
      });
    });
  }

  songFinished() {
    this.pausePlayStop('yes');
  }

  fileLoaded() {
    this.updatePlaying();
  }

  startAndUpdate() {
    this.player.start();
    this.updatePlaying();
  }

  updatePlaying() {
    var player = this.player;

    if (this.$playDiv === undefined) {
      return;
    }

    var $d = this.$playDiv; // update the timestamp

    var timePlayed = $d.find('.timePlayed')[0];
    var timeRemaining = $d.find('.timeRemaining')[0];
    var timeCursor = $d.find('.cursor')[0];
    var $capsule = $d.find('.capsule'); //

    $capsule.on('dragstart', e => {
      player.currentTime = (e.pageX - $capsule.offset().left) / 420 * player.endTime;

      if (player.currentTime < 0) {
        player.currentTime = 0;
      }

      if (player.currentTime > player.endTime) {
        player.currentTime = player.endTime;
      }

      if (this.state === 'down') {
        this.pausePlayStop('pause');
      } else if (this.state === 'up') {
        this.pausePlayStop('play');
      }
    }); //

    var timeFormatting = n => {
      var minutes = Math.floor(n / 60);
      var seconds = String(Math.floor(n - minutes * 60));

      if (seconds.length === 1) {
        seconds = '0' + seconds;
      }

      return minutes + ':' + seconds;
    };

    player.setAnimation(data => {
      var percent = data.now / data.end;
      var now = Math.floor(data.now); // where we are now

      var end = Math.floor(data.end); // end of song

      if (now === end) {
        // go to next song
        this.songFinished();
      } // display the information to the user


      timeCursor.style.width = percent * 100 + '%';
      timePlayed.innerHTML = timeFormatting(now);
      timeRemaining.innerHTML = '-' + timeFormatting(end - now);
    });
  }

}
/**
 * callbacks is an object with three keys:
 *
 * - raw: function (t, a, b,c) to call when any midi event arrives.
 *     Default: `function (t, a, b, c) { return new miditools.Event(t, a, b, c); }`
 * - general: function ( miditools.Event() ) to call when an Event object
 *     has been created. Default:
 *     `[miditools.sendToMIDIjs, miditools.quantizeLastNote]`
 * - sendOutChord: function (note.Note[]) to call
 *     when a sufficient time has passed to build a chord from input.
 *     Default: empty function.
 *
 * At present, only "general" can take an Array of event listening functions,
 * but I hope to change that for sendOutChord also.
 *
 * "general" is usually the callback list to play around with.
 *
 * @memberof music21.miditools
 */

var callbacks = {
  raw: (t, a, b, c) => new Event(t, a, b, c),
  general: [sendToMIDIjs, quantizeLastNote],
  sendOutChord: arrayOfNotes => {}
}; // For backwards compatibility -- this used to have a capital b.

var callBacks = callbacks;

/***/ }),

/***/ "./src/music21/musicxml.ts":
/*!*********************************!*\
  !*** ./src/music21/musicxml.ts ***!
  \*********************************/
/*! exports provided: m21ToXml, xmlToM21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _musicxml_m21ToXml__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./musicxml/m21ToXml */ "./src/music21/musicxml/m21ToXml.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "m21ToXml", function() { return _musicxml_m21ToXml__WEBPACK_IMPORTED_MODULE_0__; });
/* harmony import */ var _musicxml_xmlToM21__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./musicxml/xmlToM21 */ "./src/music21/musicxml/xmlToM21.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "xmlToM21", function() { return _musicxml_xmlToM21__WEBPACK_IMPORTED_MODULE_1__; });




/***/ }),

/***/ "./src/music21/musicxml/m21ToXml.ts":
/*!******************************************!*\
  !*** ./src/music21/musicxml/m21ToXml.ts ***!
  \******************************************/
/*! exports provided: GeneralObjectExporter, XMLExporterBase, ScoreExporter, PartExporter, MeasureExporter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GeneralObjectExporter", function() { return GeneralObjectExporter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XMLExporterBase", function() { return XMLExporterBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScoreExporter", function() { return ScoreExporter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PartExporter", function() { return PartExporter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeasureExporter", function() { return MeasureExporter; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _clef__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../clef */ "./src/music21/clef.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../common */ "./src/music21/common.ts");
/* harmony import */ var _stream__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../stream */ "./src/music21/stream.ts");
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony import */ var _note__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../note */ "./src/music21/note.ts");








function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @namespace music21.musicxml.m21ToXml
 */






class MusicXMLExportException extends _exceptions21__WEBPACK_IMPORTED_MODULE_10__["Music21Exception"] {}

function typeToMusicXMLType(value) {
  if (value === 'longa') {
    return 'long';
  } else if (value === '2048th') {
    throw new MusicXMLExportException('Cannot convert "2048th" duration to MusicXML (too short).');
  } else {
    return value;
  }
}

function normalizeColor(color) {
  var colors = {
    'aliceblue': '#f0f8ff',
    'antiquewhite': '#faebd7',
    'aqua': '#00ffff',
    'aquamarine': '#7fffd4',
    'azure': '#f0ffff',
    'beige': '#f5f5dc',
    'bisque': '#ffe4c4',
    'black': '#000000',
    'blanchedalmond': '#ffebcd',
    'blue': '#0000ff',
    'blueviolet': '#8a2be2',
    'brown': '#a52a2a',
    'burlywood': '#deb887',
    'cadetblue': '#5f9ea0',
    'chartreuse': '#7fff00',
    'chocolate': '#d2691e',
    'coral': '#ff7f50',
    'cornflowerblue': '#6495ed',
    'cornsilk': '#fff8dc',
    'crimson': '#dc143c',
    'cyan': '#00ffff',
    'darkblue': '#00008b',
    'darkcyan': '#008b8b',
    'darkgoldenrod': '#b8860b',
    'darkgray': '#a9a9a9',
    'darkgreen': '#006400',
    'darkkhaki': '#bdb76b',
    'darkmagenta': '#8b008b',
    'darkolivegreen': '#556b2f',
    'darkorange': '#ff8c00',
    'darkorchid': '#9932cc',
    'darkred': '#8b0000',
    'darksalmon': '#e9967a',
    'darkseagreen': '#8fbc8f',
    'darkslateblue': '#483d8b',
    'darkslategray': '#2f4f4f',
    'darkturquoise': '#00ced1',
    'darkviolet': '#9400d3',
    'deeppink': '#ff1493',
    'deepskyblue': '#00bfff',
    'dimgray': '#696969',
    'dodgerblue': '#1e90ff',
    'firebrick': '#b22222',
    'floralwhite': '#fffaf0',
    'forestgreen': '#228b22',
    'fuchsia': '#ff00ff',
    'gainsboro': '#dcdcdc',
    'ghostwhite': '#f8f8ff',
    'gold': '#ffd700',
    'goldenrod': '#daa520',
    'gray': '#808080',
    'green': '#008000',
    'greenyellow': '#adff2f',
    'honeydew': '#f0fff0',
    'hotpink': '#ff69b4',
    'indianred ': '#cd5c5c',
    'indigo': '#4b0082',
    'ivory': '#fffff0',
    'khaki': '#f0e68c',
    'lavender': '#e6e6fa',
    'lavenderblush': '#fff0f5',
    'lawngreen': '#7cfc00',
    'lemonchiffon': '#fffacd',
    'lightblue': '#add8e6',
    'lightcoral': '#f08080',
    'lightcyan': '#e0ffff',
    'lightgoldenrodyellow': '#fafad2',
    'lightgrey': '#d3d3d3',
    'lightgreen': '#90ee90',
    'lightpink': '#ffb6c1',
    'lightsalmon': '#ffa07a',
    'lightseagreen': '#20b2aa',
    'lightskyblue': '#87cefa',
    'lightslategray': '#778899',
    'lightsteelblue': '#b0c4de',
    'lightyellow': '#ffffe0',
    'lime': '#00ff00',
    'limegreen': '#32cd32',
    'linen': '#faf0e6',
    'magenta': '#ff00ff',
    'maroon': '#800000',
    'mediumaquamarine': '#66cdaa',
    'mediumblue': '#0000cd',
    'mediumorchid': '#ba55d3',
    'mediumpurple': '#9370d8',
    'mediumseagreen': '#3cb371',
    'mediumslateblue': '#7b68ee',
    'mediumspringgreen': '#00fa9a',
    'mediumturquoise': '#48d1cc',
    'mediumvioletred': '#c71585',
    'midnightblue': '#191970',
    'mintcream': '#f5fffa',
    'mistyrose': '#ffe4e1',
    'moccasin': '#ffe4b5',
    'navajowhite': '#ffdead',
    'navy': '#000080',
    'oldlace': '#fdf5e6',
    'olive': '#808000',
    'olivedrab': '#6b8e23',
    'orange': '#ffa500',
    'orangered': '#ff4500',
    'orchid': '#da70d6',
    'palegoldenrod': '#eee8aa',
    'palegreen': '#98fb98',
    'paleturquoise': '#afeeee',
    'palevioletred': '#d87093',
    'papayawhip': '#ffefd5',
    'peachpuff': '#ffdab9',
    'peru': '#cd853f',
    'pink': '#ffc0cb',
    'plum': '#dda0dd',
    'powderblue': '#b0e0e6',
    'purple': '#800080',
    'rebeccapurple': '#663399',
    'red': '#ff0000',
    'rosybrown': '#bc8f8f',
    'royalblue': '#4169e1',
    'saddlebrown': '#8b4513',
    'salmon': '#fa8072',
    'sandybrown': '#f4a460',
    'seagreen': '#2e8b57',
    'seashell': '#fff5ee',
    'sienna': '#a0522d',
    'silver': '#c0c0c0',
    'skyblue': '#87ceeb',
    'slateblue': '#6a5acd',
    'slategray': '#708090',
    'snow': '#fffafa',
    'springgreen': '#00ff7f',
    'steelblue': '#4682b4',
    'tan': '#d2b48c',
    'teal': '#008080',
    'thistle': '#d8bfd8',
    'tomato': '#ff6347',
    'turquoise': '#40e0d0',
    'violet': '#ee82ee',
    'wheat': '#f5deb3',
    'white': '#ffffff',
    'whitesmoke': '#f5f5f5',
    'yellow': '#ffff00',
    'yellowgreen': '#9acd32'
  };

  if (color === undefined || color === '') {
    return color;
  } else if (!color.startsWith('#')) {
    return colors[color].toUpperCase();
  } else {
    return color.toUpperCase();
  }
}

var _classMapping = ['Score', 'Part', 'Measure', 'Voice', 'GeneralNote'];
class GeneralObjectExporter {
  constructor(obj) {
    this.generalObj = obj;
  }

  parse() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    if (obj === undefined) {
      obj = this.generalObj;
    }

    var outObj = this.fromGeneralObj(obj);
    return this.parseWellformedObject(outObj);
  }

  parseWellformedObject(sc) {
    var scoreExporter = new ScoreExporter(sc);
    scoreExporter.parse();
    return scoreExporter.asBytes();
  }

  fromGeneralObj(obj) {
    var classes = obj.classes;
    var outObj;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _classMapping[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var cM = _step.value;

        if (classes.includes(cM)) {
          var methName = 'from' + cM;
          outObj = this[methName](obj);
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (outObj === undefined) {
      throw new MusicXMLExportException("Cannot translate the object ".concat(obj, " to a complete musicXML document; ") + 'put it in a Stream first!');
    }

    return outObj;
  }

  fromScore(sc) {
    var scOut = sc.makeNotation({
      inPlace: false
    });
    return scOut;
  }

  fromPart(p) {
    if (p.isFlat) {
      p = p.makeMeasures();
    }

    var s = new _stream__WEBPACK_IMPORTED_MODULE_9__["Score"]();
    s.insert(0, p); // metadata...;

    return this.fromScore(s);
  }

  fromMeasure(m) {
    var mCopy = m.makeNotation();

    if (m.clef === undefined) {
      mCopy.clef = _clef__WEBPACK_IMPORTED_MODULE_7__["bestClef"](mCopy, {
        recurse: true
      });
    }

    var p = new _stream__WEBPACK_IMPORTED_MODULE_9__["Part"]();
    p.append(mCopy); // TODO(msc): metadata;

    return this.fromPart(p);
  }

  fromVoice(v) {
    var m = new _stream__WEBPACK_IMPORTED_MODULE_9__["Measure"]();
    m.number = 1;
    m.insert(0, v);
    return this.fromMeasure(m);
  } // TODO(msc): fromStream
  // TODO(msc): fromDuration
  // TODO(msc): fromDynamic
  // TODO(msc): fromScale
  // TODO(msc): fromDiatonicScale
  // TODO(msc): fromMusic21Object


  fromGeneralNote(n) {
    var nCopy = n.clone(true); // makeTupletBrackets;

    var out = new _stream__WEBPACK_IMPORTED_MODULE_9__["Measure"]();
    out.number = 1;
    out.append(nCopy);
    return this.fromMeasure(out);
  }

}
var _musicxmlVersion = '3.0';
/**
 * @memberOf music21.musicxml.m21ToXml
 */

class XMLExporterBase {
  constructor() {
    this.doc = document.implementation.createDocument('', '', null);
    this.xmlRoot = undefined;
  }

  asBytes() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$noCopy = _ref.noCopy,
        noCopy = _ref$noCopy === void 0 ? true : _ref$noCopy;

    var out = this.xmlHeader();
    var oSerializer = new XMLSerializer();
    out += oSerializer.serializeToString(this.xmlRoot);
    return out;
  } // no indentation :-(


  xmlHeader() {
    return "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n        <!DOCTYPE score-partwise PUBLIC \"-//Recordare//DTD MusicXML ".concat(_musicxmlVersion, "  Partwise//EN\" \"http://www.musicxml.org/dtds/partwise.dtd\">\n        ");
  }
  /**
   * Note: this is not a method in music21p, but it needs access to this.doc in music21j
   */


  _setTagTextFromAttribute(m21El, xmlEl, tag) {
    var attributeName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

    var _ref2 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
        _ref2$transform = _ref2.transform,
        transform = _ref2$transform === void 0 ? undefined : _ref2$transform,
        _ref2$forceEmpty = _ref2.forceEmpty,
        forceEmpty = _ref2$forceEmpty === void 0 ? false : _ref2$forceEmpty;

    if (attributeName === undefined) {
      attributeName = _common__WEBPACK_IMPORTED_MODULE_8__["hyphenToCamelCase"](tag);
    }

    var value = m21El[attributeName];

    if (transform !== undefined) {
      value = transform(value);
    }

    if ((value === undefined || value === '') && !forceEmpty) {
      return undefined;
    }

    var subElement = this.subElement(xmlEl, tag);

    if (value !== undefined) {
      subElement.innerHTML = value;
    }

    return subElement;
  }

  seta(m21El, xmlEl, tag) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return this._setTagTextFromAttribute(m21El, xmlEl, tag, undefined, options);
  }

  _setAttributeFromAttribute(m21El, xmlEl, xmlAttributeName) {
    var _ref3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref3$attributeName = _ref3.attributeName,
        attributeName = _ref3$attributeName === void 0 ? undefined : _ref3$attributeName,
        _ref3$transform = _ref3.transform,
        transform = _ref3$transform === void 0 ? undefined : _ref3$transform;

    if (attributeName === undefined) {
      attributeName = _common__WEBPACK_IMPORTED_MODULE_8__["hyphenToCamelCase"](xmlAttributeName);
    }

    var value = m21El[attributeName];

    if (value === undefined) {
      return;
    }

    if (transform !== undefined) {
      value = transform(value);
    }

    xmlEl.setAttribute(xmlAttributeName, value.toString());
  }

  setb(m21El, xmlEl, xmlAttributeName) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return this._setAttributeFromAttribute(m21El, xmlEl, xmlAttributeName, options);
  } // TODO(msc): _synchronizeIds;


  _synchronizeIds(element, m21Object) {}

  addDividerComment() {
    var comment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var commentLength = comment.length;

    if (commentLength > 60) {
      commentLength = 60;
    }

    var spacerLengthLow = Math.floor((60 - commentLength) / 2);
    var spacerLengthHigh = Math.ceil((60 - commentLength) / 2);
    var commentText = '='.repeat(spacerLengthLow) + ' ' + comment + ' ' + '='.repeat(spacerLengthHigh);
    var divider = this.doc.createComment(commentText);
    this.xmlRoot.appendChild(divider);
  } // TODO(msc): dump

  /**
   * Helper method since SubElement does not exist in javascript document.implementation
   */


  subElement(el, tag) {
    var subElement = this.doc.createElement(tag);
    el.appendChild(subElement);
    return subElement;
  } // TODO(msc): setStyleAttributes
  // TODO(msc): setTextFormatting
  // TODO(msc): setPrintStyleAlign
  // TODO(msc): setPrintStyle
  // TODO(msc): setPrintObject


  setColor(mxObject, m21Object) {
    if (m21Object.color !== undefined) {
      mxObject.setAttribute('color', normalizeColor(m21Object.color));
    } else if (m21Object.style !== undefined && m21Object.style.color !== undefined) {
      mxObject.setAttribute('color', normalizeColor(m21Object.style.color));
    }
  } // TODO(msc): setFont
  // TODO(msc): setPosition
  // TODO(msc): setEditorial


  setEditorial(mxEl, el) {} // TODO(msc): pageLayoutToXmlPrint
  // TODO(msc): pageLayoutToXmlPageLayout
  // TODO(msc): systemLayoutToXmlPrint
  // TODO(msc): systemLayoutToXmlSystemLayout
  // TODO(msc): staffLayoutToXmlStaffLayout


  accidentalToMx(a) {
    // TODO(msc): v 3.0 and v3.1 accidentals; microtone;
    var mxName;

    if (a.name === 'double-flat') {
      mxName = 'flat-flat';
    } else {
      mxName = a.name; // check other accidentals here.
    }

    var mxAccidental = this.doc.createElement('accidental');
    mxAccidental.innerHTML = mxName; // TODO(msc): parentheses, bracket, setPrintStyle

    return mxAccidental;
  }

  getRandomId() {
    // hack to get random ids.
    var text = ''; // noinspection SpellCheckingInspection

    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

    for (var i = 0; i < 6; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }

}
/**
 * @extends music21.musicxml.m21ToXml.XMLExporterBase
 */

class ScoreExporter extends XMLExporterBase {
  constructor(score) {
    super();
    this.xmIdentification = undefined;
    this.scoreMetadata = undefined;
    this.spannerBundle = undefined;
    this.meterStream = undefined;
    this.scoreLayouts = undefined;
    this.firstScoreLayout = undefined;
    this.highestTime = 0.0;
    this.refStreamOrTimeRange = [0.0, this.highestTime];
    this.partExporterList = [];
    this.instrumentList = [];
    this.midiChannelList = [];
    this.parts = [];

    if (score === undefined) {
      this.stream = new _stream__WEBPACK_IMPORTED_MODULE_9__["Score"]();
    } else {
      this.stream = score;
    }

    this.xmlRoot = this.doc.createElement('score-partwise');
    this.xmlRoot.setAttribute('version', _musicxmlVersion);
  }

  parse() {
    var s = this.stream;

    if (s.length === 0) {
      return this.emptyObject();
    }

    this.scorePreliminaries();
    this.parsePartlikeScore(); // does not have parseFlatScore...

    this.postPartProcess();
    this.partExporterList = [];
    return this.xmlRoot;
  }

  emptyObject() {
    // TODO(msc): do this.
    return this.xmlRoot;
  }

  scorePreliminaries() {
    // this.setScoreLayouts();
    // this.setMeterStream();
    this.setPartsAndRefStream(); // this.textBoxes = ...;

    this.highestTime = 0.0; // spannerBundle
  }

  setPartsAndRefStream() {
    var s = this.stream;
    var streamOfStreams = s.getElementsByClass('Stream');
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = streamOfStreams[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var innerStream = _step2.value;
        // innerStream.transferOffsetToElements(); // only needed for appended Parts
        var ht = innerStream.highestTime;

        if (ht > this.highestTime) {
          this.highestTime = ht;
        }

        this.refStreamOrTimeRange = [0.0, this.highestTime];
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    this.parts = Array.from(streamOfStreams.stream());
  } // TODO(msc): setMeterStream
  // TODO(msc): setScoreLayouts


  parsePartlikeScore() {
    // makeRests
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this.parts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var innerStream = _step3.value;
        var pp = new PartExporter(innerStream, {
          parent: this
        }); // spanner bundle.

        pp.parse();
        this.partExporterList.push(pp);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  } // TODO(msc): parseFlatScore


  postPartProcess() {
    this.setScoreHeader();

    for (var i = 0; i < this.partExporterList.length; i++) {
      var pex = this.partExporterList[i];
      this.addDividerComment('Part ' + i.toString());
      this.xmlRoot.appendChild(pex.xmlRoot);
    }
  }

  setScoreHeader() {
    // const s = this.stream;
    // scoreMetadata
    // titles
    // identification
    // setDefaults
    // textBoxes
    this.setPartList();
  } // TODO(msc): textBoxToXmlCredit
  // TODO(msc): setDefaults
  // TODO(msc): addStyleToXmlDefaults
  // TODO(msc): styleToXmlAppearance


  setPartList() {
    // const spannerBundle = this.spannerBundle; // for now, always undefined;
    var mxPartList = this.subElement(this.xmlRoot, 'part-list'); // staffGroups are non-existent

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = this.partExporterList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var pex = _step4.value;
        // const p = pex.stream;
        var mxScorePart = pex.getXmlScorePart();
        mxPartList.appendChild(mxScorePart);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return mxPartList;
  }

}
/**
 * @extends music21.musicxml.m21ToXml.XMLExporterBase
 */

class PartExporter extends XMLExporterBase {
  constructor(partObj) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$parent = _ref4.parent,
        parent = _ref4$parent === void 0 ? undefined : _ref4$parent;

    super();
    this.stream = partObj;
    this.parent = parent;
    this.xmlRoot = this.doc.createElement('part');

    if (parent === undefined) {
      this.meterStream = new _stream__WEBPACK_IMPORTED_MODULE_9__["Stream"]();
      this.refStreamOrTimeRange = [0.0, 0.0];
      this.midiChannelList = [];
    } else {
      this.meterStream = parent.meterStream;
      this.refStreamOrTimeRange = parent.refStreamOrTimeRange;
      this.midiChannelList = parent.midiChannelList;
    }

    this.instrumentStream = undefined;
    this.firstInstrumentObject = undefined;
    this.lastDivisions = undefined;
    this.spannerBundle = partObj.spannerBundle;
    this.xmlPartId = this.getRandomId(); // hacky
  }

  parse() {
    // this.instrumentSetup();
    this.xmlRoot.setAttribute('id', this.xmlPartId);
    var measureStream = this.stream.getElementsByClass('Stream'); // fixupNotation;
    // setIdLocals on spannerBundle;

    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = measureStream[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var m = _step5.value;
        this.addDividerComment('Measure ' + m.number.toString());
        var measureExporter = new MeasureExporter(m, {
          parent: this
        });
        measureExporter.spannerBundle = this.spannerBundle;
        var mxMeasure = measureExporter.parse();
        this.xmlRoot.appendChild(mxMeasure);
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    return this.xmlRoot;
  } // TODO(msc): instrumentSetup
  // TODO(msc): fixupNotationFlat -- might be redundant
  // TODO(msc): fixupNotationMeasured


  getXmlScorePart() {
    // const part = this.stream;
    var mxScorePart = this.doc.createElement('score-part');
    mxScorePart.setAttribute('id', this.xmlPartId); // partName
    // partAbbreviation
    // instrument

    return mxScorePart;
  }

}
var _classesToMeasureMethods = [['Note', 'noteToXml'], // NoChord
// ChordWithFretBoard
// ChordSymbol
['Chord', 'chordToXml'], ['Rest', 'restToXml']];
var _wrapAttributeMethodClasses = [['Clef', 'clefToXml'], ['KeySignature', 'keySignatureToXml'], ['TimeSignature', 'timeSignatureToXml']];
var _ignoreOnParseClasses = ['LayoutBase', 'Barline'];
var divisionsPerQuarter = 32 * 3 * 3 * 5 * 7; // TODO(msc): create defaults.js

/**
 * @extends music21.musicxml.m21ToXml.XMLExporterBase
 */

class MeasureExporter extends XMLExporterBase {
  constructor(measureObj) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref5$parent = _ref5.parent,
        parent = _ref5$parent === void 0 ? undefined : _ref5$parent;

    super();
    this.currentDivisions = divisionsPerQuarter;
    this.transpositionInterval = undefined;
    this.mxTranspose = undefined;
    this.measureOffsetStart = 0.0;
    this.offsetInMeasure = 0.0;
    this.currentVoiceId = undefined;
    this.rbSpanners = [];
    this.stream = measureObj;
    this.parent = parent;
    this.xmlRoot = this.doc.createElement('measure');
    this.spannerBundle = parent.spannerBundle;
    this.objectSpannerBundle = this.spannerBundle;
  }

  parse() {
    // TODO(msc): setTranspose
    // TODO(msc): setRbSpanners
    this.setMxAttributes(); // TODO(msc): setMxPrint

    this.setMxAttributesObjectForStartOfMeasure(); // TODO(msc): setLeftBarline
    // THE BIG ONE

    this.mainElementsParse(); // TODO(msc): setRightBarline

    return this.xmlRoot;
  }

  mainElementsParse() {
    var m = this.stream;

    if (!m.hasVoices()) {
      this.parseFlatElements(m, {
        backupAfterwards: false
      });
      return;
    } // TODO(msc): parse elements outside of Voices...needs getElementsNotOfClass


    var allVoices = Array.from(m.voices);
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = allVoices.entries()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var _step6$value = _slicedToArray(_step6.value, 2),
            i = _step6$value[0],
            v = _step6$value[1];

        var backupAfterwards = true;

        if (i === allVoices.length - 1) {
          backupAfterwards = false;
        }

        this.parseFlatElements(v, {
          backupAfterwards
        });
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }
  }

  parseFlatElements(m) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref6$backupAfterward = _ref6.backupAfterwards,
        backupAfterwards = _ref6$backupAfterward === void 0 ? false : _ref6$backupAfterward;

    var root = this.xmlRoot;
    var divisions = this.currentDivisions;
    this.offsetInMeasure = 0.0;
    var voiceId;

    if (m.classes.includes('Voice')) {
      voiceId = m.id;

      if (voiceId === undefined) {
        voiceId = this.getRandomId();
      }
    }

    this.currentVoiceId = voiceId;
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = m[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var el = _step7.value;
        this.parseOneElement(el);
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    if (backupAfterwards) {
      var amountToBackup = Math.round(divisions * this.offsetInMeasure);

      if (amountToBackup > 0) {
        var mxBackup = this.doc.createElement('backup');
        var mxDuration = this.subElement(mxBackup, 'duration');
        mxDuration.innerHTML = amountToBackup.toString();
        root.appendChild(mxBackup);
      }
    }

    this.currentVoiceId = undefined;
  }

  parseOneElement(obj) {
    var _this = this;

    // const root = this.xmlRoot;
    // spanners...
    var classes = obj.classes;

    if (classes.includes('GeneralNote')) {
      this.offsetInMeasure += obj.duration.quarterLength;
    } // odd durations...


    var parsedObject = false;
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = _classesToMeasureMethods[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var _step8$value = _slicedToArray(_step8.value, 2),
            className = _step8$value[0],
            methName = _step8$value[1];

        if (classes.includes(className)) {
          this[methName](obj);
          parsedObject = true;
          break;
        }
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }

    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      var _loop = function _loop() {
        var _step9$value = _slicedToArray(_step9.value, 2),
            className = _step9$value[0],
            methName = _step9$value[1];

        if (classes.includes(className)) {
          var meth = o => _this[methName](o);

          _this.wrapObjectInAttributes(obj, meth);

          parsedObject = true;
          return "break";
        }
      };

      for (var _iterator9 = _wrapAttributeMethodClasses[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var _ret = _loop();

        if (_ret === "break") break;
      } // deal with skipped objects.

    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    if (!parsedObject && !_ignoreOnParseClasses.includes(obj.classes[0])) {
      console.warn('skipped object of class ' + obj.classes[0]);
    } // postSpanners.

  } // TODO(msc): prePostObjectSpanners
  // TODO(msc): _spannerStartParameters
  // TODO(msc): _spannerEndParameters
  // TODO(msc): objectAttachedSpanners

  /**
   *
   * @param {music21.note.GeneralNote} n
   * @param noteIndexInChord
   * @param chordParent
   * @returns {Node}
   */


  noteToXml(n) {
    var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref7$noteIndexInChor = _ref7.noteIndexInChord,
        noteIndexInChord = _ref7$noteIndexInChor === void 0 ? 0 : _ref7$noteIndexInChor,
        _ref7$chordParent = _ref7.chordParent,
        chordParent = _ref7$chordParent === void 0 ? undefined : _ref7$chordParent;

    var addChordTag = noteIndexInChord !== 0;
    var chordOrN;

    if (chordParent === undefined) {
      chordOrN = n;
    } else {
      chordOrN = chordParent;
    }

    var mxNote = this.doc.createElement('note'); // setPrintStyle
    // volumeInformation

    this.setColor(mxNote, n); // _synchronizeId;

    var d = chordOrN.duration; // grace;
    // setColor chord
    // setPrintObject
    // hideObject
    // articulation pizz:

    if (addChordTag) {
      this.subElement(mxNote, 'chord');
    }

    if (n.isNote) {
      var mxPitch = this.pitchToXml(n.pitch);
      mxNote.appendChild(mxPitch);
    } else {
      this.subElement(mxNote, 'rest');
    }

    if (d.isGrace !== true) {
      var mxDuration = this.durationXml(d);
      mxNote.appendChild(mxDuration);
    }

    if (n.tie !== undefined) {
      var mxTieList = this.tieToXmlTie(n.tie);
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = mxTieList[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var t = _step10.value;
          mxNote.appendChild(t);
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    } // instrument


    this.setEditorial(mxNote, n);

    if (this.currentVoiceId !== undefined) {
      var mxVoice = this.subElement(mxNote, 'voice');
      var vId;

      if (typeof vId === 'number') {
        vId = this.currentVoiceId + 1;
      } else {
        // not a number;
        vId = this.currentVoiceId;
      }

      mxVoice.innerHTML = vId.toString();
    }

    var mxType = this.subElement(mxNote, 'type');
    mxType.innerHTML = typeToMusicXMLType(d.type); // set styleAttributes
    // set noteSize

    for (var _ = 0; _ < d.dots; _++) {
      this.subElement(mxNote, 'dot');
    } // components.


    if (n instanceof _note__WEBPACK_IMPORTED_MODULE_11__["Note"] && n.pitch.accidental !== undefined && n.pitch.accidental.displayStatus !== false) {
      var mxAccidental = this.accidentalToMx(n.pitch.accidental);
      mxNote.appendChild(mxAccidental);
    }

    if (d.tuplets.length > 0) {
      // todo--nested tuplets;
      var mxTimeModification = this.tupletToTimeModification(d.tuplets[0]);
      mxNote.appendChild(mxTimeModification);
    }

    var stemDirection;

    if (!addChordTag && ![undefined, 'unspecified'].includes(chordOrN.stemDirection)) {
      stemDirection = chordOrN.stemDirection;
    } else if (chordOrN !== n && n instanceof _note__WEBPACK_IMPORTED_MODULE_11__["Note"] && ![undefined, 'unspecified'].includes(n.stemDirection)) {
      stemDirection = n.stemDirection;
    }

    if (stemDirection !== undefined) {
      var mxStem = this.subElement(mxNote, 'stem');
      var sdText = stemDirection;

      if (sdText === 'noStem') {
        sdText = 'none';
      }

      mxStem.innerHTML = sdText; // TODO: stemStyle
    } // dealWithNotehead
    // beams
    // staff
    // notations
    // tuplet display
    // notations


    if (!addChordTag) {
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = chordOrN.lyrics[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var lyricObj = _step11.value;

          if (lyricObj.text === undefined) {
            continue;
          }

          var mxLyric = this.lyricToXml(lyricObj);
          mxNote.appendChild(mxLyric);
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }
    }

    this.xmlRoot.appendChild(mxNote);
    return mxNote;
  }

  restToXml(r) {
    return this.noteToXml(r); // full measure
    // display-step, display-octave, etc.
  }

  chordToXml(c) {
    var mxNoteList = [];
    var _iteratorNormalCompletion12 = true;
    var _didIteratorError12 = false;
    var _iteratorError12 = undefined;

    try {
      for (var _iterator12 = Array.from(c).entries()[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
        var _step12$value = _slicedToArray(_step12.value, 2),
            i = _step12$value[0],
            n = _step12$value[1];

        var mxNote = this.noteToXml(n, {
          noteIndexInChord: i,
          chordParent: c
        });
        mxNoteList.push(mxNote);
      }
    } catch (err) {
      _didIteratorError12 = true;
      _iteratorError12 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
          _iterator12.return();
        }
      } finally {
        if (_didIteratorError12) {
          throw _iteratorError12;
        }
      }
    }

    return mxNoteList;
  }

  durationXml(dur) {
    var mxDuration = this.doc.createElement('duration');
    mxDuration.innerHTML = Math.round(this.currentDivisions * dur.quarterLength).toString();
    return mxDuration;
  }

  pitchToXml(p) {
    var mxPitch = this.doc.createElement('pitch');

    this._setTagTextFromAttribute(p, mxPitch, 'step');

    if (p.accidental !== undefined) {
      var mxAlter = this.subElement(mxPitch, 'alter');
      mxAlter.innerHTML = _common__WEBPACK_IMPORTED_MODULE_8__["numToIntOrFloat"](p.accidental.alter).toString();
    }

    this._setTagTextFromAttribute(p, mxPitch, 'octave', 'implicitOctave');

    return mxPitch;
  } // TODO(msc): fretNoteToXml
  // TODO(msc): fretBoardToXml
  // TODO(msc): chordWithFretBoardToXml


  tupletToTimeModification(tup) {
    var mxTimeModification = this.doc.createElement('time-modification');

    this._setTagTextFromAttribute(tup, mxTimeModification, 'actual-notes', 'numberNotesActual');

    this._setTagTextFromAttribute(tup, mxTimeModification, 'normal-notes', 'numberNotesNormal');

    if (tup.durationNormal !== undefined) {
      var mxNormalType = this.subElement(mxTimeModification, 'normal-type');
      mxNormalType.innerHTML = typeToMusicXMLType(tup.durationNormal.type);

      if (tup.durationNormal.dots > 0) {
        for (var i = 0; i < tup.durationNormal.dots; i++) {
          this.subElement(mxTimeModification, 'normal-dot');
        }
      }
    }

    return mxTimeModification;
  } // TODO(msc): dealWithNotehead
  // TODO(msc): noteheadToXml
  // TODO(msc): noteToNotations


  tieToXmlTie(t) {
    var mxTieList = [];
    var musicxmlTieType = t.type;

    if (t.type === 'continue') {
      musicxmlTieType = 'stop';
    }

    var mxTie = this.doc.createElement('tie');
    mxTie.setAttribute('type', musicxmlTieType);
    mxTieList.push(mxTie);

    if (t.type === 'continue') {
      var _mxTie = this.doc.createElement('tie');

      _mxTie.setAttribute('type', 'start');

      mxTieList.push(_mxTie);
    }

    return mxTieList;
  } // TODO(msc): tieToXmlTied -- needs notations
  // TODO(msc): tupletToXmlTuplet
  // TODO(msc): expressionToXml
  // TODO(msc): articulationToXmlArticulation
  // TODO(msc): setLineStyle
  // TODO(msc): articulationToXmlTechnical
  // TODO(msc): setHarmonic
  // TODO(msc): noChordToXml
  // TODO(msc): chordSymbolToXml
  // TODO(msc): setOffsetOptional
  // TODO(msc): placeInDirection
  // TODO(msc): dynamicToXml
  // TODO(msc): segnoToXml
  // TODO(msc): codaToXml
  // TODO(msc): tempoIndicationToXml
  // TODO(msc): rehearsalMarkToXml
  // TODO(msc): textExpressionToXml


  wrapObjectInAttributes(objectToWrap, methodToMx) {
    if (this.offsetInMeasure === 0.0) {
      return undefined;
    }

    var mxAttributes = this.doc.createElement('attributes');
    var mxObj = methodToMx(objectToWrap);
    mxAttributes.appendChild(mxObj);
    this.xmlRoot.appendChild(mxAttributes);
    return mxAttributes;
  }

  lyricToXml(l) {
    var mxLyric = this.doc.createElement('lyric');

    this._setTagTextFromAttribute(l, mxLyric, 'syllabic');

    this._setTagTextFromAttribute(l, mxLyric, 'text', 'text', {
      forceEmpty: true
    });

    if (l.identifier !== undefined) {
      mxLyric.setAttribute('name', l.identifier.toString());
    }

    if (l.number !== undefined) {
      mxLyric.setAttribute('number', l.number.toString());
    } else if (l.identifier !== undefined) {
      mxLyric.setAttribute('number', l.identifier.toString());
    } // setStyleAttributes
    // setPrintObject
    // setColor
    // setPosition


    return mxLyric;
  } // TODO(msc): beamsToXml
  // TODO(msc): beamToXml
  // TODO(msc): setRightBarline
  // TODO(msc): setLeftBarline
  // TODO(msc): setBarline
  // TODO(msc): barlineToXml
  // TODO(msc): repeatToXml


  setMxAttributesObjectForStartOfMeasure() {
    var m = this.stream;
    var mxAttributes = this.doc.createElement('attributes');
    var appendToRoot = false;
    this.currentDivisions = divisionsPerQuarter;

    if (this.parent === undefined || this.currentDivisions !== this.parent.lastDivisions) {
      var mxDivisions = this.subElement(mxAttributes, 'divisions');
      mxDivisions.innerHTML = this.currentDivisions.toString();
      this.parent.lastDivisions = this.currentDivisions;
      appendToRoot = true;
    }

    if (m.classes.includes('Measure')) {
      if (m._keySignature !== undefined) {
        mxAttributes.appendChild(this.keySignatureToXml(m._keySignature));
        appendToRoot = true;
      }

      if (m._timeSignature !== undefined) {
        mxAttributes.appendChild(this.timeSignatureToXml(m._timeSignature));
        appendToRoot = true;
      } // todo SenzaMisura...


      if (m._clef !== undefined) {
        mxAttributes.appendChild(this.clefToXml(m._clef));
        appendToRoot = true;
      }
    } // staffLayout
    // transpositionInterval
    // measureStyle


    if (appendToRoot) {
      this.xmlRoot.appendChild(mxAttributes);
    }

    return mxAttributes;
  } // TODO(msc): measureStyle
  // TODO(msc): staffLayoutToXmlStaffDetails


  timeSignatureToXml(ts) {
    var mxTime = this.doc.createElement('time'); // synchronizeIds
    // senzaMisura
    // summed denominators, compound etc.

    var mxBeats = this.subElement(mxTime, 'beats');
    mxBeats.innerHTML = ts.numerator.toString();
    var mxBeatType = this.subElement(mxTime, 'beat-type');
    mxBeatType.innerHTML = ts.denominator.toString(); // symbolizeDenominator
    // separator
    // style

    return mxTime;
  }

  keySignatureToXml(keyOrKeySignature) {
    var mxKey = this.doc.createElement('key'); // synchronizeIds
    // number
    // printStyle, print-object

    this.seta(keyOrKeySignature, mxKey, 'fifths', 'sharps');

    if (keyOrKeySignature.mode !== undefined) {
      this.seta(keyOrKeySignature, mxKey, 'mode');
    } // non-traditional
    // altered pitches


    return mxKey;
  }

  clefToXml(clefObj) {
    var mxClef = this.doc.createElement('clef'); // print-style

    var sign = clefObj.sign || 'G';
    var mxSign = this.subElement(mxClef, 'sign');
    mxSign.innerHTML = sign;
    this.seta(clefObj, mxClef, 'line');

    if (clefObj.octaveChange !== undefined && clefObj.octaveChange !== 0) {
      this.seta(clefObj, mxClef, 'clef-octave-change', 'octaveChange');
    }

    return mxClef;
  } // intervalToXmlTranspose
  // setMxPrint
  // staffLayoutToXmlPrint


  setMxAttributes() {
    var m = this.stream;
    this.xmlRoot.setAttribute('number', m.measureNumberWithSuffix()); // layoutWidth
  }

}

/***/ }),

/***/ "./src/music21/musicxml/xmlToM21.ts":
/*!******************************************!*\
  !*** ./src/music21/musicxml/xmlToM21.ts ***!
  \******************************************/
/*! exports provided: ScoreParser, PartParser, MeasureParser, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScoreParser", function() { return ScoreParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PartParser", function() { return PartParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeasureParser", function() { return MeasureParser; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../common */ "./src/music21/common.ts");
/* harmony import */ var _chord__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../chord */ "./src/music21/chord.ts");
/* harmony import */ var _clef__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../clef */ "./src/music21/clef.ts");
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../duration */ "./src/music21/duration.ts");
/* harmony import */ var _key__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../key */ "./src/music21/key.ts");
/* harmony import */ var _meter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../meter */ "./src/music21/meter.ts");
/* harmony import */ var _note__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../note */ "./src/music21/note.ts");
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../pitch */ "./src/music21/pitch.ts");
/* harmony import */ var _stream__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../stream */ "./src/music21/stream.ts");
/* harmony import */ var _tie__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../tie */ "./src/music21/tie.ts");
















var DEFAULTS = {
  divisionsPerQuarter: 32 * 3 * 3 * 5 * 7
};

function seta(m21El, xmlEl, tag) {
  var attributeName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var transform = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  var $matchEl = jquery__WEBPACK_IMPORTED_MODULE_5__(xmlEl).children(tag);

  if (!$matchEl) {
    return;
  }

  var value = $matchEl.contents().eq(0).text();

  if (value === undefined || value === '') {
    return;
  }

  if (transform !== undefined) {
    value = transform(value);
  }

  if (attributeName === undefined) {
    attributeName = Object(_common__WEBPACK_IMPORTED_MODULE_6__["hyphenToCamelCase"])(tag);
  }

  m21El[attributeName] = value;
}

class ScoreParser {
  constructor() {
    this.definesExplicitSystemBreaks = false;
    this.definesExplicitPageBreaks = false;
    this.mxScorePartDict = {};
    this.m21PartObjectsById = {};
    this.partGroupList = [];
    this.parts = [];
    this.musicXmlVersion = '1.0';
    this.stream = new _stream__WEBPACK_IMPORTED_MODULE_14__["Score"]();
  }

  scoreFromUrl(url) {
    this.xmlUrl = url; // noinspection JSUnusedLocalSymbols

    return jquery__WEBPACK_IMPORTED_MODULE_5__["get"](url, {}, (xmlDoc, textStatus) => this.scoreFromDOMTree(xmlDoc));
  }

  scoreFromText(xmlText) {
    this.xmlText = xmlText; // Not sure why this is not being found in jQuery
    // noinspection JSUnresolvedFunction

    var xmlDoc = jquery__WEBPACK_IMPORTED_MODULE_5__["parseXML"](xmlText);
    return this.scoreFromDOMTree(xmlDoc);
  }

  scoreFromDOMTree(xmlDoc) {
    this.$xmlRoot = jquery__WEBPACK_IMPORTED_MODULE_5__(jquery__WEBPACK_IMPORTED_MODULE_5__(xmlDoc).children('score-partwise'));
    this.xmlRootToScore(this.$xmlRoot, this.stream);
    return this.stream;
  }

  xmlRootToScore($mxScore, inputM21) {
    var s = inputM21;

    if (inputM21 === undefined) {
      s = new _stream__WEBPACK_IMPORTED_MODULE_14__["Score"]();
    } // version
    // defaults
    // credit


    this.parsePartList($mxScore);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = $mxScore.children('part')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var p = _step.value;
        var $p = jquery__WEBPACK_IMPORTED_MODULE_5__(p);
        var partId = $p.attr('id'); // if (partId === undefined) {
        //     partId = //something
        // }

        var $mxScorePart = this.mxScorePartDict[partId];
        var part = this.xmlPartToPart($p, $mxScorePart);

        if (part !== undefined) {
          // partStreams are undefined
          s.insert(0.0, part);
          this.m21PartObjectsById[partId] = part;
          this.parts.push(part);
        }
      } // partGroups;
      // spanners;
      // definesExplicitSystemBreaks, etc.
      // sort

    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return s;
  }

  xmlPartToPart($mxPart, $mxScorePart) {
    var parser = new PartParser($mxPart, $mxScorePart, this);
    parser.parse(); // handle partStreams

    return parser.stream;
  }

  parsePartList($mxScore) {
    var mxPartList = $mxScore.children('part-list');

    if (!mxPartList) {
      return;
    } // const openPartGroups = [];


    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = mxPartList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var partListElement = _step2.value;
        var $partListElement = jquery__WEBPACK_IMPORTED_MODULE_5__(partListElement);
        var partId = $partListElement.attr('id');
        this.mxScorePartDict[partId] = $partListElement;
      } // deal with part-groups

    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

}
/**
 * @property {MeasureParser|undefined} lastMeasureParser
 * @property {music21.meter.TimeSignature|undefined} lastTimeSignature
 * @property {jQuery|undefined} $activeAttributes
 */

class PartParser {
  constructor($mxPart, $mxScorePart) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    this.atSoundingPitch = true;
    this.staffReferenceList = [];
    this.lastTimeSignature = undefined;
    this.lastMeasureWasShort = false;
    this.lastMeasureOffset = 0.0;
    this.activeTuplets = [undefined, undefined, undefined, undefined, undefined, undefined, undefined];
    this.maxStaves = 1;
    this.lastMeasureNumber = 0;
    this.lastNumberSuffix = undefined;
    this.multiMeasureRestsToCapture = 0;
    this.activeMultimeasureRestSpanner = undefined;
    this.activeInstrument = undefined;
    this.firstMeasureParsed = false;
    this.$activeAttributes = undefined;
    this.lastDivisions = DEFAULTS.divisionsPerQuarter;
    this.appendToScoreAfterParse = true;
    this.lastMeasureParser = undefined;
    this.parent = parent;
    this.$mxPart = $mxPart;
    this.$mxScorePart = $mxScorePart; // ignore parent for now

    if ($mxPart !== undefined) {
      this.partId = $mxPart.attr('id'); // ignore empty partId for now
    } // TODO(msc): spannerBundles


    this.stream = new _stream__WEBPACK_IMPORTED_MODULE_14__["Part"]();
    this.lastClefs = {
      0: new _clef__WEBPACK_IMPORTED_MODULE_8__["TrebleClef"]()
    };
  }

  parse() {
    this.parseXmlScorePart();
    this.parseMeasures(); // atSoundingPitch;
    // spannerBundles
    // partStaves;

    this.stream.clef = this.lastClefs[0];
  }

  parseXmlScorePart() {
    var part = this.stream;
    var $mxScorePart = this.$mxScorePart;
    seta(part, $mxScorePart, 'part-name'); // todo -- clean string
    // remainder of part names
    // instruments
  }

  parseMeasures() {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this.$mxPart.children('measure')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var mxMeasure = _step3.value;
        var $mxMeasure = jquery__WEBPACK_IMPORTED_MODULE_5__(mxMeasure);
        this.xmlMeasureToMeasure($mxMeasure);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    if (this.lastMeasureParser !== undefined) {
      this.lastMeasureParser.parent = undefined; // gc.
    }
  }

  xmlMeasureToMeasure($mxMeasure) {
    var measureParser = new MeasureParser($mxMeasure, this);
    measureParser.parse();

    if (this.lastMeasureParser !== undefined) {
      this.lastMeasureParser.parent = undefined; // gc.
    }

    this.lastMeasureParser = measureParser; // max staves
    // transposition

    this.firstMeasureParsed = true; // staffReferenceList

    var m = measureParser.stream;
    this.setLastMeasureInfo(m); // fullMeasureRests
    // TODO: offsets!!!
    // this.stream.insert(this.lastMeasureOffset, m);

    this.stream.append(m);
    this.adjustTimeAttributesFromMeasure(m);
  }

  setLastMeasureInfo(m) {
    if (m.number !== this.lastMeasureNumber) {
      this.lastMeasureNumber = m.number;
      this.lastNumberSuffix = m.numberSuffix;
    }

    if (m.timeSignature !== undefined) {
      this.lastTimeSignature = m.timeSignature;
    } else if (this.lastTimeSignature === undefined) {
      this.lastTimeSignature = new _meter__WEBPACK_IMPORTED_MODULE_11__["TimeSignature"]('4/4');
    }
  }

  adjustTimeAttributesFromMeasure(m) {
    var mHighestTime = m.highestTime; // ignore incomplete measures.

    var mOffsetShift = mHighestTime;
    this.lastMeasureOffset += mOffsetShift;
  }

}
class MeasureParser {
  /**
   *
   * @param {jQuery} $mxMeasure
   * @param {PartParser} [parent]
   * @property {music21.note.GeneralNote|undefined} nLast
   * @property {jQuery|undefined} $activeAttributes
   */
  constructor($mxMeasure) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    this.$mxMeasureElements = [];
    this.divisions = undefined;
    this.transposition = undefined; // spannerBundles

    this.staffReference = {}; // activeTuplets

    this.useVoices = false;
    this.voicesById = {};
    this.staves = 1;
    this.$activeAttributes = undefined;
    this.attributesAreInternal = true;
    this.measureNumber = undefined;
    this.numberSuffix = undefined;
    this.staffLayoutObjects = [];
    this.$mxNoteList = [];
    this.$mxLyricList = [];
    this.nLast = undefined;
    this.chordVoice = undefined;
    this.fullMeasureRest = false;
    this.restAndNoteCount = {
      rest: 0,
      note: 0
    };
    this.lastClefs = {
      0: undefined
    };
    this.parseIndex = 0;
    this.offsetMeasureNote = 0.0; // class attributes in m21p

    this.attributeTagsToMethods = {
      time: 'handleTimeSignature',
      clef: 'handleClef',
      key: 'handleKeySignature'
    };
    this.musicDataMethods = {
      note: 'xmlToNote',
      // 'backup': 'xmlBackup',
      // 'forward': 'xmlForward',
      // 'direction': 'xmlDirection',
      attributes: 'parseAttributesTag'
    };
    this.$mxMeasure = $mxMeasure;
    this.parent = parent;
    this.stream = new _stream__WEBPACK_IMPORTED_MODULE_14__["Measure"]();
    this.voiceIndices = new Set();
    this.staves = 1;
    this.$activeAttributes = undefined;
    this.attributesAreInternal = true;

    if (parent !== undefined) {
      this.divisions = parent.lastDivisions;
    } else {
      this.divisions = DEFAULTS.divisionsPerQuarter;
    }
  }

  parse() {
    // mxPrint
    this.parseMeasureAttributes(); // updateVoiceInformation;

    var children = this.$mxMeasure.children();
    this.$mxMeasureElements = [];
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = children[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var c = _step4.value;
        var $c = jquery__WEBPACK_IMPORTED_MODULE_5__(c);
        this.$mxMeasureElements.push($c);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    var i = 0;
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = this.$mxMeasureElements[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var $mxObj = _step5.value;
        var tag = $mxObj[0].tagName;
        this.parseIndex = i;
        var methName = this.musicDataMethods[tag];

        if (methName !== undefined) {
          this[methName]($mxObj);
        }

        i += 1;
      } // useVoices
      // fullMeasureRest

    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
  }

  insertInMeasureOrVoice($mxObj, el) {
    // TODO: offsets!
    // this.stream.insert(this.offsetMeasureNote, el);
    this.stream.append(el);
  }

  xmlToNote($mxNote) {
    var nextNoteIsChord = false;
    var $mxObjNext = this.$mxMeasureElements[this.parseIndex + 1];

    if ($mxObjNext !== undefined) {
      if ($mxObjNext[0].tagName === 'note' && $mxObjNext.children('chord').length > 0) {
        nextNoteIsChord = true;
      }
    }

    var isChord = false;
    var isRest = false;
    var offsetIncrement = 0.0;

    if ($mxNote.children('rest').length > 0) {
      isRest = true;
    }

    if ($mxNote.children('chord').length > 0) {
      isChord = true;
    }

    if (nextNoteIsChord) {
      isChord = true;
    }

    var n;

    if (isChord) {
      this.$mxNoteList.push($mxNote);
      this.$mxLyricList.push(...$mxNote.children('lyric'));
    } else if (!isChord && !isRest) {
      // normal note
      this.restAndNoteCount.note += 1;
      n = this.xmlToSimpleNote($mxNote);
    } else {
      this.restAndNoteCount.rest += 1;
      n = this.xmlToRest($mxNote);
    }

    if (!isChord) {
      this.updateLyricsFromList(n, $mxNote.children('lyric')); // add to staffReference

      this.insertInMeasureOrVoice($mxNote, n);
      offsetIncrement = n.duration.quarterLength;
      this.nLast = n;
    }

    if (this.$mxNoteList.length && !nextNoteIsChord) {
      var c = this.xmlToChord(this.$mxNoteList);
      this.updateLyricsFromList(c, this.$mxLyricList); // addToStaffRest;
      // voices;

      this.insertInMeasureOrVoice($mxNote, c);
      this.$mxNoteList = [];
      this.$mxLyricList = [];
      offsetIncrement = c.duration.quarterLength;
      this.nLast = c;
    }

    this.offsetMeasureNote += offsetIncrement;
  }

  xmlToChord($mxNoteList) {
    var notes = [];
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = $mxNoteList[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var $mxNote = _step6.value;
        var freeSpanners = false;
        notes.push(this.xmlToSimpleNote($mxNote, freeSpanners));
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    var c = new _chord__WEBPACK_IMPORTED_MODULE_7__["Chord"](notes); // move beams from first note;
    // move articulations;
    // move expressions;
    // move spanners;

    return c;
  }

  xmlToSimpleNote($mxNote) {
    var freeSpanners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var n = new _note__WEBPACK_IMPORTED_MODULE_12__["Note"]();
    this.xmlToPitch($mxNote, n.pitch); // beams;
    // stems;
    // noteheads

    return this.xmlNoteToGeneralNoteHelper(n, $mxNote, freeSpanners);
  } // xmlToBeam
  // xmlToBeams
  // xmlNotehead


  xmlToPitch($mxNote, inputM21) {
    var p = inputM21;

    if (inputM21 === undefined) {
      p = new _pitch__WEBPACK_IMPORTED_MODULE_13__["Pitch"]();
    }

    var $mxPitch;

    if ($mxNote[0].tagName === 'pitch') {
      $mxPitch = $mxNote;
    } else {
      $mxPitch = jquery__WEBPACK_IMPORTED_MODULE_5__($mxNote.children('pitch')[0]);

      if ($mxPitch.length === 0) {
        // whoops!
        return p;
      }
    }

    seta(p, $mxPitch, 'step');
    seta(p, $mxPitch, 'octave', undefined, parseInt);
    var $mxAlter = $mxPitch.children('alter');
    var accAlter;

    if ($mxAlter.length) {
      accAlter = parseFloat($mxAlter.text().trim());
    }

    var $mxAccidental = $mxNote.children('accidental'); // dropping support for musescore 0.9 errors...

    if ($mxAccidental.length) {
      var accObj = this.xmlToAccidental($mxAccidental);
      p.accidental = accObj;
      p.accidental.displayStatus = true; // independent accidental from alter
    } else if (accAlter !== undefined && !Number.isNaN(Number(accAlter))) {
      p.accidental = new _pitch__WEBPACK_IMPORTED_MODULE_13__["Accidental"](accAlter);
      p.accidental.displayStatus = false;
    }

    return p;
  }

  xmlToAccidental($mxAccidental) {
    var acc = new _pitch__WEBPACK_IMPORTED_MODULE_13__["Accidental"](0); // to-do m21/musicxml accidental name differences;

    var name = jquery__WEBPACK_IMPORTED_MODULE_5__($mxAccidental[0]).text().trim().toLowerCase();

    if (name === 'flat-flat') {
      name = 'double-flat';
    }

    acc.set(name); // set print style
    // parentheses
    // bracket
    // editorial

    return acc;
  }

  xmlToRest($mxRest) {
    var r = new _note__WEBPACK_IMPORTED_MODULE_12__["Rest"](); // full measure rest
    // apply multi-measure rest
    // display-step, octave, etc.

    return this.xmlNoteToGeneralNoteHelper(r, $mxRest);
  } // noinspection JSUnusedLocalSymbols


  xmlNoteToGeneralNoteHelper(n, $mxNote) {
    var freeSpanners = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // spanners
    // setPrintStyle
    // print-object
    // dynamics
    // pizzicato
    // grace
    this.xmlToDuration($mxNote, n.duration); // type styles
    // color
    // position

    if ($mxNote.children('tie').length > 0) {
      n.tie = this.xmlToTie($mxNote);
    } // grace
    // notations
    // editorial


    return n;
  }

  xmlToDuration($mxNote, inputM21) {
    var d = inputM21;

    if (inputM21 === undefined) {
      d = new _duration__WEBPACK_IMPORTED_MODULE_9__["Duration"]();
    }

    var divisions = this.divisions;
    var mxDuration = $mxNote.children('duration')[0];
    var qLen = 0.0;

    if (mxDuration) {
      var noteDivisions = parseFloat(jquery__WEBPACK_IMPORTED_MODULE_5__(mxDuration).text().trim());
      qLen = noteDivisions / divisions;
    }

    var mxType = $mxNote.children('type')[0];

    if (mxType) {
      // long vs longa todo
      var durationType = jquery__WEBPACK_IMPORTED_MODULE_5__(mxType).text().trim();
      var numDots = $mxNote.children('dot').length; // tuplets!!!! big to-do!

      d.type = durationType;
      d.dots = numDots;
    } else {
      d.quarterLength = qLen;
    }

    return d;
  } // xmlGraceToGrace
  // xmlNotations
  // xmlTechnicalToArticulation
  // setHarmonic
  // handleFingering
  // xmlToArticulation
  // xmlOrnamentToExpression
  // xmlDirectionTypeToSpanners
  // xmlNotationsToSpanners
  // xmlToTremolo
  // xmlOneSpanner

  /**
   *
   * @param {jQuery} $mxNote
   * @returns {music21.tie.Tie}
   */


  xmlToTie($mxNote) {
    var t = new _tie__WEBPACK_IMPORTED_MODULE_15__["Tie"]();
    var allTies = $mxNote.children('tie');

    if (allTies.length > 1) {
      t.type = 'continue';
    } else {
      var $t0 = jquery__WEBPACK_IMPORTED_MODULE_5__(allTies[0]);
      t.type = $t0.attr('type');
    } // style


    return t;
  } // xmlToTuplets


  updateLyricsFromList(n, lyricList) {
    var currentLyricNumber = 1;
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = lyricList[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var mxLyric = _step7.value;
        var lyricObj = this.xmlToLyric(jquery__WEBPACK_IMPORTED_MODULE_5__(mxLyric));

        if (lyricObj === undefined) {
          continue;
        }

        if (lyricObj.number === 0) {
          lyricObj.number = currentLyricNumber;
        }

        n.lyrics.push(lyricObj);
        currentLyricNumber += 1;
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }
  }
  /**
   *
   * @param {jQuery} $mxLyric
   * @param {music21.note.Lyric} [inputM21]
   * @returns {*|music21.note.Lyric|undefined}
   */


  xmlToLyric($mxLyric) {
    var inputM21 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var l = inputM21;

    if (inputM21 === undefined) {
      l = new _note__WEBPACK_IMPORTED_MODULE_12__["Lyric"]('');
    }

    try {
      l.text = $mxLyric.children('text').text().trim();
    } catch (exc) {
      return undefined; // sometimes there are empty lyrics.
    }

    var number = $mxLyric.attr('number');

    try {
      number = parseInt(number);
      l.number = number;
    } catch (exc) {
      l.number = 0;

      if (number !== undefined) {
        l.identifier = number;
      }
    }

    var identifier = $mxLyric.get('name');

    if (identifier !== undefined) {
      l.identifier = identifier;
    }

    var $mxSyllabic = $mxLyric.children('syllabic');

    if ($mxSyllabic.length) {
      l.syllabic = $mxSyllabic.text().trim();
    } // setStyleAttributes
    // setColor
    // setPosition


    if (inputM21 === undefined) {
      return l;
    }

    return undefined;
  }

  insertIntoMeasureOrVoice($mxElement, el) {
    this.stream.insert(this.offsetMeasureNote, el);
  }

  parseMeasureAttributes() {
    this.parseMeasureNumbers(); // width;
  }

  parseMeasureNumbers() {
    var mNumRaw = this.$mxMeasure.attr('number');
    var mNum = parseInt(mNumRaw); // no suffixes...

    this.stream.number = mNum;

    if (this.parent) {
      this.parent.lastMeasureNumber = mNum;
    }

    this.measureNumber = mNum;
  }

  parseAttributesTag($mxAttributes) {
    this.attributesAreInternal = false;
    this.$activeAttributes = $mxAttributes;
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = $mxAttributes.children()[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var mxSub = _step8.value;
        var tag = mxSub.tagName;
        var $mxSub = jquery__WEBPACK_IMPORTED_MODULE_5__(mxSub);
        var methName = this.attributeTagsToMethods[tag];

        if (methName !== undefined) {
          this[methName]($mxSub);
        } else if (tag === 'staves') {
          this.staves = parseInt($mxSub.text());
        } else if (tag === 'divisions') {
          this.divisions = parseFloat($mxSub.text());
        } // transpose;

      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }

    if (this.parent !== undefined) {
      this.parent.lastDivisions = this.divisions;
      this.parent.$activeAttributes = this.$activeAttributes;
    }
  } // xmlTransposeToInterval


  handleTimeSignature($mxTime) {
    var ts = this.xmlToTimeSignature($mxTime);
    this.insertIntoMeasureOrVoice($mxTime, ts);
  }

  xmlToTimeSignature($mxTime) {
    // senza-misura
    // simple time signature only;
    var numerator = jquery__WEBPACK_IMPORTED_MODULE_5__($mxTime.children('beats')[0]).text().trim();
    var denominator = jquery__WEBPACK_IMPORTED_MODULE_5__($mxTime.children('beat-type')[0]).text().trim();
    return new _meter__WEBPACK_IMPORTED_MODULE_11__["TimeSignature"](numerator + '/' + denominator); // symbol
  }

  handleClef($mxClef) {
    var clefObj = this.xmlToClef($mxClef);
    this.stream.clef = clefObj;
    this.insertIntoMeasureOrVoice($mxClef, clefObj);
    this.lastClefs[0] = clefObj; // if (this.parent !== undefined) {
    //     this.parent.lastClefs[0] = clefObj.clone(true);
    // }
  }

  xmlToClef($mxClef) {
    var sign = jquery__WEBPACK_IMPORTED_MODULE_5__($mxClef.children('sign')[0]).text().trim(); // TODO: percussion, etc.

    var line = jquery__WEBPACK_IMPORTED_MODULE_5__($mxClef.children('line')[0]).text().trim();
    var clefOctaveChange = 0;
    var $coc = $mxClef.children('clef-octave-change');

    if ($coc.length > 0) {
      clefOctaveChange = parseInt(jquery__WEBPACK_IMPORTED_MODULE_5__($coc[0]).text().trim());
    }

    return _clef__WEBPACK_IMPORTED_MODULE_8__["clefFromString"](sign + line, clefOctaveChange);
  }

  handleKeySignature($mxKey) {
    var keySig = this.xmlToKeySignature($mxKey);
    this.insertIntoMeasureOrVoice($mxKey, keySig);
  }

  xmlToKeySignature($mxKey) {
    var ks = new _key__WEBPACK_IMPORTED_MODULE_10__["KeySignature"]();
    seta(ks, $mxKey, 'fifths', 'sharps', parseInt); // mode!
    // non-standard and key-octaves

    return ks;
  }

}
var musicxml = {
  ScoreParser,
  PartParser,
  MeasureParser
};
/* harmony default export */ __webpack_exports__["default"] = (musicxml);

/***/ }),

/***/ "./src/music21/note.ts":
/*!*****************************!*\
  !*** ./src/music21/note.ts ***!
  \*****************************/
/*! exports provided: NotRestException, noteheadTypeNames, stemDirectionNames, Lyric, GeneralNote, NotRest, Note, Rest */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotRestException", function() { return NotRestException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noteheadTypeNames", function() { return noteheadTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stemDirectionNames", function() { return stemDirectionNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lyric", function() { return Lyric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GeneralNote", function() { return GeneralNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotRest", function() { return NotRest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Note", function() { return Note; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Rest", function() { return Rest; });
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vexflow */ "./node_modules/vexflow/releases/vexflow-debug.js");
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vexflow__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! midicube */ "./node_modules/midicube/releases/midicube.js");
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(midicube__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _prebase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./prebase */ "./src/music21/prebase.ts");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./pitch */ "./src/music21/pitch.ts");
/* harmony import */ var _beam__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./beam */ "./src/music21/beam.ts");
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./debug */ "./src/music21/debug.ts");
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");



/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/note -- Note, Rest, NotRest, GeneralNote
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (music21p), Copyright (c) 2006–19, Michael Scott Cuthbert and cuthbertLab
 *
 * Module for note classes. See the namespace {@link music21.note}
 *
 * @requires music21/prebase
 * @requires music21/base
 * @requires music21/pitch
 * @requires music21/beam
 * @exports music21/note
 * Namespace for notes (single pitch) or rests, and some things like Lyrics that go on notes.
 *
 * @namespace music21.note
 * @memberof music21
 * @property {string[]} noteheadTypeNames - an Array of allowable notehead names.
 * @property {string[]} stemDirectionNames - an Array of allowable stemDirection names.
 */








class NotRestException extends _exceptions21__WEBPACK_IMPORTED_MODULE_9__["Music21Exception"] {} // noinspection JSUnusedGlobalSymbols

var noteheadTypeNames = ['arrow down', 'arrow up', 'back slashed', 'circle dot', 'circle-x', 'circled', 'cluster', 'cross', 'diamond', 'do', 'fa', 'inverted triangle', 'la', 'left triangle', 'mi', 'none', 'normal', 'other', 're', 'rectangle', 'slash', 'slashed', 'so', 'square', 'ti', 'triangle', 'x'];
var stemDirectionNames = ['double', 'down', 'noStem', 'none', 'unspecified', 'up'];
/**
 * Class for a single Lyric attached to a {@link GeneralNote}
 *
 * @class Lyric
 * @memberOf music21.note
 * @param {string} text - the text of the lyric
 * @param {number} number=1 - the lyric number
 * @param {string} syllabic=undefined - placement of the syllable
 *     ('begin', 'middle', 'end', 'single'); undefined = interpret from text
 * @param {boolean} applyRaw=false - true = display the text exactly as it
 *     is or, false = use "-" etc. to determine syllabic
 * @param {string} identifier=undefined - identifier for the lyric.
 * @property {string} lyricConnector='-' - what to place between two
 *     lyrics that are syllabic.
 * @property {string} text - the text of the lyric syllable.
 * @property {string} syllabic - see above
 * @property {boolean} applyRaw - see above
 * @property {string} identifier - see above; gets .number if undefined
 * @property {number} number - see above
 * @property {string} rawText - text + any connectors
 */

class Lyric extends _prebase__WEBPACK_IMPORTED_MODULE_4__["ProtoM21Object"] {
  constructor(text) {
    var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var syllabic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var applyRaw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    var identifier = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    super();
    this.lyricConnector = '-'; // override to place something else between two notes...

    this.text = text;
    this._number = number;
    this.syllabic = syllabic;
    this.applyRaw = applyRaw !== null && applyRaw !== void 0 ? applyRaw : false;
    this.setTextAndSyllabic(this.text, this.applyRaw);
    this._identifier = identifier;
    this.style = {
      fillStyle: 'black',
      strokeStyle: 'black',
      fontFamily: 'Serif',
      fontSize: 12,
      fontWeight: ''
    };
  }

  static get className() {
    return 'music21.note.Lyric';
  }

  get identifier() {
    return this._identifier || this._number;
  }

  set identifier(i) {
    this._identifier = i;
  } // a property just to match m21p


  get number() {
    return this._number;
  }

  set number(n) {
    this._number = n;
  } // noinspection JSUnusedGlobalSymbols

  /**
   * get rawText - gets the raw text.
   *
   * @return {string}  raw text
   */


  get rawText() {
    if (this.syllabic === 'begin') {
      return this.text + this.lyricConnector;
    } else if (this.syllabic === 'middle') {
      return this.lyricConnector + this.text + this.lyricConnector;
    } else if (this.syllabic === 'end') {
      return this.lyricConnector + this.text;
    } else {
      return this.text;
    }
  } // noinspection JSUnusedGlobalSymbols


  set rawText(t) {
    this.setTextAndSyllabic(t, true);
  }
  /**
   * setTextAndSyllabic - Given a setting for rawText and applyRaw,
   *     sets the syllabic type for a lyric based on the rawText
   *
   * @param  {string} rawText text
   * @param  {boolean} applyRaw = false if hyphens should not be applied
   * @return {this}
   */


  setTextAndSyllabic(rawText) {
    var applyRaw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (rawText === undefined) {
      this.text = undefined;
      return this;
    }

    if (!applyRaw && rawText.indexOf(this.lyricConnector) === 0 && rawText.slice(-1) === this.lyricConnector) {
      this.text = rawText.slice(1, -1);
      this.syllabic = 'middle';
    } else if (!applyRaw && rawText.indexOf(this.lyricConnector) === 0) {
      this.text = rawText.slice(1);
      this.syllabic = 'end';
    } else if (!applyRaw && rawText.slice(-1) === this.lyricConnector) {
      this.text = rawText.slice(0, -1);
      this.syllabic = 'begin';
    } else {
      this.text = rawText;

      if (this.syllabic === undefined) {
        this.syllabic = 'single';
      }
    }

    return this;
  }

}
/* Notes and rests etc... */

/**
 * Superclass for all Note values
 *
 * @class GeneralNote
 * @memberof music21.note
 * @param {(number|undefined)} [ql=1.0] - quarterLength of the note
 * @property {boolean} [isChord=false] - is this a chord
 * @property {number} quarterLength - shortcut to `.duration.quarterLength`
 * @property {Vex.Flow.StaveNote} [activeVexflowNote] - most recent
 *     Vex.Flow.StaveNote object to be made from this note (could change);
 *     default: undefined
 * @property {Array<music21.expressions.Expression>} expressions - array
 *     of attached expressions
 * @property {Array<music21.articulations.Articulation>} articulations - array
 *     of attached articulations
 * @property {string} lyric - the text of the first
 *     {@link Lyric} object; can also set one.
 * @property {Array<Lyric>} lyrics - array of attached lyrics
 * @property {number} [volume=60] - how loud is this note, 0-127, before
 *     articulations
 * @property {number} midiVolume - how loud is this note, taking into
 *     account articulations
 * @property {music21.tie.Tie|undefined} [tie=undefined] - a tie object
 */

class GeneralNote extends _base__WEBPACK_IMPORTED_MODULE_5__["Music21Object"] {
  constructor() {
    var ql = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.0;
    super();
    this.isNote = false;
    this.isRest = false;
    this.isChord = false;
    this.volume = 60;
    this.expressions = [];
    this.articulations = [];
    this.lyrics = [];
    this.duration.quarterLength = ql;
    /* TODO: editorial objects, style(color), addLyric, insertLyric, hasLyrics */

    /* Later: augmentOrDiminish, getGrace, */
  }

  static get className() {
    return 'music21.note.GeneralNote';
  }

  get lyric() {
    if (this.lyrics.length > 0) {
      return this.lyrics[0].text;
    } else {
      return undefined;
    }
  }

  set lyric(value) {
    this.lyrics = [];

    if (value !== undefined) {
      this.lyrics.push(new Lyric(value));
    }
  }

  get midiVolume() {
    var volume = this.volume;

    if (volume === undefined) {
      volume = 60;
    }

    if (this.articulations !== undefined) {
      this.articulations.forEach(a => {
        volume *= a.dynamicScale;

        if (volume > 127) {
          volume = 127;
        } else if (Number.isNaN(volume)) {
          volume = 60;
        }
      });
    }

    volume = Math.floor(volume);
    return volume;
  } // noinspection JSUnusedGlobalSymbols

  /**
   * Add a {@link Lyric} object to the Note
   *
   * @param {string} text - text to be added
   * @param {number} [lyricNumber] - integer specifying lyric (defaults to the current `.lyrics.length` + 1)
   * @param {boolean} [applyRaw=false] - if `true`, do not parse the text for cluses about syllable placement.
   * @param {string} [lyricIdentifier] - an optional identifier
   */


  addLyric(text, lyricNumber) {
    var applyRaw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var lyricIdentifier = arguments.length > 3 ? arguments[3] : undefined;

    if (lyricNumber === undefined) {
      var maxLyrics = this.lyrics.length + 1;
      var newLyric = new Lyric(text, maxLyrics, undefined, applyRaw, lyricIdentifier);
      this.lyrics.push(newLyric);
    } else {
      var foundLyric = false;

      for (var i = 0; i < this.lyrics.length; i++) {
        var thisLyric = this.lyrics[i];

        if (thisLyric.number === lyricNumber) {
          thisLyric.text = text;
          foundLyric = true;
          break;
        }
      }

      if (foundLyric === false) {
        var _newLyric = new Lyric(text, lyricNumber, undefined, applyRaw, lyricIdentifier);

        this.lyrics.push(_newLyric);
      }
    }
  }
  /**
   * Change stem direction according to clef. Does nothing for GeneralNote; overridden in subclasses.
   *
   * @param {music21.clef.Clef} [clef] - clef to set the stem direction of.
   * @returns {this}
   */


  setStemDirectionFromClef(clef) {
    return this;
  }

  getStemDirectionFromClef(clef) {
    return undefined;
  }
  /**
   * Sets the vexflow accidentals (if any), the dots, and the stem direction
   *
   * @param {Vex.Flow.StaveNote} vfn - a Vex.Flow note
   * @param {Object} options -- a set of Vex Flow options
   */


  vexflowAccidentalsAndDisplay(vfn) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (this.duration.dots > 0) {
      for (var i = 0; i < this.duration.dots; i++) {
        vfn.addDotToAll();
      }
    }
  }
  /**
   * Return the active channel for the instrument or activeSite's instrument
   * @param instrument
   */


  activeChannel() {
    var instrument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    if (instrument === undefined) {
      if (this.activeSite !== undefined) {
        instrument = this.activeSite.instrument;
      }
    }

    var channel = 0;

    if (instrument !== undefined) {
      channel = instrument.midiChannel;
    }

    return channel;
  }
  /**
   * Play the current element as a MIDI note.
   *
   * For a general note -- same as a rest -- doesn't make a sound.  :-)
   *
   * @param {number} [tempo=120] - tempo in bpm
   * @param {base.Music21Object} [nextElement] - for determining
   *     the length to play in case of tied notes, etc.
   * @param {Object} [options] - other options (currently just
   *     `{instrument: {@link music21.instrument.Instrument} }`)
   * @returns {number} - delay time in milliseconds until the next element (may be ignored)
   */


  playMidi() {
    var tempo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 120;
    var nextElement = arguments.length > 1 ? arguments[1] : undefined;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$instrument = _ref.instrument,
        instrument = _ref$instrument === void 0 ? undefined : _ref$instrument,
        _ref$channel = _ref.channel,
        channel = _ref$channel === void 0 ? undefined : _ref$channel;

    // returns the number of milliseconds to the next element in
    // case that can't be determined otherwise.
    var ql = this.duration.quarterLength;
    var milliseconds = 60 * ql * 1000 / tempo;
    return milliseconds;
  }

}
/**
 * Specifies that a GeneralNote is not a rest (Unpitched, Note, Chord).
 *
 * @param {number} [ql=1.0] - length in quarter notes
 * @property {music21.beam.Beams} beams - a link to a beam object
 * @property {string} [notehead='normal'] - notehead type
 * @property {string} [noteheadFill='default'] - notehead fill (to be moved to style...)
 * @property {string|undefined} [noteheadColor=undefined] - notehead color
 * @property {boolean} [noteheadParenthesis=false] - put a parenthesis around the notehead?
 * @property {string|undefined} [stemDirection=undefined] - One of
 *     ['up','down','noStem', undefined] -- 'double' not supported
 */

class NotRest extends GeneralNote {
  constructor() {
    var ql = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.0;
    super(ql); // noinspection JSUnusedGlobalSymbols

    this.notehead = 'normal'; // noinspection JSUnusedGlobalSymbols

    this.noteheadFill = 'default';
    this.noteheadColor = 'black';
    this.noteheadParenthesis = false;
    this.volume = undefined; // not a real object yet.

    this._stemDirection = 'unspecified';
    this.beams = new _beam__WEBPACK_IMPORTED_MODULE_7__["Beams"]();
    /* TODO: this.duration.linkage -- need durationUnits */

    /* TODO: check notehead, noteheadFill, noteheadParentheses */
  }

  static get className() {
    return 'music21.note.NotRest';
  }

  get stemDirection() {
    return this._stemDirection;
  }

  set stemDirection(direction) {
    if (direction === undefined) {
      direction = 'unspecified';
    } else if (direction === 'none') {
      direction = 'noStem';
    } else if (!stemDirectionNames.includes(direction)) {
      throw new NotRestException("not a valid stem direction name: ".concat(direction));
    }

    this._stemDirection = direction;
  }

}
/* ------- Note ----------- */

/**
 * A very, very important class! music21.note.Note objects combine a {@link music21.pitch.Pitch}
 * object to describe pitch (highness/lowness) with a {@link music21.duration.Duration} object
 * that defines length, with additional features for drawing the Note, playing it back, etc.
 *
 * Together with {@link Stream} one of the two most important
 * classes in `music21`.
 *
 * See {@link NotRest}, {@link GeneralNote},
 * {@link base.Music21Object}
 * and {@link prebase.ProtoM21Object} (or in general, the **extends** list below) for other
 * things you can do with a `Note` object.
 *
 * Missing from music21p: `transpose(), fullName`.  Transpose cannot be added because of circular imports
 *
 * @class Note
 * @memberof music21.note
 */

class Note extends NotRest {
  /**
   *
   * @param {(string|music21.pitch.Pitch|undefined)} [nn='C4'] - pitch
   *     name ("C", "D#", "E-") w/ or w/o octave ("C#4"), or a pitch.Pitch object
   * @param {(number|undefined)} [ql=1.0] - length in quarter notes
   * @property {boolean} [isNote=true] - is it a Note? Yes!
   * @property {boolean} [isRest=false] - is it a Rest? No!
   * @property {music21.pitch.Pitch} pitch - the {@link music21.pitch.Pitch} associated with the Note.
   * @property {string} name - shortcut to `.pitch.name`
   * @property {string} nameWithOctave - shortcut to `.pitch.nameWithOctave`
   * @property {string} step - shortcut to `.pitch.step`
   * @property {number} octave - shortcut to `.pitch.octave`
   */
  constructor() {
    var nn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'C4';
    var ql = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.0;
    super(ql); // noinspection JSUnusedGlobalSymbols

    this.isNote = true;
    this.isRest = false;

    if (nn instanceof _pitch__WEBPACK_IMPORTED_MODULE_6__["Pitch"]) {
      this.pitch = nn;
    } else {
      this.pitch = new _pitch__WEBPACK_IMPORTED_MODULE_6__["Pitch"](nn);
    }
  }

  static get className() {
    return 'music21.note.Note';
  }
  /**
   *
   * @returns {string}
   */


  stringInfo() {
    return this.name;
  }
  /**
   *
   * @type {string}
   */


  get name() {
    return this.pitch.name;
  }

  set name(nn) {
    this.pitch.name = nn;
  }
  /**
   *
   * @type {string}
   */


  get nameWithOctave() {
    return this.pitch.nameWithOctave;
  }

  set nameWithOctave(nn) {
    this.pitch.nameWithOctave = nn;
  }
  /**
   *
   * @type {string}
   */


  get step() {
    return this.pitch.step;
  }

  set step(nn) {
    this.pitch.step = nn;
  }
  /**
   *
   * @type {number}
   */


  get octave() {
    return this.pitch.octave;
  }

  set octave(nn) {
    this.pitch.octave = nn;
  }
  /**
   *
   * @returns {music21.pitch.Pitch[]}
   */


  get pitches() {
    return [this.pitch];
  }

  set pitches(value) {
    this.pitch = value[0]; // TODO: raise NoteException on index error.
  }
  /* TODO: transpose, fullName */

  /**
   * Change stem direction according to clef.
   *
   * @param {music21.clef.Clef} [clef] - clef to set the stem direction of.
   * @returns {this} Original object, for chaining methods
   */


  setStemDirectionFromClef(clef) {
    if (clef !== undefined) {
      this.stemDirection = this.getStemDirectionFromClef(clef);
    }

    return this;
  }
  /**
   * Same as setStemDirectionFromClef, but do not set the note, just return it.
   */


  getStemDirectionFromClef(clef) {
    if (clef === undefined) {
      return undefined;
    }

    var midLine = clef.lowestLine + 4;
    var DNNFromCenter = this.pitch.diatonicNoteNum - midLine; // console.log(DNNFromCenter, this.pitch.nameWithOctave);

    if (DNNFromCenter >= 0) {
      return 'down';
    } else {
      return 'up';
    }
  }

  vexflowAccidentalsAndDisplay(vfn) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$stave = _ref2.stave,
        stave = _ref2$stave === void 0 ? undefined : _ref2$stave,
        _ref2$clef = _ref2.clef,
        clef = _ref2$clef === void 0 ? undefined : _ref2$clef;

    super.vexflowAccidentalsAndDisplay(vfn, {
      stave,
      clef
    });

    if (_debug__WEBPACK_IMPORTED_MODULE_8__["debug"]) {
      console.log(this.stemDirection);
    }

    if (this.stemDirection === 'noStem') {
      vfn.glyph.stem = false; // vfn.render_options.stem_height = 0;
    } else {
      // correct VexFlow stem length for notes far from the center line;
      var staveDNNSpacing = 5;

      if (stave !== undefined) {
        staveDNNSpacing = Math.floor(stave.options.spacing_between_lines_px / 2);
      }

      if (clef !== undefined && this.pitch !== undefined) {
        var midLine = clef.lowestLine + 4; // console.log(midLine);

        var absDNNFromCenter = Math.abs(this.pitch.diatonicNoteNum - midLine);
        var absOverOctave = absDNNFromCenter - 7; // console.log(absOverOctave);

        if (absOverOctave > 0 && vfn.getStemLength !== undefined) {
          var stemHeight = absOverOctave * staveDNNSpacing + vfn.getStemLength();
          vfn.setStemLength(stemHeight);
        }
      }
    }
  }
  /**
   * Returns a `Vex.Flow.StaveNote` that approximates this note.
   *
   * @param {Object} [options={}] - `{clef: {@link music21.clef.Clef} }`
   * clef to set the stem direction of.
   * @returns {Vex.Flow.StaveNote}
   */


  vexflowNote() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$clef = _ref3.clef,
        clef = _ref3$clef === void 0 ? undefined : _ref3$clef;

    var useStemDirection = this.stemDirection; // fixup stem direction -- must happen before Vex.Flow.Note is created...

    if (this.activeSite !== undefined && this.activeSite.renderOptions.stemDirection !== undefined && stemDirectionNames.includes(this.activeSite.renderOptions.stemDirection)) {
      useStemDirection = this.activeSite.renderOptions.stemDirection;
    } else if ([undefined, 'unspecified'].includes(this.stemDirection) && clef !== undefined) {
      useStemDirection = this.getStemDirectionFromClef(clef);
    }

    var vfd = this.duration.vexflowDuration;

    if (vfd === undefined) {
      return undefined;
    }

    var vexflowKey = this.pitch.vexflowName(clef); // Not supported: Double;  None is done elsewhere?

    var vfnStemDirection = useStemDirection === 'down' ? vexflow__WEBPACK_IMPORTED_MODULE_2___default.a.Flow.StaveNote.STEM_DOWN : vexflow__WEBPACK_IMPORTED_MODULE_2___default.a.Flow.StaveNote.STEM_UP;
    var vfn = new vexflow__WEBPACK_IMPORTED_MODULE_2___default.a.Flow.StaveNote({
      keys: [vexflowKey],
      duration: vfd,
      stem_direction: vfnStemDirection
    });
    this.vexflowAccidentalsAndDisplay(vfn, {
      clef
    }); // clean up stuff...

    if (this.pitch.accidental !== undefined) {
      if (this.pitch.accidental.vexflowModifier !== 'n' && this.pitch.accidental.displayStatus !== false) {
        vfn.addAccidental(0, new vexflow__WEBPACK_IMPORTED_MODULE_2___default.a.Flow.Accidental(this.pitch.accidental.vexflowModifier));
      } else if (this.pitch.accidental.displayType === 'always' || this.pitch.accidental.displayStatus === true) {
        vfn.addAccidental(0, new vexflow__WEBPACK_IMPORTED_MODULE_2___default.a.Flow.Accidental(this.pitch.accidental.vexflowModifier));
      }
    }

    if (this.articulations[0] !== undefined) {
      for (var i = 0; i < this.articulations.length; i++) {
        var art = this.articulations[i]; // 0 refers to the first pitch (for chords etc.)...

        vfn.addArticulation(0, art.vexflow());
      }
    }

    if (this.expressions[0] !== undefined) {
      for (var j = 0; j < this.expressions.length; j++) {
        var exp = this.expressions[j]; // 0 refers to the first pitch (for chords etc.)...

        vfn.addArticulation(0, exp.vexflow());
      }
    }

    if (this.noteheadColor !== undefined) {
      vfn.setStyle({
        fillStyle: this.noteheadColor,
        strokeStyle: this.noteheadColor
      });
    }

    this.activeVexflowNote = vfn;
    return vfn;
  }

  playMidi() {
    var tempo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 120;
    var nextElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref4$instrument = _ref4.instrument,
        instrument = _ref4$instrument === void 0 ? undefined : _ref4$instrument,
        _ref4$channel = _ref4.channel,
        channel = _ref4$channel === void 0 ? undefined : _ref4$channel,
        _ref4$playLegato = _ref4.playLegato,
        playLegato = _ref4$playLegato === void 0 ? true : _ref4$playLegato;

    var milliseconds = super.playMidi(tempo, nextElement, {
      instrument,
      channel
    });

    if (channel === undefined) {
      channel = this.activeChannel();
    }

    var volume = this.midiVolume; // Note, not rest

    var midNum = this.pitch.midi;
    var stopTime = milliseconds / 1000;

    if (nextElement instanceof Note) {
      if (nextElement.pitch.midi !== this.pitch.midi && playLegato) {
        stopTime += 60 * 0.25 / tempo; // legato -- play 16th note longer
      } else if (this.tie !== undefined && (this.tie.type === 'start' || this.tie.type === 'continue')) {
        stopTime += 60 * nextElement.duration.quarterLength / tempo; // this does not take into account 3 or more notes tied.
        // TODO: look ahead at next nexts, etc.
      }
    } else if (nextElement === undefined && playLegato) {
      // let last note ring an extra beat...
      stopTime += 60 / tempo;
    } // console.log(stopTime);
    // console.log(this.tie);


    if (this.tie === undefined || this.tie.type === 'start') {
      // console.log(volume);
      try {
        midicube__WEBPACK_IMPORTED_MODULE_3__["noteOn"](channel, midNum, volume, 0);
        midicube__WEBPACK_IMPORTED_MODULE_3__["noteOff"](channel, midNum, stopTime);
      } catch (e) {// do nothing -- might not have an output channel because of audio not connected
      }
    } // else { console.log ('not going to play ', this.nameWithOctave); }


    return milliseconds;
  }

}
/* ------ TODO: Unpitched ------ */

/* ------ Rest ------ */

/**
 * Represents a musical rest.
 *
 * @class Rest
 * @memberof music21.note
 * @param {number} [ql=1.0] - length in number of quarterNotes
 * @property {Boolean} [isNote=false]
 * @property {Boolean} [isRest=true]
 * @property {string} [name='rest']
 * @property {number} [lineShift=undefined] - number of lines to shift up or down from default
 * @property {string|undefined} [color='black'] - color of the rest
 */

class Rest extends GeneralNote {
  // this dummy constructor is here for JetBrains typescript linter
  // which otherwise complains that Rests have no durations, etc.
  constructor() {
    var ql = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.0;
    super(ql); // noinspection JSUnusedGlobalSymbols

    this.isNote = false;
    this.isRest = true;
    this.name = 'rest';
    this.lineShift = 0;
    this.color = 'black';
    this.name = 'rest';
  }

  static get className() {
    return 'music21.note.Rest';
  }
  /**
   *
   * @returns {string}
   */


  stringInfo() {
    return this.duration.quarterLength.toString();
  }
  /**
   * Returns a `Vex.Flow.StaveNote` that approximates this rest.
   * Corrects for bug in VexFlow that renders a whole rest too low.
   *
   * @param {Object} options -- vexflow options
   * @returns {Vex.Flow.StaveNote}
   */


  vexflowNote(options) {
    var keyLine = 'b/4';

    if (this.duration.type === 'whole') {
      if (this.activeSite !== undefined && this.activeSite.renderOptions.staffLines !== 1) {
        keyLine = 'd/5';
      }
    }

    if (this.lineShift !== undefined) {
      var p = new _pitch__WEBPACK_IMPORTED_MODULE_6__["Pitch"]('B4');
      var ls = this.lineShift;

      if (this.duration.type === 'whole') {
        ls += 2;
      }

      p.diatonicNoteNum += ls;
      keyLine = p.vexflowName(undefined);
    }

    var vfn = new vexflow__WEBPACK_IMPORTED_MODULE_2___default.a.Flow.StaveNote({
      keys: [keyLine],
      duration: this.duration.vexflowDuration + 'r'
    });

    if (this.duration.dots > 0) {
      for (var i = 0; i < this.duration.dots; i++) {
        vfn.addDotToAll();
      }
    }

    if (this.color !== undefined) {
      vfn.setStyle({
        fillStyle: this.color,
        strokeStyle: this.color
      });
    }

    this.activeVexflowNote = vfn;
    return vfn;
  }

}
/* ------ TODO(msc): SpacerRest  or remove from music21p ------ */

/***/ }),

/***/ "./src/music21/parseLoader.ts":
/*!************************************!*\
  !*** ./src/music21/parseLoader.ts ***!
  \************************************/
/*! exports provided: runConfiguration, getBasePath, fixUrls, renderHTML, loadDefaultSoundfont, loadConfiguration, getM21attribute, warnBanner */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runConfiguration", function() { return runConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBasePath", function() { return getBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixUrls", function() { return fixUrls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderHTML", function() { return renderHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadDefaultSoundfont", function() { return loadDefaultSoundfont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadConfiguration", function() { return loadConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getM21attribute", function() { return getM21attribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warnBanner", function() { return warnBanner; });
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./debug */ "./src/music21/debug.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _miditools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./miditools */ "./src/music21/miditools.ts");
/* harmony import */ var _tinyNotation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./tinyNotation */ "./src/music21/tinyNotation.ts");



/**
 * Parses loading options -- called by music21_modules.js
 *
 */




function runConfiguration() {
  var conf; // noinspection JSUnresolvedVariable

  if (typeof window.m21conf !== 'undefined') {
    // noinspection JSUnresolvedVariable
    conf = window.m21conf;
  } else {
    conf = loadConfiguration();
  }

  conf.warnBanner = conf.warnBanner !== undefined ? conf.warnBanner : warnBanner();
  conf.loadSoundfont = conf.loadSoundfont !== undefined ? conf.loadSoundfont : getM21attribute('loadSoundFont') || true;
  conf.renderHTML = conf.renderHTML !== undefined ? conf.renderHTML : getM21attribute('renderHTML');

  if (conf.renderHTML === undefined) {
    conf.renderHTML = true;
  }

  conf.m21basePath = getBasePath();
  fixUrls(conf);
  loadDefaultSoundfont(conf);
  renderHTML();
}
function getBasePath() {
  var m21jsPath = getM21attribute('data-main');

  if (!m21jsPath) {
    m21jsPath = getM21attribute('src');
  }

  var m21basePath = _common__WEBPACK_IMPORTED_MODULE_3__["pathSimplify"](m21jsPath + '/../..');

  if (_debug__WEBPACK_IMPORTED_MODULE_2__["debug"]) {
    console.log('Music21 paths: base: ', m21basePath, '; js: ', m21jsPath);
  }

  return m21basePath;
}
function fixUrls(conf) {
  if (!conf.m21basePath) {
    return;
  }

  for (var _i = 0, _Object$keys = Object.keys(_common__WEBPACK_IMPORTED_MODULE_3__["urls"]); _i < _Object$keys.length; _i++) {
    var u = _Object$keys[_i];
    _common__WEBPACK_IMPORTED_MODULE_3__["urls"][u] = _common__WEBPACK_IMPORTED_MODULE_3__["pathSimplify"](conf.m21basePath + _common__WEBPACK_IMPORTED_MODULE_3__["urls"][u]);
  }
}
/**
 * @returns undefined
 */

function renderHTML() {
  if (!document) {
    return;
  }

  if (document.readyState === 'complete') {
    _tinyNotation__WEBPACK_IMPORTED_MODULE_5__["renderNotationDivs"]();
  } else {
    window.addEventListener('load', () => {
      _tinyNotation__WEBPACK_IMPORTED_MODULE_5__["renderNotationDivs"]();
    });
  }
}
function loadDefaultSoundfont(conf) {
  if (!conf.loadSoundfont || ['no', 'false'].includes(conf.loadSoundfont)) {
    return undefined;
  }

  var instrument;

  if (conf.loadSoundfont === true) {
    instrument = 'acoustic_grand_piano';
  } else {
    instrument = conf.loadSoundfont;
  }

  return _miditools__WEBPACK_IMPORTED_MODULE_4__["loadSoundfont"](instrument);
}
/**
 *
 * @returns {{}}
 */

function loadConfiguration() {
  var rawConf = getM21attribute('m21conf');

  if (!rawConf) {
    return {};
  }

  var m21conf;

  try {
    m21conf = JSON.parse(rawConf);
  } catch (e) {
    console.warn('Unable to JSON parse music21 configuration' + rawConf.toString() + ' into m21conf');
    m21conf = {};
  }

  return m21conf;
}
/**
 *
 * @param {string} [attribute=m21conf]
 * @returns {undefined|*|string}
 */

function getM21attribute() {
  var attribute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'm21conf';
  // this is case insensitive.
  var scripts = document.getElementsByTagName('script');

  for (var _i2 = 0, _Array$from = Array.from(scripts); _i2 < _Array$from.length; _i2++) {
    var s = _Array$from[_i2];
    var scriptName = s.getAttribute('data-main') || s.getAttribute('src');

    if (scriptName && /music21/.test(scriptName)) {
      var thisValue = s.getAttribute(attribute) || s.getAttribute(attribute.toLowerCase());

      if (thisValue !== undefined) {
        return thisValue;
      }
    }
  }

  return undefined;
}
/**
 *
 * @returns {boolean}
 */

function warnBanner() {
  return getM21attribute('warnBanner') !== 'no';
}

/***/ }),

/***/ "./src/music21/pitch.ts":
/*!******************************!*\
  !*** ./src/music21/pitch.ts ***!
  \******************************/
/*! exports provided: Accidental, nameToMidi, nameToSteps, stepsToName, midiToName, Pitch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Accidental", function() { return Accidental; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nameToMidi", function() { return nameToMidi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nameToSteps", function() { return nameToSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stepsToName", function() { return stepsToName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "midiToName", function() { return midiToName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pitch", function() { return Pitch; });
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.string.match */ "./node_modules/core-js/modules/es.string.match.js");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony import */ var _prebase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./prebase */ "./src/music21/prebase.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");




/**
 * music21j -- Javascript reimplementation of Core music21 features.
 * music21/pitch -- pitch routines
 *
 * Copyright (c) 2013-17, Michael Scott Cuthbert and cuthbertLab
 * Based on music21, Copyright (c) 2006–17, Michael Scott Cuthbert and cuthbertLab
 *
 * pitch module.  See {@link music21.pitch} namespace
 * Pitch related objects and methods
 *
 * @exports music21/pitch
 * @namespace music21.pitch
 * @memberof music21
 * @requires music21/prebase
 */



/**
 * @class Accidental
 * @memberof music21.pitch
 * @param {string|number} accName - an accidental name
 * @property {number} alter
 * @property {string} displayType
 * @property {boolean|undefined} displayStatus
 */

class Accidental extends _prebase__WEBPACK_IMPORTED_MODULE_4__["ProtoM21Object"] {
  constructor(accName) {
    super();
    this._name = '';
    this._alter = 0.0;
    this._modifier = '';
    this._unicodeModifier = '';
    this.displayType = 'normal'; // "normal", "always" supported currently

    this.displayStatus = undefined; // true, false, undefined

    this.set(accName);
  }

  static get className() {
    return 'music21.pitch.Accidental';
  }

  stringInfo() {
    return this.name;
  }
  /**
   * Sets a parameter of the accidental and updates name, alter, and modifier to suit.
   *
   * @param {number|string} accName - the name, number, or modifier to set
   * @returns {undefined}
   */


  set(accName) {
    if (typeof accName === 'string') {
      accName = accName.toLowerCase();
    }

    if (accName === 'natural' || accName === 'n' || accName === 0 || accName === undefined) {
      this._name = 'natural';
      this._alter = 0.0;
      this._modifier = '';
      this._unicodeModifier = '♮';
    } else if (accName === 'sharp' || accName === '#' || accName === 1) {
      this._name = 'sharp';
      this._alter = 1.0;
      this._modifier = '#';
      this._unicodeModifier = '♯';
    } else if (accName === 'flat' || accName === '-' || accName === 'b' || accName === -1) {
      this._name = 'flat';
      this._alter = -1.0;
      this._modifier = '-';
      this._unicodeModifier = '♭';
    } else if (accName === 'double-flat' || accName === '--' || accName === -2) {
      this._name = 'double-flat';
      this._alter = -2.0;
      this._modifier = '--';
      this._unicodeModifier = '&#x1d12b;';
    } else if (accName === 'double-sharp' || accName === '##' || accName === 2) {
      this._name = 'double-sharp';
      this._alter = 2.0;
      this._modifier = '##';
      this._unicodeModifier = '&#x1d12a;';
    } else if (accName === 'triple-flat' || accName === '---' || accName === -3) {
      this._name = 'triple-flat';
      this._alter = -3.0;
      this._modifier = '---';
      this._unicodeModifier = '♭&#x1d12b;';
    } else if (accName === 'triple-sharp' || accName === '###' || accName === 3) {
      this._name = 'triple-sharp';
      this._alter = 3.0;
      this._modifier = '###';
      this._unicodeModifier = '&#x1d12a;';
    } else if (accName === 'quadruple-flat' || accName === '----' || accName === -4) {
      this._name = 'quadruple-flat';
      this._alter = -4.0;
      this._modifier = '----';
      this._unicodeModifier = '♭&#x1d12b;';
    } else if (accName === 'quadruple-sharp' || accName === '####' || accName === 4) {
      this._name = 'quadruple-sharp';
      this._alter = 4.0;
      this._modifier = '####';
      this._unicodeModifier = '&#x1d12a;';
    } else {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_3__["Music21Exception"]('Accidental is not supported: ' + accName);
    }
  }
  /**
   * Return or set the name of the accidental ('flat', 'sharp', 'natural', etc.);
   *
   * When set, updates alter and modifier.
   *
   * @type {string}
   */


  get name() {
    return this._name;
  }

  set name(n) {
    this.set(n);
  }
  /**
   * Return or set the alter of the accidental
   *
   * When set, updates name and modifier.
   *
   * @type {number}
   */


  get alter() {
    return this._alter;
  }

  set alter(alter) {
    this.set(alter);
  }
  /**
   * Return or set the modifier ('-', '#', '')
   *
   * When set, updates alter and name.
   *
   * @type {string}
   */


  get modifier() {
    return this._modifier;
  }

  set modifier(modifier) {
    this.set(modifier);
  }
  /**
   * Returns the modifier for vexflow ('b', '#', 'n')
   *
   * @type {string}
   * @readonly
   */


  get vexflowModifier() {
    // todo -- rewrite with mapping.
    var m = this.modifier;

    if (m === '') {
      return 'n';
    } else if (m === '#') {
      return '#';
    } else if (m === '-') {
      return 'b';
    } else if (m === '##') {
      return '##';
    } else if (m === '--') {
      return 'bb';
    } else if (m === '###') {
      return '###';
    } else if (m === '---') {
      return 'bbb';
    } else {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_3__["Music21Exception"]('Vexflow does not support: ' + m);
    }
  }
  /**
   * Returns the modifier in unicode or
   * for double and triple accidentals, as a hex escape
   *
   * @type {string}
   * @readonly
   */


  get unicodeModifier() {
    return this._unicodeModifier;
  }

}
/**
 *
 * @type {{A: number, B: number, C: number, D: number, E: number, F: number, G: number}}
 */

var nameToMidi = {
  C: 0,
  D: 2,
  E: 4,
  F: 5,
  G: 7,
  A: 9,
  B: 11
};
/**
 *
 * @type {{A: number, B: number, C: number, D: number, E: number, F: number, G: number}}
 */

var nameToSteps = {
  C: 0,
  D: 1,
  E: 2,
  F: 3,
  G: 4,
  A: 5,
  B: 6
};
/**
 *
 * @type {string[]}
 */

var stepsToName = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
/**
 *
 * @type {string[]}
 */

var midiToName = ['C', 'C#', 'D', 'E-', 'E', 'F', 'F#', 'G', 'A-', 'A', 'B-', 'B'];
/**
 * Pitch objects are found in {@link music21.note.Note} objects, and many other places.
 *
 * They do not have a {@link music21.duration.Duration} associated with them, so they
 * cannot be placed inside {@link music21.stream.Stream} objects.
 *
 * Valid pitch name formats are
 * - "C", "D', etc. ("B" = American B; "H" is not allowed)
 * - "C#", "C-" (C-flat; do not use "b" for flat), "C##", "C###", "C--" etc.
 * - Octave may be specified after the name + accidental: "C#4" etc.
 * - Octave can be arbitrarily high ("C10") but only as low as "C0" because
 *     "C-1" would be interpreted as C-flat octave 1; shift octave later for very low notes.
 * - If octave is not specified, the system will usually use octave 4, but might
 *     adjust according to context. If you do not like this behavior, give an octave always.
 * - Microtones are not supported in music21j (they are in music21p)
 *
 * @class Pitch
 * @memberof music21.pitch
 * @param {string|number} pn - name of the pitch, with or without octave, see above.
 * @property {Accidental|undefined} accidental - link to an accidental
 * @property {number} diatonicNoteNum - diatonic number of the pitch,
 *     where 29 = C4, C#4, C-4, etc.; 30 = D-4, D4, D#4, etc. updates other properties.
 * @property {number} midi - midi number of the pitch (C4 = 60); readonly.
 *     See {@link Pitch#ps} for settable version.
 * @property {string} name - letter name of pitch + accidental modifier;
 *     e.g., B-flat = 'B-'; changes automatically w/ step and accidental
 * @property {string} nameWithOctave - letter name of pitch + accidental
 *     modifier + octave; changes automatically w/ step, accidental, and octave
 * @property {number} octave - number for the octave, where middle C = C4, and
 *     octaves change between B and C; default 4
 * @property {number} ps - pitch space number, like midi number but floating
 *     point and w/ no restriction on range. C4 = 60.0
 * @property {string} step - letter name for the pitch (C-G, A, B),
 *     without accidental; default 'C'
 */

class Pitch extends _prebase__WEBPACK_IMPORTED_MODULE_4__["ProtoM21Object"] {
  constructor() {
    var pn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'C';
    super();
    this._step = 'C';
    this._octave = 4;
    this._accidental = undefined;
    this.spellingIsInferred = false;
    this.microtone = undefined;
    /* pn can be a nameWithOctave */

    if (typeof pn === 'number') {
      if (pn < 12) {
        pn += 60; // pitchClass
      }

      this.ps = pn;
    } else if (pn.match(/\d+/)) {
      this.nameWithOctave = pn;
    } else {
      this.name = pn;
    }
  }

  static get className() {
    return 'music21.pitch.Pitch';
  }

  stringInfo() {
    return this.nameWithOctave;
  } // N.B. cannot use transpose here, because of circular import.


  get step() {
    return this._step;
  }

  set step(s) {
    if (s === '') {
      throw new TypeError('All notes must have a step');
    }

    if (typeof s !== 'string') {
      throw new TypeError('Steps must be strings');
    }

    s = s.toUpperCase();

    if (!stepsToName.includes(s)) {
      throw new TypeError("".concat(s, " is not a valid step name."));
    }

    this._step = s;
    this.spellingIsInferred = false;
  }

  get octave() {
    return this._octave;
  }

  set octave(o) {
    this._octave = o;
  }

  get implicitOctave() {
    var o = this._octave;

    if (o === undefined) {
      return 4; // TODO(msc): get from defaults.
    } else {
      return o;
    }
  }

  get accidental() {
    return this._accidental;
  }

  set accidental(a) {
    this._accidental = a;
    this.spellingIsInferred = false;
  }

  get name() {
    var a = this.accidental;

    if (a === undefined) {
      return this.step;
    } else {
      return this.step + a.modifier;
    }
  }

  set name(nn) {
    this.step = nn.slice(0, 1);
    var tempAccidental = nn.slice(1);

    if (tempAccidental) {
      // not the empty string
      this.accidental = new Accidental(tempAccidental);
    } else {
      this.accidental = undefined;
    }
  }

  get nameWithOctave() {
    return this.name + this.octave.toString();
  }

  set nameWithOctave(pn) {
    var storedOctave = pn.match(/\d+/);

    if (storedOctave !== undefined) {
      pn = pn.replace(/\d+/, '');
      this.octave = parseInt(storedOctave[0]);
      this.name = pn;
    } else {
      this.name = pn;
    }
  }
  /**
   *
   * @type {number}
   * @readonly
   */


  get pitchClass() {
    return _common__WEBPACK_IMPORTED_MODULE_5__["posMod"](Math.round(this.ps), 12);
  }
  /**
   *
   * @type {number}
   */


  get diatonicNoteNum() {
    return this.octave * 7 + nameToSteps[this.step] + 1;
  }

  set diatonicNoteNum(newDNN) {
    newDNN -= 1; // makes math easier

    this.octave = Math.floor(newDNN / 7);
    var mod7DNN = _common__WEBPACK_IMPORTED_MODULE_5__["posMod"](Math.round(newDNN), 7);
    this.step = stepsToName[mod7DNN];
  }
  /**
   *
   * @type {number}
   * @readonly
   */


  get frequency() {
    return 440 * (Math.pow(2, this.ps - 69) / 12);
  }
  /**
   *
   * @type {number}
   * @readonly
   */


  get midi() {
    return Math.floor(this.ps);
  }
  /**
   *
   * @type {number}
   */


  get ps() {
    var accidentalAlter = 0;

    if (this.accidental !== undefined) {
      accidentalAlter = this.accidental.alter;
    }

    return (this.octave + 1) * 12 + nameToMidi[this.step] + accidentalAlter;
  }

  set ps(ps) {
    this.name = midiToName[_common__WEBPACK_IMPORTED_MODULE_5__["posMod"](ps, 12)];
    this.octave = Math.floor(ps / 12) - 1;
    this.spellingIsInferred = true;
  }
  /**
   * @type {string}
   * @readonly
   */


  get unicodeName() {
    if (this.accidental !== undefined) {
      return this.step + this.accidental.unicodeModifier;
    } else {
      return this.step;
    }
  }
  /**
   * @type {string}
   * @readonly
   */


  get unicodeNameWithOctave() {
    if (this.octave === undefined) {
      return this.unicodeName;
    } else {
      return this.unicodeName + this.octave.toString();
    }
  }
  /**
   * @param {boolean} inPlace
   * @param {int} directionInt -- -1 = down, 1 = up
   * @returns {Pitch}
   */


  _getEnharmonicHelper() {
    var inPlace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var directionInt = arguments.length > 1 ? arguments[1] : undefined;
    // differs from Python version because
    // cannot import interval here.
    var octaveStored = true;

    if (this.octave === undefined) {
      octaveStored = false;
    }

    var p = this.clone();
    p.diatonicNoteNum += directionInt;

    if (p.accidental === undefined) {
      p.accidental = new Accidental(0);
    }

    while (p.ps % 12 !== this.ps % 12) {
      // octaveless
      // again a JSDoc choke
      // eslint-disable-next-line operator-assignment
      p.accidental.alter = p.accidental.alter + -1 * directionInt;
    }

    if (!inPlace) {
      return p;
    }

    this.step = p.step;
    this.accidental = p.accidental;

    if (p.microtone === undefined) {
      this.microtone = p.microtone;
    }

    if (!octaveStored) {
      this.octave = undefined;
    } else {
      this.octave = p.octave;
    }

    return p;
  }
  /**
   *
   * @param {boolean} [inPlace=false]
   * @returns {Pitch}
   */


  getHigherEnharmonic() {
    var inPlace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return this._getEnharmonicHelper(inPlace, 1);
  }
  /**
   *
   * @param {boolean} [inPlace=false]
   * @returns {Pitch}
   */


  getLowerEnharmonic() {
    var inPlace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return this._getEnharmonicHelper(inPlace, -1);
  }
  /* TODO: isEnharmonic, getEnharmonic, getAllCommonEnharmonics */

  /**
   * Returns the vexflow name for the pitch in the given clef.
   *
   * if clefObj is undefined, then the clef is treated as TrebleClef.
   *
   * @param {music21.clef.Clef} [clefObj] - the active {@link music21.clef.Clef} object
   * @returns {string} - representation in vexflow
   */


  vexflowName() {
    var clefObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    // returns a vexflow Key name for this pitch.
    var tempPitch = this;

    if (clefObj !== undefined) {
      try {
        tempPitch = clefObj.convertPitchToTreble(this);
      } catch (e) {
        console.log(e, clefObj);
      }
    }

    var accidentalType = 'n';

    if (this.accidental !== undefined) {
      if ([0, -1, -2, 1, 2].includes(this.accidental.alter)) {
        accidentalType = this.accidental.vexflowModifier;
      } else {
        console.warn('unsupported accidental: ' + this.accidental);
      }
    }

    var outName = tempPitch.step + accidentalType + '/' + tempPitch.octave;
    return outName;
  }

}

/***/ }),

/***/ "./src/music21/prebase.ts":
/*!********************************!*\
  !*** ./src/music21/prebase.ts ***!
  \********************************/
/*! exports provided: ProtoM21Object */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProtoM21Object", function() { return ProtoM21Object; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.last-index-of */ "./node_modules/core-js/modules/es.array.last-index-of.js");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.weak-map */ "./node_modules/core-js/modules/es.weak-map.js");
/* harmony import */ var core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7__);









/**
 * module for things that all music21-created objects, not just objects that can live in
 * Stream.elements should inherit. See the {@link music21.prebase} namespace.
 * Copyright (c) 2013-17, Michael Scott Cuthbert and cuthbertLab
 *
 * @exports music21/prebase
 * @namespace music21.prebase
 * @memberof music21
 */

/**
 * Class for pseudo-m21 objects to inherit from. The most important attributes that nearly
 * everything in music21 should inherit from are given below.
 *
 * @class ProtoM21Object
 * @memberof music21.prebase
 * @property {Array<string>} classes - An Array of strings of classes
 * that the object belongs to (default ['ProtoM21Object'])
 * @property {boolean} isProtoM21Object - Does this object descend
 * from {@link music21.prebase.ProtoM21Object}: obviously true.
 * @property {boolean} isMusic21Object - Does this object descend
 * from Music21Object; default false.
 */
class ProtoM21Object {
  constructor() {
    this.isProtoM21Object = true;
    this.isMusic21Object = false;
    this._cloneCallbacks = {};
  }

  static get className() {
    return 'music21.prebase.ProtoM21Object';
  }

  get classSet() {
    if (this._storedClassSet !== undefined) {
      return this._storedClassSet;
    }

    this._populateClassCaches();

    return this._storedClassSet;
  }
  /**
   * Gets all classes.  Note that because of webpack mangling of class names,
   * we need to specify `className` as a static property on each class.
   */


  get classes() {
    if (this._storedClasses !== undefined) {
      return this._storedClasses;
    }

    this._populateClassCaches();

    return this._storedClasses;
  }
  /**
   * Populates the class caches (.classes and .classSet)
   */


  _populateClassCaches() {
    var classSet = new Set();
    var classList = [];
    var thisConstructor = this.constructor;
    var maxLinks = 20;

    while (thisConstructor !== undefined && maxLinks) {
      maxLinks -= 1;
      var constructorName = thisConstructor.className;

      if (constructorName === undefined || constructorName === '') {
        break;
      }

      var constructorNameShort = constructorName.slice(constructorName.lastIndexOf('.') + 1);
      classList.push(constructorNameShort);
      classSet.add(thisConstructor);
      classSet.add(constructorName);
      classSet.add(constructorNameShort);
      thisConstructor = Object.getPrototypeOf(thisConstructor);
    }

    classList.push('object');
    this._storedClasses = classList;
    this._storedClassSet = classSet;
  }
  /**
   * Makes (as much as possible) a complete duplicate copy of the object called with .clone()
   *
   * Works similarly to Python's copy.deepcopy().
   *
   * Every ProtoM21Object has a `._cloneCallbacks` object which maps
   * `{attribute: callbackFunction|boolean}`
   * to handle custom clone cases.  See, for instance, Music21Object which
   * uses a custom callback to NOT clone the `.derivation` attribute directly.
   *
   * @example
   * var n1 = new music21.note.Note("C#");
   * n1.duration.quarterLength = 4;
   * var n2 = n1.clone();
   * n2.duration.quarterLength == 4; // true
   * n2 === n1; // false
   */


  clone() {
    var deep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var memo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    // console.log(`cloning ${this + ''} as ${deep ? 'deep' : 'shallow'}`);
    var classConstructor = this.constructor;
    var ret = new classConstructor();

    if (memo === undefined) {
      memo = new WeakMap();
    } // TODO(msc): test if Arrays work?


    for (var key in this) {
      // not that we ONLY copy the keys in Ret -- it's easier that way.
      if ({}.hasOwnProperty.call(this, key) === false) {
        continue;
      }

      if (key in this._cloneCallbacks) {
        if (this._cloneCallbacks[key] === true) {
          ret[key] = this[key];
        } else if (this._cloneCallbacks[key] === false) {
          ret[key] = undefined;
        } else {
          // call the cloneCallbacks function
          this._cloneCallbacks[key](key, ret, this, deep, memo);
        }
      } else if (Object.getOwnPropertyDescriptor(this, key).get !== undefined || Object.getOwnPropertyDescriptor(this, key).set !== undefined) {// do nothing
      } else if (typeof this[key] === 'function') {// do nothing -- events might not be copied.
      } else if (deep && typeof this[key] === 'object' && this[key] !== null && this[key].isProtoM21Object) {
        // console.log('cloning ', key);
        var m21Obj = this[key];
        var clonedVersion = void 0;

        if (memo.has(m21Obj)) {
          clonedVersion = memo.get(m21Obj);
        } else {
          clonedVersion = m21Obj.clone(deep, memo);
        }

        ret[key] = clonedVersion;
      } else {
        try {
          // for deep this should be:
          // music21.common.merge(ret[key], this[key]);
          ret[key] = this[key];
        } catch (e) {
          if (e instanceof TypeError) {
            console.log('typeError:', e, key); // do nothing
          } else {
            throw e;
          }
        }
      }
    }

    return ret;
  }
  /**
   * Check to see if an object is of this class or subclass.
   *
   * @param {string|string[]} testClass - a class or Array of classes to test
   * @returns {boolean}
   * @example
   * var n = new music21.note.Note();
   * n.isClassOrSubclass('Note'); // true
   * n.isClassOrSubclass('music21.base.Music21Object'); // true
   * n.isClassOrSubclass(music21.note.GeneralNote); // true
   * n.isClassOrSubclass(['Note', 'Rest']); // true
   * n.isClassOrSubclass(['Duration', 'NotRest']); // true // NotRest
   */


  isClassOrSubclass(testClass) {
    if (!(testClass instanceof Array)) {
      testClass = [testClass];
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = testClass[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var thisTestClass = _step.value;

        if (this.classSet.has(thisTestClass)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  }
  /**
   *
   * @returns {string}
   */


  toString() {
    var si = this.stringInfo();

    if (si !== '') {
      si = ' ' + si;
    }

    return "<".concat(this.classes[0]).concat(si, ">");
  }
  /**
   *
   * @returns {string}
   */


  stringInfo() {
    return '';
  }

}

/***/ }),

/***/ "./src/music21/renderOptions.ts":
/*!**************************************!*\
  !*** ./src/music21/renderOptions.ts ***!
  \**************************************/
/*! exports provided: RenderOptions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RenderOptions", function() { return RenderOptions; });
/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/renderOptions -- an object that defines the render options for a Stream
 *
 * note: no parallel in music21p except Style
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–19, Michael Scott Cuthbert and cuthbertLab
 *
 * renderOptions module, see {@link music21.renderOptions}
 * Options for rendering a stream
 *
 * @exports music21/renderOptions
 * @namespace music21.renderOptions
 * @memberof music21
 */

/**
 * An object that contains information on rendering the current stream
 *
 * Found on every Stream as `.renderOptions`
 *
 * @memberof music21.renderOptions
 */
class RenderOptions {
  constructor() {
    this.displayClef = true;
    this.displayTimeSignature = true;
    this.displayKeySignature = true;
    this.scaleFactor = {
      x: 0.7,
      y: 0.7
    };
    this.top = 0;
    this.left = undefined;
    this.width = undefined;
    this.overriddenWidth = undefined;
    this.height = undefined;
    this.naiveHeight = 120; // additional padding at the bottom of the stream (not every system).

    this.marginBottom = 0;
    this.systemIndex = 0;
    this.partIndex = 0;
    this.measureIndex = 0;
    this.systemPadding = undefined;
    this.naiveSystemPadding = 40;
    this.stemDirection = undefined;
    this.maxSystemWidth = undefined;
    this.rightBarline = undefined;
    this.staffLines = 5;
    this.staffConnectors = ['single', 'brace'];
    this.staffPadding = 60; // width...

    this.events = {
      mousedown: undefined,
      touchstart: undefined,
      click: undefined, //'play',
      dblclick: undefined
    };
    this.startNewSystem = false; // noinspection JSUnusedGlobalSymbols

    this.startNewPage = false;
    this.showMeasureNumber = undefined;
  }

}

/***/ }),

/***/ "./src/music21/roman.ts":
/*!******************************!*\
  !*** ./src/music21/roman.ts ***!
  \******************************/
/*! exports provided: figureShorthands, functionalityScores, expandShortHand, correctSuffixForChordQuality, romanToNumber, RomanNumeral */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "figureShorthands", function() { return figureShorthands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "functionalityScores", function() { return functionalityScores; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandShortHand", function() { return expandShortHand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "correctSuffixForChordQuality", function() { return correctSuffixForChordQuality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "romanToNumber", function() { return romanToNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RomanNumeral", function() { return RomanNumeral; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.constructor */ "./node_modules/core-js/modules/es.regexp.constructor.js");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.match */ "./node_modules/core-js/modules/es.string.match.js");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony import */ var _chord__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./chord */ "./src/music21/chord.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _figuredBass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./figuredBass */ "./src/music21/figuredBass.ts");
/* harmony import */ var _harmony__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./harmony */ "./src/music21/harmony.ts");
/* harmony import */ var _interval__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./interval */ "./src/music21/interval.ts");
/* harmony import */ var _key__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./key */ "./src/music21/key.ts");
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./pitch */ "./src/music21/pitch.ts");
/* harmony import */ var _scale__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./scale */ "./src/music21/scale.ts");










function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/roman -- roman.RomanNumeral -- Chord subclass
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–19, Michael Scott Cuthbert and cuthbertLab
 *
 * Roman numeral module. See  namespace
 * music21.roman -- namespace for dealing with RomanNumeral analysis.
 *
 * @exports music21/roman
 * @memberof music21
 * @requires music21/chord
 * @requires music21/common
 * @requires music21/figuredBass
 * @requires music21/harmony
 * @requires music21/key
 * @requires music21/pitch
 * @requires music21/interval
 */









var figureShorthands = {
  '53': '',
  '3': '',
  '63': '6',
  '753': '7',
  '75': '7',
  '73': '7',
  '9753': '9',
  '975': '9',
  '953': '9',
  '97': '9',
  '95': '9',
  '93': '9',
  '653': '65',
  '6b53': '6b5',
  '643': '43',
  '642': '42',
  bb7b5b3: 'o7',
  bb7b53: 'o7',
  // '6b5bb3': 'o65',
  b7b5b3: 'ø7'
}; // noinspection SpellCheckingInspection

var functionalityScores = {
  I: 100,
  i: 90,
  V7: 80,
  V: 70,
  V65: 68,
  I6: 65,
  V6: 63,
  V43: 61,
  I64: 60,
  IV: 59,
  i6: 58,
  viio7: 57,
  V42: 55,
  viio65: 53,
  viio6: 52,
  '#viio65': 51,
  ii: 50,
  '#viio6': 49,
  ii65: 48,
  ii43: 47,
  ii42: 46,
  IV6: 45,
  ii6: 43,
  VI: 42,
  '#VI': 41,
  vi: 40,
  viio: 39,
  '#viio': 39,
  iio: 37,
  iio42: 36,
  bII6: 35,
  iio43: 32,
  iio65: 31,
  '#vio': 28,
  '#vio6': 28,
  III: 22,
  v: 20,
  VII: 19,
  VII7: 18,
  IV65: 17,
  IV7: 16,
  iii: 15,
  iii6: 12,
  vi6: 10
};
/**
 * expandShortHand - expand a string of numbers into an array
 *
 * N.B. this is NOT where abbreviations get expanded
 *
 * @memberof music21.roman
 * @param  {string} shorthand string of a figure w/o roman to parse
 * @return {Array<string>}           array of shorthands
 */

function expandShortHand(shorthand) {
  shorthand = shorthand.replace('/', '');

  if (shorthand.match(/[b-]$/)) {
    shorthand += '3';
  }

  shorthand = shorthand.replace('11', 'x');
  shorthand = shorthand.replace('13', 'y');
  shorthand = shorthand.replace('15', 'z');
  var rx = new RegExp('#*-*b*o*[1-9xyz]', 'g');
  var shorthandGroups = [];
  var match = rx.exec(shorthand);

  while (match !== null) {
    shorthandGroups.push(match[0]);
    match = rx.exec(shorthand);
  }

  if (shorthandGroups.length === 1 && shorthandGroups[0].endsWith('3')) {
    shorthandGroups = ['5', shorthandGroups[0]];
  }

  var shGroupOut = [];

  for (var _i = 0, _shorthandGroups = shorthandGroups; _i < _shorthandGroups.length; _i++) {
    var sh = _shorthandGroups[_i];
    sh = sh.replace('x', '11');
    sh = sh.replace('y', '13');
    sh = sh.replace('z', '15');
    shGroupOut.push(sh);
  }

  return shGroupOut;
}
/**
 * correctSuffixForChordQuality - Correct a given inversionString suffix given a
 *     chord of various qualities.
 *
 * @memberof music21.roman
 * @param  {chord.Chord} chordObj
 * @param  {string} inversionString a string like '6' to fix.
 * @return {string}           corrected inversionString
  */

function correctSuffixForChordQuality(chordObj, inversionString) {
  var fifthType = chordObj.semitonesFromChordStep(5);
  var qualityName = '';

  if (fifthType === 6) {
    qualityName = 'o';
  } else if (fifthType === 8) {
    qualityName = '+';
  }

  if (inversionString !== undefined && (inversionString.startsWith('o') || inversionString.startsWith('/o') || inversionString.startsWith('ø'))) {
    if (qualityName === 'o') {
      // don't call viio7, viioo7.
      qualityName = '';
    }
  }

  var seventhType = chordObj.semitonesFromChordStep(7);

  if (seventhType !== undefined && fifthType === 6) {
    // there is a seventh and this is a diminished 5
    if (seventhType === 10 && qualityName === 'o') {
      qualityName = 'ø';
    } else if (seventhType !== 9) {// do something for very odd chords built on diminished triad.
    }
  }

  return qualityName + inversionString;
}
/**
 * maps an index number to a roman numeral in lowercase
 *
 * @memberof music21.roman
 * @example
 * music21.roman.romanToNumber[4]
 * // 'iv'
 */

var romanToNumber = [undefined, 'i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii'];
/**
 * Represents a RomanNumeral.  By default, capital Roman Numerals are
 * major chords; lowercase are minor.
 *
 * @class RomanNumeral
 * @memberof music21.roman
 * @param {string} figure - the roman numeral as a string, e.g., 'IV', 'viio', 'V7'
 * @param {string|music21.key.Key} [keyStr='C']
 * @property {Array<music21.pitch.Pitch>} scale - (readonly) returns the scale
 *     associated with the roman numeral
 * @property {music21.key.Key} key - the key associated with the
 *     RomanNumeral (not allowed to be undefined yet)
 * @property {string} figure - the figure as passed in
 * @property {string} degreeName - the name associated with the scale degree,
 *     such as "mediant" etc., scale 7 will be "leading tone" or
 *     "subtonic" appropriately
 * @property {int} scaleDegree
 * @property {string|undefined} impliedQuality - "major", "minor", "diminished", "augmented"
 * @property {music21.roman.RomanNumeral|undefined} secondaryRomanNumeral
 * @property {music21.key.Key|undefined} secondaryRomanNumeralKey
 * @property {string|undefined} frontAlterationString
 * @property {music21.interval.Interval|undefined} frontAlterationTransposeInterval
 * @property {music21.pitch.Accidental|undefined} frontAlterationAccidental
 * @property {string|undefined} romanNumeralAlone
 * @property {scale.Scale|boolean|undefined} impliedScale
 * @property {music21.interval.Interval|undefined} scaleOffset
 * @property {Array<music21.pitch.Pitch>} pitches - RomanNumerals
 *     are Chord objects, so .pitches will work for them also.
 */

class RomanNumeral extends _harmony__WEBPACK_IMPORTED_MODULE_13__["Harmony"] {
  constructor() {
    var figure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var keyStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$parseFigure = _ref.parseFigure,
        parseFigure = _ref$parseFigure === void 0 ? false : _ref$parseFigure,
        _ref$updatePitches = _ref.updatePitches,
        updatePitches = _ref$updatePitches === void 0 ? false : _ref$updatePitches;

    super(figure, {
      updatePitches,
      parseFigure
    }); // immediately fix low-preference figures

    figure = figure.replace('0', 'o');
    figure = figure.replace('/o', 'ø'); // end immediate fixes

    this._parsingComplete = false; // not yet used...

    this.primaryFigure = undefined;
    this.secondaryRomanNumeral = undefined;
    this.secondaryRomanNumeralKey = undefined;
    this.pivotChord = undefined;
    this.scaleCardinality = 7;
    this._figure = undefined;
    this.caseMatters = true;

    if (typeof figure === 'number') {
      this.caseMatters = false;
    }

    this.scaleDegree = undefined;
    this.frontAlterationString = undefined;
    this.frontAlterationTransposeInterval = undefined;
    this.frontAlterationAccidental = undefined;
    this.romanNumeralAlone = undefined; // TODO(msc) -- this is never defined.

    this.quality = undefined;
    this.impliedQuality = undefined;
    this.impliedScale = undefined;
    this.scaleOffset = undefined;
    this.useImpliedScale = false;
    this.bracketedAlterations = [];
    this.omittedSteps = [];
    this.followsKeyChange = false;
    this._functionalityScore = undefined;
    this._scale = undefined; // the Key

    this.figure = figure;

    if (typeof keyStr === 'string') {
      this.key = new _key__WEBPACK_IMPORTED_MODULE_15__["Key"](keyStr);
    } else {
      this.key = keyStr;
    } // to remove...


    this.numbers = undefined;

    if (figure !== '') {
      this._parseFigure();

      this._parsingComplete = true;

      this._updatePitches();
    }
  }

  static get className() {
    return 'music21.roman.RomanNumeral';
  }

  stringInfo() {
    return this.figure + ' in ' + this.key.stringInfo();
  }

  _parseFigure() {
    var workingFigure;
    var useScale = this.impliedScale;

    if (!this.useImpliedScale) {
      useScale = this.key;
    }

    var _this$_correctForSeco = this._correctForSecondaryRomanNumeral(useScale);

    var _this$_correctForSeco2 = _slicedToArray(_this$_correctForSeco, 2);

    workingFigure = _this$_correctForSeco2[0];
    useScale = _this$_correctForSeco2[1];

    if (workingFigure === 'Cad64') {
      if (useScale.mode === 'minor') {
        workingFigure = 'i64';
      } else {
        workingFigure = 'I64';
      }
    }

    this.primaryFigure = workingFigure;
    workingFigure = this._parseOmittedSteps(workingFigure);
    workingFigure = this._parseBracketedAlterations(workingFigure);
    workingFigure = workingFigure.replace(/^N6/, 'bII6');
    workingFigure = workingFigure.replace(/^N/, 'bII6');
    workingFigure = this._parseFrontAlterations(workingFigure);

    var _this$_parseRNAloneAm = this._parseRNAloneAmidstAug6(workingFigure, useScale);

    var _this$_parseRNAloneAm2 = _slicedToArray(_this$_parseRNAloneAm, 2);

    workingFigure = _this$_parseRNAloneAm2[0];
    useScale = _this$_parseRNAloneAm2[1];
    workingFigure = this._setImpliedQualityFromString(workingFigure);
    this._tempRoot = useScale.pitchFromDegree(this.scaleDegree);

    this._fixMinorVIandVII(useScale);

    var expandedFigure = expandShortHand(workingFigure);
    this.figuresNotationObj = new _figuredBass__WEBPACK_IMPORTED_MODULE_12__["Notation"](expandedFigure.toString());
    var numbersArr = workingFigure.match(/\d+/);

    if (numbersArr != null) {
      // noinspection JSUnusedAssignment
      workingFigure = workingFigure.replace(/\d+/, '');
      this.numbers = parseInt(numbersArr[0]);
    }
  }

  _parseFrontAlterations(workingFigure) {
    var frontAlterationString = '';
    var frontAlterationTransposeInterval;
    var frontAlterationAccidental;

    var _alterationRegex = new RegExp('^(b+|-+|#+)');

    var match = _alterationRegex.exec(workingFigure);

    if (match != null) {
      var group = match[1];
      var alteration = group.length;

      if (group[0] === 'b' || group[0] === '-') {
        alteration *= -1;
      }

      frontAlterationTransposeInterval = _interval__WEBPACK_IMPORTED_MODULE_14__["intervalFromGenericAndChromatic"](1, alteration);
      frontAlterationAccidental = new _pitch__WEBPACK_IMPORTED_MODULE_16__["Accidental"](alteration);
      frontAlterationString = group;
      workingFigure = workingFigure.replace(_alterationRegex, '');
    }

    this.frontAlterationString = frontAlterationString;
    this.frontAlterationTransposeInterval = frontAlterationTransposeInterval;
    this.frontAlterationAccidental = frontAlterationAccidental;
    return workingFigure;
  }

  _correctBracketedPitches() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.bracketedAlterations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var innerAlteration = _step.value;

        var _innerAlteration = _slicedToArray(innerAlteration, 2),
            alterNotation = _innerAlteration[0],
            chordStep = _innerAlteration[1];

        var alterPitch = this.getChordStep(chordStep);

        if (alterPitch === undefined) {
          continue;
        }

        var newAccidental = new _pitch__WEBPACK_IMPORTED_MODULE_16__["Accidental"](alterNotation);

        if (alterPitch.accidental === undefined) {
          alterPitch.accidental = newAccidental;
        } else {
          alterPitch.accidental.set(alterPitch.accidental.alter + newAccidental.alter);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  _setImpliedQualityFromString(workingFigure) {
    var impliedQuality = '';

    if (workingFigure.startsWith('o')) {
      impliedQuality = 'diminished';
      workingFigure = workingFigure.replace(/^o/, '');
    } else if (workingFigure.startsWith('/o')) {
      impliedQuality = 'half-diminished';
      workingFigure = workingFigure.replace(/^\/o/, '');
    } else if (workingFigure.startsWith('ø')) {
      impliedQuality = 'half-diminished';
      workingFigure = workingFigure.replace(/^ø/, '');
    } else if (workingFigure.startsWith('+')) {
      impliedQuality = 'augmented';
      workingFigure = workingFigure.replace(/^\+/, '');
    } else if (workingFigure.endsWith('d7')) {
      impliedQuality = 'dominant-seventh';
      workingFigure = workingFigure.replace(/d7$/, '7');
    } else if (this.caseMatters && this.romanNumeralAlone.toUpperCase() === this.romanNumeralAlone) {
      impliedQuality = 'major';
    } else if (this.caseMatters && this.romanNumeralAlone.toLowerCase() === this.romanNumeralAlone) {
      impliedQuality = 'minor';
    }

    this.impliedQuality = impliedQuality;
    return workingFigure;
  }

  _fixMinorVIandVII(useScale) {
    if (useScale.mode !== 'minor') {
      return;
    }

    if (!this.caseMatters) {
      return;
    }

    if (this.scaleDegree !== 6 && this.scaleDegree !== 7) {
      return;
    }

    if (!['minor', 'diminished', 'half-diminished'].includes(this.impliedQuality)) {
      return;
    }

    var fati = this.frontAlterationTransposeInterval;

    if (fati !== undefined) {
      var newFati = _interval__WEBPACK_IMPORTED_MODULE_14__["add"]([fati, new _interval__WEBPACK_IMPORTED_MODULE_14__["Interval"]('A1')]);
      this.frontAlterationTransposeInterval = newFati;
      this.frontAlterationAccidental.alter = this.frontAlterationAccidental.alter + 1;
    } else {
      this.frontAlterationTransposeInterval = new _interval__WEBPACK_IMPORTED_MODULE_14__["Interval"]('A1');
      this.frontAlterationAccidental = new _pitch__WEBPACK_IMPORTED_MODULE_16__["Accidental"](1);
    }

    this._tempRoot = this.frontAlterationTransposeInterval.transposePitch(this._tempRoot);
  }

  _parseRNAloneAmidstAug6(workingFigure, useScale) {
    var romanNumeralAlone = '';

    var _romanNumeralAloneRegex = new RegExp('(IV|I{1,3}|VI{0,2}|iv|i{1,3}|vi{0,2}|N)');

    var _augmentedSixthRegex = new RegExp('(It|Ger|Fr|Sw)');

    var rm = _romanNumeralAloneRegex.exec(workingFigure);

    var a6match = _augmentedSixthRegex.exec(workingFigure);

    if (rm === null && a6match === null) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_9__["Music21Exception"]("No roman numeral found in ".concat(workingFigure));
    }

    if (a6match !== null) {
      if (useScale.mode === 'major') {
        useScale = new _key__WEBPACK_IMPORTED_MODULE_15__["Key"](useScale.tonic.name, 'minor');
        this.impliedScale = useScale;
        this.useImpliedScale = true;
      }

      romanNumeralAlone = a6match[1];

      if (['It', 'Ger'].includes(romanNumeralAlone)) {
        this.scaleDegree = 4;
      } else {
        this.scaleDegree = 2;
      }

      workingFigure = workingFigure.replace(_augmentedSixthRegex, '');
      this.romanNumeralAlone = romanNumeralAlone;

      if (romanNumeralAlone !== 'Fr') {
        this.bracketedAlterations.push(['#', 1]);
      }

      if (romanNumeralAlone === 'Fr' || romanNumeralAlone === 'Sw') {
        this.bracketedAlterations.push(['#', 3]);
      }
    } else {
      romanNumeralAlone = rm[1];
      this.scaleDegree = _common__WEBPACK_IMPORTED_MODULE_11__["fromRoman"](romanNumeralAlone);
      workingFigure = workingFigure.replace(_romanNumeralAloneRegex, '');
      this.romanNumeralAlone = romanNumeralAlone;
    }

    return [workingFigure, useScale];
  }
  /**
   * get romanNumeral - return either romanNumeralAlone (II) or with frontAlterationAccidental (#II)
   *
   * @return {string}  new romanNumeral;
   */


  get romanNumeral() {
    if (this.frontAlterationAccidental === undefined) {
      return this.romanNumeralAlone;
    } else {
      return this.frontAlterationAccidental.modifier + this.romanNumeralAlone;
    }
  }

  get scale() {
    if (this._scale !== undefined) {
      return this._scale;
    } else {
      this._scale = this.key.getScale();
      return this._scale;
    }
  }

  get key() {
    return this._key;
  }

  set key(keyOrScale) {
    if (typeof keyOrScale === 'string') {
      this._key = new _key__WEBPACK_IMPORTED_MODULE_15__["Key"](keyOrScale);
    } else if (typeof keyOrScale === 'undefined') {
      this._key = new _key__WEBPACK_IMPORTED_MODULE_15__["Key"]('C');
    } else {
      this._key = keyOrScale;
    }

    if (keyOrScale === undefined) {
      this.useImpliedScale = true;
      this.impliedScale = new _scale__WEBPACK_IMPORTED_MODULE_17__["MajorScale"]('C');
    } else {
      this.useImpliedScale = false;
      this.impliedScale = false;
    }

    if (this._parsingComplete) {
      this._updatePitches();
    }
  }

  get figure() {
    return this._figure;
  }

  set figure(newFigure) {
    this._figure = newFigure;

    if (this._parsingComplete) {
      this._parseFigure();

      this._updatePitches();
    }
  }

  get figureAndKey() {
    var tonicName = this.key.tonic.name;
    var mode = '';

    if (this.key.mode !== undefined) {
      mode = ' ' + this.key.mode;
    }

    if (mode === ' minor') {
      tonicName = tonicName.toLowerCase();
    } else if (mode === ' major') {
      tonicName = tonicName.toUpperCase();
    }

    return this.figure + ' in ' + tonicName + mode;
  }

  get degreeName() {
    if (this.scaleDegree < 7) {
      return [undefined, 'Tonic', 'Supertonic', 'Mediant', 'Subdominant', 'Dominant', 'Submediant'][this.scaleDegree];
    } else {
      var tonicPitch = this.key.tonic;
      var diffRootToTonic = (tonicPitch.ps - this.root().ps) % 12;

      if (diffRootToTonic < 0) {
        diffRootToTonic += 12;
      }

      if (diffRootToTonic === 1) {
        return 'Leading-tone';
      } else {
        return 'Subtonic';
      }
    }
  }
  /**
   * Update the .pitches array.  Called at instantiation, but not automatically afterwards.
   *
   */


  _updatePitches() {
    var useScale;

    if (this.secondaryRomanNumeralKey !== undefined) {
      useScale = this.secondaryRomanNumeralKey;
    } else if (!this.useImpliedScale) {
      useScale = this.key;
    } else {
      useScale = this.impliedScale;
    }

    this.scaleCardinality = 7; // simple speedup;

    var bassScaleDegree = this.bassScaleDegreeFromNotation(this.figuresNotationObj);
    var bassPitch = useScale.pitchFromDegree(bassScaleDegree, 'ascending');
    var pitches = [bassPitch];
    var lastPitch = bassPitch;
    var numberNotes = this.figuresNotationObj.numbers.length;

    for (var j = 0; j < numberNotes; j++) {
      var i = numberNotes - j - 1;
      var thisScaleDegree = bassScaleDegree + this.figuresNotationObj.numbers[i] - 1;
      var newPitch = useScale.pitchFromDegree(thisScaleDegree, 'ascending');
      var pitchName = this.figuresNotationObj.modifiers[i].modifyPitchName(newPitch.name);
      var newNewPitch = new _pitch__WEBPACK_IMPORTED_MODULE_16__["Pitch"](pitchName);
      newNewPitch.octave = newPitch.octave;

      if (newNewPitch.ps < lastPitch.ps) {
        newNewPitch.octave += 1;
      }

      pitches.push(newNewPitch);
      lastPitch = newNewPitch;
    }

    if (this.frontAlterationTransposeInterval !== undefined) {
      var newPitches = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = pitches[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var thisPitch = _step2.value;

          var _newPitch = this.frontAlterationTransposeInterval.transposePitch(thisPitch);

          newPitches.push(_newPitch);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.pitches = newPitches;
    } else {
      this.pitches = pitches;
    }

    this._matchAccidentalsToQuality(this.impliedQuality);

    this.scaleOffset = this.frontAlterationTransposeInterval;

    if (this.omittedSteps.length) {
      var omittedPitches = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.omittedSteps[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var thisCS = _step3.value;
          var p = this.getChordStep(thisCS);

          if (p !== undefined) {
            omittedPitches.push(p.name);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _newPitches = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = pitches[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _thisPitch = _step4.value;

          if (!omittedPitches.includes(_thisPitch.name)) {
            _newPitches.push(_thisPitch);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.pitches = _newPitches; // do something...
    }

    this._correctBracketedPitches();
  }

  bassScaleDegreeFromNotation(notationObject) {
    var c = new _pitch__WEBPACK_IMPORTED_MODULE_16__["Pitch"]('C3');
    var cDNN = c.diatonicNoteNum; // always 22

    var pitches = [c];
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = notationObject.numbers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var i = _step5.value;
        var distanceToMove = i - 1;
        var newDiatonicNumber = cDNN + distanceToMove;

        var _interval$convertDiat = _interval__WEBPACK_IMPORTED_MODULE_14__["convertDiatonicNumberToStep"](newDiatonicNumber),
            _interval$convertDiat2 = _slicedToArray(_interval$convertDiat, 2),
            newStep = _interval$convertDiat2[0],
            newOctave = _interval$convertDiat2[1];

        var newPitch = new _pitch__WEBPACK_IMPORTED_MODULE_16__["Pitch"]('C3');
        newPitch.step = newStep;
        newPitch.octave = newOctave;
        pitches.push(newPitch);
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    var tempChord = new _chord__WEBPACK_IMPORTED_MODULE_10__["Chord"](pitches);
    var rootDNN = tempChord.root().diatonicNoteNum;
    var staffDistanceFromBassToRoot = rootDNN - cDNN;
    var bassSD = _common__WEBPACK_IMPORTED_MODULE_11__["posMod"](this.scaleDegree - staffDistanceFromBassToRoot, 7);

    if (bassSD === 0) {
      bassSD = 7;
    }

    return bassSD;
  }

  _matchAccidentalsToQuality(impliedQuality) {
    var correctSemitones = this._findSemitoneSizeForQuality(impliedQuality);

    var chordStepsToExamine = [3, 5, 7];

    for (var i = 0; i < chordStepsToExamine.length; i++) {
      var thisChordStep = chordStepsToExamine[i];
      var thisCorrect = correctSemitones[i];
      var thisSemis = this.semitonesFromChordStep(thisChordStep);

      if (thisCorrect === undefined) {
        continue;
      }

      if (thisSemis === undefined) {
        continue;
      }

      if (thisSemis === thisCorrect) {
        continue;
      }

      var correctedSemis = thisCorrect - thisSemis;

      if (correctedSemis >= 6) {
        correctedSemis = -1 * (12 - correctedSemis);
      } else if (correctedSemis <= -6) {
        correctedSemis += 12;
      }

      var faultyPitch = this.getChordStep(thisChordStep); // TODO: check for faultyPitch is undefined

      if (faultyPitch.accidental === undefined) {
        faultyPitch.accidental = new _pitch__WEBPACK_IMPORTED_MODULE_16__["Accidental"](correctedSemis);
      } else {
        var acc = faultyPitch.accidental;
        correctedSemis += acc.alter;

        if (correctedSemis >= 6) {
          correctedSemis = -1 * (12 - correctedSemis);
        } else if (correctedSemis <= -6) {
          correctedSemis += 12;
        }

        acc.set(correctedSemis);
      }
    }
  }

  _correctForSecondaryRomanNumeral(useScale) {
    var figure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    if (figure === undefined) {
      figure = this._figure;
    }

    var workingFigure = figure;
    var rx = new RegExp('(.*?)/([#a-np-zA-NP-Z].*)');
    var match = rx.exec(figure);

    if (match !== null) {
      var primaryFigure = match[1];
      var secondaryFigure = match[2];
      var secondaryRomanNumeral = new RomanNumeral(secondaryFigure, useScale);
      this.secondaryRomanNumeral = secondaryRomanNumeral;
      var secondaryMode;

      if (secondaryRomanNumeral.quality === 'minor') {
        secondaryMode = 'minor';
      } else if (secondaryRomanNumeral.quality === 'major') {
        secondaryMode = 'minor';
      } else if (secondaryRomanNumeral.semitonesFromChordStep(3) === 3) {
        secondaryMode = 'minor';
      } else {
        secondaryMode = 'major';
      }

      this.secondaryRomanNumeralKey = new _key__WEBPACK_IMPORTED_MODULE_15__["Key"](secondaryRomanNumeral.root().name, secondaryMode);
      useScale = this.secondaryRomanNumeralKey;
      workingFigure = primaryFigure;
    }

    return [workingFigure, useScale];
  }

  _parseOmittedSteps(workingFigure) {
    var omittedSteps = [];
    var rx = new RegExp(/\[no(\d+)]s*/);
    var match = rx.exec(workingFigure);

    while (match !== null) {
      var thisStepStr = match[1];
      var thisStep = parseInt(thisStepStr);
      thisStep = thisStep % 7 || 7;
      omittedSteps.push(thisStep);
      workingFigure = workingFigure.replace(rx, '');
      match = rx.exec(workingFigure);
    }

    this.omittedSteps = omittedSteps;
    return workingFigure;
  }

  _parseBracketedAlterations(workingFigure) {
    var bracketedAlterations = this.bracketedAlterations;
    var rx = new RegExp(/\[(b+|-+|#+)(\d+)]/);
    var match = rx.exec(workingFigure);

    while (match !== null) {
      var matchAlteration = match[1];
      var matchDegree = parseInt(match[2]);
      bracketedAlterations.push([matchAlteration, matchDegree]);
      workingFigure = workingFigure.replace(rx, '');
      match = rx.exec(workingFigure);
    }

    return workingFigure;
  }

  _findSemitoneSizeForQuality(impliedQuality) {
    var correctSemitones;

    if (impliedQuality === 'major') {
      correctSemitones = [4, 7];
    } else if (impliedQuality === 'minor') {
      correctSemitones = [3, 7];
    } else if (impliedQuality === 'diminished') {
      correctSemitones = [3, 6, 9];
    } else if (impliedQuality === 'half-diminished') {
      correctSemitones = [3, 6, 10];
    } else if (impliedQuality === 'augmented') {
      correctSemitones = [4, 8];
    } else if (impliedQuality === 'dominant-seventh') {
      correctSemitones = [4, 7, 10];
    } else {
      correctSemitones = [];
    }

    return correctSemitones;
  }
  /**
   * Gives a string display.  Note that since inversion is not yet supported
   * it needs to be given separately.
   *
   * Inverting 7th chords does not work.
   *
   * @param {string} displayType - ['roman', 'bassName', 'nameOnly', other]
   * @param {number} [inversion=0]
   * @returns {string}
   */


  asString(displayType) {
    var inversion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var keyObj = this.key;
    var tonicName = keyObj.tonic.name;
    var mode = keyObj.mode; // specifying inversion is for backwards compatibility only.

    if (inversion === undefined) {
      inversion = this.inversion();
    }

    var inversionName = '';

    if (inversion === 1) {
      if (displayType === 'roman') {
        inversionName = '6';
      } else {
        inversionName = ' (first inversion)';
      }
    } else if (inversion === 2) {
      if (displayType === 'roman') {
        inversionName = '64';
      } else {
        inversionName = ' (second inversion)';
      }
    }

    var fullChordName;
    var connector = ' in ';
    var suffix = '';

    if (displayType === 'roman') {
      fullChordName = this.figure;
      fullChordName = fullChordName.replace('/o', 'ø');
    } else if (displayType === 'nameOnly') {
      // use only with only choice being tonicName
      fullChordName = '';
      connector = '';
      suffix = ' triad';
    } else if (displayType === 'bassName') {
      fullChordName = this.bass().name.replace(/-/, 'b');
    } else {
      // "default" or "degreeName" submediant, etc...
      fullChordName = this.degreeName;

      if (this.numbers !== undefined) {
        fullChordName += ' ' + this.numbers.toString();
      }
    }

    var tonicDisplay = tonicName.replace(/-/, 'b');

    if (mode === 'minor') {
      tonicDisplay = tonicDisplay.toLowerCase();
    }

    var chordStr = fullChordName + inversionName + connector + tonicDisplay + ' ' + mode + suffix;
    return chordStr;
  }

}

/***/ }),

/***/ "./src/music21/scale.ts":
/*!******************************!*\
  !*** ./src/music21/scale.ts ***!
  \******************************/
/*! exports provided: Scale, AbstractScale, AbstractDiatonicScale, AbstractHarmonicMinorScale, AbstractAscendingMelodicMinorScale, ConcreteScale, DiatonicScale, MajorScale, MinorScale, HarmonicMinorScale, AscendingMelodicMinorScale, SimpleDiatonicScale, ScaleSimpleMajor, ScaleSimpleMinor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Scale", function() { return Scale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractScale", function() { return AbstractScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractDiatonicScale", function() { return AbstractDiatonicScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractHarmonicMinorScale", function() { return AbstractHarmonicMinorScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractAscendingMelodicMinorScale", function() { return AbstractAscendingMelodicMinorScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConcreteScale", function() { return ConcreteScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DiatonicScale", function() { return DiatonicScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MajorScale", function() { return MajorScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinorScale", function() { return MinorScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HarmonicMinorScale", function() { return HarmonicMinorScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AscendingMelodicMinorScale", function() { return AscendingMelodicMinorScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleDiatonicScale", function() { return SimpleDiatonicScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScaleSimpleMajor", function() { return ScaleSimpleMajor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScaleSimpleMinor", function() { return ScaleSimpleMinor; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./debug */ "./src/music21/debug.ts");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _interval__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./interval */ "./src/music21/interval.ts");
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./pitch */ "./src/music21/pitch.ts");






/**
 * Scale module. See {@link music21.scale} namespace
 * @module music21/scale
 */

/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/scale -- Scales
 *
 * Does not implement the full range of scales from music21p
 *
 * Copyright (c) 2013-17, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–17, Michael Scott Cuthbert and cuthbertLab
 *
 *
 *
 * Scale namespace.  Right now only supports very simple scales.
 *
 * @namespace music21.scale
 * @requires music21.base
 * @requires music21.common
 * @requires music21.debug
 * @requires music21.interval
 * @requires music21.pitch
 */





 // const DIRECTION_BI = 'bi';
// const DIRECTION_DESCENDING = 'descending';
// const DIRECTION_ASCENDING = 'ascending';

class Scale extends _base__WEBPACK_IMPORTED_MODULE_7__["Music21Object"] {
  constructor() {
    super();
    this.type = 'Scale';
    this.type = 'Scale';
  }

  static get className() {
    return 'music21.scale.Scale';
  }
  /**
   *
   * @returns {string}
   * @readonly
   */


  get name() {
    return this.type;
  }
  /**
   * @readonly
   * @returns {boolean}
   */


  get isConcrete() {
    return false;
  }

}
class AbstractScale extends Scale {
  constructor() {
    super();
    this._net = [];
    this.tonicDegree = 1;
    this.octaveDuplicating = true;
    this.deterministic = true;
    this._alteredDegrees = {};
    this._oneOctaveRealizationCache = undefined;
    this.type = 'Abstract';
  }

  static get className() {
    return 'music21.scale.AbstractScale';
  }
  /**
   * To be subclassed
   */


  buildNetwork() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    this._net = [];
  }
  /**
   * One scale equals another
   *
   * @param {AbstractScale} other - the scale compared to.
   * @returns {boolean}
   */


  equals(other) {
    if (_common__WEBPACK_IMPORTED_MODULE_8__["arrayEquals"](this.classes, other.classes) && this.tonicDegree === other.tonicDegree && _common__WEBPACK_IMPORTED_MODULE_8__["arrayEquals"](this._net, other._net)) {
      return true;
    } else {
      return false;
    }
  }

  buildNetworkFromPitches(pitchList) {
    var pitchListReal = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = pitchList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _p = _step.value;

        if (typeof _p === 'string') {
          pitchListReal.push(new _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"](_p));
        } else if (_p.classes.includes('Note')) {
          pitchListReal.push(_p.pitch);
        } else {
          pitchListReal.push(_p);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var pLast = pitchListReal[pitchListReal.length - 1];

    if (pLast.name === pitchListReal[0].name) {
      var p = pitchListReal[0].clone();

      if (pLast.ps > pitchListReal[0]) {
        // ascending;
        while (p.ps < pLast.ps) {
          p.octave += 1;
        }
      } else {
        while (p.ps < pLast.ps) {
          p.octave += -1;
        }
      }

      pitchListReal.push(p);
    }

    var intervalList = [];

    for (var i = 0; i < pitchListReal.length - 1; i++) {
      var thisInterval = new _interval__WEBPACK_IMPORTED_MODULE_9__["Interval"](pitchListReal[i], pitchListReal[i + 1]);
      intervalList.push(thisInterval);
    }

    this._net = intervalList;
  }

  getDegreeMaxUnique() {
    return this._net.length;
  } // noinspection JSUnusedLocalSymbols


  getRealization(pitchObj) {
    var unused_stepOfPitch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var unused_minPitch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var unused_maxPitch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    var unused_direction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    var unused_reverse = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

    // if (direction === undefined) {
    //     direction = DIRECTION_ASCENDING;
    // }
    // if (stepOfPitch === undefined) {
    //     stepOfPitch = 1;
    // }
    if (typeof pitchObj === 'string') {
      pitchObj = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"](pitchObj);
    } else {
      pitchObj = pitchObj.clone();
    }

    var post = [pitchObj];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this._net[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var intV = _step2.value;
        pitchObj = intV.transposePitch(pitchObj);
        post.push(pitchObj);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return post;
  }

  getPitchFromNodeDegree(pitchReference, unused_nodeName, nodeDegreeTarget) {
    var zeroIndexDegree = nodeDegreeTarget - 1;

    for (var i = 0; i < zeroIndexDegree; i++) {
      var thisIntv = this._net[i % this._net.length];
      pitchReference = thisIntv.transposePitch(pitchReference);
    }

    return pitchReference;
  } // noinspection JSUnusedLocalSymbols


  getRelativeNodeDegree(pitchReference, unused_nodeName, pitchTarget) {
    var unused_comparisonAttribute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    var unused_direction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

    if (typeof pitchTarget === 'string') {
      pitchTarget = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"](pitchTarget);
    }

    var realizedPitches;

    if (this._oneOctaveRealizationCache !== undefined) {
      realizedPitches = this._oneOctaveRealizationCache;
    } else {
      realizedPitches = this.getRealization(pitchReference);
      this._oneOctaveRealizationCache = realizedPitches;
    }

    var realizedNames = [];
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = realizedPitches[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var p = _step3.value;
        realizedNames.push(p.name);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var realizedIndex = realizedNames.indexOf(pitchTarget.name);

    if (realizedIndex === -1) {
      return undefined;
    } else {
      return realizedIndex + 1;
    }
  }

}
/**
 * @memberOf music21.scale
 *
 */

class AbstractDiatonicScale extends AbstractScale {
  /**
   *
   * @param {string} [mode]
   * @property {string} type
   * @property {number|undefined} tonicDegree
   * @property {number|undefined} dominantDegree
   * @property {boolean} octaveDuplicating
   */
  constructor() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'major';
    super();
    this.type = 'Abstract diatonic';
    this.tonicDegree = undefined;
    this.dominantDegree = undefined;
    this.octaveDuplicating = true;
    this.buildNetwork(mode);
  }

  static get className() {
    return 'music21.scale.AbstractDiatonicScale';
  }

  buildNetwork(mode) {
    var srcList = ['M2', 'M2', 'm2', 'M2', 'M2', 'M2', 'm2'];
    var intervalList;
    this.tonicDegree = 1;
    this.dominantDegree = 5;

    if (['major', 'ionian'].includes(mode)) {
      intervalList = srcList;
      this.relativeMajorDegree = 1;
      this.relativeMinorDegree = 6;
    } else if (['minor', 'aeolian'].includes(mode)) {
      intervalList = srcList.slice(5, 7);
      intervalList.push(...srcList.slice(0, 5));
      this.relativeMajorDegree = 3;
      this.relativeMinorDegree = 1;
    }

    this._net = [];
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = intervalList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var intVStr = _step4.value;

        this._net.push(new _interval__WEBPACK_IMPORTED_MODULE_9__["Interval"](intVStr));
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  }

}
/**
 * @memberOf music21.scale
 *
 */

class AbstractHarmonicMinorScale extends AbstractScale {
  static get className() {
    return 'music21.scale.AbstractHarmonicMinorScale';
  }

  constructor() {
    super();
    this.type = 'Abstract harmonic minor';
    this.octaveDuplicating = true;
    this.buildNetwork();
  }

  buildNetwork() {
    var intervalList = ['M2', 'm2', 'M2', 'M2', 'm2', 'A2', 'm2'];
    this._net = [];

    for (var _i = 0, _intervalList = intervalList; _i < _intervalList.length; _i++) {
      var intVStr = _intervalList[_i];

      this._net.push(new _interval__WEBPACK_IMPORTED_MODULE_9__["Interval"](intVStr));
    }
  }

} // temporary, until bidirectional scales are created
// no need for descending, since minor takes care of that.

/**
 * @memberOf music21.scale
 */

class AbstractAscendingMelodicMinorScale extends AbstractScale {
  static get className() {
    return 'music21.scale.AbstractAscendingMelodicMinorScale';
  }

  constructor() {
    super();
    this.type = 'Abstract ascending melodic minor';
    this.octaveDuplicating = true;
    this.buildNetwork();
  }

  buildNetwork() {
    var intervalList = ['M2', 'm2', 'M2', 'M2', 'M2', 'M2', 'm2'];
    this._net = [];

    for (var _i2 = 0, _intervalList2 = intervalList; _i2 < _intervalList2.length; _i2++) {
      var intVStr = _intervalList2[_i2];

      this._net.push(new _interval__WEBPACK_IMPORTED_MODULE_9__["Interval"](intVStr));
    }
  }

}
/**
 * @memberOf music21.scale
 */

class ConcreteScale extends Scale {
  constructor(tonic) {
    super();

    if (typeof tonic === 'string') {
      tonic = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"](tonic);
    }

    this.tonic = tonic;
    this.abstract = undefined;
  }

  static get className() {
    return 'music21.scale.ConcreteScale';
  } // when adding functionality here, must also be added to key.Key.


  get isConcrete() {
    if (this.tonic !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  getTonic() {
    return this.tonic;
  } // transpose
  // tune
  // No .romanNumeral function because of circular imports...
  // romanNumeral(degree) {
  //     return new roman.RomanNumeral(degree, this);
  // }
  // noinspection JSUnusedLocalSymbols


  getPitches() {
    var unused_minPitch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var unused_maxPitch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var unused_direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var pitchObj;

    if (this.tonic === undefined) {
      pitchObj = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"]('C4');
    } else {
      pitchObj = this.tonic;
    }

    return this.abstract.getRealization(pitchObj);
  } // noinspection JSUnusedLocalSymbols


  pitchFromDegree(degree) {
    var unused_minPitch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var unused_maxPitch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var unused_direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    var unused_equateTermini = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    return this.abstract.getPitchFromNodeDegree(this.tonic, this.abstract.tonicDegree, degree);
  } // noinspection JSUnusedLocalSymbols


  getScaleDegreeFromPitch(pitchTarget) {
    var unused_direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var unused_comparisonAttribute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    return this.abstract.getRelativeNodeDegree(this.tonic, this.abstract.tonicDegree, pitchTarget);
  }

}
/**
 * @memberOf music21.scale
 */

class DiatonicScale extends ConcreteScale {
  static get className() {
    return 'music21.scale.DiatonicScale';
  }

  constructor(tonic) {
    super(tonic); // a.k.a. ^2 :-)

    this.abstract = new AbstractDiatonicScale();
    this.type = 'diatonic';
  }

}
/**
 * @memberOf music21.scale
 */

class MajorScale extends DiatonicScale {
  static get className() {
    return 'music21.scale.MajorScale';
  }

  constructor(tonic) {
    super(tonic); // a.k.a. ^2 :-)

    this.type = 'major';
    this.abstract.buildNetwork(this.type);
  }

}
/**
 * @memberOf music21.scale
 */

class MinorScale extends DiatonicScale {
  static get className() {
    return 'music21.scale.MinorScale';
  }

  constructor(tonic) {
    super(tonic); // a.k.a. ^2 :-)

    this.type = 'minor';
    this.abstract.buildNetwork(this.type);
  }

}
/**
 * @memberOf music21.scale
 */

class HarmonicMinorScale extends ConcreteScale {
  static get className() {
    return 'music21.scale.HarmonicMinorScale';
  }

  constructor(tonic) {
    super(tonic); // a.k.a. ^2 :-)

    this.type = 'harmonic minor';
    this.abstract = new AbstractHarmonicMinorScale();
  }

}
/**
 * @memberOf music21.scale
 */

class AscendingMelodicMinorScale extends ConcreteScale {
  static get className() {
    return 'music21.scale.AscendingMelodicMinorScale';
  }

  constructor(tonic) {
    super(tonic); // a.k.a. ^2 :-)

    this.type = 'harmonic minor';
    this.abstract = new AbstractAscendingMelodicMinorScale();
  }

}
/**
 * Function, not class
 *
 * @memberOf music21.scale
 * @function music21.scale.SimpleDiatonicScale
 * @param {pitch.Pitch} [tonic]
 * @param {Array<string>} scaleSteps - an array of diatonic prefixes,
 *     generally 'M' (major) or 'm' (minor) describing the seconds.
 * @returns {Array<pitch.Pitch>} an octave of scale objects.
 */

function SimpleDiatonicScale(tonic, scaleSteps) {
  if (tonic === undefined) {
    tonic = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"]('C4');
  } else if (!(tonic instanceof _pitch__WEBPACK_IMPORTED_MODULE_10__["Pitch"])) {
    throw new _exceptions21__WEBPACK_IMPORTED_MODULE_5__["Music21Exception"]('Cannot make a scale not from ' + 'a music21.pitch.Pitch object: ' + tonic);
  }

  if (scaleSteps === undefined) {
    scaleSteps = ['M', 'M', 'm', 'M', 'M', 'M', 'm'];
  }

  var gi = new _interval__WEBPACK_IMPORTED_MODULE_9__["GenericInterval"](2);
  var pitches = [tonic];
  var lastPitch = tonic;

  for (var i = 0; i < scaleSteps.length; i++) {
    var di = new _interval__WEBPACK_IMPORTED_MODULE_9__["DiatonicInterval"](scaleSteps[i], gi);
    var ii = new _interval__WEBPACK_IMPORTED_MODULE_9__["Interval"](di);
    var newPitch = ii.transposePitch(lastPitch);

    if (_debug__WEBPACK_IMPORTED_MODULE_6__["debug"]) {
      console.log('ScaleSimpleMajor -- adding pitch: ' + newPitch.name);
    }

    pitches.push(newPitch);
    lastPitch = newPitch;
  }

  return pitches;
}
/**
 * One octave of a major scale
 *
 * @memberOf music21.scale
 * @function music21.scale.ScaleSimpleMajor
 * @param {pitch.Pitch} tonic
 * @returns {Array<pitch.Pitch>} an octave of scale objects.
 */

function ScaleSimpleMajor(tonic) {
  var scaleSteps = ['M', 'M', 'm', 'M', 'M', 'M', 'm'];
  return SimpleDiatonicScale(tonic, scaleSteps);
}
/**
 * One octave of a minor scale
 *
 * @memberOf music21.scale
 * @function music21.scale.ScaleSimpleMinor
 * @param {pitch.Pitch} tonic
 * @param {string} [minorType='natural'] - 'harmonic', 'harmonic-minor',
 *     'melodic', 'melodic-minor', 'melodic-minor-ascending',
 *     'melodic-ascending' or other (=natural/melodic-descending)
 * @returns {Array<pitch.Pitch>} an octave of scale objects.
 */

function ScaleSimpleMinor(tonic, minorType) {
  var scaleSteps = ['M', 'm', 'M', 'M', 'm', 'M', 'M'];

  if (typeof minorType === 'string') {
    // "harmonic minor" -> "harmonic-minor"
    minorType = minorType.replace(/\s/g, '-');
  }

  if (minorType === 'harmonic' || minorType === 'harmonic-minor') {
    scaleSteps[5] = 'A';
    scaleSteps[6] = 'm';
  } else if (minorType === 'melodic' || minorType === 'melodic-ascending' || minorType === 'melodic-minor' || minorType === 'melodic-minor-ascending') {
    scaleSteps[4] = 'M';
    scaleSteps[6] = 'm';
  }

  return SimpleDiatonicScale(tonic, scaleSteps);
}

/***/ }),

/***/ "./src/music21/sites.ts":
/*!******************************!*\
  !*** ./src/music21/sites.ts ***!
  \******************************/
/*! exports provided: SitesException, SiteRef, getId, Sites */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SitesException", function() { return SitesException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SiteRef", function() { return SiteRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getId", function() { return getId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sites", function() { return Sites; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.reverse */ "./node_modules/core-js/modules/es.array.reverse.js");
/* harmony import */ var core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.sort */ "./node_modules/core-js/modules/es.array.sort.js");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.weak-map */ "./node_modules/core-js/modules/es.weak-map.js");
/* harmony import */ var core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");












function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Objects for keeping track of relationships among Music21Objects. See {@link music21.sites} namespace
 *
 * Copyright 2017-2019, Michael Scott Cuthbert and cuthbertLab
 * License: BSD
 *
 * @namespace music21.sites
 * @memberof music21
 * @requires music21/common
 */


/**
 */

class SitesException extends _exceptions21__WEBPACK_IMPORTED_MODULE_12__["Music21Exception"] {}
/**
 * SiteRef.site is held strongly in Javascript.  This is
 * actually NOT a problem because of the difference between
 * the way JS Garbage Collection works from Python (in all
 * browsers since IE6...). They follow reference chains and
 * find unreachable references and don't just check reference
 * counts.  Thus circular references still allow memory to be
 * garbage collected.  Tested in Chrome on 100000 streams, and
 * very small additional memory usage.
 *
 * https://stackoverflow.com/questions/7347203/circular-references-in-javascript-garbage-collector
 */

class SiteRef {
  constructor() {
    this.isDead = false;
    this.globalSiteIndex = false;
  }

}

var _NoneSiteRef = new SiteRef();

_NoneSiteRef.globalSiteIndex = -2;
_NoneSiteRef.siteIndex = -2;

var _singletonCounter = new _common__WEBPACK_IMPORTED_MODULE_11__["SingletonCounter"]();

var GLOBAL_SITE_STATE_DICT = new WeakMap();
/**
 * @memberOf music21.sites
 * @param {*} obj
 * @returns {number|string}
 */

function getId(obj) {
  if (!GLOBAL_SITE_STATE_DICT.has(obj)) {
    var newId = _singletonCounter.call();

    GLOBAL_SITE_STATE_DICT.set(obj, newId);
  }

  return GLOBAL_SITE_STATE_DICT.get(obj);
}
/**
 * @memberOf music21.sites
 */

class Sites {
  constructor() {
    this._siteIndex = 0;
    this._lastID = -1;
    this.siteDict = new Map();
    this.siteDict.set(_NoneSiteRef.siteIndex, _NoneSiteRef);
  }

  get length() {
    return this.siteDict.size;
  }

  includes(checkSite) {
    // noinspection JSUnusedLocalSymbols
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.siteDict[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2),
            unused_key = _step$value[0],
            siteRef = _step$value[1];

        if (siteRef.site === checkSite) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  }
  /**
   *
   * @returns {Array<*>}
   */


  _keysByTime() {
    var newFirst = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var post = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this.siteDict[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _step2$value = _slicedToArray(_step2.value, 2),
            key = _step2$value[0],
            siteRef = _step2$value[1];

        var keyVal = [siteRef.siteIndex, key];
        post.push(keyVal);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    post.sort();

    if (newFirst) {
      post.reverse();
    }

    return post.map(innerList => innerList[1]);
  }

  add(obj) {
    var idKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var classString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    if (idKey === undefined && obj !== undefined) {
      idKey = getId(obj);
    }

    var updateNotAdd = false;

    if (this.siteDict.has(idKey)) {
      var tempSiteRef = this.siteDict.get(idKey);

      if (!tempSiteRef.isDead && tempSiteRef.site !== undefined) {
        updateNotAdd = true;
      }
    }

    if (obj !== undefined && classString === undefined) {
      classString = obj.classes[0];
    }

    var siteRef;

    if (updateNotAdd) {
      siteRef = this.siteDict.get(idKey);
      siteRef.isDead = false;
    } else {
      siteRef = new SiteRef();
    }

    siteRef.site = obj; // stores a weakRef;

    siteRef.classString = classString;
    siteRef.siteIndex = this._siteIndex;
    this._siteIndex += 1;
    siteRef.globalSiteIndex = _singletonCounter.call();

    if (!updateNotAdd) {
      this.siteDict.set(idKey, siteRef);
    }
  }
  /**
   * @param obj
   */


  remove(obj) {
    var idKey = getId(obj);

    if (idKey === undefined) {
      return false;
    }

    return this.siteDict.delete(idKey);
  }

  clear() {
    this.siteDict = new Map();
    this.siteDict.set(_NoneSiteRef.siteIndex, _NoneSiteRef);
    this._lastID = -1;
  }
  /**
   */


  yieldSites() {
    var _arguments = arguments,
        _this = this;

    return (
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var sortByCreationTime, priorityTarget, excludeNone, keyRepository, priorityId, priorityIndex, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key, siteRef, obj;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sortByCreationTime = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                priorityTarget = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : undefined;
                excludeNone = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : false;

                if (sortByCreationTime === true) {
                  keyRepository = _this._keysByTime(false);
                } else if (sortByCreationTime === 'reverse') {
                  keyRepository = _this._keysByTime(true);
                } else {
                  keyRepository = Array.from(_this.siteDict.keys());
                }

                if (priorityTarget !== undefined) {
                  priorityId = getId(priorityTarget);

                  if (keyRepository.includes(priorityId)) {
                    priorityIndex = keyRepository.indexOf(priorityId);
                    keyRepository.splice(priorityIndex, 1);
                    keyRepository.unshift(priorityId);
                  }
                }

                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context.prev = 8;
                _iterator3 = keyRepository[Symbol.iterator]();

              case 10:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context.next = 29;
                  break;
                }

                key = _step3.value;
                siteRef = _this.siteDict.get(key);

                if (!(siteRef === _NoneSiteRef)) {
                  _context.next = 19;
                  break;
                }

                if (excludeNone) {
                  _context.next = 17;
                  break;
                }

                _context.next = 17;
                return siteRef.site;

              case 17:
                _context.next = 26;
                break;

              case 19:
                obj = siteRef.site;

                if (!(obj === undefined)) {
                  _context.next = 24;
                  break;
                }

                siteRef.isDead = true;
                _context.next = 26;
                break;

              case 24:
                _context.next = 26;
                return obj;

              case 26:
                _iteratorNormalCompletion3 = true;
                _context.next = 10;
                break;

              case 29:
                _context.next = 35;
                break;

              case 31:
                _context.prev = 31;
                _context.t0 = _context["catch"](8);
                _didIteratorError3 = true;
                _iteratorError3 = _context.t0;

              case 35:
                _context.prev = 35;
                _context.prev = 36;

                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }

              case 38:
                _context.prev = 38;

                if (!_didIteratorError3) {
                  _context.next = 41;
                  break;
                }

                throw _iteratorError3;

              case 41:
                return _context.finish(38);

              case 42:
                return _context.finish(35);

              case 43:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 31, 35, 43], [36,, 38, 42]]);
      })()
    );
  }

  get() {
    var sortByCreationTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var priorityTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var excludeNone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var post = Array.from(this.yieldSites(sortByCreationTime, priorityTarget, excludeNone)); // we do this resorting again, because the priority target might not match id and we
    // want to be extra safe.  If you want fast, use .yieldSites

    if (priorityTarget !== undefined) {
      if (post.includes(priorityTarget)) {
        var priorityIndex = post.indexOf(priorityTarget);
        post.splice(priorityIndex, 1);
        post.unshift(priorityTarget);
      }
    }

    return post;
  }
  /**
   *
   * @param {string} attrName
   * @returns {undefined|*}
   */


  getAttrByName(attrName) {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = this.yieldSites('reverse')[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var obj = _step4.value;

        if (obj === undefined) {
          continue;
        }

        if (attrName in obj) {
          return obj[attrName];
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return undefined;
  }
  /**
   *
   * @param {string} className
   * @param {Object} [options]
   * @returns {Stream}
   */


  getObjByClass(className) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var params = {
      callerFirst: this,
      sortByCreationTime: false,
      priorityTarget: undefined,
      getElementMethod: 'getElementAtOrBefore',
      memo: {}
    };
    _common__WEBPACK_IMPORTED_MODULE_11__["merge"](params, options);
    var memo = params.memo;
    var post;
    var objs = Array.from(this.yieldSites(params.sortByCreationTime, params.priorityTarget, true // excludeNone
    ));

    for (var _i2 = 0, _objs = objs; _i2 < _objs.length; _i2++) {
      var obj = _objs[_i2];

      if (obj.isClassOrSubclass(className)) {
        post = obj;
        break;
      }
    }

    if (post !== undefined) {
      return post;
    }

    for (var _i3 = 0, _objs2 = objs; _i3 < _objs2.length; _i3++) {
      var _obj = _objs2[_i3];
      // TODO: check inside object... perhaps should not be done in m21p
      var objId = getId(_obj);

      if (!(objId in memo)) {
        memo[objId] = _obj;
      }

      post = _obj.getContextByClass(className, params);

      if (post !== undefined) {
        break;
      }
    }

    return post;
  }

}

/***/ }),

/***/ "./src/music21/stream.ts":
/*!*******************************!*\
  !*** ./src/music21/stream.ts ***!
  \*******************************/
/*! exports provided: filters, iterator, StreamException, Stream, Voice, Measure, Part, Score, OffsetMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StreamException", function() { return StreamException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Stream", function() { return Stream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Voice", function() { return Voice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Measure", function() { return Measure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Part", function() { return Part; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Score", function() { return Score; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OffsetMap", function() { return OffsetMap; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.flat */ "./node_modules/core-js/modules/es.array.flat.js");
/* harmony import */ var core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.sort */ "./node_modules/core-js/modules/es.array.sort.js");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.unscopables.flat */ "./node_modules/core-js/modules/es.array.unscopables.flat.js");
/* harmony import */ var core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.weak-map */ "./node_modules/core-js/modules/es.weak-map.js");
/* harmony import */ var core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! midicube */ "./node_modules/midicube/releases/midicube.js");
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(midicube__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./debug */ "./src/music21/debug.ts");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");
/* harmony import */ var _beam__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./beam */ "./src/music21/beam.ts");
/* harmony import */ var _clef__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./clef */ "./src/music21/clef.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./duration */ "./src/music21/duration.ts");
/* harmony import */ var _instrument__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./instrument */ "./src/music21/instrument.ts");
/* harmony import */ var _meter__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./meter */ "./src/music21/meter.ts");
/* harmony import */ var _note__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./note */ "./src/music21/note.ts");
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./pitch */ "./src/music21/pitch.ts");
/* harmony import */ var _renderOptions__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./renderOptions */ "./src/music21/renderOptions.ts");
/* harmony import */ var _tempo__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./tempo */ "./src/music21/tempo.ts");
/* harmony import */ var _vfShow__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./vfShow */ "./src/music21/vfShow.ts");
/* harmony import */ var _musicxml_m21ToXml__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./musicxml/m21ToXml */ "./src/music21/musicxml/m21ToXml.ts");
/* harmony import */ var _stream_filters__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./stream/filters */ "./src/music21/stream/filters.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return _stream_filters__WEBPACK_IMPORTED_MODULE_28__; });
/* harmony import */ var _stream_iterator__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./stream/iterator */ "./src/music21/stream/iterator.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "iterator", function() { return _stream_iterator__WEBPACK_IMPORTED_MODULE_29__; });












function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/stream -- Streams -- objects that hold other Music21Objects
 *
 * Does not implement the full features of music21p Streams by a long shot...
 *
 * Copyright (c) 2013-19, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006-19, Michael Scott Cuthbert
 *     and cuthbertLab
 *
 * powerful stream module, See {@link music21.stream} namespace
 * @exports music21/stream
 *
 * Streams are powerful music21 objects that hold Music21Object collections,
 * such as {@link music21.note.Note} or {@link music21.chord.Chord} objects.
 *
 * Understanding the {@link Stream} object is of fundamental
 * importance for using music21.  Definitely read the music21(python) tutorial
 * on using Streams before proceeding
 *
 * @namespace music21.stream
 * @memberof music21
 * @requires music21/base
 * @requires music21/renderOptions
 * @requires music21/clef
 * @requires music21/vfShow
 * @requires music21/duration
 * @requires music21/common
 * @requires music21/meter
 * @requires music21/pitch
 * @requires jQuery
 *
 */















 // eslint-disable-next-line import/no-cycle






class StreamException extends _exceptions21__WEBPACK_IMPORTED_MODULE_13__["Music21Exception"] {}

function _exportMusicXMLAsText(s) {
  var gox = new _musicxml_m21ToXml__WEBPACK_IMPORTED_MODULE_27__["GeneralObjectExporter"](s);
  return gox.parse();
}
/**
 * A generic Stream class -- a holder for other music21 objects
 * Will be subclassed into {@link Score},
 * {@link Part},
 * {@link Measure},
 * {@link Voice}, but most functions will be found here.
 *
 * @property {number} length - (readonly) the number of elements in the stream.
 * @property {Duration} duration - the total duration of the stream's elements
 * @property {number} highestTime -- the highest time point in the stream's elements
 * @property {music21.clef.Clef} clef - the clef for the Stream (if there is
 *     one; if there are multiple, then the first clef)
 * @property {music21.meter.TimeSignature} timeSignature - the first TimeSignature of the Stream
 * @property {music21.key.KeySignature} keySignature - the first KeySignature for the Stream
 * @property {renderOptions.RenderOptions} renderOptions - an object
 *     specifying how to render the stream
 * @property {Stream} flat - (readonly) a flattened representation of the Stream
 * @property {StreamIterator} notes - (readonly) the stream with
 *     only {@link music21.note.Note} and {@link music21.chord.Chord} objects included
 * @property {StreamIterator} notesAndRests - (readonly) like notes but
 *     also with {@link music21.note.Rest} objects included
 * @property {StreamIterator} parts - (readonly) a filter on the Stream
 *     to just get the parts (NON-recursive)
 * @property {StreamIterator} measures - (readonly) a filter on the
 *     Stream to just get the measures (NON-recursive)
 * @property {number} tempo - tempo in beats per minute (will become more
 *     sophisticated later, but for now the whole stream has one tempo
 * @property {music21.instrument.Instrument|undefined} instrument - an
 *     instrument object associated with the stream (can be set with a
 *     string also, but will return an `Instrument` object)
 * @property {boolean} autoBeam - whether the notes should be beamed automatically
 *    or not (will be moved to `renderOptions` soon)
 * @property {Vex.Flow.Stave|undefined} activeVFStave - the current Stave object for the Stream
 * @property {music21.vfShow.Renderer|undefined} activeVFRenderer - the current
 *     vfShow.Renderer object for the Stream
 * @property {int} [staffLines=5] - number of staff lines
 * @property {function|undefined} changedCallbackFunction - function to
 *     call when the Stream changes through a standard interface
 * @property {number} maxSystemWidth - confusing... should be in renderOptions
 */


class Stream extends _base__WEBPACK_IMPORTED_MODULE_15__["Music21Object"] {
  constructor() {
    super(); // from music21p's core.py

    this._offsetDict = new WeakMap();
    this._elements = []; // TODO(msc): endElements

    this.isSorted = true; // from music21p's __init__.py
    // class attributes.

    this.isStream = true;
    this.isMeasure = false;
    this.classSortOrder = -20;
    this.recursionType = 'elementsFirst'; // this may change to an enum
    // TODO(msc): _styleClass
    // individual instance attributes
    // TODO(msc): StreamStatus
    // TODO(msc): _unlinkedDuration

    this.autoSort = true;
    this.isFlat = true; // TODO(msc): definesExplicitSystemBreaks
    // TODO(msc): definesExplicitPageBreaks
    // TODO(msc): _atSoundingPitch
    // TODO(msc): _mutable -- experimental
    // music21j specific attributes NOT to remove:

    this.activeVFStave = undefined;
    this.activeVFRenderer = undefined;
    this.changedCallbackFunction = undefined; // for editable svg objects
    // music21j specific attributes eventually to remove:

    this.storedVexflowStave = undefined; // cannot figure out diff w/ activeVFStave

    this.activeNote = undefined;
    this._clef = undefined;
    this.displayClef = undefined;
    this._keySignature = undefined; // a music21.key.KeySignature object

    this._timeSignature = undefined; // a music21.meter.TimeSignature object

    this._instrument = undefined;
    this._autoBeam = undefined;
    this.renderOptions = new _renderOptions__WEBPACK_IMPORTED_MODULE_24__["RenderOptions"]();
    this._tempo = undefined;
    this.staffLines = 5;
    this._stopPlaying = false;
    this._overriddenDuration = undefined;
    this._cloneCallbacks.activeVexflowNote = false;
    this._cloneCallbacks.storedVexflowStave = false;
    this._cloneCallbacks._offsetDict = false;

    this._cloneCallbacks.renderOptions = function cloneRenderOptions(keyName, newObj, self, deep, memo) {
      if (!deep) {
        newObj.renderOptions = self.renderOptions;
        return;
      }

      var newRenderOptions = JSON.parse(JSON.stringify(self.renderOptions));
      newRenderOptions.events = _extends({}, self.renderOptions.events);
      newObj.renderOptions = newRenderOptions;
    };

    this._cloneCallbacks._elements = function cloneElements(keyName, newObj, self, deep, memo) {
      if (!deep) {
        newObj.elements = self;
        return;
      }

      newObj.clear();

      for (var j = 0; j < self._elements.length; j++) {
        var el = self._elements[j];
        var elOffset = self.elementOffset(el); // console.log('cloning el: ', el.name);

        var elCopy = el.clone(true, memo); // there may be more efficient ways to do this,
        // but for now, safety trumps efficiency.

        newObj.insert(elOffset, elCopy, {
          ignoreSort: true
        });
      } // isSorted will be cloned elsewhere.

    };

    this.DOMChangerFunction = e => {
      var canvasOrSVGElement = e.currentTarget;

      if (!(canvasOrSVGElement instanceof HTMLElement) && !(canvasOrSVGElement instanceof SVGElement)) {
        return undefined;
      }

      var _this$findNoteForClic = this.findNoteForClick(canvasOrSVGElement, e),
          _this$findNoteForClic2 = _slicedToArray(_this$findNoteForClic, 2),
          clickedDiatonicNoteNum = _this$findNoteForClic2[0],
          foundNote = _this$findNoteForClic2[1];

      if (foundNote === undefined) {
        if (_debug__WEBPACK_IMPORTED_MODULE_14__["debug"]) {
          console.log('No note found');
        }

        return undefined;
      }

      return this.noteChanged(clickedDiatonicNoteNum, foundNote, canvasOrSVGElement);
    };
  }

  static get className() {
    return 'music21.stream.Stream';
  }
  /**
   *
   * @returns {IterableIterator<Music21Object>}
   */


  [Symbol.iterator]() {
    var _this = this;

    return (
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.autoSort && !_this.isSorted) {
                  _this.sort();
                }

                i = 0;

              case 2:
                if (!(i < _this.length)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return _this.get(i);

              case 5:
                i++;
                _context.next = 2;
                break;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })()
    );
  }

  forEach(callback, thisArg) {
    if (thisArg !== undefined) {
      callback = callback.bind(thisArg);
    }

    var i = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var el = _step.value;
        callback(el, i, this);
        i += 1;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  get duration() {
    if (this._overriddenDuration instanceof _duration__WEBPACK_IMPORTED_MODULE_19__["Duration"]) {
      // return new duration.Duration(32.0);
      return this._overriddenDuration;
    }

    return new _duration__WEBPACK_IMPORTED_MODULE_19__["Duration"](this.highestTime);
  }

  set duration(newDuration) {
    this._overriddenDuration = newDuration;
  }

  get highestTime() {
    var highestTime = 0.0;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var el = _step2.value;
        var endTime = el.offset;

        if (el.duration !== undefined) {
          endTime += el.duration.quarterLength;
        }

        if (endTime > highestTime) {
          highestTime = endTime;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return highestTime;
  }

  get semiFlat() {
    return this._getFlatOrSemiFlat(true);
  }

  get flat() {
    return this._getFlatOrSemiFlat(false);
  }

  _getFlatOrSemiFlat(retainContainers) {
    var newSt = this.clone(false); // console.log('done cloning...');

    if (!this.isFlat) {
      // not the most efficient, but safety counts for a lot...
      // namely, do not set inner streams activeSites to be
      // in things that they won't have later.
      newSt.clear();
      var ri = new _stream_iterator__WEBPACK_IMPORTED_MODULE_29__["RecursiveIterator"](this, {
        restoreActiveSites: false,
        includeSelf: false,
        ignoreSorting: true
      });
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = ri[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var e = _step3.value;

          if (e.isStream && !retainContainers) {
            continue;
          }

          newSt.insert(ri.currentHierarchyOffset(), e, {
            setActiveSite: false,
            ignoreSort: true
          });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }

    if (!retainContainers) {
      newSt.isFlat = true;
      newSt.coreElementsChanged({
        updateIsFlat: false
      });
    } else {
      newSt.coreElementsChanged();
    }

    return newSt;
  }

  get notes() {
    return this.getElementsByClass(['Note', 'Chord']);
  }

  get notesAndRests() {
    return this.getElementsByClass('GeneralNote');
  }

  get tempo() {
    if (this._tempo === undefined && this.activeSite !== undefined) {
      return this.activeSite.tempo;
    } else if (this._tempo === undefined) {
      return 150;
    } else {
      return this._tempo;
    }
  }

  set tempo(newTempo) {
    this._tempo = newTempo;
  }
  /**
   * Return an array of the outer bounds of each MetronomeMark in the stream.
   * [offsetStart, offsetEnd, tempo.MetronomeMark]
   *
   * @returns {Array<number|music21.tempo.MetronomeMark>}
   */


  _metronomeMarkBoundaries() {
    var mmBoundaries = [];
    var thisFlat = this.flat;
    var metronomeMarks = thisFlat.getElementsByClass('MetronomeMark');
    var highestTime = thisFlat.highestTime;
    var lowestOffset = 0;
    var mmDefault = new _tempo__WEBPACK_IMPORTED_MODULE_25__["MetronomeMark"]({
      number: 120
    });

    if (!metronomeMarks.length) {
      mmBoundaries.push([lowestOffset, highestTime, mmDefault]);
    } else if (metronomeMarks.length === 1) {
      var metronomeMark = metronomeMarks.get(0);
      var offset = metronomeMark.getOffsetBySite(thisFlat);

      if (offset > lowestOffset) {
        mmBoundaries.push([lowestOffset, offset, mmDefault]);
        mmBoundaries.push([offset, highestTime, metronomeMark]);
      } else {
        mmBoundaries.push([lowestOffset, highestTime, metronomeMark]);
      }
    } else {
      var offsetPairs = [];

      for (var i = 0; i < metronomeMarks.length; i++) {
        var _metronomeMark = metronomeMarks.get(i);

        offsetPairs.push([_metronomeMark.getOffsetBySite(thisFlat), _metronomeMark]);
      }

      if (offsetPairs[0][0] > lowestOffset) {
        mmBoundaries.push([lowestOffset, offsetPairs[0][0], mmDefault]);
      }

      offsetPairs.forEach((offsetPair, i) => {
        if (i === offsetPairs.length - 1) {
          mmBoundaries.push([offsetPair[0], highestTime, offsetPair[1]]);
        } else {
          mmBoundaries.push([offsetPair[0], offsetPairs[i + 1][0], offsetPair[1]]);
        }
      });
    }

    return mmBoundaries;
  }
  /**
   * Return the average tempo within the span indicated by offset start and end.
   *
   * @param {number} oStart - offset start
   * @param {number} oEnd - offset end
   * @returns {number}
   */


  _averageTempo(oStart, oEnd) {
    var overallDuration = oEnd - oStart;
    return this._metronomeMarkBoundaries().reduce((tempo, mm) => {
      if (mm[0] >= oStart && mm[0] < oEnd) {
        var overlapDur = mm[1] <= oEnd ? mm[1] - mm[0] : oEnd - mm[0];
        tempo += overlapDur / overallDuration * mm[2].number;
      } else if (mm[1] > oStart && mm[1] <= oEnd) {
        var _overlapDur = mm[0] >= oStart ? mm[1] - mm[0] : mm[1] - oStart;

        tempo += _overlapDur / overallDuration * mm[2].number;
      } else if (mm[0] <= oStart && mm[1] >= oEnd) {
        tempo = mm[2].number;
      }

      return tempo;
    }, 0);
  }

  get instrument() {
    if (this._instrument === undefined && this.activeSite !== undefined) {
      return this.activeSite.instrument;
    } else {
      return this._instrument;
    }
  }

  set instrument(newInstrument) {
    if (typeof newInstrument === 'string') {
      newInstrument = new _instrument__WEBPACK_IMPORTED_MODULE_20__["Instrument"](newInstrument);
    }

    this._instrument = newInstrument;
  }
  /**
   * specialContext gets from a private attribute or from zero-position
   * or from site's first or special context.
   *
   * @private
   */


  _specialContext(attr) {
    var privAttr = '_' + attr;

    if (this[privAttr] !== undefined) {
      return this[privAttr];
    } // should be:
    // const contextClef = this.getContextByClass('Clef');
    //        const context = this.getContextByClass('Stream', { getElementMethod: 'getElementBefore' });
    //        let contextObj;
    //        if (context !== undefined && context !== this) {
    //            contextObj = context[privAttr];
    //        }


    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = this.sites.yieldSites()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var site = _step4.value;

        if (site === undefined) {
          continue;
        }

        var contextObj = site._firstElementContext(attr);

        if (contextObj === undefined) {
          contextObj = site._specialContext(attr);
        }

        if (contextObj !== undefined) {
          return contextObj;
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return undefined;
  }
  /**
   * Get an attribute like 'keySignature' from an element with the
   * same class name (except 'KeySignature' instead of 'keySignature')
   * in the stream at position 0.
   *
   * @private
   */


  _firstElementContext(attr) {
    var firstElements = this.getElementsByOffset(0.0).getElementsByClass(attr.charAt(0).toUpperCase() + attr.slice(1));

    if (firstElements.length) {
      return firstElements.get(0);
    } else {
      return undefined;
    }
  }

  get clef() {
    return this.getSpecialContext('clef', false);
  }

  set clef(newClef) {
    var oldClef = this._firstElementContext('clef');

    if (oldClef !== undefined) {
      this.replace(oldClef, newClef);
    } else {
      this.insert(0.0, newClef);
    }

    this._clef = newClef;
  }

  get keySignature() {
    return this.getSpecialContext('keySignature', false);
  }

  set keySignature(newKeySignature) {
    var oldKS = this._firstElementContext('keySignature');

    if (oldKS !== undefined) {
      this.replace(oldKS, newKeySignature);
    } else {
      this.insert(0.0, newKeySignature);
    }

    this._keySignature = newKeySignature;
  }

  get timeSignature() {
    return this.getSpecialContext('timeSignature', false);
  }

  set timeSignature(newTimeSignature) {
    if (typeof newTimeSignature === 'string') {
      newTimeSignature = new _meter__WEBPACK_IMPORTED_MODULE_21__["TimeSignature"](newTimeSignature);
    }

    var oldTS = this._firstElementContext('timeSignature');

    if (oldTS !== undefined) {
      this.replace(oldTS, newTimeSignature);
    } else {
      this.insert(0.0, newTimeSignature);
    }

    this._timeSignature = newTimeSignature;
  }

  get autoBeam() {
    return this._specialContext('autoBeam');
  }

  set autoBeam(ab) {
    this._autoBeam = ab;
  }

  get maxSystemWidth() {
    var baseMaxSystemWidth = 750;

    if (this.renderOptions.maxSystemWidth === undefined && this.activeSite !== undefined) {
      baseMaxSystemWidth = this.activeSite.maxSystemWidth;
    } else if (this.renderOptions.maxSystemWidth !== undefined) {
      baseMaxSystemWidth = this.renderOptions.maxSystemWidth;
    }

    return baseMaxSystemWidth / this.renderOptions.scaleFactor.x;
  }

  set maxSystemWidth(newSW) {
    this.renderOptions.maxSystemWidth = newSW * this.renderOptions.scaleFactor.x;
  }

  get parts() {
    return this.getElementsByClass('Part');
  }

  get measures() {
    return this.getElementsByClass('Measure');
  }

  get voices() {
    return this.getElementsByClass('Voice');
  }

  get length() {
    return this._elements.length;
  }
  /**
   * Property: the elements in the stream returned as an Array and set
   * either from an Array or from another Stream.  Setting from another Stream
   * will preserve the offsets.
   * DO NOT MODIFY individual components (consider it like a Python tuple)
   *
   * Note that a Stream is never returned from .elements,
   * but TypeScript requires getter and setters to have the same
   * function signature.
   */


  get elements() {
    if (!this.isSorted) {
      this.sort();
    }

    return this._elements;
  }

  set elements(newElements) {
    var highestOffsetSoFar = 0.0;
    this.clear();
    var tempInsert = [];
    var i;
    var thisEl;

    if (newElements instanceof Stream) {
      // iterate to set active site;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = newElements[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var unused = _step5.value;
        } // eslint-disable-line no-empty

      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      newElements = newElements.elements;
    }

    for (i = 0; i < newElements.length; i++) {
      thisEl = newElements[i];
      var thisElOffset = thisEl.offset;

      if (thisElOffset === undefined || thisElOffset === highestOffsetSoFar) {
        // append
        this._elements.push(thisEl);

        this.setElementOffset(thisEl, highestOffsetSoFar);

        if (thisEl.duration === undefined) {
          console.error('No duration for ', thisEl, ' in ', this);
        }

        highestOffsetSoFar += thisEl.duration.quarterLength;
      } else {
        // append -- slow
        tempInsert.push(thisEl);
      }
    } // console.warn('end', highestOffsetSoFar, tempInsert);


    for (i = 0; i < tempInsert.length; i++) {
      thisEl = tempInsert[i];
      this.insert(thisEl.offset, thisEl);
    }

    this.coreElementsChanged(); // would be called already if newElements != [];
  }
  /**
   * getSpecialContext is a transitional replacement for
   * .clef, .keySignature, .timeSignature that looks
   * for context to get the appropriate element as ._clef, etc.
   * as a way of making the older music21j attributes still work while
   * transitioning to a more music21p-like approach.
   *
   * May be removed
   */


  getSpecialContext(context) {
    var warnOnCall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var first_el = this._firstElementContext(context);

    if (first_el !== undefined) {
      return first_el;
    }

    var special_context = this._specialContext(context);

    if (special_context === undefined) {
      return undefined;
    }

    if (warnOnCall) {
      console.warn("Calling special context ".concat(context, "!"));
    }

    return special_context;
  }

  clear() {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = this._elements[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var e = _step6.value;

        if (e.activeSite === this) {
          e.activeSite = undefined;
        }

        e.sites.remove(this);
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    this._elements = [];
    this._offsetDict = new WeakMap();
    this.isFlat = true;
    this.isSorted = true;
  }

  coreElementsChanged() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$updateIsFlat = _ref.updateIsFlat,
        updateIsFlat = _ref$updateIsFlat === void 0 ? true : _ref$updateIsFlat,
        _ref$clearIsSorted = _ref.clearIsSorted,
        clearIsSorted = _ref$clearIsSorted === void 0 ? true : _ref$clearIsSorted,
        _ref$memo = _ref.memo,
        memo = _ref$memo === void 0 ? undefined : _ref$memo,
        _ref$keepIndex = _ref.keepIndex,
        keepIndex = _ref$keepIndex === void 0 ? false : _ref$keepIndex;

    if (clearIsSorted) {
      this.isSorted = false;
    }

    if (updateIsFlat) {
      this.isFlat = true;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this._elements[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var e = _step7.value;

          if (e.isStream) {
            this.isFlat = false;
            break;
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    }
  }

  recurse() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$streamsOnly = _ref2.streamsOnly,
        streamsOnly = _ref2$streamsOnly === void 0 ? false : _ref2$streamsOnly,
        _ref2$restoreActiveSi = _ref2.restoreActiveSites,
        restoreActiveSites = _ref2$restoreActiveSi === void 0 ? true : _ref2$restoreActiveSi,
        _ref2$classFilter = _ref2.classFilter,
        classFilter = _ref2$classFilter === void 0 ? undefined : _ref2$classFilter,
        _ref2$skipSelf = _ref2.skipSelf,
        skipSelf = _ref2$skipSelf === void 0 ? true : _ref2$skipSelf;

    var includeSelf = !skipSelf;
    var ri = new _stream_iterator__WEBPACK_IMPORTED_MODULE_29__["RecursiveIterator"](this, {
      streamsOnly,
      restoreActiveSites,
      includeSelf
    });

    if (classFilter !== undefined) {
      ri.addFilter(new _stream_filters__WEBPACK_IMPORTED_MODULE_28__["ClassFilter"](classFilter));
    }

    return ri;
  }
  /**
   * Add an element to the end of the stream, setting its `.offset` accordingly
   *
   * @param elOrElList - element
   * or list of elements to append
   * @returns {this}
   */


  append(elOrElList) {
    if (Array.isArray(elOrElList)) {
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = elOrElList[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _el = _step8.value;
          this.append(_el);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return this;
    }

    var el = elOrElList;

    if (!(el instanceof _base__WEBPACK_IMPORTED_MODULE_15__["Music21Object"])) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_13__["Music21Exception"]('Can only append a music21 object.');
    }

    try {
      if (el.isClassOrSubclass !== undefined && el.isClassOrSubclass('NotRest')) {// set stem direction on output...;
      }

      var elOffset = this.highestTime;

      this._elements.push(el);

      this.setElementOffset(el, elOffset);
      el.offset = elOffset;
      el.sites.add(this);
      el.activeSite = this;
    } catch (err) {
      console.error('Cannot append element ', el, ' to stream ', this, ' : ', err);
    }

    this.coreElementsChanged({
      clearIsSorted: false
    });
    return this;
  }

  sort() {
    if (this.isSorted) {
      return this;
    }

    this._elements.sort((a, b) => this._offsetDict.get(a) - this._offsetDict.get(b) || a.priority - b.priority || a.classSortOrder - b.classSortOrder);

    this.isSorted = true;
    return this;
  }
  /**
   * Add an element to the specified place in the stream, setting its `.offset` accordingly
   *
   * @param {number} offset - offset to place.
   * @param {Music21Object} el - element to append
   * @param {Object} [config] -- configuration options
   * @param {boolean} [config.ignoreSort=false] -- do not sort
   * @param {boolean} [config.setActiveSite=true] -- set the active site for the inserted element.
   * @returns {this}
   */


  insert(offset, el) {
    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref3$ignoreSort = _ref3.ignoreSort,
        ignoreSort = _ref3$ignoreSort === void 0 ? false : _ref3$ignoreSort,
        _ref3$setActiveSite = _ref3.setActiveSite,
        setActiveSite = _ref3$setActiveSite === void 0 ? true : _ref3$setActiveSite;

    if (el === undefined) {
      throw new StreamException('Cannot insert without an element.');
    }

    try {
      if (!ignoreSort) {
        if (offset <= this.highestTime) {
          this.isSorted = false;
        }
      }

      this._elements.push(el);

      this.setElementOffset(el, offset);
      el.sites.add(this);

      if (setActiveSite) {
        el.activeSite = this;
      }

      this.coreElementsChanged({
        clearIsSorted: false
      });
    } catch (err) {
      console.error('Cannot insert element ', el, ' to stream ', this, ' : ', err);
    }

    return this;
  }
  /**
   * Inserts a single element at offset, shifting elements at or after it begins
   * later in the stream.
   *
   * In single argument form, assumes it is an element and takes the offset from the element.
   *
   * Unlike music21p, does not take a list of elements.  TODO(msc): add this feature.
   *
   * @param {number|Music21Object} offset -- offset of the item to insert
   * @param {Music21Object|undefined} [elementOrNone] -- element.
   * @return {this}
   */


  insertAndShift(offset, elementOrNone) {
    var element;

    if (elementOrNone === undefined) {
      element = offset;
      offset = element.offset;
    } else {
      element = elementOrNone;

      if (typeof offset !== 'number') {
        throw new Error('offset must be a number if elementOrNone is not given');
      }
    }

    var amountToShift = element.duration.quarterLength;
    var shiftingOffsets = false;

    for (var i = 0; i < this.length; i++) {
      var existingEl = this._elements[i];
      var existingElOffset = this.elementOffset(existingEl);

      if (!shiftingOffsets && existingElOffset >= offset) {
        shiftingOffsets = true;
      }

      if (shiftingOffsets) {
        this.setElementOffset(existingEl, existingElOffset + amountToShift);
      }
    }

    this.insert(offset, element);
    return this;
  }
  /**
   * Return the first matched index
   */


  index(el) {
    if (!this.isSorted && this.autoSort) {
      this.sort();
    }

    var index = this._elements.indexOf(el);

    if (index === -1) {
      // endElements
      throw new StreamException("cannot find object (".concat(el, ") in Stream"));
    }

    return index;
  }
  /**
   * Remove and return the last element in the stream,
   * or return undefined if the stream is empty
   */


  pop() {
    if (!this.isSorted && this.autoSort) {
      this.sort();
    } // remove last element;


    if (this.length > 0) {
      var el = this.get(-1);

      this._elements.pop();

      this._offsetDict.delete(el);

      el.sites.remove(this);
      this.coreElementsChanged({
        clearIsSorted: false
      });
      return el;
    } else {
      return undefined;
    }
  }
  /**
   * Remove an object from this Stream.  shiftOffsets and recurse do nothing.
   */


  remove(targetOrList) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$shiftOffsets = _ref4.shiftOffsets,
        shiftOffsets = _ref4$shiftOffsets === void 0 ? false : _ref4$shiftOffsets,
        _ref4$recurse = _ref4.recurse,
        recurse = _ref4$recurse === void 0 ? false : _ref4$recurse;

    if (shiftOffsets === true) {
      throw new StreamException('sorry cannot shiftOffsets yet');
    }

    if (recurse === true) {
      throw new StreamException('sorry cannot recurse yet');
    }

    var targetList;

    if (!Array.isArray(targetOrList)) {
      targetList = [targetOrList];
    } else {
      targetList = targetOrList;
    } //        if (targetList.length > 1) {
    //            sort targetList
    //        }
    // let shiftDur = 0.0; // for shiftOffsets


    var i = -1;
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = targetList[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var target = _step9.value;
        i += 1;
        var indexInStream = void 0;

        try {
          indexInStream = this.index(target);
        } catch (err) {
          if (err instanceof StreamException) {
            if (recurse) {// do something
            }

            continue;
          }

          throw err;
        } // const matchOffset = this._offsetDict[indexInStream];
        // let match;
        // handle _endElements
        // let matchedEndElement = false;
        // let baseElementCount = this._elements.length;


        this._elements.splice(indexInStream, 1);

        this._offsetDict.delete(target);

        target.activeSite = undefined;
        target.sites.remove(this); // remove from sites if needed.
        //            if (shiftOffsets) {
        //                const matchDuration = target.duration.quarterLength;
        //                const shiftedRegionStart = matchOffset + matchDuration;
        //                shiftDur += matchDuration;
        //                let shiftedRegionEnd;
        //                if ((i + 1) < targetList.length) {
        //                    const nextElIndex = this.index(targetList[i + 1]);
        //                    const nextElOffset = this._offsetDict[nextElIndex];
        //                    shiftedRegionEnd = nextElOffset;
        //                } else {
        //                    shiftedRegionEnd = this.duration.quarterLength;
        //                }
        //                if (shiftDur !== 0.0) {
        //                    for (const e of this.getElementsByOffset(
        //                       shiftedRegionStart,
        //                       shiftedRegionEnd,
        //                       {
        //                           includeEndBoundary: false,
        //                           mustFinishInSpan: false,
        //                           mustBeginInSpan: false,
        //                       }
        //                    )) {
        //                        const elementOffset = this.elementOffset(e);
        //                        this.setElementOffset(e, elementOffset - shiftDur);
        //                    }
        //                }
        //            }
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    this.coreElementsChanged({
      clearIsSorted: false
    });
  }
  /**
   *  Given a `target` object, replace it with
   *  the supplied `replacement` object.
   *
   *  `recurse` and `allDerived` do not currently work.
   *
   *  Does nothing if target cannot be found.
   */


  replace(target, replacement) {
    var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref5$recurse = _ref5.recurse,
        recurse = _ref5$recurse === void 0 ? false : _ref5$recurse,
        _ref5$allDerived = _ref5.allDerived,
        allDerived = _ref5$allDerived === void 0 ? true : _ref5$allDerived;

    try {
      this.index(target);
    } catch (err) {
      if (err instanceof StreamException) {
        return;
      } else {
        throw err;
      }
    }

    var targetOffset = this.elementOffset(target);
    this.remove(target);
    this.insert(targetOffset, replacement);
    this.coreElementsChanged({
      clearIsSorted: false
    });
  }
  /**
   * Get the `index`th element from the Stream.  Equivalent to the
   * music21p format of s[index] using __getitem__.  Can use negative indexing to get from the end.
   *
   * Once Proxy objects are supported by all operating systems for
   *
   * @param {number} index - can be -1, -2, to index from the end, like python
   * @returns {Music21Object|undefined}
   */


  get(index) {
    // substitute for Python stream __getitem__; supports -1 indexing, etc.
    if (!this.isSorted) {
      this.sort();
    }

    var el;

    if (index === undefined || Number.isNaN(index)) {
      return undefined;
    } else if (Math.abs(index) > this._elements.length) {
      return undefined;
    } else if (index === this._elements.length) {
      return undefined;
    } else if (index < 0) {
      el = this._elements[this._elements.length + index];
      el.activeSite = this;
      return el;
    } else {
      el = this._elements[index];
      el.activeSite = this;
      return el;
    }
  }
  /**
   *
   */


  set(index, newEl) {
    var replaceEl = this.get(index);

    if (replaceEl === undefined) {
      throw new StreamException("Cannot set element at index ".concat(index, "."));
    }

    this.replace(replaceEl, newEl);
    return this;
  }

  setElementOffset(el, value) {
    var addElement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!this._elements.includes(el)) {
      if (addElement) {
        this.insert(value, el);
        return;
      } else {
        throw new StreamException('Cannot set the offset for element ' + el.toString() + ', not in Stream');
      }
    }

    this._offsetDict.set(el, value);

    el.activeSite = this;
  }

  elementOffset(element) {
    var stringReturns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!this._offsetDict.has(element)) {
      throw new StreamException('An entry for this object ' + element.toString() + ' is not stored in this Stream.');
    } else {
      return this._offsetDict.get(element);
    }
  }
  /*  --- ############# END ELEMENT FUNCTIONS ########## --- */

  /**
   * Takes a stream and places all of its elements into
   * measures (:class:`~music21.stream.Measure` objects)
   * based on the :class:`~music21.meter.TimeSignature` objects
   * placed within
   * the stream. If no TimeSignatures are found in the
   * stream, a default of 4/4 is used.
    * If `options.inPlace` is true, the original Stream is modified and lost
   * if `options.inPlace` is False, this returns a modified deep copy.
    * @param {Object} [options]
   * @returns {Stream}
   */


  makeMeasures(options) {
    var params = {
      meterStream: undefined,
      refStreamOrTimeRange: undefined,
      searchContext: false,
      innerBarline: undefined,
      finalBarline: 'final',
      bestClef: false,
      inPlace: false
    };
    _common__WEBPACK_IMPORTED_MODULE_18__["merge"](params, options);
    var voiceCount;

    if (this.hasVoices()) {
      voiceCount = this.getElementsByClass('Voice').length;
    } else {
      voiceCount = 0;
    } // MSC 2019 -- this was not working or even being used.
    // // meterStream
    // const meterStream = this.getElementsByClass('TimeSignature');
    // if (meterStream.length === 0) {
    //     meterStream.append(this.timeSignature);
    // }
    // getContextByClass('Clef')


    var clefObj = this.getSpecialContext('clef') || this.getContextByClass('Clef');
    var offsetMap = this.offsetMap();
    var oMax = 0;

    for (var i = 0; i < offsetMap.length; i++) {
      if (offsetMap[i].endTime > oMax) {
        oMax = offsetMap[i].endTime;
      }
    }

    var classConstructor = this.constructor;
    var post = new classConstructor(); // derivation

    var o = 0.0;
    var measureCount = 0;
    var lastTimeSignature;
    var m;
    var mStart;

    while (measureCount === 0 || o < oMax) {
      m = new Measure();
      m.number = measureCount + 1; // var thisTimeSignature = meterStream.getElementAtOrBefore(o);

      var thisTimeSignature = this.timeSignature;

      if (thisTimeSignature === undefined) {
        break;
      }

      var oneMeasureLength = thisTimeSignature.barDuration.quarterLength;

      if (oneMeasureLength === 0) {
        // if for some reason we are advancing not at all, then get out!
        break;
      }

      if (measureCount === 0) {// simplified...
      }

      m.clef = clefObj;
      m.timeSignature = thisTimeSignature.clone();

      for (var voiceIndex = 0; voiceIndex < voiceCount; voiceIndex++) {
        var v = new Voice();
        v.id = voiceIndex;
        m.insert(0, v);
      }

      post.insert(o, m);
      o += oneMeasureLength;
      measureCount += 1;
      lastTimeSignature = thisTimeSignature;
    }

    for (var _i2 = 0; _i2 < offsetMap.length; _i2++) {
      var ob = offsetMap[_i2];
      var e = ob.element;
      var start = ob.offset;
      var _voiceIndex = ob.voiceIndex; // if 'Spanner' in e.classes;

      lastTimeSignature = undefined;

      for (var j = 0; j < post.length; j++) {
        m = post.get(j); // nothing but measures...

        var foundTS = m.getSpecialContext('timeSignature');

        if (foundTS !== undefined) {
          lastTimeSignature = foundTS;
        }

        mStart = m.getOffsetBySite(post);
        var mEnd = void 0;

        if (lastTimeSignature !== undefined) {
          mEnd = mStart + lastTimeSignature.barDuration.quarterLength;
        } else {
          mEnd = mStart + 4.0;
        }

        if (start >= mStart && start < mEnd) {
          break;
        }
      } // if not match, raise Exception;


      var oNew = start - mStart;

      if (m.clef === e) {
        continue;
      }

      if (oNew === 0 && e.isClassOrSubclass('TimeSignature')) {
        continue;
      }

      var insertStream = m;

      if (_voiceIndex !== undefined) {
        insertStream = m.getElementsByClass('Voice').get(_voiceIndex);
      }

      insertStream.insert(oNew, e);
    } // set barlines, etc.


    if (params.inPlace !== true) {
      return post;
    } else {
      this.elements = []; // endElements
      // elementsChanged;

      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = post[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var _e2 = _step10.value;
          this.insert(_e2.offset, _e2);
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return this; // javascript style;
    }
  }

  containerInHierarchy(el) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref6$setActiveSite = _ref6.setActiveSite,
        setActiveSite = _ref6$setActiveSite === void 0 ? true : _ref6$setActiveSite;

    var elSites = el.sites;
    var _iteratorNormalCompletion11 = true;
    var _didIteratorError11 = false;
    var _iteratorError11 = undefined;

    try {
      for (var _iterator11 = this.recurse({
        skipSelf: false,
        streamsOnly: true,
        restoreActiveSites: false
      })[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
        var s = _step11.value;

        if (elSites.includes(s)) {
          if (setActiveSite) {
            el.activeSite = s;
          }

          return s;
        }
      }
    } catch (err) {
      _didIteratorError11 = true;
      _iteratorError11 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
          _iterator11.return();
        }
      } finally {
        if (_didIteratorError11) {
          throw _iteratorError11;
        }
      }
    }

    return undefined;
  }
  /**
   * chordify does not yet work...
   */


  chordify() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$addTies = _ref7.addTies,
        addTies = _ref7$addTies === void 0 ? true : _ref7$addTies,
        _ref7$addPartIdAsGrou = _ref7.addPartIdAsGroup,
        addPartIdAsGroup = _ref7$addPartIdAsGrou === void 0 ? true : _ref7$addPartIdAsGrou,
        _ref7$removeRedundant = _ref7.removeRedundantPitches,
        removeRedundantPitches = _ref7$removeRedundant === void 0 ? true : _ref7$removeRedundant,
        _ref7$toSoundingPitch = _ref7.toSoundingPitch,
        toSoundingPitch = _ref7$toSoundingPitch === void 0 ? true : _ref7$toSoundingPitch;

    var workObj = this;
    var templateStream;

    if (this.hasPartLikeStreams()) {
      templateStream = workObj.getElementsByClass('Stream').get(0);
    } else {
      templateStream = workObj;
    }

    var template = templateStream.template({
      fillWithRests: false,
      removeClasses: ['GeneralNote'],
      retainVoices: false
    });
    return template;
  }

  template() {
    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref8$fillWithRests = _ref8.fillWithRests,
        fillWithRests = _ref8$fillWithRests === void 0 ? true : _ref8$fillWithRests,
        _ref8$removeClasses = _ref8.removeClasses,
        removeClasses = _ref8$removeClasses === void 0 ? [] : _ref8$removeClasses,
        _ref8$retainVoices = _ref8.retainVoices,
        retainVoices = _ref8$retainVoices === void 0 ? true : _ref8$retainVoices;

    var out = this.cloneEmpty('template');
    var restInfo = {
      offset: undefined,
      endTime: undefined
    };

    var optionalAddRest = function optionalAddRest() {
      if (!fillWithRests) {
        return;
      }

      if (restInfo.offset === undefined) {
        return;
      }

      var restQL = restInfo.endTime - restInfo.offset;
      var restObj = new _note__WEBPACK_IMPORTED_MODULE_22__["Rest"]();
      restObj.duration.quarterLength = restQL;
      out.insert(restInfo.offset, restObj);
      restInfo.offset = undefined;
      restInfo.endTime = undefined;
    };

    var _iteratorNormalCompletion12 = true;
    var _didIteratorError12 = false;
    var _iteratorError12 = undefined;

    try {
      for (var _iterator12 = this[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
        var el = _step12.value;

        if (el.isStream && (retainVoices || el.classes.includes('Voice'))) {
          optionalAddRest();
          var outEl = el.template({
            fillWithRests,
            removeClasses,
            retainVoices
          });
          out.insert(el.offset, outEl);
        }
      }
    } catch (err) {
      _didIteratorError12 = true;
      _iteratorError12 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
          _iterator12.return();
        }
      } finally {
        if (_didIteratorError12) {
          throw _iteratorError12;
        }
      }
    }

    return out;
  }

  cloneEmpty(derivationMethod) {
    var returnObj = this.constructor(); // TODO(msc): derivation

    returnObj.mergeAttributes(this);
    return returnObj;
  }
  /**
   *
   * @param {this} other
   * @returns {this}
   */


  mergeAttributes(other) {
    super.mergeAttributes(other);

    for (var _i3 = 0, _arr2 = ['autoSort', 'isSorted', 'definesExplicitSystemBreaks', 'definesExplicitPageBreaks', '_atSoundingPitch', '_mutable']; _i3 < _arr2.length; _i3++) {
      var attr = _arr2[_i3];

      if (Object.prototype.hasOwnProperty.call(other, attr)) {
        this[attr] = other[attr];
      }
    }

    return this;
  }
  /**
   * makeNotation does not do anything yet, but it is a placeholder
   * so it can start to be called.
   *
   * TODO: move call to makeBeams from renderVexflow to here.
   */


  makeNotation() {
    var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref9$inPlace = _ref9.inPlace,
        inPlace = _ref9$inPlace === void 0 ? true : _ref9$inPlace;

    var out;

    if (inPlace) {
      out = this;
    } else {
      out = this.clone(true);
    }

    this.makeAccidentals();
    return out;
  }
  /**
   * Return a new Stream or modify this stream
   * to have beams.
   *
   * Called from renderVexflow()
   */


  makeBeams() {
    var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref10$inPlace = _ref10.inPlace,
        inPlace = _ref10$inPlace === void 0 ? false : _ref10$inPlace;

    var returnObj = this;

    if (!inPlace) {
      returnObj = this.clone(true);
    }

    var mColl;

    if (this.classes.includes('Measure')) {
      mColl = [returnObj];
    } else {
      mColl = [];
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = returnObj.getElementsByClass('Measure')[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var m = _step13.value;
          mColl.push(m);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }
    }

    var lastTimeSignature;
    var _iteratorNormalCompletion14 = true;
    var _didIteratorError14 = false;
    var _iteratorError14 = undefined;

    try {
      for (var _iterator14 = mColl[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
        var _m = _step14.value;

        if (_m.timeSignature !== undefined) {
          lastTimeSignature = _m.timeSignature;
        }

        if (lastTimeSignature === undefined) {
          throw new StreamException('Need a Time Signature to process beams');
        } // todo voices!


        if (_m.length <= 1) {
          continue; // nothing to beam.
        }

        var noteStream = _m.notesAndRests;
        var durList = [];
        var _iteratorNormalCompletion15 = true;
        var _didIteratorError15 = false;
        var _iteratorError15 = undefined;

        try {
          for (var _iterator15 = noteStream[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
            var _n2 = _step15.value;
            durList.push(_n2.duration);
          }
        } catch (err) {
          _didIteratorError15 = true;
          _iteratorError15 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
              _iterator15.return();
            }
          } finally {
            if (_didIteratorError15) {
              throw _iteratorError15;
            }
          }
        }

        var durSum = durList.map(a => a.quarterLength).reduce((total, val) => total + val);
        var barQL = lastTimeSignature.barDuration.quarterLength;

        if (durSum > barQL) {
          continue;
        }

        var offset = 0.0;

        if (_m.paddingLeft !== 0.0 && _m.paddingLeft !== undefined) {
          offset = _m.paddingLeft;
        } else if (noteStream.highestTime < barQL) {
          offset = barQL - noteStream.highestTime;
        }

        var beamsList = lastTimeSignature.getBeams(noteStream, {
          measureStartOffset: offset
        });

        for (var i = 0; i < noteStream.length; i++) {
          var n = noteStream.get(i);
          var thisBeams = beamsList[i];

          if (thisBeams !== undefined) {
            n.beams = thisBeams;
          } else {
            n.beams = new _beam__WEBPACK_IMPORTED_MODULE_16__["Beams"]();
          }
        }
      } // returnObj.streamStatus.beams = true;

    } catch (err) {
      _didIteratorError14 = true;
      _iteratorError14 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
          _iterator14.return();
        }
      } finally {
        if (_didIteratorError14) {
          throw _iteratorError14;
        }
      }
    }

    return returnObj;
  }
  /**
   * Returns a boolean value showing if this
   * Stream contains any Parts or Part-like
   * sub-Streams.
   *
   * Will deal with Part-like sub-streams later
   * for now just checks for real Part objects.
   *
   * Part-like sub-streams are Streams that
   * contain Measures or Notes. And where no
   * sub-stream begins at an offset besides zero.
   */


  hasPartLikeStreams() {
    var _iteratorNormalCompletion16 = true;
    var _didIteratorError16 = false;
    var _iteratorError16 = undefined;

    try {
      for (var _iterator16 = this[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
        var el = _step16.value;

        if (el.classes.includes('Part')) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError16 = true;
      _iteratorError16 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
          _iterator16.return();
        }
      } finally {
        if (_didIteratorError16) {
          throw _iteratorError16;
        }
      }
    }

    return false;
  }
  /**
   * Returns true if any note in the stream has lyrics, otherwise false
   *
   * @returns {boolean}
   */


  hasLyrics() {
    var _iteratorNormalCompletion17 = true;
    var _didIteratorError17 = false;
    var _iteratorError17 = undefined;

    try {
      for (var _iterator17 = this[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
        var el = _step17.value;

        if (el.lyric !== undefined) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError17 = true;
      _iteratorError17 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
          _iterator17.return();
        }
      } finally {
        if (_didIteratorError17) {
          throw _iteratorError17;
        }
      }
    }

    return false;
  }
  /**
   * Returns a list of OffsetMap objects
   */


  offsetMap() {
    var offsetMap = [];
    var groups = [];

    if (this.hasVoices()) {
      // TODO(msc) -- remove jQuery each...
      jquery__WEBPACK_IMPORTED_MODULE_11__["each"](this.getElementsByClass('Voice'), (i, v) => {
        groups.push([v.flat, i]);
      });
    } else {
      groups = [[this, undefined]];
    }

    for (var i = 0; i < groups.length; i++) {
      var group = groups[i][0];
      var voiceIndex = groups[i][1];

      for (var j = 0; j < group.length; j++) {
        var e = group.get(j);
        var dur = e.duration.quarterLength;
        var offset = group.elementOffset(e);
        var endTime = offset + dur;
        var thisOffsetMap = new OffsetMap(e, offset, endTime, voiceIndex);
        offsetMap.push(thisOffsetMap);
      }
    }

    return offsetMap;
  }

  get iter() {
    return new _stream_iterator__WEBPACK_IMPORTED_MODULE_29__["StreamIterator"](this);
  }
  /**
   * Find all elements with a certain class; if an Array is given, then any
   * matching class will work.
   *
   * @param {string[]|string} classList - a list of classes to find
   */


  getElementsByClass(classList) {
    return this.iter.getElementsByClass(classList);
  }
  /**
   * Find all elements NOT with a certain class; if an Array is given, then any
   * matching class will work.
   *
   * @param {string[]|string} classList - a list of classes to find
   */


  getElementsNotOfClass(classList) {
    return this.iter.getElementsNotOfClass(classList);
  } //    getElementsByClass(classList) {
  //        const tempEls = [];
  //        for (const thisEl of this) {
  //            // console.warn(thisEl);
  //            if (thisEl.isClassOrSubclass === undefined) {
  //                console.error(
  //                    'what the hell is a ',
  //                    thisEl,
  //                    'doing in a Stream?'
  //                );
  //            } else if (thisEl.isClassOrSubclass(classList)) {
  //                tempEls.push(thisEl);
  //            }
  //        }
  //        const newSt = this.clone(false);
  //        newSt.elements = tempEls;
  //        return newSt;
  //    }

  /**
   * Returns a new stream [StreamIterator does not yet exist in music21j]
   * containing all Music21Objects that are found at a certain offset or
   * within a certain offset time range (given the offsetStart and
   * (optional) offsetEnd values).
   *
   * See music21p documentation for the effect of various parameters.
   */


  getElementsByOffset(offsetStart) {
    var offsetEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    var _ref11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref11$includeEndBoun = _ref11.includeEndBoundary,
        includeEndBoundary = _ref11$includeEndBoun === void 0 ? true : _ref11$includeEndBoun,
        _ref11$mustFinishInSp = _ref11.mustFinishInSpan,
        mustFinishInSpan = _ref11$mustFinishInSp === void 0 ? false : _ref11$mustFinishInSp,
        _ref11$mustBeginInSpa = _ref11.mustBeginInSpan,
        mustBeginInSpan = _ref11$mustBeginInSpa === void 0 ? true : _ref11$mustBeginInSpa,
        _ref11$includeElement = _ref11.includeElementsThatEndAtStart,
        includeElementsThatEndAtStart = _ref11$includeElement === void 0 ? true : _ref11$includeElement,
        _ref11$classList = _ref11.classList,
        classList = _ref11$classList === void 0 ? undefined : _ref11$classList;

    var s;

    if (classList !== undefined) {
      s = this.iter.getElementsByClass(classList);
    } else {
      s = this.iter;
    }

    s.getElementsByOffset(offsetStart, offsetEnd, {
      includeEndBoundary,
      mustFinishInSpan,
      mustBeginInSpan,
      includeElementsThatEndAtStart
    });
    return s;
  }
  /**
   *  Given an element (from another Stream) returns the single element
   *  in this Stream that is sounding while the given element starts.
   *
   *  If there are multiple elements sounding at the moment it is
   *  attacked, the method returns the first element of the same class
   *  as this element, if any. If no element
   *  is of the same class, then the first element encountered is
   *  returned. For more complex usages, use allPlayingWhileSounding.
   *
   *  Returns None if no elements fit the bill.
   *
   *  The optional elStream is the stream in which el is found.
   *  If provided, el's offset
   *  in that Stream is used.  Otherwise, the current offset in
   *  el is used.  It is just
   *  in case you are paranoid that el.offset might not be what
   *  you want, because of some fancy manipulation of
   *  el.activeSite
   *
   * @param {Music21Object} el - object with an offset and class to search for.
   * @param {Stream} [elStream] - a place to get el's offset from.
   * @returns {Music21Object|undefined}
   */


  playingWhenAttacked(el, elStream) {
    var elOffset;

    if (elStream !== undefined) {
      elOffset = el.getOffsetBySite(elStream);
    } else {
      elOffset = el.offset;
    }

    var otherElements = this.getElementsByOffset(elOffset, elOffset, {
      mustBeginInSpan: false
    });

    if (otherElements.length === 0) {
      return undefined;
    } else if (otherElements.length === 1) {
      return otherElements.get(0);
    } else {
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = otherElements[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var thisEl = _step18.value;

          if (el.constructor === thisEl.constructor) {
            return thisEl;
          }
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }

      return otherElements.get(0);
    }
  }
  /**
   * Sets Pitch.accidental.displayStatus for every element with a
   * pitch or pitches in the stream. If a natural needs to be displayed
   * and the Pitch does not have an accidental object yet, adds one.
   *
   * Called automatically before appendDOM routines are called.
   *
   * @returns {this}
   */


  makeAccidentals() {
    // cheap version of music21p method
    var extendableStepList = {};
    var stepNames = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
    var ks = this.keySignature || this.getContextByClass('KeySignature');

    for (var _i4 = 0, _stepNames = stepNames; _i4 < _stepNames.length; _i4++) {
      var stepName = _stepNames[_i4];
      var stepAlter = 0;

      if (ks !== undefined) {
        var tempAccidental = ks.accidentalByStep(stepName);

        if (tempAccidental !== undefined) {
          stepAlter = tempAccidental.alter; // console.log(stepAlter + " " + stepName);
        }
      }

      extendableStepList[stepName] = stepAlter;
    }

    var lastOctaveStepList = [];

    for (var i = 0; i < 10; i++) {
      var tempOctaveStepDict = _extends({}, extendableStepList); // clone


      lastOctaveStepList.push(tempOctaveStepDict);
    }

    var lastOctavelessStepDict = _extends({}, extendableStepList); // probably unnecessary, but safe...


    var _iteratorNormalCompletion19 = true;
    var _didIteratorError19 = false;
    var _iteratorError19 = undefined;

    try {
      for (var _iterator19 = this[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
        var el = _step19.value;

        if (el.pitch !== undefined) {
          // note
          var p = el.pitch;
          var lastStepDict = lastOctaveStepList[p.octave];

          this._makeAccidentalForOnePitch(p, lastStepDict, lastOctavelessStepDict);
        } else if (el.notes !== undefined) {
          // chord
          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = el.notes[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var chordNote = _step20.value;
              var _p = chordNote.pitch;
              var _lastStepDict = lastOctaveStepList[_p.octave];

              this._makeAccidentalForOnePitch(_p, _lastStepDict, lastOctavelessStepDict);
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError19 = true;
      _iteratorError19 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
          _iterator19.return();
        }
      } finally {
        if (_didIteratorError19) {
          throw _iteratorError19;
        }
      }
    }

    return this;
  } //  returns pitch


  _makeAccidentalForOnePitch(p, lastStepDict, lastOctavelessStepDict) {
    if (lastStepDict === undefined) {
      // octave < 0 or > 10? -- error that appeared sometimes.
      lastStepDict = {};
    }

    var newAlter;

    if (p.accidental === undefined) {
      newAlter = 0;
    } else {
      newAlter = p.accidental.alter;
    } // console.log(p.name + " " + lastStepDict[p.step].toString());


    if (lastStepDict[p.step] !== newAlter || lastOctavelessStepDict[p.step] !== newAlter) {
      if (p.accidental === undefined) {
        p.accidental = new _pitch__WEBPACK_IMPORTED_MODULE_23__["Accidental"]('natural');
      }

      p.accidental.displayStatus = true; // console.log("setting displayStatus to true");
    } else if (lastStepDict[p.step] === newAlter && lastOctavelessStepDict[p.step] === newAlter) {
      if (p.accidental !== undefined) {
        p.accidental.displayStatus = false;
      } // console.log("setting displayStatus to false");

    }

    lastStepDict[p.step] = newAlter;
    lastOctavelessStepDict[p.step] = newAlter;
    return p;
  }
  /**
   * Sets the render options for any substreams (such as placing them
   * in systems, etc.) DOES NOTHING for music21.stream.Stream, but is
   * overridden in subclasses.
   *
   * @returns {this}
   */


  setSubstreamRenderOptions() {
    /* does nothing for standard streams ... */
    return this;
  }
  /**
   * Resets all the RenderOptions back to defaults. Can run recursively
   * and can also preserve the `RenderOptions.events` object.
   *
   * @param {boolean} [recursive=false]
   * @param {boolean} [preserveEvents=false]
   * @returns {this}
   */


  resetRenderOptions(recursive, preserveEvents) {
    var oldEvents = this.renderOptions.events;
    this.renderOptions = new _renderOptions__WEBPACK_IMPORTED_MODULE_24__["RenderOptions"]();

    if (preserveEvents) {
      this.renderOptions.events = oldEvents;
    }

    if (recursive) {
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;

      try {
        for (var _iterator21 = this[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var el = _step21.value;

          if (el.isClassOrSubclass('Stream')) {
            el.resetRenderOptions(recursive, preserveEvents);
          }
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }
    }

    return this;
  } //  * *********  VexFlow functionality


  renderVexflowOnCanvas(canvasOrSVG) {
    console.warn('renderVexflowOnCanvas is deprecated; call renderVexflow instead');
    return this.renderVexflow(canvasOrSVG);
  }

  write() {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'musicxml';
    return _exportMusicXMLAsText(this);
  }
  /**
   * Uses {@link music21.vfShow.Renderer} to render Vexflow onto an
   * existing canvas or SVG object.
   *
   * Runs `this.setRenderInteraction` on the canvas.
   *
   * Will be moved to vfShow eventually when converter objects are enabled...maybe.
   *
   * @param {jQuery|HTMLElement} $canvasOrSVG - a canvas or the div surrounding an SVG object
   * @returns {music21.vfShow.Renderer}
   */


  renderVexflow($canvasOrSVG) {
    /**
     * @type {HTMLElement|undefined}
     */
    var canvasOrSVG;

    if ($canvasOrSVG instanceof jquery__WEBPACK_IMPORTED_MODULE_11__) {
      canvasOrSVG = $canvasOrSVG[0];
    } else {
      canvasOrSVG = $canvasOrSVG;
    }

    var DOMContains = document.body.contains(canvasOrSVG);

    if (!DOMContains) {
      // temporarily add to DOM so Firefox can measure it...
      document.body.appendChild(canvasOrSVG);
    }

    var tagName = canvasOrSVG.tagName.toLowerCase();

    if (this.autoBeam === true) {
      try {
        this.makeBeams({
          inPlace: true
        });
      } catch (e) {
        if (!e.toString().includes('Time Signature')) {
          throw e;
        }
      }
    }

    var vfr = new _vfShow__WEBPACK_IMPORTED_MODULE_26__["Renderer"](this, canvasOrSVG);

    if (tagName === 'canvas') {
      vfr.rendererType = 'canvas';
    } else if (tagName === 'svg') {
      vfr.rendererType = 'svg';
    }

    vfr.render();
    this.setRenderInteraction(canvasOrSVG);
    this.activeVFRenderer = vfr;

    if (!DOMContains) {
      // remove the adding to DOM so that Firefox could measure it...
      document.body.removeChild(canvasOrSVG);
    }

    return vfr;
  }
  /**
   * Estimate the stream height for the Stream.
   *
   * If there are systems they will be incorporated into the height unless `ignoreSystems` is `true`.
   *
   * @param {boolean} [ignoreSystems=false]
   * @returns {number} height in pixels
   */


  estimateStreamHeight() {
    var ignoreSystems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var staffHeight = this.renderOptions.naiveHeight;
    var marginBottom = this.renderOptions.marginBottom; // extra at end.

    var systemPadding = 0;

    if (this instanceof Score) {
      systemPadding = this.systemPadding;
    }

    var numSystems;

    if (this instanceof Score) {
      var numParts = this.parts.length;
      numSystems = this.numSystems();

      if (numSystems === undefined || ignoreSystems) {
        numSystems = 1;
      }

      var scoreHeight = numSystems * staffHeight * numParts + (numSystems - 1) * systemPadding + marginBottom;

      if (numSystems > 1) {
        // needs a little extra padding for some reason...
        scoreHeight += systemPadding / 2;
      } // console.log('scoreHeight of ' + scoreHeight);


      return scoreHeight;
    } else if (this instanceof Part) {
      numSystems = 1;

      if (!ignoreSystems) {
        numSystems = this.numSystems();
      }

      if (_debug__WEBPACK_IMPORTED_MODULE_14__["debug"]) {
        console.log('estimateStreamHeight for Part: numSystems [' + numSystems + '] * staffHeight [' + staffHeight + '] + (numSystems [' + numSystems + '] - 1) * systemPadding [' + systemPadding + '].');
      }

      return numSystems * staffHeight + (numSystems - 1) * systemPadding + marginBottom;
    } else {
      return staffHeight + marginBottom;
    }
  }
  /**
   * Estimates the length of the Stream in pixels.
   *
   * @returns {number} length in pixels
   */


  estimateStaffLength() {
    var _a, _b;

    var i;
    var totalLength;

    if (this.renderOptions.overriddenWidth !== undefined) {
      // console.log("Overridden staff width: " + this.renderOptions.overriddenWidth);
      return this.renderOptions.overriddenWidth;
    }

    if (this.hasVoices()) {
      var maxLength = 0;
      var _iteratorNormalCompletion22 = true;
      var _didIteratorError22 = false;
      var _iteratorError22 = undefined;

      try {
        for (var _iterator22 = this[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
          var v = _step22.value;

          if (v instanceof Stream) {
            var thisLength = v.estimateStaffLength() + v.renderOptions.staffPadding;

            if (thisLength > maxLength) {
              maxLength = thisLength;
            }
          }
        }
      } catch (err) {
        _didIteratorError22 = true;
        _iteratorError22 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
            _iterator22.return();
          }
        } finally {
          if (_didIteratorError22) {
            throw _iteratorError22;
          }
        }
      }

      return maxLength;
    } else if (!this.isFlat) {
      // part
      totalLength = 0;

      for (i = 0; i < this.length; i++) {
        var m = this.get(i);

        if (m instanceof Stream) {
          totalLength += m.estimateStaffLength() + m.renderOptions.staffPadding;

          if (i !== 0 && m.renderOptions.startNewSystem === true) {
            break;
          }
        }
      }

      return totalLength;
    } else {
      var rendOp = this.renderOptions;
      totalLength = 30 * this.notesAndRests.length;

      if (rendOp.displayClef) {
        totalLength += 30;
      }

      if (rendOp.displayKeySignature) {
        var ks = this.getSpecialContext('keySignature');
        totalLength += (_b = (_a = ks) === null || _a === void 0 ? void 0 : _a.width, _b !== null && _b !== void 0 ? _b : 0);
      }

      if (rendOp.displayTimeSignature) {
        totalLength += 30;
      } // totalLength += rendOp.staffPadding;


      return totalLength;
    }
  }
  /**
   * Returns either (1) a Stream containing Elements
   * (that wrap the null object) whose offsets and durations
   * are the length of gaps in the Stream
   * or (2) null if there are no gaps.
   * @returns {object}
   */


  findGaps() {
    if (!this.isSorted && this.autoSort) {
      this.sort();
    }

    var sortedElements = this.elements;
    var elementDuration = 0;
    var gapStream = new Stream(); // cloneEmpty does not work, created new obj

    var highestCurrentEndTime = 0.0;
    var _iteratorNormalCompletion23 = true;
    var _didIteratorError23 = false;
    var _iteratorError23 = undefined;

    try {
      for (var _iterator23 = sortedElements[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
        var element = _step23.value;

        if (element) {
          if (element.offset > highestCurrentEndTime) {
            var gapElement = new _base__WEBPACK_IMPORTED_MODULE_15__["Music21Object"]();
            var gapQuarterLength = element.offset - highestCurrentEndTime;
            gapElement.duration = this.duration;
            gapElement.duration.quarterLength = gapQuarterLength;
            gapStream.insert(highestCurrentEndTime, gapElement);
          }

          if ('duration' in element && element.duration !== null) {
            elementDuration = element.duration.quarterLength;
          } else {
            elementDuration = 0;
          }

          highestCurrentEndTime = Math.max(highestCurrentEndTime, element.offset + elementDuration);
        }
      }
    } catch (err) {
      _didIteratorError23 = true;
      _iteratorError23 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion23 && _iterator23.return != null) {
          _iterator23.return();
        }
      } finally {
        if (_didIteratorError23) {
          throw _iteratorError23;
        }
      }
    }

    gapStream.sort();

    if (gapStream.elements.length) {
      return gapStream;
    }

    return null;
  }
  /**
   * Returns True if there are no gaps between the lowest offset and the highest time.
   * Otherwise returns False
   *
   * @returns {boolean}
   */


  get isGapless() {
    return this.findGaps() === null;
  } //  * ***** MIDI related routines...

  /**
   * Plays the Stream through the MIDI/sound playback (for now, only MIDI.js is supported)
   *
   * `options` can be an object containing:
   * - instrument: {@link `music`21.instrument.Instrument} object (default, `this.instrument`)
   * - tempo: number (default, `this.tempo`)
   *
   * @param {Object} [options] - object of playback options
   * @returns {this}
   */


  playStream() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var params = {
      instrument: this.instrument,
      tempo: this.tempo,
      done: undefined,
      startNote: undefined
    };
    _common__WEBPACK_IMPORTED_MODULE_18__["merge"](params, options);
    var startNoteIndex = params.startNote;
    var currentNoteIndex = 0;

    if (startNoteIndex !== undefined) {
      currentNoteIndex = startNoteIndex;
    }

    var flatEls = this.flat.elements;
    var lastNoteIndex = flatEls.length - 1;
    this._stopPlaying = false;
    var thisStream = this;

    var playNext = function playNext(elements, params) {
      if (currentNoteIndex <= lastNoteIndex && !thisStream._stopPlaying) {
        var el = elements[currentNoteIndex];
        var nextNote;
        var playDuration;

        if (currentNoteIndex < lastNoteIndex) {
          nextNote = elements[currentNoteIndex + 1];
          playDuration = nextNote.offset - el.offset;
        } else {
          playDuration = el.duration.quarterLength;
        }

        var milliseconds = playDuration * 1000 * 60 / params.tempo; // when we're ready to do full-on tempo marks:  from JV.
        // const nextOffset = nextNote ? nextNote.offset : el.offset + el.duration.quarterLength;
        // const tempo = thisStream._averageTempo(el.offset, nextOffset);
        // const milliseconds = playDuration * 1000 * 60 / tempo;

        if (_debug__WEBPACK_IMPORTED_MODULE_14__["debug"]) {
          console.log('playing: ', el, playDuration, milliseconds, params.tempo);
        }

        if (el.playMidi !== undefined) {
          el.playMidi(params.tempo, nextNote, params);
        }

        currentNoteIndex += 1;
        setTimeout(() => {
          playNext(elements, params);
        }, milliseconds);
      } else if (params && params.done) {
        params.done.call();
      }
    };

    playNext(flatEls, params);
    return this;
  }
  /**
   * Stops a stream from playing if it currently is.
   *
   * @returns {this}
   */


  stopPlayStream() {
    // turns off all currently playing MIDI notes (on any stream) and stops playback.
    this._stopPlaying = true;

    for (var i = 0; i < 127; i++) {
      midicube__WEBPACK_IMPORTED_MODULE_12__["noteOff"](0, i, 0);
    }

    return this;
  }
  /* ----------------------------------------------------------------------
   *
   *  SVG/Canvas DOM routines -- to be factored out eventually.
   *
   */


  createNewCanvas(width, height) {
    var elementType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'svg';
    console.warn('createNewCanvas is deprecated, use createNewDOM instead');
    return this.createNewDOM(width, height, elementType);
  }
  /**
   * Creates and returns a new `&lt;canvas&gt;` or `&lt;svg&gt;` object.
   *
   * Calls setSubstreamRenderOptions() first.
   *
   * Does not render on the DOM element.
   *
   * @param {number|string|undefined} width - will use
   *     `this.estimateStaffLength()`
   *     + `this.renderOptions.staffPadding` if not given
   * @param {number|string|undefined} height - if undefined will use
   *     `this.renderOptions.height`. If still undefined, will use
   *     `this.estimateStreamHeight()`
   * @param {string} elementType - what type of element, default = svg
   * @returns {JQuery} svg in jquery.
   */


  createNewDOM() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var elementType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'svg';

    if (!this.isFlat) {
      this.setSubstreamRenderOptions();
    } // we render SVG on a Div for Vexflow


    var renderElementType = 'div';

    if (elementType === 'canvas') {
      renderElementType = 'canvas';
    }

    var $newCanvasOrDIV = jquery__WEBPACK_IMPORTED_MODULE_11__('<' + renderElementType + '/>');
    $newCanvasOrDIV.addClass('streamHolding'); // .css('border', '1px red solid');

    $newCanvasOrDIV.css('display', 'inline-block');

    if (width !== undefined) {
      if (typeof width === 'string') {
        width = _common__WEBPACK_IMPORTED_MODULE_18__["stripPx"](width);
      }

      $newCanvasOrDIV.attr('width', width);
    } else {
      var computedWidth = this.estimateStaffLength() + this.renderOptions.staffPadding;
      $newCanvasOrDIV.attr('width', computedWidth);
    }

    if (height !== undefined) {
      $newCanvasOrDIV.attr('height', height);
    } else {
      var computedHeight;

      if (this.renderOptions.height === undefined) {
        computedHeight = this.estimateStreamHeight(); // console.log('computed Height estimate: ' + computedHeight);
      } else {
        computedHeight = this.renderOptions.height; // console.log('computed Height: ' + computedHeight);
      }

      $newCanvasOrDIV.attr('height', computedHeight * this.renderOptions.scaleFactor.y);
    }

    return $newCanvasOrDIV;
  }

  createPlayableCanvas(width, height) {
    var elementType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'svg';
    console.warn('createPlayableCanvas is deprecated, use createPlayableDOM instead');
    return this.createPlayableDOM(width, height, elementType);
  }
  /**
   * Creates a rendered, playable svg where clicking plays it.
   *
   * Called from appendNewDOM() etc.
   *
   * @param {number|string|undefined} [width]
   * @param {number|string|undefined} [height]
   * @param {string} [elementType='svg'] - what type of element, default = svg
   * @returns {JQuery} canvas or svg
   */


  createPlayableDOM() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var elementType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'svg';
    this.renderOptions.events.click = 'play';
    return this.createDOM(width, height, elementType);
  }

  createCanvas(width, height) {
    var elementType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'svg';
    console.warn('createCanvas is deprecated, use createDOM');
    return this.createDOM(width, height, elementType);
  }
  /**
   * Creates a new svg and renders vexflow on it
   *
   * @param {number|string|undefined} [width]
   * @param {number|string|undefined} [height]
   * @param {string} elementType - what type of element svg or canvas, default = svg
   * @returns {JQuery} canvas or SVG
   */


  createDOM() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var elementType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'svg';
    var $newSvg = this.createNewDOM(width, height, elementType); // temporarily append the SVG to the document to fix a Firefox bug
    // where nothing can be measured unless is it in the document.

    this.renderVexflow($newSvg);
    return $newSvg;
  }

  appendNewCanvas(appendElement, width, height) {
    var elementType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'svg';
    console.warn('appendNewCanvas is deprecated, use appendNewDOM instead');
    return this.appendNewDOM(appendElement, width, height, elementType);
  }
  /**
   * Creates a new canvas, renders vexflow on it, and appends it to the DOM.
   *
   * @param {JQuery|HTMLElement} [appendElement=document.body] - where to place the svg
   * @param {number|string} [width]
   * @param {number|string} [height]
   * @param {string} elementType - what type of element, default = svg
   * @returns {SVGElement|HTMLElement} svg (not the jQuery object --
   * this is a difference with other routines and should be fixed. TODO: FIX)
   *
   */


  appendNewDOM() {
    var appendElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var elementType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'svg';
    // noinspection JSMismatchedCollectionQueryUpdate
    var $appendElement;

    if (appendElement instanceof jquery__WEBPACK_IMPORTED_MODULE_11__) {
      $appendElement = appendElement;
    } else {
      $appendElement = jquery__WEBPACK_IMPORTED_MODULE_11__(appendElement);
    } //      if (width === undefined && this.renderOptions.maxSystemWidth === undefined) {
    //      var $bodyElement = bodyElement;
    //      if (!(bodyElement instanceof $) {
    //      $bodyElement = $(bodyElement);
    //      }
    //      width = $bodyElement.width();
    //      };


    var $svgOrCanvasBlock = this.createDOM(width, height, elementType);
    $appendElement.append($svgOrCanvasBlock);
    return $svgOrCanvasBlock[0];
  }

  replaceCanvas(where, preserveSvgSize) {
    var elementType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'svg';
    console.warn('replaceCanvas is deprecated, use replaceDOM instead');
    return this.replaceDOM(where, preserveSvgSize, elementType);
  }
  /**
   * Replaces a particular Svg with a new rendering of one.
   *
   * Note that if 'where' is empty, will replace all svg elements on the page.
   *
   * @param {JQuery|HTMLElement} [where] - the canvas or SVG to replace or
   *     a container holding the canvas(es) to replace.
   * @param {boolean} [preserveSvgSize=false]
   * @param {string} elementType - what type of element, default = svg
   * @returns {JQuery} the svg
   */


  replaceDOM(where) {
    var preserveSvgSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var elementType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'svg';

    // if called with no where, replaces all the svgs on the page...
    if (where === undefined) {
      where = document.body;
    }

    var $where;

    if (!(where instanceof jquery__WEBPACK_IMPORTED_MODULE_11__)) {
      $where = jquery__WEBPACK_IMPORTED_MODULE_11__(where);
    } else {
      $where = where; // where = $where[0];
    }

    var $oldSVGOrCanvas;

    if ($where.hasClass('streamHolding')) {
      $oldSVGOrCanvas = $where;
    } else {
      $oldSVGOrCanvas = $where.find('.streamHolding');
    } // TODO: Max Width!


    if ($oldSVGOrCanvas.length === 0) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_13__["Music21Exception"]('No svg defined for replaceDOM!');
    } else if ($oldSVGOrCanvas.length > 1) {
      // change last svg...
      // replacing each with svgBlock doesn't work
      // anyhow, it just resizes the svg but doesn't
      // draw.
      $oldSVGOrCanvas = jquery__WEBPACK_IMPORTED_MODULE_11__($oldSVGOrCanvas[$oldSVGOrCanvas.length - 1]);
    }

    var svgBlock;

    if (preserveSvgSize) {
      var width = $oldSVGOrCanvas.width() || parseInt($oldSVGOrCanvas.attr('width'));
      var height = $oldSVGOrCanvas.attr('height'); // height manipulates

      svgBlock = this.createDOM(width, height, elementType);
    } else {
      svgBlock = this.createDOM(undefined, undefined, elementType);
    }

    $oldSVGOrCanvas.replaceWith(svgBlock);
    return svgBlock;
  }
  /**
   * Set the type of interaction on the svg based on
   *    - Stream.renderOptions.events.click
   *    - Stream.renderOptions.events.dblclick
   *    - Stream.renderOptions.events.resize
   *
   * Currently the only options available for each are:
   *    - 'play' (string)
   *    - 'reflow' (string; only on event.resize)
   *    - customFunction (will receive event as a first variable; should set up a way to
   *                    find the original stream; var s = this; var f = function () { s...}
   *                   )
   *
   * @param {jQuery|HTMLElement} canvasOrDiv - canvas or the Div surrounding it.
   * @returns {this}
   */


  setRenderInteraction(canvasOrDiv) {
    var $svg = canvasOrDiv;

    if (canvasOrDiv === undefined) {
      return this;
    } else if (!(canvasOrDiv instanceof jquery__WEBPACK_IMPORTED_MODULE_11__)) {
      $svg = jquery__WEBPACK_IMPORTED_MODULE_11__(canvasOrDiv);
    }

    var playFunc = () => {
      this.playStream();
    };

    for (var _i5 = 0, _Object$entries = Object.entries(this.renderOptions.events); _i5 < _Object$entries.length; _i5++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i5], 2),
          eventType = _Object$entries$_i[0],
          eventFunction = _Object$entries$_i[1];

      $svg.off(eventType);

      if (typeof eventFunction === 'string' && eventFunction === 'play') {
        $svg.on(eventType, playFunc);
      } else if (typeof eventFunction === 'string' && eventType === 'resize' && eventFunction === 'reflow') {
        this.windowReflowStart($svg);
      } else if (eventFunction !== undefined) {
        $svg.on(eventType, eventFunction);
      }
    }

    return this;
  }
  /**
   *
   * Recursively search downward for the closest storedVexflowStave...
   *
   * @returns {Vex.Flow.Stave|undefined}
   */


  recursiveGetStoredVexflowStave() {
    var storedVexflowStave = this.storedVexflowStave;

    if (storedVexflowStave === undefined) {
      if (this.isFlat) {
        return undefined;
      } else {
        var subStreams = this.getElementsByClass('Stream');
        var first_subStream = subStreams.get(0);
        return first_subStream.recursiveGetStoredVexflowStave();
      }
    }

    return storedVexflowStave;
  }

  getUnscaledXYforCanvas(svg, e) {
    console.warn('getUnscaledXYforCanvas is deprecated, use getUnscaledXYforDOM instead');
    return this.getUnscaledXYforDOM(svg, e);
  }
  /**
   * Given a mouse click, or other event with .pageX and .pageY,
   * find the x and y for the svg.
   *
   * @param {HTMLElement|SVGElement} svg - a canvas or SVG object
   * @param {MouseEvent|TouchEvent} e
   * @returns {Array<number>} two-elements, [x, y] in pixels.
   */


  getUnscaledXYforDOM(svg, e) {
    var offset;

    if (svg === undefined) {
      offset = {
        left: 0,
        top: 0
      };
    } else {
      offset = jquery__WEBPACK_IMPORTED_MODULE_11__(svg).offset();
    }
    /*
     * mouse event handler code from: http://diveintohtml5.org/canvas.html
     */


    var xClick;
    var yClick;

    if (e.pageX !== undefined && e.pageY !== undefined) {
      xClick = e.pageX;
      yClick = e.pageY;
    } else {
      xClick = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
      yClick = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }

    var xPx = xClick - offset.left;
    var yPx = yClick - offset.top;
    return [xPx, yPx];
  }

  getScaledXYforCanvas(svg, e) {
    console.warn('getScaledXYforCanvas is deprecated, use getScaledXYforDOM instead');
    return this.getScaledXYforDOM(svg, e);
  }
  /**
   * return a list of [scaledX, scaledY] for
   * a svg element.
   *
   * xScaled refers to 1/scaleFactor.x -- for instance, scaleFactor.x = 0.7 (default)
   * x of 1 gives 1.42857...
   *
   * @param {Node|SVGElement} svg -- a canvas or SVG object
   * @param {MouseEvent|TouchEvent} e
   * @returns {Array<number>} [scaledX, scaledY]
   */


  getScaledXYforDOM(svg, e) {
    var _this$getUnscaledXYfo = this.getUnscaledXYforDOM(svg, e),
        _this$getUnscaledXYfo2 = _slicedToArray(_this$getUnscaledXYfo, 2),
        xPx = _this$getUnscaledXYfo2[0],
        yPx = _this$getUnscaledXYfo2[1];

    var pixelScaling = this.renderOptions.scaleFactor;
    var yPxScaled = yPx / pixelScaling.y;
    var xPxScaled = xPx / pixelScaling.x;
    return [xPxScaled, yPxScaled];
  }
  /**
   *
   * Given a Y position find the diatonicNoteNum that a note at that position would have.
   *
   * searches this.storedVexflowStave
   *
   * Y position must be offset from the start of the stave...
   *
   * @param {number} yPxScaled
   * @returns {number}
   */


  diatonicNoteNumFromScaledY(yPxScaled) {
    var storedVexflowStave = this.recursiveGetStoredVexflowStave();

    if (storedVexflowStave === undefined) {
      throw new StreamException('Could not find vexflowStave for getting size');
    } // for (var i = -10; i < 10; i++) {
    //    console.log("line: " + i + " y: " + storedVexflowStave.getYForLine(i));
    // }


    var thisClef = this.clef || this.getContextByClass('Clef');
    var lowestLine = thisClef !== undefined ? thisClef.lowestLine : 31;
    var lineSpacing = storedVexflowStave.options.spacing_between_lines_px;
    var linesAboveStaff = storedVexflowStave.options.space_above_staff_ln;
    var notesFromTop = yPxScaled * 2 / lineSpacing;
    var notesAboveLowestLine = (storedVexflowStave.options.num_lines - 1 + linesAboveStaff) * 2 - notesFromTop;
    var clickedDiatonicNoteNum = lowestLine + Math.round(notesAboveLowestLine);
    return clickedDiatonicNoteNum;
  }
  /**
   * Returns the stream that is at X location xPxScaled and system systemIndex.
   *
   * Override in subclasses, always returns this; here.
   *
   * @param {number} xPxScaled
   * @param {number} [systemIndex]
   * @returns {this}
   *
   */


  getStreamFromScaledXandSystemIndex(xPxScaled) {
    var systemIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return this;
  }
  /**
   *
   * Return the note (or chord or rest) at pixel X (or within allowablePixels [default 10])
   * of the note.
   *
   * systemIndex element is not used on bare Stream
   *
   * options can be a dictionary of: 'allowBackup' which gets the closest
   * note within the window even if it's beyond allowablePixels (default: true)
   * and 'backupMaximum' which specifies a maximum distance even for backup
   * (default: 70);
   *
   * @param {number} xPxScaled
   * @param {number} [allowablePixels=10]
   * @param {number} [systemIndex]
   * @param {Object} [options]
   * @returns {Music21Object|undefined}
   */


  noteElementFromScaledX(xPxScaled) {
    var allowablePixels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var systemIndex = arguments.length > 2 ? arguments[2] : undefined;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var params = {
      allowBackup: true,
      backupMaximum: 70
    };
    _common__WEBPACK_IMPORTED_MODULE_18__["merge"](params, options);
    var foundNote;
    var subStream = this.getStreamFromScaledXandSystemIndex(xPxScaled, systemIndex);

    if (subStream === undefined) {
      return undefined;
    }

    var backup = {
      minDistanceSoFar: params.backupMaximum,
      note: undefined
    }; // a backup in case we did not find within allowablePixels

    var _iteratorNormalCompletion24 = true;
    var _didIteratorError24 = false;
    var _iteratorError24 = undefined;

    try {
      for (var _iterator24 = subStream.flat.notesAndRests[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
        var n = _step24.value;

        /* should also
         * compensate for accidentals...
         */
        var leftDistance = Math.abs(n.x - xPxScaled);
        var rightDistance = Math.abs(n.x + n.width - xPxScaled);
        var minDistance = Math.min(leftDistance, rightDistance);

        if (leftDistance < allowablePixels && rightDistance < allowablePixels) {
          foundNote = n;
          break;
          /* O(n); can be made O(log n) */
        } else if (leftDistance < params.backupMaximum && rightDistance < params.backupMaximum && minDistance < backup.minDistanceSoFar) {
          backup.note = n;
          backup.minDistanceSoFar = minDistance;
        }
      } // console.log('note here is: ', foundNote);

    } catch (err) {
      _didIteratorError24 = true;
      _iteratorError24 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion24 && _iterator24.return != null) {
          _iterator24.return();
        }
      } finally {
        if (_didIteratorError24) {
          throw _iteratorError24;
        }
      }
    }

    if (params.allowBackup && foundNote === undefined) {
      foundNote = backup.note; // console.log('used backup: closest was: ', backup.minDistanceSoFar);
    } // console.log(foundNote);


    return foundNote;
  }
  /**
   * Given an event object, and an x and y location, returns a two-element array
   * of the pitch.Pitch.diatonicNoteNum that was clicked (i.e., if C4 was clicked this
   * will return 29; if D4 was clicked this will return 30) and the closest note in the
   * stream that was clicked.
   *
   * Return a list of [diatonicNoteNum, closestXNote]
   * for an event (e) called on the svg (svg)
   *
   * @param {HTMLElement|SVGElement} svg
   * @param {MouseEvent|TouchEvent} e
   * @param {number} [x]
   * @param {number} [y]
   * @returns {Array} [diatonicNoteNum, closestXNote]
   */


  findNoteForClick(svg, e) {
    var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

    if (x === undefined || y === undefined) {
      var _this$getScaledXYforD = this.getScaledXYforDOM(svg, e);

      var _this$getScaledXYforD2 = _slicedToArray(_this$getScaledXYforD, 2);

      x = _this$getScaledXYforD2[0];
      y = _this$getScaledXYforD2[1];
    }

    var clickedDiatonicNoteNum = this.diatonicNoteNumFromScaledY(y);
    var foundNote = this.noteElementFromScaledX(x);
    return [clickedDiatonicNoteNum, foundNote];
  }
  /**
   * Change the pitch of a note given that it has been clicked and then
   * call changedCallbackFunction
   *
   * @param {number} clickedDiatonicNoteNum
   * @param {music21.note.Note} foundNote
   * @param {SVGElement|HTMLElement} svg
   * @returns {*} output of changedCallbackFunction
   */


  noteChanged(clickedDiatonicNoteNum, foundNote, svg) {
    var n = foundNote;
    var p = new _pitch__WEBPACK_IMPORTED_MODULE_23__["Pitch"]('C');
    p.diatonicNoteNum = clickedDiatonicNoteNum;
    p.accidental = n.pitch.accidental;
    n.pitch = p;
    n.stemDirection = undefined;
    this.activeNote = n;
    var $newSvg = this.redrawDOM(svg);
    var params = {
      foundNote: n,
      svg: $newSvg
    };

    if (this.changedCallbackFunction !== undefined) {
      return this.changedCallbackFunction(params);
    } else {
      return params;
    }
  }

  redrawCanvas(svg) {
    console.warn('redrawCanvas is deprecated, use redrawDOM instead');
    return this.redrawDOM(svg);
  }
  /**
   * Redraws an svgDiv, keeping the events of the previous svg.
   *
   * @param {JQuery|HTMLElement} svg
   * @returns {JQuery}
   */


  redrawDOM(svg) {
    // this.resetRenderOptions(true, true); // recursive, preserveEvents
    if (!this.isFlat) {
      this.setSubstreamRenderOptions();
    }

    var $svg = jquery__WEBPACK_IMPORTED_MODULE_11__(svg); // works even if svg is already $jquery

    var $newSvg = this.createNewDOM(svg.width, svg.height);
    this.renderVexflow($newSvg);
    $svg.replaceWith($newSvg);
    return $newSvg;
  }

  editableAccidentalCanvas(width, height) {
    console.warn('editableAccidentalCanvas is deprecated, use editableAccidentalDOM instead');
    return this.editableAccidentalDOM(width, height);
  }
  /**
   * Renders a stream on svg with the ability to edit it and
   * a toolbar that allows the accidentals to be edited.
   *
   * @param {number} [width]
   * @param {number} [height]
   * @returns {Node} the div tag around the svg.
   */


  editableAccidentalDOM(width, height) {
    /*
     * Create an editable svg with an accidental selection bar.
     */
    var d = jquery__WEBPACK_IMPORTED_MODULE_11__('<div/>').css('text-align', 'left').css('position', 'relative');
    this.renderOptions.events.mousedown = this.DOMChangerFunction;
    this.renderOptions.events.touchstart = this.DOMChangerFunction;
    var $svgDiv = this.createDOM(width, height);
    var buttonDiv = this.getAccidentalToolbar(undefined, undefined, $svgDiv);
    d.append(buttonDiv);
    d.append(jquery__WEBPACK_IMPORTED_MODULE_11__("<br style='clear: both;' />"));
    d.append($svgDiv);
    return d;
  }
  /*
   * SVG toolbars...
   */

  /**
   *
   * @param {int} minAccidental - alter of the min accidental (default -1)
   * @param {int} maxAccidental - alter of the max accidental (default 1)
   * @param {jQuery} $siblingSvg - svg to use for redrawing;
   * @returns {jQuery} the accidental toolbar.
   */


  getAccidentalToolbar(minAccidental, maxAccidental, $siblingSvg) {
    if (minAccidental === undefined) {
      minAccidental = -1;
    }

    if (maxAccidental === undefined) {
      maxAccidental = 1;
    }

    minAccidental = Math.round(minAccidental);
    maxAccidental = Math.round(maxAccidental);

    var addAccidental = (newAlter, clickEvent) => {
      /*
       * To be called on a button...
       */
      var $useSvg = $siblingSvg;

      if ($useSvg === undefined) {
        var $searchParent = jquery__WEBPACK_IMPORTED_MODULE_11__(clickEvent.target).parent();
        var maxSearch = 99;

        while (maxSearch > 0 && $searchParent !== undefined && ($useSvg === undefined || $useSvg[0] === undefined)) {
          maxSearch -= 1;
          $useSvg = $searchParent.find('.streamHolding');
          $searchParent = $searchParent.parent();
        }

        if ($useSvg[0] === undefined) {
          console.log('Could not find a svg...');
          return;
        }
      }

      if (this.activeNote !== undefined && this.activeNote instanceof _note__WEBPACK_IMPORTED_MODULE_22__["Note"]) {
        var n = this.activeNote;
        n.pitch.accidental = new _pitch__WEBPACK_IMPORTED_MODULE_23__["Accidental"](newAlter);
        /* console.log(n.pitch.name); */

        var $newSvg = this.redrawDOM($useSvg[0]);

        if (this.changedCallbackFunction !== undefined) {
          this.changedCallbackFunction({
            foundNote: n,
            svg: $newSvg
          });
        }
      }
    };

    var $buttonDiv = jquery__WEBPACK_IMPORTED_MODULE_11__('<div/>').attr('class', 'accidentalToolbar scoreToolbar');

    var _loop = function _loop(i) {
      var acc = new _pitch__WEBPACK_IMPORTED_MODULE_23__["Accidental"](i);
      var $button = jquery__WEBPACK_IMPORTED_MODULE_11__('<button>' + acc.unicodeModifier + '</button>').click(e => addAccidental(i, e));

      if (Math.abs(i) > 1) {
        $button.css('font-family', 'Bravura Text');
        $button.css('font-size', '20px');
      }

      $buttonDiv.append($button);
    };

    for (var i = minAccidental; i <= maxAccidental; i++) {
      _loop(i);
    }

    return $buttonDiv;
  }
  /**
   *
   * @returns {jQuery} a Div containing two buttons -- play and stop
   */


  getPlayToolbar() {
    var $buttonDiv = jquery__WEBPACK_IMPORTED_MODULE_11__('<div/>').attr('class', 'playToolbar scoreToolbar');
    var $bPlay = jquery__WEBPACK_IMPORTED_MODULE_11__('<button>&#9658</button>');
    $bPlay.click(() => {
      this.playStream();
    });
    $buttonDiv.append($bPlay);
    var $bStop = jquery__WEBPACK_IMPORTED_MODULE_11__('<button>&#9724</button>');
    $bStop.click(() => {
      this.stopPlayStream();
    });
    $buttonDiv.append($bStop);
    return $buttonDiv;
  } //  reflow

  /**
   * Begins a series of bound events to the window that makes it
   * so that on resizing the stream is redrawn and reflowed to the
   * new size.
   *
   * @param {JQuery} jSvg
   * @returns {this}
   */


  windowReflowStart(jSvg) {
    // set up a bunch of windowReflow bindings that affect the svg.
    var jSvgNow = jSvg;

    var resizeEnd = () => {
      // do something, window hasn't changed size in 500ms
      var jSvgParent = jSvgNow.parent();
      var newWidth = jSvgParent.width();
      var svgWidth = newWidth; // console.log(svgWidth);

      console.log('resizeEnd triggered', newWidth); // console.log(callingStream.renderOptions.events.click);

      this.resetRenderOptions(true, true); // recursive, preserveEvents
      // console.log(callingStream.renderOptions.events.click);

      this.maxSystemWidth = svgWidth - 40;
      jSvgNow.remove();
      var svgObj = this.appendNewDOM(jSvgParent);
      jSvgNow = jquery__WEBPACK_IMPORTED_MODULE_11__(svgObj);
    };

    var resizeTimeout = 0;
    jquery__WEBPACK_IMPORTED_MODULE_11__(window).on('resize', () => {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }

      resizeTimeout = setTimeout(() => resizeEnd(), 200);
    });
    setTimeout(() => {
      var $window = jquery__WEBPACK_IMPORTED_MODULE_11__(window);
      var doResize = $window.data('triggerResizeOnCreateSvg');

      if (doResize === undefined || doResize === true) {
        resizeEnd();
        $window.data('triggerResizeOnCreateSvg', false);
      }
    }, 1000);
    return this;
  }
  /**
   * Does this stream have a {@link Voice} inside it?
   */


  hasVoices() {
    var _iteratorNormalCompletion25 = true;
    var _didIteratorError25 = false;
    var _iteratorError25 = undefined;

    try {
      for (var _iterator25 = this[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
        var el = _step25.value;

        if (el.isClassOrSubclass('Voice')) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError25 = true;
      _iteratorError25 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion25 && _iterator25.return != null) {
          _iterator25.return();
        }
      } finally {
        if (_didIteratorError25) {
          throw _iteratorError25;
        }
      }
    }

    return false;
  }

}
class Voice extends Stream {
  static get className() {
    return 'music21.stream.Voice';
  }

  constructor() {
    super();
    this.recursionType = 'elementsFirst';
  }

}
class Measure extends Stream {
  constructor() {
    super(...arguments);
    this.recursionType = 'elementsFirst';
    this.isMeasure = true;
    this.number = 0;
    this.numberSuffix = '';
  }

  static get className() {
    return 'music21.stream.Measure';
  }

  stringInfo() {
    var _a; // avoid using "this.offset" to not infinite loops.


    var offset = (_a = this._activeSiteStoredOffset, _a !== null && _a !== void 0 ? _a : this._naiveOffset);
    return this.measureNumberWithSuffix() + ' offset=' + offset.toString();
  }

  measureNumberWithSuffix() {
    return this.number.toString() + this.numberSuffix;
  }

}
/**
 * Part -- specialized to handle Measures inside it
 *
 * @class Part
 * @memberof music21.stream
 */

class Part extends Stream {
  constructor() {
    super();
    this.recursionType = 'flatten';
    this.systemHeight = this.renderOptions.naiveHeight;
  }

  static get className() {
    return 'music21.stream.Part';
  }
  /**
   * How many systems does this Part have?
   *
   * Does not change any reflow information, so by default it's always 1.
   */


  numSystems() {
    var numSystems = 1;
    var subStreams = this.getElementsByClass('Stream');

    for (var i = 1; i < subStreams.length; i++) {
      if (subStreams.get(i).renderOptions.startNewSystem) {
        numSystems += 1;
      }
    }

    return numSystems;
  }
  /**
   * Find the width of every measure in the Part.
   */


  getMeasureWidths() {
    /* call after setSubstreamRenderOptions */
    var measureWidths = [];
    var _iteratorNormalCompletion26 = true;
    var _didIteratorError26 = false;
    var _iteratorError26 = undefined;

    try {
      for (var _iterator26 = this[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
        var el = _step26.value;

        if (el.isClassOrSubclass('Measure')) {
          var elRendOp = el.renderOptions;
          measureWidths[elRendOp.measureIndex] = elRendOp.width;
        }
      }
      /* console.log(measureWidths);
       *
       */

    } catch (err) {
      _didIteratorError26 = true;
      _iteratorError26 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion26 && _iterator26.return != null) {
          _iterator26.return();
        }
      } finally {
        if (_didIteratorError26) {
          throw _iteratorError26;
        }
      }
    }

    return measureWidths;
  }
  /**
   * Overrides the default music21.stream.Stream#estimateStaffLength
   */


  estimateStaffLength() {
    if (this.renderOptions.overriddenWidth !== undefined) {
      // console.log("Overridden staff width: " + this.renderOptions.overriddenWidth);
      return this.renderOptions.overriddenWidth;
    }

    if (!this.isFlat) {
      // part with Measures underneath
      var totalLength = 0;
      var isFirst = true;
      var _iteratorNormalCompletion27 = true;
      var _didIteratorError27 = false;
      var _iteratorError27 = undefined;

      try {
        for (var _iterator27 = this.getElementsByClass('Measure')[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
          var m = _step27.value;
          // this looks wrong, but actually seems to be right. moving it to
          // after the break breaks things.
          totalLength += m.estimateStaffLength() + m.renderOptions.staffPadding;

          if (!isFirst && m.renderOptions.startNewSystem === true) {
            break;
          }

          isFirst = false;
        }
      } catch (err) {
        _didIteratorError27 = true;
        _iteratorError27 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion27 && _iterator27.return != null) {
            _iterator27.return();
          }
        } finally {
          if (_didIteratorError27) {
            throw _iteratorError27;
          }
        }
      }

      return totalLength;
    } // no measures found in part... treat as measure


    var tempM = new Measure();
    tempM.elements = this;
    return tempM.estimateStaffLength();
  }
  /**
   * Divide a part up into systems and fix the measure
   * widths so that they are all even.
   *
   * Note that this is done on the part level even though
   * the measure widths need to be consistent across parts.
   *
   * This is possible because the system is deterministic and
   * will come to the same result for each part.  Opportunity
   * for making more efficient through this...
   *
   * @param {number} systemHeight
   * @returns {Array}
   */


  fixSystemInformation(systemHeight) {
    /*
     * console.log('system height: ' + systemHeight);
     */
    if (systemHeight === undefined) {
      systemHeight = this.systemHeight;
      /* part.show() called... */
    } else if (_debug__WEBPACK_IMPORTED_MODULE_14__["debug"]) {
      console.log('overridden systemHeight: ' + systemHeight);
    }

    var systemPadding = this.renderOptions.systemPadding || this.renderOptions.naiveSystemPadding;
    var measureWidths = this.getMeasureWidths();
    var maxSystemWidth = this.maxSystemWidth;
    /* of course fix! */

    var systemCurrentWidths = [];
    var systemBreakIndexes = [];
    var lastSystemBreak = 0;
    /* needed to ensure each line has at least one measure */

    var startLeft = 20;
    /* TODO: make it obtained elsewhere */

    var currentLeft = startLeft;
    var i;

    for (i = 0; i < measureWidths.length; i++) {
      var currentRight = currentLeft + measureWidths[i];
      /* console.log("left: " + currentLeft + " ; right: " + currentRight + " ; m: " + i); */

      if (currentRight > maxSystemWidth && lastSystemBreak !== i) {
        systemBreakIndexes.push(i - 1);
        systemCurrentWidths.push(currentLeft); // console.log('setting new width at ' + currentLeft);

        currentLeft = startLeft + measureWidths[i]; // 20 + this width;

        lastSystemBreak = i;
      } else {
        currentLeft = currentRight;
      }
    } // console.log(systemCurrentWidths);
    // console.log(systemBreakIndexes);


    var currentSystemIndex = 0;
    var leftSubtract = 0;
    var newLeftSubtract;

    for (i = 0; i < this.length; i++) {
      var m = this.get(i);

      if (!(m instanceof Stream)) {
        continue;
      }

      if (m.renderOptions === undefined) {
        continue;
      }

      if (i === 0) {
        m.renderOptions.startNewSystem = true;
      }

      currentLeft = m.renderOptions.left;

      if (systemBreakIndexes.indexOf(i - 1) !== -1) {
        /* first measure of new System */
        var oldWidth = m.renderOptions.width;
        var oldEstimate = m.estimateStaffLength() + m.renderOptions.staffPadding;
        var offsetFromEstimate = oldWidth - oldEstimate; // we look at the offset from the current estimate to see how much
        // the staff length may have been adjusted to compensate for other
        // parts with different lengths.
        // but setting these options is bound to change something

        m.renderOptions.displayClef = true;
        m.renderOptions.displayKeySignature = true;
        m.renderOptions.startNewSystem = true; // so we get a new estimate.

        var newEstimate = m.estimateStaffLength() + m.renderOptions.staffPadding; // and adjust it for the change.

        var newWidth = newEstimate + offsetFromEstimate;
        m.renderOptions.width = newWidth;
        leftSubtract = currentLeft - 20; // after this one, we'll have a new left subtract...

        newLeftSubtract = leftSubtract - (newWidth - oldWidth);
        currentSystemIndex += 1;
      } else if (i !== 0) {
        m.renderOptions.startNewSystem = false;
        m.renderOptions.displayClef = false; // check for changed clef first?

        m.renderOptions.displayKeySignature = false; // check for changed KS first?
      }

      m.renderOptions.systemIndex = currentSystemIndex;
      var currentSystemMultiplier = void 0;

      if (currentSystemIndex >= systemCurrentWidths.length) {
        /* last system... non-justified */
        currentSystemMultiplier = 1;
      } else {
        var currentSystemWidth = systemCurrentWidths[currentSystemIndex];
        currentSystemMultiplier = maxSystemWidth / currentSystemWidth; // console.log('systemMultiplier: ' + currentSystemMultiplier
        // + ' max: ' + maxSystemWidth + ' current: ' + currentSystemWidth);
      }
      /* might make a small gap? fix? */


      var newLeft = currentLeft - leftSubtract;

      if (newLeftSubtract !== undefined) {
        leftSubtract = newLeftSubtract;
        newLeftSubtract = undefined;
      } // console.log('M: ' + i + ' ; old left: ' + currentLeft + ' ; new Left: ' + newLeft);


      m.renderOptions.left = Math.floor(newLeft * currentSystemMultiplier);
      m.renderOptions.width = Math.floor(m.renderOptions.width * currentSystemMultiplier);
      var newTop = m.renderOptions.top + currentSystemIndex * (systemHeight + systemPadding); // console.log('M: ' + i + '; New top: ' + newTop + " ; old Top: " + m.renderOptions.top);

      m.renderOptions.top = newTop;
    }

    return systemCurrentWidths;
  }
  /**
   * overrides music21.stream.Stream#setSubstreamRenderOptions
   *
   * figures out the `.left` and `.top` attributes for all contained measures
   *
   */


  setSubstreamRenderOptions() {
    var currentMeasureIndex = 0;
    /* 0 indexed for now */

    var currentMeasureLeft = 20;
    var rendOp = this.renderOptions;
    var lastTimeSignature;
    var lastKeySignature;
    var lastClef;
    var _iteratorNormalCompletion28 = true;
    var _didIteratorError28 = false;
    var _iteratorError28 = undefined;

    try {
      for (var _iterator28 = this.getElementsByClass('Measure')[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
        var m = _step28.value;
        var mRendOp = m.renderOptions;
        mRendOp.measureIndex = currentMeasureIndex;
        mRendOp.top = rendOp.top;
        mRendOp.partIndex = rendOp.partIndex;
        mRendOp.left = currentMeasureLeft;

        if (currentMeasureIndex === 0) {
          lastClef = m._clef;
          lastTimeSignature = m._timeSignature;
          lastKeySignature = m._keySignature;
          mRendOp.displayClef = true;
          mRendOp.displayKeySignature = true;
          mRendOp.displayTimeSignature = true;
        } else {
          // noinspection JSUnusedAssignment
          if (m._clef !== undefined && lastClef !== undefined && m._clef.name !== lastClef.name) {
            // noinspection JSUnusedAssignment
            console.log('changing clefs for ', mRendOp.measureIndex, ' from ', lastClef.name, ' to ', m._clef.name);
            lastClef = m._clef;
            mRendOp.displayClef = true;
          } else {
            mRendOp.displayClef = false;
          } // noinspection JSUnusedAssignment


          if (m._keySignature !== undefined && lastKeySignature !== undefined && m._keySignature.sharps !== lastKeySignature.sharps) {
            lastKeySignature = m._keySignature;
            mRendOp.displayKeySignature = true;
          } else {
            mRendOp.displayKeySignature = false;
          } // noinspection JSUnusedAssignment


          if (m._timeSignature !== undefined && lastTimeSignature !== undefined && m._timeSignature.ratioString !== lastTimeSignature.ratioString) {
            lastTimeSignature = m._timeSignature;
            mRendOp.displayTimeSignature = true;
          } else {
            mRendOp.displayTimeSignature = false;
          }
        }

        mRendOp.width = m.estimateStaffLength() + mRendOp.staffPadding;
        mRendOp.height = m.estimateStreamHeight();
        currentMeasureLeft += mRendOp.width;
        currentMeasureIndex += 1;
      }
    } catch (err) {
      _didIteratorError28 = true;
      _iteratorError28 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion28 && _iterator28.return != null) {
          _iterator28.return();
        }
      } finally {
        if (_didIteratorError28) {
          throw _iteratorError28;
        }
      }
    }

    return this;
  }
  /**
   * systemIndexAndScaledY - given a scaled Y, return the systemIndex
   * and the scaledYRelativeToSystem
   *
   * @param  {number} y the scaled Y
   * @return {number[]}  systemIndex, scaledYRelativeToSystem
   */


  systemIndexAndScaledY(y) {
    var systemPadding = this.renderOptions.systemPadding;

    if (systemPadding === undefined) {
      systemPadding = this.renderOptions.naiveSystemPadding;
    }

    var systemIndex = Math.floor(y / (this.systemHeight + systemPadding));
    var scaledYRelativeToSystem = y - systemIndex * (this.systemHeight + systemPadding);
    return [systemIndex, scaledYRelativeToSystem];
  }
  /**
   * Overrides the default music21.stream.Stream#findNoteForClick
   * by taking into account systems
   *
   * @param {HTMLElement|SVGElement} svg
   * @param {MouseEvent|TouchEvent} e
   * @param {number} [x]
   * @param {number} [y]
   * @returns {Array} [clickedDiatonicNoteNum, foundNote]
   */


  findNoteForClick(svg, e) {
    var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

    if (x === undefined || y === undefined) {
      var _this$getScaledXYforD3 = this.getScaledXYforDOM(svg, e);

      var _this$getScaledXYforD4 = _slicedToArray(_this$getScaledXYforD3, 2);

      x = _this$getScaledXYforD4[0];
      y = _this$getScaledXYforD4[1];
    } // debug = true;


    if (_debug__WEBPACK_IMPORTED_MODULE_14__["debug"]) {
      console.log('this.estimateStreamHeight(): ' + this.estimateStreamHeight() + ' / $(svg).height(): ' + jquery__WEBPACK_IMPORTED_MODULE_11__(svg).height());
    } // TODO(msc) -- systemPadding was never used -- should it be?
    // let systemPadding = this.renderOptions.systemPadding;
    // if (systemPadding === undefined) {
    //     systemPadding = this.renderOptions.naiveSystemPadding;
    // }


    var _this$systemIndexAndS = this.systemIndexAndScaledY(y),
        _this$systemIndexAndS2 = _slicedToArray(_this$systemIndexAndS, 2),
        systemIndex = _this$systemIndexAndS2[0],
        scaledYRelativeToSystem = _this$systemIndexAndS2[1];

    var clickedDiatonicNoteNum = this.diatonicNoteNumFromScaledY(scaledYRelativeToSystem);
    var foundNote = this.noteElementFromScaledX(x, undefined, systemIndex);
    return [clickedDiatonicNoteNum, foundNote];
  }
  /**
   * Returns the measure that is at X location xPxScaled and system systemIndex.
   *
   * @param {number} [xPxScaled]
   * @param {number} [systemIndex]
   * @returns {Stream}
   *
   */


  getStreamFromScaledXandSystemIndex(xPxScaled) {
    var systemIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var gotMeasure;
    var measures = this.measures;
    var _iteratorNormalCompletion29 = true;
    var _didIteratorError29 = false;
    var _iteratorError29 = undefined;

    try {
      for (var _iterator29 = measures[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
        var m = _step29.value;
        var rendOp = m.renderOptions;
        var left = rendOp.left;
        var right = left + rendOp.width;
        var top = rendOp.top;
        var bottom = top + rendOp.height;

        if (_debug__WEBPACK_IMPORTED_MODULE_14__["debug"]) {
          console.log('Searching for X:' + Math.round(xPxScaled) + ' in Measure ' + ' with boundaries L:' + left + ' R:' + right + ' T: ' + top + ' B: ' + bottom);
        }

        if (xPxScaled >= left && xPxScaled <= right) {
          if (systemIndex === undefined) {
            gotMeasure = m;
            break;
          } else if (rendOp.systemIndex === systemIndex) {
            gotMeasure = m;
            break;
          }
        }
      }
    } catch (err) {
      _didIteratorError29 = true;
      _iteratorError29 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion29 && _iterator29.return != null) {
          _iterator29.return();
        }
      } finally {
        if (_didIteratorError29) {
          throw _iteratorError29;
        }
      }
    }

    return gotMeasure;
  }

}
/**
 * Scores with multiple parts
 */

class Score extends Stream {
  constructor() {
    super();
    this.recursionType = 'elementsOnly';
    this.measureWidths = [];
    this.partSpacing = this.renderOptions.naiveHeight;
  }

  static get className() {
    return 'music21.stream.Score';
  }

  get clef() {
    var c = super.clef;

    if (c === undefined) {
      return new _clef__WEBPACK_IMPORTED_MODULE_17__["TrebleClef"]();
    } else {
      return c;
    }
  }

  set clef(newClef) {
    super.clef = newClef;
  }

  get systemPadding() {
    var numParts = this.parts.length;
    var systemPadding = this.renderOptions.systemPadding;

    if (systemPadding === undefined) {
      if (numParts === 1) {
        systemPadding = this.renderOptions.naiveSystemPadding; // fix to 0
      } else {
        systemPadding = this.renderOptions.naiveSystemPadding;
      }
    }

    return systemPadding;
  }
  /**
   * Override main stream makeBeams to call on each part.
   *
   * @param {boolean} [inPlace=false]
   */


  makeBeams() {
    var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref12$inPlace = _ref12.inPlace,
        inPlace = _ref12$inPlace === void 0 ? false : _ref12$inPlace;

    var returnObj = this;

    if (!inPlace) {
      returnObj = this.clone(true);
    }

    var _iteratorNormalCompletion30 = true;
    var _didIteratorError30 = false;
    var _iteratorError30 = undefined;

    try {
      for (var _iterator30 = returnObj.parts[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
        var p = _step30.value;
        p.makeBeams({
          inPlace: true
        });
      } // returnObj.streamStatus.beams = true;

    } catch (err) {
      _didIteratorError30 = true;
      _iteratorError30 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion30 && _iterator30.return != null) {
          _iterator30.return();
        }
      } finally {
        if (_didIteratorError30) {
          throw _iteratorError30;
        }
      }
    }

    return returnObj;
  }
  /**
   * Returns the measure that is at X location xPxScaled and system systemIndex.
   *
   * Always returns the measure of the top part...
   *
   * @param {number} xPxScaled
   * @param {number} [systemIndex]
   * @returns {Stream} usually a Measure
   *
   */


  getStreamFromScaledXandSystemIndex(xPxScaled) {
    var systemIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var parts = this.parts;
    return parts.get(0).getStreamFromScaledXandSystemIndex(xPxScaled, systemIndex);
  }
  /**
   * overrides music21.stream.Stream#setSubstreamRenderOptions
   *
   * figures out the `.left` and `.top` attributes for all contained parts
   */


  setSubstreamRenderOptions() {
    var currentPartNumber = 0;
    var currentPartTop = 0;
    var partSpacing = this.partSpacing;
    var _iteratorNormalCompletion31 = true;
    var _didIteratorError31 = false;
    var _iteratorError31 = undefined;

    try {
      for (var _iterator31 = this.parts[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
        var p = _step31.value;
        p.renderOptions.partIndex = currentPartNumber;
        p.renderOptions.top = currentPartTop;
        p.setSubstreamRenderOptions();
        currentPartTop += partSpacing;
        currentPartNumber += 1;
      }
    } catch (err) {
      _didIteratorError31 = true;
      _iteratorError31 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion31 && _iterator31.return != null) {
          _iterator31.return();
        }
      } finally {
        if (_didIteratorError31) {
          throw _iteratorError31;
        }
      }
    }

    this.evenPartMeasureSpacing();
    var ignoreNumSystems = true;
    var currentScoreHeight = this.estimateStreamHeight(ignoreNumSystems);
    var _iteratorNormalCompletion32 = true;
    var _didIteratorError32 = false;
    var _iteratorError32 = undefined;

    try {
      for (var _iterator32 = this.parts[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
        var _p2 = _step32.value;

        _p2.fixSystemInformation(currentScoreHeight);
      }
    } catch (err) {
      _didIteratorError32 = true;
      _iteratorError32 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion32 && _iterator32.return != null) {
          _iterator32.return();
        }
      } finally {
        if (_didIteratorError32) {
          throw _iteratorError32;
        }
      }
    }

    this.renderOptions.height = this.estimateStreamHeight();
    return this;
  }
  /**
   * Overrides the default music21.stream.Stream#estimateStaffLength
   *
   * @returns {number}
   */


  estimateStaffLength() {
    // override
    if (this.renderOptions.overriddenWidth !== undefined) {
      // console.log("Overridden staff width: " + this.renderOptions.overriddenWidth);
      return this.renderOptions.overriddenWidth;
    }

    var maxWidth = -1;
    var _iteratorNormalCompletion33 = true;
    var _didIteratorError33 = false;
    var _iteratorError33 = undefined;

    try {
      for (var _iterator33 = this.parts[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
        var p = _step33.value;
        var pWidth = p.estimateStaffLength();

        if (pWidth > maxWidth) {
          maxWidth = pWidth;
        }
      }
    } catch (err) {
      _didIteratorError33 = true;
      _iteratorError33 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion33 && _iterator33.return != null) {
          _iterator33.return();
        }
      } finally {
        if (_didIteratorError33) {
          throw _iteratorError33;
        }
      }
    }

    if (maxWidth > -1) {
      return maxWidth;
    } // no parts found in score... use part...


    console.log('no parts found in score');
    var tempPart = new Part();
    tempPart.elements = this;
    return tempPart.estimateStaffLength();
  }
  /* MIDI override */

  /**
   * Overrides the default music21.stream.Stream#playStream
   *
   * Works crappily -- just starts *n* midi players.
   *
   * Render scrollable score works better...
   *
   * @param {Object} params -- passed to each part
   */


  playStream(params) {
    // play multiple parts in parallel...
    var _iteratorNormalCompletion34 = true;
    var _didIteratorError34 = false;
    var _iteratorError34 = undefined;

    try {
      for (var _iterator34 = this[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
        var el = _step34.value;

        if (el.isClassOrSubclass('Part')) {
          el.playStream(params);
        }
      }
    } catch (err) {
      _didIteratorError34 = true;
      _iteratorError34 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion34 && _iterator34.return != null) {
          _iterator34.return();
        }
      } finally {
        if (_didIteratorError34) {
          throw _iteratorError34;
        }
      }
    }

    return this;
  }
  /**
   * Overrides the default music21.stream.Stream#stopPlayScore()
   */


  stopPlayStream() {
    var _iteratorNormalCompletion35 = true;
    var _didIteratorError35 = false;
    var _iteratorError35 = undefined;

    try {
      for (var _iterator35 = this[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
        var el = _step35.value;

        if (el.isClassOrSubclass('Part')) {
          el.stopPlayStream();
        }
      }
    } catch (err) {
      _didIteratorError35 = true;
      _iteratorError35 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion35 && _iterator35.return != null) {
          _iterator35.return();
        }
      } finally {
        if (_didIteratorError35) {
          throw _iteratorError35;
        }
      }
    }

    return this;
  }
  /*
   * Svg routines
   */

  /**
   * call after setSubstreamRenderOptions
   * gets the maximum measure width for each measure
   * by getting the maximum for each measure of
   * Part.getMeasureWidths();
   *
   * Does this work? I found a bug in this and fixed it that should have
   * broken it!
   *
   * @returns Array<number>
   */


  getMaxMeasureWidths() {
    var maxMeasureWidths = [];
    var measureWidthsArrayOfArrays = [];
    var i; // TODO: Do not crash on not partlike...

    var _iteratorNormalCompletion36 = true;
    var _didIteratorError36 = false;
    var _iteratorError36 = undefined;

    try {
      for (var _iterator36 = this.parts[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
        var p = _step36.value;
        measureWidthsArrayOfArrays.push(p.getMeasureWidths());
      }
    } catch (err) {
      _didIteratorError36 = true;
      _iteratorError36 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion36 && _iterator36.return != null) {
          _iterator36.return();
        }
      } finally {
        if (_didIteratorError36) {
          throw _iteratorError36;
        }
      }
    }

    for (i = 0; i < measureWidthsArrayOfArrays[0].length; i++) {
      var maxFound = 0;

      for (var j = 0; j < this.length; j++) {
        if (measureWidthsArrayOfArrays[j][i] > maxFound) {
          maxFound = measureWidthsArrayOfArrays[j][i];
        }
      }

      maxMeasureWidths.push(maxFound);
    } // console.log(measureWidths);


    return maxMeasureWidths;
  }
  /**
   * systemIndexAndScaledY - given a scaled Y, return the systemIndex
   * and the scaledYRelativeToSystem
   *
   * @param  {number} y the scaled Y
   * @return Array<number>   systemIndex, scaledYRelativeToSystem
   */


  systemIndexAndScaledY(y) {
    // TODO(msc) -- systemPadding was not being used; should it be?
    // let systemPadding = this.renderOptions.systemPadding;
    // if (systemPadding === undefined) {
    //     systemPadding = this.renderOptions.naiveSystemPadding;
    // }
    var numParts = this.parts.length;
    var systemHeight = numParts * this.partSpacing + this.systemPadding;
    var systemIndex = Math.floor(y / systemHeight);
    var scaledYRelativeToSystem = y - systemIndex * systemHeight;
    return [systemIndex, scaledYRelativeToSystem];
  }
  /**
   * Returns a list of [clickedDiatonicNoteNum, foundNote] for a
   * click event, taking into account that the note will be in different
   * Part objects (and different Systems) given the height and possibly different Systems.
   *
   * @param {HTMLElement|SVGElement} svg
   * @param {MouseEvent|TouchEvent} e
   * @param {number} [x]
   * @param {number} [y]
   * @returns {Array} [diatonicNoteNum, m21Element]
   */


  findNoteForClick(svg, e) {
    var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

    if (x === undefined || y === undefined) {
      var _this$getScaledXYforD5 = this.getScaledXYforDOM(svg, e);

      var _this$getScaledXYforD6 = _slicedToArray(_this$getScaledXYforD5, 2);

      x = _this$getScaledXYforD6[0];
      y = _this$getScaledXYforD6[1];
    }

    var _this$systemIndexAndS3 = this.systemIndexAndScaledY(y),
        _this$systemIndexAndS4 = _slicedToArray(_this$systemIndexAndS3, 2),
        systemIndex = _this$systemIndexAndS4[0],
        scaledYFromSystemTop = _this$systemIndexAndS4[1];

    var partIndex = Math.floor(scaledYFromSystemTop / this.partSpacing);
    var scaledYinPart = scaledYFromSystemTop - partIndex * this.partSpacing; // console.log('systemIndex: ' + systemIndex + " partIndex: " + partIndex);

    var rightPart = this.parts.get(partIndex);

    if (rightPart === undefined) {
      return [undefined, undefined]; // may be too low?
    }

    var clickedDiatonicNoteNum = rightPart.diatonicNoteNumFromScaledY(scaledYinPart);
    var foundNote = rightPart.noteElementFromScaledX(x, undefined, systemIndex);
    return [clickedDiatonicNoteNum, foundNote];
  }
  /**
   * How many systems are there? Calls numSystems() on the first part.
   */


  numSystems() {
    return this.getElementsByClass('Part').get(0).numSystems();
  }
  /**
   * Fixes the part measure spacing for all parts.
   *
   * @param {Object} options
   * @param {boolean} [options.setLeft=true]
   * @returns {this}
   */


  evenPartMeasureSpacing() {
    var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref13$setLeft = _ref13.setLeft,
        setLeft = _ref13$setLeft === void 0 ? true : _ref13$setLeft;

    var measureStacks = [];
    var currentPartNumber = 0;
    var maxMeasureWidth = []; // the maximum measure width among all parts

    var j;
    var _iteratorNormalCompletion37 = true;
    var _didIteratorError37 = false;
    var _iteratorError37 = undefined;

    try {
      for (var _iterator37 = this.parts[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
        var p = _step37.value;
        var measureWidths = p.getMeasureWidths();

        for (j = 0; j < measureWidths.length; j++) {
          var thisMeasureWidth = measureWidths[j];

          if (measureStacks[j] === undefined) {
            measureStacks[j] = [];
            maxMeasureWidth[j] = thisMeasureWidth;
          } else if (thisMeasureWidth > maxMeasureWidth[j]) {
            maxMeasureWidth[j] = thisMeasureWidth;
          }

          measureStacks[j][currentPartNumber] = thisMeasureWidth;
        }

        currentPartNumber += 1;
      }
    } catch (err) {
      _didIteratorError37 = true;
      _iteratorError37 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion37 && _iterator37.return != null) {
          _iterator37.return();
        }
      } finally {
        if (_didIteratorError37) {
          throw _iteratorError37;
        }
      }
    }

    var currentLeft = 20;

    for (var i = 0; i < maxMeasureWidth.length; i++) {
      var measureNewWidth = maxMeasureWidth[i];
      var _iteratorNormalCompletion38 = true;
      var _didIteratorError38 = false;
      var _iteratorError38 = undefined;

      try {
        for (var _iterator38 = this.parts[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
          var part = _step38.value;
          var measure = part.getElementsByClass('Measure').get(i);
          var rendOp = measure.renderOptions;
          rendOp.width = measureNewWidth;

          if (setLeft) {
            rendOp.left = currentLeft;
          }
        }
      } catch (err) {
        _didIteratorError38 = true;
        _iteratorError38 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion38 && _iterator38.return != null) {
            _iterator38.return();
          }
        } finally {
          if (_didIteratorError38) {
            throw _iteratorError38;
          }
        }
      }

      currentLeft += measureNewWidth;
    }

    return this;
  }

} // TODO(msc) -- Opus
// small Class; a namedtuple in music21p

class OffsetMap {
  constructor(element, offset, endTime, voiceIndex) {
    this.element = element;
    this.offset = offset;
    this.endTime = endTime;
    this.voiceIndex = voiceIndex;
  }

}

/***/ }),

/***/ "./src/music21/stream/filters.ts":
/*!***************************************!*\
  !*** ./src/music21/stream/filters.ts ***!
  \***************************************/
/*! exports provided: FilterException, StopIterationSingleton, StreamFilter, IsFilter, IsNotFilter, ClassFilter, ClassNotFilter, OffsetFilter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FilterException", function() { return FilterException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StopIterationSingleton", function() { return StopIterationSingleton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StreamFilter", function() { return StreamFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsFilter", function() { return IsFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsNotFilter", function() { return IsNotFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClassFilter", function() { return ClassFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClassNotFilter", function() { return ClassNotFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OffsetFilter", function() { return OffsetFilter; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../exceptions21 */ "./src/music21/exceptions21.ts");


 // noinspection JSUnusedGlobalSymbols

class FilterException extends _exceptions21__WEBPACK_IMPORTED_MODULE_2__["Music21Exception"] {}

class _StopIteration {}

var StopIterationSingleton = new _StopIteration();
/**
 * @memberof music21.stream.filters
 */

class StreamFilter {
  static get derivationStr() {
    return 'streamFilter';
  }

  reset() {}

  call(item, iterator) {
    return true;
  }

}
class IsFilter extends StreamFilter {
  constructor() {
    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    super();

    if (!Array.isArray(target)) {
      target = [target];
    }

    this.target = target;
    this.numToFind = target.length;
  }

  static get derivationStr() {
    return 'is';
  }

  reset() {
    this.numToFind = this.target.length;
  }

  call(item, iterator) {
    if (this.numToFind === 0) {
      return StopIterationSingleton;
    }

    if (this.target.includes(item)) {
      this.numToFind -= 1;
      return true;
    } else {
      return false;
    }
  }

}
class IsNotFilter extends IsFilter {
  static get derivationStr() {
    return 'IsNot';
  }

  constructor(target) {
    super(target);
    this.numToFind = Number.MAX_SAFE_INTEGER;
  }

  reset() {}

  call(item, iterator) {
    var ret = super.call(item, iterator);

    if (ret === StopIterationSingleton) {
      return ret;
    } else {
      return !ret;
    }
  }

} // TODO(msc): IdFilter

class ClassFilter extends StreamFilter {
  constructor() {
    var classList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    super();

    if (!Array.isArray(classList)) {
      classList = [classList];
    }

    this.classList = classList;
  }

  static get derivationStr() {
    return 'getElementsByClass';
  } // TODO: __eq__


  call(item, iterator) {
    return item.isClassOrSubclass(this.classList);
  }

}
class ClassNotFilter extends ClassFilter {
  static get derivationStr() {
    return 'getElementsNotOfClass';
  }

  call(item, iterator) {
    return !super.call(item, iterator);
  }

} // TODO: GroupFilter

class OffsetFilter extends StreamFilter {
  constructor(offsetStart) {
    var offsetEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$includeEndBounda = _ref.includeEndBoundary,
        includeEndBoundary = _ref$includeEndBounda === void 0 ? true : _ref$includeEndBounda,
        _ref$mustFinishInSpan = _ref.mustFinishInSpan,
        mustFinishInSpan = _ref$mustFinishInSpan === void 0 ? false : _ref$mustFinishInSpan,
        _ref$mustBeginInSpan = _ref.mustBeginInSpan,
        mustBeginInSpan = _ref$mustBeginInSpan === void 0 ? true : _ref$mustBeginInSpan,
        _ref$includeElementsT = _ref.includeElementsThatEndAtStart,
        includeElementsThatEndAtStart = _ref$includeElementsT === void 0 ? true : _ref$includeElementsT;

    super();
    this.zeroLengthSearch = false;
    this.offsetStart = offsetStart;
    this.offsetEnd = offsetEnd;
    this.includeEndBoundary = includeEndBoundary;
    this.mustFinishInSpan = mustFinishInSpan;
    this.mustBeginInSpan = mustBeginInSpan;
    this.includeElementsThatEndAtStart = includeElementsThatEndAtStart;

    if (offsetEnd === undefined) {
      this.offsetEnd = offsetStart;
      this.zeroLengthSearch = true;
    } else if (offsetEnd <= offsetStart) {
      this.zeroLengthSearch = true;
    }
  }

  static get derivationStr() {
    return 'getElementsByOffset';
  }

  call(item, iterator) {
    // N.B. iterator.srcStream.elementOffset is necessary instead
    // of elementOffset, because we have not set activeSite yet.
    return this.isElementOffsetInRange(item, iterator.srcStream.elementOffset(item));
  }

  isElementOffsetInRange(e, offset) {
    if (offset > this.offsetEnd) {
      // anything that begins after the span is definitely out.
      return false;
    }

    var dur = e.duration;
    var elementEnd = offset + dur.quarterLength;

    if (elementEnd < this.offsetStart) {
      // anything that finishes before the span ends is definitely out
      return false;
    } // some part of the element is at least touching some part of span.


    var elementIsZeroLength = false;

    if (dur.quarterLength === 0) {
      elementIsZeroLength = true;
    }

    if (this.zeroLengthSearch && elementIsZeroLength) {
      return true;
    }

    if (this.mustFinishInSpan) {
      if (elementEnd > this.offsetEnd) {
        return false;
      }

      if (!this.includeEndBoundary && offset === this.offsetEnd) {
        return false;
      }
    }

    if (this.mustBeginInSpan) {
      if (offset < this.offsetStart) {
        return false;
      }

      if (!this.includeEndBoundary && offset === this.offsetEnd) {
        return false;
      }
    } else if (!elementIsZeroLength && elementEnd === this.offsetEnd && this.zeroLengthSearch) {
      return false;
    }

    if (!this.includeEndBoundary && offset === this.offsetEnd) {
      return false;
    }

    if (!this.includeElementsThatEndAtStart && elementEnd === this.offsetStart) {
      return false;
    }

    return true;
  }

} // TODO: OffsetHierarchyFilter

/***/ }),

/***/ "./src/music21/stream/iterator.ts":
/*!****************************************!*\
  !*** ./src/music21/stream/iterator.ts ***!
  \****************************************/
/*! exports provided: StreamIteratorException, StreamIterator, OffsetIterator, RecursiveIterator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StreamIteratorException", function() { return StreamIteratorException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StreamIterator", function() { return StreamIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OffsetIterator", function() { return OffsetIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecursiveIterator", function() { return RecursiveIterator; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.sort */ "./node_modules/core-js/modules/es.array.sort.js");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony import */ var _filters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./filters */ "./src/music21/stream/filters.ts");







var StopIterationSingleton = _filters__WEBPACK_IMPORTED_MODULE_6__["StopIterationSingleton"]; // noinspection JSUnusedGlobalSymbols

class StreamIteratorException extends _exceptions21__WEBPACK_IMPORTED_MODULE_5__["StreamException"] {}
class StreamIterator {
  constructor(srcStream) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$filterList = _ref.filterList,
        filterList = _ref$filterList === void 0 ? [] : _ref$filterList,
        _ref$restoreActiveSit = _ref.restoreActiveSites,
        restoreActiveSites = _ref$restoreActiveSit === void 0 ? true : _ref$restoreActiveSit,
        _ref$activeInformatio = _ref.activeInformation,
        activeInformation = _ref$activeInformatio === void 0 ? undefined : _ref$activeInformatio,
        _ref$ignoreSorting = _ref.ignoreSorting,
        ignoreSorting = _ref$ignoreSorting === void 0 ? false : _ref$ignoreSorting;

    this.index = 0;
    this.iterSection = '_elements';
    this.cleanupOnStop = false;
    this.sectionIndex = 0;

    if (!ignoreSorting && !srcStream.isSorted && srcStream.autoSort) {
      srcStream.sort();
    }

    this.srcStream = srcStream;
    this.srcStreamElements = srcStream.elements;
    this.streamLength = this.srcStreamElements.length;
    this.restoreActiveSites = restoreActiveSites;
    this.overrideDerivation = undefined;

    if (!Array.isArray(filterList)) {
      filterList = [filterList];
    }

    this.filters = filterList;
    this.sectionIndex = 0; // no endElements yet...

    if (activeInformation === undefined) {
      this.activeInformation = {};
      this.updateActiveInformation();
    } else {
      this.activeInformation = activeInformation;
    }
  }

  [Symbol.iterator]() {
    var _this = this;

    return (
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var e, matches;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.reset();

              case 1:
                if (!(_this.index < _this.streamLength)) {
                  _context.next = 22;
                  break;
                }

                // noinspection DuplicatedCode
                _this.index += 1;
                e = void 0;
                _context.prev = 4;
                e = _this.srcStreamElements[_this.index - 1];
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](4);
                return _context.abrupt("continue", 1);

              case 11:
                matches = _this.matchesFilters(e);

                if (!(matches === false)) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("continue", 1);

              case 14:
                if (!(matches === StopIterationSingleton)) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("break", 22);

              case 16:
                if (_this.restoreActiveSites) {
                  e.activeSite = _this.srcStream;
                }

                _this.updateActiveInformation();

                _context.next = 20;
                return e;

              case 20:
                _context.next = 1;
                break;

              case 22:
                _this.cleanup();

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 8]]);
      })()
    );
  }

  get(k) {
    var fe = this.matchingElements();

    if (k < 0) {
      k = fe.length + k;
    }

    return fe[k];
  }

  get length() {
    if (this._len !== undefined) {
      return this._len;
    }

    this._len = this.matchingElements().length;
    this.reset();
    return this._len;
  }

  updateActiveInformation() {
    var ai = this.activeInformation;
    ai.stream = this.srcStream;
    ai.index = this.index - 1;
    ai.iterSection = this.iterSection;
    ai.sectionIndex = this.sectionIndex;
  }

  reset() {
    this.index = 0;
    this.iterSection = '_elements';
    this.updateActiveInformation();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var f = _step.value;

        if (f.reset !== undefined) {
          f.reset();
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  resetCaches() {
    this._len = undefined;
    this._matchingElements = undefined;
  }

  cleanup() {
    if (this.cleanupOnStop) {
      this.reset();
      this.srcStream = undefined;
      this.srcStreamElements = [];
    }
  }

  matchingElements() {
    if (this._matchingElements !== undefined) {
      return this._matchingElements;
    }

    var savedIndex = this.index;
    var savedRestoreActiveSites = this.restoreActiveSites;
    this.restoreActiveSites = true;
    var me = []; // matching elements

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var e = _step2.value;
        me.push(e);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    this.reset();
    this.index = savedIndex;
    this.restoreActiveSites = savedRestoreActiveSites;
    this._matchingElements = me;
    return me;
  }

  matchesFilters(e) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this.filters[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var f = _step3.value;
        var ret = f.call(e, this);

        if (ret === false) {
          return false; // must === false;
        }

        if (ret === StopIterationSingleton) {
          return ret;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return true;
  }

  stream() {
    var ss = this.srcStream; // let clearIsSorted = false;

    var found = ss.clone(false);
    found.elements = []; // derivation;

    var fe = this.matchingElements();
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = fe[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var e = _step4.value;
        var stringReturns = true;
        var o = ss.elementOffset(e, stringReturns); // try: getOffsetInHierarchy...
        // string returns;

        found.insert(o, e);
      } // if (fe.length) {
      //     found.coreElementsChanged()
      // }

    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return found;
  } // noinspection JSUnusedGlobalSymbols


  get activeElementList() {
    return this.activeInformation.stream[this.activeInformation.iterSection];
  }

  addFilter(newFilter) {
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = this.filters[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var f = _step5.value;

        if (newFilter === f) {
          return this; // will not work... because == overrides.
        }
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    this.filters.push(newFilter);
    this.resetCaches();
    return this;
  } // noinspection JSUnusedGlobalSymbols


  removeFilter(oldFilter) {
    var index = this.filters.indexOf(oldFilter);

    if (index !== -1) {
      this.filters.splice(index, 1);
    }

    this.resetCaches();
    return this;
  } // getElementById(elementId) {
  //
  // }


  getElementsByClass(classFilterList) {
    return this.addFilter(new _filters__WEBPACK_IMPORTED_MODULE_6__["ClassFilter"](classFilterList));
  }

  getElementsNotOfClass(classFilterList) {
    return this.addFilter(new _filters__WEBPACK_IMPORTED_MODULE_6__["ClassNotFilter"](classFilterList));
  } // getElementsByGroup;
  // getElementsByOffset;


  getElementsByOffset(offsetStart) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return this.addFilter(new _filters__WEBPACK_IMPORTED_MODULE_6__["OffsetFilter"](offsetStart, ...args));
  }

  get notes() {
    return this.addFilter(new _filters__WEBPACK_IMPORTED_MODULE_6__["ClassFilter"]('NotRest'));
  }

  get notesAndRests() {
    return this.addFilter(new _filters__WEBPACK_IMPORTED_MODULE_6__["ClassFilter"]('GeneralNote'));
  }

  get parts() {
    return this.addFilter(new _filters__WEBPACK_IMPORTED_MODULE_6__["ClassFilter"]('Part'));
  } // noinspection JSUnusedGlobalSymbols


  get spanners() {
    return this.addFilter(new _filters__WEBPACK_IMPORTED_MODULE_6__["ClassFilter"]('Spanner'));
  }

  get voices() {
    return this.addFilter(new _filters__WEBPACK_IMPORTED_MODULE_6__["ClassFilter"]('Voice'));
  }

}
class OffsetIterator extends StreamIterator {
  constructor(srcStream) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super(srcStream, options);
    this.nextToYield = [];
  }

  [Symbol.iterator]() {
    var _this2 = this;

    return (
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var e, matches, yieldEls, eOffset, forwardIndex, nextE, nextOffset, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, el;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.reset(); // this.sort();


              case 1:
                if (!(_this2.index < _this2.streamLength)) {
                  _context2.next = 65;
                  break;
                }

                // noinspection DuplicatedCode
                _this2.index += 1;
                e = void 0;
                _context2.prev = 4;
                e = _this2.srcStreamElements[_this2.index - 1];
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](4);
                return _context2.abrupt("continue", 1);

              case 11:
                matches = _this2.matchesFilters(e);

                if (!(matches === false)) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("continue", 1);

              case 14:
                if (!(matches === StopIterationSingleton)) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt("break", 65);

              case 16:
                yieldEls = [e];
                eOffset = _this2.srcStream.elementOffset(e);
                forwardIndex = _this2.index;

              case 19:
                if (!(forwardIndex < _this2.streamLength)) {
                  _context2.next = 40;
                  break;
                }

                nextE = void 0;
                _context2.prev = 21;
                nextE = _this2.srcStreamElements[_this2.index - 1];
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t1 = _context2["catch"](21);
                return _context2.abrupt("continue", 37);

              case 28:
                nextOffset = _this2.srcStream.elementOffset(nextE);

                if (!(nextOffset !== eOffset)) {
                  _context2.next = 33;
                  break;
                }

                _this2.nextToYield = [nextE];
                _this2.nextOffsetToYield = nextOffset;
                return _context2.abrupt("break", 40);

              case 33:
                if (_this2.matchesFilters(nextE)) {
                  _context2.next = 35;
                  break;
                }

                return _context2.abrupt("continue", 37);

              case 35:
                yieldEls.push(e);
                _this2.index = forwardIndex;

              case 37:
                forwardIndex++;
                _context2.next = 19;
                break;

              case 40:
                if (!_this2.restoreActiveSites) {
                  _context2.next = 60;
                  break;
                }

                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context2.prev = 44;

                for (_iterator6 = yieldEls[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  el = _step6.value;
                  el.activeSite = _this2.srcStream;
                }

                _context2.next = 52;
                break;

              case 48:
                _context2.prev = 48;
                _context2.t2 = _context2["catch"](44);
                _didIteratorError6 = true;
                _iteratorError6 = _context2.t2;

              case 52:
                _context2.prev = 52;
                _context2.prev = 53;

                if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                  _iterator6.return();
                }

              case 55:
                _context2.prev = 55;

                if (!_didIteratorError6) {
                  _context2.next = 58;
                  break;
                }

                throw _iteratorError6;

              case 58:
                return _context2.finish(55);

              case 59:
                return _context2.finish(52);

              case 60:
                _this2.updateActiveInformation();

                _context2.next = 63;
                return yieldEls;

              case 63:
                _context2.next = 1;
                break;

              case 65:
                _this2.cleanup();

              case 66:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 8], [21, 25], [44, 48, 52, 60], [53,, 55, 59]]);
      })()
    );
  }

  reset() {
    super.reset();
    this.nextToYield = [];
    this.nextOffsetToYield = undefined;
  }

}
class RecursiveIterator extends StreamIterator {
  constructor(srcStream) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$filterList = _ref2.filterList,
        filterList = _ref2$filterList === void 0 ? [] : _ref2$filterList,
        _ref2$restoreActiveSi = _ref2.restoreActiveSites,
        restoreActiveSites = _ref2$restoreActiveSi === void 0 ? true : _ref2$restoreActiveSi,
        _ref2$activeInformati = _ref2.activeInformation,
        activeInformation = _ref2$activeInformati === void 0 ? undefined : _ref2$activeInformati,
        _ref2$streamsOnly = _ref2.streamsOnly,
        streamsOnly = _ref2$streamsOnly === void 0 ? false : _ref2$streamsOnly,
        _ref2$includeSelf = _ref2.includeSelf,
        includeSelf = _ref2$includeSelf === void 0 ? false : _ref2$includeSelf,
        _ref2$ignoreSorting = _ref2.ignoreSorting,
        ignoreSorting = _ref2$ignoreSorting === void 0 ? false : _ref2$ignoreSorting;

    super(srcStream, {
      filterList,
      restoreActiveSites,
      activeInformation,
      ignoreSorting
    });
    this.iteratorStartOffsetInHierarchy = 0.0;
    this.returnSelf = includeSelf;
    this.includeSelf = includeSelf;
    this.ignoreSorting = ignoreSorting;

    if (streamsOnly) {
      this.filters.push(new _filters__WEBPACK_IMPORTED_MODULE_6__["ClassFilter"]('Stream'));
    }

    this.childRecursiveIterator = undefined;
  }

  reset() {
    this.returnSelf = this.includeSelf;
    this.childRecursiveIterator = undefined;
    this.activeInformation.lastYielded = undefined;
    super.reset();
  }

  [Symbol.iterator]() {
    var _this3 = this;

    return (
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var e, newStartOffset, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, _e;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.reset(); // in __iter__.


                if (!(_this3.returnSelf && _this3.matchesFilters(_this3.srcStream))) {
                  _context3.next = 10;
                  break;
                }

                _this3.activeInformation.stream = undefined;
                _this3.activeInformation.index = -1;
                _this3.activeInformation.lastYielded = _this3.srcStream;
                _this3.returnSelf = false;
                _context3.next = 8;
                return _this3.srcStream;

              case 8:
                _context3.next = 11;
                break;

              case 10:
                if (_this3.returnSelf) {
                  // did not match filters...
                  _this3.returnSelf = false;
                }

              case 11:
                if (!(_this3.index < _this3.streamLength)) {
                  _context3.next = 55;
                  break;
                }

                _this3.index += 1;
                e = _this3.srcStreamElements[_this3.index - 1];

                if (!(e === undefined)) {
                  _context3.next = 16;
                  break;
                }

                return _context3.abrupt("continue", 11);

              case 16:
                if (!_this3.matchesFilters(e)) {
                  _context3.next = 22;
                  break;
                }

                if (_this3.restoreActiveSites) {
                  e.activeSite = _this3.srcStream;
                }

                _this3.updateActiveInformation();

                _this3.activeInformation.lastYielded = e;
                _context3.next = 22;
                return e;

              case 22:
                if (!e.isStream) {
                  _context3.next = 53;
                  break;
                }

                _this3.childRecursiveIterator = new RecursiveIterator(e, {
                  restoreActiveSites: _this3.restoreActiveSites,
                  filterList: _this3.filters,
                  activeInformation: _this3.activeInformation,
                  includeSelf: false,
                  ignoreSorting: _this3.ignoreSorting
                });
                newStartOffset = _this3.iteratorStartOffsetInHierarchy + _this3.srcStream.elementOffset(e);
                _this3.childRecursiveIterator.iteratorStartOffsetInHierarchy = newStartOffset;
                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context3.prev = 29;
                _iterator7 = _this3.childRecursiveIterator[Symbol.iterator]();

              case 31:
                if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                  _context3.next = 38;
                  break;
                }

                _e = _step7.value;
                _context3.next = 35;
                return _e;

              case 35:
                _iteratorNormalCompletion7 = true;
                _context3.next = 31;
                break;

              case 38:
                _context3.next = 44;
                break;

              case 40:
                _context3.prev = 40;
                _context3.t0 = _context3["catch"](29);
                _didIteratorError7 = true;
                _iteratorError7 = _context3.t0;

              case 44:
                _context3.prev = 44;
                _context3.prev = 45;

                if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                  _iterator7.return();
                }

              case 47:
                _context3.prev = 47;

                if (!_didIteratorError7) {
                  _context3.next = 50;
                  break;
                }

                throw _iteratorError7;

              case 50:
                return _context3.finish(47);

              case 51:
                return _context3.finish(44);

              case 52:
                _this3.childRecursiveIterator = undefined;

              case 53:
                _context3.next = 11;
                break;

              case 55:
                _this3.activeInformation.lastYielded = undefined;

                _this3.cleanup();

              case 57:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[29, 40, 44, 52], [45,, 47, 51]]);
      })()
    );
  }

  matchingElements() {
    // none of this may be necessary in JavaScript,
    // but perhaps if called during iteration.
    var savedRecursiveIterator = this.childRecursiveIterator;
    var fe = super.matchingElements();
    this.childRecursiveIterator = savedRecursiveIterator;
    return fe;
  }
  /**
   *   Returns a stack of RecursiveIterators at this point in the iteration.
   *   Last is most recent.
   */


  iteratorStack() {
    var iterStack = [this];
    var x = this;

    while (x.childRecursiveIterator !== undefined) {
      x = x.childRecursiveIterator;
      iterStack.push(x);
    }

    return iterStack;
  } // noinspection JSUnusedGlobalSymbols

  /**
   *   Returns a stack of Streams at this point.  Last is most recent.
   */


  streamStack() {
    return this.iteratorStack().map(iter => iter.srcStream);
  } // noinspection JSUnusedGlobalSymbols

  /**
   *  Called on the current iterator, returns the current offset
   *  in the hierarchy. or undefined if we are not currently iterating.
   */


  currentHierarchyOffset() {
    var lastYield = this.activeInformation.lastYielded;

    if (lastYield === undefined) {
      return undefined;
    }

    var iteratorStack = this.iteratorStack();
    var newestIterator = iteratorStack[iteratorStack.length - 1];
    var lastStream = newestIterator.srcStream;
    var lastStartOffset = newestIterator.iteratorStartOffsetInHierarchy;

    if (lastYield === lastStream) {
      return lastStartOffset;
    } else {
      return lastStartOffset + lastStream.elementOffset(lastYield);
    }
  }

}

/***/ }),

/***/ "./src/music21/tempo.ts":
/*!******************************!*\
  !*** ./src/music21/tempo.ts ***!
  \******************************/
/*! exports provided: TempoException, defaultTempoValues, baseTempo, Metronome, MetronomeMark */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TempoException", function() { return TempoException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTempoValues", function() { return defaultTempoValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "baseTempo", function() { return baseTempo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Metronome", function() { return Metronome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MetronomeMark", function() { return MetronomeMark; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! midicube */ "./node_modules/midicube/releases/midicube.js");
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(midicube__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _prebase__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./prebase */ "./src/music21/prebase.ts");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./duration */ "./src/music21/duration.ts");
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");







/**
 * music21j -- Javascript reimplementation of Core music21 features.
 * music21/tempo -- tempo and (not in music21p) metronome objects
 *
 * Copyright (c) 2013-18, Michael Scott Cuthbert and cuthbertLab
 * Based on music21, Copyright (c) 2006–17, Michael Scott Cuthbert and cuthbertLab
 *
 * tempo module, see {@link music21.tempo}
 *
 * @exports music21/tempo
 * @namespace music21.tempo
 * @memberof music21
 * @requires music21/duration
 * @requires music21/prebase
 * @requires music21/base
 * @requires MIDI
 * @property {number} [baseTempo=60] - basic tempo
 */






class TempoException extends _exceptions21__WEBPACK_IMPORTED_MODULE_11__["Music21Exception"] {} // noinspection JSNonASCIINames,NonAsciiCharacters

/**
 * Object mapping names to tempo values
 *
 * @name music21.tempo.defaultTempoValues
 * @memberof music21.tempo
 * @example
 * music21.tempo.defaultTempoValues.grave
 * // 40
 */

var defaultTempoValues = {
  larghissimo: 16,
  largamente: 32,
  grave: 40,
  'molto adagio': 40,
  largo: 46,
  lento: 52,
  adagio: 56,
  slow: 56,
  langsam: 56,
  larghetto: 60,
  adagietto: 66,
  andante: 72,
  andantino: 80,
  'andante moderato': 83,
  maestoso: 88,
  moderato: 92,
  moderate: 92,
  allegretto: 108,
  animato: 120,
  'allegro moderato': 128,
  allegro: 132,
  fast: 132,
  schnell: 132,
  allegrissimo: 140,
  'molto allegro': 144,
  'très vite': 144,
  vivace: 160,
  vivacissimo: 168,
  presto: 184,
  prestissimo: 208
};
var baseTempo = 60;
/* --------- metronome ---------- */

/**
 *
 * @class Metronome
 * @memberof music21.tempo
 * @extends music21.prebase.ProtoM21Object
 * @param {number} [tempo=music21.tempo.baseTempo] - the tempo of the metronome to start
 * @property {number} tempo
 * @property {number} [numBeatsPerMeasure=4]
 * @property {number} [minTempo=10]
 * @property {number} [maxTempo=600]
 * @property {boolean} [flash=false] - flash the tempo
 * @property {boolean} [silent=false] - play silently
 * @property {number} beat - current beat number
 * @property {number} chirpTimeout - an index of a timeout object for chirping
 */

class Metronome extends _prebase__WEBPACK_IMPORTED_MODULE_8__["ProtoM21Object"] {
  constructor() {
    var tempoInt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : baseTempo;
    super();
    this._tempo = baseTempo;
    this.numBeatsPerMeasure = 4;
    this.minTempo = 10;
    this.maxTempo = 600;
    this.beat = 4;
    this.chirpTimeout = undefined;
    this.silent = false;
    this.flash = false;
    this.tempoRanges = [0, 40, 60, 72, 120, 144, 240, 999];
    this.tempoIncreases = [0, 1, 2, 3, 4, 6, 8, 15, 100];

    if (tempoInt === undefined) {
      this.tempo = baseTempo;
    } else {
      this.tempo = tempoInt;
    }
  }

  static get className() {
    return 'music21.tempo.Metronome';
  }

  get tempo() {
    return this._tempo;
  }

  set tempo(t) {
    this._tempo = t;

    if (this._tempo > this.maxTempo) {
      this._tempo = this.maxTempo;
    } else if (this._tempo < this.minTempo) {
      this._tempo = this.minTempo;
    }
  }

  get beatLength() {
    return 60.0 / this.tempo;
  }

  _silentFlash(flashColor) {
    this.$metronomeDiv.find('.metroFlash').css('background-color', flashColor).fadeOut(this.beatLength * 1000 / 4, function silentFadeOut() {
      jquery__WEBPACK_IMPORTED_MODULE_6__(this).css('background-color', '#ffffff').fadeIn(1);
    });
  }
  /**
   * Play a note (a higher one on the downbeat) and start the metronome chirping.
   */


  chirp() {
    this.beat += 1;

    if (this.beat > this.numBeatsPerMeasure) {
      this.beat = 1;

      if (this.silent !== true) {
        midicube__WEBPACK_IMPORTED_MODULE_7__["noteOn"](0, 96, 100, 0);
        midicube__WEBPACK_IMPORTED_MODULE_7__["noteOff"](0, 96, 0.1);
      }

      if (this.flash === true) {
        this._silentFlash('#0000f0');
      }
    } else {
      if (this.silent !== true) {
        midicube__WEBPACK_IMPORTED_MODULE_7__["noteOn"](0, 84, 70, 0);
        midicube__WEBPACK_IMPORTED_MODULE_7__["noteOff"](0, 84, 0.1);
      }

      if (this.flash === true) {
        this._silentFlash('#ff0000');
      }
    }

    var that = this;
    this.chirpTimeout = setTimeout(() => {
      that.chirp();
    }, 1000 * 60 / this.tempo);
  }
  /**
   * Stop the metronome from chirping.
   */


  stopChirp() {
    if (this.chirpTimeout !== undefined) {
      clearTimeout(this.chirpTimeout);
      this.chirpTimeout = undefined;
    }
  }
  /**
   * Increase the metronome tempo one "click".
   *
   * Value changes depending on the current tempo.  Uses standard metronome guidelines.
   *
   * To change the tempo, just set this.tempo = n
   *
   * @param {int} [n=1 - number of clicks to the right
   * @returns {number} new tempo
   */


  increaseSpeed() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    // increase by one metronome 'click' for every n
    for (var i = 0; i < n; i++) {
      var t = this.tempo;

      for (var tr = 0; tr < this.tempoRanges.length; tr++) {
        var tempoExtreme = this.tempoRanges[tr];
        var tempoIncrease = this.tempoIncreases[tr];

        if (t < tempoExtreme) {
          t += tempoIncrease;
          t = tempoIncrease * Math.round(t / tempoIncrease);
          break;
        }
      } // console.log(t);


      this.tempo = t;
    }

    return this.tempo;
  }
  /**
   * Decrease the metronome tempo one "click"
   *
   * To change the tempo, just set this.tempo = n
   *
   * @param {int} [n=1] - number of clicks to the left
   * @returns {number} new tempo
   */


  decreaseSpeed() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    for (var i = 0; i < n; i++) {
      var t = this.tempo;
      var trL = this.tempoRanges.length;

      for (var tr = 1; tr <= trL; tr++) {
        var tempoExtreme = this.tempoRanges[trL - tr];
        var tempoIncrease = this.tempoIncreases[trL - tr + 1];

        if (t > tempoExtreme) {
          t -= tempoIncrease;
          t = tempoIncrease * Math.floor(t / tempoIncrease);
          break;
        }
      } // console.log(t);


      this.tempo = t;
    }

    return this.tempo;
  }
  /**
   * add a Metronome interface onto the DOM at where
   *
   * @param {jQuery|HTMLElement} [where]
   * @returns {jQuery} - a div holding the metronome.
   */


  addDiv(where) {
    /**
     * @type {jQuery}
     */
    var $where;

    if (where !== undefined && where instanceof jquery__WEBPACK_IMPORTED_MODULE_6__) {
      $where = where;
    } else if (where !== undefined && !(where instanceof jquery__WEBPACK_IMPORTED_MODULE_6__)) {
      $where = jquery__WEBPACK_IMPORTED_MODULE_6__(where);
    } else {
      $where = jquery__WEBPACK_IMPORTED_MODULE_6__('body');
    }

    var metroThis = this;
    /**
     *
     * @type {jQuery}
     */

    var $tempoHolder = jquery__WEBPACK_IMPORTED_MODULE_6__('<span class="tempoHolder">' + this.tempo.toString() + '</span>');
    $tempoHolder.css({
      'font-size': '24px',
      'padding-left': '10px',
      'padding-right': '10px'
    });
    /**
     *
     * @type {jQuery}
     */

    var $newDiv = jquery__WEBPACK_IMPORTED_MODULE_6__('<div class="metronomeRendered"></div>');
    $newDiv.append($tempoHolder);
    /**
     *
     * @type {jQuery}
     */

    var b1 = jquery__WEBPACK_IMPORTED_MODULE_6__('<button>start</button>');
    b1.on('click', () => {
      metroThis.chirp();
    });
    /**
     *
     * @type {jQuery}
     */

    var b2 = jquery__WEBPACK_IMPORTED_MODULE_6__('<button>stop</button>');
    b2.on('click', () => {
      metroThis.stopChirp();
    });
    $newDiv.prepend(b2);
    $newDiv.prepend(b1);
    /**
     *
     * @type {jQuery}
     */

    var b3 = jquery__WEBPACK_IMPORTED_MODULE_6__('<button>up</button>');
    b3.on('click', function increaseSpeedButton() {
      metroThis.increaseSpeed();
      jquery__WEBPACK_IMPORTED_MODULE_6__(this).prevAll('.tempoHolder').html(metroThis.tempo.toString());
    });
    /**
     *
     * @type {jQuery}
     */

    var b4 = jquery__WEBPACK_IMPORTED_MODULE_6__('<button>down</button>');
    b4.on('click', function decreaseSpeedButton() {
      metroThis.decreaseSpeed();
      jquery__WEBPACK_IMPORTED_MODULE_6__(this).prevAll('.tempoHolder').html(metroThis.tempo.toString());
    });
    $newDiv.append(b3);
    $newDiv.append(b4);
    /**
     *
     * @type {jQuery}
     */

    var $flash = jquery__WEBPACK_IMPORTED_MODULE_6__('<span class="metroFlash">' + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>');
    $flash.css('margin-left', '40px');
    $flash.css('height', '40px');
    $newDiv.append($flash);
    $where.append($newDiv);
    this.$metronomeDiv = $newDiv;
    return $newDiv;
  }

}

class TempoText {
  constructor() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    this.text = text;
  }

}
/**
 *
 * @class MetronomeMark
 * @memberof music21.tempo
 * @extends base.Music21Object
 * @param {Object} metronome - metronome
 * @param {string} metronome.text - tempo text
 * @param {number} metronome.number - beats per minute
 * @param {number|music21.duration.Duration} metronome.referent - duration value of tempo
 * @param {boolean} metronome.parentheses - ???
 * @property {string} text - tempo text
 * @property {number} number - beats per minute
 * @property {music21.duration.Duration} referent - duration value of tempo
 */


class MetronomeMark extends _base__WEBPACK_IMPORTED_MODULE_9__["Music21Object"] {
  constructor() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$text = _ref.text,
        text = _ref$text === void 0 ? undefined : _ref$text,
        _ref$number = _ref.number,
        number = _ref$number === void 0 ? undefined : _ref$number,
        _ref$referent = _ref.referent,
        referent = _ref$referent === void 0 ? undefined : _ref$referent,
        _ref$parentheses = _ref.parentheses,
        parentheses = _ref$parentheses === void 0 ? false : _ref$parentheses;

    super();
    this.parentheses = false;
    this._number = number;

    if (this._number !== undefined) {
      this.numberImplicit = false;
    }

    this._tempoText = undefined;
    this.textImplicit = undefined;
    this.text = text;
    this._referent = undefined;
    this.referent = referent;
    this.parentheses = parentheses;

    this._updateNumberFromText();

    this._updateTextFromNumber();
  }

  static get className() {
    return 'music21.tempo.MetronomeMark';
  }

  _updateNumberFromText() {
    if (this._number === undefined && this._tempoText !== undefined) {
      this._number = this._getDefaultNumber(this._tempoText);

      if (this._number !== undefined) {
        this.numberImplicit = true;
      }
    }
  }

  _updateTextFromNumber() {
    if (this._tempoText === undefined && this._number !== undefined) {
      this.text = this._getDefaultText(this._number);

      if (this.text !== undefined) {
        this.textImplicit = true;
      }
    }
  } // sigh, again the TypeScript limitation...


  get text() {
    if (this._tempoText === undefined) {
      return undefined;
    }

    return this._tempoText.text;
  }

  set text(value) {
    if (value === undefined) {
      this._tempoText = undefined;
    } else if (value instanceof TempoText) {
      this._tempoText = value;
      this.textImplicit = false;
    } else {
      this._tempoText = new TempoText(value); // if (this.hasStyleInformation) { // TODO: where is this?
      //     this._tempoText.style = this.style;
      // } else {
      //     this.style = this._tempoText.style;
      // }

      this.textImplicit = false;
    }
  }

  get number() {
    return this._number;
  }

  set number(value) {
    if (typeof value !== 'number') {
      throw new TempoException('cannot set number to a string');
    }

    this._number = value;
    this.numberImplicit = false;
  }

  get referent() {
    return this._referent;
  }

  set referent(value) {
    if (value === undefined) {
      this._referent = new _duration__WEBPACK_IMPORTED_MODULE_10__["Duration"](1);
    } else if (['number', 'string'].includes(typeof value)) {
      this._referent = new _duration__WEBPACK_IMPORTED_MODULE_10__["Duration"](value);
    } else if (value.classes.includes('Duration')) {
      this._referent = value;
    } else if (value.duration) {
      this._referent = value.duration;
    } else {
      throw new TempoException("Cannot get a Duration from the supplied object: ".concat(value));
    }
  }

  _getDefaultNumber(tempoText) {
    var tempoStr = tempoText instanceof TempoText ? tempoText.text : tempoText;
    var post;
    var tempoNames = Object.keys(defaultTempoValues);

    if (tempoNames.includes(tempoStr.toLowerCase())) {
      post = defaultTempoValues[tempoStr.toLowerCase()];
    } else if (tempoNames.includes(tempoStr)) {
      post = defaultTempoValues[tempoStr];
    } else {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tempoStr.split(' ')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var word = _step.value;

          if (tempoNames.includes(word.toLowerCase())) {
            post = defaultTempoValues[tempoStr.toLowerCase()];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    return post;
  }

  _getDefaultText(number) {
    var spread = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var tempoNumber = typeof number === 'number' ? number : parseFloat(number);
    return Object.keys(defaultTempoValues).find(tempoName => {
      var tempoValue = defaultTempoValues[tempoName];
      return tempoValue - spread <= tempoNumber && tempoValue + spread >= tempoNumber;
    });
  }

}

/***/ }),

/***/ "./src/music21/tie.ts":
/*!****************************!*\
  !*** ./src/music21/tie.ts ***!
  \****************************/
/*! exports provided: Tie */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tie", function() { return Tie; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _prebase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./prebase */ "./src/music21/prebase.ts");
/* harmony import */ var _exceptions21__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./exceptions21 */ "./src/music21/exceptions21.ts");


/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/tie -- ties!
 *
 * Copyright (c) 2013-17, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–17, Michael Scott Cuthbert and cuthbertLab
 *
 */


/**
 * Simple tie module {@link music21.tie} namespace
 *
 * @exports music21/tie
 */

/**
 * Tie namespace, just has the {@link music21.tie.Tie} object
 *
 * @namespace music21.tie
 * @memberof music21
 * @requires music21/prebase
 */

var VALID_TIE_TYPES = ['start', 'stop', 'continue', 'let-ring', 'continue-let-ring'];
/**
 * Tie class. Found in {@link music21.note.GeneralNote} `.tie`.
 *
 * Does not support advanced music21p values `.to` and `.from`
 *
 * @class Tie
 * @memberof music21.tie
 * @extends music21.prebase.ProtoM21Object
 * @param {string} type - 'start', 'stop', 'continue', or 'let-ring'
 * @property {string} type - the tie type
 * @property {string} style - only supports 'normal' for now.
 * @property {string|undefined} placement - undefined = unknown or above/below.
 * (NB currently does nothing)
 */

class Tie extends _prebase__WEBPACK_IMPORTED_MODULE_1__["ProtoM21Object"] {
  constructor() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'start';
    super();
    this.style = 'normal';
    this.type = type;
  }

  static get className() {
    return 'music21.tie.Tie';
  }

  stringInfo() {
    return this.type;
  }

  get type() {
    return this._type;
  }

  set type(newType) {
    if (!VALID_TIE_TYPES.includes(newType)) {
      throw new _exceptions21__WEBPACK_IMPORTED_MODULE_2__["Music21Exception"]("Type must be one of ".concat(VALID_TIE_TYPES, ", not ").concat(newType));
    }

    this._type = newType;
  }

}

/***/ }),

/***/ "./src/music21/tinyNotation.ts":
/*!*************************************!*\
  !*** ./src/music21/tinyNotation.ts ***!
  \*************************************/
/*! exports provided: TinyNotation, renderNotationDivs */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TinyNotation", function() { return TinyNotation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNotationDivs", function() { return renderNotationDivs; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _clef__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./clef */ "./src/music21/clef.ts");
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./duration */ "./src/music21/duration.ts");
/* harmony import */ var _pitch__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./pitch */ "./src/music21/pitch.ts");
/* harmony import */ var _note__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./note */ "./src/music21/note.ts");
/* harmony import */ var _meter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./meter */ "./src/music21/meter.ts");
/* harmony import */ var _stream__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./stream */ "./src/music21/stream.ts");
/* harmony import */ var _tie__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./tie */ "./src/music21/tie.ts");








function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/tinyNotation -- TinyNotation implementation
 *
 * Copyright (c) 2013-17, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–17, Michael Scott Cuthbert and cuthbertLab
 *
 * TinyNotation module
 *
 * @exports music21.tinyNotation
 * @memberof music21
 * @requires music21/base
 * @requires music21/clef
 * @requires music21/duration
 * @requires music21/pitch
 * @requires music21/note
 * @requires music21/meter
 * @requires music21/stream
 * @requires music21/tie
 */








/**
 * Regular expressions object
 *
 * @memberof music21.tinyNotation
 */

var regularExpressions = {
  REST: /r/,
  OCTAVE2: /([A-G])[A-G]+/,
  OCTAVE3: /([A-G])/,
  OCTAVE5: /([a-g])('+)/,
  OCTAVE4: /([a-g])/,
  EDSHARP: /\((#+)\)/,
  EDFLAT: /\((-+)\)/,
  EDNAT: /\(n\)/,
  SHARP: /^[A-Ga-g]+'*(#+)/,
  FLAT: /^[A-Ga-g]+'*(-+)/,
  NAT: /^[A-Ga-g]+'*n/,
  TYPE: /(\d+)/,
  TIE: /.~/,
  PRECTIE: /~/,
  ID_EL: /=([A-Za-z0-9]*)/,
  LYRIC: /_(.*)/,
  DOT: /\.+/,
  TIMESIG: /(\d+)\/(\d+)/,
  PARTBREAK: /partBreak/,
  TRIP: /trip{/,
  QUAD: /quad{/,
  ENDBRAC: /}$/
};
/**
 * **Function, not class**.
 *
 * Converts a TinyNotation String into a music21 Stream
 *
 * See music21p for examples of what can go into tinyNotation. It's an
 * adaptation of Lilypond format, by design Extremely simple!
 *
 * @memberof music21.tinyNotation
 * @param {string} textIn - a valid tinyNotation string
 * @returns {music21.stream.Part|music21.stream.Measure} - a Stream or Part object (if multiple measures)
 * @example
 * var t = "3/4 c4 B8 c d4 e2.";
 * var p = music21.tinyNotation.TinyNotation(t);
 * p.duration.quarterLength;
 * // 6.0
 */

function TinyNotation(textIn) {
  textIn = textIn.trim();
  var tokens = textIn.split(' ');
  var optionalScore;
  var p = new _stream__WEBPACK_IMPORTED_MODULE_13__["Part"]();
  var m = new _stream__WEBPACK_IMPORTED_MODULE_13__["Measure"]();
  m.number = 1;
  var currentTSBarDuration = 4.0;
  var lastDurationQL = 1.0;
  var storedDict = {
    lastNoteTied: false,
    inTrip: false,
    inQuad: false,
    endTupletAfterNote: false
  };
  var tnre = regularExpressions; // faster typing

  var measureNumber = 1;

  for (var i = 0; i < tokens.length; i++) {
    // check at first so that a full measure but not over full
    // gets returned as a stream.Measure object.
    if (m.duration.quarterLength >= currentTSBarDuration || Math.abs(m.duration.quarterLength - currentTSBarDuration) < 0.0001) {
      p.append(m);
      measureNumber += 1;
      m = new _stream__WEBPACK_IMPORTED_MODULE_13__["Measure"]();
      m.number = measureNumber;
    }

    var token = tokens[i];
    /**
     * @type {music21.note.GeneralNote|undefined}
     */

    var noteObj = void 0;
    var lyric = void 0;

    if (tnre.PARTBREAK.exec(token)) {
      if (m.length > 0) {
        p.append(m);
        m = new _stream__WEBPACK_IMPORTED_MODULE_13__["Measure"]();
      }

      if (optionalScore === undefined) {
        optionalScore = new _stream__WEBPACK_IMPORTED_MODULE_13__["Score"]();
      }

      optionalScore.insert(0, p);
      p = new _stream__WEBPACK_IMPORTED_MODULE_13__["Part"]();
      storedDict.lastNoteTied = false;
      storedDict.inTrip = false;
      storedDict.inQuad = false;
      storedDict.endTupletAfterNote = false;
      continue;
    }

    if (tnre.TRIP.exec(token)) {
      token = token.slice(5); // cut...

      storedDict.inTrip = true;
    }

    if (tnre.QUAD.exec(token)) {
      token = token.slice(5); // cut...

      storedDict.inQuad = true;
    }

    if (tnre.ENDBRAC.exec(token)) {
      token = token.slice(0, -1); // cut...

      storedDict.endTupletAfterNote = true;
    } // Modifiers


    if (tnre.LYRIC.exec(token)) {
      var _token$split = token.split('_');

      var _token$split2 = _slicedToArray(_token$split, 2);

      token = _token$split2[0];
      lyric = _token$split2[1];
    }

    if (tnre.TIMESIG.exec(token)) {
      var _MATCH = tnre.TIMESIG.exec(token);

      var ts = new _meter__WEBPACK_IMPORTED_MODULE_12__["TimeSignature"]();
      ts.numerator = parseInt(_MATCH[1]);
      ts.denominator = parseInt(_MATCH[2]);
      m.timeSignature = ts;
      currentTSBarDuration = ts.barDuration.quarterLength; // console.log(currentTSBarDuration);

      continue;
    } else if (tnre.REST.exec(token)) {
      noteObj = new _note__WEBPACK_IMPORTED_MODULE_11__["Rest"](lastDurationQL);
    } else if (tnre.OCTAVE2.exec(token)) {
      var _MATCH2 = tnre.OCTAVE2.exec(token);

      noteObj = new _note__WEBPACK_IMPORTED_MODULE_11__["Note"](_MATCH2[1], lastDurationQL);
      noteObj.pitch.octave = 4 - _MATCH2[0].length;
    } else if (tnre.OCTAVE3.exec(token)) {
      var _MATCH3 = tnre.OCTAVE3.exec(token);

      noteObj = new _note__WEBPACK_IMPORTED_MODULE_11__["Note"](_MATCH3[1], lastDurationQL);
      noteObj.pitch.octave = 3;
    } else if (tnre.OCTAVE5.exec(token)) {
      // must match octave 5 before 4
      var _MATCH4 = tnre.OCTAVE5.exec(token);

      noteObj = new _note__WEBPACK_IMPORTED_MODULE_11__["Note"](_MATCH4[1].toUpperCase(), lastDurationQL);
      noteObj.pitch.octave = 3 + _MATCH4[0].length;
    } else if (tnre.OCTAVE4.exec(token)) {
      var _MATCH5 = tnre.OCTAVE4.exec(token);

      noteObj = new _note__WEBPACK_IMPORTED_MODULE_11__["Note"](_MATCH5[1].toUpperCase(), lastDurationQL);
      noteObj.pitch.octave = 4;
    }

    if (noteObj === undefined) {
      continue;
    }

    if (lyric !== undefined) {
      noteObj.lyric = lyric;
    }

    if (tnre.TIE.exec(token)) {
      noteObj.tie = new _tie__WEBPACK_IMPORTED_MODULE_14__["Tie"]('start');

      if (storedDict.lastNoteTied) {
        noteObj.tie.type = 'continue';
      }

      storedDict.lastNoteTied = true;
    } else if (storedDict.lastNoteTied) {
      noteObj.tie = new _tie__WEBPACK_IMPORTED_MODULE_14__["Tie"]('stop');
      storedDict.lastNoteTied = false;
    }

    if (tnre.SHARP.exec(token)) {
      var _MATCH6 = tnre.SHARP.exec(token); // sharp


      noteObj.pitch.accidental = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Accidental"](_MATCH6[1].length);
    } else if (tnre.FLAT.exec(token)) {
      var _MATCH7 = tnre.FLAT.exec(token); // sharp


      noteObj.pitch.accidental = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Accidental"](-1 * _MATCH7[1].length);
    } else if (tnre.NAT.exec(token)) {
      noteObj.pitch.accidental = new _pitch__WEBPACK_IMPORTED_MODULE_10__["Accidental"]('natural');
      noteObj.pitch.accidental.displayType = 'always';
    }

    var MATCH = tnre.TYPE.exec(token);

    if (MATCH) {
      var durationType = parseInt(MATCH[0]);
      noteObj.duration.quarterLength = 4.0 / durationType;
    }

    MATCH = tnre.DOT.exec(token);

    if (MATCH) {
      var numDots = MATCH[0].length;
      var multiplier = 1 + (1 - Math.pow(0.5, numDots));
      noteObj.duration.quarterLength *= multiplier;
    }

    lastDurationQL = noteObj.duration.quarterLength; // do before appending tuplets

    if (storedDict.inTrip) {
      // console.log(noteObj.duration.quarterLength);
      noteObj.duration.appendTuplet(new _duration__WEBPACK_IMPORTED_MODULE_9__["Tuplet"](3, 2, noteObj.duration.quarterLength));
    }

    if (storedDict.inQuad) {
      noteObj.duration.appendTuplet(new _duration__WEBPACK_IMPORTED_MODULE_9__["Tuplet"](4, 3, noteObj.duration.quarterLength));
    }

    if (storedDict.endTupletAfterNote) {
      storedDict.inTrip = false;
      storedDict.inQuad = false;
      storedDict.endTupletAfterNote = false;
    }

    m.append(noteObj);
  }

  if (m.length > 0) {
    p.append(m);
  }

  var returnObject;

  if (optionalScore !== undefined) {
    if (p.length > 0) {
      optionalScore.append(p);
    }

    for (var _i2 = 0; _i2 < optionalScore.parts.length; _i2++) {
      var innerPart = optionalScore.parts.get(_i2);
      var innerPartClef = _clef__WEBPACK_IMPORTED_MODULE_8__["bestClef"](innerPart);
      var innerMeasure = innerPart.getElementsByClass('Measure').get(0);

      if (innerMeasure !== undefined) {
        innerMeasure.insert(0, innerPartClef);
      }
    }

    returnObject = optionalScore;
  } else {
    var bestClef = _clef__WEBPACK_IMPORTED_MODULE_8__["bestClef"](p);
    p.getElementsByClass('Measure').get(0).insert(0, bestClef);
    returnObject = p;
  }

  return returnObject;
} // render notation divs in HTML

/**
 * Render all the TinyNotation classes in the DOM as notation
 *
 * Called automatically when music21 is loaded.
 *
 * @memberof music21.tinyNotation
 * @param {string} [classTypes='.music21.tinyNotation'] - a JQuery selector to find elements to replace.
 * @param {HTMLElement|jQuery} [selector]
 */

function renderNotationDivs() {
  var classTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.music21.tinyNotation';
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var $allRender;

  if (selector === undefined) {
    $allRender = jquery__WEBPACK_IMPORTED_MODULE_7__(classTypes);
  } else {
    /**
     * @type {jQuery}
     */
    var $selector;

    if (!(selector instanceof jquery__WEBPACK_IMPORTED_MODULE_7__)) {
      $selector = jquery__WEBPACK_IMPORTED_MODULE_7__(selector);
    } else {
      $selector = selector;
    }

    $allRender = $selector.find(classTypes);
  }

  for (var i = 0; i < $allRender.length; i++) {
    var thisTN = $allRender[i];
    var $thisTN = jquery__WEBPACK_IMPORTED_MODULE_7__(thisTN);
    var thisTNContents = void 0;

    if ($thisTN.attr('tinynotationcontents') !== undefined) {
      thisTNContents = $thisTN.attr('tinynotationcontents');
    } else if (thisTN.textContent !== undefined) {
      thisTNContents = thisTN.textContent;
      thisTNContents = thisTNContents.replace(/s+/g, ' '); // no line-breaks, etc.
    }

    if (String.prototype.trim !== undefined && thisTNContents !== undefined) {
      thisTNContents = thisTNContents.trim(); // remove leading, trailing whitespace
    }

    if (thisTNContents) {
      var st = TinyNotation(thisTNContents);

      if ($thisTN.hasClass('noPlayback')) {
        st.renderOptions.events.click = undefined;
      }

      var newSVG = st.createDOM();
      $thisTN.attr('tinynotationcontents', thisTNContents);
      $thisTN.empty();
      $thisTN.data('stream', st);
      $thisTN.append(newSVG); // console.log(thisTNContents);
    }
  }
}

/***/ }),

/***/ "./src/music21/vfShow.ts":
/*!*******************************!*\
  !*** ./src/music21/vfShow.ts ***!
  \*******************************/
/*! exports provided: RenderStack, Renderer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RenderStack", function() { return RenderStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Renderer", function() { return Renderer; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! vexflow */ "./node_modules/vexflow/releases/vexflow-debug.js");
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(vexflow__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./debug */ "./src/music21/debug.ts");
/* harmony import */ var _clef__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./clef */ "./src/music21/clef.ts");
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./duration */ "./src/music21/duration.ts");









function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/vfShow -- Vexflow integration
 *
 * Copyright (c) 2013-17, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–17, Michael Scott Cuthbert and cuthbertLab
 *
 * for rendering vexflow. Will eventually go to music21/converter/vexflow
 *
 * See {@link music21.vfShow} namespace for details
 *
 * @namespace music21.vfShow
 * @memberof music21
 * @requires music21.common
 * @requires vexflow
 * @exports music21.vfShow
 */






var _clefSingleton = new _clef__WEBPACK_IMPORTED_MODULE_11__["TrebleClef"]();
/**
 * Represents a stack of objects that need to be rendered together.
 *
 * An intermediary state for showing created by {@link music21.vfShow.Renderer}.
 *
 * @class RenderStack
 * @memberof music21.vfShow
 * @property {Stream[]} streams - {@link Stream} objects
 * associated with the voices
 * @property {Array<Vex.Flow.Voice>} voices - Vex.Flow.Voice objects
 * @property {Array} textVoices - Vex.Flow.Voice objects for the text.
 */


class RenderStack {
  constructor() {
    this.streams = [];
    this.voices = [];
    this.textVoices = [];
    this.voiceToStreamMapping = new Map();
  }
  /**
   * @returns {Array} this.voices and this.textVoices as one array
   */


  allTickables() {
    var t = [];
    t.push(...this.voices);
    t.push(...this.textVoices);
    return t;
  }
  /**
   * @returns {Array<Array>} each array represents one staff....
   * where this.voices and this.textVoices are all in that staff...
   */


  tickablesByStave() {
    var tickablesByStave = []; // a list of lists of tickables being placed on the same Stave.

    var knownStaves = []; // a list of Vex.Flow.Stave objects...

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.allTickables()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var t = _step.value;
        var thisStaveIndex = knownStaves.indexOf(t.stave);
        var currentStaveHolder = void 0;

        if (thisStaveIndex === -1) {
          knownStaves.push(t.stave);
          currentStaveHolder = [];
          tickablesByStave.push(currentStaveHolder);
        } else {
          currentStaveHolder = tickablesByStave[thisStaveIndex];
        }

        currentStaveHolder.push(t);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return tickablesByStave;
  }

}
/**
 * Renderer is a function that takes a stream, an
 * optional existing canvas or SVG element and a DOM
 * element where the canvas or SVG element should be placed
 * and renders the stream as Vexflow on the
 * canvas or svg element, placing it then in the where
 * DOM.
 *
 * "s" can be any type of Stream.
 *
 * "div" and "where" can be either a DOM
 * element or a jQuery object.
 *
 * @class Renderer
 * @memberof music21.vfShow
 * @param {Stream} s - main stream to render
 * @param {div} [div] - existing canvas or div-surroundingSVG element
 * @param {Node|jQuery} [where=document.body] - where to render the stream
 * @property {Vex.Flow.Renderer} vfRenderer - a Vex.Flow.Renderer to use
 * (will create if not existing)
 * @property {string} rendererType - canvas or svg
 * @property ctx - a Vex.Flow.SVGContext or Vex.Flow.CanvasContext to use.
 * @property {div} div - div-with-svg-or-canvas element
 * @property {jQuery} $div - jQuery div or canvas element
 * @property {jQuery} $where - jQuery element to render onto
 * @property {Vex.Flow.Formatter} activeFormatter - formatter
 * @property {Array<Vex.Flow.Beam>} beamGroups - beamGroups
 * @property {Array<Vex.Flow.StaveTie>} vfTies - ties as instances of Vex.Flow.StaveTie
 * @property {Array<number>} systemBreakOffsets - where to break the systems
 * @property {Array<Vex.Flow.Tuplet>} vfTuplets - tuplets represented in Vexflow
 * @property {Array<music21.vfShow.RenderStack>} stacks - array of RenderStack objects
 */

class Renderer {
  // measureFormatters = [];
  constructor(s) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var where = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    this.rendererType = 'svg';
    this.div = undefined;
    this.$div = undefined;
    this.$where = undefined;
    this.activeFormatter = undefined;
    this._vfRenderer = undefined;
    this._ctx = undefined;
    this.beamGroups = [];
    this.stacks = []; // an Array of RenderStacks: {voices: [Array of Vex.Flow.Voice objects],
    //                                           streams: [Array of Streams, usually Measures]}

    this.vfTies = [];
    this.systemBreakOffsets = [];
    this.vfTuplets = [];
    this.stream = s; // this.streamType = s.classes[-1];

    if (div !== undefined) {
      if (div.jquery !== undefined) {
        this.$div = div;
        this.div = div[0];
      } else {
        this.div = div;
        this.$div = jquery__WEBPACK_IMPORTED_MODULE_8__(div);
      }
    }

    if (where !== undefined) {
      if (where.jquery !== undefined) {
        this.$where = where;
      } else {
        this.$where = jquery__WEBPACK_IMPORTED_MODULE_8__(where);
      }
    }
  }

  get vfRenderer() {
    var backend;

    if (this.rendererType === 'canvas') {
      backend = vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Renderer.Backends.CANVAS;
    } else {
      backend = vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Renderer.Backends.SVG;
    }

    if (this._vfRenderer !== undefined) {
      return this._vfRenderer;
    } else {
      this._vfRenderer = new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Renderer(this.div, backend);

      if (this.rendererType === 'svg') {
        this._vfRenderer.resize(this.$div.attr('width'), this.$div.attr('height'));
      }

      return this._vfRenderer;
    }
  }

  set vfRenderer(vfr) {
    this._vfRenderer = vfr;
  }

  get ctx() {
    if (this._ctx !== undefined) {
      return this._ctx;
    } else {
      this._ctx = this.vfRenderer.getContext();

      if (this.stream && this.stream.renderOptions && this.stream.renderOptions.scaleFactor.x && this.stream.renderOptions.scaleFactor.y) {
        this._ctx.scale(this.stream.renderOptions.scaleFactor.x, this.stream.renderOptions.scaleFactor.y);
      }

      return this._ctx;
    }
  }

  set ctx(ctx) {
    this._ctx = ctx;
  }
  /**
   *
   * main function to render a Stream.
   *
   * if s is undefined, uses the stored Stream from
   * the constructor object.
   *
   * @param {Stream} [s=this.stream]
   */


  render() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    if (s === undefined) {
      s = this.stream;
    }

    var isScorelike = false;
    var isPartlike = false;
    var isFlat = s.isFlat;

    if (s.isClassOrSubclass('Score')) {
      isScorelike = true;
    } else if (!isFlat && !s.get(0).isFlat) {
      isScorelike = true;
    } else if (!isFlat) {
      isPartlike = true;
    } // requires organization Score -> Part -> Measure -> elements...


    if (isScorelike) {
      this.prepareScorelike(s);
    } else if (isPartlike) {
      this.preparePartlike(s);
    } else {
      this.prepareArrivedFlat(s);
    }

    this.formatMeasureStacks();
    this.drawTies();
    this.drawMeasureStacks();
    this.drawBeamGroups();
    this.drawTuplets();
  }
  /**
   * Prepares a scorelike stream (i.e., one with parts or
   * Streams that should be rendered vertically like parts)
   * for rendering and adds Staff Connectors
   *
   * @param {music21.stream.Score} s - prepare a stream of parts (i.e., Score)
   */


  prepareScorelike(s) {
    // console.log('prepareScorelike called');
    //
    var parts = s.parts;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = parts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var subStream = _step2.value;
        this.preparePartlike(subStream);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    this.addStaffConnectors(s);
  }
  /**
   *
   * Prepares a Partlike stream (that is one with Measures
   * or substreams that should be considered like Measures)
   * for rendering.
   *
   * @param {music21.stream.Part} p
   */


  preparePartlike(p) {
    // console.log('preparePartlike called');
    this.systemBreakOffsets = [];
    var measureList = p.measures;

    for (var i = 0; i < measureList.length; i++) {
      var subStream = measureList.get(i);

      if (subStream.renderOptions.startNewSystem) {
        this.systemBreakOffsets.push(subStream.offset);
      }

      if (i === p.length - 1) {
        subStream.renderOptions.rightBarline = 'end';
      }

      if (this.stacks[i] === undefined) {
        this.stacks[i] = new RenderStack();
      }

      this.prepareMeasure(subStream, this.stacks[i]);
    }

    this.prepareTies(p);
  }
  /**
   *
   * Prepares a score that arrived flat... sets up
   * stacks and vfTies after calling prepareFlat
   *
   * @param {Stream} m - a flat stream (maybe a measure or voice)
   */


  prepareArrivedFlat(m) {
    var stack = new RenderStack();
    this.prepareMeasure(m, stack);
    this.stacks[0] = stack;
    this.prepareTies(m);
  }
  /**
   *
   * Prepares a measure (w/ or w/o voices) or generic Stream -- makes accidentals,
   * associates a Vex.Flow.Stave with the stream and
   * returns a vexflow Voice object
   *
   * @param {music21.stream.Measure} m - a measure object (w or w/o voices)
   * @param {music21.vfShow.RenderStack} stack - a RenderStack object to prepare into.
   */


  prepareMeasure(m, stack) {
    if (m.hasVoices === undefined || m.hasVoices() === false) {
      this.prepareFlat(m, stack);
    } else {
      // get elements outside of voices;
      var firstVoiceCopy = m.getElementsByClass('Voice').get(0).clone(false);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = m.getElementsNotOfClass('Voice')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var el = _step3.value;
          firstVoiceCopy.insert(el.offset, el);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var rendOp = m.renderOptions; // get render options from Measure;

      var stave;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = Array.from(m.getElementsByClass('Voice')).entries()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              i = _step4$value[0],
              voiceStream = _step4$value[1];

          var voiceToRender = voiceStream;

          if (i === 0) {
            voiceToRender = firstVoiceCopy;
          } // noinspection JSUnusedAssignment


          stave = this.prepareFlat(voiceToRender, stack, stave, rendOp);

          if (i === 0) {
            voiceStream.activeVFStave = voiceToRender.activeVFStave;
            voiceStream.storedVexflowStave = voiceToRender.activeVFStave;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }

    return stack;
  }
  /**
   * Main internal routine to prepare a flat stream
   *
   * @param {Stream} s - a flat stream object
   * @param {music21.vfShow.RenderStack} stack - a RenderStack object to prepare into.
   * @param {Vex.Flow.Stave} [optionalStave] - an optional existing stave.
   * @param {Object} [optional_renderOp] - render options.
   * Passed to {@link music21.vfShow.Renderer#renderStave}
   * @returns {Vex.Flow.Stave} staff to return too
   * (also changes the `stack` parameter and runs `makeNotation` on s)
   */


  prepareFlat(s, stack) {
    var optionalStave = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var optional_renderOp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    s.makeNotation();
    var stave;

    if (optionalStave !== undefined) {
      stave = optionalStave;
    } else {
      stave = this.renderStave(s, optional_renderOp);
    }

    s.activeVFStave = stave;
    var vf_voice = this.getVoice(s, stave);
    stack.voices.push(vf_voice);
    stack.streams.push(s);
    stack.voiceToStreamMapping.set(vf_voice, s);

    if (s.hasLyrics()) {
      stack.textVoices.push(this.getLyricVoice(s, stave));
    }

    return stave;
  }
  /**
   * Render the Vex.Flow.Stave from a flat stream and draws it.
   *
   * Just draws the stave, not the notes, etc.
   *
   * @param {Stream} [m=this.stream] - a flat stream
   * @param {Object} [optional_rendOp] - render options, passed
   * to {@link music21.vfShow.Renderer#newStave} and {@link music21.vfShow.Renderer#setClefEtc}
   * @returns {Vex.Flow.Stave} stave
   */


  renderStave() {
    var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var optional_rendOp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    if (m === undefined) {
      m = this.stream;
    }

    var ctx = this.ctx; // stave will be passed in from Measure when we have Voices

    var stave = this.newStave(m, optional_rendOp);
    this.setClefEtc(m, stave, optional_rendOp);
    stave.setContext(ctx);
    stave.draw();
    return stave;
  }
  /**
   * Draws the Voices (music and text) from `this.stacks`
   *
   */


  drawMeasureStacks() {
    var ctx = this.ctx;

    for (var i = 0; i < this.stacks.length; i++) {
      var voices = this.stacks[i].allTickables();

      for (var j = 0; j < voices.length; j++) {
        var v = voices[j];
        v.draw(ctx);
      }
    }
  }
  /**
   * draws the tuplets.
   *
   */


  drawTuplets() {
    var ctx = this.ctx;
    this.vfTuplets.forEach(vft => {
      vft.setContext(ctx).draw();
    });
  }
  /**
   * draws the vfTies
   *
   */


  drawTies() {
    var ctx = this.ctx;

    for (var i = 0; i < this.vfTies.length; i++) {
      this.vfTies[i].setContext(ctx).draw();
    }
  }
  /**
   * Finds all tied notes and creates the proper Vex.Flow.StaveTie objects in
   * `this.vfTies`.
   *
   * @param {Stream} p - a Part or similar object
   */


  prepareTies(p) {
    var pf = Array.from(p.recurse().notesAndRests); // console.log('newSystemsAt', this.systemBreakOffsets);

    for (var i = 0; i < pf.length - 1; i++) {
      var thisNote = pf[i];

      if (thisNote.tie === undefined || thisNote.tie.type === 'stop') {
        continue;
      }

      var nextNote = pf[i + 1];
      var onSameSystem = true; // this.systemBreakOffsets.length will be 0 for a flat score

      for (var sbI = 0; sbI < this.systemBreakOffsets.length; sbI++) {
        var thisSystemBreak = this.systemBreakOffsets[sbI];

        if (thisNote.getOffsetInHierarchy(p) < thisSystemBreak && nextNote.getOffsetInHierarchy(p) >= thisSystemBreak) {
          onSameSystem = false;
          break;
        }
      }

      if (onSameSystem) {
        var vfTie = new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.StaveTie({
          first_note: thisNote.activeVexflowNote,
          last_note: nextNote.activeVexflowNote,
          first_indices: [0],
          last_indices: [0]
        });
        this.vfTies.push(vfTie);
      } else {
        // console.log('got me a tie across systemBreaks!');
        var vfTie1 = new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.StaveTie({
          first_note: thisNote.activeVexflowNote,
          first_indices: [0]
        });
        this.vfTies.push(vfTie1);
        var vfTie2 = new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.StaveTie({
          last_note: nextNote.activeVexflowNote,
          first_indices: [0]
        });
        this.vfTies.push(vfTie2);
      }
    }
  }
  /**
   * Returns a Vex.Flow.Voice object with all the tickables (i.e., Notes, Voices, etc.)
   *
   * Does not draw it...
   *
   * @param {Stream} [s=this.stream] -- usually a Measure or Voice
   * @param {Vex.Flow.Stave} stave - not optional (would never fly in Python...)
   * @returns {Vex.Flow.Voice}
   */


  getVoice() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var stave = arguments.length > 1 ? arguments[1] : undefined;

    if (s === undefined) {
      s = this.stream;
    } // gets a group of notes as a voice, but completely unformatted and not drawn.


    var notes = this.vexflowNotes(s, stave);
    var voice = this.vexflowVoice(s);
    voice.setStave(stave);
    voice.addTickables(notes);
    return voice;
  }
  /**
   * Returns a Vex.Flow.Voice with the lyrics set to render in the proper place.
   *
   * @param {Stream} s -- usually a Measure or Voice
   * @param {Vex.Flow.Stave} stave
   * @returns {Vex.Flow.Voice}
   */


  getLyricVoice(s, stave) {
    var textVoice = this.vexflowVoice(s);
    var lyrics = this.vexflowLyrics(s, stave);
    textVoice.setStave(stave);
    textVoice.addTickables(lyrics);
    return textVoice;
  }
  /**
   * Aligns all of `this.stacks` (after they've been prepared) so they align properly.
   *
   */


  formatMeasureStacks() {
    // adds formats the voices, then adds the formatter information to every note in a voice...
    for (var i = 0; i < this.stacks.length; i++) {
      var stack = this.stacks[i];
      var vf_voices = stack.voices;
      var measuresOrVoices = stack.streams;
      var formatter = this.formatVoiceGroup(stack);

      for (var j = 0; j < measuresOrVoices.length; j++) {
        var m = measuresOrVoices[j];
        var v = vf_voices[j];
        this.applyFormatterInformationToNotes(v.stave, m, formatter);
      }
    }
  }
  /**
   * Formats a single voice group from a stack.
   *
   * @param {music21.vfShow.RenderStack} stack
   * @param {boolean} [autoBeam=measures[0].autoBeam]
   * @returns {Vex.Flow.Formatter}
   */


  formatVoiceGroup(stack) {
    var autoBeam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    // formats a group of voices to use the same formatter; returns the formatter
    // if autoBeam is true then it will apply beams for each voice and put them in
    // this.beamGroups;
    var allTickables = stack.allTickables();
    var vf_voices = stack.voices;
    var measuresOrVoices = stack.streams;

    if (autoBeam === undefined) {
      autoBeam = measuresOrVoices[0].autoBeam;
    }

    var formatter = new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Formatter(); // var minLength = formatter.preCalculateMinTotalWidth([voices]);
    // console.log(minLength);

    if (vf_voices.length === 0) {
      return formatter;
    }

    var maxGlyphStart = 0; // find the stave with the farthest start point -- diff key sig, etc.

    for (var i = 0; i < allTickables.length; i++) {
      // console.log(voices[i], voices[i].stave, i);
      if (allTickables[i].stave.getNoteStartX() > maxGlyphStart) {
        maxGlyphStart = allTickables[i].stave.getNoteStartX();
      }
    }

    for (var _i2 = 0; _i2 < allTickables.length; _i2++) {
      allTickables[_i2].stave.setNoteStartX(maxGlyphStart); // corrected!

    } // TODO: should do the same for end_x -- for key sig changes, etc...


    var stave = vf_voices[0].stave; // all staves should be same length, so does not matter;

    var tickablesByStave = stack.tickablesByStave();
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = tickablesByStave[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var staveTickables = _step5.value;
        formatter.joinVoices(staveTickables);
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    formatter.formatToStave(allTickables, stave); // const vf_auto_stem = false;
    // for (const voice of voices) {
    //     let activeBeamGroupNotes = [];
    //     for (let j = 0; j < voice.notes.length; j++) {
    //         const n = voice.notes[j];
    //         if (n.beams === undefined || !n.beams.getNumbers().includes(1)) {
    //             continue;
    //         }
    //         const eighthNoteBeam = n.beams.getByNumber(1);
    //         if (eighthNoteBeam.type === 'start') {
    //             activeBeamGroupNotes = [n];
    //         } else {
    //             activeBeamGroupNotes.push(n);
    //         }
    //         if (eighthNoteBeam.type === 'stop') {
    //             const vfBeam = new Vex.Flow.Beam(activeBeamGroupNotes, vf_auto_stem);
    //             this.beamGroups.push(vfBeam);
    //             activeBeamGroupNotes = []; // housekeeping, not really necessary...
    //         }
    //     }
    // }

    if (autoBeam) {
      for (var _i3 = 0; _i3 < vf_voices.length; _i3++) {
        // find beam groups -- n.b. this wipes out stemDirection. worth it usually...
        var vf_voice = vf_voices[_i3];
        var associatedStream = stack.voiceToStreamMapping.get(vf_voice);
        var beatGroups = void 0;

        if (associatedStream !== undefined && associatedStream.getSpecialContext('timeSignature') !== undefined) {
          beatGroups = associatedStream.getSpecialContext('timeSignature').vexflowBeatGroups(); // TODO: getContextByClass...
          // console.log(beatGroups);
        } else {
          beatGroups = [new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Fraction(2, 8)]; // default beam groups
        }

        var beamGroups = vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Beam.applyAndGetBeams(vf_voice, undefined, beatGroups);
        this.beamGroups.push(...beamGroups);
      }
    }

    return formatter;
  }
  /**
   * Draws the beam groups.
   *
   */


  drawBeamGroups() {
    var ctx = this.ctx;

    for (var i = 0; i < this.beamGroups.length; i++) {
      this.beamGroups[i].setContext(ctx).draw();
    }
  }
  /**
   * Return a new Vex.Flow.Stave object, which represents
   * a single MEASURE of notation in m21j
   *
   * @param {Stream} s
   * @param {Object} [rendOp]
   * @returns {Vex.Flow.Stave}
   */


  newStave(s, rendOp) {
    if (s === undefined) {
      s = this.stream;
    }

    if (rendOp === undefined) {
      rendOp = s.renderOptions;
    } // measure level...


    var width = rendOp.width;

    if (width === undefined) {
      width = s.estimateStaffLength() + rendOp.staffPadding;
    }

    var top = rendOp.top; // * rendOp.scaleFactor.y;

    if (top === undefined) {
      top = 0;
    }

    var left = rendOp.left;

    if (left === undefined) {
      left = 10;
    } // console.log('streamLength: ' + streamLength);


    if (_debug__WEBPACK_IMPORTED_MODULE_10__["debug"]) {
      console.log('creating new stave: left:' + left + ' top: ' + top + ' width: ' + width);
    }

    var stave = new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Stave(left, top, width);
    return stave;
  }
  /**
   * Sets the number of stafflines, puts the clef on the Stave,
   * adds keySignature, timeSignature, and rightBarline
   *
   * @param {Stream} s
   * @param {Vex.Flow.Stave} stave
   * @param {Object} [rendOp=s.renderOptions] - a {@link music21.renderOptions.RenderOptions}
   * object that might have
   * `{showMeasureNumber: boolean, rightBarLine: string<{'single', 'double', 'end'}>}`
   */


  setClefEtc(s, stave, rendOp) {
    if (rendOp === undefined) {
      rendOp = s.renderOptions;
    }

    var sClef = s.getSpecialContext('clef') || s.getContextByClass('Clef'); // this should not be necessary now that derivation is
    // checked, but does not hurt.

    if (sClef === undefined && s.length) {
      // the clef context might be from something else in the stream...
      var firstEl = s.get(0);
      sClef = firstEl.getContextByClass('Clef');
    } // last resort


    sClef = sClef || _clefSingleton;
    this.setStafflines(s, stave);

    if (rendOp.showMeasureNumber) {
      stave.setMeasure(rendOp.measureIndex + 1);
    }

    if (rendOp.displayClef) {
      var ottava;
      var size = 'default';

      if (sClef.octaveChange === 1) {
        ottava = '8va';
      } else if (sClef.octaveChange === -1) {
        ottava = '8vb';
      }

      stave.addClef(sClef.name, size, ottava);
    }

    var context_ks = s.getSpecialContext('keySignature') || s.getContextByClass('KeySignature');

    if (context_ks !== undefined && rendOp.displayKeySignature) {
      var ksVFName = context_ks.majorName().replace(/-/g, 'b');
      stave.addKeySignature(ksVFName);
    }

    var context_ts = s.getSpecialContext('timeSignature') || s.getContextByClass('TimeSignature');

    if (context_ts !== undefined && rendOp.displayTimeSignature) {
      stave.addTimeSignature(context_ts.numerator.toString() + '/' + context_ts.denominator.toString());
    }

    if (rendOp.rightBarline !== undefined) {
      var bl = rendOp.rightBarline;
      var barlineMap = {
        single: 'SINGLE',
        double: 'DOUBLE',
        end: 'END'
      };
      var vxBL = barlineMap[bl];

      if (vxBL !== undefined) {
        stave.setEndBarType(vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Barline.type[vxBL]);
      }
    }
  }
  /**
   * Sets the number of stafflines properly for the Stave object.
   *
   * This method does not just set Vex.Flow.Stave#setNumLines() except
   * if the number of lines is 0 or >=4, because the default in VexFlow is
   * to show the bottom(top?), not middle, lines and that looks bad.
   *
   * @param {Stream} s - stream to get the `.staffLines`
   * from `s.renderOptions` from -- should allow for overriding.
   * @param {Vex.Flow.Stave} vexflowStave - stave to set the staff lines for.
   */


  setStafflines(s, vexflowStave) {
    var rendOp = s.renderOptions;

    if (rendOp.staffLines !== 5) {
      if (rendOp.staffLines === 0) {
        vexflowStave.setNumLines(0);
      } else if (rendOp.staffLines === 1) {
        // Vex.Flow.Stave.setNumLines hides all but the top line.
        // this is better
        vexflowStave.options.line_config = [{
          visible: false
        }, {
          visible: false
        }, {
          visible: true
        }, {
          visible: false
        }, {
          visible: false
        }];
      } else if (rendOp.staffLines === 2) {
        vexflowStave.options.line_config = [{
          visible: false
        }, {
          visible: false
        }, {
          visible: true
        }, {
          visible: true
        }, {
          visible: false
        }];
      } else if (rendOp.staffLines === 3) {
        vexflowStave.options.line_config = [{
          visible: false
        }, {
          visible: true
        }, {
          visible: true
        }, {
          visible: true
        }, {
          visible: false
        }];
      } else {
        vexflowStave.setNumLines(rendOp.staffLines);
      }
    }
  }
  /**
   * Gets the Vex.Flow.StaveNote objects from a Stream.
   *
   * Also changes `this.vfTuplets`.
   *
   * @param {Stream} [s=this.stream] - flat stream to find notes in
   * @param {Vex.Flow.Stave} stave - Vex.Flow.Stave to render notes on to.
   * @returns {Array<Vex.Flow.StaveNote>} notes to return
   */


  vexflowNotes(s, stave) {
    if (s === undefined) {
      s = this.stream;
    } // runs on a flat stream, returns a list of voices...


    var notes = [];
    var vfTuplets = [];
    var activeTuplet;
    var activeTupletLength = 0.0;
    var activeTupletVexflowNotes = [];
    var sClef = s.getSpecialContext('clef') || s.getContextByClass('Clef');

    if (sClef === undefined && s.length) {
      // TODO: follow Derivation...
      var firstEl = s.get(0);
      sClef = firstEl.getContextByClass('Clef');
    }

    if (sClef === undefined) {
      sClef = _clefSingleton;
    }

    var options = {
      clef: sClef,
      stave
    };
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = s[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var thisEl = _step6.value;

        if (thisEl.isClassOrSubclass('GeneralNote') && thisEl.duration !== undefined) {
          // sets thisEl.activeVexflowNote -- may be overwritten but not so fast...
          var vfn = thisEl.vexflowNote(options);

          if (vfn === undefined) {
            console.error('Cannot create a vexflowNote from: ', thisEl);
            continue;
          }

          if (stave !== undefined) {
            // noinspection TypeScriptValidateJSTypes
            vfn.setStave(stave);
          }

          notes.push(vfn); // account for tuplets...

          if (thisEl.duration.tuplets.length > 0) {
            // only support one tuplet per note -- like vexflow
            if (activeTuplet === undefined) {
              activeTuplet = thisEl.duration.tuplets[0];
            }

            activeTupletVexflowNotes.push(vfn);
            activeTupletLength += thisEl.duration.quarterLength; // console.log(activeTupletLength, activeTuplet.totalTupletLength());
            //
            // Add tuplet when complete.

            if (activeTupletLength >= activeTuplet.totalTupletLength() || Math.abs(activeTupletLength - activeTuplet.totalTupletLength()) < 0.001) {
              // console.log(activeTupletVexflowNotes);
              var tupletOptions = {
                num_notes: activeTuplet.numberNotesActual,
                notes_occupied: activeTuplet.numberNotesNormal
              }; // console.log('tupletOptions', tupletOptions);

              var vfTuplet = new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Tuplet(activeTupletVexflowNotes, tupletOptions);

              if (activeTuplet.tupletNormalShow === 'ratio') {
                vfTuplet.setRatioed(true);
              }

              vfTuplets.push(vfTuplet);
              activeTupletLength = 0.0;
              activeTuplet = undefined;
              activeTupletVexflowNotes = [];
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    if (activeTuplet !== undefined) {
      console.warn('incomplete tuplet found in stream: ', s);
    }

    if (vfTuplets.length > 0) {
      this.vfTuplets.push(...vfTuplets);
    }

    return notes;
  }
  /**
   * Gets an Array of `Vex.Flow.TextNote` objects from any lyrics found in s
   *
   * @param {Stream} s - flat stream to search.
   * @param {Vex.Flow.Stave} stave
   * @returns {Array<Vex.Flow.TextNote>}
   */


  vexflowLyrics(s, stave) {
    var getTextNote = function getTextNote(text, font, d) {
      var lyricObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      // console.log(text, font, d);
      // noinspection TypeScriptValidateJSTypes
      var t1 = new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.TextNote({
        text,
        font,
        duration: d.vexflowDuration
      }).setLine(11).setStave(stave).setJustification(vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.TextNote.Justification.LEFT);

      if (lyricObj) {
        t1.setStyle(lyricObj.style);
      }

      if (d.tuplets.length > 0) {
        t1.applyTickMultiplier(d.tuplets[0].numberNotesNormal, d.tuplets[0].numberNotesActual);
      }

      return t1;
    };

    if (s === undefined) {
      s = this.stream;
    } // runs on a flat, gapless, no-overlap stream, returns a list of TextNote objects...


    var lyricsObjects = [];
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = s[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var el = _step7.value;
        var lyricsArray = el.lyrics;

        if (lyricsArray === undefined) {
          continue;
        }

        var text = void 0;
        var d = el.duration;
        var addConnector = false;
        var firstLyric = void 0;
        var font = {
          family: 'Serif',
          size: 12,
          weight: ''
        };

        if (lyricsArray.length === 0) {
          text = '';
        } else {
          firstLyric = lyricsArray[0];
          text = firstLyric.text;

          if (text === undefined) {
            text = '';
          }

          if (firstLyric.syllabic === 'middle' || firstLyric.syllabic === 'begin') {
            addConnector = ' ' + firstLyric.lyricConnector;
            var tempQl = el.duration.quarterLength / 2.0;
            d = new _duration__WEBPACK_IMPORTED_MODULE_12__["Duration"](tempQl);
          }

          if (firstLyric.style.fontFamily) {
            font.family = firstLyric.style.fontFamily;
          }

          if (firstLyric.style.fontSize) {
            font.size = firstLyric.style.fontSize;
          }

          if (firstLyric.style.fontWeight) {
            font.weight = firstLyric.style.fontWeight;
          }
        }

        var t1 = getTextNote(text, font, d, firstLyric);
        lyricsObjects.push(t1);

        if (addConnector !== false) {
          var connector = getTextNote(addConnector, font, d);
          lyricsObjects.push(connector);
        }
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    return lyricsObjects;
  }
  /**
   * Creates a Vex.Flow.Voice of the appropriate length given a Stream.
   */


  vexflowVoice(s) {
    var totalLength = s.duration.quarterLength;
    var num1024 = Math.round(totalLength / (1 / 256));
    var beatValue = 1024;

    if (num1024 % 512 === 0) {
      beatValue = 2;
      num1024 /= 512;
    } else if (num1024 % 256 === 0) {
      beatValue = 4;
      num1024 /= 256;
    } else if (num1024 % 128 === 0) {
      beatValue = 8;
      num1024 /= 128;
    } else if (num1024 % 64 === 0) {
      beatValue = 16;
      num1024 /= 64;
    } else if (num1024 % 32 === 0) {
      beatValue = 32;
      num1024 /= 32;
    } else if (num1024 % 16 === 0) {
      beatValue = 64;
      num1024 /= 16;
    } else if (num1024 % 8 === 0) {
      beatValue = 128;
      num1024 /= 8;
    } else if (num1024 % 4 === 0) {
      beatValue = 256;
      num1024 /= 4;
    } else if (num1024 % 2 === 0) {
      beatValue = 512;
      num1024 /= 2;
    } // console.log('creating voice');


    if (_debug__WEBPACK_IMPORTED_MODULE_10__["debug"]) {
      console.log('New voice, num_beats: ' + num1024.toString() + ' beat_value: ' + beatValue.toString());
    }

    var vfv = new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Voice({
      num_beats: num1024,
      beat_value: beatValue,
      resolution: vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.RESOLUTION
    }); // from vexflow/src/voice.js
    //
    // Modes allow the addition of ticks in three different ways:
    //
    // STRICT: This is the default. Ticks must fill the voice.
    // SOFT:   Ticks can be added without restrictions.
    // FULL:   Ticks do not need to fill the voice, but can't exceed the maximum
    //         tick length.
    // noinspection TypeScriptValidateJSTypes

    vfv.setMode(vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.Voice.Mode.SOFT);
    return vfv;
  }

  staffConnectorsMap(connectorType) {
    var connectorMap = {
      brace: vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.StaveConnector.type.BRACE,
      single: vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.StaveConnector.type.SINGLE,
      double: vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.StaveConnector.type.DOUBLE,
      bracket: vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.StaveConnector.type.BRACKET
    };
    return connectorMap[connectorType];
  }
  /**
   * If a stream has parts (NOT CHECKED HERE) create and
   * draw an appropriate Vex.Flow.StaveConnector
   *
   * @param {music21.stream.Score} s
   */


  addStaffConnectors(s) {
    if (s === undefined) {
      s = this.stream;
    }

    var parts = s.parts;
    var numParts = parts.length;

    if (numParts < 2) {
      return;
    }

    var firstPart = parts.get(0);
    var lastPart = parts.get(-1);
    var firstPartMeasures = firstPart.measures;
    var lastPartMeasures = lastPart.measures;
    var numMeasures = firstPartMeasures.length;

    for (var mIndex = 0; mIndex < numMeasures; mIndex++) {
      var thisPartMeasure = firstPartMeasures.get(mIndex);
      var lastPartMeasure = lastPartMeasures.get(mIndex); // only needed once per system but
      // good for symmetry.

      if (thisPartMeasure.renderOptions.startNewSystem) {
        var topVFStaff = thisPartMeasure.activeVFStave;
        var bottomVFStaff = lastPartMeasure.activeVFStave;

        if (topVFStaff === undefined) {
          if (!thisPartMeasure.isFlat) {
            var thisPartVoice = thisPartMeasure.getElementsByClass('Stream').get(0);
            topVFStaff = thisPartVoice.activeVFStave;

            if (topVFStaff === undefined) {
              console.warn('No active VexFlow Staves defined for at least one measure');
              continue;
            }
          }
        }

        if (bottomVFStaff === undefined) {
          if (!lastPartMeasure.isFlat) {
            var lastPartVoice = lastPartMeasure.getElementsByClass('Stream').get(0);
            bottomVFStaff = lastPartVoice.activeVFStave;

            if (bottomVFStaff === undefined) {
              console.warn('No active VexFlow Staves defined for at least one measure');
              continue;
            }
          }
        }

        for (var i = 0; i < s.renderOptions.staffConnectors.length; i++) {
          var sc = new vexflow__WEBPACK_IMPORTED_MODULE_9___default.a.Flow.StaveConnector(topVFStaff, bottomVFStaff);
          var scTypeM21 = s.renderOptions.staffConnectors[i];
          var scTypeVF = this.staffConnectorsMap(scTypeM21); // noinspection TypeScriptValidateJSTypes

          sc.setType(scTypeVF);
          sc.setContext(this.ctx);
          sc.draw();
        }
      }
    }
  }
  /**
   * The process of putting a Stream onto a div affects each of the
   * elements in the Stream by adding pieces of information to
   * each {@link Music21Object} -- see `applyFormatterInformationToNotes`
   *
   * You might want to remove this information; this routine does that.
   *
   * @param {Stream} s - can have parts, measures, etc.
   * @param {boolean} [recursive=false]
   */


  removeFormatterInformation(s) {
    var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    s.storedVexflowStave = undefined;
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = s[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var el = _step8.value;
        el.x = undefined;
        el.y = undefined;
        el.width = undefined;
        el.systemIndex = undefined;
        el.activeVexflowNote = undefined;

        if (recursive && el.isClassOrSubclass('Stream')) {
          this.removeFormatterInformation(el, recursive);
        }
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }
  }
  /**
   * Adds the following pieces of information to each Note
   *
   * - el.x -- x location in pixels
   * - el.y -- y location in pixels
   * - el.width - width of element in pixels.
   * - el.systemIndex -- which system is it on
   * - el.activeVexflowNote - which Vex.Flow.StaveNote is it connected with.
   *
   * mad props to our friend Vladimir Viro for figuring this out! Visit http://peachnote.com/
   *
   * Also sets s.storedVexflowStave to stave.
   *
   * @param {Vex.Flow.Stave} stave
   * @param {Stream} [s=this.stream]
   * @param {Vex.Flow.Formatter} formatter
   */


  applyFormatterInformationToNotes(stave, s, formatter) {
    if (s === undefined) {
      s = this.stream;
    }

    var sClef = s.getSpecialContext('clef') || s.getContextByClass('Clef') || _clefSingleton;

    var noteOffsetLeft = 0; // var staveHeight = 80;

    if (stave !== undefined) {
      noteOffsetLeft = stave.start_x + stave.glyph_start_x;

      if (_debug__WEBPACK_IMPORTED_MODULE_10__["debug"]) {
        console.log('noteOffsetLeft: ' + noteOffsetLeft + ' ; stave.start_x: ' + stave.start_x);
        console.log('Bottom y: ' + stave.getBottomY());
      } // staveHeight = stave.height;

    }

    var nextTicks = 0;
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = s[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var ee = _step9.value;
        var el = ee; // TODO: get rid of the hacky el.x, el.systemIndex, el.width.

        if (el.isClassOrSubclass('GeneralNote')) {
          var vfn = el.activeVexflowNote;

          if (vfn === undefined) {
            continue;
          }

          var nTicks = parseInt(vfn.ticks);
          var formatterNote = formatter.tickContexts.map[String(nextTicks)];
          nextTicks += nTicks;
          el.x = vfn.getAbsoluteX(); // these are a bit hacky...

          el.systemIndex = s.renderOptions.systemIndex; // console.log(el.x + " " + formatterNote.x + " " + noteOffsetLeft);

          if (formatterNote === undefined) {
            continue;
          }

          el.width = formatterNote.width;

          if (el.pitch !== undefined && stave !== undefined) {
            // note only...
            el.y = stave.getBottomY() - (sClef.lowestLine - el.pitch.diatonicNoteNum) * stave.options.spacing_between_lines_px; // console.log('Note DNN: ' + el.pitch.diatonicNoteNum + " ; y: " + el.y);
          }
        }
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    if (_debug__WEBPACK_IMPORTED_MODULE_10__["debug"]) {
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = s[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var n = _step10.value;

          if (n.pitch !== undefined) {
            var nn = n;
            console.log(nn.pitch.diatonicNoteNum + ' ' + nn.x + ' ' + (nn.x + nn.width));
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    }

    s.storedVexflowStave = stave;
  }

}

/***/ }),

/***/ "./src/music21/voiceLeading.ts":
/*!*************************************!*\
  !*** ./src/music21/voiceLeading.ts ***!
  \*************************************/
/*! exports provided: MotionType, VoiceLeadingQuartet */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MotionType", function() { return MotionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VoiceLeadingQuartet", function() { return VoiceLeadingQuartet; });
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _interval__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./interval */ "./src/music21/interval.ts");
/* harmony import */ var _note__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./note */ "./src/music21/note.ts");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./base */ "./src/music21/base.ts");





/**
 * music21j -- Javascript reimplementation of Core music21 features.
 * music21/voiceLeading -- voiceLeading objects
 *
 * Copyright (c) 2013-18, Michael Scott Cuthbert and cuthbertLab
 * Based on music21, Copyright (c) 2006–18, Michael Scott Cuthbert and cuthbertLab
 *
 * @namespace music21.voiceLeading
 */



var intervalCache = [];
var MotionType = {
  antiParallel: 'Anti-Parallel',
  contrary: 'Contrary',
  noMotion: 'No Motion',
  oblique: 'Oblique',
  parallel: 'Parallel',
  similar: 'Similar'
};
/**
 * @memberOf music21.voiceLeading
 * @extends Music21Object
 */

class VoiceLeadingQuartet extends _base__WEBPACK_IMPORTED_MODULE_6__["Music21Object"] {
  constructor(v1n1, v1n2, v2n1, v2n2, analyticKey) {
    super();

    if (!intervalCache.length) {
      intervalCache.push(new _interval__WEBPACK_IMPORTED_MODULE_4__["Interval"]('P1'));
      intervalCache.push(new _interval__WEBPACK_IMPORTED_MODULE_4__["Interval"]('P5'));
      intervalCache.push(new _interval__WEBPACK_IMPORTED_MODULE_4__["Interval"]('P8'));
    }

    this.unison = intervalCache[0];
    this.fifth = intervalCache[1];
    this.octave = intervalCache[2];
    this._v1n1 = undefined;
    this._v1n2 = undefined;
    this._v2n1 = undefined;
    this._v2n2 = undefined;
    this.v1n1 = v1n1;
    this.v1n2 = v1n2;
    this.v2n1 = v2n1;
    this.v2n2 = v2n2;
    this.vIntervals = [];
    this.hIntervals = [];
    this._key = undefined;

    if (analyticKey !== undefined) {
      this.key = analyticKey;
    }

    if (v1n1 !== undefined && v1n2 !== undefined && v2n1 !== undefined && v2n2 !== undefined) {
      this._findIntervals();
    }
  }

  static get className() {
    return 'music21.voiceLeading.VoiceLeadingQuartet';
  }

  _setVoiceNote(value, which) {
    if (value === undefined) {
      this[which] = value;
    } else if (typeof value === 'string') {
      this[which] = new _note__WEBPACK_IMPORTED_MODULE_5__["Note"](value);
    } else if (value.classes.includes('Note')) {
      this[which] = value;
    } else {
      var n = new _note__WEBPACK_IMPORTED_MODULE_5__["Note"](value.nameWithOctave);
      n.duration.quarterLength = 0.0;
      this[which] = n;
    }
  }

  get v1n1() {
    return this._v1n1;
  }

  set v1n1(value) {
    this._setVoiceNote(value, '_v1n1');
  }

  get v1n2() {
    return this._v1n2;
  }

  set v1n2(value) {
    this._setVoiceNote(value, '_v1n2');
  }

  get v2n1() {
    return this._v2n1;
  }

  set v2n1(value) {
    this._setVoiceNote(value, '_v2n1');
  }

  get v2n2() {
    return this._v2n2;
  }

  set v2n2(value) {
    this._setVoiceNote(value, '_v2n2');
  }

  get key() {
    return this._key;
  } // turning off string entry because of Typescript deficiency


  set key(keyValue) {
    // if (typeof keyValue === 'string') {
    //     keyValue = new key.Key(
    //         key.convertKeyStringToMusic21KeyString(keyValue)
    //     );
    // }
    this._key = keyValue;
  }

  _findIntervals() {
    this.vIntervals.push(new _interval__WEBPACK_IMPORTED_MODULE_4__["Interval"](this.v1n1, this.v2n1));
    this.vIntervals.push(new _interval__WEBPACK_IMPORTED_MODULE_4__["Interval"](this.v1n2, this.v2n2));
    this.hIntervals.push(new _interval__WEBPACK_IMPORTED_MODULE_4__["Interval"](this.v1n1, this.v1n2));
    this.hIntervals.push(new _interval__WEBPACK_IMPORTED_MODULE_4__["Interval"](this.v2n1, this.v2n2));
  }

  motionType() {
    if (this.obliqueMotion()) {
      return MotionType.oblique;
    } else if (this.parallelMotion()) {
      return MotionType.parallel;
    } else if (this.similarMotion()) {
      return MotionType.similar;
    } else if (this.contraryMotion()) {
      return MotionType.contrary;
    } else if (this.antiParallelMotion()) {
      return MotionType.antiParallel;
    } else if (this.noMotion()) {
      return MotionType.noMotion;
    }

    return undefined;
  }

  noMotion() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.hIntervals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var iV = _step.value;

        if (iV.name !== 'P1') {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return true;
  }

  obliqueMotion() {
    if (this.noMotion()) {
      return false;
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this.hIntervals[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var iH = _step2.value;

        if (iH.name === 'P1') {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return false;
  }

  similarMotion() {
    if (this.noMotion()) {
      return false;
    }

    if (this.hIntervals[0].direction === this.hIntervals[1].direction) {
      return true;
    } else {
      return false;
    }
  }

  parallelMotion() {
    var requiredInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    if (!this.similarMotion()) {
      return false;
    }

    if (this.vIntervals[0].directedSimpleName !== this.vIntervals[1].directedSimpleName) {
      return false;
    }

    if (requiredInterval === undefined) {
      return true;
    }

    if (typeof requiredInterval === 'string') {
      requiredInterval = new _interval__WEBPACK_IMPORTED_MODULE_4__["Interval"](requiredInterval);
    }

    if (this.vIntervals[0].simpleName === requiredInterval.simpleName) {
      return true;
    } else {
      return false;
    }
  }

  contraryMotion() {
    if (this.noMotion()) {
      return false;
    }

    if (this.obliqueMotion()) {
      return false;
    }

    if (this.hIntervals[0].direction === this.hIntervals[1].direction) {
      return false;
    } else {
      return true;
    }
  }

  outwardContraryMotion() {
    return this.contraryMotion() && this.hIntervals[0].direction === _interval__WEBPACK_IMPORTED_MODULE_4__["Direction"].ASCENDING;
  }

  inwardContraryMotion() {
    return this.contraryMotion() && this.hIntervals[0].direction === _interval__WEBPACK_IMPORTED_MODULE_4__["Direction"].DESCENDING;
  }

  antiParallelMotion() {
    var simpleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    if (!this.contraryMotion()) {
      return false;
    }

    if (this.vIntervals[0].simpleName !== this.vIntervals[1].simpleName) {
      return false;
    }

    if (simpleName === undefined) {
      return true;
    }

    if (typeof simpleName === 'string') {
      if (this.vIntervals[0].simpleName === simpleName) {
        return true;
      } else {
        return false;
      }
    } else if (this.vIntervals[0].simpleName === simpleName.simpleName) {
      return true;
    } else {
      return false;
    }
  }

  parallelInterval(thisInterval) {
    if (!(this.parallelMotion() || this.antiParallelMotion())) {
      return false;
    }

    if (typeof thisInterval === 'string') {
      thisInterval = new _interval__WEBPACK_IMPORTED_MODULE_4__["Interval"](thisInterval);
    }

    if (this.vIntervals[0].semiSimpleName === thisInterval.semiSimpleName) {
      return true;
    } else {
      return false;
    }
  }

  parallelFifth() {
    return this.parallelInterval(this.fifth);
  }

  parallelOctave() {
    return this.parallelInterval(this.octave);
  }

  parallelUnison() {
    return this.parallelInterval(this.unison);
  }

  parallelUnisonOrOctave() {
    return this.parallelUnison() || this.parallelOctave();
  }

  hiddenInterval(thisInterval) {
    if (this.parallelMotion()) {
      return false;
    }

    if (!this.similarMotion()) {
      return false;
    }

    if (typeof thisInterval === 'string') {
      thisInterval = new _interval__WEBPACK_IMPORTED_MODULE_4__["Interval"](thisInterval);
    }

    if (this.vIntervals[1].simpleName === thisInterval.simpleName) {
      return true;
    } else {
      return false;
    }
  }

  hiddenFifth() {
    return this.hiddenInterval(this.fifth);
  }

  hiddenOctave() {
    return this.hiddenInterval(this.octave);
  } // True if either note in voice 1 is lower than the corresponding voice 2 note


  voiceCrossing() {
    return this.v1n1.pitch.ps < this.v2n1.pitch.ps || this.v1n2.pitch.ps < this.v2n2.pitch.ps;
  }

  voiceOverlap() {
    return this.v1n2.pitch.ps < this.v2n1.pitch.ps || this.v2n2.pitch.ps > this.v1n1.pitch.ps;
  }
  /**
   * isProperResolution - Checks whether the voice-leading quartet resolves correctly according to standard
   *         counterpoint rules. If the first harmony is dissonant (d5, A4, or m7) it checks
   *         that these are correctly resolved. If the first harmony is consonant, True is returned.
   *
   *         The key parameter should be specified to check for motion in the bass from specific
   *         note degrees. If it is not set, then no checking for scale degrees takes place.
   *
   *         Diminished Fifth: in by contrary motion to a third, with 7 resolving up to 1 in the bass
   *         Augmented Fourth: out by contrary motion to a sixth, with chordal seventh resolving
   *         down to a third in the bass.
   *         Minor Seventh: Resolves to a third with a leap form 5 to 1 in the bass
   *
   * @return {boolean}  true if proper or rules do not apply; false if improper
   */


  isProperResolution() {
    if (this.noMotion()) {
      return true;
    }

    var scale;
    var n1degree;
    var n2degree;

    if (this.key !== undefined) {
      scale = this.key.getScale();
      n1degree = scale.getScaleDegreeFromPitch(this.v2n1);
      n2degree = scale.getScaleDegreeFromPitch(this.v2n2);
    } // catches case of #7 in minor


    if (this.key !== undefined && this.key.mode === 'minor' && (n1degree === undefined || n2degree === undefined)) {
      var scale2 = this.key.getScale('melodic-minor'); // gets ascending form

      if (n1degree === undefined) {
        n1degree = scale2.getScaleDegreeFromPitch(this.v2n1);
      }

      if (n2degree === undefined) {
        n2degree = scale2.getScaleDegreeFromPitch(this.v2n2);
      }
    }

    var firstHarmony = this.vIntervals[0].simpleName;
    var secondHarmony = this.vIntervals[1].generic.simpleUndirected;

    if (firstHarmony === 'P4') {
      if (this.v1n1.pitch.ps >= this.v1n2.pitch.ps) {
        return true;
      } else {
        return false;
      }
    } else if (firstHarmony === 'd5') {
      if (scale !== undefined && n1degree !== 7) {
        return true;
      }

      if (scale !== undefined && n2degree !== 1) {
        return false;
      }

      return this.inwardContraryMotion() && secondHarmony === 3;
    } else if (firstHarmony === 'A4') {
      if (scale !== undefined && n1degree !== 4) {
        return true;
      }

      if (scale !== undefined && n2degree !== 3) {
        return false;
      }

      return this.outwardContraryMotion() && secondHarmony === 6;
    } else if (firstHarmony === 'm7') {
      if (scale !== undefined && n1degree !== 5) {
        return true;
      }

      if (scale !== undefined && n2degree !== 1) {
        return false;
      }

      return secondHarmony === 3;
    } else {
      return true;
    }
  }

}

/***/ }),

/***/ "./src/music21/webmidi.ts":
/*!********************************!*\
  !*** ./src/music21/webmidi.ts ***!
  \********************************/
/*! exports provided: webmidi, jazzMidiInArrived, midiInArrived, createPlugin, createJazzSelector, selectionChanged, createSelector, populateSelect */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "webmidi", function() { return webmidi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jazzMidiInArrived", function() { return jazzMidiInArrived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "midiInArrived", function() { return midiInArrived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPlugin", function() { return createPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createJazzSelector", function() { return createJazzSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectionChanged", function() { return selectionChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSelector", function() { return createSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "populateSelect", function() { return populateSelect; });
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./debug */ "./src/music21/debug.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./common */ "./src/music21/common.ts");
/* harmony import */ var _miditools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./miditools */ "./src/music21/miditools.ts");


/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/webmidi -- webmidi or wrapper around the Jazz Plugin
 *
 * For non webmidi --  Uses the cross-platform, cross-browser plugin from
 * http://jazz-soft.net/doc/Jazz-Plugin/Plugin.html
 * P.S. by the standards of divinity of most major religions, Sema Kachalo is a god.
 *
 * Copyright (c) 2014-18, Michael Scott Cuthbert and cuthbertLab
 * Based on music21 (=music21p), Copyright (c) 2006–18, Michael Scott Cuthbert and cuthbertLab
 *
 */

/**
 * webmidi -- for connecting with external midi devices
 *
 * Uses either the webmidi API or the Jazz plugin
 * See {@link music21.webmidi}
 *
 * @namespace music21.webmidi
 * @memberof music21
 * @requires music21/miditools
 * @requires jQuery
 * @exports music21/webmidi
 * @example smallest usage of the webmidi toolkit.  see testHTML/midiInRequire.html

<html>
<head>
    <title>MIDI In/Jazz Test for Music21j</title>
    <meta http-equiv="content-type" content="text/html; charset=utf-8" />
</head>
<body>
<div>
MIDI Input: <div id="putMidiSelectHere" />
</div>
<div id="svgDiv">
</div>
<script src='music21j.js'></script>
<script>
    s = new music21.stream.Stream();
    music21.webmidi.createSelector($("#putMidiSelectHere"));

    function displayStream(midiEvent) {
        midiEvent.sendToMIDIjs();
        if (midiEvent.noteOn) {
            var m21n = midiEvent.music21Note();
            if (s.length > 7) {
                s.elements = s.elements.slice(1)
            }
            s.append(m21n);
            var $svgDiv = $("#svgDiv");
            $svgDiv.empty();
            var svgDiv = s.appendNewDOM($svgDiv);
        }
    }
    music21.miditools.callbacks.general = displayStream;

</script>
</body>
</html>
 */




/**
 * @typedef {Object} Jazz
 * @extends HTMLObjectElement
 * @property {boolean} isJazz
 * @property {function} MidiInOpen
 * @property {function} MidiInClose
 * @property {function} MidiInList
 *
 */

/**
 *
 * @type {
 *     {
 *     selectedInputPort: *,
 *     access: *,
 *     jazzDownloadUrl: string,
 *     selectedOutputPort: *,
 *     storedPlugin: *,
 *     selectedJazzInterface: *,
 *     $select: jQuery|undefined
 *     }
 * }
 */

var webmidi = {
  selectedOutputPort: undefined,
  selectedInputPort: undefined,
  access: undefined,
  $select: undefined,
  jazzDownloadUrl: 'http://jazz-soft.net/download/Jazz-Plugin/',
  storedPlugin: undefined,
  selectedJazzInterface: undefined
};
/**
 * Called by Jazz MIDI plugin when an event arrives.
 *
 * Shim to convert the data into WebMIDI API format and then call the WebMIDI API midiInArrived
 *
 * See the MIDI spec for information on parameters
 *
 * @memberof music21.webmidi
 * @param {byte} t - timing information
 * @param {byte} a - data 1
 * @param {byte} b - data 2
 * @param {byte} c - data 3
 */

function jazzMidiInArrived(t, a, b, c) {
  var webmidiEvent = {
    timestamp: t,
    data: [a, b, c]
  };
  return midiInArrived(webmidiEvent);
}
/**
 * Called directly when a MIDI event arrives from the WebMIDI API, or via a Shim (jazzMidiInArrived)
 * when MIDI information comes from JazzMIDI
 *
 * Calls the 'raw' and 'general callbacks when a raw midi event (four bytes)
 * arrives.
 *
 * See the MIDI spec for information on the contents of the three parameters.
 *
 * midiMessageEvent should be an object with two keys: timeStamp (int) and data (array of three int values)
 *
 * @memberof music21.webmidi
 * @param {Object} midiMessageEvent - midi Information
 */

function midiInArrived(midiMessageEvent) {
  var t = midiMessageEvent.timeStamp;
  var a = midiMessageEvent.data[0];
  var b = midiMessageEvent.data[1];
  var c = midiMessageEvent.data[2];
  var midiCallbacks = _miditools__WEBPACK_IMPORTED_MODULE_4__["callbacks"];
  var eventObject = midiCallbacks.raw(t, a, b, c);

  if (midiCallbacks.general instanceof Array) {
    return midiCallbacks.general.forEach((el, index, array) => {
      el(eventObject);
    });
  } else if (midiCallbacks.general instanceof Function) {
    return midiCallbacks.general(eventObject);
  } else {
    return undefined;
  }
}
/**
 * Create a hidden tiny, &lt;object&gt; tag in the DOM with the
 * proper classid (`CLSID:1ACE1618-1C7D-4561-AEE1-34842AA85E90`) to
 * load the Jazz plugin.
 *
 * It will return the plugin if it can or undefined if it cannot. Caches it in webmidi.storedPlugin.
 *
 * @function music21.webmidi.createPlugin
 * @param {HTMLElement} [appendElement=document.body] - where to place this hidden object (does not really matter)
 * @param {Boolean} [override=false] - if this method has been called
 *     successfully before return the storedPlugin unless override is true.
 * @returns {Jazz|undefined} Jazz MIDI plugin object
 */

function createPlugin() {
  var appendElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (webmidi.storedPlugin && !override) {
    return webmidi.storedPlugin;
  }

  if (typeof appendElement === 'undefined') {
    appendElement = jquery__WEBPACK_IMPORTED_MODULE_1__('body')[0];
  }

  var obj = document.createElement('object'); // noinspection SpellCheckingInspection

  obj.classid = 'CLSID:1ACE1618-1C7D-4561-AEE1-34842AA85E90';

  if (!obj.isJazz) {
    obj.type = 'audio/x-jazz';
  }

  obj.style.visibility = 'hidden';
  obj.style.width = '0px';
  obj.style.height = '0px';
  appendElement.appendChild(obj);

  if (obj.isJazz) {
    webmidi.storedPlugin = obj;
    return obj;
  } else {
    appendElement.removeChild(obj);
    console.error('Cannot use jazz plugin; install at ' + webmidi.jazzDownloadUrl);
    return undefined;
  }
}
/**
 * Creates a &lt;select&gt; object for selecting among the MIDI choices in Jazz
 *
 * @function music21.webmidi.createJazzSelector
 * @param {jQuery|HTMLElement} [$newSelect=document.body] - object to append the select to
 * @param {Object} [options] - see createSelector for details
 * @returns {HTMLElement|undefined} DOM object containing the select tag, or undefined if Jazz cannot be loaded.
 */

function createJazzSelector($newSelect) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var params = {
    onsuccess: undefined,
    oninputsuccess: undefined,
    oninputempty: undefined
  };
  _common__WEBPACK_IMPORTED_MODULE_3__["merge"](params, options);
  var Jazz = createPlugin();

  if (Jazz === undefined) {
    return undefined;
  }

  $newSelect.on('change', () => {
    var selectedInput = jquery__WEBPACK_IMPORTED_MODULE_1__('#midiInSelect option:selected').text();

    if (selectedInput !== 'None selected') {
      webmidi.selectedJazzInterface = Jazz.MidiInOpen(selectedInput, jazzMidiInArrived);
    } else {
      Jazz.MidiInClose();
    }

    if (_debug__WEBPACK_IMPORTED_MODULE_2__["debug"]) {
      console.log('current input changed to: ' + webmidi.selectedJazzInterface);
    }
  });
  var midiOptions = Jazz.MidiInList();
  var noneAppendOption = jquery__WEBPACK_IMPORTED_MODULE_1__("<option value='None'>None selected</option>");
  $newSelect.append(noneAppendOption);
  var anySelected = false;
  var allAppendOptions = [];

  for (var i = 0; i < midiOptions.length; i++) {
    var $appendOption = jquery__WEBPACK_IMPORTED_MODULE_1__("<option value='" + midiOptions[i] + "'>" + midiOptions[i] + '</option>');

    if (midiOptions[i] === webmidi.selectedJazzInterface) {
      $appendOption.prop('selected', true);
      anySelected = true;
    }

    allAppendOptions.push($appendOption); // console.log(appendOption);

    $newSelect.append($appendOption);
  }

  if (anySelected === false && midiOptions.length > 0) {
    $newSelect.val(midiOptions[0]);
    allAppendOptions[0].prop('selected', true);
    webmidi.selectedJazzInterface = Jazz.MidiInOpen(midiOptions[0], jazzMidiInArrived);
    anySelected = true;
  } else {
    noneAppendOption.prop('selected', true);
  }

  if (params.onsuccess !== undefined) {
    params.onsuccess();
  }

  if (anySelected === true && params.oninputsuccess !== undefined) {
    params.oninputsuccess();
  } else if (anySelected === false && params.oninputempty !== undefined) {
    params.oninputempty();
  }

  return $newSelect;
}
/**
 * Function to be called if the webmidi-api selection changes. (not jazz)
 *
 */

function selectionChanged() {
  var selectedInput = webmidi.$select.val();

  if (selectedInput === webmidi.selectedInputPort) {
    return false;
  }

  var storedStateChange = webmidi.access.onstatechange; // port.close() fires onstatechange, so turn off for a moment.

  webmidi.access.onstatechange = () => {};

  if (_debug__WEBPACK_IMPORTED_MODULE_2__["debug"]) {
    console.log('current input changed to: ' + selectedInput);
  }

  webmidi.selectedInputPort = selectedInput;
  webmidi.access.inputs.forEach(port => {
    if (port.name === selectedInput) {
      port.onmidimessage = midiInArrived;
    } else {
      port.close();
    }
  });
  webmidi.access.onstatechange = storedStateChange;
  return false;
}
/**
 * Creates a &lt;select&gt; object for selecting among the MIDI choices in Jazz
 *
 * The options object has several parameters:
 *
 *
 * @function music21.webmidi.createSelector
 * @param {jQuery|HTMLElement} [midiSelectDiv=$('body')] - object to append the select to
 * @param {Object} [options] - see above.
 * @param {boolean} options.autoupdate -- should this auto update?
 * @param {function} options.onsuccess -- function to call on all successful port queries
 * @param {function} options.oninputsuccess -- function to call if successful and at least one input device is found
 * @param {function} options.oninputempty -- function to call if successful but no input devices are found.
 * @param {boolean} options.existingMidiSelect -- is there already a select tag for MIDI?
 * @returns {jQuery|undefined} DOM object containing the select tag, or undefined if Jazz cannot be loaded.
 */

function createSelector(midiSelectDiv, options) {
  var params = {
    autoUpdate: true,
    existingMidiSelect: false,
    onsuccess: undefined,
    oninputsuccess: undefined,
    oninputempty: undefined
  };
  _common__WEBPACK_IMPORTED_MODULE_3__["merge"](params, options);
  /**
   * @type {jQuery}
   */

  var $midiSelectDiv;

  if (typeof midiSelectDiv === 'undefined') {
    $midiSelectDiv = jquery__WEBPACK_IMPORTED_MODULE_1__('body');
  } else if (!(midiSelectDiv instanceof jquery__WEBPACK_IMPORTED_MODULE_1__)) {
    $midiSelectDiv = jquery__WEBPACK_IMPORTED_MODULE_1__(midiSelectDiv);
  } else {
    $midiSelectDiv = midiSelectDiv;
  }

  var $newSelect;
  var foundMidiSelects = $midiSelectDiv.find('select#midiInSelect');

  if (foundMidiSelects.length > 0) {
    $newSelect = foundMidiSelects[0];
    params.existingMidiSelect = true;
  } else {
    $newSelect = jquery__WEBPACK_IMPORTED_MODULE_1__('<select>').attr('id', 'midiInSelect');
    $midiSelectDiv.append($newSelect);
  }

  webmidi.$select = $newSelect;

  if (navigator.requestMIDIAccess === undefined) {
    createJazzSelector($newSelect, params);
  } else {
    if (params.existingMidiSelect !== true) {
      $newSelect.on('change', selectionChanged);
    }

    navigator.requestMIDIAccess().then(access => {
      webmidi.access = access;
      populateSelect();

      if (params.autoUpdate) {
        access.onstatechange = populateSelect;
      }

      webmidi.$select.change();

      if (params.onsuccess !== undefined) {
        params.onsuccess();
      }

      if (webmidi.selectedInputPort !== 'None' && params.oninputsuccess !== undefined) {
        params.oninputsuccess();
      } else if (webmidi.selectedInputPort === 'None' && params.oninputempty !== undefined) {
        params.oninputempty();
      }
    }, e => {
      $midiSelectDiv.html(e.message);
    });
  }

  _miditools__WEBPACK_IMPORTED_MODULE_4__["clearOldChords"](); // starts the chord checking process.

  return $newSelect;
}
function populateSelect() {
  var inputs = webmidi.access.inputs;
  webmidi.$select.empty();
  var $noneAppendOption = jquery__WEBPACK_IMPORTED_MODULE_1__("<option value='None'>None selected</option>");
  webmidi.$select.append($noneAppendOption);
  var allAppendOptions = [];
  var midiOptions = [];
  var i = 0;
  inputs.forEach(port => {
    var $appendOption = jquery__WEBPACK_IMPORTED_MODULE_1__("<option value='" + port.name + "'>" + port.name + '</option>');
    allAppendOptions.push($appendOption);
    midiOptions.push(port.name); // console.log(appendOption);

    webmidi.$select.append($appendOption);
    i += 1;
  });

  if (allAppendOptions.length > 0) {
    webmidi.$select.val(midiOptions[0]);
    allAppendOptions[0].prop('selected', true);
  } else {
    $noneAppendOption.prop('selected', true);
  }

  webmidi.$select.trigger('change');
}

/***/ }),

/***/ "./src/music21_modules.js":
/*!********************************!*\
  !*** ./src/music21_modules.js ***!
  \********************************/
/*! exports provided: MIDI, Vex, exceptions21, base, prebase, common, debug, articulations, audioRecording, audioSearch, bar, beam, chord, chordTables, clef, converter, derivation, duration, dynamics, editorial, expressions, figuredBass, fromPython, harmony, instrument, interval, key, keyboard, layout, meter, miditools, musicxml, note, parseLoader, pitch, renderOptions, roman, scale, sites, stream, tempo, tie, tinyNotation, vfShow, voiceLeading, webmidi, VERSION */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! midicube */ "./node_modules/midicube/releases/midicube.js");
/* harmony import */ var midicube__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(midicube__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "MIDI", function() { return midicube__WEBPACK_IMPORTED_MODULE_1__; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vexflow */ "./node_modules/vexflow/releases/vexflow-debug.js");
/* harmony import */ var vexflow__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vexflow__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Vex", function() { return vexflow__WEBPACK_IMPORTED_MODULE_3__; });
/* harmony import */ var jquery_ui_bundle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! jquery-ui-bundle */ "./node_modules/jquery-ui-bundle/jquery-ui.js");
/* harmony import */ var jquery_ui_bundle__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(jquery_ui_bundle__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _music21_exceptions21__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./music21/exceptions21 */ "./src/music21/exceptions21.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "exceptions21", function() { return _music21_exceptions21__WEBPACK_IMPORTED_MODULE_5__; });
/* harmony import */ var _music21_prebase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./music21/prebase */ "./src/music21/prebase.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "prebase", function() { return _music21_prebase__WEBPACK_IMPORTED_MODULE_6__; });
/* harmony import */ var _music21_base__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./music21/base */ "./src/music21/base.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "base", function() { return _music21_base__WEBPACK_IMPORTED_MODULE_7__; });
/* harmony import */ var _music21_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./music21/common */ "./src/music21/common.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "common", function() { return _music21_common__WEBPACK_IMPORTED_MODULE_8__; });
/* harmony import */ var _music21_articulations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./music21/articulations */ "./src/music21/articulations.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "articulations", function() { return _music21_articulations__WEBPACK_IMPORTED_MODULE_9__; });
/* harmony import */ var _music21_audioRecording__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./music21/audioRecording */ "./src/music21/audioRecording.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "audioRecording", function() { return _music21_audioRecording__WEBPACK_IMPORTED_MODULE_10__; });
/* harmony import */ var _music21_audioSearch__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./music21/audioSearch */ "./src/music21/audioSearch.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "audioSearch", function() { return _music21_audioSearch__WEBPACK_IMPORTED_MODULE_11__; });
/* harmony import */ var _music21_bar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./music21/bar */ "./src/music21/bar.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "bar", function() { return _music21_bar__WEBPACK_IMPORTED_MODULE_12__; });
/* harmony import */ var _music21_beam__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./music21/beam */ "./src/music21/beam.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "beam", function() { return _music21_beam__WEBPACK_IMPORTED_MODULE_13__; });
/* harmony import */ var _music21_chord__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./music21/chord */ "./src/music21/chord.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "chord", function() { return _music21_chord__WEBPACK_IMPORTED_MODULE_14__; });
/* harmony import */ var _music21_chordTables__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./music21/chordTables */ "./src/music21/chordTables.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "chordTables", function() { return _music21_chordTables__WEBPACK_IMPORTED_MODULE_15__; });
/* harmony import */ var _music21_clef__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./music21/clef */ "./src/music21/clef.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "clef", function() { return _music21_clef__WEBPACK_IMPORTED_MODULE_16__; });
/* harmony import */ var _music21_converter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./music21/converter */ "./src/music21/converter.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "converter", function() { return _music21_converter__WEBPACK_IMPORTED_MODULE_17__; });
/* harmony import */ var _music21_derivation__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./music21/derivation */ "./src/music21/derivation.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "derivation", function() { return _music21_derivation__WEBPACK_IMPORTED_MODULE_18__; });
/* harmony import */ var _music21_duration__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./music21/duration */ "./src/music21/duration.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "duration", function() { return _music21_duration__WEBPACK_IMPORTED_MODULE_19__; });
/* harmony import */ var _music21_dynamics__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./music21/dynamics */ "./src/music21/dynamics.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "dynamics", function() { return _music21_dynamics__WEBPACK_IMPORTED_MODULE_20__; });
/* harmony import */ var _music21_editorial__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./music21/editorial */ "./src/music21/editorial.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "editorial", function() { return _music21_editorial__WEBPACK_IMPORTED_MODULE_21__; });
/* harmony import */ var _music21_expressions__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./music21/expressions */ "./src/music21/expressions.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "expressions", function() { return _music21_expressions__WEBPACK_IMPORTED_MODULE_22__; });
/* harmony import */ var _music21_figuredBass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./music21/figuredBass */ "./src/music21/figuredBass.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "figuredBass", function() { return _music21_figuredBass__WEBPACK_IMPORTED_MODULE_23__; });
/* harmony import */ var _music21_fromPython__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./music21/fromPython */ "./src/music21/fromPython.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "fromPython", function() { return _music21_fromPython__WEBPACK_IMPORTED_MODULE_24__; });
/* harmony import */ var _music21_harmony__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./music21/harmony */ "./src/music21/harmony.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "harmony", function() { return _music21_harmony__WEBPACK_IMPORTED_MODULE_25__; });
/* harmony import */ var _music21_instrument__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./music21/instrument */ "./src/music21/instrument.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "instrument", function() { return _music21_instrument__WEBPACK_IMPORTED_MODULE_26__; });
/* harmony import */ var _music21_interval__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./music21/interval */ "./src/music21/interval.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "interval", function() { return _music21_interval__WEBPACK_IMPORTED_MODULE_27__; });
/* harmony import */ var _music21_key__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./music21/key */ "./src/music21/key.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "key", function() { return _music21_key__WEBPACK_IMPORTED_MODULE_28__; });
/* harmony import */ var _music21_keyboard__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./music21/keyboard */ "./src/music21/keyboard.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "keyboard", function() { return _music21_keyboard__WEBPACK_IMPORTED_MODULE_29__; });
/* harmony import */ var _music21_layout__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./music21/layout */ "./src/music21/layout.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "layout", function() { return _music21_layout__WEBPACK_IMPORTED_MODULE_30__; });
/* harmony import */ var _music21_meter__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./music21/meter */ "./src/music21/meter.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "meter", function() { return _music21_meter__WEBPACK_IMPORTED_MODULE_31__; });
/* harmony import */ var _music21_miditools__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./music21/miditools */ "./src/music21/miditools.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "miditools", function() { return _music21_miditools__WEBPACK_IMPORTED_MODULE_32__; });
/* harmony import */ var _music21_musicxml__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./music21/musicxml */ "./src/music21/musicxml.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "musicxml", function() { return _music21_musicxml__WEBPACK_IMPORTED_MODULE_33__; });
/* harmony import */ var _music21_note__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./music21/note */ "./src/music21/note.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "note", function() { return _music21_note__WEBPACK_IMPORTED_MODULE_34__; });
/* harmony import */ var _music21_parseLoader__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./music21/parseLoader */ "./src/music21/parseLoader.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "parseLoader", function() { return _music21_parseLoader__WEBPACK_IMPORTED_MODULE_35__; });
/* harmony import */ var _music21_pitch__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./music21/pitch */ "./src/music21/pitch.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "pitch", function() { return _music21_pitch__WEBPACK_IMPORTED_MODULE_36__; });
/* harmony import */ var _music21_renderOptions__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./music21/renderOptions */ "./src/music21/renderOptions.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "renderOptions", function() { return _music21_renderOptions__WEBPACK_IMPORTED_MODULE_37__; });
/* harmony import */ var _music21_roman__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./music21/roman */ "./src/music21/roman.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "roman", function() { return _music21_roman__WEBPACK_IMPORTED_MODULE_38__; });
/* harmony import */ var _music21_scale__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./music21/scale */ "./src/music21/scale.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "scale", function() { return _music21_scale__WEBPACK_IMPORTED_MODULE_39__; });
/* harmony import */ var _music21_sites__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./music21/sites */ "./src/music21/sites.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "sites", function() { return _music21_sites__WEBPACK_IMPORTED_MODULE_40__; });
/* harmony import */ var _music21_stream__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./music21/stream */ "./src/music21/stream.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "stream", function() { return _music21_stream__WEBPACK_IMPORTED_MODULE_41__; });
/* harmony import */ var _music21_tempo__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./music21/tempo */ "./src/music21/tempo.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "tempo", function() { return _music21_tempo__WEBPACK_IMPORTED_MODULE_42__; });
/* harmony import */ var _music21_tie__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./music21/tie */ "./src/music21/tie.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "tie", function() { return _music21_tie__WEBPACK_IMPORTED_MODULE_43__; });
/* harmony import */ var _music21_tinyNotation__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./music21/tinyNotation */ "./src/music21/tinyNotation.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "tinyNotation", function() { return _music21_tinyNotation__WEBPACK_IMPORTED_MODULE_44__; });
/* harmony import */ var _music21_vfShow__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./music21/vfShow */ "./src/music21/vfShow.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "vfShow", function() { return _music21_vfShow__WEBPACK_IMPORTED_MODULE_45__; });
/* harmony import */ var _music21_voiceLeading__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./music21/voiceLeading */ "./src/music21/voiceLeading.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "voiceLeading", function() { return _music21_voiceLeading__WEBPACK_IMPORTED_MODULE_46__; });
/* harmony import */ var _music21_webmidi__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./music21/webmidi */ "./src/music21/webmidi.ts");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "webmidi", function() { return _music21_webmidi__WEBPACK_IMPORTED_MODULE_47__; });
/* harmony import */ var _music21_debug__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./music21/debug */ "./src/music21/debug.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "debug", function() { return _music21_debug__WEBPACK_IMPORTED_MODULE_48__["debug"]; });

/**!
 * **music21j**: Javascript reimplementation of Core music21 features.
 *
 * See http://web.mit.edu/music21/ for more details.
 *
 * Copyright (c) 2013-20, Michael Scott Cuthbert and cuthbertLab
 * Released under a BSD-3-clause license
 *
 */

/**
 *
 * Based on music21, Copyright (c) 2006-20, Michael Scott Cuthbert and cuthbertLab
 * The plan is to implement all core music21 features as Javascript and to expose
 * more sophisticated features via server-side connections to remote servers running the
 * python music21 (music21p).
 *
 * Requires an ECMAScript 5 compatible browser w/ SVG and Canvas. IE 11 or any recent
 * version of Firefox, Safari, Edge,  Chrome, etc. will do.
 *
 * All interfaces are alpha and may change radically from day to day and release to release.
 * Do not use this in production code yet.
 *
 * music21j acknowledges VexFlow, MIDI.js in particular for their great efforts without which
 * this module would not be possible.
 *
 * @namespace music21
 * @exports music21
 */
// webpack loader for music21j.

 // to be removed when export * from is okay.



 // TODO: add attrchange
// order below doesn't matter, but good to give a sense
// of what will be needed by almost everyone, and then
// alphabetical.














































var VERSION = '0.9.5';
window.$ = jquery__WEBPACK_IMPORTED_MODULE_2__;
window.jQuery = jquery__WEBPACK_IMPORTED_MODULE_2__;
_music21_parseLoader__WEBPACK_IMPORTED_MODULE_35__["runConfiguration"]();

/***/ })

/******/ });
});
//# sourceMappingURL=music21.debug.js.map